webpackJsonp([22],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie_src_js_cookie_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie_src_js_cookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie_src_js_cookie_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translation_lang_en__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__translation_lang_th__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_Subject__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_environments_properties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_router__ = __webpack_require__(26);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppConfigService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var AppConfigService = AppConfigService_1 = (function () {
    function AppConfigService(activatedRoute) {
        this.activatedRoute = activatedRoute;
        this.langSubject = new __WEBPACK_IMPORTED_MODULE_6_rxjs_Subject__["Subject"]();
        this.currencyId = '1';
        this.momentUtcOffset = '+0700';
        this.dateUrlFormat = "DD-MM-YYYY";
        this.dateAPIFormat = "YYYY-MM-DD";
        this.dateHumanFormat = "DD-MM-YYYY";
        this.dateCancellationPolicyFormat = "D MMM YY";
        this.dateTravelPolicyFormat = "dd D MMM YY";
        this.defaultProductImage = "https://images.ascendtravel.com/NoImage.jpg";
        this.vat = 7;
        this.ACT_LOGO_DEFAULT = 'assets/images/header/ota_logo.png';
        this.ACT_LOGO_DEFAULT_WHITE = 'assets/images/header/ota_logo_w.png';
        this.ACT_LOGO_DEFAULT_MOBILE = 'assets/images/header/ota_logo_m.png';
        this.ActLogoPath = this.ACT_LOGO_DEFAULT;
        this.ActLogoWhitePath = this.ACT_LOGO_DEFAULT_WHITE;
        this.ActLogoMobilePath = this.ACT_LOGO_DEFAULT_MOBILE;
        AppConfigService_1.userInfoCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_stf";
        AppConfigService_1.tokenCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_tk";
        AppConfigService_1.publicKeyCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_pk";
        AppConfigService_1.featureCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_ft";
        AppConfigService_1.featureCompanyCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_cft";
        AppConfigService_1.checkoutDataCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_ck";
        AppConfigService_1.localStorageSearchHistoryName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_RECENT_SEARCHES";
        AppConfigService_1.notifyDisabledCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_nd";
        AppConfigService_1.bannerClosedCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_banner_closed";
        AppConfigService_1.ssoTokenCookieName = "sso";
        AppConfigService_1.stateCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_stc";
        AppConfigService_1.stateAffCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_affstc";
        AppConfigService_1.codeChallengeCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_ccc";
        AppConfigService_1.codeVerifierCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_cvc";
        AppConfigService_1.coBookerCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_cbc";
        AppConfigService_1.shareBudgetCodeCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_sbc";
        AppConfigService_1.languageCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_lang";
        AppConfigService_1.lat = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_lat";
        AppConfigService_1.lon = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_lon";
        AppConfigService_1.currencyCookieName = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["d" /* prefixCookieName */] + "_currency";
    }
    AppConfigService.prototype.setLanguage = function (use) {
        this.insertParam('lang', use);
        __WEBPACK_IMPORTED_MODULE_1_js_cookie_src_js_cookie_js__["set"](AppConfigService_1.languageCookieName, use, { domain: __WEBPACK_IMPORTED_MODULE_7_environments_properties__["e" /* domain */] });
        this.langSubject.next(use);
    };
    AppConfigService.prototype.getLanguage = function () {
        var languageCookie = this.getLanguageFromCookie();
        if (languageCookie && this.isValidLanguage(languageCookie)) {
            return languageCookie;
        }
        var languageParam = this.activatedRoute.snapshot.queryParams['lang'];
        if (languageParam && this.isValidLanguage(languageParam)) {
            return languageParam;
        }
        return __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["a" /* Language */].en;
    };
    AppConfigService.prototype.isValidLanguage = function (language) {
        return language == __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["a" /* Language */].en || language == __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["a" /* Language */].th;
    };
    AppConfigService.prototype.getLanguageFromCookie = function () {
        return __WEBPACK_IMPORTED_MODULE_1_js_cookie_src_js_cookie_js__["get"](AppConfigService_1.languageCookieName);
    };
    AppConfigService.prototype.getLanguageId = function () {
        return this.getLanguage() === __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["a" /* Language */].en ? "1" : "2";
    };
    AppConfigService.prototype.getLanguageObs = function () {
        return this.langSubject.asObservable();
    };
    AppConfigService.prototype.getLanguageList = function () {
        return [
            {
                name: 'thai',
                displayValue: 'ไทย',
                value: 'th',
                icon: 'assets/images/header/header_flag_th_2x.png',
                error: undefined
            },
            {
                name: 'english',
                displayValue: 'English',
                value: 'en',
                icon: 'assets/images/header/header_flag_en_2x.png',
                error: undefined
            }
        ];
    };
    AppConfigService.prototype.getTranslate = function (keyLangTranslate) {
        return this.getTranslateWithLang(keyLangTranslate, this.getLanguage());
    };
    AppConfigService.prototype.getTranslateWithLang = function (keyLangTranslate, lang) {
        switch (lang) {
            case __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["a" /* Language */].th:
                return __WEBPACK_IMPORTED_MODULE_4__translation_lang_th__["a" /* LANG_TH_TRANS */][keyLangTranslate];
            case __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["a" /* Language */].en:
                return __WEBPACK_IMPORTED_MODULE_3__translation_lang_en__["a" /* LANG_EN_TRANS */][keyLangTranslate];
        }
    };
    AppConfigService.prototype.getTimeForAuthorizationHeader = function () {
        return __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__().utcOffset(this.momentUtcOffset).format('YYYY-MM-DD-HH-mm-ss');
    };
    AppConfigService.prototype.getDateUrlFormat = function () {
        return this.dateUrlFormat;
    };
    AppConfigService.prototype.getCurrencyId = function () {
        return this.currencyId;
    };
    AppConfigService.prototype.insertParam = function (paramName, paramValue) {
        var url = window.location.href;
        var hash = location.hash;
        url = url.replace(hash, '');
        if (url.indexOf(paramName + "=") >= 0) {
            var prefix = url.substring(0, url.indexOf(paramName));
            var suffix = url.substring(url.indexOf(paramName));
            suffix = suffix.substring(suffix.indexOf("=") + 1);
            suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
            url = prefix + paramName + "=" + paramValue + suffix;
        }
        else {
            if (url.indexOf("?") < 0)
                url += "?" + paramName + "=" + paramValue;
            else
                url += "&" + paramName + "=" + paramValue;
        }
        var _pathName = document.location.pathname;
        history.replaceState({}, _pathName, url + hash);
    };
    AppConfigService.prototype.getActDefaultLogoPath = function () {
        return {
            ActDefaultLogoPath: this.ACT_LOGO_DEFAULT,
            ActDefaultLogoWhitePath: this.ACT_LOGO_DEFAULT_WHITE,
            ActDefaultLogoMobilePath: this.ACT_LOGO_DEFAULT_MOBILE
        };
    };
    AppConfigService.prototype.getActLogoPath = function () {
        return {
            ActLogoPath: this.ActLogoPath,
            ActLogoWhitePath: this.ActLogoWhitePath,
            ActLogoMobilePath: this.ActLogoMobilePath
        };
    };
    AppConfigService.prototype.setAffiliateLogo = function (partnerName) {
        if (partnerName) {
            this.ActLogoPath = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["f" /* imgUrl */] + "/partner-logo/" + partnerName + ".png";
            this.ActLogoWhitePath = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["f" /* imgUrl */] + "/partner-logo/" + partnerName + "-w.png";
            this.ActLogoMobilePath = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["f" /* imgUrl */] + "/partner-logo/" + partnerName + ".png";
        }
    };
    AppConfigService.prototype.getReturnUrl = function () {
        return localStorage.getItem(AppConfigService_1.returnUrllocalStorageName);
    };
    AppConfigService.prototype.setReturnUrl = function (returnUrl) {
        localStorage.setItem(AppConfigService_1.returnUrllocalStorageName, returnUrl);
    };
    AppConfigService.prototype.removeReturnUrlCookie = function () {
        localStorage.removeItem(AppConfigService_1.returnUrllocalStorageName);
    };
    return AppConfigService;
}());
AppConfigService.returnUrllocalStorageName = 'RETURN_URL';
AppConfigService = AppConfigService_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_8__angular_router__["b" /* ActivatedRoute */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8__angular_router__["b" /* ActivatedRoute */]) === "function" && _a || Object])
], AppConfigService);

var AppConfigService_1, _a;
//# sourceMappingURL=app-config.service.js.map

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dropdown_dropdown_option_model__ = __webpack_require__(127);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Language; });
/* unused harmony export LanguageContent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return Page; });
/* unused harmony export LandingAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SuggestionCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DefaultValue; });
/* unused harmony export STATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FeatureType; });
/* unused harmony export CompanyFeatureType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CompanyFeatureConfigType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PurposeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return ActionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return PaymentMethodType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PaymentChannelType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PaymentMethodDetailType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return PaymentErrorCodeType; });
/* unused harmony export BookerType */
/* unused harmony export PaymentMethodUpperCaseType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BookingStatusType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return PaymentType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OrderStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FeatureInternalOrderType; });
/* unused harmony export FeatureProperty */
/* unused harmony export UserExistCode */
/* unused harmony export UserExistType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return ResponseStatusType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return FilterSortType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FilterByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SortByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return OrderByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return HttpMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return EncryptionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return ApprovalActionState; });
/* unused harmony export ApprovalActionErrorCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ApprovalStatusType; });
/* unused harmony export CancelBookingType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ApprovalUpdateByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return PromotionErrorCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ConditionDisplayType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return MiceServiceTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return PaymentGateway; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return OriginalBookingStatusType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return FieldType; });
/* unused harmony export InternalOrderType */
/* unused harmony export UncommonThingsIconModel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UncommonThingsIconMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return OfferType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return DocumentType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CheckOut3DataType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return PaymentChannelStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RefundType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CallingCodeOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SSO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return HotelListRequestDefault; });
/* unused harmony export TermAndPrivacyType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return PaymentStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return LocalStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return PatternFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return BlacklistPIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return DiscountType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return RequestType; });

var Language = (function () {
    function Language() {
    }
    return Language;
}());

Language.en = 'en';
Language.th = 'th';
var LanguageContent = (function () {
    function LanguageContent() {
    }
    return LanguageContent;
}());

var Page = (function () {
    function Page() {
    }
    return Page;
}());

Page.REDIRECT = 'redirect';
Page.LEVEL_D = 'levelD';
Page.LEVEL_C = 'levelC';
Page.CHECKOUT = 'checkout';
Page.CREATE_ORDER = 'createorder';
Page.HOME = 'home';
var LandingAction = (function () {
    function LandingAction() {
    }
    return LandingAction;
}());

LandingAction.RESET = 'reset';
LandingAction.VERIFY = 'verify';
var SuggestionCategory = (function () {
    function SuggestionCategory() {
    }
    return SuggestionCategory;
}());

SuggestionCategory.DESTINATION = 'destination';
SuggestionCategory.POINT_OF_INTEREST = 'pointofinterest';
SuggestionCategory.NEAR_BY = 'nearby';
SuggestionCategory.PRODUCT = 'product';
var DefaultValue = (function () {
    function DefaultValue() {
    }
    return DefaultValue;
}());

DefaultValue.DISTANCE = 30000;
DefaultValue.CURRENCY = {
    currencyId: 1,
    currencyCode: "THB",
    currencyNameTh: "บาท ไทย",
    currencyNameEn: "Thai Baht",
    exchangeRate: 1.0
};
var STATE = (function () {
    function STATE() {
    }
    return STATE;
}());

STATE.VERIFY_ACCOUNT = 'VERIFY_ACCOUNT';
STATE.VERIFY_EMAIL = 'VERIFY_EMAIL';
STATE.LOGIN = 'LOGIN';
STATE.CREATE_ACCOUNT = 'CREATE_ACCOUNT';
STATE.CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS';
STATE.REGISTER_MEMBER = 'REGISTER_MEMBER';
STATE.JOIN_US = 'JOIN_US';
STATE.RESET_PASSWORD = 'RESET_PASSWORD';
STATE.CHECK_DOMAIN = 'CHECK_DOMAIN';
STATE.TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS';
STATE.TERMS_AND_CONDITIONS_OPEN = 'TERMS_AND_CONDITIONS_OPEN';
STATE.TERMS_AND_CONDITIONS_OPEN_VIEW = 'TERMS_AND_CONDITIONS_OPEN_VIEW';
STATE.FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
STATE.FORGOT_PASSWORD = 'FORGOT_PASSWORD';
STATE.DIALOG_MESSAGE = 'DIALOG_MESSAGE';
;
var FeatureType = (function () {
    function FeatureType() {
    }
    return FeatureType;
}());

FeatureType.ALLOW_LIMIT_BUDGET = 'allow_limit_budget';
FeatureType.ALLOW_LIMIT_ROOM = 'allow_limit_room';
FeatureType.ALLOW_LIMIT_CHILD = 'allow_limit_child';
FeatureType.ALLOW_SUPERVISOR_APPROVAL = 'allow_supervisor_approval';
FeatureType.ALLOW_EDIT_PROFILE = 'allow_edit_profile';
FeatureType.ALLOW_CHANGE_PASSWORD = 'allow_change_password';
FeatureType.ALLOW_CREDIT_TERMS = 'allow_credit_terms';
FeatureType.ALLOW_OVERLAP_BOOKING_PERIOD = 'allow_overlap_booking_period';
FeatureType.ALLOW_SEND_EMAIL_APPROVE = 'allow_send_email_approve';
FeatureType.ALLOW_SEND_EMAIL_NOTIFICATION = 'allow_send_email_notification';
FeatureType.ALLOW_BOOK_ACROSS_MONTHS = 'allow_book_across_months';
FeatureType.ALLOW_MULTI_PAYMENT = 'allow_multi_payment';
FeatureType.ALLOW_MULTI_PAYMENT_CORPORATE_FLEET = 'allow_multi_payment_corporate_fleet';
FeatureType.ALLOW_SHARE_BUDGET = 'allow_share_budget';
FeatureType.ALLOW_BOOK_FLIGHT = 'allow_book_flight';
FeatureType.ALLOW_RENT_CAR_CREDIT_TERMS = 'allow_rent_car_credit_terms';
FeatureType.ALLOW_RENT_CAR_OTHER_PAYMENTS = 'allow_rent_car_other_payments';
FeatureType.ALLOW_DISPLAY_PERMISSION_MENU = 'allow_display_permission_menu';
FeatureType.ALLOW_BOOK_WORK_PURPOSE = 'allow_book_work_purpose';
FeatureType.ENABLE_CH2_BOOKER_EMAIL = 'enable_ch2_booker_email';
FeatureType.ALLOW_CORPORATE_FLEET = 'allow_corporate_fleet';
FeatureType.ALLOW_BOOK_FOR_TRAVELLER = 'allow_book_for_traveller';
FeatureType.CONFIG_NOTIFY_TERMS_CONDITIONS_AFTER_LOGIN = 'config_notify_terms_conditions_after_login';
FeatureType.ENABLE_PIN = 'enable_pin';
FeatureType.ENABLE_PRE_APPROVAL = 'enable_pre_approval';
FeatureType.checkout3CostCenter = 'CHECKOUT_3_COST_CENTER';
FeatureType.checkout3BillingAddress = 'CHECKOUT_3_BILLING_ADDRESS';
FeatureType.checkout3InternalOrder = 'CHECKOUT_3_INTERNAL_ORDER';
FeatureType.checkout3DocumentAttach = 'CHECKOUT_3_DOCUMENT_ATTACHED';
var CompanyFeatureType = (function () {
    function CompanyFeatureType() {
    }
    return CompanyFeatureType;
}());

CompanyFeatureType.checkout3CostCenter = 'CHECKOUT_3_COST_CENTER';
CompanyFeatureType.checkout3BillingAddress = 'CHECKOUT_3_BILLING_ADDRESS';
CompanyFeatureType.checkout3InternalOrder = 'CHECKOUT_3_INTERNAL_ORDER';
CompanyFeatureType.checkout3DocumentAttach = 'CHECKOUT_3_DOCUMENT_ATTACHED';
var CompanyFeatureConfigType = (function () {
    function CompanyFeatureConfigType() {
    }
    return CompanyFeatureConfigType;
}());

CompanyFeatureConfigType.CONFIG_CHECKOUT_3 = 'config_checkout_3';
CompanyFeatureConfigType.CONFIG_NOTIFY_TERMS_CONDITIONS_AFTER_LOGIN = 'config_notify_terms_conditions_after_login';
var PurposeType = (function () {
    function PurposeType() {
    }
    return PurposeType;
}());

PurposeType.work = 'work';
PurposeType.leisure = 'leisure';
var ActionType = (function () {
    function ActionType() {
    }
    return ActionType;
}());

ActionType.autoSave = 'AUTO_SAVE';
ActionType.normalSave = 'NORMAL_SAVE';
var PaymentMethodType = (function () {
    function PaymentMethodType() {
    }
    return PaymentMethodType;
}());

PaymentMethodType.creditCard = 'creditCard';
PaymentMethodType.creditTerm = 'creditTerm';
PaymentMethodType.trueMoneyWallet = 'trueMoneyWallet';
PaymentMethodType.fleetCard = 'fleetCard';
PaymentMethodType.personalFleet = 'personalFleet';
PaymentMethodType.corporateFleet = 'corporateFleet';
PaymentMethodType.qrCode = 'qrCode';
PaymentMethodType.eWallet = 'eWallet';
PaymentMethodType.imBanking = 'imBanking';
PaymentMethodType.payAtCounter = 'payAtCounter';
var PaymentChannelType = (function () {
    function PaymentChannelType() {
    }
    return PaymentChannelType;
}());

PaymentChannelType.CREDIT_CARD = 'credit-card';
PaymentChannelType.CREDIT_TERMS = 'credit-terms';
PaymentChannelType.MULTI_PAYMENT = 'multi-payment';
PaymentChannelType.TRUE_MONEY = 'true-money';
PaymentChannelType.FLEET_CARD = 'fleet-card';
PaymentChannelType.PERSONAL_FLEET = 'personal-fleet';
PaymentChannelType.CORPORATE_FLEET = 'corporate-fleet';
PaymentChannelType.QR_CODE = 'qr-code';
PaymentChannelType.E_WALLET = 'e-wallet';
PaymentChannelType.IM_BANKING = 'im-banking';
PaymentChannelType.PAY_AT_COUNTER = 'pay-at-counter';
var PaymentMethodDetailType = (function () {
    function PaymentMethodDetailType() {
    }
    return PaymentMethodDetailType;
}());

PaymentMethodDetailType.CREDIT_CARD = 'credit_card';
PaymentMethodDetailType.CREDIT_TERMS = 'credit_terms';
PaymentMethodDetailType.TRUE_MONEY = 'true_money';
PaymentMethodDetailType.CORPORATE_FLEET = 'corporate_fleet';
PaymentMethodDetailType.PERSONAL_FLEET = 'personal_fleet';
PaymentMethodDetailType.DEBIT_CARD = 'debit_card';
PaymentMethodDetailType.MULTI_PAYMENT = 'multi_payment';
PaymentMethodDetailType.QR_CODE = 'qr_code';
PaymentMethodDetailType.E_WALLET = 'e_wallet';
PaymentMethodDetailType.IM_BANKING = 'im_banking';
PaymentMethodDetailType.PAY_AT_COUNTER = 'pay_at_counter';
var PaymentErrorCodeType = (function () {
    function PaymentErrorCodeType() {
    }
    return PaymentErrorCodeType;
}());

PaymentErrorCodeType.INVALID_CARD_NUMBER = 'Invalid Card Number';
PaymentErrorCodeType.INSUFFICIENT_FUNDS = 'Insufficient Funds';
PaymentErrorCodeType.UNKNOWN = 'Unknown';
var BookerType = (function () {
    function BookerType() {
    }
    return BookerType;
}());

BookerType.MAIN_BOOKER = 'MAIN_BOOKER';
BookerType.SHARED_BOOKER = 'SHARED_BOOKER';
var PaymentMethodUpperCaseType = (function () {
    function PaymentMethodUpperCaseType() {
    }
    return PaymentMethodUpperCaseType;
}());

PaymentMethodUpperCaseType.creditCard = 'CREDIT_CARD';
PaymentMethodUpperCaseType.creditTerms = 'CREDIT_TERMS';
var BookingStatusType = (function () {
    function BookingStatusType() {
    }
    return BookingStatusType;
}());

BookingStatusType.ON_PROCESS = 'on_process';
BookingStatusType.BOOKING_SUCCESS = 'booking_success';
BookingStatusType.WAITING_FOR_APPROVE = 'waiting_for_approve';
BookingStatusType.PAYMENT_SUCCESS = 'payment_success';
BookingStatusType.APPROVE = 'approve';
BookingStatusType.CANCEL = 'cancel';
BookingStatusType.CANCEL_BY_MAIN_BOOKER = 'cancel_by_main_booker';
BookingStatusType.CANCEL_BY_CO_BOOKER = 'cancel_by_co_booker';
BookingStatusType.REJECT_BY_SUPERVISOR = 'reject_by_main_supervisor';
BookingStatusType.REJECT_BY_CO_SUPERVISOR = 'reject_by_co_supervisor';
BookingStatusType.REJECT = 'reject';
BookingStatusType.PAYMENT_FAIL = 'payment_fail';
BookingStatusType.BOOKING_FAIL = 'booking_fail';
BookingStatusType.DEPART = 'depart';
BookingStatusType.CANNOT_CREATE_BOOKING = 'cannot_create_booking';
BookingStatusType.TIMEOUT = 'timeout';
var PaymentType = (function () {
    function PaymentType() {
    }
    return PaymentType;
}());

PaymentType.SHARE_BUDGET_BY_ADMIN = 'share_budget_by_admin';
PaymentType.SHARE_BUDGET_BY_ADMIN_MULTI_PAYMENT = 'share_budget_by_admin_multi_payment';
var OrderStatus = (function () {
    function OrderStatus() {
    }
    return OrderStatus;
}());

OrderStatus.CREATE = 'create';
OrderStatus.PAID = 'paid';
OrderStatus.BOOK = 'book';
OrderStatus.FAIL = 'fail';
OrderStatus.NO = 'no';
OrderStatus.CANCEL = 'cancel';
OrderStatus.SUCCESS = 'success';
OrderStatus.PENDING = 'pending';
var FeatureInternalOrderType = (function () {
    function FeatureInternalOrderType() {
    }
    return FeatureInternalOrderType;
}());

FeatureInternalOrderType.label = 'label';
FeatureInternalOrderType.placeholder = 'placeholder';
var FeatureProperty = (function () {
    function FeatureProperty() {
    }
    return FeatureProperty;
}());

FeatureProperty.required = 'required';
FeatureProperty.diaplay = 'display';
FeatureProperty.placeholder = 'placeholder';
FeatureProperty.label = 'label';
FeatureProperty.type = 'type';
FeatureProperty.notify = 'notify';
var UserExistCode = (function () {
    function UserExistCode() {
    }
    return UserExistCode;
}());

UserExistCode.userExisted = '2001';
UserExistCode.userNotVerified = '2002';
UserExistCode.userNotExisted = '2003';
var UserExistType = (function () {
    function UserExistType() {
    }
    return UserExistType;
}());

UserExistType.userExisted = 'User Exist';
UserExistType.userNotVerified = 'User Not Exist';
UserExistType.userNotExisted = 'User Not Verified';
var ResponseStatusType = (function () {
    function ResponseStatusType() {
    }
    return ResponseStatusType;
}());

ResponseStatusType.success = 'SUCCESS';
ResponseStatusType.failure = 'FAILURE';
ResponseStatusType.processing = 'PROCESSING';
var FilterSortType = (function () {
    function FilterSortType() {
    }
    return FilterSortType;
}());

FilterSortType.filter = 'filter';
FilterSortType.sort = 'sort';
var FilterByType = (function () {
    function FilterByType() {
    }
    return FilterByType;
}());

FilterByType.all = 'all';
FilterByType.upComing = 'up-coming';
FilterByType.departed = 'departed';
FilterByType.cancelled = 'cancelled';
FilterByType.failed = 'failed';
FilterByType.checkin = 'checkin';
FilterByType.waiting = 'waiting';
FilterByType.approved = 'approved';
FilterByType.rejected = 'rejected';
var SortByType = (function () {
    function SortByType() {
    }
    return SortByType;
}());

SortByType.bookingDate = 'booking-date';
SortByType.checkinDate = 'check-in-date';
SortByType.paymentDate = 'payment-date';
var OrderByType = (function () {
    function OrderByType() {
    }
    return OrderByType;
}());

OrderByType.ascending = 'asc';
OrderByType.descending = 'desc';
var HttpMethod = (function () {
    function HttpMethod() {
    }
    return HttpMethod;
}());

HttpMethod.GET = 'GET';
HttpMethod.POST = 'POST';
HttpMethod.PUT = 'PUT';
HttpMethod.DELETE = 'DELETE';
var EncryptionType = (function () {
    function EncryptionType() {
    }
    return EncryptionType;
}());

EncryptionType.TRUE_CUSTOM = 'true_custom';
EncryptionType.BASE64 = 'base64';
var ApprovalActionState = (function () {
    function ApprovalActionState() {
    }
    return ApprovalActionState;
}());

ApprovalActionState.APPROVED = 'APRROVED';
ApprovalActionState.REJECT_WITH_FEE = 'REJECT_WITH_FEE';
ApprovalActionState.REJECT_FREE = 'REJECT_FREE';
ApprovalActionState.REJECTED = 'REJECTED';
ApprovalActionState.UNABLE_APPROVAL = 'UNABLE_APPROVAL';
var ApprovalActionErrorCode = (function () {
    function ApprovalActionErrorCode() {
    }
    return ApprovalActionErrorCode;
}());

ApprovalActionErrorCode.CANCELED = '4201';
ApprovalActionErrorCode.APPROVED = '4202';
ApprovalActionErrorCode.REJECTED = '4203';
ApprovalActionErrorCode.INVALID_BOOKING_ID_OR_OTP = '4531';
ApprovalActionErrorCode.INVALID_BOOKING_APPROVAL = '4901';
ApprovalActionErrorCode.APPROVAL_NOT_FOUND = '4533';
var ApprovalStatusType = (function () {
    function ApprovalStatusType() {
    }
    return ApprovalStatusType;
}());

ApprovalStatusType.PENDING = 'pending';
ApprovalStatusType.APPROVE = 'approve';
ApprovalStatusType.REJECT = 'reject';
ApprovalStatusType.BOOKER_CANCELLED = 'booker_cancelled';
ApprovalStatusType.LAST_MINUTE = 'last_minute';
ApprovalStatusType.NO_ACTION = 'no_action';
ApprovalStatusType.UNABLE_TO_ACTION = 'unable_to_action';
ApprovalStatusType.UNKNOWN = 'unknown';
var CancelBookingType = (function () {
    function CancelBookingType() {
    }
    return CancelBookingType;
}());

CancelBookingType.CANCEL = 'cancel';
CancelBookingType.REJECT = 'reject';
var ApprovalUpdateByType = (function () {
    function ApprovalUpdateByType() {
    }
    return ApprovalUpdateByType;
}());

ApprovalUpdateByType.SUPERVISOR = 'supervisor';
ApprovalUpdateByType.CHECKINDATE = 'check-in date';
ApprovalUpdateByType.CRON = 'cron';
var PromotionErrorCode = (function () {
    function PromotionErrorCode() {
    }
    return PromotionErrorCode;
}());

PromotionErrorCode.REQUIRE = '4803';
PromotionErrorCode.FULLY_USED = '4804';
PromotionErrorCode.USED = '4802';
PromotionErrorCode.INVALID = '4801';
var ConditionDisplayType = (function () {
    function ConditionDisplayType() {
    }
    return ConditionDisplayType;
}());

ConditionDisplayType.ONE_BUTTON = 'oneButton';
ConditionDisplayType.TWO_BUTTON = 'twoButton';
ConditionDisplayType.ONE_BUTTON_DIVIDER = 'oneButtonDivider';
ConditionDisplayType.TABLE = 'table';
var MiceServiceTypes = (function () {
    function MiceServiceTypes() {
    }
    return MiceServiceTypes;
}());

MiceServiceTypes.TH = ['จัดงานประชุมสัมมนา',
    'จัดกิจกรรมพัฒนาบุคคลากร',
    'ทริปเดินทางในประเทศ และต่างประเทศ',
    'จัดงานเลี้ยงและงานพิธีต่างๆ',
    'จัดกิจกรรมสาธารณประโยชน์เพื่อสังคม',
    'บริการเช่าเครื่องบินส่วนตัว',
    'บริการรถเช่า',
    'จองตั๋วเครื่องบินและขอวีซ่าทั่วโลก'
];
MiceServiceTypes.EN = ['Seminar Management',
    'Team Building & Rally',
    'Group Tour & Incentive Group',
    'Staff Party & Merit-making Ceremony',
    'CSR Activity',
    'Private Jet',
    'Car Rental',
    'Ticket & Visa Service'];
var PaymentGateway = (function () {
    function PaymentGateway() {
    }
    return PaymentGateway;
}());

PaymentGateway.TCTP_GATEWAY_ID = 1;
PaymentGateway.TCTP_TMN = 3;
var OriginalBookingStatusType = (function () {
    function OriginalBookingStatusType() {
    }
    return OriginalBookingStatusType;
}());

OriginalBookingStatusType.CREATE = 'create';
OriginalBookingStatusType.PENDING = 'pending';
OriginalBookingStatusType.SUCCESS = 'success';
OriginalBookingStatusType.FAIL = 'fail';
OriginalBookingStatusType.CANCEL = 'cancel';
OriginalBookingStatusType.CANCEL_BOOKING = 'cancel_booking';
OriginalBookingStatusType.CANCEL_CREDIT = 'cancel_credit';
OriginalBookingStatusType.CANCEL_NON_CREDIT = 'cancel_non_credit';
OriginalBookingStatusType.CANCEL_MULTI_PAYMENT = 'cancel_multi_payment';
OriginalBookingStatusType.UNKNOWN = 'unknown';
var CLIENT_ID = (function () {
    function CLIENT_ID() {
    }
    return CLIENT_ID;
}());

CLIENT_ID.ASCENDTRAVEL = 1;
CLIENT_ID.B2C = 3;
var FieldType = (function () {
    function FieldType() {
    }
    return FieldType;
}());

FieldType.DROPDOWN = 'dropdown';
FieldType.FREE_TEXT = 'free_text';
FieldType.ATTACHMENT = 'attachment';
FieldType.TAX_ADDRESS_BY_API = 'tax_address_by_api';
var InternalOrderType = (function () {
    function InternalOrderType() {
    }
    return InternalOrderType;
}());

InternalOrderType.DROPDOWN = 'dropdown';
InternalOrderType.FREE_TEXT = 'free_text';
var UncommonThingsIconModel = (function () {
    function UncommonThingsIconModel(titleTH, titleEN, path) {
        this.titleTH = titleTH;
        this.titleEN = titleEN;
        this.path = path;
    }
    return UncommonThingsIconModel;
}());

var UncommonThingsIconMapping = (function () {
    function UncommonThingsIconMapping() {
    }
    UncommonThingsIconMapping.getIcon = function (title) {
        var iconMapping = UncommonThingsIconMapping.uncommonThingsIconMapping.find(function (item) {
            return title == item.titleTH || title == item.titleEN;
        });
        return iconMapping ? iconMapping.path : '';
    };
    return UncommonThingsIconMapping;
}());

UncommonThingsIconMapping.uncommonThingsIconMapping = [
    new UncommonThingsIconModel('เจอสิ่งลี้ลับ', 'Mysterious things', 'assets/images/icons/monster-ghost.png'),
    new UncommonThingsIconModel('เจอตุ๊กแก', 'Gecko', 'assets/images/icons/monster-gecko.png'),
    new UncommonThingsIconModel('เจอหนู', 'Rat', 'assets/images/icons/monster-rat.png'),
    new UncommonThingsIconModel('เจอจิ้งจก', 'Lizard', 'assets/images/icons/monster-lizard.png'),
    new UncommonThingsIconModel('เจอแมลงสาบ', 'Cockroach', 'assets/images/icons/monster-cockroach.png')
];
var OfferType = (function () {
    function OfferType() {
    }
    return OfferType;
}());

OfferType.ROOM_ONLY = 'Room Only';
OfferType.BREAKFAST = 'Breakfast';
OfferType.ALL_INCLUSIVE = 'All Inclusive';
OfferType.FULL_BOARD = 'Full Board';
OfferType.HALF_BOARD = 'Half Board';
var DocumentType = (function () {
    function DocumentType() {
    }
    return DocumentType;
}());

DocumentType.VOUCHER = 'voucher';
DocumentType.TAX_INVOICE = 'tax_invoice';
DocumentType.TAX_INVOICE_CANCEL = 'tax_invoice_cancel';
DocumentType.CREDIT_NOTE = 'credit_note';
var CheckOut3DataType = (function () {
    function CheckOut3DataType() {
    }
    return CheckOut3DataType;
}());

CheckOut3DataType.CREDIT_TERMS_INFO = 'CREDIT_TERMS_INFO';
CheckOut3DataType.CREDIT_TERMS_TAX_INFO = 'CREDIT_TERMS_TAX_INFO';
CheckOut3DataType.CREDIT_CARD_INFO = 'CREDIT_CARD_INFO';
CheckOut3DataType.CREDIT_CARD_TAX_INFO = 'CREDIT_CARD_TAX_INFO';
CheckOut3DataType.PAYMENT_INFO = 'PAYMENT_INFO';
CheckOut3DataType.TRUE_MONEY_WALLET = 'TRUE_MONEY_WALLET';
CheckOut3DataType.TRUE_MONEY_WALLET_TAX_INFO = 'TRUE_MONEY_WALLET_TAX_INFO';
CheckOut3DataType.QR_CODE = 'QR_CODE';
CheckOut3DataType.QR_CODE_TAX_INFO = 'QR_CODE_TAX_INFO';
CheckOut3DataType.E_WALLET = 'E_WALLET';
CheckOut3DataType.E_WALLET_TAX_INFO = 'E_WALLET_TAX_INFO';
CheckOut3DataType.IM_BANKING = 'IM_BANKING';
CheckOut3DataType.IM_BANKING_TAX_INFO = 'IM_BANKING_TAX_INFO';
CheckOut3DataType.PAY_AT_COUNTER = 'PAY_AT_COUNTER';
CheckOut3DataType.PAY_AT_COUNTER_TAX_INFO = 'PAY_AT_COUNTER_TAX_INFO';
var PaymentChannelStatus = (function () {
    function PaymentChannelStatus() {
    }
    return PaymentChannelStatus;
}());

// multi-payment, credit terms must alway be PAID
PaymentChannelStatus.PAID = 'PAID';
// only credit card can be PAY_LATER
PaymentChannelStatus.PAY_LATER = 'PAY_LATER';
// payment fail
PaymentChannelStatus.PAY_FAIL = 'PAY_FAIL';
// booking fail or cancel before payment date
PaymentChannelStatus.UNPAID = 'UNPAID';
var RefundType = (function () {
    function RefundType() {
    }
    return RefundType;
}());

RefundType.NON_REFUND = 'NON_REFUND';
RefundType.PARTIAL_REFUND = 'PARTIAL_REFUND';
RefundType.FULL_REFUND = 'FULL_REFUND';
var CallingCodeOption = (function () {
    function CallingCodeOption() {
    }
    return CallingCodeOption;
}());

CallingCodeOption.DEFAULT = new __WEBPACK_IMPORTED_MODULE_0__dropdown_dropdown_option_model__["a" /* Option */]('Thailand (+66)', 'TH', 'flags/th.png', '+66');
var SSO = (function () {
    function SSO() {
    }
    return SSO;
}());

SSO.RESPONSE_TPYE = 'code';
SSO.SCOPE = 'openid';
SSO.CODE_CHALLENGE_METHOD = 'S256';
SSO.CLIENT_ID = '1';
SSO.GRANT_TYPE = 'authorization_code';
SSO.INVALID_USER_CONSENT_CODE = '4005';
var HotelListRequestDefault = (function () {
    function HotelListRequestDefault() {
    }
    return HotelListRequestDefault;
}());

HotelListRequestDefault.CURRENCY_ID = 1;
HotelListRequestDefault.DISTANCE = 10000;
HotelListRequestDefault.PRICE_RANGE_MIN = 0;
HotelListRequestDefault.PRICE_RANGE_MAX = 50000;
HotelListRequestDefault.ITEM_PER_PAGE = 40;
var TermAndPrivacyType = (function () {
    function TermAndPrivacyType() {
    }
    return TermAndPrivacyType;
}());

TermAndPrivacyType.TERM_OF_USE = 'termOfUse';
TermAndPrivacyType.PRAVACY_NOTICE = 'pravacyNotice';
var PaymentStatus = (function () {
    function PaymentStatus() {
    }
    return PaymentStatus;
}());

PaymentStatus.AUTHORIZE = 'authorize';
PaymentStatus.FAIL = 'fail';
PaymentStatus.PENDING = 'pending';
PaymentStatus.SUCCESS = 'success';
PaymentStatus.CANCEL_VOID = 'void';
PaymentStatus.CANCEL_REFUND = 'refund';
PaymentStatus.CANCEL_NON_REFUND = 'non_refund';
PaymentStatus.ON_PROCESS = 'on_process';
PaymentStatus.CANCEL = 'cancel';
PaymentStatus.REFUND_FAILED = 'refund_failed';
PaymentStatus.REFUND_ON_PROCESS = 'refund_on_process';
var LocalStorage = (function () {
    function LocalStorage() {
    }
    return LocalStorage;
}());

LocalStorage.PROMOTION = 'promotion';
var PatternFormat = (function () {
    function PatternFormat() {
    }
    return PatternFormat;
}());

PatternFormat.PASSWORD_REGEXR = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,16}$/;
PatternFormat.VALID_CHARACTER = /^([A-Za-z\d@$!%*#?&]+)$/;
PatternFormat.AT_LEAST_ONE_UPPERCASE = /(?=.*?[A-Z])/;
PatternFormat.AT_LEAST_ONE_LOWERCASE = /(?=.*?[a-z])/;
PatternFormat.AT_LEAST_ONE_NUMERIC = /(?=.*?[0-9])/;
var BlacklistPIN = ['000000', '111111', '222222', '333333', '444444', '555555', '666666', '777777', '888888', '999999', '123456'];
var DiscountType = (function () {
    function DiscountType() {
    }
    return DiscountType;
}());

DiscountType.PROMOTION_CODE = 'promotion_code';
var RequestType = (function () {
    function RequestType() {
    }
    return RequestType;
}());

RequestType.NORMAL = 'normal';
RequestType.SHARE_BUDGET = 'share_budget';
RequestType.BOOK_FOR_TRAVELLER = 'book_for_traveller';
//# sourceMappingURL=constant.js.map

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsrsasign_lib_jsrsasign_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsrsasign_lib_jsrsasign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsrsasign_lib_jsrsasign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_nationalityList__ = __webpack_require__(661);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UtilitiesService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var UtilitiesService = (function () {
    function UtilitiesService(appConfig) {
        this.appConfig = appConfig;
        this.isLockedBody = false;
    }
    UtilitiesService.prototype.generateAuthorization = function (email) {
        return this.base64Encoder(email + ":" + this.appConfig.getTimeForAuthorizationHeader());
    };
    UtilitiesService.prototype.base64Encoder = function (value) {
        try {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_jsrsasign_lib_jsrsasign_js__["utf8tob64"])(value);
        }
        catch (e) {
            console.log('Error:', e);
            return '';
        }
    };
    UtilitiesService.prototype.base64Decoder = function (value) {
        try {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_jsrsasign_lib_jsrsasign_js__["b64toutf8"])(value);
        }
        catch (e) { }
        try {
            return this.customBase64Decode(value);
        }
        catch (e) {
            console.log('Error:', e);
            return '';
        }
    };
    UtilitiesService.prototype.b64toBlob = function (b64Data, contentType, sliceSize) {
        if (contentType === void 0) { contentType = ''; }
        if (sliceSize === void 0) { sliceSize = 512; }
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    };
    UtilitiesService.prototype.customBase64Decode = function (s) {
        var b = 0, l = 0, r = '';
        var m = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
        s.split('').forEach(function (v) {
            b = (b << 6) + m.indexOf(v);
            l += 6;
            while (l >= 8) {
                r += String.fromCharCode((b >>> (l -= 8)) & 0xff);
            }
        });
        return r;
    };
    UtilitiesService.prototype.reverseFormatDate = function (date) {
        var _a = date.split('-'), d = _a[0], m = _a[1], y = _a[2];
        var newD = [y, m, d];
        return newD.join('-');
    };
    UtilitiesService.prototype.resolveSlugSpace = function (value) {
        var newValue = value.split(' ').join('-');
        return newValue;
    };
    UtilitiesService.prototype.getYearFormDateFormat = function (date, format) {
        switch (format) {
            case 'dd D MMM YYYY':
                return date.split(' ')[3];
            case 'D MMM YYYY':
                return date.split(' ')[2];
        }
    };
    UtilitiesService.prototype.toBEra = function (date, format) {
        var thisYear = this.getYearFormDateFormat(date, format);
        var bEra = parseInt(thisYear) + 543;
        return date.replace(thisYear, bEra);
    };
    UtilitiesService.prototype.toBEraYear = function (year) {
        return parseInt(year) + 543;
    };
    UtilitiesService.prototype.twoNumberYear = function (date, format) {
        var thisYear = this.getYearFormDateFormat(date, format);
        var _twoNumberYear = thisYear.slice(2);
        return date.replace(thisYear, _twoNumberYear);
    };
    UtilitiesService.prototype.getOtaFormatYear = function (lang, date, format) {
        if (format === void 0) { format = 'dd D MMM YYYY'; }
        var _thisDate = __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__(date).locale(lang).format(format);
        switch (format) {
            case 'dd D MMM YYYY':
                // if thai lang convert to Budda Era.
                if (lang === __WEBPACK_IMPORTED_MODULE_5__model_constant__["a" /* Language */].th) {
                    _thisDate = this.toBEra(_thisDate, format);
                }
                else if (lang === __WEBPACK_IMPORTED_MODULE_5__model_constant__["a" /* Language */].en) {
                    // add point stop on date string
                    var _thisDateStr = _thisDate.split(' ')[0];
                    var _thisDateStrWithPoint = _thisDateStr + '.';
                    _thisDate = _thisDate.replace(_thisDateStr, _thisDateStrWithPoint);
                }
                break;
            default:
                if (lang === __WEBPACK_IMPORTED_MODULE_5__model_constant__["a" /* Language */].th) {
                    _thisDate = this.toBEra(_thisDate, format);
                }
                break;
        }
        // cut year format to two number.
        _thisDate = this.twoNumberYear(_thisDate, format);
        return _thisDate;
    };
    UtilitiesService.prototype.getDateWithFormat = function (lang, date, format, timezone) {
        if (format === void 0) { format = 'dd D MMM YYYY'; }
        var _thisDate;
        if (timezone === 'UTC') {
            _thisDate = __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__(date).utc().locale(lang).format(format);
        }
        else {
            _thisDate = __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__(date).locale(lang).format(format);
        }
        // if thai lang convert to Budda Era.
        if (lang === __WEBPACK_IMPORTED_MODULE_5__model_constant__["a" /* Language */].th) {
            _thisDate = this.convertYearToBuddhist(_thisDate);
        }
        return _thisDate;
    };
    UtilitiesService.prototype.getDateWithFormatOnly = function (lang, date, format) {
        if (format === void 0) { format = 'dd D MMM YYYY'; }
        var _thisDate = __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__(date).locale(lang).format(format);
        return _thisDate;
    };
    UtilitiesService.prototype.lockBodyMice = function () {
        var isIOS = !!navigator.platform && /iPad|iPhone/.test(navigator.platform);
        var $body = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body');
        if (isIOS) {
            $body.css({
                position: 'fixed'
            });
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('input, textarea, select').attr('tabindex', '-1');
        }
        else {
            $body.css({
                height: '100%',
                overflow: 'hidden',
            });
        }
    };
    UtilitiesService.prototype.unlockBodyMice = function () {
        var isIOS = !!navigator.platform && /iPad|iPhone/.test(navigator.platform);
        var $body = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body');
        if (isIOS) {
            $body.css({
                position: 'relative'
            });
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('input, textarea', 'select').attr('tabindex', '0');
        }
        else {
            $body.css({
                height: '',
                overflow: '',
            });
        }
    };
    UtilitiesService.prototype.lockBody = function (isOverflowHidden) {
        if (isOverflowHidden === void 0) { isOverflowHidden = true; }
        // not desktop landing-page that have fullpage.js
        if (!(!window.matchMedia('(max-width: 1024px)').matches && __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.landing-page').length > 0)) {
            this.isLockedBody = true;
            var $doc = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('html, body');
            var $bodyContent = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.body-content');
            if (window.pageYOffset) {
                this.scrollTop = window.pageYOffset;
                $bodyContent.css({
                    top: -(this.scrollTop),
                    position: 'relative'
                });
            }
            if (isOverflowHidden) {
                $doc.css({
                    height: '100%',
                    overflow: 'hidden'
                });
            }
            else {
                $doc = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body');
                $doc.css({
                    height: '100%',
                    overflow: 'hidden'
                });
            }
        }
    };
    UtilitiesService.prototype.unlockBody = function () {
        var _this = this;
        // not desktop landing-page that have fullpage.js
        if (!(!window.matchMedia('(max-width: 1024px)').matches && __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.landing-page').length > 0)) {
            this.isLockedBody = false;
            var $doc = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('html, body');
            var $bodyContent = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.body-content');
            $doc.css({
                height: '',
                overflow: ''
            });
            $bodyContent.css({
                top: '',
                position: ''
            });
            window.scrollTo(0, this.scrollTop);
            setTimeout(function () {
                _this.scrollTop = null;
            }, 0);
        }
    };
    UtilitiesService.prototype.lockBodyBackdrop = function () {
        var $body = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body');
        $body.addClass('-lock-backdrop');
    };
    UtilitiesService.prototype.unlockBodyBackdrop = function () {
        var $body = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body');
        $body.removeClass('-lock-backdrop');
    };
    UtilitiesService.prototype.commaSeparateNumber = function (num) {
        var parts = ('' + num).split('.'), s = parts[0];
        var o = '', L;
        var i = L = s.length;
        while (i--) {
            o = (i === 0 ? '' : ((L - i) % 3 ? '' : ',')) + s.charAt(i) + o;
        }
        return o + (parts[1] === undefined ? '' : '.' + parts[1]);
    };
    UtilitiesService.prototype.indexToArray = function (number) {
        var newArray = [];
        var _numberInt = parseInt(number, 10);
        var isInt = number == _numberInt ? true : false;
        var lengthLoop = isInt ? _numberInt : _numberInt + 1;
        for (var i = 0; i < lengthLoop; i++) {
            if (i == lengthLoop - 1 && !isInt) {
                newArray.push(0.5);
            }
            else {
                newArray.push(1);
            }
        }
        return newArray;
    };
    UtilitiesService.prototype.convertYearToBuddhist = function (dateString) {
        var splits = dateString.trim().split(" ");
        var plusYear = splits[splits.length - 1].length == 2 ? 43 : 543;
        splits[splits.length - 1] = (parseInt(splits[splits.length - 1]) + plusYear).toString();
        return splits.join(" ");
    };
    UtilitiesService.prototype.insertCurrencySymbol = function (amount) {
        return amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    };
    UtilitiesService.prototype.redirectPage = function (pathName, lang) {
        window.location.href = lang ? pathName + ("?lang=" + lang) : pathName;
    };
    UtilitiesService.prototype.isMobile = function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            check = true; })(navigator.userAgent || navigator.vendor);
        return check || window.matchMedia('(max-width: 767px)').matches;
    };
    UtilitiesService.prototype.isScreenLessThan416 = function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            check = true; })(navigator.userAgent || navigator.vendor);
        return check || window.matchMedia('(max-width: 416px)').matches;
    };
    UtilitiesService.prototype.isTablet = function () {
        return window.matchMedia('(max-width: 1024px)').matches;
    };
    UtilitiesService.prototype.getPriceRangeFormatText = function (number) {
        return 'THB ' + this.commaSeparateNumber(number);
    };
    UtilitiesService.prototype.getPriceRangeNumber = function (str, minPrice) {
        var _newStr = str.replace('THB', '').replace(' ', '').replace(',', '');
        if (isNaN(parseInt(_newStr)) || _newStr === '') {
            return minPrice;
        }
        else {
            return parseInt(_newStr);
        }
    };
    UtilitiesService.prototype.reFormatRangePrice = function (str, minPrice) {
        var _str = this.getPriceRangeNumber(str, minPrice);
        return this.getPriceRangeFormatText(_str);
    };
    UtilitiesService.prototype.getNumberBetweenMin = function (number, min, max) {
        var newValue = number < min ? min : number;
        newValue = newValue > max ? min : newValue;
        return newValue;
    };
    UtilitiesService.prototype.getNumberBetweenMax = function (number, min, max) {
        var newValue = number > max ? max : number;
        newValue = newValue < min ? max : newValue;
        return newValue;
    };
    UtilitiesService.prototype.getTextEllipsis = function (text, range) {
        var _text = text;
        if (text.length + 3 > range) {
            _text = text.slice(0, range) + '...';
        }
        return _text;
    };
    UtilitiesService.prototype.getNationalityList = function () {
        var nationality = __WEBPACK_IMPORTED_MODULE_6__utilities_nationalityList__["a" /* nationalityList */].list.map(function (data) { return data; });
        return nationality;
    };
    UtilitiesService.prototype.encodeToCookie = function (data) {
        return data ? this.base64Encoder(encodeURIComponent(data)) : '';
    };
    UtilitiesService.prototype.decodeFromCookie = function (data) {
        return data ? decodeURIComponent(this.base64Decoder(data)) : '';
    };
    UtilitiesService.prototype.titleize = function (title) {
        return title ? title.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); }) : "";
    };
    UtilitiesService.prototype.isSafari = function () {
        return (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) || navigator.userAgent.match(/(iPhone|iPod|iPad)/i);
    };
    UtilitiesService.prototype.isFirefox = function () {
        return (navigator.userAgent.indexOf('Firefox') != -1 && navigator.userAgent.indexOf('Chrome') == -1);
    };
    UtilitiesService.prototype.isIOS = function () {
        return navigator.userAgent.match(/(iPhone|iPod|iPad)/i);
    };
    UtilitiesService.prototype.convertDateFormat = function (timeStamp, formatTimeStamp, returnFormat, language) {
        if (returnFormat === void 0) { returnFormat = 'D MMMM YYYY'; }
        if (language === void 0) { language = undefined; }
        if (!timeStamp) {
            return '';
        }
        var newDate = __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__(timeStamp, formatTimeStamp, 'en').utc();
        var lang = language ? language : this.appConfig.getLanguage();
        switch (lang) {
            case __WEBPACK_IMPORTED_MODULE_5__model_constant__["a" /* Language */].en:
                return newDate.locale(lang).add(7, 'hour').format(returnFormat);
            case __WEBPACK_IMPORTED_MODULE_5__model_constant__["a" /* Language */].th:
            default:
                var convertDate = !returnFormat.includes('Y') ?
                    newDate.locale(lang).add(7, 'hour').format(returnFormat)
                    : this.convertYearToBuddhist(newDate.locale(lang).add(7, 'hour').format(returnFormat));
                return convertDate;
        }
    };
    UtilitiesService.prototype.randomStringWithLength = function (length, chars) {
        if (length === void 0) { length = 8; }
        if (chars === void 0) { chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghiklmnopqrstuvwxyz'; }
        var result = '';
        for (var i = 0; i < length; ++i) {
            var rnum = Math.floor(Math.random() * chars.length);
            result += chars.substring(rnum, rnum + 1);
        }
        return result;
    };
    UtilitiesService.prototype.objectToQueryString = function (obj) {
        var query = Object.keys(obj)
            .filter(function (key) { return obj[key] !== '' && obj[key] !== null && obj[key] !== undefined; })
            .map(function (key) { return key + "=" + obj[key]; })
            .join('&');
        return query.length > 0 ? "?" + query : '';
    };
    UtilitiesService.prototype.isNotExpiredURL = function (exp) {
        return exp > __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__().valueOf();
    };
    UtilitiesService.prototype.isJson = function (str) {
        try {
            JSON.parse(str);
        }
        catch (e) {
            return false;
        }
        return true;
    };
    UtilitiesService.prototype.checkDateformat = function (data, format) {
        return __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__(data, format, true).isValid();
    };
    UtilitiesService.prototype.debounce = function (func, delay) {
        var inDebounce;
        return function () {
            var context = this;
            var args = arguments;
            clearTimeout(inDebounce);
            inDebounce = setTimeout(function () { return func.apply(context, args); }, delay);
        };
    };
    UtilitiesService.prototype.objectToFormData = function (obj, rootName) {
        var formData = new FormData();
        function appendFormData(data, root) {
            root = root || '';
            if (data instanceof File) {
                formData.append(root, data);
            }
            else if (Array.isArray(data)) {
                for (var i = 0; i < data.length; i++) {
                    appendFormData(data[i], root + '[' + i + ']');
                }
            }
            else if (typeof data === 'object' && data) {
                for (var key in data) {
                    if (data.hasOwnProperty(key)) {
                        if (root === '') {
                            appendFormData(data[key], key);
                        }
                        else {
                            appendFormData(data[key], root + '.' + key);
                        }
                    }
                }
            }
            else {
                if (data !== null && typeof data !== 'undefined') {
                    formData.append(root, data);
                }
            }
        }
        appendFormData(obj, rootName);
        return formData;
    };
    UtilitiesService.prototype.oriantaionImage = function (file, callback2) {
        var callback = function (srcOrientation) {
            var reader2 = new FileReader();
            reader2.onload = function (e) {
                var srcBase64 = e.target.result;
                var img = new Image();
                img.onload = function () {
                    var width = img.width;
                    var height = img.height;
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');
                    // set proper canvas dimensions before transform & export
                    // srcOrientation not more than 9
                    // srcOrientation 4 is image flip and clockwise
                    if (4 < srcOrientation && srcOrientation < 9) {
                        canvas.width = height;
                        canvas.height = width;
                    }
                    else {
                        canvas.width = width;
                        canvas.height = height;
                    }
                    // transform context before drawing image
                    switch (srcOrientation) {
                        case 2:
                            ctx.transform(-1, 0, 0, 1, width, 0);
                            break;
                        case 3:
                            ctx.transform(-1, 0, 0, -1, width, height);
                            break;
                        case 4:
                            ctx.transform(1, 0, 0, -1, 0, height);
                            break;
                        case 5:
                            ctx.transform(0, 1, 1, 0, 0, 0);
                            break;
                        case 6:
                            ctx.transform(0, 1, -1, 0, height, 0);
                            break;
                        case 7:
                            ctx.transform(0, -1, -1, 0, height, width);
                            break;
                        case 8:
                            ctx.transform(0, -1, 1, 0, 0, width);
                            break;
                        default:
                            break;
                    }
                    // draw image
                    ctx.drawImage(img, 0, 0);
                    // export base64
                    callback2(canvas.toDataURL());
                };
                img.src = srcBase64;
            };
            reader2.readAsDataURL(file);
        };
        var reader = new FileReader();
        reader.onload = function (e) {
            var view = new DataView(e.target.result);
            if (view.getUint16(0, false) !== 0xffd8) {
                return callback(-2);
            }
            var length = view.byteLength;
            var offset = 2;
            while (offset < length) {
                var marker = view.getUint16(offset, false);
                offset += 2;
                if (marker === 0xffe1) {
                    if (view.getUint32((offset += 2), false) !== 0x45786966) {
                        return callback(-1);
                    }
                    ;
                    var little = view.getUint16((offset += 6), false) === 0x4949;
                    offset += view.getUint32(offset + 4, little);
                    var tags = view.getUint16(offset, little);
                    offset += 2;
                    for (var i = 0; i < tags; i++) {
                        if (view.getUint16(offset + i * 12, little) === 0x0112) {
                            return callback(view.getUint16(offset + i * 12 + 8, little));
                        }
                    }
                }
                else if ((marker & 0xff00) !== 0xff00) {
                    break;
                }
                else {
                    offset += view.getUint16(offset, false);
                }
            }
            return callback(-1);
        };
        reader.readAsArrayBuffer(file);
    };
    UtilitiesService.prototype.extractFileName = function (header, seperator) {
        var data = header.split(seperator);
        return data[1] ? data[1] : '';
    };
    UtilitiesService.prototype.verifyEmptyParams = function (queryParams) {
        for (var key in queryParams) {
            if (!queryParams[key]) {
                return true;
            }
        }
        return false;
    };
    UtilitiesService.prototype.encodeQueryParamWrapper = function (value, encodeUri) {
        return encodeUri ? encodeURIComponent(this.base64Encoder(JSON.stringify(value))) : this.base64Encoder(JSON.stringify(value));
    };
    return UtilitiesService;
}());
UtilitiesService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3__app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object])
], UtilitiesService);

var _a;
//# sourceMappingURL=utilities.service.js.map

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_operator_map__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_mergeMap__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vendors_moment_locale_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_user_model__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__affiliate_affiliate_service__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_services_authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__payload_encrypt_request_payload__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__payload_login_payload__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_Subject__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__payload_verify_company_domain_payload__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__model_user_verify_user_exist_model__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__payload_register_payload__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_model_user_consent_model__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_environments_properties__ = __webpack_require__(21);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






















var UserService = (function () {
    function UserService(actHttp, utilities, authService, appConfigService, affiliateService, translate) {
        this.actHttp = actHttp;
        this.utilities = utilities;
        this.authService = authService;
        this.appConfigService = appConfigService;
        this.affiliateService = affiliateService;
        this.translate = translate;
        this.cookieName = 'stf'; // tslint:disable-line
        this.listCompany = [];
        // public user: any;
        this.userSubject = new __WEBPACK_IMPORTED_MODULE_13_rxjs_Subject__["Subject"]();
        this.checkedConsent = false;
    }
    UserService.prototype.saveTokenAfterLogin = function (loginResponse) {
        if (loginResponse.token) {
            this.authService.saveSsoToken(loginResponse.token);
        }
    };
    UserService.prototype.login = function (user, password, companyId) {
        var _this = this;
        if (companyId === void 0) { companyId = 0; }
        var payload = new __WEBPACK_IMPORTED_MODULE_11__payload_login_payload__["a" /* LoginPayload */]();
        payload.username = user;
        payload.timestamp = __WEBPACK_IMPORTED_MODULE_2_vendors_moment_locale_th__().format("x");
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].AUTHORIZATION_RANDOM_STR, __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["b" /* ContentTypes */].JSON, user, JSON.stringify(payload));
        payload.clientId = 1;
        payload.companyId = companyId;
        payload.password = password;
        return this.actHttp.rawPost(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.loginAuthen, JSON.stringify(payload), options)
            .map(function (response) {
            var loginResponse = response.json().data;
            if (!!!loginResponse.token) {
                return false;
            }
            _this.saveTokenAfterLogin(loginResponse);
            return true;
        })
            .catch(function () { return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false); });
    };
    UserService.prototype.logout = function () {
        this.authService.clearToken();
        window.location.href = __WEBPACK_IMPORTED_MODULE_21_environments_properties__["k" /* redirectURIV2 */] + "/?lang=" + this.appConfigService.getLanguage();
    };
    UserService.prototype.updateFeature = function () {
        return this.authService
            .saveUserFeature(this.authService.getToken(), this.authService.getUserInfo(), __WEBPACK_IMPORTED_MODULE_8_app_services_authentication_authentication_service__["a" /* AuthenticationService */].features);
    };
    UserService.prototype.getUser = function (redirect) {
        if (redirect === void 0) { redirect = true; }
        var user = this.authService.getUserInfo();
        if (redirect && !user) {
            this.logout();
            return;
        }
        return user;
    };
    UserService.prototype.updateUser = function (user) {
        var currentUser = this.getUser();
        currentUser.fullName = user.fullName;
        currentUser.telephone = user.telephone;
        currentUser.countryCallingCode = user.countryCallingCode;
        currentUser.features = [];
        user.email && (currentUser.email = user.email);
        user.birthDate && (currentUser.birthdate = user.birthDate);
        user.timeOfBirth && (currentUser.timeOfBirth = user.timeOfBirth);
        var _user = { user: currentUser };
        this.authService.saveToken(_user);
        this.userSubject.next(_user);
    };
    UserService.prototype.getUserObs = function () {
        return this.userSubject.asObservable();
    };
    UserService.prototype.getuserInfo = function (companyId, taxAddress) {
        var id = companyId ? "companyId=" + companyId : undefined;
        var tax = taxAddress ? "taxAddress=" + taxAddress : undefined;
        var param;
        if (id && tax) {
            param = "?" + id + "&" + tax;
        }
        else if (!id && !tax) {
            param = '';
        }
        else {
            param = "?" + (id ? id : tax);
        }
        var url = "" + __WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.userInfo + param;
        var option = this.authService.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN);
        return this.actHttp.get(url, option).map(function (res) { return res.json().data; });
    };
    UserService.prototype.editProfile = function (payload) {
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["b" /* ContentTypes */].JSON, payload.email);
        return this.actHttp.put(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.editProfile.replace(':userId', payload.userId), JSON.stringify(payload), options)
            .map(function (res) { return res.json().data; });
    };
    UserService.prototype.editProfileAllCompany = function (payload) {
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["b" /* ContentTypes */].JSON, payload.email);
        return this.actHttp.put(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.editProfileAllCompany.replace(':userId', payload.userId), JSON.stringify(payload), options)
            .map(function (res) { return res.json().data; });
    };
    UserService.prototype.verifyUserExistedAndCompany = function (email) {
        var _this = this;
        var verifyUserExist = new __WEBPACK_IMPORTED_MODULE_17__model_user_verify_user_exist_model__["a" /* VerifyUserExistModel */]();
        this.listCompany = [];
        return this.verifyUserExist(email)
            .map(function (res) {
            _this.listCompany = res.companyList;
            return verifyUserExist = res;
        });
    };
    UserService.prototype.verifyDomain = function (email) {
        var payload = new __WEBPACK_IMPORTED_MODULE_16__payload_verify_company_domain_payload__["a" /* VerifyCompanyDomainPayload */]();
        payload.email = email;
        payload.appId = __WEBPACK_IMPORTED_MODULE_5__model_constant__["q" /* CLIENT_ID */].ASCENDTRAVEL;
        payload.timestamp = __WEBPACK_IMPORTED_MODULE_2_vendors_moment_locale_th__().format("x");
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].AUTHORIZATION_RANDOM_STR, __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["b" /* ContentTypes */].JSON, email, JSON.stringify(payload));
        return this.actHttp.rawPost(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.companyDomain, JSON.stringify(payload), options).map(function (res) { return res.json(); });
    };
    UserService.prototype.verifyUserExist = function (email) {
        var payload = new __WEBPACK_IMPORTED_MODULE_9__payload_encrypt_request_payload__["a" /* EncryptRequestPayload */]();
        payload.username = email;
        payload.timestamp = __WEBPACK_IMPORTED_MODULE_2_vendors_moment_locale_th__().format("x");
        payload.clientId = 1;
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].AUTHORIZATION_RANDOM_STR, __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["b" /* ContentTypes */].JSON, email, JSON.stringify(payload));
        return this.actHttp.rawPost(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.verifyUserExist, JSON.stringify(payload), options).map(function (res) { return res.json().data; });
    };
    UserService.prototype.verifyUserExistedAndLogin = function (email, password) {
        var _this = this;
        return this.verifyUserExist(email)
            .flatMap(function (res) {
            return _this.login(email, password);
        });
    };
    UserService.prototype.registerMember = function (companyId, email, password, confirmPassword) {
        var payload = new __WEBPACK_IMPORTED_MODULE_19__payload_register_payload__["a" /* RegisterPayload */](email, __WEBPACK_IMPORTED_MODULE_2_vendors_moment_locale_th__().format("x"), __WEBPACK_IMPORTED_MODULE_5__model_constant__["q" /* CLIENT_ID */].ASCENDTRAVEL, companyId);
        payload.name = email;
        payload.password = password;
        payload.confirmPassword = confirmPassword;
        payload.clientId = __WEBPACK_IMPORTED_MODULE_5__model_constant__["q" /* CLIENT_ID */].ASCENDTRAVEL;
        payload.lang = this.appConfigService.getLanguage();
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].AUTHORIZATION_RANDOM_STR, __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["b" /* ContentTypes */].JSON, payload.username, JSON.stringify(payload));
        return this.actHttp.rawPost(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.registerMember, JSON.stringify(payload), options);
    };
    UserService.prototype.verifyRegisterEmail = function (token) {
        var payload = { token: token, lang: this.appConfigService.getLanguage(), clientId: __WEBPACK_IMPORTED_MODULE_5__model_constant__["q" /* CLIENT_ID */].ASCENDTRAVEL };
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].EXCLUDE_TOKEN, __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["b" /* ContentTypes */].JSON);
        return this.actHttp.rawPost(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.verifyRegisterEmail, JSON.stringify(payload), options);
    };
    UserService.prototype.insertJoinUs = function (_a) {
        var companyName = _a.companyName, companyTravelExpense = _a.travellingExpense, companyWebsite = _a.website, email = _a.email, name = _a.name, phone = _a.contactNumber, position = _a.position;
        var payload = Array.from(arguments)[0];
        payload.timestamp = __WEBPACK_IMPORTED_MODULE_2_vendors_moment_locale_th__().format("x");
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].AUTHORIZATION_RANDOM_STR, __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["b" /* ContentTypes */].JSON, payload.username, JSON.stringify(payload));
        return this.actHttp.rawPost(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.insertJoinUs, JSON.stringify(payload), options);
    };
    UserService.prototype.changePassword = function (password, confirmPassword) {
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["b" /* ContentTypes */].JSON);
        var payload = { password: password, confirmPassword: confirmPassword };
        return this.actHttp.put(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.changePassword, JSON.stringify(payload), options);
    };
    UserService.prototype.resetPassword = function (token, password, confirmPassword) {
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].EXCLUDE_TOKEN, __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["b" /* ContentTypes */].JSON);
        var payload = { password: password, confirmPassword: confirmPassword, token: token, clientId: __WEBPACK_IMPORTED_MODULE_5__model_constant__["q" /* CLIENT_ID */].ASCENDTRAVEL };
        return this.actHttp.rawPut(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.resetPassword, JSON.stringify(payload), options).map(function (res) { return res.json(); });
    };
    UserService.prototype.forgotPassword = function (username) {
        var lang = this.appConfigService.getLanguage();
        var timestamp = __WEBPACK_IMPORTED_MODULE_2_vendors_moment_locale_th__().format("x");
        var payload = { username: username, lang: lang, timestamp: timestamp };
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].AUTHORIZATION_RANDOM_STR, __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["b" /* ContentTypes */].JSON, username, JSON.stringify(payload));
        return this.actHttp.rawPost(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.sendEmailForgetPassword, JSON.stringify(payload), options);
    };
    UserService.prototype.sendEmailRegisterVerify = function (email) {
        var lang = this.appConfigService.getLanguage();
        var timestamp = __WEBPACK_IMPORTED_MODULE_2_vendors_moment_locale_th__().format("x");
        var payload = { email: email, lang: lang, timestamp: timestamp };
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].AUTHORIZATION_RANDOM_STR, __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["b" /* ContentTypes */].JSON, payload.email, JSON.stringify(payload));
        return this.actHttp.rawPost(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.sendEmailRegisterVerify, JSON.stringify(payload), options);
    };
    UserService.prototype.editTaxAddress = function (_a) {
        var address = _a.address, active = _a.active, isDefault = _a.isDefault, title = _a.title, taxNumber = _a.taxNumber, userTaxAddressID = _a.userTaxAddressID;
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["b" /* ContentTypes */].JSON);
        var payload = Array.from(arguments)[0];
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.editTaxAddress, JSON.stringify(payload), options);
    };
    UserService.prototype.addTaxAddress = function (_a) {
        var isDefault = _a.isDefault, active = _a.active, title = _a.title, address = _a.address, taxNumber = _a.taxNumber;
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["b" /* ContentTypes */].JSON);
        var payload = Array.from(arguments)[0];
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.addTaxAddress, JSON.stringify(payload), options);
    };
    UserService.prototype.getBillingAddress = function () {
        return this.actHttp.get(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.getBilling, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
            .map(function (res) { return res.json().data; });
    };
    UserService.prototype.createBillingAddress = function (billing) {
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.createBilling, billing, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
            .map(function (res) { return res.json().data; });
    };
    UserService.prototype.updateBillingAddress = function (billing) {
        return this.actHttp.put(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.updateBilling, billing, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
            .map(function (res) { return res.json().data; });
    };
    UserService.prototype.deleteBillingAddress = function (billing) {
        return this.actHttp.delete(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.deleteBilling.replace('{billingId}', billing.billingId.toString()), this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
            .map(function (res) { return res.json().data; });
    };
    UserService.prototype.checkBudgetLimit = function (searchData) {
        var budgetLimit = new __WEBPACK_IMPORTED_MODULE_4__model_user_model__["a" /* BudgetLimitModel */]();
        var budgetLimitFeature = this.getUserFeature(__WEBPACK_IMPORTED_MODULE_5__model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET);
        if (searchData.purpose === __WEBPACK_IMPORTED_MODULE_5__model_constant__["o" /* PurposeType */].work && budgetLimitFeature && budgetLimitFeature.allow && budgetLimitFeature.data && budgetLimitFeature.data.amount > 0) {
            budgetLimit.isLimitBudget = true;
            budgetLimit.budget = budgetLimitFeature.data.amount.toFixed(2);
            budgetLimit.description = this.translate.transform("product-detail-budget-limit")
                .replace(/{x}/gi, this.utilities.getPriceRangeFormatText(budgetLimit.budget));
        }
        else {
            budgetLimit.isLimitBudget = false;
        }
        return budgetLimit;
    };
    UserService.prototype.getUserFeature = function (featureName, ignoreError) {
        if (ignoreError === void 0) { ignoreError = false; }
        var user = this.getUser(!ignoreError);
        var feature = user && user.features.find(function (ft) { return ft.feature === featureName; });
        return feature;
    };
    UserService.prototype.getAllCompanyUser = function () {
        return this.actHttp.get(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.getAllCompanyUser, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
            .map(function (res) { return res.json().data; });
    };
    UserService.prototype.checkAllowToPayOverBudget = function () {
        var allowMultiPayment = this.getUserFeature(__WEBPACK_IMPORTED_MODULE_5__model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT) && this.getUserFeature(__WEBPACK_IMPORTED_MODULE_5__model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT).allow;
        var allowCreditTerms = this.getUserFeature(__WEBPACK_IMPORTED_MODULE_5__model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS) && this.getUserFeature(__WEBPACK_IMPORTED_MODULE_5__model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS).allow;
        var allowMultiPaymentCorporateFleet = this.getUserFeature(__WEBPACK_IMPORTED_MODULE_5__model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT_CORPORATE_FLEET) && this.getUserFeature(__WEBPACK_IMPORTED_MODULE_5__model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT_CORPORATE_FLEET).allow;
        var allowCorporateFleet = this.getUserFeature(__WEBPACK_IMPORTED_MODULE_5__model_constant__["b" /* FeatureType */].ALLOW_CORPORATE_FLEET) && this.getUserFeature(__WEBPACK_IMPORTED_MODULE_5__model_constant__["b" /* FeatureType */].ALLOW_CORPORATE_FLEET).allow;
        return allowMultiPayment && allowCreditTerms || allowMultiPaymentCorporateFleet && allowCorporateFleet;
    };
    UserService.prototype.getAcceptPrivacyNote = function () {
        return this.actHttp.get(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.getAcceptPrivacyNote, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
            .map(function (res) { return res.json().data; });
    };
    UserService.prototype.getCallingCode = function () {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"](function (subscriber) {
            if (_this.callingCodeList) {
                subscriber.next(_this.callingCodeList);
                subscriber.complete();
            }
            else {
                _this.getCallingCodeFromAPI().subscribe(function (res) {
                    _this.callingCodeList = res;
                    subscriber.next(_this.callingCodeList);
                    subscriber.complete();
                }, function (err) { return subscriber.error(err); });
            }
        });
    };
    UserService.prototype.getCallingCodeFromAPI = function () {
        return this.actHttp.get(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.getCallingCode, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN)).map(function (res) { return res.json().data; });
    };
    UserService.prototype.postAcceptPrivacyNote = function (id) {
        var payload = { userId: id };
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.getAcceptPrivacyNote, JSON.stringify(payload), this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
            .map(function (res) { return res; });
    };
    UserService.prototype.getCompanyShareBudget = function () {
        return this.actHttp.get(__WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.companyShareBudget, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN)).map(function (res) { return res.json().data; });
    };
    UserService.prototype.generateShareBudgetCode = function (companyId, regenerate) {
        var url = __WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.generateBudgetCode + "?companyId=" + companyId + "&regenerate=" + regenerate;
        return this.actHttp.get(url, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN)).map(function (res) { return res.json().data; });
    };
    UserService.prototype.getUserConsentDetail = function (userId, name, types, lang) {
        var url = __WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.getUserConsentDetail.replace(':userId', userId.toString()).replace(':name', name) + ("?types=" + types + "&lang=" + lang);
        return this.actHttp.get(url, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN)).map(function (res) { return res.json().data; });
    };
    UserService.prototype.getConsentDetail = function (name, types, lang) {
        var url = __WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.getConsentDetail.replace(':name', name) + ("?types=" + types + "&lang=" + lang);
        return this.actHttp.rawGet(url).map(function (res) { return res.json().data; });
    };
    UserService.prototype.updateConsent = function (userId, consentId, purposeIds) {
        var url = __WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.updateUserConsent.replace(':userId', userId.toString());
        var payload = new __WEBPACK_IMPORTED_MODULE_20_app_model_user_consent_model__["a" /* UserSubmitConsentRequest */]();
        payload.consentId = consentId;
        payload.purposeIds = purposeIds;
        return this.actHttp.post(url, JSON.stringify(payload), this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN)).map(function (res) { return res; });
    };
    UserService.prototype.getPurposeByUserId = function (userId, name, lang) {
        var url = __WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.getPurposeByUserId
            .replace(':userId', userId.toString())
            .replace(':name', name)
            + ("?lang=" + lang);
        return this.actHttp.get(url, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN)).map(function (res) { return res.json().data; });
    };
    UserService.prototype.updatePurposeByUserId = function (userId, action, request) {
        var url = __WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.updatePurposeByUserId
            .replace(':userId', userId.toString())
            .replace(':action', action);
        return this.actHttp.post(url, request, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN));
    };
    UserService.prototype.hideMessageCart = function (currentUser) {
        var budgetlimit = currentUser.features.filter(function (x) { return x.feature === __WEBPACK_IMPORTED_MODULE_5__model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET && x.allow; })[0];
        var budgetlimitPerMonthPerYear = budgetlimit && budgetlimit.data && (budgetlimit.data.amountPerMonth || budgetlimit.data.amountPerYear);
        var corporateFleetMulti = currentUser.features.filter(function (x) {
            return (x.feature === __WEBPACK_IMPORTED_MODULE_5__model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT_CORPORATE_FLEET && x.allow) ||
                (x.feature === __WEBPACK_IMPORTED_MODULE_5__model_constant__["b" /* FeatureType */].ALLOW_CORPORATE_FLEET && x.allow);
        }).length === 2;
        return !!budgetlimitPerMonthPerYear && corporateFleetMulti;
    };
    UserService.prototype.travellerSuggest = function (search) {
        var queryParams = new URLSearchParams();
        queryParams.append("queryText", search);
        queryParams.append("companyId", this.getUser().companyId.toString());
        var url = __WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.travellerSuggest + "?" + queryParams;
        return this.actHttp.get(url, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN)).map(function (res) { return res.json().data; });
    };
    UserService.prototype.travellerDetail = function (userId, companyId, searchId) {
        var url = __WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.travellerDetail + "/" + userId + "?companyId=" + companyId + "&searchId=" + searchId;
        return this.actHttp.get(url, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN)).map(function (res) { return res.json().data; });
    };
    UserService.prototype.updateUserSetting = function (userId, request) {
        var url = __WEBPACK_IMPORTED_MODULE_18__environments_environment__["a" /* environment */].endpoint.userSetting.replace(':userId', userId.toString());
        return this.actHttp.put(url, request, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN));
    };
    return UserService;
}());
UserService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_15_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_15_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_8_app_services_authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8_app_services_authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_6__affiliate_affiliate_service__["a" /* AffiliateService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6__affiliate_affiliate_service__["a" /* AffiliateService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_14_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_14_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _f || Object])
], UserService);

var _a, _b, _c, _d, _e, _f;
//# sourceMappingURL=user.service.js.map

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return domainName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return configFlight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return configCarRental; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return configB2C; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return disableHome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return useHomeV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return disableHotelList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return useHotelListV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return disableHotelDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return useHotelDetailV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return redirectURIV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return publicKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return googleTagManagerId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return googleTagManagerAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return googleTagManagerPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return googleMapKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return productionMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return hotjarId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return imgUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return resizeImageGateway; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return redirectURI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return accountFrontend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return frontend; });
/* unused harmony export travelTogether */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return asq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return imageURI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return domain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return prefixCookieName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return onetrustDataDomainScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return clarityKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return consentName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return cookiesConsentName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return reCaptchaSiteKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return envName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sentryKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return effectiveDateNewTaxAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return landingUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return thresholdExpireToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return maintenanceSite; });
var domainName = {
    frontend: 'https://act-frontend.ascendtravel.com',
    backend: 'https://act-backend.ascendtravel.com',
    service: 'https://api.ascendtravel.com',
};
var configFlight = {
    displayFlight: true,
    clientId: 'traveligo',
    redirectURI: 'https://corporate.traveligo.com/account/generate-code'
};
var configCarRental = {
    displayCarRental: true,
    clientId: 'rentConnected',
    redirectURI: 'https://www.rentconnected.com/external/AscendLogin'
};
var configB2C = {
    clientId: '3',
};
var disableHome = true;
var useHomeV2 = true;
var disableHotelList = true;
var useHotelListV2 = true;
var disableHotelDetail = true;
var useHotelDetailV2 = true;
var redirectURIV2 = 'https://hotel.ascendtravel.com';
var publicKey = 'https://s3-ap-northeast-1.amazonaws.com/ascendtravel-authentication-keys-prod/access_publickey.cer';
var googleTagManagerId = 'GTM-PL3LW4DL';
var googleTagManagerAuth = '6G9XCEUrTLHKzNwSxFddKg';
var googleTagManagerPreview = 'env-1';
var googleMapKey = 'AIzaSyDFz9J6xoeuEUW5SZUmu21oYZ0CHzvYUBo';
var productionMode = true;
var hotjarId = 1193934;
var imgUrl = 'https://s3-ap-southeast-1.amazonaws.com/ascendtravel-image';
var resizeImageGateway = 'https://api-gateway.ascendtravel.com';
var redirectURI = 'https://www.ascendtravel.com/redirect';
var accountFrontend = 'https://account.ascendtravel.com/login';
var frontend = 'https://www.ascendtravel.com';
var travelTogether = 'https://traveltogether.ascendtravel.com';
var asq = 'https://asq.ascendtravel.com';
var imageURI = 'https://images.ascendtravel.com';
var domain = '.ascendtravel.com';
var prefixCookieName = 'act';
var onetrustDataDomainScript = '01913111-d877-7309-b285-2d887b5809fa';
var clarityKey = '5fzf2o7ger';
var consentName = 'act';
var cookiesConsentName = 'cookies';
var reCaptchaSiteKey = '6LcY6AAbAAAAAErYiOifjkZSURh4N8pineRfDbpv';
var envName = 'prod';
var sentryKey = 'https://191a9407eaa0468396cb8130bbebec23@o949524.ingest.sentry.io/5898276';
var effectiveDateNewTaxAddress = '01-12-2021 00:00';
var landingUrl = 'https://landing.ascendtravel.com';
var thresholdExpireToken = 300000;
var maintenanceSite = 'https://close.ascendtravel.com/act-maintenance';
//# sourceMappingURL=properties.js.map

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(21);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return environment; });

var serviceEndpoint = {
    frontendService: "" + __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].frontend,
    adaptorService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/adaptor",
    searchService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/search-api",
    backendService: "" + __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].backend,
    bookingService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/booking",
    cartV4Service: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/cart-v4",
    paymentService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/payment",
    paymentV2Service: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/payment-v2",
    controlService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/control",
    aadService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/aadauthen",
    accountService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/account",
    integrationService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/integration",
    reportService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/report",
    reportV2Service: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/report-v2",
    hotelService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/hotel",
    reviewService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/review",
    documentService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/document",
    bookingV2Service: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/booking-v2",
    companyService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/company",
    ascendTravelAuthorization: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/ascendtravel-authorization",
    userService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/user",
    companyV2Service: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/company-v2",
    authenticationCenter: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/authentication-center",
    creditService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/credit",
    promotionService: __WEBPACK_IMPORTED_MODULE_0__properties__["A" /* domainName */].service + "/promotion",
};
var environment = {
    googleTagManagerId: __WEBPACK_IMPORTED_MODULE_0__properties__["B" /* googleTagManagerId */],
    googleTagManagerAuth: __WEBPACK_IMPORTED_MODULE_0__properties__["C" /* googleTagManagerAuth */],
    googleTagManagerPreview: __WEBPACK_IMPORTED_MODULE_0__properties__["D" /* googleTagManagerPreview */],
    production: __WEBPACK_IMPORTED_MODULE_0__properties__["E" /* productionMode */],
    hotjarId: __WEBPACK_IMPORTED_MODULE_0__properties__["F" /* hotjarId */],
    publicKey: "" + __WEBPACK_IMPORTED_MODULE_0__properties__["G" /* publicKey */],
    googleMapKey: "" + __WEBPACK_IMPORTED_MODULE_0__properties__["H" /* googleMapKey */],
    reCaptchaSiteKey: __WEBPACK_IMPORTED_MODULE_0__properties__["I" /* reCaptchaSiteKey */],
    envName: __WEBPACK_IMPORTED_MODULE_0__properties__["b" /* envName */],
    prefixCookieName: __WEBPACK_IMPORTED_MODULE_0__properties__["d" /* prefixCookieName */],
    endpoint: {
        // Authentication
        'refreshToken': serviceEndpoint.authenticationCenter + "/api/v1/user/token",
        'authorizeRequest': serviceEndpoint.authenticationCenter + "/api/v1/authorize",
        'getTokenAuthen': serviceEndpoint.authenticationCenter + "/api/v1/token",
        'loginAuthen': serviceEndpoint.authenticationCenter + "/api/v1/user/login",
        'consent': serviceEndpoint.authenticationCenter + "/api/v1/authorize/consent",
        'sendEmailForgetPassword': serviceEndpoint.authenticationCenter + "/api/v1/user/forget-password",
        'resetPassword': serviceEndpoint.authenticationCenter + "/api/v1/user/reset-password",
        'verifyUserExist': serviceEndpoint.authenticationCenter + "/api/v1/user/exist",
        'verifyRegisterEmail': serviceEndpoint.authenticationCenter + "/api/v1/user/verify",
        'changePassword': serviceEndpoint.authenticationCenter + "/api/v1/user/password",
        'sendEmailRegisterVerify': serviceEndpoint.authenticationCenter + "/api/v1/user/verify/resend",
        'publicKeyPIN': serviceEndpoint.authenticationCenter + "/api/v1/key/public",
        'userPINExists': serviceEndpoint.authenticationCenter + "/api/v1/user/{userId}/pin/exists",
        'setupPIN': serviceEndpoint.authenticationCenter + "/api/v1/user/pin",
        'verifyPIN': serviceEndpoint.authenticationCenter + "/api/v1/pin/verify",
        'requestOTP': serviceEndpoint.authenticationCenter + "/api/v1/otp/request",
        'verifyOTP': serviceEndpoint.authenticationCenter + "/api/v1/otp/verify",
        'userPhone': serviceEndpoint.authenticationCenter + "/api/v1/user/phone",
        // billing address
        'getFeature': serviceEndpoint.accountService + "/api/1.0/users/features",
        'getBilling': serviceEndpoint.accountService + "/api/1.0/users/billing/list",
        'createBilling': serviceEndpoint.accountService + "/api/1.0/users/billing/create",
        'updateBilling': serviceEndpoint.accountService + "/api/1.0/users/billing/update",
        'deleteBilling': serviceEndpoint.accountService + "/api/1.0/users/billing/{billingId}",
        // user service
        'creditterm': serviceEndpoint.adaptorService + "/api/v1/user/creditterm",
        'getAllCompanyUser': serviceEndpoint.companyV2Service + "/api/v2/user/companies",
        'loginV2': serviceEndpoint.userService + "/api/v2/user/login",
        'getCallingCode': serviceEndpoint.userService + "/api/v2/act/country/calling-code/list",
        'userInfo': serviceEndpoint.userService + "/api/v2/user/information",
        'travellerSuggest': serviceEndpoint.userService + "/api/v2/user/search/suggest",
        'travellerDetail': serviceEndpoint.userService + "/api/v3/traveller",
        'userSetting': serviceEndpoint.userService + "/api/v2/user/:userId/setting",
        // search service
        'getSearchSuggestion': serviceEndpoint.searchService + "/api/v2/GetSearchSuggestion",
        'getProductList': serviceEndpoint.searchService + "/api/v2/hotels",
        'getProductListWithPOI': serviceEndpoint.searchService + "/api/v2/hotels/poi",
        'getProductDetail': serviceEndpoint.searchService + "/api/v2/hotel/detail",
        'getProductRoomDetail': serviceEndpoint.searchService + "/api/v3/room/detail",
        'getProductOptionDetail': serviceEndpoint.searchService + "/api/v3/room/more/detail",
        'getProductNearBy': serviceEndpoint.searchService + "/api/v2/hotels/nearby",
        // search service v3
        'getProductListWithPOIV3': serviceEndpoint.searchService + "/api/v3/hotels/poi",
        'getHotelList': serviceEndpoint.searchService + "/api/v3/hotels",
        'getTopHoteList': serviceEndpoint.searchService + "/api/v3/hotels/top",
        'getAdsHotelByDestination': serviceEndpoint.searchService + "/api/v3/hotels/ranking-ads/destination",
        'getAdsHotelByPOI': serviceEndpoint.searchService + "/api/v3/hotels/ranking-ads/poi",
        'getCurrencies': serviceEndpoint.searchService + "/api/v3/currencies",
        // cart service
        'addToCartV4': serviceEndpoint.cartV4Service + "/api/v4/cart",
        'getCartV4Checkout': serviceEndpoint.cartV4Service + "/api/v4/cart/{cartId}/checkout",
        // Home module
        'getProductListByCategory': serviceEndpoint.searchService + "/api/GetProductListByCategory",
        'registerMember': serviceEndpoint.userService + "/api/v2/user/register",
        // Profile module
        'getProfile': serviceEndpoint.userService + "/api/v2/user/profile",
        'editProfile': serviceEndpoint.userService + "/api/v2/user/:userId",
        'editProfileAllCompany': serviceEndpoint.userService + "/api/v2/companies/user/:userId",
        'editTaxAddress': serviceEndpoint.userService + "/api/v2/taxaddress/edit",
        'addTaxAddress': serviceEndpoint.userService + "/api/v2/taxaddress/add",
        'getAcceptPrivacyNote': serviceEndpoint.userService + "/api/v2/user/acceptPrivacyNote",
        'getUserConsentDetail': serviceEndpoint.userService + "/api/v2/user/:userId/consent/:name",
        'getConsentDetail': serviceEndpoint.userService + "/api/v2/consent/:name",
        'updateUserConsent': serviceEndpoint.userService + "/api/v2/user/:userId/consent",
        'getPurposeByUserId': serviceEndpoint.userService + "/api/v2/user/:userId/consent/:name/purpose",
        'updatePurposeByUserId': serviceEndpoint.userService + "/api/v2/user/:userId/consent/purpose/:action",
        // Booking Service
        'getBookingList': serviceEndpoint.bookingV2Service + "/api/v2/my-booking/list",
        'getBookingCancellationFee': serviceEndpoint.bookingV2Service + "/api/v2/booking/:bookingId/cancellation/detail",
        'getBookingDetails': serviceEndpoint.bookingV2Service + "/api/v2/my-booking",
        'getBookingSuggestion': serviceEndpoint.bookingV2Service + "/api/v2/my-booking/suggest",
        'cancelBooking': serviceEndpoint.bookingV2Service + "/api/v2/cancel/booking/",
        'cancelOldBooking': serviceEndpoint.frontendService + "/api/BookingCancel",
        'getOldBookingPDF': serviceEndpoint.frontendService + "/eng/{bookingID}/download.html",
        'getBookingReport': serviceEndpoint.reportV2Service + "/api/v2/booker/accrued/creditterm",
        'getBookingReportUrl': serviceEndpoint.reportV2Service + "/api/v2/report/url",
        'getBookingVoucherPDF': serviceEndpoint.documentService + "/api/v2/document/customer/voucher",
        'downloadDocument': serviceEndpoint.documentService + "/api/v2/my-booking/document",
        'preBookingValidatePromotionCode': serviceEndpoint.bookingV2Service + "/api/v3/pre-book/validate/promotion-code",
        'getPreBookingPromotionCodeList': serviceEndpoint.bookingV2Service + "/api/v3/pre-book/promotion-code/list",
        // Control Service
        'createOrder': serviceEndpoint.controlService + "/api/v1/createOrder",
        'checkBookingApprovalStatus': serviceEndpoint.controlService + "/api/v1/approval/status",
        'updateBookingApprovalStatus': serviceEndpoint.controlService + "/api/v1/approval",
        // Approval Service
        'getApprovalList': serviceEndpoint.bookingV2Service + "/api/v2/approval/booking/list",
        'getApprovalDetails': serviceEndpoint.bookingV2Service + "/api/v2/approval/booking/{bookingID}/detail",
        'getApprovalSuggestion': serviceEndpoint.bookingV2Service + "/api/v2/approval/suggestion",
        'approve': serviceEndpoint.bookingV2Service + "/api/v2/booking/approve",
        'reject': serviceEndpoint.bookingV2Service + "/api/v2/booking/approval/reject",
        // Payment Service
        'validateCreditCart': serviceEndpoint.paymentV2Service + "/api/v2/credit-card/validate/",
        // scb
        'scb': serviceEndpoint.frontendService + "/sa2017",
        // Integration Service
        'getUrlAuthenRequest': serviceEndpoint.integrationService + "/api/:affiliate/authenticate",
        'getAffiliateConsume': serviceEndpoint.integrationService + "/api/:affiliate/consume",
        'loginAffiliate': serviceEndpoint.integrationService + "/api/:affiliate/login",
        'logoutAffiliate': serviceEndpoint.integrationService + "/api/:affiliate/logout",
        'getTaxAddress': serviceEndpoint.integrationService + "/api/getTaxAddress/:affiliate/:costCenterCode",
        // Review Service
        'rating': serviceEndpoint.reviewService + "/api/v2/rating/:token",
        'getHotelReviewList': serviceEndpoint.reviewService + "/api/v2/hotel/{hotelId}/review/list",
        // Banner Service
        'getBannerHotelDealList': serviceEndpoint.hotelService + "/api/v2/banner/hotel-deals",
        'getBannerBillboard': serviceEndpoint.hotelService + "/api/v2/banner/billboard",
        'getBannerOverlay': serviceEndpoint.hotelService + "/api/v2/banner/overlay",
        'getBannerLeaderboard': serviceEndpoint.hotelService + "/api/v2/banner/leaderboard",
        // Confirm Supplier Service
        'supplierConfirmation': serviceEndpoint.bookingV2Service + "/api/v2/supplier/booking/confirmation/status",
        'supplierConfirmationSubmitEmailConfirm': serviceEndpoint.bookingV2Service + "/api/v2/supplier/booking/confirmation/acceptance",
        'supplierConfirmationSubmitEmailReject': serviceEndpoint.bookingV2Service + "/api/v2/supplier/booking/confirmation/rejection",
        // Checkout Service
        'travellerManagement': serviceEndpoint.userService + "/api/v2/user-guest",
        'travellerBudget': serviceEndpoint.bookingV2Service + "/api/v3/pre-book/validate/traveller/budget",
        'travellerBudgetMultipayment': serviceEndpoint.bookingV2Service + "/api/v3/pre-book/adjust/traveller/budget/multi-payment",
        // Credit Service
        'budgetAvailable': serviceEndpoint.creditService + "/api/v1/budget/available",
        'getMyBudget': serviceEndpoint.creditService + "/api/v1/my-budget/company/{companyId}/user/{userId}",
        'getFleetCardInformation': serviceEndpoint.creditService + "/api/v1/user/fleets",
        'getTransactionHistory': serviceEndpoint.creditService + "/api/v1/user/fleet/{fleetCardId}/history",
        'registerFleetCard': serviceEndpoint.creditService + "/api/v1/fleet/register",
        'transferFleetCard': serviceEndpoint.creditService + "/api/v1/user/fleet/transfer",
        // Mice Module
        'miceQuotation': serviceEndpoint.hotelService + "/api/v2/mice/quotation",
        // Booking V2
        'createBooking': serviceEndpoint.bookingV2Service + "/api/v3/booking/create",
        'getBookingCancellationStatus': serviceEndpoint.bookingV2Service + "/api/v2/booking/cancellation/status",
        'getBookingStatus': serviceEndpoint.bookingV2Service + "/api/v2/booking/:bookingId/booking/status",
        'getBookingDetailsV2': serviceEndpoint.bookingV2Service + "/api/v2/my-booking",
        'uploadBookingDocument': serviceEndpoint.bookingV2Service + "/api/v2/booking/document",
        // Company V2
        'companyDomain': serviceEndpoint.companyV2Service + "/api/v2/company/domain",
        'insertJoinUs': serviceEndpoint.companyV2Service + "/api/v2/company/join-us",
        'getTaxInvoice': serviceEndpoint.companyV2Service + "/api/v2/taxinvoice",
        'validatePromotionCode': serviceEndpoint.companyV2Service + "/api/v2/promotion/verify",
        'companyShareBudget': serviceEndpoint.companyV2Service + "/api/v2/user/companies/share-budget",
        // Ascendtravel Authorization Service
        'getFeaturesActAuthz': serviceEndpoint.ascendTravelAuthorization + "/api/v2/user/features",
        'setBudgetSuggestion': serviceEndpoint.ascendTravelAuthorization + "/api/v2/user/suggestion-budget",
        'generateBudgetCode': serviceEndpoint.ascendTravelAuthorization + "/api/v2/share-budget/generate/code",
        'userShareCode': serviceEndpoint.ascendTravelAuthorization + "/api/v2/share-budget/code/:code",
        'companyCommunication': serviceEndpoint.ascendTravelAuthorization + "/api/v2/user/communication-preference",
        'companyCommunicationBanner': serviceEndpoint.ascendTravelAuthorization + "/api/v2/user/communication-preference/banner",
        'preApprovalDetail': serviceEndpoint.ascendTravelAuthorization + "/api/v2/pre-approval-requests/:approvalRequestId",
        // API Gateway
        'resizeUri': __WEBPACK_IMPORTED_MODULE_0__properties__["J" /* resizeImageGateway */] + "/resize/image",
        // Promotion
        'campaignTracking': serviceEndpoint.promotionService + "/api/v2/campaign/{campaignId}/track-event",
    },
    onetrustDataDomainScript: __WEBPACK_IMPORTED_MODULE_0__properties__["K" /* onetrustDataDomainScript */],
    clarityKey: __WEBPACK_IMPORTED_MODULE_0__properties__["L" /* clarityKey */],
};
//# sourceMappingURL=environment.js.map

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translation_lang_en__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translation_lang_th__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_model_constant__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslatePipe; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var TranslatePipe = (function () {
    function TranslatePipe(appConfigService) {
        this.appConfigService = appConfigService;
    }
    TranslatePipe.prototype.transform = function (value, replaceWith, replaceValue) {
        var str;
        switch (this.appConfigService.getLanguage()) {
            case __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["a" /* Language */].th:
                str = __WEBPACK_IMPORTED_MODULE_3__translation_lang_th__["a" /* LANG_TH_TRANS */][value];
                break;
            default:
                str = __WEBPACK_IMPORTED_MODULE_2__translation_lang_en__["a" /* LANG_EN_TRANS */][value];
                break;
        }
        return str && replaceWith && replaceValue ? str.replace(new RegExp(replaceWith, 'g'), replaceValue) : str;
    };
    return TranslatePipe;
}());
TranslatePipe = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
        name: 'translate',
        pure: false
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object])
], TranslatePipe);

var _a;
//# sourceMappingURL=translate.pipe.js.map

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__warning_warning_service__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_environments_properties__ = __webpack_require__(21);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HeaderKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HeaderValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HttpStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContentTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ActHttpService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var HeaderKey = (function () {
    function HeaderKey() {
    }
    return HeaderKey;
}());

HeaderKey.contentType = 'Content-Type';
HeaderKey.wemallAccessToken = 'X-WM-AccessToken';
HeaderKey.wemallRefreshAccessToken = 'X-WM-RefreshToken';
HeaderKey.actAccessToken = 'X-ACT-AccessToken';
HeaderKey.actRefreshToken = 'X-ACT-RefreshToken';
HeaderKey.authorization = 'Authorization';
var HeaderValue = (function () {
    function HeaderValue() {
    }
    return HeaderValue;
}());

HeaderValue.applicationJson = 'application/json';
HeaderValue.applicationWebForm = 'application/x-www-form-urlencoded';
var HttpStatus = (function () {
    function HttpStatus() {
    }
    return HttpStatus;
}());

HttpStatus.notFound = 404;
HttpStatus.serviceUnavailable = 503;
var HeaderTypes;
(function (HeaderTypes) {
    HeaderTypes[HeaderTypes["AUTHORIZATION"] = 0] = "AUTHORIZATION";
    HeaderTypes[HeaderTypes["AUTHORIZATION_WM_TOKEN"] = 1] = "AUTHORIZATION_WM_TOKEN";
    HeaderTypes[HeaderTypes["ACT_TOKEN"] = 2] = "ACT_TOKEN";
    HeaderTypes[HeaderTypes["SSO_TOKEN"] = 3] = "SSO_TOKEN";
    HeaderTypes[HeaderTypes["EXCLUDE_TOKEN"] = 4] = "EXCLUDE_TOKEN";
    HeaderTypes[HeaderTypes["AUTHORIZATION_RANDOM_STR"] = 5] = "AUTHORIZATION_RANDOM_STR";
})(HeaderTypes || (HeaderTypes = {}));
var ContentTypes;
(function (ContentTypes) {
    ContentTypes[ContentTypes["JSON"] = 0] = "JSON";
    ContentTypes[ContentTypes["URLENCODE"] = 1] = "URLENCODE";
})(ContentTypes || (ContentTypes = {}));
var ActHttpService = ActHttpService_1 = (function () {
    function ActHttpService(http, authenticationService, utilitiesService, appConfigService, warningService) {
        this.http = http;
        this.authenticationService = authenticationService;
        this.utilitiesService = utilitiesService;
        this.appConfigService = appConfigService;
        this.warningService = warningService;
    }
    ActHttpService.prototype.rawGet = function (url, options) {
        return this.http.get(url, options).catch(this.handleError);
    };
    ActHttpService.prototype.rawPost = function (url, body, options) {
        return this.http.post(url, body, options).catch(this.handleError);
    };
    ActHttpService.prototype.rawPut = function (url, body, options) {
        return this.http.put(url, body, options).catch(this.handleError);
    };
    ActHttpService.prototype.rawDelete = function (url, options) {
        return this.http.delete(url, options).catch(this.handleError);
    };
    ActHttpService.prototype.get = function (url, options) {
        var _this = this;
        return this.authenticationService.validateToken(this.authenticationService.getToken())
            .flatMap(function (result) {
            if (result) {
                options = _this.updateTokenHeader(options);
                return _this.rawGet(url, options);
            }
            _this.handleUnauthorize();
            throw new Error(ActHttpService_1.unauthorizeMessage);
        });
    };
    ActHttpService.prototype.post = function (url, body, options) {
        var _this = this;
        return this.authenticationService.validateToken(this.authenticationService.getToken())
            .flatMap(function (result) {
            if (result) {
                options = _this.updateTokenHeader(options);
                return _this.rawPost(url, body, options);
            }
            _this.handleUnauthorize();
            throw new Error(ActHttpService_1.unauthorizeMessage);
        });
    };
    ActHttpService.prototype.put = function (url, body, options) {
        var _this = this;
        return this.authenticationService.validateToken(this.authenticationService.getToken())
            .flatMap(function (result) {
            if (result) {
                options = _this.updateTokenHeader(options);
                return _this.rawPut(url, body, options);
            }
            _this.handleUnauthorize();
            throw new Error(ActHttpService_1.unauthorizeMessage);
        });
    };
    ActHttpService.prototype.delete = function (url, options) {
        var _this = this;
        return this.authenticationService.validateToken(this.authenticationService.getToken())
            .flatMap(function (result) {
            if (result) {
                options = _this.updateTokenHeader(options);
                return _this.rawDelete(url, options);
            }
            _this.handleUnauthorize();
            throw new Error(ActHttpService_1.unauthorizeMessage);
        });
    };
    ActHttpService.prototype.getRequestOptions = function (headerType, contentType, email, payload) {
        if (headerType === void 0) { headerType = HeaderTypes.ACT_TOKEN; }
        if (contentType === void 0) { contentType = ContentTypes.JSON; }
        if (email === void 0) { email = ''; }
        return this.authenticationService.getRequestOptions(headerType, contentType, email, payload);
    };
    ActHttpService.prototype.updateTokenHeader = function (requestOption) {
        if (!(requestOption && requestOption.headers)) {
            return requestOption;
        }
        var header = requestOption.headers;
        if (header.get(HeaderKey.actAccessToken)) {
            var actToken = this.authenticationService.getToken();
            header.set(HeaderKey.actAccessToken, actToken.accessToken.valueOf());
            header.set(HeaderKey.actRefreshToken, actToken.refreshToken.valueOf());
            return requestOption;
        }
        if (header.get(HeaderKey.wemallAccessToken)) {
            var actToken = this.authenticationService.getToken();
            header.set(HeaderKey.wemallAccessToken, actToken.accessToken.valueOf());
            header.set(HeaderKey.wemallRefreshAccessToken, actToken.refreshToken.valueOf());
            return requestOption;
        }
        return requestOption;
    };
    ActHttpService.prototype.handleUnauthorize = function () {
        var userInfo = this.authenticationService.getUserInfo();
        this.authenticationService.clearToken();
        if (userInfo && userInfo.companyCode) {
            this.warningService.popDialogErrorRequest('popup-warning-session-expire', null, null, "/company/" + userInfo.companyCode);
        }
        else {
            this.utilitiesService.redirectPage('/', this.appConfigService.getLanguage());
        }
    };
    ActHttpService.prototype.handleError = function (error) {
        if (error.status === HttpStatus.serviceUnavailable && error && error.json() && error.json().code === 'MAINTENANCE') {
            window.location.href = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["c" /* maintenanceSite */];
        }
        return __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__["Observable"].throw(error);
    };
    return ActHttpService;
}());
ActHttpService.unauthorizeMessage = 'Validate token fail.';
ActHttpService = ActHttpService_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3__authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_4__utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_6__warning_warning_service__["a" /* WarningService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6__warning_warning_service__["a" /* WarningService */]) === "function" && _e || Object])
], ActHttpService);

var ActHttpService_1, _a, _b, _c, _d, _e;
//# sourceMappingURL=act-http.service.js.map

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_of__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_mergeMap__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_takeWhile__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_takeWhile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_takeWhile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_crypto_js__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_http__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jsrsasign_lib_jsrsasign_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jsrsasign_lib_jsrsasign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jsrsasign_lib_jsrsasign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__model_login_login_response_model__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_model_authen_authen__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_environments_properties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_BehaviorSubject__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_rxjs_BehaviorSubject__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthenticationService; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



















var ActToken = (function () {
    function ActToken(accessToken, refreshToken) {
        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
    }
    return ActToken;
}());

var AuthenticationService = AuthenticationService_1 = (function () {
    function AuthenticationService(appConfigService, utilitiesService, http) {
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.http = http;
        this.expiresTime = 365;
        this.jsRsaSign = new __WEBPACK_IMPORTED_MODULE_11_jsrsasign_lib_jsrsasign_js__["KJUR"].jws.JWS();
        this.refreshingToken = false;
        this.featuresSource = new __WEBPACK_IMPORTED_MODULE_18_rxjs_BehaviorSubject__["BehaviorSubject"]([]);
        this.currentFeatures = this.featuresSource.asObservable();
        this.companyNameSource = new __WEBPACK_IMPORTED_MODULE_18_rxjs_BehaviorSubject__["BehaviorSubject"]({ companyTitleTh: '', companyTitleEn: '' });
        this.currentCompanyName = this.companyNameSource.asObservable();
    }
    AuthenticationService.prototype.saveToken = function (logInResponse) {
        if (logInResponse.token && logInResponse.token.accessToken && logInResponse.token.refreshToken) {
            __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].tokenCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
            __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].tokenCookieName, this.utilitiesService.encodeToCookie(JSON.stringify(logInResponse.token)), { expires: this.expiresTime, domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        }
        if (logInResponse.user) {
            logInResponse.user.features = [];
            this.saveUserInformationCookie(logInResponse.user);
            if (logInResponse.user.userSetting) {
                this.saveLanguageCurrencyCookie(logInResponse.user.userSetting.lang, logInResponse.user.userSetting.currency);
            }
        }
    };
    AuthenticationService.prototype.saveLanguageCurrencyCookie = function (lang, currency) {
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].languageCookieName, lang, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].currencyCookieName, currency, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
    };
    AuthenticationService.prototype.saveUserInformationCookie = function (user) {
        var userCopy = __assign({}, user);
        delete userCopy.userSetting;
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].userInfoCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].userInfoCookieName, this.utilitiesService.encodeToCookie(JSON.stringify(userCopy)), { expires: this.expiresTime, domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
    };
    AuthenticationService.prototype.savePromotionToken = function (logInResponse) {
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].tokenCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].tokenCookieName, this.utilitiesService.encodeToCookie(JSON.stringify(logInResponse.token)), { expires: this.expiresTime, path: '/promotion', domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].userInfoCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].userInfoCookieName, this.utilitiesService.encodeToCookie(JSON.stringify(logInResponse.user)), { expires: this.expiresTime, path: '/promotion', domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
    };
    AuthenticationService.prototype.updateToken = function (newToken) {
        var user = this.getUserInfo();
        if (user && newToken && newToken.accessToken && newToken.refreshToken) {
            var loginResponseModel = new __WEBPACK_IMPORTED_MODULE_15__model_login_login_response_model__["a" /* LoginResponseModel */](user, newToken);
            this.saveToken(loginResponseModel);
            return true;
        }
        return false;
    };
    AuthenticationService.prototype.getPublicKey = function () {
        var _this = this;
        var publicKey = this.utilitiesService.decodeFromCookie(__WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].publicKeyCookieName));
        if (publicKey) {
            return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(publicKey);
        }
        return this.http
            .get(__WEBPACK_IMPORTED_MODULE_14__environments_environment__["a" /* environment */].publicKey, this.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].EXCLUDE_TOKEN))
            .map(function (res) { return res.text(); })
            .flatMap(function (responsePublicKey) {
            __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].publicKeyCookieName, _this.utilitiesService.encodeToCookie(responsePublicKey), { expires: _this.expiresTime, domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
            return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(responsePublicKey);
        });
    };
    AuthenticationService.prototype.isJWTFormat = function (token) {
        try {
            this.jsRsaSign.parseJWS(token);
            return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(true);
        }
        catch (error) {
            return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false);
        }
    };
    AuthenticationService.prototype.isValidSignature = function (token, publicKey) {
        try {
            return __WEBPACK_IMPORTED_MODULE_11_jsrsasign_lib_jsrsasign_js__["KJUR"].jws.JWS.verify(token, publicKey, ['RS256']) ? __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(true) : __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false);
        }
        catch (error) {
            return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false);
        }
    };
    AuthenticationService.prototype.isNotExpired = function (token) {
        var tokenArray = this.decodeJWT(token);
        var payload = tokenArray[1];
        var expAt = __WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__["unix"](payload['exp']);
        var now = __WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__();
        return expAt.diff(now) > __WEBPACK_IMPORTED_MODULE_17_environments_properties__["g" /* thresholdExpireToken */] ? __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(true) : __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false);
    };
    AuthenticationService.prototype.isB2CClient = function () {
        var token = this.getToken();
        if (!token) {
            return false;
        }
        var tokenArray = this.decodeJWT(token.accessToken.valueOf());
        var payload = tokenArray[1];
        return payload['clientId'] === __WEBPACK_IMPORTED_MODULE_17_environments_properties__["h" /* configB2C */].clientId;
    };
    AuthenticationService.prototype.refreshToken = function (actToken) {
        var _this = this;
        if (this.refreshingToken) {
            return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(true);
        }
        if (actToken && actToken.refreshToken) {
            this.refreshingToken = true;
            var userInfo_1 = this.getUserInfo();
            if (userInfo_1 && userInfo_1.companyCode) {
                return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false);
            }
            return this.http.get(__WEBPACK_IMPORTED_MODULE_14__environments_environment__["a" /* environment */].endpoint.refreshToken, this.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
                .flatMap(function (response) {
                var result = response.json();
                var newActToken = new ActToken(result.data.token.accessToken, result.data.token.refreshToken);
                return _this.updateToken(newActToken) ? __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(true) : __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false);
            })
                .flatMap((function (refreshResult) {
                return refreshResult ? _this.saveUserFeature(_this.getToken(), userInfo_1, AuthenticationService_1.features) : __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false);
            }))
                .flatMap(function () {
                return _this.refreshTokenSso(_this.getSsoToken());
            })
                .catch(function () {
                _this.refreshingToken = false;
                return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false);
            });
        }
        else {
            __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].tokenCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
            __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].userInfoCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
            __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].featureCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
            __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].featureCompanyCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
            return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false);
        }
    };
    AuthenticationService.prototype.refreshTokenSso = function (actToken) {
        var _this = this;
        if (actToken && actToken.refreshToken) {
            return this.http.get(__WEBPACK_IMPORTED_MODULE_14__environments_environment__["a" /* environment */].endpoint.refreshToken, this.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].SSO_TOKEN))
                .map(function (response) { return response.json().data; })
                .flatMap(function (result) {
                var newActToken = new ActToken(result.token.accessToken, result.token.refreshToken);
                _this.saveSsoToken(newActToken);
                _this.refreshingToken = false;
                return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(true);
            })
                .catch(function (error) {
                console.error('refreshTokenSso failed:' + error);
                _this.refreshingToken = false;
                return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(true);
            });
        }
    };
    AuthenticationService.prototype.getUserFeature = function (actToken, user, featureNames, updateCurrentFeatures, shareBudgetCode) {
        var _this = this;
        if (updateCurrentFeatures === void 0) { updateCurrentFeatures = false; }
        if (user.companyTitleEn && user.companyTitleTh) {
            this.companyNameSource.next({ companyTitleEn: user.companyTitleEn, companyTitleTh: user.companyTitleTh });
        }
        var queryParams = new __WEBPACK_IMPORTED_MODULE_8__angular_http__["c" /* URLSearchParams */]();
        featureNames && featureNames.length > 0 && queryParams.append("features", featureNames.join(','));
        queryParams.append("companyId", user.companyId.toString());
        shareBudgetCode && queryParams.append("shareBudgetCode", shareBudgetCode);
        return this.validateToken(this.getToken()).flatMap(function (res) {
            if (res) {
                var requestOption = _this.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN);
                requestOption.params = queryParams;
                return _this.http.get(__WEBPACK_IMPORTED_MODULE_14__environments_environment__["a" /* environment */].endpoint.getFeaturesActAuthz, requestOption)
                    .map(function (response) {
                    if (updateCurrentFeatures) {
                        _this.featuresSource.next(response.json().data);
                    }
                    return response.json().data;
                });
            }
            else {
                _this.clearToken();
                _this.utilitiesService.redirectPage('/', _this.appConfigService.getLanguage());
                throw new Error(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["c" /* ActHttpService */].unauthorizeMessage);
            }
        });
    };
    AuthenticationService.prototype.getUserFeatureAsync = function (actToken, user, featureNames) {
        var queryParams = new __WEBPACK_IMPORTED_MODULE_8__angular_http__["c" /* URLSearchParams */]();
        featureNames && featureNames.length > 0 && queryParams.append("features", featureNames.join(','));
        queryParams.append("companyId", user.companyId.toString());
        var requestOption = this.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN);
        requestOption.params = queryParams;
        return this.http.get(__WEBPACK_IMPORTED_MODULE_14__environments_environment__["a" /* environment */].endpoint.getFeaturesActAuthz, requestOption)
            .map(function (res) {
            return res.json().data;
        }).toPromise();
    };
    AuthenticationService.prototype.saveUserFeature = function (actToken, user, featureNames) {
        var _this = this;
        return this.getUserFeature(actToken, user, featureNames, true).flatMap(function (featureResult) {
            if (featureResult && featureResult.length > 0) {
                _this.featuresSource.next(featureResult);
                var userFeatures = _this.getUserFeatureFromFeature(featureResult);
                var companyFeatures_1 = _this.getCompanyFeatureFromFeature(featureResult);
                if (userFeatures && userFeatures.length > 0) {
                    var featuresAllowLimitBudget = userFeatures.find(function (f) { return f.feature === __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET; });
                    var featuresAllowBookForTraveller = userFeatures.find(function (f) { return f.feature === __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_BOOK_FOR_TRAVELLER; });
                    if (featuresAllowLimitBudget && featuresAllowLimitBudget.data && featuresAllowLimitBudget.data.travelPolicyList) {
                        featuresAllowLimitBudget.data.travelPolicyList = undefined;
                    }
                    if (featuresAllowBookForTraveller && featuresAllowBookForTraveller.data) {
                        featuresAllowBookForTraveller.data = undefined;
                    }
                    __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].featureCookieName, _this.utilitiesService.encodeToCookie(JSON.stringify(userFeatures)), { expires: _this.expiresTime, domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
                }
                if (companyFeatures_1 && companyFeatures_1.length > 0) {
                    companyFeatures_1.forEach(function (feature, index) {
                        if (feature.feature === __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].CONFIG_NOTIFY_TERMS_CONDITIONS_AFTER_LOGIN) {
                            feature.disabled = false;
                            delete feature.data['popupMessageTH'];
                            delete feature.data['popupMessageEN'];
                            __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].notifyDisabledCookieName, _this.utilitiesService.encodeToCookie(JSON.stringify([feature])), { expires: _this.expiresTime, domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
                            companyFeatures_1.splice(index, 1);
                            return;
                        }
                    });
                    companyFeatures_1.length > 0 && __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].featureCompanyCookieName, _this.utilitiesService.encodeToCookie(JSON.stringify(companyFeatures_1)), { expires: _this.expiresTime, domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
                }
                return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(true);
            }
            return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false);
        }).catch(function () { return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(null); });
    };
    AuthenticationService.prototype.decodeJWT = function (token) {
        var _this = this;
        return token ? token.split(".", 2).map(function (item) { return JSON.parse(_this.utilitiesService.base64Decoder(item)); }) : undefined;
    };
    AuthenticationService.prototype.validateToken = function (actToken) {
        var _this = this;
        if (actToken && actToken.accessToken) {
            return this.isJWTFormat(actToken.accessToken.valueOf())
                .flatMap(function (isJWTFormatResult) {
                return isJWTFormatResult ? _this.getPublicKey() : __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].throw('Invalid JWTFormat');
            })
                .flatMap(function (publicKey) {
                return publicKey ? _this.isValidSignature(actToken.accessToken.valueOf(), publicKey) : __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].throw('Invalid PublicKey');
            })
                .flatMap(function (isValidSignature) {
                return isValidSignature ? _this.isNotExpired(actToken.accessToken.valueOf()) : __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].throw('Invalid Signature');
            })
                .flatMap(function (isAlive) {
                return isAlive ? __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(true) : _this.refreshToken(actToken).toPromise();
            })
                .catch(function (error) {
                console.error(error);
                return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false);
            });
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false);
        }
    };
    AuthenticationService.prototype.getToken = function () {
        var actToken = __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].tokenCookieName);
        if (actToken) {
            try {
                var decryptToken = JSON.parse(this.utilitiesService.decodeFromCookie(actToken));
                if (decryptToken) {
                    return decryptToken;
                }
                this.clearToken();
            }
            catch (error) {
                this.clearToken();
            }
        }
        return;
    };
    AuthenticationService.prototype.getUserInfo = function () {
        var userInfo = __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].userInfoCookieName);
        var userFeaturesEncode = __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].featureCookieName);
        var companyFeaturesEncode = __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].featureCompanyCookieName);
        if (userInfo) {
            try {
                var decryptUserInfo = JSON.parse(this.utilitiesService.decodeFromCookie(userInfo));
                decryptUserInfo.username = decryptUserInfo.email;
                if (decryptUserInfo) {
                    var features = [];
                    if (userFeaturesEncode) {
                        var userFeatures = JSON.parse(this.utilitiesService.decodeFromCookie(userFeaturesEncode));
                        features = features.concat(userFeatures);
                    }
                    if (companyFeaturesEncode) {
                        var companyFeatures = JSON.parse(this.utilitiesService.decodeFromCookie(companyFeaturesEncode));
                        features = features.concat(companyFeatures);
                    }
                    decryptUserInfo.features = features;
                    return decryptUserInfo;
                }
                this.clearToken();
            }
            catch (error) {
                this.clearToken();
            }
        }
        return;
    };
    AuthenticationService.prototype.clearVerifyCookie = function () {
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].stateCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].codeVerifierCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].codeChallengeCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
    };
    AuthenticationService.prototype.clearToken = function () {
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].userInfoCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].tokenCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].publicKeyCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].featureCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].featureCompanyCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].notifyDisabledCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].bannerClosedCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].ssoTokenCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].coBookerCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].shareBudgetCodeCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].languageCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        this.clearVerifyCookie();
        try {
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].localStorageSearchHistoryName, JSON.stringify([]));
        }
        catch (err) {
            __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].localStorageSearchHistoryName, JSON.stringify([]), { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        }
    };
    AuthenticationService.prototype.getRequestOptions = function (headerType, contentType, email, payload) {
        if (headerType === void 0) { headerType = __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN; }
        if (contentType === void 0) { contentType = __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["b" /* ContentTypes */].JSON; }
        if (email === void 0) { email = ''; }
        var headers = new __WEBPACK_IMPORTED_MODULE_8__angular_http__["d" /* Headers */]();
        switch (contentType) {
            case __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["b" /* ContentTypes */].JSON:
                headers.append(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["d" /* HeaderKey */].contentType, __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["e" /* HeaderValue */].applicationJson);
                break;
            case __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["b" /* ContentTypes */].URLENCODE:
                headers.append(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["d" /* HeaderKey */].contentType, __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["e" /* HeaderValue */].applicationWebForm);
                break;
        }
        switch (headerType) {
            case __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].EXCLUDE_TOKEN: break;
            case __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].AUTHORIZATION_WM_TOKEN:
                var user = this.getToken();
                if (user) {
                    headers.append(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["d" /* HeaderKey */].wemallAccessToken, user.accessToken.valueOf());
                    headers.append(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["d" /* HeaderKey */].wemallRefreshAccessToken, user.refreshToken.valueOf());
                }
            // tslint:disable-next-line:no-switch-case-fall-through
            case __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].AUTHORIZATION:
                headers.append(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["d" /* HeaderKey */].authorization, this.generateAuthorization(email));
                break;
            case __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].AUTHORIZATION_RANDOM_STR:
                headers.append(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["d" /* HeaderKey */].authorization, this.generateAuthorizationWithRandomString(payload));
                break;
            case __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN:
            default:
                var currentUser = this.getToken();
                if (currentUser) {
                    headers.append(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["d" /* HeaderKey */].actAccessToken, currentUser.accessToken.valueOf());
                    headers.append(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["d" /* HeaderKey */].actRefreshToken, currentUser.refreshToken.valueOf());
                }
                break;
            case __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].SSO_TOKEN:
                var token = this.getSsoToken();
                if (token) {
                    headers.append(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["d" /* HeaderKey */].actAccessToken, token.accessToken.valueOf());
                    headers.append(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["d" /* HeaderKey */].actRefreshToken, token.refreshToken.valueOf());
                }
                break;
        }
        return new __WEBPACK_IMPORTED_MODULE_8__angular_http__["e" /* RequestOptions */]({ headers: headers });
    };
    AuthenticationService.prototype.generateAuthorization = function (email) {
        return this.utilitiesService.base64Encoder(email + ":" + this.appConfigService.getTimeForAuthorizationHeader());
    };
    AuthenticationService.prototype.generateAuthorizationWithRandomString = function (payload) {
        return Math.random().toString(36).substr(2, 3) + this.utilitiesService.base64Encoder(payload);
    };
    AuthenticationService.prototype.getUserFeatureFromFeature = function (features) {
        var keys = Object.keys(__WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */]).map(function (key) { return __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */][key]; });
        return features.filter(function (feature) { return keys.indexOf(feature.feature) > -1; });
    };
    AuthenticationService.prototype.getCompanyFeatureFromFeature = function (features) {
        var keys = Object.keys(__WEBPACK_IMPORTED_MODULE_6_app_model_constant__["c" /* CompanyFeatureConfigType */]).map(function (key) { return __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["c" /* CompanyFeatureConfigType */][key]; });
        return features.filter(function (feature) { return keys.indexOf(feature.feature) > -1; });
    };
    AuthenticationService.prototype.getExpiresTime = function () {
        return this.expiresTime;
    };
    AuthenticationService.prototype.generateCodeVerifier = function () {
        return this.utilitiesService.randomStringWithLength(48);
    };
    AuthenticationService.prototype.generateCodeChallenge = function (codeVerifier) {
        return __WEBPACK_IMPORTED_MODULE_5_crypto_js__["SHA256"](codeVerifier).toString(__WEBPACK_IMPORTED_MODULE_5_crypto_js__["enc"].Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    };
    AuthenticationService.prototype.saveCodeVerifier = function (codeVerifier, codeChallenge) {
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].codeVerifierCookieName, this.utilitiesService.encodeToCookie(codeVerifier), { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].codeChallengeCookieName, this.utilitiesService.encodeToCookie(codeChallenge), { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
    };
    AuthenticationService.prototype.saveState = function (state) {
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].stateCookieName, this.utilitiesService.encodeToCookie(state), { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
    };
    AuthenticationService.prototype.saveSsoToken = function (token) {
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].ssoTokenCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].ssoTokenCookieName, this.utilitiesService.encodeToCookie(JSON.stringify(new ActToken(token.accessToken, token.refreshToken))), { expires: this.expiresTime, domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
    };
    AuthenticationService.prototype.getCodeVerifier = function () {
        return this.utilitiesService.decodeFromCookie(__WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].codeVerifierCookieName));
    };
    AuthenticationService.prototype.getState = function () {
        return this.utilitiesService.decodeFromCookie(__WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].stateCookieName));
    };
    AuthenticationService.prototype.getSsoToken = function () {
        var ssoToken = __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */].ssoTokenCookieName, { domain: __WEBPACK_IMPORTED_MODULE_17_environments_properties__["e" /* domain */] });
        if (ssoToken) {
            try {
                var decryptToken = JSON.parse(this.utilitiesService.decodeFromCookie(ssoToken));
                if (decryptToken) {
                    return decryptToken;
                }
                this.clearToken();
            }
            catch (error) {
                this.clearToken();
            }
        }
        return;
    };
    AuthenticationService.prototype.authorizationRequest = function (queryParams) {
        var url = "" + __WEBPACK_IMPORTED_MODULE_14__environments_environment__["a" /* environment */].endpoint.authorizeRequest + this.utilitiesService.objectToQueryString(queryParams);
        var option = this.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].SSO_TOKEN);
        return this.http.get(url, option).map(function (m) { return m.json().data; });
    };
    AuthenticationService.prototype.getTokenAuthen = function (code, codeVerifier) {
        var paramsObj = {
            grant_type: __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["d" /* SSO */].GRANT_TYPE,
            client_id: __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["d" /* SSO */].CLIENT_ID,
            code: code,
            code_verifier: codeVerifier,
            code_challenge_method: __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["d" /* SSO */].CODE_CHALLENGE_METHOD
        };
        var url = "" + __WEBPACK_IMPORTED_MODULE_14__environments_environment__["a" /* environment */].endpoint.getTokenAuthen + this.utilitiesService.objectToQueryString(paramsObj);
        var option = this.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].SSO_TOKEN, __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["b" /* ContentTypes */].URLENCODE);
        return this.http.post(url, null, option).map(function (m) { return m.json().data; });
    };
    AuthenticationService.prototype.allowConsent = function (scope) {
        var url = "" + __WEBPACK_IMPORTED_MODULE_14__environments_environment__["a" /* environment */].endpoint.consent;
        var option = this.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].SSO_TOKEN);
        return this.http.post(url, scope, option);
    };
    AuthenticationService.prototype.getUserInformation = function (companyId, taxAddress) {
        var _this = this;
        var id = companyId ? "companyId=" + companyId : undefined;
        var tax = taxAddress ? "taxAddress=" + taxAddress : undefined;
        var param;
        if (id && tax) {
            param = "?" + id + "&" + tax;
        }
        else if (!id && !tax) {
            param = '';
        }
        else {
            param = "?" + (id ? id : tax);
        }
        return this.validateToken(this.getToken()).flatMap(function (res) {
            if (res) {
                var url = "" + __WEBPACK_IMPORTED_MODULE_14__environments_environment__["a" /* environment */].endpoint.userInfo + param;
                var option = _this.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN);
                return _this.http.get(url, option).map(function (res) { return res.json().data; });
            }
            else {
                _this.clearToken();
                _this.utilitiesService.redirectPage('/', _this.appConfigService.getLanguage());
                throw new Error(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["c" /* ActHttpService */].unauthorizeMessage);
            }
        });
    };
    AuthenticationService.prototype.generateAuthorizeRequest = function (codeVerifier, clientId) {
        codeVerifier = codeVerifier || this.generateCodeVerifier();
        var codeChallenge = this.generateCodeChallenge(codeVerifier);
        var state = this.utilitiesService.randomStringWithLength(10);
        var redirect_uri = "" + __WEBPACK_IMPORTED_MODULE_17_environments_properties__["i" /* redirectURI */];
        this.saveCodeVerifier(codeVerifier, codeChallenge);
        this.saveState(state);
        var queryParams = new __WEBPACK_IMPORTED_MODULE_16_app_model_authen_authen__["a" /* AuthorizeRequest */];
        queryParams.response_type = __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["d" /* SSO */].RESPONSE_TPYE;
        queryParams.scope = __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["d" /* SSO */].SCOPE;
        queryParams.client_id = clientId ? clientId : __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["d" /* SSO */].CLIENT_ID;
        queryParams.state = state;
        queryParams.code_challenge = codeChallenge;
        queryParams.redirect_uri = redirect_uri;
        queryParams.code_challenge_method = __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["d" /* SSO */].CODE_CHALLENGE_METHOD;
        queryParams.lang = this.appConfigService.getLanguage();
        return queryParams;
    };
    AuthenticationService.prototype.login = function (companyCode, clientId) {
        var _this = this;
        var codeVerifier = this.generateCodeVerifier();
        var queryParams = this.generateAuthorizeRequest(codeVerifier, clientId);
        return this.authorizationRequest(queryParams)
            .flatMap(function (res) {
            var code = res.redirectURI.substring(res.redirectURI.indexOf('code=') + 5, res.redirectURI.indexOf('&state'));
            var state = res.redirectURI.substring(res.redirectURI.indexOf('state=') + 6);
            var isValidState = state === queryParams.state;
            return isValidState ? _this.getTokenAuthen(code, codeVerifier) : __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].throw('Invalid State');
        })
            .flatMap(function (res) {
            _this.saveToken(new __WEBPACK_IMPORTED_MODULE_15__model_login_login_response_model__["a" /* LoginResponseModel */](undefined, res));
            return _this.getUserInformation();
        })
            .flatMap(function (user) {
            user.companyCode = companyCode;
            var loginResponse = new __WEBPACK_IMPORTED_MODULE_15__model_login_login_response_model__["a" /* LoginResponseModel */](user, _this.getToken());
            _this.saveToken(loginResponse);
            return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(loginResponse);
        }).flatMap(function (loginResponse) {
            return _this.saveUserFeature(loginResponse.token, loginResponse.user, AuthenticationService_1.features);
        })
            .catch(function (errer) {
            console.error(errer);
            return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false);
        })
            .finally(function () {
            _this.clearVerifyCookie();
        });
    };
    AuthenticationService.prototype.loginFromAccount = function (state, code, companyCode) {
        var _this = this;
        if (state === this.getState()) {
            var codeVerifier = this.getCodeVerifier();
            return this.getTokenAuthen(code, codeVerifier)
                .flatMap(function (res) {
                _this.saveToken(new __WEBPACK_IMPORTED_MODULE_15__model_login_login_response_model__["a" /* LoginResponseModel */](undefined, res));
                return _this.getUserInformation();
            })
                .flatMap(function (user) {
                user.companyCode = companyCode;
                var loginResponse = new __WEBPACK_IMPORTED_MODULE_15__model_login_login_response_model__["a" /* LoginResponseModel */](user, _this.getToken());
                _this.saveToken(loginResponse);
                return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(loginResponse);
            }).flatMap(function (loginResponse) {
                return _this.saveUserFeature(loginResponse.token, loginResponse.user, AuthenticationService_1.features);
            })
                .catch(function (errer) {
                console.error(errer);
                return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].of(false);
            })
                .finally(function () {
                _this.clearVerifyCookie();
            });
        }
        else {
            this.clearVerifyCookie();
            return __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"].throw('Invalid State');
        }
    };
    AuthenticationService.prototype.requestOTP = function (request) {
        var url = "" + __WEBPACK_IMPORTED_MODULE_14__environments_environment__["a" /* environment */].endpoint.requestOTP;
        var options = this.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["b" /* ContentTypes */].JSON);
        return this.http.post(url, request, options).map(function (m) { return m.json().data; });
    };
    AuthenticationService.prototype.verifyOTP = function (request) {
        var url = "" + __WEBPACK_IMPORTED_MODULE_14__environments_environment__["a" /* environment */].endpoint.verifyOTP;
        var options = this.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["b" /* ContentTypes */].JSON);
        return this.http.post(url, request, options).map(function (m) { return m.json().data; });
    };
    AuthenticationService.prototype.changePhoneNumber = function (request) {
        var url = "" + __WEBPACK_IMPORTED_MODULE_14__environments_environment__["a" /* environment */].endpoint.userPhone;
        var options = this.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["b" /* ContentTypes */].JSON);
        return this.http.post(url, request, options).map(function (m) { return m.json().data; });
    };
    return AuthenticationService;
}());
AuthenticationService.features = [
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_ROOM,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_CHILD,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_SUPERVISOR_APPROVAL,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_EDIT_PROFILE,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_CHANGE_PASSWORD,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT_CORPORATE_FLEET,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_BOOK_FLIGHT,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_BOOK_WORK_PURPOSE,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_DISPLAY_PERMISSION_MENU,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ENABLE_CH2_BOOKER_EMAIL,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_RENT_CAR_CREDIT_TERMS,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_RENT_CAR_OTHER_PAYMENTS,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_SHARE_BUDGET,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_CORPORATE_FLEET,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ALLOW_BOOK_FOR_TRAVELLER,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ENABLE_PIN,
    __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["b" /* FeatureType */].ENABLE_PRE_APPROVAL,
];
AuthenticationService = AuthenticationService_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_9_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_13_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_13_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_8__angular_http__["b" /* Http */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8__angular_http__["b" /* Http */]) === "function" && _c || Object])
], AuthenticationService);

var AuthenticationService_1, _a, _b, _c;
//# sourceMappingURL=authentication.service.js.map

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
//! custom with only th language
;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            __webpack_require__(977)("./" + name);
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports

//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;


//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

hooks.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});


hooks.locale('en');

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(215)(module)))

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogAlertComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var DialogAlertComponent = (function () {
    function DialogAlertComponent(dialogRef) {
        this.dialogRef = dialogRef;
        this.imageSrc = '/assets/images/icons/icon-failed.png';
        this.isMice = false;
    }
    Object.defineProperty(DialogAlertComponent.prototype, "autoClose", {
        set: function (second) {
            var _this = this;
            this.countdown = second;
            var interval = setInterval(function () {
                if (_this.countdown <= 0) {
                    clearInterval(interval);
                    _this.dialogRef.close();
                }
                _this.countdown -= 1;
            }, 1000);
        },
        enumerable: true,
        configurable: true
    });
    DialogAlertComponent.prototype.ngOnInit = function () {
    };
    return DialogAlertComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('alertHeader'),
    __metadata("design:type", String)
], DialogAlertComponent.prototype, "alertHeader", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('alertText'),
    __metadata("design:type", String)
], DialogAlertComponent.prototype, "alertText", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('imageSrc'),
    __metadata("design:type", String)
], DialogAlertComponent.prototype, "imageSrc", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('imageSrcSet'),
    __metadata("design:type", String)
], DialogAlertComponent.prototype, "imageSrcSet", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('mice'),
    __metadata("design:type", Boolean)
], DialogAlertComponent.prototype, "isMice", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], DialogAlertComponent.prototype, "confirmText", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('autoClose'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DialogAlertComponent.prototype, "autoClose", null);
DialogAlertComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'ota-dialog-alert',
        template: __webpack_require__(1040),
        styles: [__webpack_require__(905)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object])
], DialogAlertComponent);

var _a;
//# sourceMappingURL=dialog-alert.component.js.map

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_modal_dialog_share_budget_dialog_share_budget_model__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie_src_js_cookie_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie_src_js_cookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_cookie_src_js_cookie_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_BehaviorSubject__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_environments_properties__ = __webpack_require__(21);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthorizeService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var AuthorizeService = (function () {
    function AuthorizeService(actHttp, utilitiesService) {
        this.actHttp = actHttp;
        this.utilitiesService = utilitiesService;
        this.shareBudget = new __WEBPACK_IMPORTED_MODULE_6_rxjs_BehaviorSubject__["BehaviorSubject"](null);
    }
    AuthorizeService.prototype.shareBudgetCode = function (code, companyId, lang) {
        var url = __WEBPACK_IMPORTED_MODULE_4_environments_environment__["a" /* environment */].endpoint.userShareCode.replace(':code', code) + ("?companyId=" + companyId + "&lang=" + lang);
        return this.actHttp.get(url, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
            .map(function (res) { return res.json().data; });
    };
    AuthorizeService.prototype.getCoBookerCookie = function () {
        var coBookerCookie = __WEBPACK_IMPORTED_MODULE_5_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_8__app_config_app_config_service__["a" /* AppConfigService */].coBookerCookieName);
        if (coBookerCookie) {
            return JSON.parse(this.utilitiesService.decodeFromCookie(coBookerCookie));
        }
        else {
            return undefined;
        }
    };
    AuthorizeService.prototype.getShareBudgetCodeCookie = function () {
        return __WEBPACK_IMPORTED_MODULE_5_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_8__app_config_app_config_service__["a" /* AppConfigService */].shareBudgetCodeCookieName);
    };
    AuthorizeService.prototype.setCoBookerCookie = function (userId, companyId, email, budget, fullName, expireDate, shareBudgetCode) {
        __WEBPACK_IMPORTED_MODULE_5_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_8__app_config_app_config_service__["a" /* AppConfigService */].coBookerCookieName, { domain: __WEBPACK_IMPORTED_MODULE_10_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_5_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_8__app_config_app_config_service__["a" /* AppConfigService */].coBookerCookieName, this.utilitiesService.encodeToCookie(JSON.stringify(new __WEBPACK_IMPORTED_MODULE_2_app_components_modal_dialog_share_budget_dialog_share_budget_model__["a" /* Booker */](userId, companyId, email, budget, fullName, shareBudgetCode))), { expires: new Date(expireDate), domain: __WEBPACK_IMPORTED_MODULE_10_environments_properties__["e" /* domain */] });
    };
    AuthorizeService.prototype.setShareBudgetCodeCookie = function (codeRef) {
        __WEBPACK_IMPORTED_MODULE_5_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_8__app_config_app_config_service__["a" /* AppConfigService */].shareBudgetCodeCookieName, { domain: __WEBPACK_IMPORTED_MODULE_10_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_5_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_8__app_config_app_config_service__["a" /* AppConfigService */].shareBudgetCodeCookieName, codeRef, { expires: 365, domain: __WEBPACK_IMPORTED_MODULE_10_environments_properties__["e" /* domain */] });
    };
    AuthorizeService.prototype.removeCoBookerCookie = function () {
        __WEBPACK_IMPORTED_MODULE_5_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_8__app_config_app_config_service__["a" /* AppConfigService */].coBookerCookieName, { domain: __WEBPACK_IMPORTED_MODULE_10_environments_properties__["e" /* domain */] });
        __WEBPACK_IMPORTED_MODULE_5_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_8__app_config_app_config_service__["a" /* AppConfigService */].shareBudgetCodeCookieName, { domain: __WEBPACK_IMPORTED_MODULE_10_environments_properties__["e" /* domain */] });
    };
    AuthorizeService.prototype.setCookieFeatureShareBudgetIsFalse = function () {
        var featureResult = JSON.parse(this.utilitiesService.decodeFromCookie(__WEBPACK_IMPORTED_MODULE_5_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_8__app_config_app_config_service__["a" /* AppConfigService */].featureCookieName)));
        var userFeatures = this.getUserFeatureFromFeature(featureResult);
        if (userFeatures && userFeatures.length > 0) {
            var featuresAllowLimitBudget = userFeatures.find(function (f) { return f.feature === __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["b" /* FeatureType */].ALLOW_SHARE_BUDGET; });
            if (featuresAllowLimitBudget) {
                featuresAllowLimitBudget.allow = false;
            }
            __WEBPACK_IMPORTED_MODULE_5_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_8__app_config_app_config_service__["a" /* AppConfigService */].featureCookieName, this.utilitiesService.encodeToCookie(JSON.stringify(userFeatures)), { expires: 365, domain: __WEBPACK_IMPORTED_MODULE_10_environments_properties__["e" /* domain */] });
        }
    };
    AuthorizeService.prototype.getUserFeatureFromFeature = function (features) {
        var keys = Object.keys(__WEBPACK_IMPORTED_MODULE_3_app_model_constant__["b" /* FeatureType */]).map(function (key) { return __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["b" /* FeatureType */][key]; });
        return features.filter(function (feature) { return keys.indexOf(feature.feature) > -1; });
    };
    AuthorizeService.prototype.setShareBudgetObs = function (use) {
        this.shareBudget.next(use);
    };
    AuthorizeService.prototype.getShareBudgetObs = function () {
        return this.shareBudget.asObservable();
    };
    AuthorizeService.prototype.getCommunicationPreference = function (companyId, lang, isMobile) {
        var mode = isMobile ? 'mobile' : 'desktop';
        var url = __WEBPACK_IMPORTED_MODULE_4_environments_environment__["a" /* environment */].endpoint.companyCommunication + "?companyId=" + companyId + "&lang=" + lang + "&mode=" + mode;
        return this.actHttp.get(url, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
            .map(function (res) { return res.json().data; });
    };
    AuthorizeService.prototype.getCommunicationPreferenceBanner = function (companyId, bannerId) {
        var url = __WEBPACK_IMPORTED_MODULE_4_environments_environment__["a" /* environment */].endpoint.companyCommunicationBanner + "?companyId=" + companyId + "&bannerId=" + bannerId;
        var requestOptions = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN);
        requestOptions.responseType = __WEBPACK_IMPORTED_MODULE_1__angular_http__["f" /* ResponseContentType */].ArrayBuffer;
        return this.actHttp.get(url, requestOptions)
            .map(function (res) { return res.arrayBuffer(); });
    };
    AuthorizeService.prototype.getPreApprovalDetails = function (approvalRequestId) {
        var url = __WEBPACK_IMPORTED_MODULE_4_environments_environment__["a" /* environment */].endpoint.preApprovalDetail.replace(":approvalRequestId", approvalRequestId.toString()) + "?view=full";
        return this.actHttp.get(url, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
            .map(function (res) { return res.json().data; });
    };
    return AuthorizeService;
}());
AuthorizeService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_9__utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_9__utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object])
], AuthorizeService);

var _a, _b;
//# sourceMappingURL=authorize.service.js.map

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_products_product_room_detail_model__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_products_product_detail_info_model__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_products_product_detail_model__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__payload_product_detail_payload__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_Subject__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__payload_product_nearby_payload__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_model_products_product_list_model__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_model_products_product_nearby_dto_model__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_model_search_form_model__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_model_products_hotel_hotel_model__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_model_products_product_review_model__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__currency_currency_service__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_environments_properties__ = __webpack_require__(21);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
























var ProductService = (function () {
    function ProductService(actHttp, appConfigService, utilitiesService, translate, utilities, currencyService, authService) {
        this.actHttp = actHttp;
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.translate = translate;
        this.utilities = utilities;
        this.currencyService = currencyService;
        this.authService = authService;
        this.maxAllotment = 9;
        this.detail$ = new __WEBPACK_IMPORTED_MODULE_8_rxjs_Subject__["Subject"]();
        this.roomDetail$ = new __WEBPACK_IMPORTED_MODULE_8_rxjs_Subject__["Subject"]();
    }
    ProductService.prototype.getProductList = function (payload) {
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.getProductList, payload, this.actHttp.getRequestOptions()).map(function (res) { return res.json(); });
    };
    ProductService.prototype.getTopHotelList = function (request) {
        var url = "" + __WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.getTopHoteList;
        return this.actHttp.post(url, request, this.actHttp.getRequestOptions()).map(function (res) { return res.json().data; });
    };
    ProductService.prototype.getHotelList = function (request) {
        var url = "" + __WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.getHotelList;
        return this.actHttp.post(url, request, this.actHttp.getRequestOptions()).map(function (res) { return res.json().data; });
    };
    ProductService.prototype.getAdsHotelByDestination = function (request) {
        var url = __WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.getAdsHotelByDestination;
        return this.actHttp.post(url, request, this.actHttp.getRequestOptions()).map(function (res) { return res.json().data; });
    };
    ProductService.prototype.getAdsHotelByPOI = function (request) {
        var url = __WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.getAdsHotelByPOI;
        return this.actHttp.post(url, request, this.actHttp.getRequestOptions()).map(function (res) { return res.json().data; });
    };
    ProductService.prototype.getProductListWithPOI = function (request) {
        var url = __WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.getProductListWithPOIV3;
        return this.actHttp.post(url, request, this.actHttp.getRequestOptions()).map(function (res) { return res.json().data; });
    };
    ProductService.prototype.getProductDetail = function (productId) {
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.getProductDetail, new __WEBPACK_IMPORTED_MODULE_7__payload_product_detail_payload__["a" /* ProductDetailPayload */](productId, this.appConfigService.getLanguageId()), this.actHttp.getRequestOptions()).map(function (res) { return res.json().data; });
    };
    ProductService.prototype.getHotelPriceRange = function (request) {
        var url = __WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.getHotelList + "/info";
        return this.actHttp.post(url, request, this.actHttp.getRequestOptions()).map(function (res) { return res.json().data; });
    };
    ProductService.prototype.getHotelPriceRangePOI = function (request) {
        var url = __WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.getHotelList + "/poi/info";
        return this.actHttp.post(url, request, this.actHttp.getRequestOptions()).map(function (res) { return res.json().data; });
    };
    ProductService.prototype.getProductRoomDetail = function (productRoomDetail) {
        // Remove children from request before search
        // TODO: Please remove this logic after fixing the problem about booking with children
        productRoomDetail.rooms = productRoomDetail.rooms.map(function (room) { return new __WEBPACK_IMPORTED_MODULE_17_app_model_search_form_model__["a" /* GuestModel */](room.adult, []); });
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.getProductRoomDetail, productRoomDetail, this.actHttp.getRequestOptions()).map(function (response) {
            return response.json().data;
        });
    };
    ProductService.prototype.getProductOptionDetails = function (payload) {
        payload.langId = +this.appConfigService.getLanguageId();
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.getProductOptionDetail, payload, this.actHttp.getRequestOptions()).map(function (res) { return res.json().data; });
    };
    ProductService.prototype.getHotelReviewList = function (hotelId, page, pageSize, sort, sortDir) {
        var url = __WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.getHotelReviewList.replace('{hotelId}', hotelId) +
            ("?page=" + page + "&pageSize=" + pageSize + "&sort=" + sort + "&sortDir=" + sortDir);
        return this.actHttp.get(url, this.actHttp.getRequestOptions()).map(function (response) {
            return response.json().data;
        });
    };
    ProductService.prototype.broadcastDetail = function (data) {
        this.detail$.next(data);
    };
    ProductService.prototype.broadcastRoomDetail = function (data) {
        this.roomDetail$.next(data);
    };
    ProductService.prototype.formatTitleProductDetail = function (productDetail) {
        if (productDetail && productDetail.details) {
            productDetail.details.address = this.formatDisplayTitle(productDetail.details.address);
            productDetail.details.countryTitle = this.formatDisplayTitle(productDetail.details.countryTitle);
            productDetail.details.destinationTitle = this.formatDisplayTitle(productDetail.details.destinationTitle);
            if (productDetail.details.reviewRating) {
                productDetail.details.reviewRating.totalTitle = this.calculateReviewRatingTitle(+productDetail.details.reviewRating.totalScore);
            }
        }
        return productDetail;
    };
    ProductService.prototype.transformProductRoomDetailsToRoomConditions = function (productRooms, searchForm, currentUser, travelPolicyBudget, isShareBudget, isAllowBookForTraveller, crossCondition) {
        var _this = this;
        var index = 0;
        var count = [];
        var round = [];
        for (var i = 0; i < productRooms.length; i++) {
            count.push(productRooms[i].conditions.length);
            round.push(productRooms[i].conditions.length);
        }
        var allowMultiPayment = this.allowMultiPayment(currentUser, isShareBudget);
        var roomConditionResult = productRooms.map(function (optionDetail) { return optionDetail.conditions.map(function (conditionDetail) {
            var roomCondition = new __WEBPACK_IMPORTED_MODULE_1__model_products_product_room_detail_model__["a" /* RoomConditionDto */]();
            roomCondition.lineItemId = conditionDetail.lineItemId;
            roomCondition.allotment = _this.calculateAllotment(optionDetail.allotment, searchForm, currentUser);
            roomCondition.roomCode = optionDetail.roomCode;
            roomCondition.roomSize = productRooms[index].roomSize;
            roomCondition.roomView = productRooms[index].roomView;
            roomCondition.numberOfBedroom = productRooms[index].numberOfBedroom;
            roomCondition.numberOfBathroom = productRooms[index].numberOfBathroom;
            roomCondition.sharedBathroom = productRooms[index].sharedBathroom;
            roomCondition.bedType = productRooms[index].bedType;
            roomCondition.isFirstCondition = count[index] === 1 ? true : round[index] === count[index] ? true : false;
            roomCondition.isCountRow = count[index];
            round[index] = --round[index];
            round[index] === 0 ? index++ : index;
            roomCondition.image = optionDetail.image ? optionDetail.image : _this.appConfigService.defaultProductImage;
            roomCondition.title = optionDetail.title;
            roomCondition.displayTitle = _this.formatDisplayTitle(optionDetail.title);
            roomCondition.adult = conditionDetail.adult;
            roomCondition.breakfast = conditionDetail.breakfast;
            roomCondition.offerTypeName = conditionDetail.offerTypeName;
            roomCondition.offerTypeDisplay = conditionDetail.offerTypeDisplay;
            roomCondition.child = conditionDetail.child;
            roomCondition.netPrice = conditionDetail.netPrice;
            roomCondition.cancellationPolicies = conditionDetail.cancellationPolicies;
            roomCondition.averageNetPrice = _this.calculateCurrency(conditionDetail.netPrice);
            roomCondition.totalPrice = conditionDetail.totalPrice;
            roomCondition.averageTotalPrice = _this.calculateCurrency(conditionDetail.totalPrice);
            roomCondition.quantity = 0;
            roomCondition.isExpand = true;
            roomCondition.surcharges = conditionDetail.surcharges;
            roomCondition.benefits = conditionDetail.benefits;
            roomCondition.extraBed = conditionDetail.extraBed;
            roomCondition.displayExtraBed = _this.translate.transform("extra-bed-include").replace('{text}', conditionDetail.extraBed);
            if (roomCondition.allotment > 0) {
                if (crossCondition) {
                    roomCondition.selectAllotment = Array.from(Array(1 + roomCondition.allotment.valueOf()).keys());
                }
                else {
                    roomCondition.selectAllotment = [0, searchForm.guests.length];
                }
            }
            else {
                roomCondition.selectAllotment = [];
            }
            roomCondition.lastFiveRoom = _this.buildLastFiveRoomDescription(optionDetail.allotment);
            roomCondition.nonRefundableDescription = conditionDetail.cancellationPolicies && conditionDetail.cancellationPolicies.length > 0 ? ''
                : _this.translate.transform("product-detail-room-cancellation-non-refundable");
            if (!roomCondition.nonRefundableDescription) {
                roomCondition.cancellationDescription = _this.calculateCancellation(conditionDetail.cancellationPolicies);
                roomCondition.payOn = conditionDetail.payOn;
                roomCondition.paylaterDescription = _this.calculatePaylater(conditionDetail.payOn);
                roomCondition.lastDayFreeCanllation = _this.calculateLastDayFreeCancellation(conditionDetail.cancellationPolicies);
            }
            // check budget limit
            if (searchForm && searchForm.purpose === __WEBPACK_IMPORTED_MODULE_13__model_constant__["o" /* PurposeType */].work && !isAllowBookForTraveller) {
                if (travelPolicyBudget && travelPolicyBudget > 0) {
                    roomCondition.isOverLimit = +conditionDetail.netPrice > travelPolicyBudget;
                    if (!!roomCondition.isOverLimit && allowMultiPayment) {
                        roomCondition.overPrice = (+conditionDetail.netPrice) - travelPolicyBudget;
                    }
                }
            }
            if (conditionDetail.promotion) {
                roomCondition.promotion = conditionDetail.promotion;
            }
            return roomCondition;
        }); }).reduce(function (first, second) { return first.concat(second); })
            .map(function (item, index) {
            if (index === 0) {
                item.isExpand = true;
            }
            return item;
        });
        return roomConditionResult;
    };
    ProductService.prototype.calculateCurrency = function (price) {
        return (+price) > 0 ? this.utilities.insertCurrencySymbol(+price) : '';
    };
    ProductService.prototype.calculatePaylater = function (payOn) {
        if (payOn === void 0) { payOn = ''; }
        if (payOn === '') {
            return '';
        }
        var formatDate = this.appConfigService.dateAPIFormat;
        var minimumPaylaterDate = __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__(payOn, formatDate);
        return this.buildPaylaterDescription(minimumPaylaterDate.format(formatDate));
    };
    ProductService.prototype.buildPaylaterDescription = function (date) {
        var currentLanguage = this.appConfigService.getLanguage();
        __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__["locale"](currentLanguage);
        var currentDate = __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__(date.valueOf(), this.appConfigService.dateAPIFormat);
        if (!currentDate.isValid()) {
            return '';
        }
        var dateString = '';
        switch (currentLanguage) {
            case __WEBPACK_IMPORTED_MODULE_13__model_constant__["a" /* Language */].th:
                dateString = this.utilities.convertYearToBuddhist(currentDate.format(this.appConfigService.dateCancellationPolicyFormat));
                break;
            case __WEBPACK_IMPORTED_MODULE_13__model_constant__["a" /* Language */].en:
                dateString = currentDate.format(this.appConfigService.dateCancellationPolicyFormat);
        }
        return dateString ? this.translate.transform("product-detail-room-paylater-description").replace(/{.*}/gi, dateString) : dateString;
    };
    ProductService.prototype.calculateCancellation = function (cancellations) {
        var _this = this;
        if (cancellations && cancellations.length > 0) {
            return cancellations
                .sort(this.sortCancellation.bind(this))
                .map(function (cancellation) { return _this.buildCancellationDescription(cancellation).trim(); })
                .filter(function (cancellation) { return cancellation; });
        }
        return [this.buildCancellationDescription(null)];
    };
    ProductService.prototype.buildCancellationDescription = function (cancellation) {
        var currentLanguage = this.appConfigService.getLanguage(), dateString = '';
        __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__["locale"](currentLanguage);
        if (!cancellation) {
            return this.translate.transform("product-detail-room-cancellation-non-refundable");
        }
        dateString = __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__(cancellation.from.valueOf(), this.appConfigService.dateAPIFormat).format(this.appConfigService.dateCancellationPolicyFormat);
        dateString = currentLanguage === "th" ? this.utilities.convertYearToBuddhist(dateString) : dateString;
        switch (true) {
            case cancellation.amount && cancellation.amount > 0:
                return this.translate.transform("product-detail-room-cancellation-charge")
                    .replace(/{date}/gi, dateString)
                    .replace(/{currency}/gi, __WEBPACK_IMPORTED_MODULE_13__model_constant__["p" /* DefaultValue */].CURRENCY.currencyCode)
                    .replace(/{amount}/gi, this.utilities.insertCurrencySymbol(cancellation.amount));
            default:
                return "";
        }
    };
    ProductService.prototype.buildLastFiveRoomDescription = function (roomRemain) {
        return roomRemain && roomRemain <= 5 ? this.translate.transform("product-detail-room-last-five").replace(/{room}/gi, roomRemain) : '';
    };
    ProductService.prototype.calculateLastDayFreeCancellation = function (cancellations) {
        if (cancellations && cancellations.length > 0) {
            var currentLanguage = this.appConfigService.getLanguage();
            __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__["locale"](currentLanguage);
            var nearestDateString = cancellations
                .filter(function (cancellation) { return cancellation.from; })
                .sort(this.sortCancellation.bind(this))[0].from;
            var nearestDate = __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__(nearestDateString, this.appConfigService.dateAPIFormat).add(1, 'days');
            if (!nearestDate.isAfter(__WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__(__WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__().format(this.appConfigService.dateAPIFormat), this.appConfigService.dateAPIFormat))) {
                return "";
            }
            var dateString = nearestDate.format(this.appConfigService.dateCancellationPolicyFormat);
            dateString = currentLanguage === "th" ? this.utilities.convertYearToBuddhist(dateString) : dateString;
            return this.translate.transform("product-detail-room-cancellation-free").replace(/{date}/gi, dateString);
        }
        return "";
    };
    ProductService.prototype.sortCancellation = function (cancellation1, cancellation2) {
        var diffDate = __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__(cancellation1.from, this.appConfigService.dateAPIFormat)
            .diff(__WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__(cancellation2.from, this.appConfigService.dateAPIFormat), 'days');
        if (diffDate < 0) {
            return -1;
        }
        if (diffDate > 0) {
            return 1;
        }
        return 0;
    };
    ProductService.prototype.triggerExpandCondition = function (roomConditions, index) {
        for (var i in roomConditions) {
            if (+i === index.valueOf()) {
                roomConditions[i].isExpand = !roomConditions[index.valueOf()].isExpand;
            }
        }
        return roomConditions;
    };
    ProductService.prototype.formatDisplayTitle = function (title) {
        return title ? title.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); }) : "";
    };
    ProductService.prototype.calculateAllotment = function (allotment, searchForm, currentUser) {
        var maxAllot = this.maxAllotment;
        if (currentUser && currentUser.features && currentUser.features.length > 0 && searchForm.purpose === "work") {
            var limitRoomFeatures = currentUser.features.find(function (feature) { return (feature.feature === __WEBPACK_IMPORTED_MODULE_18_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_ROOM && feature.allow); });
            if (limitRoomFeatures) {
                maxAllot = limitRoomFeatures.data ? limitRoomFeatures.data.quantity : 1;
            }
        }
        return allotment > maxAllot ? maxAllot : allotment;
    };
    ProductService.prototype.selectOnlyCurrentRoom = function (roomConditions, index, searchForm, currentUser, crossCondition) {
        var limitRoom = currentUser.features.find(function (feature) { return (feature.feature === __WEBPACK_IMPORTED_MODULE_18_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_ROOM && feature.allow); });
        if (searchForm && searchForm.purpose === "work" && limitRoom || !crossCondition) {
            var roomAmount_1 = limitRoom && limitRoom.data ? limitRoom.data.quantity : 1;
            var sum_1 = 0;
            roomConditions.forEach(function (x) {
                sum_1 += x.quantity;
            });
            roomConditions.map(function (_room, roomIndex) {
                if (index !== roomIndex && sum_1 > roomAmount_1) {
                    for (var x = 0; x < roomConditions.length; x++) {
                        if (index !== x) {
                            roomConditions[x].quantity = 0;
                        }
                    }
                }
            });
        }
        return roomConditions;
    };
    ProductService.prototype.getProductNearBy = function (payload) {
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_12__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, __WEBPACK_IMPORTED_MODULE_12__act_http_act_http_service__["b" /* ContentTypes */].JSON);
        return this.actHttp
            .post(__WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.getProductNearBy, payload, options)
            .map(function (response) { return response.json().data; });
    };
    ProductService.prototype.mapProductDetailsUrl = function (getProductDetailWithUrl, destinationEncode, checkIn, checkOut) {
        var urlWithParams = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["c" /* URLSearchParams */]();
        urlWithParams.append("destination", "" + destinationEncode);
        urlWithParams.append("purpose", "" + getProductDetailWithUrl.purpose);
        urlWithParams.append("checkIn", "" + checkIn);
        urlWithParams.append("checkOut", "" + checkOut);
        urlWithParams.append("guests", "" + this.utilitiesService.encodeQueryParamWrapper(getProductDetailWithUrl.guests));
        urlWithParams.append("breakfast", "" + getProductDetailWithUrl.breakfast);
        urlWithParams.append("overBudget", "" + getProductDetailWithUrl.overBudget);
        urlWithParams.append("lang", "" + this.appConfigService.getLanguage());
        if (getProductDetailWithUrl.campaignId) {
            urlWithParams.append("campaignId", "" + getProductDetailWithUrl.campaignId);
        }
        return urlWithParams;
    };
    ProductService.prototype.getProductDetailsUrl = function (getProductDetailWithUrl) {
        var destinationModel = new __WEBPACK_IMPORTED_MODULE_17_app_model_search_form_model__["b" /* DestinationModel */];
        destinationModel.id = String(getProductDetailWithUrl.id);
        destinationModel.slug = getProductDetailWithUrl.slug;
        destinationModel.suggestCat = getProductDetailWithUrl.suggestCat;
        destinationModel.title = getProductDetailWithUrl.title;
        var destinationEncode = this.utilitiesService.encodeQueryParamWrapper(destinationModel, __WEBPACK_IMPORTED_MODULE_23_environments_properties__["j" /* useHotelDetailV2 */]);
        var checkIn = getProductDetailWithUrl.checkInDate;
        var checkOut = getProductDetailWithUrl.checkOutDate;
        if (getProductDetailWithUrl.isReverseFormatDate) {
            checkIn = this.utilitiesService.reverseFormatDate(getProductDetailWithUrl.checkInDate);
            checkOut = this.utilitiesService.reverseFormatDate(getProductDetailWithUrl.checkOutDate);
        }
        var params = this.mapProductDetailsUrl(getProductDetailWithUrl, destinationEncode, checkIn, checkOut);
        var url = "hotel/detail/" + getProductDetailWithUrl.slug + "?" + params;
        if (__WEBPACK_IMPORTED_MODULE_23_environments_properties__["j" /* useHotelDetailV2 */]) {
            return url.replace("hotel/detail/", __WEBPACK_IMPORTED_MODULE_23_environments_properties__["k" /* redirectURIV2 */] + "/hotel/");
        }
        return url;
    };
    ProductService.prototype.transformProductToProductNearbyDTO = function (product, searchData, priceRange, netPrice, radius) {
        if (netPrice === void 0) { netPrice = 0; }
        if (radius === void 0) { radius = 15000; }
        var productNearby = new __WEBPACK_IMPORTED_MODULE_16_app_model_products_product_nearby_dto_model__["a" /* ProductNearByDTO */]();
        !priceRange && (priceRange = new __WEBPACK_IMPORTED_MODULE_14__payload_product_nearby_payload__["a" /* PriceRange */](0, 0));
        if (product && searchData) {
            productNearby.langId = this.appConfigService.getLanguageId();
            productNearby.priceRange = priceRange;
            productNearby.rooms = searchData.guests;
            productNearby.radius = radius;
            switch (true) {
                case product instanceof __WEBPACK_IMPORTED_MODULE_15_app_model_products_product_list_model__["a" /* ProductListModel */]:
                    var productItem = product;
                    productNearby.address = productItem.address + " " + productItem.destinationTitle;
                    productNearby.destinationId = +searchData.destination.id;
                    productNearby.currencyId = productItem.currencyId;
                    productNearby.latitude = productItem.latitude;
                    productNearby.longitude = productItem.longitude;
                    productNearby.productId = productItem.productId;
                    productNearby.hotelStar = productItem.rating;
                    productNearby.productTitle = productItem.productTitle;
                    productNearby.netPrice = productItem.netPrice;
                    productNearby.imageUrl = productItem.image;
                    productNearby.slug = productItem.slug;
                    productNearby.checkIn = searchData.checkInDate;
                    productNearby.checkOut = searchData.checkOutDate;
                    productNearby.reviewRating = productItem.reviewRating;
                    break;
                case product instanceof __WEBPACK_IMPORTED_MODULE_6__model_products_product_detail_model__["a" /* ProductDetailModel */]:
                    var productDetail = product;
                    productNearby.address = productDetail.details.address + ", " + productDetail.details.destinationTitle + ", " + productDetail.details.countryTitle;
                    productNearby.destinationId = productDetail.details.destinationId;
                    productNearby.currencyId = +this.appConfigService.getCurrencyId();
                    productNearby.latitude = productDetail.details.latitude;
                    productNearby.longitude = productDetail.details.longitude;
                    productNearby.productId = productDetail.details.productId;
                    productNearby.hotelStar = productDetail.details.ratingPoint;
                    productNearby.productTitle = productDetail.details.title;
                    productNearby.slug = productDetail.details.slug;
                    productNearby.netPrice = netPrice;
                    productNearby.imageUrl = productDetail.images[0].thumbnail['1x'];
                    productNearby.checkIn = this.utilitiesService.convertDateFormat(searchData.checkInDate, 'DD-MM-YYYY', 'YYYY-MM-DD', 'en');
                    productNearby.checkOut = this.utilitiesService.convertDateFormat(searchData.checkOutDate, 'DD-MM-YYYY', 'YYYY-MM-DD', 'en');
                    productNearby.reviewRating = productDetail.details.reviewRating;
                    break;
                case product instanceof __WEBPACK_IMPORTED_MODULE_19_app_model_products_hotel_hotel_model__["a" /* CheapestRoom */]:
                    var cheapestRoom = product;
                    productNearby.address = cheapestRoom.productTitle;
                    productNearby.destinationId = cheapestRoom.destinationId;
                    productNearby.currencyId = +this.appConfigService.getCurrencyId();
                    productNearby.latitude = cheapestRoom.latitude;
                    productNearby.longitude = cheapestRoom.longitude;
                    productNearby.productId = cheapestRoom.productId;
                    productNearby.hotelStar = cheapestRoom.hotelStar;
                    productNearby.productTitle = cheapestRoom.productTitle;
                    productNearby.slug = cheapestRoom.slug;
                    productNearby.netPrice = cheapestRoom.netPrice;
                    productNearby.imageUrl = cheapestRoom.imageUrl;
                    productNearby.checkIn = this.utilitiesService.convertDateFormat(searchData.checkInDate, 'DD-MM-YYYY', 'YYYY-MM-DD', 'en');
                    productNearby.checkOut = this.utilitiesService.convertDateFormat(searchData.checkOutDate, 'DD-MM-YYYY', 'YYYY-MM-DD', 'en');
                    productNearby.reviewRating = new __WEBPACK_IMPORTED_MODULE_20_app_model_products_product_review_model__["a" /* ProductReviewModel */]();
                    cheapestRoom.reviewRatingScore && (productNearby.reviewRating.totalScore = cheapestRoom.reviewRatingScore.toString());
            }
        }
        return productNearby;
    };
    ProductService.prototype.calculateDistanceToKilometer = function (meter) {
        if (meter < 10) {
            return (Math.round((meter / 1000) * 1000) / 1000).toString();
        }
        else if (meter < 100) {
            return (Math.round((meter / 1000) * 100) / 100).toString();
        }
        else {
            return (Math.round((meter / 1000) * 10) / 10).toString();
        }
    };
    ProductService.prototype.setNewAllotLimit = function (key, list, index) {
        if (key !== undefined) {
            var selectRoomCode_1 = list[index].roomCode;
            var fullAllotment = list[index].allotment;
            var sum_2 = 0;
            list.forEach(function (x) {
                if (x.roomCode === selectRoomCode_1) {
                    sum_2 += x.quantity;
                }
            });
            var diff = fullAllotment - sum_2;
            for (var x = 0; x < list.length; x++) {
                if (list[x].roomCode === selectRoomCode_1) {
                    if (list[x].quantity === 0) {
                        list[x].selectAllotment = this.pushNumber(diff);
                    }
                    else {
                        var cal = list[x].quantity + diff;
                        list[x].selectAllotment = this.pushNumber(cal);
                    }
                }
            }
        }
    };
    ProductService.prototype.pushNumber = function (length) {
        var list = [];
        for (var i = 0; i <= length; i++) {
            list.push(i);
        }
        return list;
    };
    ProductService.prototype.allowMultiPayment = function (currentUser, isCreditTermsFeature, isCorporateFleetFeature) {
        if (isCreditTermsFeature === void 0) { isCreditTermsFeature = false; }
        if (isCorporateFleetFeature === void 0) { isCorporateFleetFeature = false; }
        var creditTermMulti = currentUser.features.filter(function (x) {
            return (x.feature === __WEBPACK_IMPORTED_MODULE_18_app_model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS && x.allow) ||
                (x.feature === __WEBPACK_IMPORTED_MODULE_18_app_model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT && x.allow);
        }).length === 2;
        var corporateFleetMulti = currentUser.features.filter(function (x) {
            return (x.feature === __WEBPACK_IMPORTED_MODULE_18_app_model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT_CORPORATE_FLEET && x.allow) ||
                (x.feature === __WEBPACK_IMPORTED_MODULE_18_app_model_constant__["b" /* FeatureType */].ALLOW_CORPORATE_FLEET && x.allow);
        }).length === 2;
        if (isCreditTermsFeature) {
            return creditTermMulti;
        }
        else if (isCorporateFleetFeature) {
            return corporateFleetMulti;
        }
        else {
            return creditTermMulti || corporateFleetMulti;
        }
    };
    ProductService.prototype.calculateReviewRatingTitle = function (reviewRatingScore) {
        if (reviewRatingScore >= 9) {
            return 'product-review-rating-exceptional';
        }
        else if (reviewRatingScore >= 8) {
            return 'product-review-rating-excellent';
        }
        else if (reviewRatingScore >= 7) {
            return 'product-review-rating-very-good';
        }
        else if (reviewRatingScore >= 0) {
            return 'product-review-rating-review-score';
        }
        return '';
    };
    ProductService.prototype.transformSHADetail = function (displayLabels) {
        var shaDetail;
        if (displayLabels && displayLabels.length > 0) {
            var displaySHA = displayLabels.find(function (dl) { return dl.name.toLowerCase() === __WEBPACK_IMPORTED_MODULE_5__model_products_product_detail_info_model__["a" /* ProductDisplayLabel */].SHA.toLowerCase(); });
            var displaySHAplus = displayLabels.find(function (dl) { return dl.name.toLowerCase() === __WEBPACK_IMPORTED_MODULE_5__model_products_product_detail_info_model__["a" /* ProductDisplayLabel */].SHA_PLUS.toLowerCase(); });
            if (!!displaySHA || !!displaySHAplus) {
                var certificateId = (displaySHA && displaySHA.value) || (displaySHAplus && displaySHAplus.value);
                shaDetail = new __WEBPACK_IMPORTED_MODULE_6__model_products_product_detail_model__["b" /* ShaModel */](!!displaySHAplus, certificateId);
            }
        }
        return shaDetail;
    };
    ProductService.prototype.transformBadgeDetail = function (displaySanitation, displayLabels) {
        var badgeDetail = new __WEBPACK_IMPORTED_MODULE_6__model_products_product_detail_model__["c" /* BadgeModel */]();
        var lang = this.appConfigService.getLanguage();
        badgeDetail.displaySanitation = displaySanitation;
        if (displayLabels && displayLabels.length > 0) {
            var yearOfBuild = displayLabels.find(function (dl) { return dl.name.toLowerCase() === __WEBPACK_IMPORTED_MODULE_5__model_products_product_detail_info_model__["a" /* ProductDisplayLabel */].YEAR_OF_BUILD.toLowerCase(); });
            if (yearOfBuild) {
                badgeDetail.displayYearOfBuild = lang === __WEBPACK_IMPORTED_MODULE_13__model_constant__["a" /* Language */].th ? this.utilitiesService.toBEraYear(yearOfBuild.value).toString() : yearOfBuild.value;
            }
            var yearOfRenovated = displayLabels.find(function (dl) { return dl.name.toLowerCase() === __WEBPACK_IMPORTED_MODULE_5__model_products_product_detail_info_model__["a" /* ProductDisplayLabel */].YEAR_OF_RENOVATED.toLowerCase(); });
            if (yearOfRenovated) {
                badgeDetail.displayYearOfRenovated = lang === __WEBPACK_IMPORTED_MODULE_13__model_constant__["a" /* Language */].th ? this.utilitiesService.toBEraYear(yearOfRenovated.value).toString() : yearOfRenovated.value;
            }
            var securityStandard = displayLabels.find(function (dl) { return dl.name.toLowerCase() === __WEBPACK_IMPORTED_MODULE_5__model_products_product_detail_info_model__["a" /* ProductDisplayLabel */].SECURITY_STANDARD.toLowerCase(); });
            if (securityStandard) {
                badgeDetail.displaySecurityStandard = securityStandard.value === "Yes";
            }
        }
        return badgeDetail;
    };
    return ProductService;
}());
ProductService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_12__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_12__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3__app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_10__utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_10__utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_9_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_9_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_10__utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_10__utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_21__currency_currency_service__["a" /* CurrencyService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_21__currency_currency_service__["a" /* CurrencyService */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_22__authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_22__authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _g || Object])
], ProductService);

var _a, _b, _c, _d, _e, _f, _g;
//# sourceMappingURL=product.service.js.map

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_environments_properties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__authentication_authentication_service__ = __webpack_require__(27);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CurrencyService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var CurrencyService = (function () {
    function CurrencyService(activatedRoute, actHttp, appConfigService, authenticationService) {
        this.activatedRoute = activatedRoute;
        this.actHttp = actHttp;
        this.appConfigService = appConfigService;
        this.authenticationService = authenticationService;
        this.currencyList = new __WEBPACK_IMPORTED_MODULE_3_rxjs__["BehaviorSubject"]([]);
        this.currencySubject = new __WEBPACK_IMPORTED_MODULE_3_rxjs__["Subject"]();
        this.isB2C = false;
        this.fetchedCurrencyList = false;
        this.isB2C = this.authenticationService.isB2CClient();
        var defaultCurrency = __WEBPACK_IMPORTED_MODULE_8_app_model_constant__["p" /* DefaultValue */].CURRENCY.currencyCode;
        var currencyParam = this.activatedRoute.snapshot.queryParamMap.get('currency');
        var currencyCookies = this.getCurrencyFromCookie();
        if (currencyParam && currencyParam != defaultCurrency || ((currencyCookies && currencyCookies != defaultCurrency) && currencyParam != defaultCurrency)) {
            this.fetchCurrencyList();
        }
        else {
            this._setCurrency(__WEBPACK_IMPORTED_MODULE_8_app_model_constant__["p" /* DefaultValue */].CURRENCY);
        }
    }
    CurrencyService.prototype.setCurrency = function (use) {
        var currency = this.currencyList.value.find(function (c) { return c.currencyCode === use; });
        if (!currency) {
            currency = __WEBPACK_IMPORTED_MODULE_8_app_model_constant__["p" /* DefaultValue */].CURRENCY;
        }
        this._setCurrency(currency);
    };
    CurrencyService.prototype._setCurrency = function (use) {
        if (this.currency !== use) {
            this.appConfigService.insertParam('currency', use.currencyCode);
            __WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_6__app_config_app_config_service__["a" /* AppConfigService */].currencyCookieName, use.currencyCode, { domain: __WEBPACK_IMPORTED_MODULE_7_environments_properties__["e" /* domain */] });
            this.currency = use;
            this.currencySubject.next(use);
        }
    };
    CurrencyService.prototype.getCurrency = function () {
        if (this.currency) {
            return this.currency;
        }
        var currencyCookie = this.getCurrencyFromCookie();
        var currency = this.currencyList.value.find(function (c) { return c.currencyCode === currencyCookie; });
        if (!currency) {
            var currencyParam_1 = this.activatedRoute.snapshot.queryParams['currency'];
            currency = this.currencyList.value.find(function (c) { return c.currencyCode === currencyParam_1; });
            if (!currency) {
                currency = __WEBPACK_IMPORTED_MODULE_8_app_model_constant__["p" /* DefaultValue */].CURRENCY;
            }
        }
        return currency;
    };
    CurrencyService.prototype.getCurrencyCode = function () {
        return this.currency && this.currency.currencyCode;
    };
    CurrencyService.prototype.getCurrencyFromCookie = function () {
        return __WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_6__app_config_app_config_service__["a" /* AppConfigService */].currencyCookieName);
    };
    CurrencyService.prototype.getCurrencyObs = function () {
        return this.currencySubject.asObservable();
    };
    CurrencyService.prototype.fetchCurrencyList = function () {
        var _this = this;
        if (this.isB2C) {
            this.currencySubscribe && this.currencySubscribe.unsubscribe();
            this.currencySubscribe = this._getCurrencyList().subscribe(function (res) {
                if (res) {
                    var currencyList = res;
                    _this.currencyList.next(currencyList);
                    _this._setCurrency(_this.getCurrency());
                }
            }, function (err) {
                _this.currencyList.next([__WEBPACK_IMPORTED_MODULE_8_app_model_constant__["p" /* DefaultValue */].CURRENCY]);
                _this._setCurrency(_this.getCurrency());
            });
        }
        else {
            this.currencyList.next([__WEBPACK_IMPORTED_MODULE_8_app_model_constant__["p" /* DefaultValue */].CURRENCY]);
            this._setCurrency(this.getCurrency());
        }
        this.fetchedCurrencyList = true;
    };
    CurrencyService.prototype._getCurrencyList = function () {
        var url = "" + __WEBPACK_IMPORTED_MODULE_2_environments_environment__["a" /* environment */].endpoint.getCurrencies;
        return this.actHttp.rawGet(url)
            .map(function (res) { return res.json().data; });
    };
    CurrencyService.prototype.getCurrencyList = function () {
        if (!this.fetchedCurrencyList) {
            this.fetchCurrencyList();
        }
        return this.currencyList.asObservable();
    };
    CurrencyService.prototype.transformCurrentCurrencyFromTHB = function (amount, ceiling) {
        if (ceiling === void 0) { ceiling = true; }
        if (ceiling) {
            return Math.ceil(amount / this.getCurrency().exchangeRate);
        }
        return amount / this.getCurrency().exchangeRate;
    };
    CurrencyService.prototype.transformCurrentCurrencyToTHB = function (amount, ceiling) {
        if (ceiling === void 0) { ceiling = true; }
        if (ceiling) {
            return Math.ceil(amount * this.getCurrency().exchangeRate);
        }
        return amount * this.getCurrency().exchangeRate;
    };
    return CurrencyService;
}());
CurrencyService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_5__angular_router__["b" /* ActivatedRoute */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__angular_router__["b" /* ActivatedRoute */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_4__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_6__app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6__app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_9__authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_9__authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _d || Object])
], CurrencyService);

var _a, _b, _c, _d;
//# sourceMappingURL=currency.service.js.map

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogConfirmComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};




var DialogConfirmComponent = (function () {
    function DialogConfirmComponent(utilitiesService, type, dialogRef) {
        this.utilitiesService = utilitiesService;
        this.dialogRef = dialogRef;
        this.pageElementName = 'dialog-confirm-close';
        this.isLoading = false;
        this.imgPath = '/assets/images/search/Budgetlimit.png';
        this.DialogConfirmType = __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */];
        switch (type.confirmType) {
            case __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CLOSE:
                this.titleText = 'dialog-confirm-close-title';
                this.descriptionText = 'dialog-confirm-close-desc';
                this.cancelText = 'dialog-confirm-close-cancel';
                this.confirmText = 'dialog-confirm-close-confirm';
                break;
            case __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_DELETE_ADDRESS:
                this.titleText = 'dialog-confirm-delete-title';
                this.descriptionText = 'dialog-confirm-delete-address-desc';
                this.cancelText = 'dialog-confirm-delete-cancel';
                this.confirmText = 'dialog-confirm-delete-confirm';
                this.confirmAction = type.data.confirmAction;
                break;
            case __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_AVAILABLE_BUDGET:
                this.descriptionText = type.data.message;
                this.cancelText = 'dialog-confirm-delete-cancel';
                this.confirmText = 'btn-ok';
                this.template = __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_AVAILABLE_BUDGET;
                break;
            case __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CONTINUE_BOOKER_BUDGET:
                this.descriptionText = type.data.message;
                this.cancelText = 'dialog-confirm-change-search';
                this.confirmText = 'dialog-confirm-change-continue-share-budget';
                this.template = __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CONTINUE_BOOKER_BUDGET;
                break;
            case __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CANCEL_SHARE_BUDGET:
                this.descriptionText = type.data.message;
                this.cancelText = 'dialog-confirm-change-search';
                this.confirmText = 'dialog-confirm-cancel-share-budget';
                this.template = __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CANCEL_SHARE_BUDGET;
                break;
            case __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CANCEL_SHARE_BUDGET_FROM_USER:
                this.descriptionText = type.data.message;
                this.cancelText = 'dialog-confirm-delete-cancel';
                this.confirmText = 'dialog-confirm-cancel-share-budget';
                this.template = __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CANCEL_SHARE_BUDGET;
                break;
            case __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CONTINUE_BOOKING:
                this.descriptionText = type.data.message;
                this.cancelText = 'dialog-confirm-delete-cancel';
                this.confirmText = type.data.confirmText;
                this.template = __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CANCEL_SHARE_BUDGET;
                this.imgPath = type.data.imgPath;
                break;
            case __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CONTINUE_WITHOUT_PROMOTION_CODE:
                this.titleText = 'cart-dialog-confirm-continue-without-promotion-code-title';
                this.descriptionText = 'cart-dialog-confirm-continue-without-promotion-code-desc';
                this.cancelText = utilitiesService.isMobile() ? 'cart-dialog-confirm-continue-without-promotion-code-cancel-short' : 'cart-dialog-confirm-continue-without-promotion-code-cancel';
                this.confirmText = utilitiesService.isMobile() ? 'cart-button-continue' : 'cart-dialog-confirm-continue-without-promotion-code-confirm';
                this.template = __WEBPACK_IMPORTED_MODULE_2__dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CONTINUE_WITHOUT_PROMOTION_CODE;
                this.imgPath = '/assets/images/checkout/promotion_code/no_promo_code.png';
                break;
        }
    }
    DialogConfirmComponent.prototype.ngOnInit = function () {
    };
    DialogConfirmComponent.prototype.handleClose = function () {
        this.dialogRef.close();
    };
    DialogConfirmComponent.prototype.handleConfirm = function () {
        var _this = this;
        if (this.confirmAction) {
            this.isLoading = true;
            this.confirmAction && this.confirmAction().subscribe(function (res) {
                _this.isLoading = true;
                res && _this.dialogRef.close({ status: 'CONFIRM' });
            });
        }
        else {
            this.dialogRef.close({ status: 'CONFIRM' });
        }
    };
    DialogConfirmComponent.prototype.ngOnDestroy = function () {
    };
    return DialogConfirmComponent;
}());
DialogConfirmComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-confirm',
        template: __webpack_require__(1050),
        styles: [__webpack_require__(915)]
    }),
    __param(1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _a || Object, Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _b || Object])
], DialogConfirmComponent);

var _a, _b;
//# sourceMappingURL=dialog-confirm.component.js.map

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogConfirmType; });
var DialogConfirmType;
(function (DialogConfirmType) {
    DialogConfirmType[DialogConfirmType["CONFIRM_CLOSE"] = 0] = "CONFIRM_CLOSE";
    DialogConfirmType[DialogConfirmType["CONFIRM_DELETE_ADDRESS"] = 1] = "CONFIRM_DELETE_ADDRESS";
    DialogConfirmType[DialogConfirmType["CONFIRM_AVAILABLE_BUDGET"] = 2] = "CONFIRM_AVAILABLE_BUDGET";
    DialogConfirmType[DialogConfirmType["CONFIRM_CANCEL_SHARE_BUDGET"] = 3] = "CONFIRM_CANCEL_SHARE_BUDGET";
    DialogConfirmType[DialogConfirmType["CONFIRM_CONTINUE_BOOKER_BUDGET"] = 4] = "CONFIRM_CONTINUE_BOOKER_BUDGET";
    DialogConfirmType[DialogConfirmType["CONFIRM_CANCEL_SHARE_BUDGET_FROM_USER"] = 5] = "CONFIRM_CANCEL_SHARE_BUDGET_FROM_USER";
    DialogConfirmType[DialogConfirmType["CONFIRM_CONTINUE_BOOKING"] = 6] = "CONFIRM_CONTINUE_BOOKING";
    DialogConfirmType[DialogConfirmType["CONFIRM_CONTINUE_WITHOUT_PROMOTION_CODE"] = 7] = "CONFIRM_CONTINUE_WITHOUT_PROMOTION_CODE";
})(DialogConfirmType || (DialogConfirmType = {}));
//# sourceMappingURL=dialog-confirm.model.js.map

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogGeneralMessageComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};


var DialogGeneralMessageComponent = (function () {
    function DialogGeneralMessageComponent(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.onUpdateState = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    Object.defineProperty(DialogGeneralMessageComponent.prototype, "autoClose", {
        set: function (second) {
            var _this = this;
            this.countdown = second;
            var interval = setInterval(function () {
                if (_this.countdown <= 0) {
                    clearInterval(interval);
                    _this.dialogRef.close();
                }
                _this.countdown -= 1;
            }, 1000);
        },
        enumerable: true,
        configurable: true
    });
    DialogGeneralMessageComponent.prototype.ngOnInit = function () {
        var _a = this.data, title = _a.title, message = _a.message, icon = _a.icon, mainBtn = _a.mainBtn;
        this.title = title;
        this.message = message;
        this.icon = icon;
        this.mainBtn = mainBtn;
    };
    DialogGeneralMessageComponent.prototype.handleCloseDialog = function () {
        this.dialogRef.close();
    };
    return DialogGeneralMessageComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], DialogGeneralMessageComponent.prototype, "message", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], DialogGeneralMessageComponent.prototype, "title", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], DialogGeneralMessageComponent.prototype, "icon", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], DialogGeneralMessageComponent.prototype, "mainBtn", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], DialogGeneralMessageComponent.prototype, "img", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('autoClose'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DialogGeneralMessageComponent.prototype, "autoClose", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], DialogGeneralMessageComponent.prototype, "onUpdateState", void 0);
DialogGeneralMessageComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'app-dialog-general-message',
        template: __webpack_require__(1052),
        styles: [__webpack_require__(917)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _b || Object])
], DialogGeneralMessageComponent);

var _a, _b;
//# sourceMappingURL=dialog-general-message.component.js.map

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__maps_api_loader_maps_api_loader__ = __webpack_require__(106);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleMapsAPIWrapper; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



/**
 * Wrapper class that handles the communication with the Google Maps Javascript
 * API v3
 */
var GoogleMapsAPIWrapper = (function () {
    function GoogleMapsAPIWrapper(_loader, _zone) {
        var _this = this;
        this._loader = _loader;
        this._zone = _zone;
        this._map = new Promise(function (resolve) { _this._mapResolver = resolve; });
    }
    GoogleMapsAPIWrapper.prototype.createMap = function (el, mapOptions) {
        var _this = this;
        return this._loader.load().then(function () {
            var map = new google.maps.Map(el, mapOptions);
            _this._mapResolver(map);
            return;
        });
    };
    GoogleMapsAPIWrapper.prototype.setMapOptions = function (options) {
        this._map.then(function (m) { m.setOptions(options); });
    };
    /**
     * Creates a google map marker with the map context
     */
    GoogleMapsAPIWrapper.prototype.createMarker = function (options, addToMap) {
        if (options === void 0) { options = {}; }
        if (addToMap === void 0) { addToMap = true; }
        return this._map.then(function (map) {
            if (addToMap) {
                options.map = map;
            }
            return new google.maps.Marker(options);
        });
    };
    GoogleMapsAPIWrapper.prototype.createInfoWindow = function (options) {
        return this._map.then(function () { return new google.maps.InfoWindow(options); });
    };
    GoogleMapsAPIWrapper.prototype.createSize = function (width, height) {
        return this._map.then(function (map) {
            return new google.maps.Size(width, height);
        });
    };
    /**
     * Creates a google.map.Circle for the current map.
     */
    GoogleMapsAPIWrapper.prototype.createCircle = function (options) {
        return this._map.then(function (map) {
            options.map = map;
            return new google.maps.Circle(options);
        });
    };
    GoogleMapsAPIWrapper.prototype.createPolyline = function (options) {
        return this.getNativeMap().then(function (map) {
            var line = new google.maps.Polyline(options);
            line.setMap(map);
            return line;
        });
    };
    GoogleMapsAPIWrapper.prototype.createPolygon = function (options) {
        return this.getNativeMap().then(function (map) {
            var polygon = new google.maps.Polygon(options);
            polygon.setMap(map);
            return polygon;
        });
    };
    /**
     * Creates a new google.map.Data layer for the current map
     */
    GoogleMapsAPIWrapper.prototype.createDataLayer = function (options) {
        return this._map.then(function (m) {
            var data = new google.maps.Data(options);
            data.setMap(m);
            return data;
        });
    };
    /**
     * Determines if given coordinates are insite a Polygon path.
     */
    GoogleMapsAPIWrapper.prototype.containsLocation = function (latLng, polygon) {
        return google.maps.geometry.poly.containsLocation(latLng, polygon);
    };
    GoogleMapsAPIWrapper.prototype.subscribeToMapEvent = function (eventName) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].create(function (observer) {
            _this._map.then(function (m) {
                m.addListener(eventName, function (arg) { _this._zone.run(function () { return observer.next(arg); }); });
            });
        });
    };
    GoogleMapsAPIWrapper.prototype.setCenter = function (latLng) {
        return this._map.then(function (map) { return map.setCenter(latLng); });
    };
    GoogleMapsAPIWrapper.prototype.getZoom = function () { return this._map.then(function (map) { return map.getZoom(); }); };
    GoogleMapsAPIWrapper.prototype.getBounds = function () {
        return this._map.then(function (map) { return map.getBounds(); });
    };
    GoogleMapsAPIWrapper.prototype.getMapTypeId = function () {
        return this._map.then(function (map) { return map.getMapTypeId(); });
    };
    GoogleMapsAPIWrapper.prototype.setZoom = function (zoom) {
        return this._map.then(function (map) { return map.setZoom(zoom); });
    };
    GoogleMapsAPIWrapper.prototype.getCenter = function () {
        return this._map.then(function (map) { return map.getCenter(); });
    };
    GoogleMapsAPIWrapper.prototype.panTo = function (latLng) {
        return this._map.then(function (map) { return map.panTo(latLng); });
    };
    GoogleMapsAPIWrapper.prototype.panBy = function (x, y) {
        return this._map.then(function (map) { return map.panBy(x, y); });
    };
    GoogleMapsAPIWrapper.prototype.fitBounds = function (latLng) {
        return this._map.then(function (map) { return map.fitBounds(latLng); });
    };
    GoogleMapsAPIWrapper.prototype.panToBounds = function (latLng) {
        return this._map.then(function (map) { return map.panToBounds(latLng); });
    };
    /**
     * Returns the native Google Maps Map instance. Be careful when using this instance directly.
     */
    GoogleMapsAPIWrapper.prototype.getNativeMap = function () { return this._map; };
    /**
     * Triggers the given event name on the map instance.
     */
    GoogleMapsAPIWrapper.prototype.triggerMapEvent = function (eventName) {
        return this._map.then(function (m) { return google.maps.event.trigger(m, eventName); });
    };
    return GoogleMapsAPIWrapper;
}());
GoogleMapsAPIWrapper = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__maps_api_loader_maps_api_loader__["a" /* MapsAPILoader */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__maps_api_loader_maps_api_loader__["a" /* MapsAPILoader */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]) === "function" && _b || Object])
], GoogleMapsAPIWrapper);

var _a, _b;
//# sourceMappingURL=google-maps-api-wrapper.js.map

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleTagManagerService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var CURRENCY = 'THB';
var GoogleTagManagerService = (function () {
    function GoogleTagManagerService(userService) {
        this.userService = userService;
    }
    GoogleTagManagerService.prototype.emitPageView = function (title) {
        try {
            var userInfo = this.userService.getUser(false);
            var userId = userInfo ? userInfo.userId : '';
            var companyId = userInfo ? userInfo.companyId : '';
            if (typeof window !== 'undefined') {
                window.dataLayer.push({
                    pageLocation: null,
                    userId: null,
                    companyId: null,
                    pageTitle: null
                });
                window.dataLayer.push({
                    event: "page_view",
                    pageLocation: window.location.href,
                    userId: userId,
                    companyId: companyId,
                    pageTitle: title
                });
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    GoogleTagManagerService.prototype.emitEvent = function (eventCategory, eventAction, eventLabel, eventValue, title) {
        if (eventLabel === void 0) { eventLabel = null; }
        if (eventValue === void 0) { eventValue = null; }
        if (title === void 0) { title = ''; }
        if (typeof window !== 'undefined') {
            window.dataLayer.push({
                eventCategory: null,
                eventLabel: null,
                eventAction: null,
                eventValue: null,
                title: null
            });
            window.dataLayer.push({
                event: "custom_event",
                eventCategory: eventCategory,
                eventLabel: eventLabel,
                eventAction: eventAction,
                eventValue: eventValue,
                title: title
            });
        }
    };
    GoogleTagManagerService.prototype.emitViewItemList = function (items) {
        if (typeof window !== 'undefined') {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: "view_item_list",
                ecommerce: {
                    items: items
                }
            });
        }
    };
    GoogleTagManagerService.prototype.emitViewItem = function (items, price) {
        if (typeof window !== 'undefined') {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: "view_item",
                ecommerce: {
                    currency: CURRENCY,
                    value: price,
                    items: items
                }
            });
        }
    };
    GoogleTagManagerService.prototype.emitAddToCart = function (items, price) {
        if (typeof window !== 'undefined') {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: "add_to_cart",
                ecommerce: {
                    currency: CURRENCY,
                    value: price,
                    items: items
                }
            });
        }
    };
    GoogleTagManagerService.prototype.emitBeginCheckout = function (items, price) {
        if (typeof window !== 'undefined') {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: "begin_checkout",
                ecommerce: {
                    currency: CURRENCY,
                    value: price,
                    items: items
                }
            });
        }
    };
    GoogleTagManagerService.prototype.emitAddShippingInfo = function (items, price) {
        if (typeof window !== 'undefined') {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: "add_shipping_info",
                ecommerce: {
                    currency: CURRENCY,
                    value: price,
                    items: items
                }
            });
        }
    };
    GoogleTagManagerService.prototype.emitAddPaymentInfo = function (items, price) {
        if (typeof window !== 'undefined') {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: "add_payment_info",
                ecommerce: {
                    currency: CURRENCY,
                    value: price,
                    items: items
                }
            });
        }
    };
    GoogleTagManagerService.prototype.emitPurchase = function (items, price, bookingId) {
        if (typeof window !== 'undefined') {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: "purchase",
                ecommerce: {
                    currency: CURRENCY,
                    value: price,
                    transaction_id: bookingId,
                    items: items
                }
            });
        }
    };
    GoogleTagManagerService.prototype.emitViewPromotion = function (items, price) {
        if (typeof window !== 'undefined') {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: "view_promotion",
                ecommerce: {
                    currency: CURRENCY,
                    value: price,
                    items: items
                }
            });
        }
    };
    GoogleTagManagerService.prototype.emitSelectPromotion = function (items, price) {
        if (typeof window !== 'undefined') {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: "select_promotion",
                ecommerce: {
                    currency: CURRENCY,
                    value: price,
                    items: items
                }
            });
        }
    };
    GoogleTagManagerService.prototype.attachPromotionInformation = function (item) {
        try {
            var localStorageItem = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2_app_model_constant__["u" /* LocalStorage */].PROMOTION));
            if (item.item_id === localStorageItem['item_id'] && __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__().isBefore(localStorageItem['expire'])) {
                item['creative_name'] = localStorageItem['creative_name'];
                item['promotion_id'] = localStorageItem['promotion_id'];
                item['promotion_name'] = localStorageItem['promotion_name'];
            }
        }
        catch (ignore) { }
    };
    return GoogleTagManagerService;
}());
GoogleTagManagerService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__user_user_service__["a" /* UserService */]) === "function" && _a || Object])
], GoogleTagManagerService);

var _a;
//# sourceMappingURL=google-tag-manager.service.js.map

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_profile_profile_model__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_feature_attach_file_feature_model__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_feature_billing_address_feature_model__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_feature_cost_center_feature_model__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_model_feature_internal_order_feature_model__ = __webpack_require__(635);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserFeatureService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var UserFeatureService = (function () {
    function UserFeatureService(userService) {
        this.userService = userService;
    }
    UserFeatureService.prototype.getAvailableFeatureData = function (featureType) {
        var feature = this.userService.getUserFeature(featureType);
        var data = (feature || { data: undefined }).data;
        var featureData;
        switch (featureType) {
            case __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["b" /* FeatureType */].checkout3BillingAddress:
                featureData = new __WEBPACK_IMPORTED_MODULE_3_app_model_feature_billing_address_feature_model__["a" /* BillingAddressFeature */](data);
                break;
            case __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["b" /* FeatureType */].checkout3DocumentAttach:
                featureData = new __WEBPACK_IMPORTED_MODULE_2__model_feature_attach_file_feature_model__["a" /* AttachFileFeature */](data);
                break;
            case __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["b" /* FeatureType */].checkout3CostCenter:
                featureData = new __WEBPACK_IMPORTED_MODULE_4__model_feature_cost_center_feature_model__["a" /* CostCenterFeature */](data);
                break;
            case __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["b" /* FeatureType */].checkout3InternalOrder:
                featureData = new __WEBPACK_IMPORTED_MODULE_7_app_model_feature_internal_order_feature_model__["a" /* InternalOrderFeature */](data);
                break;
            default:
                featureData = undefined;
                break;
        }
        return featureData;
    };
    UserFeatureService.prototype.canChangePassword = function () {
        var feature = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_0_app_model_constant__["b" /* FeatureType */].ALLOW_CHANGE_PASSWORD, true);
        return feature ? feature.allow : false;
    };
    UserFeatureService.prototype.canEditProfile = function () {
        var feature = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_0_app_model_constant__["b" /* FeatureType */].ALLOW_EDIT_PROFILE, true);
        return feature ? feature.allow : false;
    };
    UserFeatureService.prototype.getCostCenterData = function (costCenterFeature) {
        return costCenterFeature && costCenterFeature.display ? costCenterFeature : null;
    };
    UserFeatureService.prototype.checkUseDefaultCostCenter = function (costCenter) {
        var costCenterData = (costCenter || { costCenter: undefined }).costCenter;
        var costCenterNameData = (costCenter || { costCenterName: undefined }).costCenterName;
        var defaultAddressData = (costCenter || { defaultAddress: undefined }).defaultAddress;
        var haveCostCenter = !!costCenterData && costCenterData !== '';
        var haveCostCenterName = !!costCenterNameData && costCenterNameData !== '';
        var haveDefaultAddress = !!defaultAddressData;
        return haveCostCenter && haveCostCenterName && haveDefaultAddress;
    };
    UserFeatureService.prototype.transformCostCenterAddressToAddressModel = function (address) {
        var newAddress = null;
        if (address) {
            newAddress = new __WEBPACK_IMPORTED_MODULE_1__model_profile_profile_model__["a" /* AddressesUserProfileModel */]();
            newAddress.title = address.companyTitle;
            newAddress.taxNumber = address.taxNumber;
            newAddress.address = address.address;
        }
        return newAddress;
    };
    UserFeatureService.prototype.canShowApprovalList = function () {
        var feature = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_0_app_model_constant__["b" /* FeatureType */].ALLOW_SUPERVISOR_APPROVAL, true);
        return feature ? (feature.data ? feature.data.postApproval : false) : false;
    };
    UserFeatureService.prototype.canShowShareBudget = function () {
        var feature = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_0_app_model_constant__["b" /* FeatureType */].ALLOW_SHARE_BUDGET, true);
        return feature ? feature.allow : false;
    };
    UserFeatureService.prototype.isAllowBudgetLimit = function () {
        var allowLimitBudgetFeature = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_0_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET);
        var allowCreditTermsFeature = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_0_app_model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS);
        var allowCorporateFleetFeature = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_0_app_model_constant__["b" /* FeatureType */].ALLOW_CORPORATE_FLEET);
        return allowLimitBudgetFeature && allowLimitBudgetFeature.allow && (allowCreditTermsFeature.allow || allowCorporateFleetFeature.allow);
    };
    UserFeatureService.prototype.enablePreApprovalRequester = function () {
        var enablePreApproval = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_0_app_model_constant__["b" /* FeatureType */].ENABLE_PRE_APPROVAL, true);
        var hasApprovalRequest = enablePreApproval && enablePreApproval.data && enablePreApproval.data.hasApprovalRequest;
        return ((enablePreApproval && enablePreApproval.allow) || hasApprovalRequest);
    };
    UserFeatureService.prototype.enablePreApprovalApprover = function () {
        var feature = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_0_app_model_constant__["b" /* FeatureType */].ALLOW_SUPERVISOR_APPROVAL, true);
        return feature ? (feature.data ? feature.data.preApproval : false) : false;
    };
    return UserFeatureService;
}());
UserFeatureService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__["a" /* UserService */]) === "function" && _a || Object])
], UserFeatureService);

var _a;
//# sourceMappingURL=user-feature.service.js.map

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ConsentType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ConsentName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Consent; });
/* unused harmony export Purpose */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserSubmitConsentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PurposeByUserIdResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PurposeByUserIdRequest; });
var ConsentType = (function () {
    function ConsentType() {
    }
    return ConsentType;
}());

ConsentType.TERMS = 'terms';
ConsentType.PRIVACY = 'privacy';
var ConsentName = (function () {
    function ConsentName() {
    }
    return ConsentName;
}());

ConsentName.ACT = 'act';
var Consent = (function () {
    function Consent() {
    }
    return Consent;
}());

var Purpose = (function () {
    function Purpose() {
    }
    return Purpose;
}());

var UserSubmitConsentRequest = (function () {
    function UserSubmitConsentRequest() {
    }
    return UserSubmitConsentRequest;
}());

var PurposeByUserIdResponse = (function () {
    function PurposeByUserIdResponse() {
    }
    return PurposeByUserIdResponse;
}());

var PurposeByUserIdRequest = (function () {
    function PurposeByUserIdRequest() {
    }
    return PurposeByUserIdRequest;
}());

//# sourceMappingURL=consent-model.js.map

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_checkout_guest_info_model__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_checkout_booker_info_model__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_services_products_product_service__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_store__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__model_condition_condition_model__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_pipes_translate_singular_plural_pipe__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__authorize_authorize_service__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__promotion_code_enum_promotion_code_enum__ = __webpack_require__(269);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckoutService; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




















// store.addPlugin(expirePlugin);
var CheckoutService = (function () {
    function CheckoutService(actHttp, appConfigService, utilitiesService, translate, translatePlural, productService, authenticationService, userService, authorizeService, authService) {
        this.actHttp = actHttp;
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.translate = translate;
        this.translatePlural = translatePlural;
        this.productService = productService;
        this.authenticationService = authenticationService;
        this.userService = userService;
        this.authorizeService = authorizeService;
        this.authService = authService;
        this.mainBookerEmail$ = new __WEBPACK_IMPORTED_MODULE_17_rxjs__["Subject"]();
        this.fullNameSource = new __WEBPACK_IMPORTED_MODULE_17_rxjs__["BehaviorSubject"]('');
        this.currentFullName = this.fullNameSource.asObservable();
        this.countryISO2Source = new __WEBPACK_IMPORTED_MODULE_17_rxjs__["BehaviorSubject"]('');
        this.currentCountryISO2 = this.countryISO2Source.asObservable();
        this.mobileNumberSource = new __WEBPACK_IMPORTED_MODULE_17_rxjs__["BehaviorSubject"]('');
        this.currentMobileNumber = this.mobileNumberSource.asObservable();
        this.isLoadingUploadDocumentSource = new __WEBPACK_IMPORTED_MODULE_17_rxjs__["BehaviorSubject"](false);
        this.currentIsLoadingUploadDocument = this.isLoadingUploadDocumentSource.asObservable();
        this.promoCode = new __WEBPACK_IMPORTED_MODULE_17_rxjs__["BehaviorSubject"](undefined);
        this.currentPromoCode = this.promoCode.asObservable();
        this.validatedPromoCode = new __WEBPACK_IMPORTED_MODULE_17_rxjs__["BehaviorSubject"](undefined);
        this.currentValidatedPromoCode = this.validatedPromoCode.asObservable();
        this.isLockedPromoCode = new __WEBPACK_IMPORTED_MODULE_17_rxjs__["BehaviorSubject"](false);
        this.currentIsLockedPromoCode = this.isLockedPromoCode.asObservable();
        this.grandTotalPrice = new __WEBPACK_IMPORTED_MODULE_17_rxjs__["BehaviorSubject"](null);
        this.currentGrandTotalPrice = this.grandTotalPrice.asObservable();
    }
    CheckoutService.prototype.changeFullName = function (fullName) {
        this.fullNameSource.next(fullName);
    };
    CheckoutService.prototype.changeCountryISO2 = function (countryISO2) {
        this.countryISO2Source.next(countryISO2);
    };
    CheckoutService.prototype.changeMobileNumber = function (mobileNumber) {
        this.mobileNumberSource.next(mobileNumber);
    };
    CheckoutService.prototype.changeIsLoadingUploadDocument = function (isLoading) {
        this.isLoadingUploadDocumentSource.next(isLoading);
    };
    CheckoutService.prototype.transformProfileDetailToBookerInfo = function (cartAndProfile) {
        var bookerInfo = new __WEBPACK_IMPORTED_MODULE_7__model_checkout_booker_info_model__["a" /* BookerInfoModel */]();
        bookerInfo.userId = cartAndProfile.user.userId;
        bookerInfo.visitorId = cartAndProfile.user.userId;
        bookerInfo.memberId = cartAndProfile.user.userId;
        bookerInfo.companyId = cartAndProfile.user.companyId;
        bookerInfo.email = cartAndProfile.user.username ? cartAndProfile.user.username.toLowerCase() : '';
        bookerInfo.typeOfTravelObjective = cartAndProfile.cart.purpose === 'work' ? 1 : 2;
        bookerInfo.fullName = cartAndProfile.user.fullName ? cartAndProfile.user.fullName : '';
        bookerInfo.mobileNumber = cartAndProfile.user.telephone ? cartAndProfile.user.telephone : '';
        bookerInfo.countryCallingCode = cartAndProfile.profile.countryCallingCode ? cartAndProfile.profile.countryCallingCode : '';
        return bookerInfo;
    };
    CheckoutService.prototype.transformPromotionProfileDetailToBookerInfo = function (cartAndProfile) {
        var bookerInfo = new __WEBPACK_IMPORTED_MODULE_7__model_checkout_booker_info_model__["a" /* BookerInfoModel */]();
        bookerInfo.userId = cartAndProfile.user.userId;
        bookerInfo.visitorId = cartAndProfile.user.userId;
        bookerInfo.memberId = cartAndProfile.user.userId;
        bookerInfo.companyId = cartAndProfile.user.companyId;
        bookerInfo.typeOfTravelObjective = 2;
        return bookerInfo;
    };
    CheckoutService.prototype.buildCreateOrderPayload = function (checkout2Data, checkout3Data, checkout3) {
        var createOrderPayload = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["a" /* CreateOrderPayload */]();
        createOrderPayload.arrivalTime = checkout2Data.arrivalTime;
        createOrderPayload.bookerInfo = checkout2Data.bookerInfo;
        if (checkout2Data.isBookForTraveller) {
            createOrderPayload.guestInfo = this.clearAdditionalBookerTravellerInfo(checkout2Data.guestsBookerTravellerInfo);
        }
        else {
            createOrderPayload.guestInfo = this.clearSavingGuestInfo(checkout2Data.guestInfo);
        }
        checkout3Data.forEach(function (item) {
            var booker = createOrderPayload.getBookerByEmail(item.bookerEmail);
            switch (item.checkOutComponentData) {
                case __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].CREDIT_TERMS_INFO:
                    !booker.paymentCreditTerms && (booker.paymentCreditTerms = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["b" /* BookerPaymentCreditTerms */]());
                    booker.paymentCreditTerms.attachmentPath = item.data.attachmentPath;
                    booker.paymentCreditTerms.ch3CustomFields = item.data.data;
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].CREDIT_TERMS_TAX_INFO:
                    var creditTermsTaxData = item.data;
                    !booker.paymentCreditTerms && (booker.paymentCreditTerms = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["b" /* BookerPaymentCreditTerms */]());
                    booker.paymentCreditTerms.taxAddress = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["c" /* TaxAddress */]();
                    booker.paymentCreditTerms.taxAddress.taxAddress = creditTermsTaxData.address.valueOf();
                    booker.paymentCreditTerms.taxAddress.taxName = creditTermsTaxData.company.valueOf();
                    booker.paymentCreditTerms.taxAddress.taxId = creditTermsTaxData.number.valueOf();
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].CREDIT_CARD_INFO:
                    !booker.paymentCreditCard && (booker.paymentCreditCard = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["d" /* BookerPaymentCreditCard */]());
                    booker.paymentCreditCard = __assign({}, booker.paymentCreditCard, item.data);
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].CREDIT_CARD_TAX_INFO:
                    !booker.paymentCreditCard && (booker.paymentCreditCard = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["d" /* BookerPaymentCreditCard */]());
                    booker.paymentCreditCard.taxAddress = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["c" /* TaxAddress */]();
                    booker.paymentCreditCard.taxAddress.taxAddress = item.data.address;
                    booker.paymentCreditCard.taxAddress.taxName = item.data.title;
                    booker.paymentCreditCard.taxAddress.taxId = item.data.taxNumber;
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].TRUE_MONEY_WALLET:
                    !booker.paymentTrueMoney && (booker.paymentTrueMoney = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["e" /* BookerTrueMoney */]());
                    booker.paymentTrueMoney.accountNumber = item.data.accountNumber;
                    booker.paymentTrueMoney.gatewayId = item.data.gatewayId;
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].TRUE_MONEY_WALLET_TAX_INFO:
                    !booker.paymentTrueMoney && (booker.paymentTrueMoney = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["e" /* BookerTrueMoney */]());
                    booker.paymentTrueMoney.taxAddress = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["c" /* TaxAddress */]();
                    booker.paymentTrueMoney.taxAddress.taxAddress = item.data.address;
                    booker.paymentTrueMoney.taxAddress.taxName = item.data.title;
                    booker.paymentTrueMoney.taxAddress.taxId = item.data.taxNumber;
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].QR_CODE:
                    !booker.paymentQRCode && (booker.paymentQRCode = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["f" /* BookerPaymentQRCode */]());
                    booker.paymentQRCode.gatewayId = item.data.gatewayId;
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].QR_CODE_TAX_INFO:
                    !booker.paymentQRCode && (booker.paymentQRCode = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["f" /* BookerPaymentQRCode */]());
                    booker.paymentQRCode.taxAddress = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["c" /* TaxAddress */]();
                    booker.paymentQRCode.taxAddress.taxAddress = item.data.address;
                    booker.paymentQRCode.taxAddress.taxName = item.data.title;
                    booker.paymentQRCode.taxAddress.taxId = item.data.taxNumber;
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].E_WALLET:
                    !booker.paymentEWallet && (booker.paymentEWallet = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["g" /* BookerPaymentEWallet */]());
                    booker.paymentEWallet.gatewayId = item.data.gatewayId;
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].E_WALLET_TAX_INFO:
                    !booker.paymentEWallet && (booker.paymentEWallet = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["g" /* BookerPaymentEWallet */]());
                    booker.paymentEWallet.taxAddress = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["c" /* TaxAddress */]();
                    booker.paymentEWallet.taxAddress.taxAddress = item.data.address;
                    booker.paymentEWallet.taxAddress.taxName = item.data.title;
                    booker.paymentEWallet.taxAddress.taxId = item.data.taxNumber;
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].IM_BANKING:
                    !booker.paymentIMBanking && (booker.paymentIMBanking = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["h" /* BookerPaymentIMBanking */]());
                    booker.paymentIMBanking.gatewayId = item.data.gatewayId;
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].IM_BANKING_TAX_INFO:
                    !booker.paymentIMBanking && (booker.paymentIMBanking = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["h" /* BookerPaymentIMBanking */]());
                    booker.paymentIMBanking.taxAddress = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["c" /* TaxAddress */]();
                    booker.paymentIMBanking.taxAddress.taxAddress = item.data.address;
                    booker.paymentIMBanking.taxAddress.taxName = item.data.title;
                    booker.paymentIMBanking.taxAddress.taxId = item.data.taxNumber;
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].PAY_AT_COUNTER:
                    !booker.paymentPayAtCounter && (booker.paymentPayAtCounter = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["i" /* BookerPaymentPayAtCounter */]());
                    booker.paymentPayAtCounter.gatewayId = item.data.gatewayId;
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].PAY_AT_COUNTER_TAX_INFO:
                    !booker.paymentPayAtCounter && (booker.paymentPayAtCounter = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["i" /* BookerPaymentPayAtCounter */]());
                    booker.paymentPayAtCounter.taxAddress = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["c" /* TaxAddress */]();
                    booker.paymentPayAtCounter.taxAddress.taxAddress = item.data.address;
                    booker.paymentPayAtCounter.taxAddress.taxName = item.data.title;
                    booker.paymentPayAtCounter.taxAddress.taxId = item.data.taxNumber;
                    break;
            }
        });
        checkout3Data
            .filter(function (item) { return item.checkOutComponentData === __WEBPACK_IMPORTED_MODULE_0__model_constant__["B" /* CheckOut3DataType */].PAYMENT_INFO; })
            .forEach(function (item, index) {
            var booker = createOrderPayload.getBookerByEmail(item.bookerEmail);
            if (booker && booker.paymentCreditCard && item.data.creditCardAmount) {
                booker.paymentCreditCard.totalAmount = item.data.creditCardAmount;
            }
            if (booker && booker.paymentTrueMoney && item.data.trueMoneyAmount) {
                booker.paymentTrueMoney.totalAmount = item.data.trueMoneyAmount;
            }
            if (booker && booker.paymentQRCode && item.data.qrCodeAmount) {
                booker.paymentQRCode.totalAmount = item.data.qrCodeAmount;
            }
            if (booker && booker.paymentEWallet && item.data.eWalletAmount) {
                booker.paymentEWallet.totalAmount = item.data.eWalletAmount;
            }
            if (booker && booker.paymentIMBanking && item.data.imBankingAmount) {
                booker.paymentIMBanking.totalAmount = item.data.imBankingAmount;
            }
            if (booker && booker.paymentPayAtCounter && item.data.payAtCounterAmount) {
                booker.paymentPayAtCounter.totalAmount = item.data.payAtCounterAmount;
            }
            if (booker && booker.paymentCreditTerms && item.data.creditTermsAmount) {
                booker.paymentCreditTerms.totalAmount = index === 0 ? item.data.creditTermsAmount.booker : item.data.creditTermsAmount.coBooker;
            }
            if (booker && index === 0 && item.data.paymentPersonalFleetCard && item.data.paymentPersonalFleetCard.fleetCardId && item.data.paymentPersonalFleetCard.totalAmount) {
                booker.paymentPersonalFleetCard = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["j" /* PaymentFleetCard */](item.data.paymentPersonalFleetCard.fleetCardId, item.data.paymentPersonalFleetCard.totalAmount);
            }
            if (booker && index === 0 && item.data.paymentCorporateFleetCard && item.data.paymentCorporateFleetCard.fleetCardId && item.data.paymentCorporateFleetCard.totalAmount) {
                booker.paymentCorporateFleetCard = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["j" /* PaymentFleetCard */](item.data.paymentCorporateFleetCard.fleetCardId, item.data.paymentCorporateFleetCard.totalAmount);
            }
        });
        if (checkout3.useBookForTraveller(checkout2Data.isBookForTraveller)) {
            createOrderPayload.isBookForTraveller = true;
            var totalPaymentCreditTerms_1 = 0;
            createOrderPayload.bookerInfo.map(function (m) {
                m.paymentCreditTerms.totalAmount = m.totalCharge || 0;
                totalPaymentCreditTerms_1 += m.totalCharge ? m.totalCharge : 0;
                delete m.totalCharge;
            });
            var validateInfo = this.getCurrentPromotionCode().validateInfo;
            if (validateInfo && validateInfo.valid) {
                var totalPaymentCreditTermsAfterDiscount_1 = validateInfo.finalAmount;
                var totalDiscountToCreditTerms_1 = 0;
                createOrderPayload.bookerInfo.map(function (m, index) {
                    if (index === 0) {
                        totalPaymentCreditTermsAfterDiscount_1 -= m.paymentCreditCard ? m.paymentCreditCard.totalAmount : 0;
                        totalPaymentCreditTermsAfterDiscount_1 -= m.paymentTrueMoney ? m.paymentTrueMoney.totalAmount : 0;
                        totalPaymentCreditTermsAfterDiscount_1 -= m.paymentPersonalFleetCard ? m.paymentPersonalFleetCard.totalAmount : 0;
                        totalDiscountToCreditTerms_1 = totalPaymentCreditTerms_1 - totalPaymentCreditTermsAfterDiscount_1;
                    }
                    if (totalDiscountToCreditTerms_1 > 0) {
                        if (createOrderPayload.bookerInfo.length === index + 1) {
                            m.paymentCreditTerms.totalAmount = m.paymentCreditTerms.totalAmount - totalDiscountToCreditTerms_1;
                        }
                        else {
                            var newAmount = Math.floor(m.paymentCreditTerms.totalAmount * totalPaymentCreditTermsAfterDiscount_1 / totalPaymentCreditTerms_1);
                            totalDiscountToCreditTerms_1 -= m.paymentCreditTerms.totalAmount - newAmount;
                            m.paymentCreditTerms.totalAmount = newAmount;
                        }
                    }
                });
            }
        }
        // if (checkout3Data.paymentInfo.paymentMethod === PaymentMethodUpperCaseType.creditTerms) {
        //   createOrderPayload.taxAddress.taxId = checkout3Data.userBillingAddressId;
        //   createOrderPayload.internalOrder = checkout3Data.fundCode;
        //   createOrderPayload.attachment = checkout3Data.attachment;
        // }
        // if (checkout3Data.costCenter) {
        //   createOrderPayload.costCenter.costCenterCode = checkout3Data.costCenter.code;
        //   createOrderPayload.costCenter.costCenterName = checkout3Data.costCenter.name;
        // }
        // createOrderPayload.taxAddress = new OneTimeTaxAddress();
        // createOrderPayload.taxAddress.taxAddress = checkout3Data.taxInfo.address;
        // createOrderPayload.taxAddress.taxId = checkout3Data.taxInfo.number;
        // createOrderPayload.taxAddress.taxName = checkout3Data.taxInfo.company;
        return createOrderPayload;
    };
    CheckoutService.prototype.buildCreateOrderPayloadWithPromotion = function (checkout2Data, checkout3Data) {
        var createOrderPayload = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["k" /* CreateOrderPayloadWithPromotion */]();
        createOrderPayload.bookerInfo = checkout2Data.bookerInfo;
        createOrderPayload.arrivalTime = checkout2Data.arrivalTime;
        var paymentCreditCard = new __WEBPACK_IMPORTED_MODULE_8__payload_create_order_payload__["d" /* BookerPaymentCreditCard */]();
        checkout2Data.bookerInfo.map(function (booker) { return booker.paymentCreditCard = __assign({}, checkout3Data); });
        // TODO :: Uncomment when fix promition work with multi payment
        // delete createOrderPayload.bookerInfo.email;
        createOrderPayload.guestInfo = checkout2Data.guestInfo;
        // createOrderPayload.paymentInfo = checkout3Data.paymentInfo;
        // createOrderPayload.taxAddress = new OneTimeTaxAddress();
        // createOrderPayload.taxAddress.taxAddress = checkout3Data.taxInfo.address;
        // createOrderPayload.taxAddress.taxId = checkout3Data.taxInfo.number;
        // createOrderPayload.taxAddress.taxName = checkout3Data.taxInfo.company;
        return createOrderPayload;
    };
    CheckoutService.prototype.transformCartInfoToGuestDetails = function (cartAndProfile) {
        var _this = this;
        var index = 0;
        return cartAndProfile.cart.optionDetail.optionList.map(function (option) {
            return option.conditionList.map(function (condition) {
                return condition.quantity > 0 && Array.from(Array(condition.quantity.valueOf()).keys()).map(function () {
                    var guestDetail = new __WEBPACK_IMPORTED_MODULE_4__model_checkout_guest_info_model__["a" /* GuestDetailsDto */];
                    guestDetail.room = new __WEBPACK_IMPORTED_MODULE_4__model_checkout_guest_info_model__["b" /* RoomModel */]();
                    var adult = cartAndProfile.cart.optionDetail.roomOccupancy[index].adult;
                    var child = cartAndProfile.cart.optionDetail.roomOccupancy[index].child;
                    guestDetail.index = index + 1;
                    guestDetail.room.title = _this.productService.formatDisplayTitle(option.title);
                    guestDetail.room.optionCode = condition.optionCode;
                    guestDetail.room.adult = adult ? adult : 0;
                    guestDetail.room.child = child ? child : 0;
                    guestDetail.room.maxAdult = guestDetail.room.adult > 0 ? _this.translatePlural.transform("checkout-1-max-adult-title", guestDetail.room.adult).replace(/{X}/gi, guestDetail.room.adult) : '';
                    guestDetail.room.maxChild = guestDetail.room.child > 0 ? _this.translatePlural.transform("checkout-1-max-child-title", guestDetail.room.child).replace(/{X}/gi, guestDetail.room.child) : '';
                    guestDetail.room.allGuests = guestDetail.room.adult.valueOf() + guestDetail.room.child.valueOf();
                    if (condition.selectedBedTypeEn && condition.selectedBedTypeTh) {
                        guestDetail.room.selectedBedTypeEn = condition.selectedBedTypeEn;
                        guestDetail.room.selectedBedTypeTh = condition.selectedBedTypeTh;
                    }
                    // Check feature of user
                    var guestDefault = new __WEBPACK_IMPORTED_MODULE_4__model_checkout_guest_info_model__["c" /* GuestInfoModel */]();
                    if (cartAndProfile.cart.approvalRequestId && cartAndProfile.preApprovalDetail && cartAndProfile.preApprovalDetail.requestType !== __WEBPACK_IMPORTED_MODULE_0__model_constant__["C" /* RequestType */].BOOK_FOR_TRAVELLER) {
                        var guest = cartAndProfile.preApprovalDetail.travellers[index];
                        if (guest) {
                            guestDefault.fullName = guest.fullName;
                            guestDefault.email = guest.email;
                            guestDefault.nationality = guest.nationality;
                            if (guest.countryCallingCode && guest.phone) {
                                guestDefault.countryCallingCode = guest.countryCallingCode;
                                guestDefault.mobileNumber = guest.phone;
                            }
                        }
                    }
                    else {
                        cartAndProfile.user.features && cartAndProfile.user.features.map(function (feature) {
                            if (cartAndProfile.cart.purpose === __WEBPACK_IMPORTED_MODULE_3__model_constant__["o" /* PurposeType */].work && feature.feature === __WEBPACK_IMPORTED_MODULE_3__model_constant__["b" /* FeatureType */].ALLOW_LIMIT_ROOM && feature.allow) {
                                guestDefault.fullName = cartAndProfile.profile.fullName;
                                guestDefault.email = cartAndProfile.profile.email;
                                guestDefault.nationalityId = 'TH';
                            }
                        });
                    }
                    index++;
                    guestDetail.guestInfoList = [guestDefault];
                    guestDetail.guestInfoBookerTravellerList = [guestDefault];
                    return guestDetail;
                });
            }).reduce(function (a, b) { return a.concat(b); });
        }).reduce(function (a, b) { return a.concat(b); });
    };
    CheckoutService.prototype.addGuestInformation = function (guests, maxGuest) {
        guests.length < maxGuest ? guests.push(new __WEBPACK_IMPORTED_MODULE_4__model_checkout_guest_info_model__["c" /* GuestInfoModel */]()) : '';
        return guests;
    };
    CheckoutService.prototype.deleteGuestInformation = function (guests, index) {
        if (guests.length > 1 && index >= 0) {
            return guests.slice(0, index).concat(guests.slice(index + 1));
        }
        return guests;
    };
    CheckoutService.prototype.clearSavingGuestInfo = function (guestInfo) {
        guestInfo.forEach(function (gi) {
            gi.guests.forEach(function (guest) {
                delete guest.savingGuest;
            });
        });
        return guestInfo;
    };
    CheckoutService.prototype.clearAdditionalBookerTravellerInfo = function (guestsBookerTravellerInfo) {
        var guestInfo = [];
        guestsBookerTravellerInfo.forEach(function (bookerTravller) {
            var guestInfoV2 = [];
            bookerTravller.guests.map(function (guest) { return guestInfoV2.push(new __WEBPACK_IMPORTED_MODULE_4__model_checkout_guest_info_model__["d" /* GuestInfoV2 */](guest)); });
            bookerTravller.guests = guestInfoV2;
            guestInfo.push(bookerTravller);
        });
        return guestInfo;
    };
    // ***************** HTTP Connection ************************************* //
    CheckoutService.prototype.createOrder = function (payload) {
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.createBooking, payload, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_5__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, null)).map(function (res) { return res.text(); });
    };
    CheckoutService.prototype.createOrderWithPromotionCode = function (payload) {
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.createBooking, payload, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_5__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, null)).map(function (res) { return res.text(); });
    };
    CheckoutService.prototype.validateCreditCard = function (sixDigit) {
        return this.actHttp.get("" + __WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.validateCreditCart + sixDigit, this.actHttp.getRequestOptions()).map(function (res) { return res; });
    };
    // ***************** Checkout Data in Local Storage ************************ //
    CheckoutService.prototype.saveCheckoutData = function (cartAndProfile) {
        var data = this.utilitiesService.encodeToCookie(JSON.stringify(cartAndProfile));
        var expireTime = new Date().getTime() + 18e5; // expire time 30 minite
        __WEBPACK_IMPORTED_MODULE_14_store___default.a.set(__WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */].checkoutDataCookieName, data, expireTime);
    };
    CheckoutService.prototype.getCheckoutData = function () {
        var dataEncode = __WEBPACK_IMPORTED_MODULE_14_store___default.a.get(__WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */].checkoutDataCookieName);
        var dataDecode = dataEncode ? this.utilitiesService.decodeFromCookie(dataEncode) : undefined;
        var data = dataDecode ? JSON.parse(dataDecode) : undefined;
        return data;
    };
    CheckoutService.prototype.clearCheckoutData = function () {
        __WEBPACK_IMPORTED_MODULE_14_store___default.a.remove(__WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */].checkoutDataCookieName);
        return true;
    };
    CheckoutService.prototype.getPriceSelling = function (condition) {
        return Math.ceil(condition.totalPriceSellingFinalSupplierCurrency.valueOf());
    };
    CheckoutService.prototype.getTextFeatureInternalOrder = function (type, internalOrderFeature) {
        if (type === void 0) { type = __WEBPACK_IMPORTED_MODULE_3__model_constant__["D" /* FeatureInternalOrderType */].label; }
        var defaultKey = "";
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_3__model_constant__["D" /* FeatureInternalOrderType */].label:
                defaultKey = "checkout-3-label-fund-code";
                break;
            case __WEBPACK_IMPORTED_MODULE_3__model_constant__["D" /* FeatureInternalOrderType */].placeholder:
                defaultKey = "checkout-3-placeholder-fund-code";
                break;
            default:
                defaultKey = "checkout-3-label-fund-code";
                break;
        }
        var lang = this.appConfigService.getLanguage();
        var data = internalOrderFeature ? internalOrderFeature[type] : null;
        return data && data[lang] ? data[lang] : this.translate.transform(defaultKey);
    };
    CheckoutService.prototype.getTaxAddressByCostCenter = function (companyCode, costCenterCode) {
        var langId = this.appConfigService.getLanguageId();
        var options = this.actHttp.getRequestOptions();
        var url = __WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.getTaxAddress
            .replace(':affiliate', companyCode && companyCode.valueOf())
            .replace(':costCenterCode', costCenterCode && costCenterCode.valueOf()) + "?langId=" + langId;
        return this.actHttp.get(url, options).map(function (res) { return res.json().data; });
    };
    CheckoutService.prototype.transformStringToArray = function (data, type) {
        if (type === void 0) { type = ''; }
        var temp;
        switch (type) {
            case 'column':
                temp = data.split(',');
                break;
            default:
                temp = data.split(',').map(function (res) { return res.split('=').slice(1); });
                break;
        }
        return [].concat.apply([], temp);
    };
    CheckoutService.prototype.transformDetailNodeToArray = function (condition) {
        var conditionDetail = [];
        var index = 0;
        while (index < condition.details.length) {
            conditionDetail.push(this.transformDetailNode(condition.details[index]));
            index++;
        }
        return conditionDetail;
    };
    CheckoutService.prototype.transformDetailNode = function (data) {
        var result = [];
        var values;
        var title;
        values = this.transformStringToArray(data.details[0].message);
        //In case of HTB change text from 'ROOM' to 'Room'
        values[0] = this.formatDisplayTitle(values[0]);
        switch (data.code) {
            case '40711':
                result.push(values[0]);
                result.push(this.appConfigService.getTranslateWithLang('menu-bar-baht', 'en') + ' ' + this.setCurrencyFormat(values[1]));
                result.push(this.appConfigService.getTranslateWithLang('menu-bar-baht', 'en') + ' ' + this.setCurrencyFormat(values[2]));
                break;
            case '40721':
                result.push(values.shift());
                result.push(this.createListOfEachRoomType(data, 'condition-cancellation-policy-baht'));
                break;
            case '40722':
                result.push(values.shift());
                result.push(this.createListOfEachRoomType(data, 'condition-cancellation-policy-free-of-charge'));
                break;
            case '40723':
                title = this.appConfigService.getTranslate('condition-cancellation-policy-non-refundable');
                result.push(values[0]);
                result.push(title);
                break;
            case '40781':
                result.push(values[0]);
                result.push(this.appConfigService.getTranslate('condition-offer-type-breakfast-include'));
                result.push(this.appConfigService.getTranslate('condition-offer-type-breakfast-not-include'));
                break;
            default:
                break;
        }
        return result;
    };
    CheckoutService.prototype.createListOfEachRoomType = function (data, keyLangTranslate) {
        var title, message = '', tempMessage;
        var values;
        var index = 0;
        title = this.appConfigService.getTranslate(keyLangTranslate);
        while (index < data.details.length) {
            values = this.transformStringToArray(data.details[index].message);
            values.shift();
            if (data.details.length === 1) {
                message = '<li> ' + this.replaceValueInString(title, values) + '<\li>';
                break;
            }
            if (index === data.details.length - 1) {
                tempMessage = '<li> - ' + this.replaceValueInString(title, values) + '<\li>';
            }
            else {
                tempMessage = '<li> - ' + this.replaceValueInString(title, values) + '<\li> <br/>';
            }
            message += tempMessage;
            index++;
        }
        return message;
    };
    CheckoutService.prototype.replaceValueInString = function (message, data) {
        var _this = this;
        data.forEach(function (res) {
            if (_this.utilitiesService.checkDateformat(res, 'YYYY-MM-D')) {
                res = _this.utilitiesService.getOtaFormatYear(_this.appConfigService.getLanguage(), res, 'D MMM YYYY');
            }
            if (!isNaN(res)) {
                res = _this.setCurrencyFormat(res);
            }
            message = message.replace('${var}', res);
        });
        return message;
    };
    CheckoutService.prototype.popUpDataByCase = function (condition, routePageContinue) {
        var data = new __WEBPACK_IMPORTED_MODULE_15__model_condition_condition_model__["a" /* ConditionDisplay */]();
        switch (condition.code) {
            case '4071':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-pricechange.png';
                data.title = this.appConfigService.getTranslate('condition-selling-price-in-budget-title');
                data.columns = this.transformStringToArray(this.appConfigService.getTranslate('condition-selling-price-in-budget-column'), 'column');
                data.row = this.transformDetailNodeToArray(condition);
                data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
                data.btn.push(this.appConfigService.getTranslate('condition-button-accept'));
                data.route = routePageContinue;
                break;
            case '4072':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-cancellationchange.png';
                data.title = this.appConfigService.getTranslate('condition-cancellation-policy-title');
                data.columns = this.transformStringToArray(this.appConfigService.getTranslate('condition-cancellation-policy-column'), 'column');
                data.row = this.transformDetailNodeToArray(condition);
                data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
                data.btn.push(this.appConfigService.getTranslate('condition-button-accept'));
                data.route = routePageContinue;
                break;
            case '4078':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-breakfastchange.png';
                data.title = this.appConfigService.getTranslate('condition-offer-type-title');
                data.columns = this.transformStringToArray(this.appConfigService.getTranslate('condition-offer-type-column'), 'column');
                data.row = this.transformDetailNodeToArray(condition);
                data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
                data.btn.push(this.appConfigService.getTranslate('condition-button-accept'));
                data.route = routePageContinue;
                break;
            case '4075':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-paymentchange.png';
                data.title = this.appConfigService.getTranslate('condition-cancellation-policy-pay-now');
                data.title = this.replaceValueInString(data.title, this.transformStringToArray(condition.message));
                data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
                data.btn.push(this.appConfigService.getTranslate('condition-button-accept'));
                data.route = routePageContinue;
                break;
            case '4076':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-paymentchange.png';
                data.title = this.appConfigService.getTranslate('condition-cancellation-policy-pay-later');
                data.title = this.replaceValueInString(data.title, this.transformStringToArray(condition.message));
                data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
                data.btn.push(this.appConfigService.getTranslate('condition-button-accept'));
                data.route = routePageContinue;
                break;
            case '4077':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-paymentchange.png';
                data.title = this.appConfigService.getTranslate('condition-cancelltaion-policy-pay-later-from-to');
                data.title = this.replaceValueInString(data.title, this.transformStringToArray(condition.message));
                data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
                data.btn.push(this.appConfigService.getTranslate('condition-button-accept'));
                data.route = routePageContinue;
                break;
            case '4081':
            case '4811':
            case '4807':
            case '4808':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-budgetlimit.png';
                data.title = this.appConfigService.getTranslate('condition-selling-price-over-budget');
                data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
                data.route = __WEBPACK_IMPORTED_MODULE_3__model_constant__["A" /* Page */].REDIRECT;
                break;
            case '4082':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-budgetlimit.png';
                data.title = this.appConfigService.getTranslate('condition-limit-room-title');
                data.title = this.replaceValueInString(data.title, [1]);
                data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
                data.route = __WEBPACK_IMPORTED_MODULE_3__model_constant__["A" /* Page */].HOME;
                break;
            case '4083':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-worstcase.png';
                data.title = this.appConfigService.getTranslate('condition-no-available-room-title');
                data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
                data.route = __WEBPACK_IMPORTED_MODULE_3__model_constant__["A" /* Page */].REDIRECT;
                break;
            case '4701':
                if (condition.message === 'Share budget code not found') {
                    data.code = condition.code;
                    data.imgPath = 'assets/images/icons/icon-failed.png';
                    data.title = this.appConfigService.getTranslate('checkout-3-error-cannot-create-booking');
                    data.btn.push(this.appConfigService.getTranslate('btn-ok'));
                    data.route = __WEBPACK_IMPORTED_MODULE_3__model_constant__["A" /* Page */].LEVEL_D;
                    this.authorizeService.removeCoBookerCookie();
                }
                else {
                    data.code = condition.code;
                    data.imgPath = 'assets/images/icons/icon-failed.png';
                    data.title = this.appConfigService.getTranslate('checkout-3-error-credit-term-not-allow');
                    data.btn.push(this.appConfigService.getTranslate('btn-ok'));
                    data.route = null;
                }
                break;
            case '4711':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-calendar.png';
                data.title = this.appConfigService.getTranslate('condition-period-overlaps-title');
                data.description = this.appConfigService.getTranslate(!this.authorizeService.getCoBookerCookie() ? 'condition-period-overlaps-description' : 'condition-period-overlaps-share-budget-description');
                data.btn.push(this.appConfigService.getTranslate('btn-ok'));
                data.route = __WEBPACK_IMPORTED_MODULE_3__model_constant__["A" /* Page */].LEVEL_D;
                break;
            case '4717':
            case '4731':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-failed.png';
                data.title = this.appConfigService.getTranslate('checkout-3-error-supervisor-email-invalid');
                data.btn.push(this.appConfigService.getTranslate('btn-ok'));
                data.route = null;
                break;
            case '4084':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-calendar.png';
                data.title = this.appConfigService.getTranslate('productlists-pop-up-error-across-month');
                data.btn.push(this.appConfigService.getTranslate('btn-ok'));
                data.route = __WEBPACK_IMPORTED_MODULE_3__model_constant__["A" /* Page */].HOME;
                break;
            case '4091':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-failed.png';
                data.title = this.appConfigService.getTranslate('condition-restrict-destination-title');
                data.description = this.appConfigService.getTranslate('condition-restrict-destination-description');
                data.btn.push(this.appConfigService.getTranslate('btn-ok'));
                data.route = __WEBPACK_IMPORTED_MODULE_3__model_constant__["A" /* Page */].LEVEL_D;
                break;
            case '4092':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-failed.png';
                data.title = this.appConfigService.getTranslate('condition-restrict-destination-co-booker-title');
                data.description = this.appConfigService.getTranslate('condition-restrict-destination-co-booker-description');
                data.btn.push(this.appConfigService.getTranslate('btn-ok'));
                data.route = __WEBPACK_IMPORTED_MODULE_3__model_constant__["A" /* Page */].LEVEL_D;
                break;
            case '4813':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-failed.png';
                data.title = this.appConfigService.getTranslate('condition-some-guest-not-exist-in-your-comany');
                data.description = condition.message.match(/\[(.+)\]/)[1];
                data.btn.push(this.appConfigService.getTranslate('btn-ok'));
                data.route = null;
                break;
            case '4814':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-failed.png';
                data.title = this.appConfigService.getTranslate('condition-some-guest-not-allow-to-use-credit-terms');
                data.description = condition.message.match(/\[(.+)\]/)[1];
                data.btn.push(this.appConfigService.getTranslate('btn-ok'));
                data.route = null;
                break;
            case '4815':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-failed.png';
                data.title = this.appConfigService.getTranslate('condition-some-guest-already-have-a-booking-in-this-period');
                data.description = condition.message.match(/\[(.+)\]/)[1];
                data.btn.push(this.appConfigService.getTranslate('btn-ok'));
                data.route = null;
                break;
            case '4816':
                data.code = condition.code;
                data.imgPath = 'assets/images/icons/icon-failed.png';
                data.title = this.appConfigService.getTranslate('condition-some-guest-has-no-supervisor-email');
                data.description = condition.message.match(/\[(.+)\]/)[1];
                data.btn.push(this.appConfigService.getTranslate('btn-ok'));
                data.route = null;
                break;
            default:
                return null;
        }
        return data;
    };
    CheckoutService.prototype.setCurrencyFormat = function (amount) {
        return this.utilitiesService.insertCurrencySymbol(Number(amount));
    };
    CheckoutService.prototype.formatDisplayTitle = function (title) {
        return title ? title.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); }) : "";
    };
    CheckoutService.prototype.saveBudgetSuggestion = function (suggestionBudget) {
        var user = this.userService.getUser();
        var requestOption = this.authenticationService.getRequestOptions(__WEBPACK_IMPORTED_MODULE_5__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN);
        var payload = {
            companyId: user.companyId,
            suggestionBudget: +suggestionBudget
        };
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.setBudgetSuggestion, payload, requestOption)
            .map(function () { return true; });
    };
    CheckoutService.prototype.getMainBookerEmail = function () {
        return this.mainBookerEmail$.asObservable();
    };
    CheckoutService.prototype.updateMainBookerEmail = function (data) {
        this.mainBookerEmail$.next(data);
    };
    CheckoutService.prototype.getCheckoutConfigBooker = function () {
        var user = this.userService.getUser();
        var featureForcheckout3 = [
            __WEBPACK_IMPORTED_MODULE_3__model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS,
            __WEBPACK_IMPORTED_MODULE_3__model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT,
            __WEBPACK_IMPORTED_MODULE_3__model_constant__["b" /* FeatureType */].ALLOW_LIMIT_ROOM,
            __WEBPACK_IMPORTED_MODULE_3__model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET,
            __WEBPACK_IMPORTED_MODULE_3__model_constant__["b" /* FeatureType */].ALLOW_CORPORATE_FLEET,
            __WEBPACK_IMPORTED_MODULE_3__model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT_CORPORATE_FLEET,
            __WEBPACK_IMPORTED_MODULE_3__model_constant__["b" /* FeatureType */].ALLOW_BOOK_FOR_TRAVELLER,
            __WEBPACK_IMPORTED_MODULE_0__model_constant__["c" /* CompanyFeatureConfigType */].CONFIG_CHECKOUT_3,
            __WEBPACK_IMPORTED_MODULE_3__model_constant__["b" /* FeatureType */].ENABLE_PIN,
            __WEBPACK_IMPORTED_MODULE_3__model_constant__["b" /* FeatureType */].ENABLE_PRE_APPROVAL,
        ];
        return this.authService.getUserFeature(null, user, featureForcheckout3);
    };
    CheckoutService.prototype.getCheckoutConfigCoBooker = function (shareBudgetCode) {
        var user = this.userService.getUser();
        var featureForcheckout3 = [
            __WEBPACK_IMPORTED_MODULE_3__model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS,
            __WEBPACK_IMPORTED_MODULE_3__model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT,
            __WEBPACK_IMPORTED_MODULE_3__model_constant__["b" /* FeatureType */].ALLOW_LIMIT_ROOM,
            __WEBPACK_IMPORTED_MODULE_3__model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET,
            __WEBPACK_IMPORTED_MODULE_0__model_constant__["c" /* CompanyFeatureConfigType */].CONFIG_CHECKOUT_3
        ];
        return this.authService.getUserFeature(null, user, featureForcheckout3, false, shareBudgetCode);
    };
    CheckoutService.prototype.validateTravellerBudget = function (request) {
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.travellerBudget, request, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_5__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN)).map(function (res) { return res.json().data; });
    };
    CheckoutService.prototype.updateCurrentStep = function (step) {
        this.currentStep = step;
    };
    CheckoutService.prototype.getCurrentStep = function () {
        return this.currentStep;
    };
    CheckoutService.prototype.transformOccupancyInfo = function (adult, child, childAges) {
        var _this = this;
        var adultDisplay = this.translatePlural.transform("checkout-1-adult-title", adult).replace(/{X}/gi, adult);
        var childDisplay = '';
        var childAgesDisplay = '';
        if (child != 0) {
            childDisplay = this.translatePlural.transform("checkout-1-child-title", child).replace(/{X}/gi, child);
            if (childAges.length > 0) {
                childAgesDisplay = childAgesDisplay.concat(this.translate.transform("checkout-1-ages") + ": ", '');
                childAges.forEach(function (age, index) {
                    if (index > 0) {
                        childAgesDisplay = childAgesDisplay.concat(index === childAges.length - 1 ? " " + _this.translate.transform("checkout-1-and") + " " : ", ");
                    }
                    childAgesDisplay = childAgesDisplay.concat("" + age);
                });
                childAgesDisplay = childAgesDisplay.concat(this.translate.transform("checkout-1-year"));
            }
        }
        return { adult: adultDisplay, child: childDisplay, childAges: childAgesDisplay };
    };
    CheckoutService.prototype.updatePromotionCode = function (promoCode) {
        this.promoCode.next(promoCode);
    };
    CheckoutService.prototype.updateValidatedPromotionCode = function (validatedPromoCode) {
        if (validatedPromoCode && !validatedPromoCode.valid) {
            var reason = validatedPromoCode.reason.toLowerCase();
            switch (reason) {
                case __WEBPACK_IMPORTED_MODULE_19__promotion_code_enum_promotion_code_enum__["a" /* InvalidPromotionCodeReason */].INVALID_PAYMENT_METHOD:
                case __WEBPACK_IMPORTED_MODULE_19__promotion_code_enum_promotion_code_enum__["a" /* InvalidPromotionCodeReason */].PAYMENT_ISSUER_NOT_ALLOWED:
                    validatedPromoCode.reason = __WEBPACK_IMPORTED_MODULE_19__promotion_code_enum_promotion_code_enum__["a" /* InvalidPromotionCodeReason */].INVALID_PAYMENT_METHOD;
                    break;
                case __WEBPACK_IMPORTED_MODULE_19__promotion_code_enum_promotion_code_enum__["a" /* InvalidPromotionCodeReason */].QUOTA_EXHAUSTED:
                case __WEBPACK_IMPORTED_MODULE_19__promotion_code_enum_promotion_code_enum__["a" /* InvalidPromotionCodeReason */].BUDGET_NOT_ENOUGH:
                case __WEBPACK_IMPORTED_MODULE_19__promotion_code_enum_promotion_code_enum__["a" /* InvalidPromotionCodeReason */].USAGE_LIMIT_EXCEEDED:
                    validatedPromoCode.reason = 'reached_limit';
                    break;
                default:
                    validatedPromoCode.reason = __WEBPACK_IMPORTED_MODULE_19__promotion_code_enum_promotion_code_enum__["a" /* InvalidPromotionCodeReason */].CONDITION_NOT_MET;
            }
        }
        this.validatedPromoCode.next(validatedPromoCode);
    };
    CheckoutService.prototype.updateIsLockedPromotionCode = function (isLocked) {
        this.isLockedPromoCode.next(isLocked);
    };
    CheckoutService.prototype.getCurrentPromotionCode = function () {
        return {
            codeInfo: this.promoCode.value,
            validateInfo: this.validatedPromoCode.value
        };
    };
    CheckoutService.prototype.updateGrandTotalPrice = function (grandTotalPrice) {
        this.grandTotalPrice.next(grandTotalPrice);
    };
    return CheckoutService;
}());
CheckoutService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_5__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_12_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_12_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_11__pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_11__pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_16_app_pipes_translate_singular_plural_pipe__["a" /* TranslateSingularPluralPipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_16_app_pipes_translate_singular_plural_pipe__["a" /* TranslateSingularPluralPipe */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_10_app_services_products_product_service__["a" /* ProductService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_10_app_services_products_product_service__["a" /* ProductService */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_2__authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_1__user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__user_user_service__["a" /* UserService */]) === "function" && _h || Object, typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_18__authorize_authorize_service__["a" /* AuthorizeService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_18__authorize_authorize_service__["a" /* AuthorizeService */]) === "function" && _j || Object, typeof (_k = typeof __WEBPACK_IMPORTED_MODULE_2__authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _k || Object])
], CheckoutService);

var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
//# sourceMappingURL=checkout.service.js.map

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_alert_dialog_alert_component__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_Subject__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vendors_moment_locale_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_cart_model__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__authorize_authorize_service__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__products_product_service__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__search_search_service__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_model_constant__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



















var CartService = (function () {
    function CartService(actHttp, appConfigService, productService, userService, translate, authorizeService, dialog, router) {
        this.actHttp = actHttp;
        this.appConfigService = appConfigService;
        this.productService = productService;
        this.userService = userService;
        this.translate = translate;
        this.authorizeService = authorizeService;
        this.dialog = dialog;
        this.router = router;
        this.cartProduct$ = new __WEBPACK_IMPORTED_MODULE_9_rxjs_Subject__["Subject"]();
        this.cartMultiPaymentDetail$ = new __WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject__["BehaviorSubject"](null);
        this.cartMessagel$ = new __WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject__["BehaviorSubject"](null);
        this.cartLoading$ = new __WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject__["BehaviorSubject"](null);
        this.cartBudgetAvailable$ = new __WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject__["BehaviorSubject"](null);
        this.cartCancelShareBudget$ = new __WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject__["BehaviorSubject"](null);
        this.cartMultiPaymentMainChannel$ = new __WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject__["BehaviorSubject"](null);
        this.currentCartMultiPaymentDetail = this.cartMultiPaymentDetail$.asObservable();
    }
    CartService.prototype.addCartV4 = function (data) {
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.addToCartV4, data, this.actHttp.getRequestOptions()).map(function (res) { return res.json(); });
    };
    CartService.prototype.getCartV4CheckOut = function (cartProductId) {
        var url = ("" + __WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.getCartV4Checkout).replace('{cartId}', cartProductId.toString());
        return this.actHttp.get(url, this.actHttp.getRequestOptions()).map(function (res) { return res.json(); });
    };
    CartService.prototype.updateTempCart = function (cartData) {
        this.cartProduct$.next(cartData);
    };
    CartService.prototype.getTempCart$ = function () {
        return this.cartProduct$.asObservable();
    };
    CartService.prototype.calculatePayOnDate = function (roomConditions) {
        if (roomConditions && roomConditions.length === 0) {
            return '';
        }
        var formatDate = this.appConfigService.dateAPIFormat;
        var isPaynow = roomConditions.filter(function (item) { return !item.payOn || item.payOn === ''; }).length;
        return isPaynow ? __WEBPACK_IMPORTED_MODULE_10_vendors_moment_locale_th__().format(formatDate)
            : roomConditions.sort(this.sortPayLaterDate.bind(this))[0].payOn;
    };
    CartService.prototype.calculateTotalPrice = function (conditions, night) {
        if (night === void 0) { night = 1; }
        conditions.forEach(function (item) {
            item.totalPrice = '' + (item.netPrice ? +item.netPrice : 0) * night;
        });
    };
    CartService.prototype.calculateGrandTotalPrice = function (conditions, validatePromoCode) {
        var totalPrice = 0.00;
        totalPrice = conditions.reduce(function (acc, cur) { return acc + ((cur.totalPrice ? +cur.totalPrice : 0) * (cur.quantity ? +cur.quantity : 0)); }, totalPrice);
        if (validatePromoCode && validatePromoCode.valid) {
            totalPrice = validatePromoCode.finalAmount;
        }
        return totalPrice;
    };
    CartService.prototype.calculateTotalRoomSelected = function (conditions) {
        var totalRoom = 0;
        totalRoom = conditions.reduce(function (acc, cur) { return acc + (cur.quantity ? +cur.quantity : 0); }, 0);
        return totalRoom;
    };
    CartService.prototype.calculateBookNight = function (checkInDate, checkOutDate) {
        if (checkInDate === undefined || checkOutDate === undefined) {
            return 1;
        }
        var dateForm = __WEBPACK_IMPORTED_MODULE_10_vendors_moment_locale_th__(checkInDate, this.appConfigService.dateHumanFormat);
        var dateTo = __WEBPACK_IMPORTED_MODULE_10_vendors_moment_locale_th__(checkOutDate, this.appConfigService.dateHumanFormat);
        // console.log(`dateFrom: ${dateForm} , dateTo: ${dateTo}`);
        return dateTo.diff(dateForm, 'days');
    };
    /**
     * Check room limit on cart
     * @param {RoomConditionDto[]} conditions
     * @param {number} [roomLimit=1]
     * @returns boolean
     * @desc Return true = avaiable to book, false = not allow
     * @memberof CartService
     */
    CartService.prototype.checkBookingRoomLimit = function (conditions, roomLimit) {
        if (roomLimit === void 0) { roomLimit = 1; }
        var totalRoom = this.calculateTotalRoomSelected(conditions);
        return totalRoom > 0 && totalRoom <= roomLimit;
    };
    CartService.prototype.sortPayLaterDate = function (first, second) {
        var formatDate = this.appConfigService.dateAPIFormat;
        var firstDate = __WEBPACK_IMPORTED_MODULE_10_vendors_moment_locale_th__(first.payOn, formatDate);
        var secondDate = __WEBPACK_IMPORTED_MODULE_10_vendors_moment_locale_th__(second.payOn, formatDate);
        var diffDate = firstDate.diff(secondDate, 'days');
        if (diffDate < 0) {
            return -1;
        }
        if (diffDate > 0) {
            return 1;
        }
        return 0;
    };
    CartService.prototype.verifyAddToCart = function (cart, searchData, showNotifyDialog) {
        if (!cart || cart.conditions.length === 0) {
            showNotifyDialog('cart-select-room');
            return false;
        }
        var roomLimit = 9;
        if (searchData.purpose === __WEBPACK_IMPORTED_MODULE_17__search_search_service__["a" /* PurposeType */][__WEBPACK_IMPORTED_MODULE_17__search_search_service__["a" /* PurposeType */].work]) {
            var limitRoomFeatures = this.userService.getUser().features
                .find(function (feature) { return (feature.feature === __WEBPACK_IMPORTED_MODULE_13__model_constant__["b" /* FeatureType */].ALLOW_LIMIT_ROOM.toUpperCase()
                && feature.allow); });
            if (limitRoomFeatures) {
                roomLimit = limitRoomFeatures.data ? limitRoomFeatures.data : 1;
            }
        }
        var isOverBookingRoomLimit = !this.checkBookingRoomLimit(cart.conditions, roomLimit);
        if (isOverBookingRoomLimit) {
            var msg = this.appConfigService.getTranslate('condition-limit-room-title').replace('${var}', '' + roomLimit);
            showNotifyDialog(undefined, undefined, msg);
            return false;
        }
        return true;
    };
    CartService.prototype.convertPrice = function (cart) {
        var night = this.calculateBookNight(cart.search.checkInDate, cart.search.checkOutDate);
        return cart.conditions.map(function (roomCondition, roomIndex) {
            if (cart.optionDetail && cart.optionDetail.optionList && cart.optionDetail.optionList.length > 0) {
                cart.optionDetail.optionList.map(function (option, optionIndex) {
                    return option.conditionList.map(function (condition) {
                        if (roomIndex === optionIndex) {
                            roomCondition.netPrice = (condition.totalPriceSellingFinalSupplierCurrency.valueOf() / night).toString();
                        }
                    });
                });
            }
            return roomCondition;
        });
    };
    CartService.prototype.getUserBudgetInfo = function (searchData) {
        return this.userService.checkBudgetLimit(searchData);
    };
    CartService.prototype.updateCartMultiPaymentDetail = function (detail) {
        if (JSON.stringify(this.cartMultiPaymentDetail$.value) !== JSON.stringify(detail)) {
            this.cartMultiPaymentDetail$.next(detail);
        }
    };
    CartService.prototype.getCartMultiPaymentDetail = function () {
        return this.cartMultiPaymentDetail$.asObservable();
    };
    CartService.prototype.calculateTotalAdult = function (conditions) {
        var totalAdult = 0;
        totalAdult = conditions.reduce(function (acc, cur) { return acc + ((cur.adult ? +cur.adult : 0) * (cur.quantity ? +cur.quantity : 0)); }, totalAdult);
        return totalAdult;
    };
    CartService.prototype.calculateTotalChild = function (conditions) {
        var totalChild = 0;
        totalChild = conditions.reduce(function (acc, cur) { return acc + ((cur.child ? +cur.child : 0) * (cur.quantity ? +cur.quantity : 0)); }, totalChild);
        return totalChild;
    };
    CartService.prototype.getBudgetAvailable = function (request) {
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_11__environments_environment__["a" /* environment */].endpoint.budgetAvailable, request, this.actHttp.getRequestOptions()).map(function (res) { return res.json(); });
    };
    CartService.prototype.updateCartMessage = function (message) {
        this.cartMessagel$.next(message);
    };
    CartService.prototype.getCartMessage = function () {
        return this.cartMessagel$.asObservable();
    };
    CartService.prototype.updateCartLoading = function (loading) {
        this.cartLoading$.next(loading);
    };
    CartService.prototype.getCartLoading = function () {
        return this.cartLoading$.asObservable();
    };
    CartService.prototype.getMultiPaymentMainChannel = function () {
        return this.cartMultiPaymentMainChannel$.asObservable();
    };
    CartService.prototype.updateMultiPaymentMainChannel = function (data) {
        this.cartMultiPaymentMainChannel$.next(data);
    };
    CartService.prototype.getCartBudgetAvailable = function () {
        return this.cartBudgetAvailable$.asObservable();
    };
    CartService.prototype.updateCartBudgetAvailable = function (data) {
        this.cartBudgetAvailable$.next(data);
    };
    CartService.prototype.messageBudgetAvailable = function (request, budgetPerNight, night) {
        var _this = this;
        this.updateMultiPaymentMainChannel('');
        var allowMultiPayment = this.productService.allowMultiPayment(this.userService.getUser());
        var allowMultiPaymentCreditTerms = this.productService.allowMultiPayment(this.userService.getUser(), true);
        var allowMultiPaymentCorporateFleet = this.productService.allowMultiPayment(this.userService.getUser(), false, true);
        var totalBudget = budgetPerNight * night;
        this.updateCartLoading({ loading: true, error: false });
        this.getBudgetAvailable(request).subscribe(function (res) {
            if (res && res.data) {
                var data = res.data;
                _this.updateCartBudgetAvailable(data);
                var multipaymentCreditterms = allowMultiPaymentCreditTerms && data.totalAvailableBudget > 0 && request.totalSellingPrice > data.totalAvailableBudget;
                var multiPaymentCorporateFleet = allowMultiPaymentCorporateFleet && totalBudget && totalBudget > 0 && request.totalSellingPrice > totalBudget;
                if (request.shareBudgetCode) {
                    var half = _this.calculateHalfBudget(data.totalAvailableBudget, data.totalAvailableBudgetBooker, data.totalAvailableBudgetCoBooker);
                    var detail = new __WEBPACK_IMPORTED_MODULE_12__model_cart_model__["b" /* CartMultipaymentDetail */](data.totalOverBudget, half.booker, half.coBooker);
                    detail.availableBudget = new __WEBPACK_IMPORTED_MODULE_12__model_cart_model__["c" /* AvailableBudget */](data.totalAvailableBudgetBooker, data.totalAvailableBudgetCoBooker, data.totalAvailableBudget);
                    detail.isLimitBudgetPerMonthPerYearBooker = data.budgetPerMonth.length > 0 || data.budgetPerYear.length > 0;
                    detail.isLimitBudgetPerMonthPerYearCoBooker = data.budgetPerMonthCoBooker.length > 0 || data.budgetPerYearCoBooker.length > 0;
                    _this.updateCartMultiPaymentDetail(detail);
                }
                else if (multipaymentCreditterms) {
                    var cartMultipaymentDetail = new __WEBPACK_IMPORTED_MODULE_12__model_cart_model__["b" /* CartMultipaymentDetail */](data.totalOverBudget, data.totalAvailableBudget);
                    _this.updateCartMultiPaymentDetail(cartMultipaymentDetail);
                }
                else if (multiPaymentCorporateFleet) {
                    var cartMultipaymentDetail = new __WEBPACK_IMPORTED_MODULE_12__model_cart_model__["b" /* CartMultipaymentDetail */](request.totalSellingPrice - totalBudget, totalBudget);
                    _this.updateCartMultiPaymentDetail(cartMultipaymentDetail);
                    _this.updateMultiPaymentMainChannel('corporate-fleet');
                }
                else {
                    _this.updateCartMultiPaymentDetail(null);
                }
            }
            if (res.errors && res.errors.length > 0 && res.errors[0].code) {
                switch (res.errors[0].code) {
                    case '2004':
                        if (request.shareBudgetCode) {
                            var text = res.errors[0].message;
                            _this.updateCartMessage({ text: text.charAt(0).toUpperCase() + text.slice(1), code: res.errors[0].code, event: 'cannot' });
                        }
                        else {
                            var text = _this.translate.transform('cart-budget-no-remaning');
                            var subtext = _this.appConfigService.getLanguage() === 'th' ? 'เนื่องจาก' + res.errors[0].message : res.errors[0].message + '.';
                            if (!_this.userService.hideMessageCart(_this.userService.getUser())) {
                                _this.updateCartMessage({ text: text.charAt(0).toUpperCase() + text.slice(1), subText: subtext, code: res.errors[0].code });
                            }
                        }
                        break;
                    case '2005':
                        if (request.shareBudgetCode) {
                            var text = res.errors[0].message;
                            _this.updateCartMessage({ text: text.charAt(0).toUpperCase() + text.slice(1), code: res.errors[0].code, event: 'cannot', continueType: res.data.totalOverBudget === 0 ? 'myBudget' : 'multipayment' });
                        }
                        else {
                            if (allowMultiPaymentCreditTerms) {
                                var text = res.errors[0].message;
                                _this.updateCartMessage({ text: text.charAt(0).toUpperCase() + text.slice(1), subText: _this.translate.transform('cart-budget-detail-below'), code: res.errors[0].code });
                            }
                            else {
                                var text = _this.translate.transform('cart-budget-no-remaning');
                                var subtext = _this.appConfigService.getLanguage() === 'th' ? 'เนื่องจาก' + res.errors[0].message : res.errors[0].message + '.';
                                if (!_this.userService.hideMessageCart(_this.userService.getUser())) {
                                    _this.updateCartMessage({ text: text.charAt(0).toUpperCase() + text.slice(1), subText: subtext, code: res.errors[0].code });
                                }
                            }
                        }
                        break;
                    case '2006':
                        if (request.shareBudgetCode) {
                            if (allowMultiPayment) {
                                var text = res.errors[0].message;
                                _this.updateCartMessage({ text: text.charAt(0).toUpperCase() + text.slice(1), subText: _this.translate.transform('cart-share-budget-detail-below'), code: res.errors[0].code });
                            }
                            else {
                                var text = res.errors[0].message;
                                _this.updateCartMessage({ text: text.charAt(0).toUpperCase() + text.slice(1), code: res.errors[0].code, event: 'cannot' });
                            }
                        }
                        break;
                }
            }
            _this.updateCartLoading({ loading: false, error: false });
        }, function (err) {
            if (err && err.json() && err.json().errors && err.json().errors.length > 0) {
                var errors_1 = err.json().errors;
                var alertText = void 0;
                var systemError = void 0;
                switch (errors_1[0].code) {
                    case '4701':
                        alertText = "<strong>" + _this.translate.transform('dialog-budget-cannot-share-budget-co-booker') + "</strong><br>" + _this.translate.transform('search-box-error-code-ref-incorrect');
                        break;
                    case '4702':
                        alertText = "<strong>" + _this.translate.transform('dialog-budget-cannot-share-budget-co-booker') + "</strong><br>" + _this.translate.transform('search-box-error-code-ref-expired');
                        break;
                    case '4704':
                    case '4705':
                        alertText = "<strong>" + _this.translate.transform('dialog-budget-cannot-share-budget-co-booker') + "</strong><br>" + _this.translate.transform('search-box-error-feature-not-allow');
                        break;
                    default:
                        systemError = true;
                }
                if (!systemError) {
                    var dialogRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */]);
                    dialogRef.componentInstance.alertText = alertText;
                    dialogRef.componentInstance.imageSrc = '/assets/images/icons/icon-failed.png';
                    dialogRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-failed.png';
                    dialogRef.componentInstance.confirmText = _this.translate.transform('search-box-cancel-share-budget');
                    return dialogRef.afterClosed().subscribe(function (m) {
                        _this.authorizeService.removeCoBookerCookie();
                        if (errors_1[0].code === '4704') {
                            _this.authorizeService.setCookieFeatureShareBudgetIsFalse();
                        }
                        // Reload current router
                        _this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
                        _this.router.navigated = false;
                        _this.router.navigateByUrl(_this.router.url);
                        return __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__["Observable"].of(false);
                    });
                }
                _this.updateCartLoading({ loading: false, error: true });
            }
        });
    };
    CartService.prototype.calculateHalfBudget = function (availableBudget, bookerBudget, coBookerBudget) {
        var result = { booker: 0, coBooker: 0 };
        var halfRoundUp = Math.ceil(availableBudget / 2);
        if (coBookerBudget < bookerBudget) {
            var val = this.compareBudget(halfRoundUp, coBookerBudget);
            result.coBooker = val.value;
            result.booker = availableBudget - halfRoundUp + val.carry;
            if (Math.abs(result.coBooker - result.booker) === 1) {
                result.coBooker = result.coBooker - 1;
                result.booker = result.booker + 1;
            }
        }
        else {
            var val = this.compareBudget(halfRoundUp, bookerBudget);
            result.booker = val.value;
            result.coBooker = availableBudget - halfRoundUp + val.carry;
        }
        return result;
    };
    CartService.prototype.compareBudget = function (halfRoundUp, budget) {
        var value;
        var carry;
        if (halfRoundUp > budget) {
            value = budget;
            carry = halfRoundUp - budget;
        }
        else {
            value = halfRoundUp;
            carry = 0;
        }
        return { value: value, carry: carry };
    };
    CartService.prototype.updateCartCancelShareBudget = function () {
        this.cartCancelShareBudget$.next(true);
    };
    CartService.prototype.getCartCancelShareBudget = function () {
        return this.cartCancelShareBudget$.asObservable();
    };
    CartService.prototype.verifyShouldCheckBudgetAvailable = function (purpose) {
        var isAllowCreditTerms = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13__model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS).allow;
        var isAllowBookForTraveller = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13__model_constant__["b" /* FeatureType */].ALLOW_BOOK_FOR_TRAVELLER) && this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13__model_constant__["b" /* FeatureType */].ALLOW_BOOK_FOR_TRAVELLER).allow;
        return isAllowCreditTerms && !isAllowBookForTraveller
            && purpose === __WEBPACK_IMPORTED_MODULE_18_app_model_constant__["o" /* PurposeType */].work
            && (this.isBudgetAvailable() || this.authorizeService.getShareBudgetCodeCookie());
    };
    CartService.prototype.isBudgetAvailable = function () {
        var limitBudget = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13__model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET);
        return limitBudget && limitBudget.data && (limitBudget.data.amountPerMonth || limitBudget.data.amountPerYear);
    };
    return CartService;
}());
CartService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_14__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_14__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_16__products_product_service__["a" /* ProductService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_16__products_product_service__["a" /* ProductService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__["a" /* UserService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_4_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_15__authorize_authorize_service__["a" /* AuthorizeService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_15__authorize_authorize_service__["a" /* AuthorizeService */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* Router */]) === "function" && _h || Object])
], CartService);

var _a, _b, _c, _d, _e, _f, _g, _h;
//# sourceMappingURL=cart.service.js.map

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogErrorComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var DialogErrorComponent = (function () {
    function DialogErrorComponent() {
    }
    DialogErrorComponent.prototype.ngOnInit = function () {
    };
    return DialogErrorComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('text'),
    __metadata("design:type", String)
], DialogErrorComponent.prototype, "text", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('text'),
    __metadata("design:type", String)
], DialogErrorComponent.prototype, "subText", void 0);
DialogErrorComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'ota-dialog-error',
        template: __webpack_require__(1051),
        styles: [__webpack_require__(916)]
    }),
    __metadata("design:paramtypes", [])
], DialogErrorComponent);

//# sourceMappingURL=dialog-error.component.js.map

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SearchFormModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GuestModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DestinationModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PoiLocation; });

var SearchFormModel = (function () {
    function SearchFormModel(cart, lang, breakfast, securityStandard, sanitizedStay, freeCancellation, overBudget) {
        if (cart === void 0) { cart = undefined; }
        if (lang === void 0) { lang = 'en'; }
        if (breakfast === void 0) { breakfast = false; }
        if (securityStandard === void 0) { securityStandard = false; }
        if (sanitizedStay === void 0) { sanitizedStay = false; }
        if (freeCancellation === void 0) { freeCancellation = false; }
        if (overBudget === void 0) { overBudget = false; }
        if (cart && cart.productDetail) {
            this.destination = new DestinationModel();
            this.destination.title = lang === 'th' ? cart.productDetail.destinationTitles.th.toString() : cart.productDetail.destinationTitles.en.toString();
            this.destination.id = cart.productDetail.destinationId.toString();
            this.checkInDate = __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__["unix"](cart.optionDetail.dateCheckIn.valueOf() / 1000).utc().format('DD-MM-YYYY');
            this.checkOutDate = __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__["unix"](cart.optionDetail.dateCheckOut.valueOf() / 1000).utc().format('DD-MM-YYYY');
            this.purpose = cart.purpose.toString();
            this.breakfast = breakfast;
            this.securityStandard = securityStandard;
            this.sanitizedStay = sanitizedStay;
            this.freeCancellation = freeCancellation;
            this.overBudget = overBudget;
        }
    }
    return SearchFormModel;
}());

var GuestModel = (function () {
    function GuestModel(adult, children) {
        this.adult = adult;
        this.children = children;
    }
    return GuestModel;
}());

var DestinationModel = (function () {
    function DestinationModel() {
    }
    return DestinationModel;
}());

var PoiLocation = (function () {
    function PoiLocation(lat, lon) {
        this.lat = lat;
        this.lon = lon;
    }
    return PoiLocation;
}());

//# sourceMappingURL=search-form-model.js.map

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payload_search_suggestion_payload__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_model_search_form_model__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_model_constant__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PurposeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SearchService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var PurposeType;
(function (PurposeType) {
    PurposeType[PurposeType["work"] = 0] = "work";
    PurposeType[PurposeType["leisure"] = 1] = "leisure";
})(PurposeType || (PurposeType = {}));
var SearchService = (function () {
    function SearchService(actHttp, appConfigService, utilitiesService) {
        this.actHttp = actHttp;
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.defaultCheckInDateFromNow = 0;
        this.defaultCheckOutDateFromNow = 1;
        this.defaultDiffDate = 1;
        this.defaultGuest = [{ "adult": 2, "children": [] }];
        this.formatDate = this.appConfigService.getDateUrlFormat();
    }
    SearchService.prototype.getSearchSuggestion = function (req) {
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_6__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, __WEBPACK_IMPORTED_MODULE_6__act_http_act_http_service__["b" /* ContentTypes */].JSON);
        var payload = new __WEBPACK_IMPORTED_MODULE_2__payload_search_suggestion_payload__["a" /* SearchSuggestionPayload */]();
        payload.str = req.str;
        payload.lang = req.lang;
        payload.lat = req.lat;
        payload.lon = req.lon;
        payload.companyId = req.companyId;
        payload.objective = req.objective;
        return this.actHttp
            .post(__WEBPACK_IMPORTED_MODULE_1__environments_environment__["a" /* environment */].endpoint.getSearchSuggestion, payload, options)
            .map(function (response) {
            var json = response.json();
            return json.d.data;
        });
    };
    SearchService.prototype.getSearchFormModelFromQueryParams = function (queryParms) {
        var destination = queryParms.get("destination"), purpose = queryParms.get("purpose"), guest = queryParms.get("guests"), breakfast = queryParms.get("breakfast"), overBudget = queryParms.get("overBudget"), campaignId = queryParms.get("campaignId"), searchModel = new __WEBPACK_IMPORTED_MODULE_7_app_model_search_form_model__["d" /* SearchFormModel */]();
        if (!(destination && purpose && (purpose === "work" || purpose === "leisure"))) {
            throw new Error("destination and purpose are required");
        }
        else {
            searchModel.purpose = purpose;
            searchModel.destination = JSON.parse(this.utilitiesService.base64Decoder(destination));
            if (!(searchModel.destination.id && searchModel.destination.title) && searchModel.destination.suggestCat != __WEBPACK_IMPORTED_MODULE_8_app_model_constant__["y" /* SuggestionCategory */].NEAR_BY) {
                throw new Error("destination and purpose are required");
            }
        }
        var checkIn = queryParms.get("checkIn");
        if (this.isInvalidDate(checkIn) || this.isPastFrom(checkIn)) {
            searchModel.checkInDate = __WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__().add(this.defaultCheckInDateFromNow, 'day').format(this.formatDate);
            searchModel.checkOutDate = __WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__().add(this.defaultCheckOutDateFromNow, 'day').format(this.formatDate);
        }
        else {
            searchModel.checkInDate = checkIn;
            var checkOut = queryParms.get("checkOut");
            searchModel.checkOutDate = this.isInvalidDate(checkOut) || this.isPastFrom(checkOut, checkIn) || checkIn === checkOut ? __WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__(checkIn, this.formatDate).add(this.defaultDiffDate, 'day').format(this.formatDate) : checkOut;
        }
        if (!guest) {
            searchModel.guests = this.defaultGuest;
        }
        else {
            searchModel.guests = JSON.parse(this.utilitiesService.base64Decoder(guest));
            if (searchModel.guests.length <= 0) {
                searchModel.guests = this.defaultGuest;
            }
            else {
                for (var index in searchModel.guests) {
                    var guestItem = searchModel.guests[index];
                    if (!(guestItem.hasOwnProperty("children") && guestItem.hasOwnProperty("adult") && guestItem.children instanceof Array && !isNaN(guestItem.adult) && guestItem.adult > 0)) {
                        searchModel.guests = this.defaultGuest;
                        break;
                    }
                }
            }
        }
        searchModel.breakfast = breakfast == 'true';
        searchModel.overBudget = overBudget ? overBudget == 'true' : true;
        if (campaignId) {
            searchModel.campaignId = Number(campaignId);
        }
        return searchModel;
    };
    SearchService.prototype.isInvalidDate = function (dateString) {
        return !dateString ||
            __WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__(dateString, this.formatDate).format(this.formatDate) != dateString ||
            !__WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__(dateString, this.formatDate).isValid();
    };
    SearchService.prototype.isPastFrom = function (dateString, checkDate) {
        var fromDate = checkDate ? __WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__(checkDate, this.formatDate) : __WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__(__WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__().format(this.formatDate), this.formatDate);
        return __WEBPACK_IMPORTED_MODULE_4_vendors_moment_locale_th__(dateString, this.formatDate).isBefore(fromDate);
    };
    SearchService.prototype.calculateMaxMinFilterPrice = function (min, max, budgetLimit, overBudget) {
        if (!budgetLimit.isLimitBudget || overBudget) {
            var finalMax = budgetLimit.budget && budgetLimit.budget > max ? budgetLimit.budget : max;
            return { min: min, max: finalMax };
        }
        var budget = budgetLimit.budget;
        switch (true) {
            case budget >= max:
                return { min: min, max: max };
            case budget < max && budget > min:
                return { min: min, max: budget };
            case budget < max && budget <= min:
                return { min: 0, max: 0 };
            default:
                return { min: min, max: max };
        }
    };
    return SearchService;
}());
SearchService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_6__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_5__utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _c || Object])
], SearchService);

var _a, _b, _c;
//# sourceMappingURL=search.service.js.map

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_model_constant__ = __webpack_require__(6);
/* unused harmony export LANG_EN_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LANG_EN_TRANS; });

var LANG_EN_NAME = __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["a" /* Language */].en;
var LANG_EN_TRANS = {
    'hello world': 'hello world',
    'menu-bar-home': 'Home',
    'menu-bar-account': 'My Account',
    'menu-bar-profile': 'Profile',
    'menu-bar-booking': 'Booking',
    'menu-bar-approval': 'Approval',
    'menu-bar-my-budget': 'User permission & budget',
    'menu-bar-fleet-card': 'Fleet card',
    'menu-bar-setting-account': 'Account Security',
    'menu-bar-login': 'Register/Login',
    'menu-bar-logout': 'Log out',
    'menu-bar-baht': 'THB',
    'menu-bar-baht-opposite': 'บาท',
    'menu-bar-baht-accommodation': 'Accommodations',
    'menu-bar-baht-business-events': 'Corporate group / Event',
    'menu-bar-co-working-space': 'Co-working space',
    'menu-bar-flight': 'Flight',
    'menu-bar-car-rental': 'Car Rental',
    'menu-bar-help': 'Help',
    'menu-bar-language': 'Language',
    'menu-bar-language-choice-en': 'English',
    'menu-bar-language-choice-th': 'Thai',
    'menu-bar-currency': 'Currency',
    'menu-bar-switch-company': 'Company',
    'menu-bar-setting': 'Settings',
    'menu-bar-pre-approval-requests': 'Pre-Approval Request',
    'menu-bar-pre-approval-approvals': 'Approval Requests',
    'switch-language-title': 'Language',
    'switch-currency-title': 'Currency',
    'switch-language-currency-title': 'Language and Currency',
    'switch-language-currency-sub-title': 'The system will convert and display the price in the currency you selected. The currency in which you pay may vary depending on your booking. There may also be a service charge.',
    'btn-register': 'Register',
    'btn-joinus': 'Join Us',
    'btn-cancel': 'Cancel',
    'btn-clear': 'Clear',
    'btn-choose': 'Choose',
    'btn-go-to-booking': 'Go to my booking',
    'btn-export': 'Export',
    'btn-clear-selection': 'Clear Selection',
    'btn-clear-selection-mb': 'Cancel',
    'btn-confirm': 'Confirm',
    'btn-close': 'Close',
    'btn-submit': 'Confirm',
    'link-view-map': 'View map',
    'map-marker-room-not-available': 'Unavailable',
    'footer-company-name': 'Ascend Travel Co.,Ltd. (Head Office)',
    'footer-address-01': 'AIA Capital Center Building,',
    'footer-address-02': '18-19 Floor, 89 Ratchadaphisek Road,',
    'footer-address-03': 'Dindaeng, Dindaeng, Bangkok 10400',
    'footer-new-address-01': 'No. 101 True Digital Park, Griffin Building, 12A Floor,',
    'footer-new-address-02': 'Sukhumvit Road, Bangchak Sub-District,',
    'footer-new-address-03': 'Phra Khanong District, Bangkok 10260, Thailand',
    'footer-license': 'TAT License : 11/08384',
    'footer-call-center': 'Call Center',
    'footer-customer-support': 'Customer Support',
    'footer-customer-help': 'Help',
    'footer-customer-terms': 'Terms of Use',
    'footer-customer-terms-02': 'Privacy Policy',
    'footer-customer-cookies': 'Cookies Policy',
    'province-hauhin': 'HAU HIN / CHA AM',
    'province-pattaya': 'PATTAYA',
    'province-chiang-mai': 'CHIANG MAI',
    'province-phuket': 'PHUKET',
    'province-krabi': 'KRABI',
    'province-koh-samui': 'KOH SAMUI',
    'province-bangkok': 'BANGKOK',
    'province-khao-lak': 'KHAO LAK',
    'province-koh-chang': 'KOH CHANG',
    'province-kanchanaburi': 'KANCHANABURI',
    'search-top-destination': 'Top Destinations',
    'search-top-destination-sub': 'Discover new, inspiring places around your favorite destinations.',
    'search-box-title': 'Search and Book Hotels',
    'search-box-title-sub': 'All your business travel & personal trip in one place.',
    'search-box-topic-travel': 'Leisure',
    'search-box-topic-work': 'Work',
    'search-box-tooltip-title': 'What’s the difference ?',
    'search-box-tooltip-travel': 'Search properties for your vocation. Your booking will not link to your company account.',
    'search-box-tooltip-work': 'Easy to search properties for your business trip.',
    'search-box-topic-title': 'Travelling for',
    'search-box-want': 'Where would you like to go?',
    'search-box-want-placeholder': 'Enter your destination or hotel name',
    'search-box-check-in': 'Check-in',
    'search-box-check-in-calendar': 'Check-in Date',
    'search-box-check-out': 'Check-out',
    'search-box-check-out-calendar': 'Check-out Date',
    'search-box-room': 'Room',
    'search-box-guest': 'Guest',
    'search-box-btn-search': 'Search',
    'search-box-destination': 'Destination',
    'search-box-props': 'props',
    'search-box-hotel': 'Properties/Hotels',
    'search-box-result-search': 'Search Result',
    'search-box-recent-searches': 'Recent Searches',
    'search-box-near-by': 'Nearby location',
    'search-box-near-by-you': 'Accommodation nearby',
    'your-location': 'your location',
    'location-not-found': 'Location could not be found',
    'location-message-not-found': 'Please allowing site to know your location before search accommodation nearby',
    'enter': 'OK',
    'search-box-room-in-choose': 'Room',
    'search-box-adult': 'Adult',
    'search-box-guest-count': 'Room & Guest',
    'search-box-child': 'Child',
    'search-box-children': 'Children',
    'search-box-child-age': 'Children\'s ages (years)',
    'search-box-person': 'person',
    'search-box-want-read': 'Your Destination',
    'search-box-check-in-out-read': 'Period of stay',
    'search-box-guest-read': 'Room & Guest',
    'search-box-btn-cancel-change': 'Cancel',
    'search-box-btn-change': 'Change',
    'search-box-point_of_interest': 'Point of Interest',
    'search-box-over-budget-checkbox-label': 'I want to see all properties without budget limit.',
    'search-box-over-budget-hover-info-label': 'You can book and pay for the exceeding amount of your budget.',
    'search-box-over-budget-hover-credit-card-label': 'personal credit/debit card',
    'search-box-error-purpose': 'Please choose your travel objective.',
    'search-box-error-destination': 'Please enter destination or hotel that you interested.',
    'search-box-error-work-1-room': 'Reservation for work can be booked only 1 room and maximum 2 guests at a time.',
    'search-box-error-work-2-person': 'Reservation for work can be booked maximum 2 guests per room.',
    'search-box-error-work-no-child': 'Reservation for work cannot be booked with children.',
    'search-box-error-feature-not-allow': 'due to your company or co-booker company not allow to share budget.',
    'search-box-error-code-ref-expired': 'due to share budget code is expired.',
    'search-box-error-code-ref-incorrect': 'due to share budget code is incorrect.',
    'search-box-budget-per-night': 'Your budget limit is <strong>{currency} {budget}</strong> /room/night.',
    'search-box-budget-per-month': 'You have budget <strong>{currency} {budgetPerMonth}</strong> /month.',
    'search-box-budget-per-year': 'You have budget <strong>{currency} {budgetPerYear}</strong> /year.',
    'search-box-budget-per-month-per-year': 'You have budget <strong>{currency} {budgetPerMonth}</strong> /month and <strong>{currency} {budgetPerYear}</strong> /year.',
    'search-box-budget-unlimited': 'Your budget/room/night is unlimited.',
    'search-box-new-budget-per-night': 'Your new budget limit is <strong>{currency} {budget}</strong> /room/night.',
    'search-box-new-budget-unlimited': 'Your new budget/room/night is unlimited.',
    'search-box-see-all-my-budget': 'View budget details',
    'search-box-share-budget': 'Share budget',
    'search-box-share-budget-tooltips': 'You can book and share budget with your co-booker.',
    'search-box-cancel-share-budget': 'Cancel share budget',
    'budget-unlimited': 'Unlimited',
    'search-box-tooltips-share-budget-detail-title': 'You have shared budget with co-booker',
    'search-box-tooltips-share-budget-detail-booker-budget': 'Your budget',
    'search-box-tooltips-share-budget-detail-co-booker-budget': 'Your co-booker budget',
    'search-box-tooltips-share-budget-detail-total-budget': 'Total budget/room/night',
    'search-box-tooltips-share-budget-detail-apply-co-budget': 'There is a budget limit for booking with 2 guests.',
    'account-menu-bar-profile': 'Profile',
    'account-menu-bar-share-budget-code': 'Share budget code',
    'account-menu-bar-my-budget': 'User permission & budget',
    'account-menu-bar-fleet-card': 'Fleet Card',
    'account-menu-bar-account-security': 'Account Security',
    'account-menu-bar-logout': 'Logout',
    'account-change-password-headline': 'Change Password',
    'account-change-password-title': 'Change Password',
    'account-change-password-new': 'New Password',
    'account-change-password-new-fill': 'Enter your new password here',
    'account-change-password-confirmation': 'Confirm Password',
    'account-change-password-confirmation-fill': 'Enter your new password again',
    'account-change-password-button-submit': 'Save',
    'account-change-password-button-cancel': 'Cancel',
    'account-change-password-validation-text': 'The password must include',
    'account-change-password-validation-length-text': 'Length of 8-16 characters which included alphabetic characters, numeric characters or special character such as @ $ ! % * # ? &',
    'account-change-password-validation-uppercase-text': 'At least one uppercase letter',
    'account-change-password-validation-lowercase-text': 'At least one lowercase letter',
    'account-change-password-validation-numeric-text': 'At least one numeric characters',
    'account-security-title': 'Account Security',
    'account-security-email': 'Email',
    'account-security-email-description': 'This email is used for login and we use this email to send you booking details.',
    'account-security-password': 'Password',
    'account-security-password-description': 'Regularly changing your password helps keep your account protected.',
    'account-security-password-action': 'Change Password',
    'account-security-phone': 'Phone',
    'account-security-phone-action': 'Change Phone',
    'account-security-new-phone-action': 'Binding Phone',
    'account-security-pin': 'PIN Code',
    'account-security-pin-description': 'Use PIN code for credit terms payment processing to your company.',
    'account-security-pin-action': 'Set PIN',
    'booking-my-booking': 'Booking',
    'booking-my-booking-list': 'All',
    'booking-my-booking-from': 'From',
    'booking-my-booking-from2': 'From',
    'booking-my-booking-until': 'Until',
    'booking-my-booking-until2': 'Until',
    'booking-my-booking-before': 'Before',
    'booking-my-booking-id': 'Booking ID',
    'booking-my-booking-booking-date': 'Booking Date / Time',
    'booking-my-booking-payment-date': 'Pay on',
    'booking-my-booking-booker-cancel-date': 'by booker on',
    'booking-my-booking-booker-cancel-booker-date': 'by main booker on',
    'booking-my-booking-booker-cancel-co-booker-date': 'by co-booker on',
    'booking-my-booking-booker-cancel-name-date': 'by {name} on',
    'booking-my-booking-booker-reject-supervisor-date': ' by supervisor (main booker) on',
    'booking-my-booking-booker-reject-co-supervisor-date': 'by supervisor (co-booker) on',
    'booking-my-booking-checkin': 'Check-in',
    'booking-my-booking-checkout': 'Check-out',
    'booking-my-booking-approved-date': 'Approved date',
    'booking-my-booking-rejected-date': 'by supervisor on',
    'booking-my-booking-re-booking': 'Re-Booking',
    'booking-my-booking-sumbit': 'Booking',
    'booking-my-booking-btn-details': 'Booking details',
    'booking-my-booking-cancel': 'Cancel booking',
    'booking-my-booking-map': 'View map',
    'booking-my-booking-review': 'Review your stay',
    'booking-my-booking-review-published': 'Review published',
    'booking-my-booking-previous': 'Previous',
    'booking-my-booking-next': 'Next',
    'booking-my-booking-arranged-by': 'Sort By',
    'booking-my-booking-arranged-by-mobile': 'By',
    'booking-my-booking-all': 'All',
    'booking-my-booking-search-text': 'Booking ID',
    'booking-my-booking-search-not-found': 'Cannot found this Booking ID',
    'booking-my-booking-text-booking-date': 'Booking date/time',
    'booking-my-booking-text-total-room': 'No. of room',
    'booking-my-room': 'room',
    'booking-my-night': 'Night',
    'booking-my-guest': 'Guest',
    'booking-my-booking-text-total-max-guest': 'No. of guest',
    'booking-my-adult': 'adult',
    'booking-my-child': 'child',
    'booking-my-children': 'children',
    'booking-my-status-success-booking': 'Booking successful',
    'booking-my-status-successfully-payment': 'Payment successful',
    'booking-my-status-success-payment': 'Payment successful',
    'booking-my-status-failure-payment': 'Payment failed',
    'booking-my-status-cancelled-booking': 'Booking cancelled',
    'booking-my-status-inprogress': 'On process',
    'booking-my-status-already-checkout': 'Depart',
    'booking-my-status-failure-booking': 'Booking failed',
    'booking-my-status-awaiting-approval': 'Booked and awaiting approval',
    'booking-my-status-booking-approved': 'Booked and approved successful',
    'booking-my-status-booking-rejected': 'Rejected',
    'booking-my-booking-filter-by': 'Filter',
    'booking-my-booking-filter-by-all': 'All',
    'booking-my-booking-filter-by-upcoming': 'Upcoming',
    'booking-my-booking-filter-by-check-in': 'During Stay',
    'booking-my-booking-filter-by-completed': 'Completed',
    'booking-my-booking-filter-by-cancelled': 'Cancelled',
    'booking-my-booking-filter-by-failed': 'Failed',
    'booking-my-booking-sort-by-booking-date': 'Booking date',
    'booking-my-booking-sort-by-checkin-date': 'Check-in date',
    'booking-my-booking-sort-by-payment-date': 'Payment date',
    // Approval List
    'approval-list': 'Approval',
    'approval-list-search-text': 'Search by Booking ID',
    'approval-list-search-not-found': 'Cannot found this Booking ID',
    'approval-list-search-empty': 'No Booking',
    'approval-list-filter-by': 'Filter',
    'approval-list-sort-by': 'Sort by',
    'approval-list-filter-by-all': 'All',
    'approval-list-filter-by-waiting': 'Waiting',
    'approval-list-filter-by-approved': 'Approved',
    'approval-list-filter-by-cancelled': 'Cancelled',
    'approval-list-sort-by-booking-date': 'Booking date',
    'approval-list-sort-by-checkin-date': 'Check-in date',
    'approval-list-requester-name': 'Requester name',
    'approval-list-booking-id': 'Booking ID',
    'approval-list-grand-total': 'Total price',
    'approval-list-button-detail': 'Booking details',
    'approval-list-status-approved': 'Approved',
    'approval-list-status-booker-cancelled': 'Booking cancelled',
    'approval-list-status-last-minute1': 'Cannot approve or reject reservation',
    'approval-list-status-last-minute2': 'because it booked on check-in date.',
    'approval-list-status-no-action': 'Booking Successful without Approval',
    'approval-list-status-rejected': 'Rejected',
    'approval-list-approved-date': 'Approved date',
    'approval-list-rejected-date': 'Rejected date',
    'approval-list-cancel-date': 'Cancelled date',
    'approval-message-approve-success': 'Reservation has been approved and processed successfully.',
    'approval-message-approve-fail': 'Process is not successful. Please try again.',
    'approval-message-reject-success': 'Rejected reservation successfully.',
    'approval-message-reject-fail': 'Process is not successful. Please try again.',
    'approval-button-reject': 'Reject',
    'approval-button-approve': 'Approve',
    'approval-details-btn-back': 'Back to approval',
    'approval-details-contact-number': ' Contact number',
    // Payment Summary
    'payment-summary-cancel-header': 'Booking cancelled',
    'payment-summary-reject-header': 'Booking rejected',
    'payment-summary-exclude-vat': 'Price (Excluding VAT)',
    'payment-summary-vat': 'VAT 7% ',
    'payment-summary-before-discount': 'Total before discount',
    'payment-summary-promotion-code-discount': 'Promotion code discount',
    'payment-summary-book-grand-total': 'Total price',
    'payment-summary-pay-credit-term-main-booker': 'Charge to main booker',
    'payment-summary-pay-credit-term-co-booker': 'Charge to co-booker',
    'payment-summary-pay-credit-term-remark': 'Charge to credit terms',
    'payment-summary-taxes-fees': 'Taxes & Fees',
    'payment-summary-price': 'Price',
    'payment-summary-pay-credit-term': 'Pay by credit terms',
    'payment-summary-pay-credit-card': 'Pay by credit/debit card',
    'payment-summary-pay-credit-card-add': 'Pay by credit/debit card',
    'payment-summary-pay-true-money': 'Pay by TrueMoney Wallet',
    'payment-summary-pay-true-money-add': 'Pay by TrueMoney Wallet',
    'payment-summary-pay-corporate-fleet': 'Pay by corporate fleet card',
    'payment-summary-pay-personal-fleet': 'Pay by personal fleet card',
    'payment-summary-pay-personal-fleet-add': 'Pay by personal fleet card',
    'payment-summary-cancel-exclude-vat': 'Cancellation fee (Excluding VAT)',
    'payment-summary-cancel-pay-credit-term-main-booker': 'Cancellation fee charge to main booker',
    'payment-summary-cancel-pay-credit-term-co-booker': 'Cancellation fee charge to co-booker',
    'payment-summary-cancel-pay-credit-term': 'Charge to credit terms',
    'payment-summary-cancel-pay-credit-card': 'Charge to credit/debit card',
    'payment-summary-cancel-pay-true-money': 'Charge to TrueMoney Wallet',
    'payment-summary-cancel-pay-corporate-fleet': 'Charge to corporate fleet card',
    'payment-summary-cancel-pay-personal-fleet': 'Charge to personal fleet card',
    'payment-summary-cancel-total-price': 'Total price',
    'payment-summary-cancel-total-cancellation-fee': 'Total cancellation fee',
    'payment-summary-cancel-grand-total-cancellation-fee': 'Total cancellation fee',
    'payment-summary-cancel-grand-desc-main-booker': 'Charge to main booker credit terms',
    'payment-summary-cancel-grand-desc-co-booker': 'Charge to co-booker credit terms',
    'payment-summary-cancel-credit-card-refund': 'Credit/debit card refund',
    'payment-summary-cancel-true-money-refund': 'TrueMoney Wallet refund',
    'payment-summary-cancel-corporate-fleet-refund': 'Coporate fleet card refund',
    'payment-summary-cancel-personal-fleet-refund': 'Personal fleet card refund',
    'payment-summary-refund': 'Refund',
    'payment-summary-booker': 'Main booker',
    'payment-summary-co-booker': 'Co-booker',
    // Global form
    'landing-form-password-hint': 'Password must be A-Z or a-z or 0-9 or Special Charactors except single-quote(\'), double-quote("), comma(,) and back-slash(\\) 8-16 digits.',
    // Create account form
    'landing-form-create-account-select': 'Choose your main company',
    'landing-form-create-account-terms-and-conditions': 'Terms of Service and Privacy Note',
    'landing-form-create-account-accept': 'I accept',
    // Verify account form
    'landing-form-verify-account-title': 'Please enter your corporate email',
    'landing-form-verify-account-enroll': 'Not sure that your company already enrolled with Ascend Travel',
    'landing-form-confirm-email-title': 'Please check your mailbox',
    'landing-form-confirm-email-description': 'We have sent email to <br/><span class="color-main">[email]</span><br/>Check your mailbox to complete your registration<br/>within 30 mins after receive a mailbox.<br/>*If you cannot find, please check in your junk mail.</p>',
    'landing-form-confirm-email-footer': 'If you didn\'t receive your verification email. Click',
    'landing-form-confirm-email-success-description': 'We have sent email to<br/><span class="color-main">[email]</span><br/>Check your mailbox to complete your registration.<br/>*If you cannot find, please check in your junk mail.</p>',
    'landing-form-confirm-email-success-footer': 'We have sent an email for verification. If you didn\'t receive your verification email. Click',
    'landing-form-verify-email-failure-description': 'We have sent email to<br/><span class="color-main">[email]</span><br/><p>Check your mailbox to complete your registration.<br/>*If you cannot find, please check in your junk mail.</p><p>If you didn\'t receive your verification email. Click Resend verify email.</p>',
    'landing-verify-email-success': 'You have successfully verified<br/>your registration.',
    // Reset password
    'landing-form-reset-password-title': 'Reset Password',
    'landing-form-reset-password-success-title': 'Your password has been reset',
    'landing-form-reset-password-success-description': 'You can then login to your account using your new password.',
    'landing-form-reset-password-expired-title': 'Reset new password link is expired',
    'landing-form-reset-password-expired-description': 'Please click "OK" to reset new password<br/>and check your mailbox to reset new password<br/>within 30 mins after receive a mailbox.',
    'landing-form-action-link-fail-description': 'There is a system error.<br/>Please try again.',
    // Login form
    'landing-form-required-login': 'Please enter your password',
    'landing-form-forget-password': 'Forget Password ?',
    'landing-form-login-failure-title': '<p>Incorrect email or password</p>',
    'landing-form-login-failure-description': 'Please check and try it again.',
    'affiliate-form-login-title': 'Welcome to Corporate Secure Page',
    'affiliate-form-login-desc': 'Login with your organizational account.',
    'affiliate-form-login-username-required': 'Please enter your username',
    'affiliate-form-login-password-required': 'Please enter your password',
    'affiliate-form-login-button': 'Login',
    'affiliate-form-login-failure': 'Incorrect username or password. <br>Please check and try it again.',
    'affiliate-form-login-failure-cost-center-or-cost-owner-missing': 'Sorry, your cost center or cost center owner is missing! Please contact your HR. <br>True HR contact: HRIS@truecorp.co.th',
    'affiliate-form-login-failure-technical-problems': 'Login failed due to technical problems from TrueHR. Please contact your HR. <br>True HR contact: HRIS@truecorp.co.th',
    'affiliate-dialog-ok-button': 'OK',
    'error-unable-to-connect-SSO': 'Unable to connect to the SSO service. Please try again later or contact your IT support.',
    // Forgot password form
    'landing-form-forgot-password-title': 'Please enter your corporate email',
    'landing-form-forgot-password-description': 'To reset your password, enter the email you use to register with us.',
    'landing-form-forgot-password-success-title': '<p class="forget-password-title">Please check your mailbox</p>',
    'landing-form-forgot-password-success-description': 'We have sent an email to<br/><span class="color-main">[email]</span><br/>Please check your mailbox to reset new password<br/>within 30 mins after receive a mailbox.',
    'landing-form-forgot-password-fail-message': 'Request to reset new password is fail.<br/>Please click at "OK" to reset password again.',
    // Register / Join us form
    'landing-form-register-title': 'Interested to join with Ascend Travel?',
    'landing-form-register-description': 'We would like to please you but your company have not contact with us yet. If you are interested to travel with us, please leave your information. Our staff will contact you back soon.',
    'landing-form-join-us-title': 'Join with Ascend Travel',
    'landing-form-join-us-description': 'If you are interested to travel with us, please leave your information. Our staff will contact you back soon.',
    'landing-form-register-success-title': '<p>Thank you for your interest.</p>',
    'landing-form-register-success-description': 'We have already received your information.<br/>Our staff will contact you back soon.',
    'landing-form-join-us-error-title': 'Submit information failed.',
    'landing-form-join-us-error-description': 'Please contact +66(0) 2-020-2351 or Support@ascendtravel.com',
    'landing-form-register-error-title': 'Register failed.',
    'landing-form-register-error-description': 'Please contact +66(0) 2-020-2351 or Support@ascendtravel.com',
    // Verify register email
    'landing-form-verify-email-expired-title': 'Your activation link has expired',
    'landing-form-verify-email-expired-description': '<br/>We have sent an email to you again<br/>Check your mailbox to complete registration<br/>within 30 mins after receive a mailbox.<br/>*If you cannot find, please check in your junk mail.',
    'landing-form-verify-email-invalid-title': 'Link is invalid',
    'landing-form-verify-email-invalid-description': 'Please enter your email to resend verify email',
    // Login
    'landing-login-unable-get-company-feature': 'Sorry, we cannot retrieve your company information. Please contact call center for more information.<br/>Call center : +66(0) 2-020-2351',
    // Guideline
    'guideline-password': 'Create your password here',
    'guideline-confirm-password': 'Confirm your password here',
    'guideline-email': 'email@company.com',
    'guideline-name': 'Name/Surname',
    'guideline-firstname': 'Name',
    'guideline-lastname': 'Surname',
    'guideline-contact-number': '0XXXXXXXXX',
    'guideline-company': 'Company Name',
    'guideline-position': 'Your position in company',
    'guideline-company-website': 'Company Website (Optional)',
    'guideline-company-travelling-expense': 'Company Travelling Expense (Optional)',
    // Validation message
    'validation-required-name': 'Please enter your name/surname.',
    'validation-required-firstname': 'Please enter your name.',
    'validation-required-lastname': 'Please enter your surname.',
    'validation-required-full-name': 'Please enter your first name and last name.',
    'validation-required-email': 'Please enter your corporate email.',
    'validation-required-contact-number': 'Please enter your contact number.',
    'validation-required-company': 'Please enter your company name.',
    'validation-required-select-company': 'Please choose your main company.',
    'validation-required-position': 'Please enter your position in company.',
    'validation-required-accept-terms': 'Please accept terms & conditions in order to register.',
    'validation-required-password': 'Password must be A-Z or a-z or 0-9 or Special Charactors except single-quote(\'), double-quote("), comma(,) and back-slash(\\) 8-16 digits.',
    'validation-required-new-password': 'Please enter your new password.',
    'validation-required-confirm-new-password': 'Please confirm your new password.',
    'validation-previously-used-new-password': 'Please try again with a password you haven\'t used before.',
    'validation-required-title': 'Please enter Company Name or Name-Surname.',
    'validation-required-tax-number': 'Please enter Tax ID or Personal ID.',
    'validation-invalid-tax-number': 'Tax ID or Personal ID must only contain letters (a-z, A-Z), numbers (0-9).',
    'validation-required-invoice-address': 'Please enter Tax Invoice or Receipt Address.',
    'validation-required-group-select-birth-date': 'Please enter a valid date of birth.',
    'validation-pattern-email': 'Your email is incorrect. Please check and try it again',
    'validation-pattern-name': 'Name must be a-z A-Z',
    'validation-pattern-firstname': 'Name must be a-z A-Z',
    'validation-pattern-lastname': 'Surname must be a-z A-Z',
    'validation-pattern-full-name': 'Please enter guest name in English only.',
    'validation-pattern-contact-number': 'Please enter a valid phone number.',
    'validation-min-length-password': 'Password must be at between 8 - 16 characters long.',
    'validation-max-length-password': 'Password must be at between 8 - 16 characters long.',
    'validation-match-password': 'Password is not match with confirm password. Please check and try it again.',
    'validation-required-select-your-company': 'Please select company.',
    'validation-required-time-of-birth': 'Please select time of birth.',
    'btn-create-account': 'Register',
    'btn-try-again': 'Try Again',
    'btn-continue': 'Continue',
    'btn-ok': 'OK',
    'btn-login': 'Login',
    'link-resend': 'Resend verify email',
    'btn-submit-information': 'Submit information',
    'btn-request-new-password': 'Request New Password',
    'login-not-sure': 'Not sure that your company already enroll with Ascend Travel',
    'click-here': 'Click Here',
    'forget-password': 'Forget Password ?',
    'placeholder-password': 'Enter your password here',
    'my-profile-headline': 'My Profile',
    'my-profile-personal-informations': 'Personal Information',
    'my-profile-edit-profile': 'Edit Profile',
    'my-profile-name': 'Name/Surname',
    'my-profile-firstname': 'Name',
    'my-profile-lastname': 'Surname',
    'my-profile-full-name-label': 'Name/Surname',
    'my-profile-full-name-placeholder': 'Full name',
    'my-profile-member-code': 'Member No.',
    'my-profile-birthday': 'Date of birth',
    'my-profile-company-name': 'Company',
    'my-profile-nationality': 'Nationality',
    'my-profile-phone-number': 'Phone number',
    'my-profile-phone-number-placeholder': 'e.g. 0812345678',
    'my-profile-email': 'Email',
    'my-profile-working-position': 'Position',
    'my-profile-tax-invoice': 'Tax Invoice/Receipt Address',
    'my-profile-add-tax': 'Add new Tax Invoice/Receipt Information',
    'my-profile-edit': 'Edit',
    'my-profile-delete': 'Delete',
    'my-profile-edit-presonal-profile': 'Edit Personal Information',
    'my-profile-birthdate-remark': 'This information used for searching accommodations that enhance positive energy. If you wish to change your date of birth, please contact Call Center: <b>+66(0) 2-020-2351</b> / Line Official Account: <b>@AscendTravel</b>',
    'my-profile-edit-button-submit': 'Save',
    'my-profile-edit-button-cancel': 'Cancel',
    'my-profile-change-password-success-title': 'Password Reset Successful. You can use this password for next login.',
    'my-profile-change-password-success-description': '',
    'my-profile-change-password-failure-title': 'Password Reset Failed. Please try again.',
    'my-profile-change-password-failure-description': '',
    'my-profile-edit-success-title': 'Update profile successful.',
    'my-profile-edit-success-description': '',
    'my-profile-edit-failure-title': 'Update profile fail.',
    'my-profile-edit-failure-description': 'Please try again.',
    'my-profile-edit-address-failure-title': 'Update address fail.',
    'my-profile-edit-address-failure-description': 'Please try again.',
    'my-profile-address-form-tax-number': 'Tax ID',
    'my-profile-address-form-company-name': 'Company name/Name-Surname',
    'my-profile-address-form-company-name-placeholder': 'Enter Company name/Name-Surname',
    'my-profile-address-form-tax-number-id': 'Tax ID/Personal ID',
    'my-profile-address-form-tax-number-id-placeholder': 'Enter Tax ID/Personal ID',
    'my-profile-address-form-billing-address': 'Tax Invoice/​Receipt address',
    'my-profile-address-form-billing-address-placeholder': 'Enter Tax Invoice/​Receipt address',
    'my-profile-address-form-btn-cancel': 'Cancel',
    'my-profile-address-form-btn-submit': 'Submit',
    'my-profile-delete-address-success': 'Delete address success.',
    'my-profile-delete-address-failure': 'Delete address failure.',
    'my-profile-delete-address-failure-text': 'Please try agian.',
    'my-profile-confirm-msg-delete-address': 'Confirm to delete tax address?',
    'my-profile-confirm-msg-type-address': 'edit address',
    'my-profile-confirm-msg-type-profile': 'edit profile',
    'my-profile-confirm-msg': 'You have not finished {dataType} yet. Do you want to leave without finishing?',
    'my-profile-address-dialog-button-delete': 'Delete',
    'my-profile-address-dialog-button-cancel': 'Cancel',
    'my-profile-address-dialog-button-close': 'Close',
    'facility-title': 'Facilities',
    'facility-title-room': 'Room Facilities',
    'show-more-btn': 'View more',
    'show-less-btn': 'View less',
    'description-title': 'Description',
    'occupancy-policy-title': 'Occupancy policy',
    'occupancy-policy-remark-title': 'Additional Information',
    'remark': 'Remark',
    'my-profile-subscription': 'Subscription',
    // Child policy
    'child-policy-title': 'Children and extra beds',
    'child-policy-table-guest-age': "Guest's age",
    'child-policy-table-extrabed': 'Extra bed',
    'child-policy-min-guest-age-all-age': 'All children are welcome',
    'child-policy-min-guest-age': ' Minimum age of guest is {x} year(s) ',
    'child-policy-infant-policy': 'Infant {from}-{to} year(s)',
    'child-policy-infant-description': 'Baby cot/crib available upon request',
    'child-policy-child-policy': 'Children {from}-{to} year(s)',
    'child-policy-adult-policy': 'Guests {from} years and older are considered as adults',
    'child-policy-free-stay-description': 'Stay for free if using existing bedding.',
    'child-policy-stay-description': 'Must use an extra bed.',
    'child-policy-free-description': 'Extra beds may be requested directly from the property; additional charges may apply',
    'child-policy-description': 'Must use an extra bed which will incur an additional charge.',
    // Review rating component in level-D
    'review-rating-title': 'Guest Rating',
    'review-uncommonThings-title': 'Special reviews',
    'review-uncommonThings-title-right': 'Special review from guest',
    // Product lists page
    'productlists-popular-filter': 'Popular filters',
    'productlists-price-per-night': 'Price',
    'productlists-price': 'Price/Night',
    'productlists-price-low-high': 'Price low to high',
    'productlists-price-high-low': 'Price high to low',
    'productlists-hotel-star': 'Hotel star',
    'productlists-hotel-star-1-5': 'Star 1-5',
    'productlists-hotel-star-5-1': 'Star 5-1',
    'productlists-no-star-rating': 'No star rating',
    'productlists-your-balance': 'Your budget limit is THB X,XXX/room/night',
    'productlists-sorting': 'Sort by',
    'productlists-filter': 'Filter',
    'productlists-filter-by': 'Filter by',
    'productlists-more': 'More',
    'productlists-recommendation': 'Recommended',
    'productlists-score': 'Guest rating',
    'productlists-poi-distance': 'Distance',
    'productlists-hotel-name': 'Hotel name',
    'productlists-hotel-name-sorting-a-z': 'A-Z',
    'productlists-hotel-name-sorting-z-a': 'Z-A',
    'productlists-special-price': 'Special price applied on company only',
    'productlists-available-room': 'Only {X} rooms left!',
    'product-booknow': 'Book now, Pay on {9 Jul 17}',
    'productlists-see-room': 'See all rooms',
    'productlists-night': 'night',
    'productlists-no-room-left': 'No available rooms on selected dates',
    'productlists-recommended-title': 'Special price of employee who book via Ascend Travel Only',
    'productlists-found-01': 'Found',
    'productlists-found-02': 'properties.',
    'productlists-found-03': 'Showing',
    'productlists-pop-up-error': 'System error. Please try again.',
    'productlists-pop-up-error-missing-email-header': 'Missing user’s email from CPF Web Service.',
    'productlists-pop-up-error-missing-email': 'Please contact CPF HRIS through the Ask HR channel.<br/>1. Go to <a class="link-hover-style" href="https://cpffamily.cpf.co.th" target="_blank">https://cpffamily.cpf.co.th</a><br/>2. Go to <span class="bold">HR-eXp</span> and click  <span class="bold">Ask HR</span> button on the top right.',
    'productlists-pop-up-error-across-month': 'Your company not allow to book across months.',
    'productlists-pop-up-error-across-month-share-budget': 'Your company or co-booker company not allow to book across months.',
    'productlists-not-found': 'Sorry, we couldn\'t find any properties from your search keyword. Try one of these popular destination instead.',
    'productlists-business-desination': 'Distance from destination',
    'productlists-business-desination-kilometer': 'km.',
    'productlists-business-distance': 'From {poi} {km} km.',
    'productlists-hotel-review': 'Review scores',
    'productlists-hotel-review-9': 'Exceptional: 9+',
    'productlists-hotel-review-8': 'Excellent: 8+',
    'productlists-hotel-review-7': 'Very good: 7+',
    'productlists-hotel-review-6': 'Review Score: 6+',
    'productlists-hotel-review-nonreview-newhotel': 'New or waiting review',
    'productlists-filter-header': 'Filters',
    'productlists-filter-clear': 'Clear all',
    'productlists-filter-submit': 'Apply',
    'productlists-filter-show-more-item': 'Show more',
    'productlists-filter-facility': 'Facilities',
    'productlists-filter-include-breakfast': 'Breakfast included',
    'productlists-filter-popup-include-breakfast': 'Breakfast included',
    'productlists-filter-location': 'Location',
    'productlists-filter-location-search': 'Location',
    'productlists-filter-over-budget': 'Book without budget<br>limit',
    'productlists-filter-popup-over-budget': 'Book without budget limit',
    'productlists-filter-clear-btn': 'Clear',
    'productlists-over-budget': 'Over Budget',
    'productlists-bestSeller': 'Best Seller',
    'productlists-topBooking': 'Top Booking',
    'productlists-bestReview': 'The Best Review Accommodations',
    'productlists-specialRecommendation': 'Special Recommendation',
    'productlists-holidayOffer': 'Holiday Offer',
    'productlists-midMonth': 'MID MONTH - Limited time offer!',
    'productlists-summerDeal': 'Summer Deal',
    'productlists-flashDeal': 'Flash Deal',
    'productlists-bestDeal': 'Best Deal',
    'productlists-room-breakfast': 'Breakfast Included',
    'productlists-positive-energy': 'Positive Energy',
    'productlists-positive-energy-work': 'Work',
    'productlists-positive-energy-wealth': 'Wealth',
    'productlists-positive-energy-love': 'Love',
    'productlists-positive-energy-family': 'Family',
    'productlists-positive-energy-friendship': 'Friendship',
    'productlists-positive-energy-fortune': 'Fortune',
    'productlists-positive-energy-health': 'Health',
    'productlists-positive-energy-patronage': 'Patronage',
    'productlists-positive-energy-reputation': 'Reputation',
    // Product list - guest review rating title
    'product-review-rating-exceptional': 'Exceptional',
    'product-review-rating-excellent': 'Excellent',
    'product-review-rating-very-good': 'Very good',
    'product-review-rating-review-score': 'Review Score',
    // Product detail page
    'product-detail-choose-your-room': "Select room type",
    'product-detail-room-type': "Room type",
    'product-detail-room-condition': "Details & Conditions",
    'product-detail-number-of-guest': "Capacity",
    'product-detail-price-today': "Price per night",
    'product-detail-amount-room': "Room",
    'product-detail-room-last-five': "Only {room} rooms left!",
    'product-detail-room-breakfast': "Breakfast Included",
    'product-detail-room-all-inclusive': "Breakfast, Lunch, Dinner and Beverages Included",
    'product-detail-room-full-board': "Breakfast, Lunch and Dinner Included",
    'product-detail-room-half-board': "Breakfast and Lunch or Breakfast and Dinner Included",
    'product-detail-room-only': "Room Only",
    'product-detail-room-condition-cancellation-fee': 'Cancellation with fee',
    'product-detail-room-cancellation-policy': "Cancellation Policy",
    'product-detail-room-cancellation-non-refundable': "Special Rate (Non-Refundable)",
    'product-detail-room-cancellation-charge': "- If cancel after {date}, will incur cancellation charge for {currency} {amount} per room",
    'product-detail-room-cancellation-night': "- If cancel after {date}, will incur cancellation charge first {night} room night",
    'product-detail-room-cancellation-percent': "- If cancel after {date}, will incur cancellation charge {percent}% of total price",
    'product-detail-room-cancellation-free': "Free Cancellation if cancel before {date}",
    'product-detail-room-paylater-description': "Book now, Pay on {date}",
    'product-detail-budget-limit': "Your budget limit is <strong>{x}</strong> /room/night",
    'product-detail-new-budget-limit': "Your new budget limit is <strong>{x}</strong> /room/night",
    'product-detail-room-over-limit': "Over Budget",
    'product-detail-room-over-price': "Pay more",
    'product-detail-room-night': "/night",
    'product-detail-tooltip-price-per-night': "1 room x 1 night",
    'product-detail-tooltip-user-budget': "Budget per room per night",
    'product-detail-tooltip-pay-over-budget': "Pay more",
    'product-detail-image-map-description': "*Click on map to see nearby hotels.",
    'product-detail-review-mysterious-things': 'Mysterious things',
    'product-detail-review-pest': 'Pest',
    'product-detail-bathroom': 'bathroom',
    'product-detail-private-bathroom': 'Private bathroom',
    'product-detail-shared-bathroom': 'Shared bathroom',
    'product-detail-bedroom': 'bedroom',
    'product-detail-sqm': 'sq. m.',
    'product-detail-information': 'More information',
    'extra-bed-include-in-room-price': 'Extra bed(s) included in room price',
    'extra-bed-include': "{text} Extra Bed Included",
    'product-detail-room-note-title': 'Benefits & Information',
    'product-detail-room-note-see-more': 'View more',
    'room-detail-title': "Room Type Details",
    'room-not-available-line-1': "Sorry, there is no available room for the dates you searched.",
    'room-not-available-line-2': "Please change your dates.",
    'room-price-change-line-1': 'Room rate has changed.',
    'room-price-change-line-2': 'You can see the new price',
    'room-price-change-line-3': 'as information below.',
    'room-price-change-space': ' ',
    'room-price-change-col-1': 'Room Type',
    'room-price-change-col-2': 'Previous Price',
    'room-price-change-col-3': 'New Price',
    'room-price-btn-accept': 'Accept',
    'room-price-btn-back': 'Back to Search',
    'show-photo': "Photo",
    'product-description-text-sha-title': 'SHA : Amazing Thailand Safety & Health Administration',
    'product-description-text-sha-plus-title': 'SHA Plus : Amazing Thailand Safety & Health Administration',
    'product-description-text-sha-desc': 'The property have successfully passed a strict inspection of preventive measures by Tourism Authority of Thailand (TAT) implemented to ensure that both Thai and foreign tourists have a positive experience.',
    'product-description-text-sha-plus-desc': 'The property have successfully passed a strict inspection of preventive measures by Tourism Authority of Thailand (TAT) implemented to ensure that both Thai and foreign tourists have a positive experience. And at least 70% of staff at the venues and businesses have been fully vaccinated against COVID-19.',
    'product-description-text-sha-certificate-id': 'Certificate ID',
    'product-description-text-property-opened': 'Property opened',
    'product-description-text-recent-renovation': 'Recent renovation',
    'sanitized-stay-title': 'Sanitized Stay',
    'product-detail-dialog-continue-with-my-budget': 'Do you still want to book and pay by your budget?',
    'product-detail-dialog-continue-with-credit-card': 'Do you still want to book and pay by your budget?',
    'product-detail-dialog-continue-with-multi-payment': 'Do you still want to book and pay by your budget?',
    'product-detail-dialog-continue-confirm-with-my-budget': 'Continue',
    'product-detail-dialog-continue-confirm-with-credit-card': 'Continue',
    'product-detail-dialog-continue-confirm-with-multi-payment': 'Continue',
    'product-detail-dialog-continue-sub-text-with-my-budget': 'You cannot share budget with co-booker. If you confirm to continue booking, we will remove share budget and you must pay by your budget.',
    'product-detail-dialog-continue-sub-text-with-credit-card': 'You cannot share budget with co-booker. If you confirm to continue booking, we will remove share budget and you must pay by your budget.',
    'product-detail-dialog-continue-sub-text-with-multi-payment': 'You cannot share budget with co-booker. If you confirm to continue booking, we will remove share budget and you have to pay for the exceeding amount by your own. ',
    'product-detail-dialog-btn-continue': 'Continue',
    // booking
    'booking-cancellation-fee': 'Cancellation Fee',
    'booking-cancellation-fee-2': 'Cancellation Fee',
    'booking-cancellation-fee-3': 'Reject a reservation',
    'booking-cancellation-free': 'No Cancellation Fee.',
    'booking-cancellation-free-2': 'You can reject this booking with no cancellation fee.',
    'booking-cancellation-booking-id': 'Booking ID',
    'booking-cancellation-if-cancel-text': 'If you cancel this booking, it will have cancellation fee by below details.',
    'booking-cancellation-if-cancel-text-2': 'If you reject this booking, it will have cancellation fee by below details.',
    'booking-cancellation-room-type': 'Room Type',
    'booking-cancellation-total': 'Total Cancellation Fee',
    'booking-cancellation-note': 'Note',
    'booking-cancellation-note-text': 'Cancellation fee can be changed depend on the cancellation period you submit.',
    'booking-cancellation-promotion-text': 'If a promo code is applied, the cancellation fee will be calculated based on the net price after discount, or as determined by the company.',
    'booking-cancellation-btn-confirm': 'Confirm',
    'booking-cancellation-btn-confirm-2': 'Reject',
    'booking-cancellation-btn-close': 'Back',
    'booking-cancellation-empty': 'No Booking',
    'booking-cancel-success': 'Cancel Booking ID {bookingID} Successful.',
    'booking-cancel-failure': 'Cancel Booking ID {bookingID} Failed. Please try again.',
    'booking-cancel-date': 'Cancel Date',
    'booking-cancellation-credit-terms': 'Cancellation fee charge to credit terms',
    'booking-cancellation-credit-terms-main-booker': 'Main booker',
    'booking-cancellation-credit-terms-co-booker': 'Co-booker',
    'booking-cancellation-credit-card': "Cancellation fee charge to card holder's credit/debit card",
    'booking-cancellation-true-money': "Cancellation fee charge to TrueMoney Wallet",
    'booking-cancellation-corporate-fleet': "Cancellation fee charge to card holder's corporate fleet card",
    'booking-cancellation-personal-fleet': "Cancellation fee charge to card holder's personal fleet card",
    'booking-cancellation-multipayment': 'Separate into 2 payment methods',
    'booking-cancellation-reject-reason-label': 'Reject reasons',
    'booking-cancellation-reject-reason-placeholder': 'Please specify reasons...',
    'booking-cancellation-reject-reason-error-required': 'Please enter reasons to reject.',
    'booking-cancellation-refund-details': 'We are unable to automatically process refunds once a cancellation has been ordered. Customer must make a request for a <span class="refund-themselves"">refund by themselves</span> through the refund request. Please contact <b>Call Center : +66(0) 2-020-2351</b> or <b>Line Official Account : @AscendTravel</b>',
    'product-menu-photo': "Photo",
    'product-menu-room': "Select Rooms",
    'product-menu-detail': "Hotel Detail",
    'product-menu-facility': "Facilities",
    'booking-arranged-by': 'Arranged By',
    'booking-report': 'Booking report (.xlsx)',
    'booking-report-dialog-title': 'Booking Report by Check-in Period',
    'booking-report-check-in-from': 'From',
    'booking-report-check-in-to': 'To',
    'booking-report-placeholder-from': 'Tu. 1 Jan 19',
    'booking-report-placeholder-to': 'Th. 31 Jan 19',
    'booking-report-information': 'There are only bookings paid by credit terms in this report.',
    'booking-report-data-not-found': 'There is no booking paid by credit terms in the selected period.',
    'booking-report-export-error': 'Export report failed. Please try again.',
    'dialog-booking-report-error': 'Please select check-in period.',
    'booking-condition-popup-title': 'Cancellation policy',
    'booking-condition-popup-detail-1': 'If cancel after',
    'booking-condition-popup-detail-2': ', will incur cancellation charge for THB',
    'booking-condition-popup-detail-3': 'per room',
    // cart
    'cart-booking-detail': "Booking details",
    'cart-price-for': "Price for",
    'cart-night': "night",
    'cart-time-from': "From",
    'cart-time-until': "Until",
    'cart-room': "room",
    'cart-room-type-detail': "Room details",
    'cart-grand-total': "Grand Total",
    'cart-include-vat-label': "Price already include VAT and service charge.",
    'cart-credit-card-label': "For Credit/Debit Card payment method,",
    'cart-non-refund-label': "Non Refundable Price",
    'cart-pay-on-label': "Pay date will be on",
    'cart-book-now': "Book now",
    'cart-select-room': "Please select number of room.",
    'cart-button-continue': "Continue",
    'cart-button-confirm-to-book': "Confirm to Book",
    'cart-surcharge-include': "Price already include VAT, {text} and Service Charge.",
    'cart-surcharge-exclude': "Not included in price (collected by the property): {text}",
    'cart-seperate-payment': "Separate into 2 payment methods",
    'cart-seperate-payment-credit-terms': "Separate payment into",
    'cart-pay-credit-terms': "Pay by credit terms",
    'cart-pay-corporate-fleet': "Pay by corporate fleet card",
    'cart-pay-personal-fleet': "Pay by personal fleet card",
    'cart-pay-corporate-fleet-new-line': "Pay by corporate fleet card",
    'cart-pay-personal-fleet-new-line': "Pay by personal fleet card",
    'cart-pay-debit-card': "Pay more",
    'cart-multi-pay-label': "For multi-payment, payment date will be",
    'cart-max-guest': '',
    'cart-adult-text': 'Max',
    'cart-child-text': '',
    'cart-adult': 'adult',
    'cart-child': 'child',
    'cart-children': 'children',
    'cart-budget-no-remaning': 'You have to pay by your own due to ',
    'cart-budget-detail-below': ', you have to pay for the exceeding amount by your own.',
    'cart-budget-no-remaning-mobile': 'You have to pay by your own.',
    'cart-budget-detail-mobile': 'You have to pay for the exceeding amount by your own.',
    'cart-booker': 'Booker',
    'cart-co-booker': 'Co-Booker',
    'cart-cannot-share-budget': 'You cannot share budget with co-booker, please',
    'cart-before-continuing': 'continuing your booking.',
    'cart-btn-cannot-share-budget': 'cancel share budget',
    'cart-share-budget-detail-below': ' You have to pay for the exceeding amount by your own.',
    'cart-budget-over-budget-mobile': 'You have to pay more for the amount over budget',
    'cart-budget-over-budget-book-for-traveller': 'The price exceeds guest’s budget limit. ',
    'cart-budget-over-budget-book-for-traveller-sub-text': 'Please select new room.',
    'cart-currency-note': 'We will charge your booking in THB. The price shown in {currency} is an approximate conversion of THB to {currency}, based on the current exchange rate. (Please note that exchange rates are subject to change.)',
    'cart-approximate-price-in': 'Approximate price in',
    'cart-taxes-fees': 'Taxes & Fees',
    'cart-taxes-fees-description': 'This charge includes estimated amounts the travel service provider (i.e. hotel, car rental company) pays for their taxes, and/or taxes that we pay, to taxing authorities on your booking (including but not limited to sales, occupancy, and value added tax). This amount may also include any amounts charged to us for resort fees, cleaning fees, and other fees and/or a fee we, the hotel supplier and/or the site you booked on, retain as part of the compensation for our and/or their services, which varies based on factors such as location, the amount, and how you booked. For more details, please see the terms and conditions.',
    'cart-terms-conditions': 'By completing this booking you agree to the',
    'cart-terms-conditions-and': 'and',
    'cart-terms-conditions-supplier': 'Supplier Terms and Conditions',
    'cart-terms-conditions-agent': 'Agent Terms of Use',
    'cart-price-info': 'Price Information',
    'cart-discount': 'Discount',
    'cart-promotion-code': 'Promotion Code',
    'cart-select-code': 'Select Code',
    'cart-promotion-code-discount': 'Promotion Code Discount',
    'cart-promotion-code-error-invalid_payment_method': 'Please use a different payment method to apply this code.',
    'cart-promotion-code-error-reached_limit': 'Please use a different code. This code has reached its limit.',
    'cart-promotion-code-error-condition_not_met': 'Please use a different code. This code does not meet the conditions.',
    'cart-dialog-use-promotion-code-title': 'Promotion Code',
    'cart-dialog-use-promotion-code-search-placeholder': 'Enter your promotion code',
    'cart-dialog-use-promotion-code-best-deal': 'Best Deal',
    'cart-dialog-use-promotion-code-btn-search': 'Apply Code',
    'cart-dialog-use-promotion-code-search-error-invalid': 'Invalid promotion code. Please check and try again.',
    'cart-dialog-use-promotion-code-discount': '{amount} Off',
    'cart-dialog-use-promotion-code-max-discount-per-book': 'Up to {amount}',
    'cart-dialog-use-promotion-code-min-spend-per-book': 'Minimum booking of {amount}',
    'cart-dialog-use-promotion-code-min-spend-per-book-no-limit': 'No minimum required',
    'cart-dialog-use-promotion-code-term-condition': 'T&C',
    'cart-dialog-use-promotion-no-promotion-code': 'No valid code available.',
    'cart-dialog-use-promotion-credit-terms': 'Valid only for Credit Terms payments.',
    'cart-dialog-use-promotion-credit-debit-card-bank': 'Valid only for {bank} Card payments.',
    'cart-dialog-use-promotion-credit-card': 'Valid only for {bank}Credit Card payments.',
    'cart-dialog-use-promotion-debit-card': 'Valid only for {bank}Debit Card payments.',
    'cart-dialog-use-promotion-payment': 'Valid only for {payment} payments.',
    'cart-dialog-use-promotion-promotional-code-participating-payment-methods': 'This code is valid only for participating payment methods.',
    'cart-dialog-use-promotion-discount': 'Promotional code discount',
    'cart-dialog-confirm-continue-without-promotion-code-title': 'Proceed without using the code?',
    'cart-dialog-confirm-continue-without-promotion-code-desc': 'This promotion code is not valid for this booking.<br>You can continue without applying the code or go back to select a different one.',
    'cart-dialog-confirm-continue-without-promotion-code-cancel': 'Choose another code',
    'cart-dialog-confirm-continue-without-promotion-code-cancel-short': 'Try another',
    'cart-dialog-confirm-continue-without-promotion-code-confirm': 'Proceed without the code',
    'cart-dialog-error-session-expired-title': 'This search has expired',
    'cart-dialog-error-session-expired-description': 'Because the booking time limit has been reached.<br>Please search again.',
    // Month
    'day-select': 'Day',
    'year-select': 'Year',
    'month-select': 'Month',
    'month-january': 'January',
    'month-february': 'February',
    'month-march': 'March',
    'month-april': 'April',
    'month-may': 'May',
    'month-june': 'June',
    'month-july': 'July',
    'month-august': 'August',
    'month-september': 'September',
    'month-october': 'October',
    'month-november': 'November',
    'month-december': 'December',
    // Thank you
    'thankyou-download-voucher': 'Download voucher',
    'thankyou-print-voucher': 'Print',
    'thankyou-office-address-name': 'Ascend Travel Co.,Ltd. (Head Office)',
    'thankyou-office-address-location': 'AIA Capital Center Building, 18-19 Floor, 89 Ratchadaphisek Road, Dindaeng, Dindaeng, Bangkok 10400',
    'thankyou-office-address-taxnum': 'Tax ID : 0105559069212',
    'thankyou-bookingId-ref': 'Ref. with Ascend Travel',
    'thankyou-bookingId-hotel-ref-number': 'Hotel Booking ID',
    'thankyou-bookingId-hotel-book-by': 'Booked and payable by ',
    'thankyou-payment-title': 'Payment Method',
    'thankyou-payment-detail': 'Credit/Debit Card',
    'thankyou-payment-detail-true-money': 'TrueMoney Wallet',
    'thankyou-payment-detail-2': 'Credit Terms',
    'thankyou-payment-creditcard-details': 'Easy to pay via Credit Card/Debit Card without fee with convenience, express checkout and save & secure 24 hours.',
    'thankyou-payment-date': 'Payment date',
    'thankyou-booking-details': 'Booking Details',
    'thankyou-details-props-info': 'Property Information',
    'thankyou-details-props-name': 'Property Name',
    'thankyou-details-props-address': 'Address',
    'thankyou-details-props-phone': 'Phone',
    'thankyou-details-details': 'Booking Details',
    'thankyou-details-roomtype': 'Room type',
    'thankyou-details-price': 'Price',
    'thankyou-guest-order-number': 'Guest',
    'thankyou-guest-special-request': 'Special Request',
    'thankyou-room-condition': "Room's condition",
    'thankyou-details-vat': 'Price (Excluding VAT)',
    'thankyou-price-vat': 'VAT',
    'thankyou-price-total': 'Grand Total',
    'thankyou-thankyou-statement-01': "Thank you for your trust in using Ascend Travel's services.",
    'thankyou-thankyou-statement-02': "You can contact us via Call Center +66(0) 2-020-2351 with 24 hours service everyday.",
    'thankyou-status-pay-now-success-title': 'Your payment is processed successfully.',
    'thankyou-status-pay-now-success-text': 'Thank you for your trust in using Ascend Travel services.',
    'thankyou-status-pay-later-success-title': 'Your reservation is processed successfully',
    'thankyou-status-pay-later-success-text': 'Thank you for your trust in using Ascend Travel services.',
    'thankyou-status-pay-now-fail-title': 'Your credit/debit card payment is failed',
    'thankyou-status-tmn-pay-now-fail-title': 'Your TrueMoney Wallet payment is failed',
    'thankyou-status-fleet-pay-now-fail-title': 'Your fleet card payment is failed',
    'thankyou-status-payment-fail-title': 'Your payment is failed.',
    'thankyou-status-fleet-pay-now-fail-sub-title': 'Please check your card balance or contact call center +66(0) 2-020-2351.',
    'thankyou-status-pay-now-fail-text': 'Please check your card information or contact issuing bank.',
    'thankyou-status-tmn-pay-now-fail-default-text': 'Please check your TrueMoney Wallet account or contact TrueMoney Customer Care.',
    'thankyou-status-payment-fail-text': 'Please check your account or complete the transaction again.',
    'thankyou-status-tmn-pay-now-fail-invalid-card-number-text': 'Your TrueMoney Wallet phone number does not exist. Please contact TrueMoney Customer Care.',
    'thankyou-status-tmn-pay-now-fail-insufficient-funds-text': 'Insufficient balance in your TrueMoney Wallet account. Please topup your account balance and make payment again.',
    'thankyou-status-payment-fail-description': 'Payment failed',
    'thankyou-status-payment-credit-terms-fail-description': 'No payment has been charged to your company.',
    'thankyou-status-payment-credit-terms-share-budget-fail-description': 'No payment has been charged to your company and co-booker’s company.',
    'thankyou-status-payment-credit-card-fail-description': 'No payment has been charged to your issuing bank.',
    'thankyou-status-payment-tmn-fail-description': 'No payment has been charged to your TrueMoney Wallet account.',
    'thankyou-status-payment-fleet-fail-description': 'No payment has been charged to your fleet card.',
    'thankyou-status-payment-account-fail-description': 'No payment will be deducted from your account.',
    'thankyou-status-seperate-payment-method': 'Separate into 2 payment methods',
    'thankyou-more-information': 'Additional information',
    'thankyou-status-booking-success-title': 'Your reservation is processed successfully.',
    'thankyou-status-booking-success-text': 'You will receive email confirmation again.<br />Thank you for your trust in using Ascend Travel service.',
    'thankyou-status-booking-fail-title': 'Your booking is failed',
    'thankyou-status-booking-fail-text': "We're really sorry. Because the room type you have selected has many customers interested too and the last room just booked by another customer.",
    'thankyou-status-cannot-create-temp-booking-title': "Your booking is failed.",
    'thankyou-status-cannot-create-temp-booking-text': "Please try again.",
    'thankyou-status-timeout-title': 'Please check your booking status at menu "Booking".',
    'thankyou-status-timeout-text': "There was an error while processing your booking.",
    'thankyou-surcharge-exclude': "The prices do not include {text} which will be collected by the property. Please request Receipt/Tax invoice from the property after payment has been made.",
    'thankyou-payment-successful': 'Payment successful',
    'thankyou-booking-successful': 'Booking successful',
    'thankyou-booking-pay-on': 'Pay on',
    'thankyou-booking-credit-terms-title': 'Credit Terms',
    'thankyou-booking-credit-terms-success': 'We will process to issue invoice to your company as per credit terms agreed.',
    'thankyou-booking-credit-terms-share-budget-success': 'We will process to issue invoice to your company and co-booker’s company as per credit terms agreed.',
    'thankyou-payment-detail-total-title': 'Payment details',
    'thankyou-booking-id': 'Booking ID',
    'thankyou-we-send-information': 'We have sent the confirmation e-mail to',
    'thankyou-total-price': 'Total price',
    'thankyou-voucher': 'Voucher',
    'thankyou-tax-invoice': 'Tax invoice/Receipt',
    'thankyou-back-home-button': 'Back to home',
    'thankyou-booking-detail-button': 'View booking details',
    'thankyou-check-booking-button': 'View booking',
    'thankyou-on-process': 'Your booking is on process',
    'thankyou-booking-corporate-fleet-title': 'Corporate fleet card',
    'thankyou-booking-personal-fleet-title': 'Personal fleet card',
    // Booking Details
    'booking-details-btn-back': 'Back to booking',
    'booking-details-dropdown-title': 'Download document',
    'booking-details-save-voucher': 'Save Voucher',
    'booking-details-save-tax-invoice': 'Save Tax Invoice',
    'booking-details-save-tax-invoice-cancel': 'Save Tax Invoice Cancel',
    'booking-details-save-credit-note': 'Save Credit Note',
    //Payment method detail component
    'payment-method-detail-payment-title': 'Payment method',
    'payment-method-detail-payment-date': 'Payment date',
    'payment-method-detail-payment-multi-payment-expand': 'Credit Terms and Credit/Debit Card',
    'payment-method-detail-payment-credit-terms': 'Credit Terms',
    'payment-method-detail-payment-credit-card': 'Credit/Debit Card',
    'payment-method-detail-payment-true-money': 'TrueMoney Wallet',
    'payment-method-detail-payment-corporate-fleet': 'Corporate fleet card',
    'payment-method-detail-payment-personal-fleet': 'Personal fleet card',
    'payment-method-detail-payment-date-credit-card': 'Payment Date',
    'payment-method-detail-payment-date-credit-terms': 'As we have agreed on credit terms',
    'payment-method-detail-payment-date-credit-terms-no-charge': 'No payment has been charged to your company.',
    'payment-method-detail-payment-date-true-money-no-charge': 'No payment has been charged to your TrueMoney Wallet account.',
    'payment-method-detail-payment-date-credit-card-no-charge': 'No payment has been charged to your issuing bank.',
    'payment-method-detail-payment-date-fleet-no-charge': 'No payment has been charged to your fleet card.',
    'payment-method-detail-payment-date-payment-no-charge': 'No payment has been charged to your account.',
    'payment-method-detail-payment-date-refund-policy': 'Refund policy',
    'payment-method-detail-payment-date-refund-policy-details-credit-card': 'We processes refunds immediately after booking cancelled. Credit card holders will receive the refunded amount in their next billing cycle. For debit cards, the amount will be returned within 30-60 days.',
    'payment-method-detail-payment-date-refund-policy-details-true-money': ' We processes refunds immediately after booking cancelled. True Money account holder will receive a refund to the True Money Wallet within 14-30 working days.',
    'payment-method-detail-payment-date-refund-policy-details-fleet': 'We processes refunds immediately after booking cancelled.  Fleet card holders will receive the refunded amount within 30 minutes.',
    'payment-method-detail-payment-date-refund-policy-details-payment': 'We are unable to automatically process refunds once a cancellation has been ordered. Customer must make a request for a refund by themselves through the refund request. Please contact <b>Call Center : +66(0) 2-020-2351</b> or <b>Line Official Account : @AscendTravel</b>',
    'payment-method-detail-payment-date-refund-policy-details-e-wallet': 'We processes refunds immediately after booking cancelled. Rabbit LINE Pay account holder will receive a refund to Rabbit LINE Pay within 14-30 working days.',
    // Booking detail component
    'booking-detail-bookingId-ref-number': 'Booking ID',
    'booking-detail-bookingId-hotel-ref': 'Ref. with hotel',
    'booking-detail-booking-date-and-time': 'Booking date/time',
    'booking-detail-details-booking-detail-title': 'Booking details',
    'booking-detail-details-checkin': 'Check-in',
    'booking-detail-details-checkout': 'Check-out',
    'booking-detail-details-from': 'from',
    'booking-detail-details-before': 'until',
    'booking-detail-details-period': 'Period of stay',
    'booking-detail-details-night': 'night',
    'booking-detail-details-room-amount': 'No. of room',
    'booking-detail-details-room': 'room',
    'booking-detail-details-total-max-guest': 'No. of guest',
    'booking-detail-details-max-guest': 'No. of guest',
    'booking-detail-details-adult-text': 'Max',
    'booking-detail-details-child-text': 'Max',
    'booking-detail-details-adult': 'adult',
    'booking-detail-details-child': 'child',
    'booking-detail-details-children': 'children',
    'booking-detail-details-children-age': '(ages {age})',
    'booking-detail-details-room-guest-amount': 'No. of room and guest',
    'booking-detail-details-and': 'and',
    'booking-detail-details-traveller-info-title': 'Guest details',
    'booking-detail-details-traveller-info-table-room-header': 'Room',
    'booking-detail-details-traveller-info-table-guest-header': 'Guest',
    'booking-detail-details-traveller-info-table-guest-number-header': 'Guest',
    'booking-detail-details-traveller-info-table-supervisor-header': 'Supervisor',
    'booking-detail-details-traveller-info-table-pending-status': 'Awaiting approval',
    'booking-detail-details-traveller-info-table-approved-status': 'Approved',
    'booking-detail-details-traveller-info-table-rejected-status': 'Rejected',
    'booking-detail-details-traveller-info-table-unable-status': 'Cannot approve or reject reservation',
    'booking-detail-details-room-detail-title': 'Room details',
    'booking-detail-details-room-title': '1 room x',
    'booking-detail-details-room-guest': 'Guest',
    'booking-detail-details-room-special-request': 'Special request',
    'booking-detail-cancellation-policy-free-of-charge': 'Free Cancellation if cancel before',
    'booking-detail-details-room-non-refund': 'Special Rate (Non-Refundable)',
    'booking-detail-room-cancellation-policy': "Cancellation policy",
    'booking-detail-cancellation-policy-charge': '- If cancel after {date}, will incur cancellation charge for {currencycode} {cancelFee} per room',
    'booking-detail-room-price-total': 'Total',
    'booking-detail-details-room-benefits': "Benefits & Information",
    'booking-detail-details-booker-information-title': 'Booker information',
    'booking-detail-details-main-booker-information-title': 'Main booker information',
    'booking-detail-details-booker-name': 'Booker name',
    'booking-detail-details-main-booker-name': 'Main booker name',
    'booking-detail-details-booker-id': 'Member ID',
    'booking-detail-details-booker-phonenum': 'Contact number',
    'booking-detail-details-booker-email': 'Email',
    'booking-detail-details-supervisor-fullname': 'Supervisor name',
    'booking-detail-details-supervisor-email': 'Email',
    'booking-detail-details-booker-company-name': 'Company name/Name',
    'booking-detail-details-booker-company-tax': 'Tax ID/Personal ID',
    'booking-detail-details-booker-company-address': 'Tax invoice/Receipt address',
    'booking-detail-details-credit-terms-title': 'Tax invoice information - Credit Terms',
    'booking-detail-details-credit-card-title': 'Tax invoice information - Credit/Debit Card',
    'booking-detail-details-true-money-title': 'Tax invoice information - TrueMoney Wallet',
    'booking-detail-details-co-booker-information-title': 'Co-booker information',
    'booking-detail-details-co-booker-name': 'Co-booker name',
    'booking-detail-arrival-time': 'Arrival time',
    'cart-notify-over-room-limit': 'You can book maximum 9 rooms/booking',
    'cart-notify-add-cart-fail': 'This property cannot be booked temporarily. <br />Please select another property instead. <br />Sorry for the inconvenience.',
    'cart-notify-add-cart-fail-fit-invalid-number-of-adult': 'Sorry, we cannot process your booking. (FIT9)<br />Please contact call center <br />for more information.<br />Call center: +66(0) 2-020-2351',
    // checkout
    'checkout-step1': 'Booking details',
    'checkout-step2': 'Customer information',
    'checkout-step3': 'Payment information',
    'checkout-1-booking-details': 'Booking details',
    'checkout-1-view-map': 'View map',
    'checkout-1-checkin': 'Check-in',
    'checkout-1-checkout': 'Check-out',
    'checkout-1-from': 'from',
    'checkout-1-until': 'until',
    'checkout-1-period': 'Period of stay',
    'checkout-1-night-unit': 'night',
    'checkout-1-room-amount': 'No. of room and guest',
    'checkout-1-room-unit': 'room',
    'checkout-1-guest-amount': 'No. of guest',
    'checkout-1-adult-title': '{X} adult',
    'checkout-1-child-title': '{X} child',
    'checkout-1-children-title': '{X} children',
    'checkout-1-ages': 'ages',
    'checkout-1-and': 'and',
    'checkout-1-year': '',
    'checkout-1-max-adult-title': 'Max {X} adult',
    'checkout-1-max-child-title': '{X} child',
    'checkout-1-max-children-title': '{X} children',
    'checkout-1-room-detail-max-guest': 'No. of guest',
    'checkout-1-adult': 'Adult',
    'checkout-1-child': 'Child',
    'checkout-1-room-detail': 'Room details',
    'checkout-1-room-type': 'Room Type',
    'checkout-1-price-per-night': 'Price/night',
    'checkout-1-night': 'Night',
    'checkout-1-room': 'Room',
    'checkout-1-total': 'Total',
    'checkout-1-note': 'Note',
    'checkout-1-max-adult': 'Max {X} adults',
    'checkout-1-max-child': 'Max {X} children',
    'checkout-1-extrbed': '{X} Extra Bed Incleded',
    'checkout-1-description': 'Description',
    'checkout-1-bed-type-available': '(Cannot be guaranteed)',
    // checkout 2
    'checkout-2-booker-information-title': 'Booker information',
    'checkout-2-guest-information-title': 'Guest information',
    'checkout-2-topic-title': 'Travelling for',
    'checkout-2-booker-name-title': 'Booker name',
    'checkout-2-booker-name-title-more': '(Please enter in English only)',
    'checkout-2-form-firstname-title': 'Name',
    'checkout-2-form-lastname-title': 'Surname',
    'checkout-2-form-full-name-title': 'Booker name',
    'checkout-2-form-email-title': 'Email',
    'checkout-2-form-number-title': 'Phone number',
    'checkout-2-form-nationality-title': 'Nationality',
    'checkout-2-button-add-guest': 'Add guest',
    'checkout-2-button-display-more-details': 'Add special request',
    'checkout-2-button-display-hide-details': 'Hide special request',
    'checkout-2-room-number-title': 'Room',
    'checkout-2-guest-number-title': 'Guest name',
    'checkout-2-guest-number-title-without-index': 'Guest name',
    'checkout-2-button-delete-guest': 'Delete guest',
    'checkout-2-special-request-title': 'Special request',
    'checkout-2-special-request-title-eng-only': 'Special request (Please enter in English only)',
    'checkout-2-special-request-english-only': 'Special request must input in english only',
    'checkout-2-special-request-legend': 'We\'ll send your request right after you book. Special request cannot be guaranteed and may incur charges, but the property will do its best to meet your wish.',
    'checkout-2-form-require-full-name': 'Please enter your first name and last name.',
    'checkout-2-form-invalid-full-name': 'Please enter your name in English only.',
    'checkout-2-form-require-firstname': 'Please enter your first name.',
    'checkout-2-form-require-lastname': 'Please enter your last name.',
    'checkout-2-form-invalid-firstname': 'Please enter your first name in English only.',
    'checkout-2-form-invalid-lastname': 'Please enter your last name in English only.',
    'checkout-2-form-require-mobile-number': 'Please enter your phone number.',
    'checkout-2-form-invalid-mobile-number': 'Please enter a valid phone number.',
    'checkout-2-form-require-booker-email': "Please enter your email.",
    'checkout-2-form-invalid-booker-email': "Your email is incorrect. Please check and try it again.",
    'checkout-2-form-require-guest-firstname': 'Please enter guest name.',
    'checkout-2-form-require-guest-lastname': 'Please enter guest surname.',
    'checkout-2-form-require-guest-full-name': 'Please enter guest\'s first name and last name.',
    'checkout-2-form-require-guest-email': "Please enter guest's email.",
    'checkout-2-form-require-guest-nationality': "Please enter guest's nationality.",
    'checkout-2-form-invalid-guest-firstname': 'Guest name must input in english only.',
    'checkout-2-form-invalid-guest-lastname': 'Guest surname must input in english only.',
    'checkout-2-form-invalid-guest-email': 'Guest email is incorrect. Please check and try it again.',
    'checkout-2-autocomplete-remove-guest': 'Remove',
    'checkout-2-save-new-guest': 'Save this guest to the list',
    'checkout-2-tooltips-save-new-guest': 'Maximum 50 guests',
    'checkout-2-form-hint-full-name': 'As in Passport/Official ID Card (without title/special characters)',
    'checkout-2-form-full-name-placeholder': 'Full name',
    'checkout-2-attach-file-upload-fail': 'Upload file fail',
    'checkout-2-attach-file-upload-fail-press-try-again': 'Please try agian.',
    'checkout-2-send-email-and-sms-traveller': 'We will send confirmation to this email and phone number.',
    'checkout-2-send-email-and-sms-booker': 'We will send confirmation to this email and phone number.',
    'checkout-2-arrival-time-title': 'Arrival information',
    'checkout-2-arrival-time-check-in': 'Check-in:',
    'checkout-2-arrival-time-description': 'Let the property know your planned arrival time.',
    'checkout-2-arrival-time-property-local-time': 'Property local time',
    'checkout-2-booker-for-other-employee-title': 'Booker for other employee',
    'checkout-2-booker-for-other-employee-sub-title': 'Please select checkbox to retrieve employee data.',
    'checkout-2-addtional-traveller-field-place-holder': 'Enter',
    'checkout-2-full-name-invalid-not-exist-company': 'Guest name not exist in your company. Please check and try again.',
    'checkout-2-full-name-invalid-duplicate': 'This guest already been selected. Please check and try again.',
    'checkout-2-full-name-invalid-credit-terms-off': 'Guest not allow to use credit terms.',
    'checkout-2-full-name-invalid-over-lap': 'Guest already have a booking in this period.',
    'checkout-2-full-name-invalid-restrict': 'This guest cannot book the accommodations in this destination due to company’s policy.',
    'checkout-2-full-name-invalid-no-approval': 'Guest has no supervisor email, please contact call center +66(0)2-020-2351.',
    'checkout-2-full-name-invalid-no-full-name': 'This guest has no full name, please contact call center +66(0)2-020-2351.',
    'checkout-2-over-budget-travel-policy': 'Guest has special budget limit in this destination THB {budget} /room/night',
    'checkout-2-over-budget': 'Guest has budget limit THB {budget} /room/night',
    'checkout-2-over-co-budget': 'Guest has budget limit for booking with 2 guests at THB {budget} /room/night.',
    // checkout 3
    'checkout-3-tooltip-label-diff': 'ต่างกันอย่างไร ?',
    'checkout-3-tooltip-label-work': 'ทำงาน',
    'checkout-3-tooltip-label-leisure': 'ท่องเที่ยว',
    'checkout-3-tooltip-desc-work': 'จองทริปทำงานสำหรับผู้เดินทางติดต่อธุรกิจได้อย่างง่ายดาย',
    'checkout-3-tooltip-desc-leisure': 'ค้นหาที่พักยอดเยี่ยมสำหรับทริปทุกรูปแบบ โดยการจองดังกล่าวจะไม่เชื่อมโยงกับบัญชีชองบริษัท',
    'checkout-3-label-custom-payment-paynow-topic': 'Select payment date',
    'checkout-3-label-select-payment-method': 'Select payment method',
    'checkout-3-label-custom-payment-paynow': 'Pay now',
    'checkout-3-label-custom-payment-paylater': 'Pay later',
    'checkout-3-label-custom-payment-paylater-sub-title': 'Book now, pay on ',
    'checkout-3-label-credit-card-infomation': 'Enter your card information',
    'checkout-3-label-tax-invoice-infomation': 'Tax Invoice/​Receipt Information',
    'checkout-3-label-month': 'Month',
    'checkout-3-label-year': 'Year',
    'checkout-3-label-card-number': 'Credit/debit card no.',
    'checkout-3-label-card-name': 'Card holder name',
    'checkout-3-label-card-expire-date': 'Expiry date',
    'checkout-3-label-card-cvv': 'CVC/CVV',
    'checkout-3-label-book-now': 'Book now,',
    'checkout-3-label-pay-on': 'Payment date for credit/debit card',
    'checkout-3-label-valid-until': 'Your credit card must valid until',
    'checkout-3-label-payment-detail': 'Payment details',
    'checkout-3-label-payment-multi-detail': 'Payment information',
    'checkout-3-label-payment-added-credit-card': 'Payment date for credit/debit card will be',
    'checkout-3-label-payment-added-pay-on': 'Payment date for credit/debit card',
    'checkout-3-label-payment-will-be': 'will be',
    'checkout-3-label-payment-credit-terms-tax-info': 'Tax invoice/Receipt information - Credit terms',
    'checkout-3-label-payment-credit-terms-tax-info-booker': 'Your Tax invoice/Receipt information - Credit terms',
    'checkout-3-label-payment-credit-terms-tax-info-co-booker': 'Co-booker Tax invoice/​Receipt information - Credit terms',
    'checkout-3-label-payment-credit-card-tax-info': 'Tax invoice/​Receipt information - Credit/debit card',
    'checkout-3-label-payment-true-money-tax-info': 'Tax invoice/​Receipt information - TrueMoney Wallet',
    'checkout-3-label-payment-tax-description-true-money': 'Tax invoice/​Receipt information - TrueMoney Wallet',
    'checkout-3-label-payment-qr-code-tax-info': 'Tax invoice/​Receipt information - QR Code',
    'checkout-3-label-payment-e-wallet-tax-info': 'Tax invoice/​Receipt information - E-Wallet',
    'checkout-3-label-payment-pay-at-counter-tax-info': 'Tax invoice/​Receipt information - Pay at Counter',
    'checkout-3-label-payment-im-banking-tax-info': 'Tax invoice/​Receipt information - Internet/Mobile Banking',
    'checkout-3-label-payment-tax-description-credit-term': 'Tax invoice/​Receipt information - Credit terms',
    'checkout-3-label-payment-tax-description': 'Tax invoice/​Receipt information - Credit/debit card',
    'checkout-3-label-multi-payment-info-edit-budget': 'Edit budget',
    'checkout-3-label-multi-payment-main-info': 'Pay with ',
    'checkout-3-label-multi-payment-extra-info': 'Pay with ',
    'checkout-3-label-multi-payment-info-credit-card': 'credit/debit card',
    'checkout-3-label-multi-payment-info-true-money': 'trueMoney wallet',
    'checkout-3-label-multi-payment-info-personal-fleet': 'personal fleet card',
    'checkout-3-label-multi-payment-info-personal-fleet-additional': 'personal fleet card',
    'checkout-3-label-multi-payment-info-corporate-fleet': 'corporate fleet card',
    'checkout-3-label-multi-payment-info-credit-terms': 'credit terms',
    'checkout-3-label-multi-payment-change-payment': 'Change payment',
    'checkout-3-label-night': 'night',
    'checkout-3-label-dot': '.',
    'checkout-3-label-multi-payment-info-budget-not-found': 'Do you have a budget limit?',
    'checkout-3-label-multi-payment-info-add-budget': 'Add budget',
    'checkout-3-label-multi-payment-info-reset': 'Reset',
    'checkout-3-label-multi-payment-info-not-reach-grand-total': 'Amount must be at least THB',
    'checkout-3-label-multi-payment-info-exceed-total-price': 'Amount exceed total price, maximum THB',
    'checkout-3-label-multi-payment-exceed-fleet-card': 'Amount exceed your card balance amount, maximum THB',
    'checkout-3-label-multi-payment-info-exceed-budget-limit': 'Amount exceed your budget limit, maximum THB',
    'checkout-3-label-multi-payment-info-exceed-budget-remaining': 'Amount exceed your remaining budget, maximum THB',
    'checkout-3-label-multi-payment-share-budget-least-booker': 'Your amount must be at least THB',
    'checkout-3-label-multi-payment-info-exceed-budget-limit-co-booker': 'Amount exceed co-booker budget limit, maximum THB',
    'checkout-3-label-multi-payment-info-exceed-budget-remaining-co-booker': 'Amount exceed co-booker remaining budget, maximum THB',
    'checkout-3-label-multi-payment-share-budget-least-co-booker': 'Co-booker mount must be at least THB',
    'checkout-3-label-credit-terms-info-title': 'Your credit terms information',
    'checkout-3-label-credit-terms-info-title-co-booker': 'Co-booker credit terms information',
    'checkout-3-label-credit-terms-info-desc': 'We will process to issue invoice to your company as per credit terms agreed.',
    'checkout-3-label-credit-terms-info-desc-co-booker': 'We will process to issue invoice to co-booker company as per credit terms agreed.',
    'checkout-3-label-credit-card-info-title': 'Credit/debit card information',
    'checkout-3-label-credit-terms-info-co-booker-email': 'Co-booker :',
    'checkout-3-label-credit-terms-info-traveller-title': 'Credit terms information for guest',
    'checkout-3-label-credit-terms-info-traveller-email': 'Guest',
    'checkout-3-label-desc-credit-term': 'You have select Credit Term as payment method.',
    'checkout-3-label-sub-desc-credit-term': 'We will process to issue invoice to your company as per Credit Terms agreed.',
    'checkout-3-label-fund-code': 'Company Reference Code (Optional)',
    'checkout-3-label-cost-center': 'Cost Center',
    'checkout-3-label-set-default': 'Use your cost center',
    'checkout-3-label-cost-center-name': 'Cost Center Name',
    'checkout-3-placeholder-cost-center': 'Enter Cost Center here',
    'checkout-3-placeholder-cost-center-name': 'Enter Cost Center Name here',
    'checkout-3-form-cost-center-required': 'Please enter ',
    'checkout-3-form-cost-center-name-required': 'Please enter ',
    'checkout-3-form-cost-center-name-invalid': '{text} is incorrect. Please enter {text} again.',
    'checkout-3-label-cost-center-dropdown': 'Please select ',
    'checkout-3-label-internal-order-dropdown': 'Please select ',
    'checkout-3-form-dropdown-placeholder': 'Select',
    'checkout-3-form-dropdown-required': 'Please select',
    'checkout-3-form-free-text-placeholder': 'Enter',
    'checkout-3-form-free-text-required': 'Please enter',
    'checkout-3-form-attachment-required': 'Please attach file.',
    'checkout-3-placeholder-card-number': '●●●● ●●●● ●●●● ●●●●',
    'checkout-3-placeholder-card-name': 'Card holder name',
    'checkout-3-placeholder-card-cvv': 'CVC/CVV',
    'checkout-3-placeholder-fund-code': 'Enter company reference code here',
    'checkout-3-placeholder-expire-date': 'dd/yy',
    'checkout-3-form-require-card-number': 'Please enter card number',
    'checkout-3-form-invalid-card-number': 'Card number is incorrect. Please check and try it again.',
    'checkout-3-form-invalid-card-number-not-support': 'The card you entered cannot be used for this payment.',
    'checkout-3-form-require-card-name': 'Please enter name on card',
    'checkout-3-form-invalid-card-name': 'Name on card must input in english only.',
    'checkout-3-form-require-card-cvv': 'Please enter CVC/CVV number.',
    'checkout-3-form-invalid-card-cvv': ' CVV number is incorrect. Please check and try it again.',
    'checkout-3-form-require-card-exp-date': 'Please enter card expiry date',
    'checkout-3-form-invalid-card-exp-date': 'Card expire date invalid.',
    'checkout-3-form-invalid-card-expire-pay-on': 'Cannot use this card due to the card expires before payment date',
    'checkout-3-require-tax-address': 'Please select tax invoice or receipt information',
    'checkout-3-error-cannot-create-booking': 'Your reservation is failed.<br/>Please try it again.',
    'checkout-3-error-limit-room': 'Your right for reservation has changed.<br/>Please check and try it again.',
    'checkout-3-error-limit-budget': 'Your budget limit has changed.<br/>Please check and try it again.',
    'checkout-3-address-edit-failure-title': 'Update tax infomation fail.',
    'checkout-3-error-cannot-get-dropdown-list': 'Get tax address list fail.',
    'checkout-3-default-dropdown': 'Please Select',
    'checkout-3-error-supervisor-email-invalid': 'Sorry, we cannot process your booking. Please contact call center to verify your supervisor email.<br/>Call center : +66(0) 2-020-2351',
    'checkout-3-error-credit-term-not-allow': 'Credit Terms not allowed for your reservation. Please contact call center for more information.<br/> Call center: +66(0) 2-020-2351',
    'checkout-3-error-multi-payment-not-allow': 'Sorry, you don\'t have a permission to book accommodations over your budget. Please contact call center for more information. <br/> Call center: +66(0) 2-020-2351',
    'checkout-3-error-credit-term-over-trip-budget': 'Credit Terms Amount Exceeds Approved Trip Budget<br>The approved trip budget is THB {totalTripBudget}.<br>Please adjust the credit terms amount or select another hotel and try again.',
    'checkout-3-true-money-title': 'TrueMoney Wallet information',
    'checkout-3-true-money-payment': 'ชำระเงินผ่านบัญชีทรูมันนี่',
    'checkout-3-true-money-payment-recheck': 'Add enough money before making a payment',
    'checkout-3-true-money-phone-no': 'TrueMoney Wallet phone number',
    'checkout-3-true-money-phone-no-empty': 'Please enter TrueMoney Wallet phone number.',
    'checkout-3-true-money-phone-pattern': 'Please enter a valid phone number.',
    'checkout-3-true-money-box-text-1': 'Payment date for TrueMoney Wallet',
    'checkout-3-true-money-box-text-2': 'will be',
    'checkout-3-true-money-true-point-short': 'ทุกการใช้จ่าย 25 บาท รับ 1 ทรูพอยท์',
    'checkout-3-require-payment-method': 'กรุณาเลือกช่องทางการชำระเงิน',
    'checkout-3-true-money-note': 'หมายเหตุ',
    'checkout-3-true-money-note-0': 'มูลค่าชำระทุก 25 บาท สำหรับการชำระเงินด้วย ทรูมันนี่ วอลเล็ท ได้รับ 1 ทรูพอยท์ ต่อ 1 รายการ ต่อ 1 หมายเลขบัตรประชาชน',
    'checkout-3-true-money-note-1': 'ลูกค้าจะได้รับทรูพอยท์ ภายใน 30 วันทำการหลังจากสั่งสินค้าผ่าน https://traveltogether.ascendtravel.com และจ่ายด้วย ทรูมันนี่ วอลเล็ท โดยจำกัดสิทธิ์ 100 ทรูพอยท์ / 1 บัตรประชาชน ตลอดระยะเวลาแคมเปญ',
    'checkout-3-true-money-note-2': 'รายการส่งเสริมการขายนี้ ดำเนินการโดยบริษัท ทรูมันนี่ จำกัด',
    'checkout-3-true-money-note-3': 'หากมีข้อสงสัย กรุณาติดต่อ TrueMoney Customer Care 1242 ตลอด 24 ชั่วโมง',
    'checkout-3-label-main-payment': 'Main payment',
    'checkout-3-label-additional-payment': 'Extra payment by yourself',
    'checkout-3-label-place-holder-payment': 'Please select payment method...',
    'checkout-3-label-additional-payment-error': 'Please select payment method.',
    'checkout-3-label-approximate-price-in': 'Approximate price in',
    'checkout-3-qr-code-title': 'QR Code',
    'checkout-3-e-wallet-title': 'E-Wallet',
    'checkout-3-im-banking-title': 'Internet/Mobile Banking',
    'checkout-3-im-banking-payment-channel': 'Mobile Banking / Internet Banking',
    'checkout-3-pay-at-counter-title': 'Pay at Counter',
    'checkout-3-pay-at-counter-bank-counter': 'Bank Counter',
    'checkout-3-pay-at-counter-other-counter': 'Other Counter',
    'checkout-3-payment-method-line1': 'We will inform you of payment methods on the next page.',
    'checkout-3-payment-method-line2': 'Please complete payment within 15 minutes to avoid cancellation of your booking.',
    'checkout-3-payment-method-line2-30': 'Please complete payment within 30 minutes to avoid cancellation of your booking.',
    'checkout-3-payment-method-line3-2c2p': 'Payments to Ascend Travel are processed by 2C2P SERVICE.',
    'checkout-3-payment-method-line3-123': 'Payments to Ascend Travel are processed by 123 SERVICE.',
    'checkout-3-payment-method-remark-line1': 'Additional service fees may be charged when you pay at the counter. (Additional service fees are non-refundable)',
    'checkout-3-payment-method-remark-line2': 'After completing payment You will receive a booking confirmation email within 2 hours. If you do not receive the email in the specified time, please contact',
    'checkout-3-payment-method-remark-line2-call-center': 'Call Center : +66(0) 2-020-2351',
    'checkout-3-payment-method-remark-line2-or': 'or',
    'checkout-3-payment-method-remark-line2-line': 'Line Official Account : @AscendTravel',
    'checkout-3-warning-please-make-payment': 'Please make payment within 15 minutes',
    'checkout-3-warning-please-make-payment-30': 'Please make payment within 30 minutes',
    'checkout-3-warning-avoid-cancellation': 'to avoid cancellation of your booking.',
    'checkout-3-warning-press': 'Please press',
    'checkout-3-warning-confirm-to-book': '"Confirm to book"',
    'checkout-3-warning-to-proceed': 'to proceed.',
    'checkout-3-payment-channel': 'Payment Channels',
    'checkout-3-payment-method': 'Payment Method',
    'checkout-3-payment-method-remark-title': 'Remark',
    // billing address component
    'checkout-3-label-billing-infomation': 'Bill To Information',
    'checkout-3-billing-address-name': 'Bill To',
    'checkout-3-billing-address-name-placeholder': 'Input Bill to Name/Surname',
    'checkout-3-billing-address-phone': 'Contact Number',
    'checkout-3-billing-address-phone-placeholder': '0XXXXXXXXX',
    'checkout-3-billing-address-address': 'Bill to Address',
    'checkout-3-billing-address-address-address-placeholder': 'Input bill to address here',
    'checkout-3-billing-validation-required-name': 'Please input bill to name',
    'checkout-3-billing-validation-required-phone': 'Please input contact number',
    'checkout-3-billing-validation-required-address': 'Please input bill to address',
    'checkout-3-billing-validation-invalid-name': 'Bill to name must be a-z A-Z',
    'checkout-3-billing-validation-invalid-phone': 'Contact number must be 0-9, 9 or 10 digits only',
    'checkout-3-billing-validation-invalid-address': 'Please input bill to address',
    'checkout-3-require-internal-order': 'Please enter ',
    'checkout-3-require-billing-address': 'Please select billing address',
    'checkout-3-billing-dialog-delete-button': 'Delete',
    'checkout-3-billing-delete-success': 'Delete Successful',
    'checkout-3-billing-delete-failure': 'Delete Failure',
    'checkout-3-billing-failure-text-try-again': 'Please try agian.',
    'checkout-3-billing-add': 'add billing address',
    'checkout-3-billing-edit': 'edit billing address',
    'checkout-3-billing-confirm-delete-msg': 'Are you sure you want to delete this information?',
    'checkout-3-billing-confirm-cancel-editing': 'You have not finished {dataType} yet. Do you want to leave without finishing?',
    'checkout-3-attach-file-title': 'File Attachment',
    'checkout-3-attach-file-choose-button': 'File Attachment',
    'checkout-3-attach-file-guide': 'Can attach up to 5 files and must be .jpg, .pdf, .png, .msg, .eml maximum size 2 MB only.',
    'checkout-3-attach-file-validation-invalid-file-type': 'Cannot support file format you have attached. You can attached file format .jpg, .pdf, .png, .msg, .eml only.',
    'checkout-3-attach-file-validation-file-size-overflow': 'The attachment size exceeds the allowable limit. You can attached file maximum size 2 MB only.',
    'checkout-3-attach-file-validation-file-not-attached': 'Please attach file.',
    'search-popup-checkbox-label': 'Do not show this message again',
    'popup-warning-session-expire': 'Your session will expire almost immediately.<br/>Please click OK to renew your session.',
    // Approval action
    'approval-action-success-approve': 'Approve reservation successfully.',
    'approval-action-success-reject': 'Rejected reservation successfully.',
    'approval-action-after-done': 'Cannot approve/reject reservation.',
    'approval-action-after-done-desc': 'Because you have already approved/rejected or traveller already check-in.',
    'approval-action-after-cancel': 'Cannot approve/reject reservation.',
    'approval-action-after-cancel-desc': 'Because booker has already cancelled this booking.',
    'approval-action-fail-service': 'Process is not successful.',
    'approval-action-fail-service-desc': 'Please try again.',
    'approval-action-thankyou-1': 'Thank you for your trust in using Ascend Travel\'s services.',
    'approval-action-thankyou-2': 'You can contact us via Call Center +66(0) 2-020-2351.',
    'approval-action-btn-home': 'Go to home',
    'approval-action-btn-approval-list': 'Go to approval',
    'approval-action-unable-approval': 'You cannot approve or reject booking.',
    'approval-action-unable-approval-detail': 'Please check your approval list at menu "Approval".',
    'approval-action-unable-approval-or-reject-detail': 'You cannot confirm or reject booking.',
    'approval-cancellation-credit-card': "Cancellation fee charge to card holder's credit/debit card",
    'notify_accept_terms_conditions': 'ฉันยอมรับเงื่อนไข / I accept those conditions.',
    'notify_accept_terms_conditions_validation_accept': 'กรุณายอมรับเงื่อนไข / Please accept terms and condition.',
    // Krung sri
    'notify_accept_terms_conditions_message_krungsri': 'I acknowledge and agree that I will attach the form approved by the authorized person in order to book hotel for “work” In this case, invoices shall be issued by Ascend Travel to your Company. However, I agree and acknowledge that within 7 days of the Company’s request, I will make a payment for the cost and expenses charged by Ascend Travel to the Company if I didn’t check-in without reasonable reasons. For the booking for “leisure”, I pay by myself.',
    // Osotspa
    'notify_accept_terms_conditions_message_osotspa': 'I hereby agree to always comply with these booking terms and conditions.',
    'rating-header': 'What did you think of',
    'rating-check-in': 'Check-in',
    'rating-check-out': 'Check-out',
    'rating-star-1': 'Awful',
    'rating-star-2': 'Disappointing',
    'rating-star-3': 'Satisfactory',
    'rating-star-4': 'Good',
    'rating-star-5': 'Excellent',
    'rating-submit': 'Submit Review',
    'rating-error-select-satisfaction': 'Please select your satisfaction.',
    'rating-message-thankyou': 'Thank You for your review.<br/>Your feedback will help the hotel to improve and helps other travellers make the right decision.',
    'rating-header-animal': 'Have you seen any of these following creepy things?',
    'rating-summarize-header-1': 'Title of your review',
    'rating-summarize-placeholder-1': 'Summarize your visit or highlight an interesting detail',
    'rating-summarize-header-2': 'Your review',
    'rating-summarize-placeholder-2': 'Tell people about your experience: your room, location, amenties?',
    'rating-summarize-error': 'Please summarize your visit or highlight an interesting detail.',
    'rating-img-error': 'The file exceeds 2 MB.',
    'hide-name': 'Hide my name',
    'rating-photo-header': 'Do you have photos to share?',
    'rating-photo-subtitle': 'Maximum 5 Photos. File can be .png, jpeg or .jpg with maximum file size 2 MB.',
    // Banner promotion
    'banner-topic': 'Today\'s Deals',
    'banner-sub-topic': 'Exclusive promotions, discounts, and special offers just for you.',
    'banner-book-period': 'Book Period',
    'banner-stay-period': 'Stay Period',
    'banner-btn-book': 'Book',
    // Confirmation supplier
    'confirmation-supplier-email-reject': 'Please input your name to reject reservation from Ascend Travel',
    'confirmation-supplier-email-confirm': 'Please input your name to confirm reservation from Ascend Travel',
    'confirmation-supplier-email-confirm-title': 'Confirmed by',
    'confirmation-supplier-email-confirm-title-error': 'Please input Confirmed by',
    'confirmation-supplier-email-confirm-confirm-number': 'Confirmation Number (Optional)',
    'confirmation-supplier-email-reject-title': 'Rejected by',
    'confirmation-supplier-email-reject-title-error': 'Pease input Rejected by',
    'confirmation-supplier-email-reject-reason': 'Reason',
    'confirmation-supplier-email-reject-reason-error': 'Please input Reason',
    'confirmation-supplier-email-reject-topic-title': 'Please input your name to reject reservation from Ascend Travel',
    'confirmation-supplier-email-confirm-topic-title': 'Please input your name to confirm reservation from Ascend Travel',
    'confirmation-supplier-email-confirm-status-success': 'You have confirmed booking reservation from Ascend Travel',
    'confirmation-supplier-email-reject-status-success': 'You have rejected booking reservation from Ascend Travel',
    'confirmation-supplier-email-already': 'Because you have already confirmed/rejected.',
    'confirmation-supplier-email-placeholder-confirmed-by': 'Name/Surname',
    'confirmation-supplier-email-placeholder-confirmation-number': 'Confirmation Number',
    'confirmation-supplier-email-placeholder-rejected-by': 'Name/Surname',
    'confirmation-supplier-email-placeholder-reason': 'Reason to Reject',
    // Promotion
    'promotion-promotion-code-title': 'Promotion Code',
    'promotion-promotion-code-error': 'Please input Promotion Code',
    'promotion-promotion-code-button-submit': 'Submit',
    'promotion-promotion-code-topic-title': 'Please input Promotion Code',
    'promotion-promotion-code-error-invalid-message': 'Promotion code is invalid',
    'promotion-promotion-code-error-used-message': 'Promotion code has already used',
    'promotion-thankyou-title1': 'Your Booking No.',
    'promotion-thankyou-title2': 'is in progress',
    'promotion-thankyou-description': 'You will receive email confirmation again.',
    'promotion-promotion-code-error-invalid-link': 'This link has been removed from system.',
    'promotion-promotion-code-error-use-full': 'Sorry, this promotion code has been fully used already. ',
    'promotion-thankyou-status-timeout-title': 'Please contact call center to check your booking',
    'promotion-thankyou-status-timeout-text': "There was an error while processing your booking. Call center +66 (0)2-020-2351",
    // Condition
    'condition-selling-price-in-budget-title': 'Room price has changed as the following details.',
    'condition-selling-price-over-budget': 'The price exceeds your budget.',
    'condition-selling-price-in-budget-column': 'Room Type,Original Price per night,New Price per night',
    'condition-limit-room-title': 'Your booking condition is limited to a maximum of ${var} rooms.',
    'condition-cancellation-policy-title': 'The cancellation policy has changed as the following details.',
    'condition-cancellation-policy-column': 'Room Type,New Cancellation Policy',
    'condition-cancellation-policy-baht': 'If you cancel after ${var}, THB ${var} cancellation fees will be charged.',
    'condition-cancellation-policy-non-refundable': 'Non-refundable in any cases of cancellation',
    'condition-cancellation-policy-free-of-charge': 'Free Cancellation if cancellation is before ${var}.',
    'condition-free-cancellation': 'Free Cancellation',
    'condition-cancellation-policy-pay-now': 'Payment condition has changed <br/> from the original payment date of ${var}<br/> to be pay now.',
    'condition-cancellation-policy-pay-later': 'Payment condition has changed <br/> from the original payment date of today<br/> to ${var}.',
    'condition-cancelltaion-policy-pay-later-from-to': 'Payment condition has changed <br/> from the original payment date of ${var}<br/> to ${var}.',
    'condition-offer-type-title': 'Room condition has changed as the following details',
    'condition-offer-type-column': 'Room Type,Original Details,New Details',
    'condition-no-available-room-title': 'There is no available room in your preferred period.',
    'condition-button-accept': 'Accept',
    'condition-button-back-to-search': 'Back to Search',
    'condition-offer-type-breakfast-include': 'Breakfast Included',
    'condition-offer-type-breakfast-not-include': 'No Breakfast',
    'condition-aad-userid-not-exist': 'User not found',
    'condition-user-not-active-or-not-approve': 'User is inactive',
    'condition-period-overlaps-title': 'The selected period overlaps with the existing booking.',
    'condition-period-overlaps-description': 'You already have a booking in this period.',
    'condition-period-overlaps-share-budget-description': 'You or your co-booker already have a booking in this period.',
    'condition-restrict-destination-title': 'You cannot book the accommodations in this destination.',
    'condition-restrict-destination-description': 'This accommodation cannot be reserved at the destination which is in your working area. Please click OK and make a new selection.',
    'condition-restrict-destination-co-booker-title': 'You cannot book the accommodations in this destination.',
    'condition-restrict-destination-co-booker-description': 'Your company or co-booker company does not allow to book the accommodations in the selected destination.',
    'condition-some-guest-not-exist-in-your-comany': 'Some guest not exist in your company.',
    'condition-some-guest-not-allow-to-use-credit-terms': 'Some guest not allow to use credit terms.',
    'condition-some-guest-already-have-a-booking-in-this-period': 'Some guest already have a booking in this period.',
    'condition-some-guest-has-no-supervisor-email': 'Some guest has no supervisor email, please contact call center +66(0)2-020-2351.',
    // Mice
    'mice-quotation-title': 'Partner with us for the best solution.',
    'mice-quotation-sub-title': 'Please tell us about your event, we will be in touch with you shortly.',
    'mice-quotation-placeholder-dropdown': 'Please select service type',
    'mice-quotation-destination': 'Destination',
    'mice-quotation-start-date': 'Start Date',
    'mice-quotation-end-date': 'End Date',
    'mice-quotation-attendees': 'Attendees',
    'mice-quotation-budget': 'Budget (THB)',
    'mice-quotation-special-request': 'Special request',
    'mice-quotation-contact-title': 'Contact Information',
    'mice-quotation-contact-name': 'Contact Name',
    'mice-quotation-contact-company': 'Company Name',
    'mice-quotation-contact-phone': '0XXXXXXXXX',
    'mice-quotation-contact-email': 'email@mail.com',
    'mice-quotation-description-service': 'If you need additional services, please select the main service and specify more details in the additional field below.',
    'mice-quotation-description-date': 'If you cannot define the service date, you can just specify the period in the additional field below.',
    'mice-quotation-warning-placeholder-dropdown': 'Please select service type.',
    'mice-quotation-warning-contact-name': 'Please enter your name.',
    'mice-quotation-warning-zero-budget': 'Budget must be greater than 0 baht.',
    'mice-quotation-warning-zero-attendees': 'Attendees must be greater than 0.',
    'mice-quotation-warning-contact-company': 'Please enter your company name.',
    'mice-quotation-warning-contact-phone': 'Please enter your contact number.',
    'mice-quotation-warning-contact-email': 'Please enter your email.',
    'mice-quotation-button-submit': 'Submit information',
    'mice-quotation-popup-sent': 'Information has been sent!<br/> We will get back to you shortly',
    'mice-quotation-popup-fail': 'Sorry, something went wrong.<br/> Please try again',
    'mice-our-service-heading': 'Our Services',
    'mice-our-service-seminar': 'Seminar Management',
    'mice-our-service-seminar-sub-title': '(Seminar Management / MICE)',
    'mice-our-service-team-building': 'Team Building',
    'mice-our-service-team-building-sub-title': '(Team Building / Camp Project / Rally)',
    'mice-our-service-group-tour': 'Group Tour',
    'mice-our-service-group-tour-sub-title': '(Group Tour / Incentive Group)',
    'mice-our-service-party': 'Party and Event',
    'mice-our-service-party-sub-title': '(Staff Party / Private Party / Merit-making Ceremony)',
    'mice-our-service-csr': 'CSR Activity',
    'mice-our-service-csr-sub-title': '',
    'mice-our-service-private-jet': 'Private Jet',
    'mice-our-service-private-jet-sub-title': '',
    'mice-our-service-car-rental': 'Car Rental',
    'mice-our-service-car-rental-sub-title': '',
    'mice-our-service-ticket': 'Ticket & Visa Service',
    'mice-our-service-ticket-sub-title': '',
    'mice-benefit-title-easy': 'Easy',
    'mice-benefit-easy': 'Fill in all information in one place.',
    'mice-benefit-title-convenience': 'Convenience',
    'mice-benefit-convenience': 'Anywhere, Anytime, Any devices.',
    'mice-benefit-title-stop-service': 'One Stop Service',
    'mice-benefit-stop-service': 'Integrate all services to support all your business type.',
    'mice-benefit-title-professional': 'Professional',
    'mice-benefit-professional': 'Take care by experienced teams to make your perfect trip.',
    'mice-service-choice-tile': 'Partner with us for the best solution',
    'mice-service-choice-sub-title': 'with full services made convenient for bookings everywhere seamlessly. It\'s Free, Fast & Easy.',
    'mice-service-choice-button': 'Click here',
    'mice-service-gallery-title': 'Gallery',
    'mice-validation-pattern-contact-number': 'Contact number must be 0-9, 9-10 digits.',
    'mice-validation-pattern-email': 'Your email is incorrect. Please check and try it again.',
    'booking-cannot-be-processed-error-header': 'The booking cannot be processed',
    'booking-cannot-be-processed-error': 'Please try again.',
    'system-error': 'System error. Please try again.',
    // Dialog Switch Company
    'dialog-switch-company-title': 'Change company to',
    'dialog-switch-company-sub-title': 'For work purpose traveling, your condition will depend on the company setting.',
    'dialog-switch-company-payment-method': 'Payment method',
    'dialog-switch-company-budget': 'Budget per room per night',
    'dialog-switch-company-co-budget': 'Budget per room per night<br/>for 2 persons',
    'dialog-switch-company-budget-per-month': 'Budget per month',
    'dialog-switch-company-budget-per-year': 'Budget per year',
    'dialog-switch-company-tax-address': 'Tax Invoice',
    'dialog-switch-company-allow': 'Allow',
    'dialog-switch-company-allow-credit-terms': 'credit terms',
    'dialog-switch-company-allow-corporate-fleet': 'corporate fleet card',
    'dialog-switch-company-not-allow': 'not allowed',
    'dialog-switch-company-not-allow-credit-terms': 'for your reservation.',
    'dialog-switch-company-not-allow-corporate-fleet': 'Corporate fleet card not allow for your reservation',
    'dialog-switch-company-booking-under': 'If you want to make a booking under',
    'dialog-switch-company-credit-card': ', you can book and pay by credit/debit card.',
    'dialog-switch-company-warning': 'May be changed by your selection at payment step.',
    'dialog-switch-company-limit-room': 'No. of room per booking',
    'dialog-switch-company-room': 'room',
    'dialog-switch-company-multi-payment': 'Book over budget and pay for the exceeding amount by your own',
    'dialog-switch-company-share-budget': 'Share budget with another staff',
    'dialog-switch-company-limit-budget-warning': 'Your budget may vary according to the destination and period of stay.',
    'dialog-switch-company-for': 'for',
    'unlimited-budget': 'Unlimited',
    // Product Review
    'product-review-title': 'Guest Reviews',
    'product-review': 'Review',
    'product-review-date': 'Reviewed on',
    'product-review-order-by-review-date': 'Most recent',
    'product-review-order-by-rating-desc': 'Rating high to low',
    'product-review-order-by-rating-asc': 'Rating low to high',
    'product-review-image': 'Photo from guest',
    'product-review-anonymous': 'Anonymous',
    // Dialog Budget suggestion
    'dialog-budget-suggestion-title': 'Budget limit',
    'dialog-budget-suggestion-desc': 'Your budget will be calculated to fill amount for each payment method, and saved for your next reservation. You can modify budget anytime in this step.',
    'dialog-budget-suggestion-form-btn-submit': 'Apply budget',
    'dialog-budget-suggestion-form-btn-cancel': 'Cancel',
    'dialog-budget-suggestion-label-budget': 'Budget per room per night',
    'dialog-budget-suggestion-form-require-budget': 'Please enter budget per room per night.',
    'dialog-budget-suggestion-form-exceed-limit-budget': 'Amount exceed limit, maximum THB 1,000,000.',
    // Dialog Tax Address
    'dialog-tax-address-title-add-mode': 'Add new Tax Invoice/​Receipt Information',
    'dialog-tax-address-title-edit-mode': 'Tax Invoice/​Receipt Information',
    // Filter Dropdown
    'filter-dropdown-no-results-match': 'No results match',
    'form-autocomplete-no-result': 'No results found',
    // Dialog
    'dialog-close': 'Close',
    'dialog-cancel': 'Cancel',
    'dialog-confirm': 'Confirm',
    // Dropdown
    'default-dropdown': 'Please Select',
    // Dialog confirm close
    'dialog-confirm-close-title': 'Leave this page',
    'dialog-confirm-close-desc': 'Do you want to leave this page without saving?',
    'dialog-confirm-close-cancel': 'Cancel',
    'dialog-confirm-close-confirm': 'Yes, leave',
    'dialog-confirm-change-search': 'Change search',
    'dialog-confirm-change-continue-share-budget': 'Continue',
    'dialog-confirm-cancel-share-budget': 'Cancel share budget',
    // Dialog confirm delete
    'dialog-confirm-delete-title': 'Delete',
    'dialog-confirm-delete-cancel': 'Cancel',
    'dialog-confirm-delete-confirm': 'Delete',
    // Dialog confirm delete address
    'dialog-confirm-delete-address-desc': 'Do you want to delete this address?',
    // PDPA
    'pdpa-btn-accept': 'Accept',
    'pdpa-title': 'Terms of Use and Privacy Policy',
    'pdpa-term-of-use': 'Terms of Use',
    'pdpa-privacy-notice': 'Privacy Policy',
    'cookies-policy': 'Cookies Policy',
    // Dialog Consent
    'dialog-consent-to-website': 'We’re taking you to website',
    'dialog-consent-requesting-permission': 'website is requesting permission to do the following:',
    'dialog-consent-basic-information': 'Access your basic information',
    'dialog-consent-contact-information': 'Access your contact information',
    'dialog-consent-allow': 'Allow',
    'dialog-consent-dont-allow': 'Don’t allow',
    'dialog-consent-full-name-etc': "Includes first name, last name and any other information you've shared with Ascend Travel.",
    // Badge or Notices
    'sanitized-stay': 'Sanitized Stay',
    'sanitized-stay-hover': 'Hygiene and sanitizing standards to ensure the protection of your health and safety',
    'year-of-build-badge': 'Newly built {yyyy}',
    'year-of-renovated-badge': 'New renovated {yyyy}',
    'security-standard-badge': 'Safety Standard',
    'security-standard-badge-hover': 'Hotel property has undergone special inspections for safety standard.',
    // Dialog Budget Available
    'dialog-budget-pay-option': 'You can pay by another options if you are still want to book a room.',
    'dialog-budget-pay-exceeding-option': 'You can pay for the exceeding amount by another options if you are still want to book a room.',
    'dialog-budget-cannot-share-budget-co-booker': 'You cannot share budget with co-booker',
    'dialog-budget-due-to': ' due to ',
    // Dialog Cancel Share Budget
    'dialog-cancel-share-budget-text': 'Do you want to cancel share budget?',
    'dialog-cancel-share-budget-sub-text': 'If you cancel share budget, you can only book accommodations under your budget limit.',
    //Dialog PIN
    'dialog-set-pin-header': 'Set Pin',
    'dialog-confirm-set-pin-header': 'Confirm PIN code',
    'dialog-set-pin-sub-header': 'Set a 6-digit number to maintain account security.',
    'dialog-set-pin-sub-header-2': 'Use PIN code for credit terms payment processing to your company.',
    'dialog-confirm-pin-booking-header': 'Entering the PIN code.',
    'dialog-confirm-pin-booking-sub-header': 'Please enter a 6-digit PIN code for credit terms payment processing to your company.',
    'dialog-confirm-pin-booking-forgot-pin': 'Forgot your PIN?',
    'dialog-confirm-pin-booking-set-new-pin': 'Click to set a new PIN.',
    'dialog-alert-set-pin-title': 'Your account does not have a PIN code set up yet.',
    'dialog-alert-set-pin-description': 'To ensure safety for credit terms payment to the company. Please set a new PIN by yourself.<br> Go to the menu: <b>My Account > Account Security > Set PIN<b>',
    'dialog-alert-btn-confirm-set-pin': 'Set PIN',
    'pin-code-incorrect': 'The PIN code is incorrect.',
    'set-pin-not-matched': 'PIN code is not match with confirm PIN code. Please check and try it again.',
    'pin-too-weak': 'The PIN code is too simple. Please choose a more secure PIN.',
    'pin-remaining-attempts': 'The PIN code is incorrect. Please try again. You have {x} remaining attempts before your PIN code gets locked.',
    'pin-locked': 'Your PIN code has been locked. Please reset your PIN code or contact: Call Center: +66(0) 2-020-2351 / Line Official Account: @AscendTravel',
    'otp-title': 'Identity Verification',
    'otp-select-channel': 'Please select one of the options below to verify your identity.',
    'otp-send-to': 'Send verification code to',
    'otp-resend': 'Resend verification code',
    'otp-reference': 'Ref.: ',
    'otp-code-incorrect': 'The verification code is incorrect.',
    'otp-last-attempts': 'The verification code is incorrect. You have 1 remaining attempt. If you enter the verification code incorrectly again, your account will be temporarily locked.',
    'otp-remaining-attempts': 'The verification code is incorrect. Please try again. You have {x} remaining attempts before your account gets locked.',
    'otp-try-another-way': 'Try another way',
    'setup-pin-success': 'PIN code has been successfully set.',
    'dialog-otp-verify-sub-header': 'We have sent a verification code to',
    'dialog-otp-verify-email-sub-header': 'Please check your email and enter the verification code below within 15 minutes after receiving the email.',
    'dialog-otp-verify-sms-sub-header': 'Please check your message and enter the verification code below within 15 minutes after receiving the message.',
    'email': 'Email',
    'phone': 'Phone',
    'account-locked': 'Your account has been locked. Due to exceeding the allowed number of incorrect verification code entries. For unlocking, please contact: Call Center: +66(0) 2-020-2351 / Line Official Account: @AscendTravel',
    'session-expired': 'Session expired. Please try again.',
    // Dialog Phone
    'dialog-set-phone-header': 'Enter your phone',
    'dialog-set-phone-sub-header': 'Please provide the phone number you want to link to your account.',
    'dialog-set-phone-label-phone-number': 'Phone',
    'dialog-set-phone-require-mobile-number': 'Please enter phone number.',
    'dialog-set-phone-invalid-mobile-number': 'Please enter a valid phone number.',
    'change-phone-success': 'The phone number has been successfully linked to the account.',
    // Budget Limit
    'budget-limit-special-budget-for-destination': 'Special budget for this destination',
    'budget-limit-special-budget-for-poi': 'You budget depends on the selected destination.',
    'budget-limit-special-budget-for-poi-new': 'Your new budget depends on the selected destination.',
    'budget-limit-normal-budget': 'Normal budget',
    'budget-limit-tittle': 'You have special budget limit for this destination',
    'budget-limit-detail': 'You have special budget limit on some days, view your budget limit details as below.',
    'budget-limit-detail-poi': 'You have special budget limit on some days and some areas, view your budget limit details as below.',
    'budget-limit-dialog-detail-poi': 'You have special budget limit for this destination, view your budget limit details as below.',
    'budget-limit-detail-bottom-poi': 'Budget per room per night depends on the selected destination.',
    'budget-limit-net-budget': 'Budget limit/room/night for this period',
    'budget-limit-more-detail': 'More details',
    'budget-limit-day-check-in': 'Stay date',
    'budget-limit-budget-per-night': 'Budget per night',
    'budget-limit-sum-budget-per-night': 'Total budget per night',
    'budget-limit-budget-special': 'Special budget',
    'budget-limit-budget-per-night-per-room': 'Budget per room per night',
    'budget-limit-for-search': 'for the selected period',
    'budget-limit-and': 'and',
    'budget-limit-for': 'For',
    'budget-limit-unlimited': 'Unlimited',
    'budget-limit-view-detail': 'View Details',
    'budget-limit-unlimited-share-budget': 'Your new budget/room/night is unlimited.',
    'budget-limit-share-budget': 'Your new budget limit <strong>{x}</strong> /room/night.',
    'budget-limit-share-budget-title': 'You have shared budget with co-booker and have special budget limit for this destination',
    'budget-limit-share-budget-detail': 'You have special budget limit on some days, view your budget limit details as below.',
    'budget-limit-booker-budget': 'Your budget',
    'budget-limit-co-booker-budget': 'Your co-booker budget',
    'budget-limit-co-booker-budget-new-tab': 'Your co-booker budget',
    'budget-limit-total-budget': 'Total budget per night',
    'budget-limit-normal-budget-booker': 'Your normal budget',
    'budget-limit-normal-budget-co-booker': 'Your co-booker budget',
    'budget-limit-applied-co-budget': '**There is a budget limit for booking with 2 guests.',
    // My Budget
    'my-budget-title': 'User permission & budget',
    'my-budget-under': '{companyName}',
    'my-budget-user-permission-detail-title': 'User permission',
    'my-budget-budget-detail-title': 'Budget',
    'my-budget-month': 'Month',
    'my-budget-budget-used': 'Spending',
    'my-budget-budget-per-month-remaining': ' Remaining budget/month',
    'my-budget-budget-per-year-remaining': 'Remaining budget/year',
    'my-budget-badge-per-month-remaining': 'Remaining budget for',
    'my-budget-badge-per-monht-used': 'You have already spent',
    'my-budget-badge-per-year-remaining': 'Remaining budget for',
    'my-budget-badge-per-year-used': 'You have already spent',
    'my-budget-year': 'Year',
    // Share Budget Code
    'share-budget-code-title': 'Generate share budget code',
    'share-budget-code-content-title': 'Share budget code is the reference code for main booker to share budget with you.',
    'share-budget-code-generate-code': 'Generate code',
    'share-budget-code-copy-code': 'Copy code',
    'share-budget-code-text': 'Share budget code',
    'share-budget-code-generate-code-link': 'Generate new code',
    'share-budget-code-copied': 'Copied to clipcoard ',
    'share-budget-code-description': 'Code will expire in 24 hours. If you generate new code, the previous code will expire immediately.',
    'share-budget-code-select-company-label': 'Please select company',
    'share-budget-code-defalut-company': 'Select company',
    'share-budget-code-not-allow': 'Your company not allow to share budget.',
    // Dialog Share Budget
    'dialog-share-budget-title': 'Share budget with co-booker',
    'dialog-share-budget-sub-title': 'You need to get an approval from a co-booker before you make a booking.',
    'dialog-share-budget-code-ref': 'Share budget code',
    'dialog-share-budget-code-ref-change': 'Change',
    'dialog-share-budget-co-booker-email': 'Co-booker email',
    'dialog-share-budget-co-booker-company': 'Co-booker company',
    'dialog-share-budget-co-booker-company-address': 'Co-booker Tax Invoice/​Receipt information',
    'dialog-share-budget-error-code-ref-require': 'Please enter share budget code.',
    'dialog-share-budget-error-code-ref-incorrect': 'Share budget code is incorrect. Please check and try again.',
    'dialog-share-budget-error-code-ref-expired': 'Share budget code is expired. Please check and try again.',
    'dialog-share-budget-error-code-ref-yourself': 'You cannot share budget with yourself.',
    'dialog-share-budget-error-code-ref-not-allow-feature': 'Share budget code is expire due to your company or co-booker company not allow to share budget.',
    'dialog-share-budget-gen-code-link': 'Co-booker can generate share budget code at',
    'dialog-share-budget-copy-link': 'Copy link',
    'dialog-share-budget-copy-link-to-clipboard': 'Copied to clipboard',
    'dialog-share-budget-company': '',
    'dialog-share-budget-tax-id': 'Tax ID',
    'dialog-share-budget-confirm-share-budget': 'Confirm',
    //Dialog payment
    'dialog-payment-title': 'Payment will be separated into 2 payment methods',
    'dialog-payment-sub-title': 'Please select payment method',
    'dialog-payment-main-payment': 'Main payment',
    'dialog-payment-extra-payment': 'Extra payment by yourself',
    // Form Share Budget
    'form-share-budget-title': 'Payment details',
    'form-share-budget-title-multi': 'Payment information',
    'form-share-budget-credit-terms-title': 'Pay with credit terms',
    'form-share-budget-credit-terms-booker': 'Charge to main booker',
    'form-share-budget-credit-terms-co-booker': 'Charge to co-booker',
    'form-share-budget-other-payment': 'Pay with ',
    'form-share-budget-other-payment-credit-terms': 'Pay with credit terms',
    'form-share-budget-other-payment-credit-card': 'credit/debit card',
    'form-share-budget-other-payment-true-money': 'truemoney wallet',
    'form-share-budget-other-payment-personal-fleet': 'personal fleet card',
    'room-special-request-optional': ' - Optional',
    'room-special-request-sub-title': "We'll send your request right after you book. Special request cannot be guaranteed and may incur charges, but the property will do its best to meet your wish.",
    'room-special-preferred-room': 'Preferred Room',
    'room-special-request-non-smoke-room': 'Non-smoking Room',
    'room-special-request-smoke-room': 'Smoking Room',
    'room-special-preferred-bed': 'Preferred Bed',
    'room-special-request-large-bed': 'Large Bed',
    'room-special-request-twin-bed': 'Twin Bed',
    'room-special-more-special-requests': 'More special requests',
    'room-special-request-high-floor-room': 'High Floor Room',
    'room-special-request-connecting-room': 'Connecting Room',
    'room-special-request-quiet-room': 'Quiet Room',
    'room-special-others-en': 'Others (Please enter in English only)',
    'room-special-others': 'Others',
    'room-special-more-request': 'More requests',
    // Dialog Information Cart
    'dialog-information-cart-title': 'Important Information',
    'dialog-information-cart-sub-title': 'Please read this important information. Some condition has been updated and may incur additional charges as follows.',
    'dialog-information-cart-accept-condition': 'I accept the conditions above.',
    'dialog-information-cart-accept-condition-required': 'Please accept the conditions in order to process booking.',
    // Fleet Card Information
    'fleet-card-status-active': 'Active',
    'fleet-card-status-inactive': 'Inactive',
    'fleet-card-status-expired': 'Expired',
    'fleet-card-type-corporate': 'Corporate',
    'fleet-card-type-personal': 'Personal',
    'fleet-card-information-card-personal': 'Personal',
    'fleet-card-no-expiration-date': 'No expiration date',
    'fleet-card-information-fleet-card-type-all': 'All fleet card',
    'fleet-card-information-fleet-card-type-corporate': 'Corporate fleet card',
    'fleet-card-information-fleet-card-type-personal': 'Personal fleet card',
    'fleet-card-information-title': 'Fleet card',
    'fleet-card-information-register': 'Add new card',
    'fleet-card-information-fleet-card-no-label': 'Fleet card no.',
    'fleet-card-information-redeemed-amount': 'Used',
    'fleet-card-information-balance-amount': 'Balance',
    'fleet-card-information-information-label': 'Fleet card information',
    'fleet-card-information-status-label': 'Status',
    'fleet-card-information-type-label': 'Type',
    'fleet-card-information-company-label': 'Company',
    'fleet-card-information-expiration-label': 'Expiration date',
    'fleet-card-information-topup': 'Top up',
    'fleet-card-information-transfer': 'Transfer',
    'fleet-card-information-no-fleet-title': 'There is no fleet card added to your account',
    'fleet-card-information-no-fleet-description-1': 'If you already have fleet card, please click “Add new card” to start using your card.',
    'fleet-card-information-no-fleet-description-2': 'If you want to buy fleet card, please contact us.',
    'fleet-card-information-no-fleet-company-title': 'There is no corporate fleet card added to your account.',
    'fleet-card-information-no-fleet-personal-title': 'There is no personal fleet card added to your account.',
    // Dialog Fleet Card Top Up
    'dialog-fleet-card-top-up-title': 'We will open online top up service soon!',
    'dialog-fleet-card-top-up-sub-title-1': 'If you want to buy more fleet card, please contact us.',
    // Dialog Fleet Card Register
    'dialog-fleet-card-register-title': 'Add new fleet card',
    'dialog-fleet-card-register-fleet-card-no-label': 'Fleet card no.',
    'dialog-fleet-card-register-fleet-card-no-error-required': 'Please enter fleet card number.',
    'dialog-fleet-card-register-secret-code-label': 'Secret code',
    'dialog-fleet-card-register-secret-code-tooltip': "Secret code is an authentication number to add fleet card to your account. Secret code will be sent to the specified email of the card buyer.",
    'dialog-fleet-card-register-secret-code-error-required': 'Please enter secret code.',
    'dialog-fleet-card-register-fleet-card-no-or-secret-code-invalid': 'Fleet card number or secret code is incorrect.',
    'dialog-fleet-card-register-fleet-card-is-already-registered': 'This card is already added.',
    'dialog-fleet-card-register-fleet-card-is-expired': 'This card is already expired.',
    'dialog-fleet-card-register-fleet-card-cannot-register-company': 'This card cannot be added to this company account.',
    // Fleet Card Transaction History
    'fleet-card-transaction-history-title': 'Transaction history',
    'fleet-card-transaction-history-filter-date-all': 'All',
    'fleet-card-transaction-history-filter-by': 'Transaction type',
    'fleet-card-transaction-history-filter-all': 'All',
    'fleet-card-transaction-history-filter-redeem': 'Redeem',
    'fleet-card-transaction-history-filter-transfer-withdrawal': 'Transfer withdrawal',
    'fleet-card-transaction-history-filter-transfer-deposit': 'Transfer deposit',
    'fleet-card-transaction-history-filter-refund': 'Refund',
    'fleet-card-transaction-history-date': 'Transaction date',
    'fleet-card-transaction-history-activity': 'Activity',
    'fleet-card-transaction-history-balance': 'Balance',
    'fleet-card-transaction-history-text-redeem': 'Redeem Booking ID',
    'fleet-card-transaction-history-text-transfer-withdrawal': 'Transfer to',
    'fleet-card-transaction-history-text-transfer-deposit': 'Transfer from',
    'fleet-card-transaction-history-text-refund': 'Refund Booking ID',
    'fleet-card-transaction-history-no-transaction': 'No Transaction',
    // Dialog Fleet Card Register Complete
    'dialog-fleet-card-register-complete-title': 'Fleet card successfully added',
    'dialog-fleet-card-register-complete-fleet-card-no-label': 'Card no.',
    'dialog-fleet-card-register-complete-fleet-card-type-label': 'Card type',
    'dialog-fleet-card-register-complete-company-label': 'Company',
    'dialog-fleet-card-register-complete-expiration-date-label': 'Expiration date',
    'dialog-fleet-card-register-complete-amount-label': 'Amount',
    // Checkout 3 Fleet Card
    'checkout-3-fleet-card-title': 'Fleet card information',
    'checkout-3-personal-fleet-title': 'Personal fleet card information',
    'checkout-3-corporate-fleet-title': 'Corporate Fleet card information',
    'checkout-3-fleet-card-no-you-account': 'There is no fleet card registered on your account',
    'checkout-3-fleet-card-no-you-account-sub-1': 'If you already have fleet card, please register to start using your card at menu <i class="icon-fleet"> <b>Fleet Card</b>',
    'checkout-3-fleet-card-no-you-account-sub-2': 'If you want to buy fleet card, please contact call center +66(0) 2-020-2351',
    'checkout-3-fleet-card-no-you-account-sub-3': 'or Line Official Account',
    'checkout-3-fleet-card-information': 'Payment date for fleet card',
    'checkout-3-fleet-card-payment-date': 'will be',
    'checkout-3-personal-fleet': 'Personal',
    'checkout-3-fleet-card-cannot-selected-error': 'Your balance is insufficient. Please select a different payment method or select another fleet card.',
    'checkout-3-fleet-card-cannot-selected-error-multi': 'Amount exceed your budget limit. Please select a different payment method.',
    // Dialog Fleet Card Transfer
    'dialog-fleet-card-transfer-default-dropdown': 'Select fleet card no.',
    'dialog-fleet-card-transfer-title': 'Transfer balance',
    'dialog-fleet-card-transfer-sub-title': 'You can transfer fleet balance to the card which is the same card type and under the same company. The card must not have an expiration date.',
    'dialog-fleet-card-transfer-fleet-card-no-from-label': 'From fleet card no.',
    'dialog-fleet-card-transfer-fleet-card-no-to-label': 'To fleet card no.',
    'dialog-fleet-card-transfer-fleet-card-no-to-note': 'The list of cards will only show cards that can transfer funds.',
    'dialog-fleet-card-transfer-amount-label': 'Amount',
    'dialog-fleet-card-transfer-amount-error-required': 'Please enter amount.',
    'dialog-fleet-card-transfer-amount-error-insufficient': 'Insufficient balance.',
    'dialog-fleet-card-transfer-amount-error-exceed': 'Amount exceeds the limit on the card.',
    // Dialog Fleet Card Transfer Complete
    'dialog-fleet-card-transfer-complete-title': 'Your funds transfer is complete',
    'dialog-fleet-card-transfer-complete-from-label': 'Transfer from card no.',
    'dialog-fleet-card-transfer-complete-to-label': 'To card no.',
    'dialog-fleet-card-transfer-complete-amount-label': 'Amount',
    // Dialog Fleet Card Register Fail
    'dialog-fleet-card-register-fail-title': 'Could not add card',
    'dialog-fleet-card-register-fail-sub-title': 'Please try again.',
    // Dialog Fleet Card Transfer Fail
    'dialog-fleet-card-transfer-fail-title': 'Could not transfer fleet balance',
    'dialog-fleet-card-transfer-fail-sub-title': 'Please try again.',
    'payment-channel-type-multi-payment': 'Multi-payment',
    'payment-channel-type-credit-terms': 'Credit Terms',
    'payment-channel-type-credit-card': 'Credit/Debit Card',
    'payment-channel-type-true-money': 'TrueMoney Wallet',
    'payment-channel-type-personal-fleet': 'Personal Fleet Card',
    'payment-channel-type-corporate-fleet': 'Corporate Fleet Card',
    'payment-channel-type-fleet-card': 'Fleet Card',
    'payment-channel-type-personal-payment': '* Personal Payment *',
    'payment-channel-type-qr-code': 'QR Code',
    'payment-channel-type-e-wallet': 'E-Wallet',
    'payment-channel-type-im-banking': 'Internet/Mobile Banking',
    'payment-channel-type-pay-at-counter': 'Counter',
    'payment-method-collapse': 'View less',
    'payment-method-expanse': 'Show all payment methods',
    'check-in-check-out': 'Check-in/Check-out',
    'check-in-from': 'Check-in from',
    'check-out-until': 'Check-out until',
    'check-out-from': 'Check-out from',
    'early-late-check-in': 'You may request early or late check-in during booking, subject to availability.',
    'product-description': 'About the property',
    'product-images': 'View all photos',
    'all-photos': 'All photos',
    // product item
    'product-hot-deal': 'Hot Deal!',
    'product-promotion-last-minute': '<strong>Last Minute Sale!</strong>',
    'product-discount-percent': 'Discount <strong>{price}</strong>%',
    'product-discount-amount': 'Discount <strong>THB {price}</strong>',
    'info-window-content-navigate': 'Get directions',
    // arrival time
    'arrival-time-i-dont-know': 'I don’t know',
    'arrival-time-0000-0100': '00:00 - 01:00',
    'arrival-time-0100-0200': '01:00 - 02:00',
    'arrival-time-0200-0300': '02:00 - 03:00',
    'arrival-time-0300-0400': '03:00 - 04:00',
    'arrival-time-0400-0500': '04:00 - 05:00',
    'arrival-time-0500-0600': '05:00 - 06:00',
    'arrival-time-0600-0700': '06:00 - 07:00',
    'arrival-time-0700-0800': '07:00 - 08:00',
    'arrival-time-0800-0900': '08:00 - 09:00',
    'arrival-time-0900-1000': '09:00 - 10:00',
    'arrival-time-1000-1100': '10:00 - 11:00',
    'arrival-time-1100-1200': '11:00 - 12:00',
    'arrival-time-1200-1300': '12:00 - 13:00',
    'arrival-time-1300-1400': '13:00 - 14:00',
    'arrival-time-1400-1500': '14:00 - 15:00',
    'arrival-time-1500-1600': '15:00 - 16:00',
    'arrival-time-1600-1700': '16:00 - 17:00',
    'arrival-time-1700-1800': '17:00 - 18:00',
    'arrival-time-1800-1900': '18:00 - 19:00',
    'arrival-time-1900-2000': '19:00 - 20:00',
    'arrival-time-2000-2100': '20:00 - 21:00',
    'arrival-time-2100-2200': '21:00 - 22:00',
    'arrival-time-2200-2300': '22:00 - 23:00',
    'arrival-time-2300-2400': '23:00 - 24:00',
    'arrival-time-0000-0100-the-next-day': '00:00 - 01:00 (the next day)',
    'arrival-time-0100-0200-the-next-day': '01:00 - 02:00 (the next day)',
    'view-more': 'View more',
    'view-less': 'View less',
    //Modal Update Profile
    'positive-energy-title': 'Find positive energy accommodation',
    'positive-energy-title-desc': 'Simply provide your date of birth, and we will help you find accommodation that enhances positive energy by using numerology calculations.',
    'positive-energy-description': 'The information regarding your date of birth and time of birth <strong>will be kept confidential and protected under The Personal Data Protection Act (PDPA).</strong> It will be used for recommending positive energy accommodations only and <strong>it does not affect search result.</strong> By submitting your information, you agree with <a class="link-hover-style" href="https://www.ascendtravel.com/privacy-policy?lang=en" target="_blank">Privacy Policy</a> of AscendTravel.com',
    'full-name-description': 'Please enter in English only as in Passport/Official ID Card (without title/special characters).',
    'time-of-birth-label': 'Time of birth',
    'time-of-birth-placeholder': 'Select time of birth',
    'time-of-birth-option-unspecified': 'Unknown',
    'time-of-birth-option-day': 'Daytime (6:00 - 17:59 hrs.)',
    'time-of-birth-option-night': 'Nighttime (18:00 - 05:59 hrs.)',
    'time-of-birth-day': 'Daytime',
    'time-of-birth-night': 'Nighttime',
    'positive-energy-btn-submit': 'Search'
};
//# sourceMappingURL=lang-en.js.map

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_model_constant__ = __webpack_require__(6);
/* unused harmony export LANG_TH_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LANG_TH_TRANS; });

var LANG_TH_NAME = __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["a" /* Language */].th;
var LANG_TH_TRANS = {
    'hello world': 'สวัสดีชาวโลก',
    'menu-bar-home': 'หน้าหลัก',
    'menu-bar-account': 'บัญชีของฉัน',
    'menu-bar-profile': 'จัดการข้อมูลผู้ใช้',
    'menu-bar-booking': 'การจอง',
    'menu-bar-approval': 'รายการที่ต้องอนุมัติ',
    'menu-bar-my-budget': 'สิทธิ์และวงเงินการจองที่พัก',
    'menu-bar-fleet-card': 'บัตรฟลีท (Fleet Card)',
    'menu-bar-setting-account': 'ความปลอดภัยบัญชี',
    'menu-bar-login': 'เข้าสู่ระบบ',
    'menu-bar-logout': 'ออกจากระบบ',
    'menu-bar-baht': 'บาท',
    'menu-bar-baht-opposite': 'THB',
    'menu-bar-baht-accommodation': 'ที่พัก',
    'menu-bar-baht-business-events': 'จัดกรุ๊ปองค์กร / อีเวนต์',
    'menu-bar-co-working-space': 'Co-working space',
    'menu-bar-flight': 'ตั๋วเครื่องบิน',
    'menu-bar-car-rental': 'รถเช่า',
    'menu-bar-help': 'ช่วยเหลือ',
    'menu-bar-language': 'ภาษา',
    'menu-bar-language-choice-en': 'อังกฤษ',
    'menu-bar-language-choice-th': 'ไทย',
    'menu-bar-currency': 'สกุลเงิน',
    'menu-bar-switch-company': 'จองภายใต้บริษัท',
    'menu-bar-setting': 'ตั้งค่า',
    'menu-bar-pre-approval-requests': 'คำขออนุมัติล่วงหน้า',
    'menu-bar-pre-approval-approvals': 'รายการขออนุมัติล่วงหน้า',
    'switch-language-title': 'ภาษา',
    'switch-currency-title': 'สกุลเงิน',
    'switch-language-currency-title': 'ภาษาและสกุลเงิน',
    'switch-language-currency-sub-title': 'ระบบจะแปลงและแสดงราคาเป็นสกุลเงินที่ท่านเลือก โดยสกุลเงินที่ท่านจะชำระนั้นอาจแตกต่างออกไปขึ้นอยู่กับการจองของท่าน และอาจมีการคิดค่าบริการด้วยเช่นกัน',
    'btn-register': 'สมัครใช้งาน',
    'btn-joinus': 'เข้าร่วมกับเรา',
    'btn-back': 'กลับ',
    'btn-cancel': 'ยกเลิก',
    'btn-clear': 'ล้างข้อมูล',
    'btn-choose': 'เลือก',
    'btn-go-to-booking': 'ไปที่การจองของฉัน',
    'btn-export': 'ดึงไฟล์รายงาน',
    'btn-clear-selection': 'ยกเลิกการเลือกทั้งหมด',
    'btn-clear-selection-mb': 'ยกเลิกการเลือก',
    'btn-confirm': 'ยืนยัน',
    'btn-close': 'ปิด',
    'btn-submit': 'ตกลง',
    'link-view-map': 'ดูแผนที่',
    'map-marker-room-not-available': 'ไม่มีห้องว่าง',
    'footer-company-name': 'บริษัท แอสเซนด์ แทรเวิล จำกัด (สำนักงานใหญ่)',
    'footer-address-01': 'เลขที่ 89 อาคารเอไอเอ แคปปิตอล เซ็นเตอร์',
    'footer-address-02': 'ชั้นที่ 18-19 ถนนรัชดาภิเษก แขวงดินแดง',
    'footer-address-03': 'เขตดินแดง กรุงเทพมหานคร 10400',
    'footer-new-address-01': 'เลขที่ 101 ทรู ดิจิทัล พาร์ค อาคารกริฟฟิน',
    'footer-new-address-02': 'ชั้น 12A ถนนสุขุมวิท แขวงบางจาก',
    'footer-new-address-03': 'เขตพระโขนง กรุงเทพมหานคร 10260',
    'footer-license': 'ใบอนุญาตบริษัททัวร์ : 11/08384',
    'footer-call-center': 'ติดต่อสอบถาม',
    'footer-customer-support': 'ติดต่อเรา',
    'footer-customer-help': 'ช่วยเหลือ',
    'footer-customer-terms': 'เงื่อนไขการใช้บริการ',
    'footer-customer-terms-02': 'นโยบายความเป็นส่วนตัว',
    'footer-customer-cookies': 'นโยบายคุกกี้',
    'province-hauhin': 'หัวหิน / ชะอำ',
    'province-pattaya': 'พัทยา',
    'province-chiang-mai': 'เชียงใหม่',
    'province-phuket': 'ภูเก็ต',
    'province-krabi': 'กระบี่',
    'province-koh-samui': 'เกาะสมุย',
    'province-bangkok': 'กรุงเทพมหานคร',
    'province-khao-lak': 'เขาหลัก',
    'province-koh-chang': 'เกาะช้าง',
    'province-kanchanaburi': 'กาญจนบุรี',
    'search-top-destination': 'สถานที่ที่น่าสนใจ',
    'search-top-destination-sub': 'ค้นพบสถานที่ใหม่ที่สามารถสร้างแรงบันดาลใจให้กับคุณ',
    'search-box-title': 'ค้นหาและจองที่พัก',
    'search-box-title-sub': 'รวมที่พักสำหรับเดินทางไปทำงานหรือไปท่องเที่ยวส่วนตัว หลากหลายสไตล์ตามใจคุณ',
    'search-box-topic-travel': 'ท่องเที่ยว',
    'search-box-topic-work': 'ทำงาน',
    'search-box-tooltip-title': 'ต่างกันอย่างไร ?',
    'search-box-tooltip-travel': 'ค้นหาที่พักสำหรับการพักผ่อนของคุณ โดยการจองจะไม่เชื่อมโยงกับบัญชีบริษัท',
    'search-box-tooltip-work': 'ค้นหาที่พักสำหรับผู้เดินทางติดต่อธุรกิจได้อย่างง่ายดาย',
    'search-box-topic-title': 'เดินทางเพื่อ',
    'search-box-want': 'คุณต้องการเดินทางไปที่ใด?',
    'search-box-want-placeholder': 'พิมพ์จุดหมายปลายทาง หรือ ชื่อที่พัก',
    'search-box-check-in': 'เช็คอิน',
    'search-box-check-in-calendar': 'วันที่เช็คอิน',
    'search-box-check-out': 'เช็คเอาท์',
    'search-box-check-out-calendar': 'วันที่เช็คเอาท์',
    'search-box-room': 'จำนวนห้อง',
    'search-box-guest': 'จำนวนผู้เข้าพัก',
    'search-box-btn-search': 'ค้นหา',
    'search-box-destination': 'จุดหมายปลายทาง',
    'search-box-props': 'ที่พัก',
    'search-box-hotel': 'ที่พัก/โรงแรม',
    'search-box-result-search': 'ผลการค้นหา',
    'search-box-recent-searches': 'ผลการค้นหาล่าสุด',
    'search-box-near-by': 'ค้นหาจากตำแหน่งของคุณ',
    'search-box-near-by-you': 'ที่พักใกล้ตำแหน่งของคุณ',
    'your-location': 'ตำแหน่งของคุณ',
    'location-not-found': 'ไม่สามารถระบุตำเเหน่งของคุณได้',
    'location-message-not-found': 'กรุณาตั้งค่าเปิดสิทธิ์การแชร์ข้อมูลตำแหน่งที่ตั้งก่อนค้นหาที่พักจากตำแหน่งของคุณ',
    'enter': 'ตกลง ',
    'search-box-room-in-choose': 'ห้อง',
    'search-box-adult': 'ผู้ใหญ่',
    'search-box-guest-count': 'จำนวนห้องและผู้เข้าพัก',
    'search-box-child': 'เด็ก',
    'search-box-child-age': 'อายุเด็ก (ปี)',
    'search-box-person': 'คน',
    'search-box-want-read': 'จุดหมายปลายทาง',
    'search-box-check-in-out-read': 'ช่วงวันเข้าพัก',
    'search-box-guest-read': 'จำนวนห้องและผู้เข้าพัก',
    'search-box-btn-cancel-change': 'ยกเลิกการเปลี่ยนแปลง',
    'search-box-btn-change': 'เปลี่ยนการค้นหา',
    'search-box-point_of_interest': 'จุดที่น่าสนใจ',
    'search-box-over-budget-checkbox-label': 'แสดงที่พักเกินวงเงินและคำนวณส่วนต่างที่ต้องจ่ายเพิ่มเอง',
    'search-box-over-budget-hover-info-label': 'คุณสามารถจองที่พักที่เกินจากวงเงินได้โดยการชำระค่าส่วนเกินเอง',
    'search-box-over-budget-hover-credit-card-label': 'บัตรเครดิตส่วนตัว',
    'search-box-error-purpose': 'กรุณาเลือกวัตถุประสงค์การเดินทาง',
    'search-box-error-destination': 'กรุณาระบุจุดหมายปลายทางหรือโรงแรมที่พัก',
    'search-box-error-work-1-room': 'การจองเพื่อทำงานสามารถจองได้ครั้งละ 1ห้อง และ ไม่เกิน 2 คน',
    'search-box-error-work-2-person': 'การจองเพื่อทำงานสามารถจองได้ห้องละไม่เกิน 2 คน',
    'search-box-error-work-no-child': 'การจองเพื่อทำงานไม่สามารถจองแบบมีเด็กได้',
    'search-box-error-feature-not-allow': 'เนื่องจากบริษัทของคุณหรือผู้ร่วมเดินทางไม่อนุญาตให้รวมวงเงินการจอง',
    'search-box-error-code-ref-expired': 'เนื่องจากรหัสสำหรับรวมวงเงินหมดอายุแล้ว',
    'search-box-error-code-ref-incorrect': 'เนื่องจากรหัสสำหรับรวมวงเงินไม่ถูกต้อง',
    'search-box-budget-per-night': 'คุณมีวงเงินในการจองที่พักอยู่ <strong>{currency} {budget}</strong> /ห้อง/คืน',
    'search-box-budget-per-month': 'วงเงินต่อเดือนที่คุณได้รับคือ <strong>{currency} {budgetPerMonth}</strong> /เดือน',
    'search-box-budget-per-year': 'วงเงินต่อปีที่คุณได้รับคือ <strong>{currency} {budgetPerYear}</strong> /ปี',
    'search-box-budget-per-month-per-year': 'วงเงินต่อเดือนและต่อปีที่คุณได้รับคือ <strong>{currency} {budgetPerMonth}</strong> /เดือน และ <strong>{currency} {budgetPerYear}</strong> /ปี',
    'search-box-budget-unlimited': 'คุณมีวงเงินต่อห้องต่อคืนไม่จำกัด',
    'search-box-new-budget-per-night': 'คุณมีวงเงินใหม่ในการจองที่พักอยู่ <strong>{currency} {budget}</strong> /ห้อง/คืน',
    'search-box-new-budget-unlimited': 'คุณมีวงเงินใหม่ในการจองที่พักต่อห้องต่อคืนไม่จำกัด',
    'search-box-see-all-my-budget': 'ดูวงเงินทั้งหมด',
    'search-box-share-budget': 'รวมวงเงินกับผู้ร่วมเดินทาง',
    'search-box-share-budget-tooltips': 'คุณสามารถจองห้องพักโดยการรวมวงเงินกับผู้ร่วมเดินทางท่านอื่นได้',
    'search-box-cancel-share-budget': 'ยกเลิกการรวมวงเงิน',
    'budget-unlimited': 'ไม่จำกัด',
    'search-box-tooltips-share-budget-detail-title': 'คุณได้รวมกับวงเงินของผู้ร่วมเดินทาง',
    'search-box-tooltips-share-budget-detail-booker-budget': 'วงเงินของคุณ',
    'search-box-tooltips-share-budget-detail-co-booker-budget': 'วงเงินของผู้ร่วมเดินทาง',
    'search-box-tooltips-share-budget-detail-total-budget': 'วงเงินใหม่ในการจองที่พักต่อห้องต่อคืนของคุณ',
    'search-box-tooltips-share-budget-detail-apply-co-budget': 'มีการจำกัดวงเงินในการจองห้องพักสำหรับผู้เข้าพัก 2 คน',
    'account-menu-bar-profile': 'จัดการข้อมูลผู้ใช้',
    'account-menu-bar-share-budget-code': 'สร้างรหัสสำหรับรวมวงเงิน',
    'account-menu-bar-my-budget': 'สิทธิ์และวงเงินการจองที่พัก',
    'account-menu-bar-fleet-card': 'บัตรฟลีท',
    'account-menu-bar-account-security': 'ความปลอดภัยบัญชี',
    'account-menu-bar-logout': 'ออกจากระบบ',
    'account-change-password-headline': 'เปลี่ยนรหัสผ่าน',
    'account-change-password-title': 'เปลี่ยนรหัสผ่าน',
    'account-change-password-new': 'รหัสผ่านใหม่',
    'account-change-password-new-fill': 'พิมพ์รหัสผ่านใหม่ที่นี่',
    'account-change-password-confirmation': 'ยืนยันรหัสผ่านใหม่',
    'account-change-password-confirmation-fill': 'พิมพ์รหัสผ่านใหม่อีกครั้ง',
    'account-change-password-button-submit': 'บันทึก',
    'account-change-password-button-cancel': 'ยกเลิก',
    'account-change-password-validation-text': 'รหัสผ่านต้องประกอบไปด้วย',
    'account-change-password-validation-length-text': 'อักขระอย่างน้อย 8-16 ตัว โดยมีตัวอักษรภาษาอังกฤษ ตัวเลข หรืออักขระพิเศษ เช่น @ $ ! % * # ? &',
    'account-change-password-validation-uppercase-text': 'ตัวอักษรภาษาอังกฤษตัวพิมพ์ใหญ่ อย่างน้อย 1 ตัว',
    'account-change-password-validation-lowercase-text': 'ตัวอักษรภาษาอังกฤษตัวพิมพ์เล็ก อย่างน้อย 1 ตัว',
    'account-change-password-validation-numeric-text': 'ตัวเลข 0-9 อย่างน้อย 1 ตัว',
    'account-security-title': 'ความปลอดภัยบัญชี',
    'account-security-email': 'อีเมล',
    'account-security-email-description': 'อีเมลนี้ใช้เข้าสู่ระบบ และเป็นอีเมลที่เราส่งรายละเอียดการจองไปให้คุณ',
    'account-security-password': 'รหัสผ่าน',
    'account-security-password-description': 'เปลี่ยนรหัสผ่านของคุณเป็นประจำเพื่อให้บัญชีของคุณปลอดภัยเสมอ',
    'account-security-password-action': 'เปลี่ยนรหัสผ่าน',
    'account-security-phone': 'เบอร์โทรศัพท์',
    'account-security-phone-action': 'เปลี่ยนเบอร์โทรศัพท์',
    'account-security-new-phone-action': 'เชื่อมเบอร์โทรศัพท์',
    'account-security-pin': 'รหัส PIN เพื่อความปลอดภัย',
    'account-security-pin-description': 'ใช้รหัส PIN สำหรับการชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัทของคุณ',
    'account-security-pin-action': 'ตั้งรหัส PIN',
    'booking-my-booking': 'การจอง',
    'booking-my-booking-list': 'ทั้งหมด',
    'booking-my-booking-from': 'ช่วงระหว่างวันที่',
    'booking-my-booking-from2': 'ตั้งแต่',
    'booking-my-booking-until': 'ถึง',
    'booking-my-booking-until2': 'ถึง',
    'booking-my-booking-before': 'ก่อน',
    'booking-my-booking-id': 'หมายเลขการจอง',
    'booking-my-booking-booking-date': 'วันที่จอง / เวลาจอง',
    'booking-my-booking-payment-date': 'ตัดบัตรวันที่',
    'booking-my-booking-booker-cancel-date': 'โดยผู้จองวันที่',
    'booking-my-booking-booker-cancel-booker-date': 'โดยผู้จองหลักวันที่',
    'booking-my-booking-booker-cancel-co-booker-date': 'โดยผู้จองร่วมวันที่',
    'booking-my-booking-booker-cancel-name-date': 'โดย {name} วันที่',
    'booking-my-booking-booker-reject-supervisor-date': 'โดยผู้บังคับบัญชาของผู้จองหลักวันที่',
    'booking-my-booking-booker-reject-co-supervisor-date': 'โดยผู้บังคับบัญชาของผู้จองร่วมวันที่',
    'booking-my-booking-checkin': 'เช็คอิน',
    'booking-my-booking-checkout': 'เช็คเอาท์',
    'booking-my-booking-checkin-date': 'วันที่เช็คอิน',
    'booking-my-booking-bookingdate': 'วันที่จอง',
    'booking-my-booking-approved-date': 'วันที่อนุมัติ',
    'booking-my-booking-rejected-date': 'โดยผู้บังคับบัญชาวันที่',
    'booking-my-booking-roomtype': 'ประเภทห้องพัก',
    'booking-my-booking-re-booking': 'จองอีกครั้ง',
    'booking-my-booking-sumbit': 'จัดการจอง',
    'booking-my-booking-cancel': 'ยกเลิกการจองนี้',
    'booking-my-booking-map': 'ดูแผนที่',
    'booking-my-booking-review': 'ให้คะแนนรีวิวที่พัก',
    'booking-my-booking-review-published': 'ให้คะแนนรีวิวที่พักแล้ว',
    'booking-my-booking-btn-details': 'ดูรายละเอียด',
    'booking-my-booking-previous': 'ก่อนหน้า',
    'booking-my-booking-next': 'ถัดไป',
    'booking-my-booking-arranged-by': 'จัดเรียงตาม',
    'booking-my-booking-arranged-by-mobile': 'เรียงตาม',
    'booking-my-booking-all': 'การจองทั้งหมด',
    'booking-my-booking-search-text': 'หมายเลขการจอง',
    'booking-my-booking-search-not-found': 'ไม่พบหมายเลขการจอง',
    'booking-my-booking-text-booking-date': 'วัน/เวลาจอง',
    'booking-my-booking-text-total-room': 'จำนวนห้อง',
    'booking-my-room': 'ห้อง',
    'booking-my-night': 'คืน',
    'booking-my-guest': 'จำนวนผู้เข้าพัก',
    'booking-my-booking-text-total-max-guest': 'จำนวนผู้เข้าพักสูงสุดทั้งหมด',
    'booking-my-adult-text': 'ผู้ใหญ่',
    'booking-my-child-text': 'เด็ก',
    'booking-my-child': 'คน',
    'booking-my-adult': 'คน',
    'booking-my-status-success-booking': 'จองเรียบร้อยแล้ว',
    'booking-my-status-successfully-payment': 'ชำระเงินเรียบร้อยแล้ว',
    'booking-my-status-success-payment': 'จองและชำระเงินเรียบร้อยแล้ว',
    'booking-my-status-failure-payment': 'ชำระเงินไม่สำเร็จ',
    'booking-my-status-cancelled-booking': 'รายการจองถูกยกเลิก',
    'booking-my-status-inprogress': 'กำลังดำเนินการ',
    'booking-my-status-already-checkout': 'เช็คเอาท์แล้ว',
    'booking-my-status-failure-booking': 'ทำรายการไม่สำเร็จ',
    'booking-my-status-awaiting-approval': 'จองและรอการอนุมัติ',
    'booking-my-status-booking-approved': 'จองและอนุมัติเรียบร้อยแล้ว',
    'booking-my-status-booking-rejected': 'ถูกปฏิเสธการจอง',
    'booking-my-booking-filter-by': 'แสดง',
    'booking-my-booking-filter-by-all': 'ทั้งหมด',
    'booking-my-booking-filter-by-upcoming': 'กำลังจะเข้าพัก',
    'booking-my-booking-filter-by-check-in': 'เข้าพักอยู่',
    'booking-my-booking-filter-by-completed': 'เช็คเอาท์แล้ว',
    'booking-my-booking-filter-by-cancelled': 'ยกเลิก',
    'booking-my-booking-filter-by-failed': 'ทำรายการไม่สำเร็จ',
    'booking-my-booking-sort-by-booking-date': 'วันที่จอง',
    'booking-my-booking-sort-by-checkin-date': 'วันเข้าพัก',
    'booking-my-booking-sort-by-payment-date': 'วันชำระเงิน',
    'booking-my-booking-sort-by-booking-id': 'หมายเลขการจอง',
    // Approval List
    'approval-list': 'รายการที่ต้องอนุมัติ',
    'approval-list-search-text': 'หมายเลขการจอง',
    'approval-list-search-not-found': 'ไม่พบหมายเลขการจอง',
    'approval-list-search-empty': 'ยังไม่มีรายการจอง',
    'approval-list-filter-by': 'แสดง',
    'approval-list-sort-by': 'จัดเรียงตาม',
    'approval-list-filter-by-all': 'ทั้งหมด',
    'approval-list-filter-by-waiting': 'รอการอนุมัติ',
    'approval-list-filter-by-approved': 'อนุมัติแล้ว',
    'approval-list-filter-by-cancelled': 'ยกเลิกการจอง',
    'approval-list-sort-by-booking-date': 'วันที่จอง',
    'approval-list-sort-by-checkin-date': 'วันเข้าพัก',
    'approval-list-requester-name': 'ผู้ขออนุมัติ',
    'approval-list-booking-id': 'หมายเลขการจอง',
    'approval-list-grand-total': 'ยอดรวม',
    'approval-list-button-detail': 'ดูรายละเอียด',
    'approval-list-status-approved': 'อนุมัติการจอง',
    'approval-list-status-booker-cancelled': 'รายการจองถูกยกเลิก',
    'approval-list-status-last-minute1': 'ไม่สามารถอนุมัติหรือปฏิเสธการจองได้',
    'approval-list-status-last-minute2': 'เนื่องจากเป็นการจอง ณ​ วันเข้าพัก',
    'approval-list-status-no-action': 'จองเรียบร้อยโดยไม่ผ่านการอนุมัติ',
    'approval-list-status-rejected': 'ปฏิเสธการจอง',
    'approval-list-approved-date': 'วันที่อนุมัติ',
    'approval-list-rejected-date': 'วันที่ปฏิเสธ',
    'approval-list-cancel-date': 'วันที่ยกเลิก',
    'approval-message-approve-success': 'รายการจองห้องพักได้รับการอนุมัติและดำเนินการเรียบร้อยแล้ว',
    'approval-message-approve-fail': 'ทำรายการไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    'approval-message-reject-success': 'รายการจองห้องพักถูกยกเลิกเรียบร้อยแล้ว',
    'approval-message-reject-fail': 'ทำรายการไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    'approval-button-reject': 'ปฏิเสธการจอง',
    'approval-button-approve': 'อนุมัติการจอง',
    'approval-details-btn-back': 'กลับไปรายการที่ต้องอนุมัติ',
    'approval-details-contact-number': ' เบอร์ติดต่อ',
    // Payment Summary
    'payment-summary-cancel-header': 'รายการจองถูกยกเลิก',
    'payment-summary-reject-header': 'รายการจองถูกปฏิเสธ',
    'payment-summary-exclude-vat': 'ราคาทั้งหมดไม่รวมภาษี',
    'payment-summary-vat': 'ภาษีมูลค่าเพิ่ม 7%',
    'payment-summary-before-discount': 'ยอดรวมก่อนส่วนลด',
    'payment-summary-promotion-code-discount': 'ส่วนลดโค้ดโปรโมชั่น',
    'payment-summary-book-grand-total': 'ยอดรวมสุทธิ',
    'payment-summary-pay-credit-term-main-booker': 'เรียกเก็บไปยังบริษัทผู้จองหลัก',
    'payment-summary-pay-credit-term-co-booker': 'เรียกเก็บไปยังบริษัทผู้จองร่วม',
    'payment-summary-pay-credit-term-remark': 'สำหรับการชำระเงินแบบส่งใบแจ้งหนี้',
    'payment-summary-taxes-fees': 'ภาษีและค่าธรรมเนียม',
    'payment-summary-price': 'ราคา',
    'payment-summary-pay-credit-term': 'ชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัท',
    'payment-summary-pay-credit-card': 'ชำระเงินด้วยบัตรเครดิต/เดบิต',
    'payment-summary-pay-credit-card-add': 'ชำระเงินเพิ่มด้วยบัตรเครดิต/เดบิต',
    'payment-summary-pay-true-money': 'ชำระเงินด้วยทรูมันนี่ วอลเล็ท',
    'payment-summary-pay-true-money-add': 'ชำระเงินเพิ่มด้วยทรูมันนี่ วอลเล็ท',
    'payment-summary-pay-corporate-fleet': 'ชำระเงินด้วยบัตรฟลีทบริษัท',
    'payment-summary-pay-personal-fleet': 'ชำระเงินด้วยบัตรฟลีทส่วนตัว',
    'payment-summary-pay-personal-fleet-add': 'ชำระเงินเพิ่มด้วยบัตรฟลีทส่วนตัว',
    'payment-summary-cancel-exclude-vat': 'ค่าธรรมเนียมการยกเลิกทั้งหมดไม่รวมภาษี',
    'payment-summary-cancel-pay-credit-term-main-booker': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินแบบส่งใบแจ้งหนี้ผู้จองหลัก',
    'payment-summary-cancel-pay-credit-term-co-booker': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินแบบส่งใบแจ้งหนี้ผู้จองร่วม',
    'payment-summary-cancel-pay-credit-term': 'สำหรับการชำระเงินแบบส่งใบแจ้งหนี้',
    'payment-summary-cancel-pay-credit-card': 'สำหรับการชำระเงินด้วยบัตรเครดิต/เดบิต',
    'payment-summary-cancel-pay-true-money': 'สำหรับการชำระเงินด้วยทรูมันนี่ วอลเล็ท',
    'payment-summary-cancel-pay-corporate-fleet': 'สำหรับการชำระเงินด้วยบัตรฟลีทบริษัท',
    'payment-summary-cancel-pay-personal-fleet': 'สำหรับการชำระเงินด้วยบัตรฟลีทส่วนตัว',
    'payment-summary-cancel-total-price': 'มูลค่าการจอง',
    'payment-summary-cancel-total-cancellation-fee': 'ค่าธรรมเนียมการยกเลิก',
    'payment-summary-cancel-total-cancellation-share-fee': 'ค่าธรรมเนียมการยกเลิกสำหรับการรับชำระเงิน',
    'payment-summary-cancel-total-cancellation-share-fee-main-booker': 'แบบส่งใบแจ้งหนี้ผู้จองหลัก',
    'payment-summary-cancel-total-cancellation-share-fee-co-booker': 'แบบส่งใบแจ้งหนี้ผู้จองร่วม',
    'payment-summary-cancel-grand-total-cancellation-fee': 'ค่าธรรมเนียมการยกเลิกสุทธิ',
    'payment-summary-cancel-grand-desc-main-booker': 'สำหรับการชำระเงินแบบส่งใบแจ้งหนี้ผู้จองหลัก',
    'payment-summary-cancel-grand-desc-co-booker': 'สำหรับการชำระเงินแบบส่งใบแจ้งหนี้ผู้จองร่วม',
    'payment-summary-cancel-credit-card-refund': 'ยอดเงินคืนเข้าบัตรเครดิต/เดบิต',
    'payment-summary-cancel-true-money-refund': 'ยอดเงินคืนเข้าทรูมันนี่ วอลเล็ท',
    'payment-summary-cancel-corporate-fleet-refund': 'ยอดเงินคืนเข้าบัตรฟลีทบริษัท',
    'payment-summary-cancel-personal-fleet-refund': 'ยอดเงินคืนเข้าบัตรฟลีทส่วนตัว',
    'payment-summary-refund': 'ยอดเงินคืน',
    'payment-summary-booker': 'ผู้จองหลัก',
    'payment-summary-co-booker': 'ผู้จองร่วม',
    // Global form
    'landing-form-password-hint': 'รหัสผ่านจะต้องเป็นตัวอักษรภาษาอังกฤษ A-Z หรือ a-z หรือ ตัวเลข 0-9 หรือ อักขระพิเศษยกเว้น ซิงเกิลโคด(\'), ดับเบิ้ลโคด("), คอมม่า(,) และ แบ็กสแลช(\\) จำนวน 8-16 หลัก',
    // Create account form
    'landing-form-create-account-select': 'เลือกบริษัทหลัก',
    'landing-form-create-account-terms-and-conditions': 'เงื่อนไขการใช้บริการและนโยบายความเป็นส่วนตัว',
    'landing-form-create-account-accept': 'ฉันยอมรับ',
    // Verify account form
    'landing-form-verify-account-title': 'กรุณาระบุอีเมลบริษัทของคุณ',
    'landing-form-verify-account-enroll': 'หากคุณไม่แน่ใจว่าบริษัทของคุณเข้าร่วมกับ Ascend Travel แล้วหรือยัง',
    'landing-form-confirm-email-title': 'กรุณาตรวจสอบอีเมลของคุณ',
    'landing-form-confirm-email-description': 'เราได้ทำการส่งอีเมลไปยัง<br/><span class="color-main">[email]</span><br/>กรุณาตรวจสอบอีเมลและทำการยืนยันการสมัครสมาชิก<br/>ภายใน 30 นาที หลังได้รับอีเมล<br/>*ถ้าไม่พบกรุณาตรวจสอบในกล่องจดหมายขยะ',
    'landing-form-confirm-email-footer': 'หากคุณไม่พบอีเมลยืนยันของคุณ คลิก',
    'landing-form-confirm-email-success-description': 'เราได้ทำการส่งอีเมลไปยัง<br/><span class="color-main">[email]</span><br/>กรุณาตรวจสอบอีเมลและทำการยืนยันการสมัครสมาชิกค่ะ<br/>*ถ้าไม่พบกรุณาตรวจสอบในกล่องจดหมายขยะ',
    'landing-form-confirm-email-success-footer': 'เราได้ทำการส่งอีเมลเพื่อยืนยันให้คุณแล้ว หากคุณไม่พบอีเมลยืนยันของคุณ คลิก',
    'landing-form-verify-email-failure-description': 'เราได้ทำการส่งอีเมลไปยัง<br/><span class="color-main">[email]</span><br/>กรุณาตรวจสอบอีเมลและทำการยืนยันการสมัครสมาชิกค่ะ<br/>*ถ้าไม่พบกรุณาตรวจสอบในกล่องจดหมายขยะ',
    'landing-verify-email-success': 'คุณทำการยืนยันการสมัครสมาชิก<br/>เรียบร้อยแล้ว',
    // Reset password
    'landing-form-reset-password-title': 'ตั้งรหัสผ่านใหม่',
    'landing-form-reset-password-success-title': 'คุณตั้งรหัสผ่านใหม่เรียบร้อยแล้ว',
    'landing-form-reset-password-success-description': 'คุณสามารถใช้รหัสผ่านใหม่ในการเข้าสู่ระบบได้',
    'landing-form-reset-password-expired-title': 'ลิงก์ตั้งรหัสผ่านหมดอายุ',
    'landing-form-reset-password-expired-description': 'กรุณากด "ตกลง" เพื่อตั้งรหัสผ่านใหม่<br/>แล้วทำการตรวจสอบอีเมลของคุณเพื่อทำการตั้งรหัสผ่านใหม่<br/>ภายใน 30 นาที หลังได้รับอีเมลอีกครั้ง',
    'landing-form-action-link-fail-description': 'มีข้อผิดพลาดเกิดขึ้น<br/>กรุณาลองใหม่อีกครั้ง',
    // Login form
    'landing-form-required-login': 'กรุณาระบุรหัสผ่านของคุณ',
    'landing-form-forget-password': 'ลืมรหัสผ่าน ?',
    'landing-form-login-failure-title': '<p class="bold">อีเมลหรือรหัสผ่านของคุณไม่ถูกต้อง</p>',
    'landing-form-login-failure-description': 'กรุณาตรวจสอบและลองใหม่อีกครั้ง',
    'affiliate-form-login-title': 'Welcome to Corporate Secure Page',
    'affiliate-form-login-desc': 'Login with your organizational account.',
    'affiliate-form-login-username-required': 'Please enter your username',
    'affiliate-form-login-password-required': 'Please enter your password',
    'affiliate-form-login-button': 'Login',
    'affiliate-form-login-failure': 'Incorrect username or password. <br>Please check and try it again.',
    'affiliate-form-login-failure-cost-center-or-cost-owner-missing': 'Sorry, your cost center or cost center owner is missing! Please contact your HR. <br>True HR contact: HRIS@truecorp.co.th',
    'affiliate-form-login-failure-technical-problems': 'Login failed due to technical problems from TrueHR. Please contact your HR. <br>True HR contact: HRIS@truecorp.co.th',
    'affiliate-dialog-ok-button': 'OK',
    'error-unable-to-connect-SSO': 'ไม่สามารถเชื่อมต่อกับระบบ SSO ได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง หรือติดต่อฝ่าย IT ขององค์กร',
    // Forgot password form
    'landing-form-forgot-password-title': 'กรุณาระบุอีเมลบริษัทของคุณ',
    'landing-form-forgot-password-description': 'หากคุณต้องการตั้งรหัสผ่านใหม่ กรุณาระบุอีเมลที่ใช้ในการสมัคร',
    'landing-form-forgot-password-success-title': '<p class="forget-password-title">กรุณาตรวจสอบอีเมลของคุณ</p>',
    'landing-form-forgot-password-success-description': 'เราได้ทำการส่งอีเมลไปยัง<br/><span class="color-main">[email]</span> เรียบร้อยแล้ว<br/>กรุณาตรวจสอบอีเมลของคุณเพื่อทำการตั้งรหัสผ่านใหม่<br/>ภายใน 30 นาที หลังได้รับอีเมล',
    'landing-form-forgot-password-fail-message': 'การขอตั้งรหัสผ่านใหม่ไม่สำเร็จ <br/>กรุณากด "ตกลง" เพื่อตั้งรหัสผ่านใหม่อีกครั้ง',
    // Register / Join us form
    'landing-form-register-title': 'สนใจเข้าร่วมกับ Ascend Travel?',
    'landing-form-register-description': 'เนื่องจากบริษัทของคุณยังไม่ได้เข้าร่วมกับ Ascend Travel หากคุณสนใจที่จะใช้บริการของเรา กรุณาระบุข้อมูลของคุณเพื่อให้ทีมงานของเราติดต่อกลับคุณค่ะ',
    'landing-form-join-us-title': 'สนใจเข้าร่วมกับ Ascend Travel',
    'landing-form-join-us-description': 'หากคุณสนใจที่จะใช้บริการของเรา กรุณาระบุข้อมูลของคุณเพื่อให้ทีมงานของเราติดต่อกลับคุณค่ะ',
    'landing-form-register-success-title': '<p class="bold">เราได้รับข้อมูลของคุณเรียบร้อยแล้ว</p>',
    'landing-form-register-success-description': 'ทีมงานของเราจะติดต่อกลับคุณอย่างเร็วที่สุดค่ะ<br/>ขอบคุณที่ให้ความสนใจที่จะใช้บริการของเราค่ะ',
    'landing-form-join-us-error-title': 'การส่งข้อมูลของคุณล้มเหลว',
    'landing-form-join-us-error-description': 'กรุณาติดต่อ +66(0) 2-020-2351 หรือ Support@ascendtravel.com',
    'landing-form-register-error-title': 'การสมัครใช้งานของคุณล้มเหลว',
    'landing-form-register-error-description': 'กรุณาติดต่อ +66(0) 2-020-2351 หรือ Support@ascendtravel.com',
    // Verify register email
    'landing-form-verify-email-expired-title': 'ขออภัยค่ะ ลิงค์สำหรับเปิดใช้งานของคุณ<br/>ได้หมดอายุแล้ว',
    'landing-form-verify-email-expired-description': '<br/>เราได้ทำการส่งอีเมลยืนยันไปยังอีเมลของคุณอีกครั้ง<br/>กรุณาตรวจสอบอีเมลและทำการยืนยันการสมัครสมาชิก<br/>ภายใน 30 นาที หลังได้รับอีเมล<br/>*ถ้าไม่พบกรุณาตรวจสอบในกล่องจดหมายขยะ',
    'landing-form-verify-email-invalid-title': 'ลิงค์สำหรับเปิดใช้งานของคุณไม่ถูกต้อง',
    'landing-form-verify-email-invalid-description': 'กรุณาระบุอีเมลของคุณเพื่อส่งอีเมลยืนยันอีกครั้ง',
    // Login
    'landing-login-unable-get-company-feature': 'ระบบไม่สามารถดึงข้อมูลบริษัทได้ กรุณาติดต่อ Call Center เพื่อตรวจสอบข้อมูลเพิ่มเติม<br/>Call center +66(02) 2-020-2351',
    // Guideline
    'guideline-password': 'พิมพ์รหัสผ่านของคุณที่นี่',
    'guideline-confirm-password': 'ยืนยันรหัสผ่านของคุณที่นี่',
    'guideline-email': 'email@company.com',
    'guideline-name': 'ชื่อ/นามสกุล',
    'guideline-firstname': 'ชื่อ',
    'guideline-lastname': 'นามสกุล',
    'guideline-contact-number': '0XXXXXXXXX',
    'guideline-company': 'ชื่อบริษัท',
    'guideline-position': 'ตำแหน่งในบริษัท',
    'guideline-company-website': 'เว็บไซต์บริษัท (ถ้ามี)',
    'guideline-company-travelling-expense': 'ค่าใช้จ่ายการเดินทางของบริษัท (ถ้ามี)',
    // Validation message
    'validation-required-name': 'กรุณาระบุชื่อ/นามสกุลของคุณ',
    'validation-required-firstname': 'กรุณาระบุชื่อของคุณ',
    'validation-required-lastname': 'กรุณาระบุนามสกุลของคุณ',
    'validation-required-full-name': 'กรุณาระบุชื่อและนามสกุลของคุณ',
    'validation-required-email': 'กรุณาระบุอีเมลบริษัทของคุณ',
    'validation-required-contact-number': 'กรุณาระบุเบอร์ติดต่อของคุณ',
    'validation-required-company': 'กรุณาระบุชื่อบริษัทของคุณ',
    'validation-required-select-company': 'กรุณาเลือกบริษัทหลักของคุณ ',
    'validation-required-position': 'กรุณาระบุตำแหน่งของคุณ',
    'validation-required-accept-terms': 'กรุณากดยอมรับข้อกำหนดและเงื่อนไขในการสมัครสมาชิก',
    'validation-required-password': 'รหัสผ่านจะต้องเป็นตัวอักษรภาษาอังกฤษ A-Z หรือ a-z หรือ ตัวเลข 0-9 หรือ อักขระพิเศษยกเว้น ซิงเกิลโคด(\'), ดับเบิ้ลโคด("), คอมม่า(,) และ แบ็กสแลช(\\) จำนวน 8-16 หลัก',
    'validation-required-new-password': 'กรุณาระบุรหัสผ่านใหม่ของคุณ ',
    'validation-required-confirm-new-password': 'กรุณายืนยันรหัสผ่านใหม่ของคุณ ',
    'validation-previously-used-new-password': 'กรุณาตั้งรหัสผ่านอีกครั้งด้วยรหัสผ่านที่คุณไม่เคยใช้มาก่อน',
    'validation-required-title': 'กรุณาระบุชื่อบริษัท หรือ ชื่อ-นามสกุล',
    'validation-required-tax-number': 'กรุณาระบุหมายเลขประจำตัวผู้เสียภาษี หรือ หมายเลขบัตรประชาชน',
    'validation-invalid-tax-number': 'หมายเลขประจำตัวผู้เสียภาษี หรือหมายเลขบัตรประชาชนต้องเป็นตัวเลข 10 หรือ 13 หลักเท่านั้น',
    'validation-required-invoice-address': 'กรุณาระบุที่อยู่สำหรับออกใบกำกับภาษี หรือ ใบเสร็จ ',
    'validation-required-group-select-birth-date': 'กรุณาระบุวัน เดือน และปีเกิดที่ถูกต้อง',
    'validation-pattern-email': 'อีเมลของคุณไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง',
    'validation-pattern-name': 'ชื่อของคุณจะต้องเป็นตัวอักษร a-z A-Z',
    'validation-pattern-firstname': 'ชื่อของคุณจะต้องเป็นตัวอักษร a-z A-Z',
    'validation-pattern-lastname': 'นามสกุลของคุณจะต้องเป็นตัวอักษร a-z A-Z',
    'validation-pattern-full-name': 'กรุณาระบุชื่อและนามสกุลของผู้เข้าพักเป็นภาษาอังกฤษเท่านั้น',
    'validation-pattern-contact-number': 'กรุณาระบุเบอร์ติดต่อที่ถูกต้อง',
    'validation-min-length-password': 'รหัสผ่านจะต้องมีจำนวน 8-16 หลัก',
    'validation-max-length-password': 'รหัสผ่านจะต้องมีจำนวน 8-16 หลัก',
    'validation-match-password': 'รหัสผ่านไม่ตรงกับยืนยันรหัสผ่าน กรุณาตรวจสอบและลองใหม่อีกครั้ง',
    'validation-required-select-your-company': 'กรุณาเลือกบริษัท',
    'validation-required-time-of-birth': 'กรุณาเลือกช่วงเวลาเกิด',
    'btn-create-account': 'สมัครสมาชิก',
    'btn-try-again': 'ลองอีกครั้ง',
    'btn-continue': 'ดำเนินการต่อ',
    'btn-ok': 'ตกลง',
    'btn-submit-information': 'ส่งข้อมูล',
    'btn-login': 'เข้าสู่ระบบ',
    'link-resend': 'ส่งอีเมลยืนยันอีกครั้ง',
    'btn-request-new-password': 'ตั้งรหัสผ่านใหม่',
    'login-not-sure': 'หากคุณไม่แน่ใจว่าบริษัทของคุณเข้าร่วมกับ Ascend Travel แล้วหรือยัง',
    'click-here': 'คลิกที่นี่',
    'forget-password': 'ลืมรหัสผ่าน ?',
    'placeholder-password': 'พิมพ์รหัสผ่านของคุณที่นี่',
    'my-profile-headline': 'ข้อมูลส่วนตัวของฉัน',
    'my-profile-personal-informations': 'ข้อมูลส่วนตัว',
    'my-profile-edit-profile': 'แก้ไขข้อมูล',
    'my-profile-name': 'ชื่อ/นามสกุล',
    'my-profile-firstname': 'ชื่อ',
    'my-profile-lastname': 'นามสกุล',
    'my-profile-full-name-label': 'ชื่อ/นามสกุล',
    'my-profile-full-name-placeholder': 'ชื่อ-นามสกุลภาษาอังกฤษ',
    'my-profile-member-code': 'รหัสสมาชิก',
    'my-profile-birthday': 'วันเกิด',
    'my-profile-company-name': 'ชื่อบริษัท',
    'my-profile-nationality': 'สัญชาติ',
    'my-profile-phone-number': 'เบอร์ติดต่อ',
    'my-profile-phone-number-placeholder': 'e.g. 0812345678',
    'my-profile-email': 'อีเมล',
    'my-profile-working-position': 'ตำแหน่ง',
    'my-profile-tax-invoice': 'ที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'my-profile-add-tax': 'เพิ่มที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'my-profile-edit': 'แก้ไขข้อมูล',
    'my-profile-delete': 'ลบข้อมูล',
    'my-profile-edit-presonal-profile': 'แก้ไขข้อมูลส่วนตัว',
    'my-profile-birthdate-remark': 'ข้อมูลนี้ถูกใช้และประมวลผลสำหรับการค้นหาที่พักเสริมพลังบวก หากต้องการเปลี่ยนแปลงวันเกิด สามารถติดต่อ Call Center: <b>+66(0) 2-020-2351</b> / Line Official Account: <b>@AscendTravel</b>',
    'my-profile-edit-button-submit': 'บันทึกข้อมูล',
    'my-profile-edit-button-cancel': 'ยกเลิก',
    'my-profile-change-password-success-title': 'คุณตั้งรหัสผ่านใหม่เรียบร้อยแล้ว คุณสามารถใช้รหัสผ่านนี้ในการเข้าสู่ระบบครั้งถัดไป',
    'my-profile-change-password-success-description': '',
    'my-profile-change-password-failure-title': 'ตั้งรหัสผ่านใหม่ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    'my-profile-change-password-failure-description': '',
    'my-profile-edit-success-title': 'อัพเดทข้อมูลเรียบร้อยแล้ว',
    'my-profile-edit-success-description': '',
    'my-profile-edit-failure-title': 'ไม่สามารถอัพเดทข้อมูลได้',
    'my-profile-edit-failure-description': 'กรุณาลองใหม่อีกครั้ง',
    'my-profile-edit-address-failure-title': 'ไม่สามารถอัพเดทที่อยู่ได้',
    'my-profile-edit-address-failure-description': 'กรุณาลองใหม่อีกครั้ง',
    'my-profile-address-form-tax-number': 'หมายเลขประจำตัวผู้เสียภาษี',
    'my-profile-address-form-company-name': 'ชื่อบริษัท/ชื่อ-นามสกุล',
    'my-profile-address-form-company-name-placeholder': 'ชื่อบริษัท/ชื่อ-นามสกุล',
    'my-profile-address-form-tax-number-id': 'หมายเลขประจำตัวผู้เสียภาษี/บัตรประชาชน',
    'my-profile-address-form-tax-number-id-placeholder': 'หมายเลขประจำตัวผู้เสียภาษี/บัตรประชาชน',
    'my-profile-address-form-billing-address': 'ที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'my-profile-address-form-billing-address-placeholder': 'ที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'my-profile-address-form-btn-cancel': 'ยกเลิก',
    'my-profile-address-form-btn-submit': 'บันทึก',
    'my-profile-delete-address-success': 'ลบที่อยู่สำเร็จ',
    'my-profile-delete-address-failure': 'ลบที่อยู่ไม่สำเร็จ',
    'my-profile-delete-address-failure-text': 'กรุณาลองใหม่อีกครั้ง',
    'my-profile-confirm-msg-delete-address': 'คุณต้องการลบข้อมูลที่อยู่นี้ใช่หรือไม่?',
    'my-profile-confirm-msg-type-address': 'ข้อมูลที่อยู่',
    'my-profile-confirm-msg-type-profile': 'ข้อมูลส่วนตัว',
    'my-profile-confirm-msg': 'คุณยังไม่ได้ทำการบันทึก{dataType}ที่แก้ไขต้องการออกจากหน้านี้โดยไม่บันทึกใช่หรือไม่?',
    'my-profile-address-dialog-button-delete': 'ลบ',
    'my-profile-address-dialog-button-cancel': 'ยกเลิก',
    'my-profile-address-dialog-button-close': 'ปิด',
    'facility-title': 'สิ่งอำนวยความสะดวก',
    'facility-title-room': 'สิ่งอำนวยความสะดวกภายในห้องพัก',
    'show-more-btn': 'แสดงทั้งหมด',
    'show-less-btn': 'ย่อ',
    'description-title': 'ข้อมูลที่พัก',
    'occupancy-policy-title': 'นโยบายการเข้าพักของที่พัก',
    'occupancy-policy-remark-title': 'ข้อมูลเพิ่มเติม',
    'remark': 'หมายเหตุ',
    'my-profile-subscription': 'การแจ้งเตือน',
    // Child policy
    'child-policy-title': 'เด็กและเตียงเสริม',
    'child-policy-table-guest-age': 'อายุผู้เข้าพัก',
    'child-policy-table-extrabed': 'เตียงเสริม',
    'child-policy-min-guest-age-all-age': 'เด็กทุกคนเข้าพักได้ (ไม่จำกัดอายุ)',
    'child-policy-min-guest-age': ' ผู้เข้าพักต้องมีอายุอย่างน้อย {x} ปี',
    'child-policy-infant-policy': 'เด็กทารกอายุ {from}-{to} ปี (รวมอายุ {to} ปี)',
    'child-policy-infant-description': 'กรุณาสอบถามที่พักโดยตรงเกี่ยวกับบริการเตียงเด็ก/เปล',
    'child-policy-child-policy': 'เด็กอายุ {from}-{to} ปี (รวมอายุ {to} ปี)',
    'child-policy-adult-policy': 'ผู้เข้าพักอายุ {from} ขึ้นไป ถือเป็นผู้ใหญ่',
    'child-policy-free-stay-description': 'พักฟรีหากใช้เตียงที่มีอยู่แล้ว',
    'child-policy-stay-description': 'ต้องใช้เตียงเสริม',
    'child-policy-free-description': 'ขอรับบริการเตียงเสริมได้โดยตรงกับที่พัก (อาจมีค่าใช้จ่ายเพิ่มเติม)',
    'child-policy-description': 'ขอรับบริการเตียงเสริมได้โดยตรงกับที่พัก (อาจมีค่าใช้จ่ายเพิ่มเติม)',
    // Review rating component in level-D
    'review-rating-title': 'คะแนนจากผู้เข้าพัก',
    'review-uncommonThings-title': 'รีวิวพิเศษจากผู้เข้าพัก',
    'review-uncommonThings-title-right': 'จากรีวิวผู้เข้าพักทั้งหมดพบว่า',
    // Product lists page
    'productlists-popular-filter': 'ตัวกรองยอดนิยม',
    'productlists-price-per-night': 'ราคาต่อคืน',
    'productlists-price': 'ราคา/คืน',
    'productlists-price-low-high': 'ราคาน้อยไปมาก',
    'productlists-price-high-low': 'ราคามากไปน้อย',
    'productlists-hotel-star': 'ระดับดาว',
    'productlists-hotel-star-1-5': 'ระดับดาว 1-5',
    'productlists-hotel-star-5-1': 'ระดับดาว 5-1',
    'productlists-no-star-rating': 'ไม่มีระดับดาว',
    'productlists-your-balance': 'คุณมีวงเงินในการจองที่พักอยู่ THB X,XXX/ห้อง/คืน',
    'productlists-sorting': 'จัดเรียงตาม',
    'productlists-filter': 'กรองผลการค้นหา',
    'productlists-filter-by': 'เลือกตัวกรอง',
    'productlists-more': 'เพิ่มเติม',
    'productlists-recommendation': 'ที่พักแนะนำ',
    'productlists-score': 'คะแนนจากผู้เข้าพัก',
    'productlists-poi-distance': 'ระยะทาง',
    'productlists-hotel-name': 'ชื่อโรงแรม',
    'productlists-hotel-name-sorting-a-z': 'ชื่อโรงแรม A-Z',
    'productlists-hotel-name-sorting-z-a': 'ชื่อโรงแรม Z-A',
    'productlists-special-price': 'ราคาที่ท่านเห็นเป็น ราคาพิเศษสำหรับบริษัท เท่านั้น',
    'productlists-available-room': 'เหลือเพียง {3} ห้อง เท่านั้น!',
    'product-booknow': 'จองวันนี้ ชำระเงินวันที่ {9 ก.ค. 60}',
    'productlists-see-room': 'ดูห้องพัก',
    'productlists-night': 'คืน',
    'productlists-no-room-left': 'ไม่มีห้องพัก ณ ช่วงวันที่คุณต้องการเข้าพัก',
    'productlists-recommended-title': 'ราคาดีลส่วนลดพิเศษสำหรับพนักงานองค์กรที่จองผ่าน Ascend Travel เท่านั้น',
    'productlists-found-01': 'พบที่พัก',
    'productlists-found-02': 'แห่ง',
    'productlists-found-03': 'แสดง',
    'productlists-pop-up-error': 'ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง',
    'productlists-pop-up-error-missing-email-header': 'ไม่พบอีเมลของผู้ใช้จากระบบ CPF Web Service',
    'productlists-pop-up-error-missing-email': 'กรุณาติดต่อหน่วยงาน CPF HRIS โดยการแจ้งผ่านระบบ Ask HR<br/>1. เข้าไปที่หน้าเว็บไซต์ <a class="link-hover-style" href="https://cpffamily.cpf.co.th" target="_blank">https://cpffamily.cpf.co.th</a><br/>2. เลือกไปที่ <span class="bold">HR-eXp</span> และกดปุ่ม <span class="bold">Ask HR</span> ด้านขวาบนของหน้าจอ',
    'productlists-pop-up-error-across-month': 'บริษัทของคุณไม่อนุญาตให้จองที่พักแบบคร่อมเดือน',
    'productlists-pop-up-error-across-month-share-budget': 'บริษัทของคุณหรือผู้ร่วมเดินทางไม่อนุญาตให้จองที่พักแบบคร่อมเดือน',
    'productlists-not-found': 'ขออภัยค่ะ ไม่พบที่พักจากคำที่คุณค้นหา คุณอาจเลือกจากสถานที่ค้นหายอดนิยมแทน',
    'productlists-business-desination': 'ระยะห่างจากจุดหมาย',
    'productlists-business-desination-kilometer': 'กม.',
    'productlists-business-distance': 'ห่างจาก {poi} {km} กม.',
    'productlists-hotel-review': 'คะแนนรีวิว',
    'productlists-hotel-review-9': 'ยอดเยี่ยม: 9+',
    'productlists-hotel-review-8': 'ดีเยี่ยม: 8+',
    'productlists-hotel-review-7': 'ดีมาก: 7+',
    'productlists-hotel-review-6': 'คะแนนรีวิว: 6+',
    'productlists-hotel-review-nonreview-newhotel': 'เพิ่งเปิดหรือยังรอการรีวิวจากผู้เข้าพัก',
    'productlists-filter-header': 'กรองผลการค้นหา',
    'productlists-filter-clear': 'ล้างทั้งหมด',
    'productlists-filter-submit': 'แสดงผลการค้นหา',
    'productlists-filter-show-more-item': 'แสดงทั้งหมด',
    'productlists-filter-facility': 'สิ่งอำนวยความสะดวก',
    'productlists-filter-include-breakfast': 'แสดงเฉพาะที่พักที่มี<br>บริการอาหารเช้าฟรี',
    'productlists-filter-popup-include-breakfast': 'แสดงเฉพาะที่พักที่มีบริการอาหารเช้าฟรี',
    'productlists-filter-location': 'ทำเลที่ตั้ง',
    'productlists-filter-location-search': 'ค้นหาทำเลที่ตั้ง',
    'productlists-filter-over-budget': 'แสดงที่พักเกินวงเงิน<br>ของคุณ',
    'productlists-filter-popup-over-budget': 'แสดงที่พักเกินวงเงินของคุณ',
    'productlists-filter-clear-btn': 'ล้าง',
    'productlists-over-budget': 'เกินวงเงินการจองของคุณ',
    'productlists-bestSeller': 'ที่พักยอดนิยม',
    'productlists-topBooking': 'ที่พักที่ยอดจองสูงสุด',
    'productlists-bestReview': 'ที่พักที่มีคะแนนรีวิวสูงสุด',
    'productlists-specialRecommendation': 'ที่พักแนะนำ',
    'productlists-holidayOffer': 'ที่พักแนะนำช่วงวันหยุด',
    'productlists-midMonth': 'ดีลพิเศษช่วงกลางเดือน',
    'productlists-summerDeal': 'ดีลพิเศษรับหน้าร้อน',
    'productlists-flashDeal': 'ด่วน! ดีลพิเศษวันนี้',
    'productlists-bestDeal': 'ดีลจองที่พักที่ดีที่สุด',
    'productlists-room-breakfast': 'รวมอาหารเช้า',
    'productlists-positive-energy': 'เสริมพลังบวก',
    'productlists-positive-energy-work': 'การงาน',
    'productlists-positive-energy-wealth': 'การเงิน',
    'productlists-positive-energy-love': 'ความรัก',
    'productlists-positive-energy-family': 'ครอบครัว',
    'productlists-positive-energy-friendship': 'มิตรภาพ',
    'productlists-positive-energy-fortune': 'โชคลาภ',
    'productlists-positive-energy-health': 'สุขภาพ',
    'productlists-positive-energy-patronage': 'อุปถัมภ์',
    'productlists-positive-energy-reputation': 'ชื่อเสียง',
    // Product list - guest review rating title
    'product-review-rating-exceptional': 'ยอดเยี่ยม',
    'product-review-rating-excellent': 'ดีเยี่ยม',
    'product-review-rating-very-good': 'ดีมาก',
    'product-review-rating-review-score': 'คะแนนรีวิว',
    // Product detail page
    'product-detail-choose-your-room': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23",
    'product-detail-room-type': "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01",
    'product-detail-room-condition': "\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E41\u0E25\u0E30\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02",
    'product-detail-number-of-guest': "\u0E1C\u0E39\u0E49\u0E40\u0E02\u0E49\u0E32\u0E1E\u0E31\u0E01",
    'product-detail-price-today': "\u0E23\u0E32\u0E04\u0E32\u0E15\u0E48\u0E2D\u0E04\u0E37\u0E19",
    'product-detail-amount-room': "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2B\u0E49\u0E2D\u0E07",
    'product-detail-room-last-five': "\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E40\u0E1E\u0E35\u0E22\u0E07 {room} \u0E2B\u0E49\u0E2D\u0E07 \u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19!",
    'product-detail-room-breakfast': "\u0E23\u0E27\u0E21\u0E2D\u0E32\u0E2B\u0E32\u0E23\u0E40\u0E0A\u0E49\u0E32",
    'product-detail-room-all-inclusive': "\u0E23\u0E27\u0E21\u0E2D\u0E32\u0E2B\u0E32\u0E23\u0E40\u0E0A\u0E49\u0E32 \u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19 \u0E40\u0E22\u0E47\u0E19 \u0E41\u0E25\u0E30\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E14\u0E37\u0E48\u0E21",
    'product-detail-room-full-board': "\u0E23\u0E27\u0E21\u0E2D\u0E32\u0E2B\u0E32\u0E23\u0E40\u0E0A\u0E49\u0E32 \u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19 \u0E41\u0E25\u0E30\u0E40\u0E22\u0E47\u0E19",
    'product-detail-room-half-board': "\u0E23\u0E27\u0E21\u0E2D\u0E32\u0E2B\u0E32\u0E23\u0E40\u0E0A\u0E49\u0E32\u0E41\u0E25\u0E30\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19 \u0E2B\u0E23\u0E37\u0E2D \u0E2D\u0E32\u0E2B\u0E32\u0E23\u0E40\u0E0A\u0E49\u0E32\u0E41\u0E25\u0E30\u0E40\u0E22\u0E47\u0E19",
    'product-detail-room-only': "\u0E44\u0E21\u0E48\u0E23\u0E27\u0E21\u0E2D\u0E32\u0E2B\u0E32\u0E23\u0E40\u0E0A\u0E49\u0E32",
    'product-detail-room-condition-cancellation-fee': 'ยกเลิกมีค่าธรรมเนียม',
    'product-detail-room-cancellation-policy': "\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01",
    'product-detail-room-cancellation-non-refundable': "\u0E23\u0E32\u0E04\u0E32\u0E1E\u0E34\u0E40\u0E28\u0E29 \u0E02\u0E2D\u0E23\u0E31\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E04\u0E37\u0E19\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49",
    'product-detail-room-cancellation-charge': "- \u0E2B\u0E32\u0E01\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E2B\u0E25\u0E31\u0E07\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48 {date} \u0E08\u0E30\u0E40\u0E2A\u0E35\u0E22\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01 {currency} {amount} \u0E15\u0E48\u0E2D\u0E2B\u0E49\u0E2D\u0E07",
    'product-detail-room-cancellation-night': "- \u0E2B\u0E32\u0E01\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E2B\u0E25\u0E31\u0E07\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48 {date} \u0E08\u0E30\u0E40\u0E2A\u0E35\u0E22\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E23\u0E32\u0E04\u0E32 \u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A\u0E04\u0E48\u0E32\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01 {night} \u0E04\u0E37\u0E19\u0E41\u0E23\u0E01",
    'product-detail-room-cancellation-percent': "- \u0E2B\u0E32\u0E01\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E2B\u0E25\u0E31\u0E07\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48 {date} \u0E08\u0E30\u0E40\u0E2A\u0E35\u0E22\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01 {percent}% \u0E08\u0E32\u0E01\u0E23\u0E32\u0E04\u0E32\u0E2A\u0E38\u0E17\u0E18\u0E34\u0E17\u0E35\u0E48\u0E08\u0E2D\u0E07\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01",
    'product-detail-room-cancellation-free': "\u0E1F\u0E23\u0E35! \u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01 \u0E2B\u0E32\u0E01\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E48\u0E2D\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48 {date}",
    'product-detail-room-paylater-description': "\u0E08\u0E2D\u0E07\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49 \u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48 {date}",
    'product-detail-budget-limit': "\u0E04\u0E38\u0E13\u0E21\u0E35\u0E27\u0E07\u0E40\u0E07\u0E34\u0E19\u0E43\u0E19\u0E01\u0E32\u0E23\u0E08\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E1E\u0E31\u0E01\u0E2D\u0E22\u0E39\u0E48 <strong>{x}</strong> /\u0E2B\u0E49\u0E2D\u0E07/\u0E04\u0E37\u0E19",
    'product-detail-new-budget-limit': "\u0E04\u0E38\u0E13\u0E21\u0E35\u0E27\u0E07\u0E40\u0E07\u0E34\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E43\u0E19\u0E01\u0E32\u0E23\u0E08\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E1E\u0E31\u0E01\u0E2D\u0E22\u0E39\u0E48 <strong>{x}</strong> /\u0E2B\u0E49\u0E2D\u0E07/\u0E04\u0E37\u0E19",
    'product-detail-room-over-limit': "\u0E40\u0E01\u0E34\u0E19\u0E27\u0E07\u0E40\u0E07\u0E34\u0E19",
    'product-detail-room-over-price': "\u0E08\u0E48\u0E32\u0E22\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E08\u0E32\u0E01\u0E27\u0E07\u0E40\u0E07\u0E34\u0E19",
    'product-detail-room-night': "/\u0E04\u0E37\u0E19",
    'product-detail-tooltip-price-per-night': "1 \u0E2B\u0E49\u0E2D\u0E07 x 1 \u0E04\u0E37\u0E19",
    'product-detail-tooltip-user-budget': "\u0E27\u0E07\u0E40\u0E07\u0E34\u0E19\u0E15\u0E48\u0E2D\u0E2B\u0E49\u0E2D\u0E07\u0E15\u0E48\u0E2D\u0E04\u0E37\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'product-detail-tooltip-pay-over-budget': "\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E2D\u0E07",
    'product-detail-image-map-description': "*\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E41\u0E1C\u0E19\u0E17\u0E35\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E17\u0E35\u0E48\u0E1E\u0E31\u0E01\u0E43\u0E01\u0E25\u0E49\u0E40\u0E04\u0E35\u0E22\u0E07",
    'product-detail-review-mysterious-things': 'เจอสิ่งลี้ลับ',
    'product-detail-review-pest': 'เจอสัตว์รบกวน',
    'product-detail-bathroom': 'ห้องน้ำ',
    'product-detail-private-bathroom': 'ห้องน้ำส่วนตัว',
    'product-detail-shared-bathroom': 'ห้องน้ำส่วนรวม',
    'product-detail-bedroom': 'ห้องนอน',
    'product-detail-sqm': 'ตารางเมตร',
    'product-detail-information': 'รายละเอียดเพิ่มเติม',
    'extra-bed-include-in-room-price': 'รวมค่าบริการเตียงเสริมแล้ว',
    'extra-bed-include': "\u0E23\u0E27\u0E21\u0E40\u0E15\u0E35\u0E22\u0E07\u0E40\u0E2A\u0E23\u0E34\u0E21 {text} \u0E40\u0E15\u0E35\u0E22\u0E07",
    'product-detail-room-note-title': 'สิทธิประโยชน์และข้อมูลเพิ่มเติม',
    'product-detail-room-note-see-more': 'ดูเพิ่มเติม',
    'room-detail-title': "\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01",
    'room-not-available-line-1': "\u0E02\u0E2D\u0E2D\u0E20\u0E31\u0E22\u0E04\u0E48\u0E30 \u0E44\u0E21\u0E48\u0E21\u0E35\u0E2B\u0E49\u0E2D\u0E07\u0E27\u0E48\u0E32\u0E07\u0E43\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E40\u0E25\u0E37\u0E2D\u0E01",
    'room-not-available-line-2': "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E27\u0E31\u0E19\u0E40\u0E02\u0E49\u0E32\u0E1E\u0E31\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'room-price-change-line-1': 'ราคาห้องพักมีการเปลี่ยนแปลง',
    'room-price-change-line-2': 'คุณสามารถดูราคาใหม่ได้',
    'room-price-change-line-3': 'ตามข้อมูลด้านล่าง',
    'room-price-change-space': '',
    'room-price-change-col-1': 'ประเภทห้องพัก',
    'room-price-change-col-2': 'ราคาก่อนหน้า',
    'room-price-change-col-3': 'ราคาใหม่',
    'room-price-btn-accept': 'ยอมรับ',
    'room-price-btn-back': 'กลับไปค้นหาใหม่',
    'show-photo': "\u0E14\u0E39\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
    'product-description-text-sha-title': 'SHA : Amazing Thailand Safety & Health Administration',
    'product-description-text-sha-plus-title': 'SHA Plus : Amazing Thailand Safety & Health Administration',
    'product-description-text-sha-desc': 'ผู้ประกอบการผ่านมาตรฐานแนวทางความปลอดภัยด้านสุขอนามัย ออกให้โดยการท่องเที่ยวแห่งประเทศไทย (ททท.)',
    'product-description-text-sha-plus-desc': 'ผู้ประกอบการผ่านมาตรฐานแนวทางความปลอดภัยด้านสุขอนามัย ออกให้โดยการท่องเที่ยวแห่งประเทศไทย (ททท.) และพนักงานในสถานประกอบการได้รับการฉีดวัคซีนแล้วมากกว่า ร้อยละ 70',
    'product-description-text-sha-certificate-id': 'รหัสผู้ประกอบการ',
    'product-description-text-property-opened': 'ที่พักสร้างปี',
    'product-description-text-recent-renovation': 'ที่พักปรับปรุงล่าสุดปี',
    'sanitized-stay-title': 'สุขภาพและอนามัย',
    'product-detail-dialog-continue-with-my-budget': 'คุณต้องการจองต่อโดยใช้วงเงินคุณเอง?',
    'product-detail-dialog-continue-with-credit-card': 'คุณต้องการจองต่อโดยชำระเงินค่าที่พักเอง?',
    'product-detail-dialog-continue-with-multi-payment': 'คุณต้องการจองต่อโดยชำระเงินค่าที่พักเพิ่มเอง?',
    'product-detail-dialog-continue-confirm-with-my-budget': 'จองต่อโดยใช้วงเงินคุณเอง',
    'product-detail-dialog-continue-confirm-with-credit-card': 'จองต่อโดยชำระค่าที่พักเอง',
    'product-detail-dialog-continue-confirm-with-multi-payment': 'จองต่อโดยชำระค่าที่พักเพิ่มเอง',
    'product-detail-dialog-continue-sub-text-with-my-budget': 'คุณไม่สามารถใช้วงเงินกับผู้ร่วมเดินทางได้ หากคุณเลือก จองต่อโดยใช้วงเงินคุณเอง เราจะทำการยกเลิกการวงเงินให้โดยอัตโนมัติ',
    'product-detail-dialog-continue-sub-text-with-credit-card': 'คุณไม่สามารถใช้วงเงินกับผู้ร่วมเดินทางได้ หากคุณเลือก จองต่อโดยชำระค่าที่พักเอง เราจะทำการยกเลิกการวงเงินให้โดยอัตโนมัติ',
    'product-detail-dialog-continue-sub-text-with-multi-payment': 'คุณไม่สามารถใช้วงเงินกับผู้ร่วมเดินทางได้ หากคุณเลือก จองต่อโดยชำระค่าที่พักเพิ่มเอง เราจะทำการยกเลิกการวงเงินให้โดยอัตโนมัติ',
    'product-detail-dialog-btn-continue': 'จองต่อ',
    // booking
    'booking-cancellation-fee': 'ค่าธรรมเนียมยกเลิก',
    'booking-cancellation-fee-2': 'ค่าธรรมเนียม',
    'booking-cancellation-fee-3': 'ปฏิเสธรายการจองห้องพัก',
    'booking-cancellation-free': 'ไม่มีค่าธรรมเนียม',
    'booking-cancellation-free-2': 'ท่านสามารถปฏิเสธรายการจองห้องพักโดยไม่มีค่าธรรมเนียมการยกเลิก',
    'booking-cancellation-booking-id': 'หมายเลขการจอง',
    'booking-cancellation-if-cancel-text': 'หากท่านยกเลิกการจองจะมีค่าธรรมเนียมในการยกเลิกดังนี้',
    'booking-cancellation-if-cancel-text-2': 'หากท่านปฏิเสธรายการจองห้องพัก จะมีค่าธรรมเนียมในการยกเลิกดังนี้',
    'booking-cancellation-room-type': 'ประเภทห้องพัก',
    'booking-cancellation-total': 'ค่าธรรมเนียมการยกเลิกสุทธิ',
    'booking-cancellation-note': 'หมายเหตุ',
    'booking-cancellation-note-text': 'ค่าธรรมเนียมการยกเลิกอาจมีการเปลี่ยนแปลง ขึ้นอยู่กับเวลาที่ทำการยกเลิก',
    'booking-cancellation-promotion-text': 'กรณีใช้โค้ดโปรโมชั่น ค่าธรรมเนียมการยกเลิกคำนวณจากราคาสุทธิหลังหักส่วนลด หรือเป็นไปตามที่บริษัทกำหนด',
    'booking-cancellation-btn-confirm': 'ยืนยันการยกเลิก',
    'booking-cancellation-btn-confirm-2': 'ปฏิเสธการจอง',
    'booking-cancellation-btn-close': 'กลับไปก่อนหน้า',
    'booking-cancellation-empty': 'ยังไม่มีรายการจอง',
    'booking-cancel-success': 'ทำการยกเลิกรายการจองหมายเลข {bookingID} เรียบร้อยแล้ว',
    'booking-cancel-failure': 'ยกเลิกรายการจองหมายเลข {bookingID} ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    'booking-cancel-date': 'วันยกเลิก',
    'booking-cancellation-credit-terms': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินแบบส่งใบแจ้งหนี้',
    'booking-cancellation-credit-terms-main-booker': 'ผู้จองหลัก',
    'booking-cancellation-credit-terms-co-booker': 'ผู้จองร่วม',
    'booking-cancellation-credit-card': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินด้วยบัตรเครดิต/เดบิต',
    'booking-cancellation-true-money': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินด้วยทรูมันนี่ วอลเล็ท ',
    'booking-cancellation-corporate-fleet': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินด้วยบัตรฟลีทบริษัทของเจ้าของบัตร',
    'booking-cancellation-personal-fleet': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินด้วยบัตรฟลีทส่วนตัวของเจ้าของบัตร',
    'booking-cancellation-multipayment': 'แบ่งชำระเงิน 2 ช่องทาง',
    'booking-cancellation-reject-reason-label': 'เหตุผลการปฏิเสธ',
    'booking-cancellation-reject-reason-placeholder': 'ระบุเหตุผล...',
    'booking-cancellation-reject-reason-error-required': 'กรุณาระบุเหตุผลการปฏิเสธ',
    'booking-cancellation-refund-details': 'เราไม่สามารถดำเนินการคืนเงินโดยอัตโนมัติทันทีที่ได้รับคำสั่งยกเลิกการจอง คุณจะต้องดำเนินการ <span class="refund-themselves"">ขอรับเงินคืนด้วยตนเอง</span><br>กรุณาติดต่อ <b>Call Center : +66(0) 2-020-2351</b> หรือ <b>Line Official Account : @AscendTravel</b>',
    'product-menu-photo': "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
    'product-menu-room': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01",
    'product-menu-detail': "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E1E\u0E31\u0E01",
    'product-menu-facility': "\u0E2A\u0E34\u0E48\u0E07\u0E2D\u0E33\u0E19\u0E27\u0E22\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E30\u0E14\u0E27\u0E01",
    'booking-arranged-by': 'จัดเรียงตาม',
    'booking-report': 'ดึงรายงานการจอง (.xlsx)',
    'booking-report-dialog-title': 'ดึงรายงานการจองจากช่วงวันเข้าพัก',
    'booking-report-check-in-from': 'จาก',
    'booking-report-check-in-to': 'ถึง',
    'booking-report-placeholder-from': 'อ. 1 ม.ค. 62',
    'booking-report-placeholder-to': 'พฤ. 31 ม.ค. 62',
    'booking-report-information': 'รายงานนี้มีเฉพาะรายการจองที่ชำระเงินด้วยรูปแบบ Credit Terms เท่านั้น',
    'booking-report-data-not-found': 'ไม่มีรายการจองที่พักด้วยการชำระเงินแบบส่งใบแจ้งหนี้ (Credit Terms) ในช่วงวันที่คุณเลือก',
    'booking-report-export-error': 'การดึงไฟล์รายงานการจองของคุณล้มเหลว<br>กรุณาทำรายการอีกครั้ง',
    'dialog-booking-report-error': 'กรุณาระบุช่วงวันเข้าพัก',
    'booking-condition-popup-title': 'เงื่อนไขการยกเลิกห้องพัก',
    'booking-condition-popup-detail-1': 'หากยกเลิกหลังวันที่',
    'booking-condition-popup-detail-2': 'จะเสียค่าธรรมเนียมการยกเลิกห้องพัก THB',
    'booking-condition-popup-detail-3': 'ต่อห้อง',
    // cart
    'cart-booking-detail': "\u0E2A\u0E23\u0E38\u0E1B\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E08\u0E2D\u0E07",
    'cart-price-for': "\u0E23\u0E32\u0E04\u0E32\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A",
    'cart-night': "\u0E04\u0E37\u0E19",
    'cart-time-from': "\u0E15\u0E31\u0E49\u0E07\u0E41\u0E15\u0E48",
    'cart-time-until': "\u0E08\u0E19\u0E16\u0E36\u0E07",
    'cart-room': "\u0E2B\u0E49\u0E2D\u0E07",
    'cart-room-type-detail': "\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01",
    'cart-grand-total': "\u0E22\u0E2D\u0E14\u0E23\u0E27\u0E21\u0E2A\u0E38\u0E17\u0E18\u0E34",
    'cart-include-vat-label': "\u0E23\u0E32\u0E04\u0E32\u0E19\u0E35\u0E49\u0E23\u0E27\u0E21\u0E20\u0E32\u0E29\u0E35\u0E41\u0E25\u0E30\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E41\u0E25\u0E49\u0E27",
    'cart-credit-card-label': "\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15/\u0E40\u0E14\u0E1A\u0E34\u0E15",
    'cart-non-refund-label': "\u0E23\u0E32\u0E04\u0E32\u0E19\u0E35\u0E49\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E37\u0E19\u0E40\u0E07\u0E34\u0E19\u0E44\u0E14\u0E49",
    'cart-pay-on-label': "\u0E08\u0E30\u0E15\u0E31\u0E14\u0E40\u0E07\u0E34\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48",
    'cart-book-now': "\u0E08\u0E2D\u0E07\u0E17\u0E31\u0E19\u0E17\u0E35",
    'cart-select-room': "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01",
    'cart-button-continue': "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
    'cart-button-confirm-to-book': "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E08\u0E2D\u0E07",
    'cart-surcharge-include': "\u0E23\u0E32\u0E04\u0E32\u0E19\u0E35\u0E49\u0E23\u0E27\u0E21\u0E20\u0E32\u0E29\u0E35, {text} \u0E41\u0E25\u0E30\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E41\u0E25\u0E49\u0E27",
    'cart-surcharge-exclude': "\u0E23\u0E32\u0E04\u0E32\u0E44\u0E21\u0E48\u0E23\u0E27\u0E21 (\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E42\u0E14\u0E22\u0E17\u0E35\u0E48\u0E1E\u0E31\u0E01): {text}",
    'cart-seperate-payment': "\u0E41\u0E1A\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E40\u0E1B\u0E47\u0E19 2 \u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07",
    'cart-seperate-payment-credit-terms': "\u0E41\u0E1A\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
    'cart-pay-credit-terms': "\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E41\u0E1A\u0E1A\u0E2A\u0E48\u0E07\u0E43\u0E1A\u0E41\u0E08\u0E49\u0E07\u0E2B\u0E19\u0E35\u0E49\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17",
    'cart-pay-corporate-fleet': "\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E31\u0E15\u0E23\u0E1F\u0E25\u0E35\u0E17\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17",
    'cart-pay-personal-fleet': "\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E31\u0E15\u0E23\u0E1F\u0E25\u0E35\u0E17\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27",
    'cart-pay-corporate-fleet-new-line': "\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E31\u0E15\u0E23<br>\u0E1F\u0E25\u0E35\u0E17\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17",
    'cart-pay-personal-fleet-new-line': "\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E31\u0E15\u0E23<br>\u0E1F\u0E25\u0E35\u0E17\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27",
    'cart-pay-debit-card': "\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E2D\u0E07",
    'cart-multi-pay-label': "\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E41\u0E1A\u0E1A 2 \u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E2D\u0E07\u0E08\u0E30\u0E15\u0E31\u0E14\u0E40\u0E07\u0E34\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48",
    'cart-max-guest': 'ผู้เข้าพักสูงสุด',
    'cart-adult-text': 'ผู้ใหญ่',
    'cart-child-text': 'เด็ก',
    'cart-adult': 'คน',
    'cart-child': 'คน',
    'cart-budget-no-remaning': 'คุณต้องชำระเงินค่าที่พักเอง ',
    'cart-budget-detail-below': ' คุณต้องชำระเงินเพิ่มเองตามรายละเอียดด้านล่างนี้',
    'cart-budget-no-remaning-mobile': 'คุณต้องชำระเงินค่าที่พักเองตามรายละเอียด',
    'cart-budget-detail-mobile': 'คุณต้องชำระเงินเพิ่มเองตามรายละเอียด',
    'cart-booker': 'ผู้จอง',
    'cart-co-booker': 'ผู้ร่วมเดินทาง',
    'cart-cannot-share-budget': 'ไม่สามารถใช้วงเงินกับผู้ร่วมเดินทางได้ กรุณา',
    'cart-before-continuing': 'ก่อนดำเนินการต่อ',
    'cart-btn-cannot-share-budget': 'ยกเลิกการรวมวงเงิน',
    'cart-share-budget-detail-below': ' คุณต้องชำระเงินเพิ่มเองตามรายการชำระเงินด้านล่างนี้',
    'cart-budget-over-budget-mobile': 'คุณต้องชำระเงินค่าเพิ่มเองตามรายละเอียด',
    'cart-budget-over-budget-book-for-traveller': 'วงเงินต่อคืนของผู้เข้าพักไม่พอ',
    'cart-budget-over-budget-book-for-traveller-sub-text': 'กรุณาตรวจสอบหรือเลือกห้องพักใหม่อีกครั้ง',
    'cart-currency-note': 'เราจะเรียกเก็บรายการจองของคุณในสกุลเงิน THB ราคาที่แสดงในสกุล {currency} เป็นราคาโดยประมาณจากการแปลงสกุลเงิน THB เป็นสกุลเงิน {currency} โดยอิงตามอัตราแลกเปลี่ยนปัจจุบัน (โปรดทราบว่าอัตราแลกเปลี่ยนอาจมีการเปลี่ยนแปลง)',
    'cart-approximate-price-in': 'ราคาโดยประมาณสกุลเงิน',
    'cart-taxes-fees': 'ภาษีและค่าธรรมเนียม',
    'cart-taxes-fees-description': 'ค่าบริการนี้รวมจำนวนเงินโดยประมาณที่ผู้ให้บริการด้านการเดินทาง (เช่น โรงแรม บริษัทเช่ารถ) จ่ายภาษี และ/หรือภาษีที่เราจ่ายให้กับหน่วยงานสรรพากรในการจองของคุณ (รวมถึงแต่ไม่จำกัดเพียงการขาย จำนวนผู้เข้าพัก และภาษีมูลค่าเพิ่ม) จำนวนนี้อาจรวมถึงจำนวนเงินใดๆ ที่เรียกเก็บจากเราสำหรับค่าธรรมเนียมรีสอร์ต ค่าทำความสะอาด และค่าธรรมเนียมอื่นๆ และ/หรือค่าธรรมเนียมที่เรา ซัพพลายเออร์โรงแรม และ/หรือเว็บไซต์ที่คุณจองเก็บไว้เป็นส่วนหนึ่งของค่าตอบแทนสำหรับบริการของเรา และ/หรือบริการของพวกเขา ซึ่งจะแตกต่างกันไปตามปัจจัยต่างๆ เช่น สถานที่ จำนวน และวิธีการจองของคุณ สำหรับรายละเอียดเพิ่มเติม โปรดดูข้อกำหนดและเงื่อนไข',
    'cart-terms-conditions': 'เมื่อทำการจองนี้ถือว่า คุณเข้าใจและยอมรับ',
    'cart-terms-conditions-and': 'และ',
    'cart-terms-conditions-supplier': 'ข้อกำหนดและเงื่อนไขของซัพพลายเออร์',
    'cart-terms-conditions-agent': 'เงื่อนไขการใช้บริการของเอเจนต์',
    'cart-price-info': 'ข้อมูลเกี่ยวกับราคา',
    'cart-discount': 'ส่วนลด',
    'cart-promotion-code': 'โค้ดโปรโมชั่น',
    'cart-select-code': 'เลือกโค้ดที่มีอยู่',
    'cart-promotion-code-discount': 'ส่วนลดจากโค้ดโปรโมชั่น',
    'cart-promotion-code-error-invalid_payment_method': 'กรุณาเปลี่ยนช่องทางการชำระเงินเพื่อใช้โค้ดนี้',
    'cart-promotion-code-error-reached_limit': 'กรุณาเลือกใช้โค้ดอื่น โค้ดนี้ถูกใช้ครบจำนวนสิทธิ์แล้ว',
    'cart-promotion-code-error-condition_not_met': 'กรุณาเลือกใช้โค้ดอื่น โค้ดนี้ไม่ตรงตามเงื่อนไขการจองนี้',
    'cart-dialog-use-promotion-code-title': 'ใช้โค้ดโปรโมชั่น',
    'cart-dialog-use-promotion-code-search-placeholder': 'ระบุโค้ดโปรโมชั่นของคุณที่นี่',
    'cart-dialog-use-promotion-code-best-deal': 'คุ้มค่าที่สุด',
    'cart-dialog-use-promotion-code-btn-search': 'ใช้โค้ด',
    'cart-dialog-use-promotion-code-search-error-invalid': 'โค้ดโปรโมชั่นไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง',
    'cart-dialog-use-promotion-code-discount': 'ส่วนลด {amount}',
    'cart-dialog-use-promotion-code-max-discount-per-book': 'ลดสูงสุด {amount}',
    'cart-dialog-use-promotion-code-min-spend-per-book': 'ยอดจองขั้นต่ำ {amount}',
    'cart-dialog-use-promotion-code-min-spend-per-book-no-limit': 'ไม่มียอดจองขั้นต่ำ',
    'cart-dialog-use-promotion-code-term-condition': 'เงื่อนไข',
    'cart-dialog-use-promotion-no-promotion-code': 'ไม่มีโค้ดที่ใช้ได้',
    'cart-dialog-use-promotion-credit-terms': 'เฉพาะเมื่อชำระเงินแบบส่งใบแจ้งหนี้ เท่านั้น',
    'cart-dialog-use-promotion-credit-debit-card-bank': 'เฉพาะเมื่อชำระเงินผ่านบัตรเครดิต/เดบิต {bank} เท่านั้น',
    'cart-dialog-use-promotion-credit-card': 'เฉพาะเมื่อชำระเงินผ่านบัตรเครดิต {bank}เท่านั้น',
    'cart-dialog-use-promotion-debit-card': 'เฉพาะเมื่อชำระเงินผ่านบัตรเดบิต {bank}เท่านั้น',
    'cart-dialog-use-promotion-payment': 'เฉพาะเมื่อชำระเงินผ่าน{payment} เท่านั้น',
    'cart-dialog-use-promotion-promotional-code-participating-payment-methods': 'เฉพาะเมื่อชำระเงินผ่านช่องทางที่ร่วมรายการเท่านั้น',
    'cart-dialog-use-promotion-discount': 'ส่วนลดจากโค้ดโปรโมชั่น',
    'cart-dialog-confirm-continue-without-promotion-code-title': 'ดำเนินการต่อโดยไม่ใช้โค้ด?',
    'cart-dialog-confirm-continue-without-promotion-code-desc': 'โค้ดโปรโมชันนี้ไม่เข้าเงื่อนไขของรายการจองนี้<br>คุณสามารถดำเนินการต่อโดยไม่ใช้โค้ด หรือกลับไปเลือกโค้ดใหม่ได้',
    'cart-dialog-confirm-continue-without-promotion-code-cancel': 'กลับไปเลือกโค้ดใหม่',
    'cart-dialog-confirm-continue-without-promotion-code-cancel-short': 'เลือกโค้ดใหม่',
    'cart-dialog-confirm-continue-without-promotion-code-confirm': 'ดำเนินการต่อโดยไม่ใช้โค้ด',
    'cart-dialog-error-session-expired-title': 'การค้นหานี้หมดอายุแล้ว',
    'cart-dialog-error-session-expired-description': 'เนื่องจากหมดเวลาสำหรับการจอง<br>กรุณาค้นหาใหม่อีกครั้ง',
    // Month
    'day-select': 'วัน',
    'year-select': 'ปี',
    'month-select': 'เดือน',
    'month-january': 'มกราคม',
    'month-february': 'กุมภาพันธ์',
    'month-march': 'มีนาคม',
    'month-april': 'เมษายน',
    'month-may': 'พฤษภาคม',
    'month-june': 'มิถุนายน',
    'month-july': 'กรกฏาคม',
    'month-august': 'สิงหาคม',
    'month-september': 'กันยายน',
    'month-october': 'ตุลาคม',
    'month-november': 'พฤศจิกายน',
    'month-december': 'ธันวาคม',
    // Thank you
    'thankyou-download-voucher': 'ดาวน์โหลดใบยืนยันการจองที่พัก',
    'thankyou-print-voucher': 'สั่งพิมพ์',
    'thankyou-office-address-name': 'บริษัท แอสเซนด์ แทรเวิล จำกัด (สำนักงานใหญ่) ',
    'thankyou-office-address-location': 'เลขที่ 89 อาคารเอไอเอ แคปปิตอล เซ็นเตอร์ ชั้นที่ 18-19 ถนนรัชดาภิเษก แขวงดินแดง เขตดินแดง กรุงเทพมหานคร 10400',
    'thankyou-office-address-taxnum': 'เลขประจำตัวผู้เสียภาษี : 0105559069212',
    'thankyou-bookingId-ref': 'สำหรับอ้างอิงกับแอสเซนด์แทรเวิล',
    'thankyou-bookingId-hotel-ref-number': 'หมายเลขการจอง',
    'thankyou-bookingId-hotel-book-by': 'จองและชำระเงินโดย ',
    'thankyou-payment-title': 'ช่องทางการชำระเงิน',
    'thankyou-payment-detail': 'บัตรเครดิต/เดบิต',
    'thankyou-payment-detail-true-money': 'ทรูมันนี่ วอลเล็ท',
    'thankyou-payment-detail-2': 'คุณเลือกการชำระเงินแบบ Credit Terms',
    'thankyou-payment-creditcard-details': 'ชำระเงินผ่านบัตรเครดิต/เดบิต ง่ายๆ โดยไม่เสียค่าธรรมเนียม สะดวก รวดเร็ว และปลอดภัย ได้ตลอด 24 ชั่วโมง',
    'thankyou-payment-date': 'วันที่ชำระเงิน',
    'thankyou-booking-details': 'สรุปรายละเอียดการจอง',
    'thankyou-details-props-info': 'รายละเอียดที่พัก',
    'thankyou-details-props-name': 'ชื่อที่พัก',
    'thankyou-details-props-address': 'ที่อยู่',
    'thankyou-details-props-phone': 'เบอร์ติดต่อ',
    'thankyou-details-details': 'รายละเอียดการจอง',
    'thankyou-details-roomtype': 'ประเภทห้องพัก',
    'thankyou-details-price': 'ราคา',
    'thankyou-guest-order-number': 'ผู้เข้าพัก ',
    'thankyou-guest-special-request': 'คำขอพิเศษ ',
    'thankyou-room-condition': "\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01",
    'thankyou-details-vat': 'ราคาไม่รวมภาษี',
    'thankyou-price-vat': 'ภาษีมูลค่าเพิ่ม',
    'thankyou-price-total': 'ยอดรวมสุทธิ',
    'thankyou-thankyou-statement-01': 'ขอขอบคุณที่ให้ความไว้วางใจในการใช้บริการกับ Ascend Travel',
    'thankyou-thankyou-statement-02': 'ท่านสามารถติดต่อสอบถาม Call Center +66(0) 2-020-2351 เปิดให้บริการตลอด 24 ชั่วโมงทุกวัน',
    'thankyou-status-pay-now-success-title': 'รายการจองห้องพักของคุณชำระเงินเรียบร้อยแล้ว',
    'thankyou-status-pay-now-success-text': 'ขอบคุณที่ให้ความไว้วางใจในการใช้บริการ Ascend Travel ค่ะ',
    'thankyou-status-pay-later-success-title': 'รายการจองห้องพักของคุณเรียบร้อยแล้ว',
    'thankyou-status-pay-later-success-text': 'ขอบคุณที่ให้ความไว้วางใจในการใช้บริการ Ascend Travel ค่ะ',
    'thankyou-status-pay-now-fail-title': 'ชำระเงินผ่านช่องทางบัตรเครดิต/เดบิตไม่สำเร็จ',
    'thankyou-status-tmn-pay-now-fail-title': 'ชำระเงินผ่านทรูมันนี่ วอลเล็ทไม่สำเร็จ',
    'thankyou-status-fleet-pay-now-fail-title': 'ชำระเงินผ่านช่องทางบัตรฟลีทไม่สำเร็จ',
    'thankyou-status-payment-fail-title': 'ชำระเงินไม่สำเร็จ',
    'thankyou-status-fleet-pay-now-fail-sub-title': 'กรุณาตรวจสอบยอดเงินในบัตรของคุณ หรือ ติดต่อ Call Center +66(0) 2-020-2351',
    'thankyou-status-pay-now-fail-text': 'กรุณาตรวจสอบข้อมูลบัตรของคุณ หรือติดต่อธนาคารเจ้าของบัตร',
    'thankyou-status-tmn-pay-now-fail-default-text': 'กรุณาตรวจสอบบัญชีทรูมันนี่ วอลเล็ทของคุณ หรือติดต่อ TrueMoney Customer Care',
    'thankyou-status-payment-fail-text': 'กรุณาตรวจสอบบัญชีของคุณ หรือทำรายการใหม่อีกครั้ง',
    'thankyou-status-tmn-pay-now-fail-invalid-card-number-text': 'บัญชีทรูมันนี่ วอลเล็ทไม่ถูกต้อง กรุณาติดต่อ TrueMoney Customer Care',
    'thankyou-status-tmn-pay-now-fail-insufficient-funds-text': 'เงินในบัญชีทรูมันนี่ วอลเล็ท เหลือไม่พอ กรุณาเติมเงินให้เพียงพอก่อนชำระเงิน',
    'thankyou-status-payment-fail-description': 'ชำระเงินไม่สำเร็จ',
    'thankyou-status-payment-credit-terms-fail-description': 'ไม่มีการเรียกเก็บยอดชำระไปยังบริษัทของคุณ',
    'thankyou-status-payment-credit-terms-share-budget-fail-description': 'ไม่มีการเรียกเก็บยอดชำระไปยังบริษัทของคุณ และบริษัทของผู้จองร่วม',
    'thankyou-status-payment-credit-card-fail-description': 'ไม่มีการเรียกเก็บยอดชำระไปยังธนาคารเจ้าของบัตร',
    'thankyou-status-payment-tmn-fail-description': 'ไม่มีการตัดยอดชำระจากบัญชีทรูมันนี่ วอลเล็ทของคุณ',
    'thankyou-status-payment-fleet-fail-description': 'ไม่มีการตัดยอดชำระจากบัตรฟลีทของคุณ',
    'thankyou-status-payment-account-fail-description': 'ไม่มีการตัดยอดชำระจากบัญชีของคุณ',
    'thankyou-status-seperate-payment-method': 'แบ่งรายการชำระเงินเป็น 2 ช่องทาง',
    'thankyou-more-information': 'ข้อมูลเพิ่มเติม',
    'thankyou-status-booking-success-title': 'รายการสั่งจองของคุณเรียบร้อยแล้ว',
    'thankyou-status-booking-success-text': 'คุณจะได้รับอีเมลยืนยันการจองอีกครั้ง<br />ขอบคุณที่ให้ความไว้วางใจในการใช้บริการกับ Ascend Travel ค่ะ',
    'thankyou-status-booking-fail-title': 'รายการจองห้องพักของคุณทำรายการไม่สำเร็จ',
    'thankyou-status-booking-fail-text': 'ทางเราต้องขออภัยอย่างสูงค่ะ เนื่องจากขณะนี้ห้องพักที่คุณต้องการมีลูกค้าหลายท่านสนใจ และห้องสุดท้ายพึ่งถูกจองไป',
    'thankyou-status-cannot-create-temp-booking-title': "รายการสั่งจองของคุณทำรายการไม่สำเร็จ",
    'thankyou-status-cannot-create-temp-booking-text': "กรุณาจองใหม่อีกครั้ง",
    'thankyou-status-timeout-title': 'กรุณาตรวจสอบรายการจองที่เมนู "การจองของฉัน"',
    'thankyou-status-timeout-text': "เนื่องจากระบบขัดข้องระหว่างทำรายการ ตรวจสอบรายการจอง",
    'thankyou-surcharge-exclude': "\u0E23\u0E32\u0E04\u0E32\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01\u0E44\u0E21\u0E48\u0E23\u0E27\u0E21 {text} \u0E08\u0E30\u0E16\u0E39\u0E01\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E42\u0E14\u0E22\u0E17\u0E35\u0E48\u0E1E\u0E31\u0E01 \u0E41\u0E25\u0E30\u0E01\u0E23\u0E38\u0E13\u0E32\u0E02\u0E2D\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E23\u0E31\u0E1A\u0E40\u0E07\u0E34\u0E19 / \u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35 \u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E1E\u0E31\u0E01\u0E17\u0E38\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E21\u0E35\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
    'thankyou-payment-successful': 'ชำระเงินเรียบร้อยแล้ว',
    'thankyou-booking-successful': 'จองเรียบร้อยแล้ว',
    'thankyou-booking-pay-on': 'ตัดบัตรวันที่',
    'thankyou-booking-credit-terms-title': 'ชำระเงินแบบส่งใบแจ้งหนี้',
    'thankyou-booking-credit-terms-success': 'เราจะทำการส่งใบแจ้งหนี้สำหรับการจองห้องพักไปยังบริษัทของคุณ <br/> ตามรอบบิลที่ได้ทำการตกลงกันไว้',
    'thankyou-booking-credit-terms-share-budget-success': 'เราจะทำการส่งใบแจ้งหนี้สำหรับการจองห้องพักไปยังบริษัทของคุณ และบริษัทของผู้จองร่วมตามรอบบิลที่ได้ทำการตกลงกันไว้',
    'thankyou-payment-detail-total-title': 'รายละเอียดราคารวมทั้งหมด',
    'thankyou-booking-id': 'หมายเลขการจอง',
    'thankyou-we-send-information': 'เราส่งรายละเอียดการจองไปที่',
    'thankyou-total-price': 'ยอดรวมสุทธิ',
    'thankyou-voucher': 'ใบยืนยันการจอง',
    'thankyou-tax-invoice': 'ใบเสร็จรับเงิน/ใบกำกับภาษี',
    'thankyou-back-home-button': 'กลับหน้าหลัก',
    'thankyou-booking-detail-button': 'ดูรายละเอียดการจอง',
    'thankyou-check-booking-button': 'ตรวจสอบรายการจอง',
    'thankyou-on-process': 'เนื่องจากรายการจองอยู่ในระหว่างดำเนินการ',
    'thankyou-booking-corporate-fleet-title': 'บัตรฟลีทบริษัท',
    'thankyou-booking-personal-fleet-title': 'บัตรฟลีทส่วนตัว',
    // Booking Details
    'booking-details-btn-back': 'กลับไปรายการจอง',
    'booking-details-dropdown-title': 'ดาวน์โหลดเอกสาร',
    'booking-details-save-voucher': 'บันทึก Voucher',
    'booking-details-save-tax-invoice': 'บันทึก Tax Invoice',
    'booking-details-save-tax-invoice-cancel': 'บันทึก Tax Invoice Cancel',
    'booking-details-save-credit-note': 'บันทึก Credit Note',
    //Payment method detail component
    'payment-method-detail-payment-title': 'ช่องทางการชำระเงิน',
    'payment-method-detail-payment-date': 'วันที่ชำระเงิน',
    'payment-method-detail-payment-multi-payment-expand': 'ชำระเงินแบบส่งใบแจ้งหนี้ และบัตรเครดิต/เดบิต',
    'payment-method-detail-payment-credit-terms': 'ชำระเงินแบบส่งใบแจ้งหนี้',
    'payment-method-detail-payment-credit-card': 'บัตรเครดิต/เดบิต',
    'payment-method-detail-payment-true-money': 'ทรูมันนี่ วอลเล็ท',
    'payment-method-detail-payment-corporate-fleet': 'บัตรฟลีทบริษัท',
    'payment-method-detail-payment-personal-fleet': 'บัตรฟลีทส่วนตัว',
    'payment-method-detail-payment-date-credit-card': 'ตัดบัตรวันที่',
    'payment-method-detail-payment-date-credit-terms': 'ตามรอบบิลที่ได้ทำการตกลงกันไว้',
    'payment-method-detail-payment-date-credit-terms-no-charge': 'ไม่มีการเรียกเก็บยอดชำระไปยังบริษัทของคุณ',
    'payment-method-detail-payment-date-true-money-no-charge': 'ไม่มีการตัดยอดชำระจากบัญชีทรูมันนี่ วอลเล็ทของคุณ',
    'payment-method-detail-payment-date-credit-card-no-charge': 'ไม่มีการเรียกเก็บยอดชำระไปยังธนาคารเจ้าของบัตร',
    'payment-method-detail-payment-date-fleet-no-charge': 'ไม่มีการตัดยอดชำระจากบัตรฟลีทของคุณ',
    'payment-method-detail-payment-date-payment-no-charge': 'ไม่มีการตัดยอดชำระจากบัญชีของคุณ',
    'payment-method-detail-payment-date-refund-policy': 'นโยบายการคืนเงิน',
    'payment-method-detail-payment-date-refund-policy-details-credit-card': 'เราส่งเรื่องขอคืนเงินไปยังธนาคารทันทีที่ได้รับคำสั่งยกเลิกการจอง โดยการดำเนินการคืนเงินหลังจากนี้จะขึ้นอยู่กับนโยบายของแต่ละธนาคาร โดยทั่วไปแล้วผู้ถือบัตรจะได้รับเงินคืนในรอบบิลถัดไป สำหรับบัตรเดบิตจะได้รับเงินคืนใน 30-60 วัน',
    'payment-method-detail-payment-date-refund-policy-details-true-money': 'เราส่งเรื่องขอคืนเงินทันทีที่ได้รับคำสั่งยกเลิกการจอง กรณีลูกค้าชำระเงินผ่านช่องทาง True Money Wallet ระบบจะทำการคืนเงินกลับไปยัง True Money Wallet ที่ลูกค้าใช้ในการชำระเงิน โดยใช้ระยะเวลาประมาณ 14-30 วันทำการ',
    'payment-method-detail-payment-date-refund-policy-details-fleet': 'เราดำเนินการคืนเงินทันทีที่ได้รับคำสั่งยกเลิกการจอง โดยระบบจะทำการคืนเงินกลับไปยังบัตรฟลีทที่ลูกค้าใช้ในการชำระเงินภายใน 30 นาที',
    'payment-method-detail-payment-date-refund-policy-details-payment': 'เราไม่สามารถดำเนินการคืนเงินโดยอัตโนมัติทันทีที่ได้รับคำสั่งยกเลิกการจอง คุณจะต้องดำเนินการขอรับเงินคืนด้วยตนเอง กรุณาติดต่อ <b>Call Center : +66(0) 2-020-2351</b> หรือ <b>Line Official Account : @AscendTravel</b>',
    'payment-method-detail-payment-date-refund-policy-details-e-wallet': ' เราส่งเรื่องขอคืนเงินทันทีที่ได้รับคำสั่งยกเลิกการจอง กรณีลูกค้าชำระเงินผ่านช่องทาง Rabbit LINE Pay ระบบจะทำการคืนเงินกลับไปยัง Rabbit LINE Pay ที่ลูกค้าใช้ในการชำระเงิน โดยใช้ระยะเวลาประมาณ 14-30 วันทำการ',
    // Booking detail share component
    'booking-detail-bookingId-ref-number': 'หมายเลขการจอง',
    'booking-detail-bookingId-hotel-ref': 'หมายเลขอ้างอิงกับโรงแรม',
    'booking-detail-booking-date-and-time': 'วัน/เวลาจอง',
    'booking-detail-details-booking-detail-title': 'รายละเอียดการจอง',
    'booking-detail-details-checkin': 'เช็คอิน',
    'booking-detail-details-checkout': 'เช็คเอาท์',
    'booking-detail-details-from': 'ตั้งแต่',
    'booking-detail-details-before': 'จนถึง',
    'booking-detail-details-period': 'ระยะเวลาเข้าพัก',
    'booking-detail-details-night': 'คืน',
    'booking-detail-details-room-amount': 'จำนวนห้อง',
    'booking-detail-details-room': 'ห้อง',
    'booking-detail-details-total-max-guest': 'ผู้เข้าพักสูงสุดทั้งหมด',
    'booking-detail-details-max-guest': 'ผู้เข้าพักสูงสุด',
    'booking-detail-details-adult-text': 'ผู้ใหญ่',
    'booking-detail-details-child-text': 'เด็ก',
    'booking-detail-details-adult': 'คน',
    'booking-detail-details-child': 'คน',
    'booking-detail-details-children-age': '(อายุ {age} ปี)',
    'booking-detail-details-room-guest-amount': 'จำนวนห้องและผู้เข้าพัก',
    'booking-detail-details-and': 'และ',
    'booking-detail-details-traveller-info-title': 'ข้อมูลผู้เข้าพัก',
    'booking-detail-details-traveller-info-table-room-header': 'ห้องพัก',
    'booking-detail-details-traveller-info-table-guest-header': 'ผู้เข้าพัก',
    'booking-detail-details-traveller-info-table-guest-number-header': 'ผู้เข้าพักคนที่',
    'booking-detail-details-traveller-info-table-supervisor-header': 'ผู้บังคับบัญชา',
    'booking-detail-details-traveller-info-table-pending-status': 'รอการอนุมัติ',
    'booking-detail-details-traveller-info-table-approved-status': 'อนุมัติการจอง',
    'booking-detail-details-traveller-info-table-rejected-status': 'ปฏิเสธการจอง',
    'booking-detail-details-traveller-info-table-unable-status': 'ไม่สามารถอนุมัติหรือปฏิเสธการจองได้',
    'booking-detail-details-room-detail-title': "\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01",
    'booking-detail-details-room-title': "1 \u0E2B\u0E49\u0E2D\u0E07 x",
    'booking-detail-details-room-guest': "\u0E1C\u0E39\u0E49\u0E40\u0E02\u0E49\u0E32\u0E1E\u0E31\u0E01",
    'booking-detail-details-room-special-request': 'คำขอพิเศษ',
    'booking-detail-cancellation-policy-free-of-charge': 'ฟรี! ค่าธรรมเนียมการยกเลิก หากยกเลิกก่อนวันที่',
    'booking-detail-details-room-non-refund': 'ราคาพิเศษ ขอรับเงินคืนไม่ได้',
    'booking-detail-room-cancellation-policy': "\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E2B\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E01",
    'booking-detail-cancellation-policy-charge': '- หากยกเลิกหลังวันที่ {date} จะเสียค่าธรรมเนียมการยกเลิกห้องพัก {currencycode} {cancelFee} ต่อห้อง',
    'booking-detail-room-price-total': 'ยอดรวม',
    'booking-detail-details-room-benefits': "\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E0A\u0E19\u0E4C\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'booking-detail-details-booker-information-title': 'ข้อมูลผู้จอง',
    'booking-detail-details-main-booker-information-title': 'ข้อมูลผู้จองหลัก',
    'booking-detail-details-booker-name': 'ชื่อผู้จอง',
    'booking-detail-details-main-booker-name': 'ชื่อผู้จองหลัก',
    'booking-detail-details-booker-id': 'รหัสสมาชิก',
    'booking-detail-details-booker-phonenum': 'เบอร์ติดต่อ',
    'booking-detail-details-booker-email': 'อีเมล',
    'booking-detail-details-supervisor-fullname': 'ชื่อผู้บังคับบัญชา',
    'booking-detail-details-supervisor-email': 'อีเมล',
    'booking-detail-details-booker-company-name': 'ชื่อบริษัท/ชื่อ',
    'booking-detail-details-booker-company-tax': 'หมายเลขประจำตัวผู้เสียภาษี/บัตรประชาชน',
    'booking-detail-details-booker-company-address': 'ที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'booking-detail-details-credit-terms-title': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ - ชำระเงินแบบส่งใบแจ้งหนี้',
    'booking-detail-details-credit-card-title': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ - บัตรเครดิต/เดบิต',
    'booking-detail-details-true-money-title': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ - ทรูมันนี่ วอลเล็ท',
    'booking-detail-details-co-booker-information-title': 'ข้อมูลผู้จองร่วม',
    'booking-detail-details-co-booker-name': 'ชื่อผู้จองร่วม',
    'booking-detail-arrival-time': 'เวลาถึงที่พัก',
    'cart-notify-over-room-limit': 'คุณสามารถทำการจองพักห้องได้สูงสุด 9 ห้อง/การจอง เท่านั้นค่ะ',
    'cart-notify-add-cart-fail': 'ไม่สามารถจองที่พักนี้ได้ชั่วคราว<br/> กรุณาจองที่พักอื่นค่ะ<br/> ขออภัยในความไม่สะดวก',
    'cart-notify-add-cart-fail-fit-invalid-number-of-adult': 'ไม่สามารถจองห้องพักได้ (FIT9)<br />กรุณาติดต่อ Call Center<br />Call Center : +66(0) 2-020-2351',
    // checkout
    'checkout-step1': 'รายละเอียดการจอง',
    'checkout-step2': 'ข้อมูลผู้เข้าพัก',
    'checkout-step3': 'ช่องทางชำระเงิน',
    'checkout-1-booking-details': 'รายละเอียดการจอง',
    'checkout-1-view-map': 'ดูแผนที่',
    'checkout-1-checkin': 'เช็คอิน',
    'checkout-1-checkout': 'เช็คเอาท์',
    'checkout-1-from': 'ตั้งแต่',
    'checkout-1-until': 'จนถึง',
    'checkout-1-period': 'ระยะเวลาเข้าพัก',
    'checkout-1-night-unit': 'คืน',
    'checkout-1-room-amount': 'จำนวนห้องและผู้เข้าพัก',
    'checkout-1-room-unit': 'ห้อง',
    'checkout-1-guest-amount': 'ผู้เข้าพักสูงสุดทั้งหมด',
    'checkout-1-adult-title': 'ผู้ใหญ่ {X} คน',
    'checkout-1-child-title': 'เด็ก {X} คน',
    'checkout-1-children-title': 'เด็ก {X} คน',
    'checkout-1-ages': 'อายุ',
    'checkout-1-and': 'และ',
    'checkout-1-year': ' ปี',
    'checkout-1-max-adult-title': 'ผู้ใหญ่ {X} คน',
    'checkout-1-max-child-title': 'เด็ก {X} คน',
    'checkout-1-max-children-title': 'เด็ก {X} คน',
    'checkout-1-room-detail-max-guest': 'ผู้เข้าพักสูงสุด',
    'checkout-1-adult': 'ผู้ใหญ่',
    'checkout-1-child': 'เด็ก',
    'checkout-1-room-detail': 'รายละเอียดห้องพัก',
    'checkout-1-room-type': 'ประเภทห้องพัก',
    'checkout-1-price-per-night': 'ราคาต่อคืน',
    'checkout-1-night': 'ระยะเวลาเข้าพัก',
    'checkout-1-room': 'จำนวนห้อง',
    'checkout-1-total': 'ยอดรวม',
    'checkout-1-note': 'หมายเหตุ',
    'checkout-1-max-adult': 'ผู้ใหญ่เข้าพักสูงสุด {X} คน',
    'checkout-1-max-child': 'เด็กเข้าพักสูงสุด {X} คน',
    'checkout-1-extrbed': 'รวมเตียงเสริม {X} เตียง',
    'checkout-1-description': 'ข้อมูลที่ควรทราบ',
    'checkout-1-bed-type-available': '(ขึ้นกับความพร้อมของที่พัก)',
    //checkout 2
    'checkout-2-booker-information-title': 'ข้อมูลผู้จอง',
    'checkout-2-guest-information-title': 'ข้อมูลผู้เข้าพัก',
    'checkout-2-topic-title': 'วัตถุประสงค์ในการเดินทาง',
    'checkout-2-booker-name-title': 'ชื่อผู้จอง',
    'checkout-2-booker-name-title-more': '(กรุณาใส่ข้อมูลเป็นอักษรภาษาอังกฤษ เท่านั้น)',
    'checkout-2-form-firstname-title': 'ชื่อ',
    'checkout-2-form-lastname-title': 'นามสกุล',
    'checkout-2-form-full-name-title': 'ชื่อผู้เข้าพักคน',
    'checkout-2-form-email-title': 'อีเมล',
    'checkout-2-form-number-title': 'เบอร์ติดต่อ',
    'checkout-2-form-nationality-title': 'สัญชาติ',
    'checkout-2-button-add-guest': 'เพิ่มรายชื่อผู้เข้าพัก',
    'checkout-2-button-display-more-details': 'เพิ่มคำขอพิเศษ',
    'checkout-2-button-display-hide-details': 'ซ่อนคำขอพิเศษ',
    'checkout-2-room-number-title': 'ห้อง',
    'checkout-2-guest-number-title': 'ชื่อผู้เข้าพักคนที่',
    'checkout-2-guest-number-title-without-index': 'ชื่อผู้เข้าพัก',
    'checkout-2-button-delete-guest': 'ลบผู้เข้าพัก',
    'checkout-2-special-request-title': 'คำขอพิเศษ',
    'checkout-2-special-request-title-eng-only': 'คำขอพิเศษ (กรุณาใส่ข้อมูลเป็นอักษรภาษาอังกฤษ เท่านั้น)',
    'checkout-2-special-request-english-only': 'คำขอพิเศษต้องเป็นภาษาอังกฤษเท่านั้น',
    'checkout-2-special-request-legend': 'เราจะส่งคำขอของคุณให้ที่พักทราบทันทีหลังจากที่จอง ไม่สามารถรับประกันการให้บริการตามคำขอได้ แต่ที่พักจะดำเนินการอย่างสุดความสามารถเพื่อความประสงค์ของคุณ และอาจมีค่าใช้จ่ายเพิ่มเติม',
    'checkout-2-form-require-full-name': 'กรุณาระบุชื่อและนามสกุลของคุณ',
    'checkout-2-form-invalid-full-name': 'กรุณาระบุชื่อและนามสกุลของคุณเป็นภาษาอังกฤษเท่านั้น',
    'checkout-2-form-require-firstname': 'กรุณาระบุชื่อของคุณ',
    'checkout-2-form-require-lastname': 'กรุณาระบุนามสกุลของคุณ',
    'checkout-2-form-invalid-firstname': 'กรุณาระบุชื่อของคุณเป็นภาษาอังกฤษเท่านั้น',
    'checkout-2-form-invalid-lastname': 'กรุณาระบุนามสกุลของคุณเป็นภาษาอังกฤษเท่านั้น',
    'checkout-2-form-require-mobile-number': 'กรุณาระบุเบอร์ติดต่อของคุณ',
    'checkout-2-form-invalid-mobile-number': 'กรุณาระบุเบอร์ติดต่อที่ถูกต้อง',
    'checkout-2-form-require-booker-email': "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E23\u0E30\u0E1A\u0E38\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'checkout-2-form-invalid-booker-email': "\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E41\u0E25\u0E30\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'checkout-2-form-require-guest-firstname': 'กรุณาระบุชื่อผู้เข้าพัก',
    'checkout-2-form-require-guest-lastname': 'กรุณาระบุนามสกุลผู้เข้าพัก',
    'checkout-2-form-require-guest-full-name': 'กรุณาระบุชื่อและนามสกุลของผู้เข้าพัก',
    'checkout-2-form-require-guest-email': 'กรุณาระบุอีเมลของผู้เข้าพัก',
    'checkout-2-form-require-guest-nationality': 'กรุณาระบุสัญชาติของผู้เข้าพัก',
    'checkout-2-form-invalid-guest-firstname': 'ชื่อผู้เข้าพักต้องเป็นภาษาอังกฤษเท่านั้น',
    'checkout-2-form-invalid-guest-lastname': 'นามสกุลผู้เข้าพักต้องเป็นภาษาอังกฤษเท่านั้น',
    'checkout-2-form-invalid-guest-email': 'อีเมลของผู้เข้าพักไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง',
    'checkout-2-autocomplete-remove-guest': 'ลบข้อมูล',
    'checkout-2-save-new-guest': 'บันทึกข้อมูลเข้าในรายชื่อผู้เข้าพัก',
    'checkout-2-tooltips-save-new-guest': 'คุณสามารถบันทึกข้อมูลผู้เข้าพักได้สูงสุด 50 คน',
    'checkout-2-form-hint-full-name': 'ตามที่ปรากฏในหนังสือเดินทาง/เอกสารประจำตัวที่หน่วยงานราชการออกให้ (ไม่ต้องระบุคำนำหน้า/ตัวอักษรพิเศษ)',
    'checkout-2-form-full-name-placeholder': 'ชื่อ-นามสกุลภาษาอังกฤษ',
    'checkout-2-attach-file-upload-fail': 'อัพโหลดไฟล์ไม่สำเร็จ',
    'checkout-2-attach-file-upload-fail-press-try-again': 'กรุณาลองใหม่',
    'checkout-2-send-email-and-sms-traveller': 'เราจะส่งรายละเอียดการจองไปให้ทางอีเมลและเบอร์ติดต่อที่คุณระบุ',
    'checkout-2-send-email-and-sms-booker': 'เราจะส่งรายละเอียดการจองไปให้ทางอีเมลและเบอร์ติดต่อของคุณ',
    'checkout-2-arrival-time-title': 'เวลาเดินทางไปถึงที่พัก',
    'checkout-2-arrival-time-check-in': 'เวลาเช็คอิน:',
    'checkout-2-arrival-time-description': 'เพื่อให้แน่ใจว่าคุณจะได้รับความสะดวกและเช็คอินอย่างราบรื่นไร้ปัญหา โปรดแจ้งเวลาเช็คอินโดยประมาณให้ที่พักทราบล่วงหน้า',
    'checkout-2-arrival-time-property-local-time': 'เวลาท้องถิ่นของที่พัก',
    'checkout-2-booker-for-other-employee-title': 'จองให้พนักงานในบริษัท',
    'checkout-2-booker-for-other-employee-sub-title': 'กรุณาทำเครื่องหมายในช่องเพื่อเชื่อมต่อดึงข้อมูลพนักงาน',
    'checkout-2-addtional-traveller-field-place-holder': 'พิมพ์',
    'checkout-2-full-name-invalid-not-exist-company': 'ชื่อผู้เข้าพักไม่อยู่ในบริษัทของคุณ กรุณาตรวจสอบอีกครั้ง',
    'checkout-2-full-name-invalid-duplicate': 'ผู้เข้าพักนี้ถูกเลือกไปแล้ว กรุณาตรวจสอบใหม่อีกครั้ง',
    'checkout-2-full-name-invalid-credit-terms-off': 'ผู้เข้าพักไม่มีสิทธิ์ใช้งบประมาณบริษัท',
    'checkout-2-full-name-invalid-over-lap': 'ผู้เข้าพักมีรายการจองที่พักอื่นในช่วงเวลานี้ไปแล้ว',
    'checkout-2-full-name-invalid-restrict': 'ผู้เข้าพักนี้ไม่สามารถจองที่พักในจุดหมายปลายทางที่เลือกได้ เนื่องจากข้อจำกัดของบริษัท',
    'checkout-2-full-name-invalid-no-approval': 'ผู้เข้าพักไม่มีอีเมลผู้บังคับบัญชา กรุณาติดต่อ Call Center +66(0)2-020-2351 เพื่อตรวจสอบข้อมูล',
    'checkout-2-full-name-invalid-no-full-name': 'ผู้เข้าพักไม่มีข้อมูล ชื่อ-นามสกุล กรุณาติดต่อ Call Center +66(0)2-020-2351 เพื่อตรวจสอบข้อมูล',
    'checkout-2-over-budget-travel-policy': 'วงเงินต่อคืนของผู้เข้าพักไม่พอ เนื่องจากมีวงเงินพิเศษในจุดหมายปลายทางที่เลือก {budget} บาท ต่อห้องต่อคืน',
    'checkout-2-over-budget': 'วงเงินต่อคืนของผู้เข้าพักไม่พอ เนื่องจากมีวงเงิน {budget} บาท ต่อห้องต่อคืน',
    'checkout-2-over-co-budget': 'วงเงินต่อคืนของผู้เข้าพักไม่พอ เนื่องจากมีการจำกัดวงเงินในการจองห้องพักสำหรับผู้เข้าพัก 2 คน {budget} บาท ต่อห้องต่อคืน',
    // checkout 3
    'checkout-3-tooltip-label-diff': 'ต่างกันอย่างไร ?',
    'checkout-3-tooltip-label-work': 'ทำงาน',
    'checkout-3-tooltip-label-leisure': 'ท่องเที่ยว',
    'checkout-3-tooltip-desc-work': 'จองทริปทำงานสำหรับผู้เดินทางติดต่อธุรกิจได้อย่างง่ายดาย',
    'checkout-3-tooltip-desc-leisure': 'ค้นหาที่พักยอดเยี่ยมสำหรับทริปทุกรูปแบบ โดยการจองดังกล่าวจะไม่เชื่อมโยงกับบัญชีของบริษัท',
    'checkout-3-label-custom-payment-paynow-topic': 'เลือกวันชำระเงิน',
    'checkout-3-label-select-payment-method': 'เลือกช่องทางชำระเงิน ',
    'checkout-3-label-custom-payment-paynow': 'ชำระเงินทันที',
    'checkout-3-label-custom-payment-paylater': 'ชำระเงินภายหลัง',
    'checkout-3-label-custom-payment-paylater-sub-title': 'จองวันนี้ จะตัดเงินวันที่ ',
    'checkout-3-label-credit-card-infomation': 'กรอกข้อมูลบัตรเครดิต/เดบิต',
    'checkout-3-label-tax-invoice-infomation': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'checkout-3-label-month': 'เดือน',
    'checkout-3-label-year': 'ปี',
    'checkout-3-label-card-number': 'หมายเลขบัตรเครดิต/เดบิต',
    'checkout-3-label-card-name': 'ชื่อบนบัตร',
    'checkout-3-label-card-expire-date': 'วันหมดอายุ',
    'checkout-3-label-card-cvv': 'รหัสหลังบัตร',
    'checkout-3-label-book-now': 'จองวันนี้',
    'checkout-3-label-pay-on': 'รายการชำระเงินด้วยบัตรเครดิต/เดบิต',
    'checkout-3-label-valid-until': 'บัตรเครดิตของคุณต้องมีอายุถึงเดือน',
    'checkout-3-label-payment-detail': 'รายการชำระเงิน',
    'checkout-3-label-payment-multi-detail': 'รายการชำระเงิน',
    'checkout-3-label-payment-added-credit-card': 'รายการชำระเงินเพิ่มด้วยบัตรเครดิต/เดบิต',
    'checkout-3-label-payment-added-pay-on': 'ชำระเงินเพิ่มด้วยบัตรเครดิต/เดบิต',
    'checkout-3-label-payment-will-be': 'จะตัดเงินวันที่',
    'checkout-3-label-payment-tax-description-credit-term': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'checkout-3-label-payment-tax-description': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'checkout-3-label-payment-credit-terms-tax-info': 'สำหรับการชำระเงินแบบส่งใบแจ้งหนี้',
    'checkout-3-label-payment-credit-terms-tax-info-booker': 'สำหรับการชำระเงินแบบส่งใบแจ้งหนี้ของคุณ',
    'checkout-3-label-payment-credit-terms-tax-info-co-booker': 'สำหรับการชำระเงินแบบส่งใบแจ้งหนี้ของผู้ร่วมเดินทาง',
    'checkout-3-label-payment-credit-card-tax-info': 'สำหรับการชำระเงินผ่านบัตรเครดิต/เดบิต',
    'checkout-3-label-payment-true-money-tax-info': 'สำหรับการชำระเงินผ่านทรูมันนี่ วอลเล็ท',
    'checkout-3-label-payment-tax-description-true-money': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'checkout-3-label-payment-qr-code-tax-info': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'checkout-3-label-payment-e-wallet-tax-info': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'checkout-3-label-payment-pay-at-counter-tax-info': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'checkout-3-label-payment-im-banking-tax-info': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'checkout-3-label-multi-payment-info-edit-budget': 'แก้ไขวงเงิน',
    'checkout-3-label-multi-payment-main-info': 'ชำระเงิน',
    'checkout-3-label-multi-payment-extra-info': 'ชำระเงินเพิ่มด้วย',
    'checkout-3-label-multi-payment-info-credit-card': 'บัตรเครดิต/เดบิต',
    'checkout-3-label-multi-payment-info-true-money': 'ทรูมันนี่ วอลเล็ท',
    'checkout-3-label-multi-payment-info-personal-fleet': 'ด้วยบัตรฟลีทส่วนตัว',
    'checkout-3-label-multi-payment-info-personal-fleet-additional': 'บัตรฟลีทส่วนตัว',
    'checkout-3-label-multi-payment-info-corporate-fleet': 'ด้วยบัตรฟลีทบริษัท',
    'checkout-3-label-multi-payment-info-credit-terms': 'แบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัท',
    'checkout-3-label-multi-payment-change-payment': 'เปลี่ยนช่องทาง',
    'checkout-3-label-night': 'คืน',
    'checkout-3-label-dot': '',
    'checkout-3-label-multi-payment-info-budget-not-found': 'คุณมีวงเงินในการจองที่พักจำกัดหรือไม่?',
    'checkout-3-label-multi-payment-info-add-budget': 'ระบุวงเงินของคุณ',
    'checkout-3-label-multi-payment-info-reset': 'เปลี่ยนกลับไปใช้ค่าตั้งต้น',
    'checkout-3-label-multi-payment-info-not-reach-grand-total': 'ยอดชำระขั้นต่ำ THB',
    'checkout-3-label-multi-payment-info-exceed-total-price': 'ยอดชำระเกินยอดรวมสุทธิ สามารถใส่ได้สูงสุด THB',
    'checkout-3-label-multi-payment-info-exceed-budget-limit': 'ยอดชำระเกินวงเงินที่คุณได้รับ สามารถใส่ได้สูงสุด THB',
    'checkout-3-label-multi-payment-info-exceed-budget-remaining': 'ยอดชำระเกินวงเงินที่คุณเหลืออยู่ สามารถใส่ได้สูงสุด THB',
    'checkout-3-label-multi-payment-share-budget-least-booker': 'ยอดชำระขั้นต่ำของคุณ THB',
    'checkout-3-label-multi-payment-info-exceed-budget-limit-co-booker': 'ยอดชำระเกินวงเงินที่ผู้ร่วมเดินทางได้รับ สามารถใส่ได้สูงสุด THB',
    'checkout-3-label-multi-payment-info-exceed-budget-remaining-co-booker': 'ยอดชำระเกินวงเงินที่ผู้ร่วมเดินทางเหลืออยู่ สามารถใส่ได้สูงสุด THB',
    'checkout-3-label-multi-payment-share-budget-least-co-booker': 'ยอดชำระขั้นต่ำของผู้ร่วมเดินทาง THB',
    'checkout-3-label-multi-payment-exceed-fleet-card': 'ยอดชำระเกินยอดคงเหลือในบัตรสามารถใส่ได้สูงสุด THB',
    'checkout-3-label-credit-terms-info-title': 'ข้อมูลการส่งใบแจ้งหนี้ของคุณ',
    'checkout-3-label-credit-terms-info-title-co-booker': 'ข้อมูลการส่งใบแจ้งหนี้ของผู้ร่วมเดินทาง',
    'checkout-3-label-credit-terms-info-desc': 'เราจะทำการส่งใบแจ้งหนี้สำหรับการจองห้องพักไปยังบริษัทของคุณ ตามรอบบิลที่ได้ทำการตกลงกันไว้',
    'checkout-3-label-credit-terms-info-desc-co-booker': 'เราจะทำการส่งใบแจ้งหนี้สำหรับการจองห้องพักไปยังบริษัทของผู้ร่วมเดินทาง ตามรอบบิลที่ได้ทำการตกลงกันไว้',
    'checkout-3-label-credit-card-info-title': 'ข้อมูลบัตรเครดิต/เดบิต',
    'checkout-3-label-credit-terms-info-co-booker-email': 'ผู้ร่วมเดินทาง :',
    'checkout-3-label-credit-terms-info-traveller-title': 'ข้อมูลการส่งใบแจ้งหนี้ของผู้เข้าพักคนที่',
    'checkout-3-label-credit-terms-info-traveller-email': 'ผู้เข้าพักคนที่',
    'checkout-3-label-desc-credit-term': 'คุณเลือกการชำระเงินแบบวางบิล',
    'checkout-3-label-sub-desc-credit-term': 'เราจะทำการเรียกเก็บเงินไปยังบริษัทของคุณตามระยะเวลาที่ได้ทำการตกลงไว้',
    'checkout-3-label-fund-code': 'หมายเลขอ้างอิงในบริษัท (ถ้ามี)',
    'checkout-3-label-cost-center': 'Cost Center',
    'checkout-3-label-set-default': 'ใช้ Cost Center ของคุณ',
    'checkout-3-label-cost-center-name': 'Cost Center Name',
    'checkout-3-placeholder-cost-center': 'พิมพ์ Cost Center ที่นี่',
    'checkout-3-placeholder-cost-center-name': 'พิมพ์ Cost Center Name ที่นี่',
    'checkout-3-form-cost-center-required': 'กรุณาระบุ ',
    'checkout-3-form-cost-center-name-required': 'กรุณาระบุ ',
    'checkout-3-form-cost-center-name-invalid': '{text} ไม่ถูกต้อง กรุณาระบุ {text} ใหม่อีกครั้ง',
    'checkout-3-label-cost-center-dropdown': 'กรุณาเลือก ',
    'checkout-3-label-internal-order-dropdown': 'กรุณาเลือก ',
    'checkout-3-form-dropdown-placeholder': 'เลือก',
    'checkout-3-form-dropdown-required': 'กรุณาเลือก',
    'checkout-3-form-free-text-placeholder': 'พิมพ์',
    'checkout-3-form-free-text-required': 'กรุณาระบุ',
    'checkout-3-form-attachment-required': 'กรุณาแนบไฟล์',
    'checkout-3-placeholder-card-number': '●●●● ●●●● ●●●● ●●●●',
    'checkout-3-placeholder-card-name': 'ชื่อบนบัตร',
    'checkout-3-placeholder-card-cvv': 'รหัส CVC/CVV',
    'checkout-3-placeholder-fund-code': 'พิมพ์หมายเลขอ้างอิงในบริษัทที่นี่',
    'checkout-3-placeholder-expire-date': 'ดด/ปป',
    'checkout-3-form-require-card-number': 'กรุณาระบุหมายเลขบัตร',
    'checkout-3-form-invalid-card-number': 'คุณกรอกหมายเลขบัตรไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง',
    'checkout-3-form-invalid-card-number-not-support': 'ไม่สามารถใช้บัตรนี้ในการชำระเงินได้',
    'checkout-3-form-require-card-name': 'กรุณาระบุชื่อบนบัตร',
    'checkout-3-form-invalid-card-name': 'ชื่อบนบัตรต้องเป็นภาษาอังกฤษเท่านั้น',
    'checkout-3-form-require-card-cvv': 'กรุณาระบุรหัสหลังบัตร',
    'checkout-3-form-invalid-card-cvv': 'คุณกรอกรหัสหลังบัตรไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง',
    'checkout-3-form-require-card-exp-date': 'กรุณาระบุวันหมดอายุบัตร',
    'checkout-3-form-invalid-card-exp-date': 'วันหมดอายุของบัตรไม่ถูกต้อง',
    'checkout-3-form-invalid-card-expire-pay-on': 'ไม่สามารถใช้บัตรนี้ได้เนื่องจากบัตรจะหมดอายุก่อนวันตัดเงิน',
    'checkout-3-require-tax-address': 'กรุณาเลือกข้อมูลสำหรับออกใบกำกับภาษี หรือ ใบเสร็จ',
    'checkout-3-error-cannot-create-booking': 'รายการสั่งจองของคุณทำรายการไม่สำเร็จ<br/>กรุณาทำรายการใหม่อีกครั้ง',
    'checkout-3-error-limit-room': 'วงเงินการจองของคุณมีการเปลี่ยนแปลง<br/>กรุณาตรวจสอบและทำรายการใหม่อีกครั้ง',
    'checkout-3-error-limit-budget': 'สิทธิ์การจองของคุณมีการเปลี่ยนแปลง<br/>กรุณาตรวจสอบและทำรายการใหม่อีกครั้ง',
    'checkout-3-address-edit-failure-title': 'ไม่สามารถอัพเดตข้อมูลได้',
    'checkout-3-error-cannot-get-dropdown-list': 'ไม่สามารถดึงข้อมูลใบกำกับภาษีได้.',
    'checkout-3-default-dropdown': 'กรุณาเลือก',
    'checkout-3-error-supervisor-email-invalid': 'คุณไม่สามารถจองที่พักได้ กรุณาติดต่อ Call Center เพื่อตรวจสอบอีเมลผู้บังคับบัญชาของคุณ<br/>Call center : +66(0) 2-020-2351',
    'checkout-3-error-credit-term-not-allow': 'คุณไม่มีสิทธิ์ในการจองห้องพักแบบส่งใบแจ้งหนี้ (Credit Terms) กรุณาติดต่อ Call Center เพื่อตรวจสอบข้อมูล <br/> Call center: +66(0) 2-020-2351',
    'checkout-3-error-multi-payment-not-allow': 'คุณไม่มีสิทธิ์ในการจองห้องพักเกินงบประมาณ กรุณาติดต่อ Call Center เพื่อตรวจสอบข้อมูลเพิ่มเติม <br/> Call center: +66(0) 2-020-2351',
    'checkout-3-error-credit-term-over-trip-budget': 'ยอดชำระเงินแบบส่งใบแจ้งหนี้เกินงบประมาณที่ขออนุมัติ<br>งบประมาณที่ขออนุมัติคือ THB {totalTripBudget}<br>กรุณาปรับยอดชำระเงินหรือเลือกที่พักใหม่อีกครั้ง',
    'checkout-3-true-money-title': 'ข้อมูลบัญชี',
    'checkout-3-true-money-payment': 'ชำระเงินผ่านบัญชีทรูมันนี่',
    'checkout-3-true-money-payment-recheck': 'กรุณาตรวจสอบยอดเงินคงเหลือเพียงพอก่อนการใช้',
    'checkout-3-true-money-phone-no': 'เบอร์โทรศัพท์ที่ผูกกับทรูมันนี่ วอลเล็ท',
    'checkout-3-true-money-phone-no-empty': 'กรุณาระบุเบอร์โทรศัพท์',
    'checkout-3-true-money-phone-pattern': 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    'checkout-3-true-money-box-text-1': 'ชำระเงินผ่านบัญชีทรูมันนี่ วอลเล็ท',
    'checkout-3-true-money-box-text-2': ' จะตัดเงินวันที่',
    'checkout-3-true-money-true-point-short': 'ทุกการใช้จ่าย 25 บาท รับ 1 ทรูพอยท์',
    'checkout-3-require-payment-method': 'กรุณาเลือกช่องทางการชำระเงิน',
    'checkout-3-true-money-note': 'หมายเหตุ',
    'checkout-3-true-money-note-0': 'มูลค่าชำระทุก 25 บาท สำหรับการชำระเงินด้วย ทรูมันนี่ วอลเล็ท ได้รับ 1 ทรูพอยท์ ต่อ 1 รายการ ต่อ 1 หมายเลขบัตรประชาชน',
    'checkout-3-true-money-note-1': 'ลูกค้าจะได้รับทรูพอยท์ ภายใน 30 วันทำการหลังจากสั่งสินค้าผ่าน https://traveltogether.ascendtravel.com และจ่ายด้วย ทรูมันนี่ วอลเล็ท โดยจำกัดสิทธิ์ 100 ทรูพอยท์ / 1 บัตรประชาชน ตลอดระยะเวลาแคมเปญ',
    'checkout-3-true-money-note-2': 'รายการส่งเสริมการขายนี้ ดำเนินการโดยบริษัท ทรูมันนี่ จำกัด',
    'checkout-3-true-money-note-3': 'หากมีข้อสงสัย กรุณาติดต่อ TrueMoney Customer Care 1242 ตลอด 24 ชั่วโมง',
    'checkout-3-label-main-payment': 'ช่องทางหลัก',
    'checkout-3-label-additional-payment': 'ช่องทางชำระเงินเพิ่ม',
    'checkout-3-label-place-holder-payment': 'กรุณาเลือกช่องทางการชำระเงิน...',
    'checkout-3-label-additional-payment-error': 'กรุณาเลือกช่องทางการชำระเงิน',
    'checkout-3-label-approximate-price-in': 'ราคาโดยประมาณสกุลเงิน',
    'checkout-3-qr-code-title': 'QR Code',
    'checkout-3-e-wallet-title': 'E-Wallet',
    'checkout-3-im-banking-title': 'ธนาคารออนไลน์',
    'checkout-3-im-banking-payment-channel': 'โมบายแบงก์กิ้ง / อินเตอร์เนตแบงก์กิ้ง',
    'checkout-3-pay-at-counter-title': 'เงินสดผ่านเคาน์เตอร์',
    'checkout-3-pay-at-counter-bank-counter': 'เคาน์เตอร์ธนาคาร',
    'checkout-3-pay-at-counter-other-counter': 'เคาน์เตอร์ชำระเงินต่างๆ',
    'checkout-3-payment-method-line1': 'เราจะแจ้งวิธีชำระเงินในหน้าถัดไป',
    'checkout-3-payment-method-line2': 'กรุณาชำระเงินให้เสร็จสมบูรณ์ภายใน 15 นาที เพื่อไม่ให้การจองของท่านถูกยกเลิก',
    'checkout-3-payment-method-line2-30': 'กรุณาชำระเงินให้เสร็จสมบูรณ์ภายใน 30 นาที เพื่อไม่ให้การจองของท่านถูกยกเลิก',
    'checkout-3-payment-method-line3-2c2p': 'การชำระเงินให้กับแอสเซนด์ แทรเวิล ดำเนินการโดยบริการ 2C2P (2C2P SERVICE)',
    'checkout-3-payment-method-line3-123': 'การชำระเงินให้กับแอสเซนด์ แทรเวิล ดำเนินการโดยบริการ 123 (123 SERVICE)',
    'checkout-3-payment-method-remark-line1': 'อาจมีการเรียกเก็บค่าบริการเพิ่มเติมเมื่อคุณชำระเงินที่เคาน์เตอร์ (ค่าบริการเพิ่มเติมไม่สามารถขอคืนเงินได้)',
    'checkout-3-payment-method-remark-line2': 'หลังจากทำการชำระเงินเสร็จ คุณจะได้รับอีเมลยืนยันการจองห้องพักภายใน 2 ชั่วโมง หากท่านไม่ได้รับอีเมลในเวลาที่กำหนด กรุณาติดต่อ',
    'checkout-3-payment-method-remark-line2-call-center': 'Call Center : +66(0) 2-020-2351',
    'checkout-3-payment-method-remark-line2-or': 'หรือ',
    'checkout-3-payment-method-remark-line2-line': 'Line Official Account : @AscendTravel',
    'checkout-3-warning-please-make-payment': 'กรุณาชำระเงินภายใน 15 นาที',
    'checkout-3-warning-please-make-payment-30': 'กรุณาชำระเงินภายใน 30 นาที',
    'checkout-3-warning-avoid-cancellation': 'เพื่อไม่ให้รายการจองของคุณถูกยกเลิก',
    'checkout-3-warning-press': 'กด',
    'checkout-3-warning-confirm-to-book': '"ยืนยันการจอง"',
    'checkout-3-warning-to-proceed': 'เพื่อดำเนินการต่อ',
    'checkout-3-payment-channel': 'ช่องทางการชำระเงิน',
    'checkout-3-payment-method': 'วิธีชำระเงิน',
    'checkout-3-payment-method-remark-title': 'หมายเหตุ',
    // billing address component
    'checkout-3-label-billing-infomation': 'ข้อมูลสำหรับวางบิล',
    'checkout-3-billing-address-name': 'ชื่อผู้รับวางบิล',
    'checkout-3-billing-address-name-placeholder': 'พิมพ์ ชื่อ-นามสกุล ของผู้รับวางบิลที่นี่',
    'checkout-3-billing-address-phone': 'เบอร์ติดต่อผู้รับวางบิล',
    'checkout-3-billing-address-phone-placeholder': '0XXXXXXXXX',
    'checkout-3-billing-address-address': 'ที่อยู่สำหรับวางบิล',
    'checkout-3-billing-address-address-address-placeholder': 'พิมพ์ที่อยู่สำหรับวางบิลที่นี่',
    'checkout-3-billing-validation-required-name': 'กรุณาระบุชื่อผู้รับวางบิล',
    'checkout-3-billing-validation-required-phone': 'กรุณาระบุเบอร์ติดต่อผู้รับวางบิล',
    'checkout-3-billing-validation-required-address': 'กรุณาระบุที่อยู่สำหรับวางบิล',
    'checkout-3-billing-validation-invalid-name': 'ชื่อผู้รับวางบิลจะต้องเป็นตัวอักษร a-z A-Z',
    'checkout-3-billing-validation-invalid-phone': 'เบอร์ติดต่อต้องเป็นตัวเลข 0-9 จำนวน 9 หรือ 10 หลักเท่านั้น',
    'checkout-3-billing-validation-invalid-address': 'กรุณาระบุที่อยู่สำหรับวางบิล',
    'checkout-3-require-internal-order': 'กรุณาระบุ',
    'checkout-3-require-billing-address': 'กรุณาเลือกข้อมูลสำหรับวางบิล',
    'checkout-3-billing-dialog-delete-button': 'ลบ',
    'checkout-3-billing-delete-success': 'ลบเรียบร้อยแล้ว',
    'checkout-3-billing-delete-failure': 'ลบไม่สำเร็จ',
    'checkout-3-billing-failure-text-try-again': 'กรุณาลองใหม่อีกครั้ง',
    'checkout-3-billing-add': 'ที่อยุ่สำหรับวางบิลที่เพิ่ม',
    'checkout-3-billing-edit': 'ที่อยุ่สำหรับวางบิลที่แก้ไข',
    'checkout-3-billing-confirm-delete-msg': 'คุณต้องการลบข้อมูลนี้?',
    'checkout-3-billing-confirm-cancel-editing': 'คุณยังไม่ได้ทำการบันทึก{dataType} ต้องการออกจากหน้านี้โดยไม่บันทึกใช่หรือไม่?',
    'checkout-3-attach-file-title': 'แนบไฟล์',
    'checkout-3-attach-file-choose-button': 'แนบไฟล์',
    'checkout-3-attach-file-guide': 'สามารถแนบไฟล์สูงสุด 5 ไฟล์ และรองรับไฟล์ .jpg, .pdf, .png, .msg, .eml ขนาดไม่เกิน 2 MB เท่านั้น',
    'checkout-3-attach-file-validation-invalid-file-type': 'ไม่รองรับประเภทไฟล์ที่คุณแนบมา คุณสามารถแนบไฟล์ .jpg, .pdf, .png, .msg, .eml ได้เท่านั้น',
    'checkout-3-attach-file-validation-file-size-overflow': 'ไฟล์แนบมีขนาดเกินกว่าที่กำหนดไว้ คุณสามารถแนบไฟล์ขนาดไม่เกิน 2 MB เท่านั้น',
    'checkout-3-attach-file-validation-file-not-attached': 'กรุณาเลือกไฟล์',
    'search-popup-checkbox-label': 'ไม่ต้องแสดงข้อความนี้อีก',
    'popup-warning-session-expire': 'การใช้งานของคุณกำลังจะหมดอายุ<br/>กรุณากด ตกลง เพื่อต่ออายุการใช้งานอีกครั้ง',
    // Approval action
    'approval-action-success-approve': 'การจองได้รับการอนุมัติและดำเนินการเรียบร้อยแล้ว',
    'approval-action-success-reject': 'รายการจองถูกยกเลิกเรียบร้อยแล้ว',
    'approval-action-after-done': 'ไม่สามารถอนุมัติ/ปฏิเสธการจองได้',
    'approval-action-after-done-desc': 'เนื่องจากคุณได้ทำการอนุมัติ/ปฏิเสธการจองหรือเลยวันเข้าพักแล้ว',
    'approval-action-after-cancel': 'ไม่สามารถอนุมัติ/ปฏิเสธการจองได้',
    'approval-action-after-cancel-desc': 'เนื่องจากผู้จองยกเลิกการจองแล้ว',
    'approval-action-fail-service': 'ทำรายการไม่สำเร็จ',
    'approval-action-fail-service-desc': 'กรุณาลองใหม่อีกครั้ง',
    'approval-action-thankyou-1': 'ขอขอบคุณที่ให้ความไว้วางใจในการใช้บริการกับ Ascend Travel',
    'approval-action-thankyou-2': 'ติดต่อสอบถาม Call Center +66(0) 2-020-2351',
    'approval-action-btn-home': 'ไปหน้าหลัก',
    'approval-action-btn-approval-list': 'ตรวจสอบรายการอนุมัติ',
    'approval-action-unable-approval': 'ไม่สามารถอนุมัติหรือปฏิเสธการจองได้',
    'approval-action-unable-approval-detail': 'กรุณาตรวจสอบสถานะของรายการอนุมัติที่เมนู "รายการที่ต้องอนุมัติ"',
    'approval-action-unable-approval-or-reject-detail': 'ไม่สามารถอนุมัติหรือปฏิเสธรายการจองได้',
    'approval-cancellation-credit-card': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินด้วยบัตรเครดิต/เดบิต',
    'notify_accept_terms_conditions': 'ฉันยอมรับเงื่อนไข / I accept those conditions.',
    'notify_accept_terms_conditions_validation_accept': 'กรุณายอมรับเงื่อนไข / Please accept terms and condition.',
    // Krung sri
    'notify_accept_terms_conditions_message_krungsri': 'ข้าพเจ้ารับทราบและตกลงว่า ในการจองที่พักเพื่อ “ทำงาน”  ข้าพเจ้าจะทำการแนบเอกสารที่ได้รับอนุมัติจากผู้มีอำนาจก่อนการจองที่พักทุกครั้ง และ Ascend Travel จะทำการเรียกเก็บเงินที่พักกับบริษัทที่ท่านสังกัด ทั้งนี้ ข้าพเจ้าตกลงและรับทราบว่าข้าพเจ้าจะต้องรับผิดชอบค่าใช้จ่ายด้วยตนเอง ภายใน 7 วันนับแต่วันที่บริษัทเรียกเก็บค่าใช้จ่ายหากข้าพเจ้าไม่เข้าพักโดยไม่มีเหตุผลอันสมควร ในกรณีการจองเพื่อ “ท่องเที่ยว” ข้าพเจ้าจะต้องทำการชำระเงินด้วยตนเอง',
    // Osotspa
    'notify_accept_terms_conditions_message_osotspa': 'ข้าพเจ้ารับทราบนโยบายการจองที่พัก และการปฏิบัติตามแนวทางที่บริษัทฯกำหนด ในการจองห้องพักทุกครั้ง',
    'rating-header': 'คุณมีความเห็นอย่างไรเกี่ยวกับ',
    'rating-check-in': 'เช็คอิน',
    'rating-check-out': 'เช็คเอาท์',
    'rating-star-1': 'แย่มาก',
    'rating-star-2': 'แย่',
    'rating-star-3': 'พอใจ',
    'rating-star-4': 'ดี',
    'rating-star-5': 'ดีมาก',
    'rating-submit': 'ส่งรีวิว',
    'rating-error-select-satisfaction': 'กรุณาเลือกระดับความพอใจ',
    'rating-message-thankyou': 'ขอบคุณสำหรับการรีวิว<br/>ความเห็นของคุณจะช่วยในการพัฒนาให้กับทางที่พัก รวมถึงช่วยผู้เข้าพักท่านอื่นในการตัดสินใจ',
    'rating-header-animal': 'คุณเจอสิ่งลี้ลับ หรือสัตว์ต่างๆเหล่านี้ไหม',
    'rating-summarize-header-1': 'หัวข้อความคิดเห็น',
    'rating-summarize-placeholder-1': 'คุณคิดอย่างไรกับการเข้าพักครั้งนี้',
    'rating-summarize-header-2': 'แสดงความคิดเห็น',
    'rating-summarize-placeholder-2': 'แชร์ประสบการณ์ การเข้าพักของคุณให้คนอื่นๆ',
    'rating-summarize-error': 'กรุณาระบุหัวข้อความคิดเห็น',
    'rating-img-error': 'ไฟล์ ขนาดเกิน 2 MB',
    'hide-name': 'ซ่อนชื่อของฉัน',
    'rating-photo-header': 'แชร์รูปที่พักให้คนอื่นๆได้ที่นี่',
    'rating-photo-subtitle': 'สามารถใส่ภาพได้สูงสุด 5 ภาพโดยไฟล์ต้องใช้นามสกุล .png, jpeg หรือ .jpg และขนาดไฟล์ที่แนบห้ามเกิน 2 MB',
    // Banner promotion
    'banner-topic': 'ข้อเสนอสุดพิเศษวันนี้',
    'banner-sub-topic': 'โปรโมชั่น ส่วนลด และข้อเสนอพิเศษสำหรับคุณโดยเฉพาะ',
    'banner-book-period': 'ระยะเวลาการจอง',
    'banner-stay-period': 'ช่วงเวลาเข้าพัก',
    'banner-btn-book': 'จอง',
    // Confirmation supplier
    'confirmation-supplier-email-reject': 'กรุณาระบุชื่อของคุณเพื่อแจ้งการปฏิเสธการจองห้องพักจาก Ascend Travel',
    'confirmation-supplier-email-confirm': 'กรุณาระบุชื่อของคุณเพื่อทำการยืนยันการจองห้องพักจาก Ascend Travel',
    'confirmation-supplier-email-confirm-title': 'ผู้ยืนยันการจอง',
    'confirmation-supplier-email-confirm-title-error': 'กรุณาระบุ ผู้ยืนยันการจอง',
    'confirmation-supplier-email-confirm-confirm-number': 'Confirmation Number (ถ้ามี)',
    'confirmation-supplier-email-reject-title': 'ผู้ปฏิเสธการจอง',
    'confirmation-supplier-email-reject-title-error': 'กรุณาระบุ ผู้ปฏิเสธการจอง',
    'confirmation-supplier-email-reject-reason': 'เหตุผล',
    'confirmation-supplier-email-reject-reason-error': 'กรุณาระบุ เหตุผล',
    'confirmation-supplier-email-reject-topic-title': 'กรุณาระบุชื่อของคุณเพื่อแจ้งการปฏิเสธการจองห้องพักจาก Ascend Travel',
    'confirmation-supplier-email-confirm-topic-title': 'กรุณาระบุชื่อของคุณเพื่อทำการยืนยันการจองห้องพักจาก Ascend Travel',
    'confirmation-supplier-email-confirm-status-success': 'คุณได้ทำการยืนยันการจองห้องพักจาก Ascend Travel เรียบร้อยแล้ว',
    'confirmation-supplier-email-reject-status-success': 'คุณได้ทำการปฏิเสธการจองห้องพักจาก Ascend Travel เรียบร้อยแล้ว',
    'confirmation-supplier-email-already': 'เนื่องจากคุณได้ทำการ ยืนยัน/ปฏิเสธ การจองเรียบร้อยแล้ว',
    'confirmation-supplier-email-placeholder-confirmed-by': 'ชื่อ/นามสกุล',
    'confirmation-supplier-email-placeholder-confirmation-number': 'Confirmation Number',
    'confirmation-supplier-email-placeholder-rejected-by': 'ชื่อ/นามสกุล',
    'confirmation-supplier-email-placeholder-reason': 'เหตุผลในการปฏิเสธ',
    // Promotion
    'promotion-promotion-code-title': 'Promotion Code',
    'promotion-promotion-code-error': 'กรุณาระบุ Promotion Code',
    'promotion-promotion-code-button-submit': 'ยืนยัน',
    'promotion-promotion-code-topic-title': 'กรุณากรอก Promotion Code',
    'promotion-promotion-code-error-invalid-message': 'Promotion code ไม่ถูกต้อง',
    'promotion-promotion-code-error-used-message': 'Promotion code นี้ถูกใช้ไปแล้ว',
    'promotion-thankyou-title1': 'หมายเลขการสั่งจอง ',
    'promotion-thankyou-title2': 'กำลังดำเนินการ',
    'promotion-thankyou-description': 'ระบบกำลังดำเนินการจองห้องพักให้กับคุณโดย คุณจะได้รับอีเมลยืนยันการจองอีกครั้ง',
    'promotion-promotion-code-error-invalid-link': 'Link นี้ได้ถูกยกเลิกจากระบบแล้ว',
    'promotion-promotion-code-error-use-full': 'ขออภัย Promotion Code นี้ มีผู้รับสิทธิ์เต็มจำนวนเรียบร้อยแล้ว',
    'promotion-thankyou-status-timeout-title': ' กรุณาติดต่อ Call Center เพื่อตรวจสอบรายการจอง',
    'promotion-thankyou-status-timeout-text': "เนื่องจากระบบขัดข้องระหว่างทำรายการ ติดต่อ Call Center +66 (0)2-020-2351",
    // Condition
    'condition-selling-price-in-budget-title': 'ราคาห้องพักมีการเปลี่ยนแปลงตามข้อมูลในตารางด้านล่าง',
    'condition-selling-price-over-budget': 'ราคาห้องพักเกินงบประมาณของคุณ',
    'condition-selling-price-in-budget-column': 'ประเภทห้องพัก,ราคาต่อคืนก่อนหน้า,ราคาต่อคืนใหม่',
    'condition-limit-room-title': 'คุณมีสิทธิ์ในการจองแค่เพียง ${var} ห้อง',
    'condition-cancellation-policy-title': 'เงื่อนไขการยกเลิกห้องพักมีการเปลี่ยนแปลงตามข้อมูลในตารางด้านล่าง',
    'condition-cancellation-policy-column': 'ประเภทห้องพัก,เงื่อนไขการยกเลิกห้องพักใหม่',
    'condition-cancellation-policy-baht': 'หากยกเลิกหลังวันที่ ${var} จะเสียค่าธรรมเนียมการยกเลิกห้องพัก THB ${var}',
    'condition-cancellation-policy-non-refundable': 'ไม่สามารถขอรับเงินคืน หากยกเลิิกการจอง',
    'condition-cancellation-policy-free-of-charge': 'ฟรี! ค่าธรรมเนียมการยกเลิก หากยกเลิกก่อนวันที่ ${var}',
    'condition-free-cancellation': 'ยกเลิกการจองฟรี',
    'condition-cancellation-policy-pay-now': 'เงื่อนไขการชำระเงินเปลี่ยนแปลง<br/> จากชำระเงินวันที่ ${var}<br/> เป็นชำระเงินวันนี้',
    'condition-cancellation-policy-pay-later': 'เงื่อนไขการชำระเงินเปลี่ยนแปลง<br/> จากชำระเงินวันนี้<br/> เป็นชำระเงินวันที่ ${var}',
    'condition-cancelltaion-policy-pay-later-from-to': 'เงื่อนไขการชำระเงินเปลี่ยนแปลง<br/> จากชำระเงินวันที่ ${var}<br/> เป็็นชำระเงินวันที่ ${var}',
    'condition-offer-type-title': 'รายละเอียดห้องพักมีการเปลี่ยนแปลงตามข้อมูลในตารางด้านล่าง',
    'condition-offer-type-column': 'ประเภทห้องพัก,รายละเอียดก่อนหน้า,รายละเอียดใหม่',
    'condition-no-available-room-title': 'ไม่มีห้องพักในช่วงวันที่คุณต้องการ',
    'condition-button-accept': 'ยอมรับ',
    'condition-button-back-to-search': 'กลับไปค้นหาใหม่',
    'condition-offer-type-breakfast-include': 'รวมอาหารเช้า',
    'condition-offer-type-breakfast-not-include': 'ไม่รวมอาหารเช้า',
    'condition-aad-userid-not-exist': 'User not found',
    'condition-user-not-active-or-not-approve': 'User is inactive',
    'condition-period-overlaps-title': 'คุณไม่สามารถจองที่พักได้',
    'condition-period-overlaps-description': 'เนื่องจากคุณมีรายการจองที่พักอื่นในช่วงเวลานี้ไปแล้ว',
    'condition-period-overlaps-share-budget-description': 'เนื่องจากคุณหรือผู้ร่วมเดินทางมีรายการจองที่พักอื่นในช่วงเวลานี้ไปแล้ว',
    'condition-restrict-destination-title': 'คุณไม่สามารถจองที่พักในจุดหมายปลายทางที่เลือกได้',
    'condition-restrict-destination-description': 'เนื่องจากเป็นเขตพื้นที่ปฏิบัติงานปกติของคุณ กรุณากดตกลงเพื่อกลับไปค้นหาใหม่',
    'condition-restrict-destination-co-booker-title': 'คุณไม่สามารถจองที่พักในจุดหมายปลายทางที่เลือกได้',
    'condition-restrict-destination-co-booker-description': 'เนื่องจากบริษัทของคุณหรือผู้ร่วมเดินทางไม่อนุญาตให้จองที่พักในจุดหมายปลายทางดังกล่าว กรุณากดตกลงเพื่อกลับไปค้นหาใหม่',
    'condition-some-guest-not-exist-in-your-comany': 'มีผู้เข้าพักที่ไม่อยู่ในบริษัทของคุณ',
    'condition-some-guest-not-allow-to-use-credit-terms': 'มีผู้เข้าพักที่ไม่มีสิทธิ์ใช้งบประมาณบริษัท',
    'condition-some-guest-already-have-a-booking-in-this-period': 'มีผู้เข้าพักที่มีรายการจองที่พักอื่นในช่วงเวลานี้ไปแล้ว',
    'condition-some-guest-has-no-supervisor-email': 'มีผู้เข้าพักที่ไม่มีอีเมลผู้บังคับบัญชา กรุณาติดต่อ Call Center +66(0)2-020-2351 เพื่อตรวจสอบ',
    // Mice
    'mice-quotation-title': 'ให้เราช่วยจัดหาบริการที่เหมาะกับคุณ',
    'mice-quotation-sub-title': 'กรุณาระบุข้อมูลของคุณเพื่อให้ทีมงานของเราเสนอราคาบริการที่คุณสนใจ และเราจะติดต่อคุณโดยเร็วที่สุดค่ะ',
    'mice-quotation-placeholder-dropdown': 'กรุณาเลือกบริการที่คุณสนใจ',
    'mice-quotation-destination': 'สถานที่/จุดหมายปลายทาง',
    'mice-quotation-start-date': 'วันที่เริ่มต้นใช้บริการ',
    'mice-quotation-end-date': 'วันที่สิ้นสุดบริการ',
    'mice-quotation-attendees': 'จำนวนคน (คน)',
    'mice-quotation-budget': 'งบประมาณ (บาท)',
    'mice-quotation-special-request': 'คำขอพิเศษ',
    'mice-quotation-contact-title': 'ข้อมูลติดต่อ',
    'mice-quotation-contact-name': 'ชื่อผู้ติดต่อ',
    'mice-quotation-contact-company': 'ติดต่อในนาม',
    'mice-quotation-contact-phone': '0XXXXXXXXX',
    'mice-quotation-contact-email': 'email@mail.com',
    'mice-quotation-description-service': 'หากคุณต้องการหลายบริการ คุณสามารถเลือกบริการหลัก และระบุบริการเสริมในช่องรายละเอียดเพิ่มเติม',
    'mice-quotation-description-date': 'หากคุณไม่สามารถระบุช่วงวันที่ได้ กรุณาระบุในช่องรายละเอียดเพิ่มเติม',
    'mice-quotation-warning-zero-budget': 'งบประมาณต้องมากกว่า 0 บาท',
    'mice-quotation-warning-zero-attendees': 'จำนวนคนต้องมากกว่า 0 คน',
    'mice-quotation-warning-placeholder-dropdown': 'กรุณาเลือกบริการที่คุณสนใจ',
    'mice-quotation-warning-contact-name': 'กรุณาระบุชื่อผู้ติดต่อ',
    'mice-quotation-warning-contact-company': 'กรุณาระบุชื่อบริษัทของคุณ',
    'mice-quotation-warning-contact-phone': 'กรุณาระบุเบอร์ติดต่อของคุณ',
    'mice-quotation-warning-contact-email': 'กรุณาระบุอีเมลของคุณ',
    'mice-quotation-button-submit': 'ส่งข้อมูล',
    'mice-quotation-popup-sent': 'ข้อมูลของคุณได้ถูกส่งไปยังทีมงานของเราแล้ว<br/> เราจะติดต่อกลับภายใน 1 วันทำการ',
    'mice-quotation-popup-fail': 'ขออภัยค่ะ ระบบขัดข้อง<br/> กรุณาลองใหม่อีกครั้ง',
    'mice-our-service-heading': 'บริการของเรา',
    'mice-our-service-seminar': 'จัดงานประชุมสัมมนา',
    'mice-our-service-seminar-sub-title': '(Seminar Management / MICE)',
    'mice-our-service-team-building': 'จัดกิจกรรมพัฒนาบุคคลากร',
    'mice-our-service-team-building-sub-title': '(Team Building / Camp Project / Rally)',
    'mice-our-service-group-tour': 'ทริปเดินทางในประเทศและต่างประเทศ',
    'mice-our-service-group-tour-sub-title': '(Group Tour / Incentive Group)',
    'mice-our-service-party': 'จัดงานเลี้ยงและงานพิธีต่างๆ',
    'mice-our-service-party-sub-title': '(Staff Party / Private Party / Merit-making Ceremony)',
    'mice-our-service-csr': 'จัดกิจกรรมสาธารณประโยชน์เพื่อสังคม',
    'mice-our-service-csr-sub-title': '(CSR Activity)',
    'mice-our-service-private-jet': 'บริการเช่าเครื่องบินส่วนตัว',
    'mice-our-service-private-jet-sub-title': '',
    'mice-our-service-car-rental': 'บริการรถเช่า',
    'mice-our-service-car-rental-sub-title': '',
    'mice-our-service-ticket': 'จองตั๋วเครื่องบิน<br/>และขอวีซ่าทั่วโลก',
    'mice-our-service-ticket-sub-title': '',
    'mice-benefit-title-easy': 'ง่าย',
    'mice-benefit-easy': 'กรอกข้อมูลทั้งหมด ทุกความต้องการไว้ที่เดียว',
    'mice-benefit-title-convenience': 'สะดวก',
    'mice-benefit-convenience': 'ทำรายการได้ทุกที่ ตลอด 24 ชั่วโมง',
    'mice-benefit-title-stop-service': 'ครบทุกความต้องการ',
    'mice-benefit-stop-service': 'ผสมผสานทุกบริการไว้ที่เดียว ตอบโจทย์ธุรกิจทุกรูปแบบ',
    'mice-benefit-title-professional': 'ทำงานอย่างมืออาชีพ',
    'mice-benefit-professional': 'ดูแลโดยทีมงานมืออาชีพ สร้างความประทับใจให้กับทุกทริป',
    'mice-service-choice-tile': 'ให้เราช่วยจัดหาบริการที่เหมาะกับคุณ',
    'mice-service-choice-sub-title': 'ด้วยบริการดูแลแบบครบวงจรที่คุณไม่ต้องเสียเวลาทำเอง สะดวกสบาย อยู่ที่ไหนก็จองได้ ปรีกษาฟรี! ไม่เสียค่าบริการใดๆ',
    'mice-service-choice-button': 'คลิกที่นี่',
    'mice-service-gallery-title': 'ภาพบรรยากาศและผลงานที่ผ่านมา',
    'mice-validation-pattern-contact-number': 'เบอร์ติดต่อต้องเป็นตัวเลข 0-9 จำนวน 9-10 หลัก',
    'mice-validation-pattern-email': 'อีเมลของคุณไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง',
    'booking-cannot-be-processed-error-header': 'ไม่สามารถทำรายการจองได้',
    'booking-cannot-be-processed-error': 'กรุณาเลือกที่พักใหม่อีกครั้ง',
    'system-error': 'ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง',
    // Dialog Switch Company
    'dialog-switch-company-title': 'คุณต้องการเปลี่ยนไปใช้ข้อมูลภายใต้บริษัท',
    'dialog-switch-company-sub-title': 'สำหรับการจองที่พักเพื่อทำงาน สิทธิ์ที่คุณจะได้รับขึ้นอยู่กับแต่ละบริษัท กรุณาตรวจสอบข้อมูลของคุณตามด้านล่างนี้',
    'dialog-switch-company-payment-method': 'การชำระเงิน',
    'dialog-switch-company-budget': 'วงเงินต่อห้องต่อคืน',
    'dialog-switch-company-co-budget': 'วงเงินต่อห้องต่อคืน<br/>สำหรับผู้เข้าพัก 2 คน',
    'dialog-switch-company-budget-per-month': 'วงเงินต่อเดือน',
    'dialog-switch-company-budget-per-year': 'วงเงินต่อปี',
    'dialog-switch-company-tax-address': 'ที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'dialog-switch-company-allow': 'อนุญาต',
    'dialog-switch-company-allow-credit-terms': 'ใช้การชำระเงินแบบส่งใบแจ้งหนี้ (Credit Terms)',
    'dialog-switch-company-allow-corporate-fleet': 'ใช้การชำระเงินด้วยบัตรฟลีทบริษัท (Corporate Fleet Card)',
    'dialog-switch-company-not-allow': 'ไม่มีสิทธิ์',
    'dialog-switch-company-not-allow-credit-terms': 'ใช้การชำระเงินแบบส่งใบแจ้งหนี้ (Credit Terms)',
    'dialog-switch-company-not-allow-corporate-fleet': 'ไม่มีสิทธิ์ ใช้การชำระเงินด้วยบัตรฟลีทบริษัท (Corporate Fleet Card)',
    'dialog-switch-company-booking-under': 'หากต้องการเปลี่ยนไปจองห้องพักภายใต้สิทธิ์ของบริษัท',
    'dialog-switch-company-credit-card': ' คุณสามารถชำระเงินด้วยบัตรเครดิต/เดบิตเท่านั้น',
    'dialog-switch-company-warning': 'หรืออาจเปลี่ยนแปลงไปตามข้อมูลที่คุณเลือกในหน้าชำระเงิน',
    'dialog-switch-company-limit-room': 'จำนวนห้องพักที่จองได้ต่อครั้ง',
    'dialog-switch-company-room': 'ห้อง',
    'dialog-switch-company-multi-payment': 'จองที่พักเกินวงเงินและจ่ายส่วนต่างเอง',
    'dialog-switch-company-share-budget': 'รวมงบประมาณการจอง',
    'dialog-switch-company-limit-budget-warning': 'วงเงินของคุณจะเปลี่ยนแปลงตามจุดหมายปลายทางและช่วงวันที่คุณเลือกพัก',
    'dialog-switch-company-for': 'สำหรับ',
    'unlimited-budget': 'ไม่จำกัด',
    // Product Review
    'product-review-title': 'รีวิวจากผู้เข้าพัก',
    'product-review': 'รีวิว',
    'product-review-date': 'รีวิวเมื่อ',
    'product-review-order-by-review-date': 'รีวิวล่าสุด',
    'product-review-order-by-rating-desc': 'คะแนนรีวิวมากไปน้อย',
    'product-review-order-by-rating-asc': 'คะแนนรีวิวน้อยไปมาก',
    'product-review-image': 'ภาพรีวิวจากผู้เข้าพัก',
    'product-review-anonymous': 'ไม่ระบุชื่อ',
    // Dialog Budget suggestion
    'dialog-budget-suggestion-title': 'วงเงินการจองที่พัก',
    'dialog-budget-suggestion-desc': 'ระบบจะนำวงเงินที่คุณระบุไปคำนวณส่วนต่างในการเรียกเก็บเงินแบบแบ่งชำระ 2 ช่องทาง และวงเงินนี้จะถูกบันทึกไว้ใช้ในจองครั้งถัดไป โดยคุณสามารถแก้ไขได้อีกครั้งในขั้นตอนนี้',
    'dialog-budget-suggestion-form-btn-submit': 'ใช้วงเงินนี้',
    'dialog-budget-suggestion-form-btn-cancel': 'ยกเลิก',
    'dialog-budget-suggestion-label-budget': 'วงเงินต่อห้องต่อคืนของคุณ',
    'dialog-budget-suggestion-form-require-budget': 'กรุณาระบุวงเงินต่อห้องต่อคืนของคุณ',
    'dialog-budget-suggestion-form-exceed-limit-budget': 'กรุณาระบุวงเงินไม่เกิน THB 1,000,000',
    // Dialog Tax Address
    'dialog-tax-address-title-add-mode': 'เพิ่มที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
    'dialog-tax-address-title-edit-mode': 'ที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
    // Filter Dropdown
    'filter-dropdown-no-results-match': 'ไม่พบผลลัพธ์การค้นหา',
    'form-autocomplete-no-result': 'ไม่พบข้อมูล',
    // Dialog
    'dialog-close': 'ปิด',
    'dialog-cancel': 'ยกเลิก',
    'dialog-confirm': 'เลือก',
    // Dropdown
    'default-dropdown': 'กรุณาเลือก',
    // Dialog confirm close
    'dialog-confirm-close-title': 'ออกจากหน้านี้',
    'dialog-confirm-close-desc': 'คุณต้องการออกจากหน้านี้โดยไม่ทำการบันทึกใช่หรือไม่?',
    'dialog-confirm-close-cancel': 'ยกเลิก',
    'dialog-confirm-close-confirm': 'ใช่ ออกจากหน้านี้',
    'dialog-confirm-change-search': 'เปลี่ยนการค้นหา',
    'dialog-confirm-change-continue-share-budget': 'จองต่อโดยใช้วงเงินคุณเอง',
    'dialog-confirm-cancel-share-budget': 'ยกเลิกการรวมวงเงิน',
    // Dialog confirm delete
    'dialog-confirm-delete-title': 'ลบข้อมูล',
    'dialog-confirm-delete-cancel': 'ยกเลิก',
    'dialog-confirm-delete-confirm': 'ลบ',
    // Dialog confirm delete address
    'dialog-confirm-delete-address-desc': 'คุณต้องการลบที่อยู่นี้ใช่หรือไม่?',
    // PDPA
    'pdpa-btn-accept': 'ยอมรับ',
    'pdpa-title': 'เงื่อนไขการใช้บริการและนโยบายความเป็นส่วนตัว',
    'pdpa-term-of-use': 'ข้อกำหนดและเงื่อนไขการใช้บริการ',
    'pdpa-privacy-notice': 'นโยบายความเป็นส่วนตัว',
    'cookies-policy': 'นโยบายคุกกี้',
    // Dialog Consent
    'dialog-consent-to-website': 'เรากำลังจะพาคุณไปยังหน้าเว็บไซต์',
    'dialog-consent-requesting-permission': 'โดยขอสิทธิ์การอนุญาตเข้าถึงข้อมูลต่อไปนี้',
    'dialog-consent-basic-information': 'เข้าถึงข้อมูลส่วนตัวพื้นฐานของคุณ',
    'dialog-consent-contact-information': 'เข้าถึงข้อมูลการติดต่อของคุณ',
    'dialog-consent-allow': 'อนุญาต',
    'dialog-consent-dont-allow': 'ไม่อนุญาต',
    'dialog-consent-full-name-etc': 'ชื่อ นามสกุล และข้อมูลอื่นๆ ที่คุณเปิดเผยกับ Ascend Travel',
    // Dialog Budget Available
    'dialog-budget-pay-option': 'คุณสามารถจองห้องพักโดยชำระเงินค่าที่พักเอง',
    'dialog-budget-pay-exceeding-option': 'คุณสามารถจองห้องพักโดยชำระส่วนที่เกินวงเงินเอง',
    'dialog-budget-cannot-share-budget-co-booker': 'ไม่สามารถรวมเงินกับผู้ร่วมเดินทางได้',
    // Dialog Cancel Share Budget
    'dialog-cancel-share-budget-text': 'คุณต้องการยกเลิกการรวมวงเงินใช่หรือไม่?',
    'dialog-cancel-share-budget-sub-text': 'เมื่อยกเลิกการรวมวงเงิน คุณจะสามารถจองห้องพัก ตามวงเงินที่คุณได้รับเท่านั้น',
    //Dialog PIN
    'dialog-set-pin-header': 'ตั้งรหัส PIN',
    'dialog-confirm-set-pin-header': 'ยืนยันรหัส PIN ใหม่อีกครั้ง',
    'dialog-set-pin-sub-header': 'กำหนดหมายเลข 6 ตัว เพื่อรักษาความปลอดภัยของบัญชี',
    'dialog-set-pin-sub-header-2': 'ใช้รหัส PIN สำหรับการชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัทของคุณ',
    'dialog-verify-otp-header': 'ยืนยันตัวตน',
    'dialog-verify-otp-sub-header': 'กรุณาเลือกช่องทางด้านล่างในการยืนยันตัวตนของคุณ',
    'dialog-confirm-pin-booking-header': 'ยืนยันการจองด้วยรหัส PIN',
    'dialog-confirm-pin-booking-sub-header': 'กรุณาระบุรหัสรหัส PIN 6 หลัก สำหรับการชำระเงินแบบส่งใบแจ้งหนี้ เรียกเก็บเงินไปยังบริษัทของคุณ',
    'dialog-confirm-pin-booking-forgot-pin': 'ลืมรหัส PIN?',
    'dialog-confirm-pin-booking-set-new-pin': 'คลิกเพื่อไปตั้งรหัส PIN ใหม่',
    'dialog-alert-set-pin-title': 'บัญชีของคุณยังไม่มีการตั้งรหัส PIN',
    'dialog-alert-set-pin-description': 'เพื่อความปลอดภัยสำหรับการชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัท กรุณาตั้งรหัส PIN ใหม่ได้ด้วยตัวเอง<br> โดยไปที่เมนู <b>บัญชี > ความปลอดภัยบัญชี > ตั้งรหัส PIN<b>',
    'dialog-alert-btn-confirm-set-pin': 'ตั้งรหัส PIN',
    'pin-code-incorrect': 'รหัส PIN ไม่ถูกต้อง',
    'set-pin-not-matched': 'รหัส PIN ไม่ตรงกับที่ยืนยัน กรุณาตรวจสอบและลองใหม่อีกครั้ง',
    'pin-too-weak': 'รหัส PIN ง่ายเกินไป โปรดเลือกใช้รหัส PIN ที่ปลอดภัยมากขึ้น',
    'pin-remaining-attempts': 'รหัส PIN ไม่ถูกต้อง กรุณาลองใหม่ คุณเหลือโอกาสอีก {x} ครั้ง ก่อนที่รหัส PIN จะถูกล็อก',
    'pin-locked': 'รหัส PIN ถูกล็อก คุณสามารถไปตั้งรหัส PIN ใหม่ <br>หรือติดต่อ Call Center: +66(0) 2-020-2351 / Line Official Account: @AscendTravel',
    'otp-title': 'ยืนยันตัวตน',
    'otp-select-channel': 'กรุณาเลือกช่องทางด้านล่างในการยืนยันตัวตนของคุณ',
    'otp-send-to': 'ส่งรหัสยืนยันไปที่',
    'otp-resend': 'ส่งรหัสยืนยันอีกครั้ง',
    'otp-reference': 'รหัสอ้างอิง: ',
    'otp-code-incorrect': 'รหัสยืนยันไม่ถูกต้อง',
    'otp-last-attempts': 'รหัสยืนยันไม่ถูกต้อง กรุณาลองใหม่ คุณเหลือโอกาสอีก 1 ครั้ง หากคุณระบุรหัสยืนยันผิดเกินจำนวนครั้งที่กำหนดบัญชีจะถูกล็อกชั่วคราว',
    'otp-remaining-attempts': 'รหัสยืนยันไม่ถูกต้อง กรุณาลองใหม่ คุณเหลือโอกาสอีก {x} ครั้งก่อนที่บัญชีจะถูกล็อก',
    'otp-try-another-way': 'ลองวิธีอื่น',
    'setup-pin-success': 'ตั้งรหัส PIN เรียบร้อยแล้ว',
    'dialog-otp-verify-sub-header': 'เราได้ส่งรหัสยืนยันไปที่',
    'dialog-otp-verify-email-sub-header': 'กรุณาตรวจสอบอีเมลและกรอกรหัสด้านล่างภายใน 15 นาที หลังได้รับอีเมล',
    'dialog-otp-verify-sms-sub-header': 'กรุณาตรวจสอบข้อความและกรอกรหัสด้านล่างภายใน 15 นาที หลังได้รับข้อความ',
    'email': 'อีเมล',
    'phone': 'เบอร์โทรศัพท์',
    'account-locked': 'บัญชีถูกล็อก เนื่องจากคุณระบุรหัสยืนยันผิดเกินจำนวนครั้งที่กำหนด หากต้องการปลดล็อก สามารถติดต่อ Call Center: +66(0) 2-020-2351 / Line Official Account: @AscendTravel',
    'session-expired': 'เซสชันหมดอายุ กรุณาทำรายการใหม่อีกครั้ง',
    // Dialog Phone
    'dialog-set-phone-header': 'ระบุเบอร์โทรศัพท์',
    'dialog-set-phone-sub-header': 'กรุณาระบุเบอร์โทรศัพท์ที่คุณต้องการเชื่อมกับบัญชี',
    'dialog-set-phone-label-phone-number': 'เบอร์โทรศัพท์',
    'dialog-set-phone-require-mobile-number': 'กรุณากรอกเบอร์โทรศัพท์',
    'dialog-set-phone-invalid-mobile-number': 'กรุณาระบุเบอร์ติดต่อที่ถูกต้อง',
    'change-phone-success': 'เชื่อมเบอร์โทรศัพท์กับบัญชีเรียบร้อยแล้ว',
    // Badge or Notices
    'sanitized-stay': 'มั่นใจเมื่อเข้าพัก',
    'sanitized-stay-hover': 'ที่พักมีมาตรการพิเศษเพื่อความปลอดภัยด้านสุขนามัยในการให้บริการผู้เข้าพัก',
    'year-of-build-badge': 'สร้างใหม่ {yyyy}',
    'year-of-renovated-badge': 'ปรับปรุงใหม่ {yyyy}',
    'security-standard-badge': 'มาตรฐานความปลอดภัย',
    'security-standard-badge-hover': 'ที่พักได้รับการตรวจสอบเป็นพิเศษเรื่องมาตรฐานความปลอดภัยจากหน่วยงานที่เกี่ยวข้องแล้ว',
    // Budget Limit
    'budget-limit-special-budget-for-destination': 'วงเงินพิเศษสำหรับการจองจุดหมายปลายทางนี้',
    'budget-limit-special-budget-for-poi': 'วงเงินในการจองที่พักขึ้นอยู่กับจุดหมายปลายทางที่เลือก',
    'budget-limit-special-budget-for-poi-new': 'คุณมีวงเงินใหม่ในการจองที่พักขึ้นอยู่กับจุดหมายปลายทางที่คุณเลือก',
    'budget-limit-normal-budget': 'วงเงินปกติ',
    'budget-limit-tittle': 'คุณมีวงเงินพิเศษสำหรับการจองจุดหมายปลายทางนี้',
    'budget-limit-detail': 'เนื่องจากมีวงเงินพิเศษเฉพาะบางวันเท่านั้น วงเงินที่แสดงจึงเป็นวงเงินเฉลี่ยจากช่วงวันเข้าพักและจำนวนคืนที่คุณเลือกตามรายละเอียดด้านล่างนี้',
    'budget-limit-detail-poi': 'เนื่องจากมีวงเงินพิเศษเฉพาะบางวันและบางจุดหมายปลายทางเท่านั้น คุณสามารถกดดูเพิ่มเติมเพื่อดูวงเงินทั้งหมดของคุณได้',
    'budget-limit-dialog-detail-poi': 'เนื่องจากมีวงเงินพิเศษเฉพาะบางวันและบางจุดหมายปลายทางเท่านั้น วงเงินที่แสดงจึงเป็นวงเงินเฉลี่ยจากช่วงวันเข้าพักและจำนวนคืนที่คุณเลือกตามรายละเอียดด้านล่างนี้',
    'budget-limit-detail-bottom-poi': 'วงเงินต่อห้องต่อคืนที่สามารถใช้ได้จะขึ้นอยู่กับจุดหมายปลายทางของที่พักที่คุณเลือก',
    'budget-limit-net-budget': 'วงเงินต่อห้องต่อคืน สำหรับช่วงวันเข้าพักที่เลือกค้นหา',
    'budget-limit-more-detail': 'ดูเพิ่มเติม',
    'budget-limit-day-check-in': 'วันที่เข้าพัก',
    'budget-limit-budget-per-night': 'วงเงินต่อคืน',
    'budget-limit-sum-budget-per-night': 'วงเงินรวมต่อคืน',
    'budget-limit-budget-special': 'วงเงินพิเศษ',
    'budget-limit-budget-per-night-per-room': 'วงเงินต่อห้องต่อคืน',
    'budget-limit-for-search': 'สำหรับช่วงวันเข้าพักที่เลือกค้นหา',
    'budget-limit-and': 'และ',
    'budget-limit-for': 'สำหรับ',
    'budget-limit-unlimited': 'ไม่จำกัด',
    'budget-limit-view-detail': 'ดูรายละเอียด',
    'budget-limit-unlimited-share-budget': 'คุณมีวงเงินใหม่ในการจองที่พักต่อห้องต่อคืนไม่จำกัด',
    'budget-limit-share-budget': 'คุณมีวงเงินใหม่ในการจองที่พักอยู่ <strong>{x}</strong> /ห้อง/คืน',
    'budget-limit-share-budget-title': 'คุณได้รวมกับวงเงินของผู้ร่วมเดินทาง และมีวงเงินพิเศษสำหรับการจองจุดหมายปลายทางนี้',
    'budget-limit-share-budget-detail': 'เนื่องจากมีวงเงินพิเศษเฉพาะบางวันเท่านั้น วงเงินที่แสดงจึงเป็นวงเงินเฉลี่ยจากช่วงวันเข้าพักและจำนวนคืนที่คุณเลือก',
    'budget-limit-booker-budget': 'วงเงินของคุณ',
    'budget-limit-co-booker-budget': 'วงเงินของผู้ร่วมเดินทาง',
    'budget-limit-co-booker-budget-new-tab': 'วงเงินของ<br>ผู้ร่วมเดินทาง',
    'budget-limit-total-budget': 'วงเงินรวมต่อคืน',
    'budget-limit-normal-budget-booker': 'วงเงินปกติของคุณ',
    'budget-limit-normal-budget-co-booker': 'วงเงินปกติของผู้ร่วมเดินทาง',
    'budget-limit-applied-co-budget': '**มีการจำกัดวงเงินในการจองห้องพักสำหรับผู้เข้าพัก 2 คน',
    // My Budget
    'my-budget-title': 'สิทธิ์และวงเงินการจองที่พัก',
    'my-budget-under': 'ภายใต้บริษัท {companyName}',
    'my-budget-user-permission-detail-title': 'สิทธิ์การจองที่พัก',
    'my-budget-budget-detail-title': 'วงเงิน',
    'my-budget-month': 'เดือน',
    'my-budget-budget-used': 'ยอดที่ใช้ไป',
    'my-budget-budget-per-month-remaining': 'วงเงินต่อเดือนคงเหลือ',
    'my-budget-budget-per-year-remaining': 'วงเงินต่อปีคงเหลือ',
    'my-budget-badge-per-month-remaining': 'วงเงินต่อเดือนคงเหลือ',
    'my-budget-badge-per-monht-used': 'จากวงเงินต่อเดือนทั้งหมด คุณใช้ไป',
    'my-budget-badge-per-year-remaining': 'วงเงินต่อปีคงเหลือ',
    'my-budget-badge-per-year-used': 'จากวงเงินต่อปีทั้งหมด คุณใช้ไป',
    'my-budget-year': 'ปี',
    // Share Budget Code
    'share-budget-code-title': 'สร้างรหัสสำหรับรวมวงเงิน',
    'share-budget-code-content-title': 'รหัสสำหรับรวมวงเงิน คือรหัสสำหรับให้ผู้จองหลักใช้รวมวงเงินการจองที่พักกับคุณ',
    'share-budget-code-generate-code': 'สร้างรหัส',
    'share-budget-code-copy-code': 'คัดลอกรหัส',
    'share-budget-code-text': 'รหัสสำหรับรวมวงเงิน',
    'share-budget-code-generate-code-link': 'สร้างรหัสใหม่',
    'share-budget-code-copied': 'คัดลอกรหัสแล้ว',
    'share-budget-code-description': 'เมื่อสร้างรหัสเรียบร้อยแล้วจะสามารถใช้ได้ภายใน 24 ชั่วโมงเท่านั้น หากคุณสร้างรหัสใหม่ รหัสที่เคยสร้างไว้จะหมดอายุทันที',
    'share-budget-code-select-company-label': 'กรุณาเลือกบริษัทที่ต้องการรวมวงเงินการจอง',
    'share-budget-code-defalut-company': 'เลือกบริษัท',
    'share-budget-code-not-allow': 'บริษัทของคุณไม่อนุญาตให้รวมวงเงิน',
    // Dialog Share Budget
    'dialog-share-budget-title': 'รวมวงเงินการจองกับผู้ร่วมเดินทาง',
    'dialog-share-budget-sub-title': 'คุณต้องได้รับความยินยอมจากผู้ร่วมเดินทางก่อนการจองทุกครั้ง สำหรับการจองครั้งนี้ ผู้ร่วมเดินทางจะถือว่าเป็น <b>“ผู้จองร่วม”</b> และวงเงินในการจองที่พักจะเป็นวงเงินชั่วคราวของคุณและผู้ร่วมเดินทางของคุณ',
    'dialog-share-budget-code-ref': 'รหัสสำหรับรวมวงเงิน',
    'dialog-share-budget-code-ref-change': 'เปลี่ยน',
    'dialog-share-budget-co-booker-email': 'อีเมลผู้ร่วมเดินทาง',
    'dialog-share-budget-co-booker-company': 'ผู้ร่วมเดินทางภายใต้บริษัท',
    'dialog-share-budget-co-booker-company-address': 'ที่อยู่ออกใบกำกับภาษี/ใบเสร็จ',
    'dialog-share-budget-error-code-ref-require': 'กรุณาใส่รหัสสำหรับรวมวงเงิน',
    'dialog-share-budget-error-code-ref-incorrect': 'รหัสสำหรับรวมวงเงินไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง',
    'dialog-share-budget-error-code-ref-expired': 'รหัสสำหรับรวมวงเงินหมดอายุแล้ว กรุณาตรวจสอบและลองใหม่อีกครั้ง',
    'dialog-share-budget-error-code-ref-yourself': 'ไม่สามารถรวมวงเงินกับตัวเองได้',
    'dialog-share-budget-error-code-ref-not-allow-feature': 'รหัสไม่สามารถใช้งานได้ เนื่องจากบริษัทของคุณหรือผู้ร่วมเดินทางไม่อนุญาตให้รวมวงเงินการจอง',
    'dialog-share-budget-gen-code-link': 'ผู้จองร่วมสามารถสร้างรหัสสำหรับรวมวงเงินได้ที่',
    'dialog-share-budget-copy-link': 'คัดลอกลิงก์',
    'dialog-share-budget-copy-link-to-clipboard': 'คัดลอกลิงก์แล้ว',
    'dialog-share-budget-company': 'บริษัท',
    'dialog-share-budget-tax-id': 'หมายเลขประจำตัวผู้เสียภาษี',
    'dialog-share-budget-confirm-share-budget': 'รวมวงเงิน',
    //Dialog payment
    'dialog-payment-title': 'รายการชำระเงินแบ่งเป็น 2 ช่องทาง',
    'dialog-payment-sub-title': 'กรุณาเลือกช่องทางการชำระเงินที่คุณต้องการ',
    'dialog-payment-main-payment': 'รายการชำระเงินหลัก',
    'dialog-payment-extra-payment': 'รายการชำระเงินเพิ่มเอง',
    // Form Share Budget
    'form-share-budget-title': 'รายการชำระเงิน',
    'form-share-budget-title-multi': 'รายการชำระเงิน',
    'form-share-budget-credit-terms-title': 'ชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัท',
    'form-share-budget-credit-terms-booker': 'ยอดชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัทคุณ  ',
    'form-share-budget-credit-terms-co-booker': 'ยอดชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัทผู้ร่วมเดินทาง',
    'form-share-budget-other-payment': 'ชำระเงินเพิ่มด้วย',
    'form-share-budget-other-payment-credit-terms': 'ชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัท',
    'form-share-budget-other-payment-credit-card': 'บัตรเครดิต/เดบิต',
    'form-share-budget-other-payment-true-money': 'ทรูมันนี่ วอลเล็ท',
    'form-share-budget-other-payment-personal-fleet': 'บัตรฟลีทส่วนตัว',
    'room-special-request-optional': ' - ถ้ามี',
    'room-special-request-sub-title': "\u0E40\u0E23\u0E32\u0E08\u0E30\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E17\u0E35\u0E48\u0E1E\u0E31\u0E01\u0E17\u0E23\u0E32\u0E1A\u0E17\u0E31\u0E19\u0E17\u0E35\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E08\u0E2D\u0E07 \u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E15\u0E32\u0E21\u0E04\u0E33\u0E02\u0E2D\u0E44\u0E14\u0E49 \u0E41\u0E15\u0E48\u0E17\u0E35\u0E48\u0E1E\u0E31\u0E01\u0E08\u0E30\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E2A\u0E38\u0E14\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E41\u0E25\u0E30\u0E2D\u0E32\u0E08\u0E21\u0E35\u0E04\u0E48\u0E32\u0E43\u0E0A\u0E49\u0E08\u0E48\u0E32\u0E22\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'room-special-preferred-room': 'ประเภทห้องที่ต้องการ',
    'room-special-request-non-smoke-room': 'ห้องปลอดบุหรี่',
    'room-special-request-smoke-room': 'ห้องสูบบุหรี่ได้',
    'room-special-preferred-bed': 'ประเภทเตียงที่ต้องการ',
    'room-special-request-large-bed': 'เตียงใหญ่',
    'room-special-request-twin-bed': 'เตียงแฝด',
    'room-special-more-special-requests': 'ขอรับบริการอื่นๆ',
    'room-special-request-high-floor-room': 'ห้องพักที่อยู่ชั้นสูง',
    'room-special-request-connecting-room': 'ห้องพักแบบเชื่อมถึงกัน',
    'room-special-request-quiet-room': 'ห้องพักเงียบสงบ',
    'room-special-others-en': 'เพิ่มเติม (กรุณาใส่ข้อมูลเป็นภาษาอังกฤษ เท่านั้น)',
    'room-special-others': 'เพิ่มเติม',
    'room-special-more-request': 'อื่นๆ',
    // Dialog Information Cart
    'dialog-information-cart-title': 'ข้อมูลที่ควรทราบ',
    'dialog-information-cart-sub-title': 'กรุณาอ่านเงื่อนไขของห้องพักก่อนยืนยันการจอง เนื่องจากข้อมูลมีการเปลี่ยนแปลง หรืออาจมีค่าใช้จ่ายเพิ่มเติมเมื่อเข้าพัก ตามรายละเอียดด้านล่าง',
    'dialog-information-cart-accept-condition': 'ยอมรับข้อตกลงและเงื่อนไข',
    'dialog-information-cart-accept-condition-required': 'กรุณากดยอมรับข้อตกลงและเงื่อนไข',
    // Fleet Card Information
    'fleet-card-status-active': 'เปิดใช้งาน',
    'fleet-card-status-inactive': 'ปิดใช้งาน',
    'fleet-card-status-expired': 'หมดอายุ',
    'fleet-card-type-corporate': 'บริษัท',
    'fleet-card-type-personal': 'บัตรฟลีทส่วนตัว',
    'fleet-card-information-card-personal': 'บัตรฟลีทส่วนตัว',
    'fleet-card-no-expiration-date': 'ไม่มีวันหมดอายุ',
    'fleet-card-information-fleet-card-type-all': 'ทั้งหมด',
    'fleet-card-information-fleet-card-type-corporate': 'บริษัท',
    'fleet-card-information-fleet-card-type-personal': 'ส่วนตัว',
    'fleet-card-information-title': 'บัตรฟลีท (Fleet Card)',
    'fleet-card-information-register': 'เพิ่มบัตรใหม่',
    'fleet-card-information-fleet-card-no-label': 'หมายเลขบัตรฟลีท',
    'fleet-card-information-redeemed-amount': 'ยอดที่ใช้ไปทั้งหมด',
    'fleet-card-information-balance-amount': 'ยอดเงินคงเหลือ',
    'fleet-card-information-information-label': 'ข้อมูลบัตร',
    'fleet-card-information-status-label': 'สถานะบัตร',
    'fleet-card-information-type-label': 'ประเภทบัตร',
    'fleet-card-information-company-label': 'ภายใต้บริษัท',
    'fleet-card-information-expiration-label': 'วันหมดอายุ',
    'fleet-card-information-topup': 'เติมเงินเข้าบัตร',
    'fleet-card-information-transfer': 'โอนเงินระหว่างบัตร',
    'fleet-card-information-no-fleet-title': 'ไม่มีบัตรฟลีทในบัญชีของคุณ',
    'fleet-card-information-no-fleet-description-1': 'หากคุณมีบัตรฟลีทแล้ว กรุณาคลิก “เพิ่มบัตรใหม่” เพื่อเริ่มต้นใช้งาน',
    'fleet-card-information-no-fleet-description-2': 'หากคุณต้องการซื้อบัตรฟลีท สามารถติดต่อได้ 2 ช่องทาง',
    'fleet-card-information-no-fleet-company-title': 'ไม่มีบัตรฟลีทบริษัทในบัญชีของคุณ',
    'fleet-card-information-no-fleet-personal-title': 'ไม่มีบัตรฟลีทส่วนตัวในบัญชีของคุณ',
    // Dialog Fleet Card Top Up
    'dialog-fleet-card-top-up-title': 'เราจะเปิดให้บริการเติมเงินผ่านช่องทางออนไลน์เร็วๆนี้',
    'dialog-fleet-card-top-up-sub-title-1': 'หากคุณต้องการซื้อบัตรฟลีทเพิ่ม สามารถติดต่อได้ 2 ช่องทาง',
    // Dialog Fleet Card Register
    'dialog-fleet-card-register-title': 'เพิ่มบัตรฟลีท (Fleet Card)',
    'dialog-fleet-card-register-fleet-card-no-label': 'หมายเลขบัตรฟลีท',
    'dialog-fleet-card-register-fleet-card-no-error-required': 'กรุณาระบุหมายเลขบัตรฟลีท',
    'dialog-fleet-card-register-secret-code-label': 'รหัสลับ',
    'dialog-fleet-card-register-secret-code-tooltip': "\u0E23\u0E2B\u0E31\u0E2A\u0E25\u0E31\u0E1A \u0E04\u0E37\u0E2D\u0E23\u0E2B\u0E31\u0E2A\u0E04\u0E39\u0E48\u0E01\u0E31\u0E1A\u0E1A\u0E31\u0E15\u0E23\u0E1F\u0E25\u0E35\u0E17 \u0E43\u0E0A\u0E49\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E31\u0E15\u0E23\u0E1F\u0E25\u0E35\u0E17\u0E40\u0E02\u0E49\u0E32\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E39\u0E49\u0E16\u0E37\u0E2D\u0E1A\u0E31\u0E15\u0E23\u0E08\u0E23\u0E34\u0E07 \u0E42\u0E14\u0E22\u0E23\u0E2B\u0E31\u0E2A\u0E25\u0E31\u0E1A \u0E08\u0E30\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E1C\u0E39\u0E49\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E0B\u0E37\u0E49\u0E2D\u0E1A\u0E31\u0E15\u0E23\u0E44\u0E14\u0E49\u0E23\u0E30\u0E1A\u0E38\u0E44\u0E27\u0E49",
    'dialog-fleet-card-register-secret-code-error-required': 'กรุณาระบุรหัสลับ',
    'dialog-fleet-card-register-fleet-card-no-or-secret-code-invalid': 'หมายเลขบัตร หรือรหัสลับไม่ถูกต้อง',
    'dialog-fleet-card-register-fleet-card-is-already-registered': 'หมายเลขบัตรนี้ถูกเพิ่มแล้ว',
    'dialog-fleet-card-register-fleet-card-is-expired': 'หมายเลขบัตรนี้หมดอายุแล้ว ',
    'dialog-fleet-card-register-fleet-card-cannot-register-company': 'หมายเลขบัตรนี้ไม่สามารถเพิ่มได้สำหรับบริษัทของคุณ ',
    // Fleet Card Transaction History
    'fleet-card-transaction-history-title': 'ประวัติรายการ',
    'fleet-card-transaction-history-filter-date-all': 'ทั้งหมด',
    'fleet-card-transaction-history-filter-by': 'แสดง',
    'fleet-card-transaction-history-filter-all': 'รายการทั้งหมด',
    'fleet-card-transaction-history-filter-redeem': 'รายการชำระเงิน',
    'fleet-card-transaction-history-filter-transfer-withdrawal': 'รายการโอนเงิน',
    'fleet-card-transaction-history-filter-transfer-deposit': 'รายการรับโอนเงิน',
    'fleet-card-transaction-history-filter-refund': 'รายการคืนเงิน',
    'fleet-card-transaction-history-date': 'วันที่บันทึกรายการ',
    'fleet-card-transaction-history-activity': 'รายการ',
    'fleet-card-transaction-history-balance': 'ยอดเงิน',
    'fleet-card-transaction-history-text-redeem': 'มีรายการใช้บัตร หมายเลขการจอง',
    'fleet-card-transaction-history-text-transfer-withdrawal': 'โอนเงิน ไปยัง',
    'fleet-card-transaction-history-text-transfer-deposit': 'เงินเข้า จาก',
    'fleet-card-transaction-history-text-refund': 'รายการคืนเงิน หมายเลขการจอง',
    'fleet-card-transaction-history-no-transaction': 'ไม่มีประวัติรายการ',
    // Dialog Fleet Card Register Complete
    'dialog-fleet-card-register-complete-title': 'เพิ่มบัตรใหม่เรียบร้อยแล้ว',
    'dialog-fleet-card-register-complete-fleet-card-no-label': 'หมายเลขบัตร',
    'dialog-fleet-card-register-complete-fleet-card-type-label': 'ประเภทบัตร',
    'dialog-fleet-card-register-complete-company-label': 'ภายใต้บริษัท',
    'dialog-fleet-card-register-complete-expiration-date-label': 'วันหมดอายุ',
    'dialog-fleet-card-register-complete-amount-label': 'จำนวนเงิน',
    // Checkout 3 Fleet Card
    'checkout-3-fleet-card-title': 'ข้อมูลบัตรฟลีท',
    'checkout-3-personal-fleet-title': 'ข้อมูลบัตรฟลีทส่วนตัว',
    'checkout-3-corporate-fleet-title': 'ข้อมูลบัตรฟลีทบริษัท',
    'checkout-3-fleet-card-no-you-account': 'ไม่มีบัตรฟลีทในบัญชีของคุณ',
    'checkout-3-fleet-card-no-you-account-sub-1': 'หากคุณมีบัตรฟลีทแล้ว กรุณาลงทะเบียนเพื่อเริ่มต้นใช้งานบัตรที่เมนู <i class="icon-fleet"> <b>บัตรฟลีท (Fleet Card)</b>',
    'checkout-3-fleet-card-no-you-account-sub-2': 'หากคุณต้องการซื้อบัตรฟลีท กรุณาติดต่อ Call Center +66(0) 2-020-2351',
    'checkout-3-fleet-card-no-you-account-sub-3': 'หรือ Line Official Account',
    'checkout-3-fleet-card-information': 'รายการชำระเงินด้วยบัตรฟลีท',
    'checkout-3-fleet-card-payment-date': 'จะตัดเงินวันที่',
    'checkout-3-personal-fleet': 'บัตรส่วนตัว',
    'checkout-3-fleet-card-cannot-selected-error': 'ยอดเงินคงเหลือในบัตรไม่เพียงพอ กรุณาเลือกบัตรใหม่หรือเปลี่ยนช่องทางการชำระเงิน',
    'checkout-3-fleet-card-cannot-selected-error-multi': 'ยอดชำระเกินวงเงินที่ได้รับ กรุณาเลือกบัตรใหม่หรือเปลี่ยนช่องทางการชำระเงิน',
    // Dialog Fleet Card Transfer
    'dialog-fleet-card-transfer-default-dropdown': 'เลือกหมายเลขบัตรฟลีท',
    'dialog-fleet-card-transfer-title': 'โอนเงินระหว่างบัตร',
    'dialog-fleet-card-transfer-sub-title': 'สามารถโอนเงินในบัตรไปยังบัตรประเภทเดียวกัน หรือภายใต้บริษัทเดียวกัน และบัตรต้องไม่มีวันหมดอายุ',
    'dialog-fleet-card-transfer-fleet-card-no-from-label': 'จากหมายเลขบัตร',
    'dialog-fleet-card-transfer-fleet-card-no-to-label': 'ไปยังหมายเลขบัตร',
    'dialog-fleet-card-transfer-fleet-card-no-to-note': 'รายการบัตรจะแสดงเฉพาะบัตรที่สามารถโอนเงินได้เท่านั้น',
    'dialog-fleet-card-transfer-amount-label': 'จำนวนเงิน',
    'dialog-fleet-card-transfer-amount-error-required': 'กรุณาระบุจำนวนเงิน',
    'dialog-fleet-card-transfer-amount-error-insufficient': 'จำนวนเงินในบัตรไม่เพียงพอ',
    'dialog-fleet-card-transfer-amount-error-exceed': 'จำนวนเงินในบัตรปลายทางเกินวงเงินสูงสุดของบัตร',
    // Dialog Fleet Card Transfer Complete
    'dialog-fleet-card-transfer-complete-title': 'โอนเงินระหว่างบัตรเรียบร้อยแล้ว',
    'dialog-fleet-card-transfer-complete-from-label': 'จากหมายเลขบัตร',
    'dialog-fleet-card-transfer-complete-to-label': 'ไปยังหมายเลขบัตร',
    'dialog-fleet-card-transfer-complete-amount-label': 'จำนวนเงิน',
    // Dialog Fleet Card Register Fail
    'dialog-fleet-card-register-fail-title': 'เพิ่มบัตรไม่สำเร็จ',
    'dialog-fleet-card-register-fail-sub-title': 'กรุณาทำรายการใหม่อีกครั้ง',
    // Dialog Fleet Card Transfer Fail
    'dialog-fleet-card-transfer-fail-title': 'โอนเงินระหว่างบัตรไม่สำเร็จ',
    'dialog-fleet-card-transfer-fail-sub-title': 'กรุณาทำรายการใหม่อีกครั้ง',
    'payment-channel-type-multi-payment': 'แบ่งชำระเงิน 2 ช่องทาง',
    'payment-channel-type-credit-terms': 'ชำระเงินแบบส่งใบแจ้งหนี้',
    'payment-channel-type-credit-card': 'บัตรเครดิต/เดบิต',
    'payment-channel-type-true-money': 'ทรูมันนี่ วอลเล็ท',
    'payment-channel-type-personal-fleet': 'บัตรฟลีทส่วนตัว',
    'payment-channel-type-corporate-fleet': 'บัตรฟลีทบริษัท',
    'payment-channel-type-fleet-card': 'บัตรฟลีท',
    'payment-channel-type-personal-payment': '* ชำระเองเต็มจำนวน *',
    'payment-channel-type-qr-code': 'QR Code',
    'payment-channel-type-e-wallet': 'E-Wallet',
    'payment-channel-type-im-banking': 'ธนาคารออนไลน์',
    'payment-channel-type-pay-at-counter': 'เคาน์เตอร์',
    'payment-method-collapse': 'ย่อ',
    'payment-method-expanse': 'แสดงช่องทางชำระเงินทั้งหมด',
    'check-in-check-out': 'เช็คอิน/เช็คเอาท์',
    'check-in-from': 'เช็คอินได้ตั้งแต่',
    'check-out-until': 'เช็คเอาท์ได้จนถึง',
    'check-out-from': 'เช็คเอาท์ได้ตั้งแต่',
    'early-late-check-in': 'โปรดติดต่อที่พักล่วงหน้า หากต้องการเช็คอินนอกเหนือเวลาดังกล่าว',
    'product-description': 'รายละเอียด',
    'product-images': 'ดูรูปภาพทั้งหมด',
    'all-photos': 'รูปภาพทั้งหมด',
    // product item
    'product-hot-deal': 'ดีลสุดฮอต!',
    'product-promotion-last-minute': '<strong>ราคาพิเศษ</strong> <span>นาทีสุดท้าย!</span>',
    'product-discount-percent': 'ลด <strong>{price}</strong>%',
    'product-discount-amount': 'ลด <strong>THB {price}</strong>',
    'info-window-content-navigate': 'ดูเส้นทาง',
    // arrival time
    'arrival-time-i-dont-know': 'ไม่ทราบเวลาแน่ชัด',
    'arrival-time-0000-0100': '00:00 - 01:00',
    'arrival-time-0100-0200': '01:00 - 02:00',
    'arrival-time-0200-0300': '02:00 - 03:00',
    'arrival-time-0300-0400': '03:00 - 04:00',
    'arrival-time-0400-0500': '04:00 - 05:00',
    'arrival-time-0500-0600': '05:00 - 06:00',
    'arrival-time-0600-0700': '06:00 - 07:00',
    'arrival-time-0700-0800': '07:00 - 08:00',
    'arrival-time-0800-0900': '08:00 - 09:00',
    'arrival-time-0900-1000': '09:00 - 10:00',
    'arrival-time-1000-1100': '10:00 - 11:00',
    'arrival-time-1100-1200': '11:00 - 12:00',
    'arrival-time-1200-1300': '12:00 - 13:00',
    'arrival-time-1300-1400': '13:00 - 14:00',
    'arrival-time-1400-1500': '14:00 - 15:00',
    'arrival-time-1500-1600': '15:00 - 16:00',
    'arrival-time-1600-1700': '16:00 - 17:00',
    'arrival-time-1700-1800': '17:00 - 18:00',
    'arrival-time-1800-1900': '18:00 - 19:00',
    'arrival-time-1900-2000': '19:00 - 20:00',
    'arrival-time-2000-2100': '20:00 - 21:00',
    'arrival-time-2100-2200': '21:00 - 22:00',
    'arrival-time-2200-2300': '22:00 - 23:00',
    'arrival-time-2300-2400': '23:00 - 24:00',
    'arrival-time-0000-0100-the-next-day': '00:00 - 01:00 (วันถัดไป)',
    'arrival-time-0100-0200-the-next-day': '01:00 - 02:00 (วันถัดไป)',
    'view-more': 'แสดงทั้งหมด',
    'view-less': 'ซ่อนทั้งหมด',
    //Modal Update Profile
    'positive-energy-title': 'ค้นหาที่พักเสริมพลังบวก',
    'positive-energy-title-desc': 'เพียงระบุวันเกิดของคุณ เราจะช่วยค้นหาที่พักที่เสริมพลังบวก โดยใช้วิธีคำนวณจากศาสตร์ตัวเลข',
    'positive-energy-description': 'ข้อมูลวันเดือนปีเกิดและช่วงเวลาเกิดจะถูกเก็บไว้<strong>เป็นความลับและได้รับความคุ้มครองตามกฎหมายที่เกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล</strong> โดยใช้สำหรับประมวลผลเพื่อแนะนำที่พักเสริมพลังบวกเท่านั้น <strong>ไม่ส่งผลกระทบกับการค้นหาที่พักแบบเดิม</strong> เมื่อกรอกข้อมูลแล้วถือว่าคุณยอมรับและเข้าใจ <a class="link-hover-style" href="https://www.ascendtravel.com/privacy-policy?lang=th" target="_blank">นโยบายความเป็นส่วนตัว</a> ของ AscendTravel.com',
    'full-name-description': 'กรุณาระบุข้อมูลเป็นภาษาอังกฤษเท่านั้น ตามที่ปรากฏในหนังสือเดินทาง/บัตรประจำตัวประชาชน (ไม่ต้องระบุคำนำหน้า/ตัวอักษรพิเศษ)',
    'time-of-birth-label': 'ช่วงเวลาเกิด',
    'time-of-birth-placeholder': 'ระบุช่วงเวลาเกิด',
    'time-of-birth-option-unspecified': 'ไม่ทราบช่วงเวลาเกิด',
    'time-of-birth-option-day': 'กลางวัน (6:00 - 17:59 น.)',
    'time-of-birth-option-night': 'กลางคืน (18:00 - 05:59 น.)',
    'time-of-birth-day': 'กลางวัน',
    'time-of-birth-night': 'กลางคืน',
    'positive-energy-btn-submit': 'ค้นหา'
};
//# sourceMappingURL=lang-th.js.map

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BannerService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var BannerService = (function () {
    function BannerService(actHttp, utilities) {
        this.actHttp = actHttp;
        this.utilities = utilities;
    }
    BannerService.prototype.getBannerHotelDealList = function (companyId, lang, isMobile) {
        var device = isMobile ? 'mobile' : 'desktop';
        var url = "" + __WEBPACK_IMPORTED_MODULE_3_environments_environment__["a" /* environment */].endpoint.getBannerHotelDealList + ("?companyId=" + companyId) + ("&lang=" + lang) + ("&device=" + device);
        return this.actHttp.get(url, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_1_app_services_act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
            .map(function (res) { return res.json().data; });
    };
    BannerService.prototype.transformToDisplayBanner = function (banners) {
        var _this = this;
        var bannerDisplays = [];
        var formatFullDate = 'YYYY-MM-DD';
        var formatDisplayDate = 'D MMM YY';
        var formatDisplayDateNotYear = 'D MMM';
        banners.forEach(function (banner) {
            var display = {
                bannerId: banner.bannerId,
                title: banner.title,
                bookPeriodFrom: banner.bookPeriodFrom,
                bookPeriodTo: banner.bookPeriodTo,
                stayPeriodFrom: banner.stayPeriodFrom,
                stayPeriodTo: banner.stayPeriodTo,
                fileUrl: banner.fileUrl,
                description: banner.description,
                link: banner.link,
                altText: banner.altText
            };
            var isSameYearBook = _this.checkSameYear(banner.bookPeriodFrom, banner.bookPeriodTo);
            var isSameYearStay = _this.checkSameYear(banner.stayPeriodFrom, banner.stayPeriodTo);
            display.displayBookStart = _this.utilities.convertDateFormat(banner.bookPeriodFrom, formatFullDate, isSameYearBook ? formatDisplayDateNotYear : formatDisplayDate);
            display.displayBookEnd = _this.utilities.convertDateFormat(banner.bookPeriodTo, formatFullDate, formatDisplayDate);
            display.displayStayStart = _this.utilities.convertDateFormat(banner.stayPeriodFrom, formatFullDate, isSameYearStay ? formatDisplayDateNotYear : formatDisplayDate);
            display.displayStayEnd = _this.utilities.convertDateFormat(banner.stayPeriodTo, formatFullDate, formatDisplayDate);
            bannerDisplays.push(display);
        });
        return bannerDisplays;
    };
    BannerService.prototype.checkSameYear = function (start, end) {
        var startYear = __WEBPACK_IMPORTED_MODULE_4_moment__(start, 'YYYY-MM-DD', 'en').year();
        var endYear = __WEBPACK_IMPORTED_MODULE_4_moment__(end, 'YYYY-MM-DD', 'en').year();
        return startYear === endYear;
    };
    BannerService.prototype.getBannerBillboard = function (companyId, lang, device) {
        var params = new URLSearchParams();
        params.append('companyId', "" + companyId);
        params.append('lang', lang);
        params.append('device', device);
        var url = __WEBPACK_IMPORTED_MODULE_3_environments_environment__["a" /* environment */].endpoint.getBannerBillboard + "?" + params;
        return this.actHttp.get(url, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_1_app_services_act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
            .map(function (res) { return res.json().data; });
    };
    BannerService.prototype.getBannerOverlay = function (companyId, lang, device) {
        var params = new URLSearchParams();
        params.append('companyId', "" + companyId);
        params.append('lang', lang);
        params.append('device', device);
        var url = __WEBPACK_IMPORTED_MODULE_3_environments_environment__["a" /* environment */].endpoint.getBannerOverlay + "?" + params;
        return this.actHttp.get(url, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_1_app_services_act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
            .map(function (res) { return res.json().data; });
    };
    BannerService.prototype.getBannerLeaderboard = function (companyId, lang, device) {
        var params = new URLSearchParams();
        params.append('companyId', "" + companyId);
        params.append('lang', lang);
        params.append('device', device);
        var url = __WEBPACK_IMPORTED_MODULE_3_environments_environment__["a" /* environment */].endpoint.getBannerLeaderboard + "?" + params;
        return this.actHttp.get(url, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_1_app_services_act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN))
            .map(function (res) { return res.json().data; });
    };
    return BannerService;
}());
BannerService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object])
], BannerService);

var _a, _b;
//# sourceMappingURL=banner.service.js.map

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MapsAPILoader; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var MapsAPILoader = (function () {
    function MapsAPILoader() {
    }
    return MapsAPILoader;
}());
MapsAPILoader = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
], MapsAPILoader);

//# sourceMappingURL=maps-api-loader.js.map

/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_model_constant__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Form; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var Form = (function () {
    function Form() {
        this.formStore = {};
        this.formErrors = {};
        this.validationMessages = {};
        this.validateInvalidCharacter = function (pattern) { return function (control) {
            if (!control.value.match(pattern)) {
                return {
                    invalidChar: true
                };
            }
            return null;
        }; };
    }
    Object.defineProperty(Form.prototype, "validatePattern", {
        get: function () {
            return {
                email: /^([^<>()\[\]\\.,;:\s@"ก-๛]+(\.[^<>()\[\]\\.,;:\s@"ก-๛]+)*)@(?:(?:(?!.*[^.]{64,})(?:(?:[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*\.){1,126}){1,}(?:(?:[a-zA-Z][a-zA-Z0-9]*))(?:-[a-zA-Z0-9]+)*)|(?:\[(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){7})|(?:(?!(?:.*[a-f0-9][:\]]){7,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?)))|(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){5}:)|(?:(?!(?:.*[a-f0-9]:){5,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3}:)?)))?(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))(?:\.(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))){3}))\]))$/,
                password: __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["G" /* PatternFormat */].PASSWORD_REGEXR,
                name: "[a-zA-Z]([\\sa-zA-Z\\-]{0,97}[a-zA-Z])?",
                fullName: /^(([A-Za-z]\.?)+)((((-([A-Za-z]\.?)+)+)|(( ([A-Za-z]\.?)+)+))*) (([A-Za-z]\.?)+)((((-([A-Za-z]\.?)+)+)|(( ([A-Za-z]\.?)+)+))*)$/,
                phone: "[0]{1}[0-9]{8,9}",
                cardName: "[0a-zA-Z]{0,1}[\\s0a-zA-Z\\-]{0,97}[0a-zA-Z]",
                billingName: "[a-zA-z\u0E01-\u0E2E\u0E30-\u0E4C][a-zA-z\\-\\s\u0E01-\u0E2E\u0E30-\u0E4C]+[a-zA-z\u0E01-\u0E2E\u0E30-\u0E4C]",
                billingAddress: "[a-zA-z0-9\u0E01-\u0E2E\u0E30-\u0E4C][a-zA-z0-9@()&,'\u0E2F/.\\-\\s\u0E01-\u0E2E\u0E30-\u0E4C]+[a-zA-z0-9\u0E01-\u0E2E\u0E30-\u0E4C\u0E2F.]",
                specialRequest: "[^\u0E01-\u0E5B]*",
                digit: "^(0[1-9][0-9]{7,8})$",
            };
        },
        enumerable: true,
        configurable: true
    });
    Form.prototype.setStore = function (form) {
        this.formStore = __assign({}, form.getRawValue());
    };
    Form.prototype.clearAllErrorMessage = function () {
        var _this = this;
        Object.keys(this.formErrors).map(function (key) { return _this.formErrors[key] = {
            valid: true,
            invalid: false,
        }; });
    };
    Form.prototype.getStoreChanged = function (prev, current) {
        return Object.keys(prev).concat(Object.keys(current)).reduce(function (map, key) {
            if (prev[key] !== current[key]) {
                map[key] = current[key];
            }
            return map;
        }, {});
    };
    Form.prototype.matchingPasswords = function (passwordKey, passwordConfirmationKey) {
        return function (form) {
            var passwordInput = form.controls[passwordKey];
            var passwordConfirmationInput = form.controls[passwordConfirmationKey];
            if (passwordInput.value !== passwordConfirmationInput.value) {
                passwordConfirmationInput.setErrors({ different: false });
            }
        };
    };
    Form.prototype.clearErrorMessage = function (data) {
        var _this = this;
        var diff = __assign({}, this.getStoreChanged(this.formStore, data));
        Object.keys(diff).map(function (key) { return _this.formErrors[key] = { valid: true, invalid: false }; });
        this.formStore = __assign({}, this.formStore, data);
    };
    Form.prototype.setErrorMessage = function (form) {
        for (var field in this.formErrors) {
            if (!this.formErrors.hasOwnProperty(field)) {
                continue;
            }
            // clear previous error message (if any)
            this.formErrors[field] = {
                invalid: false,
                valid: true
            };
            var control = form.get(field);
            if (control && !control.valid) {
                // const messages = this.validationMessages[field];
                for (var key in control.errors) {
                    if (!control.errors.hasOwnProperty(key)) {
                        continue;
                    }
                    this.formErrors[field] = __assign({}, this.formErrors[field], (_a = {}, _a[key] = true, _a.invalid = true, _a.valid = false, _a));
                }
            }
        }
        this.setStore(form);
        var _a;
    };
    Form.prototype.setErrorMessageToControl = function (control, field) {
        this.formErrors[field] = {
            invalid: false,
            valid: true
        };
        if (!control.valid) {
            for (var key in control.errors) {
                if (!control.errors.hasOwnProperty(key)) {
                    continue;
                }
                this.formErrors[field] = __assign((_a = {}, _a[key] = true, _a.invalid = true, _a.valid = false, _a));
            }
        }
        var _a;
    };
    return Form;
}());

//# sourceMappingURL=form.js.map

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Option; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PaymentOption; });
var Option = (function () {
    function Option(name, value, icon, displayValue, error) {
        if (error === void 0) { error = false; }
        this.name = name;
        this.value = value;
        this.displayValue = displayValue;
        this.icon = icon;
        this.error = error;
    }
    return Option;
}());

var PaymentOption = (function () {
    function PaymentOption(value, display, icon) {
        this.value = value;
        this.display = display;
        this.icon = icon;
    }
    return PaymentOption;
}());

//# sourceMappingURL=dropdown-option-model.js.map

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductReviewModel; });
var ProductReviewModel = (function () {
    function ProductReviewModel(totalScore, totalTitle, totalNumberOfSubmit, ratings, uncommonThings, mysteriousThings, pest) {
        if (ratings === void 0) { ratings = []; }
        if (uncommonThings === void 0) { uncommonThings = []; }
        this.totalNumberOfSubmit = totalNumberOfSubmit;
        this.totalScore = totalScore;
        this.totalTitle = totalTitle;
        this.ratings = ratings;
        this.uncommonThings = uncommonThings;
        this.mysteriousThings = mysteriousThings;
        this.pest = pest;
    }
    return ProductReviewModel;
}());

//# sourceMappingURL=product-review.model.js.map

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_translation_lang_th__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_translation_lang_en__ = __webpack_require__(103);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslateSingularPluralPipe; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var TranslateSingularPluralPipe = (function () {
    function TranslateSingularPluralPipe(appConfigService) {
        this.appConfigService = appConfigService;
    }
    TranslateSingularPluralPipe.prototype.transform = function (value, args) {
        switch (this.appConfigService.getLanguage()) {
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["a" /* Language */].th:
                return __WEBPACK_IMPORTED_MODULE_3_translation_lang_th__["a" /* LANG_TH_TRANS */][value];
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["a" /* Language */].en:
                var txt = __WEBPACK_IMPORTED_MODULE_4_translation_lang_en__["a" /* LANG_EN_TRANS */][value];
                if (args > 1) {
                    if (value === 'booking-my-child') {
                        return __WEBPACK_IMPORTED_MODULE_4_translation_lang_en__["a" /* LANG_EN_TRANS */]['booking-my-children'];
                    }
                    else if (value === 'cart-child') {
                        return __WEBPACK_IMPORTED_MODULE_4_translation_lang_en__["a" /* LANG_EN_TRANS */]['cart-children'];
                    }
                    else if (value === 'checkout-1-max-child-title') {
                        return __WEBPACK_IMPORTED_MODULE_4_translation_lang_en__["a" /* LANG_EN_TRANS */]['checkout-1-max-children-title'];
                    }
                    else if (value === 'checkout-1-child-title') {
                        return __WEBPACK_IMPORTED_MODULE_4_translation_lang_en__["a" /* LANG_EN_TRANS */]['checkout-1-children-title'];
                    }
                    else if (value === 'booking-detail-details-child') {
                        return __WEBPACK_IMPORTED_MODULE_4_translation_lang_en__["a" /* LANG_EN_TRANS */]['booking-detail-details-children'];
                    }
                    txt = txt + 's';
                }
                return txt;
        }
    };
    return TranslateSingularPluralPipe;
}());
TranslateSingularPluralPipe = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
        name: 'translateSingularPlural',
        pure: false
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object])
], TranslateSingularPluralPipe);

var _a;
//# sourceMappingURL=translate-singular-plural.pipe.js.map

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ShareBudget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Booker; });
var ShareBudget = (function () {
    function ShareBudget(booker, coBooker) {
        this.booker = booker;
        this.coBooker = coBooker;
    }
    return ShareBudget;
}());

var Booker = (function () {
    function Booker(userId, companyId, email, amount, fullName, shareBudgetCode) {
        this.userId = userId;
        this.companyId = companyId;
        this.email = email;
        this.amount = amount;
        this.fullName = fullName;
        this.shareBudgetCode = shareBudgetCode;
    }
    return Booker;
}());

//# sourceMappingURL=dialog-share-budget.model.js.map

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OTP_STATE; });
var OTP_STATE = (function () {
    function OTP_STATE() {
    }
    return OTP_STATE;
}());

OTP_STATE.METHODS = 'methods';
OTP_STATE.OTP = 'otp';
OTP_STATE.SESSION_EXPIRE = 'session_expire';
;
//# sourceMappingURL=otp-state.js.map

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AllowFeature; });
var AllowFeature = (function () {
    function AllowFeature(required, display) {
        this.required = false;
        this.display = false;
        this.required = required;
        this.display = display;
    }
    return AllowFeature;
}());

//# sourceMappingURL=allow-feature.model.js.map

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_google_maps_api_wrapper__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_managers_info_marker_manager__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_maps_api_loader_maps_api_loader__ = __webpack_require__(106);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActInfoMarker; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




// tslint:disable
var ActInfoMarker = (function () {
    function ActInfoMarker(_wrapper, _manager, _loader) {
        this._wrapper = _wrapper;
        this._manager = _manager;
        this._loader = _loader;
        this.key = "Marker";
        this.keyCenter = 'center';
        this.placement = 'top';
        this.maxWidth = 200;
        this.maxHeight = 200;
        this.showCloseButton = false;
        this.panOnOpen = true;
        this.isFirstActive = false;
        this.enablePopOver = true;
        this.isPoi = false;
        this.isOpenChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.beforeOpen = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.afterClose = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onRenderMarkerComplete = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.isOpen = true;
        this.closeOnMapClick = false;
        this._infoMarkerInitialized = null;
    }
    ActInfoMarker.prototype.ngOnChanges = function (changes) {
        if (this._nativeInfoMarker == null) {
            return;
        }
        if ('isOpen' in changes && this.isOpen) {
            this._openInfoWindow();
        }
        else if ('isOpen' in changes && !this.isOpen) {
            this._closeInfoWindow();
        }
        if ('latitude' in changes || 'longitude' in changes) {
            this._updatePosition();
        }
        if ('isAllPopOverComplete' in changes && this.isAllPopOverComplete) {
            this._popOver = !this.isPoi && this._manager.getPopOver(this.key);
        }
    };
    ActInfoMarker.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.isPoi) {
            this.createPoiInfoMarker();
        }
        else {
            this.createInfoMarker();
        }
        setTimeout(function () {
            _this.onRenderMarkerComplete.emit(_this.key);
        }, 500);
    };
    ActInfoMarker.prototype.createInfoMarker = function () {
        var _this = this;
        this._infoMarkerInitialized = this._loader.load()
            .then(function () { return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 241)); })
            .then(function (module) { return Promise.all([module, null, _this._wrapper.getNativeMap()]); })
            .then(function (elems) {
            var options = {
                classPrefix: 'info-marker-',
                eventPrefix: 'info-marker-window-',
                map: elems[2],
                content: '',
                placement: _this.placement,
                maxWidth: _this.maxWidth,
                maxHeight: _this.maxHeight,
                backgroundColor: _this.backgroundColor,
                padding: _this.padding,
                border: _this.border,
                borderRadius: _this.borderRadius,
                fontColor: _this.fontColor,
                pointer: _this.pointer,
                shadow: false,
                closeOnMapClick: _this.closeOnMapClick,
                closeWhenOthersOpen: false,
                showCloseButton: false,
                isHandleBackground: true,
                panOnOpen: _this.panOnOpen,
                wrapperClass: _this.wrapperClass,
                callbacks: {
                    beforeOpen: function () {
                        _this._createViewContent();
                        _this.beforeOpen.emit();
                    },
                    afterOpen: function () {
                        _this.isFirstActive && _this.addActive();
                        _this.isOpenChange.emit(_this.openStatus());
                    },
                    afterClose: function () {
                        _this.afterClose.emit();
                        _this.isOpenChange.emit(_this.openStatus());
                    },
                    bgClicked: function () {
                        _this.addActive();
                        // const marker = this._manager.getMarker(this.keyCenter);
                        // this.isFirstActive && marker.removeActive();
                        _this.onClick.emit({ key: _this.key });
                        // this._popOver && this._popOver.togglePopOver();
                        _this.enablePopOver && _this._popOver && _this._popOver.openPopOver();
                    },
                    bgHoverEnter: function () {
                        // this.enablePopOver && this._popOver && this._popOver.openPopOver();
                    },
                    bgHoverLeave: function () {
                        // this._popOver && this._popOver.closePopOver();
                    }
                }
            };
            if (elems[1] != null) {
                options.marker = elems[1];
            }
            else {
                options.position = {
                    lat: _this.latitude,
                    lng: _this.longitude
                };
            }
            _this._nativeInfoMarker = new elems[0](options);
        });
        this._infoMarkerInitialized.then(function () {
            if (_this.isOpen) {
                _this._openInfoWindow();
            }
            _this._manager.addInfoMarker(_this.key, _this);
        });
    };
    ActInfoMarker.prototype.createPoiInfoMarker = function () {
        var _this = this;
        this._infoMarkerInitialized = this._loader.load()
            .then(function () { return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 241)); })
            .then(function (module) { return Promise.all([module, null, _this._wrapper.getNativeMap()]); })
            .then(function (elems) {
            var options = {
                classPrefix: 'info-marker-',
                eventPrefix: 'info-marker-window-',
                map: elems[2],
                content: '',
                placement: _this.placement,
                maxWidth: _this.maxWidth,
                maxHeight: _this.maxHeight,
                backgroundColor: 'transparent',
                padding: _this.padding,
                border: false,
                borderRadius: false,
                fontColor: _this.fontColor,
                pointer: false,
                shadow: false,
                closeOnMapClick: _this.closeOnMapClick,
                closeWhenOthersOpen: false,
                showCloseButton: false,
                isHandleBackground: true,
                panOnOpen: _this.panOnOpen,
                wrapperClass: _this.wrapperClass,
                callbacks: {
                    beforeOpen: function () {
                        _this._createViewContent();
                        _this.beforeOpen.emit();
                    },
                    afterOpen: function () {
                        _this.isFirstActive && _this.addActive();
                        _this.isOpenChange.emit(_this.openStatus());
                    },
                    afterClose: function () {
                        _this.afterClose.emit();
                        _this.isOpenChange.emit(_this.openStatus());
                    },
                    bgClicked: function () {
                        _this.addActive();
                        // const marker = this._manager.getMarker(this.keyCenter);
                        // this.isFirstActive && marker.removeActive();
                        _this.onClick.emit({ key: _this.key });
                        // this._popOver && this._popOver.togglePopOver();
                    },
                    bgHoverEnter: function () {
                        // this.enablePopOver && this._popOver && this._popOver.openPopOver();
                    },
                    bgHoverLeave: function () {
                        // this._popOver && this._popOver.closePopOver();
                    }
                }
            };
            if (elems[1] != null) {
                options.marker = elems[1];
            }
            else {
                options.position = {
                    lat: _this.latitude,
                    lng: _this.longitude
                };
            }
            _this._nativeInfoMarker = new elems[0](options);
        });
        this._infoMarkerInitialized.then(function () {
            if (_this.isOpen) {
                _this._openInfoWindow();
            }
            _this._manager.addInfoMarker(_this.key, _this);
        });
    };
    ActInfoMarker.prototype._openInfoWindow = function () {
        var _this = this;
        this._infoMarkerInitialized.then(function () {
            _this._createViewContent();
            _this._nativeInfoMarker.open();
        });
    };
    ActInfoMarker.prototype._closeInfoWindow = function () {
        var _this = this;
        this._infoMarkerInitialized.then(function () {
            _this._nativeInfoMarker.close();
        });
    };
    ActInfoMarker.prototype._createViewContent = function () {
        if (this._viewContainerRef.length === 1) {
            return;
        }
        var evr = this._viewContainerRef.createEmbeddedView(this._templateRef);
        this._nativeInfoMarker.setContent(this._outerWrapper.nativeElement);
        // we have to run this in a separate cycle.
        setTimeout(function () {
            evr.detectChanges();
        });
    };
    ActInfoMarker.prototype._updatePosition = function () {
        this._nativeInfoMarker.setPosition({
            lat: this.latitude,
            lng: this.longitude
        });
    };
    ActInfoMarker.prototype.openStatus = function () {
        return this._nativeInfoMarker && this._nativeInfoMarker.isOpen();
    };
    ActInfoMarker.prototype.getMap = function () {
        return this._nativeInfoMarker.map;
    };
    ActInfoMarker.prototype.addActive = function () {
        var _html = (this._nativeInfoMarker || { _html: undefined })._html;
        var contentWrapper = (_html || { contentWrapper: undefined }).contentWrapper;
        var classList = (contentWrapper || { classList: undefined }).classList;
        if (classList) {
            classList.add('-active');
        }
    };
    ActInfoMarker.prototype.removeActive = function () {
        var _html = (this._nativeInfoMarker || { _html: undefined })._html;
        var contentWrapper = (_html || { contentWrapper: undefined }).contentWrapper;
        var classList = (contentWrapper || { classList: undefined }).classList;
        if (classList) {
            classList.remove('-active');
        }
    };
    ActInfoMarker.prototype.ngOnDestroy = function () {
        if (this._nativeInfoMarker) {
            this._manager.deleteInfoMarker(this.key);
            this._nativeInfoMarker.destroy();
        }
    };
    ActInfoMarker.prototype.setActiveMarker = function (active) {
        active ? this.addActive() : this.removeActive();
    };
    return ActInfoMarker;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ActInfoMarker.prototype, "key", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActInfoMarker.prototype, "keyCenter", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActInfoMarker.prototype, "latitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActInfoMarker.prototype, "longitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActInfoMarker.prototype, "placement", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ActInfoMarker.prototype, "maxWidth", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ActInfoMarker.prototype, "maxHeight", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActInfoMarker.prototype, "backgroundColor", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActInfoMarker.prototype, "padding", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ActInfoMarker.prototype, "border", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActInfoMarker.prototype, "borderRadius", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActInfoMarker.prototype, "fontColor", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActInfoMarker.prototype, "fontSize", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ActInfoMarker.prototype, "pointer", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ActInfoMarker.prototype, "shadow", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActInfoMarker.prototype, "wrapperClass", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActInfoMarker.prototype, "showCloseButton", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActInfoMarker.prototype, "panOnOpen", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActInfoMarker.prototype, "isFirstActive", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActInfoMarker.prototype, "enablePopOver", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActInfoMarker.prototype, "isAllPopOverComplete", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActInfoMarker.prototype, "isPoi", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], ActInfoMarker.prototype, "isOpenChange", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
], ActInfoMarker.prototype, "beforeOpen", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
], ActInfoMarker.prototype, "afterClose", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _d || Object)
], ActInfoMarker.prototype, "onClick", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _e || Object)
], ActInfoMarker.prototype, "onRenderMarkerComplete", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('outerWrapper', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] }),
    __metadata("design:type", typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _f || Object)
], ActInfoMarker.prototype, "_outerWrapper", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('viewContainer', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] }),
    __metadata("design:type", typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]) === "function" && _g || Object)
], ActInfoMarker.prototype, "_viewContainerRef", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"])(__WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]),
    __metadata("design:type", typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]) === "function" && _h || Object)
], ActInfoMarker.prototype, "_templateRef", void 0);
ActInfoMarker = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-info-marker',
        template: "\n  <div id=\"outWrapper\" #outerWrapper>\n    <div style=\"display: none;\" #viewContainer>\n      <ng-content></ng-content>\n    </div>\n  </div>\n  "
    }),
    __metadata("design:paramtypes", [typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_1__services_google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__services_google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */]) === "function" && _j || Object, typeof (_k = typeof __WEBPACK_IMPORTED_MODULE_2__services_managers_info_marker_manager__["a" /* InfoMarkerManager */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_managers_info_marker_manager__["a" /* InfoMarkerManager */]) === "function" && _k || Object, typeof (_l = typeof __WEBPACK_IMPORTED_MODULE_3__services_maps_api_loader_maps_api_loader__["a" /* MapsAPILoader */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__services_maps_api_loader_maps_api_loader__["a" /* MapsAPILoader */]) === "function" && _l || Object])
], ActInfoMarker);

var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
//# sourceMappingURL=info-marker.js.map

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_file_saver__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_booking_booking_list_model__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_model_booking_booking_detail_model__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_booking_booking_status_model__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_Rx__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_services_products_product_service__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__angular_http__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_booking_detail_booking_detail_section__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_utilities_arrival_time_list__ = __webpack_require__(537);
/* unused harmony export EndBookingStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookingService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


















var EndBookingStatus;
(function (EndBookingStatus) {
    EndBookingStatus[EndBookingStatus["success"] = 0] = "success";
    EndBookingStatus[EndBookingStatus["fail"] = 1] = "fail";
})(EndBookingStatus || (EndBookingStatus = {}));
var BookingService = (function () {
    function BookingService(actHttp, utilities, userService, appConfigService, productService, translate) {
        this.actHttp = actHttp;
        this.utilities = utilities;
        this.userService = userService;
        this.appConfigService = appConfigService;
        this.productService = productService;
        this.translate = translate;
        this.interval = 5000;
        this.isViewBookingDetail = false;
    }
    BookingService.prototype.getBookingList = function (_a) {
        var lang = _a.lang, page = _a.page, limit = _a.limit, searchBy = _a.searchBy, filterBy = _a.filterBy, sortBy = _a.sortBy, orderBy = _a.orderBy;
        var options = this.actHttp.getRequestOptions();
        var url = "" + __WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.getBookingList +
            ("?lang=" + lang) +
            ("&page=" + page) +
            ("&limit=" + limit) +
            "&search=" + encodeURIComponent(searchBy) +
            ("&filter=" + filterBy) +
            ("&sort=" + sortBy) +
            ("&order=" + orderBy);
        return this.actHttp.get(url, options)
            .map(function (res) { return res.json(); });
    };
    BookingService.prototype.getBookingDetails = function (bookingId) {
        var options = this.actHttp.getRequestOptions();
        var url = __WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.getBookingDetails + "/" + bookingId + "?lang=" + this.appConfigService.getLanguage();
        return this.actHttp.get(url, options).map(function (res) { return res.json().data; });
    };
    BookingService.prototype.getBookingDetailsV2 = function (bookingId) {
        var options = this.actHttp.getRequestOptions();
        var url = __WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.getBookingDetails + "/" + bookingId + "?lang=" + this.appConfigService.getLanguage();
        return this.actHttp.get(url, options).map(function (res) { return res.json().data; });
    };
    BookingService.prototype.getBookingSuggestion = function (bookingId) {
        if (bookingId === void 0) { bookingId = ''; }
        return this.actHttp.get(__WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.getBookingSuggestion + "?bookingId=" + bookingId, this.actHttp.getRequestOptions())
            .map(function (res) { return res.json().data; });
    };
    BookingService.prototype.getBookingStatus = function (bookingId) {
        var options = this.actHttp.getRequestOptions();
        return this.actHttp.get(__WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.getBookingStatus.replace(':bookingId', bookingId), options).map(function (res) { return res.json().data; });
    };
    BookingService.prototype.getBookingVoucherPDF = function (bookingId) {
        var options = this.actHttp.getRequestOptions();
        options.responseType = __WEBPACK_IMPORTED_MODULE_14__angular_http__["f" /* ResponseContentType */].Blob;
        return this.actHttp.get(__WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.getBookingVoucherPDF + "/" + bookingId, options).map(function (res) {
            if (res.status === 200) {
                var _filename = 'VOUCHER-' + bookingId + '.pdf';
                __WEBPACK_IMPORTED_MODULE_0_file_saver__["saveAs"](res.blob(), _filename, true);
            }
        });
    };
    BookingService.prototype.getOldBookingPDF = function (bookingId) {
        var _linkPDF = "" + __WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.getOldBookingPDF;
        _linkPDF = _linkPDF.replace('{bookingID}', bookingId);
        window.open(_linkPDF);
    };
    BookingService.prototype.getBookingCancellationFee = function (bookingId) {
        var options = this.actHttp.getRequestOptions();
        return this.actHttp.get(__WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.getBookingCancellationFee.replace(':bookingId', bookingId), options)
            .map(function (res) { return res.json(); });
    };
    BookingService.prototype.cancelBooking = function (bookingId) {
        var options = this.actHttp.getRequestOptions();
        var payload = {
            'bookingId': bookingId
        };
        return this.actHttp.post("" + __WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.cancelBooking, payload, options)
            .map(function (res) { return res.json(); });
    };
    BookingService.prototype.sendBookingCancellation = function (bookingId) {
        return false;
    };
    BookingService.prototype.verifyStatusBooking = function (bookingStatus) {
        if (bookingStatus) {
            for (var key in EndBookingStatus) {
                if (bookingStatus.status === EndBookingStatus[key]) {
                    return true;
                }
            }
        }
        return false;
    };
    BookingService.prototype.getDiffDate = function (timeStamp) {
        var date = __WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__(timeStamp).format('YYYY-MM-DD');
        return __WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__(date).diff(__WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__().format('YYYY-MM-DD'), 'days');
    };
    BookingService.prototype.getDateDay = function (timeStamp) {
        if (typeof timeStamp === 'undefined') {
            return '';
        }
        var _timeStamp;
        if (this.utilities.isSafari() || this.utilities.isIOS()) {
            _timeStamp = timeStamp;
        }
        else {
            _timeStamp = new Date(timeStamp);
        }
        var lang = this.appConfigService.getLanguage();
        if (lang === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["a" /* Language */].en) {
            return __WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__(_timeStamp).locale(lang).add(7, 'hour').format('ddd');
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__(_timeStamp).locale(lang).add(7, 'hour').format('dddd');
        }
    };
    BookingService.prototype.getDateAndTimeFormat = function (timeStamp) {
        if (typeof timeStamp === 'undefined') {
            return '';
        }
        var lang = this.appConfigService.getLanguage();
        return __WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__(timeStamp).locale(lang).add(7, 'hour').format('dddd D MMMM YYYY HH:mm');
    };
    BookingService.prototype.calculateStatusBooking = function (orderStatus, checkoutDate) {
        var bookingStatus;
        switch (true) {
            // กำลังดำเนินการ
            case (orderStatus.orderStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].CREATE ||
                orderStatus.orderStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].PAID ||
                orderStatus.orderStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].BOOK):
                {
                    bookingStatus = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].ON_PROCESS;
                }
                break;
            // จ่ายเงินไม่สำเร็จ
            case (orderStatus.paymentStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].FAIL):
                {
                    bookingStatus = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].PAYMENT_FAIL;
                }
                break;
            // ทำรายการไม่สำเร็จ
            case (orderStatus.bookingStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].FAIL):
                {
                    bookingStatus = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].BOOKING_FAIL;
                }
                break;
            // ยกเลิกการจอง
            case (orderStatus.cancelStatus !== __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].NO ||
                orderStatus.bookingStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].CANCEL):
                {
                    bookingStatus = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].CANCEL;
                }
                break;
            // ชำระเงินเรียบร้อยแล้ว
            case (orderStatus.bookingStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].SUCCESS &&
                orderStatus.orderStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].SUCCESS &&
                orderStatus.paymentStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].SUCCESS &&
                (this.getDiffDate(checkoutDate) >= 0)):
                {
                    bookingStatus = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].PAYMENT_SUCCESS;
                }
                break;
            // เช็คเอ้าท์แล้ว
            case (orderStatus.bookingStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].SUCCESS &&
                orderStatus.orderStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].SUCCESS &&
                (orderStatus.paymentStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].SUCCESS
                    || orderStatus.paymentStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].PENDING) &&
                (this.getDiffDate(checkoutDate) < 0)):
                {
                    bookingStatus = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].DEPART;
                }
                break;
            // จองเรียบร้อบแล้ว
            case (orderStatus.bookingStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].SUCCESS &&
                orderStatus.orderStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["e" /* OrderStatus */].SUCCESS):
                {
                    bookingStatus = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].BOOKING_SUCCESS;
                }
                break;
        }
        return bookingStatus;
    };
    BookingService.prototype.transformToBookingStatusModel = function (data) {
        return new __WEBPACK_IMPORTED_MODULE_7__model_booking_booking_status_model__["a" /* BookingStatusModel */](data.orderStatus, data.paymentStatus, data.bookStatus, data.cancelStatus);
    };
    BookingService.prototype.fetchBookingStatus = function (bookingId, interval, timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 10e3; }
        return __WEBPACK_IMPORTED_MODULE_9_rxjs_Rx__["Observable"].interval(interval)
            .timeout(timeout)
            .take(5)
            .flatMap(function (intervalIndex) {
            return _this.getBookingStatus(bookingId)
                .catch(function (error) {
                console.log('catch error', error);
                return __WEBPACK_IMPORTED_MODULE_9_rxjs_Rx__["Observable"].empty();
            });
        })
            .flatMap(function (bookingStatus) {
            return __WEBPACK_IMPORTED_MODULE_9_rxjs_Rx__["Observable"].of(_this.verifyStatusBooking(bookingStatus));
        });
    };
    BookingService.prototype.getBookingStatusWithExpectStatus = function (expectStatus, bookingId, interval, timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 10e3; }
        return __WEBPACK_IMPORTED_MODULE_9_rxjs_Rx__["Observable"].interval(interval)
            .timeout(timeout)
            .take(5)
            .flatMap(function (intervalIndex) {
            return _this.getBookingStatus(bookingId)
                .map(function (res) { return !!expectStatus.find(function (item) { return item === res.status; }); })
                .catch(function (error) {
                console.log('catch error', error);
                return __WEBPACK_IMPORTED_MODULE_9_rxjs_Rx__["Observable"].empty();
            });
        });
    };
    BookingService.prototype.getRoomTypes = function (bookingProductItems) {
        var _productItems = [];
        bookingProductItems.map(function (item, i) {
            item.guests.map(function (guest, j) {
                var _productItem = JSON.parse(JSON.stringify(item));
                _productItem.guests = [guest];
                _productItems.push(_productItem);
            });
        });
        return _productItems;
    };
    BookingService.prototype.canCancelBooking = function (bookingStatus, date) {
        var statusCanCancel = bookingStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].BOOKING_SUCCESS
            || bookingStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].PAYMENT_SUCCESS
            || bookingStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].WAITING_FOR_APPROVE
            || bookingStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].APPROVE;
        return statusCanCancel && (this.getDiffDate(date) > 0);
    };
    BookingService.prototype.transformBookingListData = function (booking) {
        var dayFormat = 'dd';
        var dateFormat = 'D';
        var monthYearFormat = 'MMM YY';
        var shortDateFormat = 'D MMM YY';
        var longDateFormat = 'dd D MMM YY';
        var bookingDateFormat = 'D MMMM YYYY';
        var bookingTimeFormat = 'HH:mm';
        var transformData = new __WEBPACK_IMPORTED_MODULE_3_app_model_booking_booking_list_model__["a" /* DisplayBookingListDTO */]();
        transformData.productTitle = booking.hotelName ? this.productService.formatDisplayTitle(booking.hotelName) : '';
        transformData.address = booking.hotelAddress ? this.productService.formatDisplayTitle(booking.hotelAddress) : '';
        transformData.dateOrder = booking.bookingDate ? this.utilities.convertDateFormat(booking.bookingDate, null, bookingDateFormat) : '';
        transformData.timeOrder = booking.bookingDate ? this.utilities.convertDateFormat(booking.bookingDate, null, bookingTimeFormat) : '';
        transformData.payOnDate = booking.payOnDate ? this.utilities.convertDateFormat(booking.payOnDate, null, shortDateFormat) : '';
        transformData.approvalDate = booking.approvalDate ? this.utilities.convertDateFormat(booking.approvalDate, null, shortDateFormat) : '';
        transformData.cancellationDate = booking.cancelDate ? this.utilities.convertDateFormat(booking.cancelDate, null, shortDateFormat) : '';
        transformData.dayCheckin = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, dayFormat) : '';
        transformData.dateCheckin = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, dateFormat) : '';
        transformData.monthYearCheckin = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, monthYearFormat) : '';
        transformData.longDateCheckin = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, longDateFormat) : '';
        transformData.dayCheckout = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, dayFormat) : '';
        transformData.dateCheckout = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, dateFormat) : '';
        transformData.monthYearCheckout = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, monthYearFormat) : '';
        transformData.longDateCheckout = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, longDateFormat) : '';
        transformData.ratingStar = booking.hotelStar ? this.utilities.indexToArray(booking.hotelStar) : [];
        transformData.isReviewPublished = !!booking.reviewSubmitDate;
        transformData.reviewUrl = !booking.reviewSubmitDate && booking.reviewToken ? this.generateReviewUrl(booking.reviewToken) : null;
        transformData.totalRoom = booking.quantity;
        transformData.totalAdult = booking.adult;
        transformData.totalChild = booking.child;
        return transformData;
    };
    BookingService.prototype.transformBookingDetailsData = function (booking) {
        var formatDateInt = 'YYYY-MM-DD HH:mm:ss';
        var formatDateString = 'D MMM YYYY HH:mm:ss';
        var dayFormat = this.appConfigService.getLanguage() === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["a" /* Language */].th ? 'dddd' : 'ddd';
        var transformData = new __WEBPACK_IMPORTED_MODULE_4_app_model_booking_booking_detail_model__["a" /* DisplayBookingDetailDTO */]();
        transformData.productName = booking.productName ? this.productService.formatDisplayTitle(booking.productName) : '';
        transformData.productAddress = booking.productAddress ? this.productService.formatDisplayTitle(booking.productAddress) : '';
        transformData.ratingStar = booking.ratingStar ? this.utilities.indexToArray(booking.ratingStar) : [];
        transformData.orderDate = booking.dateOrder ? this.utilities.convertDateFormat(booking.dateOrder) : '';
        transformData.orderTime = booking.dateOrder ? this.utilities.convertDateFormat(booking.dateOrder, formatDateInt, 'HH:mm') : '';
        transformData.dateTimeToPay = booking.dateTimeToPay ? this.utilities.convertDateFormat(booking.dateTimeToPay, formatDateString) : '';
        transformData.paymentDate = booking.paymentDate ? this.utilities.convertDateFormat(booking.paymentDate, formatDateString) : '';
        transformData.cancelDate = booking.cancellationDate ? this.utilities.convertDateFormat(booking.cancellationDate, formatDateString) : '';
        transformData.cancellationCharge = booking.cancellationFee ? (+booking.cancellationFee).toFixed(2) : '';
        transformData.refund = booking.totalPrice && booking.cancellationFee ? ((+booking.totalPrice) - (+booking.cancellationFee)).toFixed(2) : '';
        transformData.dayCheckIn = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, formatDateString, dayFormat) : '';
        transformData.checkInDate = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, formatDateString) : '';
        transformData.dayCheckOut = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, formatDateString, dayFormat) : '';
        transformData.checkOutDate = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, formatDateString) : '';
        return transformData;
    };
    BookingService.prototype.transformMyBookingDetailsData = function (booking) {
        var dayFormat = this.appConfigService.getLanguage() === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["a" /* Language */].th ? 'dddd' : 'ddd';
        var transformData = new __WEBPACK_IMPORTED_MODULE_4_app_model_booking_booking_detail_model__["a" /* DisplayBookingDetailDTO */]();
        transformData.productName = booking.hotelInformation.name ? this.productService.formatDisplayTitle(booking.hotelInformation.name) : '';
        transformData.productAddress = booking.hotelInformation.address ? this.productService.formatDisplayTitle(booking.hotelInformation.address) : '';
        transformData.ratingStar = booking.hotelInformation.star ? this.utilities.indexToArray(booking.hotelInformation.star) : [];
        transformData.orderDate = booking.bookingDate ? this.utilities.convertDateFormat(booking.bookingDate) : '';
        transformData.orderTime = booking.bookingDate ? this.utilities.convertDateFormat(booking.bookingDate, null, 'HH:mm') : '';
        transformData.dateTimeToPay = booking.payOnDate ? this.utilities.convertDateFormat(booking.payOnDate, null) : '';
        transformData.cancelDate = booking.cancellationCharge && booking.cancellationCharge.cancelDate ? this.utilities.convertDateFormat(booking.cancellationCharge.cancelDate, null) : '';
        transformData.cancellationCharge = booking.cancellationCharge && booking.cancellationCharge.cancellationFee ? booking.cancellationCharge.cancellationFee.toString() : '0';
        transformData.refund = booking.cancellationCharge && booking.cancellationCharge.refundAmount ? booking.cancellationCharge.refundAmount.toString() : '0';
        transformData.dayCheckIn = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, dayFormat) : '';
        transformData.checkInDate = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null) : '';
        transformData.dayCheckOut = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, dayFormat) : '';
        transformData.checkOutDate = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null) : '';
        transformData.phone = booking.hotelInformation.phone ? booking.hotelInformation.phone : '';
        return transformData;
    };
    BookingService.prototype.transformMyBookingDetailsDataV2 = function (hotelInformation) {
        var transformData = new __WEBPACK_IMPORTED_MODULE_4_app_model_booking_booking_detail_model__["a" /* DisplayBookingDetailDTO */]();
        transformData.productName = hotelInformation.name ? this.productService.formatDisplayTitle(hotelInformation.name) : '';
        transformData.productAddress = hotelInformation.address ? this.productService.formatDisplayTitle(hotelInformation.address) : '';
        transformData.ratingStar = hotelInformation.star ? this.utilities.indexToArray(hotelInformation.star) : [];
        transformData.phone = hotelInformation.phone ? hotelInformation.phone : '';
        return transformData;
    };
    BookingService.prototype.transformApprovalDetailsData = function (booking) {
        var dayFormat = this.appConfigService.getLanguage() === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["a" /* Language */].th ? 'dddd' : 'ddd';
        var transformData = new __WEBPACK_IMPORTED_MODULE_4_app_model_booking_booking_detail_model__["a" /* DisplayBookingDetailDTO */]();
        transformData.productName = booking.hotelInformation.name ? this.productService.formatDisplayTitle(booking.hotelInformation.name) : '';
        transformData.productAddress = booking.hotelInformation.address ? this.productService.formatDisplayTitle(booking.hotelInformation.address) : '';
        transformData.ratingStar = booking.hotelInformation.star ? this.utilities.indexToArray(booking.hotelInformation.star) : [];
        transformData.orderDate = booking.bookingDate ? this.utilities.convertDateFormat(booking.bookingDate) : '';
        transformData.orderTime = booking.bookingDate ? this.utilities.convertDateFormat(booking.bookingDate, null, 'HH:mm') : '';
        transformData.dateTimeToPay = booking.bookingPayment && booking.bookingPayment.payOnDate ? this.utilities.convertDateFormat(booking.bookingPayment.payOnDate, null) : '';
        transformData.cancelDate = booking.bookingCancellationCharge && booking.bookingCancellationCharge.cancelDate
            ? this.utilities.convertDateFormat(booking.bookingCancellationCharge.cancelDate, null) : '';
        transformData.cancellationCharge = booking.bookingCancellationCharge && booking.bookingCancellationCharge.cancellationFee
            ? booking.bookingCancellationCharge.cancellationFee.toString() : '0';
        if (this.utilities.isMobile()) {
            transformData.dayCheckIn = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, 'dd') : '';
            transformData.dayCheckOut = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, 'dd') : '';
            transformData.checkOutDate = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, 'D MMM YYYY') : '';
            transformData.checkInDate = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, 'D MMM YYYY') : '';
        }
        else {
            transformData.dayCheckIn = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, dayFormat) : '';
            transformData.dayCheckOut = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, dayFormat) : '';
            transformData.checkOutDate = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null) : '';
            transformData.checkInDate = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null) : '';
        }
        return transformData;
    };
    BookingService.prototype.getSortByWithFilter = function (filter) {
        var sortBy = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["g" /* SortByType */].checkinDate;
        switch (filter) {
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["h" /* FilterByType */].all:
                sortBy = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["g" /* SortByType */].bookingDate;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["h" /* FilterByType */].upComing:
                sortBy = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["g" /* SortByType */].checkinDate;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["h" /* FilterByType */].checkin:
                sortBy = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["g" /* SortByType */].checkinDate;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["h" /* FilterByType */].departed:
                sortBy = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["g" /* SortByType */].bookingDate;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["h" /* FilterByType */].cancelled:
                sortBy = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["g" /* SortByType */].bookingDate;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["h" /* FilterByType */].failed:
                sortBy = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["g" /* SortByType */].bookingDate;
                break;
        }
        return sortBy;
    };
    BookingService.prototype.getOrderByWithFilter = function (filter) {
        var orderBy = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["i" /* OrderByType */].descending;
        if (filter === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["h" /* FilterByType */].upComing || filter === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["h" /* FilterByType */].checkin) {
            orderBy = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["i" /* OrderByType */].ascending;
        }
        return orderBy;
    };
    BookingService.prototype.calculateApprovalStatus = function (bookingStatus, bookingApproval) {
        switch (bookingStatus) {
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].BOOKING_SUCCESS:
                if (bookingApproval.approvalStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["j" /* ApprovalStatusType */].PENDING && !bookingApproval.updateBy) {
                    return __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].WAITING_FOR_APPROVE;
                }
                else if (bookingApproval.approvalStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["j" /* ApprovalStatusType */].APPROVE && bookingApproval.updateBy === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["k" /* ApprovalUpdateByType */].SUPERVISOR) {
                    return __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].APPROVE;
                }
                else if (bookingApproval.approvalStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["j" /* ApprovalStatusType */].REJECT && bookingApproval.updateBy === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["k" /* ApprovalUpdateByType */].SUPERVISOR) {
                    return __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].REJECT;
                }
                else {
                    return bookingStatus;
                }
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].CANCEL:
                if (bookingApproval.approvalStatus === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["j" /* ApprovalStatusType */].REJECT) {
                    return __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */].REJECT;
                }
                else {
                    return bookingStatus;
                }
            default:
                return bookingStatus;
        }
    };
    BookingService.prototype.getAccuredReport = function (from, to) {
        var options = this.actHttp.getRequestOptions();
        return this.actHttp.get("" + __WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.getBookingReport +
            ("?from=" + from) +
            ("&to=" + to), options)
            .map(function (res) {
            return res.json().data;
        });
    };
    BookingService.prototype.downloadReport = function (downloadReportId, interval, timeout, take) {
        var _this = this;
        if (interval === void 0) { interval = 5000; }
        if (timeout === void 0) { timeout = 10000; }
        if (take === void 0) { take = 180; }
        return __WEBPACK_IMPORTED_MODULE_9_rxjs_Rx__["Observable"].interval(interval)
            .timeout(timeout)
            .take(take)
            .flatMap(function (intervalIndex) {
            return _this.getReportUrl(downloadReportId)
                .catch(function (err) {
                if (intervalIndex == take - 1) {
                    throw __WEBPACK_IMPORTED_MODULE_9_rxjs_Rx__["Observable"].throw(err);
                }
                var errors = err.json().errors;
                if (errors[0].code == '5008') {
                    throw __WEBPACK_IMPORTED_MODULE_9_rxjs_Rx__["Observable"].throw(err);
                }
                return __WEBPACK_IMPORTED_MODULE_9_rxjs_Rx__["Observable"].empty();
            });
        }).map(function (res) {
            window.location.href = res.url;
            return true;
        });
    };
    BookingService.prototype.getReportUrl = function (downloadReportId) {
        var url = __WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.getBookingReportUrl + "?downloadReportId=" + downloadReportId;
        var options = this.actHttp.getRequestOptions();
        return this.actHttp.get(url, options).map(function (res) { return res.json().data; });
    };
    BookingService.prototype.transformFreeCancellationMsg = function (freeCancellationDate) {
        return freeCancellationDate ? this.translate
            .transform('product-detail-room-cancellation-free')
            .replace('{date}', this.utilities.convertDateFormat(freeCancellationDate, null, 'D MMM YYYY')) : null;
    };
    BookingService.prototype.getBookingStatusType = function (status) {
        for (var bookingStatus in __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */]) {
            if (__WEBPACK_IMPORTED_MODULE_2_app_model_constant__["f" /* BookingStatusType */][bookingStatus] === status) {
                return bookingStatus;
            }
        }
        return null;
    };
    BookingService.prototype.generateReviewUrl = function (token) {
        return '/rating?data=' + this.utilities.base64Encoder('{"token":"' + token + '","email":"' + this.userService.getUser().username + '"}') +
            '&lang=' + this.appConfigService.getLanguage();
    };
    BookingService.prototype.downloadDocument = function (request) {
        var _this = this;
        var options = this.actHttp.getRequestOptions();
        options.responseType = __WEBPACK_IMPORTED_MODULE_14__angular_http__["f" /* ResponseContentType */].Blob;
        var url = "" + __WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.downloadDocument;
        return this.actHttp.post(url, request, options).map(function (res) {
            if (res.status === 200) {
                __WEBPACK_IMPORTED_MODULE_0_file_saver__["saveAs"](res.blob(), _this.utilities.extractFileName(res.headers.get('Content-Disposition'), '='), true);
                return true;
            }
        });
    };
    BookingService.prototype.getLinkDownloadDocument = function (request) {
        var options = this.actHttp.getRequestOptions();
        options.responseType = __WEBPACK_IMPORTED_MODULE_14__angular_http__["f" /* ResponseContentType */].Blob;
        var url = "" + __WEBPACK_IMPORTED_MODULE_13__environments_environment__["a" /* environment */].endpoint.downloadDocument;
        return this.actHttp.post(url, request, options).map(function (res) {
            if (res.status === 200) {
                var fileURL = URL.createObjectURL(new Blob([res.blob()], { type: 'application/pdf' }));
                return fileURL;
            }
        });
    };
    BookingService.prototype.prepareBookingInfoSection = function (myBookingDetail) {
        var prep = new __WEBPACK_IMPORTED_MODULE_16__components_booking_detail_booking_detail_section__["a" /* BookingInfoSection */]();
        prep.bookingId = myBookingDetail.bookingId;
        prep.wsReference = myBookingDetail.wsReference;
        prep.checkIn = new __WEBPACK_IMPORTED_MODULE_16__components_booking_detail_booking_detail_section__["b" /* OperationDateTime */](myBookingDetail.checkInDate, myBookingDetail.checkInTimeFrom, myBookingDetail.checkInTimeUntil);
        prep.checkOut = new __WEBPACK_IMPORTED_MODULE_16__components_booking_detail_booking_detail_section__["b" /* OperationDateTime */](myBookingDetail.checkOutDate, myBookingDetail.checkOutTimeFrom, myBookingDetail.checkOutTimeUntil);
        prep.periodOfStay = this.calNight(myBookingDetail.checkInDate, myBookingDetail.checkOutDate);
        prep.roomAmount = myBookingDetail.roomTypes.length;
        if (myBookingDetail.limitOccupancy && myBookingDetail.limitOccupancy.length > 0) {
            prep.occupancyInfo = this.createTotalMaxGuestAmountLimitOccupancy(myBookingDetail.limitOccupancy);
            prep.maxGuest = this.createTotalMaxGuestAmount(myBookingDetail.roomTypes);
        }
        else {
            prep.occupancyInfo = prep.maxGuest = this.createTotalMaxGuestAmount(myBookingDetail.roomTypes);
        }
        prep.bookingDate = this.utilities.convertDateFormat(myBookingDetail.bookingDate, null, 'D MMMM YYYY');
        prep.bookingTime = this.utilities.convertDateFormat(myBookingDetail.bookingDate, null, 'HH:mm');
        return prep;
    };
    BookingService.prototype.prepareRoomDetailSection = function (myBookingDetail, showcancellationPolicies) {
        var _this = this;
        if (showcancellationPolicies === void 0) { showcancellationPolicies = false; }
        var result = [];
        myBookingDetail.roomTypes.forEach(function (room) {
            var prep = new __WEBPACK_IMPORTED_MODULE_16__components_booking_detail_booking_detail_section__["c" /* RoomDetailSection */]();
            prep.roomTypeName = room.roomTypeName;
            prep.night = _this.calNight(myBookingDetail.checkInDate, myBookingDetail.checkOutDate);
            prep.maxGuest = _this.createTotalMaxGuestAmount([room]);
            prep.guest = room.guests;
            if (myBookingDetail.arrivalTime) {
                var arrivalTimeKeyTranslate = __WEBPACK_IMPORTED_MODULE_17_app_utilities_arrival_time_list__["a" /* arrivalTimeList */].find(function (arrivalTime) { return arrivalTime.value === myBookingDetail.arrivalTime; }).keyTranslate;
                prep.specialRequest = _this.translate.transform('booking-detail-arrival-time') + " : " + _this.translate.transform(arrivalTimeKeyTranslate);
                if (room.specialRequest) {
                    prep.specialRequest += ', ' + room.specialRequest;
                }
            }
            else {
                prep.specialRequest = room.specialRequest;
            }
            prep.offerType = room.offerTypeName;
            prep.offerTypeDisplay = room.offerTypeDisplay;
            prep.benefits = room.benefits;
            prep.freeCancellationDate = room.freeCancellationDate;
            prep.price = room.price;
            prep.currencyCode = myBookingDetail.bookingPayment.currencyCode;
            prep.showcancellationPolicies = showcancellationPolicies;
            prep.cancellationPolicies = room.cancellationPolicies;
            result.push(prep);
        });
        return result;
    };
    BookingService.prototype.prepareBookersInfoSection = function (myBookingDetail) {
        var _this = this;
        var result = [];
        myBookingDetail.bookerInformation.forEach(function (booker) {
            var prep = new __WEBPACK_IMPORTED_MODULE_16__components_booking_detail_booking_detail_section__["d" /* BookerInfoSection */]();
            prep.mainBooker = booker.mainBooker;
            prep.fullName = booker.fullName;
            prep.phone = booker.phone;
            prep.email = booker.email;
            if (booker.creditTermsInformation) {
                prep.creditTermsInfo = booker.creditTermsInformation.taxAddressInformation ? booker.creditTermsInformation.taxAddressInformation : null;
                if (booker.creditTermsInformation.bookingApproval) {
                    prep.approval = booker.creditTermsInformation.bookingApproval;
                }
            }
            if (booker.creditCardInformation) {
                prep.creditCardInfo = booker.creditCardInformation.taxAddressInformation ? booker.creditCardInformation.taxAddressInformation : null;
            }
            if (booker.trueMoneyInformation) {
                prep.trueMoneyInfo = booker.trueMoneyInformation.taxAddressInformation ? booker.trueMoneyInformation.taxAddressInformation : null;
            }
            if (booker.qrCodeInformation) {
                prep.qrCodeInfo = booker.qrCodeInformation.taxAddressInformation ? booker.qrCodeInformation.taxAddressInformation : null;
            }
            if (booker.eWalletInformation) {
                prep.eWalletInfo = booker.eWalletInformation.taxAddressInformation ? booker.eWalletInformation.taxAddressInformation : null;
            }
            if (booker.imBankingInformation) {
                prep.imBankingInfo = booker.imBankingInformation.taxAddressInformation ? booker.imBankingInformation.taxAddressInformation : null;
            }
            if (booker.payAtCounterInformation) {
                prep.payAtCounterInfo = booker.payAtCounterInformation.taxAddressInformation ? booker.payAtCounterInformation.taxAddressInformation : null;
            }
            prep.paymentChannel = _this.calculatePaymentChannel(myBookingDetail.bookingPayment.paymentMethod);
            if (booker.checkoutFields) {
                prep.checkoutFields = booker.checkoutFields.length > 0 ? booker.checkoutFields : null;
            }
            result.push(prep);
        });
        return result;
    };
    BookingService.prototype.calculatePaymentChannel = function (paymentStringFromMyBookingDetail) {
        var paymentChannel = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["l" /* PaymentChannelType */].CREDIT_TERMS;
        switch (paymentStringFromMyBookingDetail) {
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["m" /* PaymentMethodDetailType */].MULTI_PAYMENT:
                paymentChannel = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["l" /* PaymentChannelType */].MULTI_PAYMENT;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_CARD:
                paymentChannel = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["l" /* PaymentChannelType */].CREDIT_CARD;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["m" /* PaymentMethodDetailType */].TRUE_MONEY:
                paymentChannel = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["l" /* PaymentChannelType */].TRUE_MONEY;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["m" /* PaymentMethodDetailType */].CORPORATE_FLEET:
                paymentChannel = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["l" /* PaymentChannelType */].CORPORATE_FLEET;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["m" /* PaymentMethodDetailType */].PERSONAL_FLEET:
                paymentChannel = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["l" /* PaymentChannelType */].PERSONAL_FLEET;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["m" /* PaymentMethodDetailType */].QR_CODE:
                paymentChannel = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["l" /* PaymentChannelType */].QR_CODE;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["m" /* PaymentMethodDetailType */].E_WALLET:
                paymentChannel = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["l" /* PaymentChannelType */].E_WALLET;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["m" /* PaymentMethodDetailType */].IM_BANKING:
                paymentChannel = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["l" /* PaymentChannelType */].IM_BANKING;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["m" /* PaymentMethodDetailType */].PAY_AT_COUNTER:
                paymentChannel = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["l" /* PaymentChannelType */].PAY_AT_COUNTER;
                break;
            default:
                break;
        }
        return paymentChannel;
    };
    BookingService.prototype.calculateRefundType = function (totalPrice, cancellationFee) {
        if (totalPrice == cancellationFee) {
            return __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["n" /* RefundType */].NON_REFUND;
        }
        else if (cancellationFee == 0) {
            return __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["n" /* RefundType */].FULL_REFUND;
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["n" /* RefundType */].PARTIAL_REFUND;
        }
    };
    BookingService.prototype.calNight = function (checkinDate, checkOutDate) {
        var date1 = new Date(checkinDate);
        var date2 = new Date(checkOutDate);
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    };
    BookingService.prototype.createTotalMaxGuestAmount = function (rooms) {
        var adult = 0;
        var child = 0;
        rooms.forEach(function (room) {
            adult += room.maxAdult;
            child += room.maxChild;
        });
        return new __WEBPACK_IMPORTED_MODULE_16__components_booking_detail_booking_detail_section__["e" /* GuestAmount */](adult, child);
    };
    BookingService.prototype.createTotalMaxGuestAmountLimitOccupancy = function (rooms) {
        var adult = 0;
        var child = 0;
        var childrenAge = [];
        rooms.forEach(function (room) {
            adult += room.adult;
            child += room.children;
            childrenAge = childrenAge.concat(room.childrenAge);
        });
        childrenAge.sort(function (a, b) { return a - b; });
        return new __WEBPACK_IMPORTED_MODULE_16__components_booking_detail_booking_detail_section__["e" /* GuestAmount */](adult, child, childrenAge);
    };
    return BookingService;
}());
BookingService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_5__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_12_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_12_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_11_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_11_app_services_user_user_service__["a" /* UserService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_10_app_services_products_product_service__["a" /* ProductService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_10_app_services_products_product_service__["a" /* ProductService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_15_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_15_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _f || Object])
], BookingService);

var _a, _b, _c, _d, _e, _f;
//# sourceMappingURL=booking.service.js.map

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Checkout3Config; });
/* unused harmony export Checkout3ConfigField */
/* unused harmony export CheckoutConfig */
/* unused harmony export DropdownConfig */
/* unused harmony export CostCenterDropdownItem */
/* unused harmony export InternalOrderConfig */
/* unused harmony export InternalOrderDropdownItem */
/* unused harmony export AttachmentConfig */
/* unused harmony export FeatureItem */
/* unused harmony export PaymentChannelItem */
/* unused harmony export Paymentable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentChannelCheckout; });
/* unused harmony export MultiPaymentInfo */
/* unused harmony export CreditTermsAmount */
/* unused harmony export CheckOut3SubmitData */
/* unused harmony export UploadBookingDocumentResponse */

var Checkout3Config = (function () {
    function Checkout3Config() {
    }
    return Checkout3Config;
}());

var Checkout3ConfigField = (function () {
    function Checkout3ConfigField() {
    }
    return Checkout3ConfigField;
}());

var CheckoutConfig = (function () {
    function CheckoutConfig() {
        this.disabled = false;
    }
    return CheckoutConfig;
}());

var DropdownConfig = (function () {
    function DropdownConfig() {
    }
    return DropdownConfig;
}());

var CostCenterDropdownItem = (function () {
    function CostCenterDropdownItem() {
    }
    return CostCenterDropdownItem;
}());

var InternalOrderConfig = (function () {
    function InternalOrderConfig() {
        this.internalOrderDropdown = [];
    }
    return InternalOrderConfig;
}());

var InternalOrderDropdownItem = (function () {
    function InternalOrderDropdownItem() {
    }
    return InternalOrderDropdownItem;
}());

var AttachmentConfig = (function () {
    function AttachmentConfig() {
    }
    return AttachmentConfig;
}());

var FeatureItem = (function () {
    function FeatureItem() {
    }
    return FeatureItem;
}());

var PaymentChannelItem = (function () {
    function PaymentChannelItem(paymentChannelName, title, subTitle, icon, mainBookerPayment) {
        this.hide = true;
        this.default = false;
        this.disable = false;
        this.paymentChannelName = paymentChannelName;
        this.title = title;
        this.subTitle = subTitle;
        this.mainBookerPayment = mainBookerPayment;
        this.icon = icon;
    }
    return PaymentChannelItem;
}());

var Paymentable = (function () {
    function Paymentable() {
    }
    return Paymentable;
}());

var PaymentChannelCheckout = (function () {
    function PaymentChannelCheckout() {
        this.MULTI_PAYMENT = new PaymentChannelItem(__WEBPACK_IMPORTED_MODULE_0__constant__["l" /* PaymentChannelType */].MULTI_PAYMENT, 'payment-channel-type-multi-payment', undefined, 'icon-card-add', [__WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].creditTerm, __WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].creditCard, __WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].trueMoneyWallet, __WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].fleetCard, __WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].corporateFleet, __WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].personalFleet]);
        this.CREDIT_TERMS = new PaymentChannelItem(__WEBPACK_IMPORTED_MODULE_0__constant__["l" /* PaymentChannelType */].CREDIT_TERMS, 'payment-channel-type-credit-terms', undefined, 'icon-credit-terms', [__WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].creditTerm]);
        this.CREDIT_CARD = new PaymentChannelItem(__WEBPACK_IMPORTED_MODULE_0__constant__["l" /* PaymentChannelType */].CREDIT_CARD, 'payment-channel-type-credit-card', 'payment-channel-type-personal-payment', 'icon-debit-card', [__WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].creditCard]);
        this.PERSONAL_FLEET = new PaymentChannelItem(__WEBPACK_IMPORTED_MODULE_0__constant__["l" /* PaymentChannelType */].PERSONAL_FLEET, 'payment-channel-type-personal-fleet', 'บัตรฟลีทส่วนตัว', 'icon-fleet-card', [__WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].fleetCard]);
        this.CORPORATE_FLEET = new PaymentChannelItem(__WEBPACK_IMPORTED_MODULE_0__constant__["l" /* PaymentChannelType */].CORPORATE_FLEET, 'payment-channel-type-corporate-fleet', undefined, 'icon-fleet-card', [__WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].fleetCard]);
        this.FLEET_CARD = new PaymentChannelItem(__WEBPACK_IMPORTED_MODULE_0__constant__["l" /* PaymentChannelType */].FLEET_CARD, 'payment-channel-type-fleet-card', undefined, 'icon-fleet-card', [__WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].fleetCard]);
        this.TRUE_MONEY_WALLET = new PaymentChannelItem(__WEBPACK_IMPORTED_MODULE_0__constant__["l" /* PaymentChannelType */].TRUE_MONEY, 'payment-channel-type-true-money', 'payment-channel-type-personal-payment', '', [__WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].trueMoneyWallet]);
        this.QR_CODE = new PaymentChannelItem(__WEBPACK_IMPORTED_MODULE_0__constant__["l" /* PaymentChannelType */].QR_CODE, 'payment-channel-type-qr-code', 'payment-channel-type-personal-payment', 'icon-qr-code', [__WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].qrCode]);
        this.E_WALLET = new PaymentChannelItem(__WEBPACK_IMPORTED_MODULE_0__constant__["l" /* PaymentChannelType */].E_WALLET, 'payment-channel-type-e-wallet', 'payment-channel-type-personal-payment', '', [__WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].eWallet]);
        this.IM_BANKING = new PaymentChannelItem(__WEBPACK_IMPORTED_MODULE_0__constant__["l" /* PaymentChannelType */].IM_BANKING, 'payment-channel-type-im-banking', 'payment-channel-type-personal-payment', 'icon-im-banking', [__WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].imBanking]);
        this.PAY_AT_COUNTER = new PaymentChannelItem(__WEBPACK_IMPORTED_MODULE_0__constant__["l" /* PaymentChannelType */].PAY_AT_COUNTER, 'payment-channel-type-pay-at-counter', 'payment-channel-type-personal-payment', 'icon-pay-at-counter', [__WEBPACK_IMPORTED_MODULE_0__constant__["E" /* PaymentMethodType */].payAtCounter]);
    }
    PaymentChannelCheckout.prototype.getPaymentable = function () {
        var _this = this;
        return {
            mainBookerEmail: this.mainBookerEmail,
            paymentChannels: Object.keys(this).filter(function (i) { return i !== 'mainBookerEmail'; }).map(function (i) { return _this[i]; }),
            isOverBudget: this.isOverBudget
        };
    };
    return PaymentChannelCheckout;
}());

var MultiPaymentInfo = (function () {
    function MultiPaymentInfo() {
    }
    return MultiPaymentInfo;
}());

var CreditTermsAmount = (function () {
    function CreditTermsAmount() {
    }
    return CreditTermsAmount;
}());

var CheckOut3SubmitData = (function () {
    function CheckOut3SubmitData() {
    }
    return CheckOut3SubmitData;
}());

var UploadBookingDocumentResponse = (function () {
    function UploadBookingDocumentResponse() {
    }
    return UploadBookingDocumentResponse;
}());

//# sourceMappingURL=checkout3-config.model.js.map

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_authorize_authorize_service__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie_src_js_cookie_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie_src_js_cookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_js_cookie_src_js_cookie_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_model_user_communication_preference_model__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_modal_dialog_company_communication_text_dialog_company_communication_text_component__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_modal_dialog_company_communication_banner_dialog_company_communication_banner_component__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_modal_dialog_terms_and_conditions_dialog_terms_and_conditions_component__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_environments_properties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_model_user_consent_model__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_services_banner_banner_service__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_modal_dialog_banner_overlay_dialog_banner_overlay_component__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pin_pin_service__ = __webpack_require__(161);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotifyType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NoticeService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




















var NotifyType;
(function (NotifyType) {
    NotifyType[NotifyType["CONSENT"] = 0] = "CONSENT";
    NotifyType[NotifyType["COMMUNICATION"] = 1] = "COMMUNICATION";
    NotifyType[NotifyType["BANNER_OVERLAY"] = 2] = "BANNER_OVERLAY";
    NotifyType[NotifyType["SET_PIN"] = 3] = "SET_PIN";
})(NotifyType || (NotifyType = {}));
var NoticeService = (function () {
    function NoticeService(authorizeService, userService, appConfigService, utilitiesService, bannerService, dialog, router, pinService) {
        this.authorizeService = authorizeService;
        this.userService = userService;
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.bannerService = bannerService;
        this.dialog = dialog;
        this.router = router;
        this.pinService = pinService;
        this.checkedConsent = false;
    }
    NoticeService.prototype.openDialogNotifyByType = function (notifyType) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(true)
            .flatMap(function () {
            if (notifyType.includes(NotifyType.CONSENT)) {
                return _this.openDialogConsent();
            }
            return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(false);
        })
            .flatMap(function () {
            if (notifyType.includes(NotifyType.BANNER_OVERLAY)) {
                return _this.openDialogBannerOverlay();
            }
            return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(false);
        })
            .flatMap(function (closedBanner) {
            if (closedBanner) {
                __WEBPACK_IMPORTED_MODULE_7_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */].bannerClosedCookieName, __WEBPACK_IMPORTED_MODULE_8_moment__().unix(), { expires: 1, domain: __WEBPACK_IMPORTED_MODULE_13_environments_properties__["e" /* domain */] });
            }
            return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(closedBanner);
        })
            .flatMap(function () {
            if (notifyType.includes(NotifyType.COMMUNICATION)) {
                return _this.openDialogCompanyCommunication();
            }
            return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(false);
        })
            .flatMap(function (closedCommunication) {
            if (closedCommunication) {
                _this.setNotifyDisabled(__WEBPACK_IMPORTED_MODULE_17_app_model_constant__["b" /* FeatureType */].CONFIG_NOTIFY_TERMS_CONDITIONS_AFTER_LOGIN, true);
            }
            return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(closedCommunication);
        }).flatMap(function () {
            if (notifyType.includes(NotifyType.SET_PIN)) {
                var isEnablePIN = _this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_17_app_model_constant__["b" /* FeatureType */].ENABLE_PIN) && _this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_17_app_model_constant__["b" /* FeatureType */].ENABLE_PIN).allow;
                var isAllowCreditTerm = _this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_17_app_model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS) && _this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_17_app_model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS).allow;
                if (isEnablePIN && isAllowCreditTerm) {
                    var userId = _this.userService.getUser().userId;
                    _this.pinService.userPINExists(userId).subscribe(function (res) {
                        if (!res.exists) {
                            _this.router.navigateByUrl("/setting?set_pin=true");
                        }
                    });
                }
            }
            return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(false);
        });
    };
    NoticeService.prototype.openDialogConsent = function () {
        var _this = this;
        if (!this.checkedConsent) {
            var userId_1 = this.userService.getUser().userId;
            return this.userService.getUserConsentDetail(userId_1, __WEBPACK_IMPORTED_MODULE_13_environments_properties__["n" /* consentName */], [__WEBPACK_IMPORTED_MODULE_14_app_model_user_consent_model__["b" /* ConsentType */].TERMS, __WEBPACK_IMPORTED_MODULE_14_app_model_user_consent_model__["b" /* ConsentType */].PRIVACY].join(','), this.appConfigService.getLanguage())
                .flatMap(function (res) {
                _this.checkedConsent = true;
                if (res && !res.accepted) {
                    var dialogRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_12_app_components_modal_dialog_terms_and_conditions_dialog_terms_and_conditions_component__["a" /* DialogTermsAndConditionsComponent */], new __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdDialogConfig */]());
                    dialogRef.componentInstance.userId = userId_1;
                    dialogRef.componentInstance.consent = res;
                    dialogRef.componentInstance.isShowSubmit = true;
                    return dialogRef.afterClosed();
                }
                return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(false);
            })
                .catch(function () { return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(false); });
        }
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(false);
    };
    NoticeService.prototype.openDialogCompanyCommunication = function () {
        var _this = this;
        var hasNotifyDisabledCookie = !!__WEBPACK_IMPORTED_MODULE_7_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */].notifyDisabledCookieName);
        if (!hasNotifyDisabledCookie) {
            var companyId_1 = this.userService.getUser().companyId;
            return this.authorizeService.getCommunicationPreference(companyId_1, this.appConfigService.getLanguage(), this.utilitiesService.isMobile())
                .flatMap(function (res) {
                if (res && res.display) {
                    switch (res.template) {
                        case __WEBPACK_IMPORTED_MODULE_9_app_model_user_communication_preference_model__["a" /* CommunicationTemplate */].TEXT:
                            return _this.openDialogCompanyCommunicationTextTemplate(res);
                        case __WEBPACK_IMPORTED_MODULE_9_app_model_user_communication_preference_model__["a" /* CommunicationTemplate */].BANNER:
                            return _this.openDialogCompanyCommunicationBannerTemplate(companyId_1, res);
                    }
                }
                return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(false);
            })
                .catch(function () { return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(false); });
        }
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(false);
    };
    NoticeService.prototype.openDialogCompanyCommunicationTextTemplate = function (data) {
        var config = new __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdDialogConfig */]();
        config.data = data;
        config.disableClose = true;
        return this.dialog.open(__WEBPACK_IMPORTED_MODULE_10_app_components_modal_dialog_company_communication_text_dialog_company_communication_text_component__["a" /* DialogCompanyCommunicationTextComponent */], config).afterClosed();
    };
    NoticeService.prototype.openDialogCompanyCommunicationBannerTemplate = function (companyId, data) {
        var _this = this;
        return this.authorizeService.getCommunicationPreferenceBanner(companyId, data.bannerTemplate.bannerId)
            .flatMap(function (res) {
            data.bannerTemplate.bannerImage = res;
            var config = new __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdDialogConfig */]();
            config.data = data;
            config.disableClose = true;
            return _this.dialog.open(__WEBPACK_IMPORTED_MODULE_11_app_components_modal_dialog_company_communication_banner_dialog_company_communication_banner_component__["a" /* DialogCompanyCommunicationBannerComponent */], config).afterClosed();
        });
    };
    NoticeService.prototype.removeNotifyCookie = function () {
        __WEBPACK_IMPORTED_MODULE_7_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */].notifyDisabledCookieName, { domain: __WEBPACK_IMPORTED_MODULE_13_environments_properties__["e" /* domain */] });
    };
    NoticeService.prototype.setNotifyDisabled = function (notifyType, disabled) {
        var notifyCookie = __WEBPACK_IMPORTED_MODULE_7_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */].notifyDisabledCookieName);
        if (notifyCookie) {
            var notifyCookieDecoded = JSON.parse(this.utilitiesService.decodeFromCookie(notifyCookie));
            var notifyCookieFound = notifyCookieDecoded.find(function (feature) { return (feature.feature === notifyType); });
            if (notifyCookieFound) {
                notifyCookieFound.disabled = disabled;
                __WEBPACK_IMPORTED_MODULE_7_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */].notifyDisabledCookieName, this.utilitiesService.encodeToCookie(JSON.stringify(notifyCookieDecoded)), { expires: 1, domain: __WEBPACK_IMPORTED_MODULE_13_environments_properties__["e" /* domain */] });
            }
            else {
                notifyCookieDecoded.push({ feature: notifyType, disabled: disabled });
                __WEBPACK_IMPORTED_MODULE_7_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */].notifyDisabledCookieName, this.utilitiesService.encodeToCookie(JSON.stringify(notifyCookieDecoded)), { expires: 1, domain: __WEBPACK_IMPORTED_MODULE_13_environments_properties__["e" /* domain */] });
            }
        }
        else {
            __WEBPACK_IMPORTED_MODULE_7_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */].notifyDisabledCookieName, this.utilitiesService.encodeToCookie(JSON.stringify([{ feature: notifyType, disabled: disabled }])), { expires: 1, domain: __WEBPACK_IMPORTED_MODULE_13_environments_properties__["e" /* domain */] });
        }
    };
    NoticeService.prototype.displayNotifyDialog = function (notifyType) {
        var notifyCookie = __WEBPACK_IMPORTED_MODULE_7_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */].notifyDisabledCookieName);
        if (!notifyCookie) {
            return true;
        }
        var featureCookieDecoded = JSON.parse(this.utilitiesService.decodeFromCookie(notifyCookie));
        var notifyTermsCondition = featureCookieDecoded ? featureCookieDecoded.find(function (feature) { return (feature.feature === notifyType); }) : null;
        return notifyTermsCondition && notifyTermsCondition.data && notifyTermsCondition.data.display && !notifyTermsCondition.disabled;
    };
    NoticeService.prototype.openDialogBannerOverlay = function () {
        var _this = this;
        var closedOn = __WEBPACK_IMPORTED_MODULE_7_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */].bannerClosedCookieName);
        if (closedOn && __WEBPACK_IMPORTED_MODULE_8_moment__["unix"](closedOn).isSame(__WEBPACK_IMPORTED_MODULE_8_moment__(), 'day')) {
            return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(false);
        }
        var isMobile = this.utilitiesService.isMobile();
        var device = isMobile ? 'mobile' : 'desktop';
        var companyId = this.userService.getUser().companyId;
        return this.bannerService.getBannerOverlay(companyId, this.appConfigService.getLanguage(), device)
            .flatMap(function (res) {
            if (res && res.length > 0) {
                return _this.dialog.open(__WEBPACK_IMPORTED_MODULE_16_app_components_modal_dialog_banner_overlay_dialog_banner_overlay_component__["a" /* DialogBannerOverlayComponent */], {
                    data: res,
                    disableClose: true
                }).afterClosed();
            }
            return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(false);
        })
            .catch(function () { return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(false); });
    };
    return NoticeService;
}());
NoticeService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_authorize_authorize_service__["a" /* AuthorizeService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_authorize_authorize_service__["a" /* AuthorizeService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_user_user_service__["a" /* UserService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_15_app_services_banner_banner_service__["a" /* BannerService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_15_app_services_banner_banner_service__["a" /* BannerService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_18__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_18__angular_router__["c" /* Router */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_19__pin_pin_service__["a" /* PinService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_19__pin_pin_service__["a" /* PinService */]) === "function" && _h || Object])
], NoticeService);

var _a, _b, _c, _d, _e, _f, _g, _h;
//# sourceMappingURL=notice.service.js.map

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UserModel; });
/* unused harmony export AddressModel */
/* unused harmony export FeatureModel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BudgetLimitModel; });
/* unused harmony export FeatureNotifyModel */
/* unused harmony export FeatureBookForTraveller */
/* unused harmony export AdditionalTravellerFieldsModel */
/* unused harmony export UserSetting */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UserModel = (function () {
    function UserModel() {
    }
    return UserModel;
}());

var AddressModel = (function () {
    function AddressModel() {
    }
    return AddressModel;
}());

var FeatureModel = (function () {
    function FeatureModel(feature, allow, data) {
        this.feature = feature;
        this.allow = allow;
        this.data = data;
    }
    return FeatureModel;
}());

var BudgetLimitModel = (function () {
    function BudgetLimitModel(isLimitBudget, budget, description) {
        this.isLimitBudget = isLimitBudget;
        this.budget = budget;
        this.description = description;
    }
    return BudgetLimitModel;
}());

var FeatureNotifyModel = (function (_super) {
    __extends(FeatureNotifyModel, _super);
    function FeatureNotifyModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FeatureNotifyModel;
}(FeatureModel));

var FeatureBookForTraveller = (function () {
    function FeatureBookForTraveller() {
    }
    return FeatureBookForTraveller;
}());

var AdditionalTravellerFieldsModel = (function () {
    function AdditionalTravellerFieldsModel() {
    }
    return AdditionalTravellerFieldsModel;
}());

var UserSetting = (function () {
    function UserSetting() {
    }
    return UserSetting;
}());

//# sourceMappingURL=user.model.js.map

/***/ }),
/* 159 */,
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_confirm_dialog_confirm_component__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_modal_dialog_general_message_dialog_general_message_component__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__address_form__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_dialog_confirm_dialog_confirm_model__ = __webpack_require__(60);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddressFormComponent; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var AddressFormComponent = (function () {
    function AddressFormComponent(formProvider, formBuilder, userService, dialog, appConfigService, translatePipe) {
        var _this = this;
        this.formProvider = formProvider;
        this.formBuilder = formBuilder;
        this.userService = userService;
        this.dialog = dialog;
        this.appConfigService = appConfigService;
        this.translatePipe = translatePipe;
        this.isActiveSelected = false;
        this.isDisplayButton = true;
        this.onUpdateAddressInfo = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onCancelAddressInfo = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onEditAddressInfo = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.isLoading = false;
        this.taxNumberMask = [];
        this.numberUnMask = /\D/g; // tslint:disable-line
        this.response = {
            SUCCESS: 'SUCCESS',
            FAIL: 'FAIL'
        };
        this.handleResponse = function (_a) {
            var type = _a.type;
            return function (response) {
                if (type === _this.response.SUCCESS) {
                    var data = response['_body'] ? response.json() : {};
                    _this.setUpdateAddress(data, _this.form.getRawValue());
                }
                else {
                    _this.onUpdateAddressInfo.emit(undefined);
                    _this.showAddressFailDialog();
                }
                _this.setLoadingState(false);
            };
        };
        this.addressInfo = {
            title: '',
            address: '',
            taxNumber: ''
        };
        this.formProvider = new __WEBPACK_IMPORTED_MODULE_9__address_form__["a" /* AddressForm */]();
        var formErrors = this.formProvider.formErrors;
        this.formErrors = formErrors;
    }
    AddressFormComponent.prototype.ngOnInit = function () {
        this.buildForm();
        this.formProvider.clearAllErrorMessage();
    };
    AddressFormComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // preventing fast click
        var saveButtonElement = document.getElementById("address-form-btn-save-" + this.index);
        if (saveButtonElement) {
            this.saveButtonSubscription = __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__["Observable"].fromEvent(saveButtonElement, 'click')
                .throttleTime(1e3)
                .subscribe(function () { return _this.onSubmit(_this.form); });
        }
    };
    AddressFormComponent.prototype.ngOnDestroy = function () {
        this.saveAddressSubscription && this.saveAddressSubscription.unsubscribe();
        this.saveButtonSubscription && this.saveButtonSubscription.unsubscribe();
    };
    AddressFormComponent.prototype.isSelected = function () {
        return (this.addressInfo.isDefault === true && typeof this.addressInfo.taxAddressId !== 'undefined') || this.isActiveSelected;
    };
    AddressFormComponent.prototype.isEditAddress = function (taxAddressId) {
        return !!taxAddressId;
    };
    AddressFormComponent.prototype.handleCancel = function (callback) {
        var _this = this;
        if (callback === void 0) { callback = function () { }; }
        if (this.form.dirty) {
            var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */], { data: { confirmType: __WEBPACK_IMPORTED_MODULE_10__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CLOSE } });
            dialogRef.afterClosed().subscribe(function (res) {
                if (res) {
                    callback();
                    _this.onCancelAddressInfo.emit(_this.addressInfo);
                }
            });
        }
        else {
            callback();
            this.onCancelAddressInfo.emit(this.addressInfo);
        }
    };
    AddressFormComponent.prototype.setLoadingState = function (isLoading) {
        this.isLoading = isLoading;
    };
    AddressFormComponent.prototype.buildForm = function () {
        var _this = this;
        var getInitForm = this.formProvider.getInitForm;
        var _a = this.addressInfo, title = _a.title, address = _a.address, taxNumber = _a.taxNumber;
        this.form = this.formBuilder.group(getInitForm(title, address, taxNumber));
        this.form.valueChanges.subscribe(function (data) {
            _this.onEditAddressInfo.emit(data);
            _this.formProvider.clearErrorMessage(data);
        });
    };
    AddressFormComponent.prototype.setFocusErrors = function (isFocus, form) {
        if (isFocus === void 0) { isFocus = false; }
        if (form === void 0) { form = this.form; }
        var fieldSorted = [
            { name: 'title', element: this.inputTitle },
            { name: 'taxNumber', element: this.inputTaxNumber },
            { name: 'address', element: this.inputAddress },
        ];
        this.formProvider.setErrorMessage(form);
        fieldSorted.map(function (field) { return ({ control: form.get(field.name), element: field.element.nativeElement }); })
            .filter(function (field) { return field.control.invalid; })
            .forEach(function (field, index) {
            index === 0 && isFocus && field.element.focus();
            field.control.markAsTouched();
        });
    };
    AddressFormComponent.prototype.getAddressProcess = function (form) {
        if (form === void 0) { form = this.form; }
        this.setLoadingState(true);
        var formData = form.getRawValue();
        return this.isEditAddress(this.addressInfo.taxAddressId) ?
            this.editTaxAddress$(formData) : this.addTaxAddress$(formData);
    };
    AddressFormComponent.prototype.onSubmit = function (form) {
        if (form.invalid) {
            this.setFocusErrors(true, form);
            return false;
        }
        this.saveAddressSubscription && this.saveAddressSubscription.unsubscribe();
        this.saveAddressSubscription = this.getAddressProcess().subscribe(this.handleResponse({ type: 'SUCCESS' }), this.handleResponse({ type: 'FAIL' }));
        return true;
    };
    AddressFormComponent.prototype.onSubmit$ = function (form) {
        var _this = this;
        if (form.invalid) {
            this.setFocusErrors(false, form);
            return __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__["Observable"].of(false);
        }
        return this.getAddressProcess().do(function (res) {
            _this.setLoadingState(false);
            _this.setUpdateAddress(res.json(), _this.form.getRawValue());
        }, function (error) {
            _this.setLoadingState(false);
            _this.showAddressFailDialog();
            return __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__["Observable"].throw(new Error('Save Address Error'));
        })
            .map(function () { return __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__["Observable"].of(true); });
    };
    AddressFormComponent.prototype.showAddressFailDialog = function () {
        var message = this.createMessage({ type: 'FAIL' });
        var config = {
            hasBackdrop: true,
            disableClose: false,
            focusOnOpen: false,
            data: message
        };
        this.dialog.open(__WEBPACK_IMPORTED_MODULE_4_app_components_modal_dialog_general_message_dialog_general_message_component__["a" /* DialogGeneralMessageComponent */], config);
    };
    AddressFormComponent.prototype.translate = function (value) {
        return this.translatePipe.transform(value);
    };
    AddressFormComponent.prototype.createMessage = function (_a) {
        var type = _a.type;
        if (type === this.response.FAIL) {
            var isProfile = this.options.page === 'profile';
            return {
                icon: 'icon-service-failed',
                title: this.translate(isProfile ? 'my-profile-edit-failure-title' : 'checkout-3-address-edit-failure-title'),
                message: this.translate('my-profile-edit-failure-description'),
                mainBtn: this.translate('btn-ok')
            };
        }
    };
    AddressFormComponent.prototype.addTaxAddress$ = function (_a) {
        var title = _a.title, taxNumber = _a.taxNumber, address = _a.address;
        var _b = this.userService.getUser(), companyId = _b.companyId, email = _b.username, memberId = _b.userId, langId = _b.Langid;
        return this.userService.addTaxAddress({
            title: this.setTrim(title),
            taxNumber: this.setTrim(taxNumber),
            address: this.setTrim(address),
            isDefault: true,
            active: true
        });
    };
    AddressFormComponent.prototype.editTaxAddress$ = function (_a) {
        var title = _a.title, taxNumber = _a.taxNumber, address = _a.address;
        return this.userService.editTaxAddress(__assign({}, this.addressInfo, { address: this.setTrim(address), title: this.setTrim(title), taxNumber: this.setTrim(taxNumber) }));
    };
    AddressFormComponent.prototype.setTrim = function (value) {
        return typeof value === 'string' ? value.trim() : value;
    };
    AddressFormComponent.prototype.setUpdateAddress = function (data, _a) {
        var title = _a.title, taxNumber = _a.taxNumber, address = _a.address;
        this.onUpdateAddressInfo.emit(__assign({}, this.addressInfo, { title: title, address: address, taxNumber: taxNumber }, data));
    };
    // Method for formControl, check value on blur
    // tslint:disable-next-line:no-unused-variable
    AddressFormComponent.prototype.isInvalid = function (field) {
        return this.form.get(field).invalid && this.form.get(field).touched;
    };
    AddressFormComponent.prototype.validateForm = function () {
        this.form.invalid && this.setFocusErrors(true, this.form);
        return this.form.valid;
    };
    AddressFormComponent.prototype.submitAddressForm = function () {
        return this.onSubmit(this.form);
    };
    AddressFormComponent.prototype.removeSpaceBetween = function (event, name) {
        this.form.controls[name].patchValue(event.target.value.replace(/\s+/g, ' ').trim());
        this.form.controls[name].updateValueAndValidity();
    };
    AddressFormComponent.prototype.removeSpace = function (event, name) {
        this.form.controls[name].patchValue(event.target.value.trim());
        this.form.controls[name].updateValueAndValidity();
    };
    return AddressFormComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], AddressFormComponent.prototype, "options", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], AddressFormComponent.prototype, "addressInfo", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], AddressFormComponent.prototype, "selectedAddressInfo", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], AddressFormComponent.prototype, "index", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], AddressFormComponent.prototype, "isActiveSelected", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], AddressFormComponent.prototype, "isDisplayButton", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], AddressFormComponent.prototype, "onUpdateAddressInfo", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
], AddressFormComponent.prototype, "onCancelAddressInfo", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
], AddressFormComponent.prototype, "onEditAddressInfo", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('title'),
    __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _d || Object)
], AddressFormComponent.prototype, "inputTitle", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('taxNumber'),
    __metadata("design:type", typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _e || Object)
], AddressFormComponent.prototype, "inputTaxNumber", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('address'),
    __metadata("design:type", typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _f || Object)
], AddressFormComponent.prototype, "inputAddress", void 0);
AddressFormComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-address-form',
        template: __webpack_require__(1006),
        styles: [__webpack_require__(871)]
    }),
    __metadata("design:paramtypes", [typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_9__address_form__["a" /* AddressForm */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_9__address_form__["a" /* AddressForm */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"]) === "function" && _h || Object, typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_user_user_service__["a" /* UserService */]) === "function" && _j || Object, typeof (_k = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */]) === "function" && _k || Object, typeof (_l = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _l || Object, typeof (_m = typeof __WEBPACK_IMPORTED_MODULE_5_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _m || Object])
], AddressFormComponent);

var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
//# sourceMappingURL=address-form.component.js.map

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_pin_pin_model__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__encrypt_encrypt_service__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_authentication_service__ = __webpack_require__(27);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PinService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var PinService = (function () {
    function PinService(actHttp, encrypt, authenticationService) {
        this.actHttp = actHttp;
        this.encrypt = encrypt;
        this.authenticationService = authenticationService;
    }
    PinService.prototype.getPublicKey = function () {
        var url = "" + __WEBPACK_IMPORTED_MODULE_4_environments_environment__["a" /* environment */].endpoint.publicKeyPIN;
        var options = this.authenticationService.getRequestOptions(__WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["b" /* ContentTypes */].JSON);
        return this.actHttp.get(url, options).map(function (res) { return res.json().data; });
    };
    PinService.prototype.setupPIN = function (rawPin, token, publicKey, verifiedToken) {
        var url = "" + __WEBPACK_IMPORTED_MODULE_4_environments_environment__["a" /* environment */].endpoint.setupPIN;
        var options = this.authenticationService.getRequestOptions(__WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["b" /* ContentTypes */].JSON);
        var encryptPIN = this.getEncryptPINRequest(rawPin, token, publicKey);
        var setupPINRequest = new __WEBPACK_IMPORTED_MODULE_2_app_model_pin_pin_model__["a" /* SetupPINRequest */](encryptPIN, verifiedToken);
        return this.actHttp.post(url, setupPINRequest, options).map(function (res) { return new __WEBPACK_IMPORTED_MODULE_2_app_model_pin_pin_model__["b" /* SetupPINResponse */](res); });
    };
    PinService.prototype.verifyPIN = function (rawPin) {
        var _this = this;
        var url = "" + __WEBPACK_IMPORTED_MODULE_4_environments_environment__["a" /* environment */].endpoint.verifyPIN;
        var options = this.authenticationService.getRequestOptions(__WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["b" /* ContentTypes */].JSON);
        return this.getPublicKey().flatMap(function (res) {
            var encryptPIN = _this.getEncryptPINRequest(rawPin, res.token, res.key);
            var verifyPINRequest = new __WEBPACK_IMPORTED_MODULE_2_app_model_pin_pin_model__["c" /* VerifyPINRequest */](encryptPIN);
            return _this.actHttp.post(url, verifyPINRequest, options)
                .map(function (res) { return res.json().data; });
        });
    };
    PinService.prototype.getEncryptPINRequest = function (rawPin, token, publicKey) {
        var pinRequest = new __WEBPACK_IMPORTED_MODULE_2_app_model_pin_pin_model__["d" /* PINRequest */](rawPin, token);
        var encryptPIN = this.encrypt.encryptWithPublicKey(JSON.stringify(pinRequest), publicKey);
        return encryptPIN;
    };
    PinService.prototype.userPINExists = function (userId) {
        var url = ("" + __WEBPACK_IMPORTED_MODULE_4_environments_environment__["a" /* environment */].endpoint.userPINExists).replace('{userId}', userId.toString());
        var option = this.authenticationService.getRequestOptions(__WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN);
        return this.actHttp.get(url, option).map(function (m) { return m.json().data; });
    };
    return PinService;
}());
PinService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3__encrypt_encrypt_service__["a" /* EncryptService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__encrypt_encrypt_service__["a" /* EncryptService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_5__authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _c || Object])
], PinService);

var _a, _b, _c;
//# sourceMappingURL=pin.service.js.map

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_dialog_alert_dialog_alert_component__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WarningService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var WarningService = (function () {
    function WarningService(dialog, appConfigService, utilitiesService) {
        this.dialog = dialog;
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.errorRequestCount = 0;
    }
    WarningService.prototype.popDialogErrorRequest = function (alertText, fetchFunction, parameter, redirectPath, alertHeader) {
        var _this = this;
        if (redirectPath === void 0) { redirectPath = '/'; }
        this.errorRequestCount += 1;
        var config = new __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdDialogConfig */]();
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2__components_modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */], config);
        dialogRef.componentInstance.alertText = this.appConfigService.getTranslate(alertText) ? this.appConfigService.getTranslate(alertText) : alertText;
        dialogRef.componentInstance.alertHeader = this.appConfigService.getTranslate(alertHeader) ? this.appConfigService.getTranslate(alertHeader) : alertHeader;
        dialogRef.afterClosed().subscribe(function (result) {
            if (fetchFunction && _this.errorRequestCount < 3) {
                parameter ? fetchFunction(parameter) : fetchFunction();
            }
            else {
                _this.errorRequestCount = 0;
                _this.utilitiesService.redirectPage(redirectPath, _this.appConfigService.getLanguage());
            }
        });
    };
    return WarningService;
}());
WarningService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3__app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _c || Object])
], WarningService);

var _a, _b, _c;
//# sourceMappingURL=warning.service.js.map

/***/ }),
/* 163 */,
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vendors_moment_locale_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__ = __webpack_require__(243);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogBudgetLimitDetailComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};









var DialogBudgetLimitDetailComponent = (function () {
    function DialogBudgetLimitDetailComponent(dialogRef, appConfigService, translate, decimal, utilities, data) {
        this.dialogRef = dialogRef;
        this.appConfigService = appConfigService;
        this.translate = translate;
        this.decimal = decimal;
        this.utilities = utilities;
        this.data = data;
        this.name = 'dialog-budget-limit-detail';
        this.titleList = [];
        this.dayList = [];
        this.itemList = [];
        this.totalList = [];
        this.tableList = [];
        this.shareBudgetDestination = [];
        this.isMobile = false;
        __WEBPACK_IMPORTED_MODULE_7_vendors_moment_locale_th__["locale"](this.lang);
        this.lang = this.appConfigService.getLanguage();
        this.isMobile = this.utilities.isMobile();
    }
    DialogBudgetLimitDetailComponent.prototype.onResize = function (event) {
        document.documentElement.style.setProperty('--height-vh', window.innerHeight * 0.01 + "px");
    };
    DialogBudgetLimitDetailComponent.prototype.ngOnInit = function () {
        this.onResize();
        if (this.data.isShareBudget) {
            this.transformShareBudget();
        }
        else {
            if (this.isMobile && this.data.destinationTravelPolicyBooker.length > 1) {
                this.transformMobileCasePOIs();
            }
            else {
                this.transformTravelPolicyDestination();
            }
        }
    };
    DialogBudgetLimitDetailComponent.prototype.transformTravelPolicyDestination = function () {
        this.averageBudget = this.data && this.data.destinationTravelPolicyBooker.length > 0 && this.transformBudget(this.data.destinationTravelPolicyBooker[0].averageBudget);
        var roundDestination = this.data.destinationTravelPolicyBooker.length;
        var destinationPolicyNotEmptyTravelPolicy = this.findDestinationTravelPolicyNotEmptyTravelPolicyList(this.data.destinationTravelPolicyBooker);
        var roundDays = destinationPolicyNotEmptyTravelPolicy.travelPolicyList.length;
        for (var index = 0; index < roundDestination; index++) {
            if (this.data.destinationTravelPolicyBooker[index].travelPolicyList) {
                this.titleList.push(this.lang === __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["a" /* Language */].en ? this.translate.transform('budget-limit-for') + " " + this.data.destinationTravelPolicyBooker[index].destinationNameEn : "" + this.translate.transform('budget-limit-for') + this.data.destinationTravelPolicyBooker[index].destinationNameTh);
                this.totalList.push(this.data.destinationTravelPolicyBooker[index].averageBudget ? this.transformBudget(this.data.destinationTravelPolicyBooker[index].averageBudget, true) : "" + this.translate.transform('budget-limit-unlimited'));
            }
        }
        for (var day = 0; day < roundDays; day++) {
            this.dayList = [];
            this.dayList.push(new __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["a" /* Item */](this.transformDateString(destinationPolicyNotEmptyTravelPolicy, day)));
            for (var index = 0; index < roundDestination; index++) {
                if (this.data.destinationTravelPolicyBooker[index].travelPolicyList) {
                    var item = this.data.destinationTravelPolicyBooker[index].travelPolicyList ? this.data.destinationTravelPolicyBooker[index].travelPolicyList[day] : undefined;
                    var budget = item ? (item.budget ? this.transformBudget(item.budget) : "" + this.translate.transform('budget-limit-unlimited')) : (this.data.budgetBooker ? this.transformBudget(this.data.budgetBooker) : "" + this.translate.transform('budget-limit-unlimited'));
                    if (item.budgetType === __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["b" /* BUDGET_TYPE */].NEW_BUDGET) {
                        this.dayList.push(new __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["a" /* Item */](budget, "" + this.translate.transform('budget-limit-budget-special')));
                    }
                    else {
                        this.dayList.push(new __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["a" /* Item */](budget));
                    }
                }
            }
            this.itemList.push(this.dayList);
        }
        this.isPOIs = this.titleList.length > 1;
    };
    DialogBudgetLimitDetailComponent.prototype.transformMobileCasePOIs = function () {
        var roundDestination = this.data.destinationTravelPolicyBooker.length;
        var destinationPolicyNotEmptyTravelPolicy = this.findDestinationTravelPolicyNotEmptyTravelPolicyList(this.data.destinationTravelPolicyBooker);
        var roundDays = destinationPolicyNotEmptyTravelPolicy.travelPolicyList.length;
        for (var index = 0; index < roundDestination; index++) {
            if (this.data.destinationTravelPolicyBooker[index].travelPolicyList) {
                this.titleList.push(this.lang === __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["a" /* Language */].en ? this.translate.transform('budget-limit-for') + " " + this.data.destinationTravelPolicyBooker[index].destinationNameEn : "" + this.translate.transform('budget-limit-for') + this.data.destinationTravelPolicyBooker[index].destinationNameTh);
                this.totalList.push(this.data.destinationTravelPolicyBooker[index].averageBudget ? this.transformBudget(this.data.destinationTravelPolicyBooker[index].averageBudget) : "" + this.translate.transform('budget-limit-unlimited'));
                this.itemList = [];
                for (var day = 0; day < roundDays; day++) {
                    this.dayList = [];
                    this.dayList.push(new __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["a" /* Item */](this.transformDateString(destinationPolicyNotEmptyTravelPolicy, day)));
                    var item = this.data.destinationTravelPolicyBooker[index].travelPolicyList ? this.data.destinationTravelPolicyBooker[index].travelPolicyList[day] : undefined;
                    ;
                    var budget = item ? (item.budget ? this.transformBudget(item.budget) : "" + this.translate.transform('budget-limit-unlimited')) : (this.data.budgetBooker ? this.transformBudget(this.data.budgetBooker) : "" + this.translate.transform('budget-limit-unlimited'));
                    if (item.budgetType === __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["b" /* BUDGET_TYPE */].NEW_BUDGET) {
                        this.dayList.push(new __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["a" /* Item */](budget, "" + this.translate.transform('budget-limit-budget-special')));
                    }
                    else {
                        this.dayList.push(new __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["a" /* Item */](budget));
                    }
                    this.itemList.push(this.dayList);
                }
                this.tableList.push(this.itemList);
            }
        }
        this.isPOIs = this.titleList.length > 1;
    };
    DialogBudgetLimitDetailComponent.prototype.transformShareBudget = function () {
        this.shareBudgetDestination = this.findShareBudgetDestination(this.data.destinationTravelPolicyBooker, this.data.destinationTravelPolicyCoBooker);
        this.isPOIs = this.shareBudgetDestination.length > 1;
        var isDestinationTravelPolicy = this.isDestinationTravelPolicy(this.data.destinationTravelPolicyBooker);
        var isDestinationTravelPolicyCoBooker = this.isDestinationTravelPolicy(this.data.destinationTravelPolicyCoBooker);
        var booker = isDestinationTravelPolicy ? {
            budget: this.data.destinationTravelPolicyBooker[0].totalBudget,
            destination: this.data.destinationTravelPolicyBooker.length,
            days: Math.max.apply(Math, this.data.destinationTravelPolicyBooker.map(function (d) { return d.travelPolicyList ? d.travelPolicyList.length : 0; }))
        } : { budget: this.data.budgetBooker, destination: 0, days: 0 };
        var coBooker = isDestinationTravelPolicyCoBooker ? {
            budget: this.data.destinationTravelPolicyCoBooker[0].totalBudget,
            destination: this.data.destinationTravelPolicyCoBooker.length,
            days: Math.max.apply(Math, this.data.destinationTravelPolicyCoBooker.map(function (d) { return d.travelPolicyList ? d.travelPolicyList.length : 0; }))
        } : { budget: this.data.budgetCoBooker, destination: 0, days: 0 };
        var roundDays = Math.max(booker.days, coBooker.days);
        this.averageBudget = this.transformBudget(booker.budget + coBooker.budget);
        for (var index = 0; index < this.shareBudgetDestination.length; index++) {
            var destinationId = this.shareBudgetDestination[index].id;
            var indexDestinationBooker = this.findIndexListDestinationTravelPolicy(this.data.destinationTravelPolicyBooker, destinationId);
            var appliedCoBudget = this.data.destinationTravelPolicyBooker[indexDestinationBooker].appliedCoBudget;
            var totalBudget = this.data.destinationTravelPolicyBooker[indexDestinationBooker].totalBudget;
            this.totalList.push({
                totalBudget: totalBudget ? this.transformBudget(totalBudget, true) : "" + this.translate.transform('budget-limit-unlimited'),
                appliedCoBudget: appliedCoBudget
            });
            this.itemList = [];
            var listDay = isDestinationTravelPolicy ? this.data.destinationTravelPolicyBooker : this.data.destinationTravelPolicyCoBooker;
            var destinationPolicyNotEmptyTravelPolicyList = this.findDestinationTravelPolicyNotEmptyTravelPolicyList(listDay);
            for (var day = 0; day < roundDays; day++) {
                this.dayList = [];
                this.dayList.push(new __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["a" /* Item */](this.transformDateString(destinationPolicyNotEmptyTravelPolicyList, day)));
                var resultBooker = this.prepareDataShareBudget(this.data.destinationTravelPolicyBooker, this.data.budgetBooker, destinationId, day, true);
                this.dayList.push.apply(this.dayList, resultBooker.dayList);
                var resultCoBooker = this.prepareDataShareBudget(this.data.destinationTravelPolicyCoBooker, this.data.budgetCoBooker, destinationId, day, false);
                this.dayList.push.apply(this.dayList, resultCoBooker.dayList);
                var totalBudget_1 = resultBooker.appliedCoBudget ?
                    resultBooker.totalBudget ? this.transformBudget(resultBooker.totalBudget) : "" + this.translate.transform('budget-limit-unlimited') :
                    resultBooker.dailyBudget + resultCoBooker.dailyBudget ? this.transformBudget(resultBooker.dailyBudget + resultCoBooker.dailyBudget) : "" + this.translate.transform('budget-limit-unlimited');
                this.dayList.push({
                    totalBudget: totalBudget_1,
                    appliedCoBudget: resultBooker.appliedCoBudget
                });
                this.itemList.push(this.dayList);
            }
            this.tableList.push(this.itemList);
        }
    };
    DialogBudgetLimitDetailComponent.prototype.findShareBudgetDestination = function (travelpolicyListBooker, travelpolicyListCoBooker) {
        var _this = this;
        var destinations = [];
        travelpolicyListBooker && travelpolicyListBooker.forEach(function (f) {
            if (f.appliedCoBudget || f.travelPolicyList) {
                destinations.push({ id: f.destinationId, name: _this.lang === __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["a" /* Language */].th ? f.destinationNameTh : f.destinationNameEn });
            }
        });
        travelpolicyListCoBooker && travelpolicyListCoBooker.forEach(function (f) {
            if (f.appliedCoBudget || f.travelPolicyList) {
                destinations.push({ id: f.destinationId, name: _this.lang === __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["a" /* Language */].th ? f.destinationNameTh : f.destinationNameEn });
            }
        });
        destinations = destinations.filter(function (obj) { return !destinations[obj.id] && (destinations[obj.id] = true); });
        return destinations;
    };
    DialogBudgetLimitDetailComponent.prototype.prepareDataShareBudget = function (travelpolicyList, normalBudget, destinationId, day, isMainBooker) {
        var budget;
        var dayList = [];
        var indexDestination = this.findIndexListDestinationTravelPolicy(travelpolicyList, destinationId);
        if (indexDestination !== -1) {
            if (travelpolicyList[indexDestination].travelPolicyList) {
                var item = travelpolicyList[indexDestination].travelPolicyList[day];
                var budgeBooker = item.budget ? this.transformBudget(item.budget) : "" + this.translate.transform('budget-limit-unlimited');
                budget = +item.budget;
                if (item.budgetType === __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["b" /* BUDGET_TYPE */].NEW_BUDGET) {
                    dayList.push(new __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["a" /* Item */](budgeBooker, "" + this.translate.transform('budget-limit-budget-special')));
                }
                else {
                    dayList.push(new __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["a" /* Item */](budgeBooker));
                }
            }
            else {
                if (isMainBooker) {
                    dayList.push(new __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["a" /* Item */](this.data.budgetBooker ? this.transformBudget(this.data.budgetBooker) : "" + this.translate.transform('budget-limit-unlimited')));
                }
                else {
                    dayList.push(new __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["a" /* Item */](this.data.budgetCoBooker ? this.transformBudget(this.data.budgetCoBooker) : "" + this.translate.transform('budget-limit-unlimited')));
                }
            }
        }
        else {
            dayList.push(new __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["a" /* Item */](normalBudget ? this.transformBudget(normalBudget) : "" + this.translate.transform('budget-limit-unlimited')));
            budget = normalBudget;
        }
        var appliedCoBudget;
        var dailyBudget;
        var totalBudget;
        if (travelpolicyList[indexDestination] && travelpolicyList[indexDestination].travelPolicyList) {
            appliedCoBudget = travelpolicyList[indexDestination].travelPolicyList[day].totalBudgetType === __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["c" /* TOTAL_BUDGET_TYPE */].CO_BUDGET ||
                travelpolicyList[indexDestination].travelPolicyList[day].totalBudgetType === __WEBPACK_IMPORTED_MODULE_8__budget_limit_model__["c" /* TOTAL_BUDGET_TYPE */].SPECIAL_CO_BUDGET;
            dailyBudget = travelpolicyList[indexDestination].travelPolicyList[day].budget;
            totalBudget = travelpolicyList[indexDestination].travelPolicyList[day].totalBudget;
        }
        else {
            appliedCoBudget = travelpolicyList[indexDestination].appliedCoBudget;
            dailyBudget = normalBudget;
            totalBudget = appliedCoBudget ? this.data.coBudget : undefined;
        }
        return { budget: budget, dayList: dayList, dailyBudget: dailyBudget, totalBudget: totalBudget, appliedCoBudget: appliedCoBudget };
    };
    DialogBudgetLimitDetailComponent.prototype.transformDateString = function (destinationTravelPolicy, day) {
        var dateString = '';
        dateString = __WEBPACK_IMPORTED_MODULE_7_vendors_moment_locale_th__(destinationTravelPolicy.travelPolicyList[day].date, this.appConfigService.dateAPIFormat).locale(this.lang).format(this.appConfigService.dateTravelPolicyFormat);
        dateString = this.lang === __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["a" /* Language */].th ? this.utilities.convertYearToBuddhist(dateString) : dateString;
        return dateString;
    };
    DialogBudgetLimitDetailComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    DialogBudgetLimitDetailComponent.prototype.onGoTable = function (index) {
        var _this = this;
        setTimeout(function () {
            try {
                document.getElementById(_this.name + "-table-" + index).scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
            catch (error) { }
        }, 400);
    };
    DialogBudgetLimitDetailComponent.prototype.transformBudget = function (budget, highlight) {
        if (highlight === void 0) { highlight = false; }
        if (highlight) {
            return "THB <b>" + this.decimal.transform(budget, '1.0') + "</b>";
        }
        return "THB " + this.decimal.transform(budget, '1.0');
    };
    DialogBudgetLimitDetailComponent.prototype.findIndexListDestinationTravelPolicy = function (travelpolicyList, destinationId) {
        if (travelpolicyList) {
            return travelpolicyList.findIndex(function (f) { return f.destinationId == destinationId; });
        }
        else {
            return -1;
        }
    };
    DialogBudgetLimitDetailComponent.prototype.findDestinationTravelPolicyNotEmptyTravelPolicyList = function (destinationTravelPolicyList) {
        return destinationTravelPolicyList.find(function (d) { return d.travelPolicyList && d.travelPolicyList.length > 0; });
    };
    DialogBudgetLimitDetailComponent.prototype.isDestinationTravelPolicy = function (destinationTravelPolicyList) {
        if (destinationTravelPolicyList && destinationTravelPolicyList.length > 0) {
            for (var _i = 0, destinationTravelPolicyList_1 = destinationTravelPolicyList; _i < destinationTravelPolicyList_1.length; _i++) {
                var destination = destinationTravelPolicyList_1[_i];
                if (destination.travelPolicyList && destination.travelPolicyList.length > 0) {
                    return true;
                }
            }
        }
        return false;
    };
    return DialogBudgetLimitDetailComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DialogBudgetLimitDetailComponent.prototype, "onResize", null);
DialogBudgetLimitDetailComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
        selector: 'act-dialog-budget-limit-detail',
        template: __webpack_require__(1017),
        styles: [__webpack_require__(882)]
    }),
    __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_4_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_common__["k" /* DecimalPipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_common__["k" /* DecimalPipe */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _e || Object, Object])
], DialogBudgetLimitDetailComponent);

var _a, _b, _c, _d, _e;
//# sourceMappingURL=dialog-budget-limit-detail.component.js.map

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogTaxesFeesComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};



var DialogTaxesFeesComponent = (function () {
    function DialogTaxesFeesComponent(data, dialogRef, utilitiesService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.utilitiesService = utilitiesService;
    }
    DialogTaxesFeesComponent.prototype.ngOnInit = function () {
    };
    DialogTaxesFeesComponent.prototype.ngOnDestroy = function () {
        this.utilitiesService.unlockBody();
        this.utilitiesService.unlockBodyBackdrop();
    };
    return DialogTaxesFeesComponent;
}());
DialogTaxesFeesComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-taxes-fees',
        template: __webpack_require__(1022),
        styles: [__webpack_require__(887)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [Object, typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object])
], DialogTaxesFeesComponent);

var _a, _b;
//# sourceMappingURL=dialog-taxes-fees.component.js.map

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_products_product_review_model__ = __webpack_require__(128);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoWindowContentComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var InfoWindowContentComponent = (function () {
    function InfoWindowContentComponent(utilitiesService, ref) {
        this.utilitiesService = utilitiesService;
        this.ref = ref;
        this._isActive = true;
        this.ratingArray = [];
        // tslint:disable-next-line:no-unused-variable
        this.MINTOTALNUMBEROFSUBMITBEFORESHOW = 6;
    }
    Object.defineProperty(InfoWindowContentComponent.prototype, "image", {
        set: function (image) {
            this._image = image;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoWindowContentComponent.prototype, "title", {
        set: function (title) {
            this._title = title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoWindowContentComponent.prototype, "isActive", {
        set: function (isActive) {
            this._isActive = isActive || this._isActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoWindowContentComponent.prototype, "rating", {
        set: function (rating) {
            this.ratingArray = this.utilitiesService.indexToArray(rating);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoWindowContentComponent.prototype, "review", {
        set: function (review) {
            this.reviewRating = review;
        },
        enumerable: true,
        configurable: true
    });
    InfoWindowContentComponent.prototype.ngOnInit = function () {
    };
    InfoWindowContentComponent.prototype.setData = function (image, title, rating, review, isActive, displayNavigate) {
        if (isActive === void 0) { isActive = true; }
        if (displayNavigate === void 0) { displayNavigate = false; }
        this._image = image;
        this._title = title;
        this._isActive = isActive;
        this.ratingArray = this.utilitiesService.indexToArray(rating);
        this.reviewRating = review;
        this.displayNavigate = displayNavigate;
        this.ref.detectChanges();
    };
    InfoWindowContentComponent.prototype.onNavigate = function () {
        window.open("https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=" + this.latitude + "," + this.longitude, '_blank');
    };
    return InfoWindowContentComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], InfoWindowContentComponent.prototype, "image", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], InfoWindowContentComponent.prototype, "title", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], InfoWindowContentComponent.prototype, "isActive", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], InfoWindowContentComponent.prototype, "rating", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2_app_model_products_product_review_model__["a" /* ProductReviewModel */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_model_products_product_review_model__["a" /* ProductReviewModel */]) === "function" && _a || Object),
    __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2_app_model_products_product_review_model__["a" /* ProductReviewModel */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_model_products_product_review_model__["a" /* ProductReviewModel */]) === "function" && _b || Object])
], InfoWindowContentComponent.prototype, "review", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], InfoWindowContentComponent.prototype, "latitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], InfoWindowContentComponent.prototype, "longitude", void 0);
InfoWindowContentComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-info-window-content',
        template: __webpack_require__(1056),
        styles: [__webpack_require__(921)]
    }),
    __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _d || Object])
], InfoWindowContentComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=info-window-content.component.js.map

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_authorize_authorize_service__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_environments_properties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dialog_share_budget_model__ = __webpack_require__(130);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogShareBudgetComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var DialogShareBudgetComponent = (function () {
    function DialogShareBudgetComponent(dialogRef, fb, authorizeService, appConfigService, userService, translate) {
        this.dialogRef = dialogRef;
        this.fb = fb;
        this.authorizeService = authorizeService;
        this.appConfigService = appConfigService;
        this.userService = userService;
        this.translate = translate;
        this.STATE = {
            VERIFY: 'VERIFY',
            CO_BOOKER_COMPANY: 'CO_BOOKER_COMPANY'
        };
        this.state = this.STATE.VERIFY;
        this.listCompany = [];
        this.isSubmitted = false;
        this.isLoading = false;
        this.copied = false;
        this.bookerNotAllowFeature = false;
        this.link = '';
    }
    DialogShareBudgetComponent.prototype.onResize = function (event) {
        document.documentElement.style.setProperty('--height-vh', window.innerHeight * 0.01 + "px");
    };
    DialogShareBudgetComponent.prototype.ngOnInit = function () {
        this.onResize();
        this.form = this.fb.group({
            codeRef: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].minLength(6), __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].pattern(/^[a-zA-Z0-9]+$/)]],
            coBookerEmail: [''],
            companyName: [''],
        });
        this.link = __WEBPACK_IMPORTED_MODULE_7_environments_properties__["t" /* frontend */] + "/share-budget-code";
    };
    DialogShareBudgetComponent.prototype.onContinue = function () {
        var _this = this;
        this.isSubmitted = true;
        switch (this.state) {
            case this.STATE.VERIFY:
                if (this.form.valid) {
                    this.isLoading = true;
                    this.authorizeService.shareBudgetCode(this.form.get('codeRef').value, this.userService.getUser().companyId, this.getLang())
                        .subscribe(function (res) {
                        _this.form.get('companyName').setValue(res.coBookerDetail.companyName);
                        _this.form.get('coBookerEmail').setValue(res.coBookerDetail.email);
                        _this.form.get('codeRef').disable();
                        _this.budget = res.coBookerDetail.budget;
                        _this.coBookerUserId = res.coBookerDetail.userId;
                        _this.coBookerCompanyId = res.coBookerDetail.companyId;
                        _this.coBookerFullName = res.coBookerDetail.fullName;
                        _this.coBookerAddress = _this.translate.transform('dialog-share-budget-company') + " " + res.coBookerDetail.taxAddress.name + "<br>" + _this.translate.transform('dialog-share-budget-tax-id') + " " + res.coBookerDetail.taxAddress.taxNumber + "<br>" + res.coBookerDetail.taxAddress.address;
                        _this.expireDate = res.expireDate;
                        _this.state = _this.STATE.CO_BOOKER_COMPANY;
                        _this.isSubmitted = false;
                        _this.isLoading = false;
                    }, function (err) {
                        _this.isLoading = false;
                        try {
                            var errors = err.json();
                            if (errors && errors.errors && errors.errors.length > 0) {
                                var code = errors.errors[0].code;
                                switch (code) {
                                    case "4701":
                                        _this.form.get('codeRef').setErrors({ incorrect: true });
                                        break;
                                    case "4702":
                                        _this.form.get('codeRef').setErrors({ expired: true });
                                        break;
                                    case "4703":
                                        _this.form.get('codeRef').setErrors({ yourself: true });
                                        break;
                                    case "4704":
                                        // case booker not allow feature share budget
                                        _this.authorizeService.setCookieFeatureShareBudgetIsFalse();
                                        _this.bookerNotAllowFeature = true;
                                        _this.form.get('codeRef').setErrors({ notAllowFeature: true });
                                        break;
                                    case "4705":
                                        _this.form.get('codeRef').setErrors({ notAllowFeature: true });
                                        break;
                                    default:
                                        _this.form.get('codeRef').setErrors({ incorrect: true });
                                        break;
                                }
                            }
                            else {
                                _this.form.get('codeRef').setErrors({ incorrect: true });
                            }
                        }
                        catch (error) {
                            _this.form.get('codeRef').setErrors({ incorrect: true });
                        }
                    });
                }
                break;
            case this.STATE.CO_BOOKER_COMPANY:
                if (this.form.valid) {
                    this.isSubmitted = false;
                    this.authorizeService.setCoBookerCookie(this.coBookerUserId, this.coBookerCompanyId, this.form.get('coBookerEmail').value, this.budget, this.coBookerFullName, this.expireDate, this.form.get('codeRef').value);
                    this.authorizeService.setShareBudgetCodeCookie(this.form.get('codeRef').value);
                    this.dialogRef.close({ event: 'success', shareBudget: new __WEBPACK_IMPORTED_MODULE_8__dialog_share_budget_model__["b" /* ShareBudget */](undefined, new __WEBPACK_IMPORTED_MODULE_8__dialog_share_budget_model__["a" /* Booker */](this.coBookerUserId, this.coBookerCompanyId, this.form.get('coBookerEmail').value, this.budget, this.coBookerFullName)) });
                }
                break;
        }
    };
    DialogShareBudgetComponent.prototype.onChangeCodeRef = function () {
        this.form.get('codeRef').reset({ value: '', disabled: false });
        this.form.get('companyName').reset('');
        this.form.get('coBookerEmail').reset('');
        this.coBookerAddress = undefined;
        this.state = this.STATE.VERIFY;
        this.isSubmitted = false;
    };
    DialogShareBudgetComponent.prototype.onClose = function () {
        if (this.bookerNotAllowFeature) {
            this.dialogRef.close({ event: 'bookerNotAllowFeature' });
        }
        else {
            this.form.get('codeRef').value === '' ? this.dialogRef.close({ event: 'closeDialog' }) : this.dialogRef.close({ event: 'close' });
        }
    };
    DialogShareBudgetComponent.prototype.onCopyLink = function () {
        var _this = this;
        this.copied = true;
        setTimeout(function () {
            _this.copied = false;
        }, 5000);
    };
    DialogShareBudgetComponent.prototype.getLang = function () {
        return this.appConfigService.getLanguage();
    };
    return DialogShareBudgetComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DialogShareBudgetComponent.prototype, "onResize", null);
DialogShareBudgetComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-share-budget',
        template: __webpack_require__(1070),
        styles: [__webpack_require__(935)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_authorize_authorize_service__["a" /* AuthorizeService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_authorize_authorize_service__["a" /* AuthorizeService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__["a" /* UserService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_3_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _f || Object])
], DialogShareBudgetComponent);

var _a, _b, _c, _d, _e, _f;
//# sourceMappingURL=dialog-share-budget.component.js.map

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__otp_otp_component__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modal_dialog_error_dialog_error_component__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__otp_state__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_services_user_user_service__ = __webpack_require__(15);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VerifyOtpComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var VerifyOtpComponent = (function () {
    function VerifyOtpComponent(translatePipe, authenticationService, appConfigService, userService, dialog) {
        this.translatePipe = translatePipe;
        this.authenticationService = authenticationService;
        this.appConfigService = appConfigService;
        this.userService = userService;
        this.dialog = dialog;
        this.methods = [];
        this.isLoading = false;
        this.isLoadingChange = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.stateChange = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.accountLock = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.verified = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.elementId = 'verify-otp';
        this.sendingRequestOtp = false;
        this.requiredSetPin = false;
        this.OTP_STATE = __WEBPACK_IMPORTED_MODULE_7__otp_state__["a" /* OTP_STATE */];
        this.otpReference = "";
        this.sessionExpired = false;
        this.selectedVerifyMethodMap = new Map();
        this.isAccountLocked = false;
    }
    VerifyOtpComponent.prototype.ngOnDestroy = function () {
        this.verifyPinSubscription && this.verifyPinSubscription.unsubscribe();
    };
    VerifyOtpComponent.prototype.ngOnInit = function () {
        this.subscribeLanguageChanges();
    };
    VerifyOtpComponent.prototype.subscribeLanguageChanges = function () {
        var _this = this;
        this.lang = this.appConfigService.getLanguage();
        this.langSubscription && this.langSubscription.unsubscribe();
        this.langSubscription = this.appConfigService.getLanguageObs().subscribe(function (lang) {
            _this.lang = lang;
        });
    };
    VerifyOtpComponent.prototype.onSubmit = function () {
        var _this = this;
        if (this.isAccountLocked) {
            this.userService.logout();
        }
        var verifyOTPRequest = {
            otp: this.otpChild.getOtp(),
            referenceCode: this.otpReference,
            token: this.token
        };
        this.authenticationService.verifyOTP(verifyOTPRequest).subscribe(function (res) {
            _this.isLoading = false;
            _this.isLoadingChange.emit(_this.isLoading);
            if (res) {
                _this.errorMessage = undefined;
            }
            else {
                _this.handleError();
            }
            _this.verified.emit(res);
        }, function (errRes) {
            _this.isLoading = false;
            _this.isLoadingChange.emit(_this.isLoading);
            _this.handleError(errRes);
        });
    };
    VerifyOtpComponent.prototype.handleInvalidOTP = function (message) {
        var match = message.match(/\{(\d+)\}/);
        if (match && match[1]) {
            var remaining = +match[1];
            if (remaining <= 1) {
                this.errorMessage = this.translatePipe.transform('otp-last-attempts');
            }
            else if (remaining <= 3) {
                this.errorMessage = this.translatePipe.transform('otp-remaining-attempts').replace('{x}', remaining);
            }
        }
    };
    VerifyOtpComponent.prototype.handleError = function (errRes) {
        if (errRes) {
            if (errRes.status === 400) {
                this.errorMessage = this.translatePipe.transform('otp-code-incorrect');
                var errorData = errRes.json();
                if (errorData.errors && errorData.errors.length > 0) {
                    this.handleInvalidOTP(errorData.errors[0].message);
                }
                else {
                    this.showDialogError();
                }
            }
            else if (errRes.status === 401) {
                this.errorMessage = this.translatePipe.transform('session-expired');
                this.sessionExpired = true;
                this.state = this.OTP_STATE.SESSION_EXPIRE;
                this.stateChange.emit(this.state);
            }
            else if (errRes.status === 403) {
                this.isAccountLocked = true;
                this.errorMessage = this.translatePipe.transform('account-locked');
                this.accountLock.emit();
            }
        }
        else {
            this.showDialogError();
        }
    };
    Object.defineProperty(VerifyOtpComponent.prototype, "otpInputForm", {
        get: function () {
            if (this.otpChild) {
                return this.otpChild.otpInputForm;
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    VerifyOtpComponent.prototype.onSelectOtpMethod = function (method) {
        if (this.selectedVerifyMethodMap.has(method.method)) {
            var requestOtpResponse = this.selectedVerifyMethodMap.get(method.method);
            this.otpReference = requestOtpResponse.referenceCode;
            this.selectedVerifyMethod = requestOtpResponse.methods;
            this.state = this.OTP_STATE.OTP;
            this.stateChange.emit(this.state);
        }
        else {
            this.requestOTP(method);
        }
    };
    VerifyOtpComponent.prototype.requestOTP = function (method) {
        var _this = this;
        var otpRequest = {
            lang: this.lang,
            methods: method,
            purpose: this.purpose,
            token: this.token
        };
        this.sendingRequestOtp = true;
        this.authenticationService.requestOTP(otpRequest).subscribe(function (res) {
            _this.selectedVerifyMethodMap.set(method.method, res);
            _this.selectedVerifyMethod = res.methods;
            _this.otpReference = res.referenceCode;
            _this.sendingRequestOtp = false;
            _this.state = _this.OTP_STATE.OTP;
            _this.stateChange.emit(_this.state);
        }, function (error) {
            _this.sendingRequestOtp = false;
            _this.handleError(error);
        });
    };
    VerifyOtpComponent.prototype.showDialogError = function () {
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__modal_dialog_error_dialog_error_component__["a" /* DialogErrorComponent */]);
        dialogRef.componentInstance.text = this.translatePipe.transform('system-error');
    };
    return VerifyOtpComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])('otpChild'),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_5__otp_otp_component__["a" /* OtpComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__otp_otp_component__["a" /* OtpComponent */]) === "function" && _a || Object)
], VerifyOtpComponent.prototype, "otpChild", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Array)
], VerifyOtpComponent.prototype, "methods", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", String)
], VerifyOtpComponent.prototype, "token", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_7__otp_state__["a" /* OTP_STATE */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7__otp_state__["a" /* OTP_STATE */]) === "function" && _b || Object)
], VerifyOtpComponent.prototype, "state", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], VerifyOtpComponent.prototype, "isLoading", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", String)
], VerifyOtpComponent.prototype, "purpose", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])(),
    __metadata("design:type", Object)
], VerifyOtpComponent.prototype, "isLoadingChange", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])(),
    __metadata("design:type", Object)
], VerifyOtpComponent.prototype, "stateChange", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])(),
    __metadata("design:type", Object)
], VerifyOtpComponent.prototype, "accountLock", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])(),
    __metadata("design:type", Object)
], VerifyOtpComponent.prototype, "verified", void 0);
VerifyOtpComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
        selector: 'act-verify-otp',
        template: __webpack_require__(1096),
        styles: [__webpack_require__(961)]
    }),
    __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_8_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8_app_services_user_user_service__["a" /* UserService */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */]) === "function" && _g || Object])
], VerifyOtpComponent);

var _a, _b, _c, _d, _e, _f, _g;
//# sourceMappingURL=verify-otp.component.js.map

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginResponseModel; });
var LoginResponseModel = (function () {
    function LoginResponseModel(user, token) {
        this.user = user;
        this.token = token;
    }
    return LoginResponseModel;
}());

//# sourceMappingURL=login-response.model.js.map

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VerificationMethodModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OTPPurpose; });
var VerificationMethodModel = (function () {
    function VerificationMethodModel(type, method, identity) {
        this.type = type;
        this.method = method;
        this.identity = identity;
    }
    return VerificationMethodModel;
}());

var OTPPurpose = (function () {
    function OTPPurpose() {
    }
    return OTPPurpose;
}());

OTPPurpose.LOGIN = 'login';
OTPPurpose.SET_PIN = 'set_pin';
OTPPurpose.SET_PHONE = 'set_phone';
//# sourceMappingURL=otp.model.js.map

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommunicationTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CompanyCommunication; });
/* unused harmony export CompanyCommunicationText */
/* unused harmony export CompanyCommunicationBanner */
var CommunicationTemplate = {
    TEXT: 'text',
    BANNER: 'banner'
};
var CompanyCommunication = (function () {
    function CompanyCommunication() {
    }
    return CompanyCommunication;
}());

var CompanyCommunicationText = (function () {
    function CompanyCommunicationText() {
    }
    return CompanyCommunicationText;
}());

var CompanyCommunicationBanner = (function () {
    function CompanyCommunicationBanner() {
    }
    return CompanyCommunicationBanner;
}());

//# sourceMappingURL=communication-preference.model.js.map

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__google_maps_api_wrapper__ = __webpack_require__(77);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoMarkerManager; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var InfoMarkerManager = (function () {
    function InfoMarkerManager(_zone, _mapsWrapper) {
        this._zone = _zone;
        this._mapsWrapper = _mapsWrapper;
        this._infoMarkers = new Map();
        this._popOvers = new Map();
    }
    InfoMarkerManager.prototype.addInfoMarker = function (key, infoWindow) {
        this._infoMarkers.set(key, infoWindow);
    };
    InfoMarkerManager.prototype.deleteInfoMarker = function (key) {
        return this._infoMarkers.delete(key);
    };
    InfoMarkerManager.prototype.getMarker = function (key) {
        return this._infoMarkers.get(key);
    };
    InfoMarkerManager.prototype.addPopOver = function (key, popOver) {
        this._popOvers.set(key, popOver);
    };
    InfoMarkerManager.prototype.deletePopOver = function (key) {
        return this._popOvers.delete(key);
    };
    InfoMarkerManager.prototype.getPopOver = function (key) {
        return this._popOvers.get(key);
    };
    return InfoMarkerManager;
}());
InfoMarkerManager = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */]) === "function" && _b || Object])
], InfoMarkerManager);

var _a, _b;
//# sourceMappingURL=info-marker-manager.js.map

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__ = __webpack_require__(77);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarkerManager; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var MarkerManager = (function () {
    function MarkerManager(_mapsWrapper, _zone) {
        this._mapsWrapper = _mapsWrapper;
        this._zone = _zone;
        this._markers = new Map();
    }
    MarkerManager.prototype.deleteMarker = function (marker) {
        var _this = this;
        var m = this._markers.get(marker);
        if (m == null) {
            // marker already deleted
            return Promise.resolve();
        }
        return m.then(function (m) {
            return _this._zone.run(function () {
                m.setMap(null);
                _this._markers.delete(marker);
            });
        });
    };
    MarkerManager.prototype.updateMarkerPosition = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setPosition({ lat: marker.latitude, lng: marker.longitude }); });
    };
    MarkerManager.prototype.updateTitle = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setTitle(marker.title); });
    };
    MarkerManager.prototype.updateLabel = function (marker) {
        return this._markers.get(marker).then(function (m) { m.setLabel(marker.label); });
    };
    MarkerManager.prototype.updateDraggable = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setDraggable(marker.draggable); });
    };
    MarkerManager.prototype.updateIcon = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setIcon(marker.iconUrl); });
    };
    MarkerManager.prototype.updateOpacity = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setOpacity(marker.opacity); });
    };
    MarkerManager.prototype.updateVisible = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setVisible(marker.visible); });
    };
    MarkerManager.prototype.updateZIndex = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setZIndex(marker.zIndex); });
    };
    MarkerManager.prototype.updateClickable = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setClickable(marker.clickable); });
    };
    MarkerManager.prototype.updateAnimation = function (marker) {
        return this._markers.get(marker).then(function (m) {
            if (typeof marker.animation === 'string') {
                m.setAnimation(google.maps.Animation[marker.animation]);
            }
            else {
                m.setAnimation(marker.animation);
            }
        });
    };
    MarkerManager.prototype.addMarker = function (marker) {
        var markerPromise = this._mapsWrapper.createMarker({
            position: { lat: marker.latitude, lng: marker.longitude },
            label: marker.label,
            draggable: marker.draggable,
            icon: marker.iconUrl,
            opacity: marker.opacity,
            visible: marker.visible,
            zIndex: marker.zIndex,
            title: marker.title,
            clickable: marker.clickable,
            animation: (typeof marker.animation === 'string') ? google.maps.Animation[marker.animation] : marker.animation
        });
        this._markers.set(marker, markerPromise);
    };
    MarkerManager.prototype.getNativeMarker = function (marker) {
        return this._markers.get(marker);
    };
    MarkerManager.prototype.createEventObservable = function (eventName, marker) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].create(function (observer) {
            _this._markers.get(marker).then(function (m) {
                m.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
            });
        });
    };
    return MarkerManager;
}());
MarkerManager = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]) === "function" && _b || Object])
], MarkerManager);

var _a, _b;
//# sourceMappingURL=marker-manager.js.map

/***/ }),
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ngx_clipboard__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_menu_account_menu_component__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pipes_act_date_pipe__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__act_image_act_image_component__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utilities_act_map_act_map_module__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__address_form_address_form_component__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__address_list_address_list_component__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__approval_approval_action_approval_action_component__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__approval_button_approval_button_component__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__banner_promotion_banner_promotion_component__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__billing_address_billing_address_component__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__billing_address_billing_form_billing_form_component__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__cart_cart_component__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_pipes_comma_currency_pipe__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__angular_common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives_daterangepicker_daterangepicker_module__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modal_dialog_alert_dialog_alert_component__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_components_dialog_cancellation_booking_dialog_cancellation_booking_component__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modal_dialog_cancellation_dialog_cancellation_component__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modal_dialog_dialog_component__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modal_dialog_confirm_action_dialog_confirm_action_component__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modal_dialog_confirm_dialog_confirm_component__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modal_dialog_error_dialog_error_component__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_app_components_dialog_filter_booking_dialog_filter_booking_component__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_app_components_modal_dialog_general_message_dialog_general_message_component__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modal_dialog_map_dialog_map_component__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modal_dialog_map_nearby_dialog_map_nearby_component__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__modal_dialog_notify_budget_dialog_notify_budget_component__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__modal_dialog_success_dialog_success_component__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__modal_dialog_terms_and_conditions_dialog_terms_and_conditions_component__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__footer_footer_component__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__footer_copyright_footer_copyright_component__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__google_map_google_map_component__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__modal_dialog_map_nearby_info_window_content_info_window_content_component__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__input_suggestion_input_suggestion_component__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__lang_dropdown_lang_dropdown_component__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__menu_bar_menu_bar_component__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pagination_pagination_component__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__roomtype_item_roomtype_item_component__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pipes_round_pipe__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__search_box_search_box_component__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__show_more_content_box_show_more_content_box_component__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__star_rating_star_rating_component__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__terms_and_conditions_terms_and_conditions_component__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_angular2_text_mask__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_angular2_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_angular2_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__directives_typeahead_typeahead_module__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__directives_UnMaskInput_un_mask_module__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_app_components_upload_file_upload_file_component__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__modal_dialog_map_poi_dialog_map_poi_component__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__promotion_promotion_menu_bar_promotion_menu_bar_component__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__promotion_promotion_search_box_promotion_search_box_component__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__modal_dialog_condition_change_dialog_condition_change_component__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__modal_dialog_special_day_dialog_special_day_component__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__modal_dialog_booking_report_dialog_booking_report_component__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__form_autocomplete_form_autocomplete_component__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__gallery_gallery_component__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__carousel_carousel_component__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__modal_dialog_quotation_form_dialog_quotation_form_component__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__slide_show_slide_show_component__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_app_pipes_translate_singular_plural_pipe__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__hotel_remark_information_hotel_remark_information_component__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_app_directives_ImagePreload_image_preload_module__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__menu_bar_dialog_switch_company_dialog_switch_company_component__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_app_pipes_replaceLineBreaks_pipe__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__toggle_button_toggle_button_component__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__filter_dropdown_filter_dropdown_component__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__slider_range_slider_range_component__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__modal_dialog_tax_address_dialog_tax_address_component__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__modal_dialog_budget_suggestion_dialog_budget_suggestion_component__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__cart_dialog_cart_summary_dialog_cart_summary_component__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__modal_dialog_multi_payment_dialog_multi_payment_component__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__service_and_privacy_service_and_privacy_component__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__payment_summary_payment_summary_component__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__payment_method_details_payment_method_details_component__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__booking_detail_booking_detail_component__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__modal_dialog_see_all_properties_dialog_see_all_properties_component__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__icon_dropdown_icon_dropdown_component__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__budget_limit_dialog_budget_limit_dialog_budget_limit_detail_dialog_budget_limit_detail_component__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__budget_limit_dialog_budget_limit_dialog_budget_limit_mobile_dialog_budget_limit_mobile_component__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__budget_limit_budget_limit_component__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__modal_dialog_share_budget_dialog_share_budget_component__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__modal_dialog_share_budget_dialog_share_budget_detail_dialog_share_budget_detail_component__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__modal_dialog_room_note_dialog_room_note_component__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__modal_dialog_room_note_description_dialog_room_note_description_component__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_app_pipes_safeHTML_pipe__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__subscription_subscription_component__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__modal_dialog_information_cart_dialog_information_cart_component__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_app_pipes_split_join_pipe__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__modal_dialog_list_dialog_list_component__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__fleet_card_select_box_fleet_card_select_box_component__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__payment_method_payment_method_component__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__payment_channel_select_box_payment_channel_select_box_component__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_app_pipes_fullyear_pipe__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__act_text_area_act_text_area_component__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__modal_dialog_company_communication_text_dialog_company_communication_text_component__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__modal_dialog_company_communication_banner_dialog_company_communication_banner_component__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__banner_billboard_banner_billboard_component__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__modal_dialog_banner_overlay_dialog_banner_overlay_component__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__banner_leaderboard_banner_leaderboard_component__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__menu_bar_dialog_switch_lang_currency_dialog_switch_lang_currency_component__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106_app_pipes_convert_exchange_pipe__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__modal_dialog_change_password_dialog_change_password_component__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__modal_dialog_pin_dialog_pin_component__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__modal_dialog_pin_pin_pin_component__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__modal_dialog_pin_dialog_alert_pin_dialog_alert_pin_component__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__verify_otp_verify_otp_component__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__verify_otp_otp_otp_component__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__modal_dialog_phone_dialog_phone_component__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__verify_otp_verify_method_verify_method_component__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115_app_pages_my_profile_dialog_my_profile_dialog_my_profile_component__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116_app_pages_my_profile_dialog_my_profile_dialog_my_profile_form__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__cart_dialog_taxes_fees_dialog_taxes_fees_component__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__cart_dialog_use_promotion_code_dialog_use_promotion_code_component__ = __webpack_require__(246);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComponentsModule; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};























































































































var ComponentsModule = (function () {
    function ComponentsModule() {
    }
    return ComponentsModule;
}());
ComponentsModule = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39__angular_core__["NgModule"])({
        imports: [
            __WEBPACK_IMPORTED_MODULE_16__angular_common__["a" /* CommonModule */],
            __WEBPACK_IMPORTED_MODULE_0__angular_forms__["ReactiveFormsModule"],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogModule */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["f" /* MdMenuModule */],
            __WEBPACK_IMPORTED_MODULE_50__directives_typeahead_typeahead_module__["a" /* TypeaheadModule */],
            __WEBPACK_IMPORTED_MODULE_17__directives_daterangepicker_daterangepicker_module__["a" /* DaterangepickerModule */],
            __WEBPACK_IMPORTED_MODULE_67_app_directives_ImagePreload_image_preload_module__["a" /* ImagePreloadModule */],
            __WEBPACK_IMPORTED_MODULE_43__angular_router__["a" /* RouterModule */],
            __WEBPACK_IMPORTED_MODULE_48_angular2_text_mask__["TextMaskModule"],
            __WEBPACK_IMPORTED_MODULE_51__directives_UnMaskInput_un_mask_module__["a" /* UnMaskInputModule */],
            __WEBPACK_IMPORTED_MODULE_0__angular_forms__["FormsModule"],
            __WEBPACK_IMPORTED_MODULE_6_app_utilities_act_map_act_map_module__["a" /* ActMapModule */].forRoot({ apiKey: __WEBPACK_IMPORTED_MODULE_53_environments_environment__["a" /* environment */].googleMapKey }),
            __WEBPACK_IMPORTED_MODULE_2_ngx_clipboard__["a" /* ClipboardModule */],
        ],
        exports: [
            __WEBPACK_IMPORTED_MODULE_16__angular_common__["a" /* CommonModule */],
            __WEBPACK_IMPORTED_MODULE_0__angular_forms__["FormsModule"],
            __WEBPACK_IMPORTED_MODULE_0__angular_forms__["ReactiveFormsModule"],
            __WEBPACK_IMPORTED_MODULE_38__menu_bar_menu_bar_component__["a" /* MenuBarComponent */],
            __WEBPACK_IMPORTED_MODULE_44__search_box_search_box_component__["a" /* SearchBoxComponent */],
            __WEBPACK_IMPORTED_MODULE_32__footer_footer_component__["a" /* FooterComponent */],
            __WEBPACK_IMPORTED_MODULE_33__footer_copyright_footer_copyright_component__["a" /* FooterCopyrightComponent */],
            __WEBPACK_IMPORTED_MODULE_49__pipes_translate_pipe__["a" /* TranslatePipe */],
            __WEBPACK_IMPORTED_MODULE_106_app_pipes_convert_exchange_pipe__["a" /* ConvertExchangePipe */],
            __WEBPACK_IMPORTED_MODULE_42__pipes_round_pipe__["a" /* RoundPipe */],
            __WEBPACK_IMPORTED_MODULE_4__pipes_act_date_pipe__["a" /* ActDatePipe */],
            __WEBPACK_IMPORTED_MODULE_15_app_pipes_comma_currency_pipe__["a" /* CommaCurrencyPipe */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogModule */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["f" /* MdMenuModule */],
            __WEBPACK_IMPORTED_MODULE_37__lang_dropdown_lang_dropdown_component__["a" /* LangDropdownComponent */],
            __WEBPACK_IMPORTED_MODULE_14__cart_cart_component__["a" /* CartComponent */],
            __WEBPACK_IMPORTED_MODULE_3__account_menu_account_menu_component__["a" /* AccountMenuComponent */],
            __WEBPACK_IMPORTED_MODULE_18__modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */],
            __WEBPACK_IMPORTED_MODULE_34__google_map_google_map_component__["a" /* GoogleMapComponent */],
            __WEBPACK_IMPORTED_MODULE_45__show_more_content_box_show_more_content_box_component__["a" /* ShowMoreContentBoxComponent */],
            __WEBPACK_IMPORTED_MODULE_21__modal_dialog_dialog_component__["a" /* DialogComponent */],
            __WEBPACK_IMPORTED_MODULE_5__act_image_act_image_component__["a" /* ActImageComponent */],
            __WEBPACK_IMPORTED_MODULE_27__modal_dialog_map_dialog_map_component__["a" /* DialogMapComponent */],
            __WEBPACK_IMPORTED_MODULE_40__pagination_pagination_component__["a" /* PaginationComponent */],
            __WEBPACK_IMPORTED_MODULE_26_app_components_modal_dialog_general_message_dialog_general_message_component__["a" /* DialogGeneralMessageComponent */],
            __WEBPACK_IMPORTED_MODULE_22__modal_dialog_confirm_action_dialog_confirm_action_component__["a" /* DialogConfirmActionComponent */],
            __WEBPACK_IMPORTED_MODULE_47__terms_and_conditions_terms_and_conditions_component__["a" /* TermsAndConditionsComponent */],
            __WEBPACK_IMPORTED_MODULE_77__service_and_privacy_service_and_privacy_component__["a" /* ServiceAndPrivacyComponent */],
            __WEBPACK_IMPORTED_MODULE_30__modal_dialog_success_dialog_success_component__["a" /* DialogSuccessComponent */],
            __WEBPACK_IMPORTED_MODULE_24__modal_dialog_error_dialog_error_component__["a" /* DialogErrorComponent */],
            __WEBPACK_IMPORTED_MODULE_41__roomtype_item_roomtype_item_component__["a" /* RoomtypeItemComponent */],
            __WEBPACK_IMPORTED_MODULE_8__address_list_address_list_component__["a" /* AddressListComponent */],
            __WEBPACK_IMPORTED_MODULE_7__address_form_address_form_component__["a" /* AddressFormComponent */],
            __WEBPACK_IMPORTED_MODULE_52_app_components_upload_file_upload_file_component__["a" /* UploadFileComponent */],
            __WEBPACK_IMPORTED_MODULE_12__billing_address_billing_address_component__["a" /* BillingAddressComponent */],
            __WEBPACK_IMPORTED_MODULE_13__billing_address_billing_form_billing_form_component__["a" /* BillingFormComponent */],
            __WEBPACK_IMPORTED_MODULE_20__modal_dialog_cancellation_dialog_cancellation_component__["a" /* DialogCancellationComponent */],
            __WEBPACK_IMPORTED_MODULE_29__modal_dialog_notify_budget_dialog_notify_budget_component__["a" /* DialogNotifyBudgetComponent */],
            __WEBPACK_IMPORTED_MODULE_36__input_suggestion_input_suggestion_component__["a" /* InputSuggestionComponent */],
            __WEBPACK_IMPORTED_MODULE_25_app_components_dialog_filter_booking_dialog_filter_booking_component__["a" /* DialogFilterBookingComponent */],
            __WEBPACK_IMPORTED_MODULE_19_app_components_dialog_cancellation_booking_dialog_cancellation_booking_component__["a" /* DialogCancelBookingComponent */],
            __WEBPACK_IMPORTED_MODULE_10__approval_button_approval_button_component__["a" /* ApprovalButtonComponent */],
            __WEBPACK_IMPORTED_MODULE_9__approval_approval_action_approval_action_component__["a" /* ApprovalActionComponent */],
            __WEBPACK_IMPORTED_MODULE_35__modal_dialog_map_nearby_info_window_content_info_window_content_component__["a" /* InfoWindowContentComponent */],
            __WEBPACK_IMPORTED_MODULE_46__star_rating_star_rating_component__["a" /* StarRatingComponent */],
            __WEBPACK_IMPORTED_MODULE_11__banner_promotion_banner_promotion_component__["a" /* BannerPromotionComponent */],
            __WEBPACK_IMPORTED_MODULE_55__promotion_promotion_menu_bar_promotion_menu_bar_component__["a" /* PromotionMenuBarComponent */],
            __WEBPACK_IMPORTED_MODULE_56__promotion_promotion_search_box_promotion_search_box_component__["a" /* PromotionSearchBoxComponent */],
            __WEBPACK_IMPORTED_MODULE_58__modal_dialog_special_day_dialog_special_day_component__["a" /* DialogSpecialDayComponent */],
            __WEBPACK_IMPORTED_MODULE_59__modal_dialog_booking_report_dialog_booking_report_component__["a" /* DialogBookingReportComponent */],
            __WEBPACK_IMPORTED_MODULE_60__form_autocomplete_form_autocomplete_component__["a" /* FormAutocompleteComponent */],
            __WEBPACK_IMPORTED_MODULE_61__gallery_gallery_component__["a" /* GalleryComponent */],
            __WEBPACK_IMPORTED_MODULE_62__carousel_carousel_component__["a" /* CarouselComponent */],
            __WEBPACK_IMPORTED_MODULE_64__slide_show_slide_show_component__["a" /* SlideShowComponent */],
            __WEBPACK_IMPORTED_MODULE_65_app_pipes_translate_singular_plural_pipe__["a" /* TranslateSingularPluralPipe */],
            __WEBPACK_IMPORTED_MODULE_66__hotel_remark_information_hotel_remark_information_component__["a" /* HotelRemarkInformationComponent */],
            __WEBPACK_IMPORTED_MODULE_69_app_pipes_replaceLineBreaks_pipe__["a" /* ReplaceLineBreaksPipe */],
            __WEBPACK_IMPORTED_MODULE_70__toggle_button_toggle_button_component__["a" /* ToggleButtonComponent */],
            __WEBPACK_IMPORTED_MODULE_71__filter_dropdown_filter_dropdown_component__["b" /* FilterDropdownComponent */],
            __WEBPACK_IMPORTED_MODULE_72__slider_range_slider_range_component__["a" /* SliderRangeComponent */],
            __WEBPACK_IMPORTED_MODULE_75__cart_dialog_cart_summary_dialog_cart_summary_component__["a" /* DialogCartSummaryComponent */],
            __WEBPACK_IMPORTED_MODULE_76__modal_dialog_multi_payment_dialog_multi_payment_component__["a" /* DialogMultiPaymentComponent */],
            __WEBPACK_IMPORTED_MODULE_78__payment_summary_payment_summary_component__["a" /* PaymentSummaryComponent */],
            __WEBPACK_IMPORTED_MODULE_79__payment_method_details_payment_method_details_component__["a" /* PaymentMethodDetailsComponent */],
            __WEBPACK_IMPORTED_MODULE_80__booking_detail_booking_detail_component__["a" /* BookingDetailComponent */],
            __WEBPACK_IMPORTED_MODULE_81__modal_dialog_see_all_properties_dialog_see_all_properties_component__["a" /* DialogSeeAllPropertiesComponent */],
            __WEBPACK_IMPORTED_MODULE_82__icon_dropdown_icon_dropdown_component__["a" /* IconDropdownComponent */],
            __WEBPACK_IMPORTED_MODULE_85__budget_limit_budget_limit_component__["a" /* BudgetLimitComponent */],
            __WEBPACK_IMPORTED_MODULE_83__budget_limit_dialog_budget_limit_dialog_budget_limit_detail_dialog_budget_limit_detail_component__["a" /* DialogBudgetLimitDetailComponent */],
            __WEBPACK_IMPORTED_MODULE_84__budget_limit_dialog_budget_limit_dialog_budget_limit_mobile_dialog_budget_limit_mobile_component__["a" /* DialogBudgetLimitMobileComponent */],
            __WEBPACK_IMPORTED_MODULE_86__modal_dialog_share_budget_dialog_share_budget_component__["a" /* DialogShareBudgetComponent */],
            __WEBPACK_IMPORTED_MODULE_87__modal_dialog_share_budget_dialog_share_budget_detail_dialog_share_budget_detail_component__["a" /* DialogShareBudgetDetailComponent */],
            __WEBPACK_IMPORTED_MODULE_90_app_pipes_safeHTML_pipe__["a" /* SafeHTMLPipe */],
            __WEBPACK_IMPORTED_MODULE_91__subscription_subscription_component__["a" /* SubscriptionComponent */],
            __WEBPACK_IMPORTED_MODULE_93_app_pipes_split_join_pipe__["a" /* SplitJoinPipe */],
            __WEBPACK_IMPORTED_MODULE_95__fleet_card_select_box_fleet_card_select_box_component__["a" /* FleetCardSelectBoxComponent */],
            __WEBPACK_IMPORTED_MODULE_96__payment_method_payment_method_component__["a" /* PaymentMethodComponent */],
            __WEBPACK_IMPORTED_MODULE_97__payment_channel_select_box_payment_channel_select_box_component__["a" /* PaymentChannelSelectBoxComponent */],
            __WEBPACK_IMPORTED_MODULE_98_app_pipes_fullyear_pipe__["a" /* FullyearPipe */],
            __WEBPACK_IMPORTED_MODULE_102__banner_billboard_banner_billboard_component__["a" /* BannerBillboardComponent */],
            __WEBPACK_IMPORTED_MODULE_104__banner_leaderboard_banner_leaderboard_component__["a" /* BannerLeaderboardComponent */],
            __WEBPACK_IMPORTED_MODULE_108__modal_dialog_pin_dialog_pin_component__["a" /* DialogPinComponent */],
            __WEBPACK_IMPORTED_MODULE_109__modal_dialog_pin_pin_pin_component__["a" /* PinComponent */],
            __WEBPACK_IMPORTED_MODULE_110__modal_dialog_pin_dialog_alert_pin_dialog_alert_pin_component__["a" /* DialogAlertPinComponent */]
        ],
        declarations: [
            __WEBPACK_IMPORTED_MODULE_49__pipes_translate_pipe__["a" /* TranslatePipe */],
            __WEBPACK_IMPORTED_MODULE_106_app_pipes_convert_exchange_pipe__["a" /* ConvertExchangePipe */],
            __WEBPACK_IMPORTED_MODULE_4__pipes_act_date_pipe__["a" /* ActDatePipe */],
            __WEBPACK_IMPORTED_MODULE_42__pipes_round_pipe__["a" /* RoundPipe */],
            __WEBPACK_IMPORTED_MODULE_15_app_pipes_comma_currency_pipe__["a" /* CommaCurrencyPipe */],
            __WEBPACK_IMPORTED_MODULE_38__menu_bar_menu_bar_component__["a" /* MenuBarComponent */],
            __WEBPACK_IMPORTED_MODULE_44__search_box_search_box_component__["a" /* SearchBoxComponent */],
            __WEBPACK_IMPORTED_MODULE_32__footer_footer_component__["a" /* FooterComponent */],
            __WEBPACK_IMPORTED_MODULE_37__lang_dropdown_lang_dropdown_component__["a" /* LangDropdownComponent */],
            __WEBPACK_IMPORTED_MODULE_14__cart_cart_component__["a" /* CartComponent */],
            __WEBPACK_IMPORTED_MODULE_3__account_menu_account_menu_component__["a" /* AccountMenuComponent */],
            __WEBPACK_IMPORTED_MODULE_18__modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */],
            __WEBPACK_IMPORTED_MODULE_34__google_map_google_map_component__["a" /* GoogleMapComponent */],
            __WEBPACK_IMPORTED_MODULE_45__show_more_content_box_show_more_content_box_component__["a" /* ShowMoreContentBoxComponent */],
            __WEBPACK_IMPORTED_MODULE_21__modal_dialog_dialog_component__["a" /* DialogComponent */],
            __WEBPACK_IMPORTED_MODULE_5__act_image_act_image_component__["a" /* ActImageComponent */],
            __WEBPACK_IMPORTED_MODULE_27__modal_dialog_map_dialog_map_component__["a" /* DialogMapComponent */],
            __WEBPACK_IMPORTED_MODULE_40__pagination_pagination_component__["a" /* PaginationComponent */],
            __WEBPACK_IMPORTED_MODULE_26_app_components_modal_dialog_general_message_dialog_general_message_component__["a" /* DialogGeneralMessageComponent */],
            __WEBPACK_IMPORTED_MODULE_47__terms_and_conditions_terms_and_conditions_component__["a" /* TermsAndConditionsComponent */],
            __WEBPACK_IMPORTED_MODULE_77__service_and_privacy_service_and_privacy_component__["a" /* ServiceAndPrivacyComponent */],
            __WEBPACK_IMPORTED_MODULE_31__modal_dialog_terms_and_conditions_dialog_terms_and_conditions_component__["a" /* DialogTermsAndConditionsComponent */],
            __WEBPACK_IMPORTED_MODULE_30__modal_dialog_success_dialog_success_component__["a" /* DialogSuccessComponent */],
            __WEBPACK_IMPORTED_MODULE_24__modal_dialog_error_dialog_error_component__["a" /* DialogErrorComponent */],
            __WEBPACK_IMPORTED_MODULE_33__footer_copyright_footer_copyright_component__["a" /* FooterCopyrightComponent */],
            __WEBPACK_IMPORTED_MODULE_41__roomtype_item_roomtype_item_component__["a" /* RoomtypeItemComponent */],
            __WEBPACK_IMPORTED_MODULE_23__modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */],
            __WEBPACK_IMPORTED_MODULE_22__modal_dialog_confirm_action_dialog_confirm_action_component__["a" /* DialogConfirmActionComponent */],
            __WEBPACK_IMPORTED_MODULE_8__address_list_address_list_component__["a" /* AddressListComponent */],
            __WEBPACK_IMPORTED_MODULE_7__address_form_address_form_component__["a" /* AddressFormComponent */],
            __WEBPACK_IMPORTED_MODULE_20__modal_dialog_cancellation_dialog_cancellation_component__["a" /* DialogCancellationComponent */],
            __WEBPACK_IMPORTED_MODULE_29__modal_dialog_notify_budget_dialog_notify_budget_component__["a" /* DialogNotifyBudgetComponent */],
            __WEBPACK_IMPORTED_MODULE_52_app_components_upload_file_upload_file_component__["a" /* UploadFileComponent */],
            __WEBPACK_IMPORTED_MODULE_12__billing_address_billing_address_component__["a" /* BillingAddressComponent */],
            __WEBPACK_IMPORTED_MODULE_13__billing_address_billing_form_billing_form_component__["a" /* BillingFormComponent */],
            __WEBPACK_IMPORTED_MODULE_36__input_suggestion_input_suggestion_component__["a" /* InputSuggestionComponent */],
            __WEBPACK_IMPORTED_MODULE_25_app_components_dialog_filter_booking_dialog_filter_booking_component__["a" /* DialogFilterBookingComponent */],
            __WEBPACK_IMPORTED_MODULE_19_app_components_dialog_cancellation_booking_dialog_cancellation_booking_component__["a" /* DialogCancelBookingComponent */],
            __WEBPACK_IMPORTED_MODULE_10__approval_button_approval_button_component__["a" /* ApprovalButtonComponent */],
            __WEBPACK_IMPORTED_MODULE_9__approval_approval_action_approval_action_component__["a" /* ApprovalActionComponent */],
            __WEBPACK_IMPORTED_MODULE_28__modal_dialog_map_nearby_dialog_map_nearby_component__["a" /* DialogMapNearbyComponent */],
            __WEBPACK_IMPORTED_MODULE_54__modal_dialog_map_poi_dialog_map_poi_component__["a" /* DialogMapPoiComponent */],
            __WEBPACK_IMPORTED_MODULE_35__modal_dialog_map_nearby_info_window_content_info_window_content_component__["a" /* InfoWindowContentComponent */],
            __WEBPACK_IMPORTED_MODULE_46__star_rating_star_rating_component__["a" /* StarRatingComponent */],
            __WEBPACK_IMPORTED_MODULE_11__banner_promotion_banner_promotion_component__["a" /* BannerPromotionComponent */],
            __WEBPACK_IMPORTED_MODULE_54__modal_dialog_map_poi_dialog_map_poi_component__["a" /* DialogMapPoiComponent */],
            __WEBPACK_IMPORTED_MODULE_55__promotion_promotion_menu_bar_promotion_menu_bar_component__["a" /* PromotionMenuBarComponent */],
            __WEBPACK_IMPORTED_MODULE_56__promotion_promotion_search_box_promotion_search_box_component__["a" /* PromotionSearchBoxComponent */],
            __WEBPACK_IMPORTED_MODULE_57__modal_dialog_condition_change_dialog_condition_change_component__["a" /* DialogConditionChangeComponent */],
            __WEBPACK_IMPORTED_MODULE_58__modal_dialog_special_day_dialog_special_day_component__["a" /* DialogSpecialDayComponent */],
            __WEBPACK_IMPORTED_MODULE_59__modal_dialog_booking_report_dialog_booking_report_component__["a" /* DialogBookingReportComponent */],
            __WEBPACK_IMPORTED_MODULE_60__form_autocomplete_form_autocomplete_component__["a" /* FormAutocompleteComponent */],
            __WEBPACK_IMPORTED_MODULE_61__gallery_gallery_component__["a" /* GalleryComponent */],
            __WEBPACK_IMPORTED_MODULE_62__carousel_carousel_component__["a" /* CarouselComponent */],
            __WEBPACK_IMPORTED_MODULE_63__modal_dialog_quotation_form_dialog_quotation_form_component__["a" /* DialogQuotationFormComponent */],
            __WEBPACK_IMPORTED_MODULE_64__slide_show_slide_show_component__["a" /* SlideShowComponent */],
            __WEBPACK_IMPORTED_MODULE_65_app_pipes_translate_singular_plural_pipe__["a" /* TranslateSingularPluralPipe */],
            __WEBPACK_IMPORTED_MODULE_66__hotel_remark_information_hotel_remark_information_component__["a" /* HotelRemarkInformationComponent */],
            __WEBPACK_IMPORTED_MODULE_68__menu_bar_dialog_switch_company_dialog_switch_company_component__["a" /* DialogSwitchCompanyComponent */],
            __WEBPACK_IMPORTED_MODULE_69_app_pipes_replaceLineBreaks_pipe__["a" /* ReplaceLineBreaksPipe */],
            __WEBPACK_IMPORTED_MODULE_70__toggle_button_toggle_button_component__["a" /* ToggleButtonComponent */],
            __WEBPACK_IMPORTED_MODULE_71__filter_dropdown_filter_dropdown_component__["b" /* FilterDropdownComponent */],
            __WEBPACK_IMPORTED_MODULE_72__slider_range_slider_range_component__["a" /* SliderRangeComponent */],
            __WEBPACK_IMPORTED_MODULE_73__modal_dialog_tax_address_dialog_tax_address_component__["a" /* DialogTaxAddressComponent */],
            __WEBPACK_IMPORTED_MODULE_74__modal_dialog_budget_suggestion_dialog_budget_suggestion_component__["a" /* DialogBudgetSuggestionComponent */],
            __WEBPACK_IMPORTED_MODULE_75__cart_dialog_cart_summary_dialog_cart_summary_component__["a" /* DialogCartSummaryComponent */],
            __WEBPACK_IMPORTED_MODULE_76__modal_dialog_multi_payment_dialog_multi_payment_component__["a" /* DialogMultiPaymentComponent */],
            __WEBPACK_IMPORTED_MODULE_78__payment_summary_payment_summary_component__["a" /* PaymentSummaryComponent */],
            __WEBPACK_IMPORTED_MODULE_79__payment_method_details_payment_method_details_component__["a" /* PaymentMethodDetailsComponent */],
            __WEBPACK_IMPORTED_MODULE_80__booking_detail_booking_detail_component__["a" /* BookingDetailComponent */],
            __WEBPACK_IMPORTED_MODULE_81__modal_dialog_see_all_properties_dialog_see_all_properties_component__["a" /* DialogSeeAllPropertiesComponent */],
            __WEBPACK_IMPORTED_MODULE_82__icon_dropdown_icon_dropdown_component__["a" /* IconDropdownComponent */],
            __WEBPACK_IMPORTED_MODULE_85__budget_limit_budget_limit_component__["a" /* BudgetLimitComponent */],
            __WEBPACK_IMPORTED_MODULE_83__budget_limit_dialog_budget_limit_dialog_budget_limit_detail_dialog_budget_limit_detail_component__["a" /* DialogBudgetLimitDetailComponent */],
            __WEBPACK_IMPORTED_MODULE_84__budget_limit_dialog_budget_limit_dialog_budget_limit_mobile_dialog_budget_limit_mobile_component__["a" /* DialogBudgetLimitMobileComponent */],
            __WEBPACK_IMPORTED_MODULE_86__modal_dialog_share_budget_dialog_share_budget_component__["a" /* DialogShareBudgetComponent */],
            __WEBPACK_IMPORTED_MODULE_87__modal_dialog_share_budget_dialog_share_budget_detail_dialog_share_budget_detail_component__["a" /* DialogShareBudgetDetailComponent */],
            __WEBPACK_IMPORTED_MODULE_88__modal_dialog_room_note_dialog_room_note_component__["a" /* DialogRoomNoteComponent */],
            __WEBPACK_IMPORTED_MODULE_89__modal_dialog_room_note_description_dialog_room_note_description_component__["a" /* DialogRoomNoteDescriptionComponent */],
            __WEBPACK_IMPORTED_MODULE_90_app_pipes_safeHTML_pipe__["a" /* SafeHTMLPipe */],
            __WEBPACK_IMPORTED_MODULE_91__subscription_subscription_component__["a" /* SubscriptionComponent */],
            __WEBPACK_IMPORTED_MODULE_92__modal_dialog_information_cart_dialog_information_cart_component__["a" /* DialogInformationCartComponent */],
            __WEBPACK_IMPORTED_MODULE_93_app_pipes_split_join_pipe__["a" /* SplitJoinPipe */],
            __WEBPACK_IMPORTED_MODULE_94__modal_dialog_list_dialog_list_component__["a" /* DialogListComponent */],
            __WEBPACK_IMPORTED_MODULE_95__fleet_card_select_box_fleet_card_select_box_component__["a" /* FleetCardSelectBoxComponent */],
            __WEBPACK_IMPORTED_MODULE_96__payment_method_payment_method_component__["a" /* PaymentMethodComponent */],
            __WEBPACK_IMPORTED_MODULE_97__payment_channel_select_box_payment_channel_select_box_component__["a" /* PaymentChannelSelectBoxComponent */],
            __WEBPACK_IMPORTED_MODULE_98_app_pipes_fullyear_pipe__["a" /* FullyearPipe */],
            __WEBPACK_IMPORTED_MODULE_99__act_text_area_act_text_area_component__["a" /* ActTextAreaComponent */],
            __WEBPACK_IMPORTED_MODULE_100__modal_dialog_company_communication_text_dialog_company_communication_text_component__["a" /* DialogCompanyCommunicationTextComponent */],
            __WEBPACK_IMPORTED_MODULE_101__modal_dialog_company_communication_banner_dialog_company_communication_banner_component__["a" /* DialogCompanyCommunicationBannerComponent */],
            __WEBPACK_IMPORTED_MODULE_102__banner_billboard_banner_billboard_component__["a" /* BannerBillboardComponent */],
            __WEBPACK_IMPORTED_MODULE_103__modal_dialog_banner_overlay_dialog_banner_overlay_component__["a" /* DialogBannerOverlayComponent */],
            __WEBPACK_IMPORTED_MODULE_104__banner_leaderboard_banner_leaderboard_component__["a" /* BannerLeaderboardComponent */],
            __WEBPACK_IMPORTED_MODULE_105__menu_bar_dialog_switch_lang_currency_dialog_switch_lang_currency_component__["a" /* DialogSwitchLangCurrencyComponent */],
            __WEBPACK_IMPORTED_MODULE_107__modal_dialog_change_password_dialog_change_password_component__["a" /* DialogChangePasswordComponent */],
            __WEBPACK_IMPORTED_MODULE_108__modal_dialog_pin_dialog_pin_component__["a" /* DialogPinComponent */],
            __WEBPACK_IMPORTED_MODULE_109__modal_dialog_pin_pin_pin_component__["a" /* PinComponent */],
            __WEBPACK_IMPORTED_MODULE_110__modal_dialog_pin_dialog_alert_pin_dialog_alert_pin_component__["a" /* DialogAlertPinComponent */],
            __WEBPACK_IMPORTED_MODULE_111__verify_otp_verify_otp_component__["a" /* VerifyOtpComponent */],
            __WEBPACK_IMPORTED_MODULE_112__verify_otp_otp_otp_component__["a" /* OtpComponent */],
            __WEBPACK_IMPORTED_MODULE_114__verify_otp_verify_method_verify_method_component__["a" /* VerifyMethodComponent */],
            __WEBPACK_IMPORTED_MODULE_113__modal_dialog_phone_dialog_phone_component__["a" /* DialogPhoneComponent */],
            __WEBPACK_IMPORTED_MODULE_115_app_pages_my_profile_dialog_my_profile_dialog_my_profile_component__["a" /* DialogMyProfileComponent */],
            __WEBPACK_IMPORTED_MODULE_117__cart_dialog_taxes_fees_dialog_taxes_fees_component__["a" /* DialogTaxesFeesComponent */],
            __WEBPACK_IMPORTED_MODULE_118__cart_dialog_use_promotion_code_dialog_use_promotion_code_component__["a" /* DialogUsePromotionCodeComponent */]
        ],
        entryComponents: [
            __WEBPACK_IMPORTED_MODULE_18__modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */],
            __WEBPACK_IMPORTED_MODULE_21__modal_dialog_dialog_component__["a" /* DialogComponent */],
            __WEBPACK_IMPORTED_MODULE_5__act_image_act_image_component__["a" /* ActImageComponent */],
            __WEBPACK_IMPORTED_MODULE_26_app_components_modal_dialog_general_message_dialog_general_message_component__["a" /* DialogGeneralMessageComponent */],
            __WEBPACK_IMPORTED_MODULE_31__modal_dialog_terms_and_conditions_dialog_terms_and_conditions_component__["a" /* DialogTermsAndConditionsComponent */],
            __WEBPACK_IMPORTED_MODULE_47__terms_and_conditions_terms_and_conditions_component__["a" /* TermsAndConditionsComponent */],
            __WEBPACK_IMPORTED_MODULE_30__modal_dialog_success_dialog_success_component__["a" /* DialogSuccessComponent */],
            __WEBPACK_IMPORTED_MODULE_24__modal_dialog_error_dialog_error_component__["a" /* DialogErrorComponent */],
            __WEBPACK_IMPORTED_MODULE_23__modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */],
            __WEBPACK_IMPORTED_MODULE_22__modal_dialog_confirm_action_dialog_confirm_action_component__["a" /* DialogConfirmActionComponent */],
            __WEBPACK_IMPORTED_MODULE_27__modal_dialog_map_dialog_map_component__["a" /* DialogMapComponent */],
            __WEBPACK_IMPORTED_MODULE_20__modal_dialog_cancellation_dialog_cancellation_component__["a" /* DialogCancellationComponent */],
            __WEBPACK_IMPORTED_MODULE_29__modal_dialog_notify_budget_dialog_notify_budget_component__["a" /* DialogNotifyBudgetComponent */],
            __WEBPACK_IMPORTED_MODULE_28__modal_dialog_map_nearby_dialog_map_nearby_component__["a" /* DialogMapNearbyComponent */],
            __WEBPACK_IMPORTED_MODULE_54__modal_dialog_map_poi_dialog_map_poi_component__["a" /* DialogMapPoiComponent */],
            __WEBPACK_IMPORTED_MODULE_58__modal_dialog_special_day_dialog_special_day_component__["a" /* DialogSpecialDayComponent */],
            __WEBPACK_IMPORTED_MODULE_59__modal_dialog_booking_report_dialog_booking_report_component__["a" /* DialogBookingReportComponent */],
            __WEBPACK_IMPORTED_MODULE_68__menu_bar_dialog_switch_company_dialog_switch_company_component__["a" /* DialogSwitchCompanyComponent */],
            __WEBPACK_IMPORTED_MODULE_73__modal_dialog_tax_address_dialog_tax_address_component__["a" /* DialogTaxAddressComponent */],
            __WEBPACK_IMPORTED_MODULE_74__modal_dialog_budget_suggestion_dialog_budget_suggestion_component__["a" /* DialogBudgetSuggestionComponent */],
            __WEBPACK_IMPORTED_MODULE_75__cart_dialog_cart_summary_dialog_cart_summary_component__["a" /* DialogCartSummaryComponent */],
            __WEBPACK_IMPORTED_MODULE_76__modal_dialog_multi_payment_dialog_multi_payment_component__["a" /* DialogMultiPaymentComponent */],
            __WEBPACK_IMPORTED_MODULE_81__modal_dialog_see_all_properties_dialog_see_all_properties_component__["a" /* DialogSeeAllPropertiesComponent */],
            __WEBPACK_IMPORTED_MODULE_82__icon_dropdown_icon_dropdown_component__["a" /* IconDropdownComponent */],
            __WEBPACK_IMPORTED_MODULE_83__budget_limit_dialog_budget_limit_dialog_budget_limit_detail_dialog_budget_limit_detail_component__["a" /* DialogBudgetLimitDetailComponent */],
            __WEBPACK_IMPORTED_MODULE_84__budget_limit_dialog_budget_limit_dialog_budget_limit_mobile_dialog_budget_limit_mobile_component__["a" /* DialogBudgetLimitMobileComponent */],
            __WEBPACK_IMPORTED_MODULE_86__modal_dialog_share_budget_dialog_share_budget_component__["a" /* DialogShareBudgetComponent */],
            __WEBPACK_IMPORTED_MODULE_87__modal_dialog_share_budget_dialog_share_budget_detail_dialog_share_budget_detail_component__["a" /* DialogShareBudgetDetailComponent */],
            __WEBPACK_IMPORTED_MODULE_88__modal_dialog_room_note_dialog_room_note_component__["a" /* DialogRoomNoteComponent */],
            __WEBPACK_IMPORTED_MODULE_89__modal_dialog_room_note_description_dialog_room_note_description_component__["a" /* DialogRoomNoteDescriptionComponent */],
            __WEBPACK_IMPORTED_MODULE_92__modal_dialog_information_cart_dialog_information_cart_component__["a" /* DialogInformationCartComponent */],
            __WEBPACK_IMPORTED_MODULE_94__modal_dialog_list_dialog_list_component__["a" /* DialogListComponent */],
            __WEBPACK_IMPORTED_MODULE_95__fleet_card_select_box_fleet_card_select_box_component__["a" /* FleetCardSelectBoxComponent */],
            __WEBPACK_IMPORTED_MODULE_100__modal_dialog_company_communication_text_dialog_company_communication_text_component__["a" /* DialogCompanyCommunicationTextComponent */],
            __WEBPACK_IMPORTED_MODULE_101__modal_dialog_company_communication_banner_dialog_company_communication_banner_component__["a" /* DialogCompanyCommunicationBannerComponent */],
            __WEBPACK_IMPORTED_MODULE_103__modal_dialog_banner_overlay_dialog_banner_overlay_component__["a" /* DialogBannerOverlayComponent */],
            __WEBPACK_IMPORTED_MODULE_105__menu_bar_dialog_switch_lang_currency_dialog_switch_lang_currency_component__["a" /* DialogSwitchLangCurrencyComponent */],
            __WEBPACK_IMPORTED_MODULE_107__modal_dialog_change_password_dialog_change_password_component__["a" /* DialogChangePasswordComponent */],
            __WEBPACK_IMPORTED_MODULE_108__modal_dialog_pin_dialog_pin_component__["a" /* DialogPinComponent */],
            __WEBPACK_IMPORTED_MODULE_110__modal_dialog_pin_dialog_alert_pin_dialog_alert_pin_component__["a" /* DialogAlertPinComponent */],
            __WEBPACK_IMPORTED_MODULE_113__modal_dialog_phone_dialog_phone_component__["a" /* DialogPhoneComponent */],
            __WEBPACK_IMPORTED_MODULE_115_app_pages_my_profile_dialog_my_profile_dialog_my_profile_component__["a" /* DialogMyProfileComponent */],
            __WEBPACK_IMPORTED_MODULE_117__cart_dialog_taxes_fees_dialog_taxes_fees_component__["a" /* DialogTaxesFeesComponent */],
            __WEBPACK_IMPORTED_MODULE_118__cart_dialog_use_promotion_code_dialog_use_promotion_code_component__["a" /* DialogUsePromotionCodeComponent */],
        ],
        providers: [
            __WEBPACK_IMPORTED_MODULE_16__angular_common__["k" /* DecimalPipe */],
            __WEBPACK_IMPORTED_MODULE_16__angular_common__["l" /* TitleCasePipe */],
            __WEBPACK_IMPORTED_MODULE_93_app_pipes_split_join_pipe__["a" /* SplitJoinPipe */],
            __WEBPACK_IMPORTED_MODULE_116_app_pages_my_profile_dialog_my_profile_dialog_my_profile_form__["a" /* DialogMyProfileForm */]
        ]
    })
], ComponentsModule);

//# sourceMappingURL=components.module.js.map

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_components_form_autocomplete_form_autocomplete__ = __webpack_require__(597);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GuestInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GuestInfoModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GuestInfoV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RoomModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GuestDetailsDto; });
/* unused harmony export GuestDetailsPayload */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Traveller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BookForTraveller; });
/* unused harmony export UserCondition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TravellerConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return AddNewGuestRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RoomGuestIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return AdditionalTravellerDetail; });
/* unused harmony export OccupancyInfoDTO */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var GuestInfo = (function () {
    function GuestInfo() {
    }
    return GuestInfo;
}());

var GuestInfoModel = (function () {
    function GuestInfoModel() {
        this.fullName = '';
        // Only for promotiom checkout
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.guestType = 'AD';
        this.countryId = '0';
        this.nationalityId = 'TH';
        this.specialRequest = '';
        this.savingGuest = false;
        this.nationality = 'TH';
    }
    return GuestInfoModel;
}());

var GuestInfoV2 = (function () {
    function GuestInfoV2(guestInfoModel) {
        this.fullName = '';
        // Only for promotiom checkout
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.guestType = 'AD';
        this.nationality = 'TH';
        this.savingGuest = false;
        this.fullName = guestInfoModel.fullName;
        this.firstName = guestInfoModel.firstName;
        this.lastName = guestInfoModel.lastName;
        this.email = guestInfoModel.email;
        this.guestType = guestInfoModel.guestType;
        this.nationality = guestInfoModel.nationalityId;
        this.savingGuest = guestInfoModel.savingGuest;
        this.mobileNumber = guestInfoModel.mobileNumber;
        this.countryISO2 = guestInfoModel.countryISO2;
        this.countryCallingCode = guestInfoModel.countryCallingCode;
        this.specialRequest = guestInfoModel.specialRequest;
    }
    return GuestInfoV2;
}());

var RoomModel = (function () {
    function RoomModel() {
    }
    return RoomModel;
}());

var GuestDetailsDto = (function () {
    function GuestDetailsDto() {
        this.guestInfoBookerTravellerList = [];
    }
    return GuestDetailsDto;
}());

var GuestDetailsPayload = (function () {
    function GuestDetailsPayload() {
    }
    return GuestDetailsPayload;
}());

var Traveller = (function (_super) {
    __extends(Traveller, _super);
    function Traveller(fullName, email, nationality, iso2, phone) {
        var _this = _super.call(this) || this;
        _this.fullName = fullName;
        _this.email = email;
        _this.nationality = nationality;
        _this.iso2 = iso2;
        _this.phone = phone;
        return _this;
    }
    return Traveller;
}(__WEBPACK_IMPORTED_MODULE_0_app_components_form_autocomplete_form_autocomplete__["a" /* FormAutocomplete */]));

var BookForTraveller = (function (_super) {
    __extends(BookForTraveller, _super);
    function BookForTraveller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayEmail = false;
        return _this;
    }
    return BookForTraveller;
}(Traveller));

var UserCondition = (function () {
    function UserCondition() {
    }
    return UserCondition;
}());

var TravellerConstants = (function () {
    function TravellerConstants() {
    }
    return TravellerConstants;
}());

TravellerConstants.MAX_SAVE_GUEST = 50;
var AddNewGuestRequest = (function () {
    function AddNewGuestRequest(travellers) {
        this.userGuests = travellers;
    }
    return AddNewGuestRequest;
}());

var RoomGuestIndex = (function () {
    function RoomGuestIndex(roomIndex, guestIndex) {
        this.roomIndex = roomIndex;
        this.guestIndex = guestIndex;
    }
    return RoomGuestIndex;
}());

var AdditionalTravellerDetail = (function () {
    function AdditionalTravellerDetail(fieldId, value, allowSavingData) {
        this.fieldId = fieldId;
        this.value = value;
        this.allowSavingData = allowSavingData;
    }
    return AdditionalTravellerDetail;
}());

var OccupancyInfoDTO = (function () {
    function OccupancyInfoDTO() {
    }
    return OccupancyInfoDTO;
}());

//# sourceMappingURL=guest-info.model.js.map

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateOrderPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CreateOrderBookerInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BookerPaymentQRCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BookerPaymentEWallet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BookerPaymentIMBanking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BookerPaymentPayAtCounter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BookerTrueMoney; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BookerPaymentCreditCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BookerPaymentCreditTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return Ch3CustomFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TaxAddress; });
/* unused harmony export CostCenter */
/* unused harmony export InternalOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CreateOrderPayloadWithPromotion; });
/* unused harmony export Promotion */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PromotionCode; });
/* unused harmony export OneTimeTaxAddress */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PaymentFleetCard; });
/* unused harmony export Discount */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CreateOrderPayload = (function () {
    function CreateOrderPayload() {
        this.isBookForTraveller = false;
    }
    CreateOrderPayload.prototype.getBookerByEmail = function (email) {
        return this.bookerInfo.find(function (item) { return item.email.toLowerCase() === email.toLowerCase(); });
    };
    return CreateOrderPayload;
}());

var CreateOrderBookerInfo = (function () {
    function CreateOrderBookerInfo(bookerInfo) {
        this.bookerCurrency = bookerInfo.bookerCurrency;
        this.fullName = bookerInfo.fullName;
        this.firstName = bookerInfo.firstName;
        this.lastName = bookerInfo.lastName;
        this.mobileNumber = bookerInfo.mobileNumber;
        this.email = bookerInfo.email;
        this.countryISO2 = bookerInfo.countryISO2;
        this.countryCallingCode = bookerInfo.countryCallingCode;
    }
    return CreateOrderBookerInfo;
}());

var BookerPaymentQRCode = (function () {
    function BookerPaymentQRCode() {
    }
    return BookerPaymentQRCode;
}());

var BookerPaymentEWallet = (function () {
    function BookerPaymentEWallet() {
    }
    return BookerPaymentEWallet;
}());

var BookerPaymentIMBanking = (function () {
    function BookerPaymentIMBanking() {
    }
    return BookerPaymentIMBanking;
}());

var BookerPaymentPayAtCounter = (function () {
    function BookerPaymentPayAtCounter() {
    }
    return BookerPaymentPayAtCounter;
}());

var BookerTrueMoney = (function () {
    function BookerTrueMoney() {
    }
    return BookerTrueMoney;
}());

var BookerPaymentCreditCard = (function () {
    function BookerPaymentCreditCard() {
    }
    return BookerPaymentCreditCard;
}());

var BookerPaymentCreditTerms = (function () {
    function BookerPaymentCreditTerms() {
    }
    return BookerPaymentCreditTerms;
}());

var Ch3CustomFields = (function () {
    function Ch3CustomFields(fieldId, value) {
        this.fieldId = fieldId;
        this.value = value;
    }
    return Ch3CustomFields;
}());

var TaxAddress = (function () {
    function TaxAddress() {
    }
    return TaxAddress;
}());

var CostCenter = (function () {
    function CostCenter() {
    }
    return CostCenter;
}());

var InternalOrder = (function () {
    function InternalOrder() {
    }
    return InternalOrder;
}());

var CreateOrderPayloadWithPromotion = (function (_super) {
    __extends(CreateOrderPayloadWithPromotion, _super);
    function CreateOrderPayloadWithPromotion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.promotion = new Promotion();
        return _this;
    }
    return CreateOrderPayloadWithPromotion;
}(CreateOrderPayload));

var Promotion = (function () {
    function Promotion() {
        this.promotionCode = new PromotionCode;
    }
    return Promotion;
}());

var PromotionCode = (function () {
    function PromotionCode() {
    }
    return PromotionCode;
}());

var OneTimeTaxAddress = (function () {
    function OneTimeTaxAddress() {
    }
    return OneTimeTaxAddress;
}());

var PaymentFleetCard = (function () {
    function PaymentFleetCard(fleetCardId, totalAmount) {
        this.fleetCardId = fleetCardId;
        this.totalAmount = totalAmount;
    }
    return PaymentFleetCard;
}());

var Discount = (function () {
    function Discount() {
    }
    return Discount;
}());

//# sourceMappingURL=create-order.payload.js.map

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_google_libphonenumber__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_google_libphonenumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_google_libphonenumber__);
/* harmony export (immutable) */ __webpack_exports__["a"] = PhoneNumberValidator;
/* harmony export (immutable) */ __webpack_exports__["c"] = PhoneNumberValidatorNotRequired;
/* harmony export (immutable) */ __webpack_exports__["b"] = transformPhoneNumber;

var phoneNumberUtil = __WEBPACK_IMPORTED_MODULE_0_google_libphonenumber__["PhoneNumberUtil"].getInstance();
function PhoneNumberValidator(regionCode) {
    return function (control) {
        var validNumber = false;
        try {
            var phoneNumber = phoneNumberUtil.parseAndKeepRawInput(control.value, regionCode);
            validNumber = phoneNumberUtil.isValidNumberForRegion(phoneNumber, regionCode);
        }
        catch (e) { }
        return validNumber ? null : { 'wrongNumber': { value: control.value } };
    };
}
function PhoneNumberValidatorNotRequired(regionCode) {
    return function (control) {
        var validNumber = false;
        try {
            if (control.value) {
                var phoneNumber = phoneNumberUtil.parseAndKeepRawInput(control.value, regionCode);
                validNumber = phoneNumberUtil.isValidNumberForRegion(phoneNumber, regionCode);
            }
            else {
                validNumber = true;
            }
        }
        catch (e) { }
        return validNumber ? null : { 'wrongNumber': { value: control.value } };
    };
}
function transformPhoneNumber(phoneNumber, regionCode) {
    try {
        return phoneNumberUtil.parse(phoneNumber, regionCode).getNationalNumber().toString();
    }
    catch (error) {
        return null;
    }
}
//# sourceMappingURL=phone-number-validator.js.map

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AddressesModel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddressesUserProfileModel; });
/* unused harmony export MemberModel */
/* unused harmony export staffMemberModel */
/* unused harmony export StaffModel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UserInfoModel; });
/* unused harmony export ProfileModel */
/* unused harmony export CompanyUserModel */
/* unused harmony export CreditTermModel */
var AddressesModel = (function () {
    function AddressesModel() {
    }
    return AddressesModel;
}());

var AddressesUserProfileModel = (function () {
    function AddressesUserProfileModel() {
    }
    return AddressesUserProfileModel;
}());

var MemberModel = (function () {
    function MemberModel() {
    }
    return MemberModel;
}());

var staffMemberModel = (function () {
    function staffMemberModel() {
    }
    return staffMemberModel;
}());

var StaffModel = (function () {
    function StaffModel() {
    }
    return StaffModel;
}());

var UserInfoModel = (function () {
    function UserInfoModel(user, langId) {
        this.birthDate = user.birthdate;
        this.userId = user.userId;
        this.email = user.email;
        this.fullName = user.fullName;
        this.picture = user.profileImage;
        this.countryCallingCode = user.countryCallingCode;
        this.telephone = user.telephone;
        this.companyUser = new CompanyUserModel(user, langId);
        this.timeOfBirth = user.timeOfBirth;
    }
    return UserInfoModel;
}());

var ProfileModel = (function () {
    function ProfileModel() {
    }
    return ProfileModel;
}());

var CompanyUserModel = (function () {
    function CompanyUserModel(user, langId) {
        this.position = user.position;
        this.companyTitle = langId === '1' ? user.companyTitleEn : user.companyTitleTh;
    }
    return CompanyUserModel;
}());

var CreditTermModel = (function () {
    function CreditTermModel() {
    }
    return CreditTermModel;
}());

//# sourceMappingURL=profile.model.js.map

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FleetService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var FleetService = (function () {
    function FleetService(actHttpService, utilitiesService) {
        this.actHttpService = actHttpService;
        this.utilitiesService = utilitiesService;
    }
    FleetService.prototype.getFleetCardInformation = function (sortBy, companyId, fleetCardType, status) {
        if (companyId === void 0) { companyId = null; }
        if (fleetCardType === void 0) { fleetCardType = null; }
        if (status === void 0) { status = null; }
        var url = __WEBPACK_IMPORTED_MODULE_1_environments_environment__["a" /* environment */].endpoint.getFleetCardInformation + "?sortBy=" + sortBy;
        if (fleetCardType) {
            url += "&fleetCardType=" + fleetCardType;
        }
        if (companyId) {
            url += "&companyId=" + companyId.toString();
        }
        if (status) {
            url += "&status=" + status;
        }
        var options = this.actHttpService.getRequestOptions();
        return this.actHttpService.get(url, options)
            .map(function (res) { return res.json().data; });
    };
    FleetService.prototype.getFleetCardTransactionHistory = function (request, fleetCardId) {
        var options = this.actHttpService.getRequestOptions(__WEBPACK_IMPORTED_MODULE_2__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, __WEBPACK_IMPORTED_MODULE_2__act_http_act_http_service__["b" /* ContentTypes */].JSON);
        var url = "" + __WEBPACK_IMPORTED_MODULE_1_environments_environment__["a" /* environment */].endpoint.getTransactionHistory.replace('{fleetCardId}', fleetCardId) + this.utilitiesService.objectToQueryString(request);
        return this.actHttpService
            .get(url, options)
            .map(function (response) { return response.json().data; });
    };
    FleetService.prototype.registerFleetCard = function (fleetCardId, secretCode, reCaptcha) {
        var options = this.actHttpService.getRequestOptions();
        var payload = {
            fleetCardId: fleetCardId,
            secretCode: secretCode,
            reCaptcha: reCaptcha
        };
        var url = __WEBPACK_IMPORTED_MODULE_1_environments_environment__["a" /* environment */].endpoint.registerFleetCard;
        return this.actHttpService.post(url, payload, options)
            .map(function (res) { return res.json().data; });
    };
    FleetService.prototype.transferFleetCard = function (fleetCardIdFrom, fleetCardIdTo, amount) {
        var options = this.actHttpService.getRequestOptions();
        var payload = {
            from: fleetCardIdFrom,
            to: fleetCardIdTo,
            amount: amount,
        };
        var url = __WEBPACK_IMPORTED_MODULE_1_environments_environment__["a" /* environment */].endpoint.transferFleetCard;
        return this.actHttpService.post(url, payload, options);
    };
    return FleetService;
}());
FleetService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3__utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object])
], FleetService);

var _a, _b;
//# sourceMappingURL=fleet.service.js.map

/***/ }),
/* 223 */,
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyBookingSection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OperationDateTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GuestAmount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MyBookingDataSctionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookingInfoSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RoomDetailSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BookerInfoSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CancellationPolicy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BookingStatusDisPlayModel; });
var MyBookingSection = (function () {
    function MyBookingSection(data) {
        this.data = data;
    }
    return MyBookingSection;
}());

var OperationDateTime = (function () {
    function OperationDateTime(date, timeFrom, timeUntil) {
        this.date = date;
        this.timeFrom = timeFrom;
        this.timeUntil = timeUntil;
    }
    return OperationDateTime;
}());

var GuestAmount = (function () {
    function GuestAmount(adult, child, childrenAge) {
        this.adult = adult;
        this.child = child;
        this.childrenAge = childrenAge;
    }
    return GuestAmount;
}());

var MyBookingDataSctionType;
(function (MyBookingDataSctionType) {
    MyBookingDataSctionType[MyBookingDataSctionType["BOOKING"] = 0] = "BOOKING";
    MyBookingDataSctionType[MyBookingDataSctionType["ROOM"] = 1] = "ROOM";
    MyBookingDataSctionType[MyBookingDataSctionType["BOOKER"] = 2] = "BOOKER";
    MyBookingDataSctionType[MyBookingDataSctionType["BOOKING_DETAIL"] = 3] = "BOOKING_DETAIL";
    MyBookingDataSctionType[MyBookingDataSctionType["TRAVELLER_INFO"] = 4] = "TRAVELLER_INFO";
})(MyBookingDataSctionType || (MyBookingDataSctionType = {}));
var BookingInfoSection = (function () {
    function BookingInfoSection() {
    }
    return BookingInfoSection;
}());

var RoomDetailSection = (function () {
    function RoomDetailSection() {
    }
    return RoomDetailSection;
}());

var BookerInfoSection = (function () {
    function BookerInfoSection() {
    }
    return BookerInfoSection;
}());

var CancellationPolicy = (function () {
    function CancellationPolicy() {
    }
    return CancellationPolicy;
}());

var BookingStatusDisPlayModel = (function () {
    function BookingStatusDisPlayModel() {
    }
    return BookingStatusDisPlayModel;
}());

//# sourceMappingURL=booking-detail-section.js.map

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageScaleFactorModel; });
var ImageScaleFactorModel = (function () {
    function ImageScaleFactorModel(img1x, img2x, img3x) {
        if (img1x === void 0) { img1x = ''; }
        if (img2x === void 0) { img2x = undefined; }
        if (img3x === void 0) { img3x = undefined; }
        this['1x'] = img1x;
        this['2x'] = img2x || img1x;
        this['3x'] = img3x || img1x;
    }
    return ImageScaleFactorModel;
}());

//# sourceMappingURL=image-scale-factor-model.js.map

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProductDetailInfoModel; });
/* unused harmony export Remark */
/* unused harmony export ChildPolicy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ChildPolicyDislay; });
/* unused harmony export DisplayLabel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductDisplayLabel; });
/* unused harmony export Sanitation */
var ProductDetailInfoModel = (function () {
    function ProductDetailInfoModel() {
        this.displayLabels = [];
    }
    return ProductDetailInfoModel;
}());

var Remark = (function () {
    function Remark() {
    }
    return Remark;
}());

var ChildPolicy = (function () {
    function ChildPolicy() {
    }
    return ChildPolicy;
}());

var ChildPolicyDislay = (function () {
    function ChildPolicyDislay() {
    }
    return ChildPolicyDislay;
}());

var DisplayLabel = (function () {
    function DisplayLabel() {
    }
    return DisplayLabel;
}());

var ProductDisplayLabel = (function () {
    function ProductDisplayLabel() {
    }
    return ProductDisplayLabel;
}());

ProductDisplayLabel.SHA = 'SHA';
ProductDisplayLabel.SHA_PLUS = 'SHA+';
ProductDisplayLabel.YEAR_OF_BUILD = 'YearOfBuild';
ProductDisplayLabel.YEAR_OF_RENOVATED = 'YearOfRenovated';
ProductDisplayLabel.SECURITY_STANDARD = 'SecurityStandard';
var Sanitation = (function () {
    function Sanitation() {
    }
    return Sanitation;
}());

//# sourceMappingURL=product-detail-info.model.js.map

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie_src_js_cookie_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie_src_js_cookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie_src_js_cookie_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_user_payload_encrypt_request_payload__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_model_login_login_api_response_model__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_login_login_response_model__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_Rx__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_environments_properties__ = __webpack_require__(21);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AffiliateService; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};















var AffiliateService = (function () {
    function AffiliateService(actHttp, utilitiesService, authenticationService) {
        this.actHttp = actHttp;
        this.utilitiesService = utilitiesService;
        this.authenticationService = authenticationService;
    }
    AffiliateService.prototype.getUrlAuthenRequest = function (companyCode) {
        return this.actHttp
            .rawPost(__WEBPACK_IMPORTED_MODULE_12__environments_environment__["a" /* environment */].endpoint.getUrlAuthenRequest.replace(':affiliate', companyCode), { companyCode: companyCode })
            .map(function (res) { return res.json(); });
    };
    AffiliateService.prototype.saveTokenAndUserInfo$ = function (loginResponse) {
        try {
            this.authenticationService.saveToken(loginResponse);
            var actToken = this.authenticationService.getToken();
            var userFromStorage = this.authenticationService.getUserInfo();
            return this.authenticationService.saveUserFeature(actToken, userFromStorage, __WEBPACK_IMPORTED_MODULE_5_app_services_authentication_authentication_service__["a" /* AuthenticationService */].features);
        }
        catch (error) {
            return __WEBPACK_IMPORTED_MODULE_10_rxjs_Rx__["Observable"].of(false);
        }
    };
    AffiliateService.prototype.createLoginResponse = function (token, user, companyCode) {
        var actToken = new __WEBPACK_IMPORTED_MODULE_4__authentication_authentication_service__["b" /* ActToken */](token.accessToken, token.refreshToken);
        var actUser = user;
        actUser.companyCode = companyCode;
        var loginResponse = new __WEBPACK_IMPORTED_MODULE_9__model_login_login_response_model__["a" /* LoginResponseModel */]();
        loginResponse.user = actUser;
        loginResponse.token = actToken;
        return loginResponse;
    };
    /* **************** SAML Protocol **************** */
    AffiliateService.prototype.loginWithSAML = function (loginResponse) {
        return this.saveTokenAndUserInfo$(loginResponse);
    };
    AffiliateService.prototype.logoutIntegrate = function (email, companyCode) {
        var payload = new __WEBPACK_IMPORTED_MODULE_6_app_services_user_payload_encrypt_request_payload__["a" /* EncryptRequestPayload */]();
        payload.username = email;
        payload.timestamp = __WEBPACK_IMPORTED_MODULE_0_moment__().unix();
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_2__act_http_act_http_service__["a" /* HeaderTypes */].AUTHORIZATION_RANDOM_STR, __WEBPACK_IMPORTED_MODULE_2__act_http_act_http_service__["b" /* ContentTypes */].JSON, email, JSON.stringify(payload));
        return this.actHttp
            .rawPost(__WEBPACK_IMPORTED_MODULE_12__environments_environment__["a" /* environment */].endpoint.logoutAffiliate.replace(':affiliate', companyCode), JSON.stringify(payload), options)
            .map(function (res) { return res.json(); });
    };
    AffiliateService.prototype.decodeSAMLFromURL = function (encryptUserInfo, companyCode) {
        var result = JSON.parse(this.utilitiesService.base64Decoder(decodeURIComponent(encryptUserInfo)));
        var token = result.token, user = result.user;
        return this.createLoginResponse(token, user, companyCode);
    };
    /* **************** API Protocol **************** */
    AffiliateService.prototype.loginWithAPI = function (apiResponse, formData) {
        var _this = this;
        var _a = formData || { username: undefined, password: undefined }, username = _a.username, password = _a.password;
        var _b = apiResponse || new __WEBPACK_IMPORTED_MODULE_8_app_model_login_login_api_response_model__["a" /* LoginApiResponseModel */](), httpMethod = _b.httpMethod, endPoint = _b.endPoint, appKey = _b.appKey, companyCode = _b.companyCode, userNameField = _b.userNameField, passwordField = _b.passwordField, encryptionType = _b.encryptionType;
        // verify arguments
        var isValidArgs = [
            username, password, httpMethod, endPoint, appKey,
            userNameField, passwordField, encryptionType, companyCode,
        ].filter(function (args) { return args === undefined; }).length === 0;
        if (!isValidArgs) {
            return __WEBPACK_IMPORTED_MODULE_10_rxjs_Rx__["Observable"].of(false);
        }
        var requestLogin;
        var params = {};
        params[userNameField] = username;
        params[passwordField] = this.encryptPasswordWithType(encryptionType, password);
        switch (httpMethod) {
            case __WEBPACK_IMPORTED_MODULE_3__model_constant__["r" /* HttpMethod */].POST: {
                // TODO: update post method later
                var url = "" + endPoint;
                requestLogin = this.actHttp.rawPost(url, params);
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_3__model_constant__["r" /* HttpMethod */].GET:
            default: {
                params = __assign({}, params, { key: appKey });
                var url = "" + endPoint + this.utilitiesService.objectToQueryString(params);
                var requestEndpoint = __WEBPACK_IMPORTED_MODULE_12__environments_environment__["a" /* environment */].endpoint.loginAffiliate.replace(':affiliate', companyCode);
                requestEndpoint = requestEndpoint + "?data=" + this.utilitiesService.base64Encoder(url);
                requestLogin = this.actHttp.rawGet(requestEndpoint);
                break;
            }
        }
        return requestLogin.map(function (res) { return res.json().data; })
            .flatMap(function (_a) {
            var token = _a.token;
            return _this.getUserWithConsumeToken$(token, companyCode);
        });
    };
    AffiliateService.prototype.getUserWithConsumeToken$ = function (token, companyCode) {
        var _this = this;
        try {
            if (!token || !companyCode) {
                throw new Error('affiliate token or companyCode not found');
            }
            var url = __WEBPACK_IMPORTED_MODULE_12__environments_environment__["a" /* environment */].endpoint.getAffiliateConsume.replace(':affiliate', companyCode);
            var params = { data: token };
            return this.actHttp.rawPost(url, params)
                .map(function (res) { return res.json().data; })
                .flatMap(function (f) {
                _this.authenticationService.saveSsoToken(f.token);
                return _this.authenticationService.login(companyCode, f.clientId);
            });
        }
        catch (error) {
            return __WEBPACK_IMPORTED_MODULE_10_rxjs_Rx__["Observable"].throw(new Error('Get user info with consume token fail'));
        }
        finally {
            this.removeAffiliateState();
        }
    };
    AffiliateService.prototype.logoutWithAPI = function () {
        // TODO: implement logout by api protocol
    };
    AffiliateService.prototype.encryptPasswordWithType = function (encryptionType, password) {
        var encryptedPassword = '';
        switch (encryptionType) {
            case __WEBPACK_IMPORTED_MODULE_3__model_constant__["s" /* EncryptionType */].TRUE_CUSTOM:
                var random2digit = this.utilitiesService.randomStringWithLength(2);
                var random4digit = this.utilitiesService.randomStringWithLength(4);
                var encryptPass = this.utilitiesService.base64Encoder(password);
                encryptedPassword = "" + random2digit + encryptPass + random4digit;
                break;
            case __WEBPACK_IMPORTED_MODULE_3__model_constant__["s" /* EncryptionType */].BASE64:
            default:
                encryptedPassword = this.utilitiesService.base64Encoder(password);
                break;
        }
        return encryptedPassword;
    };
    AffiliateService.prototype.decodeAPIFromURL = function (encryptData, requireFields) {
        if (requireFields === void 0) { requireFields = __WEBPACK_IMPORTED_MODULE_8_app_model_login_login_api_response_model__["a" /* LoginApiResponseModel */].requireFields(); }
        var decryptData = JSON.parse(this.utilitiesService.base64Decoder(decodeURIComponent(encryptData)));
        var loginApi = decryptData;
        var amountOfRequired = requireFields.length;
        var validFields = requireFields.filter(function (key) { return loginApi[key] !== undefined && loginApi[key] !== ''; });
        return validFields.length === amountOfRequired ? loginApi : undefined;
    };
    AffiliateService.prototype.saveAffiliateState = function (state) {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_13__app_config_app_config_service__["a" /* AppConfigService */].stateAffCookieName, this.utilitiesService.encodeToCookie(state), { domain: __WEBPACK_IMPORTED_MODULE_14_environments_properties__["e" /* domain */] });
    };
    AffiliateService.prototype.getAffiliateState = function () {
        return this.utilitiesService.decodeFromCookie(__WEBPACK_IMPORTED_MODULE_1_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_13__app_config_app_config_service__["a" /* AppConfigService */].stateAffCookieName));
    };
    AffiliateService.prototype.removeAffiliateState = function () {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie_src_js_cookie_js__["remove"](__WEBPACK_IMPORTED_MODULE_13__app_config_app_config_service__["a" /* AppConfigService */].stateAffCookieName, { domain: __WEBPACK_IMPORTED_MODULE_14_environments_properties__["e" /* domain */] });
    };
    return AffiliateService;
}());
AffiliateService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_11_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_11_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _c || Object])
], AffiliateService);

var _a, _b, _c;
//# sourceMappingURL=affiliate.service.js.map

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environments_properties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogSpecialDayComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var DialogSpecialDayComponent = (function () {
    function DialogSpecialDayComponent(dialogRef, utilitiesService) {
        this.dialogRef = dialogRef;
        this.utilitiesService = utilitiesService;
        this.URI = "" + __WEBPACK_IMPORTED_MODULE_2_environments_properties__["x" /* asq */];
        this.ImageURI = "" + __WEBPACK_IMPORTED_MODULE_2_environments_properties__["y" /* imageURI */];
        this.isMobile = false;
    }
    DialogSpecialDayComponent.prototype.ngOnInit = function () {
        this.isMobile = this.utilitiesService.isMobile();
    };
    DialogSpecialDayComponent.prototype.onResize = function (event) {
        this.isMobile = this.utilitiesService.isMobile();
    };
    return DialogSpecialDayComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DialogSpecialDayComponent.prototype, "onResize", null);
DialogSpecialDayComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-special-day',
        template: __webpack_require__(1071),
        styles: [__webpack_require__(936)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object])
], DialogSpecialDayComponent);

var _a, _b;
//# sourceMappingURL=dialog-special-day.component.js.map

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogSuccessComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var DialogSuccessComponent = (function () {
    function DialogSuccessComponent() {
        this.icon = "icon-successful";
    }
    DialogSuccessComponent.prototype.ngOnInit = function () {
    };
    return DialogSuccessComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('text'),
    __metadata("design:type", String)
], DialogSuccessComponent.prototype, "text", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('icon'),
    __metadata("design:type", Object)
], DialogSuccessComponent.prototype, "icon", void 0);
DialogSuccessComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'ota-dialog-success',
        template: __webpack_require__(1072),
        styles: [__webpack_require__(937)]
    }),
    __metadata("design:paramtypes", [])
], DialogSuccessComponent);

//# sourceMappingURL=dialog-success.component.js.map

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CompanyFeatures */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompanyFeaturesDetail; });
/* unused harmony export TravelPolicy */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CompanyFeatures = (function () {
    function CompanyFeatures() {
    }
    return CompanyFeatures;
}());

var CompanyFeaturesDetail = (function (_super) {
    __extends(CompanyFeaturesDetail, _super);
    function CompanyFeaturesDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CompanyFeaturesDetail;
}(CompanyFeatures));

var TravelPolicy = (function () {
    function TravelPolicy() {
    }
    return TravelPolicy;
}());

//# sourceMappingURL=companyFeatures.js.map

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_approval_approval_status__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_environments_environment__ = __webpack_require__(22);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApprovalService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var ApprovalService = (function () {
    function ApprovalService(actHttp, utilities, appConfig) {
        this.actHttp = actHttp;
        this.utilities = utilities;
        this.appConfig = appConfig;
    }
    ApprovalService.prototype.getApprovalList = function (_a) {
        var lang = _a.lang, page = _a.page, limit = _a.limit, searchBy = _a.searchBy, filterBy = _a.filterBy, sortBy = _a.sortBy, orderBy = _a.orderBy, companyId = _a.companyId;
        var options = this.actHttp.getRequestOptions();
        var url = "" + __WEBPACK_IMPORTED_MODULE_6_environments_environment__["a" /* environment */].endpoint.getApprovalList +
            ("?lang=" + lang) +
            ("&page=" + page) +
            ("&limit=" + limit) +
            "&search=" + encodeURIComponent(searchBy) +
            ("&filter=" + filterBy) +
            ("&sort=" + sortBy) +
            ("&order=" + orderBy) +
            ("&companyId=" + companyId);
        return this.actHttp.get(url, options)
            .map(function (res) { return res.json().data; });
    };
    ApprovalService.prototype.getApprovalDetails = function (bookingId, companyId, bookingBookerId) {
        var url = __WEBPACK_IMPORTED_MODULE_6_environments_environment__["a" /* environment */].endpoint.getApprovalDetails.replace('{bookingID}', bookingId) + "?lang=" + this.appConfig.getLanguage() + "&companyId=" + companyId + "&bookingBookerId=" + bookingBookerId;
        var options = this.actHttp.getRequestOptions();
        return this.actHttp.get(url, options)
            .map(function (res) { return res.json().data; });
    };
    ApprovalService.prototype.getApprovalSuggestion = function (bookingId, companyId) {
        if (bookingId === void 0) { bookingId = ''; }
        var options = this.actHttp.getRequestOptions();
        var url = __WEBPACK_IMPORTED_MODULE_6_environments_environment__["a" /* environment */].endpoint.getApprovalSuggestion + "?bookingId=" + bookingId + "&companyId=" + companyId;
        return this.actHttp.get(url, options)
            .map(function (res) { return res.json().data; });
    };
    ApprovalService.prototype.approveBooking = function (bookingId, ref, loggedIn) {
        if (loggedIn === void 0) { loggedIn = true; }
        var options = this.actHttp.getRequestOptions();
        var payload = {
            'bookingId': bookingId,
            'otp': ref
        };
        var result = loggedIn ? this.actHttp.put("" + __WEBPACK_IMPORTED_MODULE_6_environments_environment__["a" /* environment */].endpoint.approve, payload, options) :
            this.actHttp.rawPut("" + __WEBPACK_IMPORTED_MODULE_6_environments_environment__["a" /* environment */].endpoint.approve, payload);
        return result.map(function (res) { return res; });
    };
    ApprovalService.prototype.rejectBooking = function (bookingId, ref, reason, loggedIn) {
        if (loggedIn === void 0) { loggedIn = true; }
        var options = this.actHttp.getRequestOptions();
        var payload = {
            'bookingId': bookingId,
            'otp': ref,
            'reason': reason
        };
        var result = loggedIn ? this.actHttp.post("" + __WEBPACK_IMPORTED_MODULE_6_environments_environment__["a" /* environment */].endpoint.reject, payload, options) :
            this.actHttp.rawPost("" + __WEBPACK_IMPORTED_MODULE_6_environments_environment__["a" /* environment */].endpoint.reject, payload);
        return result.map(function (res) { return res; });
    };
    ApprovalService.prototype.getApprovalStatus = function (_a) {
        var approvalStatus = _a.approvalStatus, approvalDate = _a.approvalDate, cancelDate = _a.cancelDate;
        var formatStatusDate = "D MMM YY";
        var keyStatus1 = '';
        var keyStatus2 = '';
        var keyPrefixDate = '';
        var status = new __WEBPACK_IMPORTED_MODULE_3_app_model_approval_approval_status__["a" /* ApprovalStatusModel */]();
        switch (approvalStatus) {
            case __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["j" /* ApprovalStatusType */].APPROVE:
                keyStatus1 = "approval-list-status-approved";
                keyPrefixDate = "approval-list-approved-date";
                status.cssStatus = "green";
                status.statusDate = approvalDate;
                status.status = __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["j" /* ApprovalStatusType */].APPROVE;
                break;
            case __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["j" /* ApprovalStatusType */].BOOKER_CANCELLED:
                keyStatus1 = "approval-list-status-booker-cancelled";
                keyPrefixDate = "approval-list-cancel-date";
                status.cssStatus = "grey";
                status.statusDate = cancelDate;
                status.status = __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["j" /* ApprovalStatusType */].BOOKER_CANCELLED;
                break;
            case __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["j" /* ApprovalStatusType */].LAST_MINUTE:
                keyStatus1 = "approval-list-status-last-minute1";
                keyStatus2 = "approval-list-status-last-minute2";
                status.cssStatus = "orange";
                status.status = __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["j" /* ApprovalStatusType */].LAST_MINUTE;
                break;
            case __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["j" /* ApprovalStatusType */].NO_ACTION:
                keyStatus1 = "approval-list-status-no-action";
                status.cssStatus = "green";
                status.status = __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["j" /* ApprovalStatusType */].NO_ACTION;
                break;
            case __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["j" /* ApprovalStatusType */].REJECT:
                keyStatus1 = "approval-list-status-rejected";
                keyPrefixDate = "approval-list-rejected-date";
                status.cssStatus = "red";
                status.statusDate = approvalDate;
                status.status = __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["j" /* ApprovalStatusType */].REJECT;
                break;
            case __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["j" /* ApprovalStatusType */].PENDING:
                status.status = __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["j" /* ApprovalStatusType */].PENDING;
                break;
            default:
                status.status = __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["j" /* ApprovalStatusType */].UNKNOWN;
                break;
        }
        status.textStatus1 = keyStatus1 ? this.appConfig.getTranslate(keyStatus1) : undefined;
        status.textStatus2 = keyStatus2 ? this.appConfig.getTranslate(keyStatus2) : undefined;
        if (status.statusDate) {
            status.textStatusDate = this.appConfig.getTranslate(keyPrefixDate) + ' ' +
                this.utilities.convertDateFormat(status.statusDate, null, formatStatusDate);
        }
        return status;
    };
    ApprovalService.prototype.getOrderByWithFilterAndSorting = function (filter, sortBy) {
        var orderBy = __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["i" /* OrderByType */].descending;
        if (filter === __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["h" /* FilterByType */].waiting && sortBy === __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["g" /* SortByType */].checkinDate) {
            orderBy = __WEBPACK_IMPORTED_MODULE_0_app_model_constant__["i" /* OrderByType */].ascending;
        }
        return orderBy;
    };
    ApprovalService.prototype.getBookingCancellationStatus = function (bookingId, otp) {
        return this.actHttp.rawGet("" + __WEBPACK_IMPORTED_MODULE_6_environments_environment__["a" /* environment */].endpoint.getBookingCancellationStatus +
            ("?bookingId=" + bookingId) +
            ("&otp=" + otp)).map(function (res) { return res.json().data; });
    };
    ApprovalService.prototype.updateBookingApprovalStatus = function (bookingId, ref, action) {
        if (bookingId === void 0) { bookingId = ''; }
        if (ref === void 0) { ref = ''; }
        if (action === void 0) { action = ''; }
        return this.actHttp.rawPut(__WEBPACK_IMPORTED_MODULE_6_environments_environment__["a" /* environment */].endpoint.updateBookingApprovalStatus + "/" + action, { bookingId: bookingId, ref: ref }).map(function (res) { return res.json().data; });
    };
    return ApprovalService;
}());
ApprovalService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _c || Object])
], ApprovalService);

var _a, _b, _c;
//# sourceMappingURL=approval.service.js.map

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_environments_properties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authentication_authentication_service__ = __webpack_require__(27);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageGuard; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PageGuard = (function () {
    function PageGuard(authService) {
        this.authService = authService;
    }
    PageGuard.prototype.canActivate = function (next, state) {
        var path = state.url.split('?')[0];
        switch (path) {
            case '/':
                if (__WEBPACK_IMPORTED_MODULE_1_environments_properties__["u" /* disableHome */]) {
                    window.location.href = "" + __WEBPACK_IMPORTED_MODULE_1_environments_properties__["k" /* redirectURIV2 */] + state.url;
                    return false;
                }
                break;
            case '/hotel/searchdestination':
                if (__WEBPACK_IMPORTED_MODULE_1_environments_properties__["v" /* disableHotelList */]) {
                    window.location.href = "" + __WEBPACK_IMPORTED_MODULE_1_environments_properties__["k" /* redirectURIV2 */] + state.url;
                    return false;
                }
                break;
        }
        if (path.includes('/hotel/detail')) {
            if (__WEBPACK_IMPORTED_MODULE_1_environments_properties__["w" /* disableHotelDetail */] || this.authService.isB2CClient()) {
                var newPath = state.url.replace('/hotel/detail', '/hotel');
                window.location.href = "" + __WEBPACK_IMPORTED_MODULE_1_environments_properties__["k" /* redirectURIV2 */] + newPath;
                return false;
            }
        }
        if (path.includes('/pre-approval')) {
            window.location.href = "" + __WEBPACK_IMPORTED_MODULE_1_environments_properties__["k" /* redirectURIV2 */] + state.url;
            return false;
        }
        return true;
    };
    return PageGuard;
}());
PageGuard = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _a || Object])
], PageGuard);

var _a;
//# sourceMappingURL=page.guard.js.map

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_components_verify_otp_otp_state__ = __webpack_require__(131);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PIN_STATE; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PIN_STATE = (function (_super) {
    __extends(PIN_STATE, _super);
    function PIN_STATE() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PIN_STATE;
}(__WEBPACK_IMPORTED_MODULE_0_app_components_verify_otp_otp_state__["a" /* OTP_STATE */]));

PIN_STATE.CHECKOUT = 'checkout';
PIN_STATE.SET_PIN = 'set_pin';
PIN_STATE.CONFIRM_SET_PIN = 'confirm_set_pin';
//# sourceMappingURL=pin-state.js.map

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogSeeAllPropertiesComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var DialogSeeAllPropertiesComponent = (function () {
    function DialogSeeAllPropertiesComponent(dialogRef, appConfigService) {
        this.dialogRef = dialogRef;
        this.appConfigService = appConfigService;
        this.isCustomText = false;
    }
    DialogSeeAllPropertiesComponent.prototype.ngOnInit = function () {
    };
    DialogSeeAllPropertiesComponent.prototype.lang = function () {
        return this.appConfigService.getLanguage();
    };
    DialogSeeAllPropertiesComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    return DialogSeeAllPropertiesComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], DialogSeeAllPropertiesComponent.prototype, "isCustomText", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], DialogSeeAllPropertiesComponent.prototype, "text", void 0);
DialogSeeAllPropertiesComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-see-all-properties',
        template: __webpack_require__(1068),
        styles: [__webpack_require__(933)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object])
], DialogSeeAllPropertiesComponent);

var _a, _b;
//# sourceMappingURL=dialog-see-all-properties.component.js.map

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MyBookingDetailModel; });
/* unused harmony export BookerInformation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BookerPaymentInformation; });
/* unused harmony export HotelInformation */
/* unused harmony export BookingApproval */
/* unused harmony export TaxAddressInformation */
/* unused harmony export RoomType */
/* unused harmony export CancellationCharge */
/* unused harmony export Surcharge */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MyBookingDownloadDocument; });
/* unused harmony export CreditCardInformation */
/* unused harmony export FleetInformation */
/* unused harmony export TrueMoneyInformation */
/* unused harmony export QRCodeInformation */
/* unused harmony export EWalletInformation */
/* unused harmony export IMBankingInformation */
/* unused harmony export PayAtCounterInformation */
/* unused harmony export PaymentInformation */
/* unused harmony export CreditTermsInformation */
/* unused harmony export BookingPayment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PaymentMethodDetail; });
/* unused harmony export BookingCancellationCharge */
/* unused harmony export CancellationPolicy */
/* unused harmony export Benefit */
/* unused harmony export TravellerInformation */
/* unused harmony export Traveller */
/* unused harmony export CheckoutField */
/* unused harmony export Approval */
/* unused harmony export LimitOccupancy */
var MyBookingDetailModel = (function () {
    function MyBookingDetailModel() {
    }
    return MyBookingDetailModel;
}());

var BookerInformation = (function () {
    function BookerInformation() {
    }
    return BookerInformation;
}());

var BookerPaymentInformation = (function () {
    function BookerPaymentInformation() {
    }
    return BookerPaymentInformation;
}());

var HotelInformation = (function () {
    function HotelInformation() {
    }
    return HotelInformation;
}());

var BookingApproval = (function () {
    function BookingApproval() {
    }
    return BookingApproval;
}());

var TaxAddressInformation = (function () {
    function TaxAddressInformation() {
    }
    return TaxAddressInformation;
}());

var RoomType = (function () {
    function RoomType() {
    }
    return RoomType;
}());

var CancellationCharge = (function () {
    function CancellationCharge() {
    }
    return CancellationCharge;
}());

var Surcharge = (function () {
    function Surcharge() {
    }
    return Surcharge;
}());

var MyBookingDownloadDocument = (function () {
    function MyBookingDownloadDocument() {
    }
    return MyBookingDownloadDocument;
}());

var CreditCardInformation = (function () {
    function CreditCardInformation() {
    }
    return CreditCardInformation;
}());

var FleetInformation = (function () {
    function FleetInformation() {
    }
    return FleetInformation;
}());

var TrueMoneyInformation = (function () {
    function TrueMoneyInformation() {
    }
    return TrueMoneyInformation;
}());

var QRCodeInformation = (function () {
    function QRCodeInformation() {
    }
    return QRCodeInformation;
}());

var EWalletInformation = (function () {
    function EWalletInformation() {
    }
    return EWalletInformation;
}());

var IMBankingInformation = (function () {
    function IMBankingInformation() {
    }
    return IMBankingInformation;
}());

var PayAtCounterInformation = (function () {
    function PayAtCounterInformation() {
    }
    return PayAtCounterInformation;
}());

var PaymentInformation = (function () {
    function PaymentInformation() {
    }
    return PaymentInformation;
}());

var CreditTermsInformation = (function () {
    function CreditTermsInformation() {
    }
    return CreditTermsInformation;
}());

var BookingPayment = (function () {
    function BookingPayment() {
    }
    return BookingPayment;
}());

var PaymentMethodDetail = (function () {
    function PaymentMethodDetail() {
    }
    return PaymentMethodDetail;
}());

var BookingCancellationCharge = (function () {
    function BookingCancellationCharge() {
    }
    return BookingCancellationCharge;
}());

var CancellationPolicy = (function () {
    function CancellationPolicy() {
    }
    return CancellationPolicy;
}());

var Benefit = (function () {
    function Benefit() {
    }
    return Benefit;
}());

var TravellerInformation = (function () {
    function TravellerInformation() {
    }
    return TravellerInformation;
}());

var Traveller = (function () {
    function Traveller() {
    }
    return Traveller;
}());

var CheckoutField = (function () {
    function CheckoutField() {
    }
    return CheckoutField;
}());

var Approval = (function () {
    function Approval() {
    }
    return Approval;
}());

var LimitOccupancy = (function () {
    function LimitOccupancy() {
    }
    return LimitOccupancy;
}());

//# sourceMappingURL=my-booking-model-v2.js.map

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_general_message_dialog_general_message_component__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_model_dropdown_dropdown_option_model__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_user_feature_user_feature_service__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dialog_my_profile_form__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialog_my_profile_model__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_utilities_phone_number_validator__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_google_libphonenumber__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_google_libphonenumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_google_libphonenumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogMyProfileComponent; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};














var DialogMyProfileComponent = DialogMyProfileComponent_1 = (function () {
    function DialogMyProfileComponent(dialogRef, data, userService, userFeatureService, formBuilder, dialog, translatePipe, formProvider) {
        var _this = this;
        this.dialogRef = dialogRef;
        this.data = data;
        this.userService = userService;
        this.userFeatureService = userFeatureService;
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.translatePipe = translatePipe;
        this.formProvider = formProvider;
        this.pageElementName = 'dialog-my-profile';
        this.phoneNumberMask = Array.from({ length: 20 }, function () { return /\d/; });
        this.options = { page: this.pageElementName, selectable: false, editable: true };
        this.isLoading = false;
        this.isSubmit = false;
        this.dates = [];
        this.months = [];
        this.years = [];
        this.TimeOfBirthType = __WEBPACK_IMPORTED_MODULE_10__dialog_my_profile_model__["a" /* TimeOfBirthType */];
        this.timeOfBirths = [];
        this.profileEditable = true;
        this.isCallbackEditFromParent = false;
        this.callingCodeList = [__WEBPACK_IMPORTED_MODULE_4_app_model_constant__["J" /* CallingCodeOption */].DEFAULT];
        this.phoneNumberUtil = __WEBPACK_IMPORTED_MODULE_12_google_libphonenumber__["PhoneNumberUtil"].getInstance();
        this.STATE = {
            VIEW: 'VIEW',
            EDIT: 'EDIT'
        };
        this.response = {
            SUCCESS: 'SUCCESS',
            FAIL: 'FAIL'
        };
        this.STATUS = {
            INITIAL: 'INITIAL',
            PENDING: 'PENDING',
            RESPONSE: 'RESPONSE',
        };
        this.dataStatus = {
            isInitial: false,
            isPending: false,
            isResponse: false,
        };
        this.handleOpenDialog = function (_a) {
            var type = _a.type, fullName = _a.fullName, contactNumber = _a.contactNumber, birthDate = _a.birthDate, timeOfBirth = _a.timeOfBirth;
            _this.setLoadingState(false);
            if (type === _this.response.SUCCESS) {
                var _b = _this.form.getRawValue(), year = _b.year, month = _b.month, date = _b.date;
                _this.profile = __assign({}, _this.form.getRawValue(), { birthDate: birthDate });
                if (!birthDate) {
                    _this.profile = __assign({}, _this.profile, { date: '', month: '', year: '' });
                }
                _this.userService.updateUser({
                    fullName: fullName,
                    telephone: contactNumber,
                    birthDate: birthDate,
                    timeOfBirth: timeOfBirth
                });
            }
            if (!_this.data.applyMuTravel) {
                var message = _this.createMessage({ type: type });
                var config = {
                    hasBackdrop: true,
                    disableClose: false,
                    focusOnOpen: false,
                    data: message
                };
                _this.dialog.open(__WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_general_message_dialog_general_message_component__["a" /* DialogGeneralMessageComponent */], config);
            }
            _this.dialogRef.close({ action: __WEBPACK_IMPORTED_MODULE_10__dialog_my_profile_model__["b" /* DialogMyProfileActionType */].UPDATED });
        };
        if (this.data.profileData) {
            this.profile = this.profileAdaptor(this.data.profileData);
            this.profileData = this.data.profileData;
        }
        this.buildForm();
        this.title = this.data.title;
        this.subTitle = this.data.subTitle;
        this.submitText = this.data.submitText;
        this.dates = this.createDates(31);
        this.months = this.createMonths();
        this.years = this.createYearsForAges({ after: 0, before: 120 });
        this.timeOfBirths = this.createTimeOfBirths();
    }
    DialogMyProfileComponent.prototype.onResize = function (event) {
        document.documentElement.style.setProperty('--height-vh', window.innerHeight * 0.01 + "px");
    };
    DialogMyProfileComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.onResize();
        this.currentState = this.STATE.VIEW;
        this.profileEditable = this.userFeatureService.canEditProfile();
        this.getCallingCodeSubscription && this.getCallingCodeSubscription.unsubscribe();
        this.getCallingCodeSubscription = this.userService.getCallingCode().subscribe(function (countryCallingCodeList) {
            if (countryCallingCodeList.length > 0) {
                _this.callingCodeList = _this.transformCallingCode(countryCallingCodeList);
            }
        });
    };
    DialogMyProfileComponent.prototype.handleCancel = function () {
        this.dialogRef.close({
            action: __WEBPACK_IMPORTED_MODULE_10__dialog_my_profile_model__["b" /* DialogMyProfileActionType */].CANCEL
        });
    };
    DialogMyProfileComponent.prototype.isInvalid = function (field) {
        return this.form.get(field).invalid;
    };
    DialogMyProfileComponent.prototype.hasError = function (field, error) {
        return this.form.get(field).hasError(error);
    };
    DialogMyProfileComponent.prototype.touched = function (field) {
        return this.form.get(field).touched;
    };
    DialogMyProfileComponent.prototype.profileAdaptor = function (profileData) {
        var _a = profileData.companyUser, companyTitle = _a.companyTitle, position = _a.position, telephone = profileData.telephone, countryCallingCode = profileData.countryCallingCode, _b = profileData.birthDate, birthDate = _b === void 0 ? '' : _b, fullName = profileData.fullName, email = profileData.email, timeOfBirth = profileData.timeOfBirth;
        var _c = !birthDate ? [] : String(birthDate).split('-'), _d = _c[0], year = _d === void 0 ? '' : _d, _e = _c[1], month = _e === void 0 ? '' : _e, _f = _c[2], date = _f === void 0 ? '' : _f;
        var callingCode = countryCallingCode ? countryCallingCode : "+" + this.phoneNumberUtil.getCountryCodeForRegion(this.callingCodeList[0].value);
        var countryISO2 = telephone ?
            this.phoneNumberUtil.getRegionCodeForNumber(this.phoneNumberUtil.parse("" + callingCode + telephone))
            : this.phoneNumberUtil.getRegionCodeForCountryCode(+callingCode);
        return {
            birthDate: birthDate,
            fullName: fullName,
            email: email,
            position: position,
            year: year ? parseInt(year, 10) + '' : '',
            month: month ? parseInt(month, 10) + '' : '',
            date: date ? parseInt(date, 10) + '' : '',
            companyName: companyTitle,
            contactNumber: telephone,
            countryCallingCode: callingCode,
            countryISO2: countryISO2,
            timeOfBirth: timeOfBirth
        };
    };
    DialogMyProfileComponent.prototype.createDates = function (last) {
        var current = 1;
        var dates = [];
        while (current <= last) {
            dates = dates.concat([current]);
            current = current + 1;
        }
        return dates;
    };
    DialogMyProfileComponent.prototype.updateDates = function (last) {
        this.dates = this.createDates(last);
    };
    DialogMyProfileComponent.prototype.createYearsForAges = function (period) {
        var current = (new Date()).getFullYear();
        var years = [];
        var startYear = current - period.after;
        var lastYear = current - period.before;
        while (startYear >= lastYear) {
            years = years.concat([startYear]);
            startYear = startYear - 1;
        }
        return years;
    };
    DialogMyProfileComponent.prototype.buildForm = function () {
        var getInitForm = this.formProvider.getInitForm;
        var _a = this.profile, fullName = _a.fullName, contactNumber = _a.contactNumber, countryCallingCode = _a.countryCallingCode, email = _a.email, companyName = _a.companyName, position = _a.position, year = _a.year, month = _a.month, date = _a.date, countryISO2 = _a.countryISO2, timeOfBirth = _a.timeOfBirth;
        var _date = date ? parseInt(date + '', 10) === 0 ? '' : parseInt(date + '', 10) : '';
        var _month = month ? parseInt(month + '', 10) === 0 ? '' : parseInt(month + '', 10) : '';
        var _year = year ? parseInt(year + '', 10) === 0 ? '' : parseInt(year + '', 10) : '';
        var _timeOfBirth = timeOfBirth ? timeOfBirth : '';
        this.form = this.formBuilder.group(getInitForm(fullName, companyName, position, _date, _month, _year, _timeOfBirth));
        if (this.profileData.birthDate) {
            this.form.controls['date'].disable();
            this.form.controls['month'].disable();
            this.form.controls['year'].disable();
        }
        if (this.profileData.timeOfBirth) {
            this.form.controls['timeOfBirth'].disable();
        }
    };
    Object.defineProperty(DialogMyProfileComponent.prototype, "isEditForm", {
        get: function () {
            return this.currentState === this.STATE.EDIT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogMyProfileComponent.prototype, "isViewForm", {
        get: function () {
            return this.currentState === this.STATE.VIEW;
        },
        enumerable: true,
        configurable: true
    });
    DialogMyProfileComponent.prototype.setLoadingState = function (isLoading) {
        this.isLoading = isLoading;
    };
    DialogMyProfileComponent.prototype.onSubmit = function (form) {
        var _this = this;
        this.isSubmit = true;
        this.setLoadingState(true);
        if (form.invalid || this.isInvalidBirthDate()) {
            this.setLoadingState(false);
            return;
        }
        var _a = this.userService.getUser(), companyId = _a.companyId, userId = _a.userId;
        var _b = form.getRawValue(), fullName = _b.fullName, contactNumber = _b.contactNumber, position = _b.position, timeOfBirth = _b.timeOfBirth;
        var birthDate = this.getBirthDate(form);
        var payload = {
            fullName: fullName,
            companyId: companyId,
            userId: userId,
            birthDate: birthDate,
            position: position,
            timeOfBirth: timeOfBirth
        };
        this.userService.editProfile(payload).subscribe(function (res) {
            _this.handleOpenDialog(__assign({ type: 'SUCCESS' }, { fullName: fullName, contactNumber: contactNumber, birthDate: birthDate, timeOfBirth: timeOfBirth }));
        }, function (eror) {
            _this.handleOpenDialog(__assign({ type: 'FAILURE' }, { fullName: fullName, contactNumber: contactNumber, birthDate: birthDate, timeOfBirth: timeOfBirth }));
        });
    };
    DialogMyProfileComponent.prototype.getBirthDate = function (form) {
        var _a = form.getRawValue(), date = _a.date, month = _a.month, year = _a.year;
        var _month = month < 10 ? '0' + month : month;
        var _date = date < 10 ? '0' + date : date;
        var _year = year == 0 ? '0000' : year;
        var birthDate = [_year, _month, _date].join('-');
        if (!date || !month || !year) {
            birthDate = null;
        }
        return birthDate;
    };
    DialogMyProfileComponent.prototype.translate = function (value) {
        return this.translatePipe.transform(value);
    };
    DialogMyProfileComponent.prototype.createMessage = function (_a) {
        var type = _a.type;
        if (type === this.response.SUCCESS) {
            return {
                icon: 'icon-successful',
                title: this.translate('my-profile-edit-success-title'),
                message: this.translate('my-profile-edit-success-description'),
                mainBtn: this.translate('btn-ok')
            };
        }
        else {
            return {
                icon: 'icon-service-failed',
                title: this.translate('my-profile-edit-failure-title'),
                message: this.translate('my-profile-edit-failure-description'),
                mainBtn: this.translate('btn-ok')
            };
        }
    };
    DialogMyProfileComponent.prototype.onClickEditProfile = function () {
        this.dialog.open(DialogMyProfileComponent_1);
    };
    DialogMyProfileComponent.prototype.onSelectCallingCode = function (event) {
        this.form.controls.contactNumber.setValidators([__WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_app_utilities_phone_number_validator__["a" /* PhoneNumberValidator */])(event)]);
        this.form.controls.contactNumber.updateValueAndValidity();
    };
    DialogMyProfileComponent.prototype.transformCallingCode = function (callingCodeList) {
        var callingCodeOptionList = [];
        callingCodeList.forEach(function (item) {
            if (__WEBPACK_IMPORTED_MODULE_4_app_model_constant__["J" /* CallingCodeOption */].DEFAULT.value === item.countryISO2) {
                callingCodeOptionList.unshift(new __WEBPACK_IMPORTED_MODULE_5_app_model_dropdown_dropdown_option_model__["a" /* Option */](item.countryNameEN + ' (' + item.countryCallingCode + ')', item.countryISO2, item.countryISO2 ? 'flags/' + item.countryISO2.toLowerCase() + '.png' : '', item.countryCallingCode));
            }
            else {
                callingCodeOptionList.push(new __WEBPACK_IMPORTED_MODULE_5_app_model_dropdown_dropdown_option_model__["a" /* Option */](item.countryNameEN + ' (' + item.countryCallingCode + ')', item.countryISO2, item.countryISO2 ? 'flags/' + item.countryISO2.toLowerCase() + '.png' : '', item.countryCallingCode));
            }
        });
        return callingCodeOptionList;
    };
    DialogMyProfileComponent.prototype.ngOnDestroy = function () {
        this.getCallingCodeSubscription && this.getCallingCodeSubscription.unsubscribe();
    };
    DialogMyProfileComponent.prototype.removeSpaceBetween = function (event, name) {
        this.form.controls[name].patchValue(event.target.value.replace(/\s+/g, ' ').trim());
        this.form.controls[name].updateValueAndValidity();
    };
    DialogMyProfileComponent.prototype.removeSpace = function (event, name) {
        this.form.controls[name].patchValue(event.target.value.trim());
        this.form.controls[name].updateValueAndValidity();
    };
    DialogMyProfileComponent.prototype.isInvalidBirthDate = function () {
        if (this.isInvalid('date') || this.isInvalid('month') || this.isInvalid('year')) {
            return true;
        }
        var date = this.form.get('date').value;
        var month = this.form.get('month').value;
        var year = this.form.get('year').value;
        if (!__WEBPACK_IMPORTED_MODULE_13_moment__(year + "-" + month + "-" + date, ['YYYY-MM-DD', 'YYYY-M-D'], true).isValid()) {
            return true;
        }
        return false;
    };
    DialogMyProfileComponent.prototype.createMonths = function () {
        return [
            {
                value: '1',
                label: 'month-january'
            },
            {
                value: '2',
                label: 'month-february'
            },
            {
                value: '3',
                label: 'month-march'
            },
            {
                value: '4',
                label: 'month-april'
            },
            {
                value: '5',
                label: 'month-may'
            },
            {
                value: '6',
                label: 'month-june'
            },
            {
                value: '7',
                label: 'month-july'
            },
            {
                value: '8',
                label: 'month-august'
            },
            {
                value: '9',
                label: 'month-september'
            },
            {
                value: '10',
                label: 'month-october'
            },
            {
                value: '11',
                label: 'month-november'
            },
            {
                value: '12',
                label: 'month-december'
            },
        ];
    };
    DialogMyProfileComponent.prototype.createTimeOfBirths = function () {
        return [
            {
                value: __WEBPACK_IMPORTED_MODULE_10__dialog_my_profile_model__["a" /* TimeOfBirthType */].UN_SPECIFIED,
                label: 'time-of-birth-option-unspecified'
            },
            {
                value: __WEBPACK_IMPORTED_MODULE_10__dialog_my_profile_model__["a" /* TimeOfBirthType */].DAY,
                label: 'time-of-birth-option-day'
            },
            {
                value: __WEBPACK_IMPORTED_MODULE_10__dialog_my_profile_model__["a" /* TimeOfBirthType */].NIGHT,
                label: 'time-of-birth-option-night'
            }
        ];
    };
    return DialogMyProfileComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DialogMyProfileComponent.prototype, "onResize", null);
DialogMyProfileComponent = DialogMyProfileComponent_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-my-profile',
        template: __webpack_require__(1097),
        styles: [__webpack_require__(962)]
    }),
    __param(1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_8__services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8__services_user_user_service__["a" /* UserService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_user_feature_user_feature_service__["a" /* UserFeatureService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_user_feature_user_feature_service__["a" /* UserFeatureService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_6_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_9__dialog_my_profile_form__["a" /* DialogMyProfileForm */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_9__dialog_my_profile_form__["a" /* DialogMyProfileForm */]) === "function" && _g || Object])
], DialogMyProfileComponent);

var DialogMyProfileComponent_1, _a, _b, _c, _d, _e, _f, _g;
//# sourceMappingURL=dialog-my-profile.component.js.map

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DialogMyProfileActionType; });
/* unused harmony export ProfileAdaptor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeOfBirthType; });
var DialogMyProfileActionType;
(function (DialogMyProfileActionType) {
    DialogMyProfileActionType[DialogMyProfileActionType["UPDATED"] = 0] = "UPDATED";
    DialogMyProfileActionType[DialogMyProfileActionType["CANCEL"] = 1] = "CANCEL";
})(DialogMyProfileActionType || (DialogMyProfileActionType = {}));
var ProfileAdaptor = (function () {
    function ProfileAdaptor() {
    }
    return ProfileAdaptor;
}());

var TimeOfBirthType = {
    UN_SPECIFIED: 'unspecified',
    DAY: 'day',
    NIGHT: 'night',
};
//# sourceMappingURL=dialog-my-profile.model.js.map

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CarouselInfo; });
var CarouselInfo = (function () {
    function CarouselInfo() {
    }
    return CarouselInfo;
}());

//# sourceMappingURL=carousel.model.js.map

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_form_form__ = __webpack_require__(126);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogMyProfileForm; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var DialogMyProfileForm = (function (_super) {
    __extends(DialogMyProfileForm, _super);
    function DialogMyProfileForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formErrors = {
            'fullName': {},
            'companyName': {},
            'position': {},
            'date': {},
            'month': {},
            'year': {},
        };
        _this.getInitForm = function (fullName, company, position, date, month, year, timeOfBirth) {
            return {
                'fullName': [fullName, [__WEBPACK_IMPORTED_MODULE_0__angular_forms__["Validators"].required, __WEBPACK_IMPORTED_MODULE_0__angular_forms__["Validators"].pattern(_this.validatePattern.fullName)]],
                'companyName': [{ value: company, disabled: !!company }, __WEBPACK_IMPORTED_MODULE_0__angular_forms__["Validators"].required],
                'position': [position],
                'date': [date, [__WEBPACK_IMPORTED_MODULE_0__angular_forms__["Validators"].required]],
                'month': [month, [__WEBPACK_IMPORTED_MODULE_0__angular_forms__["Validators"].required]],
                'year': [year, [__WEBPACK_IMPORTED_MODULE_0__angular_forms__["Validators"].required]],
                'timeOfBirth': [timeOfBirth, [__WEBPACK_IMPORTED_MODULE_0__angular_forms__["Validators"].required]]
            };
        };
        return _this;
    }
    return DialogMyProfileForm;
}(__WEBPACK_IMPORTED_MODULE_1_app_components_form_form__["a" /* Form */]));

//# sourceMappingURL=dialog-my-profile.form.js.map

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environments_environment__ = __webpack_require__(22);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromotionCodeService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PromotionCodeService = (function () {
    function PromotionCodeService(actHttp) {
        this.actHttp = actHttp;
    }
    PromotionCodeService.prototype.getPromotionCodeActiveList = function (request) {
        var url = __WEBPACK_IMPORTED_MODULE_2_environments_environment__["a" /* environment */].endpoint.getPreBookingPromotionCodeList;
        return this.actHttp.post(url, request, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN)).map(function (res) { return res.json().data; });
    };
    PromotionCodeService.prototype.validatePromotionCode = function (request) {
        var url = __WEBPACK_IMPORTED_MODULE_2_environments_environment__["a" /* environment */].endpoint.preBookingValidatePromotionCode;
        return this.actHttp.post(url, request, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN)).map(function (res) { return res.json().data; });
    };
    return PromotionCodeService;
}());
PromotionCodeService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object])
], PromotionCodeService);

var _a;
//# sourceMappingURL=promotion-code.service.js.map

/***/ }),
/* 241 */,
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__billing_form__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_modal_dialog_confirm_dialog_confirm_component__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_modal_dialog_general_message_dialog_general_message_component__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_modal_dialog_confirm_dialog_confirm_model__ = __webpack_require__(60);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BillingFormComponent; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var BillingFormComponent = (function () {
    function BillingFormComponent(formProvider, formBuilder, userService, appConfigService, dialog) {
        this.formProvider = formProvider;
        this.formBuilder = formBuilder;
        this.userService = userService;
        this.appConfigService = appConfigService;
        this.dialog = dialog;
        this.options = {};
        this.refName = 'form-add';
        this.isDisplayButton = true;
        this.onSaveCompleted = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onCancelCompleted = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.isLoading = false; // tslint:disable-line
    }
    BillingFormComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    BillingFormComponent.prototype.ngOnDestroy = function () {
        this.subscriptionForm && this.subscriptionForm.unsubscribe();
        this.subscriptionProcess && this.subscriptionProcess.unsubscribe();
    };
    BillingFormComponent.prototype.buildForm = function () {
        var _this = this;
        var getInitForm = this.formProvider.getInitForm;
        var _a = this.data, name = _a.billingName, phone = _a.billingPhone, address = _a.billingAddress;
        this.form = this.formBuilder.group(getInitForm(name, phone, address));
        this.subscriptionForm = this.form.valueChanges.subscribe(function (data) {
            _this.formProvider.clearErrorMessage(data);
        });
    };
    BillingFormComponent.prototype.onSaveBillingCompleted = function (billing, state) {
        if (state === void 0) { state = __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["V" /* ActionType */].normalSave; }
        this.isLoading = false;
        this.onSaveCompleted.emit({ billing: billing, state: state });
    };
    BillingFormComponent.prototype.onSaveBillingFailure = function (errors) {
        this.isLoading = false;
        var title = this.appConfigService.getTranslate('checkout-3-address-edit-failure-title');
        var message = this.appConfigService.getTranslate('checkout-3-billing-failure-text-try-again');
        var mainBtn = this.appConfigService.getTranslate('btn-ok');
        var config = {
            data: { icon: 'icon-service-failed', title: title, message: message, mainBtn: mainBtn }
        };
        this.dialog.open(__WEBPACK_IMPORTED_MODULE_7_app_components_modal_dialog_general_message_dialog_general_message_component__["a" /* DialogGeneralMessageComponent */], config);
    };
    // Method for formControl, check value on blur
    // tslint:disable:no-unused-variable
    BillingFormComponent.prototype.isInvalid = function (field) {
        return this.form.get(field).invalid && this.form.get(field).touched;
    };
    /**
     ***************** UI Event Handler ******************************
     */
    BillingFormComponent.prototype.getSavingProcess = function () {
        this.isLoading = true;
        this.subscriptionProcess && this.subscriptionProcess.unsubscribe();
        return this.isEditMode() ? this.updateBilling$() : this.addBilling$();
    };
    BillingFormComponent.prototype.onSubmitButtonClicked = function (event) {
        var _this = this;
        if (this.form.invalid) {
            this.setFocusErrors(true);
            return false;
        }
        var process$ = this.getSavingProcess();
        this.subscriptionProcess = process$.subscribe(this.onSaveBillingCompleted.bind(this), this.onSaveBillingFailure.bind(this), function () { _this.isLoading = false; });
    };
    BillingFormComponent.prototype.onCancelButtonClicked = function (event) {
        this.isFormChanged() ? this.notifyConfirmFormCancel() : this.onCancelCompleted.emit();
    };
    BillingFormComponent.prototype.isAddBillingForm = function () {
        return this.refName === 'form-add';
    };
    BillingFormComponent.prototype.isFormChanged = function () {
        var formChanged = this.form.dirty;
        if (this.isAddBillingForm()) {
            var currentBilling = this.getFormBillingData();
            var isBillingEmpty = (currentBilling.billingAddress === '' &&
                currentBilling.billingName === '' &&
                currentBilling.billingPhone === '');
            formChanged = (formChanged && !isBillingEmpty);
        }
        return formChanged;
    };
    BillingFormComponent.prototype.notifyConfirmFormCancel = function () {
        var _this = this;
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6_app_components_modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */], { data: { confirmType: __WEBPACK_IMPORTED_MODULE_10_app_components_modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CLOSE } });
        dialogRef.afterClosed().subscribe(function (res) {
            res && _this.onCancelCompleted.emit();
        });
    };
    /**
     ************************************************************
     */
    BillingFormComponent.prototype.setSubmitting$ = function () {
        var _this = this;
        if (this.form.invalid) {
            this.setFocusErrors();
            return __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__["Observable"].of(false);
        }
        return this.getSavingProcess()
            .do(function (billing) {
            _this.onSaveBillingCompleted(billing, __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["V" /* ActionType */].autoSave);
        }, function (error) {
            _this.onSaveBillingFailure(error);
            return __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__["Observable"].throw(new Error('add billing failure'));
        })
            .map(function () { return __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__["Observable"].of(true); });
    };
    BillingFormComponent.prototype.setFocusErrors = function (isFocus, form) {
        if (isFocus === void 0) { isFocus = false; }
        if (form === void 0) { form = this.form; }
        var fieldSorted = [
            { name: 'name', element: this.inputName },
            { name: 'phone', element: this.inputPhone },
            { name: 'address', element: this.inputAddress },
        ];
        this.formProvider.setErrorMessage(form);
        fieldSorted.map(function (field) { return ({ control: form.get(field.name), element: field.element.nativeElement }); })
            .filter(function (field) { return field.control.invalid; })
            .forEach(function (field, index) {
            index === 0 && isFocus && field.element.focus();
            field.control.markAsTouched();
        });
    };
    BillingFormComponent.prototype.isEditMode = function () {
        return !!this.data.billingId;
    };
    BillingFormComponent.prototype.getFormControl = function () {
        return this.form;
    };
    BillingFormComponent.prototype.getFormBillingData = function () {
        var formData = this.form.getRawValue();
        var updatedData = __assign({}, this.data, { billingName: formData.name.trim(), billingPhone: formData.phone.trim(), billingAddress: formData.address.trim() });
        var billing = updatedData;
        return billing;
    };
    BillingFormComponent.prototype.addBilling$ = function (billing) {
        if (billing === void 0) { billing = this.getFormBillingData(); }
        billing.isDefault = true;
        return this.userService.createBillingAddress(billing);
    };
    BillingFormComponent.prototype.updateBilling$ = function (billing) {
        if (billing === void 0) { billing = this.getFormBillingData(); }
        return this.userService.updateBillingAddress(billing);
    };
    return BillingFormComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], BillingFormComponent.prototype, "options", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], BillingFormComponent.prototype, "refName", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], BillingFormComponent.prototype, "data", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], BillingFormComponent.prototype, "isDisplayButton", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], BillingFormComponent.prototype, "onSaveCompleted", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
], BillingFormComponent.prototype, "onCancelCompleted", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('name'),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _c || Object)
], BillingFormComponent.prototype, "inputName", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('phone'),
    __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _d || Object)
], BillingFormComponent.prototype, "inputPhone", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('address'),
    __metadata("design:type", typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _e || Object)
], BillingFormComponent.prototype, "inputAddress", void 0);
BillingFormComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'billing-form',
        template: __webpack_require__(1014),
        styles: [__webpack_require__(879)]
    }),
    __metadata("design:paramtypes", [typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_5__billing_form__["a" /* BillingForm */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__billing_form__["a" /* BillingForm */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_9_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_9_app_services_user_user_service__["a" /* UserService */]) === "function" && _h || Object, typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _j || Object, typeof (_k = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */]) === "function" && _k || Object])
], BillingFormComponent);

var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
//# sourceMappingURL=billing-form.component.js.map

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Item; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUDGET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOTAL_BUDGET_TYPE; });
var Item = (function () {
    function Item(title, subTitle) {
        this.title = title;
        this.subTitle = subTitle;
    }
    return Item;
}());

var TEMPLATE = {
    SPECIAL_BUDGET: 'special_budget',
    SPECIAL_BUDGET_SOME_DAYS: 'special_budget_some_days',
    SPECIAL_BUDGET_POI: 'special_budget_poi',
    NORMAL_BUDGET: 'normal_budget',
    UNLIMITED_BUDGET: 'unlimited_budget',
    UNLIMITED_SHARE_BUDGET_FEATURE: 'unlimited_share_budget_feature',
    SHARE_BUDGET: 'share_budget',
    SHARE_BUDGET_SPECIAL_BUDGET: 'share_budget_special_budget',
    SHARE_BUDGET_SPECIAL_BUDGET_POI: 'share_budget_special_budget_poi',
};
var BUDGET_TYPE = {
    NEW_BUDGET: 'new_budget',
    NORMAL_BUDGET: 'normal_budget'
};
var TOTAL_BUDGET_TYPE = {
    NORMAL_BUDGET: 'normal_budget',
    CO_BUDGET: 'co_budget',
    SPECIAL_CO_BUDGET: 'special_co_budget'
};
//# sourceMappingURL=budget-limit.model.js.map

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dialog_budget_limit_detail_dialog_budget_limit_detail_component__ = __webpack_require__(164);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogBudgetLimitMobileComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};



var DialogBudgetLimitMobileComponent = (function () {
    function DialogBudgetLimitMobileComponent(dialogRef, dialog, data) {
        this.dialogRef = dialogRef;
        this.dialog = dialog;
        this.data = data;
        this.name = 'dialog-budget-limit-mobile';
        this.appliedCoBudget = false;
        this.appliedCoBudget = data.destinationTravelPolicyBooker.some(function (tp) { return tp.appliedCoBudget; });
    }
    DialogBudgetLimitMobileComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    DialogBudgetLimitMobileComponent.prototype.onMoreDetail = function () {
        this.dialog.open(__WEBPACK_IMPORTED_MODULE_2__dialog_budget_limit_detail_dialog_budget_limit_detail_component__["a" /* DialogBudgetLimitDetailComponent */], {
            data: {
                budgetBooker: this.data.budgetBooker,
                budgetCoBooker: this.data.budgetCoBooker,
                destinationTravelPolicyBooker: this.data.destinationTravelPolicyBooker,
                destinationTravelPolicyCoBooker: this.data.destinationTravelPolicyCoBooker,
                isShareBudget: !!this.data.shareBudget
            }
        });
    };
    return DialogBudgetLimitMobileComponent;
}());
DialogBudgetLimitMobileComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-budget-limit-mobile',
        template: __webpack_require__(1018),
        styles: [__webpack_require__(883)]
    }),
    __param(2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */]) === "function" && _b || Object, Object])
], DialogBudgetLimitMobileComponent);

var _a, _b;
//# sourceMappingURL=dialog-budget-limit-mobile.component.js.map

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_modal_dialog_confirm_dialog_confirm_component__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_confirm_dialog_confirm_model__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_authorize_authorize_service__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_cart_cart_service__ = __webpack_require__(99);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogCartSummaryComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var DialogCartSummaryComponent = (function () {
    function DialogCartSummaryComponent(translatePipe, dialog, authorizeService, cartService) {
        this.translatePipe = translatePipe;
        this.dialog = dialog;
        this.authorizeService = authorizeService;
        this.cartService = cartService;
    }
    DialogCartSummaryComponent.prototype.ngOnInit = function () { };
    DialogCartSummaryComponent.prototype.onCancelShareBudget = function () {
        var _this = this;
        var message = { text: this.translatePipe.transform('dialog-cancel-share-budget-text'), subText: this.translatePipe.transform('dialog-cancel-share-budget-sub-text') };
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2_app_components_modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */], {
            data: {
                confirmType: __WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CANCEL_SHARE_BUDGET_FROM_USER,
                data: {
                    message: message
                }
            },
        });
        dialogRef.afterClosed().subscribe(function (res) {
            if (res) {
                _this.authorizeService.removeCoBookerCookie();
                _this.cartService.updateCartCancelShareBudget();
            }
        });
    };
    return DialogCartSummaryComponent;
}());
DialogCartSummaryComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-cart-summary',
        template: __webpack_require__(1021),
        styles: [__webpack_require__(886)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_4_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_authorize_authorize_service__["a" /* AuthorizeService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_authorize_authorize_service__["a" /* AuthorizeService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_cart_cart_service__["a" /* CartService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_cart_cart_service__["a" /* CartService */]) === "function" && _d || Object])
], DialogCartSummaryComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=dialog-cart-summary.component.js.map

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_alert_dialog_alert_component__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_model_checkout_checkout3_config_model__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_checkout_checkout_service__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_services_promotion_code_enum_promotion_code_enum__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_services_promotion_code_promotion_code_service__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogUsePromotionCodeComponent; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};











var DialogUsePromotionCodeComponent = (function () {
    function DialogUsePromotionCodeComponent(data, dialog, dialogRef, utilitiesService, appConfigService, checkoutService, promotionCodeService) {
        this.data = data;
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.utilitiesService = utilitiesService;
        this.appConfigService = appConfigService;
        this.checkoutService = checkoutService;
        this.promotionCodeService = promotionCodeService;
        this.elementId = 'dialog-use-promo-code';
        this.isLoading = false;
        this.isMobile = false;
        this.searchControl = new __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormControl"]('');
        this.searchErrorMessage = '';
        this.promotionCodeActiveList = [];
        this.promotionCodeActiveDisplayList = [];
    }
    DialogUsePromotionCodeComponent.prototype.ngOnInit = function () {
        this.isMobile = this.utilitiesService.isMobile();
        this.cart = this.checkoutService.getCheckoutData().cart;
        this.currentPromotionCode = this.checkoutService.getCurrentPromotionCode().codeInfo;
        this.subscribeSearchChange();
        this.getPromotionCodeActiveList(this.currentPromotionCode ? this.currentPromotionCode.promotionCode : undefined);
    };
    DialogUsePromotionCodeComponent.prototype.ngOnDestroy = function () {
        this.utilitiesService.unlockBody();
        this.utilitiesService.unlockBodyBackdrop();
        this.searchSubscription && this.searchSubscription.unsubscribe();
    };
    DialogUsePromotionCodeComponent.prototype.subscribeSearchChange = function () {
        var _this = this;
        this.searchSubscription = this.searchControl.valueChanges.subscribe(function (value) {
            var upper = value.toUpperCase();
            if (value !== upper) {
                _this.searchControl.setValue(upper, { emitEvent: false });
            }
            _this.searchErrorMessage = '';
        });
    };
    DialogUsePromotionCodeComponent.prototype.generatePromotionCodeActiveListRequest = function () {
        var currentSelectedPromotionCode = this.currentPromotionCode ? this.currentPromotionCode.promotionCode : '';
        var promotionCode = this.searchControl.value ? this.searchControl.value.trim() : currentSelectedPromotionCode;
        return {
            promotionCode: promotionCode,
            searchId: this.cart.searchId,
            lineItems: this.cart.lineItems
        };
    };
    DialogUsePromotionCodeComponent.prototype.getPromotionCodeActiveList = function (code) {
        var _this = this;
        this.isLoading = true;
        this.promotionCodeService.getPromotionCodeActiveList(this.generatePromotionCodeActiveListRequest())
            .subscribe(function (res) {
            _this.promotionCodeActiveList = [];
            _this.promotionCodeActiveDisplayList = [];
            if (res) {
                _this.transformPromotionCodeResponse(res.promotionCodes);
                if (code) {
                    _this.handleApplyCodeAfterSearch(code);
                }
            }
            _this.isLoading = false;
        }, function (errors) {
            _this.isLoading = false;
            _this.handleErrorPromotionCodeActiveList(errors);
        });
    };
    DialogUsePromotionCodeComponent.prototype.handleErrorPromotionCodeActiveList = function (errors) {
        var _this = this;
        var errorBody = errors.json();
        if (errorBody && errorBody.errors && errorBody.errors.length) {
            var errorCode_1 = errorBody.errors[0].code;
            if (errorCode_1 === '4723') {
                var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */]);
                dialogRef.componentInstance.alertHeader = this.appConfigService.getTranslate('cart-dialog-error-session-expired-title');
                dialogRef.componentInstance.alertText = this.appConfigService.getTranslate('cart-dialog-error-session-expired-description');
                dialogRef.componentInstance.imageSrc = '/assets/images/icons/Error.png';
                dialogRef.componentInstance.imageSrcSet = '/assets/images/icons/Error.png';
                dialogRef.afterClosed().subscribe(function () {
                    _this.handleCloseDialog('error', errorCode_1);
                });
            }
            else {
                var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */]);
                dialogRef.componentInstance.alertText = this.appConfigService.getTranslate('system-error');
                dialogRef.componentInstance.imageSrc = '/assets/images/icons/icon-failed.png';
                dialogRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-failed.png';
                dialogRef.afterClosed().subscribe(function () {
                    _this.handleCloseDialog('close');
                });
            }
        }
    };
    DialogUsePromotionCodeComponent.prototype.transformPromotionCodeResponse = function (promotionCodes) {
        var _this = this;
        var promotionCodesDisplay = promotionCodes.map(function (item, index) {
            var discountType = item.discount.discountType;
            var discount = __WEBPACK_IMPORTED_MODULE_8_app_services_promotion_code_enum_promotion_code_enum__["b" /* PromotionCodeDiscountType */].AMOUNT == discountType ? _this.utilitiesService.commaSeparateNumber(item.discount.discount) : item.discount.discount;
            var discountDisplay = _this.appConfigService.getTranslate('cart-dialog-use-promotion-code-discount')
                .replace('{amount}', __WEBPACK_IMPORTED_MODULE_8_app_services_promotion_code_enum_promotion_code_enum__["b" /* PromotionCodeDiscountType */].AMOUNT == discountType ? "THB " + discount : discount + "%");
            var discountAmountDisplay = _this.utilitiesService.commaSeparateNumber(item.discount.discountAmount);
            var maxDiscountPerBook = item.discount.maxDiscountPerBook ? _this.utilitiesService.commaSeparateNumber(item.discount.maxDiscountPerBook) : undefined;
            var maxDiscountPerBookDisplay = maxDiscountPerBook
                ? _this.appConfigService.getTranslate('cart-dialog-use-promotion-code-max-discount-per-book').replace('{amount}', "THB " + maxDiscountPerBook)
                : '';
            var minSpendPerBook = item.discount.minSpendPerBook ? _this.utilitiesService.commaSeparateNumber(item.discount.minSpendPerBook) : undefined;
            var minSpendPerBookDisplay = minSpendPerBook
                ? _this.appConfigService.getTranslate('cart-dialog-use-promotion-code-min-spend-per-book').replace('{amount}', "THB " + minSpendPerBook)
                : _this.appConfigService.getTranslate('cart-dialog-use-promotion-code-min-spend-per-book-no-limit');
            return __assign({}, item, { discountDisplay: discountDisplay,
                discountAmountDisplay: discountAmountDisplay,
                maxDiscountPerBookDisplay: maxDiscountPerBookDisplay,
                minSpendPerBookDisplay: minSpendPerBookDisplay, paymentMethodDisplay: _this.transformPaymentMethodDisplay(item.paymentMethods) });
        });
        this.promotionCodeActiveList = promotionCodesDisplay;
        this.promotionCodeActiveDisplayList = promotionCodesDisplay.slice();
    };
    DialogUsePromotionCodeComponent.prototype.transformPaymentMethodDisplay = function (paymentMethods) {
        if (!paymentMethods.length) {
            return '';
        }
        var paymentChannel = new __WEBPACK_IMPORTED_MODULE_4_app_model_checkout_checkout3_config_model__["a" /* PaymentChannelCheckout */]();
        if (paymentMethods.length > 1) {
            return this.handleMultiplePaymentMethods(paymentMethods, paymentChannel);
        }
        return this.handleSinglePaymentMethod(paymentMethods[0], paymentChannel);
    };
    DialogUsePromotionCodeComponent.prototype.handleMultiplePaymentMethods = function (paymentMethods, paymentChannel) {
        var paymentMethodDisplay = '';
        var types = paymentMethods.map(function (p) { return p.paymentMethod; });
        var isAllCardType = types.every(function (type) {
            return type === __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_CARD ||
                type === __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].DEBIT_CARD;
        });
        var isAllFleetType = types.every(function (type) {
            return type === __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].CORPORATE_FLEET ||
                type === __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].PERSONAL_FLEET;
        });
        if (isAllCardType) {
            paymentMethodDisplay = this.handleCreditDebitCard(paymentMethods[0], paymentChannel, true);
        }
        else if (isAllFleetType) {
            var paymentMethodTitle = this.appConfigService.getTranslate(paymentChannel.FLEET_CARD.title);
            paymentMethodDisplay = this.appConfigService.getTranslate('cart-dialog-use-promotion-payment').replace('{payment}', paymentMethodTitle);
        }
        else {
            paymentMethodDisplay = this.appConfigService.getTranslate('cart-dialog-use-promotion-promotional-code-participating-payment-methods');
        }
        return paymentMethodDisplay;
    };
    DialogUsePromotionCodeComponent.prototype.handleSinglePaymentMethod = function (payment, paymentChannel) {
        if (payment.paymentMethod === __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_TERMS) {
            return this.appConfigService.getTranslate('cart-dialog-use-promotion-credit-terms');
        }
        if (payment.paymentMethod === __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_CARD || payment.paymentMethod === __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].DEBIT_CARD) {
            return this.handleCreditDebitCard(payment, paymentChannel, false);
        }
        var paymentMethodMap = {};
        paymentMethodMap[__WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].TRUE_MONEY] = paymentChannel.TRUE_MONEY_WALLET;
        paymentMethodMap[__WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].CORPORATE_FLEET] = paymentChannel.CORPORATE_FLEET;
        paymentMethodMap[__WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].PERSONAL_FLEET] = paymentChannel.PERSONAL_FLEET;
        paymentMethodMap[__WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].QR_CODE] = paymentChannel.QR_CODE;
        paymentMethodMap[__WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].IM_BANKING] = paymentChannel.IM_BANKING;
        paymentMethodMap[__WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].PAY_AT_COUNTER] = paymentChannel.PAY_AT_COUNTER;
        paymentMethodMap[__WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].E_WALLET] = paymentChannel.E_WALLET;
        var paymentMethodChannel = paymentMethodMap[payment.paymentMethod];
        if (!paymentMethodChannel) {
            return '';
        }
        var title = this.appConfigService.getTranslate(paymentMethodChannel.title);
        var needSpace = payment.paymentMethod === __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].E_WALLET || payment.paymentMethod === __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].QR_CODE;
        return this.appConfigService.getTranslate('cart-dialog-use-promotion-payment').replace('{payment}', "" + (needSpace ? ' ' : '') + title);
    };
    DialogUsePromotionCodeComponent.prototype.handleCreditDebitCard = function (payment, paymentChannel, isMultiple) {
        var banks = payment.bank;
        var hasSingleBank = banks && banks.length === 1;
        var hasMultipleBanks = banks && banks.length > 1;
        if (hasMultipleBanks) {
            return this.appConfigService.getTranslate('cart-dialog-use-promotion-promotional-code-participating-payment-methods');
        }
        if (isMultiple) {
            if (hasSingleBank) {
                return this.appConfigService.getTranslate('cart-dialog-use-promotion-credit-debit-card-bank').replace('{bank}', banks[0]);
            }
            var title = this.appConfigService.getTranslate(paymentChannel.CREDIT_CARD.title);
            return this.appConfigService.getTranslate('cart-dialog-use-promotion-payment').replace('{payment}', title);
        }
        var key = payment.paymentMethod === __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_CARD
            ? 'cart-dialog-use-promotion-credit-card'
            : 'cart-dialog-use-promotion-debit-card';
        return this.appConfigService.getTranslate(key).replace('{bank}', hasSingleBank ? banks[0] + " " : '');
    };
    DialogUsePromotionCodeComponent.prototype.onApplyCode = function () {
        var search = this.searchControl.value ? this.searchControl.value.trim() : '';
        if (!search) {
            return;
        }
        this.getPromotionCodeActiveList(search);
    };
    DialogUsePromotionCodeComponent.prototype.handleApplyCodeAfterSearch = function (code) {
        var search = code ? code.trim() : '';
        var promotionCode = this.promotionCodeActiveDisplayList.find(function (p) { return p.promotionCode === search; });
        if (!promotionCode) {
            this.searchErrorMessage = this.appConfigService.getTranslate('cart-dialog-use-promotion-code-search-error-invalid');
            this.selectedItem = undefined;
            return;
        }
        this.searchErrorMessage = '';
        this.selectedItem = promotionCode;
    };
    DialogUsePromotionCodeComponent.prototype.resetApplyCode = function () {
        this.searchControl.setValue('');
        this.selectedItem = undefined;
        this.promotionCodeActiveDisplayList.forEach(function (i) { return i.selected = false; });
        this.getPromotionCodeActiveList();
    };
    DialogUsePromotionCodeComponent.prototype.onSelected = function (item) {
        if (item.selected) {
            item.selected = false;
            this.selectedItem = undefined;
            return;
        }
        this.promotionCodeActiveDisplayList.forEach(function (i) { return i.selected = false; });
        item.selected = true;
        this.selectedItem = item;
    };
    DialogUsePromotionCodeComponent.prototype.handleSubmit = function () {
        if (!this.selectedItem) {
            this.handleCloseDialog('submit', {});
            return;
        }
        var _a = this.selectedItem, discountDisplay = _a.discountDisplay, discountAmountDisplay = _a.discountAmountDisplay, maxDiscountPerBookDisplay = _a.maxDiscountPerBookDisplay, minSpendPerBookDisplay = _a.minSpendPerBookDisplay, paymentMethodDisplay = _a.paymentMethodDisplay, selected = _a.selected, promotionCodeResponse = __rest(_a, ["discountDisplay", "discountAmountDisplay", "maxDiscountPerBookDisplay", "minSpendPerBookDisplay", "paymentMethodDisplay", "selected"]);
        this.handleCloseDialog('submit', promotionCodeResponse);
    };
    DialogUsePromotionCodeComponent.prototype.handleCloseDialog = function (type, data) {
        this.dialogRef.close({ type: type, data: data });
    };
    return DialogUsePromotionCodeComponent;
}());
DialogUsePromotionCodeComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-use-promotion-code',
        template: __webpack_require__(1023),
        styles: [__webpack_require__(888)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [Object, typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_10_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_10_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_checkout_checkout_service__["a" /* CheckoutService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_checkout_checkout_service__["a" /* CheckoutService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_9_app_services_promotion_code_promotion_code_service__["a" /* PromotionCodeService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_9_app_services_promotion_code_promotion_code_service__["a" /* PromotionCodeService */]) === "function" && _f || Object])
], DialogUsePromotionCodeComponent);

var _a, _b, _c, _d, _e, _f;
//# sourceMappingURL=dialog-use-promotion-code.component.js.map

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_login_login_response_model__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_model_menu_companyFeatures__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_model_user_model__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_modal_dialog_alert_dialog_alert_component__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_services_authorize_authorize_service__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_services_notice_notice_service__ = __webpack_require__(157);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogSwitchCompanyComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};











var DialogSwitchCompanyComponent = (function () {
    function DialogSwitchCompanyComponent(dialogRef, appConfigService, authService, authorizeService, router, dialog, noticeService, data) {
        this.dialogRef = dialogRef;
        this.appConfigService = appConfigService;
        this.authService = authService;
        this.authorizeService = authorizeService;
        this.router = router;
        this.dialog = dialog;
        this.noticeService = noticeService;
        this.data = data;
        this.setElementIdPage = 'dialog-switch-company';
        this.travelPolicyCoBudgetList = [];
    }
    DialogSwitchCompanyComponent.prototype.onResize = function (event) {
        document.documentElement.style.setProperty('--height-vh', window.innerHeight * 0.01 + "px");
    };
    DialogSwitchCompanyComponent.prototype.ngOnInit = function () {
        this.onResize();
        this.user = this.authService.getUserInfo();
        this.lang = this.getLang();
        if (this.data && this.data.travelPolicyList !== null) {
            for (var _i = 0, _a = this.data.travelPolicyList; _i < _a.length; _i++) {
                var travelPolicy = _a[_i];
                if (travelPolicy.coBudgetUnlimited != null) {
                    this.travelPolicyCoBudgetList.push(travelPolicy);
                }
            }
        }
    };
    DialogSwitchCompanyComponent.prototype.ngOnDestroy = function () {
        this.authServiceSubscription && this.authServiceSubscription.unsubscribe();
    };
    DialogSwitchCompanyComponent.prototype.onChangeCompany = function () {
        var _this = this;
        this.isLoading = true;
        var user = new __WEBPACK_IMPORTED_MODULE_5_app_model_user_model__["b" /* UserModel */];
        user.companyId = this.data.companyId;
        var loginResponseModel = new __WEBPACK_IMPORTED_MODULE_3_app_model_login_login_response_model__["a" /* LoginResponseModel */];
        this.user.companyId = this.data.companyId;
        this.user.companyTitleTh = this.data.companyTitleTh;
        this.user.companyTitleEn = this.data.companyTitleEn;
        loginResponseModel.user = this.user;
        this.noticeService.removeNotifyCookie();
        this.authorizeService.removeCoBookerCookie();
        this.authServiceSubscription && this.authServiceSubscription.unsubscribe();
        this.authServiceSubscription = this.authService.saveUserFeature(null, user, __WEBPACK_IMPORTED_MODULE_7_app_services_authentication_authentication_service__["a" /* AuthenticationService */].features).subscribe(function (save) {
            save && _this.authService.saveToken(loginResponseModel);
            _this.dialogRef.close('success');
            if (document.location.pathname === '/checkout') {
                _this.router.navigateByUrl('/?lang=' + _this.appConfigService.getLanguage());
            }
            else {
                // Reload current router
                _this.router.routeReuseStrategy.shouldReuseRoute = function () {
                    return false;
                };
                _this.router.navigated = false;
                _this.router.navigateByUrl(_this.router.url);
            }
        }), function (error) {
            _this.dialogRef.close();
            var dialogAlertRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_8_app_components_modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */]);
            dialogAlertRef.componentInstance.alertText = _this.appConfigService.getTranslate('system-error');
            dialogAlertRef.componentInstance.imageSrc = '/assets/images/icons/icon-failed.png';
            dialogAlertRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-failed.png';
        };
    };
    DialogSwitchCompanyComponent.prototype.getLang = function () {
        return this.appConfigService.getLanguage();
    };
    DialogSwitchCompanyComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    return DialogSwitchCompanyComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DialogSwitchCompanyComponent.prototype, "onResize", null);
DialogSwitchCompanyComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-switch-company',
        template: __webpack_require__(1037),
        styles: [__webpack_require__(902)]
    }),
    __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_9_app_services_authorize_authorize_service__["a" /* AuthorizeService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_9_app_services_authorize_authorize_service__["a" /* AuthorizeService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* Router */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_10_app_services_notice_notice_service__["b" /* NoticeService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_10_app_services_notice_notice_service__["b" /* NoticeService */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_4_app_model_menu_companyFeatures__["a" /* CompanyFeaturesDetail */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_model_menu_companyFeatures__["a" /* CompanyFeaturesDetail */]) === "function" && _h || Object])
], DialogSwitchCompanyComponent);

var _a, _b, _c, _d, _e, _f, _g, _h;
//# sourceMappingURL=dialog-switch-company.component.js.map

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_currency_currency_service__ = __webpack_require__(58);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogSwitchLangCurrencyComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var DialogSwitchLangCurrencyComponent = (function () {
    function DialogSwitchLangCurrencyComponent(dialogRef, appConfigService, currencyService) {
        this.dialogRef = dialogRef;
        this.appConfigService = appConfigService;
        this.currencyService = currencyService;
        this.elementIdPage = 'dialog-switch-language-currency';
        this.LANGUAGE = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["a" /* Language */];
        this.languageList = [];
    }
    DialogSwitchLangCurrencyComponent.prototype.ngOnInit = function () {
        this.languageList = this.appConfigService.getLanguageList();
        this.currentLanguage = this.appConfigService.getLanguage();
        this.tempLanguage = this.currentLanguage;
        this.currencyList = this.currencyService.getCurrencyList();
        this.tempCurrency = this.currencyService.getCurrencyCode();
    };
    DialogSwitchLangCurrencyComponent.prototype.ngOnDestroy = function () {
    };
    DialogSwitchLangCurrencyComponent.prototype.handleChangeLanguage = function (use) {
        this.tempLanguage = use;
    };
    DialogSwitchLangCurrencyComponent.prototype.handleChangeCurrency = function (use) {
        this.tempCurrency = use;
    };
    DialogSwitchLangCurrencyComponent.prototype.handleCancel = function () {
        this.dialogRef.close();
    };
    DialogSwitchLangCurrencyComponent.prototype.handleSubmit = function () {
        this.dialogRef.close({
            language: this.tempLanguage,
            currency: this.tempCurrency
        });
    };
    return DialogSwitchLangCurrencyComponent;
}());
DialogSwitchLangCurrencyComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-switch-lang-currency',
        template: __webpack_require__(1038),
        styles: [__webpack_require__(903)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_currency_currency_service__["a" /* CurrencyService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_currency_currency_service__["a" /* CurrencyService */]) === "function" && _c || Object])
], DialogSwitchLangCurrencyComponent);

var _a, _b, _c;
//# sourceMappingURL=dialog-switch-lang-currency.component.js.map

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogBannerOverlayComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};



var DialogBannerOverlayComponent = (function () {
    function DialogBannerOverlayComponent(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.elementId = 'banner-overlay';
        this.owlCarouselInitialed = false;
    }
    DialogBannerOverlayComponent.prototype.ngOnInit = function () {
        this.initCarousel();
    };
    DialogBannerOverlayComponent.prototype.ngOnDestroy = function () {
        this.owlCarousel && this.owlCarousel.trigger("destroy.owl.carousel");
    };
    DialogBannerOverlayComponent.prototype.initCarousel = function () {
        var _this = this;
        setTimeout(function () {
            _this.owlCarousel = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.banner-overlay-owl');
            if (_this.owlCarousel && _this.owlCarousel.children().length === _this.data.length) {
                _this.owlCarousel.owlCarousel({
                    loop: true,
                    nav: true,
                    navText: [
                        '<i class="icon-arrow-left-circle"></i>',
                        '<i class="icon-arrow-right-circle"></i>'
                    ],
                    items: 1,
                    autoplay: true,
                    autoplayTimeout: 5000,
                    autoplayHoverPause: true
                });
                _this.owlCarouselInitialed = true;
            }
            else {
                _this.initCarousel();
            }
        }, 500);
    };
    DialogBannerOverlayComponent.prototype.onClose = function () {
        this.dialogRef.close(true);
    };
    return DialogBannerOverlayComponent;
}());
DialogBannerOverlayComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-banner-overlay',
        template: __webpack_require__(1041),
        styles: [__webpack_require__(906)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [Array, typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object])
], DialogBannerOverlayComponent);

var _a;
//# sourceMappingURL=dialog-banner-overlay.component.js.map

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_user_communication_preference_model__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogCompanyCommunicationBannerComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};





var DialogCompanyCommunicationBannerComponent = (function () {
    function DialogCompanyCommunicationBannerComponent(data, dialogRef, utilitiesService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.utilitiesService = utilitiesService;
        this.isValidFormSubmitted = null;
        this.dialogWidthDesktop = 750;
        this.dialogHeightMobile = 640;
        this.dialogMaxWidthMobile = 430;
        this.buildForm();
    }
    DialogCompanyCommunicationBannerComponent.prototype.onResize = function (event) {
        this.resizeDialog();
        document.documentElement.style.setProperty('--height-vh', window.innerHeight * 0.01 + "px");
    };
    DialogCompanyCommunicationBannerComponent.prototype.ngOnInit = function () {
        this.resizeDialog();
        this.image = "data:image/jpeg;base64," + btoa(new Uint8Array(this.data.bannerTemplate.bannerImage).reduce(function (data, byte) { return data + String.fromCharCode(byte); }, ''));
    };
    DialogCompanyCommunicationBannerComponent.prototype.resizeDialog = function () {
        if (!this.utilitiesService.isMobile()) {
            this.resizeDialogDesktopSize();
        }
        else {
            this.resizeDialogMobileSize();
        }
    };
    DialogCompanyCommunicationBannerComponent.prototype.resizeDialogMobileSize = function () {
        var dialogWidthMobile = (window.innerWidth - 20);
        this.dialogHeightMobile = dialogWidthMobile * (640 / 480);
        if (this.data.acceptingCondition) {
            this.dialogMaxWidthMobile = 540;
        }
        else {
            this.dialogMaxWidthMobile = Math.max((window.innerHeight - 70) * (480 / 640), 200);
        }
        document.getElementsByClassName('dialog-wrapper-content')[0].style.maxWidth = this.dialogMaxWidthMobile + "px";
        document.getElementsByClassName('dialog-wrapper-content')[0].style.marginLeft = "auto";
        document.getElementsByClassName('dialog-wrapper-content')[0].style.marginRight = "auto";
        document.getElementsByClassName('dialog-wrapper-content')[0].style.marginTop = "-50px";
    };
    DialogCompanyCommunicationBannerComponent.prototype.resizeDialogDesktopSize = function () {
        if (window.innerHeight < 680) {
            this.dialogWidthDesktop = Math.max(750 - (680 - window.innerHeight) * (750 / 600), 200);
            document.getElementsByClassName('dialog-wrapper-content')[0].style.width = this.dialogWidthDesktop + "px";
        }
        else {
            this.dialogWidthDesktop = 750;
            document.getElementsByClassName('dialog-wrapper-content')[0].style.width = this.dialogWidthDesktop + "px";
        }
        document.getElementsByClassName('dialog-wrapper-content')[0].style.maxWidth = "unset";
        document.getElementsByClassName('dialog-wrapper-content')[0].style.marginLeft = "unset";
        document.getElementsByClassName('dialog-wrapper-content')[0].style.marginRight = "unset";
        document.getElementsByClassName('dialog-wrapper-content')[0].style.marginTop = "unset";
    };
    DialogCompanyCommunicationBannerComponent.prototype.buildForm = function () {
        this.form = new __WEBPACK_IMPORTED_MODULE_3__angular_forms__["FormGroup"]({
            agree: new __WEBPACK_IMPORTED_MODULE_3__angular_forms__["FormControl"]('', __WEBPACK_IMPORTED_MODULE_3__angular_forms__["Validators"].requiredTrue)
        });
    };
    DialogCompanyCommunicationBannerComponent.prototype.onFormSubmit = function () {
        this.isValidFormSubmitted = false;
        if (this.data.acceptingCondition && (this.form.invalid)) {
            return;
        }
        this.isValidFormSubmitted = true;
        this.dialogRef.close(true);
    };
    return DialogCompanyCommunicationBannerComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DialogCompanyCommunicationBannerComponent.prototype, "onResize", null);
DialogCompanyCommunicationBannerComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-company-communication-banner',
        template: __webpack_require__(1046),
        styles: [__webpack_require__(911)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2_app_model_user_communication_preference_model__["b" /* CompanyCommunication */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_model_user_communication_preference_model__["b" /* CompanyCommunication */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _c || Object])
], DialogCompanyCommunicationBannerComponent);

var _a, _b, _c;
//# sourceMappingURL=dialog-company-communication-banner.component.js.map

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_model_user_communication_preference_model__ = __webpack_require__(171);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogCompanyCommunicationTextComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};





var DialogCompanyCommunicationTextComponent = (function () {
    function DialogCompanyCommunicationTextComponent(data, dialogRef, sanitizer) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.sanitizer = sanitizer;
        this.isValidFormSubmitted = null;
        this.buildForm();
    }
    DialogCompanyCommunicationTextComponent.prototype.onResize = function (event) {
        document.documentElement.style.setProperty('--height-vh', window.innerHeight * 0.01 + "px");
    };
    DialogCompanyCommunicationTextComponent.prototype.ngOnInit = function () {
        if (this.data.textTemplate) {
            this.title = this.data.textTemplate.title ? this.sanitizer.bypassSecurityTrustHtml(this.data.textTemplate.title) : undefined;
            this.message = this.data.textTemplate.message ? this.sanitizer.bypassSecurityTrustHtml(this.data.textTemplate.message) : undefined;
        }
    };
    DialogCompanyCommunicationTextComponent.prototype.buildForm = function () {
        this.form = new __WEBPACK_IMPORTED_MODULE_3__angular_forms__["FormGroup"]({
            agree: new __WEBPACK_IMPORTED_MODULE_3__angular_forms__["FormControl"]('', __WEBPACK_IMPORTED_MODULE_3__angular_forms__["Validators"].requiredTrue)
        });
    };
    DialogCompanyCommunicationTextComponent.prototype.onFormSubmit = function () {
        this.isValidFormSubmitted = false;
        if (this.data.acceptingCondition && (this.form.invalid)) {
            return;
        }
        this.isValidFormSubmitted = true;
        this.dialogRef.close(true);
    };
    return DialogCompanyCommunicationTextComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DialogCompanyCommunicationTextComponent.prototype, "onResize", null);
DialogCompanyCommunicationTextComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-company-communication-text',
        template: __webpack_require__(1047),
        styles: [__webpack_require__(912)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_4_app_model_user_communication_preference_model__["b" /* CompanyCommunication */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_model_user_communication_preference_model__["b" /* CompanyCommunication */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["e" /* DomSanitizer */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["e" /* DomSanitizer */]) === "function" && _c || Object])
], DialogCompanyCommunicationTextComponent);

var _a, _b, _c;
//# sourceMappingURL=dialog-company-communication-text.component.js.map

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogConfirmActionComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};



var DialogConfirmActionComponent = (function () {
    function DialogConfirmActionComponent(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.isLoading = false;
        this.confirmClick = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
    }
    DialogConfirmActionComponent.prototype.ngOnInit = function () {
        var mainBtn = this.data.mainBtn;
        this.mainBtn = mainBtn;
    };
    DialogConfirmActionComponent.prototype.handleClose = function () {
        this.isLoading = false;
        this.dialogRef.close();
    };
    DialogConfirmActionComponent.prototype.handleConfirm = function () {
        this.isLoading = true;
        this.confirmClick.next();
    };
    DialogConfirmActionComponent.prototype.onConfirmClicked = function () {
        return this.confirmClick;
    };
    return DialogConfirmActionComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], DialogConfirmActionComponent.prototype, "message", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], DialogConfirmActionComponent.prototype, "mainBtn", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], DialogConfirmActionComponent.prototype, "isLoading", void 0);
DialogConfirmActionComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'dialog-confirm-action',
        template: __webpack_require__(1049),
        styles: [__webpack_require__(914)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [Object, typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object])
], DialogConfirmActionComponent);

var _a;
//# sourceMappingURL=dialog-confirm-action.component.js.map

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pin_state__ = __webpack_require__(233);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PinComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var PinComponent = (function () {
    function PinComponent(fb, appConfigService) {
        this.fb = fb;
        this.appConfigService = appConfigService;
        this.elementId = 'pin';
        this.PIN_STATE = __WEBPACK_IMPORTED_MODULE_3__pin_state__["a" /* PIN_STATE */];
        this.isLoading = false;
        this.clickResentOTP = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.resetError = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.initialForm();
    }
    PinComponent.prototype.ngOnInit = function () {
        this.subscribeLanguageChanges();
    };
    PinComponent.prototype.ngOnChanges = function (changes) {
        var state = changes['state'];
        if (state && state.currentValue) {
            this.pinInputForm.reset();
            this.focusInput(0);
        }
    };
    PinComponent.prototype.subscribeLanguageChanges = function () {
        var _this = this;
        this.lang = this.appConfigService.getLanguage();
        this.langSubscription && this.langSubscription.unsubscribe();
        this.langSubscription = this.appConfigService.getLanguageObs().subscribe(function (lang) {
            _this.lang = lang;
        });
    };
    Object.defineProperty(PinComponent.prototype, "pinControls", {
        get: function () {
            return Object.keys(this.pinInputForm.controls);
        },
        enumerable: true,
        configurable: true
    });
    PinComponent.prototype.initialForm = function () {
        var _this = this;
        this.pinInputForm = this.fb.group({
            0: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required],
            1: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required],
            2: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required],
            3: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required],
            4: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required],
            5: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required],
        });
        this.pinInputForm.valueChanges.subscribe(function () {
            _this.resetError.emit();
        });
    };
    PinComponent.prototype.onPinInput = function (event, index) {
        var inputElement = event.target;
        if (inputElement.value.length === 1 && index < 5) {
            this.focusInput(index + 1);
        }
        else if (inputElement.value.length > 1) {
            var value = inputElement.value.slice(0, 1);
            inputElement.value = value;
            this.pinInputForm.controls[index].setValue(value);
        }
    };
    PinComponent.prototype.onKeydown = function (event, index) {
        var allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Meta', 'Control', 'v'];
        var isNumeric = /^[0-9]$/i.test(event.key);
        if (!isNumeric && !allowedKeys.includes(event.key)) {
            event.preventDefault();
        }
        var control = this.pinInputForm.get(index.toString());
        var value = control ? control.value : '';
        if (event.key === 'Backspace' && value !== 0 && !value && index > 0) {
            this.focusInput(index - 1);
        }
    };
    PinComponent.prototype.onPaste = function (event) {
        var _this = this;
        var clipboardData = event.clipboardData ? event.clipboardData.getData('text') : '';
        if (clipboardData) {
            var pastedPin = clipboardData.replace(/[^0-9]/g, '');
            var pinChars = pastedPin.split('');
            pinChars.forEach(function (char, index) {
                var control = _this.pinInputForm.get(index.toString());
                if (control) {
                    control.setValue(char);
                }
            });
            event.preventDefault();
        }
    };
    Object.defineProperty(PinComponent.prototype, "rawPin", {
        get: function () {
            var _this = this;
            return Object.keys(this.pinInputForm.value).map(function (key) { return _this.pinInputForm.value[key]; }).join('');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PinComponent.prototype, "pinInputFormControls", {
        get: function () {
            return this.pinInputForm;
        },
        enumerable: true,
        configurable: true
    });
    PinComponent.prototype.focusInput = function (index) {
        var input = document.querySelectorAll("#" + this.elementId + "-form input")[index];
        if (input) {
            input.focus();
        }
    };
    return PinComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], PinComponent.prototype, "state", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], PinComponent.prototype, "isLoading", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], PinComponent.prototype, "errorMessage", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], PinComponent.prototype, "clickResentOTP", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
], PinComponent.prototype, "resetError", void 0);
PinComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-pin',
        template: __webpack_require__(1064),
        styles: [__webpack_require__(929)]
    }),
    __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object])
], PinComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=pin.component.js.map

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogShareBudgetDetailComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};


var DialogShareBudgetDetailComponent = (function () {
    function DialogShareBudgetDetailComponent(dialogRef, dialog, shareBudget) {
        this.dialogRef = dialogRef;
        this.dialog = dialog;
        this.shareBudget = shareBudget;
    }
    DialogShareBudgetDetailComponent.prototype.ngOnInit = function () {
    };
    DialogShareBudgetDetailComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    return DialogShareBudgetDetailComponent;
}());
DialogShareBudgetDetailComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-share-budget-detail',
        template: __webpack_require__(1069),
        styles: [__webpack_require__(934)]
    }),
    __param(2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */]) === "function" && _b || Object, Object])
], DialogShareBudgetDetailComponent);

var _a, _b;
//# sourceMappingURL=dialog-share-budget-detail.component.js.map

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__address_form_address_form_component__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dialog_tax_address_model__ = __webpack_require__(256);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogTaxAddressComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};




var DialogTaxAddressComponent = (function () {
    function DialogTaxAddressComponent(dialogRef, address) {
        this.dialogRef = dialogRef;
        this.address = address;
        this.pageElementName = 'dialog-tax-address';
        this.addressInfo = {
            title: '',
            address: '',
            taxNumber: ''
        };
        this.options = { page: this.pageElementName, selectable: false, editable: true };
        this.isLoading = false;
        this.address && (this.addressInfo = this.address);
    }
    DialogTaxAddressComponent.prototype.ngOnInit = function () {
    };
    DialogTaxAddressComponent.prototype.handleUpdateAddressInfo = function (data) {
        this.dialogRef.close({
            action: data ? __WEBPACK_IMPORTED_MODULE_3__dialog_tax_address_model__["a" /* DialogTaxAddressActionType */].UPDATE_ADDRESS : __WEBPACK_IMPORTED_MODULE_3__dialog_tax_address_model__["a" /* DialogTaxAddressActionType */].CANCEL,
            data: data
        });
    };
    DialogTaxAddressComponent.prototype.handleCancel = function () {
        this.dialogRef.close({
            action: __WEBPACK_IMPORTED_MODULE_3__dialog_tax_address_model__["a" /* DialogTaxAddressActionType */].CANCEL,
            data: undefined
        });
    };
    DialogTaxAddressComponent.prototype.onSubmit = function () {
        this.isLoading = true;
        if (!this.addressFormComponent.submitAddressForm()) {
            this.isLoading = false;
        }
    };
    return DialogTaxAddressComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_2__address_form_address_form_component__["a" /* AddressFormComponent */]),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__address_form_address_form_component__["a" /* AddressFormComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__address_form_address_form_component__["a" /* AddressFormComponent */]) === "function" && _a || Object)
], DialogTaxAddressComponent.prototype, "addressFormComponent", void 0);
DialogTaxAddressComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-tax-address',
        template: __webpack_require__(1073),
        styles: [__webpack_require__(938)]
    }),
    __param(1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _b || Object, Object])
], DialogTaxAddressComponent);

var _a, _b;
//# sourceMappingURL=dialog-tax-address.component.js.map

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DialogTaxAddressData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogTaxAddressActionType; });
var DialogTaxAddressData = (function () {
    function DialogTaxAddressData() {
    }
    return DialogTaxAddressData;
}());

var DialogTaxAddressActionType;
(function (DialogTaxAddressActionType) {
    DialogTaxAddressActionType[DialogTaxAddressActionType["UPDATE_ADDRESS"] = 0] = "UPDATE_ADDRESS";
    DialogTaxAddressActionType[DialogTaxAddressActionType["CANCEL"] = 1] = "CANCEL";
})(DialogTaxAddressActionType || (DialogTaxAddressActionType = {}));
//# sourceMappingURL=dialog-tax-address.model.js.map

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_user_consent_model__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(11);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogTermsAndConditionsComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var DEFAULT_PURPOSE_CHECKBOX = true;
var DialogTermsAndConditionsComponent = (function () {
    function DialogTermsAndConditionsComponent(dialogRef, userService, formBuilder) {
        this.dialogRef = dialogRef;
        this.userService = userService;
        this.formBuilder = formBuilder;
        this.isShowSubmit = false;
        this.consentTypeConst = __WEBPACK_IMPORTED_MODULE_3_app_model_user_consent_model__["b" /* ConsentType */];
        this.form = this.formBuilder.group({
            purposes: new __WEBPACK_IMPORTED_MODULE_4__angular_forms__["FormArray"]([])
        });
    }
    Object.defineProperty(DialogTermsAndConditionsComponent.prototype, "consent", {
        get: function () {
            return this._consent;
        },
        set: function (consent) {
            var _this = this;
            this._consent = consent;
            this.addPurposes();
            setTimeout(function () { return _this.onResize(); }, 0);
        },
        enumerable: true,
        configurable: true
    });
    DialogTermsAndConditionsComponent.prototype.onResize = function (event) {
        document.documentElement.style.setProperty('--dialog-filter-vh', window.innerHeight * 0.01 + "px");
        if (document.getElementById('dialog-terms-and-condition-footer') && document.getElementById('dialog-terms-and-condition-title')) {
            document.documentElement.style.setProperty('--title-height', document.getElementById('dialog-terms-and-condition-title').clientHeight + "px");
            document.documentElement.style.setProperty('--footer-height', document.getElementById('dialog-terms-and-condition-footer').clientHeight + "px");
        }
    };
    DialogTermsAndConditionsComponent.prototype.onKeydownHandler = function (event) {
        event.stopImmediatePropagation();
        return false;
    };
    Object.defineProperty(DialogTermsAndConditionsComponent.prototype, "purposesFormArray", {
        get: function () {
            return this.form.controls.purposes;
        },
        enumerable: true,
        configurable: true
    });
    DialogTermsAndConditionsComponent.prototype.ngOnInit = function () {
        this.onResize();
    };
    DialogTermsAndConditionsComponent.prototype.ngOnDestroy = function () {
        this.updateUserConsentSubscription && this.updateUserConsentSubscription.unsubscribe();
    };
    DialogTermsAndConditionsComponent.prototype.addPurposes = function () {
        var _this = this;
        this.consent.purposes.forEach(function () { return _this.purposesFormArray.push(new __WEBPACK_IMPORTED_MODULE_4__angular_forms__["FormControl"](DEFAULT_PURPOSE_CHECKBOX)); });
    };
    DialogTermsAndConditionsComponent.prototype.handleCloseDialog = function () {
        this.dialogRef.close();
    };
    DialogTermsAndConditionsComponent.prototype.submit = function () {
        var _this = this;
        var selectedPurposeIds = this.form.value.purposes
            .map(function (checked, i) { return checked ? _this.consent.purposes[i].purposeId : null; })
            .filter(function (v) { return v !== null; });
        this.updateUserConsentSubscription && this.updateUserConsentSubscription.unsubscribe();
        this.updateUserConsentSubscription = this.userService.updateConsent(this.userId, this.consent.consentId, selectedPurposeIds).subscribe(function (res) { _this.dialogRef.close(); }, function (error) { _this.dialogRef.close(); });
    };
    return DialogTermsAndConditionsComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], DialogTermsAndConditionsComponent.prototype, "userId", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], DialogTermsAndConditionsComponent.prototype, "isShowSubmit", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], DialogTermsAndConditionsComponent.prototype, "consentType", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3_app_model_user_consent_model__["c" /* Consent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_model_user_consent_model__["c" /* Consent */]) === "function" && _a || Object),
    __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3_app_model_user_consent_model__["c" /* Consent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_model_user_consent_model__["c" /* Consent */]) === "function" && _b || Object])
], DialogTermsAndConditionsComponent.prototype, "consent", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DialogTermsAndConditionsComponent.prototype, "onResize", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('document:keydown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DialogTermsAndConditionsComponent.prototype, "onKeydownHandler", null);
DialogTermsAndConditionsComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-terms-and-conditions',
        template: __webpack_require__(1074),
        styles: [__webpack_require__(939)]
    }),
    __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_user_user_service__["a" /* UserService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_4__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__angular_forms__["FormBuilder"]) === "function" && _e || Object])
], DialogTermsAndConditionsComponent);

var _a, _b, _c, _d, _e;
//# sourceMappingURL=dialog-terms-and-conditions.component.js.map

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_model_user_consent_model__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_environments_properties__ = __webpack_require__(21);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TermsAndConditionsComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var TermsAndConditionsComponent = (function () {
    function TermsAndConditionsComponent(appConfigService, userService) {
        this.appConfigService = appConfigService;
        this.userService = userService;
        this.isGetContentFromAPI = false;
        this.lang = this.appConfigService.getLanguage();
    }
    TermsAndConditionsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.langSubscription && this.langSubscription.unsubscribe();
        this.langSubscription = this.appConfigService.getLanguageObs().subscribe(function (lang) {
            _this.lang = lang;
            _this.getConsentDetail(__WEBPACK_IMPORTED_MODULE_4_environments_properties__["n" /* consentName */], _this.lang);
        });
        if (this.isGetContentFromAPI) {
            this.getConsentDetail(__WEBPACK_IMPORTED_MODULE_4_environments_properties__["n" /* consentName */], this.lang);
        }
    };
    TermsAndConditionsComponent.prototype.ngOnDestroy = function () {
        this.langSubscription && this.langSubscription.unsubscribe();
        this.getConsentDetailSubscription && this.getConsentDetailSubscription.unsubscribe();
    };
    TermsAndConditionsComponent.prototype.getConsentDetail = function (consentName, lang) {
        var _this = this;
        this.getConsentDetailSubscription && this.getConsentDetailSubscription.unsubscribe();
        this.getConsentDetailSubscription = this.userService.getConsentDetail(consentName, __WEBPACK_IMPORTED_MODULE_1_app_model_user_consent_model__["b" /* ConsentType */].TERMS, lang)
            .subscribe(function (res) {
            if (res) {
                _this.contentFromAPI = res.terms;
            }
        }, function (err) { return console.error(err); });
    };
    return TermsAndConditionsComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], TermsAndConditionsComponent.prototype, "lang", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], TermsAndConditionsComponent.prototype, "content", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], TermsAndConditionsComponent.prototype, "isGetContentFromAPI", void 0);
TermsAndConditionsComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-terms-and-conditions',
        template: __webpack_require__(1091),
        styles: [__webpack_require__(956)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_user_user_service__["a" /* UserService */]) === "function" && _b || Object])
], TermsAndConditionsComponent);

var _a, _b;
//# sourceMappingURL=terms-and-conditions.component.js.map

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_otp_otp_model__ = __webpack_require__(170);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OtpComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var OtpComponent = (function () {
    function OtpComponent(fb) {
        this.fb = fb;
        this.COUNTDOWN_RESEND_OTP = 60;
        this.elementId = 'verify-otp';
        this.coundown = this.COUNTDOWN_RESEND_OTP;
        this.isLoading = false;
        this.sessionExpired = false;
        this.clickResentOTP = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.clickVerifyOTP = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.initialForm();
    }
    OtpComponent.prototype.ngOnInit = function () {
        this.countdownResentOTP();
    };
    OtpComponent.prototype.ngAfterViewInit = function () {
        this.focusInput(0);
    };
    OtpComponent.prototype.ngOnChanges = function (changes) {
        if (changes.referenceCode && changes.referenceCode.currentValue) {
            this.otpInputForm.reset();
        }
    };
    OtpComponent.prototype.initialForm = function () {
        var _this = this;
        this.otpInputForm = this.fb.group({
            0: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required],
            1: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required],
            2: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required],
            3: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required],
            4: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required],
        });
        this.otpInputForm.valueChanges.subscribe(function () {
            _this.error = undefined;
        });
    };
    Object.defineProperty(OtpComponent.prototype, "otpControls", {
        get: function () {
            return Object.keys(this.otpInputForm.controls);
        },
        enumerable: true,
        configurable: true
    });
    OtpComponent.prototype.countdownResentOTP = function () {
        var _this = this;
        this.coundown = this.COUNTDOWN_RESEND_OTP;
        var interval = setInterval(function () {
            if (_this.coundown <= 0) {
                clearInterval(interval);
            }
            _this.coundown -= 1;
        }, 1000);
    };
    OtpComponent.prototype.onOtpInput = function (event, index) {
        var inputElement = event.target;
        if (inputElement.value.length === 1 && index < 4) {
            this.focusInput(index + 1);
        }
        else if (inputElement.value.length > 1) {
            var value = inputElement.value.slice(0, 1);
            inputElement.value = value;
            this.otpInputForm.controls[index].setValue(value);
        }
    };
    OtpComponent.prototype.onKeydown = function (event, index) {
        var allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Meta', 'Control', 'v'];
        var isNumeric = /^[0-9]$/i.test(event.key);
        if (!isNumeric && !allowedKeys.includes(event.key)) {
            event.preventDefault();
        }
        var control = this.otpInputForm.get(index.toString());
        var value = control ? control.value : '';
        if (event.key === 'Backspace' && value !== 0 && !value && index > 0) {
            this.focusInput(index - 1);
        }
    };
    OtpComponent.prototype.onPaste = function (event) {
        var _this = this;
        var clipboardData = event.clipboardData ? event.clipboardData.getData('text') : '';
        if (clipboardData) {
            var pastedOtp = clipboardData.replace(/[^0-9]/g, '');
            var otpChars = pastedOtp.split('');
            otpChars.forEach(function (char, index) {
                var control = _this.otpInputForm.get(index.toString());
                if (control) {
                    control.setValue(char);
                }
            });
            event.preventDefault();
        }
    };
    OtpComponent.prototype.onClickResendOTP = function () {
        if (this.coundown <= 0 && !this.sessionExpired) {
            this.countdownResentOTP();
            this.clickResentOTP.emit(this.selectedMethod);
        }
    };
    OtpComponent.prototype.getOtp = function () {
        var _this = this;
        var prefix = "A-";
        var otp = Object.keys(this.otpInputForm.value).map(function (key) { return _this.otpInputForm.value[key]; }).join('');
        return "" + prefix + otp;
    };
    OtpComponent.prototype.focusInput = function (index) {
        var input = document.querySelectorAll("#" + this.elementId + "-form input")[index];
        if (input) {
            input.focus();
        }
    };
    return OtpComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], OtpComponent.prototype, "isLoading", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2_app_model_otp_otp_model__["b" /* VerificationMethodModel */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_model_otp_otp_model__["b" /* VerificationMethodModel */]) === "function" && _a || Object)
], OtpComponent.prototype, "selectedMethod", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], OtpComponent.prototype, "referenceCode", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], OtpComponent.prototype, "error", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], OtpComponent.prototype, "sessionExpired", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
], OtpComponent.prototype, "clickResentOTP", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
], OtpComponent.prototype, "clickVerifyOTP", void 0);
OtpComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-otp',
        template: __webpack_require__(1094),
        styles: [__webpack_require__(959)]
    }),
    __metadata("design:paramtypes", [typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"]) === "function" && _d || Object])
], OtpComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=otp.component.js.map

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthorizeRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LoginParams; });
/* unused harmony export AuthorizationResponse */
/* unused harmony export ConsentRequest */
/* unused harmony export Scope */
/* unused harmony export ChangePhoneRequest */
/* unused harmony export ChangePhoneResponse */
/* unused harmony export RequiredVerifyUserResponse */
var AuthorizeRequest = (function () {
    function AuthorizeRequest() {
    }
    return AuthorizeRequest;
}());

var LoginParams = (function () {
    function LoginParams() {
    }
    return LoginParams;
}());

var AuthorizationResponse = (function () {
    function AuthorizationResponse() {
    }
    return AuthorizationResponse;
}());

var ConsentRequest = (function () {
    function ConsentRequest(clientId, scopes) {
        this.clientId = clientId;
        this.scopes = scopes;
    }
    return ConsentRequest;
}());

var Scope = (function () {
    function Scope(scopeId, allow) {
        this.scopeId = scopeId;
        this.allow = allow;
    }
    return Scope;
}());

var ChangePhoneRequest = (function () {
    function ChangePhoneRequest() {
    }
    return ChangePhoneRequest;
}());

var ChangePhoneResponse = (function () {
    function ChangePhoneResponse() {
    }
    return ChangePhoneResponse;
}());

var RequiredVerifyUserResponse = (function () {
    function RequiredVerifyUserResponse() {
    }
    return RequiredVerifyUserResponse;
}());

//# sourceMappingURL=authen.js.map

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Condition */
/* unused harmony export ConditionDetail */
/* unused harmony export ConditionMessage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConditionDisplay; });
var Condition = (function () {
    function Condition() {
    }
    return Condition;
}());

var ConditionDetail = (function () {
    function ConditionDetail() {
    }
    return ConditionDetail;
}());

var ConditionMessage = (function () {
    function ConditionMessage() {
    }
    return ConditionMessage;
}());

var ConditionDisplay = (function () {
    function ConditionDisplay() {
        this.columns = [];
        this.code = '';
        this.imgPath = '';
        this.row = [];
        this.route = '';
        this.title = '';
        this.btn = [];
        this.isVerticalDisplayMobile = false;
    }
    return ConditionDisplay;
}());

//# sourceMappingURL=condition.model.js.map

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageNotFoundComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var PageNotFoundComponent = (function () {
    function PageNotFoundComponent() {
    }
    PageNotFoundComponent.prototype.ngOnInit = function () { };
    return PageNotFoundComponent;
}());
PageNotFoundComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'app-page-not-found',
        template: __webpack_require__(1098),
        styles: [__webpack_require__(963)]
    }),
    __metadata("design:paramtypes", [])
], PageNotFoundComponent);

//# sourceMappingURL=page-not-found.component.js.map

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_currency_currency_service__ = __webpack_require__(58);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConvertExchangePipe; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var ConvertExchangePipe = (function () {
    function ConvertExchangePipe(currencyService) {
        this.currencyService = currencyService;
    }
    ConvertExchangePipe.prototype.transform = function (amountTHB) {
        var transformedValue = this.currencyService.transformCurrentCurrencyFromTHB(amountTHB);
        return transformedValue.toLocaleString();
    };
    return ConvertExchangePipe;
}());
ConvertExchangePipe = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
        name: 'convertExchange',
        pure: false
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_currency_currency_service__["a" /* CurrencyService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_currency_currency_service__["a" /* CurrencyService */]) === "function" && _a || Object])
], ConvertExchangePipe);

var _a;
//# sourceMappingURL=convert-exchange.pipe.js.map

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__(48);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SafeHTMLPipe; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var SafeHTMLPipe = (function () {
    function SafeHTMLPipe(sanitizer) {
        this.sanitizer = sanitizer;
    }
    SafeHTMLPipe.prototype.transform = function (htmlString) {
        return this.sanitizer.bypassSecurityTrustHtml(htmlString);
    };
    return SafeHTMLPipe;
}());
SafeHTMLPipe = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
        name: 'safeHTML'
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["e" /* DomSanitizer */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["e" /* DomSanitizer */]) === "function" && _a || Object])
], SafeHTMLPipe);

var _a;
//# sourceMappingURL=safeHTML.pipe.js.map

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_node_forge__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_node_forge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_node_forge__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EncryptService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var EncryptService = (function () {
    function EncryptService() {
    }
    EncryptService.prototype.encryptWithPublicKey = function (data, publicKeyString) {
        var publicKeyPem = this.convertBase64ToPem(publicKeyString);
        var publicKey = __WEBPACK_IMPORTED_MODULE_1_node_forge__["pki"].publicKeyFromPem(publicKeyPem);
        var encrypted = publicKey.encrypt(data);
        return __WEBPACK_IMPORTED_MODULE_1_node_forge__["util"].encode64(encrypted);
    };
    EncryptService.prototype.convertBase64ToPem = function (base64Key) {
        var keyBody = base64Key.match(/.{1,64}/g);
        if (keyBody) {
            return "-----BEGIN PUBLIC KEY-----\n" + keyBody.join('\n') + "\n-----END PUBLIC KEY-----";
        }
        else {
            throw new Error('Invalid Base64 key format');
        }
    };
    return EncryptService;
}());
EncryptService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [])
], EncryptService);

//# sourceMappingURL=encrypt.service.js.map

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(26);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppDeepLinkGuard; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


// /app/* is claimed by the mobile app (see wellknown/<env>/.well-known/apple-app-site-association).
// Reaching here means the app didn't open it, so fall back to the same path on the web.
var AppDeepLinkGuard = (function () {
    function AppDeepLinkGuard(router) {
        this.router = router;
    }
    AppDeepLinkGuard.prototype.canActivate = function (next, state) {
        var _this = this;
        var webUrl = '/' + state.url.replace(/^\/app\/?/i, '').replace(/^[/\\]+/, '');
        this.router.navigateByUrl(webUrl, { replaceUrl: true })
            .catch(function () { return _this.router.navigateByUrl('/', { replaceUrl: true }); });
        return false;
    };
    return AppDeepLinkGuard;
}());
AppDeepLinkGuard = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_router__["c" /* Router */]) === "function" && _a || Object])
], AppDeepLinkGuard);

var _a;
//# sourceMappingURL=app-deep-link.guard.js.map

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_authen_authen__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_environments_properties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_config_app_config_service__ = __webpack_require__(5);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExtraGuard; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var ExtraGuard = (function () {
    function ExtraGuard(utilitiesService, authService, router, appConfigService) {
        this.utilitiesService = utilitiesService;
        this.authService = authService;
        this.router = router;
        this.appConfigService = appConfigService;
        this.loginParams = new __WEBPACK_IMPORTED_MODULE_2_app_model_authen_authen__["b" /* LoginParams */]();
    }
    ExtraGuard.prototype.canActivate = function (next, state) {
        var _this = this;
        if (state.url.includes('/action') && state.root.queryParams.action && state.root.queryParams.lang) {
            var authorizeRequest = this.authService.generateAuthorizeRequest();
            authorizeRequest.lang = state.root.queryParams.lang;
            var queryString = this.utilitiesService.objectToQueryString(__assign({ action: state.root.queryParams.action }, authorizeRequest));
            var redirectURI = "" + __WEBPACK_IMPORTED_MODULE_6_environments_properties__["o" /* accountFrontend */] + queryString;
            window.location.href = encodeURI(redirectURI);
        }
        else if (state.url.includes('/redirect') && state.root.queryParams.code && state.root.queryParams.state) {
            this.loginParams.code = state.root.queryParams.code;
            this.loginParams.state = state.root.queryParams.state;
            this.authService.loginFromAccount(this.loginParams.state, this.loginParams.code).subscribe(function (res) {
                if (res) {
                    var returnUrl = _this.appConfigService.getReturnUrl() || '/';
                    var returnUrlTree = _this.router.parseUrl(returnUrl);
                    if (!('lang' in returnUrlTree.queryParams)) {
                        returnUrlTree.queryParams['lang'] = _this.appConfigService.getLanguage();
                    }
                    _this.appConfigService.removeReturnUrlCookie();
                    _this.router.navigateByUrl(returnUrlTree.toString());
                }
                else {
                    _this.router.navigate([]);
                }
            }, function (error) {
                console.log(error);
                _this.router.navigate([]);
            });
        }
        else if (state.url.includes('/b2c/login')) {
            var lang = state.root.queryParams.lang ? state.root.queryParams.lang : __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["a" /* Language */].th;
            this.login(lang, __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["q" /* CLIENT_ID */].B2C.toString());
        }
        else if (state.url.includes('/login')) {
            var lang = state.root.queryParams.lang ? state.root.queryParams.lang : __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["a" /* Language */].th;
            this.login(lang, __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["q" /* CLIENT_ID */].ASCENDTRAVEL.toString());
        }
        else if (state.url.includes('/joinus')) {
            var lang = state.root.queryParams.lang ? state.root.queryParams.lang : __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["a" /* Language */].th;
            this.joinUs(lang);
        }
        else {
            return true;
        }
    };
    ExtraGuard.prototype.login = function (lang, clietId) {
        var queryParams = this.authService.generateAuthorizeRequest(undefined, clietId);
        queryParams = __assign({}, queryParams, { lang: lang });
        window.location.href = encodeURI("" + __WEBPACK_IMPORTED_MODULE_6_environments_properties__["o" /* accountFrontend */] + this.utilitiesService.objectToQueryString(queryParams));
    };
    ExtraGuard.prototype.joinUs = function (lang) {
        var queryParams = __assign({ page: 'joinUs' }, this.authService.generateAuthorizeRequest(), { lang: lang });
        window.location.href = encodeURI("" + __WEBPACK_IMPORTED_MODULE_6_environments_properties__["o" /* accountFrontend */] + this.utilitiesService.objectToQueryString(queryParams));
    };
    return ExtraGuard;
}());
ExtraGuard = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_1__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_router__["c" /* Router */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_7__app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7__app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object])
], ExtraGuard);

var _a, _b, _c, _d;
//# sourceMappingURL=extra.guard.js.map

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_config_app_config_service__ = __webpack_require__(5);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LanguageCurrencyGuard; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var LanguageCurrencyGuard = (function () {
    function LanguageCurrencyGuard(appConfigService, router) {
        this.appConfigService = appConfigService;
        this.router = router;
    }
    LanguageCurrencyGuard.prototype.canActivate = function (next, state) {
        var currentURL = this.router.parseUrl(state.url);
        var langParams = currentURL.queryParams['lang'];
        var langCookie = this.appConfigService.getLanguageFromCookie();
        if (langParams) {
            if (langCookie) {
                if (langParams !== langCookie) {
                    currentURL.queryParams['lang'] = langCookie;
                    this.router.navigateByUrl(currentURL, { replaceUrl: true });
                    return false;
                }
            }
            else {
                if (!this.appConfigService.isValidLanguage(langParams)) {
                    currentURL.queryParams['lang'] = this.appConfigService.getLanguage();
                    this.router.navigateByUrl(currentURL, { replaceUrl: true });
                    return false;
                }
            }
        }
        else {
            currentURL.queryParams['lang'] = this.appConfigService.getLanguage();
            this.router.navigateByUrl(currentURL, { replaceUrl: true });
            return false;
        }
        return true;
    };
    return LanguageCurrencyGuard;
}());
LanguageCurrencyGuard = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_router__["c" /* Router */]) === "function" && _b || Object])
], LanguageCurrencyGuard);

var _a, _b;
//# sourceMappingURL=language-currency.guard.js.map

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PromotionCodeDiscountType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InvalidPromotionCodeReason; });
var PromotionCodeDiscountType = (function () {
    function PromotionCodeDiscountType() {
    }
    return PromotionCodeDiscountType;
}());

PromotionCodeDiscountType.PERCENT = 'percent';
PromotionCodeDiscountType.AMOUNT = 'amount';
var InvalidPromotionCodeReason = (function () {
    function InvalidPromotionCodeReason() {
    }
    return InvalidPromotionCodeReason;
}());

InvalidPromotionCodeReason.INVALID_PAYMENT_METHOD = 'invalid_payment_method';
InvalidPromotionCodeReason.PAYMENT_ISSUER_NOT_ALLOWED = 'payment_issuer_not_allowed';
InvalidPromotionCodeReason.QUOTA_EXHAUSTED = 'quota_exhausted';
InvalidPromotionCodeReason.BUDGET_NOT_ENOUGH = 'budget_not_enough';
InvalidPromotionCodeReason.USAGE_LIMIT_EXCEEDED = 'usage_limit_exceeded';
InvalidPromotionCodeReason.CONDITION_NOT_MET = 'condition_not_met';
//# sourceMappingURL=promotion-code.enum.js.map

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EncryptRequestPayload; });
var EncryptRequestPayload = (function () {
    function EncryptRequestPayload() {
    }
    return EncryptRequestPayload;
}());

//# sourceMappingURL=encrypt-request.payload.js.map

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_managers_info_window_manager__ = __webpack_require__(273);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActInfoWindow; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


// tslint:disable
var infoWindowId = 0;
var ActInfoWindow = ActInfoWindow_1 = (function () {
    function ActInfoWindow(_infoWindowManager, _el) {
        this._infoWindowManager = _infoWindowManager;
        this._el = _el;
        this.isOpen = false;
        this.infoWindowClose = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._infoWindowAddedToManager = false;
        this._id = (infoWindowId++).toString();
    }
    ActInfoWindow.prototype.ngOnInit = function () {
        this.content = this._el.nativeElement.querySelector('.act-info-window-content');
        this._infoWindowManager.addInfoWindow(this);
        this._infoWindowAddedToManager = true;
        this._updateOpenState();
        this._registerEventListeners();
    };
    /** @internal */
    ActInfoWindow.prototype.ngOnChanges = function (changes) {
        if (!this._infoWindowAddedToManager) {
            return;
        }
        if ((changes['latitude'] || changes['longitude']) && typeof this.latitude === 'number' &&
            typeof this.longitude === 'number') {
            this._infoWindowManager.setPosition(this);
        }
        if (changes['zIndex']) {
            this._infoWindowManager.setZIndex(this);
        }
        if (changes['isOpen']) {
            this._updateOpenState();
        }
        this._setInfoWindowOptions(changes);
    };
    ActInfoWindow.prototype._registerEventListeners = function () {
        var _this = this;
        this._infoWindowManager.createEventObservable('closeclick', this).subscribe(function () {
            _this.isOpen = false;
            _this.infoWindowClose.emit();
        });
    };
    ActInfoWindow.prototype._updateOpenState = function () {
        this.isOpen ? this.open() : this.close();
    };
    ActInfoWindow.prototype._setInfoWindowOptions = function (changes) {
        var options = {};
        var optionKeys = Object.keys(changes).filter(function (k) { return ActInfoWindow_1._infoWindowOptionsInputs.indexOf(k) !== -1; });
        optionKeys.forEach(function (k) { options[k] = changes[k].currentValue; });
        this._infoWindowManager.setOptions(this, options);
    };
    ActInfoWindow.prototype.open = function () { return this._infoWindowManager.open(this); };
    ActInfoWindow.prototype.close = function () {
        var _this = this;
        return this._infoWindowManager.close(this).then(function () { _this.infoWindowClose.emit(); });
    };
    /** @internal */
    ActInfoWindow.prototype.id = function () { return this._id; };
    /** @internal */
    ActInfoWindow.prototype.toString = function () { return 'ActInfoWindow-' + this._id.toString(); };
    /** @internal */
    ActInfoWindow.prototype.ngOnDestroy = function () { this._infoWindowManager.deleteInfoWindow(this); };
    return ActInfoWindow;
}());
ActInfoWindow._infoWindowOptionsInputs = ['disableAutoPan', 'maxWidth'];
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActInfoWindow.prototype, "latitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActInfoWindow.prototype, "longitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActInfoWindow.prototype, "disableAutoPan", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActInfoWindow.prototype, "zIndex", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActInfoWindow.prototype, "maxWidth", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActInfoWindow.prototype, "isOpen", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], ActInfoWindow.prototype, "infoWindowClose", void 0);
ActInfoWindow = ActInfoWindow_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-info-window',
        template: "\n    <div class='act-info-window-content'>\n      <ng-content></ng-content>\n    </div>\n  "
    }),
    __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__services_managers_info_window_manager__["a" /* InfoWindowManager */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__services_managers_info_window_manager__["a" /* InfoWindowManager */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _c || Object])
], ActInfoWindow);

var ActInfoWindow_1, _a, _b, _c;
//# sourceMappingURL=info-window.js.map

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__ = __webpack_require__(77);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CircleManager; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



// tslint:disable
var CircleManager = (function () {
    function CircleManager(_apiWrapper, _zone) {
        this._apiWrapper = _apiWrapper;
        this._zone = _zone;
        this._circles = new Map();
    }
    CircleManager.prototype.addCircle = function (circle) {
        this._circles.set(circle, this._apiWrapper.createCircle({
            center: { lat: circle.latitude, lng: circle.longitude },
            clickable: circle.clickable,
            draggable: circle.draggable,
            editable: circle.editable,
            fillColor: circle.fillColor,
            fillOpacity: circle.fillOpacity,
            radius: circle.radius,
            strokeColor: circle.strokeColor,
            strokeOpacity: circle.strokeOpacity,
            strokePosition: circle.strokePosition,
            strokeWeight: circle.strokeWeight,
            visible: circle.visible,
            zIndex: circle.zIndex
        }));
    };
    /**
     * Removes the given circle from the map.
     */
    CircleManager.prototype.removeCircle = function (circle) {
        var _this = this;
        return this._circles.get(circle).then(function (c) {
            c.setMap(null);
            _this._circles.delete(circle);
        });
    };
    CircleManager.prototype.setOptions = function (circle, options) {
        return this._circles.get(circle).then(function (c) { return c.setOptions(options); });
    };
    CircleManager.prototype.getBounds = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.getBounds(); });
    };
    CircleManager.prototype.getCenter = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.getCenter(); });
    };
    CircleManager.prototype.getRadius = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.getRadius(); });
    };
    CircleManager.prototype.setCenter = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.setCenter({ lat: circle.latitude, lng: circle.longitude }); });
    };
    CircleManager.prototype.setEditable = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.setEditable(circle.editable); });
    };
    CircleManager.prototype.setDraggable = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.setDraggable(circle.draggable); });
    };
    CircleManager.prototype.setVisible = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.setVisible(circle.visible); });
    };
    CircleManager.prototype.setRadius = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.setRadius(circle.radius); });
    };
    CircleManager.prototype.createEventObservable = function (eventName, circle) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].create(function (observer) {
            var listener = null;
            _this._circles.get(circle).then(function (c) {
                listener = c.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
            });
            return function () {
                if (listener !== null) {
                    listener.remove();
                }
            };
        });
    };
    return CircleManager;
}());
CircleManager = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]) === "function" && _b || Object])
], CircleManager);

var _a, _b;
//# sourceMappingURL=circle-manager.js.map

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__marker_manager__ = __webpack_require__(173);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoWindowManager; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var InfoWindowManager = (function () {
    function InfoWindowManager(_mapsWrapper, _zone, _markerManager) {
        this._mapsWrapper = _mapsWrapper;
        this._zone = _zone;
        this._markerManager = _markerManager;
        this._infoWindows = new Map();
    }
    InfoWindowManager.prototype.deleteInfoWindow = function (infoWindow) {
        var _this = this;
        var iWindow = this._infoWindows.get(infoWindow);
        if (iWindow == null) {
            // info window already deleted
            return Promise.resolve();
        }
        return iWindow.then(function (i) {
            return _this._zone.run(function () {
                i.close();
                _this._infoWindows.delete(infoWindow);
            });
        });
    };
    InfoWindowManager.prototype.setPosition = function (infoWindow) {
        return this._infoWindows.get(infoWindow).then(function (i) { return i.setPosition({
            lat: infoWindow.latitude,
            lng: infoWindow.longitude
        }); });
    };
    InfoWindowManager.prototype.setZIndex = function (infoWindow) {
        return this._infoWindows.get(infoWindow)
            .then(function (i) { return i.setZIndex(infoWindow.zIndex); });
    };
    InfoWindowManager.prototype.open = function (infoWindow) {
        var _this = this;
        return this._infoWindows.get(infoWindow).then(function (w) {
            if (infoWindow.hostMarker != null) {
                return _this._markerManager.getNativeMarker(infoWindow.hostMarker).then(function (marker) {
                    return _this._mapsWrapper.getNativeMap().then(function (map) { return w.open(map, marker); });
                });
            }
            return _this._mapsWrapper.getNativeMap().then(function (map) { return w.open(map); });
        });
    };
    InfoWindowManager.prototype.close = function (infoWindow) {
        return this._infoWindows.get(infoWindow).then(function (w) { return w.close(); });
    };
    InfoWindowManager.prototype.setOptions = function (infoWindow, options) {
        return this._infoWindows.get(infoWindow).then(function (i) { return i.setOptions(options); });
    };
    InfoWindowManager.prototype.addInfoWindow = function (infoWindow) {
        var options = {
            content: infoWindow.content,
            maxWidth: infoWindow.maxWidth,
            zIndex: infoWindow.zIndex,
            disableAutoPan: infoWindow.disableAutoPan
        };
        if (typeof infoWindow.latitude === 'number' && typeof infoWindow.longitude === 'number') {
            options.position = { lat: infoWindow.latitude, lng: infoWindow.longitude };
        }
        var infoWindowPromise = this._mapsWrapper.createInfoWindow(options);
        this._infoWindows.set(infoWindow, infoWindowPromise);
    };
    InfoWindowManager.prototype.createEventObservable = function (eventName, infoWindow) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].create(function (observer) {
            _this._infoWindows.get(infoWindow).then(function (i) {
                i.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
            });
        });
    };
    return InfoWindowManager;
}());
InfoWindowManager = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__marker_manager__["a" /* MarkerManager */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__marker_manager__["a" /* MarkerManager */]) === "function" && _c || Object])
], InfoWindowManager);

var _a, _b, _c;
//# sourceMappingURL=info-window-manager.js.map

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_browser_globals__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__maps_api_loader__ = __webpack_require__(106);
/* unused harmony export GoogleMapsScriptProtocol */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LAZY_MAPS_API_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LazyMapsAPILoader; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};



var GoogleMapsScriptProtocol;
(function (GoogleMapsScriptProtocol) {
    GoogleMapsScriptProtocol[GoogleMapsScriptProtocol["HTTP"] = 1] = "HTTP";
    GoogleMapsScriptProtocol[GoogleMapsScriptProtocol["HTTPS"] = 2] = "HTTPS";
    GoogleMapsScriptProtocol[GoogleMapsScriptProtocol["AUTO"] = 3] = "AUTO";
})(GoogleMapsScriptProtocol || (GoogleMapsScriptProtocol = {}));
/**
 * Token for the config of the LazyMapsAPILoader. Please provide an object of type {@link
 * LazyMapsAPILoaderConfig}.
 */
var LAZY_MAPS_API_CONFIG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('angular-google-maps LAZY_MAPS_API_CONFIG');
// tslint:disable
var LazyMapsAPILoader = (function (_super) {
    __extends(LazyMapsAPILoader, _super);
    function LazyMapsAPILoader(config, w, d) {
        var _this = _super.call(this) || this;
        _this._config = config || {};
        _this._windowRef = w;
        _this._documentRef = d;
        return _this;
    }
    LazyMapsAPILoader.prototype.load = function () {
        var _this = this;
        var window = this._windowRef.getNativeWindow();
        if (window.google && window.google.maps) {
            // Google maps already loaded on the page.
            return Promise.resolve();
        }
        if (this._scriptLoadingPromise) {
            return this._scriptLoadingPromise;
        }
        var script = this._documentRef.getNativeDocument().createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        var callbackName = "GoogleMapsAPILoader";
        script.src = this._getScriptSrc(callbackName);
        this._scriptLoadingPromise = new Promise(function (resolve, reject) {
            _this._windowRef.getNativeWindow()[callbackName] = function () {
                resolve();
            };
            script.onerror = function (error) {
                reject(error);
            };
        });
        this._documentRef.getNativeDocument().body.appendChild(script);
        return this._scriptLoadingPromise;
    };
    LazyMapsAPILoader.prototype._getScriptSrc = function (callbackName) {
        var protocolType = (this._config && this._config.protocol) || GoogleMapsScriptProtocol.HTTPS;
        var protocol;
        switch (protocolType) {
            case GoogleMapsScriptProtocol.AUTO:
                protocol = '';
                break;
            case GoogleMapsScriptProtocol.HTTP:
                protocol = 'http:';
                break;
            case GoogleMapsScriptProtocol.HTTPS:
                protocol = 'https:';
                break;
        }
        var hostAndPath = this._config.hostAndPath || 'maps.googleapis.com/maps/api/js';
        var queryParams = {
            v: this._config.apiVersion || '3',
            callback: callbackName,
            key: this._config.apiKey,
            client: this._config.clientId,
            channel: this._config.channel,
            libraries: this._config.libraries,
            region: this._config.region,
            language: this._config.language
        };
        var params = Object.keys(queryParams)
            .filter(function (k) { return queryParams[k] != null; })
            .filter(function (k) {
            // remove empty arrays
            return !Array.isArray(queryParams[k]) ||
                (Array.isArray(queryParams[k]) && queryParams[k].length > 0);
        })
            .map(function (k) {
            // join arrays as comma seperated strings
            var i = queryParams[k];
            if (Array.isArray(i)) {
                return { key: k, value: i.join(',') };
            }
            return { key: k, value: queryParams[k] };
        })
            .map(function (entry) {
            return entry.key + "=" + entry.value;
        })
            .join('&');
        return protocol + "//" + hostAndPath + "?" + params;
    };
    return LazyMapsAPILoader;
}(__WEBPACK_IMPORTED_MODULE_2__maps_api_loader__["a" /* MapsAPILoader */]));
LazyMapsAPILoader = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(LAZY_MAPS_API_CONFIG)),
    __metadata("design:paramtypes", [Object, typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__utils_browser_globals__["b" /* WindowRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__utils_browser_globals__["b" /* WindowRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__utils_browser_globals__["c" /* DocumentRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__utils_browser_globals__["c" /* DocumentRef */]) === "function" && _b || Object])
], LazyMapsAPILoader);

var _a, _b;
//# sourceMappingURL=lazy-maps-api-loader.js.map

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WindowRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DocumentRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BROWSER_GLOBALS_PROVIDERS; });
var WindowRef = (function () {
    function WindowRef() {
    }
    WindowRef.prototype.getNativeWindow = function () { return window; };
    return WindowRef;
}());

var DocumentRef = (function () {
    function DocumentRef() {
    }
    DocumentRef.prototype.getNativeDocument = function () { return document; };
    return DocumentRef;
}());

var BROWSER_GLOBALS_PROVIDERS = [WindowRef, DocumentRef];
//# sourceMappingURL=browser-globals.js.map

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomPreloadingStrategy; });

var CustomPreloadingStrategy = (function () {
    function CustomPreloadingStrategy() {
    }
    CustomPreloadingStrategy.prototype.preload = function (route, fn) {
        // return Observable.of(true).delay(7000).flatMap(_ => fn());
        if (route.data['preload']) {
            return fn();
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(null);
        }
    };
    return CustomPreloadingStrategy;
}());

//# sourceMappingURL=custom-preloading-strategy.js.map

/***/ }),
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * typeahead.js 0.11.2 ( fixed: bugs limit render items when have mutilply object items)
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2015 Twitter, Inc. and other contributors; Licensed MIT
 */

(function(root, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(16) ], __WEBPACK_AMD_DEFINE_RESULT__ = function(a0) {
            return factory(a0);
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === "object") {
        module.exports = factory(require("jquery"));
    } else {
        factory(jQuery);
    }
})(this, function($) {
    var _ = function() {
        "use strict";
        return {
            isMsie: function() {
                return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
            },
            isBlankString: function(str) {
                return !str || /^\s*$/.test(str);
            },
            escapeRegExChars: function(str) {
                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
            },
            isString: function(obj) {
                return typeof obj === "string";
            },
            isNumber: function(obj) {
                return typeof obj === "number";
            },
            isArray: $.isArray,
            isFunction: $.isFunction,
            isObject: $.isPlainObject,
            isUndefined: function(obj) {
                return typeof obj === "undefined";
            },
            isElement: function(obj) {
                return !!(obj && obj.nodeType === 1);
            },
            isJQuery: function(obj) {
                return obj instanceof $;
            },
            toStr: function toStr(s) {
                return _.isUndefined(s) || s === null ? "" : s + "";
            },
            bind: $.proxy,
            each: function(collection, cb) {
                $.each(collection, reverseArgs);
                function reverseArgs(index, value) {
                    return cb(value, index);
                }
            },
            map: $.map,
            filter: $.grep,
            every: function(obj, test) {
                var result = true;
                if (!obj) {
                    return result;
                }
                $.each(obj, function(key, val) {
                    if (!(result = test.call(null, val, key, obj))) {
                        return false;
                    }
                });
                return !!result;
            },
            some: function(obj, test) {
                var result = false;
                if (!obj) {
                    return result;
                }
                $.each(obj, function(key, val) {
                    if (result = test.call(null, val, key, obj)) {
                        return false;
                    }
                });
                return !!result;
            },
            mixin: $.extend,
            identity: function(x) {
                return x;
            },
            clone: function(obj) {
                return $.extend(true, {}, obj);
            },
            getIdGenerator: function() {
                var counter = 0;
                return function() {
                    return counter++;
                };
            },
            templatify: function templatify(obj) {
                return $.isFunction(obj) ? obj : template;
                function template() {
                    return String(obj);
                }
            },
            defer: function(fn) {
                setTimeout(fn, 0);
            },
            debounce: function(func, wait, immediate) {
                var timeout, result;
                return function() {
                    var context = this, args = arguments, later, callNow;
                    later = function() {
                        timeout = null;
                        if (!immediate) {
                            result = func.apply(context, args);
                        }
                    };
                    callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) {
                        result = func.apply(context, args);
                    }
                    return result;
                };
            },
            throttle: function(func, wait) {
                var context, args, timeout, result, previous, later;
                previous = 0;
                later = function() {
                    previous = new Date();
                    timeout = null;
                    result = func.apply(context, args);
                };
                return function() {
                    var now = new Date(), remaining = wait - (now - previous);
                    context = this;
                    args = arguments;
                    if (remaining <= 0) {
                        clearTimeout(timeout);
                        timeout = null;
                        previous = now;
                        result = func.apply(context, args);
                    } else if (!timeout) {
                        timeout = setTimeout(later, remaining);
                    }
                    return result;
                };
            },
            stringify: function(val) {
                return _.isString(val) ? val : JSON.stringify(val);
            },
            noop: function() {}
        };
    }();
    var WWW = function() {
        "use strict";
        var defaultClassNames = {
            wrapper: "twitter-typeahead",
            input: "tt-input",
            hint: "tt-hint",
            menu: "tt-menu",
            dataset: "tt-dataset",
            suggestion: "tt-suggestion",
            selectable: "tt-selectable",
            empty: "tt-empty",
            open: "tt-open",
            cursor: "tt-cursor",
            highlight: "tt-highlight"
        };
        return build;
        function build(o) {
            var www, classes;
            classes = _.mixin({}, defaultClassNames, o);
            www = {
                css: buildCss(),
                classes: classes,
                html: buildHtml(classes),
                selectors: buildSelectors(classes)
            };
            return {
                css: www.css,
                html: www.html,
                classes: www.classes,
                selectors: www.selectors,
                mixin: function(o) {
                    _.mixin(o, www);
                }
            };
        }
        function buildHtml(c) {
            return {
                wrapper: '<span class="' + c.wrapper + '"></span>',
                menu: '<div class="' + c.menu + '"></div>'
            };
        }
        function buildSelectors(classes) {
            var selectors = {};
            _.each(classes, function(v, k) {
                selectors[k] = "." + v;
            });
            return selectors;
        }
        function buildCss() {
            var css = {
                wrapper: {
                    position: "relative",
                    display: "inline-block"
                },
                hint: {
                    position: "absolute",
                    top: "0",
                    left: "0",
                    borderColor: "transparent",
                    boxShadow: "none",
                    opacity: "1"
                },
                input: {
                    position: "relative",
                    verticalAlign: "top",
                    backgroundColor: "transparent"
                },
                inputWithNoHint: {
                    position: "relative",
                    verticalAlign: "top"
                },
                menu: {
                    position: "absolute",
                    top: "100%",
                    left: "0",
                    zIndex: "100",
                    display: "none"
                },
                ltr: {
                    left: "0",
                    right: "auto"
                },
                rtl: {
                    left: "auto",
                    right: " 0"
                }
            };
            if (_.isMsie()) {
                _.mixin(css.input, {
                    backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)"
                });
            }
            return css;
        }
    }();
    var EventBus = function() {
        "use strict";
        var namespace, deprecationMap;
        namespace = "typeahead:";
        deprecationMap = {
            render: "rendered",
            cursorchange: "cursorchanged",
            select: "selected",
            autocomplete: "autocompleted"
        };
        function EventBus(o) {
            if (!o || !o.el) {
                $.error("EventBus initialized without el");
            }
            this.$el = $(o.el);
        }
        _.mixin(EventBus.prototype, {
            _trigger: function(type, args) {
                var $e;
                $e = $.Event(namespace + type);
                (args = args || []).unshift($e);
                this.$el.trigger.apply(this.$el, args);
                return $e;
            },
            before: function(type) {
                var args, $e;
                args = [].slice.call(arguments, 1);
                $e = this._trigger("before" + type, args);
                return $e.isDefaultPrevented();
            },
            trigger: function(type) {
                var deprecatedType;
                this._trigger(type, [].slice.call(arguments, 1));
                if (deprecatedType = deprecationMap[type]) {
                    this._trigger(deprecatedType, [].slice.call(arguments, 1));
                }
            }
        });
        return EventBus;
    }();
    var EventEmitter = function() {
        "use strict";
        var splitter = /\s+/, nextTick = getNextTick();
        return {
            onSync: onSync,
            onAsync: onAsync,
            off: off,
            trigger: trigger
        };
        function on(method, types, cb, context) {
            var type;
            if (!cb) {
                return this;
            }
            types = types.split(splitter);
            cb = context ? bindContext(cb, context) : cb;
            this._callbacks = this._callbacks || {};
            while (type = types.shift()) {
                this._callbacks[type] = this._callbacks[type] || {
                    sync: [],
                    async: []
                };
                this._callbacks[type][method].push(cb);
            }
            return this;
        }
        function onAsync(types, cb, context) {
            return on.call(this, "async", types, cb, context);
        }
        function onSync(types, cb, context) {
            return on.call(this, "sync", types, cb, context);
        }
        function off(types) {
            var type;
            if (!this._callbacks) {
                return this;
            }
            types = types.split(splitter);
            while (type = types.shift()) {
                delete this._callbacks[type];
            }
            return this;
        }
        function trigger(types) {
            var type, callbacks, args, syncFlush, asyncFlush;
            if (!this._callbacks) {
                return this;
            }
            types = types.split(splitter);
            args = [].slice.call(arguments, 1);
            while ((type = types.shift()) && (callbacks = this._callbacks[type])) {
                syncFlush = getFlush(callbacks.sync, this, [ type ].concat(args));
                asyncFlush = getFlush(callbacks.async, this, [ type ].concat(args));
                syncFlush() && nextTick(asyncFlush);
            }
            return this;
        }
        function getFlush(callbacks, context, args) {
            return flush;
            function flush() {
                var cancelled;
                for (var i = 0, len = callbacks.length; !cancelled && i < len; i += 1) {
                    cancelled = callbacks[i].apply(context, args) === false;
                }
                return !cancelled;
            }
        }
        function getNextTick() {
            var nextTickFn;
            if (window.setImmediate) {
                nextTickFn = function nextTickSetImmediate(fn) {
                    setImmediate(function() {
                        fn();
                    });
                };
            } else {
                nextTickFn = function nextTickSetTimeout(fn) {
                    setTimeout(function() {
                        fn();
                    }, 0);
                };
            }
            return nextTickFn;
        }
        function bindContext(fn, context) {
            return fn.bind ? fn.bind(context) : function() {
                fn.apply(context, [].slice.call(arguments, 0));
            };
        }
    }();
    var highlight = function(doc) {
        "use strict";
        var defaults = {
            node: null,
            pattern: null,
            tagName: "strong",
            className: null,
            wordsOnly: false,
            caseSensitive: false
        };
        return function hightlight(o) {
            var regex;
            o = _.mixin({}, defaults, o);
            if (!o.node || !o.pattern) {
                return;
            }
            o.pattern = _.isArray(o.pattern) ? o.pattern : [ o.pattern ];
            regex = getRegex(o.pattern, o.caseSensitive, o.wordsOnly);
            traverse(o.node, hightlightTextNode);
            function hightlightTextNode(textNode) {
                var match, patternNode, wrapperNode;
                if (match = regex.exec(textNode.data)) {
                    wrapperNode = doc.createElement(o.tagName);
                    o.className && (wrapperNode.className = o.className);
                    patternNode = textNode.splitText(match.index);
                    patternNode.splitText(match[0].length);
                    wrapperNode.appendChild(patternNode.cloneNode(true));
                    textNode.parentNode.replaceChild(wrapperNode, patternNode);
                }
                return !!match;
            }
            function traverse(el, hightlightTextNode) {
                var childNode, TEXT_NODE_TYPE = 3;
                for (var i = 0; i < el.childNodes.length; i++) {
                    childNode = el.childNodes[i];
                    if (childNode.nodeType === TEXT_NODE_TYPE) {
                        i += hightlightTextNode(childNode) ? 1 : 0;
                    } else {
                        traverse(childNode, hightlightTextNode);
                    }
                }
            }
        };
        function getRegex(patterns, caseSensitive, wordsOnly) {
            var escapedPatterns = [], regexStr;
            for (var i = 0, len = patterns.length; i < len; i++) {
                escapedPatterns.push(_.escapeRegExChars(patterns[i]));
            }
            regexStr = wordsOnly ? "\\b(" + escapedPatterns.join("|") + ")\\b" : "(" + escapedPatterns.join("|") + ")";
            return caseSensitive ? new RegExp(regexStr) : new RegExp(regexStr, "i");
        }
    }(window.document);
    var Input = function() {
        "use strict";
        var specialKeyCodeMap;
        specialKeyCodeMap = {
            9: "tab",
            27: "esc",
            37: "left",
            39: "right",
            13: "enter",
            38: "up",
            40: "down"
        };
        function Input(o, www) {
            o = o || {};
            if (!o.input) {
                $.error("input is missing");
            }
            www.mixin(this);
            this.$hint = $(o.hint);
            this.$input = $(o.input);
            this.query = this.$input.val();
            this.queryWhenFocused = this.hasFocus() ? this.query : null;
            this.$overflowHelper = buildOverflowHelper(this.$input);
            this._checkLanguageDirection();
            if (this.$hint.length === 0) {
                this.setHint = this.getHint = this.clearHint = this.clearHintIfInvalid = _.noop;
            }
        }
        Input.normalizeQuery = function(str) {
            return _.toStr(str).replace(/^\s*/g, "").replace(/\s{2,}/g, " ");
        };
        _.mixin(Input.prototype, EventEmitter, {
            _onBlur: function onBlur() {
                this.resetInputValue();
                this.trigger("blurred");
            },
            _onFocus: function onFocus() {
                this.queryWhenFocused = this.query;
                this.trigger("focused");
            },
            _onKeydown: function onKeydown($e) {
                var keyName = specialKeyCodeMap[$e.which || $e.keyCode];
                this._managePreventDefault(keyName, $e);
                if (keyName && this._shouldTrigger(keyName, $e)) {
                    this.trigger(keyName + "Keyed", $e);
                }
            },
            _onInput: function onInput() {
                this._setQuery(this.getInputValue());
                this.clearHintIfInvalid();
                this._checkLanguageDirection();
            },
            _managePreventDefault: function managePreventDefault(keyName, $e) {
                var preventDefault;
                switch (keyName) {
                  case "up":
                  case "down":
                    preventDefault = !withModifier($e);
                    break;

                  default:
                    preventDefault = false;
                }
                preventDefault && $e.preventDefault();
            },
            _shouldTrigger: function shouldTrigger(keyName, $e) {
                var trigger;
                switch (keyName) {
                  case "tab":
                    trigger = !withModifier($e);
                    break;

                  default:
                    trigger = true;
                }
                return trigger;
            },
            _checkLanguageDirection: function checkLanguageDirection() {
                var dir = (this.$input.css("direction") || "ltr").toLowerCase();
                if (this.dir !== dir) {
                    this.dir = dir;
                    this.$hint.attr("dir", dir);
                    this.trigger("langDirChanged", dir);
                }
            },
            _setQuery: function setQuery(val, silent) {
                var areEquivalent, hasDifferentWhitespace;
                areEquivalent = areQueriesEquivalent(val, this.query);
                hasDifferentWhitespace = areEquivalent ? this.query.length !== val.length : false;
                this.query = val;
                if (!silent && !areEquivalent) {
                    this.trigger("queryChanged", this.query);
                } else if (!silent && hasDifferentWhitespace) {
                    this.trigger("whitespaceChanged", this.query);
                }
            },
            bind: function() {
                var that = this, onBlur, onFocus, onKeydown, onInput;
                onBlur = _.bind(this._onBlur, this);
                onFocus = _.bind(this._onFocus, this);
                onKeydown = _.bind(this._onKeydown, this);
                onInput = _.bind(this._onInput, this);
                this.$input.on("blur.tt", onBlur).on("focus.tt", onFocus).on("keydown.tt", onKeydown);
                if (!_.isMsie() || _.isMsie() > 9) {
                    this.$input.on("input.tt", onInput);
                } else {
                    this.$input.on("keydown.tt keypress.tt cut.tt paste.tt", function($e) {
                        if (specialKeyCodeMap[$e.which || $e.keyCode]) {
                            return;
                        }
                        _.defer(_.bind(that._onInput, that, $e));
                    });
                }
                return this;
            },
            focus: function focus() {
                this.$input.focus();
            },
            blur: function blur() {
                this.$input.blur();
            },
            getLangDir: function getLangDir() {
                return this.dir;
            },
            getQuery: function getQuery() {
                return this.query || "";
            },
            setQuery: function setQuery(val, silent) {
                this.setInputValue(val);
                this._setQuery(val, silent);
            },
            hasQueryChangedSinceLastFocus: function hasQueryChangedSinceLastFocus() {
                return this.query !== this.queryWhenFocused;
            },
            getInputValue: function getInputValue() {
                return this.$input.val();
            },
            setInputValue: function setInputValue(value) {
                this.$input.val(value);
                this.clearHintIfInvalid();
                this._checkLanguageDirection();
            },
            resetInputValue: function resetInputValue() {
                this.setInputValue(this.query);
            },
            getHint: function getHint() {
                return this.$hint.val();
            },
            setHint: function setHint(value) {
                this.$hint.val(value);
            },
            clearHint: function clearHint() {
                this.setHint("");
            },
            clearHintIfInvalid: function clearHintIfInvalid() {
                var val, hint, valIsPrefixOfHint, isValid;
                val = this.getInputValue();
                hint = this.getHint();
                valIsPrefixOfHint = val !== hint && hint.indexOf(val) === 0;
                isValid = val !== "" && valIsPrefixOfHint && !this.hasOverflow();
                !isValid && this.clearHint();
            },
            hasFocus: function hasFocus() {
                return this.$input.is(":focus");
            },
            hasOverflow: function hasOverflow() {
                var constraint = this.$input.width() - 2;
                this.$overflowHelper.text(this.getInputValue());
                return this.$overflowHelper.width() >= constraint;
            },
            isCursorAtEnd: function() {
                var valueLength, selectionStart, range;
                valueLength = this.$input.val().length;
                selectionStart = this.$input[0].selectionStart;
                if (_.isNumber(selectionStart)) {
                    return selectionStart === valueLength;
                } else if (document.selection) {
                    range = document.selection.createRange();
                    range.moveStart("character", -valueLength);
                    return valueLength === range.text.length;
                }
                return true;
            },
            destroy: function destroy() {
                this.$hint.off(".tt");
                this.$input.off(".tt");
                this.$overflowHelper.remove();
                this.$hint = this.$input = this.$overflowHelper = $("<div>");
            }
        });
        return Input;
        function buildOverflowHelper($input) {
            return $('<pre aria-hidden="true"></pre>').css({
                position: "absolute",
                visibility: "hidden",
                whiteSpace: "pre",
                fontFamily: $input.css("font-family"),
                fontSize: $input.css("font-size"),
                fontStyle: $input.css("font-style"),
                fontVariant: $input.css("font-variant"),
                fontWeight: $input.css("font-weight"),
                wordSpacing: $input.css("word-spacing"),
                letterSpacing: $input.css("letter-spacing"),
                textIndent: $input.css("text-indent"),
                textRendering: $input.css("text-rendering"),
                textTransform: $input.css("text-transform")
            }).insertAfter($input);
        }
        function areQueriesEquivalent(a, b) {
            return Input.normalizeQuery(a) === Input.normalizeQuery(b);
        }
        function withModifier($e) {
            return $e.altKey || $e.ctrlKey || $e.metaKey || $e.shiftKey;
        }
    }();
    var Dataset = function() {
        "use strict";
        var keys, nameGenerator;
        keys = {
            val: "tt-selectable-display",
            obj: "tt-selectable-object"
        };
        nameGenerator = _.getIdGenerator();
        function Dataset(o, www) {
            o = o || {};
            o.templates = o.templates || {};
            o.templates.notFound = o.templates.notFound || o.templates.empty;
            if (!o.source) {
                $.error("missing source");
            }
            if (!o.node) {
                $.error("missing node");
            }
            if (o.name && !isValidName(o.name)) {
                $.error("invalid dataset name: " + o.name);
            }
            www.mixin(this);
            this.highlight = !!o.highlight;
            this.name = o.name || nameGenerator();
            this.limit = o.limit || 5;
            this.displayFn = getDisplayFn(o.display || o.displayKey);
            this.templates = getTemplates(o.templates, this.displayFn);
            this.source = o.source.__ttAdapter ? o.source.__ttAdapter() : o.source;
            this.async = _.isUndefined(o.async) ? this.source.length > 2 : !!o.async;
            this._resetLastSuggestion();
            this.$el = $(o.node).addClass(this.classes.dataset).addClass(this.classes.dataset + "-" + this.name);
        }
        Dataset.extractData = function extractData(el) {
            var $el = $(el);
            if ($el.data(keys.obj)) {
                return {
                    val: $el.data(keys.val) || "",
                    obj: $el.data(keys.obj) || null
                };
            }
            return null;
        };
        _.mixin(Dataset.prototype, EventEmitter, {
            _overwrite: function overwrite(query, suggestions) {
                suggestions = suggestions || [];
                if (suggestions.length) {
                    this._renderSuggestions(query, suggestions);
                } else if (this.async && this.templates.pending) {
                    this._renderPending(query);
                } else if (!this.async && this.templates.notFound) {
                    this._renderNotFound(query);
                } else {
                    this._empty();
                }
                this.trigger("rendered", this.name, suggestions, false);
            },
            _append: function append(query, suggestions) {
                suggestions = suggestions || [];
                if (suggestions.length && this.$lastSuggestion.length) {
                    this._appendSuggestions(query, suggestions);
                } else if (suggestions.length) {
                    this._renderSuggestions(query, suggestions);
                } else if (!this.$lastSuggestion.length && this.templates.notFound) {
                    this._renderNotFound(query);
                }
                this.trigger("rendered", this.name, suggestions, true);
            },
            _renderSuggestions: function renderSuggestions(query, suggestions) {
                var $fragment;
                $fragment = this._getSuggestionsFragment(query, suggestions);
                this.$lastSuggestion = $fragment.children().last();
                this.$el.html($fragment).prepend(this._getHeader(query, suggestions)).append(this._getFooter(query, suggestions));
            },
            _appendSuggestions: function appendSuggestions(query, suggestions) {
                var $fragment, $lastSuggestion;
                $fragment = this._getSuggestionsFragment(query, suggestions);
                $lastSuggestion = $fragment.children().last();
                this.$lastSuggestion.after($fragment);
                this.$lastSuggestion = $lastSuggestion;
            },
            _renderPending: function renderPending(query) {
                var template = this.templates.pending;
                this._resetLastSuggestion();
                template && this.$el.html(template({
                    query: query,
                    dataset: this.name
                }));
            },
            _renderNotFound: function renderNotFound(query) {
                var template = this.templates.notFound;
                this._resetLastSuggestion();
                template && this.$el.html(template({
                    query: query,
                    dataset: this.name
                }));
            },
            _empty: function empty() {
                this.$el.empty();
                this._resetLastSuggestion();
            },
            _getSuggestionsFragment: function getSuggestionsFragment(query, suggestions) {
                var that = this, fragment;
                fragment = document.createDocumentFragment();
                _.each(suggestions, function getSuggestionNode(suggestion) {
                    var $el, context;
                    context = that._injectQuery(query, suggestion);
                    $el = $(that.templates.suggestion(context)).data(keys.obj, suggestion).data(keys.val, that.displayFn(suggestion)).addClass(that.classes.suggestion + " " + that.classes.selectable);
                    fragment.appendChild($el[0]);
                });
                this.highlight && highlight({
                    className: this.classes.highlight,
                    node: fragment,
                    pattern: query
                });
                return $(fragment);
            },
            _getFooter: function getFooter(query, suggestions) {
                return this.templates.footer ? this.templates.footer({
                    query: query,
                    suggestions: suggestions,
                    dataset: this.name
                }) : null;
            },
            _getHeader: function getHeader(query, suggestions) {
                return this.templates.header ? this.templates.header({
                    query: query,
                    suggestions: suggestions,
                    dataset: this.name
                }) : null;
            },
            _resetLastSuggestion: function resetLastSuggestion() {
                this.$lastSuggestion = $();
            },
            _injectQuery: function injectQuery(query, obj) {
                return _.isObject(obj) ? _.mixin({
                    _query: query
                }, obj) : obj;
            },
            update: function update(query) {
                var that = this, canceled = false, syncCalled = false, rendered = 0;
                this.cancel();
                this.cancel = function cancel() {
                    canceled = true;
                    that.cancel = $.noop;
                    that.async && that.trigger("asyncCanceled", query);
                };
                this.source(query, sync, async);
                !syncCalled && sync([]);
                function sync(suggestions) {
                    if (syncCalled) {
                        return;
                    }
                    syncCalled = true;
                    suggestions = (suggestions || []).slice(0, that.limit);
                    rendered = suggestions.length;
                    that._overwrite(query, suggestions);
                    if (rendered < that.limit && that.async) {
                        that.trigger("asyncRequested", query);
                    }
                }
                function async(suggestions) {
                    suggestions = suggestions || [];
                    if (!canceled && rendered < that.limit) {
                        that.cancel = $.noop;
                        rendered += suggestions.length;
                        that._overwrite(query, suggestions.slice(0, that.limit));
                        that.async && that.trigger("asyncReceived", query);
                    }
                }
            },
            cancel: $.noop,
            clear: function clear() {
                this._empty();
                this.cancel();
                this.trigger("cleared");
            },
            isEmpty: function isEmpty() {
                return this.$el.is(":empty");
            },
            destroy: function destroy() {
                this.$el = $("<div>");
            }
        });
        return Dataset;
        function getDisplayFn(display) {
            display = display || _.stringify;
            return _.isFunction(display) ? display : displayFn;
            function displayFn(obj) {
                return obj[display];
            }
        }
        function getTemplates(templates, displayFn) {
            return {
                notFound: templates.notFound && _.templatify(templates.notFound),
                pending: templates.pending && _.templatify(templates.pending),
                header: templates.header && _.templatify(templates.header),
                footer: templates.footer && _.templatify(templates.footer),
                suggestion: templates.suggestion || suggestionTemplate
            };
            function suggestionTemplate(context) {
                return $("<div>").text(displayFn(context));
            }
        }
        function isValidName(str) {
            return /^[_a-zA-Z0-9-]+$/.test(str);
        }
    }();
    var Menu = function() {
        "use strict";
        function Menu(o, www) {
            var that = this;
            o = o || {};
            if (!o.node) {
                $.error("node is required");
            }
            www.mixin(this);
            this.$node = $(o.node);
            this.query = null;
            this.datasets = _.map(o.datasets, initializeDataset);
            function initializeDataset(oDataset) {
                var node = that.$node.find(oDataset.node).first();
                oDataset.node = node.length ? node : $("<div>").appendTo(that.$node);
                return new Dataset(oDataset, www);
            }
        }
        _.mixin(Menu.prototype, EventEmitter, {
            _onSelectableClick: function onSelectableClick($e) {
                this.trigger("selectableClicked", $($e.currentTarget));
            },
            _onRendered: function onRendered(type, dataset, suggestions, async) {
                this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
                this.trigger("datasetRendered", dataset, suggestions, async);
            },
            _onCleared: function onCleared() {
                this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
                this.trigger("datasetCleared");
            },
            _propagate: function propagate() {
                this.trigger.apply(this, arguments);
            },
            _allDatasetsEmpty: function allDatasetsEmpty() {
                return _.every(this.datasets, isDatasetEmpty);
                function isDatasetEmpty(dataset) {
                    return dataset.isEmpty();
                }
            },
            _getSelectables: function getSelectables() {
                return this.$node.find(this.selectors.selectable);
            },
            _removeCursor: function _removeCursor() {
                var $selectable = this.getActiveSelectable();
                $selectable && $selectable.removeClass(this.classes.cursor);
            },
            _ensureVisible: function ensureVisible($el) {
                var elTop, elBottom, nodeScrollTop, nodeHeight;
                elTop = $el.position().top;
                elBottom = elTop + $el.outerHeight(true);
                nodeScrollTop = this.$node.scrollTop();
                nodeHeight = this.$node.height() + parseInt(this.$node.css("paddingTop"), 10) + parseInt(this.$node.css("paddingBottom"), 10);
                if (elTop < 0) {
                    this.$node.scrollTop(nodeScrollTop + elTop);
                } else if (nodeHeight < elBottom) {
                    this.$node.scrollTop(nodeScrollTop + (elBottom - nodeHeight));
                }
            },
            bind: function() {
                var that = this, onSelectableClick;
                onSelectableClick = _.bind(this._onSelectableClick, this);
                this.$node.on("click.tt", this.selectors.selectable, onSelectableClick);
                _.each(this.datasets, function(dataset) {
                    dataset.onSync("asyncRequested", that._propagate, that).onSync("asyncCanceled", that._propagate, that).onSync("asyncReceived", that._propagate, that).onSync("rendered", that._onRendered, that).onSync("cleared", that._onCleared, that);
                });
                return this;
            },
            isOpen: function isOpen() {
                return this.$node.hasClass(this.classes.open);
            },
            open: function open() {
                this.$node.addClass(this.classes.open);
            },
            close: function close() {
                this.$node.removeClass(this.classes.open);
                this._removeCursor();
            },
            setLanguageDirection: function setLanguageDirection(dir) {
                this.$node.attr("dir", dir);
            },
            selectableRelativeToCursor: function selectableRelativeToCursor(delta) {
                var $selectables, $oldCursor, oldIndex, newIndex;
                $oldCursor = this.getActiveSelectable();
                $selectables = this._getSelectables();
                oldIndex = $oldCursor ? $selectables.index($oldCursor) : -1;
                newIndex = oldIndex + delta;
                newIndex = (newIndex + 1) % ($selectables.length + 1) - 1;
                newIndex = newIndex < -1 ? $selectables.length - 1 : newIndex;
                return newIndex === -1 ? null : $selectables.eq(newIndex);
            },
            setCursor: function setCursor($selectable) {
                this._removeCursor();
                if ($selectable = $selectable && $selectable.first()) {
                    $selectable.addClass(this.classes.cursor);
                    this._ensureVisible($selectable);
                }
            },
            getSelectableData: function getSelectableData($el) {
                return $el && $el.length ? Dataset.extractData($el) : null;
            },
            getActiveSelectable: function getActiveSelectable() {
                var $selectable = this._getSelectables().filter(this.selectors.cursor).first();
                return $selectable.length ? $selectable : null;
            },
            getTopSelectable: function getTopSelectable() {
                var $selectable = this._getSelectables().first();
                return $selectable.length ? $selectable : null;
            },
            update: function update(query) {
                var isValidUpdate = query !== this.query;
                if (isValidUpdate) {
                    this.query = query;
                    _.each(this.datasets, updateDataset);
                }
                return isValidUpdate;
                function updateDataset(dataset) {
                    dataset.update(query);
                }
            },
            empty: function empty() {
                _.each(this.datasets, clearDataset);
                this.query = null;
                this.$node.addClass(this.classes.empty);
                function clearDataset(dataset) {
                    dataset.clear();
                }
            },
            destroy: function destroy() {
                this.$node.off(".tt");
                this.$node = $("<div>");
                _.each(this.datasets, destroyDataset);
                function destroyDataset(dataset) {
                    dataset.destroy();
                }
            }
        });
        return Menu;
    }();
    var DefaultMenu = function() {
        "use strict";
        var s = Menu.prototype;
        function DefaultMenu() {
            Menu.apply(this, [].slice.call(arguments, 0));
        }
        _.mixin(DefaultMenu.prototype, Menu.prototype, {
            open: function open() {
                !this._allDatasetsEmpty() && this._show();
                return s.open.apply(this, [].slice.call(arguments, 0));
            },
            close: function close() {
                this._hide();
                return s.close.apply(this, [].slice.call(arguments, 0));
            },
            _onRendered: function onRendered() {
                if (this._allDatasetsEmpty()) {
                    this._hide();
                } else {
                    this.isOpen() && this._show();
                }
                return s._onRendered.apply(this, [].slice.call(arguments, 0));
            },
            _onCleared: function onCleared() {
                if (this._allDatasetsEmpty()) {
                    this._hide();
                } else {
                    this.isOpen() && this._show();
                }
                return s._onCleared.apply(this, [].slice.call(arguments, 0));
            },
            setLanguageDirection: function setLanguageDirection(dir) {
                this.$node.css(dir === "ltr" ? this.css.ltr : this.css.rtl);
                return s.setLanguageDirection.apply(this, [].slice.call(arguments, 0));
            },
            _hide: function hide() {
                this.$node.hide();
            },
            _show: function show() {
                this.$node.css("display", "block");
            }
        });
        return DefaultMenu;
    }();
    var Typeahead = function() {
        "use strict";
        function Typeahead(o, www) {
            var onFocused, onBlurred, onEnterKeyed, onTabKeyed, onEscKeyed, onUpKeyed, onDownKeyed, onLeftKeyed, onRightKeyed, onQueryChanged, onWhitespaceChanged;
            o = o || {};
            if (!o.input) {
                $.error("missing input");
            }
            if (!o.menu) {
                $.error("missing menu");
            }
            if (!o.eventBus) {
                $.error("missing event bus");
            }
            www.mixin(this);
            this.eventBus = o.eventBus;
            this.minLength = _.isNumber(o.minLength) ? o.minLength : 1;
            this.input = o.input;
            this.menu = o.menu;
            this.enabled = true;
            this.active = false;
            this.input.hasFocus() && this.activate();
            this.dir = this.input.getLangDir();
            this._hacks();
            this.menu.bind().onSync("selectableClicked", this._onSelectableClicked, this).onSync("asyncRequested", this._onAsyncRequested, this).onSync("asyncCanceled", this._onAsyncCanceled, this).onSync("asyncReceived", this._onAsyncReceived, this).onSync("datasetRendered", this._onDatasetRendered, this).onSync("datasetCleared", this._onDatasetCleared, this);
            onFocused = c(this, "activate", "open", "_onFocused");
            onBlurred = c(this, "deactivate", "_onBlurred");
            onEnterKeyed = c(this, "isActive", "isOpen", "_onEnterKeyed");
            onTabKeyed = c(this, "isActive", "isOpen", "_onTabKeyed");
            onEscKeyed = c(this, "isActive", "_onEscKeyed");
            onUpKeyed = c(this, "isActive", "open", "_onUpKeyed");
            onDownKeyed = c(this, "isActive", "open", "_onDownKeyed");
            onLeftKeyed = c(this, "isActive", "isOpen", "_onLeftKeyed");
            onRightKeyed = c(this, "isActive", "isOpen", "_onRightKeyed");
            onQueryChanged = c(this, "_openIfActive", "_onQueryChanged");
            onWhitespaceChanged = c(this, "_openIfActive", "_onWhitespaceChanged");
            this.input.bind().onSync("focused", onFocused, this).onSync("blurred", onBlurred, this).onSync("enterKeyed", onEnterKeyed, this).onSync("tabKeyed", onTabKeyed, this).onSync("escKeyed", onEscKeyed, this).onSync("upKeyed", onUpKeyed, this).onSync("downKeyed", onDownKeyed, this).onSync("leftKeyed", onLeftKeyed, this).onSync("rightKeyed", onRightKeyed, this).onSync("queryChanged", onQueryChanged, this).onSync("whitespaceChanged", onWhitespaceChanged, this).onSync("langDirChanged", this._onLangDirChanged, this);
        }
        _.mixin(Typeahead.prototype, {
            _hacks: function hacks() {
                var $input, $menu;
                $input = this.input.$input || $("<div>");
                $menu = this.menu.$node || $("<div>");
                $input.on("blur.tt", function($e) {
                    var active, isActive, hasActive;
                    active = document.activeElement;
                    isActive = $menu.is(active);
                    hasActive = $menu.has(active).length > 0;
                    if (_.isMsie() && (isActive || hasActive)) {
                        $e.preventDefault();
                        $e.stopImmediatePropagation();
                        _.defer(function() {
                            $input.focus();
                        });
                    }
                });
                $menu.on("mousedown.tt", function($e) {
                    $e.preventDefault();
                });
            },
            _onSelectableClicked: function onSelectableClicked(type, $el) {
                this.select($el);
            },
            _onDatasetCleared: function onDatasetCleared() {
                this._updateHint();
            },
            _onDatasetRendered: function onDatasetRendered(type, dataset, suggestions, async) {
                this._updateHint();
                this.eventBus.trigger("render", suggestions, async, dataset);
            },
            _onAsyncRequested: function onAsyncRequested(type, dataset, query) {
                this.eventBus.trigger("asyncrequest", query, dataset);
            },
            _onAsyncCanceled: function onAsyncCanceled(type, dataset, query) {
                this.eventBus.trigger("asynccancel", query, dataset);
            },
            _onAsyncReceived: function onAsyncReceived(type, dataset, query) {
                this.eventBus.trigger("asyncreceive", query, dataset);
            },
            _onFocused: function onFocused() {
                this._minLengthMet() && this.menu.update(this.input.getQuery());
            },
            _onBlurred: function onBlurred() {
                if (this.input.hasQueryChangedSinceLastFocus()) {
                    this.eventBus.trigger("change", this.input.getQuery());
                }
            },
            _onEnterKeyed: function onEnterKeyed(type, $e) {
                var $selectable;
                if ($selectable = this.menu.getActiveSelectable()) {
                    this.select($selectable) && $e.preventDefault();
                } else if ($selectable = this.menu.getTopSelectable()) {
                    this.select($selectable) && $e.preventDefault();
                }
            },
            _onTabKeyed: function onTabKeyed(type, $e) {
                var $selectable;
                if ($selectable = this.menu.getActiveSelectable()) {
                    this.select($selectable) && $e.preventDefault();
                }
            },
            _onEscKeyed: function onEscKeyed() {
                this.close();
            },
            _onUpKeyed: function onUpKeyed() {
                this.moveCursor(-1);
            },
            _onDownKeyed: function onDownKeyed() {
                this.moveCursor(+1);
            },
            _onLeftKeyed: function onLeftKeyed() {
                if (this.dir === "rtl" && this.input.isCursorAtEnd()) {
                    this.autocomplete(this.menu.getTopSelectable());
                }
            },
            _onRightKeyed: function onRightKeyed() {
                // if (this.dir === "ltr" && this.input.isCursorAtEnd()) {
                //     this.autocomplete(this.menu.getTopSelectable());
                // }
            },
            _onQueryChanged: function onQueryChanged(e, query) {
                this._minLengthMet(query) ? this.menu.update(query) : this.menu.empty();
            },
            _onWhitespaceChanged: function onWhitespaceChanged() {
                this._updateHint();
            },
            _onLangDirChanged: function onLangDirChanged(e, dir) {
                if (this.dir !== dir) {
                    this.dir = dir;
                    this.menu.setLanguageDirection(dir);
                }
            },
            _openIfActive: function openIfActive() {
                this.isActive() && this.open();
            },
            _minLengthMet: function minLengthMet(query) {
                query = _.isString(query) ? query : this.input.getQuery() || "";
                return query.length >= this.minLength;
            },
            _updateHint: function updateHint() {
                var $selectable, data, val, query, escapedQuery, frontMatchRegEx, match;
                $selectable = this.menu.getTopSelectable();
                data = this.menu.getSelectableData($selectable);
                val = this.input.getInputValue();
                if (data && !_.isBlankString(val) && !this.input.hasOverflow()) {
                    query = Input.normalizeQuery(val);
                    escapedQuery = _.escapeRegExChars(query);
                    frontMatchRegEx = new RegExp("^(?:" + escapedQuery + ")(.+$)", "i");
                    match = frontMatchRegEx.exec(data.val);
                    match && this.input.setHint(val + match[1]);
                } else {
                    this.input.clearHint();
                }
            },
            isEnabled: function isEnabled() {
                return this.enabled;
            },
            enable: function enable() {
                this.enabled = true;
            },
            disable: function disable() {
                this.enabled = false;
            },
            isActive: function isActive() {
                return this.active;
            },
            activate: function activate() {
                if (this.isActive()) {
                    return true;
                } else if (!this.isEnabled() || this.eventBus.before("active")) {
                    return false;
                } else {
                    this.active = true;
                    this.eventBus.trigger("active");
                    return true;
                }
            },
            deactivate: function deactivate() {
                if (!this.isActive()) {
                    return true;
                } else if (this.eventBus.before("idle")) {
                    return false;
                } else {
                    this.active = false;
                    this.close();
                    this.eventBus.trigger("idle");
                    return true;
                }
            },
            isOpen: function isOpen() {
                return this.menu.isOpen();
            },
            open: function open() {
                if (!this.isOpen() && !this.eventBus.before("open")) {
                    this.menu.open();
                    this._updateHint();
                    this.eventBus.trigger("open");
                }
                return this.isOpen();
            },
            close: function close() {
                if (this.isOpen() && !this.eventBus.before("close")) {
                    this.menu.close();
                    this.input.clearHint();
                    this.input.resetInputValue();
                    this.eventBus.trigger("close");
                }
                return !this.isOpen();
            },
            setVal: function setVal(val) {
                this.input.setQuery(_.toStr(val));
            },
            getVal: function getVal() {
                return this.input.getQuery();
            },
            select: function select($selectable) {
                var data = this.menu.getSelectableData($selectable);
                if (data && !this.eventBus.before("select", data.obj)) {
                    this.input.setQuery(data.val, true);
                    this.eventBus.trigger("select", data.obj);
                    this.close();
                    return true;
                }
                return false;
            },
            autocomplete: function autocomplete($selectable) {
                var query, data, isValid;
                query = this.input.getQuery();
                data = this.menu.getSelectableData($selectable);
                isValid = data && query !== data.val;
                if (isValid && !this.eventBus.before("autocomplete", data.obj)) {
                    this.input.setQuery(data.val);
                    this.eventBus.trigger("autocomplete", data.obj);
                    return true;
                }
                return false;
            },
            moveCursor: function moveCursor(delta) {
                var query, $candidate, data, payload, cancelMove;
                query = this.input.getQuery();
                $candidate = this.menu.selectableRelativeToCursor(delta);
                data = this.menu.getSelectableData($candidate);
                payload = data ? data.obj : null;
                cancelMove = this._minLengthMet() && this.menu.update(query);
                if (!cancelMove && !this.eventBus.before("cursorchange", payload)) {
                    this.menu.setCursor($candidate);
                    if (data) {
                        this.input.setInputValue(data.val);
                    } else {
                        this.input.resetInputValue();
                        this._updateHint();
                    }
                    this.eventBus.trigger("cursorchange", payload);
                    return true;
                }
                return false;
            },
            destroy: function destroy() {
                this.input.destroy();
                this.menu.destroy();
            }
        });
        return Typeahead;
        function c(ctx) {
            var methods = [].slice.call(arguments, 1);
            return function() {
                var args = [].slice.call(arguments);
                _.each(methods, function(method) {
                    return ctx[method].apply(ctx, args);
                });
            };
        }
    }();
    (function() {
        "use strict";
        var old, keys, methods;
        old = $.fn.typeahead;
        keys = {
            www: "tt-www",
            attrs: "tt-attrs",
            typeahead: "tt-typeahead"
        };
        methods = {
            initialize: function initialize(o, datasets) {
                var www;
                datasets = _.isArray(datasets) ? datasets : [].slice.call(arguments, 1);
                o = o || {};
                www = WWW(o.classNames);
                return this.each(attach);
                function attach() {
                    var $input, $wrapper, $hint, $menu, defaultHint, defaultMenu, eventBus, input, menu, typeahead, MenuConstructor;
                    _.each(datasets, function(d) {
                        d.highlight = !!o.highlight;
                    });
                    $input = $(this);
                    $wrapper = $(www.html.wrapper);
                    $hint = $elOrNull(o.hint);
                    $menu = $elOrNull(o.menu);
                    defaultHint = o.hint !== false && !$hint;
                    defaultMenu = o.menu !== false && !$menu;
                    defaultHint && ($hint = buildHintFromInput($input, www));
                    defaultMenu && ($menu = $(www.html.menu).css(www.css.menu));
                    $hint && $hint.val("");
                    $input = prepInput($input, www);
                    if (defaultHint || defaultMenu) {
                        $wrapper.css(www.css.wrapper);
                        $input.css(defaultHint ? www.css.input : www.css.inputWithNoHint);
                        $input.wrap($wrapper).parent().prepend(defaultHint ? $hint : null).append(defaultMenu ? $menu : null);
                    }
                    MenuConstructor = defaultMenu ? DefaultMenu : Menu;
                    eventBus = new EventBus({
                        el: $input
                    });
                    input = new Input({
                        hint: $hint,
                        input: $input
                    }, www);
                    menu = new MenuConstructor({
                        node: $menu,
                        datasets: datasets
                    }, www);
                    typeahead = new Typeahead({
                        input: input,
                        menu: menu,
                        eventBus: eventBus,
                        minLength: o.minLength
                    }, www);
                    $input.data(keys.www, www);
                    $input.data(keys.typeahead, typeahead);
                }
            },
            isEnabled: function isEnabled() {
                var enabled;
                ttEach(this.first(), function(t) {
                    enabled = t.isEnabled();
                });
                return enabled;
            },
            enable: function enable() {
                ttEach(this, function(t) {
                    t.enable();
                });
                return this;
            },
            disable: function disable() {
                ttEach(this, function(t) {
                    t.disable();
                });
                return this;
            },
            isActive: function isActive() {
                var active;
                ttEach(this.first(), function(t) {
                    active = t.isActive();
                });
                return active;
            },
            activate: function activate() {
                ttEach(this, function(t) {
                    t.activate();
                });
                return this;
            },
            deactivate: function deactivate() {
                ttEach(this, function(t) {
                    t.deactivate();
                });
                return this;
            },
            isOpen: function isOpen() {
                var open;
                ttEach(this.first(), function(t) {
                    open = t.isOpen();
                });
                return open;
            },
            open: function open() {
                ttEach(this, function(t) {
                    t.open();
                });
                return this;
            },
            close: function close() {
                ttEach(this, function(t) {
                    t.close();
                });
                return this;
            },
            select: function select(el) {
                var success = false, $el = $(el);
                ttEach(this.first(), function(t) {
                    success = t.select($el);
                });
                return success;
            },
            autocomplete: function autocomplete(el) {
                var success = false, $el = $(el);
                ttEach(this.first(), function(t) {
                    success = t.autocomplete($el);
                });
                return success;
            },
            moveCursor: function moveCursoe(delta) {
                var success = false;
                ttEach(this.first(), function(t) {
                    success = t.moveCursor(delta);
                });
                return success;
            },
            val: function val(newVal) {
                var query;
                if (!arguments.length) {
                    ttEach(this.first(), function(t) {
                        query = t.getVal();
                    });
                    return query;
                } else {
                    ttEach(this, function(t) {
                        t.setVal(newVal);
                    });
                    return this;
                }
            },
            destroy: function destroy() {
                ttEach(this, function(typeahead, $input) {
                    revert($input);
                    typeahead.destroy();
                });
                return this;
            }
        };
        $.fn.typeahead = function(method) {
            if (methods[method]) {
                return methods[method].apply(this, [].slice.call(arguments, 1));
            } else {
                return methods.initialize.apply(this, arguments);
            }
        };
        $.fn.typeahead.noConflict = function noConflict() {
            $.fn.typeahead = old;
            return this;
        };
        function ttEach($els, fn) {
            $els.each(function() {
                var $input = $(this), typeahead;
                (typeahead = $input.data(keys.typeahead)) && fn(typeahead, $input);
            });
        }
        function buildHintFromInput($input, www) {
            return $input.clone().addClass(www.classes.hint).removeData().css(www.css.hint).css(getBackgroundStyles($input)).prop("readonly", true).removeAttr("id name placeholder required").attr({
                autocomplete: "off",
                spellcheck: "false",
                tabindex: -1
            });
        }
        function prepInput($input, www) {
            $input.data(keys.attrs, {
                dir: $input.attr("dir"),
                autocomplete: $input.attr("autocomplete"),
                spellcheck: $input.attr("spellcheck"),
                style: $input.attr("style")
            });
            $input.addClass(www.classes.input).attr({
                autocomplete: "off",
                spellcheck: false
            });
            try {
                !$input.attr("dir") && $input.attr("dir", "auto");
            } catch (e) {}
            return $input;
        }
        function getBackgroundStyles($el) {
            return {
                backgroundAttachment: $el.css("background-attachment"),
                backgroundClip: $el.css("background-clip"),
                backgroundColor: $el.css("background-color"),
                backgroundImage: $el.css("background-image"),
                backgroundOrigin: $el.css("background-origin"),
                backgroundPosition: $el.css("background-position"),
                backgroundRepeat: $el.css("background-repeat"),
                backgroundSize: $el.css("background-size")
            };
        }
        function revert($input) {
            var www, $wrapper;
            www = $input.data(keys.www);
            $wrapper = $input.parent().filter(www.selectors.wrapper);
            _.each($input.data(keys.attrs), function(val, key) {
                _.isUndefined(val) ? $input.removeAttr(key) : $input.attr(key, val);
            });
            $input.removeData(keys.typeahead).removeData(keys.www).removeData(keys.attr).removeClass(www.classes.input);
            if ($wrapper.length) {
                $input.detach().insertAfter($wrapper);
                $wrapper.remove();
            }
        }
        function $elOrNull(obj) {
            var isValid, $el;
            isValid = _.isJQuery(obj) || _.isElement(obj);
            $el = isValid ? $(obj).first() : [];
            return $el.length ? $el : null;
        }
    })();
});

/***/ }),
/* 502 */,
/* 503 */,
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"app/pages/affiliate-module/affiliate.module": [
		1385,
		6
	],
	"app/pages/approval-module/approval-module.module": [
		1386,
		7
	],
	"app/pages/booking-module/booking-module.module": [
		1387,
		9
	],
	"app/pages/checkout-module/checkout-module.module": [
		1388,
		2
	],
	"app/pages/confirmation-module/confirmation-module.module": [
		1389,
		8
	],
	"app/pages/cookies-policy/cookies-policy.module": [
		1390,
		21
	],
	"app/pages/data-deletion-instructions-module/data-deletion-instructions-module.module": [
		1391,
		20
	],
	"app/pages/fleet-card-module/fleet-card-module.module": [
		1392,
		4
	],
	"app/pages/mice-module/mice-module.module": [
		1393,
		19
	],
	"app/pages/my-budget-module/my-budget-module.module": [
		1394,
		10
	],
	"app/pages/my-profile/my-profile-module.module": [
		1395,
		12
	],
	"app/pages/privacy-policy-module/privacy-policy-module.module": [
		1396,
		18
	],
	"app/pages/product-detail-module/product-detail-module.module": [
		1397,
		3
	],
	"app/pages/product-list-module/product-list-module.module": [
		1398,
		5
	],
	"app/pages/promotion-module/promotion-module.module": [
		1399,
		1
	],
	"app/pages/rating-module/rating-module.module": [
		1400,
		11
	],
	"app/pages/search-module/search-module.module": [
		1401,
		17
	],
	"app/pages/setting-module/setting-module.module": [
		1402,
		16
	],
	"app/pages/share-budget-code-module/share-budget-code-module.module": [
		1403,
		15
	],
	"app/pages/terms-of-use-module/terms-of-use-module.module": [
		1404,
		14
	],
	"app/pages/thankyou/thankyou-module.module": [
		1405,
		13
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 504;


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_app_module__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser_dynamic__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_offline_plugin_runtime__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_offline_plugin_runtime__);





__WEBPACK_IMPORTED_MODULE_4_offline_plugin_runtime__["install"]({
    onUpdateReady: function () {
        __WEBPACK_IMPORTED_MODULE_4_offline_plugin_runtime__["applyUpdate"]();
    },
    onUpdated: function () {
        window.location.reload();
    }
});
var o = document;
var a = o.getElementsByTagName('head')[0];
var body = o.getElementsByTagName('body')[0];
// Load Google Tag Manager 
var gtm = o.createElement('script');
gtm.defer = true;
gtm.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=" + __WEBPACK_IMPORTED_MODULE_2__environments_environment__["a" /* environment */].googleTagManagerAuth + "&gtm_preview=" + __WEBPACK_IMPORTED_MODULE_2__environments_environment__["a" /* environment */].googleTagManagerPreview + "&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','" + __WEBPACK_IMPORTED_MODULE_2__environments_environment__["a" /* environment */].googleTagManagerId + "');";
a.insertBefore(gtm, a.firstChild);
var gtmNoscript = o.createElement('noscript');
var gtmIframe = o.createElement('iframe');
gtmIframe.setAttribute('src', "https://www.googletagmanager.com/ns.html?id=" + __WEBPACK_IMPORTED_MODULE_2__environments_environment__["a" /* environment */].googleTagManagerId + "&gtm_auth=" + __WEBPACK_IMPORTED_MODULE_2__environments_environment__["a" /* environment */].googleTagManagerAuth + "&gtm_preview=" + __WEBPACK_IMPORTED_MODULE_2__environments_environment__["a" /* environment */].googleTagManagerPreview + "&gtm_cookies_win=x");
gtmIframe.setAttribute('height', '0');
gtmIframe.setAttribute('width', '0');
gtmIframe.setAttribute('style', 'display:none;visibility:hidden');
gtmNoscript.appendChild(gtmIframe);
body.insertBefore(gtmNoscript, body.firstChild);
// Load reCAPTCHA
var reCaptcha = o.createElement('script');
reCaptcha.setAttribute('src', "https://www.google.com/recaptcha/api.js?render=" + __WEBPACK_IMPORTED_MODULE_2__environments_environment__["a" /* environment */].reCaptchaSiteKey);
reCaptcha.setAttribute('type', 'text/javascript');
a.appendChild(reCaptcha);
if (__WEBPACK_IMPORTED_MODULE_2__environments_environment__["a" /* environment */].production) {
    var onetrust = o.createElement('script');
    onetrust.setAttribute('src', 'https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js');
    onetrust.setAttribute('type', 'text/javascript');
    onetrust.setAttribute('charset', 'UTF-8');
    onetrust.setAttribute('data-domain-script', __WEBPACK_IMPORTED_MODULE_2__environments_environment__["a" /* environment */].onetrustDataDomainScript);
    a.appendChild(onetrust);
    // Run
    var oneTrustFct = o.createElement('script');
    oneTrustFct.setAttribute('type', 'text/javascript');
    oneTrustFct.innerText = 'function OptanonWrapper() {}';
    a.appendChild(oneTrustFct);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["enableProdMode"])();
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_platform_browser_dynamic__["a" /* platformBrowserDynamic */])().bootstrapModule(__WEBPACK_IMPORTED_MODULE_0__app_app_module__["a" /* AppModule */]);
//# sourceMappingURL=main.js.map

/***/ }),
/* 506 */,
/* 507 */,
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartAndProfileModel; });
var CartAndProfileModel = (function () {
    function CartAndProfileModel() {
    }
    return CartAndProfileModel;
}());

//# sourceMappingURL=cart-profile.model.js.map

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__warning_warning_service__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_environments_properties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_model_constant__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthenticationGuard; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var AuthenticationGuard = (function () {
    function AuthenticationGuard(authService, warningService, appConfigService, router) {
        this.authService = authService;
        this.warningService = warningService;
        this.appConfigService = appConfigService;
        this.router = router;
    }
    AuthenticationGuard.prototype.canActivate = function (next, state) {
        var _this = this;
        return this.authService.validateToken(this.authService.getToken()).map(function (result) {
            if (!result) {
                var userInfo = _this.authService.getUserInfo();
                _this.authService.clearToken();
                if (userInfo && userInfo.companyCode) {
                    _this.warningService.popDialogErrorRequest('popup-warning-session-expire', null, null, "/company/" + userInfo.companyCode);
                }
                else {
                    var parseUrl = _this.router.parseUrl(state.url);
                    delete parseUrl.queryParams['lang'];
                    var returnUrl = next.queryParams && next.queryParams.returnUrl ? next.queryParams.returnUrl : parseUrl.toString();
                    _this.appConfigService.setReturnUrl(returnUrl);
                    if (_this.appConfigService.getLanguage() === __WEBPACK_IMPORTED_MODULE_6_app_model_constant__["a" /* Language */].th) {
                        window.location.href = __WEBPACK_IMPORTED_MODULE_5_environments_properties__["l" /* landingUrl */] + '/th/index.html';
                    }
                    else {
                        window.location.href = __WEBPACK_IMPORTED_MODULE_5_environments_properties__["l" /* landingUrl */];
                    }
                }
            }
            return result;
        });
    };
    return AuthenticationGuard;
}());
AuthenticationGuard = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_4__warning_warning_service__["a" /* WarningService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__warning_warning_service__["a" /* WarningService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_router__["c" /* Router */]) === "function" && _d || Object])
], AuthenticationGuard);

var _a, _b, _c, _d;
//# sourceMappingURL=authentication.guard.js.map

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_platform__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_platform__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogMapComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var DialogMapComponent = (function () {
    function DialogMapComponent(dialogRef) {
        this.dialogRef = dialogRef;
    }
    DialogMapComponent.prototype.ngOnInit = function () { };
    DialogMapComponent.prototype.resetIphoneHandler = function () {
        this.$mapElement && this.$mapElement.removeClass('iphone');
    };
    DialogMapComponent.prototype.iPhoneUpdateSizing = function () {
        var _this = this;
        setTimeout(function () {
            _this.$mapElement = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#map');
            // handle for iPhone (safari and firefox) only
            var canHandle = !!__WEBPACK_IMPORTED_MODULE_3_platform___default.a && window.navigator.platform === 'iPhone';
            canHandle = canHandle && __WEBPACK_IMPORTED_MODULE_3_platform___default.a.product === 'iPhone';
            canHandle = canHandle && (__WEBPACK_IMPORTED_MODULE_3_platform___default.a.name === 'Safari' || __WEBPACK_IMPORTED_MODULE_3_platform___default.a.name === 'Firefox');
            canHandle && _this.$mapElement && _this.$mapElement.addClass('iphone');
        }, 500);
    };
    return DialogMapComponent;
}());
DialogMapComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-map',
        template: __webpack_require__(1058),
        styles: [__webpack_require__(923)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object])
], DialogMapComponent);

var _a;
//# sourceMappingURL=dialog-map.component.js.map

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShowMorePrefixModel; });
var ShowMorePrefixModel = (function () {
    function ShowMorePrefixModel() {
        this.page = 'page';
        this.component = 'component';
    }
    return ShowMorePrefixModel;
}());

//# sourceMappingURL=show-more-prefix.model.js.map

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkout_cart_info_model__ = __webpack_require__(548);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CartMultipaymentDetail; });
/* unused harmony export CreditTermsAmount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AvailableBudget; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var CartModel = (function (_super) {
    __extends(CartModel, _super);
    function CartModel(condition, search, searchId) {
        if (condition === void 0) { condition = []; }
        if (search === void 0) { search = undefined; }
        if (searchId === void 0) { searchId = null; }
        var _this = _super.call(this) || this;
        _this.conditions = condition;
        _this.search = search;
        _this.searchId = searchId;
        return _this;
    }
    return CartModel;
}(__WEBPACK_IMPORTED_MODULE_0__checkout_cart_info_model__["a" /* CartInfoModel */]));

var CartMultipaymentDetail = (function () {
    function CartMultipaymentDetail(creditCardAmount, creditTermsBooker, creditTermsCoBooker) {
        this.creditCardAmount = creditCardAmount;
        this.creditTermsAmount = new CreditTermsAmount(creditTermsBooker, creditTermsCoBooker);
    }
    return CartMultipaymentDetail;
}());

var CreditTermsAmount = (function () {
    function CreditTermsAmount(creditTermsBooker, creditTermsCoBooker) {
        this.booker = creditTermsBooker;
        this.coBooker = creditTermsCoBooker;
    }
    return CreditTermsAmount;
}());

var AvailableBudget = (function (_super) {
    __extends(AvailableBudget, _super);
    function AvailableBudget(creditTermsBooker, creditTermsCoBooker, totalAvailableBudget) {
        var _this = _super.call(this, creditTermsBooker, creditTermsCoBooker) || this;
        _this.totalAvailableBudget = totalAvailableBudget;
        return _this;
    }
    return AvailableBudget;
}(CreditTermsAmount));

//# sourceMappingURL=cart.model.js.map

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductDetailModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ShaModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BadgeModel; });
var ProductDetailModel = (function () {
    function ProductDetailModel(details, notices, images) {
        if (details === void 0) { details = undefined; }
        if (notices === void 0) { notices = []; }
        if (images === void 0) { images = []; }
        this.notices = [];
        this.images = [];
        this.details = details;
        this.notices = notices;
        this.images = images;
    }
    return ProductDetailModel;
}());

var ShaModel = (function () {
    function ShaModel(isShaPlus, certificateId) {
        if (isShaPlus === void 0) { isShaPlus = false; }
        this.isShaPlus = isShaPlus;
        this.certificateId = certificateId;
    }
    return ShaModel;
}());

var BadgeModel = (function () {
    function BadgeModel(displaySanitation, displayYearOfBuild, displayYearOfRenovated, displaySecurityStandard) {
        if (displaySanitation === void 0) { displaySanitation = false; }
        this.displaySanitation = displaySanitation;
        this.displayYearOfBuild = displayYearOfBuild;
        this.displayYearOfRenovated = displayYearOfRenovated;
        this.displaySecurityStandard = displaySecurityStandard;
    }
    return BadgeModel;
}());

//# sourceMappingURL=product-detail.model.js.map

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductRoomDetailModel */
/* unused harmony export Room */
/* unused harmony export Condition */
/* unused harmony export Surcharge */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CancellationPolicy; });
/* unused harmony export Benefit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RoomDetailDto; });
/* unused harmony export Remark */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RoomConditionDto; });
var ProductRoomDetailModel = (function () {
    function ProductRoomDetailModel() {
        this.companyTravelPolicyUserResponse = [];
    }
    return ProductRoomDetailModel;
}());

var Room = (function () {
    function Room() {
    }
    return Room;
}());

var Condition = (function () {
    function Condition() {
    }
    return Condition;
}());

var Surcharge = (function () {
    function Surcharge() {
    }
    return Surcharge;
}());

var CancellationPolicy = (function () {
    function CancellationPolicy() {
    }
    return CancellationPolicy;
}());

var Benefit = (function () {
    function Benefit() {
    }
    return Benefit;
}());

var RoomDetailDto = (function () {
    function RoomDetailDto(detailList, search, searchId, crossCondition) {
        if (detailList === void 0) { detailList = undefined; }
        if (search === void 0) { search = undefined; }
        if (searchId === void 0) { searchId = null; }
        if (crossCondition === void 0) { crossCondition = true; }
        this.roomDetails = detailList;
        this.searchFormModel = search;
        this.crossCondition = crossCondition;
        this.searchId = searchId;
    }
    return RoomDetailDto;
}());

var Remark = (function () {
    function Remark() {
    }
    return Remark;
}());

var RoomConditionDto = (function () {
    function RoomConditionDto(option, condition) {
        if (option === void 0) { option = undefined; }
        if (condition === void 0) { condition = undefined; }
        this.nonRefundableDescription = "";
        this.payOn = "";
        this.paylaterDescription = "";
        this.lastDayFreeCanllation = "";
        this.isExpand = false;
        this.isOverLimit = false;
        this.isFirstCondition = false;
        this.isCountRow = 1;
        this.displayIncludeSurcharge = "";
        this.displayExcludeSurcharge = "";
        this.displayExtraBed = "";
        if (option && condition) {
            this.lineItemId = '' + condition.conditionId;
            this.allotment = option.allotment;
            this.title = option.title;
            this.displayTitle = option.title.toString();
            this.adult = condition.adult;
            this.child = condition.child;
            this.breakfast = condition.breakfast > 0;
            this.netPrice = Math.ceil(condition.totalPriceSellingFinalSupplierCurrency.valueOf()).toString();
            this.quantity = condition.quantity;
            this.cancellationPolicies = [];
            this.surcharges = condition.surcharges;
            if (condition.cancellationList.length > 0) {
                this.cancellationPolicies.push(new CancellationPolicy());
            }
        }
    }
    return RoomConditionDto;
}());

//# sourceMappingURL=product-room-detail.model.js.map

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_condition_condition_model__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_constant__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogConditionChangeComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};





var DialogConditionChangeComponent = (function () {
    function DialogConditionChangeComponent(inputData, dialogRef, utilitiesService) {
        this.inputData = inputData;
        this.dialogRef = dialogRef;
        this.utilitiesService = utilitiesService;
        this.isMobile = false;
        this.conditionDisplayType = __WEBPACK_IMPORTED_MODULE_4__model_constant__["v" /* ConditionDisplayType */];
    }
    DialogConditionChangeComponent.prototype.ngOnInit = function () {
        this.utilitiesService.isMobile() && (this.isMobile = true);
        this.checkUIcondition(this.inputData);
    };
    DialogConditionChangeComponent.prototype.checkUIcondition = function (inputData) {
        switch (inputData.code) {
            case '4071':
            case '4072':
            case '4078':
                this.title = inputData.title;
                this.columns = inputData.columns;
                this.data = inputData.row;
                this.noOfColumns = this.columns.length;
                this.type = __WEBPACK_IMPORTED_MODULE_4__model_constant__["v" /* ConditionDisplayType */].TABLE;
                break;
            case '4075':
            case '4076':
            case '4077':
                this.title = inputData.title;
                this.type = __WEBPACK_IMPORTED_MODULE_4__model_constant__["v" /* ConditionDisplayType */].TWO_BUTTON;
                break;
            case '4081':
            case '4082':
            case '4083':
            case '4731':
            case '4701':
            case '4717':
            case '4084':
            case '4811':
            case '4807':
                this.description = inputData.title;
                this.type = __WEBPACK_IMPORTED_MODULE_4__model_constant__["v" /* ConditionDisplayType */].ONE_BUTTON_DIVIDER;
                break;
            case '4091':
            case '4092':
            case '4711':
                this.title = inputData.title;
                this.description = inputData.description;
                this.type = __WEBPACK_IMPORTED_MODULE_4__model_constant__["v" /* ConditionDisplayType */].ONE_BUTTON_DIVIDER;
        }
        this.btn = inputData.btn;
        this.isVerticalDisplayMobile = this.inputData.isVerticalDisplayMobile;
        this.route = inputData.route;
        this.imgPath = inputData.imgPath;
    };
    DialogConditionChangeComponent.prototype.onResize = function (event) {
        this.isMobile = this.utilitiesService.isMobile();
    };
    DialogConditionChangeComponent.prototype.acceptChange = function () {
        this.handleSuccess();
    };
    DialogConditionChangeComponent.prototype.goToHome = function () {
        this.handleFailure();
    };
    DialogConditionChangeComponent.prototype.handleSuccess = function () {
        this.dialogRef.close({ status: true, type: this.type, route: this.inputData.route });
    };
    DialogConditionChangeComponent.prototype.handleFailure = function () {
        this.dialogRef.close({ status: false });
    };
    return DialogConditionChangeComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DialogConditionChangeComponent.prototype, "onResize", null);
DialogConditionChangeComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-condition-change',
        template: __webpack_require__(1048),
        styles: [__webpack_require__(913)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3__model_condition_condition_model__["a" /* ConditionDisplay */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__model_condition_condition_model__["a" /* ConditionDisplay */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _c || Object])
], DialogConditionChangeComponent);

var _a, _b, _c;
//# sourceMappingURL=dialog-condition-change.component.js.map

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FleetCardType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FleetCardStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FleetCardSoryBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FleetCardInformationResponse; });
/* unused harmony export FleetCardInformationDisplay */
/* unused harmony export RegisterFleetCardResponse */
/* unused harmony export RegisterFleetCardRequest */
/* unused harmony export TransferFleetCardRequest */
/* unused harmony export FleetCardOption */
var FleetCardType = (function () {
    function FleetCardType() {
    }
    return FleetCardType;
}());

FleetCardType.ALL = 'all';
FleetCardType.CORPORATE = 'corporate';
FleetCardType.PERSONAL = 'personal';
var FleetCardStatus = (function () {
    function FleetCardStatus() {
    }
    return FleetCardStatus;
}());

FleetCardStatus.ALL = 'all';
FleetCardStatus.ACTIVE = 'active';
FleetCardStatus.INACTIVE = 'inactive';
FleetCardStatus.EXPIRED = 'expired';
var FleetCardSoryBy = (function () {
    function FleetCardSoryBy() {
    }
    return FleetCardSoryBy;
}());

FleetCardSoryBy.FLEET_CARD_ID = 'fleet-card-id ';
FleetCardSoryBy.EXPIRATION_DATE = 'expiration-date';
var FleetCardInformationResponse = (function () {
    function FleetCardInformationResponse() {
    }
    return FleetCardInformationResponse;
}());

var FleetCardInformationDisplay = (function () {
    function FleetCardInformationDisplay() {
    }
    return FleetCardInformationDisplay;
}());

var RegisterFleetCardResponse = (function () {
    function RegisterFleetCardResponse() {
    }
    return RegisterFleetCardResponse;
}());

var RegisterFleetCardRequest = (function () {
    function RegisterFleetCardRequest() {
    }
    return RegisterFleetCardRequest;
}());

var TransferFleetCardRequest = (function () {
    function TransferFleetCardRequest() {
    }
    return TransferFleetCardRequest;
}());

var FleetCardOption = (function () {
    function FleetCardOption() {
    }
    return FleetCardOption;
}());

//# sourceMappingURL=fleet.model.js.map

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__image_scale_factor_model__ = __webpack_require__(225);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSizingModel; });

var ImageSizingModel = (function () {
    function ImageSizingModel() {
        this.original = new __WEBPACK_IMPORTED_MODULE_0__image_scale_factor_model__["a" /* ImageScaleFactorModel */]();
        this.thumbnail = new __WEBPACK_IMPORTED_MODULE_0__image_scale_factor_model__["a" /* ImageScaleFactorModel */]();
        this.large = new __WEBPACK_IMPORTED_MODULE_0__image_scale_factor_model__["a" /* ImageScaleFactorModel */]();
        this.gallery = new __WEBPACK_IMPORTED_MODULE_0__image_scale_factor_model__["a" /* ImageScaleFactorModel */]();
    }
    ImageSizingModel.defaultImage = function () {
        return {
            thumbnail: new __WEBPACK_IMPORTED_MODULE_0__image_scale_factor_model__["a" /* ImageScaleFactorModel */]('https://images.ascendtravel.com/NoImage.jpg'),
            large: new __WEBPACK_IMPORTED_MODULE_0__image_scale_factor_model__["a" /* ImageScaleFactorModel */]('https://images.ascendtravel.com/NoImage.jpg')
        };
    };
    ImageSizingModel.largeSrcSet = function (image) {
        return image.large['1x'] + " 1x, " + image.large['2x'] + " 2x, " + image.large['3x'] + " 3x";
    };
    ImageSizingModel.thumbnailSrcSet = function (image) {
        return image.thumbnail['1x'] + " 1x, " + image.thumbnail['2x'] + " 2x, " + image.thumbnail['3x'] + " 3x";
    };
    return ImageSizingModel;
}());

//# sourceMappingURL=image-sizing-model.js.map

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HotelListRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HotelListRoomRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HotelListPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HotelListSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HotelListFilter; });
/* unused harmony export HotelListLocation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GeoPolygon; });
/* unused harmony export HotelListResponse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheapestRoom; });
/* unused harmony export PositiveEnergy */
/* unused harmony export CampaignRankAds */
/* unused harmony export HotelListLocaltionResponse */
/* unused harmony export HotelListFacilityResponse */
/* unused harmony export HotelStarResponse */
/* unused harmony export HotelListFacilityIcon */
/* unused harmony export HotelStarFilter */
/* unused harmony export HotelListPriceRangeResponse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HotelListSortType; });
/* unused harmony export DestinationTravelPolicy */
/* unused harmony export TravelPolicy */
/* unused harmony export CompanyTravelPolicyUserResponse */
/* unused harmony export HotelPromotion */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HotelPromotionPromotionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HotelPromotionDiscountType; });
/* unused harmony export HotelListExclude */
/* ---------------- LV.C ---------------- */
// --------- Hotel List Request --------- //
var HotelListRequest = (function () {
    function HotelListRequest() {
        this.productIds = [];
        this.roomRequests = [];
        this.allowOverBudget = false;
    }
    return HotelListRequest;
}());

var HotelListRoomRequest = (function () {
    function HotelListRoomRequest(adultAmount, children) {
        if (children === void 0) { children = []; }
        this.children = [];
        this.adultAmount = adultAmount;
        this.children = children;
    }
    return HotelListRoomRequest;
}());

var HotelListPagination = (function () {
    function HotelListPagination(itemPerPage, pageNo) {
        this.itemPerPage = itemPerPage;
        this.pageNo = pageNo;
    }
    return HotelListPagination;
}());

var HotelListSort = (function () {
    function HotelListSort(sortBy, sortDir) {
        this.sortBy = sortBy;
        this.sortDir = sortDir;
    }
    return HotelListSort;
}());

var HotelListFilter = (function () {
    function HotelListFilter() {
        this.priceRange = null;
        this.facilities = [];
        this.hotelStars = [];
        this.locations = [];
        this.muTravelTypes = [];
        this.includeBreakfast = false;
        this.includeSecurityStandard = false;
        this.includeSanitizedStay = false;
        this.includeFreeCancellation = false;
    }
    return HotelListFilter;
}());

var HotelListLocation = (function () {
    function HotelListLocation() {
        this.polygon = [];
    }
    return HotelListLocation;
}());

var GeoPolygon = (function () {
    function GeoPolygon(lat, lon) {
        this.lat = lat;
        this.lon = lon;
    }
    return GeoPolygon;
}());

// -------- Hotel List Response -------- //
var HotelListResponse = (function () {
    function HotelListResponse() {
        this.items = [];
        this.locations = [];
        this.facilities = [];
        this.companyTravelPolicyUserResponse = [];
    }
    return HotelListResponse;
}());

var CheapestRoom = (function () {
    function CheapestRoom(data) {
        this.facilityIcons = [];
        this.displayLabels = [];
        this.allotment = data.allotment;
        this.netPrice = data.netPrice;
        this.totalPrice = data.totalPrice;
        this.payOn = data.payOn;
        this.lastDayCancel = data.lastDayCancel;
        this.productId = data.productId;
        this.latitude = data.latitude;
        this.longitude = data.longitude;
        this.hotelStar = data.hotelStar;
        this.imageUrl = data.imageUrl;
        this.slug = data.slug;
        this.reviewRatingScore = data.reviewRatingScore;
        this.totalScore = data.totalScore;
        this.productTitle = data.productTitle;
        this.address = data.address;
        this.facilityIcons = data.facilityIcons.slice();
        this.reviewRatingTitle = data.reviewRatingTitle;
        this.overPrice = data.overPrice;
        this.currencyCode = data.currencyCode;
        this.distance = data.distance;
        this.displaySanitation = data.displaySanitation;
        this.displayLabels = data.displayLabels;
        this.promotion = data.promotion;
        this.campaignRankingAds = data.campaignRankingAds;
        this.muTravelTypes = data.muTravelTypes;
    }
    return CheapestRoom;
}());

var PositiveEnergy = (function () {
    function PositiveEnergy() {
    }
    return PositiveEnergy;
}());

var CampaignRankAds = (function () {
    function CampaignRankAds() {
    }
    return CampaignRankAds;
}());

var HotelListLocaltionResponse = (function () {
    function HotelListLocaltionResponse() {
        this.polygon = [];
    }
    return HotelListLocaltionResponse;
}());

var HotelListFacilityResponse = (function () {
    function HotelListFacilityResponse() {
        this.selected = false;
    }
    return HotelListFacilityResponse;
}());

var HotelStarResponse = (function () {
    function HotelStarResponse() {
    }
    return HotelStarResponse;
}());

var HotelListFacilityIcon = (function () {
    function HotelListFacilityIcon() {
    }
    return HotelListFacilityIcon;
}());

var HotelStarFilter = (function () {
    function HotelStarFilter() {
        this.selected = false;
    }
    return HotelStarFilter;
}());

var HotelListPriceRangeResponse = (function () {
    function HotelListPriceRangeResponse(minPrice, maxPrice) {
        this.minPrice = minPrice;
        this.maxPrice = maxPrice;
    }
    return HotelListPriceRangeResponse;
}());

var HotelListSortType = (function () {
    function HotelListSortType() {
    }
    return HotelListSortType;
}());

HotelListSortType.RECOMMEND = 'recommend';
HotelListSortType.NAME_TYPE = 'name';
HotelListSortType.PRICE = 'price';
HotelListSortType.REVIEW_RATING = 'reviewRating';
HotelListSortType.HOTEL_STAR = 'hotelStar';
HotelListSortType.POI_DISTANCE = 'distance';
var DestinationTravelPolicy = (function () {
    function DestinationTravelPolicy() {
    }
    return DestinationTravelPolicy;
}());

var TravelPolicy = (function () {
    function TravelPolicy() {
    }
    return TravelPolicy;
}());

var CompanyTravelPolicyUserResponse = (function () {
    function CompanyTravelPolicyUserResponse() {
    }
    return CompanyTravelPolicyUserResponse;
}());

var HotelPromotion = (function () {
    function HotelPromotion() {
    }
    return HotelPromotion;
}());

var HotelPromotionPromotionType = (function () {
    function HotelPromotionPromotionType() {
    }
    return HotelPromotionPromotionType;
}());

HotelPromotionPromotionType.LAST_MINUTE = 'last_minute';
HotelPromotionPromotionType.SPECIAL_PRICE = 'special_price';
var HotelPromotionDiscountType = (function () {
    function HotelPromotionDiscountType() {
    }
    return HotelPromotionDiscountType;
}());

HotelPromotionDiscountType.PERCENT = 'percent';
HotelPromotionDiscountType.AMOUNT = 'amount';
var HotelListExclude = (function () {
    function HotelListExclude() {
    }
    return HotelListExclude;
}());

//# sourceMappingURL=hotel.model.js.map

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_services_checkout_checkout_service__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_checkout_checkout3_config_model__ = __webpack_require__(156);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkout3Service; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var Checkout3Service = (function () {
    function Checkout3Service(userService, actHttp, authService, checkoutService) {
        this.userService = userService;
        this.actHttp = actHttp;
        this.authService = authService;
        this.checkoutService = checkoutService;
        this._costCenterFromDropDown = new Map();
        this.$updateCostCenterFromDropDown = new __WEBPACK_IMPORTED_MODULE_4_rxjs__["BehaviorSubject"](undefined);
    }
    Checkout3Service.prototype.allowCreditTerm = function (creditTerm, purpose) {
        return (creditTerm === true && purpose === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["o" /* PurposeType */].work) ? true : false;
    };
    Checkout3Service.prototype.fillterCostCenterFollowMainCompany = function (costCenterList, mainCompanyId) {
        var newCostCenterList = [];
        costCenterList.forEach(function (costCenter) { return costCenter.companyId === mainCompanyId ? newCostCenterList.push(costCenter) : null; });
        return newCostCenterList;
    };
    Checkout3Service.prototype.getCompanyTaxAddress = function () {
        var user = this.userService.getUser();
        var requestOption = this.authService.getRequestOptions(__WEBPACK_IMPORTED_MODULE_5__services_act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN);
        return this.actHttp.get(__WEBPACK_IMPORTED_MODULE_3_environments_environment__["a" /* environment */].endpoint.getTaxInvoice + '/' + user.companyId, requestOption)
            .map(function (response) { return response.json().data; });
    };
    Checkout3Service.prototype.getPayableMethod = function (checkout3Config, purpose, cartAndProfile, fleetCardListCorporate, fleetCardListPersonal, isShareBudget) {
        if (isShareBudget === void 0) { isShareBudget = false; }
        var isLimitBudget = cartAndProfile.cart.budgetAvailable !== null || cartAndProfile.cart.averageBudget !== null;
        var grandTotalPricePerNight = this.getTotalPricePerNight(cartAndProfile.cart);
        var grandTotalPrice = this.getGrandTotalPrice(cartAndProfile.cart);
        var totalCondition = this.getTotalCondition(cartAndProfile.cart);
        var isOverBudget = false;
        var usedBudgetFleet = false;
        var isAllowMultiPaymentCreditTerms = purpose === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["o" /* PurposeType */].work && checkout3Config.allowCreditTerms && checkout3Config.allowMultiPayment;
        var isAllowMultiPaymentCorporateFleet = purpose === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["o" /* PurposeType */].work && checkout3Config.allowMultiPaymentCorporateFleet && fleetCardListCorporate && fleetCardListCorporate.length > 0;
        var isAllowBookForTraveller = checkout3Config.allowBookForTraveller && checkout3Config.allowBookForTraveller.allow;
        var budgetAvailable = cartAndProfile.cart.budgetAvailable !== 0;
        var hasPersonalFleet = fleetCardListPersonal && fleetCardListPersonal.length > 0;
        var hasBudgetPerMonthPerYear = cartAndProfile.cart.budgetAvailable !== null;
        var budget = cartAndProfile.cart.budgetAvailable !== null ? cartAndProfile.cart.budgetAvailable : cartAndProfile.cart.averageBudget * totalCondition;
        var isOverBudgetInCondition = this.getIsOverBudgetInCondition(cartAndProfile.cart, cartAndProfile.cart.averageBudget);
        // unlimit budget
        if (budget === undefined) {
            budget = grandTotalPrice;
        }
        if (purpose === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["o" /* PurposeType */].work) {
            if (cartAndProfile.cart.shareBudgetCode) {
                isOverBudget = cartAndProfile.cart.budgetAvailable < grandTotalPrice;
            }
            else if (budget >= grandTotalPrice) {
                isOverBudget = false;
            }
            else if (isOverBudgetInCondition) {
                isOverBudget = true;
                // case overbudget and allow book for traveller then display credit terms for user knowing limit budget at dialog alert limit budget and hasn't budget /m/y
                if (isAllowBookForTraveller && !isAllowMultiPaymentCreditTerms && !isAllowMultiPaymentCorporateFleet && budgetAvailable && !hasBudgetPerMonthPerYear) {
                    isOverBudget = false;
                }
                if (hasPersonalFleet && !budgetAvailable) {
                    usedBudgetFleet = true;
                    isOverBudget = fleetCardListPersonal[0].balanceAmount < grandTotalPrice;
                }
            }
            else if (isLimitBudget && checkout3Config.allowLimitBudget.allow && budget < (hasBudgetPerMonthPerYear ? grandTotalPrice : grandTotalPricePerNight)) {
                if (fleetCardListCorporate && fleetCardListCorporate.length > 0 && cartAndProfile.cart.averageBudget) {
                    usedBudgetFleet = true;
                    budget = Math.min(fleetCardListCorporate[0].balanceAmount, cartAndProfile.cart.averageBudget);
                }
                isOverBudget = budget < (hasBudgetPerMonthPerYear ? grandTotalPrice : grandTotalPricePerNight);
                if (isOverBudget && hasPersonalFleet && !budgetAvailable) {
                    usedBudgetFleet = true;
                    isOverBudget = fleetCardListPersonal[0].balanceAmount < grandTotalPrice;
                }
            }
        }
        var isCreditTermsAble = false;
        var isMultiPaymentAble = false;
        isCreditTermsAble = purpose === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["o" /* PurposeType */].work
            && checkout3Config.allowCreditTerms
            && !isOverBudget
            && !usedBudgetFleet;
        if (isShareBudget) {
            isMultiPaymentAble = purpose === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["o" /* PurposeType */].work
                && checkout3Config.allowMultiPayment
                && checkout3Config.allowCreditTerms;
        }
        else {
            isMultiPaymentAble = isAllowMultiPaymentCreditTerms && budgetAvailable
                || isAllowMultiPaymentCorporateFleet
                || hasPersonalFleet;
        }
        var corporateFleet = false;
        corporateFleet = fleetCardListCorporate && fleetCardListCorporate.length > 0 && checkout3Config.allowCorporateFleet;
        var payableMethod = new __WEBPACK_IMPORTED_MODULE_8__model_checkout_checkout3_config_model__["a" /* PaymentChannelCheckout */]();
        payableMethod.MULTI_PAYMENT.hide = !isMultiPaymentAble;
        payableMethod.CREDIT_TERMS.hide = !isCreditTermsAble;
        payableMethod.CREDIT_CARD.hide = false;
        payableMethod.TRUE_MONEY_WALLET.hide = false;
        payableMethod.FLEET_CARD.hide = false;
        payableMethod.QR_CODE.hide = false;
        payableMethod.E_WALLET.hide = false;
        payableMethod.IM_BANKING.hide = false;
        payableMethod.PAY_AT_COUNTER.hide = false;
        if (isMultiPaymentAble && isOverBudget) {
            payableMethod.MULTI_PAYMENT.default = true;
        }
        else if (!isCreditTermsAble && corporateFleet) {
            payableMethod.FLEET_CARD.default = true;
        }
        else if (!isCreditTermsAble) {
            payableMethod.CREDIT_CARD.default = true;
        }
        else {
            payableMethod.CREDIT_TERMS.default = true;
        }
        var paymentable = payableMethod.getPaymentable();
        paymentable.paymentChannels = paymentable.paymentChannels.filter(function (item) { return !item.hide; });
        paymentable.mainBookerEmail = cartAndProfile.profile.email.valueOf();
        paymentable.isOverBudget = isOverBudget;
        return paymentable;
    };
    Checkout3Service.prototype.getLimitBudget = function () {
        var user = this.userService.getUser();
        return this.authService.getUserFeature(null, user, [__WEBPACK_IMPORTED_MODULE_2_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET])
            .map(function (res) { return res.find(function (item) { return item.feature === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET; }); });
    };
    Checkout3Service.prototype.getGrandTotalPrice = function (cart) {
        var grandTotalPrice = 0;
        cart.optionDetail.optionList.forEach(function (option) {
            option.conditionList.forEach(function (condition) {
                if (condition) {
                    grandTotalPrice += Math.ceil(condition.totalPriceSellingFinalSupplierCurrency.valueOf() * condition.quantity.valueOf());
                }
            });
        });
        var validateInfo = this.checkoutService.getCurrentPromotionCode().validateInfo;
        if (validateInfo && validateInfo.valid) {
            grandTotalPrice = validateInfo.finalAmount;
        }
        return grandTotalPrice;
    };
    Checkout3Service.prototype.getTotalPricePerNight = function (cart) {
        var grandTotalPrice = 0;
        cart.optionDetail.optionList.forEach(function (option) {
            option.conditionList.forEach(function (condition) {
                if (condition) {
                    grandTotalPrice += Math.ceil(condition.totalPriceSellingFinalSupplierCurrency.valueOf() / condition.night);
                }
            });
        });
        return grandTotalPrice;
    };
    Checkout3Service.prototype.getTotalCondition = function (cart) {
        var totalCondition = 0;
        cart.optionDetail.optionList.forEach(function (option) {
            option.conditionList.forEach(function () {
                totalCondition++;
            });
        });
        return totalCondition;
    };
    Checkout3Service.prototype.getIsOverBudgetInCondition = function (cart, budget) {
        var totalBudgetAvailable = 0;
        cart.optionDetail.optionList.map(function (option) {
            option.conditionList.map(function (con) {
                var pricePerNight = con.totalPriceSellingFinalSupplierCurrency.valueOf() / con.night;
                var maximumBudgetPerNight = Math.min(pricePerNight, budget);
                totalBudgetAvailable += maximumBudgetPerNight * con.quantity.valueOf() * con.night;
            });
        });
        return this.getGrandTotalPrice(cart) > totalBudgetAvailable;
    };
    Checkout3Service.prototype.getNight = function (cart) {
        return cart.optionDetail.optionList
            .map(function (option) { return option.conditionList[0] ? option.conditionList[0].night : undefined; })
            .find(function (night) { return !!night; });
    };
    Checkout3Service.prototype.getMaximumRoomPricePerNight = function (cart) {
        var roomPricePerNight = 0;
        var night = this.getNight(cart);
        cart.optionDetail.optionList.forEach(function (option) {
            option.conditionList.forEach(function (condition) {
                if (condition) {
                    var conditionPricePerNight = condition.totalPriceSellingFinalSupplierCurrency.valueOf() / night;
                    roomPricePerNight = roomPricePerNight > conditionPricePerNight ? roomPricePerNight : conditionPricePerNight;
                }
            });
        });
        return roomPricePerNight;
    };
    Checkout3Service.prototype.updateCostCenterFromDropDown = function (bookerEmail, val) {
        this._costCenterFromDropDown.set(bookerEmail, val);
        this.$updateCostCenterFromDropDown.next(this._costCenterFromDropDown);
    };
    Checkout3Service.prototype.getCostCenterFromDropDown = function (bookerEmail) {
        return this.$updateCostCenterFromDropDown.asObservable()
            .filter(function (res) { return !!res; })
            .map(function (res) { return res.get(bookerEmail); });
    };
    Checkout3Service.prototype.uploadBookingDocument = function (file) {
        var url = __WEBPACK_IMPORTED_MODULE_3_environments_environment__["a" /* environment */].endpoint.uploadBookingDocument;
        var formData = new FormData();
        formData.append('file', file);
        return this.actHttp.post(url, formData, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_5__services_act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, null))
            .map(function (res) { return res.json(); });
    };
    Checkout3Service.prototype.calculateBudgetAvailable = function (cartProfile, isFleetCard) {
        var isAvailableBudget = true;
        if (cartProfile.cart.budgetAvailable === null) {
            isAvailableBudget = false;
        }
        var budget = isAvailableBudget && !isFleetCard ? cartProfile.cart.budgetAvailable : cartProfile.cart.averageBudget;
        if (isAvailableBudget && !isFleetCard) {
            return cartProfile.cart.budgetAvailable;
        }
        else {
            return cartProfile.cart.optionDetail.optionList
                .map(function (option) { return option.conditionList
                .map(function (con) {
                if (budget) {
                    var perNight = con.totalPriceSellingFinalSupplierCurrency.valueOf() / con.night;
                    return Math.min(perNight, budget) * con.quantity.valueOf() * con.night;
                }
                else {
                    return con.totalPriceSellingFinalSupplierCurrency.valueOf() * con.quantity.valueOf();
                }
            }).reduce(function (next, prev) { return next + prev; }); })
                .reduce(function (next, prev) { return next + prev; });
        }
    };
    Checkout3Service.prototype.travellerBudgetMultipayment = function (request) {
        return this.actHttp.post(__WEBPACK_IMPORTED_MODULE_3_environments_environment__["a" /* environment */].endpoint.travellerBudgetMultipayment, request, this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_5__services_act_http_act_http_service__["a" /* HeaderTypes */].ACT_TOKEN, null))
            .map(function (res) { return res.json().data; });
    };
    return Checkout3Service;
}());
Checkout3Service = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_7__services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7__services_user_user_service__["a" /* UserService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_5__services_act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__services_act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_6__services_authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6__services_authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0_app_services_checkout_checkout_service__["a" /* CheckoutService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0_app_services_checkout_checkout_service__["a" /* CheckoutService */]) === "function" && _d || Object])
], Checkout3Service);

var _a, _b, _c, _d;
//# sourceMappingURL=checkout3.service.js.map

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RoundPipe; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var RoundPipe = (function () {
    function RoundPipe() {
    }
    /**
     *
     * @param value
     * @returns {number}
     */
    RoundPipe.prototype.transform = function (value) {
        return Math.ceil(value);
    };
    return RoundPipe;
}());
RoundPipe = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({ name: 'round' })
], RoundPipe);

//# sourceMappingURL=round.pipe.js.map

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartOptionModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TermsCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TermsConditionsType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TermsConditionsTemplate; });
var CartOptionModel = (function () {
    function CartOptionModel(page) {
        if (page === void 0) { page = 'cart'; }
        this.page = page;
        this.isLoading = false;
        this.enableSticky = false;
        this.displayHotel = false;
        this.displayConfirmBookingBtn = false;
    }
    return CartOptionModel;
}());

var TermsCondition = (function () {
    function TermsCondition() {
    }
    return TermsCondition;
}());

var TermsConditionsType = {
    SUPPLIER: 'supplier',
    AGENT: 'agent'
};
var TermsConditionsTemplate = {
    SUPPLIER: 'supplier',
    SUPPLIER_AGENT: 'supplier_agent'
};
//# sourceMappingURL=cart-option.model.js.map

/***/ }),
/* 522 */,
/* 523 */,
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_modal_dialog_confirm_dialog_confirm_component__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_general_message_dialog_general_message_component__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_Rx__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__address_form_address_form_component__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_dialog_tax_address_dialog_tax_address_component__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_dialog_tax_address_dialog_tax_address_model__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modal_dialog_confirm_dialog_confirm_model__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_dialog_success_dialog_success_component__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_dialog_error_dialog_error_component__ = __webpack_require__(100);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddressListComponent; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};














var AddressListComponent = (function () {
    function AddressListComponent(dialog, appConfigService, userService, translatePipe) {
        this.dialog = dialog;
        this.appConfigService = appConfigService;
        this.userService = userService;
        this.translatePipe = translatePipe;
        this.options = { page: 'profile', selectable: false, editable: true, editPopup: false };
        this.isCallbackEditFromParent = false;
        this.onFetchData = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onSelected = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onUpdated = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onShowEditAddressList = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onCloseEditAddressList = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onCallEditFromParent = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.limitAddress = 5;
        this.isLoading = false; // tslint:disable-line
        this.selectedAddress = { taxAddressId: -1 };
        this.selectedEditAddress = { taxAddressId: -1 };
        this.formAddress = {};
        this.oneTimeAddress = false;
        this.STATE = {
            VIEW: 'VIEW',
            EDIT: 'EDIT',
            ADD: 'ADD'
        };
        this.STATUS = {
            INITIAL: 'INITIAL',
            PENDING: 'PENDING',
            RESPONSE: 'RESPONSE',
        };
        this.dataStatus = {
            isInitial: false,
            isPending: false,
            isResponse: false,
        };
    }
    AddressListComponent.prototype.ngOnInit = function () {
    };
    AddressListComponent.prototype.ngOnChanges = function () {
        if (typeof this.addressData !== 'undefined' && this.addressData !== null) {
            this.addressData = this.addressData.map(function (address, idx) {
                return __assign({}, address, { state: 'view', idx: idx });
            });
            // Set default address
            // this.setSelectedAddress();
            this.setDataStatus(this.STATUS.RESPONSE);
        }
    };
    AddressListComponent.prototype.getDefaultSelectedAddress = function () {
        var defaultAddress = this.addressData.filter(function (address) { return address.isDefault; })[0];
        var address = defaultAddress ? defaultAddress : this.addressData ? this.addressData[0] : {};
        return __assign({}, address);
    };
    AddressListComponent.prototype.setSelectedAddress = function (address) {
        if (address === void 0) { address = undefined; }
        this.selectedAddress = address || (this.isCreditCardBilling() ? this.getDefaultSelectedAddress() : { taxAddressId: -1 });
        this.onSelected.emit(this.selectedAddress);
    };
    AddressListComponent.prototype.onAddressSelected = function (address) {
        this.setSelectedAddress(address);
    };
    AddressListComponent.prototype.setDataStatus = function (status) {
        var _a = this.STATUS, INITIAL = _a.INITIAL, PENDING = _a.PENDING, RESPONSE = _a.RESPONSE;
        switch (status) {
            case INITIAL:
                this.addressDataStatus = __assign({}, this.dataStatus, { isInitial: true });
                break;
            case PENDING:
                this.addressDataStatus = __assign({}, this.dataStatus, { isPending: true });
                break;
            case RESPONSE:
                this.addressDataStatus = __assign({}, this.dataStatus, { isResponse: true });
                break;
            default:
                break;
        }
    };
    AddressListComponent.prototype.isEdit = function (address) {
        return (address.taxAddressId === this.selectedEditAddress.taxAddressId
            && this.selectedEditAddress.state === 'edit');
    };
    AddressListComponent.prototype.isFormDirty = function () {
        return Object.keys(this.formAddress).length;
    };
    AddressListComponent.prototype.isCreditCardBilling = function () {
        return this.addressData && this.addressData.length > 0 && this.addressData[0].taxAddressId !== null;
    };
    AddressListComponent.prototype.isSelectedAddress = function (address, i) {
        var isCreditCardBilling = this.isCreditCardBilling();
        var actualAddressId = isCreditCardBilling ? this.selectedAddress.taxAddressId : this.selectedAddress.companyBillingId;
        var expectedAddressId = isCreditCardBilling ? address.taxAddressId : address.companyBillingId;
        var matchAddress = actualAddressId === expectedAddressId;
        return (matchAddress && this.currentState !== this.STATE.ADD && this.currentState !== this.STATE.EDIT);
    };
    AddressListComponent.prototype.isChecked = function (address, i) {
        return this.isCreditCardBilling() ? (this.isSelectedAddress(address) ||
            (this.currentState === this.STATE.VIEW && this.selectedAddress.taxAddressId === -1 && this.getDefaultSelectedAddress().idx === i)) : this.isSelectedAddress(address);
    };
    AddressListComponent.prototype.canAddAddress = function () {
        return !!this.addressData && this.addressData.length < this.limitAddress;
    };
    AddressListComponent.prototype.clearFormDirty = function () {
        this.formAddress = {};
    };
    AddressListComponent.prototype.clearSelectedAddress = function () {
        this.selectedAddress = { taxAddressId: -1 };
    };
    AddressListComponent.prototype.clearSelectedEditAddress = function () {
        this.selectedEditAddress = {};
    };
    AddressListComponent.prototype.translate = function (value) {
        return this.translatePipe.transform(value);
    };
    AddressListComponent.prototype.createMessage = function (_a) {
        var type = _a.type;
        var content = {
            message: {
                icon: 'icon-service-failed',
                title: this.translate('my-profile-edit-failure-title'),
                message: this.translate('my-profile-edit-failure-description'),
                mainBtn: this.translate('btn-ok')
            },
            remove: {
                confirmType: __WEBPACK_IMPORTED_MODULE_11__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_DELETE_ADDRESS,
                data: {
                    confirmAction: this.handleDeleteAddressDialog.bind(this)
                }
            }
        };
        return content[type];
    };
    AddressListComponent.prototype.updateAddresses = function (address) {
        this.addressData = this.addressData.map(function (record) {
            if (record.taxAddressId === address.taxAddressId) {
                return __assign({}, record, address);
            }
            return record;
        });
    };
    AddressListComponent.prototype.handleDeleteAddress = function (address) {
        this.selectedDeleteAddress = __assign({}, address);
        this.showDialog({ type: 'remove' });
    };
    AddressListComponent.prototype.handleSelectAddress = function (address) {
        if (this.isFormDirty()) {
            // not have event
        }
        else {
            this.currentState = this.STATE.VIEW;
            this.selectedAddress = __assign({}, address, { state: 'view' });
            this.selectedEditAddress = __assign({}, address, { state: 'view' });
        }
    };
    AddressListComponent.prototype.handleAddAddress = function () {
        var _this = this;
        if (this.options.editPopup) {
            this.dialog.open(__WEBPACK_IMPORTED_MODULE_9__modal_dialog_tax_address_dialog_tax_address_component__["a" /* DialogTaxAddressComponent */])
                .afterClosed()
                .subscribe(this.handleAddressEditPopup.bind(this));
        }
        else {
            if (this.isCallbackEditFromParent) {
                this.onCallEditFromParent.emit({
                    callback: function () {
                        if (_this.canAddAddress()) {
                            _this.currentState = _this.STATE.ADD;
                            _this.clearSelectedAddress();
                            _this.clearSelectedEditAddress();
                            _this.onShowEditAddressList.emit();
                        }
                    }
                });
            }
            else {
                if (this.canAddAddress()) {
                    this.currentState = this.STATE.ADD;
                    this.clearSelectedAddress();
                    this.clearSelectedEditAddress();
                    this.onShowEditAddressList.emit();
                }
            }
        }
    };
    AddressListComponent.prototype.setViewModeOnFormValid = function () {
        if (this.addressFormComponent && this.addressFormComponent.form.valid && !!this.selectedAddress && this.addressData.length > 0) {
            var address = this.addressFormComponent.addressInfo;
            this.handleUpdateAddressInfo(address);
        }
    };
    AddressListComponent.prototype.exitEditMode = function () {
        this.currentState = this.STATE.VIEW;
    };
    AddressListComponent.prototype.showDialog = function (_a) {
        var _this = this;
        var type = _a.type;
        var config = {
            hasBackdrop: true,
            disableClose: false,
            focusOnOpen: false,
            data: this.createMessage({ type: type })
        };
        var dialog = {
            remove: __WEBPACK_IMPORTED_MODULE_2_app_components_modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */],
            message: __WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_general_message_dialog_general_message_component__["a" /* DialogGeneralMessageComponent */]
        };
        var dialogRef = this.dialog.open(dialog[type], config);
        dialogRef.afterClosed().subscribe(function (res) {
            if (res) {
                _this.onFetchData.emit();
            }
        });
    };
    AddressListComponent.prototype.handleEditAddress = function (address) {
        var _this = this;
        if (this.isCallbackEditFromParent) {
            this.onCallEditFromParent.emit({
                callback: function () {
                    _this.selectedEditAddress = __assign({}, address, { state: 'edit' });
                    _this.clearFormDirty();
                    _this.currentState = _this.STATE.EDIT;
                    _this.onShowEditAddressList.emit();
                }
            });
        }
        else {
            if (this.options.editPopup) {
                this.dialog.open(__WEBPACK_IMPORTED_MODULE_9__modal_dialog_tax_address_dialog_tax_address_component__["a" /* DialogTaxAddressComponent */], { data: address })
                    .afterClosed()
                    .subscribe(this.handleAddressEditPopup.bind(this));
            }
            else {
                if (this.isFormDirty()) {
                    var config = { data: { confirmType: __WEBPACK_IMPORTED_MODULE_11__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CLOSE } };
                    var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2_app_components_modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */], config);
                    dialogRef.afterClosed().subscribe(function (res) {
                        if (res) {
                            _this.selectedEditAddress = __assign({}, address, { state: 'edit' });
                            _this.clearFormDirty();
                            _this.currentState = _this.STATE.EDIT;
                            _this.onShowEditAddressList.emit();
                        }
                    });
                }
                else {
                    this.selectedEditAddress = __assign({}, address, { state: 'edit' });
                    this.clearFormDirty();
                    this.currentState = this.STATE.EDIT;
                    this.onShowEditAddressList.emit();
                }
                if (this.selectedAddress.taxAddressId === -1) {
                    this.setSelectedAddress();
                }
            }
        }
    };
    // Collect form dirty
    AddressListComponent.prototype.handleEditAddressInfo = function (data) {
        this.formAddress = data;
    };
    AddressListComponent.prototype.handleCancelAddAddressInfo = function () {
        this.currentState = this.STATE.VIEW;
        this.clearFormDirty();
        this.setSelectedAddress();
        this.onCloseEditAddressList.emit();
    };
    AddressListComponent.prototype.handleAddAddressInfo = function (address) {
        this.currentState = this.STATE.VIEW;
        this.addressData = this.addressData.concat(address);
        this.clearFormDirty();
        this.clearSelectedAddress();
        this.onFetchData.emit();
    };
    AddressListComponent.prototype.handleUpdateAddressInfo = function (address) {
        this.currentState = this.STATE.VIEW;
        this.selectedEditAddress = __assign({}, address, { state: 'view' });
        this.updateAddresses(address);
        this.clearFormDirty();
        this.onCloseEditAddressList.emit();
        this.onUpdated.emit(this.addressData);
    };
    AddressListComponent.prototype.handleClickSubmit = function () {
        if (this.addressFormComponent.onSubmit(this.addressFormComponent.form)) {
            this.setSelectedAddress();
        }
    };
    AddressListComponent.prototype.setSubmitting$ = function () {
        var _this = this;
        if (!this.addressFormComponent) {
            return __WEBPACK_IMPORTED_MODULE_7_rxjs_Rx__["Observable"].of(false);
        }
        return this.addressFormComponent.onSubmit$(this.addressFormComponent.form)
            .do(function (isValidAddress) {
            !!isValidAddress && _this.setSelectedAddress();
        });
    };
    AddressListComponent.prototype.isDefaultAddressChanged = function () {
        var defaultAddress = this.getDefaultSelectedAddress();
        var defaultId = defaultAddress.taxAddressId ? defaultAddress.taxAddressId : defaultAddress.companyBillingId;
        var expectedId = this.selectedAddress.taxAddressId ? this.selectedAddress.taxAddressId : this.selectedAddress.companyBillingId;
        return defaultId !== expectedId;
    };
    AddressListComponent.prototype.saveDefaultAddress$ = function () {
        return this.userService.editTaxAddress(__assign({}, this.selectedAddress, { isDefault: true, active: true }));
    };
    AddressListComponent.prototype.setOneTimeAddress = function (enable, getTaxAddressByAPI) {
        if (getTaxAddressByAPI === void 0) { getTaxAddressByAPI = false; }
        this.oneTimeAddress = enable && !getTaxAddressByAPI;
        this.currentState = this.oneTimeAddress ? this.STATE.ADD : this.STATE.VIEW;
    };
    AddressListComponent.prototype.getSelectedAddress = function () {
        return this.selectedAddress;
    };
    AddressListComponent.prototype.handleAddressEditPopup = function (res) {
        if (res) {
            switch (res.action) {
                case __WEBPACK_IMPORTED_MODULE_10__modal_dialog_tax_address_dialog_tax_address_model__["a" /* DialogTaxAddressActionType */].UPDATE_ADDRESS:
                    this.handleAddAddressInfo(res.data);
                    break;
            }
        }
    };
    AddressListComponent.prototype.handleDeleteAddressDialog = function () {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_7_rxjs_Rx__["Observable"](function (subscriber) {
            var payload = _this.selectedDeleteAddress;
            payload.active = false;
            var _a = _this.userService.getUser(), langId = _a.Langid, email = _a.username;
            _this.userService.editTaxAddress(__assign({}, payload, { langId: langId, email: email }))
                .subscribe(function (res) {
                subscriber.next(true);
                subscriber.complete();
                var dialogRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_12__modal_dialog_success_dialog_success_component__["a" /* DialogSuccessComponent */]);
                dialogRef.componentInstance.text = _this.appConfigService.getTranslate('my-profile-delete-address-success');
            }, function (error) {
                subscriber.next(true);
                subscriber.complete();
                var dialogRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_13__modal_dialog_error_dialog_error_component__["a" /* DialogErrorComponent */]);
                dialogRef.componentInstance.text = _this.appConfigService.getTranslate('my-profile-delete-address-failure');
                dialogRef.componentInstance.subText = _this.appConfigService.getTranslate('my-profile-delete-address-failure-text');
            });
        });
    };
    return AddressListComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], AddressListComponent.prototype, "addressData", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], AddressListComponent.prototype, "options", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], AddressListComponent.prototype, "isCallbackEditFromParent", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", Object)
], AddressListComponent.prototype, "onFetchData", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", Object)
], AddressListComponent.prototype, "onSelected", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", Object)
], AddressListComponent.prototype, "onUpdated", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", Object)
], AddressListComponent.prototype, "onShowEditAddressList", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", Object)
], AddressListComponent.prototype, "onCloseEditAddressList", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", Object)
], AddressListComponent.prototype, "onCallEditFromParent", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_8__address_form_address_form_component__["a" /* AddressFormComponent */]),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_8__address_form_address_form_component__["a" /* AddressFormComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8__address_form_address_form_component__["a" /* AddressFormComponent */]) === "function" && _a || Object)
], AddressListComponent.prototype, "addressFormComponent", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('addressFormList'),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_8__address_form_address_form_component__["a" /* AddressFormComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8__address_form_address_form_component__["a" /* AddressFormComponent */]) === "function" && _b || Object)
], AddressListComponent.prototype, "addressFormList", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('addressFormAdd'),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_8__address_form_address_form_component__["a" /* AddressFormComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8__address_form_address_form_component__["a" /* AddressFormComponent */]) === "function" && _c || Object)
], AddressListComponent.prototype, "addressFormAdd", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('addressFormOneTime'),
    __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_8__address_form_address_form_component__["a" /* AddressFormComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8__address_form_address_form_component__["a" /* AddressFormComponent */]) === "function" && _d || Object)
], AddressListComponent.prototype, "addressFormOneTime", void 0);
AddressListComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-address-list',
        template: __webpack_require__(1007),
        styles: [__webpack_require__(872)]
    }),
    __metadata("design:paramtypes", [typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__["a" /* UserService */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_4_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _h || Object])
], AddressListComponent);

var _a, _b, _c, _d, _e, _f, _g, _h;
//# sourceMappingURL=address-list.component.js.map

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_authorize_authorize_service__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_products_product_service__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_images_image_sizing_model__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_cart_cart_service__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_dialog_confirm_dialog_confirm_component__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modal_dialog_confirm_dialog_confirm_model__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__cart_option_model__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__dialog_cart_summary_dialog_cart_summary_component__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_services_currency_currency_service__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_services_checkout_checkout_service__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__dialog_taxes_fees_dialog_taxes_fees_component__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__dialog_use_promotion_code_dialog_use_promotion_code_component__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_environments_properties__ = __webpack_require__(21);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};























var CartComponent = (function () {
    function CartComponent(cartService, appConfigService, utilitiesService, titlecasePipe, decimalPipe, translatePipe, dialog, productService, userService, authorizeService, changeDetectorRef, currencyService, checkoutService, route) {
        this.cartService = cartService;
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.titlecasePipe = titlecasePipe;
        this.decimalPipe = decimalPipe;
        this.translatePipe = translatePipe;
        this.dialog = dialog;
        this.productService = productService;
        this.userService = userService;
        this.authorizeService = authorizeService;
        this.changeDetectorRef = changeDetectorRef;
        this.currencyService = currencyService;
        this.checkoutService = checkoutService;
        this.route = route;
        this.option$ = new __WEBPACK_IMPORTED_MODULE_7_rxjs_BehaviorSubject__["BehaviorSubject"](new __WEBPACK_IMPORTED_MODULE_15__cart_option_model__["a" /* CartOptionModel */]());
        this.onCartButtonClick = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.onClickMore = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.onSelectPromotionCode = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.isCartButtonClicked = false;
        this.langId = this.appConfigService.getLanguageId();
        this.lang = this.appConfigService.getLanguage();
        this.langType = __WEBPACK_IMPORTED_MODULE_8__model_constant__["a" /* Language */];
        this.bookNight = 1;
        this.grandTotalPrice = 0;
        this.totalRoomSelected = 0;
        this.formatSearchDate = this.appConfigService.dateHumanFormat; // tslint:disable-line
        this.dataSelenium = {};
        this.totalAdult = 0;
        this.totalChild = 0;
        this.dialogSummaryOpening = false;
        this.isMobileShowFullCart = false;
        this.allowMultiPayment = false;
        this.isAllowMultiCorporateFleetOnly = false;
        this.messageError = {
            payOwn: false,
            multiPayment: false
        };
        this.totalTaxesAndFees = 0;
        this.termsConditions = new __WEBPACK_IMPORTED_MODULE_15__cart_option_model__["b" /* TermsCondition */]();
        this.TermsConditionTemplate = __WEBPACK_IMPORTED_MODULE_15__cart_option_model__["c" /* TermsConditionsTemplate */];
        this.displaySurcharges = false;
        this.displayCurrencyNote = false;
        this.isLockedPromoCode = false;
        this.defaultCurrency = __WEBPACK_IMPORTED_MODULE_8__model_constant__["p" /* DefaultValue */].CURRENCY;
        this.mobileMode = false;
    }
    Object.defineProperty(CartComponent.prototype, "options", {
        get: function () { return this.option$.getValue(); },
        set: function (value) { this.option$.next(value); },
        enumerable: true,
        configurable: true
    });
    CartComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscribeCurrency();
        this.hotelImage = __WEBPACK_IMPORTED_MODULE_9__model_images_image_sizing_model__["a" /* ImageSizingModel */].defaultImage().thumbnail['1x'];
        this.allowMultiPayment = this.productService.allowMultiPayment(this.userService.getUser());
        var notAllowMultiPaymentCreditTerms;
        var allowMultiPaymentCorporateFleet;
        this.userService.getUser().features
            .map(function (f) {
            if (f.feature === __WEBPACK_IMPORTED_MODULE_8__model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS && !f.allow || f.feature === __WEBPACK_IMPORTED_MODULE_8__model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT && !f.allow) {
                notAllowMultiPaymentCreditTerms = true;
            }
            if (f.feature === __WEBPACK_IMPORTED_MODULE_8__model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT_CORPORATE_FLEET && f.allow) {
                allowMultiPaymentCorporateFleet = true;
            }
        });
        this.isAllowMultiCorporateFleetOnly = notAllowMultiPaymentCreditTerms && allowMultiPaymentCorporateFleet;
        this.cartSubscription = this.cartService.getTempCart$()
            .subscribe(function (items) {
            _this.onCartItemChanged(items);
        });
        this.subscriptionTotalMultipaymentDetail = this.cartService.getCartMultiPaymentDetail()
            .subscribe(function (detail) {
            _this.multiPaymentDetail = detail;
        });
        this.messageSubscription = this.cartService.getCartMessage()
            .subscribe(function (msg) {
            _this.message = msg;
            if (_this.message && _this.message.code === '2004') {
                _this.messageError.payOwn = true;
            }
            if (_this.message && _this.message.code === '2005') {
                _this.messageError.multiPayment = true;
            }
        });
        this.appConfigService.getLanguageObs()
            .subscribe(function (lang) {
            _this.lang = lang;
            _this.setSpecialTermsAndConditions();
        });
        this.checkoutService.currentValidatedPromoCode.subscribe(function (validatedPromoCode) {
            _this.updatePromotionCode();
        });
        this.checkoutService.currentIsLockedPromoCode.subscribe(function (isLocked) {
            _this.isLockedPromoCode = isLocked;
        });
    };
    CartComponent.prototype.ngAfterViewInit = function () {
        this.changeDetectorRef.detectChanges();
    };
    CartComponent.prototype.ngAfterViewChecked = function () {
        this.mobileMode = this.utilitiesService.isMobile();
    };
    CartComponent.prototype.ngOnDestroy = function () {
        this.cartSubscription && this.cartSubscription.unsubscribe();
        this.subscriptionDialog && this.subscriptionDialog.unsubscribe();
        this.currencySubscription && this.currencySubscription.unsubscribe();
        this.dialogRef && this.dialogRef.close();
    };
    CartComponent.prototype.getTotalRoom = function () {
        return this.totalRoomSelected;
    };
    CartComponent.prototype.getGrandTotal = function () {
        return this.grandTotalPrice;
    };
    CartComponent.prototype.setCurrencyFormat = function (amount) {
        return this.utilitiesService.insertCurrencySymbol(amount);
    };
    CartComponent.prototype.setRoomTitleize = function (conditions) {
        var _this = this;
        conditions.map(function (condition) {
            condition.displayTitle = _this.utilitiesService.titleize(condition.title);
            return condition;
        });
    };
    CartComponent.prototype.onCartItemChanged = function (cart) {
        var _this = this;
        this.cart = cart;
        this.bookNight = this.cartService.calculateBookNight(this.cart.search.checkInDate, this.cart.search.checkOutDate);
        if (this.cart.conditions.length > 0) {
            if (this.cart.optionDetail !== undefined) {
                var conditionIndex_1 = 0;
                this.cart.optionDetail.optionList.forEach(function (option) {
                    option.conditionList.forEach(function (condition) {
                        if (condition.titles.th != null && condition.titles.en != null) {
                            option.title = _this.lang === _this.lang ?
                                option.title + " (" + condition.titles.th + ")" :
                                option.title + " (" + condition.titles.en + ")";
                            _this.cart.conditions[conditionIndex_1].displayTitle = _this.utilitiesService.titleize(option.title);
                        }
                        else {
                            option.title = option.title;
                            _this.cart.conditions[conditionIndex_1].displayTitle = _this.utilitiesService.titleize(option.title);
                        }
                        conditionIndex_1++;
                    });
                });
            }
            else {
                this.setRoomTitleize(this.cart.conditions);
            }
            this.cartService.calculateTotalPrice(this.cart.conditions, this.bookNight);
            this.totalRoomSelected = this.cartService.calculateTotalRoomSelected(this.cart.conditions);
            this.grandTotalPrice = this.cartService.calculateGrandTotalPrice(this.cart.conditions, this.validatedPromoCode);
            this.totalAdult = this.cartService.calculateTotalAdult(this.cart.conditions);
            this.totalChild = this.cartService.calculateTotalChild(this.cart.conditions);
        }
        if (cart.productDetail && cart.productDetail.image) {
            this.hotelImage = cart.productDetail.image['1x'];
        }
        this.dataSelenium.checkInDate = this.utilitiesService.reverseFormatDate(this.cart.search.checkInDate);
        this.dataSelenium.checkOutDate = this.utilitiesService.reverseFormatDate(this.cart.search.checkOutDate);
        this.cart.conditions.map(function (condition) {
            condition.surcharges && (condition.displayIncludeSurcharge = _this.surcharge(condition.surcharges, 'include'));
            condition.surcharges && (condition.displayExcludeSurcharge = _this.surcharge(condition.surcharges, 'exclude'));
            _this.displaySurcharges = condition.surcharges && condition.surcharges.length > 0;
            return condition;
        });
        this.messageError.payOwn = false;
        this.messageError.multiPayment = false;
        this.updateOccupancyInfo();
    };
    CartComponent.prototype.updateOccupancyInfo = function () {
        var adult = 0;
        var child = 0;
        var childAges = [];
        this.cart.optionDetail.roomOccupancy.forEach(function (roomOccupancy) {
            adult += roomOccupancy.adult.valueOf();
            child += roomOccupancy.child.valueOf();
            childAges.push.apply(childAges, roomOccupancy.childAge);
        });
        this.occupancyInfo = this.checkoutService.transformOccupancyInfo(adult, child, childAges);
        this.setSpecialTermsAndConditions();
        this.calculateTotalPriceExcludeAndTaxesAndFees();
        this.displayCurrencyNote = this.currency.currencyCode !== this.defaultCurrency.currencyCode;
    };
    CartComponent.prototype.onCartButtonClicked = function () {
        this.isCartButtonClicked = true;
        this.onCartButtonClick.emit(this.cart);
    };
    CartComponent.prototype.surcharge = function (surcharges, type) {
        var result = '';
        var count = 0;
        for (var _i = 0, surcharges_1 = surcharges; _i < surcharges_1.length; _i++) {
            var surcharge = surcharges_1[_i];
            if (surcharge.charge == type) {
                if (count > 0) {
                    result = result.concat(', ');
                }
                var defaultSurchargePriceString = this.decimalPipe.transform(surcharge.price, '1.2-2');
                result = result.concat(surcharge.name.toString() + " " + __WEBPACK_IMPORTED_MODULE_8__model_constant__["p" /* DefaultValue */].CURRENCY.currencyCode + " " + defaultSurchargePriceString);
                if (this.currency.currencyCode !== __WEBPACK_IMPORTED_MODULE_8__model_constant__["p" /* DefaultValue */].CURRENCY.currencyCode) {
                    var surchargePrice = this.currencyService.transformCurrentCurrencyFromTHB(surcharge.price, false);
                    var surchargePriceString = this.decimalPipe.transform(surchargePrice, '1.2-2');
                    result = result.concat(" (\u2248 " + this.currency.currencyCode + " " + surchargePriceString + ")");
                }
                count++;
            }
        }
        result && (result = this.translatePipe.transform(type == 'include' ? 'cart-surcharge-include' : 'cart-surcharge-exclude').replace('{text}', result));
        return result;
    };
    CartComponent.prototype.openDialog = function () {
        var _this = this;
        if (this.cart && this.cart.conditions && this.cart.conditions.length > 0 && !this.dialogSummaryOpening) {
            this.dialogSummaryOpening = true;
            this.onClickMore.emit();
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_16__dialog_cart_summary_dialog_cart_summary_component__["a" /* DialogCartSummaryComponent */], {
                position: {
                    top: '0px',
                    bottom: '0px'
                },
                hasBackdrop: false
            });
            this.dialogRef.componentInstance.data = {
                formatSearchDate: this.formatSearchDate,
                cart: this.cart,
                bookNight: this.bookNight,
                multiPaymentDetail: this.multiPaymentDetail,
                grandTotalPrice: this.grandTotalPrice,
                message: this.message,
                multiPaymentMainChannel: this.multiPaymentMainChannel,
                isAllowMultiCorporateFleetOnly: this.isAllowMultiCorporateFleetOnly
            };
            this.subscriptionDialog && this.subscriptionDialog.unsubscribe();
            this.subscriptionDialog = this.dialogRef.afterClosed().subscribe(function () { return _this.dialogSummaryOpening = false; });
        }
        else {
            this.dialogRef && this.dialogRef.close();
        }
    };
    CartComponent.prototype.closeDialogSummaryIfExist = function () {
        this.dialogSummaryOpening = false;
        this.dialogRef && this.dialogRef.close();
    };
    CartComponent.prototype.onCancelShareBudget = function () {
        var _this = this;
        var message = { text: this.translatePipe.transform('dialog-cancel-share-budget-text'), subText: this.translatePipe.transform('dialog-cancel-share-budget-sub-text') };
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_13__modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */], {
            data: {
                confirmType: __WEBPACK_IMPORTED_MODULE_14__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CANCEL_SHARE_BUDGET_FROM_USER,
                data: {
                    message: message
                }
            },
        });
        dialogRef.afterClosed().subscribe(function (res) {
            if (res) {
                _this.authorizeService.removeCoBookerCookie();
                _this.cartService.updateCartCancelShareBudget();
            }
        });
    };
    CartComponent.prototype.subscribeCurrency = function () {
        var _this = this;
        this.currency = this.currencyService.getCurrency();
        this.currencySubscription = this.currencyService.getCurrencyObs().subscribe(function (currency) {
            _this.currency = currency;
            _this.onCartItemChanged(_this.cart);
        });
    };
    CartComponent.prototype.setSpecialTermsAndConditions = function () {
        var specialTermsAndConditions = this.cart.specialTermsAndConditions;
        if (specialTermsAndConditions) {
            var types = specialTermsAndConditions.map(function (item) { return item.type; });
            if (types.includes(__WEBPACK_IMPORTED_MODULE_15__cart_option_model__["d" /* TermsConditionsType */].SUPPLIER)) {
                this.termsConditions.template = __WEBPACK_IMPORTED_MODULE_15__cart_option_model__["c" /* TermsConditionsTemplate */].SUPPLIER;
                var supplier = specialTermsAndConditions.find(function (item) { return item.type === __WEBPACK_IMPORTED_MODULE_15__cart_option_model__["d" /* TermsConditionsType */].SUPPLIER; });
                this.termsConditions.linkSupplier = this.lang === this.langType.en ? supplier.linkEn : supplier.linkTh;
                if (types.includes(__WEBPACK_IMPORTED_MODULE_15__cart_option_model__["d" /* TermsConditionsType */].AGENT)) {
                    this.termsConditions.template = __WEBPACK_IMPORTED_MODULE_15__cart_option_model__["c" /* TermsConditionsTemplate */].SUPPLIER_AGENT;
                    var agent = specialTermsAndConditions.find(function (item) { return item.type === __WEBPACK_IMPORTED_MODULE_15__cart_option_model__["d" /* TermsConditionsType */].AGENT; });
                    this.termsConditions.linkAgent = this.lang === this.langType.en ? agent.linkEn : agent.linkTh;
                }
            }
        }
    };
    CartComponent.prototype.calculateTotalPriceExcludeAndTaxesAndFees = function () {
        var _this = this;
        this.totalTaxesAndFees = 0;
        this.cart.conditions.forEach(function (each) {
            var totalPrice = Number(each.totalPrice) * Number(each.quantity);
            var totalPriceExclude = totalPrice;
            if (each.taxesAndFees) {
                var taxesAndFees = each.taxesAndFees * Number(each.quantity);
                totalPriceExclude = totalPrice - taxesAndFees;
                _this.totalTaxesAndFees += taxesAndFees;
            }
            each.totalPriceExclude = parseFloat(totalPriceExclude.toFixed(2));
            _this.totalTaxesAndFees = parseFloat(_this.totalTaxesAndFees.toFixed(2));
        });
    };
    CartComponent.prototype.openDialogTaxesAndFees = function () {
        if (this.mobileMode) {
            var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_19__dialog_taxes_fees_dialog_taxes_fees_component__["a" /* DialogTaxesFeesComponent */]);
        }
    };
    CartComponent.prototype.openDialogUsePromotionCode = function () {
        var _this = this;
        if (!this.isLockedPromoCode) {
            var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_20__dialog_use_promotion_code_dialog_use_promotion_code_component__["a" /* DialogUsePromotionCodeComponent */]);
            dialogRef.afterClosed().subscribe(function (response) {
                if (response.type != 'close') {
                    if (response.type == 'submit') {
                        _this.onSelectPromotionCode.emit(response.data);
                    }
                    else if (response.type == 'error') {
                        if (response.data === '4723') {
                            var hotelParam = _this.route.snapshot.queryParamMap.get('hotel');
                            if (hotelParam) {
                                var decoded = decodeURIComponent(hotelParam);
                                window.location.href = "" + __WEBPACK_IMPORTED_MODULE_22_environments_properties__["k" /* redirectURIV2 */] + decoded;
                            }
                        }
                    }
                }
            });
        }
    };
    CartComponent.prototype.updatePromotionCode = function () {
        var _a = this.checkoutService.getCurrentPromotionCode(), codeInfo = _a.codeInfo, validateInfo = _a.validateInfo;
        this.promoCode = codeInfo;
        this.validatedPromoCode = validateInfo;
        this.updateGrandTotal();
    };
    CartComponent.prototype.updateGrandTotal = function () {
        if (this.cart) {
            this.grandTotalPrice = this.cartService.calculateGrandTotalPrice(this.cart.conditions, this.validatedPromoCode);
            this.checkoutService.updateGrandTotalPrice(this.grandTotalPrice);
        }
    };
    return CartComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], CartComponent.prototype, "options", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Object)
], CartComponent.prototype, "multiPaymentMainChannel", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])(),
    __metadata("design:type", Object)
], CartComponent.prototype, "onCartButtonClick", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])(),
    __metadata("design:type", Object)
], CartComponent.prototype, "onClickMore", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])(),
    __metadata("design:type", Object)
], CartComponent.prototype, "onSelectPromotionCode", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])('miniCart'),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]) === "function" && _a || Object)
], CartComponent.prototype, "miniCart", void 0);
CartComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
        selector: 'act-cart',
        template: __webpack_require__(1020),
        styles: [__webpack_require__(885)]
    }),
    __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_12__services_cart_cart_service__["a" /* CartService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_12__services_cart_cart_service__["a" /* CartService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_11__services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_11__services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_common__["l" /* TitleCasePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_common__["l" /* TitleCasePipe */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_common__["k" /* DecimalPipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_common__["k" /* DecimalPipe */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_10__pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_10__pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */]) === "function" && _h || Object, typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_products_product_service__["a" /* ProductService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_products_product_service__["a" /* ProductService */]) === "function" && _j || Object, typeof (_k = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_user_user_service__["a" /* UserService */]) === "function" && _k || Object, typeof (_l = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_authorize_authorize_service__["a" /* AuthorizeService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_authorize_authorize_service__["a" /* AuthorizeService */]) === "function" && _l || Object, typeof (_m = typeof __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectorRef"]) === "function" && _m || Object, typeof (_o = typeof __WEBPACK_IMPORTED_MODULE_17_app_services_currency_currency_service__["a" /* CurrencyService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_17_app_services_currency_currency_service__["a" /* CurrencyService */]) === "function" && _o || Object, typeof (_p = typeof __WEBPACK_IMPORTED_MODULE_18_app_services_checkout_checkout_service__["a" /* CheckoutService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_18_app_services_checkout_checkout_service__["a" /* CheckoutService */]) === "function" && _p || Object, typeof (_q = typeof __WEBPACK_IMPORTED_MODULE_21__angular_router__["b" /* ActivatedRoute */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_21__angular_router__["b" /* ActivatedRoute */]) === "function" && _q || Object])
], CartComponent);

var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
//# sourceMappingURL=cart.component.js.map

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_booking_booking_service__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_dialog_alert_dialog_alert_component__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vendors_moment_locale_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_model_constant__ = __webpack_require__(6);
/* unused harmony export DialogCancellationData */
/* unused harmony export DialogCancellationResponse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogCancelBookingComponent; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};








var DialogCancellationData = (function () {
    function DialogCancellationData() {
    }
    return DialogCancellationData;
}());

var PaymentCreditTermShareBudget = (function () {
    function PaymentCreditTermShareBudget() {
    }
    return PaymentCreditTermShareBudget;
}());
var BookerCancellationCharge = (function () {
    function BookerCancellationCharge() {
    }
    return BookerCancellationCharge;
}());
var DialogCancellationResponse = (function () {
    function DialogCancellationResponse(bookingId, ref, done, reason) {
        this.bookingId = bookingId;
        this.ref = ref;
        this.done = done;
        this.reason = reason;
    }
    return DialogCancellationResponse;
}());

var DisplayPaymentNonCreditTerm = (function () {
    function DisplayPaymentNonCreditTerm() {
    }
    return DisplayPaymentNonCreditTerm;
}());
var ID_PAYMENT = {
    MAIN_PAYMENT: 'main-payment',
    ANOTHER_PAYMENT: 'another-payment',
};
var DialogCancelBookingComponent = (function () {
    function DialogCancelBookingComponent(dialogRef, bookingService, utilitiesService, appConfigService, dialog, el, data) {
        this.dialogRef = dialogRef;
        this.bookingService = bookingService;
        this.utilitiesService = utilitiesService;
        this.appConfigService = appConfigService;
        this.dialog = dialog;
        this.el = el;
        this.data = data;
        this.cancelBookingListState = 'LOADING';
        this.isCancelling = false;
        this.isShareBudget = false;
        this.isCreditTerms = false;
        this.isDisplayRefundPolicy = false;
        this.isDisplayPromotionPolicy = false;
        this.paymentCreditTerms = null;
        this.paymentCreditTermsShareBudget = null;
        this.paymentCreditCard = null;
        this.paymentTrueMoneyWallet = null;
        this.paymentCorporateFleet = null;
        this.paymentPersonalFleet = null;
        this.displayPaymentNonCreditTermList = [];
    }
    DialogCancelBookingComponent.prototype.onResize = function (event) {
        document.documentElement.style.setProperty('--dialog-filter-vh', window.innerHeight * 0.01 + "px");
    };
    DialogCancelBookingComponent.prototype.ngOnInit = function () {
        this.onResize();
        this.fetchData();
    };
    DialogCancelBookingComponent.prototype.fetchData = function () {
        var _this = this;
        this.cancelBookingListState = 'LOADING';
        if (this.getBookingCancellationDataRequest) {
            this.getBookingCancellationDataRequest.unsubscribe();
        }
        this.getBookingCancellationDataRequest = this.bookingService.getBookingCancellationFee(this.data.bookingId)
            .subscribe(function (res) {
            var data = res.data;
            _this.cancelBookingId = data.bookingId;
            _this.cancellationChargeList = data.cancellationChargeList;
            _this.cancellationFee = data.totalCharge;
            _this.isDisplayRefundPolicy = data.displayRefundPolicy;
            _this.isDisplayPromotionPolicy = data.displayPromotionPolicy;
            if (_this.cancellationChargeList && _this.cancellationChargeList.length > 0) {
                _this.cancelBookingListState = 'SUCCESS';
                _this.lang = _this.appConfigService.getLanguage();
                _this.cancellationChargeList = _this.cancellationChargeList.map(function (item) {
                    return __assign({}, item, { cancellationDate: item.fromDate ? __WEBPACK_IMPORTED_MODULE_6_vendors_moment_locale_th__(item.fromDate).locale(_this.lang).format('DD MMM YY') : undefined });
                });
            }
            else {
                _this.cancelBookingListState = 'FREE';
            }
            if (data.bookerCancellationChargeList !== undefined) {
                var bookerCancellationChargeList = data.bookerCancellationChargeList;
                if (bookerCancellationChargeList.filter(function (cancellation) { return cancellation.paymentType === __WEBPACK_IMPORTED_MODULE_7_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_TERMS; }).length > 1) {
                    _this.isShareBudget = true;
                    _this.paymentCreditTermsShareBudget = new PaymentCreditTermShareBudget();
                }
                _this.displayPaymentNonCreditTermList = [];
                for (var i = 0; i < bookerCancellationChargeList.length; i++) {
                    if (bookerCancellationChargeList[i].paymentType === __WEBPACK_IMPORTED_MODULE_7_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_TERMS) {
                        _this.isCreditTerms = true;
                        if (_this.isShareBudget) {
                            if (bookerCancellationChargeList[i].mainBooker) {
                                _this.paymentCreditTermsShareBudget.mainBooker = bookerCancellationChargeList[i].totalCharge;
                            }
                            else {
                                _this.paymentCreditTermsShareBudget.coBooker = bookerCancellationChargeList[i].totalCharge;
                            }
                        }
                        else {
                            _this.paymentCreditTerms += bookerCancellationChargeList[i].totalCharge;
                        }
                    }
                    else {
                        var displayPaymentNonCreditTerm = new DisplayPaymentNonCreditTerm();
                        switch (bookerCancellationChargeList[i].paymentType) {
                            case __WEBPACK_IMPORTED_MODULE_7_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_CARD:
                                displayPaymentNonCreditTerm.title = 'booking-cancellation-credit-card';
                                break;
                            case __WEBPACK_IMPORTED_MODULE_7_app_model_constant__["m" /* PaymentMethodDetailType */].TRUE_MONEY:
                                displayPaymentNonCreditTerm.title = 'booking-cancellation-true-money';
                                break;
                            case __WEBPACK_IMPORTED_MODULE_7_app_model_constant__["m" /* PaymentMethodDetailType */].CORPORATE_FLEET:
                                displayPaymentNonCreditTerm.title = 'booking-cancellation-corporate-fleet';
                                break;
                            case __WEBPACK_IMPORTED_MODULE_7_app_model_constant__["m" /* PaymentMethodDetailType */].PERSONAL_FLEET:
                                displayPaymentNonCreditTerm.title = 'booking-cancellation-personal-fleet';
                                break;
                            default:
                                displayPaymentNonCreditTerm.title = '';
                                break;
                        }
                        displayPaymentNonCreditTerm.paymentId = i === 0 ? ID_PAYMENT.MAIN_PAYMENT : ID_PAYMENT.ANOTHER_PAYMENT;
                        displayPaymentNonCreditTerm.totalCancellationFee = bookerCancellationChargeList[i].totalCharge;
                        _this.displayPaymentNonCreditTermList.push(displayPaymentNonCreditTerm);
                    }
                }
            }
        }, function (err) {
            _this.dialogRef.close();
            var dialogAlertRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_5__modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */]);
            dialogAlertRef.componentInstance.alertText = _this.appConfigService.getTranslate('approval-action-unable-approval-or-reject-detail');
            dialogAlertRef.componentInstance.imageSrc = '/assets/images/icons/icon-failed.png';
            dialogAlertRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-failed.png';
        });
    };
    DialogCancelBookingComponent.prototype.cancelBooking = function () {
        if (this.data.type === 'approval') {
            if (this.isReasonError === false) {
                this.isCancelling = true;
                this.data.onSubmit(new DialogCancellationResponse(this.data.bookingId, this.data.ref, this.done.bind(this), this.reasonText));
            }
            else {
                this.isReasonError = true;
            }
        }
        else {
            this.isCancelling = true;
            this.data.onSubmit(new DialogCancellationResponse(this.data.bookingId, this.data.ref, this.done.bind(this), this.reasonText));
        }
    };
    DialogCancelBookingComponent.prototype.done = function () {
        this.dialogRef.close();
    };
    DialogCancelBookingComponent.prototype.onKeyupReason = function (text) {
        this.isReasonError = text && text.trim().length > 0 ? false : true;
        this.reasonText = text;
    };
    return DialogCancelBookingComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DialogCancelBookingComponent.prototype, "onResize", null);
DialogCancelBookingComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'ota-dialog-cancellation-booking',
        template: __webpack_require__(1024),
        styles: [__webpack_require__(889)]
    }),
    __param(6, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_booking_booking_service__["a" /* BookingService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_booking_booking_service__["a" /* BookingService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _f || Object, DialogCancellationData])
], DialogCancelBookingComponent);

var _a, _b, _c, _d, _e, _f;
//# sourceMappingURL=dialog-cancellation-booking.component.js.map

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogFilterBookingComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};






var DialogFilterBookingComponent = (function () {
    function DialogFilterBookingComponent(data, dialogRef, formBuilder, appConfigService, utilitiesService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
    }
    DialogFilterBookingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._bookingPayload = this.formBuilder.group({
            'filterSort': [this.filterType === __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["L" /* FilterSortType */].sort ?
                    (this.bookingPayload.controls.sortBy ? this.bookingPayload.controls.sortBy.value : __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["g" /* SortByType */].bookingDate) :
                    (this.bookingPayload.controls.filterBy ? this.bookingPayload.controls.filterBy.value : __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["h" /* FilterByType */].all)
            ]
        });
        this.subscriptionFilter = this._bookingPayload.controls.filterSort.valueChanges
            .subscribe(function (val) {
            if (_this.filterType === __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["L" /* FilterSortType */].sort && _this.bookingPayload.controls.sortBy) {
                _this.bookingPayload.controls.sortBy.setValue(val);
            }
            else if (_this.filterType === __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["L" /* FilterSortType */].filter && _this.bookingPayload.controls.filterBy) {
                _this.bookingPayload.controls.filterBy.setValue(val);
            }
            _this.dialogRef.close();
        });
    };
    DialogFilterBookingComponent.prototype.ngOnDestroy = function () {
        this.subscriptionFilter && this.subscriptionFilter.unsubscribe();
    };
    return DialogFilterBookingComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('bookingPayload'),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__angular_forms__["FormGroup"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_forms__["FormGroup"]) === "function" && _a || Object)
], DialogFilterBookingComponent.prototype, "bookingPayload", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('listItems'),
    __metadata("design:type", Array)
], DialogFilterBookingComponent.prototype, "listItems", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('filterType'),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["L" /* FilterSortType */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["L" /* FilterSortType */]) === "function" && _b || Object)
], DialogFilterBookingComponent.prototype, "filterType", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('filterTitle'),
    __metadata("design:type", String)
], DialogFilterBookingComponent.prototype, "filterTitle", void 0);
DialogFilterBookingComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'ota-dialog-filter-booking',
        template: __webpack_require__(1025),
        styles: [__webpack_require__(890)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_3__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__angular_material__["b" /* MdDialogRef */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_2__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_forms__["FormBuilder"]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _f || Object])
], DialogFilterBookingComponent);

var _a, _b, _c, _d, _e, _f;
//# sourceMappingURL=dialog-filter-booking.component.js.map

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogCancellationComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var DialogCancellationComponent = (function () {
    function DialogCancellationComponent(dialogRef) {
        this.dialogRef = dialogRef;
    }
    DialogCancellationComponent.prototype.ngOnInit = function () {
    };
    return DialogCancellationComponent;
}());
DialogCancellationComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-cancellation',
        template: __webpack_require__(1044),
        styles: [__webpack_require__(909)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object])
], DialogCancellationComponent);

var _a;
//# sourceMappingURL=dialog-cancellation.component.js.map

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookerInfoModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BookerInfo; });
var BookerInfoModel = (function () {
    function BookerInfoModel() {
        this.visitorId = 1;
        this.typeOfTravel = 1;
    }
    return BookerInfoModel;
}());

var BookerInfo = (function () {
    function BookerInfo() {
    }
    return BookerInfo;
}());

//# sourceMappingURL=booker-info.model.js.map

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__ = __webpack_require__(24);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GuestInfoService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var GuestInfoService = (function () {
    function GuestInfoService(actHttp) {
        this.actHttp = actHttp;
        this.savingGuest = [];
        this.savingGuestCount = new __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__["BehaviorSubject"](0);
        this.travellersObj = new __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__["BehaviorSubject"]([]);
    }
    // ***************** Guest Suggestion ************************ //
    GuestInfoService.prototype.getTravellerList = function () {
        var url = __WEBPACK_IMPORTED_MODULE_2__environments_environment__["a" /* environment */].endpoint.travellerManagement + "s";
        return this.actHttp.get(url, this.actHttp.getRequestOptions()).map(function (res) { return res.json(); });
    };
    GuestInfoService.prototype.addNewGuest = function (request) {
        var url = "" + __WEBPACK_IMPORTED_MODULE_2__environments_environment__["a" /* environment */].endpoint.travellerManagement;
        return this.actHttp.post(url, request, this.actHttp.getRequestOptions()).map(function (res) { return res.json(); });
    };
    GuestInfoService.prototype.deleteGuest = function (travellerId) {
        var url = __WEBPACK_IMPORTED_MODULE_2__environments_environment__["a" /* environment */].endpoint.travellerManagement + "/" + travellerId;
        return this.actHttp.delete(url, this.actHttp.getRequestOptions());
    };
    GuestInfoService.prototype.addSavingGuest = function (traveller) {
        this.savingGuest.push(traveller);
    };
    GuestInfoService.prototype.clearSavingGuest = function () {
        this.savingGuest = [];
    };
    GuestInfoService.prototype.getSavingGuest = function () {
        this.savingGuest.forEach(function (guest) {
            delete guest.owned;
            delete guest.selected;
            delete guest.selecting;
        });
        return this.savingGuest;
    };
    GuestInfoService.prototype.setSavingGuestCount$ = function (count) {
        this.savingGuestCount.next(count);
    };
    GuestInfoService.prototype.getSavingGuestCount$ = function () {
        return this.savingGuestCount;
    };
    GuestInfoService.prototype.getSavingGuestCount = function () {
        return this.savingGuestCount.value;
    };
    GuestInfoService.prototype.setTravellers$ = function (travellers) {
        this.travellersObj.next(travellers);
    };
    GuestInfoService.prototype.getTravellers$ = function () {
        return this.travellersObj;
    };
    GuestInfoService.prototype.onCompleteSaveGuest = function () {
        this.setTravellers$(null);
        this.clearSavingGuest();
        this.setSavingGuestCount$(0);
    };
    return GuestInfoService;
}());
GuestInfoService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object])
], GuestInfoService);

var _a;
//# sourceMappingURL=guest-info.service.js.map

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThankyouService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var ThankyouService = (function () {
    function ThankyouService(titlecasePipe, decimalPipe, translatePipe) {
        this.titlecasePipe = titlecasePipe;
        this.decimalPipe = decimalPipe;
        this.translatePipe = translatePipe;
    }
    ThankyouService.prototype.transfromSurcharge = function (surcharges, type) {
        var _this = this;
        var listSurcharges = [];
        surcharges && surcharges.map(function (sur) {
            if (sur.charge === type) {
                listSurcharges.push(sur.name.toString() + " THB " + _this.decimalPipe.transform(sur.price, '1.2-2'));
            }
        });
        listSurcharges.length > 0 && listSurcharges.join(', ');
        return listSurcharges.length > 0 ?
            this.translatePipe.transform(type === 'include' ? 'cart-surcharge-include' : 'thankyou-surcharge-exclude').replace('{text}', listSurcharges) :
            undefined;
    };
    return ThankyouService;
}());
ThankyouService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_common__["l" /* TitleCasePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_common__["l" /* TitleCasePipe */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_common__["k" /* DecimalPipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_common__["k" /* DecimalPipe */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _c || Object])
], ThankyouService);

var _a, _b, _c;
//# sourceMappingURL=thankyou.service.js.map

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_components_form_form__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddressForm; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var AddressForm = (function (_super) {
    __extends(AddressForm, _super);
    function AddressForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formErrors = {
            'title': {},
            'address': {},
            'taxNumber': {},
        };
        _this.getInitForm = function (title, address, taxNumber) {
            return {
                'title': [title, [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required]],
                'address': [address, [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required]],
                'taxNumber': [taxNumber, [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].maxLength(20), __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].pattern("^[a-zA-Z0-9-]*$")]]
            };
        };
        return _this;
    }
    return AddressForm;
}(__WEBPACK_IMPORTED_MODULE_0_app_components_form_form__["a" /* Form */]));

//# sourceMappingURL=address.form.js.map

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_map_nearby_info_window_content_info_window_content_component__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_model_products_product_review_model__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_products_product_service__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_platform__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_act_map_directives_info_marker__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_services_currency_currency_service__ = __webpack_require__(58);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogMapNearbyComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};














var DialogMapNearbyComponent = (function () {
    function DialogMapNearbyComponent(data, dialogRef, productService, utilitiesService, appConfigService, userService, googleTagManagerService, currencyService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.productService = productService;
        this.utilitiesService = utilitiesService;
        this.appConfigService = appConfigService;
        this.userService = userService;
        this.googleTagManagerService = googleTagManagerService;
        this.currencyService = currencyService;
        this.isMobile = false; // tslint:disable-line
        this.resetCenter = false; // tslint:disable-line
        this.isAllPopOverComplete = false;
        this.countPopOver = 0;
        this.countMarker = 0;
        this.gaSent = false;
        this.now = new Date().getTime() / 1000;
        this.zoom = 11;
        this.radius = __WEBPACK_IMPORTED_MODULE_10__model_constant__["p" /* DefaultValue */].DISTANCE;
    }
    DialogMapNearbyComponent.prototype.onResize = function () {
        document.documentElement.style.setProperty('--dialog-vh', window.innerHeight * 0.01 + "px");
    };
    DialogMapNearbyComponent.prototype.ngOnInit = function () {
        this.onResize();
        if (this.data && this.data.product) {
            if (this.data.product.reviewRatingScore) {
                this.reviewRating = new __WEBPACK_IMPORTED_MODULE_4_app_model_products_product_review_model__["a" /* ProductReviewModel */]('' + this.data.product.reviewRatingScore, this.productService.calculateReviewRatingTitle(this.data.product.reviewRatingScore));
            }
            this.product = this.data.product;
        }
        this.product && this.getProductNearBy(this.product);
        this.utilitiesService.isMobile() && (this.isMobile = true);
        this.googleTagManagerService.emitEvent('Nearby Map Search', 'Loading', this.data && this.data.product ? this.data.product.productTitle || '' : '', 0);
        this.subscribeCurrency();
    };
    DialogMapNearbyComponent.prototype.ngOnDestroy = function () {
        this.getProductNearBySubScription && this.getProductNearBySubScription.unsubscribe();
        this.currencySubscription && this.currencySubscription.unsubscribe();
        this.utilitiesService.unlockBody();
        this.utilitiesService.unlockBodyBackdrop();
    };
    DialogMapNearbyComponent.prototype.setInfoWindowData = function (image, title, rating, keyMarker, review, displayNavigate) {
        if (displayNavigate === void 0) { displayNavigate = false; }
        this.infoWindowKey = {
            key: keyMarker
        };
        this.infoWindowContentComponent.setData(image, title, rating, review, true, displayNavigate);
    };
    DialogMapNearbyComponent.prototype.getProductNearBy = function (data) {
        var _this = this;
        this.getProductNearBySubScription && this.getProductNearBySubScription.unsubscribe();
        this.data.hotelListRequest.filterRequest.distance = this.radius;
        this.getProductNearBySubScription = this.productService.getProductListWithPOI(this.data.hotelListRequest).subscribe(function (res) {
            _this.productNearByList = res.items;
            _this.productNearByList.forEach(function (e) {
                e.reviewRating = new __WEBPACK_IMPORTED_MODULE_4_app_model_products_product_review_model__["a" /* ProductReviewModel */](e.reviewRatingScore, _this.productService.calculateReviewRatingTitle(e.reviewRatingScore));
            });
        });
    };
    DialogMapNearbyComponent.prototype.calculateZoom = function () {
        var _this = this;
        var tmpDistanceLat = 0;
        var tmpDistanceLon = 0;
        var centerLon = Number(this.product.longitude);
        var centerLat = Number(this.product.latitude);
        var distanceLat = Math.abs(Number(this.product.latitude) - centerLat);
        var distanceLon = Math.abs(Number(this.product.longitude) - centerLon);
        this.productNearByList.forEach(function (element) {
            if (_this.product.productId !== element.productId) {
                tmpDistanceLat = Math.abs(element.latitude.valueOf() - centerLat);
                tmpDistanceLon = Math.abs(element.longitude.valueOf() - centerLon);
                distanceLat = tmpDistanceLat > distanceLat ? tmpDistanceLat : distanceLat;
                distanceLon = tmpDistanceLon > distanceLon ? tmpDistanceLon : distanceLon;
            }
        });
        var mapElement = document.querySelector('.dialog-map');
        var widthPixel = this.isMobile ? mapElement.offsetWidth / 3.5 : 256;
        var heightPixel = this.isMobile ? mapElement.offsetHeight / 4.2 : 148;
        var GLOBE_WIDTH = 256;
        var zoomLat = Math.round(Math.log(heightPixel * 360 / distanceLat / GLOBE_WIDTH) / Math.LN2);
        var zoomLon = Math.round(Math.log(widthPixel * 360 / distanceLon / GLOBE_WIDTH) / Math.LN2);
        this.zoom = zoomLat < zoomLon ? zoomLat : zoomLon;
    };
    DialogMapNearbyComponent.prototype.onMarkerClicked = function (data) {
        var key = data && data.key ? data.key : undefined;
        this.isMobile && key && this.setActiveMarker(key);
        switch (key) {
            case undefined:
                break;
            case "center":
                this.setInfoWindowData(this.data.product.imageUrl, this.data.product.productTitle, this.data.product.hotelStar, key, this.reviewRating, true);
                break;
            default:
                var product = this.productNearByList[key];
                this.setInfoWindowData(product.imageUrl, product.productTitle, product.hotelStar, data.key, new __WEBPACK_IMPORTED_MODULE_4_app_model_products_product_review_model__["a" /* ProductReviewModel */]('' + product.reviewRatingScore, this.productService.calculateReviewRatingTitle(product.reviewRatingScore)));
                break;
        }
    };
    DialogMapNearbyComponent.prototype.onPopOverClicked = function (data) {
        if (data && data.key === 'center') {
            this.data.page !== __WEBPACK_IMPORTED_MODULE_10__model_constant__["A" /* Page */].LEVEL_D && this.goToProductDetail(this.data.product.productId, this.data.product.slug, this.data.product.productTitle);
        }
        else {
            var product = this.productNearByList[data.key];
            this.goToProductDetail(product.productId, product.slug, product.productTitle);
        }
    };
    DialogMapNearbyComponent.prototype.onRenderMarkerComplete = function (event) {
        ++this.countMarker;
        event === 'center' && this.infoWindowContentComponent && this.isMobile && this.setInfoWindowData(this.data.product.imageUrl, this.data.product.productTitle, this.data.product.hotelStar, 'center', this.reviewRating, true);
        var allMarker = this.productNearByList && this.productNearByList.length > 0
            ? this.productNearByList.length + 1 : 1;
        this.isMobile && allMarker === this.countMarker && (this.resetCenter = true);
        this.resetCenter && this.iPhoneUpdateSizing();
        this.resetCenter && this.setActiveMarker('center');
    };
    DialogMapNearbyComponent.prototype.onRenderPopOverComplete = function (event) {
        ++this.countPopOver;
        var allPopOver = this.productNearByList && this.productNearByList.length > 0
            ? this.productNearByList.length + 1 : 1;
        allPopOver === this.countPopOver && allPopOver === this.countMarker
            && (this.isAllPopOverComplete = this.resetCenter = true);
        this.resetCenter && this.iPhoneUpdateSizing();
    };
    DialogMapNearbyComponent.prototype.sendGAMapLoaded = function () {
        if (!this.gaSent) {
            this.gaSent = true;
            this.calculateZoom();
            var maxDistance = Math.max.apply(Math, this.productNearByList.map(function (o) { return o.distance; }));
            var tempRadius = Math.round((maxDistance * 1.01) / Math.LN2);
            this.radius = tempRadius > this.data.product.radius ? this.data.product.radius : tempRadius;
            this.googleTagManagerService.emitEvent('Nearby Map Search', 'Loaded', this.data && this.data.product ? this.data.product.productTitle || '' : '', Math.round(new Date().getTime() / 1000 - this.now));
        }
    };
    DialogMapNearbyComponent.prototype.goToProductDetail = function (id, slug, title) {
        this.removeLink();
        var url = this.productService.getProductDetailsUrl({
            id: id,
            slug: slug,
            suggestCat: 'product',
            title: title,
            purpose: this.data.searchData.purpose,
            checkInDate: this.utilitiesService.convertDateFormat(this.data.searchData.checkInDate, 'YYYY-MM-DD', 'DD-MM-YYYY', 'en'),
            checkOutDate: this.utilitiesService.convertDateFormat(this.data.searchData.checkOutDate, 'YYYY-MM-DD', 'DD-MM-YYYY', 'en'),
            guests: this.data.searchData.guests,
            breakfast: false,
            overBudget: false,
            isReverseFormatDate: false
        });
        this.setLink(url);
    };
    DialogMapNearbyComponent.prototype.setLink = function (url) {
        var link = document.getElementById('link-to-product-detail');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', url);
        link.click();
    };
    DialogMapNearbyComponent.prototype.removeLink = function () {
        var link = document.getElementById('link-to-product-detail');
        link.removeAttribute('target');
        link.removeAttribute('href');
    };
    DialogMapNearbyComponent.prototype.resetIphoneHandler = function () {
        this.$mapElement && this.$mapElement.removeClass('iphone');
    };
    DialogMapNearbyComponent.prototype.iPhoneUpdateSizing = function () {
        this.$mapElement = __WEBPACK_IMPORTED_MODULE_8_jquery___default()('.act-map-container-inner');
        this.$infoWindowElement = __WEBPACK_IMPORTED_MODULE_8_jquery___default()('.info-window-mobile');
        // handle for iPhone (safari and firefox) only
        var canHandle = !!__WEBPACK_IMPORTED_MODULE_9_platform___default.a && window.navigator.platform === 'iPhone';
        canHandle = canHandle && __WEBPACK_IMPORTED_MODULE_9_platform___default.a.product === 'iPhone';
        canHandle = canHandle && (__WEBPACK_IMPORTED_MODULE_9_platform___default.a.name === 'Safari' || __WEBPACK_IMPORTED_MODULE_9_platform___default.a.name === 'Firefox');
        canHandle && this.$mapElement && this.$mapElement.addClass('iphone');
        canHandle && this.$infoWindowElement && this.$infoWindowElement.addClass('iphone');
        this.sendGAMapLoaded();
    };
    DialogMapNearbyComponent.prototype.setActiveMarker = function (active) {
        this.infoMarker.map(function (marker) {
            marker.setActiveMarker(active === marker.key);
        });
    };
    DialogMapNearbyComponent.prototype.subscribeCurrency = function () {
        var _this = this;
        this.currency = this.currencyService.getCurrency();
        this.currencySubscription = this.currencyService.getCurrencyObs().subscribe(function (currency) {
            _this.currency = currency;
        });
    };
    return DialogMapNearbyComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_map_nearby_info_window_content_info_window_content_component__["a" /* InfoWindowContentComponent */]),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_map_nearby_info_window_content_info_window_content_component__["a" /* InfoWindowContentComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_map_nearby_info_window_content_info_window_content_component__["a" /* InfoWindowContentComponent */]) === "function" && _a || Object)
], DialogMapNearbyComponent.prototype, "infoWindowContentComponent", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChildren"])(__WEBPACK_IMPORTED_MODULE_12__utilities_act_map_directives_info_marker__["a" /* ActInfoMarker */]),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_core__["QueryList"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_core__["QueryList"]) === "function" && _b || Object)
], DialogMapNearbyComponent.prototype, "infoMarker", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DialogMapNearbyComponent.prototype, "onResize", null);
DialogMapNearbyComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
        selector: 'act-dialog-map-nearby',
        template: __webpack_require__(1055),
        styles: [__webpack_require__(920)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_products_product_service__["a" /* ProductService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_products_product_service__["a" /* ProductService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_11__services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_11__services_user_user_service__["a" /* UserService */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__["a" /* GoogleTagManagerService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__["a" /* GoogleTagManagerService */]) === "function" && _h || Object, typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_13_app_services_currency_currency_service__["a" /* CurrencyService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_13_app_services_currency_currency_service__["a" /* CurrencyService */]) === "function" && _j || Object])
], DialogMapNearbyComponent);

var _a, _b, _c, _d, _e, _f, _g, _h, _j;
//# sourceMappingURL=dialog-map-nearby.component.js.map

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__un_mask_directive__ = __webpack_require__(623);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnMaskInputModule; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var UnMaskInputModule = (function () {
    function UnMaskInputModule() {
    }
    return UnMaskInputModule;
}());
UnMaskInputModule = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
        imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["a" /* CommonModule */]],
        declarations: [__WEBPACK_IMPORTED_MODULE_2__un_mask_directive__["a" /* UnMaskDirective */]],
        exports: [__WEBPACK_IMPORTED_MODULE_2__un_mask_directive__["a" /* UnMaskDirective */]]
    })
], UnMaskInputModule);

//# sourceMappingURL=un-mask.module.js.map

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BudgetAvailableRequest; });
/* unused harmony export BudgetAvailableResponse */
/* unused harmony export BudgetPerYear */
/* unused harmony export BudgetPerMonth */
/* unused harmony export User */

var BudgetAvailableRequest = (function () {
    function BudgetAvailableRequest() {
        this.lang = __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* Language */].en;
    }
    return BudgetAvailableRequest;
}());

var BudgetAvailableResponse = (function () {
    function BudgetAvailableResponse() {
    }
    return BudgetAvailableResponse;
}());

var BudgetPerYear = (function () {
    function BudgetPerYear() {
    }
    return BudgetPerYear;
}());

var BudgetPerMonth = (function () {
    function BudgetPerMonth() {
    }
    return BudgetPerMonth;
}());

var User = (function () {
    function User(userId, companyId, mainBooker) {
        this.userId = userId;
        this.companyId = companyId;
        this.mainBooker = mainBooker;
    }
    return User;
}());

//# sourceMappingURL=budget-available.model.js.map

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_services_act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_environments_environment__ = __webpack_require__(22);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RatingService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var RatingService = (function () {
    function RatingService(actHttpService) {
        this.actHttpService = actHttpService;
    }
    RatingService.prototype.getRatingData = function (token) {
        var options = this.actHttpService.getRequestOptions(__WEBPACK_IMPORTED_MODULE_0_app_services_act_http_act_http_service__["a" /* HeaderTypes */].EXCLUDE_TOKEN);
        var url = __WEBPACK_IMPORTED_MODULE_3_environments_environment__["a" /* environment */].endpoint.rating.replace(':token', token.toString());
        return this.actHttpService.rawGet(url, options)
            .map(function (res) { return res.json().data; });
    };
    RatingService.prototype.submitRatingData = function (token, data, photo) {
        var url = __WEBPACK_IMPORTED_MODULE_3_environments_environment__["a" /* environment */].endpoint.rating.replace(':token', token.toString());
        var rating = new FormData();
        rating.append('review', new Blob([JSON.stringify(data)], { type: 'application/json' }));
        if (photo.length > 0) {
            for (var i = 0; i < photo.length; i++) {
                rating.append('photos', photo[i]);
            }
        }
        var responseType = __WEBPACK_IMPORTED_MODULE_2__angular_http__["f" /* ResponseContentType */].Blob;
        return this.actHttpService.rawPost(url, rating, new __WEBPACK_IMPORTED_MODULE_2__angular_http__["e" /* RequestOptions */]({ responseType: responseType }))
            .map(function (res) { return res; });
    };
    RatingService.prototype.uploadImg = function (data) {
        var url = __WEBPACK_IMPORTED_MODULE_3_environments_environment__["a" /* environment */].endpoint.resizeUri;
        var request = new FormData();
        request.append('file', data);
        return this.actHttpService.rawPost(url, request).map(function (res) { return res; }).toPromise();
    };
    RatingService.prototype.prepareDataForDisplay = function (reviewRating) {
        if (reviewRating.totalScore === '10.0') {
            reviewRating.totalScore = '10';
        }
        reviewRating.ratings = reviewRating.ratings.map(function (rating) {
            rating.score = rating.score === '10.0' ? '10' : rating.score;
            return rating;
        });
        return reviewRating;
    };
    return RatingService;
}());
RatingService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0_app_services_act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0_app_services_act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object])
], RatingService);

var _a;
//# sourceMappingURL=rating.service.js.map

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return arrivalTimeList; });
var arrivalTimeList = [
    {
        value: null,
        keyTranslate: 'arrival-time-i-dont-know'
    },
    {
        value: "00:00 - 01:00",
        keyTranslate: 'arrival-time-0000-0100'
    },
    {
        value: "01:00 - 02:00",
        keyTranslate: 'arrival-time-0100-0200'
    },
    {
        value: "02:00 - 03:00",
        keyTranslate: 'arrival-time-0200-0300'
    },
    {
        value: "03:00 - 04:00",
        keyTranslate: 'arrival-time-0300-0400'
    },
    {
        value: "04:00 - 05:00",
        keyTranslate: 'arrival-time-0400-0500'
    },
    {
        value: "05:00 - 06:00",
        keyTranslate: 'arrival-time-0500-0600'
    },
    {
        value: "06:00 - 07:00",
        keyTranslate: 'arrival-time-0600-0700'
    },
    {
        value: "07:00 - 08:00",
        keyTranslate: 'arrival-time-0700-0800'
    },
    {
        value: "08:00 - 09:00",
        keyTranslate: 'arrival-time-0800-0900'
    },
    {
        value: "09:00 - 10:00",
        keyTranslate: 'arrival-time-0900-1000'
    },
    {
        value: "10:00 - 11:00",
        keyTranslate: 'arrival-time-1000-1100'
    },
    {
        value: "11:00 - 12:00",
        keyTranslate: 'arrival-time-1100-1200'
    },
    {
        value: "12:00 - 13:00",
        keyTranslate: 'arrival-time-1200-1300'
    },
    {
        value: "13:00 - 14:00",
        keyTranslate: 'arrival-time-1300-1400'
    },
    {
        value: "14:00 - 15:00",
        keyTranslate: 'arrival-time-1400-1500'
    },
    {
        value: "15:00 - 16:00",
        keyTranslate: 'arrival-time-1500-1600'
    },
    {
        value: "16:00 - 17:00",
        keyTranslate: 'arrival-time-1600-1700'
    },
    {
        value: "17:00 - 18:00",
        keyTranslate: 'arrival-time-1700-1800'
    },
    {
        value: "18:00 - 19:00",
        keyTranslate: 'arrival-time-1800-1900'
    },
    {
        value: "19:00 - 20:00",
        keyTranslate: 'arrival-time-1900-2000'
    },
    {
        value: "20:00 - 21:00",
        keyTranslate: 'arrival-time-2000-2100'
    },
    {
        value: "21:00 - 22:00",
        keyTranslate: 'arrival-time-2100-2200'
    },
    {
        value: "22:00 - 23:00",
        keyTranslate: 'arrival-time-2200-2300'
    },
    {
        value: "23:00 - 24:00",
        keyTranslate: 'arrival-time-2300-2400'
    },
    {
        value: "00:00 - 01:00 (the next day)",
        keyTranslate: 'arrival-time-0000-0100-the-next-day'
    },
    {
        value: "01:00 - 02:00 (the next day)",
        keyTranslate: 'arrival-time-0100-0200-the-next-day'
    },
];
//# sourceMappingURL=arrival-time-list.js.map

/***/ }),
/* 538 */,
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_images_image_scale_factor_model__ = __webpack_require__(225);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActImageComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var ActImageComponent = (function () {
    function ActImageComponent() {
        this.defaultImage = '';
        this.scaleFactorImage = '';
    }
    ActImageComponent.prototype.ngOnInit = function () {
        // console.log('on init act image ', this.image);
        this.defaultImage = this.image['2x'];
        this.scaleFactorImage = this.image['1x'] + " 1x, " + this.image['2x'] + " 2x, " + this.image['3x'] + " 3x";
    };
    ActImageComponent.prototype.ngAfterViewInit = function () {
        // console.log('on init act image ', this.image);
    };
    ActImageComponent.prototype.onImgError = function (event) {
        this.scaleFactorImage = undefined;
        event.target.src = 'https://images.ascendtravel.com/NoImage.jpg';
    };
    return ActImageComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__model_images_image_scale_factor_model__["a" /* ImageScaleFactorModel */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__model_images_image_scale_factor_model__["a" /* ImageScaleFactorModel */]) === "function" && _a || Object)
], ActImageComponent.prototype, "image", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActImageComponent.prototype, "contentClass", void 0);
ActImageComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-image',
        template: __webpack_require__(1004),
        styles: [__webpack_require__(869)],
    }),
    __metadata("design:paramtypes", [])
], ActImageComponent);

var _a;
//# sourceMappingURL=act-image.component.js.map

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_components_form_form__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BillingForm; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var BillingForm = (function (_super) {
    __extends(BillingForm, _super);
    function BillingForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formErrors = {
            'name': {},
            'address': {},
            'phone': {},
        };
        _this.getInitForm = function (name, phone, address) {
            return {
                'name': [name, [
                        __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required,
                        __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].pattern(_this.validatePattern.billingName)
                    ]],
                'address': [address, [
                        __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required,
                        __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].pattern(_this.validatePattern.billingAddress)
                    ]],
                'phone': [phone, [
                        __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required,
                        __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].pattern(_this.validatePattern.phone)
                    ]]
            };
        };
        return _this;
    }
    return BillingForm;
}(__WEBPACK_IMPORTED_MODULE_0_app_components_form_form__["a" /* Form */]));

//# sourceMappingURL=billing.form.js.map

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogListComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};



var DialogListComponent = (function () {
    function DialogListComponent(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.formCtrl = new __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormControl"]();
    }
    DialogListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formCtrl.setValue(this.data.items[this.data.defaultIndex].value);
        this.valueChangesSubscription && this.valueChangesSubscription.unsubscribe();
        this.valueChangesSubscription = this.formCtrl.valueChanges
            .subscribe(function () { return _this.dialogRef.close(_this.formCtrl.value); });
    };
    DialogListComponent.prototype.ngOnDestroy = function () {
        this.valueChangesSubscription && this.valueChangesSubscription.unsubscribe();
    };
    DialogListComponent.prototype.close = function () {
        this.dialogRef.close(this.formCtrl.value);
    };
    return DialogListComponent;
}());
DialogListComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-list',
        template: __webpack_require__(1054),
        styles: [__webpack_require__(919)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [Object, typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object])
], DialogListComponent);

var _a;
//# sourceMappingURL=dialog-list.component.js.map

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogMultiPaymentComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var DialogMultiPaymentComponent = (function () {
    function DialogMultiPaymentComponent(utilitiesService) {
        this.utilitiesService = utilitiesService;
    }
    DialogMultiPaymentComponent.prototype.ngOnInit = function () {
    };
    DialogMultiPaymentComponent.prototype.ngOnDestroy = function () {
        this.utilitiesService.unlockBody();
        this.utilitiesService.unlockBodyBackdrop();
    };
    return DialogMultiPaymentComponent;
}());
DialogMultiPaymentComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-multi-payment',
        template: __webpack_require__(1059),
        styles: [__webpack_require__(924)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _a || Object])
], DialogMultiPaymentComponent);

var _a;
//# sourceMappingURL=dialog-multi-payment.component.js.map

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pin_pin_component__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_pin_pin_service__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dialog_alert_dialog_alert_component__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dialog_error_dialog_error_component__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_verify_otp_otp_state__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pin_state__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_verify_otp_verify_otp_component__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_model_otp_otp_model__ = __webpack_require__(170);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogPinComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};















var DialogPinComponent = (function () {
    function DialogPinComponent(dialogRef, translatePipe, route, pinService, appConfigService, userService, dialog, cd, router) {
        this.dialogRef = dialogRef;
        this.translatePipe = translatePipe;
        this.route = route;
        this.pinService = pinService;
        this.appConfigService = appConfigService;
        this.userService = userService;
        this.dialog = dialog;
        this.cd = cd;
        this.router = router;
        this.backButtonMode = 'cancel';
        this.elementId = 'dialog-pin';
        this.sendingRequestOtp = false;
        this.isLoading = false;
        this.requiredSetPin = false;
        this.PIN_STATE = __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */];
        this.OTP_PURPOSE = __WEBPACK_IMPORTED_MODULE_14_app_model_otp_otp_model__["a" /* OTPPurpose */];
        this.otpMethods = [];
        this.pinLocked = false;
        this.accountLocked = false;
        this.inputPin = '';
        this.state = __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */].SET_PIN;
    }
    DialogPinComponent.prototype.ngOnDestroy = function () {
        this.verifyPinSubscription && this.verifyPinSubscription.unsubscribe();
    };
    DialogPinComponent.prototype.ngOnInit = function () {
        if (this.route.snapshot.queryParamMap.get('set_pin')) {
            this.backButtonMode = undefined;
            this.requiredSetPin = true;
        }
        this.subscribeLanguageChanges();
    };
    DialogPinComponent.prototype.ngAfterViewInit = function () {
        this.cd.detectChanges();
    };
    DialogPinComponent.prototype.subscribeLanguageChanges = function () {
        var _this = this;
        this.lang = this.appConfigService.getLanguage();
        this.langSubscription && this.langSubscription.unsubscribe();
        this.langSubscription = this.appConfigService.getLanguageObs().subscribe(function (lang) {
            _this.lang = lang;
        });
    };
    DialogPinComponent.prototype.onSubmit = function () {
        if (this.state == __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */].CHECKOUT) {
            this.verifyPIN();
        }
        else if (this.state == __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */].SET_PIN) {
            this.validatePIN();
        }
        else if (this.state == __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */].CONFIRM_SET_PIN) {
            this.validateConfirmPIN();
            this.setupPIN();
        }
        else if (this.state == __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */].METHODS) {
            this.onClickCancel();
        }
        else if (this.state == __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */].OTP) {
            this.isLoading = true;
            this.otpVerifyChild.onSubmit();
        }
    };
    DialogPinComponent.prototype.validatePIN = function () {
        var _this = this;
        this.errorMessage = '';
        if (__WEBPACK_IMPORTED_MODULE_4_app_model_constant__["P" /* BlacklistPIN */].includes(this.pinChild.rawPin)) {
            setTimeout(function () {
                _this.errorMessage = _this.translatePipe.transform('pin-too-weak');
            }, 0);
            return;
        }
        this.inputPin = this.pinChild.rawPin;
        this.state = __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */].CONFIRM_SET_PIN;
        this.backButtonMode = 'back';
    };
    DialogPinComponent.prototype.validateConfirmPIN = function () {
        var _this = this;
        this.errorMessage = '';
        if (this.inputPin != this.pinChild.rawPin) {
            setTimeout(function () {
                _this.errorMessage = _this.translatePipe.transform('set-pin-not-matched');
            }, 0);
            throw new Error(this.errorMessage);
        }
    };
    DialogPinComponent.prototype.verifyPIN = function () {
        var _this = this;
        if (this.pinInputForm.valid && !this.pinLocked) {
            this.isLoading = true;
            var rawPin = this.pinChild.rawPin;
            this.verifyPinSubscription && this.verifyPinSubscription.unsubscribe();
            this.verifyPinSubscription = this.pinService.verifyPIN(rawPin)
                .subscribe(function (res) {
                if (res && res.verifiedToken) {
                    _this.dialogRef.close({ verifiedToken: res.verifiedToken });
                }
                _this.isLoading = false;
            }, function (error) {
                if (error.status === 403) {
                    _this.errorMessage = _this.translatePipe.transform('pin-locked');
                    _this.pinLocked = true;
                }
                else {
                    _this.errorMessage = _this.translatePipe.transform('pin-code-incorrect');
                    if (error && error.json() && error.json().errors && error.json().errors.length > 0) {
                        _this.handleInvalidPIN(error.json().errors[0].message);
                    }
                }
                _this.isLoading = false;
            });
        }
    };
    DialogPinComponent.prototype.handleInvalidPIN = function (message) {
        var match = message.match(/\{(\d+)\}/);
        if (match && match[1]) {
            var remaining = +match[1];
            if (remaining <= 3) {
                this.errorMessage = this.translatePipe.transform('pin-remaining-attempts').replace('{x}', remaining);
            }
        }
    };
    DialogPinComponent.prototype.resetError = function () {
        this.errorMessage = undefined;
        this.pinLocked = false;
    };
    DialogPinComponent.prototype.onClickBack = function () {
        if (this.accountLocked) {
            this.userService.logout();
            return;
        }
        if (this.state == __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */].CONFIRM_SET_PIN) {
            this.state = __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */].SET_PIN;
            if (this.requiredSetPin) {
                this.backButtonMode = undefined;
            }
            else {
                this.backButtonMode = 'cancel';
            }
        }
        else if (this.state == __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */].OTP) {
            this.state = __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */].METHODS;
            this.backButtonMode = undefined;
        }
    };
    DialogPinComponent.prototype.onClickCancel = function () {
        var _this = this;
        if (this.accountLocked) {
            this.dialogRef.afterClosed().take(1).subscribe(function () {
                _this.userService.logout();
            });
        }
        this.dialogRef.close({ close: true });
    };
    Object.defineProperty(DialogPinComponent.prototype, "pinInputForm", {
        get: function () {
            if (this.pinChild) {
                return this.pinChild.pinInputForm;
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogPinComponent.prototype, "otpInputForm", {
        get: function () {
            if (this.otpVerifyChild) {
                return this.otpVerifyChild.otpInputForm;
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    DialogPinComponent.prototype.setupPIN = function (verifiedToken) {
        var _this = this;
        this.isLoading = true;
        this.pinService.getPublicKey().flatMap(function (pk) {
            return _this.pinService.setupPIN(_this.inputPin, pk.token, pk.key, verifiedToken);
        }).subscribe(function (res) {
            if (res.verification) {
                _this.needVerifyOtp(res);
            }
            else {
                _this.dialogRef.afterClosed().take(1).subscribe(function () {
                    _this.showDialogSetupPinSuccess();
                });
                _this.dialogRef.close();
            }
        }, function (error) {
            _this.dialogRef.afterClosed().take(1).subscribe(function () {
                _this.showDialogError(_this.translatePipe.transform('system-error'));
            });
            _this.dialogRef.close();
        });
    };
    DialogPinComponent.prototype.needVerifyOtp = function (res) {
        this.otpToken = res.verification.token;
        this.otpMethods = res.verification.methods;
        this.state = __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */].METHODS;
        this.backButtonMode = undefined;
        this.isLoading = false;
        this.cd.detectChanges();
    };
    DialogPinComponent.prototype.showDialogSetupPinSuccess = function () {
        var _this = this;
        var successPopupRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */]);
        successPopupRef.afterClosed().take(1).subscribe(function () {
            var queryParam = new URLSearchParams(window.location.search);
            queryParam.delete('set_pin');
            _this.router.navigateByUrl("/setting?" + queryParam.toString(), { replaceUrl: true });
        });
        successPopupRef.componentInstance.imageSrc = '/assets/images/icons/icon-setup-pin-success.png';
        successPopupRef.componentInstance.alertHeader = this.translatePipe.transform('setup-pin-success');
        successPopupRef.componentInstance.autoClose = 10;
    };
    DialogPinComponent.prototype.showDialogError = function (message, subText) {
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_9__dialog_error_dialog_error_component__["a" /* DialogErrorComponent */]);
        dialogRef.componentInstance.text = message;
        if (subText) {
            dialogRef.componentInstance.subText = subText;
        }
        return dialogRef;
    };
    DialogPinComponent.prototype.onVerifiedOtp = function (event) {
        this.setupPIN(event.verifiedToken);
    };
    DialogPinComponent.prototype.onOtpStateChange = function (event) {
        this.state = event;
        if (event == __WEBPACK_IMPORTED_MODULE_10_app_components_verify_otp_otp_state__["a" /* OTP_STATE */].METHODS) {
            this.backButtonMode = undefined;
        }
        else if (event == __WEBPACK_IMPORTED_MODULE_10_app_components_verify_otp_otp_state__["a" /* OTP_STATE */].OTP) {
            this.backButtonMode = 'back';
        }
        else if (event == __WEBPACK_IMPORTED_MODULE_10_app_components_verify_otp_otp_state__["a" /* OTP_STATE */].SESSION_EXPIRE) {
            this.backButtonMode = 'cancel';
        }
    };
    DialogPinComponent.prototype.onAccountLocked = function () {
        this.accountLocked = true;
    };
    return DialogPinComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])('pinChild'),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3__pin_pin_component__["a" /* PinComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__pin_pin_component__["a" /* PinComponent */]) === "function" && _a || Object)
], DialogPinComponent.prototype, "pinChild", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])('otpVerifyChild'),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_12_app_components_verify_otp_verify_otp_component__["a" /* VerifyOtpComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_12_app_components_verify_otp_verify_otp_component__["a" /* VerifyOtpComponent */]) === "function" && _b || Object)
], DialogPinComponent.prototype, "otpVerifyChild", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_11__pin_state__["a" /* PIN_STATE */]) === "function" && _c || Object)
], DialogPinComponent.prototype, "state", void 0);
DialogPinComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
        selector: 'act-dialog-pin',
        template: __webpack_require__(1063),
        styles: [__webpack_require__(928)]
    }),
    __metadata("design:paramtypes", [typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_5__angular_router__["b" /* ActivatedRoute */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__angular_router__["b" /* ActivatedRoute */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_pin_pin_service__["a" /* PinService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_pin_pin_service__["a" /* PinService */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _h || Object, typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_13_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_13_app_services_user_user_service__["a" /* UserService */]) === "function" && _j || Object, typeof (_k = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */]) === "function" && _k || Object, typeof (_l = typeof __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectorRef"]) === "function" && _l || Object, typeof (_m = typeof __WEBPACK_IMPORTED_MODULE_5__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__angular_router__["c" /* Router */]) === "function" && _m || Object])
], DialogPinComponent);

var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
//# sourceMappingURL=dialog-pin.component.js.map

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_text_mask_addons_dist_createNumberMask__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_text_mask_addons_dist_createNumberMask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_text_mask_addons_dist_createNumberMask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogQuotationFormComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};








var DialogQuotationFormComponent = (function () {
    function DialogQuotationFormComponent(dialogRef, appConfigService, utilitiesService, fb, document) {
        this.dialogRef = dialogRef;
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.fb = fb;
        this.document = document;
        this.serviceTypesConstant = __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["t" /* MiceServiceTypes */].EN;
        this.isSubmitted = false;
        this.maskPhoneNumber = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
        this.maskBudgetNumber = __WEBPACK_IMPORTED_MODULE_6_text_mask_addons_dist_createNumberMask___default()({
            prefix: '',
            integerLimit: 8,
            includeThousandsSeparator: true,
        });
        this.maskAttendeesNumber = __WEBPACK_IMPORTED_MODULE_6_text_mask_addons_dist_createNumberMask___default()({
            prefix: '',
            integerLimit: 4,
            includeThousandsSeparator: true,
        });
    }
    DialogQuotationFormComponent.prototype.ngOnInit = function () {
        this.setDefaultForm();
        this.setDropDownServiceTypeDisplay(this.appConfigService.getLanguage());
        this.utilitiesService.lockBodyMice();
    };
    DialogQuotationFormComponent.prototype.ngOnDestroy = function () {
        this.utilitiesService.unlockBodyMice();
    };
    DialogQuotationFormComponent.prototype.setDefaultForm = function () {
        this.quotationForm = this.fb.group({
            serviceType: ['', __WEBPACK_IMPORTED_MODULE_2__angular_forms__["Validators"].required],
            destination: [''],
            budget: ['', [this.validateZeroInput]],
            attendees: ['', [this.validateZeroInput]],
            startDate: [null],
            endDate: [null],
            remark: [''],
            contactName: ['', [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["Validators"].required, this.noWhitespaceValidator]],
            companyName: ['', [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["Validators"].required, this.noWhitespaceValidator]],
            phone: ['', [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["Validators"].required, this.noWhitespaceValidator, __WEBPACK_IMPORTED_MODULE_2__angular_forms__["Validators"].minLength(9)]],
            email: ['', [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["Validators"].required, __WEBPACK_IMPORTED_MODULE_2__angular_forms__["Validators"].pattern(/[a-z0-9]+[_a-z0-9\.-]*[a-z0-9]+@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})/i)]],
        });
    };
    DialogQuotationFormComponent.prototype.setDropDownServiceTypeDisplay = function (lang) {
        if (lang === 'th') {
            this.serviceTypes = __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["t" /* MiceServiceTypes */].TH;
        }
        else {
            this.serviceTypes = __WEBPACK_IMPORTED_MODULE_5_app_model_constant__["t" /* MiceServiceTypes */].EN;
        }
    };
    DialogQuotationFormComponent.prototype.noWhitespaceValidator = function (formControl) {
        var isWhitespace = (formControl.value || '').trim().length === 0;
        return !isWhitespace ? null : { 'whitespace': true };
    };
    DialogQuotationFormComponent.prototype.validateZeroInput = function (formControl) {
        var isZero = formControl.value === '0';
        return !isZero ? null : { 'zero': true };
    };
    DialogQuotationFormComponent.prototype.closeDialog = function () {
        this.dialogRef.close({ status: false });
    };
    DialogQuotationFormComponent.prototype.onSubmit = function () {
        if (this.quotationForm.valid) {
            this.quotationModel = this.quotationForm.value;
            this.quotationModel.destination = this.quotationModel.destination.trim();
            this.quotationModel.remark = this.quotationModel.remark.trim();
            this.quotationModel.contactName = this.quotationModel.contactName.trim();
            this.quotationModel.companyName = this.quotationModel.companyName.trim();
            this.quotationModel.email = this.quotationModel.email.trim();
            this.quotationModel.lang = this.appConfigService.getLanguage();
            this.quotationModel.serviceType = this.serviceTypesConstant[this.quotationForm.get('serviceType').value];
            this.quotationModel.attendees = null;
            this.quotationModel.budget = null;
            if (this.quotationForm.get('attendees').value.trim() !== '') {
                this.quotationModel.attendees = this.transformStringWithSeperatorToNumber(this.quotationForm.get('attendees').value, ',');
            }
            if (this.quotationForm.get('budget').value.trim() !== '') {
                this.quotationModel.budget = this.transformStringWithSeperatorToNumber(this.quotationForm.get('budget').value, ',');
            }
            this.dialogRef.close({ status: true, data: this.quotationModel });
        }
        this.isSubmitted = true;
    };
    DialogQuotationFormComponent.prototype.transformStringWithSeperatorToNumber = function (value, seperator) {
        var result = '';
        var input = value.split(seperator);
        input.forEach(function (data) {
            result += data;
        });
        return Number(result);
    };
    return DialogQuotationFormComponent;
}());
DialogQuotationFormComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-quotation-form',
        template: __webpack_require__(1065),
        styles: [__webpack_require__(930)]
    }),
    __param(4, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_4__angular_common__["c" /* DOCUMENT */])),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_2__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_forms__["FormBuilder"]) === "function" && _d || Object, Object])
], DialogQuotationFormComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=dialog-quotation-form.component.js.map

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogRoomNoteDescriptionComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};


var DialogRoomNoteDescriptionComponent = (function () {
    function DialogRoomNoteDescriptionComponent(data) {
        if (data === void 0) { data = ''; }
        this.data = data;
    }
    DialogRoomNoteDescriptionComponent.prototype.ngOnInit = function () {
    };
    return DialogRoomNoteDescriptionComponent;
}());
DialogRoomNoteDescriptionComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-room-note-description',
        template: __webpack_require__(1066),
        styles: [__webpack_require__(931)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [String])
], DialogRoomNoteDescriptionComponent);

//# sourceMappingURL=dialog-room-note-description.component.js.map

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogRoomNoteComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};


var DialogRoomNoteComponent = (function () {
    function DialogRoomNoteComponent(data) {
        if (data === void 0) { data = []; }
        this.data = data;
    }
    DialogRoomNoteComponent.prototype.ngOnInit = function () {
    };
    return DialogRoomNoteComponent;
}());
DialogRoomNoteComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-room-note',
        template: __webpack_require__(1067),
        styles: [__webpack_require__(932)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [Array])
], DialogRoomNoteComponent);

//# sourceMappingURL=dialog-room-note.component.js.map

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentChannelSelectBoxComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var PaymentChannelSelectBoxComponent = PaymentChannelSelectBoxComponent_1 = (function () {
    function PaymentChannelSelectBoxComponent(utilitiesService, cdr) {
        this.utilitiesService = utilitiesService;
        this.cdr = cdr;
        this.setElementIdPage = 'payment-select-box';
        this.optionList = [];
        this.placeHolder = 'Please select';
        this.error = false;
        this.onSelectPaymentChannel = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.paymentChannelType = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["l" /* PaymentChannelType */];
        this.Language = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["a" /* Language */];
        this.isOpenMenu = false;
    }
    PaymentChannelSelectBoxComponent.prototype.ngOnInit = function () {
        this.isMobile = this.utilitiesService.isMobile();
    };
    PaymentChannelSelectBoxComponent.prototype.ngAfterViewInit = function () {
        if (document.getElementById(this.setElementIdPage + "-select-box").clientWidth === 0) {
            this.selectBoxWidth = window.innerWidth - 18 + 'px';
        }
        else {
            this.selectBoxWidth = (document.getElementById(this.setElementIdPage + "-select-box").clientWidth + 2) + 'px';
        }
        this.cdr.detectChanges();
    };
    PaymentChannelSelectBoxComponent.prototype.writeValue = function (value) {
        if (value && this.optionList && this.optionList.length > 0) {
            var option = this.optionList.find(function (f) { return f.value === value; });
            this.onSelect(option);
        }
    };
    PaymentChannelSelectBoxComponent.prototype.registerOnChange = function (onChange) {
        this.onChange = onChange;
    };
    PaymentChannelSelectBoxComponent.prototype.registerOnTouched = function (onTouch) {
        this.onTouch = onTouch;
    };
    PaymentChannelSelectBoxComponent.prototype.onSelect = function (option) {
        if (option !== this.currentOption) {
            this.currentOption = option;
            this.onSelectPaymentChannel.emit(option.value);
        }
    };
    PaymentChannelSelectBoxComponent.prototype.onOpenMenu = function () {
        this.onTouch(true);
        this.isOpenMenu = true;
    };
    PaymentChannelSelectBoxComponent.prototype.onCloseMenu = function () {
        this.isOpenMenu = false;
    };
    PaymentChannelSelectBoxComponent.prototype.onScrollTo = function () {
        this.selectBox.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    return PaymentChannelSelectBoxComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], PaymentChannelSelectBoxComponent.prototype, "setElementIdPage", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Array)
], PaymentChannelSelectBoxComponent.prototype, "optionList", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], PaymentChannelSelectBoxComponent.prototype, "placeHolder", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], PaymentChannelSelectBoxComponent.prototype, "error", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], PaymentChannelSelectBoxComponent.prototype, "onSelectPaymentChannel", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('selectBox'),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _b || Object)
], PaymentChannelSelectBoxComponent.prototype, "selectBox", void 0);
PaymentChannelSelectBoxComponent = PaymentChannelSelectBoxComponent_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-payment-channel-select-box',
        template: __webpack_require__(1077),
        styles: [__webpack_require__(942)],
        providers: [
            {
                provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
                useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return PaymentChannelSelectBoxComponent_1; }),
                multi: true
            }
        ]
    }),
    __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _d || Object])
], PaymentChannelSelectBoxComponent);

var PaymentChannelSelectBoxComponent_1, _a, _b, _c, _d;
//# sourceMappingURL=payment-channel-select-box.component.js.map

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartInfoModel; });
/* unused harmony export CartCharacterDetailModel */
/* unused harmony export CartLineItemsModel */
/* unused harmony export CartSpecialTermsConditions */
var CartInfoModel = (function () {
    function CartInfoModel() {
    }
    return CartInfoModel;
}());

var CartCharacterDetailModel = (function () {
    function CartCharacterDetailModel() {
    }
    return CartCharacterDetailModel;
}());

var CartLineItemsModel = (function () {
    function CartLineItemsModel() {
    }
    return CartLineItemsModel;
}());

var CartSpecialTermsConditions = (function () {
    function CartSpecialTermsConditions() {
    }
    return CartSpecialTermsConditions;
}());

//# sourceMappingURL=cart-info-model.js.map

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environments_environment__ = __webpack_require__(22);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MiceService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var MiceService = (function () {
    function MiceService(actHttpService) {
        this.actHttpService = actHttpService;
    }
    MiceService.prototype.sendQuotation = function (data) {
        var url = __WEBPACK_IMPORTED_MODULE_2_environments_environment__["a" /* environment */].endpoint.miceQuotation;
        return this.actHttpService.rawPost(url, data)
            .map(function (res) { return res.json(); });
    };
    MiceService.prototype.getGallery = function () {
        return this.actHttpService.rawGet('../../../assets/mice/dataGallery.json')
            .map(function (res) { return res.json(); });
    };
    return MiceService;
}());
MiceService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object])
], MiceService);

var _a;
//# sourceMappingURL=mice.service.js.map

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_model_search_form_model__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__product_poi_payload__ = __webpack_require__(572);
/* unused harmony export ProductNearByPayload */
/* unused harmony export FilterNearBy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PriceRange; });
/* unused harmony export Room */
/* unused harmony export Sort */


var ProductNearByPayload = (function () {
    function ProductNearByPayload(productNearBy) {
        if (productNearBy === void 0) { productNearBy = undefined; }
        if (productNearBy) {
            this.langId = productNearBy.langId;
            this.categoryId = 3;
            this.currencyId = 1;
            this.productId = productNearBy.productId;
            this.destinationId = productNearBy.destinationId;
            this.filter = new FilterNearBy(productNearBy);
            this.poi = new __WEBPACK_IMPORTED_MODULE_0_app_model_search_form_model__["c" /* PoiLocation */](productNearBy.latitude.valueOf(), productNearBy.longitude.valueOf());
        }
    }
    return ProductNearByPayload;
}());

var FilterNearBy = (function () {
    function FilterNearBy(productNearBy) {
        if (productNearBy === void 0) { productNearBy = undefined; }
        if (productNearBy) {
            this.distance = productNearBy.radius;
            this.priceRange = productNearBy.priceRange;
            this.checkIn = productNearBy.checkIn;
            this.checkOut = productNearBy.checkOut;
            this.rooms = productNearBy.rooms;
            this.pagination = new __WEBPACK_IMPORTED_MODULE_1__product_poi_payload__["a" /* Paginate */]();
            this.sort = new Sort();
        }
    }
    return FilterNearBy;
}());

var PriceRange = (function () {
    function PriceRange(min, max) {
        if (min === void 0) { min = undefined; }
        if (max === void 0) { max = undefined; }
        this.min = min;
        this.max = max;
    }
    return PriceRange;
}());

var Room = (function () {
    function Room() {
    }
    return Room;
}());

var Sort = (function () {
    function Sort(poiDistance) {
        if (poiDistance === void 0) { poiDistance = true; }
        this.poiDistance = poiDistance;
    }
    return Sort;
}());

//# sourceMappingURL=product-nearby-payload.js.map

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__environments_environment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__checkout_payload_create_order_payload__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__payload_campaign_model__ = __webpack_require__(573);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromotionService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var PromotionService = (function () {
    function PromotionService(actHttp, authService) {
        this.actHttp = actHttp;
        this.authService = authService;
        this.cookieName = 'stf';
    }
    PromotionService.prototype.saveTokenAfterLogin = function (loginResponse) {
        if (loginResponse.token && loginResponse.user) {
            this.authService.savePromotionToken(loginResponse);
        }
    };
    PromotionService.prototype.verifyPromotionCode = function (code, destination, companyId) {
        var _this = this;
        var payload = new __WEBPACK_IMPORTED_MODULE_4__checkout_payload_create_order_payload__["l" /* PromotionCode */]();
        payload.code = code;
        payload.destination = destination;
        payload.companyId = companyId;
        var options = this.actHttp.getRequestOptions(__WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["a" /* HeaderTypes */].AUTHORIZATION_RANDOM_STR, __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["b" /* ContentTypes */].JSON, JSON.stringify(payload));
        return this.actHttp.rawPost(__WEBPACK_IMPORTED_MODULE_2__environments_environment__["a" /* environment */].endpoint.validatePromotionCode, JSON.stringify(payload), options)
            .map(function (response) {
            var loginResponse = response.json().data;
            _this.saveTokenAfterLogin(loginResponse);
            return response.json();
        });
    };
    PromotionService.prototype.trackAdsEvent = function (campaignId, event) {
        var request = new __WEBPACK_IMPORTED_MODULE_5__payload_campaign_model__["a" /* CampaignTrackEventRequest */](event);
        var url = __WEBPACK_IMPORTED_MODULE_2__environments_environment__["a" /* environment */].endpoint.campaignTracking.replace('{campaignId}', campaignId.toString());
        return this.actHttp.post(url, request, this.actHttp.getRequestOptions());
    };
    return PromotionService;
}());
PromotionService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _b || Object])
], PromotionService);

var _a, _b;
//# sourceMappingURL=promotion.service.js.map

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_user_feature_user_feature_service__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_environments_properties__ = __webpack_require__(21);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountMenuComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var AccountMenuComponent = (function () {
    function AccountMenuComponent(userService, userFeatureService, appConfigService, authenticationService) {
        this.userService = userService;
        this.userFeatureService = userFeatureService;
        this.appConfigService = appConfigService;
        this.authenticationService = authenticationService;
        this.canChangePassword = true;
        this.showApprovalList = false;
        this.showPermission = true;
        this.showFleetMenu = true;
        this.isB2C = false;
        this.showPreApprovalRequester = false;
        this.showPreApprovalApprover = false;
        this.redirectURIV2 = __WEBPACK_IMPORTED_MODULE_6_environments_properties__["k" /* redirectURIV2 */];
        this.isB2C = this.authenticationService.isB2CClient();
    }
    AccountMenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.user = this.userService.getUser();
        this.canChangePassword = this.userFeatureService.canChangePassword();
        this.showApprovalList = this.userFeatureService.canShowApprovalList();
        this.showPreApprovalRequester = this.userFeatureService.enablePreApprovalRequester();
        this.showPreApprovalApprover = this.userFeatureService.enablePreApprovalApprover();
        this.showPermission =
            this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_4_app_model_constant__["b" /* FeatureType */].ALLOW_DISPLAY_PERMISSION_MENU, true) &&
                this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_4_app_model_constant__["b" /* FeatureType */].ALLOW_DISPLAY_PERMISSION_MENU, true).allow != undefined ?
                this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_4_app_model_constant__["b" /* FeatureType */].ALLOW_DISPLAY_PERMISSION_MENU, true).allow : this.showPermission;
        this.userSubRef = this.userService.getUserObs().subscribe(function (user) {
            _this.user = user;
        });
    };
    AccountMenuComponent.prototype.getLang = function () {
        return this.appConfigService.getLanguage();
    };
    AccountMenuComponent.prototype.getUserPicture = function () {
        var _userImg = this.user.PicturePath;
        if (_userImg == '/assets/img/avatar/nopicture.gif') {
            // Not have User Image
            return "/assets/images/header/user_default_display.png";
        }
        else {
            // Have User Image
            return _userImg;
        }
    };
    AccountMenuComponent.prototype.ngOnDestroy = function () {
        this.userSubRef ? this.userSubRef.unsubscribe() : '';
    };
    return AccountMenuComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('page'),
    __metadata("design:type", String)
], AccountMenuComponent.prototype, "currentPage", void 0);
AccountMenuComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'app-account-menu',
        template: __webpack_require__(1003),
        styles: [__webpack_require__(868)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_user_user_service__["a" /* UserService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__services_user_feature_user_feature_service__["a" /* UserFeatureService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_user_feature_user_feature_service__["a" /* UserFeatureService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _d || Object])
], AccountMenuComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=account-menu.component.js.map

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FilterDropdownComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var FilterDropdown = (function () {
    function FilterDropdown(id, name, rawValue) {
        this.id = id;
        this.name = name;
        this.rawValue = rawValue;
    }
    return FilterDropdown;
}());

var FilterDropdownComponent = FilterDropdownComponent_1 = (function () {
    function FilterDropdownComponent(elRef) {
        this.elRef = elRef;
        this.isShow = false;
        this.isDropUp = false;
        this.search = '';
        this.listShow = [];
        this.disabled = false;
        this.defaultName = '';
        this.isSetDefaultSelect = false;
    }
    FilterDropdownComponent.prototype.ngOnChanges = function (changes) {
        this.listShow = this.listInput;
        if ((!changes.error || (changes.error !== undefined && changes.error.currentValue)) && this.isSetDefaultSelect) {
            this.defaultSelect = this.defaultName;
        }
        this.name = this.name === undefined ? '' : this.name;
    };
    FilterDropdownComponent.prototype.ngOnInit = function () {
    };
    FilterDropdownComponent.prototype.writeValue = function (value) {
        this.value = value;
        if (this.value && this.listInput) {
            try {
                this.defaultSelect = this.listInput.find(function (x) { return x.id === value.id; }).name;
            }
            catch (e) {
                this.defaultSelect = this.defaultName;
            }
        }
    };
    FilterDropdownComponent.prototype.registerOnChange = function (onChange) {
        this.onChange = onChange;
    };
    FilterDropdownComponent.prototype.registerOnTouched = function (onTouch) {
        this.onTouch = onTouch;
    };
    FilterDropdownComponent.prototype.onClickDDL = function () {
        this.listShow = this.listInput;
        var isMobile = window.innerWidth <= 425;
        var menuHeight = isMobile ? (40 * 6) : (40 * 11);
        var windowHeight = window.innerHeight;
        var boundClientRect = this.elRef.nativeElement.getBoundingClientRect();
        var buttonPosition = boundClientRect.top;
        var buttonHeight = boundClientRect.height;
        this.isDropUp = windowHeight - buttonPosition < buttonHeight + menuHeight;
        this.isShow = !this.isShow;
    };
    FilterDropdownComponent.prototype.filterFunction = function () {
        var filter = this.search.trim().toUpperCase();
        this.listShow = this.listInput.filter(function (x) { return x.name.toUpperCase().includes(filter); });
    };
    FilterDropdownComponent.prototype.onSelect = function (value) {
        this.defaultSelect = value.name;
        this.isShow = false;
        this.search = '';
        this.filterFunction();
        this.onChange(value);
    };
    FilterDropdownComponent.prototype.onClick = function (event) {
        if (!this.elRef.nativeElement.contains(event.target) && !this.disabled) {
            this.isShow = false;
            this.search = '';
        }
    };
    FilterDropdownComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return FilterDropdownComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChildren"])('list'),
    __metadata("design:type", Object)
], FilterDropdownComponent.prototype, "list", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], FilterDropdownComponent.prototype, "defaultSelect", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Array)
], FilterDropdownComponent.prototype, "listInput", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], FilterDropdownComponent.prototype, "name", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], FilterDropdownComponent.prototype, "value", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], FilterDropdownComponent.prototype, "error", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], FilterDropdownComponent.prototype, "defaultName", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], FilterDropdownComponent.prototype, "isSetDefaultSelect", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('document:click', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FilterDropdownComponent.prototype, "onClick", null);
FilterDropdownComponent = FilterDropdownComponent_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-filter-dropdown',
        template: __webpack_require__(1026),
        styles: [__webpack_require__(891)],
        providers: [
            {
                provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
                useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FilterDropdownComponent_1; }),
                multi: true
            }
        ]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _a || Object])
], FilterDropdownComponent);

var FilterDropdownComponent_1, _a;
//# sourceMappingURL=filter-dropdown.component.js.map

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_mice_js_owl_carousel_js__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_mice_js_owl_carousel_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_mice_js_owl_carousel_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_mice_mice_model__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_environments_properties__ = __webpack_require__(21);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GalleryComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var GalleryComponent = (function () {
    function GalleryComponent(elementRef, utilitiesService) {
        this.elementRef = elementRef;
        this.utilitiesService = utilitiesService;
        this.galleryItems = new __WEBPACK_IMPORTED_MODULE_2__model_mice_mice_model__["a" /* GalleryList */]();
        this.imangePath = __WEBPACK_IMPORTED_MODULE_5_environments_properties__["f" /* imgUrl */] + "/mice/gallery/";
        this.modalSlideIndex = 0;
        this.showModalSlide = false;
        this.setTimeOut = null;
        this.isHidden = true;
    }
    Object.defineProperty(GalleryComponent.prototype, "_galleryItems", {
        set: function (value) {
            if (value) {
                this.galleryItems = value;
                this.initCarousel();
            }
        },
        enumerable: true,
        configurable: true
    });
    GalleryComponent.prototype.ngAfterViewInit = function () {
        this.initCarousel();
    };
    GalleryComponent.prototype.ngOnInit = function () { };
    GalleryComponent.prototype.initCarousel = function () {
        var _this = this;
        clearTimeout(this.setTimeOut);
        this.setTimeOut = setTimeout(function () {
            _this.owlCarousel = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".owl-carousel");
            _this.owlCarousel.owlCarousel({
                loop: true,
                nav: false,
                center: true,
                onInitialized: onInitialized,
                onTranslate: onTranslate,
                onTranslated: onTranslated,
                navText: ["", ""],
                responsive: {
                    0: {
                        items: 1,
                        nav: false,
                        touchDrag: true
                    },
                    492: {
                        items: 3,
                        nav: true,
                        dots: false,
                        autoWidth: true,
                        mouseDrag: false,
                        touchDrag: false
                    }
                }
            });
            _this.isHidden = false;
            function onInitialized(event) { }
            function onTranslate(event) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".owl-next").attr("disabled", true);
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".owl-prev").attr("disabled", true);
            }
            function onTranslated(event) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".owl-next").attr("disabled", false);
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".owl-prev").attr("disabled", false);
            }
            var self = _this;
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".owl-carousel").on("click", ".owl-item.cloned", function (event) {
                var cloneNodeId = event.currentTarget.childNodes[0].childNodes[1].id;
                var splipId = cloneNodeId.split("-");
                self.openModal(splipId[2]);
            });
        }, 3000);
    };
    GalleryComponent.prototype.setDetailByLanguage = function (lang) { };
    GalleryComponent.prototype.openModal = function (index) {
        this.modalGalery = this.galleryItems.data[index];
        if (this.modalGalery) {
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
            this.showModalSlide = true;
            this.modalSlideIndex = 0;
            this.modalCurrentSlide(this.modalSlideIndex);
        }
    };
    GalleryComponent.prototype.refreshOwlCarousel = function () {
        this.owlCarousel && this.owlCarousel.trigger("destroy.owl.carousel");
        this.initCarousel();
    };
    GalleryComponent.prototype.closeModal = function () {
        document.getElementsByTagName("body")[0].style.overflow = "inherit";
        this.showModalSlide = false;
    };
    GalleryComponent.prototype.modalPlusSlides = function (n) {
        this.modalSlideIndex = this.modalSlideIndex + n;
        if (this.modalSlideIndex >= this.modalGalery.gallery.length) {
            this.modalSlideIndex = 0;
        }
        if (this.modalSlideIndex < 0) {
            this.modalSlideIndex = this.modalGalery.gallery.length - 1;
        }
    };
    GalleryComponent.prototype.modalCurrentSlide = function (n) {
        this.modalSlideIndex = n;
    };
    GalleryComponent.prototype.ngOnDestroy = function () {
        this.owlCarousel && this.owlCarousel.trigger("destroy.owl.carousel");
        clearTimeout(this.setTimeOut);
    };
    return GalleryComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])("galleryItems"),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__model_mice_mice_model__["a" /* GalleryList */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__model_mice_mice_model__["a" /* GalleryList */]) === "function" && _a || Object),
    __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__model_mice_mice_model__["a" /* GalleryList */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__model_mice_mice_model__["a" /* GalleryList */]) === "function" && _b || Object])
], GalleryComponent.prototype, "_galleryItems", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", String)
], GalleryComponent.prototype, "lang", void 0);
GalleryComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
        selector: "act-gallery",
        template: __webpack_require__(1031),
        styles: [__webpack_require__(896)]
    }),
    __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_4__services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _d || Object])
], GalleryComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=gallery.component.js.map

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_model_products_product_detail_info_model__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_model_constant__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HotelRemarkInformationComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var HotelRemarkInformationComponent = (function () {
    function HotelRemarkInformationComponent(translate, appConfigService) {
        this.translate = translate;
        this.appConfigService = appConfigService;
        this.childPolicies = [];
        this.hotelRemarks = [];
        this.hotelRemarksDisplay = [];
        this.childPolicyDisplay = [];
    }
    Object.defineProperty(HotelRemarkInformationComponent.prototype, "setMinGuestAge", {
        set: function (minGuestAge) {
            if (this.minGuestAge && this.minGuestAge > 0) {
                this.minGuestAge = minGuestAge;
                this.minGuestDisplay = this.translate.transform('child-policy-min-guest-age');
                this.minGuestDisplay = this.minGuestDisplay.replace('{x}', this.minGuestAge.toString());
            }
            else {
                this.minGuestDisplay = this.translate.transform('child-policy-min-guest-age-all-age');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HotelRemarkInformationComponent.prototype, "setChildPolicies", {
        set: function (childPolicies) {
            if (childPolicies) {
                this.childPolicies = childPolicies;
                this.transformChildPolicyForDisplay();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HotelRemarkInformationComponent.prototype, "setHotelRemarks", {
        set: function (hotelRemarks) {
            if (hotelRemarks) {
                this.hotelRemarks = hotelRemarks;
                this.transformHotelRemarkForDisplay();
            }
        },
        enumerable: true,
        configurable: true
    });
    HotelRemarkInformationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.languageSubscription = this.appConfigService.getLanguageObs()
            .subscribe(function (lang) {
            _this.transformChildPolicyForDisplay();
            _this.transformHotelRemarkForDisplay();
            if (_this.minGuestAge > 0) {
                _this.minGuestDisplay = _this.translate.transform('child-policy-min-guest-age');
                _this.minGuestDisplay = _this.minGuestDisplay.replace('{x}', _this.minGuestAge.toString());
            }
            else {
                _this.minGuestDisplay = _this.translate.transform('child-policy-min-guest-age-all-age');
            }
        });
    };
    HotelRemarkInformationComponent.prototype.ngOnDestroy = function () {
        this.languageSubscription && this.languageSubscription.unsubscribe();
    };
    HotelRemarkInformationComponent.prototype.transformHotelRemarkForDisplay = function () {
        this.hotelRemarksDisplay = [];
        for (var i = 0; i < this.hotelRemarks.length; i++) {
            var remark = this.appConfigService.getLanguage() === __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["a" /* Language */].th ? this.hotelRemarks[i].th : this.hotelRemarks[i].en;
            if (remark != null) {
                var remarkModified = remark.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
                this.hotelRemarksDisplay.push(remarkModified);
            }
        }
    };
    HotelRemarkInformationComponent.prototype.transformChildPolicyForDisplay = function () {
        this.childPolicyDisplay = [];
        for (var i = 0; i < this.childPolicies.length; i++) {
            var childPolicy = new __WEBPACK_IMPORTED_MODULE_1_app_model_products_product_detail_info_model__["c" /* ChildPolicyDislay */]();
            if (this.childPolicies[i].isInfant) {
                childPolicy.policy = this.replaceFromTo('child-policy-infant-policy', this.childPolicies[i].ageFrom, this.childPolicies[i].ageTo);
                childPolicy.stayFree = this.translate.transform(this.childPolicies[i].isFree ? 'child-policy-free-stay-description' : 'child-policy-stay-description');
                childPolicy.description = this.translate.transform('child-policy-infant-description');
            }
            else {
                childPolicy.description = this.translate.transform('child-policy-adult-description');
                if (this.childPolicies[i].ageTo) {
                    childPolicy.policy = this.replaceFromTo('child-policy-child-policy', this.childPolicies[i].ageFrom, this.childPolicies[i].ageTo);
                    childPolicy.stayFree = this.translate.transform(this.childPolicies[i].isFree ? 'child-policy-free-stay-description' : 'child-policy-stay-description');
                }
                else {
                    childPolicy.policy = this.replaceFromTo('child-policy-adult-policy', this.childPolicies[i].ageFrom, this.childPolicies[i].ageTo);
                }
                childPolicy.description = this.translate.transform(this.childPolicies[i].isFree ? 'child-policy-free-description' : 'child-policy-description');
            }
            this.childPolicyDisplay.push(childPolicy);
        }
    };
    HotelRemarkInformationComponent.prototype.replaceFromTo = function (text, from, to) {
        var val = this.translate.transform(text);
        from !== undefined && (val = val.replace(/{from}/g, from));
        to !== undefined && (val = val.replace(/{to}/g, to));
        return val;
    };
    return HotelRemarkInformationComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('page'),
    __metadata("design:type", Object)
], HotelRemarkInformationComponent.prototype, "page", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('minGuestAge'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], HotelRemarkInformationComponent.prototype, "setMinGuestAge", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('childPolicies'),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], HotelRemarkInformationComponent.prototype, "setChildPolicies", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('hotelRemarks'),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], HotelRemarkInformationComponent.prototype, "setHotelRemarks", null);
HotelRemarkInformationComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-hotel-remark-information',
        template: __webpack_require__(1033),
        styles: [__webpack_require__(898)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object])
], HotelRemarkInformationComponent);

var _a, _b;
//# sourceMappingURL=hotel-remark-information.component.js.map

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_user_feature_user_feature_service__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dialog_switch_company_dialog_switch_company_component__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_services_authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_model_user_model__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_model_menu_companyFeatures__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modal_dialog_alert_dialog_alert_component__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_environments_properties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_services_fleet_fleet_service__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_services_currency_currency_service__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__dialog_switch_lang_currency_dialog_switch_lang_currency_component__ = __webpack_require__(248);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuBarComponent; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



















var MenuBarComponent = (function () {
    function MenuBarComponent(appConfigService, utilitiesService, userService, userFeatureService, authenticationService, dialog, router, activeRoute, fleetService, googleTagManagerService, currencyService) {
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.userService = userService;
        this.userFeatureService = userFeatureService;
        this.authenticationService = authenticationService;
        this.dialog = dialog;
        this.router = router;
        this.activeRoute = activeRoute;
        this.fleetService = fleetService;
        this.googleTagManagerService = googleTagManagerService;
        this.currencyService = currencyService;
        this.LANGUAGE = __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["a" /* Language */];
        this.useHomeV2 = __WEBPACK_IMPORTED_MODULE_15_environments_properties__["p" /* useHomeV2 */];
        this.redirectURIV2 = __WEBPACK_IMPORTED_MODULE_15_environments_properties__["k" /* redirectURIV2 */];
        this.languageList = [];
        this.companies = [];
        this.companyFeatures = [];
        this.displayMoreService = true;
        this.displayCoWorkingSpace = false;
        this.isShowCompanies = false;
        this.isMobileDisplayMenu = false;
        this.isfirstSection = false;
        this.isLogin = false;
        this.isShowListLanguageCurrency = false;
        this.showApprovalList = false;
        this.showPermission = true;
        this.showFleetMenu = true;
        this.showPreApprovalRequester = false;
        this.showPreApprovalApprover = false;
        this.allowBookWork = true;
        this.features = [
            __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS,
            __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET,
            __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_ROOM,
            __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT,
            __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_SHARE_BUDGET,
            __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["c" /* CompanyFeatureConfigType */].CONFIG_CHECKOUT_3,
            __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_CORPORATE_FLEET,
            __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT_CORPORATE_FLEET,
        ];
        this.theme = '';
        this.notFoundPage = false;
        this.showMenu = true;
        this.isShowCurrency = true;
        this.mobileToggleMenuBar = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"](); // tslint:disable-line
    }
    Object.defineProperty(MenuBarComponent.prototype, "firstLandingState", {
        set: function (firstLandingState) {
            this._firstLandingState = firstLandingState ? firstLandingState : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuBarComponent.prototype, "landingPageState", {
        set: function (landingPageState) {
            this._landingPageState = landingPageState ? landingPageState : '';
            this.isfirstSection = this._landingPageState === this._firstLandingState;
        },
        enumerable: true,
        configurable: true
    });
    MenuBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.languageList = this.appConfigService.getLanguageList();
        this.user = this.userService.getUser(false);
        if (this.user && this.user.companyId) {
            this.selectedCompanyId = this.user.companyId;
        }
        this.showApprovalList = this.userFeatureService.canShowApprovalList();
        this.displayFlight = __WEBPACK_IMPORTED_MODULE_15_environments_properties__["q" /* configFlight */].displayFlight && this.displayFlightFeature();
        this.displayCarRental = __WEBPACK_IMPORTED_MODULE_15_environments_properties__["r" /* configCarRental */].displayCarRental && this.displayCarRentalFeature();
        this.showPermission = this.displayPermissionMenuFeature();
        this.allowBookWork = this.isAllowBookWorkPurpose();
        this.showPreApprovalRequester = this.userFeatureService.enablePreApprovalRequester();
        this.showPreApprovalApprover = this.userFeatureService.enablePreApprovalApprover();
        var countService = 1; // default accommodation;
        this.displayFlight && countService++;
        this.displayCarRental && countService++;
        if (countService >= 3) {
            this.displayMoreService = true;
        }
        else if (countService == 2) {
            this.displayCoWorkingSpace = true;
            this.displayMoreService = true;
        }
        else {
            this.displayCoWorkingSpace = true;
            this.displayMoreService = false;
        }
        if (this.user) {
            if (this.user.ImageUser === null) {
                this.user_img = 'url("assets/images/header/user_default_display.png")';
            }
            else {
                this.user_img = "url(\"" + this.user.ImageUser + "\")";
            }
        }
        this.isLogin = this.user ? true : false;
        this.currentLanguage = this.appConfigService.getLanguage();
        this.tempLanguage = this.currentLanguage;
        this.currentCurrency = this.currencyService.getCurrencyCode();
        this.tempCurrency = this.currentCurrency;
        this.currencySubscription = this.currencyService.getCurrencyObs().subscribe(function (currency) {
            _this.currentCurrency = currency.currencyCode;
            _this.tempCurrency = _this.currentCurrency;
        });
        this.userSubscription = this.userService.getUserObs().subscribe(function (user) {
            _this.user = _this.userService.getUser(false);
        });
        this.activeRoute.queryParams.subscribe(function (params) {
            if (params.returnUrl) {
                _this.returnUrl = params.returnUrl;
            }
        });
        this.setLogoPath();
    };
    MenuBarComponent.prototype.ngOnDestroy = function () {
        this.utilitiesService.unlockBody();
        this.userSubscription && this.userSubscription.unsubscribe();
        this.userSettingSubscription && this.userSettingSubscription.unsubscribe();
        this.appConfigSubscription && this.appConfigSubscription.unsubscribe();
        this.authServiceSubscription && this.authServiceSubscription.unsubscribe();
        this.currencySubscription && this.currencySubscription.unsubscribe();
    };
    MenuBarComponent.prototype.goToTop = function (e) {
        this.goToHome(null);
        if (window.matchMedia('(max-width: 1024px)').matches) {
            var $body = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("html, body");
            $body.stop().animate({ scrollTop: 0 }, 500);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#fullpage').fullpage.moveTo(1);
        }
    };
    MenuBarComponent.prototype.goToHome = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_15_environments_properties__["p" /* useHomeV2 */]) {
            window.location.href = __WEBPACK_IMPORTED_MODULE_15_environments_properties__["k" /* redirectURIV2 */];
        }
        else {
            if (document.location.pathname !== '/') {
                this.router.navigateByUrl('/?lang=' + this.appConfigService.getLanguage());
            }
            if (window.matchMedia('(max-width: 767px)').matches) {
                this.handleBlurMenuBar();
            }
        }
    };
    MenuBarComponent.prototype.goToMice = function (e) {
        if (document.location.pathname !== '/mice') {
            this.router.navigateByUrl('/mice?lang=' + this.appConfigService.getLanguage());
        }
        if (window.matchMedia('(max-width: 767px)').matches) {
            this.handleBlurMenuBar();
        }
    };
    MenuBarComponent.prototype.goToMyBudget = function (e) {
        if (document.location.pathname !== '/permission') {
            this.router.navigateByUrl('/permission?lang=' + this.appConfigService.getLanguage());
        }
        if (window.matchMedia('(max-width: 767px)').matches) {
            this.handleBlurMenuBar();
        }
    };
    MenuBarComponent.prototype.goToFleetCard = function (e) {
        if (document.location.pathname !== '/fleet-card') {
            this.router.navigateByUrl('/fleet-card?lang=' + this.appConfigService.getLanguage());
        }
        if (window.matchMedia('(max-width: 767px)').matches) {
            this.handleBlurMenuBar();
        }
    };
    MenuBarComponent.prototype.goToProfile = function (e) {
        if (document.location.pathname !== '/profile') {
            this.router.navigateByUrl('/profile?lang=' + this.appConfigService.getLanguage());
        }
        if (window.matchMedia('(max-width: 767px)').matches) {
            this.handleBlurMenuBar();
        }
    };
    MenuBarComponent.prototype.goToBooking = function (e) {
        if (document.location.pathname !== '/booking') {
            this.router.navigateByUrl('/booking?lang=' + this.appConfigService.getLanguage());
        }
        if (window.matchMedia('(max-width: 767px)').matches) {
            this.handleBlurMenuBar();
        }
    };
    MenuBarComponent.prototype.goToApproval = function (e) {
        if (document.location.pathname !== '/approval') {
            this.router.navigateByUrl('/approval?lang=' + this.appConfigService.getLanguage());
        }
        if (window.matchMedia('(max-width: 767px)').matches) {
            this.handleBlurMenuBar();
        }
    };
    MenuBarComponent.prototype.goToShareBudget = function (e) {
        if (document.location.pathname !== '/share-budget-code') {
            this.router.navigateByUrl('/share-budget-code?lang=' + this.appConfigService.getLanguage());
        }
        if (window.matchMedia('(max-width: 767px)').matches) {
            this.handleBlurMenuBar();
        }
    };
    MenuBarComponent.prototype.goToSetting = function (e) {
        if (document.location.pathname !== '/setting') {
            this.router.navigateByUrl('/setting?lang=' + this.appConfigService.getLanguage());
        }
        if (window.matchMedia('(max-width: 767px)').matches) {
            this.handleBlurMenuBar();
        }
    };
    MenuBarComponent.prototype.getLang = function () {
        return this.appConfigService.getLanguage();
    };
    MenuBarComponent.prototype.handleToggleMenuBar = function () {
        this.isMobileDisplayMenu = !this.isMobileDisplayMenu;
        this.mobileToggleMenuBar.emit({ 'isMobileDisplayMenu': this.isMobileDisplayMenu });
        if (this.isMobileDisplayMenu) {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('html').addClass('-open-sidemenu');
            this.utilitiesService.lockBody();
        }
        else {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('html').removeClass('-open-sidemenu');
            this.utilitiesService.unlockBody();
        }
        this.user !== undefined && this.onGetUserCompanies();
    };
    MenuBarComponent.prototype.handleBlurMenuBar = function () {
        this.isMobileDisplayMenu = false;
        this.mobileToggleMenuBar.emit({ 'isMobileDisplayMenu': this.isMobileDisplayMenu });
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('html').removeClass('-open-sidemenu');
        this.utilitiesService.unlockBody();
    };
    MenuBarComponent.prototype.onClickLogin = function (e) {
        var queryParams = this.authenticationService.generateAuthorizeRequest();
        if (this.returnUrl) {
            queryParams = __assign({}, queryParams, { returnUrl: encodeURIComponent(this.returnUrl) });
        }
        window.location.href = encodeURI("" + __WEBPACK_IMPORTED_MODULE_15_environments_properties__["o" /* accountFrontend */] + this.utilitiesService.objectToQueryString(queryParams));
    };
    MenuBarComponent.prototype.handleShowLanguageCurrency = function (show) {
        var _this = this;
        this.isShowListLanguageCurrency = show;
        if (this.isShowListLanguageCurrency) {
            this.currencyList = this.currencyService.getCurrencyList();
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.side-menu-language-currency-overlay').addClass('-open');
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.side-menu-language-currency-container').addClass('-open-language-currency');
            });
        }
        else {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.side-menu-language-currency-container').removeClass('-open-language-currency');
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.side-menu-language-currency-overlay').removeClass('-open');
                _this.tempLanguage = _this.currentLanguage;
                _this.tempCurrency = _this.currentCurrency;
            }, 400);
        }
    };
    MenuBarComponent.prototype.handleChangeLanguage = function (languageCode) {
        this.tempLanguage = languageCode;
    };
    MenuBarComponent.prototype.handleChangeCurrency = function (currencyCode) {
        this.tempCurrency = currencyCode;
    };
    MenuBarComponent.prototype.handleSubmitLanguageCurrency = function () {
        this.appConfigService.setLanguage(this.tempLanguage);
        this.currencyService.setCurrency(this.tempCurrency);
        this.updateUserSetting(this.tempLanguage, this.tempCurrency);
        this.currentLanguage = this.tempLanguage;
        this.handleShowLanguageCurrency(false);
        this.handleToggleMenuBar();
    };
    MenuBarComponent.prototype.handleLogoutButton = function (e) {
        this.userService.logout();
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('html').removeClass('-open-sidemenu');
    };
    MenuBarComponent.prototype.onClickCompany = function (companyId) {
        var _this = this;
        var user = new __WEBPACK_IMPORTED_MODULE_11_app_model_user_model__["b" /* UserModel */]();
        user.companyId = companyId;
        var companyFeaturesDetail = new __WEBPACK_IMPORTED_MODULE_13_app_model_menu_companyFeatures__["a" /* CompanyFeaturesDetail */];
        if (companyId !== this.selectedCompanyId) {
            this.authServiceSubscription && this.authServiceSubscription.unsubscribe();
            this.authServiceSubscription = this.authenticationService.getUserFeature(null, user, this.features).subscribe(function (features) {
                companyFeaturesDetail.companyId = companyId;
                companyFeaturesDetail.companyTitleTh = _this.companies.find(function (f) { return f.companyId === companyId; }).companyTitleTh;
                companyFeaturesDetail.companyTitleEn = _this.companies.find(function (f) { return f.companyId === companyId; }).companyTitleEn;
                features.map(function (f) {
                    switch (f.feature) {
                        case __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS:
                            companyFeaturesDetail.paymentMethod = f.allow ? 'CREDIT_TERMS' : 'CREDIT_CARD';
                            companyFeaturesDetail.allowCreditTerm = f.allow ? f.allow : null;
                            break;
                        case __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET:
                            companyFeaturesDetail.limitBudget = f.allow;
                            companyFeaturesDetail.normalBudget = f.allow && f.data && f.data.amount ? f.data.amount : null;
                            companyFeaturesDetail.normalBudgetPerMonth = f.allow && f.data && f.data.amountPerMonth ? f.data.amountPerMonth : null;
                            companyFeaturesDetail.normalBudgetPerYear = f.allow && f.data && f.data.amountPerYear ? f.data.amountPerYear : null;
                            companyFeaturesDetail.normalBudgetUnlimited = f.allow && f.data && f.data.budgetUnlimited;
                            companyFeaturesDetail.normalCoBudget = f.allow && f.data && f.data.coBudget ? f.data.coBudget : null;
                            companyFeaturesDetail.normalCoBudgetUnlimited = f.allow && f.data && f.data.coBudgetUnlimited != null ? f.data.coBudgetUnlimited : null;
                            if (f.allow && f.data && f.data.travelPolicyList) {
                                companyFeaturesDetail.travelPolicyList = f.data.travelPolicyList;
                            }
                            else {
                                companyFeaturesDetail.travelPolicyList = null;
                            }
                            break;
                        case __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["c" /* CompanyFeatureConfigType */].CONFIG_CHECKOUT_3:
                            companyFeaturesDetail.taxAddress = _this.getLang() === 'th' ? f.data.taxAddressTh : f.data.taxAddressEn;
                            companyFeaturesDetail.taxId = f.data.taxId;
                            companyFeaturesDetail.taxName = _this.getLang() === 'th' ? f.data.taxNameTh : f.data.taxNameEn;
                            break;
                        case __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_ROOM:
                            companyFeaturesDetail.allowLimitRoom = f.allow ? f.allow : null;
                            companyFeaturesDetail.limitRoom = f.data.quantity;
                            break;
                        case __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT:
                            companyFeaturesDetail.multiPayment = f.allow ? f.allow : null;
                            break;
                        case __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_SHARE_BUDGET:
                            companyFeaturesDetail.shareBudget = f.allow ? f.allow : null;
                            break;
                        case __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_CORPORATE_FLEET:
                            companyFeaturesDetail.allowCorporateFleet = f.allow ? f.allow : null;
                            break;
                        case __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_MULTI_PAYMENT_CORPORATE_FLEET:
                            companyFeaturesDetail.allowMultiPaymentCorporateFleet = f.allow ? f.allow : null;
                            break;
                    }
                });
                _this.dialog.open(__WEBPACK_IMPORTED_MODULE_9__dialog_switch_company_dialog_switch_company_component__["a" /* DialogSwitchCompanyComponent */], {
                    data: companyFeaturesDetail
                }).afterClosed().subscribe(function (res) {
                    if (res && res === 'success') {
                        _this.selectedCompanyId = companyId;
                    }
                    _this.handleBlurMenuBar();
                });
            }, function (error) {
                var dialogAlertRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_14__modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */]);
                dialogAlertRef.componentInstance.alertText = _this.appConfigService.getTranslate('system-error');
                dialogAlertRef.componentInstance.imageSrc = '/assets/images/icons/icon-failed.png';
                dialogAlertRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-failed.png';
            });
        }
        else {
            this.handleBlurMenuBar();
        }
    };
    MenuBarComponent.prototype.onGetUserCompanies = function () {
        var _this = this;
        this.userSubscription && this.userSubscription.unsubscribe();
        this.userSubscription = this.userService.getAllCompanyUser().subscribe(function (companies) {
            _this.isShowCompanies = true;
            _this.companies = companies;
            _this.isShowCompanies = _this.companies.length !== 0;
        });
    };
    MenuBarComponent.prototype.setLogoPath = function () {
        var _a = this.appConfigService.getActLogoPath(), ActLogoPath = _a.ActLogoPath, ActLogoWhitePath = _a.ActLogoWhitePath, ActLogoMobilePath = _a.ActLogoMobilePath;
        var _b = this.appConfigService.getActDefaultLogoPath(), ActDefaultLogoPath = _b.ActDefaultLogoPath, ActDefaultLogoWhitePath = _b.ActDefaultLogoWhitePath, ActDefaultLogoMobilePath = _b.ActDefaultLogoMobilePath;
        this.logoPath = ActLogoPath;
        this.logoWhitePath = ActLogoWhitePath;
        this.logoMobilePath = ActLogoMobilePath;
        this.ACT_LOGO_DEFAULT = ActDefaultLogoPath;
        this.ACT_LOGO_DEFAULT_WHITE = ActDefaultLogoWhitePath;
        this.ACT_LOGO_DEFAULT_MOBILE = ActDefaultLogoMobilePath;
    };
    MenuBarComponent.prototype.onClickFlight = function () {
        var userInfo = this.authenticationService.getUserInfo();
        var redirectUrl = __WEBPACK_IMPORTED_MODULE_15_environments_properties__["q" /* configFlight */].redirectURI + (!!userInfo.companyId ? "?companyId=" + userInfo.companyId : "");
        window.open(redirectUrl, '_blank');
    };
    MenuBarComponent.prototype.onClickCarRental = function () {
        var userInfo = this.authenticationService.getUserInfo();
        var redirectUrl = __WEBPACK_IMPORTED_MODULE_15_environments_properties__["r" /* configCarRental */].redirectURI + (!!userInfo.companyId ? "?companyId=" + userInfo.companyId : "");
        window.open(redirectUrl, '_blank');
    };
    MenuBarComponent.prototype.displayCarRentalFeature = function () {
        var allowCarRentalCreditTerms = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_RENT_CAR_CREDIT_TERMS, true);
        var allowCarRentalOtherPayment = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_RENT_CAR_OTHER_PAYMENTS, true);
        return (allowCarRentalCreditTerms && allowCarRentalCreditTerms.allow) || (allowCarRentalOtherPayment && allowCarRentalOtherPayment.allow);
    };
    MenuBarComponent.prototype.displayFlightFeature = function () {
        var allowBookFlight = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_BOOK_FLIGHT, true);
        return allowBookFlight && allowBookFlight.allow;
    };
    MenuBarComponent.prototype.displayPermissionMenuFeature = function () {
        var featureAllowDisplayPermission = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_DISPLAY_PERMISSION_MENU, true);
        return featureAllowDisplayPermission && featureAllowDisplayPermission.allow !== undefined ? featureAllowDisplayPermission.allow : this.showPermission;
    };
    MenuBarComponent.prototype.isAllowBookWorkPurpose = function () {
        var featureAllowBookWorkPurpose = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_12_app_model_constant__["b" /* FeatureType */].ALLOW_BOOK_WORK_PURPOSE, true);
        return featureAllowBookWorkPurpose && featureAllowBookWorkPurpose.allow !== undefined ? featureAllowBookWorkPurpose.allow : this.allowBookWork;
    };
    MenuBarComponent.prototype.openTabCoWorkingSpace = function () {
        this.googleTagManagerService.emitEvent('Co-working space', 'click', 'click', 1, 'click menu');
        if (this.appConfigService.getLanguage() == 'th') {
            window.open('https://www.truespaceth.com/meeting_ascend_th/');
        }
        else {
            window.open('https://www.truespaceth.com/en/meeting_ascend_en/');
        }
    };
    MenuBarComponent.prototype.openDialogLanguageCurrency = function () {
        var _this = this;
        this.dialogSwitchLanguageCurrencySubscription && this.dialogSwitchLanguageCurrencySubscription.unsubscribe();
        this.dialogSwitchLanguageCurrencySubscription = this.dialog.open(__WEBPACK_IMPORTED_MODULE_18__dialog_switch_lang_currency_dialog_switch_lang_currency_component__["a" /* DialogSwitchLangCurrencyComponent */]).afterClosed().subscribe(function (res) {
            if (res) {
                _this.currentLanguage = res.language;
                _this.appConfigService.setLanguage(res.language);
                _this.currencyService.setCurrency(res.currency);
                _this.updateUserSetting(res.language, res.currency);
            }
        });
    };
    MenuBarComponent.prototype.updateUserSetting = function (language, currency) {
        if (this.isLogin) {
            var request = {
                lang: language,
                currency: currency,
            };
            this.userSettingSubscription && this.userSettingSubscription.unsubscribe();
            this.userSettingSubscription = this.userService.updateUserSetting(this.user.userId, request).subscribe({
                next: function (response) { },
                error: function (error) { }
            });
        }
        this.authenticationService.saveLanguageCurrencyCookie(language, currency);
    };
    return MenuBarComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Object)
], MenuBarComponent.prototype, "theme", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Object)
], MenuBarComponent.prototype, "notFoundPage", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Object)
], MenuBarComponent.prototype, "showMenu", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Object)
], MenuBarComponent.prototype, "isShowCurrency", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('firstLandingState'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], MenuBarComponent.prototype, "firstLandingState", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('landingPageState'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], MenuBarComponent.prototype, "landingPageState", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])('onMobileToggleMenuBar'),
    __metadata("design:type", Object)
], MenuBarComponent.prototype, "mobileToggleMenuBar", void 0);
MenuBarComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
        selector: 'app-menu-bar',
        template: __webpack_require__(1039),
        styles: [__webpack_require__(904)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_8_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_user_user_service__["a" /* UserService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_6__services_user_feature_user_feature_service__["a" /* UserFeatureService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6__services_user_feature_user_feature_service__["a" /* UserFeatureService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_10_app_services_authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_10_app_services_authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_4__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__angular_material__["d" /* MdDialog */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_5__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__angular_router__["c" /* Router */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_5__angular_router__["b" /* ActivatedRoute */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__angular_router__["b" /* ActivatedRoute */]) === "function" && _h || Object, typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_16_app_services_fleet_fleet_service__["a" /* FleetService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_16_app_services_fleet_fleet_service__["a" /* FleetService */]) === "function" && _j || Object, typeof (_k = typeof __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__["a" /* GoogleTagManagerService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__["a" /* GoogleTagManagerService */]) === "function" && _k || Object, typeof (_l = typeof __WEBPACK_IMPORTED_MODULE_17_app_services_currency_currency_service__["a" /* CurrencyService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_17_app_services_currency_currency_service__["a" /* CurrencyService */]) === "function" && _l || Object])
], MenuBarComponent);

var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
//# sourceMappingURL=menu-bar.component.js.map

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_booking_booking_service__ = __webpack_require__(155);
/* unused harmony export BookingReportData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogBookingReportComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};




var BookingReportData = (function () {
    function BookingReportData() {
    }
    return BookingReportData;
}());

var DialogBookingReportComponent = (function () {
    function DialogBookingReportComponent(data, formBuilder, dialogRef, bookingService) {
        var _this = this;
        this.data = data;
        this.formBuilder = formBuilder;
        this.dialogRef = dialogRef;
        this.bookingService = bookingService;
        this.defaultDate = false;
        this.isLoading = false;
        this.isError = false;
        this.chechInDateForm = this.formBuilder.group({
            'from': [this.data ? this.data.from : '', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required],
            'to': [this.data ? this.data.to : '', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].required],
        });
        this.defaultDate = !!this.data;
        this.chechInDateForm.valueChanges.subscribe(function () {
            _this.isError = false;
        });
    }
    DialogBookingReportComponent.prototype.ngOnInit = function () {
    };
    DialogBookingReportComponent.prototype.exportReport = function () {
        var _this = this;
        if (this.chechInDateForm.value.from && this.chechInDateForm.value.to) {
            this.reportExportSubscriber && this.reportExportSubscriber.unsubscribe();
            this.isLoading = true;
            this.reportExportSubscriber = this.bookingService.getAccuredReport(this.chechInDateForm.value.from, this.chechInDateForm.value.to).subscribe(function (res) {
                _this.intervalSubscription && _this.intervalSubscription.unsubscribe();
                _this.intervalSubscription = _this.bookingService.downloadReport(res.downloadReportId).subscribe(function (inter) {
                    inter && _this.intervalSubscription.unsubscribe();
                    _this.closeDialog();
                }, function (error) {
                    _this.isLoading = false;
                    _this.handleError(error);
                });
            }, function (error) {
                _this.isLoading = false;
                _this.handleError(error);
            });
        }
        else {
            this.isError = true;
        }
    };
    DialogBookingReportComponent.prototype.closeDialog = function (error, data) {
        this.dialogRef.close(error ? { error: error, data: data } : undefined);
    };
    DialogBookingReportComponent.prototype.onCancael = function () {
        this.reportExportSubscriber && this.reportExportSubscriber.unsubscribe();
        this.closeDialog();
    };
    DialogBookingReportComponent.prototype.handleError = function (error) {
        var data = new BookingReportData;
        data.from = this.chechInDateForm.value.from;
        data.to = this.chechInDateForm.value.to;
        var code = '6001';
        try {
            var errors = error.error.json();
            if (errors.errors[0].message === 'Data report not found.') {
                code = '4004';
            }
        }
        catch (ex) {
            console.log(ex);
        }
        this.closeDialog(code, data);
    };
    return DialogBookingReportComponent;
}());
DialogBookingReportComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-booking-report',
        template: __webpack_require__(1042),
        styles: [__webpack_require__(907)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [BookingReportData, typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__services_booking_booking_service__["a" /* BookingService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__services_booking_booking_service__["a" /* BookingService */]) === "function" && _c || Object])
], DialogBookingReportComponent);

var _a, _b, _c;
//# sourceMappingURL=dialog-booking-report.component.js.map

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_change_password_change_password_form__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dialog_general_message_dialog_general_message_component__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_user_user_service__ = __webpack_require__(15);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogChangePasswordComponent; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var DialogChangePasswordComponent = (function () {
    function DialogChangePasswordComponent(dialog, dialogRef, formProvider, formBuilder, translatePipe, userService) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.formProvider = formProvider;
        this.formBuilder = formBuilder;
        this.translatePipe = translatePipe;
        this.userService = userService;
        this.isLoading = false;
    }
    DialogChangePasswordComponent.prototype.buildForm = function () {
        var _this = this;
        var _a = this.formProvider, getInitForm = _a.getInitForm, matchingPasswords = _a.matchingPasswords, formErrors = _a.formErrors;
        this.formErrors = formErrors;
        this.form = this.formBuilder.group(getInitForm('', ''), {
            validator: matchingPasswords('newPassword', 'confirmNewPassword')
        });
        this.form.valueChanges.subscribe(function (data) {
            _this.formProvider.clearErrorMessage(data);
        });
    };
    DialogChangePasswordComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    DialogChangePasswordComponent.prototype.setLoadingState = function (isLoading) {
        this.isLoading = isLoading;
    };
    DialogChangePasswordComponent.prototype.isInvalid = function (field) {
        return this.form.get(field).invalid && this.form.get(field).touched;
    };
    DialogChangePasswordComponent.prototype.onSubmit = function () {
        var _this = this;
        this.setLoadingState(true);
        if (this.form.invalid) {
            this.setLoadingState(false);
            this.formProvider.setErrorMessage(this.form);
            return;
        }
        var _a = this.form.getRawValue(), confirmNewPassword = _a.confirmNewPassword, newPassword = _a.newPassword;
        this.userService.changePassword(newPassword, confirmNewPassword).subscribe(function (data) {
            _this.dialogRef.afterClosed().take(1).subscribe(function () {
                _this.handleOpenDialog({ type: 'SUCCESS' });
            });
            _this.dialogRef.close();
        }, function (errRes) {
            var data = errRes.json();
            if (data && data.errors && data.errors.length > 0 && data.errors[0].code === '4214') {
                _this.form.get('newPassword').setErrors({ previouslyUsed: true });
                _this.formProvider.setErrorMessage(_this.form);
                _this.setLoadingState(false);
            }
            else {
                _this.dialogRef.afterClosed().take(1).subscribe(function () {
                    _this.handleOpenDialog({ type: 'FAILURE' });
                });
                _this.dialogRef.close();
            }
        });
    };
    DialogChangePasswordComponent.prototype.handleOpenDialog = function (_a) {
        var type = _a.type;
        var message = __assign({}, this.createMessage({ type: type }));
        var config = {
            hasBackdrop: true,
            disableClose: false,
            focusOnOpen: false,
            data: message
        };
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__dialog_general_message_dialog_general_message_component__["a" /* DialogGeneralMessageComponent */], config);
        dialogRef.componentInstance.autoClose = 10;
    };
    ;
    DialogChangePasswordComponent.prototype.createMessage = function (_a) {
        var type = _a.type;
        if (type === 'SUCCESS') {
            return {
                icon: 'icon-successful',
                title: this.translate('my-profile-change-password-success-title'),
                message: this.translate('my-profile-change-password-success-description'),
                mainBtn: this.translate('btn-ok')
            };
        }
        else {
            return {
                icon: 'icon-service-failed',
                title: this.translate('my-profile-change-password-failure-title'),
                message: this.translate('my-profile-change-password-failure-description'),
                mainBtn: this.translate('btn-ok')
            };
        }
    };
    DialogChangePasswordComponent.prototype.translate = function (value) {
        return this.translatePipe.transform(value);
    };
    DialogChangePasswordComponent.prototype.handleFormReset = function () {
        this.buildForm();
        this.elePassword.nativeElement.blur();
        this.eleConfirmPassword.nativeElement.blur();
        this.formProvider.clearAllErrorMessage();
    };
    DialogChangePasswordComponent.prototype.handleCancel = function () {
        this.dialogRef.close();
    };
    Object.defineProperty(DialogChangePasswordComponent.prototype, "passwordHasValidLength", {
        get: function () {
            var pwc = this.form.controls.newPassword;
            var validCharacter = this.form.controls.newPassword.value.match(__WEBPACK_IMPORTED_MODULE_4_app_model_constant__["G" /* PatternFormat */].VALID_CHARACTER);
            return pwc.value && !pwc.hasError('minlength') && !pwc.hasError('maxlength') && validCharacter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogChangePasswordComponent.prototype, "passwordHasUppercase", {
        get: function () {
            return this.form.controls.newPassword.value.match(__WEBPACK_IMPORTED_MODULE_4_app_model_constant__["G" /* PatternFormat */].AT_LEAST_ONE_UPPERCASE);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogChangePasswordComponent.prototype, "passwordHasLowercase", {
        get: function () {
            return this.form.controls.newPassword.value.match(__WEBPACK_IMPORTED_MODULE_4_app_model_constant__["G" /* PatternFormat */].AT_LEAST_ONE_LOWERCASE);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogChangePasswordComponent.prototype, "passwordHasNumeric", {
        get: function () {
            return this.form.controls.newPassword.value.match(__WEBPACK_IMPORTED_MODULE_4_app_model_constant__["G" /* PatternFormat */].AT_LEAST_ONE_NUMERIC);
        },
        enumerable: true,
        configurable: true
    });
    return DialogChangePasswordComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('password'),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _a || Object)
], DialogChangePasswordComponent.prototype, "elePassword", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('confirmPassword'),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _b || Object)
], DialogChangePasswordComponent.prototype, "eleConfirmPassword", void 0);
DialogChangePasswordComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-change-password',
        template: __webpack_require__(1045),
        styles: [__webpack_require__(910)],
        providers: [__WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_change_password_change_password_form__["a" /* ChangePasswordForm */]]
    }),
    __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_change_password_change_password_form__["a" /* ChangePasswordForm */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_components_modal_dialog_change_password_change_password_form__["a" /* ChangePasswordForm */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_5_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_user_user_service__["a" /* UserService */]) === "function" && _h || Object])
], DialogChangePasswordComponent);

var _a, _b, _c, _d, _e, _f, _g, _h;
//# sourceMappingURL=dialog-change-password.component.js.map

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogInformationCartComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};





var DialogInformationCartComponent = (function () {
    function DialogInformationCartComponent(fb, appConfigService, data, dialogRef) {
        this.fb = fb;
        this.appConfigService = appConfigService;
        this.data = data;
        this.dialogRef = dialogRef;
        this.isSubmitted = false;
        this.lang = __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["a" /* Language */].en;
        this.pageElementName = 'remark-cart-dialog';
    }
    DialogInformationCartComponent.prototype.ngOnInit = function () {
        this.form = this.fb.group({
            acceptTerms: [false, [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["Validators"].requiredTrue]],
        });
        this.lang = this.appConfigService.getLanguage();
    };
    DialogInformationCartComponent.prototype.onCancel = function () {
        this.dialogRef.close({ event: 'fail' });
    };
    DialogInformationCartComponent.prototype.onConfirm = function () {
        this.isSubmitted = true;
        if (this.form.valid) {
            this.dialogRef.close({ event: 'success' });
        }
    };
    return DialogInformationCartComponent;
}());
DialogInformationCartComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-information-cart',
        template: __webpack_require__(1053),
        styles: [__webpack_require__(918)]
    }),
    __param(2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_forms__["FormBuilder"]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object, Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */]) === "function" && _c || Object])
], DialogInformationCartComponent);

var _a, _b, _c;
//# sourceMappingURL=dialog-information-cart.component.js.map

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_products_product_service__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_platform__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_act_map_directives_info_marker__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dialog_map_nearby_info_window_content_info_window_content_component__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_products_product_review_model__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_services_currency_currency_service__ = __webpack_require__(58);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogMapPoiComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};














var DialogMapPoiComponent = (function () {
    function DialogMapPoiComponent(data, dialogRef, productService, utilitiesService, appConfigService, userService, googleTagManagerService, currencyService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.productService = productService;
        this.utilitiesService = utilitiesService;
        this.appConfigService = appConfigService;
        this.userService = userService;
        this.googleTagManagerService = googleTagManagerService;
        this.currencyService = currencyService;
        this.isMobile = false; // tslint:disable-line
        this.resetCenter = false; // tslint:disable-line
        this.isAllPopOverComplete = false;
        this.countPopOver = 0;
        this.countMarker = 0;
        this.zoom = 0;
        this.gaSent = false;
        this.now = new Date().getTime() / 1000;
        this.radius = __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["p" /* DefaultValue */].DISTANCE;
    }
    DialogMapPoiComponent.prototype.onResize = function () {
        document.documentElement.style.setProperty('--dialog-vh', window.innerHeight * 0.01 + "px");
    };
    DialogMapPoiComponent.prototype.ngOnInit = function () {
        this.onResize();
        if (this.data && this.data.product) {
            if (this.data.product.reviewRatingScore) {
                this.reviewRating = new __WEBPACK_IMPORTED_MODULE_10__model_products_product_review_model__["a" /* ProductReviewModel */]('' + this.data.product.reviewRatingScore, this.productService.calculateReviewRatingTitle(this.data.product.reviewRatingScore));
            }
            this.product = this.data.product;
        }
        this.product && this.getProductPOI();
        this.utilitiesService.isMobile() && (this.isMobile = true);
        this.googleTagManagerService.emitEvent('Poi Map Search', 'Loading', this.data && this.data.product ? this.data.product.title || '' : '', 0);
        this.subscribeCurrency();
    };
    DialogMapPoiComponent.prototype.ngOnDestroy = function () {
        this.getProductPoiSubScription && this.getProductPoiSubScription.unsubscribe();
        this.currencySubscription && this.currencySubscription.unsubscribe();
        this.utilitiesService.unlockBody();
        this.utilitiesService.unlockBodyBackdrop();
    };
    DialogMapPoiComponent.prototype.setInfoWindowData = function (image, title, rating, keyMarker, review, displayNavigate) {
        if (displayNavigate === void 0) { displayNavigate = false; }
        this.infoWindowKey = {
            key: keyMarker
        };
        this.InfoWindowContentComponent.setData(image, title, rating, review, true, displayNavigate);
    };
    DialogMapPoiComponent.prototype.getProductPOI = function () {
        var _this = this;
        this.getProductPoiSubScription && this.getProductPoiSubScription.unsubscribe();
        this.data.hotelListRequest.filterRequest.distance = this.data.searchData.radius;
        this.getProductPoiSubScription = this.productService.getProductListWithPOI(this.data.hotelListRequest).subscribe(function (res) {
            _this.getProductPOIList(res.items);
        });
    };
    DialogMapPoiComponent.prototype.getProductPOIList = function (poiList) {
        var _this = this;
        this.productPoiList = new Array();
        var tmpDistanceLat = 0;
        var tmpDistanceLon = 0;
        var centerLon = Number(this.data.searchData.destination.poi.lon);
        var centerLat = Number(this.data.searchData.destination.poi.lat);
        var distanceLat = Math.abs(Number(this.product.latitude) - centerLat);
        var distanceLon = Math.abs(Number(this.product.longitude) - centerLon);
        poiList.forEach(function (element) {
            if (_this.product.productId !== element.productId) {
                var productPoi = {
                    'destinationId': element.destinationId,
                    'distance': element.distance,
                    'distanceUnit': 'Meters',
                    'imageUrl': element.imageUrl,
                    'latitude': element.latitude,
                    'longitude': element.longitude,
                    'netPrice': element.netPrice,
                    'productId': element.productId,
                    'hotelStar': element.hotelStar,
                    'slug': element.slug,
                    'suggestCat': _this.data.searchData.destination.suggestCat,
                    'productTitle': element.productTitle,
                    'reviewRating': new __WEBPACK_IMPORTED_MODULE_10__model_products_product_review_model__["a" /* ProductReviewModel */]('' + element.reviewRatingScore, _this.productService.calculateReviewRatingTitle(element.reviewRatingScore))
                };
                _this.productPoiList.push(productPoi);
            }
            tmpDistanceLat = Math.abs(element.latitude - centerLat);
            tmpDistanceLon = Math.abs(element.longitude - centerLon);
            distanceLat = tmpDistanceLat > distanceLat ? tmpDistanceLat : distanceLat;
            distanceLon = tmpDistanceLon > distanceLon ? tmpDistanceLon : distanceLon;
        });
        var mapElement = document.querySelector('.dialog-map');
        var widthPixel = this.isMobile ? mapElement.offsetWidth / 3.5 : 256;
        var heightPixel = this.isMobile ? mapElement.offsetHeight / 4.2 : 148;
        var GLOBE_WIDTH = 256;
        var zoomLat = Math.round(Math.log(heightPixel * 360 / distanceLat / GLOBE_WIDTH) / Math.LN2);
        var zoomLon = Math.round(Math.log(widthPixel * 360 / distanceLon / GLOBE_WIDTH) / Math.LN2);
        this.zoom = zoomLat < zoomLon ? zoomLat : zoomLon;
        if (poiList.length > 0) {
            var maxDistance = Math.max.apply(Math, poiList.map(function (o) { return o.distance; }));
            var tempRadius = Math.round((maxDistance * 1.01) / Math.LN2);
            this.radius = tempRadius > this.data.searchData.radius ? this.data.searchData.radius : tempRadius;
        }
        else {
            var tempRadius = Math.round((this.data.product.distance * 1.01) / Math.LN2);
            this.radius = tempRadius > this.data.searchData.radius ? this.data.searchData.radius : tempRadius;
        }
    };
    DialogMapPoiComponent.prototype.onMarkerClicked = function (data) {
        var key = data && data.key ? data.key : undefined;
        this.isMobile && key && this.setActiveMarker(key);
        switch (key) {
            case undefined:
                break;
            case "center":
                this.setInfoWindowData(this.data.product.imageUrl, this.data.product.productTitle, this.data.product.hotelStar, key, this.reviewRating, true);
                break;
            default:
                var product = this.productPoiList[key];
                this.setInfoWindowData(product.imageUrl, product.productTitle, product.hotelStar, data.key, product.reviewRating);
                break;
        }
    };
    DialogMapPoiComponent.prototype.onPopOverClicked = function (data) {
        if (data && data.key === 'center') {
            this.data.page !== __WEBPACK_IMPORTED_MODULE_12_app_model_constant__["A" /* Page */].LEVEL_D && this.goToProductDetail(this.data.product.productId, this.data.product.slug, this.data.product.productTitle);
        }
        else {
            var product = this.productPoiList[data.key];
            this.goToProductDetail(product.productId, product.slug, product.productTitle);
        }
    };
    DialogMapPoiComponent.prototype.onRenderMarkerComplete = function (event) {
        ++this.countMarker;
        event === 'center' && this.InfoWindowContentComponent && this.isMobile && this.setInfoWindowData(this.data.product.imageUrl, this.data.product.productTitle, this.data.product.hotelStar, 'center', this.reviewRating, true);
        var allMarker = this.productPoiList && this.productPoiList.length > 0
            ? this.productPoiList.length + 2 : 2;
        this.isMobile && allMarker === this.countMarker && (this.resetCenter = true);
        this.resetCenter && this.iPhoneUpdateSizing();
        this.resetCenter && this.setActiveMarker('center');
    };
    DialogMapPoiComponent.prototype.onRenderPopOverComplete = function (event) {
        ++this.countPopOver;
        var allPopOver = this.productPoiList && this.productPoiList.length > 0
            ? this.productPoiList.length + 2 : 2;
        allPopOver === this.countPopOver && allPopOver === this.countMarker
            && (this.isAllPopOverComplete = this.resetCenter = true);
        this.resetCenter && this.iPhoneUpdateSizing();
    };
    DialogMapPoiComponent.prototype.sendGAMapLoaded = function () {
        if (!this.gaSent) {
            this.gaSent = true;
            this.googleTagManagerService.emitEvent('Poi Map Search', 'Loaded', this.data && this.data.product ? this.data.product.title || '' : '', Math.round(new Date().getTime() / 1000 - this.now));
        }
    };
    DialogMapPoiComponent.prototype.goToProductDetail = function (id, slug, title) {
        this.removeLink();
        var url = this.productService.getProductDetailsUrl({
            id: id,
            slug: slug,
            suggestCat: 'product',
            title: title,
            purpose: this.data.searchData.purpose,
            checkInDate: this.utilitiesService.convertDateFormat(this.data.searchData.checkInDate, 'YYYY-MM-DD', 'DD-MM-YYYY', 'en'),
            checkOutDate: this.utilitiesService.convertDateFormat(this.data.searchData.checkOutDate, 'YYYY-MM-DD', 'DD-MM-YYYY', 'en'),
            guests: this.data.searchData.guests,
            breakfast: false,
            overBudget: false,
            isReverseFormatDate: false
        });
        this.setLink(url);
    };
    DialogMapPoiComponent.prototype.setLink = function (url) {
        var link = document.getElementById('link-to-product-detail');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', url);
        link.click();
    };
    DialogMapPoiComponent.prototype.removeLink = function () {
        var link = document.getElementById('link-to-product-detail');
        link.removeAttribute('target');
        link.removeAttribute('href');
    };
    DialogMapPoiComponent.prototype.resetIphoneHandler = function () {
        this.$mapElement && this.$mapElement.removeClass('iphone');
    };
    DialogMapPoiComponent.prototype.iPhoneUpdateSizing = function () {
        this.$mapElement = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.act-map-container-inner');
        this.$infoWindowElement = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.info-window-mobile');
        // handle for iPhone (safari and firefox) only
        var canHandle = !!__WEBPACK_IMPORTED_MODULE_7_platform___default.a && window.navigator.platform === 'iPhone';
        canHandle = canHandle && __WEBPACK_IMPORTED_MODULE_7_platform___default.a.product === 'iPhone';
        canHandle = canHandle && (__WEBPACK_IMPORTED_MODULE_7_platform___default.a.name === 'Safari' || __WEBPACK_IMPORTED_MODULE_7_platform___default.a.name === 'Firefox');
        canHandle && this.$mapElement && this.$mapElement.addClass('iphone');
        canHandle && this.$infoWindowElement && this.$infoWindowElement.addClass('iphone');
        this.sendGAMapLoaded();
    };
    DialogMapPoiComponent.prototype.setActiveMarker = function (active) {
        this.infoMarker.map(function (marker) {
            marker.setActiveMarker(active === marker.key);
        });
    };
    DialogMapPoiComponent.prototype.subscribeCurrency = function () {
        var _this = this;
        this.currency = this.currencyService.getCurrency();
        this.currencySubscription = this.currencyService.getCurrencyObs().subscribe(function (currency) {
            _this.currency = currency;
        });
    };
    return DialogMapPoiComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_9__dialog_map_nearby_info_window_content_info_window_content_component__["a" /* InfoWindowContentComponent */]),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_9__dialog_map_nearby_info_window_content_info_window_content_component__["a" /* InfoWindowContentComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_9__dialog_map_nearby_info_window_content_info_window_content_component__["a" /* InfoWindowContentComponent */]) === "function" && _a || Object)
], DialogMapPoiComponent.prototype, "InfoWindowContentComponent", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChildren"])(__WEBPACK_IMPORTED_MODULE_8__utilities_act_map_directives_info_marker__["a" /* ActInfoMarker */]),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_core__["QueryList"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_core__["QueryList"]) === "function" && _b || Object)
], DialogMapPoiComponent.prototype, "infoMarker", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DialogMapPoiComponent.prototype, "onResize", null);
DialogMapPoiComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
        selector: 'act-dialog-map-poi',
        template: __webpack_require__(1057),
        styles: [__webpack_require__(922)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialogRef */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_products_product_service__["a" /* ProductService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_products_product_service__["a" /* ProductService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_11__services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_11__services_user_user_service__["a" /* UserService */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__["a" /* GoogleTagManagerService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__["a" /* GoogleTagManagerService */]) === "function" && _h || Object, typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_13_app_services_currency_currency_service__["a" /* CurrencyService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_13_app_services_currency_currency_service__["a" /* CurrencyService */]) === "function" && _j || Object])
], DialogMapPoiComponent);

var _a, _b, _c, _d, _e, _f, _g, _h, _j;
//# sourceMappingURL=dialog-map-poi.component.js.map

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__phone_state__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_model_dropdown_dropdown_option_model__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utilities_phone_number_validator__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_services_authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_model_otp_otp_model__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dialog_error_dialog_error_component__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dialog_alert_dialog_alert_component__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_verify_otp_verify_otp_component__ = __webpack_require__(168);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogPhoneComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};














var DialogPhoneComponent = (function () {
    function DialogPhoneComponent(dialogRef, formBuilder, translatePipe, dialog, userService, authenticationService) {
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.translatePipe = translatePipe;
        this.dialog = dialog;
        this.userService = userService;
        this.authenticationService = authenticationService;
        this.elementId = 'dialog-phone';
        this.isLoading = false;
        this.backButtonMode = 'cancel';
        this.state = __WEBPACK_IMPORTED_MODULE_1__phone_state__["a" /* PHONE_STATE */].SET_PHONE;
        this.PHONE_STATE = __WEBPACK_IMPORTED_MODULE_1__phone_state__["a" /* PHONE_STATE */];
        this.OTP_PURPOSE = __WEBPACK_IMPORTED_MODULE_9_app_model_otp_otp_model__["a" /* OTPPurpose */];
        this.callingCodeList = [];
        this.defaultOption = __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["J" /* CallingCodeOption */].DEFAULT;
        this.phoneNumberMask = Array.from({ length: 20 }, function () { return /\d/; });
        this.otpMethods = [];
        this.accountLocked = false;
    }
    Object.defineProperty(DialogPhoneComponent.prototype, "otpInputForm", {
        get: function () {
            if (this.otpVerifyChild) {
                return this.otpVerifyChild.otpInputForm;
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    DialogPhoneComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.form = this.formBuilder.group({
            mobileNumber: ['', [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["Validators"].required, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_app_utilities_phone_number_validator__["a" /* PhoneNumberValidator */])(__WEBPACK_IMPORTED_MODULE_3_app_model_constant__["J" /* CallingCodeOption */].DEFAULT.value)]],
            countryISO2: [this.defaultOption.value],
        });
        this.callingCodeSubscribe = this.userService.getCallingCode().subscribe(function (res) {
            _this.transformCallingCode(res);
        });
    };
    DialogPhoneComponent.prototype.ngOnDestroy = function () {
        this.callingCodeSubscribe && this.callingCodeSubscribe.unsubscribe();
    };
    DialogPhoneComponent.prototype.onClickBack = function () {
        if (this.accountLocked) {
            this.userService.logout();
            return;
        }
        if (this.state == __WEBPACK_IMPORTED_MODULE_1__phone_state__["a" /* PHONE_STATE */].OTP) {
            this.state = __WEBPACK_IMPORTED_MODULE_1__phone_state__["a" /* PHONE_STATE */].METHODS;
            this.backButtonMode = undefined;
        }
    };
    DialogPhoneComponent.prototype.onClickCancel = function () {
        var _this = this;
        if (this.accountLocked) {
            this.dialogRef.afterClosed().take(1).subscribe(function () {
                _this.userService.logout();
            });
        }
        this.dialogRef.close();
    };
    DialogPhoneComponent.prototype.onSubmit = function () {
        if (this.state == __WEBPACK_IMPORTED_MODULE_1__phone_state__["a" /* PHONE_STATE */].SET_PHONE) {
            this.setPhone();
        }
        else if (this.state == __WEBPACK_IMPORTED_MODULE_1__phone_state__["a" /* PHONE_STATE */].METHODS) {
            this.onClickCancel();
        }
        else if (this.state == __WEBPACK_IMPORTED_MODULE_1__phone_state__["a" /* PHONE_STATE */].OTP) {
            this.isLoading = true;
            this.otpVerifyChild.onSubmit();
        }
    };
    DialogPhoneComponent.prototype.setPhone = function (verifiedToken) {
        var _this = this;
        this.isLoading = true;
        var request = {
            countryCallingCode: this.callingCodeList.find(function (c) { return c.value == _this.form.value.countryISO2; }).displayValue,
            countryISO2: this.form.value.countryISO2,
            phone: this.form.value.mobileNumber,
            verifiedToken: verifiedToken,
        };
        this.authenticationService.changePhoneNumber(request).subscribe(function (res) {
            switch (res.status) {
                case 'success':
                    _this.dialogRef.afterClosed().take(1).subscribe(function () {
                        _this.showDialogSuccess();
                    });
                    _this.dialogRef.close({
                        telephone: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_app_utilities_phone_number_validator__["b" /* transformPhoneNumber */])(request.phone, request.countryISO2),
                        countryCallingCode: request.countryCallingCode
                    });
                    break;
                case 'require_verification':
                    _this.requireVerifyOtp(res.verification);
                    break;
            }
            _this.isLoading = false;
        }, function (err) {
            _this.dialogRef.afterClosed().take(1).subscribe(function () {
                _this.showDialogError(_this.translatePipe.transform('system-error'));
            });
            _this.dialogRef.close();
        });
    };
    DialogPhoneComponent.prototype.requireVerifyOtp = function (verification) {
        this.otpToken = verification.token;
        this.otpMethods = verification.methods;
        this.state = __WEBPACK_IMPORTED_MODULE_1__phone_state__["a" /* PHONE_STATE */].METHODS;
        this.backButtonMode = undefined;
    };
    DialogPhoneComponent.prototype.transformCallingCode = function (list) {
        var _this = this;
        this.callingCodeList = [];
        list.forEach(function (item) {
            if (_this.defaultOption.value === item.countryISO2) {
                _this.callingCodeList.unshift(new __WEBPACK_IMPORTED_MODULE_4_app_model_dropdown_dropdown_option_model__["a" /* Option */](item.countryNameEN + ' (' + item.countryCallingCode + ')', item.countryISO2, item.countryISO2 ? 'flags/' + item.countryISO2.toLowerCase() + '.png' : '', item.countryCallingCode));
            }
            else {
                _this.callingCodeList.push(new __WEBPACK_IMPORTED_MODULE_4_app_model_dropdown_dropdown_option_model__["a" /* Option */](item.countryNameEN + ' (' + item.countryCallingCode + ')', item.countryISO2, item.countryISO2 ? 'flags/' + item.countryISO2.toLowerCase() + '.png' : '', item.countryCallingCode));
            }
        });
    };
    DialogPhoneComponent.prototype.onSelectCallingCode = function (countryISO2) {
        this.form.controls.mobileNumber.setValidators([__WEBPACK_IMPORTED_MODULE_5__angular_forms__["Validators"].required, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_app_utilities_phone_number_validator__["a" /* PhoneNumberValidator */])(countryISO2)]);
        this.form.controls.mobileNumber.updateValueAndValidity();
        if (this.form.controls.mobileNumber.value) {
            this.form.controls.mobileNumber.markAsTouched();
        }
    };
    DialogPhoneComponent.prototype.isInvalid = function (field) {
        return this.form.get(field).invalid && this.form.get(field).touched;
    };
    DialogPhoneComponent.prototype.onVerifiedOtp = function (event) {
        this.setPhone(event.verifiedToken);
    };
    DialogPhoneComponent.prototype.onOtpStateChange = function (event) {
        this.state = event;
        if (event == __WEBPACK_IMPORTED_MODULE_1__phone_state__["a" /* PHONE_STATE */].METHODS) {
            this.backButtonMode = undefined;
        }
        else if (event == __WEBPACK_IMPORTED_MODULE_1__phone_state__["a" /* PHONE_STATE */].OTP) {
            this.backButtonMode = 'back';
        }
        else if (event == __WEBPACK_IMPORTED_MODULE_1__phone_state__["a" /* PHONE_STATE */].SESSION_EXPIRE) {
            this.backButtonMode = 'cancel';
        }
    };
    DialogPhoneComponent.prototype.onAccountLocked = function () {
        this.accountLocked = true;
    };
    DialogPhoneComponent.prototype.showDialogError = function (message, subText) {
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_11__dialog_error_dialog_error_component__["a" /* DialogErrorComponent */]);
        dialogRef.componentInstance.text = message;
        if (subText) {
            dialogRef.componentInstance.subText = subText;
        }
    };
    DialogPhoneComponent.prototype.showDialogSuccess = function () {
        var successPopupRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_12__dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */]);
        successPopupRef.componentInstance.imageSrc = '/assets/images/icons/icon-setup-pin-success.png';
        successPopupRef.componentInstance.alertHeader = this.translatePipe.transform('change-phone-success');
        successPopupRef.componentInstance.autoClose = 10;
    };
    return DialogPhoneComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('otpVerifyChild'),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_13_app_components_verify_otp_verify_otp_component__["a" /* VerifyOtpComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_13_app_components_verify_otp_verify_otp_component__["a" /* VerifyOtpComponent */]) === "function" && _a || Object)
], DialogPhoneComponent.prototype, "otpVerifyChild", void 0);
DialogPhoneComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-phone',
        template: __webpack_require__(1061),
        styles: [__webpack_require__(926)]
    }),
    __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_7__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7__angular_material__["b" /* MdDialogRef */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_5__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__angular_forms__["FormBuilder"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_10_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_10_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_7__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7__angular_material__["d" /* MdDialog */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_user_user_service__["a" /* UserService */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_8_app_services_authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8_app_services_authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _g || Object])
], DialogPhoneComponent);

var _a, _b, _c, _d, _e, _f, _g;
//# sourceMappingURL=dialog-phone.component.js.map

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogAlertPinComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var DialogAlertPinComponent = (function () {
    function DialogAlertPinComponent(dialogRef, utilitiesService) {
        this.dialogRef = dialogRef;
        this.utilitiesService = utilitiesService;
        this.isMobile = false;
        this.elementId = 'dialog-alert-pin';
        this.imageSrc = '/assets/images/icons/icon-failed.png';
        this.isMobile = this.utilitiesService.isMobile();
    }
    DialogAlertPinComponent.prototype.ngOnInit = function () { };
    DialogAlertPinComponent.prototype.handleSubmit = function () {
        this.dialogRef.close({ confirm: true });
    };
    DialogAlertPinComponent.prototype.handleClose = function () {
        this.dialogRef.close();
    };
    return DialogAlertPinComponent;
}());
DialogAlertPinComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-dialog-alert-pin',
        template: __webpack_require__(1062),
        styles: [__webpack_require__(927)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object])
], DialogAlertPinComponent);

var _a, _b;
//# sourceMappingURL=dialog-alert-pin.component.js.map

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_model_checkout_cart_profile_model__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_checkout_checkout3_config_model__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_pages_checkout_module_checkout3_services_checkout3_service__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_authorize_authorize_service__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_cart_cart_service__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentMethodComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var PaymentMethodComponent = (function () {
    function PaymentMethodComponent(checkout3Service, utilitiesService, authorizeService, cartService) {
        this.checkout3Service = checkout3Service;
        this.utilitiesService = utilitiesService;
        this.authorizeService = authorizeService;
        this.cartService = cartService;
        this.selectPaymentChannel = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.isOverBudget = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.paymentChannelType = __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["l" /* PaymentChannelType */];
        this.collapse = true;
        this.isMobile = false;
    }
    Object.defineProperty(PaymentMethodComponent.prototype, "isMultipaymentBookForTraveller", {
        set: function (isMultipaymentBookForTraveller) {
            if (isMultipaymentBookForTraveller) {
                this.paymentMethodForBookForTraveller();
            }
            else {
                this.handlePaymentMethod();
            }
        },
        enumerable: true,
        configurable: true
    });
    PaymentMethodComponent.prototype.ngOnInit = function () {
        this.isMobile = this.utilitiesService.isMobile();
        this.isShareBudget = !!this.authorizeService.getCoBookerCookie() && this.purpose === __WEBPACK_IMPORTED_MODULE_3_app_model_constant__["o" /* PurposeType */].work;
    };
    PaymentMethodComponent.prototype.ngOnDestroy = function () {
        this.cartBudgetAvailableSubscription && this.cartBudgetAvailableSubscription.unsubscribe();
    };
    PaymentMethodComponent.prototype.handlePaymentMethod = function () {
        var _this = this;
        if (this.cartService.verifyShouldCheckBudgetAvailable(this.purpose)) {
            this.cartBudgetAvailableSubscription && this.cartBudgetAvailableSubscription.unsubscribe();
            this.cartBudgetAvailableSubscription = this.cartService.getCartBudgetAvailable().subscribe(function (res) {
                if (res) {
                    _this.paymentMethod();
                }
            });
        }
        else {
            this.paymentMethod();
        }
    };
    PaymentMethodComponent.prototype.onSelectPaymentChannel = function (paymentChannel) {
        this.paymentChannelSelected = paymentChannel;
        if (this.isMobile) {
            this.collapse = true;
        }
        this.selectPaymentChannel.emit(paymentChannel.paymentChannelName);
    };
    PaymentMethodComponent.prototype.paymentMethod = function () {
        this.paymentable = this.checkout3Service.getPayableMethod(this.checkout3Config, this.purpose, this.cartProfile, this.fleetCardListCorporate, this.fleetCardListPersonal, this.isShareBudget);
        this.paymentChannelSelected = this.paymentable.paymentChannels.find(function (item) { return item.default; });
        this.selectPaymentChannel.emit(this.paymentChannelSelected.paymentChannelName);
        this.isOverBudget.emit(this.paymentable.isOverBudget);
    };
    PaymentMethodComponent.prototype.paymentMethodForBookForTraveller = function () {
        var payableMethod = new __WEBPACK_IMPORTED_MODULE_2_app_model_checkout_checkout3_config_model__["a" /* PaymentChannelCheckout */]();
        payableMethod.MULTI_PAYMENT.hide = false;
        payableMethod.CREDIT_TERMS.hide = true;
        payableMethod.CREDIT_CARD.hide = false;
        payableMethod.TRUE_MONEY_WALLET.hide = false;
        payableMethod.FLEET_CARD.hide = false;
        payableMethod.MULTI_PAYMENT.default = true;
        payableMethod.QR_CODE.hide = false;
        payableMethod.E_WALLET.hide = false;
        payableMethod.IM_BANKING.hide = false;
        payableMethod.PAY_AT_COUNTER.hide = false;
        this.paymentable.paymentChannels = payableMethod.getPaymentable().paymentChannels.filter(function (item) { return !item.hide; });
        this.paymentable.mainBookerEmail = this.cartProfile.profile.email.valueOf();
        this.paymentable.isOverBudget = true;
        this.paymentChannelSelected = this.paymentable.paymentChannels.find(function (item) { return item.default; });
        this.selectPaymentChannel.emit(this.paymentChannelSelected.paymentChannelName);
        this.isOverBudget.emit(this.paymentable.isOverBudget);
    };
    return PaymentMethodComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], PaymentMethodComponent.prototype, "name", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2_app_model_checkout_checkout3_config_model__["b" /* Checkout3Config */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_model_checkout_checkout3_config_model__["b" /* Checkout3Config */]) === "function" && _a || Object)
], PaymentMethodComponent.prototype, "checkout3Config", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], PaymentMethodComponent.prototype, "purpose", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1_app_model_checkout_cart_profile_model__["a" /* CartAndProfileModel */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_model_checkout_cart_profile_model__["a" /* CartAndProfileModel */]) === "function" && _b || Object)
], PaymentMethodComponent.prototype, "cartProfile", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Array)
], PaymentMethodComponent.prototype, "fleetCardListCorporate", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Array)
], PaymentMethodComponent.prototype, "fleetCardListPersonal", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], PaymentMethodComponent.prototype, "isMultipaymentBookForTraveller", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
], PaymentMethodComponent.prototype, "selectPaymentChannel", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _d || Object)
], PaymentMethodComponent.prototype, "isOverBudget", void 0);
PaymentMethodComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-payment-method',
        template: __webpack_require__(1079),
        styles: [__webpack_require__(944)]
    }),
    __metadata("design:paramtypes", [typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_4_app_pages_checkout_module_checkout3_services_checkout3_service__["a" /* Checkout3Service */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_pages_checkout_module_checkout3_services_checkout3_service__["a" /* Checkout3Service */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_authorize_authorize_service__["a" /* AuthorizeService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_authorize_authorize_service__["a" /* AuthorizeService */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_cart_cart_service__["a" /* CartService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_cart_cart_service__["a" /* CartService */]) === "function" && _h || Object])
], PaymentMethodComponent);

var _a, _b, _c, _d, _e, _f, _g, _h;
//# sourceMappingURL=payment-method.component.js.map

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_modal_dialog_alert_dialog_alert_component__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_model_search_form_model__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_services_search_search_service__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_services_authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modal_dialog_see_all_properties_dialog_see_all_properties_component__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__angular_common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_services_cart_cart_service__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_model_cart_budget_available_model__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modal_dialog_confirm_dialog_confirm_component__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modal_dialog_confirm_dialog_confirm_model__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_services_products_product_service__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modal_dialog_share_budget_dialog_share_budget_component__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modal_dialog_share_budget_dialog_share_budget_model__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modal_dialog_share_budget_dialog_share_budget_detail_dialog_share_budget_detail_component__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_app_services_authorize_authorize_service__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_rxjs_observable_forkJoin__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_rxjs_observable_forkJoin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_app_services_user_feature_user_feature_service__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_app_components_modal_dialog_general_message_dialog_general_message_component__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_js_cookie_src_js_cookie_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_js_cookie_src_js_cookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_js_cookie_src_js_cookie_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_environments_properties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_app_pages_my_profile_dialog_my_profile_dialog_my_profile_model__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_app_pages_my_profile_dialog_my_profile_dialog_my_profile_component__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_app_model_profile_profile_model__ = __webpack_require__(221);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchBoxComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





































var SearchBoxComponent = (function () {
    function SearchBoxComponent(formBuilder, searchService, userService, appConfigService, router, dialog, utilitiesService, authService, cartService, productService, decimalPipe, translate, authorizeService, userFeatureService, googleTagManagerService) {
        this.formBuilder = formBuilder;
        this.searchService = searchService;
        this.userService = userService;
        this.appConfigService = appConfigService;
        this.router = router;
        this.dialog = dialog;
        this.utilitiesService = utilitiesService;
        this.authService = authService;
        this.cartService = cartService;
        this.productService = productService;
        this.decimalPipe = decimalPipe;
        this.translate = translate;
        this.authorizeService = authorizeService;
        this.userFeatureService = userFeatureService;
        this.googleTagManagerService = googleTagManagerService;
        this.type = 'H'; // H = home, C = Level-C, D = Level-D
        this.layout = 'home'; // home, topwrap
        this.submitSearch = new __WEBPACK_IMPORTED_MODULE_2__angular_core__["EventEmitter"](); // tslint:disable-line:no-output-rename
        this.sendData = new __WEBPACK_IMPORTED_MODULE_2__angular_core__["EventEmitter"](); // tslint:disable-line:no-output-rename
        this.sendState = new __WEBPACK_IMPORTED_MODULE_2__angular_core__["EventEmitter"](); // tslint:disable-line:no-output-rename
        this.searchFormModel = new __WEBPACK_IMPORTED_MODULE_9_app_model_search_form_model__["d" /* SearchFormModel */]();
        this.isSelectedDestination = false;
        this.isDestinationFocus = false;
        this.bookWorkPurpose = true;
        this.searchSubmitted = false;
        this.isShareBudget = false;
        this.displayPermission = true;
        this.isAllowOverBudget = false;
        this.isShowRoomBox = false;
        this.isRoomBoxShowArrow = false;
        this.isWorkOnly = false;
        this.isEditable = false;
        this.isSearchHome = true;
        this.isLoading = false;
        this.roomCount = 1;
        this.adultCount = 2;
        this.childCount = 0;
        this.currentTabRoom = 1;
        this.defaultChildrenAges = 12;
        this.allowOverBudget = false;
        this.lang = __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["a" /* Language */].th;
        var findFeature = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_CHILD);
        findFeature && (this.isLimitChild = findFeature.allow);
        findFeature = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_ROOM);
        findFeature && (this.isLimitRoom = findFeature.allow);
        findFeature = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_SHARE_BUDGET);
        findFeature && (this.isShareBudget = findFeature.allow);
        if (this.userFeatureService.isAllowBudgetLimit()) {
            var limitBudgetFeature = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET);
            this.budget = limitBudgetFeature.data.amount;
            this.coBudget = limitBudgetFeature.data.coBudget;
            this.budgetPerMonth = limitBudgetFeature.data.amountPerMonth;
            this.budgetPerYear = limitBudgetFeature.data.amountPerYear;
            this.allowOverBudget = this.userService.checkAllowToPayOverBudget();
        }
        this.allowCreditTerms = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS) && this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS).allow;
        this.allowBookForTraveller = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_BOOK_FOR_TRAVELLER) && this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_BOOK_FOR_TRAVELLER).allow;
        this.getCoBooker();
        this.createBudgetText();
        this.bookWorkPurpose = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_BOOK_WORK_PURPOSE) && this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_BOOK_WORK_PURPOSE).allow != undefined ? this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_BOOK_WORK_PURPOSE).allow : this.bookWorkPurpose;
    }
    SearchBoxComponent.prototype.ngOnChanges = function (changes) {
        this.getCoBooker();
    };
    SearchBoxComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.lang = this.appConfigService.getLanguage();
        if (!this.data) {
            this.data = {
                checkInDate: __WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__().format('DD-MM-YYYY'),
                checkOutDate: __WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__().add(1, 'days').format('DD-MM-YYYY'),
                destination: { title: '', id: '', suggestCat: '', slug: '' },
                guests: [{ adult: 2, children: [] }],
                breakfast: false,
                overBudget: this.allowOverBudget,
                purpose: ''
            };
        }
        else {
            this.isSelectedDestination = true;
            // this.isSearchHome = false;
        }
        // Setup Data
        this.originId = this.data.destination.id;
        this.searchFormModel.destination = this.data.destination;
        this.searchFormModel.guests = this.data.guests;
        this.searchFormModel.checkInDate = this.utilitiesService.reverseFormatDate(this.data.checkInDate);
        this.searchFormModel.checkOutDate = this.utilitiesService.reverseFormatDate(this.data.checkOutDate);
        this.searchFormModel.purpose = this.isWorkOnly ? 'work' : this.data.purpose;
        this.searchFormModel.breakfast = this.data.breakfast;
        this.searchFormModel.overBudget = this.data.overBudget;
        this.searchFormModel.campaignId = this.data.campaignId;
        this.searchForm = this.formBuilder.group({
            'destination': this.formBuilder.group({
                id: [this.searchFormModel.destination.id],
                title: [this.searchFormModel.destination.title, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["Validators"].required],
                suggestCat: [this.searchFormModel.destination.suggestCat],
                slug: [this.searchFormModel.destination.slug],
                poi: [this.searchFormModel.destination.poi],
                destinationId: [this.searchFormModel.destination.destinationId],
                destinationTitle: [this.searchFormModel.destination.destinationTitle],
                type: [this.searchFormModel.destination.type],
            }),
            'checkInDate': [this.searchFormModel.checkInDate, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["Validators"].required],
            'checkOutDate': [this.searchFormModel.checkOutDate, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["Validators"].required],
            'guests': [this.searchFormModel.guests, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["Validators"].required],
            'purpose': [{ value: this.searchFormModel.purpose, disabled: this.isWorkOnly }, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["Validators"].required],
            'breakfast': [this.searchFormModel.breakfast],
            'overBudget': [this.searchFormModel.overBudget]
        });
        this.currentRoom = this.searchForm.value.guests[0];
        this.lastestSearchForm = JSON.parse(JSON.stringify(this.searchForm.value));
        if (this.isWorkOnly) {
            this.lastestSearchForm.purpose = 'work';
        }
        if (this.isShowLimitedRoomSelect()) {
            this.searchForm.get('guests').setValue([{ adult: this.searchFormModel.guests[0].adult >= 2 ? 2 : 1, children: [] }]);
            // !this.isSearchHome && this.onSubmit({ value: this.searchFormModel, valid: true }, false);
            !this.isSearchHome && this.onSubmit(this.searchFormModel, false);
        }
        this.updateCountOfRoom();
        // call emit data when outside component need data
        this.sendData.emit({ data: this.lastestSearchForm });
        if (this.searchForm.get('destination').get('suggestCat').value == __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["y" /* SuggestionCategory */].NEAR_BY) {
            this.searchForm.get('destination').get('title').setValue(this.appConfigService.getTranslate('search-box-near-by-you'));
        }
        this.searchForm.controls.destination.valueChanges.subscribe(function (val) {
            // do not reset isSelectDestination same value backup of destination.
            if (val.title != _this.lastestSearchForm.destination.title
                && val.suggestCat != __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["y" /* SuggestionCategory */].NEAR_BY) {
                _this.isSelectedDestination = false;
            }
        });
        this.searchForm.controls.purpose.valueChanges.subscribe(function (val) {
            var config = new __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdDialogConfig */]();
            if (_this.isLimitRoom && val == 'work') {
                if (_this.roomCount > 1) {
                    var dialogRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_7_app_components_modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */], config);
                    dialogRef.componentInstance.alertText = _this.appConfigService.getTranslate('search-box-error-work-1-room');
                    _this.resetToRoomDefault();
                    _this.resetChildren();
                }
                else if (_this.adultCount > 2) {
                    var dialogRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_7_app_components_modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */], config);
                    dialogRef.componentInstance.alertText = _this.appConfigService.getTranslate('search-box-error-work-2-person');
                    _this.resetToRoomDefault();
                    _this.resetChildren();
                }
                else if (_this.childCount > 0) {
                    var dialogRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_7_app_components_modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */], config);
                    dialogRef.componentInstance.alertText = _this.appConfigService.getTranslate('search-box-error-work-no-child');
                    _this.resetToRoomDefault();
                    _this.resetChildren();
                }
            }
            if (!_this.isLimitRoom && val == 'work' && _this.childCount > 0) {
                var dialogRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_7_app_components_modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */], config);
                dialogRef.componentInstance.alertText = _this.appConfigService.getTranslate('search-box-error-work-no-child');
                _this.resetChildren();
            }
        });
        // init date on text read
        this.dateCheckInOutput = this.utilitiesService.getOtaFormatYear(this.lang, this.searchForm.value.checkInDate);
        this.dateCheckOutOutput = this.utilitiesService.getOtaFormatYear(this.lang, this.searchForm.value.checkOutDate);
        this.searchForm.controls.checkInDate.valueChanges.subscribe(function (val) {
            _this.dateCheckInOutput = _this.utilitiesService.getOtaFormatYear(_this.lang, val);
        });
        this.searchForm.controls.checkOutDate.valueChanges.subscribe(function (val) {
            _this.dateCheckOutOutput = _this.utilitiesService.getOtaFormatYear(_this.lang, val);
        });
        this.appConfigService.getLanguageObs().subscribe(function (lang) {
            if (_this.searchForm.value.destination.suggestCat == __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["y" /* SuggestionCategory */].NEAR_BY) {
                _this.searchForm.get('destination').get('title').setValue(_this.appConfigService.getTranslate('search-box-near-by-you'));
            }
            _this.dateCheckInOutput = _this.utilitiesService.getOtaFormatYear(lang, _this.searchForm.value.checkInDate);
            _this.dateCheckOutOutput = _this.utilitiesService.getOtaFormatYear(lang, _this.searchForm.value.checkOutDate);
            _this.lang = lang;
            _this.createBudgetText();
        });
        // init class header for can know type search-box from css context
        var $html = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('html');
        $html.removeClass('topwrap-layout home-layout');
        $html.addClass(this.layout + '-layout');
        if (!this.bookWorkPurpose) {
            this.searchForm.get('purpose').setValue(__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["o" /* PurposeType */].leisure);
        }
        this.authorizeService.getShareBudgetObs().subscribe(function (res) {
            _this.getCoBooker();
            if (res && _this.searchForm.value.purpose === __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["o" /* PurposeType */].work) {
                var suggestCat = _this.searchForm.value.destination.suggestCat;
                var params = void 0;
                _this.searchForm.get('guests').setValue([{ adult: 2, children: [] }]);
                _this.lastestSearchForm.guests = [{ adult: 2, children: [] }];
                _this.adultCount = 2;
                _this.currentRoom.adult = 2;
                if (suggestCat == 'destination' || suggestCat == 'country' || suggestCat === 'pointofinterest') {
                    params = {
                        destination: _this.utilitiesService.encodeQueryParamWrapper(_this.searchForm.value.destination),
                        purpose: _this.isWorkOnly ? 'work' : _this.searchForm.value.purpose,
                        checkIn: _this.utilitiesService.reverseFormatDate(_this.searchForm.value.checkInDate),
                        checkOut: _this.utilitiesService.reverseFormatDate(_this.searchForm.value.checkOutDate),
                        guests: _this.utilitiesService.encodeQueryParamWrapper(_this.searchForm.value.guests),
                        lang: _this.lang
                    };
                    if (_this.isShowPropertiesWithoutBudgetLimit()) {
                        params['overBudget'] = _this.searchForm.value.overBudget;
                    }
                }
                else if (suggestCat == 'product' || suggestCat == 'hotel') {
                    params = {
                        destination: _this.utilitiesService.encodeQueryParamWrapper(_this.searchForm.value.destination),
                        purpose: _this.isWorkOnly ? 'work' : _this.searchForm.value.purpose,
                        checkIn: _this.utilitiesService.reverseFormatDate(_this.searchForm.value.checkInDate),
                        checkOut: _this.utilitiesService.reverseFormatDate(_this.searchForm.value.checkOutDate),
                        guests: _this.utilitiesService.encodeQueryParamWrapper(_this.searchForm.value.guests),
                        breakfast: _this.searchForm.value.breakfast,
                        lang: _this.lang
                    };
                    if (_this.isShowPropertiesWithoutBudgetLimit()) {
                        params['overBudget'] = _this.searchForm.value.overBudget;
                    }
                }
                _this.router.navigate([], {
                    queryParams: params
                });
            }
            if (_this.type !== 'H') {
                _this.submitSearch.emit({ data: _this.lastestSearchForm });
            }
        });
    };
    SearchBoxComponent.prototype.createBudgetText = function () {
        var currency = 'THB';
        var budget = '';
        var budgetPerMonth = '';
        var budgetPerYear = '';
        var totalBudget = 0;
        var totalBudgetPerMonth = 0;
        var totalBudgetPerYear = 0;
        if (this.shareBudget) {
            totalBudget = this.shareBudget.totalBudget;
            this.displayPermission = false;
        }
        else {
            totalBudget = this.budget;
            totalBudgetPerMonth = this.budgetPerMonth;
            totalBudgetPerYear = this.budgetPerYear;
        }
        budget = this.decimalPipe.transform(totalBudget);
        budgetPerMonth = this.decimalPipe.transform(totalBudgetPerMonth);
        budgetPerYear = this.decimalPipe.transform(totalBudgetPerYear);
        var budgetPerNightText = this.shareBudget ? this.translate.transform('search-box-new-budget-per-night') : this.translate.transform('search-box-budget-per-night');
        budgetPerNightText = budgetPerNightText
            .replace(/{currency}/gi, currency)
            .replace(/{budget}/gi, budget);
        var budgetPerMonthText = this.translate.transform('search-box-budget-per-month')
            .replace(/{currency}/gi, currency)
            .replace(/{budgetPerMonth}/gi, budgetPerMonth);
        var budgetPerYearText = this.translate.transform('search-box-budget-per-year')
            .replace(/{currency}/gi, currency)
            .replace(/{budgetPerYear}/gi, budgetPerYear);
        var budgetPerMonthPerYearText = this.translate.transform('search-box-budget-per-month-per-year')
            .replace(/{currency}/gi, currency)
            .replace(/{budgetPerMonth}/gi, budgetPerMonth)
            .replace(/{budgetPerYear}/gi, budgetPerYear);
        if (totalBudget && totalBudgetPerMonth && totalBudgetPerYear) {
            if (this.allowCreditTerms) {
                this.displayFirstLineBudget = budgetPerNightText;
                this.displaySecondLineBudget = budgetPerMonthPerYearText.replace(/<strong>/gi, '').replace(/<\/strong>/gi, '');
            }
            else {
                this.displayFirstLineBudget = budgetPerNightText;
            }
        }
        else if (totalBudget && totalBudgetPerMonth && !totalBudgetPerYear) {
            if (this.allowCreditTerms) {
                this.displayFirstLineBudget = budgetPerNightText;
                this.displaySecondLineBudget = budgetPerMonthText.replace(/<strong>/gi, '').replace(/<\/strong>/gi, '');
            }
            else {
                this.displayFirstLineBudget = budgetPerNightText;
            }
        }
        else if (totalBudget && !totalBudgetPerMonth && totalBudgetPerYear) {
            if (this.allowCreditTerms) {
                this.displayFirstLineBudget = budgetPerNightText;
                this.displaySecondLineBudget = budgetPerYearText.replace(/<strong>/gi, '').replace(/<\/strong>/gi, '');
            }
            else {
                this.displayFirstLineBudget = budgetPerNightText;
            }
        }
        else if (totalBudget && !totalBudgetPerMonth && !totalBudgetPerYear) {
            this.displayFirstLineBudget = budgetPerNightText;
            this.displaySecondLineBudget = null;
        }
        else if (!totalBudget && totalBudgetPerMonth && totalBudgetPerYear) {
            this.displayFirstLineBudget = budgetPerMonthPerYearText;
            this.displaySecondLineBudget = null;
        }
        else if (!totalBudget && totalBudgetPerMonth && !totalBudgetPerYear) {
            this.displayFirstLineBudget = budgetPerMonthText;
            this.displaySecondLineBudget = null;
        }
        else if (!totalBudget && !totalBudgetPerMonth && totalBudgetPerYear) {
            this.displayFirstLineBudget = budgetPerYearText;
            this.displaySecondLineBudget = null;
        }
        else {
            this.displayFirstLineBudget = this.shareBudget && this.shareBudget.coBooker ? this.translate.transform('search-box-new-budget-unlimited') : this.translate.transform('search-box-budget-unlimited');
            this.displaySecondLineBudget = null;
            this.displayPermission = false;
        }
    };
    SearchBoxComponent.prototype.onSubmit = function (value, callBudgetAvailable) {
        var _this = this;
        if (callBudgetAvailable === void 0) { callBudgetAvailable = true; }
        this.searchSubmitted = true;
        if (this.searchForm.value.purpose == '') {
            return false;
        }
        else if (!this.isSelectedDestination) {
            this.inputDestination.nativeElement.focus();
        }
        else {
            this.isLoading = true;
            this.allowBookAcrossMonth(value)
                .flatMap(function (allow) { return allow ? __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(allow) : _this.showErrorPopupAcrossMonth(); })
                .flatMap(function (allowToBook) {
                if (allowToBook) {
                    if (_this.allowBookForTraveller) {
                        return __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(true);
                    }
                    return _this.checkAvailableBudget(callBudgetAvailable, value);
                }
                return __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(false);
            })
                .flatMap(function (allowToSearch) { return allowToSearch ? _this.getCurrentPosition(value) : __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(false); })
                .flatMap(function (allowPosition) { return allowPosition ? _this.validateUserBirthDateTime() : __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(false); })
                .subscribe(function (res) {
                if (res) {
                    _this.navigateToNextPage(value);
                }
                _this.isLoading = false;
            }, function (err) {
                _this.isLoading = false;
                var dialogRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_7_app_components_modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */]);
                dialogRef.componentInstance.alertText = _this.appConfigService.getTranslate('system-error');
                dialogRef.afterClosed().subscribe(function () {
                    _this.utilitiesService.redirectPage('');
                });
            });
        }
    };
    SearchBoxComponent.prototype.validateUserBirthDateTime = function () {
        var _this = this;
        var userCookie = this.userService.getUser();
        this.profileData = new __WEBPACK_IMPORTED_MODULE_35_app_model_profile_profile_model__["b" /* UserInfoModel */](userCookie, this.lang);
        if (!this.profileData.birthDate || !this.profileData.timeOfBirth) {
            return this.userService.getuserInfo(userCookie.companyId).flatMap(function (user) {
                _this.profileData = new __WEBPACK_IMPORTED_MODULE_35_app_model_profile_profile_model__["b" /* UserInfoModel */](user, _this.lang);
                _this.authService.saveUserInformationCookie(user);
                if (!_this.profileData.birthDate || !_this.profileData.timeOfBirth) {
                    return _this.openDialogUpdateDateOfBirth();
                }
                return __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(true);
            });
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(true);
        }
    };
    SearchBoxComponent.prototype.openDialogUpdateDateOfBirth = function () {
        var _this = this;
        return this.dialog.open(__WEBPACK_IMPORTED_MODULE_34_app_pages_my_profile_dialog_my_profile_dialog_my_profile_component__["a" /* DialogMyProfileComponent */], {
            data: {
                profileData: this.profileData,
                title: 'positive-energy-title',
                subTitle: 'positive-energy-title-desc',
                submitText: 'positive-energy-btn-submit',
                applyMuTravel: true,
            },
        }).afterClosed().map(function (val) {
            switch (val.action) {
                case __WEBPACK_IMPORTED_MODULE_33_app_pages_my_profile_dialog_my_profile_dialog_my_profile_model__["b" /* DialogMyProfileActionType */].UPDATED:
                    return true;
                case __WEBPACK_IMPORTED_MODULE_33_app_pages_my_profile_dialog_my_profile_dialog_my_profile_model__["b" /* DialogMyProfileActionType */].CANCEL:
                    _this.isLoading = false;
                    return false;
            }
        });
    };
    SearchBoxComponent.prototype.getCurrentPosition = function (value) {
        var _this = this;
        if (value.destination.suggestCat === __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["y" /* SuggestionCategory */].NEAR_BY) {
            if (navigator.geolocation) {
                var options_1 = {
                    enableHighAccuracy: false,
                    timeout: 2000,
                    maximumAge: 0,
                };
                return new __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"](function (observer) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        value.destination.title = _this.appConfigService.getTranslate('search-box-near-by-you');
                        value.destination.poi = {
                            lat: position.coords.latitude,
                            lon: position.coords.longitude,
                        };
                        __WEBPACK_IMPORTED_MODULE_31_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */].lat, position.coords.latitude.toString(), { domain: __WEBPACK_IMPORTED_MODULE_32_environments_properties__["e" /* domain */] });
                        __WEBPACK_IMPORTED_MODULE_31_js_cookie_src_js_cookie_js__["set"](__WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */].lon, position.coords.longitude.toString(), { domain: __WEBPACK_IMPORTED_MODULE_32_environments_properties__["e" /* domain */] });
                        observer.next(true);
                        observer.complete();
                    }, function (error) {
                        _this.displayPopup();
                        _this.isLoading = false;
                        observer.next(false);
                        observer.complete();
                    }, options_1);
                });
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(false);
            }
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(true);
        }
    };
    SearchBoxComponent.prototype.checkAvailableBudget = function (callBudgetAvailable, searchForm) {
        var _this = this;
        if (callBudgetAvailable && searchForm.purpose === __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["o" /* PurposeType */].work) {
            return this.authService.getUserFeature(null, this.userService.getUser(), [__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET, __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS])
                .flatMap(function (feature) {
                var limitBudgetFeature = feature && feature.length > 0 ? feature.find(function (f) { return f.feature === __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_LIMIT_BUDGET; }) : undefined;
                var allowCreditTerms = feature && feature.length > 0 ? feature.find(function (f) { return f.feature === __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_CREDIT_TERMS; }) : undefined;
                var hasBudgetPerMonthOrYear = limitBudgetFeature && limitBudgetFeature.allow && limitBudgetFeature.data
                    && (limitBudgetFeature.data.amountPerMonth || limitBudgetFeature.data.amountPerYear);
                var shareBudgetCode = _this.authorizeService.getShareBudgetCodeCookie();
                if (allowCreditTerms && allowCreditTerms.allow && (hasBudgetPerMonthOrYear || shareBudgetCode)) {
                    var request = new __WEBPACK_IMPORTED_MODULE_19_app_model_cart_budget_available_model__["a" /* BudgetAvailableRequest */]();
                    request.checkIn = searchForm.checkInDate;
                    request.checkOut = searchForm.checkOutDate;
                    request.companyId = _this.userService.getUser().companyId;
                    request.lang = _this.appConfigService.getLanguage();
                    request.page = 'search';
                    request.shareBudgetCode = shareBudgetCode;
                    return _this.cartService.getBudgetAvailable(request)
                        .flatMap(function (res) {
                        if (res && res.errors && res.errors.length > 0 && res.errors[0].code) {
                            return _this.handlePopupAvailableBudget(res.errors[0]);
                        }
                        else {
                            return __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(true);
                        }
                    }).catch(function (err) {
                        var observer;
                        if (err && err.json() && err.json().errors && err.json().errors.length > 0) {
                            var errors_1 = err.json().errors;
                            var dialogMessage = void 0;
                            var systemError = void 0;
                            switch (errors_1[0].code) {
                                case '4701':
                                    dialogMessage = {
                                        text: _this.translate.transform('dialog-budget-cannot-share-budget-co-booker'),
                                        subText: _this.translate.transform('search-box-error-code-ref-incorrect')
                                    };
                                    break;
                                case '4702':
                                    dialogMessage = {
                                        text: _this.translate.transform('dialog-budget-cannot-share-budget-co-booker'),
                                        subText: _this.translate.transform('search-box-error-code-ref-expired')
                                    };
                                    break;
                                case '4704':
                                case '4705':
                                    dialogMessage = {
                                        text: _this.translate.transform('dialog-budget-cannot-share-budget-co-booker'),
                                        subText: _this.translate.transform('search-box-error-feature-not-allow')
                                    };
                                    break;
                                default:
                                    systemError = true;
                                    var dialogAlertRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_7_app_components_modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */]);
                                    dialogAlertRef.componentInstance.alertText = _this.appConfigService.getTranslate('system-error');
                                    dialogAlertRef.componentInstance.imageSrc = '/assets/images/icons/icon-failed.png';
                                    dialogAlertRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-failed.png';
                                    break;
                            }
                            if (systemError) {
                                return __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(false);
                            }
                            else {
                                var dialogRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_20__modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */], {
                                    data: {
                                        confirmType: __WEBPACK_IMPORTED_MODULE_21__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CONTINUE_BOOKER_BUDGET,
                                        data: { message: dialogMessage }
                                    }
                                });
                                return dialogRef.afterClosed().flatMap(function (m) {
                                    _this.cancelShareBudget();
                                    if (m) {
                                        if (errors_1[0].code === '4704') {
                                            _this.authorizeService.setCookieFeatureShareBudgetIsFalse();
                                        }
                                        return __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(true);
                                    }
                                    else {
                                        // Reload current router
                                        _this.router.routeReuseStrategy.shouldReuseRoute = function () {
                                            return false;
                                        };
                                        _this.router.navigated = false;
                                        _this.router.navigateByUrl(_this.router.url);
                                        return __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(false);
                                    }
                                });
                            }
                        }
                        return observer;
                    });
                }
                return __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(true);
            });
        }
        return __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(true);
    };
    SearchBoxComponent.prototype.handlePopupAvailableBudget = function (error) {
        var _this = this;
        var allowMultiPayment = this.productService.allowMultiPayment(this.userService.getUser());
        var text = error.message;
        var dialogConfirmType;
        var dialogMessage;
        this.getCoBooker();
        switch (error.code) {
            case '2004':
                if (this.shareBudget) {
                    dialogMessage = {
                        text: this.translate.transform('dialog-budget-cannot-share-budget-co-booker'),
                        subText: this.lang === __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["a" /* Language */].en ? this.translate.transform('dialog-budget-due-to') + text : text
                    };
                    dialogConfirmType = __WEBPACK_IMPORTED_MODULE_21__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CANCEL_SHARE_BUDGET;
                }
                else {
                    dialogMessage = {
                        text: text.charAt(0).toUpperCase() + text.slice(1),
                        subText: this.translate.transform('dialog-budget-pay-option')
                    };
                    dialogConfirmType = __WEBPACK_IMPORTED_MODULE_21__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_AVAILABLE_BUDGET;
                }
                break;
            case '2005':
                if (this.shareBudget) {
                    dialogMessage = {
                        text: this.translate.transform('dialog-budget-cannot-share-budget-co-booker'),
                        subText: this.lang === __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["a" /* Language */].en ? this.translate.transform('dialog-budget-due-to') + text : text
                    };
                    dialogConfirmType = __WEBPACK_IMPORTED_MODULE_21__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CONTINUE_BOOKER_BUDGET;
                }
                else {
                    if (allowMultiPayment) {
                        dialogMessage = {
                            text: text.charAt(0).toUpperCase() + text.slice(1),
                            subText: this.translate.transform('dialog-budget-pay-exceeding-option')
                        };
                    }
                    else {
                        dialogMessage = {
                            text: text.charAt(0).toUpperCase() + text.slice(1),
                            subText: this.translate.transform('dialog-budget-pay-option')
                        };
                    }
                    dialogConfirmType = __WEBPACK_IMPORTED_MODULE_21__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_AVAILABLE_BUDGET;
                }
                break;
            case '2006':
                if (!allowMultiPayment) {
                    dialogMessage = {
                        text: this.translate.transform('dialog-budget-cannot-share-budget-co-booker'),
                        subText: this.lang === __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["a" /* Language */].en ? this.translate.transform('dialog-budget-due-to') + text : text
                    };
                    dialogConfirmType = __WEBPACK_IMPORTED_MODULE_21__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CANCEL_SHARE_BUDGET;
                }
            case '2007':
                if (!allowMultiPayment) {
                    dialogMessage = {
                        text: this.translate.transform('dialog-budget-cannot-share-budget-co-booker'),
                        subText: this.lang === __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["a" /* Language */].en ? this.translate.transform('dialog-budget-due-to') + text : text
                    };
                    dialogConfirmType = __WEBPACK_IMPORTED_MODULE_21__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CONTINUE_BOOKER_BUDGET;
                }
                break;
        }
        if (dialogMessage) {
            var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_20__modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */], {
                data: {
                    confirmType: dialogConfirmType,
                    data: { message: dialogMessage }
                }
            });
            return dialogRef.afterClosed().map(function (res) {
                var redirect = false;
                if (res) {
                    switch (dialogConfirmType) {
                        case __WEBPACK_IMPORTED_MODULE_21__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CANCEL_SHARE_BUDGET:
                            _this.cancelShareBudget();
                            redirect = _this.type === 'C' || _this.type === 'D';
                            break;
                        case __WEBPACK_IMPORTED_MODULE_21__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CONTINUE_BOOKER_BUDGET:
                            _this.cancelShareBudget();
                            redirect = true;
                            break;
                        default:
                            redirect = true;
                            break;
                    }
                }
                return redirect;
            });
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(true);
        }
    };
    SearchBoxComponent.prototype.navigateToNextPage = function (value) {
        var _this = this;
        // can submit and call emit event
        // alert('Goto LevelC: "' + value.destination + '"');
        var suggestCat = this.searchForm.value.destination.suggestCat;
        this.googleTagManagerService.emitEvent('Search', suggestCat, this.searchForm.value.destination.title, 1, this.searchForm.value.destination.title);
        var slug = suggestCat === 'pointofinterest' ? '' : this.searchForm.value.destination.slug;
        slug = this.utilitiesService.resolveSlugSpace(slug);
        if (this.isNavigateToProductDetail(suggestCat)) {
            delete this.searchForm.value.destination.destinationId;
            delete this.searchForm.value.destination.destinationTitle;
            var params = {
                destination: this.utilitiesService.encodeQueryParamWrapper(this.searchForm.value.destination, __WEBPACK_IMPORTED_MODULE_32_environments_properties__["j" /* useHotelDetailV2 */]),
                purpose: this.isWorkOnly ? 'work' : this.searchForm.value.purpose,
                checkIn: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkInDate),
                checkOut: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkOutDate),
                guests: this.utilitiesService.encodeQueryParamWrapper(this.searchForm.value.guests, __WEBPACK_IMPORTED_MODULE_32_environments_properties__["j" /* useHotelDetailV2 */]),
                breakfast: this.searchForm.value.breakfast,
                lang: this.lang
            };
            if (this.isShowPropertiesWithoutBudgetLimit()) {
                params['overBudget'] = this.searchForm.value.overBudget;
            }
            if (this.searchFormModel.campaignId) {
                params['campaignId'] = this.searchFormModel.campaignId;
            }
            if (__WEBPACK_IMPORTED_MODULE_32_environments_properties__["j" /* useHotelDetailV2 */]) {
                window.location.href = __WEBPACK_IMPORTED_MODULE_32_environments_properties__["k" /* redirectURIV2 */] + "/hotel/" + slug + this.utilitiesService.objectToQueryString(params);
            }
            else {
                this.router.navigate(['hotel/detail/' + slug], {
                    queryParams: params
                }).then(function (res) {
                    _this.originId = _this.searchForm.value.destination.id;
                    if (_this.type !== 'H') {
                        _this.submitSearch.emit({ data: value });
                        _this.hideEditable();
                    }
                });
            }
        }
        else {
            if (suggestCat == 'product') {
                this.searchForm.value.destination.title = this.searchForm.value.destination.destinationTitle;
            }
            var params = {
                destination: this.utilitiesService.encodeQueryParamWrapper(this.searchForm.value.destination),
                purpose: this.isWorkOnly ? 'work' : this.searchForm.value.purpose,
                checkIn: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkInDate),
                checkOut: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkOutDate),
                guests: this.utilitiesService.encodeQueryParamWrapper(this.searchForm.value.guests),
                lang: this.lang
            };
            if (this.isShowPropertiesWithoutBudgetLimit()) {
                params['overBudget'] = this.searchForm.value.overBudget;
            }
            if (__WEBPACK_IMPORTED_MODULE_32_environments_properties__["s" /* useHotelListV2 */]) {
                window.location.href = __WEBPACK_IMPORTED_MODULE_32_environments_properties__["k" /* redirectURIV2 */] + "/hotel/searchdestination" + this.utilitiesService.objectToQueryString(params);
            }
            else {
                this.router.navigate(['hotel/searchdestination'], {
                    queryParams: params
                }).then(function (res) {
                    _this.originId = _this.searchForm.value.destination.id;
                    if (_this.type !== 'H') {
                        _this.submitSearch.emit({ data: value });
                        _this.hideEditable();
                    }
                });
            }
        }
        this.lastestSearchForm = value;
        if (this.isWorkOnly) {
            this.lastestSearchForm.purpose = 'work';
        }
    };
    SearchBoxComponent.prototype.isNavigateToProductDetail = function (suggestCat) {
        var isNavigateToProductDetail = false;
        if (suggestCat == 'product'
            && (this.searchForm.value.destination.type == 'history'
                || (this.type == 'D' && this.originId == this.searchForm.value.destination.id))) {
            isNavigateToProductDetail = true;
        }
        return isNavigateToProductDetail;
    };
    SearchBoxComponent.prototype.getCoBooker = function () {
        var coBookerCookie = this.authorizeService.getCoBookerCookie();
        if (coBookerCookie) {
            this.shareBudget = new __WEBPACK_IMPORTED_MODULE_24__modal_dialog_share_budget_dialog_share_budget_model__["b" /* ShareBudget */]();
            this.shareBudget.booker = new __WEBPACK_IMPORTED_MODULE_24__modal_dialog_share_budget_dialog_share_budget_model__["a" /* Booker */](this.userService.getUser().userId, this.userService.getUser().companyId, this.userService.getUser().email, this.budget);
            this.shareBudget.coBooker = new __WEBPACK_IMPORTED_MODULE_24__modal_dialog_share_budget_dialog_share_budget_model__["a" /* Booker */](coBookerCookie.userId, coBookerCookie.companyId, coBookerCookie.email, coBookerCookie.amount);
            this.setTotalBudget();
        }
        else {
            this.shareBudget = undefined;
            this.authorizeService.removeCoBookerCookie();
        }
    };
    SearchBoxComponent.prototype.allowBookAcrossMonth = function (searchForm) {
        var requestTasks = [this.authService.getUserFeature(null, this.userService.getUser(), [__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_BOOK_ACROSS_MONTHS])];
        if (this.shareBudget) {
            var shareBudgetCode = this.authorizeService.getShareBudgetCodeCookie();
            requestTasks.push(this.authService.getUserFeature(null, this.userService.getUser(), [__WEBPACK_IMPORTED_MODULE_13_app_model_constant__["b" /* FeatureType */].ALLOW_BOOK_ACROSS_MONTHS], false, shareBudgetCode));
        }
        var dateFormat = 'YYYY-MM-DD';
        var checkIn = __WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__(searchForm.checkInDate, dateFormat);
        var checkOut = __WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__(searchForm.checkOutDate, dateFormat);
        var firstDayOfMonth = __WEBPACK_IMPORTED_MODULE_1_vendors_moment_locale_th__(searchForm.checkOutDate, dateFormat).startOf('month');
        if (searchForm.purpose === 'work'
            && this.inputDestination !== undefined
            && !checkIn.isSame(checkOut, 'month')
            && !checkOut.isSame(firstDayOfMonth, 'day')) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28_rxjs_observable_forkJoin__["forkJoin"])(requestTasks).map(function (results) {
                var booker = results[0], coBooker = results[1];
                var allow = true;
                if (booker && booker.length > 0) {
                    allow = allow && booker[0].allow;
                }
                if (coBooker && coBooker.length > 0) {
                    allow = allow && coBooker[0].allow;
                }
                return allow;
            });
        }
        return __WEBPACK_IMPORTED_MODULE_27_rxjs_Observable__["Observable"].of(true);
    };
    SearchBoxComponent.prototype.showErrorPopupAcrossMonth = function () {
        var config = new __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdDialogConfig */]();
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7_app_components_modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */], config);
        dialogRef.componentInstance.alertText = this.shareBudget ? this.appConfigService.getTranslate('productlists-pop-up-error-across-month-share-budget') : this.appConfigService.getTranslate('productlists-pop-up-error-across-month');
        dialogRef.componentInstance.imageSrc = '/assets/images/icons/icon-calendar.png';
        dialogRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-calendar.png';
        return dialogRef.afterClosed().map(function () { return false; });
    };
    SearchBoxComponent.prototype.isShowLimitedRoomSelect = function () {
        return this.searchForm.value.purpose == 'work' && (this.isLimitRoom || this.shareBudget);
    };
    SearchBoxComponent.prototype.isShowFreeStyleRoomSelect = function () {
        return this.searchForm.value.purpose == 'leisure' || (!this.isLimitRoom && !this.shareBudget) && this.searchForm.value.purpose != '';
    };
    SearchBoxComponent.prototype.isShowPropertiesWithoutBudgetLimit = function () {
        return this.searchForm.value.purpose == 'work' && this.allowOverBudget && this.budget;
    };
    SearchBoxComponent.prototype.toggleRoomBox = function (event) {
        if (this.isShowRoomBox) {
            this.hideRoomBox(event);
        }
        else {
            this.showRoomBox(event);
        }
    };
    SearchBoxComponent.prototype.showRoomBox = function (event) {
        var _this = this;
        this.isShowRoomBox = true;
        // Oganize JS Queue Stack Process.
        setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('html').on('click.hideRoomBox', function (e) {
                _this.hideRoomBox(e);
            });
            _this.detectToShowArrow();
        });
    };
    SearchBoxComponent.prototype.hideRoomBox = function (event) {
        this.isShowRoomBox = false;
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()('html').off('click.hideRoomBox');
    };
    SearchBoxComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    SearchBoxComponent.prototype.handleOnFocusDestination = function () {
        this.isDestinationFocus = true;
    };
    SearchBoxComponent.prototype.handleOnBlurDestination = function () {
        this.isDestinationFocus = false;
    };
    SearchBoxComponent.prototype.displayPopup = function () {
        var _this = this;
        var message = {
            title: this.appConfigService.getTranslate('location-not-found'),
            message: this.appConfigService.getTranslate('location-message-not-found'),
            mainBtn: this.appConfigService.getTranslate('enter')
        };
        var config = {
            hasBackdrop: true,
            disableClose: false,
            focusOnOpen: false,
            data: message
        };
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_30_app_components_modal_dialog_general_message_dialog_general_message_component__["a" /* DialogGeneralMessageComponent */], config);
        dialogRef.afterClosed().subscribe(function (state) {
            _this.inputDestination.nativeElement.blur();
        });
        dialogRef.componentInstance.img = '/assets/images/icons/product-list-search-not-found.png';
    };
    SearchBoxComponent.prototype.handleOnSelectedDestination = function (event) {
        // Emit Set Selected Item from TypeAhead AutoSuggestion
        this.isSelectedDestination = true;
    };
    SearchBoxComponent.prototype.resetDestinationValue = function (event) {
        this.searchForm.controls.destination.setValue({ title: '', id: '', suggestCat: '', slug: '', poi: null, destinationId: null, destinationTitle: null, type: null });
        this.isSelectedDestination = false;
    };
    SearchBoxComponent.prototype.resetToRoomDefault = function () {
        this.setActiveTabRoom(1);
        this.searchForm.controls.guests.setValue([{ adult: 2, children: [] }]);
        this.currentRoom = this.searchForm.value.guests[0];
        this.roomCount = 1;
        this.adultCount = 2;
    };
    // RoomBox
    SearchBoxComponent.prototype.handlerOnChangeRoom = function (event) {
        var oldRoomCount = this.roomCount;
        var roomChoose = parseInt(event.target.value);
        var _rooms = this.searchForm.value.guests;
        if (oldRoomCount > roomChoose) {
            // delete room
            _rooms.splice(roomChoose);
            this.setActiveTabRoom(roomChoose);
        }
        else {
            // add room
            var newRoomsCount = roomChoose - oldRoomCount;
            var newRooms = [];
            for (var i = 0; i < newRoomsCount; i++) {
                newRooms.push({
                    adult: 2,
                    children: []
                });
            }
            this.searchForm.controls.guests.setValue(_rooms.concat(newRooms));
        }
        this.roomCount = roomChoose;
        this.updateCountOfRoom();
        this.detectToShowArrow();
    };
    SearchBoxComponent.prototype.handlerOnChangeAdultCount = function (event) {
        var _adultCount = parseInt(event.target.value);
        this.currentRoom.adult = _adultCount;
        if (this.isShowLimitedRoomSelect()) {
            this.searchForm.get('guests').setValue([{ adult: _adultCount, children: [] }]);
        }
        this.updateCountOfRoom();
    };
    SearchBoxComponent.prototype.handlerOnChangeChildren = function (event) {
        var _this = this;
        var oldChildrenCount = this.currentRoom.children.length;
        var _childrenCount = parseInt(event.target.value);
        if (oldChildrenCount > _childrenCount) {
            // delete children
            this.currentRoom.children.splice(_childrenCount);
        }
        else {
            // add children
            var newChildrenCount = _childrenCount - oldChildrenCount;
            var newChildren = [];
            for (var i = 0; i < newChildrenCount; i++) {
                newChildren.push(this.defaultChildrenAges);
            }
            this.currentRoom.children = this.currentRoom.children.concat(newChildren);
        }
        var guests = [];
        this.searchForm.value.guests.forEach(function (guest, index) {
            guests.push(_this.currentTabRoom - 1 == index ? _this.currentRoom : guest);
        });
        this.searchForm.get('guests').setValue(guests);
        this.updateCountOfRoom();
    };
    SearchBoxComponent.prototype.handlerOnChangeChildrenOld = function (event, i) {
        this.currentRoom.children[i] = parseInt(event.target.value);
    };
    SearchBoxComponent.prototype.resetChildren = function () {
        var _rooms = this.searchForm.value.guests;
        _rooms.forEach(function (room) {
            room.children = [];
        });
        this.childCount = 0;
        this.searchForm.controls.guests.setValue(_rooms);
    };
    SearchBoxComponent.prototype.setActiveTabRoom = function (index) {
        if (this.currentTabRoom != index) {
            this.currentTabRoom = index;
            this.currentRoom = this.searchForm.value.guests[index - 1];
            this.moveScrollToItem();
        }
    };
    SearchBoxComponent.prototype.nextActiveTabRoom = function () {
        var nextRoom = this.currentTabRoom < this.searchForm.value.guests.length ? this.currentTabRoom + 1 : this.currentTabRoom;
        this.setActiveTabRoom(nextRoom);
        this.moveScrollToItem();
    };
    SearchBoxComponent.prototype.prevActiveTabRoom = function () {
        var prevRoom = this.currentTabRoom > 1 ? this.currentTabRoom - 1 : 1;
        this.setActiveTabRoom(prevRoom);
        this.moveScrollToItem();
    };
    SearchBoxComponent.prototype.detectToShowArrow = function () {
        var $tabContainer = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.select-room-popup-container');
        var $scrollContainer = $tabContainer.find('.tab-detail-room-list ul');
        var $tabs = $tabContainer.find('li');
        var $currentTab = $tabs[this.currentTabRoom - 1];
        var tabWidth = $currentTab.clientWidth;
        var scrollContainerWidth = $scrollContainer[0].clientWidth;
        var scrollLeft = $scrollContainer[0].scrollLeft;
        var currentPosLeft = __WEBPACK_IMPORTED_MODULE_5_jquery___default()($currentTab).position().left;
        var currentPosRight = currentPosLeft + tabWidth;
        // detect item is width over range
        if ((tabWidth + 2) * this.roomCount > scrollContainerWidth) {
            this.isRoomBoxShowArrow = true;
        }
        else {
            this.isRoomBoxShowArrow = false;
        }
    };
    SearchBoxComponent.prototype.moveScrollToItem = function () {
        var $tabContainer = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.select-room-popup-container');
        var $scrollContainer = $tabContainer.find('.tab-detail-room-list ul');
        var $tabs = $tabContainer.find('li');
        var $currentTab = $tabs[this.currentTabRoom - 1];
        var tabWidth = $currentTab.clientWidth;
        var scrollContainerWidth = $scrollContainer[0].clientWidth;
        var scrollLeft = $scrollContainer[0].scrollLeft;
        var currentPosLeft = __WEBPACK_IMPORTED_MODULE_5_jquery___default()($currentTab).position().left;
        var currentPosRight = currentPosLeft + tabWidth;
        // detect visible tab on scroll
        var targetLeftPos = (tabWidth + 2) * (this.currentTabRoom - 1);
        if (currentPosRight > scrollContainerWidth) {
            $scrollContainer[0].scrollLeft = targetLeftPos - scrollContainerWidth + tabWidth + 30;
        }
        else if (currentPosLeft < 0) {
            $scrollContainer[0].scrollLeft = targetLeftPos - 30;
        }
    };
    SearchBoxComponent.prototype.updateCountOfRoom = function () {
        var _adultCount = 0;
        var _childCount = 0;
        this.searchForm.value.guests.forEach(function (room, i) {
            _adultCount += room.adult;
            _childCount += room.children.length;
        });
        this.roomCount = this.searchForm.value.guests.length;
        this.adultCount = _adultCount;
        this.childCount = _childCount;
    };
    SearchBoxComponent.prototype.trackByChild = function (index, child) {
        return index;
    };
    // top wrap layout
    SearchBoxComponent.prototype.showEditable = function () {
        this.isEditable = true;
        this.sendState.emit({ mode: 'EDIT' });
    };
    SearchBoxComponent.prototype.hideEditable = function () {
        this.isEditable = false;
        this.sendState.emit({ mode: 'NORMAL' });
    };
    SearchBoxComponent.prototype.cancleChangeSearch = function () {
        this.hideEditable();
        if (this.lastestSearchForm.destination.suggestCat == __WEBPACK_IMPORTED_MODULE_13_app_model_constant__["y" /* SuggestionCategory */].NEAR_BY) {
            this.lastestSearchForm.destination.title = this.appConfigService.getTranslate('search-box-near-by-you');
        }
        this.searchForm.reset(JSON.parse(JSON.stringify(this.lastestSearchForm)));
        this.isSelectedDestination = true;
        this.currentRoom = this.searchForm.value.guests[0];
        this.updateCountOfRoom();
    };
    SearchBoxComponent.prototype.handleClickDestinationTextArea = function () {
        var _this = this;
        this.showEditable();
        if (!window.matchMedia('(max-width: 767px)').matches) {
            setTimeout(function () {
                _this.inputDestination && _this.inputDestination.nativeElement.focus();
            }, 600);
        }
        else {
            setTimeout(function () {
                _this.inputDestination.nativeElement.focus();
            }, 800);
        }
    };
    SearchBoxComponent.prototype.handleClickDateTextArea = function () {
        var _this = this;
        this.showEditable();
        setTimeout(function () {
            if (_this.utilitiesService.isIOS()) {
                __WEBPACK_IMPORTED_MODULE_5_jquery___default()(_this.inputCheckIn.nativeElement).trigger('touchend');
            }
            else {
                __WEBPACK_IMPORTED_MODULE_5_jquery___default()(_this.inputCheckIn.nativeElement).trigger('click');
            }
        }, 400);
    };
    SearchBoxComponent.prototype.handleClickRoomTextArea = function () {
        var _this = this;
        this.showEditable();
        setTimeout(function () {
            if (_this.inputRoomBox) {
                __WEBPACK_IMPORTED_MODULE_5_jquery___default()(_this.inputRoomBox.nativeElement).trigger('click');
            }
        }, 200);
    };
    SearchBoxComponent.prototype.openDialogTooltips = function () {
        var isClickable = window.matchMedia('(max-width: 767px)').matches;
        isClickable && this.dialog.open(__WEBPACK_IMPORTED_MODULE_15__modal_dialog_see_all_properties_dialog_see_all_properties_component__["a" /* DialogSeeAllPropertiesComponent */]);
    };
    SearchBoxComponent.prototype.openDialogShareBudget = function () {
        var _this = this;
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_23__modal_dialog_share_budget_dialog_share_budget_component__["a" /* DialogShareBudgetComponent */]);
        dialogRef.afterClosed().subscribe(function (val) {
            if (val.event === 'success') {
                _this.shareBudget = val.shareBudget;
                _this.shareBudget.booker = new __WEBPACK_IMPORTED_MODULE_24__modal_dialog_share_budget_dialog_share_budget_model__["a" /* Booker */](_this.userService.getUser().userId, _this.userService.getUser().companyId, _this.userService.getUser().email, _this.budget);
                _this.setTotalBudget();
                _this.authorizeService.setShareBudgetObs(true);
                _this.handlerOnChangeAdultCount({ target: { value: 2 } });
                _this.createBudgetText();
            }
            if (val.event === 'closeDialog') {
                dialogRef.close();
            }
            if (val.event === 'close') {
                dialogRef.close();
                var dialog = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_20__modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */], { data: { confirmType: __WEBPACK_IMPORTED_MODULE_21__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CLOSE } });
                dialog.afterClosed().subscribe(function (res) {
                    if (!res) {
                        _this.openDialogShareBudget();
                    }
                });
            }
            if (val.event === 'bookerNotAllowFeature') {
                // Reload current router
                _this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
                _this.router.navigated = false;
                _this.router.navigateByUrl(_this.router.url);
            }
        });
    };
    SearchBoxComponent.prototype.openDialogShareBudgetDetail = function () {
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_25__modal_dialog_share_budget_dialog_share_budget_detail_dialog_share_budget_detail_component__["a" /* DialogShareBudgetDetailComponent */], {
            data: this.shareBudget
        });
    };
    SearchBoxComponent.prototype.onCancelShareBudget = function () {
        var _this = this;
        var message = { text: this.translate.transform('dialog-cancel-share-budget-text'), subText: this.translate.transform('dialog-cancel-share-budget-sub-text') };
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_20__modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */], {
            data: {
                confirmType: __WEBPACK_IMPORTED_MODULE_21__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CANCEL_SHARE_BUDGET_FROM_USER,
                data: {
                    message: message
                }
            },
        });
        dialogRef.afterClosed().subscribe(function (res) {
            if (res) {
                _this.cancelShareBudget();
            }
        });
    };
    SearchBoxComponent.prototype.cancelShareBudget = function () {
        this.shareBudget = undefined;
        this.authorizeService.removeCoBookerCookie();
        this.authorizeService.setShareBudgetObs(false);
        this.createBudgetText();
    };
    SearchBoxComponent.prototype.updateRoomAndGuestRequest = function (guests) {
        // Reload search result when room and guest changed
        // (for FIT and Agoda hotel or hotel crossCondition = false)
        this.searchFormModel.guests = guests;
        this.searchForm.get('guests').setValue(guests);
        this.currentRoom = this.searchForm.value.guests[0];
        this.lastestSearchForm = JSON.parse(JSON.stringify(this.searchForm.value));
        this.updateCountOfRoom();
        return this.searchFormModel;
    };
    SearchBoxComponent.prototype.setTotalBudget = function () {
        this.shareBudget.totalBudget = this.shareBudget.booker.amount + this.shareBudget.coBooker.amount;
        this.shareBudget.applyCoBudget = false;
        if (this.coBudget) {
            if (!this.shareBudget.totalBudget || this.shareBudget.totalBudget > this.coBudget) {
                this.shareBudget.totalBudget = this.coBudget;
                this.shareBudget.applyCoBudget = true;
            }
        }
    };
    return SearchBoxComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Input"])(),
    __metadata("design:type", Object)
], SearchBoxComponent.prototype, "data", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Input"])(),
    __metadata("design:type", String)
], SearchBoxComponent.prototype, "type", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Input"])(),
    __metadata("design:type", String)
], SearchBoxComponent.prototype, "layout", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Output"])('onSubmitSearch'),
    __metadata("design:type", Object)
], SearchBoxComponent.prototype, "submitSearch", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Output"])('onGetData'),
    __metadata("design:type", Object)
], SearchBoxComponent.prototype, "sendData", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Output"])('onGetState'),
    __metadata("design:type", Object)
], SearchBoxComponent.prototype, "sendState", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewChild"])('inputDestination'),
    __metadata("design:type", Object)
], SearchBoxComponent.prototype, "inputDestination", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewChild"])('inputCheckIn'),
    __metadata("design:type", Object)
], SearchBoxComponent.prototype, "inputCheckIn", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewChild"])('inputRoomBox'),
    __metadata("design:type", Object)
], SearchBoxComponent.prototype, "inputRoomBox", void 0);
SearchBoxComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Component"])({
        selector: 'app-search-box',
        template: __webpack_require__(1084),
        styles: [__webpack_require__(949)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__angular_forms__["FormBuilder"]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_10_app_services_search_search_service__["b" /* SearchService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_10_app_services_search_search_service__["b" /* SearchService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_11_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_11_app_services_user_user_service__["a" /* UserService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_8__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8__angular_router__["c" /* Router */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_4__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__angular_material__["d" /* MdDialog */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_12_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_12_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_14_app_services_authentication_authentication_service__["a" /* AuthenticationService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_14_app_services_authentication_authentication_service__["a" /* AuthenticationService */]) === "function" && _h || Object, typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_18_app_services_cart_cart_service__["a" /* CartService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_18_app_services_cart_cart_service__["a" /* CartService */]) === "function" && _j || Object, typeof (_k = typeof __WEBPACK_IMPORTED_MODULE_22_app_services_products_product_service__["a" /* ProductService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_22_app_services_products_product_service__["a" /* ProductService */]) === "function" && _k || Object, typeof (_l = typeof __WEBPACK_IMPORTED_MODULE_16__angular_common__["k" /* DecimalPipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_16__angular_common__["k" /* DecimalPipe */]) === "function" && _l || Object, typeof (_m = typeof __WEBPACK_IMPORTED_MODULE_17_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_17_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _m || Object, typeof (_o = typeof __WEBPACK_IMPORTED_MODULE_26_app_services_authorize_authorize_service__["a" /* AuthorizeService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_26_app_services_authorize_authorize_service__["a" /* AuthorizeService */]) === "function" && _o || Object, typeof (_p = typeof __WEBPACK_IMPORTED_MODULE_29_app_services_user_feature_user_feature_service__["a" /* UserFeatureService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_29_app_services_user_feature_user_feature_service__["a" /* UserFeatureService */]) === "function" && _p || Object, typeof (_q = typeof __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__["a" /* GoogleTagManagerService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__["a" /* GoogleTagManagerService */]) === "function" && _q || Object])
], SearchBoxComponent);

var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
//# sourceMappingURL=search-box.component.js.map

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_modal_dialog_general_message_dialog_general_message_component__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(7);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UploadFileComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t;
    return { next: verb(0), "throw": verb(1), "return": verb(2) };
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var UploadFileComponent = (function () {
    function UploadFileComponent(appConfigService, dialog) {
        this.appConfigService = appConfigService;
        this.dialog = dialog;
        this.options = { id: 'file' };
        this.maximumSize = 2097152; // default size: 2 MB
        this.maxFile = 1;
        this.isLoading = false;
        this.onUpload = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onDeleteFile = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.STATE = { NO_ATTACH: 'no-attach', ATTACHING: 'attaching', FULL_ATTACH: 'full-attach' };
        this.FileTypes = { PNG: 'png', JPG: 'jpg', PDF: 'pdf', MSG: 'msg', EML: 'eml' };
        this.defaultErrors = { overflowSize: false, invalidFileType: false, notSelected: false };
        this.currentFile = [];
        this.currentState = this.STATE.NO_ATTACH;
        this.errors = this.defaultErrors;
        this.fileReader = new FileReader();
        this.preloadedFileSizes = new Map();
    }
    UploadFileComponent.prototype.ngOnInit = function () { };
    // tslint:disable:no-unused-variable
    UploadFileComponent.prototype.getCurrentFileName = function (index) {
        return this.currentFile.length > 0 ? this.currentFile[index].name : 'No attached file';
    };
    UploadFileComponent.prototype.getCurrentFileSize = function (index) {
        var size = this.preloadedFileSizes.has(index) ? this.preloadedFileSizes.get(index) : (this.currentFile[index] ? this.currentFile[index].size : 0);
        return this.bytesToHumanSize(size);
    };
    UploadFileComponent.prototype.canDeleteFile = function (index) {
        return !this.preloadedFileSizes.has(index);
    };
    UploadFileComponent.prototype.onFileUploadChanged = function (event) {
        if (event && event.target && event.target.files && event.target.files.length > 0) {
            var file = event.target.files[0];
            if (this.setValidated([file])) {
                var fileIndex = this.currentFile.push(file);
                this.setState();
                this.onUpload.emit({ file: file, fileIndex: fileIndex - 1, fileName: file.name, componentId: this.options.id });
            }
            else {
                this.inputFileElement && (this.inputFileElement.nativeElement.value = '');
            }
        }
    };
    UploadFileComponent.prototype.onCloseButtonClicked = function (index) {
        this.currentFile[index] = null;
        this.currentFile = this.currentFile.filter(function (file) { return file != null; });
        this.setState();
        this.inputFileElement && (this.inputFileElement.nativeElement.value = '');
        this.onDeleteFile.emit(index);
    };
    UploadFileComponent.prototype.bytesToHumanSize = function (bytes) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes === 0) {
            return '0 Byte';
        }
        var index = (Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, index)) + ' ' + sizes[index];
    };
    UploadFileComponent.prototype.showErrorWithMessage = function (message) {
        var title = this.appConfigService.getTranslate('checkout-3-attach-file-title');
        var mainBtn = this.appConfigService.getTranslate('btn-ok');
        var config = {
            data: { icon: 'icon-service-failed', title: title, message: message, mainBtn: mainBtn }
        };
        this.dialog.open(__WEBPACK_IMPORTED_MODULE_2_app_components_modal_dialog_general_message_dialog_general_message_component__["a" /* DialogGeneralMessageComponent */], config);
    };
    UploadFileComponent.prototype.setValidated = function (files) {
        var _this = this;
        if (files === void 0) { files = this.currentFile; }
        var validate = true;
        if (files && files.length === 0) {
            var message = this.appConfigService.getTranslate('checkout-3-attach-file-validation-file-not-attached');
            this.showErrorWithMessage(message);
            this.errors.notSelected = true;
            return false;
        }
        files.forEach(function (file) {
            if (file.size > _this.maximumSize) {
                var message = _this.appConfigService.getTranslate('checkout-3-attach-file-validation-file-size-overflow');
                _this.showErrorWithMessage(message);
                _this.errors.overflowSize = true;
                validate = false;
                return;
            }
            if (!_this.getFileType(file)) {
                var message = _this.appConfigService.getTranslate('checkout-3-attach-file-validation-invalid-file-type');
                _this.showErrorWithMessage(message);
                _this.errors.invalidFileType = true;
                validate = false;
                return;
            }
        });
        return validate;
    };
    UploadFileComponent.prototype.isAttached = function () {
        return this.currentFile && this.currentFile.length > 0;
    };
    UploadFileComponent.prototype.getFileType = function (file) {
        if (!file) {
            return undefined;
        }
        return this.validateFileType(file);
    };
    UploadFileComponent.prototype.getFileTypeForDisplay = function (index) {
        var file = this.currentFile[index];
        if (!file) {
            return undefined;
        }
        return this.validateFileType(file);
    };
    UploadFileComponent.prototype.validateFileType = function (file) {
        var currentType = undefined;
        if (/\/pdf/.test(file.type)) {
            currentType = this.FileTypes.PDF;
        }
        else if (/\/jpg|\/jpeg/.test(file.type)) {
            currentType = this.FileTypes.JPG;
        }
        else if (/\/png/.test(file.type)) {
            currentType = this.FileTypes.PNG;
        }
        else if (/\/rfc822/.test(file.type)) {
            currentType = this.FileTypes.EML;
        }
        else if (/\/vnd.ms-outlook/.test(file.type) || /\.msg/.test(file.name)) {
            currentType = this.FileTypes.MSG;
        }
        return currentType;
    };
    UploadFileComponent.prototype.getBase64Images = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (!_this.currentFile) {
                            reject('file empty!');
                        }
                        _this.fileReader.readAsDataURL(_this.currentFile[0]);
                        _this.fileReader.onload = function () {
                            resolve(_this.fileReader.result);
                        };
                        _this.fileReader.onerror = function (err) {
                            console.error('[UploadFileComponent] read file error', err);
                            reject(err);
                        };
                    })];
            });
        });
    };
    UploadFileComponent.prototype.getCurrentFile = function () {
        return this.currentFile || null;
    };
    UploadFileComponent.prototype.setPreloadedFiles = function (attachments) {
        var _this = this;
        var mimeTypeMap = {
            pdf: 'application/pdf',
            jpg: 'image/jpeg',
            jpeg: 'image/jpeg',
            png: 'image/png',
            eml: 'message/rfc822',
            msg: 'application/vnd.ms-outlook',
        };
        attachments.forEach(function (attachment) {
            var fileType = attachment.fileType ? attachment.fileType.toLowerCase() : '';
            var mimeType = mimeTypeMap[fileType] || fileType;
            var index = _this.currentFile.push(new File([''], attachment.originalFileName, { type: mimeType })) - 1;
            _this.preloadedFileSizes.set(index, attachment.fileSize);
        });
        this.setState();
    };
    UploadFileComponent.prototype.setState = function () {
        if (this.currentFile.length === 0) {
            this.currentState = this.STATE.NO_ATTACH;
        }
        else if (this.currentFile.length === this.maxFile) {
            this.currentState = this.STATE.FULL_ATTACH;
        }
        else {
            this.currentState = this.STATE.ATTACHING;
        }
    };
    return UploadFileComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], UploadFileComponent.prototype, "options", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], UploadFileComponent.prototype, "maximumSize", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], UploadFileComponent.prototype, "maxFile", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], UploadFileComponent.prototype, "isLoading", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", Object)
], UploadFileComponent.prototype, "onUpload", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", Object)
], UploadFileComponent.prototype, "onDeleteFile", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('inputFile'),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _a || Object)
], UploadFileComponent.prototype, "inputFileElement", void 0);
UploadFileComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'upload-file',
        template: __webpack_require__(1093),
        styles: [__webpack_require__(958)]
    }),
    __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialog */]) === "function" && _c || Object])
], UploadFileComponent);

var _a, _b, _c;
//# sourceMappingURL=upload-file.component.js.map

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__daterangepicker_directive__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(29);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DaterangepickerModule; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var DaterangepickerModule = (function () {
    function DaterangepickerModule() {
    }
    return DaterangepickerModule;
}());
DaterangepickerModule = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
        imports: [__WEBPACK_IMPORTED_MODULE_2__angular_common__["a" /* CommonModule */]],
        declarations: [__WEBPACK_IMPORTED_MODULE_1__daterangepicker_directive__["a" /* DaterangepickerDirective */]],
        exports: [__WEBPACK_IMPORTED_MODULE_1__daterangepicker_directive__["a" /* DaterangepickerDirective */]]
    })
], DaterangepickerModule);

//# sourceMappingURL=daterangepicker.module.js.map

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BookingPageModel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BookingListModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DisplayBookingListDTO; });
/* unused harmony export BookingApprovalModel */
var BookingPageModel = (function () {
    function BookingPageModel() {
    }
    return BookingPageModel;
}());

var BookingListModel = (function () {
    function BookingListModel() {
    }
    return BookingListModel;
}());

var DisplayBookingListDTO = (function () {
    function DisplayBookingListDTO() {
    }
    return DisplayBookingListDTO;
}());

var BookingApprovalModel = (function () {
    function BookingApprovalModel() {
    }
    return BookingApprovalModel;
}());

//# sourceMappingURL=booking-list.model.js.map

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginApiResponseModel; });
var LoginApiResponseModel = (function () {
    function LoginApiResponseModel() {
    }
    LoginApiResponseModel.requireFields = function () {
        return [
            'logo', 'appKey', 'affiliateId', 'companyCode',
            'apiName', 'httpMethod', 'endPoint',
            'userNameField', 'passwordField', 'encryptionType',
        ];
    };
    return LoginApiResponseModel;
}());

//# sourceMappingURL=login-api-response.model.js.map

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environments_environment__ = __webpack_require__(22);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BudgetService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var BudgetService = (function () {
    function BudgetService(actHttp) {
        this.actHttp = actHttp;
    }
    BudgetService.prototype.getMyBudget = function (companyId, userId, year) {
        var options = this.actHttp.getRequestOptions();
        var url = __WEBPACK_IMPORTED_MODULE_2_environments_environment__["a" /* environment */].endpoint.getMyBudget
            .replace('{companyId}', companyId.toString())
            .replace('{userId}', userId.toString())
            + ("?year=" + year);
        return this.actHttp.get(url, options).map(function (res) { return res.json().data; });
    };
    return BudgetService;
}());
BudgetService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object])
], BudgetService);

var _a;
//# sourceMappingURL=budget.service.js.map

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environments_environment__ = __webpack_require__(22);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SupplierConfirmationService; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var SupplierConfirmationService = (function () {
    function SupplierConfirmationService(actHttpService) {
        this.actHttpService = actHttpService;
    }
    SupplierConfirmationService.prototype.verifyConfirmationToken = function (data) {
        var url = __WEBPACK_IMPORTED_MODULE_2_environments_environment__["a" /* environment */].endpoint.supplierConfirmation;
        return this.actHttpService.rawPost(url, data);
    };
    SupplierConfirmationService.prototype.confirmationEmailConfirm = function (data) {
        var url = __WEBPACK_IMPORTED_MODULE_2_environments_environment__["a" /* environment */].endpoint.supplierConfirmationSubmitEmailConfirm;
        return this.actHttpService.rawPost(url, data);
    };
    SupplierConfirmationService.prototype.confirmationEmailReject = function (data) {
        var url = __WEBPACK_IMPORTED_MODULE_2_environments_environment__["a" /* environment */].endpoint.supplierConfirmationSubmitEmailReject;
        return this.actHttpService.rawPost(url, data);
    };
    return SupplierConfirmationService;
}());
SupplierConfirmationService = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["c" /* ActHttpService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__act_http_act_http_service__["c" /* ActHttpService */]) === "function" && _a || Object])
], SupplierConfirmationService);

var _a;
//# sourceMappingURL=supplier-confirmation.service.js.map

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_user_feature_user_feature_service__ = __webpack_require__(86);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthorizationGuard; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var AuthorizationGuard = (function () {
    function AuthorizationGuard(router, userFeatureService, activatedRoute, appConfigService) {
        this.router = router;
        this.userFeatureService = userFeatureService;
        this.activatedRoute = activatedRoute;
        this.appConfigService = appConfigService;
    }
    AuthorizationGuard.prototype.canActivate = function (next, state) {
        var path = state.url.substring(0, state.url.indexOf('?'));
        path = path.length === 0 ? state.url : path;
        switch (path) {
            case '/approval':
                if (!this.userFeatureService.canShowApprovalList()) {
                    this.router.navigate([''], { queryParams: { returnUrl: state.url } });
                    return false;
                }
                break;
        }
        return true;
    };
    return AuthorizationGuard;
}());
AuthorizationGuard = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_router__["c" /* Router */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_user_feature_user_feature_service__["a" /* UserFeatureService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_user_feature_user_feature_service__["a" /* UserFeatureService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_router__["b" /* ActivatedRoute */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_router__["b" /* ActivatedRoute */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object])
], AuthorizationGuard);

var _a, _b, _c, _d;
//# sourceMappingURL=authorization.guard.js.map

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductPOIPayload */
/* unused harmony export FilterPoi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PriceRange; });
/* unused harmony export Room */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Paginate; });
/* unused harmony export SortBy */
/* unused harmony export PoiLocation */
var ProductPOIPayload = (function () {
    function ProductPOIPayload(productNearBy, searchFormModel) {
        if (productNearBy === void 0) { productNearBy = undefined; }
        if (searchFormModel === void 0) { searchFormModel = undefined; }
        if (productNearBy) {
            this.langId = productNearBy.langId;
            this.categoryId = 3;
            this.currencyId = 1;
            this.destinationId = productNearBy.destinationId;
            this.poi = new PoiLocation(searchFormModel);
            this.filter = new FilterPoi(productNearBy, searchFormModel);
        }
    }
    return ProductPOIPayload;
}());

var FilterPoi = (function () {
    function FilterPoi(productNearBy, searchFormModel) {
        if (productNearBy === void 0) { productNearBy = undefined; }
        if (searchFormModel === void 0) { searchFormModel = undefined; }
        if (productNearBy) {
            this.distance = searchFormModel.radius;
            this.priceRange = productNearBy.priceRange;
            this.checkIn = productNearBy.checkIn;
            this.checkOut = productNearBy.checkOut;
            this.rooms = productNearBy.rooms;
            this.sort = new SortBy;
            this.pagination = new Paginate;
        }
    }
    return FilterPoi;
}());

var PriceRange = (function () {
    function PriceRange(min, max) {
        if (min === void 0) { min = undefined; }
        if (max === void 0) { max = undefined; }
        this.min = min;
        this.max = max;
    }
    return PriceRange;
}());

var Room = (function () {
    function Room() {
    }
    return Room;
}());

var Paginate = (function () {
    function Paginate() {
        this.itemperpage = 30;
        this.pageno = 1;
    }
    return Paginate;
}());

var SortBy = (function () {
    function SortBy() {
        this.poiMap = true;
    }
    return SortBy;
}());

var PoiLocation = (function () {
    function PoiLocation(searchFormModel) {
        if (searchFormModel === void 0) { searchFormModel = undefined; }
        this.lat = searchFormModel.destination.poi.lat;
        this.lon = searchFormModel.destination.poi.lon;
    }
    return PoiLocation;
}());

//# sourceMappingURL=product-poi-payload.js.map

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CampaignTrackEventRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CampaignTrackEventType; });
var CampaignTrackEventRequest = (function () {
    function CampaignTrackEventRequest(event) {
        this.event = event;
    }
    return CampaignTrackEventRequest;
}());

var CampaignTrackEventType = (function () {
    function CampaignTrackEventType() {
    }
    return CampaignTrackEventType;
}());

CampaignTrackEventType.VIEW = 'view';
CampaignTrackEventType.CLICK = 'click';
//# sourceMappingURL=campaign.model.js.map

/***/ }),
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_custom_preloading_strategy__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_guard_page_guard__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_guard_app_deep_link_guard__ = __webpack_require__(266);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppRoutingModule; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var routes = [
    { path: '', loadChildren: 'app/pages/search-module/search-module.module#SearchModule', data: { preload: true }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'landing', redirectTo: '', canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'hotel/searchdestination', loadChildren: 'app/pages/product-list-module/product-list-module.module#ProductListModule', data: { preload: true }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'hotel/detail/:slug', loadChildren: 'app/pages/product-detail-module/product-detail-module.module#ProductDetailModule', data: { preload: true }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'checkout', loadChildren: 'app/pages/checkout-module/checkout-module.module#CheckoutModule', data: { preload: true }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'thankyou', loadChildren: 'app/pages/thankyou/thankyou-module.module#ThankyouModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'profile', loadChildren: 'app/pages/my-profile/my-profile-module.module#MyProfileModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'booking', loadChildren: 'app/pages/booking-module/booking-module.module#BookingModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'setting', loadChildren: 'app/pages/setting-module/setting-module.module#SettingModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'company', loadChildren: 'app/pages/affiliate-module/affiliate.module#AffiliateModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'approval', loadChildren: 'app/pages/approval-module/approval-module.module#ApprovalModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'rating', loadChildren: 'app/pages/rating-module/rating-module.module#RatingModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'confirmation', loadChildren: 'app/pages/confirmation-module/confirmation-module.module#ConfirmationModuleModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'promotion', loadChildren: 'app/pages/promotion-module/promotion-module.module#PromotionModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'mice', loadChildren: 'app/pages/mice-module/mice-module.module#MiceModuleModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'permission', loadChildren: 'app/pages/my-budget-module/my-budget-module.module#MyBudgetModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'share-budget-code', loadChildren: 'app/pages/share-budget-code-module/share-budget-code-module.module#ShareBudgetCodeModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'privacy-policy', loadChildren: 'app/pages/privacy-policy-module/privacy-policy-module.module#PrivacyPolicyModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'terms-of-use', loadChildren: 'app/pages/terms-of-use-module/terms-of-use-module.module#TermsOfUseModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'data-deletion-instructions', loadChildren: 'app/pages/data-deletion-instructions-module/data-deletion-instructions-module.module#DataDeletionInstructionsModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'cookies-policy', loadChildren: 'app/pages/cookies-policy/cookies-policy.module#CookiesPolicyModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'fleet-card', loadChildren: 'app/pages/fleet-card-module/fleet-card-module.module#FleetCardModule', data: { preload: false }, canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_language_currency_guard__["a" /* LanguageCurrencyGuard */]] },
    { path: 'pre-approval', canActivate: [__WEBPACK_IMPORTED_MODULE_4__services_guard_page_guard__["a" /* PageGuard */]], children: [
            { path: '**', children: [] }
        ] },
    { path: 'app', canActivate: [__WEBPACK_IMPORTED_MODULE_5__services_guard_app_deep_link_guard__["a" /* AppDeepLinkGuard */]], children: [
            { path: '**', children: [] }
        ] },
];
var AppRoutingModule = (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
AppRoutingModule = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["NgModule"])({
        imports: [__WEBPACK_IMPORTED_MODULE_0__angular_router__["a" /* RouterModule */].forRoot(routes, { preloadingStrategy: __WEBPACK_IMPORTED_MODULE_1__utilities_custom_preloading_strategy__["a" /* CustomPreloadingStrategy */] })],
        exports: [__WEBPACK_IMPORTED_MODULE_0__angular_router__["a" /* RouterModule */]]
    })
], AppRoutingModule);

//# sourceMappingURL=app-routing.module.js.map

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_touch_class_js__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_touch_class_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities_touch_class_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_detect_ios_js__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_detect_ios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utilities_detect_ios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_detect_chrome_js__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_detect_chrome_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utilities_detect_chrome_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_detect_andriod_js__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_detect_andriod_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utilities_detect_andriod_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var AppComponent = (function () {
    function AppComponent() {
    }
    return AppComponent;
}());
AppComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__angular_core__["Component"])({
        selector: 'app-root',
        template: __webpack_require__(1002),
        styles: [__webpack_require__(867)],
        encapsulation: __WEBPACK_IMPORTED_MODULE_4__angular_core__["ViewEncapsulation"].None
    }),
    __metadata("design:paramtypes", [])
], AppComponent);

//# sourceMappingURL=app.component.js.map

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_components_module__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_component__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_routing_module__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser_animations__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_utilities_helper__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_http__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_services_module__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_custom_preloading_strategy__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_page_not_found_module_page_not_found_module_module__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_terms_and_conditions_terms_and_conditions_component__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modal_dialog_special_day_dialog_special_day_component__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pipes_translate_singular_plural_pipe__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pipes_safeHTML_pipe__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_raven_js__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__environments_properties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pipes_convert_exchange_pipe__ = __webpack_require__(263);
/* unused harmony export RavenErrorHandler */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppModule; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





















__WEBPACK_IMPORTED_MODULE_18_raven_js__["config"](__WEBPACK_IMPORTED_MODULE_19__environments_properties__["a" /* sentryKey */])
    .install();
__WEBPACK_IMPORTED_MODULE_18_raven_js__["setEnvironment"](__WEBPACK_IMPORTED_MODULE_19__environments_properties__["b" /* envName */]);
var RavenErrorHandler = (function () {
    function RavenErrorHandler() {
    }
    RavenErrorHandler.prototype.handleError = function (err) {
        if (__WEBPACK_IMPORTED_MODULE_19__environments_properties__["b" /* envName */] !== 'local') {
            __WEBPACK_IMPORTED_MODULE_18_raven_js__["captureException"](err);
        }
        console.error(err);
    };
    return RavenErrorHandler;
}());

var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
AppModule = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_core__["NgModule"])({
        declarations: [
            __WEBPACK_IMPORTED_MODULE_2__app_component__["a" /* AppComponent */],
        ],
        imports: [
            __WEBPACK_IMPORTED_MODULE_0__angular_common__["a" /* CommonModule */],
            __WEBPACK_IMPORTED_MODULE_1_app_components_components_module__["a" /* ComponentsModule */],
            __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["a" /* BrowserModule */],
            __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser_animations__["a" /* BrowserAnimationsModule */],
            __WEBPACK_IMPORTED_MODULE_6__angular_forms__["FormsModule"],
            __WEBPACK_IMPORTED_MODULE_8__angular_http__["a" /* HttpModule */],
            __WEBPACK_IMPORTED_MODULE_10__services_services_module__["a" /* ServicesModule */],
            __WEBPACK_IMPORTED_MODULE_3__app_routing_module__["a" /* AppRoutingModule */],
            __WEBPACK_IMPORTED_MODULE_13__pages_page_not_found_module_page_not_found_module_module__["a" /* PageNotFoundModule */],
        ],
        entryComponents: [
            __WEBPACK_IMPORTED_MODULE_14__components_terms_and_conditions_terms_and_conditions_component__["a" /* TermsAndConditionsComponent */],
            __WEBPACK_IMPORTED_MODULE_15__components_modal_dialog_special_day_dialog_special_day_component__["a" /* DialogSpecialDayComponent */],
        ],
        providers: [
            __WEBPACK_IMPORTED_MODULE_7_app_utilities_helper__["a" /* Helper */],
            __WEBPACK_IMPORTED_MODULE_11__pipes_translate_pipe__["a" /* TranslatePipe */],
            __WEBPACK_IMPORTED_MODULE_20__pipes_convert_exchange_pipe__["a" /* ConvertExchangePipe */],
            __WEBPACK_IMPORTED_MODULE_12__utilities_custom_preloading_strategy__["a" /* CustomPreloadingStrategy */],
            __WEBPACK_IMPORTED_MODULE_16__pipes_translate_singular_plural_pipe__["a" /* TranslateSingularPluralPipe */],
            __WEBPACK_IMPORTED_MODULE_17__pipes_safeHTML_pipe__["a" /* SafeHTMLPipe */],
            { provide: __WEBPACK_IMPORTED_MODULE_9__angular_core__["ErrorHandler"], useClass: RavenErrorHandler }
        ],
        bootstrap: [__WEBPACK_IMPORTED_MODULE_2__app_component__["a" /* AppComponent */]]
    })
], AppModule);

//# sourceMappingURL=app.module.js.map

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActTextAreaComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var ActTextAreaComponent = (function () {
    function ActTextAreaComponent() {
        this.text = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    ActTextAreaComponent.prototype.ngOnChanges = function () {
    };
    ActTextAreaComponent.prototype.onKeyup = function (event) {
        if (event.key != ' ' || event.target.value.trim().length != 0) {
            this.text.emit(event.target.value.trim());
        }
    };
    ActTextAreaComponent.prototype.onKeySpace = function (event) {
        if (event.target.value.trim().length == 0) {
            event.preventDefault();
        }
    };
    ActTextAreaComponent.prototype.onFocusOut = function (event) {
        event.target.value = event.target.value.trim();
    };
    return ActTextAreaComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActTextAreaComponent.prototype, "id", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActTextAreaComponent.prototype, "label", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActTextAreaComponent.prototype, "placeholder", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActTextAreaComponent.prototype, "maxLength", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActTextAreaComponent.prototype, "isError", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActTextAreaComponent.prototype, "errorText", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", Object)
], ActTextAreaComponent.prototype, "text", void 0);
ActTextAreaComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-text-area',
        template: __webpack_require__(1005),
        styles: [__webpack_require__(870)]
    })
], ActTextAreaComponent);

//# sourceMappingURL=act-text-area.component.js.map

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApprovalButtonComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var ApprovalButtonComponent = (function () {
    function ApprovalButtonComponent() {
        this.index = 0;
        this.disabledRejectBtn = false;
        this.options = { page: '' };
        this.isApproveLoading = false;
        this.display = "desktop";
        this.onApproveButtonOutput = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](); // tslint:disable-line
        this.onRejectButtonOutput = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](); // tslint:disable-line
    }
    ApprovalButtonComponent.prototype.ngOnInit = function () {
    };
    ApprovalButtonComponent.prototype.onApproveButtonClicked = function () {
        this.onApproveButtonOutput.emit();
    };
    ApprovalButtonComponent.prototype.onRejectButtonClicked = function () {
        this.onRejectButtonOutput.emit();
    };
    return ApprovalButtonComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ApprovalButtonComponent.prototype, "index", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ApprovalButtonComponent.prototype, "disabledRejectBtn", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ApprovalButtonComponent.prototype, "options", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ApprovalButtonComponent.prototype, "isApproveLoading", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ApprovalButtonComponent.prototype, "display", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])('onApproveClicked'),
    __metadata("design:type", Object)
], ApprovalButtonComponent.prototype, "onApproveButtonOutput", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])('onRejectClicked'),
    __metadata("design:type", Object)
], ApprovalButtonComponent.prototype, "onRejectButtonOutput", void 0);
ApprovalButtonComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'approval-button',
        template: __webpack_require__(1008),
        styles: [__webpack_require__(873)]
    }),
    __metadata("design:paramtypes", [])
], ApprovalButtonComponent);

//# sourceMappingURL=approval-button.component.js.map

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_approval_approval_service__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vendors_moment_locale_th__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApprovalActionComponent; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var DisplayPayment = (function () {
    function DisplayPayment() {
    }
    return DisplayPayment;
}());
var ApprovalActionComponent = (function () {
    function ApprovalActionComponent(router, appConfigService, approvalService) {
        this.router = router;
        this.appConfigService = appConfigService;
        this.approvalService = approvalService;
        this.paymentCreditTerms = null;
        this.paymentCoBooker = null;
        this.displayPaymentNonCreditTermList = [];
        this.PaymentMethodDetailType = __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["m" /* PaymentMethodDetailType */];
        this.isShareBudget = false;
        this.isMultiPayment = false;
        this.STATE = __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["U" /* ApprovalActionState */];
        this.LANG = __WEBPACK_IMPORTED_MODULE_5__model_constant__["a" /* Language */];
        this.state = (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_1_app_model_constant__["U" /* ApprovalActionState */].APPROVED] = false,
            _a[__WEBPACK_IMPORTED_MODULE_1_app_model_constant__["U" /* ApprovalActionState */].REJECT_WITH_FEE] = false,
            _a[__WEBPACK_IMPORTED_MODULE_1_app_model_constant__["U" /* ApprovalActionState */].REJECT_FREE] = false,
            _a[__WEBPACK_IMPORTED_MODULE_1_app_model_constant__["U" /* ApprovalActionState */].REJECTED] = false,
            _a[__WEBPACK_IMPORTED_MODULE_1_app_model_constant__["U" /* ApprovalActionState */].UNABLE_APPROVAL] = false,
            _a);
        this.loading = {
            PAGE: false,
            BUTTON: false
        };
        var _a;
    }
    ApprovalActionComponent.prototype.ngOnInit = function () {
        this.setLoading('PAGE');
        this.currentLang = this.appConfigService.getLanguage();
        if (this.approvalAction === 'reject') {
            this.getBookingCancellationStatus();
        }
        else {
            this.updateBookingApprovalStatus();
        }
    };
    ApprovalActionComponent.prototype.getBookingCancellationStatus = function () {
        var _this = this;
        this.subscriptionGetBookingCancellationStatus = this.approvalService.getBookingCancellationStatus(this.bookingId, this.approvalRef)
            .subscribe(function (data) {
            if (data) {
                _this.bookingCancellationStatus = data;
                if (data.cancellationChargeList) {
                    _this.cancellationChargeList = data.cancellationChargeList;
                    _this.cancellationChargeList = _this.cancellationChargeList.map(function (item) {
                        return __assign({}, item, { cancellationDate: item.fromDate ? __WEBPACK_IMPORTED_MODULE_6_vendors_moment_locale_th__(item.fromDate).locale(_this.currentLang).format('DD MMM YY') : undefined });
                    });
                    _this.cancellationFee = data.totalCharge;
                    if (data.bookerCancellationChargeList !== undefined) {
                        var bookerCancellationChargeList = data.bookerCancellationChargeList;
                        if (bookerCancellationChargeList.filter(function (cancellation) { return cancellation.paymentType === __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_TERMS; }).length > 1) {
                            _this.isShareBudget = true;
                        }
                        for (var i = 0; i < bookerCancellationChargeList.length; i++) {
                            if (bookerCancellationChargeList[i].paymentType === __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_TERMS) {
                                if (_this.isShareBudget) {
                                    if (bookerCancellationChargeList[i].mainBooker) {
                                        _this.paymentCreditTerms += bookerCancellationChargeList[i].totalCharge;
                                    }
                                    else {
                                        _this.paymentCoBooker += bookerCancellationChargeList[i].totalCharge;
                                    }
                                }
                                else {
                                    _this.paymentCreditTerms += bookerCancellationChargeList[i].totalCharge;
                                }
                            }
                            if (bookerCancellationChargeList[i].paymentType !== __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_TERMS) {
                                var label = '';
                                switch (bookerCancellationChargeList[i].paymentType) {
                                    case __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_CARD:
                                        label = 'booking-cancellation-credit-card';
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["m" /* PaymentMethodDetailType */].TRUE_MONEY:
                                        label = 'booking-cancellation-true-money';
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["m" /* PaymentMethodDetailType */].CORPORATE_FLEET:
                                        label = 'booking-cancellation-corporate-fleet';
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_1_app_model_constant__["m" /* PaymentMethodDetailType */].PERSONAL_FLEET:
                                        label = 'booking-cancellation-personal-fleet';
                                        break;
                                }
                                _this.displayPaymentNonCreditTermList.push({
                                    label: label,
                                    amount: bookerCancellationChargeList[i].totalCharge
                                });
                            }
                        }
                        _this.isMultiPayment = bookerCancellationChargeList.length > 1;
                    }
                    if (_this.cancellationFee > 0) {
                        _this.setState(__WEBPACK_IMPORTED_MODULE_1_app_model_constant__["U" /* ApprovalActionState */].REJECT_WITH_FEE);
                    }
                    else {
                        _this.setState(__WEBPACK_IMPORTED_MODULE_1_app_model_constant__["U" /* ApprovalActionState */].REJECT_FREE);
                    }
                }
            }
            else {
                _this.setState(__WEBPACK_IMPORTED_MODULE_1_app_model_constant__["U" /* ApprovalActionState */].UNABLE_APPROVAL);
            }
        }, function (errors) {
            _this.setState(__WEBPACK_IMPORTED_MODULE_1_app_model_constant__["U" /* ApprovalActionState */].UNABLE_APPROVAL);
        });
    };
    ;
    ApprovalActionComponent.prototype.updateBookingApprovalStatus = function (action) {
        var _this = this;
        if (action === void 0) { action = 'approve'; }
        var updateBookingApprovalStatus;
        switch (action) {
            case 'approve':
                updateBookingApprovalStatus = this.approvalService.approveBooking(this.bookingId, this.approvalRef, false);
                break;
            case 'reject':
                if (this.isReasonError === false) {
                    this.setLoading('BUTTON');
                    updateBookingApprovalStatus = this.approvalService.rejectBooking(this.bookingId, this.approvalRef, this.reasonText, false);
                }
                else {
                    this.isReasonError = true;
                }
        }
        this.subscriptionUpdateBookingApprovalStatus = updateBookingApprovalStatus.subscribe(function (response) { return _this.handleResponse(); }, function (errors) { return _this.setState(__WEBPACK_IMPORTED_MODULE_1_app_model_constant__["U" /* ApprovalActionState */].UNABLE_APPROVAL); });
    };
    ApprovalActionComponent.prototype.handleResponse = function () {
        if (this.approvalAction === 'approve') {
            this.setState(__WEBPACK_IMPORTED_MODULE_1_app_model_constant__["U" /* ApprovalActionState */].APPROVED);
        }
        else if (this.approvalAction === 'reject') {
            this.setState(__WEBPACK_IMPORTED_MODULE_1_app_model_constant__["U" /* ApprovalActionState */].REJECTED);
        }
        else {
            this.setState(__WEBPACK_IMPORTED_MODULE_1_app_model_constant__["U" /* ApprovalActionState */].UNABLE_APPROVAL);
        }
    };
    ApprovalActionComponent.prototype.setState = function (value) {
        if (value === void 0) { value = ''; }
        this.setLoading();
        for (var name in this.state) {
            if (this.state.hasOwnProperty(name)) {
                this.state[name] = (name === value);
            }
        }
    };
    ApprovalActionComponent.prototype.setLoading = function (value) {
        if (value === void 0) { value = ''; }
        for (var name in this.loading) {
            if (this.loading.hasOwnProperty(name)) {
                this.loading[name] = (name === value);
            }
        }
    };
    ApprovalActionComponent.prototype.goToHome = function () {
        this.router.navigateByUrl('?lang=' + this.appConfigService.getLanguage());
    };
    ApprovalActionComponent.prototype.goToApprovalList = function () {
        this.router.navigateByUrl('/approval?lang=' + this.appConfigService.getLanguage() + '&bookingid=' + this.bookingId);
    };
    ApprovalActionComponent.prototype.ngOnDestroy = function () {
        this.subscriptionGetBookingCancellationStatus && this.subscriptionGetBookingCancellationStatus.unsubscribe();
        this.subscriptionUpdateBookingApprovalStatus && this.subscriptionUpdateBookingApprovalStatus.unsubscribe();
    };
    ApprovalActionComponent.prototype.onKeyupReason = function (text) {
        this.isReasonError = text && text.trim().length > 0 ? false : true;
        this.reasonText = text;
    };
    return ApprovalActionComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('bookingId'),
    __metadata("design:type", Object)
], ApprovalActionComponent.prototype, "bookingId", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('approvalRef'),
    __metadata("design:type", Object)
], ApprovalActionComponent.prototype, "approvalRef", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('approvalAction'),
    __metadata("design:type", Object)
], ApprovalActionComponent.prototype, "approvalAction", void 0);
ApprovalActionComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-approval-action',
        template: __webpack_require__(1009),
        styles: [__webpack_require__(874)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_4__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__angular_router__["c" /* Router */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_approval_approval_service__["a" /* ApprovalService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_approval_approval_service__["a" /* ApprovalService */]) === "function" && _c || Object])
], ApprovalActionComponent);

var _a, _b, _c;
//# sourceMappingURL=approval-action.component.js.map

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_banner_banner_service__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BannerBillboardComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var BannerBillboardComponent = (function () {
    function BannerBillboardComponent(appConfigService, utilitiesService, userService, bannerService) {
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.userService = userService;
        this.bannerService = bannerService;
        this.billboards = [];
        this.bannerType = 'billboard';
        this.isMobile = this.utilitiesService.isMobile();
        this.lang = this.appConfigService.getLanguage();
    }
    BannerBillboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fetchBillboard();
        this.languageSubscription && this.languageSubscription.unsubscribe();
        this.languageSubscription = this.appConfigService.getLanguageObs()
            .subscribe(function (val) {
            if (_this.lang !== val) {
                _this.lang = val;
                _this.fetchBillboard();
            }
        });
    };
    BannerBillboardComponent.prototype.ngOnDestroy = function () {
        this.getBannerBillboardSubscription && this.getBannerBillboardSubscription.unsubscribe();
    };
    BannerBillboardComponent.prototype.initCarousel = function () {
        var _this = this;
        setTimeout(function () {
            var owlCarousel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.billboard-owl');
            if (owlCarousel && owlCarousel.children().length === _this.billboards.length) {
                owlCarousel.owlCarousel({
                    loop: true,
                    margin: 10,
                    nav: false,
                    items: 1,
                    autoplay: true,
                    autoplayTimeout: 5000,
                    autoplayHoverPause: true
                });
            }
            else {
                _this.initCarousel();
            }
        });
    };
    BannerBillboardComponent.prototype.fetchBillboard = function () {
        var _this = this;
        this.billboards = [];
        var companyId = this.userService.getUser().companyId;
        this.getBannerBillboardSubscription && this.getBannerBillboardSubscription.unsubscribe();
        this.getBannerBillboardSubscription = this.bannerService.getBannerBillboard(companyId, this.lang, this.isMobile ? 'mobile' : 'desktop')
            .subscribe(function (res) {
            _this.billboards = res;
            _this.initCarousel();
        }, function (err) {
            console.error(err);
            _this.billboards = [];
        });
    };
    return BannerBillboardComponent;
}());
BannerBillboardComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
        selector: 'act-banner-billboard',
        template: __webpack_require__(1010),
        styles: [__webpack_require__(875)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_user_user_service__["a" /* UserService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_banner_banner_service__["a" /* BannerService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_banner_banner_service__["a" /* BannerService */]) === "function" && _d || Object])
], BannerBillboardComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=banner-billboard.component.js.map

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_banner_banner_service__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BannerLeaderboardComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var BannerLeaderboardComponent = (function () {
    function BannerLeaderboardComponent(appConfigService, utilitiesService, userService, bannerService) {
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.userService = userService;
        this.bannerService = bannerService;
        this.bannerType = 'leaderboard';
        this.isMobile = this.utilitiesService.isMobile();
        this.lang = this.appConfigService.getLanguage();
    }
    BannerLeaderboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fetchLeaderboard();
        this.languageSubscription && this.languageSubscription.unsubscribe();
        this.languageSubscription = this.appConfigService.getLanguageObs()
            .subscribe(function (val) {
            if (_this.lang !== val) {
                _this.lang = val;
                _this.fetchLeaderboard();
            }
        });
    };
    BannerLeaderboardComponent.prototype.ngOnDestroy = function () {
        this.getBannerLeaderboardSubscription && this.getBannerLeaderboardSubscription.unsubscribe();
    };
    BannerLeaderboardComponent.prototype.fetchLeaderboard = function () {
        var _this = this;
        var companyId = this.userService.getUser().companyId;
        this.getBannerLeaderboardSubscription && this.getBannerLeaderboardSubscription.unsubscribe();
        this.getBannerLeaderboardSubscription = this.bannerService.getBannerLeaderboard(companyId, this.lang, this.isMobile ? 'mobile' : 'desktop')
            .subscribe(function (res) {
            if (res && res.length > 0) {
                _this.leaderboard = res[0];
            }
        }, function (err) {
            console.error(err);
        });
    };
    return BannerLeaderboardComponent;
}());
BannerLeaderboardComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-banner-leaderboard',
        template: __webpack_require__(1011),
        styles: [__webpack_require__(876)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_user_user_service__["a" /* UserService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_banner_banner_service__["a" /* BannerService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_banner_banner_service__["a" /* BannerService */]) === "function" && _d || Object])
], BannerLeaderboardComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=banner-leaderboard.component.js.map

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_banner_banner_service__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_owl_carousel_dist_owl_carousel_js__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_owl_carousel_dist_owl_carousel_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_owl_carousel_dist_owl_carousel_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__ = __webpack_require__(15);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BannerPromotionComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var BannerPromotionComponent = (function () {
    function BannerPromotionComponent(appConfigService, bannerService, utilitiesService, userService) {
        this.appConfigService = appConfigService;
        this.bannerService = bannerService;
        this.utilitiesService = utilitiesService;
        this.userService = userService;
        this.bannerType = 'hotel_deals';
    }
    Object.defineProperty(BannerPromotionComponent.prototype, "isMobile", {
        get: function () {
            return this.utilitiesService.isMobile();
        },
        enumerable: true,
        configurable: true
    });
    BannerPromotionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscriptionLanguage && this.subscriptionLanguage.unsubscribe();
        this.subscriptionLanguage = this.appConfigService.getLanguageObs()
            .subscribe(function (val) {
            if (_this.lang !== val) {
                _this.fetchData();
            }
        });
        this.fetchData();
    };
    BannerPromotionComponent.prototype.initCarousel = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.utilitiesService.isMobile()) {
                __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.banner-owl').owlCarousel({
                    loop: true,
                    margin: 10,
                    nav: false,
                    items: 1
                });
            }
        });
    };
    BannerPromotionComponent.prototype.fetchData = function () {
        var _this = this;
        this.banners = undefined;
        var companyId = this.userService.getUser().companyId;
        this.subscriptionGetBannerList && this.subscriptionGetBannerList.unsubscribe();
        this.subscriptionGetBannerList = this.bannerService.getBannerHotelDealList(companyId, this.appConfigService.getLanguage(), this.utilitiesService.isMobile())
            .subscribe(function (res) {
            _this.banners = _this.bannerService.transformToDisplayBanner(res);
            _this.initCarousel();
        }, function (res) {
            _this.banners = undefined;
        });
    };
    BannerPromotionComponent.prototype.openNewTab = function (banner, isMobileOnly) {
        if (isMobileOnly) {
            if (this.utilitiesService.isMobile()) {
                window.open(banner.link);
            }
        }
        else {
            window.open(banner.link);
        }
    };
    BannerPromotionComponent.prototype.ngOnDestroy = function () {
        this.subscriptionLanguage && this.subscriptionLanguage.unsubscribe();
        this.subscriptionGetBannerList && this.subscriptionGetBannerList.unsubscribe();
    };
    return BannerPromotionComponent;
}());
BannerPromotionComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-banner-promotion',
        template: __webpack_require__(1012),
        styles: [__webpack_require__(877)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_banner_banner_service__["a" /* BannerService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_banner_banner_service__["a" /* BannerService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_user_user_service__["a" /* UserService */]) === "function" && _d || Object])
], BannerPromotionComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=banner-promotion.component.js.map

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_billing_billing_model__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__billing_form_billing_form_component__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modal_dialog_confirm_action_dialog_confirm_action_component__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_modal_dialog_confirm_dialog_confirm_component__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_modal_dialog_general_message_dialog_general_message_component__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modal_dialog_confirm_dialog_confirm_model__ = __webpack_require__(60);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BillingAddressComponent; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};












var BillingAddressComponent = (function () {
    function BillingAddressComponent(userService, appConfigService, dialog) {
        this.userService = userService;
        this.appConfigService = appConfigService;
        this.dialog = dialog;
        this.LIMIT_ADDING = 5; // tslint:disable-line
        this.STATE = {
            VIEW: 'VIEW', EDIT: 'EDIT', ADD: 'ADD', DELETE: 'DELETE',
        };
        this.defaultOptions = { page: 'checkout3', selectable: true, editable: true, name: 'billingAddress' };
        this.currentState = this.STATE.VIEW;
        this.emptyBilling = new __WEBPACK_IMPORTED_MODULE_4__model_billing_billing_model__["a" /* Billing */](); // tslint:disable-line
        this.options = this.defaultOptions;
        this.dataItems = []; // tslint:disable-line:no-input-rename
        this.onFetchingData = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onSelectedData = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    BillingAddressComponent.prototype.ngOnInit = function () {
    };
    BillingAddressComponent.prototype.ngOnChanges = function (changes) {
        changes.options && changes.options.currentValue && this.onOptionsChanging(changes.options.currentValue);
        var dataItemsHaveValue = changes.dataItems && changes.dataItems.currentValue;
        if (dataItemsHaveValue && changes.dataItems.currentValue.length) {
            this.onDataItemsChanging(changes.dataItems.currentValue);
        }
        else {
            this.currentState = this.STATE.ADD;
            this.onSelectedData.emit(this.getSelectedItem());
        }
    };
    BillingAddressComponent.prototype.ngOnDestroy = function () {
        this.subscriptionBilling && this.subscriptionBilling.unsubscribe();
    };
    BillingAddressComponent.prototype.getCurrentFormComponent = function () {
        return this.currentState === this.STATE.ADD ? this.componentAddForm : this.componentEditForm;
    };
    BillingAddressComponent.prototype.getCurrentForm = function () {
        var currentFormComponent = this.getCurrentFormComponent();
        return currentFormComponent && currentFormComponent.getFormControl();
    };
    BillingAddressComponent.prototype.autoSubmitBillingForm$ = function () {
        if (!this.getCurrentFormComponent()) {
            return __WEBPACK_IMPORTED_MODULE_9_rxjs_Observable__["Observable"].of(false);
        }
        return this.getCurrentFormComponent().setSubmitting$();
    };
    BillingAddressComponent.prototype.setToViewMode = function () {
        this.currentState !== this.STATE.VIEW && this.clearSelectedState();
    };
    BillingAddressComponent.prototype.validateSubmitingForm = function (allowNotification) {
        if (allowNotification === void 0) { allowNotification = true; }
        var available;
        var currentFormComponent = this.getCurrentFormComponent();
        if (!currentFormComponent) {
            return true;
        }
        var currentForm = this.getCurrentForm();
        switch (this.currentState) {
            case this.STATE.EDIT:
                allowNotification && this.notifyConfirmFormCancel();
                available = (currentForm.valid && !allowNotification);
                break;
            case this.STATE.ADD:
                var formChanged = currentFormComponent.isFormChanged();
                allowNotification && formChanged && this.notifyConfirmFormCancel();
                available = (currentForm.valid && !formChanged && !allowNotification);
                available && this.setDefaultState();
                break;
            default:
                available = true;
                break;
        }
        return available;
    };
    BillingAddressComponent.prototype.isViewMode = function () {
        return this.currentState === this.STATE.VIEW;
    };
    BillingAddressComponent.prototype.getSelectedItem = function () {
        var selectedItem = this.dataItems.filter(function (item) { return item.isSelected; })[0];
        return selectedItem;
    };
    BillingAddressComponent.prototype.onOptionsChanging = function (options) {
        this.options = __assign({}, this.defaultOptions, options);
    };
    BillingAddressComponent.prototype.onDataItemsChanging = function (dataItems) {
        this.setDefaultState();
        this.ensureItemDefault();
        this.onSelectedData.emit(this.getSelectedItem());
    };
    BillingAddressComponent.prototype.ensureItemDefault = function () {
        var defaultItem = this.dataItems.filter(function (item) { return item.isDefault; })[0];
        !defaultItem && this.dataItems.length && (this.dataItems[0].isDefault = this.dataItems[0].isSelected = true);
    };
    BillingAddressComponent.prototype.clearSelectedState = function (excludeDefaultSelected) {
        var _this = this;
        if (excludeDefaultSelected === void 0) { excludeDefaultSelected = false; }
        this.currentState = this.STATE.VIEW;
        var itemChecked = this.dataItems.filter(function (item) { return item.isChecked; })[0];
        this.dataItems = this.dataItems.map(function (item) {
            var isChecked = itemChecked ? item.isChecked : item.isDefault;
            return __assign({}, item, { state: _this.STATE.VIEW, isChecked: excludeDefaultSelected ? false : isChecked, isSelected: excludeDefaultSelected ? false : isChecked });
        });
    };
    BillingAddressComponent.prototype.setDefaultState = function () {
        var _this = this;
        this.currentState = this.STATE.VIEW;
        this.dataItems = this.dataItems.map(function (item) { return (__assign({}, item, { state: _this.STATE.VIEW, isChecked: item.isDefault, isSelected: item.isDefault })); });
    };
    /**
     ***************** UI Event Handler ******************************
     */
    // tslint:disable:no-unused-variable
    BillingAddressComponent.prototype.onItemSelected = function (newSelected) {
        var _this = this;
        if (newSelected === void 0) { newSelected = this.getSelectedItem(); }
        this.dataItems = this.dataItems.map(function (item) {
            var isMatchId = newSelected.billingId === item.billingId;
            return __assign({}, item, { isChecked: isMatchId, isSelected: _this.isViewMode() ? isMatchId : item.isSelected });
        });
        this.onSelectedData.emit(newSelected);
    };
    BillingAddressComponent.prototype.onAddButtonClicked = function (data) {
        if (this.currentState === this.STATE.EDIT) {
            this.notifyConfirmFormCancel();
        }
        else {
            this.clearSelectedState(true);
            this.currentState = this.STATE.ADD;
        }
    };
    BillingAddressComponent.prototype.onEditButtonClicked = function (data) {
        var _this = this;
        if (this.currentState === this.STATE.EDIT) {
            this.notifyConfirmFormCancel();
        }
        else {
            this.clearSelectedState(true);
            this.currentState = this.STATE.EDIT;
            this.dataItems = this.dataItems.map(function (item) {
                var isMatchId = data.billingId === item.billingId;
                return __assign({}, item, { isChecked: isMatchId, isSelected: isMatchId, state: isMatchId ? _this.STATE.EDIT : _this.STATE.VIEW });
            });
            this.onItemSelected();
        }
    };
    BillingAddressComponent.prototype.onDeleteButtonClicked = function (data) {
        var _this = this;
        if (this.currentState === this.STATE.EDIT) {
            this.notifyConfirmFormCancel();
        }
        else {
            // show confirm delete
            var title = this.appConfigService.getTranslate('checkout-3-billing-confirm-delete-msg');
            var mainBtn = this.appConfigService.getTranslate('checkout-3-billing-dialog-delete-button');
            var config = {
                data: { mainBtn: mainBtn }
            };
            var dialogRef_1 = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__modal_dialog_confirm_action_dialog_confirm_action_component__["a" /* DialogConfirmActionComponent */], config);
            dialogRef_1.componentInstance.dialogRef = dialogRef_1;
            dialogRef_1.componentInstance.message = title;
            // on confirm delete is ok
            var confirmButtonClicked$ = dialogRef_1.componentInstance.onConfirmClicked();
            this.subscriptionBilling = confirmButtonClicked$
                .flatMap(function () {
                return _this.userService.deleteBillingAddress(data);
            })
                .subscribe(function (res) {
                dialogRef_1.close();
                res && _this.onDeleteCompleted();
            }, this.onDeleteFailure.bind(this));
        }
    };
    BillingAddressComponent.prototype.onDeleteCompleted = function () {
        var _this = this;
        var title = this.appConfigService.getTranslate('checkout-3-billing-delete-success');
        setTimeout(function () {
            _this.notifyMessage(title);
        }, 500);
        this.onFetchingData.emit();
    };
    BillingAddressComponent.prototype.onDeleteFailure = function () {
        var _this = this;
        var title = this.appConfigService.getTranslate('checkout-3-billing-delete-failure');
        var message = this.appConfigService.getTranslate('checkout-3-billing-failure-text-try-again');
        this.notifyMessage(title, message, 'icon-service-failed')
            .afterClosed().subscribe(function () {
            _this.setDefaultState();
        });
    };
    BillingAddressComponent.prototype.notifyMessage = function (title, message, icon, mainBtn) {
        if (message === void 0) { message = ''; }
        if (icon === void 0) { icon = 'icon-successful'; }
        if (mainBtn === void 0) { mainBtn = undefined; }
        mainBtn = mainBtn || this.appConfigService.getTranslate('btn-ok');
        var config = {
            data: { icon: icon, title: title, message: message, mainBtn: mainBtn }
        };
        return this.dialog.open(__WEBPACK_IMPORTED_MODULE_8_app_components_modal_dialog_general_message_dialog_general_message_component__["a" /* DialogGeneralMessageComponent */], config);
    };
    BillingAddressComponent.prototype.notifyConfirmFormCancel = function () {
        var _this = this;
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7_app_components_modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */], { data: { confirmType: __WEBPACK_IMPORTED_MODULE_11__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CLOSE } });
        dialogRef.afterClosed().subscribe(function (res) {
            res && _this.onFormCancelCompleted();
        });
    };
    BillingAddressComponent.prototype.onFormSaveCompleted = function (data) {
        var _a = data || { billing: undefined, state: __WEBPACK_IMPORTED_MODULE_2__model_constant__["V" /* ActionType */].normalSave }, billing = _a.billing, state = _a.state;
        this.setDefaultState();
        (state === __WEBPACK_IMPORTED_MODULE_2__model_constant__["V" /* ActionType */].autoSave) ? this.onSelectedData.emit(billing) : this.onFetchingData.emit();
    };
    BillingAddressComponent.prototype.onFormCancelCompleted = function () {
        this.clearSelectedState();
    };
    return BillingAddressComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], BillingAddressComponent.prototype, "options", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('items'),
    __metadata("design:type", Object)
], BillingAddressComponent.prototype, "dataItems", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], BillingAddressComponent.prototype, "onFetchingData", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
], BillingAddressComponent.prototype, "onSelectedData", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('addForm'),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_5__billing_form_billing_form_component__["a" /* BillingFormComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__billing_form_billing_form_component__["a" /* BillingFormComponent */]) === "function" && _c || Object)
], BillingAddressComponent.prototype, "componentAddForm", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('editForm'),
    __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_5__billing_form_billing_form_component__["a" /* BillingFormComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__billing_form_billing_form_component__["a" /* BillingFormComponent */]) === "function" && _d || Object)
], BillingAddressComponent.prototype, "componentEditForm", void 0);
BillingAddressComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'billing-address',
        template: __webpack_require__(1013),
        styles: [__webpack_require__(878)]
    }),
    __metadata("design:paramtypes", [typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_10_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_10_app_services_user_user_service__["a" /* UserService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_3__services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */]) === "function" && _g || Object])
], BillingAddressComponent);

var _a, _b, _c, _d, _e, _f, _g;
//# sourceMappingURL=billing-address.component.js.map

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__booking_detail_section__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_pipes_translate_singular_plural_pipe__ = __webpack_require__(129);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookingDetailComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var BookingDetailComponent = (function () {
    function BookingDetailComponent(utilService, translate, appConfigService, translatePlural) {
        this.utilService = utilService;
        this.translate = translate;
        this.appConfigService = appConfigService;
        this.translatePlural = translatePlural;
        this.dataType = __WEBPACK_IMPORTED_MODULE_3__booking_detail_section__["f" /* MyBookingDataSctionType */];
        this.paymentChannelType = __WEBPACK_IMPORTED_MODULE_4__model_constant__["l" /* PaymentChannelType */];
        this.offerType = __WEBPACK_IMPORTED_MODULE_4__model_constant__["x" /* OfferType */];
        this.isMobile = false;
        this.isShareBudget = false;
        this.paymentType = __WEBPACK_IMPORTED_MODULE_4__model_constant__["N" /* PaymentType */];
        this.approvalStatusType = __WEBPACK_IMPORTED_MODULE_0__model_constant__["j" /* ApprovalStatusType */];
        this.isShareBudgetByAdmin = false;
        this.showMoreRoomInfo = [];
        this.showMoreBookerInfo = [];
        this.showMoreCoBookerInfo = [];
        this.dataSelenium = {};
        this.formatDateFromApi = 'D MMM YYYY HH:mm:ss';
        this.formatDateSelenium = 'YYYY-MM-DD';
        this.isMobile = this.utilService.isMobile();
    }
    BookingDetailComponent.prototype.ngOnInit = function () { };
    BookingDetailComponent.prototype.ngOnChanges = function (changes) {
        if (changes && changes.myBooking && changes.myBooking.currentValue) {
            this.initialData();
        }
    };
    BookingDetailComponent.prototype.initialData = function () {
        switch (this.type) {
            case __WEBPACK_IMPORTED_MODULE_3__booking_detail_section__["f" /* MyBookingDataSctionType */].BOOKING:
                this.prepareBookingSection();
                break;
            case __WEBPACK_IMPORTED_MODULE_3__booking_detail_section__["f" /* MyBookingDataSctionType */].ROOM:
                this.prepareRoomDetailSection();
                break;
            case __WEBPACK_IMPORTED_MODULE_3__booking_detail_section__["f" /* MyBookingDataSctionType */].BOOKING_DETAIL:
                this.prepareBookingDetailSection();
                break;
        }
    };
    BookingDetailComponent.prototype.prepareBookingSection = function () {
        if (this.isMobile) {
            this.myBooking.checkIn['date'] = this.lang === __WEBPACK_IMPORTED_MODULE_4__model_constant__["a" /* Language */].th ? this.utilService.convertDateFormat(this.myBooking.checkIn['date'], null, 'dd D MMM YY') :
                this.utilService.convertDateFormat(this.myBooking.checkIn['date'], null, 'dd D MMM YY');
            this.myBooking.checkOut['date'] = this.lang === __WEBPACK_IMPORTED_MODULE_4__model_constant__["a" /* Language */].th ? this.utilService.convertDateFormat(this.myBooking.checkOut['date'], null, 'dd D MMM YY') :
                this.utilService.convertDateFormat(this.myBooking.checkOut['date'], null, 'dd D MMM YY');
        }
        else {
            this.myBooking.checkIn['date'] = this.utilService.convertDateFormat(this.myBooking.checkIn['date'], null, 'ddd D MMMM YYYY');
            this.myBooking.checkOut['date'] = this.utilService.convertDateFormat(this.myBooking.checkOut['date'], null, 'ddd D MMMM YYYY');
        }
        this.dataSelenium.checkInDate = this.utilService.convertDateFormat(this.myBooking.checkIn['date'], this.formatDateFromApi, this.formatDateSelenium, __WEBPACK_IMPORTED_MODULE_4__model_constant__["a" /* Language */].en);
        this.dataSelenium.checkOutDate = this.utilService.convertDateFormat(this.myBooking.checkOut['date'], this.formatDateFromApi, this.formatDateSelenium, __WEBPACK_IMPORTED_MODULE_4__model_constant__["a" /* Language */].en);
    };
    BookingDetailComponent.prototype.prepareRoomDetailSection = function () {
        var _this = this;
        this.myBooking.forEach(function (room) {
            if (room.freeCancellationDate) {
                room.freeCancellationDate = _this.utilService.convertDateFormat(room.freeCancellationDate, null, 'D MMM YY');
            }
            if (room.showcancellationPolicies && room.cancellationPolicies && room.cancellationPolicies.length > 0) {
                room.policyMessage = [];
                room.cancellationPolicies.forEach(function (cancelPolicy) {
                    room.policyMessage.push(_this.translate
                        .transform('booking-detail-cancellation-policy-charge')
                        .replace('{date}', _this.utilService.convertDateFormat(cancelPolicy.fromDate, null, 'D MMM YY'))
                        .replace('{currencycode}', room.currencyCode)
                        .replace('{cancelFee}', _this.utilService.insertCurrencySymbol(cancelPolicy.cancelFee)));
                });
            }
        });
    };
    BookingDetailComponent.prototype.prepareBookingDetailSection = function () {
        if (this.isMobile) {
            this.myBooking.checkIn['date'] = this.lang === __WEBPACK_IMPORTED_MODULE_4__model_constant__["a" /* Language */].th ? this.utilService.convertDateFormat(this.myBooking.checkIn['date'], null, 'do MMM YY') :
                this.utilService.convertDateFormat(this.myBooking.checkIn['date'], null, 'DD MMM YY');
            this.myBooking.checkOut['date'] = this.lang === __WEBPACK_IMPORTED_MODULE_4__model_constant__["a" /* Language */].th ? this.utilService.convertDateFormat(this.myBooking.checkOut['date'], null, 'do MMM YY') :
                this.utilService.convertDateFormat(this.myBooking.checkOut['date'], null, 'DD MMM YY');
        }
        else {
            this.myBooking.checkIn['date'] = this.utilService.convertDateFormat(this.myBooking.checkIn['date'], null, 'ddd D MMMM YYYY');
            this.myBooking.checkOut['date'] = this.utilService.convertDateFormat(this.myBooking.checkOut['date'], null, 'ddd D MMMM YYYY');
        }
        this.dataSelenium.checkInDate = this.utilService.convertDateFormat(this.myBooking.checkIn['date'], this.formatDateFromApi, this.formatDateSelenium, __WEBPACK_IMPORTED_MODULE_4__model_constant__["a" /* Language */].en);
        this.dataSelenium.checkOutDate = this.utilService.convertDateFormat(this.myBooking.checkOut['date'], this.formatDateFromApi, this.formatDateSelenium, __WEBPACK_IMPORTED_MODULE_4__model_constant__["a" /* Language */].en);
        if (this.myBooking.bookingStatus) {
            this.myBooking.bookingStatus.payOnDate = this.myBooking.bookingStatus.payOnDate ?
                this.utilService.convertDateFormat(this.myBooking.bookingStatus.payOnDate, null, 'D MMM YY') : undefined;
            this.myBooking.bookingStatus.cancellationDate = this.myBooking.bookingStatus.cancellationDate ?
                this.utilService.convertDateFormat(this.myBooking.bookingStatus.cancellationDate, null, 'D MMM YY') : undefined;
            this.myBooking.bookingStatus.approvalDate = this.myBooking.bookingStatus.approvalDate ?
                this.utilService.convertDateFormat(this.myBooking.bookingStatus.approvalDate, null, 'D MMM YY') : undefined;
        }
        this.isShareBudgetByAdmin = this.shareBudgetByAdmin();
        this.prepareRoomGuestAmount();
    };
    BookingDetailComponent.prototype.prepareRoomGuestAmount = function () {
        var occupancyInfo = this.myBooking.occupancyInfo;
        var bookingDetailAdultText = this.appConfigService.getLanguage() === __WEBPACK_IMPORTED_MODULE_4__model_constant__["a" /* Language */].th ? this.translate.transform('booking-detail-details-adult-text') + ' ' : '';
        var bookingDetailChildText = this.appConfigService.getLanguage() === __WEBPACK_IMPORTED_MODULE_4__model_constant__["a" /* Language */].th ? this.translate.transform('booking-detail-details-child-text') + ' ' : '';
        var roomGuestAmount = bookingDetailAdultText + occupancyInfo.adult + ' ' + this.translatePlural.transform('booking-detail-details-adult', occupancyInfo.adult);
        if (occupancyInfo.child && occupancyInfo.child > 0) {
            roomGuestAmount += ', ' + bookingDetailChildText + occupancyInfo.child + ' ' + this.translatePlural.transform('booking-detail-details-child', occupancyInfo.child);
        }
        if (occupancyInfo.childrenAge && occupancyInfo.childrenAge.length > 0) {
            var and = this.translate.transform('booking-detail-details-and');
            var childrenAgeTextTemplate = this.translate.transform('booking-detail-details-children-age');
            var formattedChildrenAge = occupancyInfo.childrenAge.length === 1
                ? occupancyInfo.childrenAge[0].toString()
                : occupancyInfo.childrenAge.slice(0, -1).join(', ') + " " + and + " " + occupancyInfo.childrenAge.slice(-1)[0];
            var childrenAgeText = childrenAgeTextTemplate.replace('{age}', formattedChildrenAge);
            roomGuestAmount += ' ' + childrenAgeText;
        }
        this.dataSelenium.roomGuestAmount = roomGuestAmount;
    };
    BookingDetailComponent.prototype.filterMainBooker = function (bookersInfo, isMain) {
        if (isMain === void 0) { isMain = true; }
        this.isShareBudget = bookersInfo.length > 1;
        if (bookersInfo.length > 0 && bookersInfo.length <= 2) {
            return bookersInfo.filter(function (booker) { return booker.mainBooker === isMain; });
        }
        return isMain ? bookersInfo.filter(function (booker) { return booker.mainBooker; }) : bookersInfo.filter(function (booker) { return !booker.mainBooker; })[0];
    };
    BookingDetailComponent.prototype.shareBudgetByAdmin = function () {
        return this.myBooking.bookingStatus.paymentType === __WEBPACK_IMPORTED_MODULE_4__model_constant__["N" /* PaymentType */].SHARE_BUDGET_BY_ADMIN || this.myBooking.bookingStatus.paymentType === __WEBPACK_IMPORTED_MODULE_4__model_constant__["N" /* PaymentType */].SHARE_BUDGET_BY_ADMIN_MULTI_PAYMENT;
    };
    BookingDetailComponent.prototype.toggleCollapseInfo = function (section, index) {
        if (this[section].includes(index)) {
            this[section] = this[section].filter(function (x) { return x !== index; });
        }
        else {
            this[section].push(index);
        }
    };
    return BookingDetailComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Object)
], BookingDetailComponent.prototype, "myBooking", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3__booking_detail_section__["f" /* MyBookingDataSctionType */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__booking_detail_section__["f" /* MyBookingDataSctionType */]) === "function" && _a || Object)
], BookingDetailComponent.prototype, "type", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", String)
], BookingDetailComponent.prototype, "lang", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", String)
], BookingDetailComponent.prototype, "prefixElementId", void 0);
BookingDetailComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
        selector: 'act-booking-detail',
        template: __webpack_require__(1015),
        styles: [__webpack_require__(880)]
    }),
    __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_5_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_7_app_pipes_translate_singular_plural_pipe__["a" /* TranslateSingularPluralPipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_pipes_translate_singular_plural_pipe__["a" /* TranslateSingularPluralPipe */]) === "function" && _e || Object])
], BookingDetailComponent);

var _a, _b, _c, _d, _e;
//# sourceMappingURL=booking-detail.component.js.map

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_pipes_translate_pipe__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_authorize_authorize_service__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vendors_moment_locale_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modal_dialog_confirm_dialog_confirm_component__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_dialog_confirm_dialog_confirm_model__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_dialog_share_budget_dialog_share_budget_component__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modal_dialog_share_budget_dialog_share_budget_model__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__dialog_budget_limit_dialog_budget_limit_detail_dialog_budget_limit_detail_component__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__dialog_budget_limit_dialog_budget_limit_mobile_dialog_budget_limit_mobile_component__ = __webpack_require__(244);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BudgetLimitComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


















var BudgetLimitComponent = (function () {
    function BudgetLimitComponent(utilities, translate, decimal, dialog, appConfigService, userService, router, authorizeService) {
        this.utilities = utilities;
        this.translate = translate;
        this.decimal = decimal;
        this.dialog = dialog;
        this.appConfigService = appConfigService;
        this.userService = userService;
        this.router = router;
        this.authorizeService = authorizeService;
        this.allowLimitBudget = true;
        this.isPOI = false;
        this.isWorkPurpose = true;
        this.isLoading = true;
        this.onShareBudget = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.itemList = [];
        this.itemListCoBooker = [];
        this.policyIdList = new Set();
        this.policyIdListCoBooker = new Set();
        this.isLimitBudget = false;
        this.isNewBudget = false;
        this.isShareBudget = false;
        this.appliedCoBudget = false;
        this.showBudgetBar = false;
        var featureShareBudget = this.userService.getUserFeature(__WEBPACK_IMPORTED_MODULE_4_app_model_constant__["b" /* FeatureType */].ALLOW_SHARE_BUDGET, true);
        this.isShareBudget = featureShareBudget && featureShareBudget.allow;
        this.lang = this.appConfigService.getLanguage();
    }
    BudgetLimitComponent.prototype.ngOnChanges = function (changes) {
        this.lang = this.appConfigService.getLanguage();
        this.policyIdList = new Set();
        this.policyIdListCoBooker = new Set();
        this.itemList = [];
        this.itemListCoBooker = [];
        this.isShareBudget && this.getShareBudget();
        if (this.shareBudget) {
            this.selectTemplateShareBudget();
        }
        else {
            if (this.allowLimitBudget && this.destinationTravelPolicyBooker || this.isShareBudget) {
                this.selectTemplate();
            }
            else {
                this.isLimitBudget = false;
            }
        }
        if (changes['isLoading']) {
            if (changes['isLoading'].previousValue === true && changes['isLoading'].currentValue === false) {
                this.showBudgetBar = true;
            }
            else {
                this.showBudgetBar = false;
            }
        }
    };
    BudgetLimitComponent.prototype.selectTemplate = function () {
        this.template = '';
        this.textNormalBudget = this.normalBudgetBooker ? this.transformBudget(this.normalBudgetBooker) : "" + this.translate.transform('budget-limit-unlimited');
        this.isNewBudget = this.checkNewBudget();
        this.isLimitBudget = this.destinationTravelPolicyBooker.some(function (f) { return !!f.averageBudget; });
        switch (true) {
            case this.isLimitBudget:
                if (this.isPOI) {
                    this.template = __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].SPECIAL_BUDGET_POI;
                }
                else if (this.policyIdList.size > 1) {
                    this.template = __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].SPECIAL_BUDGET_SOME_DAYS;
                }
                else {
                    this.template = __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].SPECIAL_BUDGET;
                }
                break;
            case this.destinationTravelPolicyBooker.length === 0 && !!this.normalBudgetBooker:
                this.template = __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].NORMAL_BUDGET;
                break;
            default:
                if (this.policyIdList.size >= 1 && this.isShareBudget) {
                    this.template = __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].UNLIMITED_SHARE_BUDGET_FEATURE;
                }
                else {
                    this.template = __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].UNLIMITED_BUDGET;
                }
        }
        this.transform();
    };
    BudgetLimitComponent.prototype.selectTemplateShareBudget = function () {
        var _this = this;
        this.template = '';
        var sumNormalBudget = this.normalBudgetBooker + this.normalBudgetCoBooker;
        if (this.normalCoBudgetUnlimited === undefined) {
            this.textNormalBudget = sumNormalBudget
                ? this.transformBudget(sumNormalBudget)
                : this.translate.transform('budget-limit-unlimited');
        }
        else if (this.normalCoBudgetUnlimited && (this.normalBudgetBookerUnlimited || this.normalBudgetCoBookerUnlimited)) {
            this.textNormalBudget = this.translate.transform('budget-limit-unlimited');
        }
        else {
            if (sumNormalBudget) {
                this.textNormalBudget = this.transformBudget(sumNormalBudget < this.normalCoBudget ? sumNormalBudget : this.normalCoBudget);
            }
            else {
                this.textNormalBudget = this.translate.transform('budget-limit-unlimited');
            }
        }
        this.isNewBudget = true;
        this.destinationTravelPolicyBooker.forEach(function (d) {
            d.travelPolicyList && d.travelPolicyList.forEach(function (t) {
                _this.policyIdList.add(t.policyId);
            });
        });
        this.destinationTravelPolicyCoBooker.forEach(function (d) {
            d.travelPolicyList && d.travelPolicyList.forEach(function (t) {
                _this.policyIdListCoBooker.add(t.policyId);
            });
        });
        if ((this.destinationTravelPolicyBooker.length > 0 && this.destinationTravelPolicyBooker.some(function (d) { return !!d.travelPolicyList; })) ||
            (this.destinationTravelPolicyCoBooker.length > 0 && this.destinationTravelPolicyCoBooker.some(function (d) { return !!d.travelPolicyList; }))) {
            if (this.isPOI) {
                this.template = __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].SHARE_BUDGET_SPECIAL_BUDGET_POI;
            }
            else {
                this.template = __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].SHARE_BUDGET_SPECIAL_BUDGET;
            }
        }
        else {
            this.template = __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].SHARE_BUDGET;
        }
        this.transform();
    };
    BudgetLimitComponent.prototype.transform = function () {
        switch (this.template) {
            case __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].SPECIAL_BUDGET:
                this.transformTemplateSpecialBudget();
                this.isLimitBudget = true;
                break;
            case __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].SPECIAL_BUDGET_SOME_DAYS:
                this.transformTemplateSpecialBudgetSomeDays();
                this.isLimitBudget = true;
                break;
            case __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].SPECIAL_BUDGET_POI:
            case __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].SHARE_BUDGET_SPECIAL_BUDGET_POI:
                this.transformTemplatePOI();
                this.isLimitBudget = true;
                break;
            case __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].NORMAL_BUDGET:
                this.description = this.translate.transform("product-detail-budget-limit").replace(/{x}/gi, this.utilities.getPriceRangeFormatText(this.normalBudgetBooker));
                this.isLimitBudget = true;
                break;
            case __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].UNLIMITED_BUDGET:
                this.description = this.translate.transform("search-box-budget-unlimited");
                this.isLimitBudget = false;
                this.isNewBudget = false;
                break;
            case __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].UNLIMITED_SHARE_BUDGET_FEATURE:
                this.description = this.translate.transform("search-box-budget-unlimited");
                this.isLimitBudget = false;
                this.isNewBudget = true;
                break;
            case __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].SHARE_BUDGET:
                var totalBudget = void 0;
                if (this.shareBudget.booker.amount && this.shareBudget.coBooker.amount) {
                    totalBudget = this.shareBudget.booker.amount + this.shareBudget.coBooker.amount;
                }
                this.appliedCoBudget = this.destinationTravelPolicyBooker.length > 0 ? this.destinationTravelPolicyBooker.some(function (tp) { return tp.appliedCoBudget; }) : false;
                if (this.appliedCoBudget) {
                    totalBudget = this.destinationTravelPolicyBooker[0].totalBudget;
                }
                if (totalBudget) {
                    this.description = this.translate.transform("budget-limit-share-budget").replace(/{x}/gi, this.utilities.getPriceRangeFormatText(totalBudget));
                }
                else {
                    this.description = this.translate.transform("budget-limit-unlimited-share-budget");
                }
                this.shareBudget.totalBudget = totalBudget;
                this.isLimitBudget = true;
                break;
            case __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["d" /* TEMPLATE */].SHARE_BUDGET_SPECIAL_BUDGET:
                this.transformTemplateShareBudgetSpecialBudget();
                this.isLimitBudget = true;
                break;
            default:
                this.isLimitBudget = false;
                break;
        }
    };
    BudgetLimitComponent.prototype.transformTemplatePOI = function () {
        this.description = this.shareBudget ? this.translate.transform("budget-limit-special-budget-for-poi-new") : this.translate.transform("budget-limit-special-budget-for-poi");
        var roundDestination = this.destinationTravelPolicyBooker.length;
        for (var index = 0; index < roundDestination; index++) {
            if (this.destinationTravelPolicyBooker[index].appliedCoBudget || this.destinationTravelPolicyBooker[index].travelPolicyList) {
                var destination = "" + this.translate.transform('budget-limit-for') + (this.lang === __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["a" /* Language */].en ? " " + this.destinationTravelPolicyBooker[index].destinationNameEn : "" + this.destinationTravelPolicyBooker[index].destinationNameTh);
                var budget = this.destinationTravelPolicyBooker[index].averageBudget ? this.transformBudget(this.destinationTravelPolicyBooker[index].averageBudget) : "" + this.translate.transform('budget-limit-unlimited');
                this.itemList.push(new __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["a" /* Item */](destination, budget));
            }
        }
        if (this.itemList.length === 0) {
            this.description = this.normalBudgetBooker ?
                this.translate.transform("product-detail-budget-limit").replace(/{x}/gi, this.utilities.getPriceRangeFormatText(this.normalBudgetBooker)) :
                this.translate.transform("budget-limit-unlimited");
        }
        var roundDestinationCoBooker = this.destinationTravelPolicyCoBooker.length;
        for (var index = 0; index < roundDestinationCoBooker; index++) {
            if (this.destinationTravelPolicyCoBooker[index].appliedCoBudget || this.destinationTravelPolicyCoBooker[index].travelPolicyList) {
                var destination = "" + this.translate.transform('budget-limit-for') + (this.lang === __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["a" /* Language */].en ? " " + this.destinationTravelPolicyCoBooker[index].destinationNameEn : "" + this.destinationTravelPolicyCoBooker[index].destinationNameTh);
                var budget = this.destinationTravelPolicyCoBooker[index].averageBudget ? this.transformBudget(this.destinationTravelPolicyCoBooker[index].averageBudget) : "" + this.translate.transform('budget-limit-unlimited');
                this.itemListCoBooker.push(new __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["a" /* Item */](destination, budget));
            }
        }
        this.appliedCoBudget = this.destinationTravelPolicyBooker.length > 0 ? this.destinationTravelPolicyBooker.some(function (tp) { return tp.appliedCoBudget; }) : false;
    };
    BudgetLimitComponent.prototype.transformTemplateSpecialBudget = function () {
        var bookerBudget = this.destinationTravelPolicyBooker.length > 0 ? this.destinationTravelPolicyBooker[0].averageBudget : this.normalBudgetBooker;
        this.description = this.translate.transform("product-detail-budget-limit").replace(/{x}/gi, this.utilities.getPriceRangeFormatText(bookerBudget));
        this.textAverageBudget = this.transformBudget(this.destinationTravelPolicyBooker[0].averageBudget);
    };
    BudgetLimitComponent.prototype.transformTemplateShareBudgetSpecialBudget = function () {
        var bookerBudget = this.destinationTravelPolicyBooker.length > 0 ? this.destinationTravelPolicyBooker[0].averageBudget : this.normalBudgetBooker;
        var coBookerBudget = this.destinationTravelPolicyCoBooker.length > 0 ? this.destinationTravelPolicyCoBooker[0].averageBudget : this.normalBudgetCoBooker;
        var totalBudget;
        if (bookerBudget && coBookerBudget) {
            totalBudget = bookerBudget + coBookerBudget;
        }
        this.appliedCoBudget = this.destinationTravelPolicyBooker.length > 0 ? this.destinationTravelPolicyBooker.some(function (tp) { return tp.appliedCoBudget; }) : false;
        if (this.appliedCoBudget) {
            totalBudget = this.destinationTravelPolicyBooker[0].totalBudget;
        }
        if (totalBudget) {
            this.description = this.translate.transform("budget-limit-share-budget").replace(/{x}/gi, this.utilities.getPriceRangeFormatText(totalBudget));
        }
        else {
            this.description = this.translate.transform("budget-limit-unlimited-share-budget");
        }
        this.textAverageBudget = this.transformBudget(totalBudget);
        this.shareBudget.booker.amount = bookerBudget;
        this.shareBudget.coBooker.amount = coBookerBudget;
        this.shareBudget.totalBudget = totalBudget;
    };
    BudgetLimitComponent.prototype.transformTemplateSpecialBudgetSomeDays = function () {
        var _this = this;
        this.itemList = [];
        this.description = this.translate.transform("product-detail-budget-limit").replace(/{x}/gi, this.utilities.getPriceRangeFormatText(this.destinationTravelPolicyBooker[0].averageBudget));
        this.textAverageBudget = this.transformBudget(this.destinationTravelPolicyBooker[0].averageBudget);
        var policy = this.destinationTravelPolicyBooker[0];
        var mapDayBudget = new Map();
        policy.travelPolicyList.filter(function (f) { return f.budgetType === __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["b" /* BUDGET_TYPE */].NEW_BUDGET; }).map(function (p) {
            var dayOfweek = __WEBPACK_IMPORTED_MODULE_10_vendors_moment_locale_th__(p.date, _this.appConfigService.dateAPIFormat).format('E');
            mapDayBudget.set(dayOfweek, p.budget);
        });
        var _loop_1 = function (r) {
            var budget = mapDayBudget.get('' + r);
            if (budget) {
                var tmpKeys_1 = [];
                mapDayBudget.forEach(function (value, key) {
                    if (value === budget) {
                        tmpKeys_1.push(key);
                        mapDayBudget.delete(key);
                    }
                });
                var dateString_1 = '';
                tmpKeys_1.sort().map(function (m, i) {
                    if (i === 0) {
                        dateString_1 += "" + _this.translate.transform('budget-limit-for') + (_this.lang === __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["a" /* Language */].en ? ' ' : '') + _this.convertDays(m, _this.lang);
                    }
                    else if (i === tmpKeys_1.length - 1) {
                        dateString_1 += "" + (_this.lang === __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["a" /* Language */].en ? ' ' : '') + _this.translate.transform('budget-limit-and') + (_this.lang === __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["a" /* Language */].en ? ' ' : '') + _this.convertDays(m, _this.lang);
                    }
                    else {
                        dateString_1 += "" + (_this.lang === __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["a" /* Language */].en ? ', ' : ' ') + _this.convertDays(m, _this.lang);
                    }
                });
                this_1.itemList.push(new __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["a" /* Item */](dateString_1, this_1.transformBudget(budget)));
            }
        };
        var this_1 = this;
        for (var r = 1; r <= 7; r++) {
            _loop_1(r);
        }
    };
    BudgetLimitComponent.prototype.checkNewBudget = function () {
        var _this = this;
        var newBudget = false;
        this.destinationTravelPolicyBooker.forEach(function (d) {
            d.travelPolicyList && d.travelPolicyList.forEach(function (t) {
                if (t.budgetType === __WEBPACK_IMPORTED_MODULE_15__budget_limit_model__["b" /* BUDGET_TYPE */].NEW_BUDGET) {
                    newBudget = true;
                }
                _this.policyIdList.add(t.policyId);
            });
        });
        return newBudget;
    };
    BudgetLimitComponent.prototype.getShareBudget = function () {
        var coBookerCookie = this.authorizeService.getCoBookerCookie();
        if (coBookerCookie) {
            this.shareBudget = new __WEBPACK_IMPORTED_MODULE_14__modal_dialog_share_budget_dialog_share_budget_model__["b" /* ShareBudget */]();
            this.shareBudget.booker = new __WEBPACK_IMPORTED_MODULE_14__modal_dialog_share_budget_dialog_share_budget_model__["a" /* Booker */](this.userService.getUser().userId, this.userService.getUser().companyId, this.userService.getUser().email, this.normalBudgetBooker);
            this.shareBudget.coBooker = new __WEBPACK_IMPORTED_MODULE_14__modal_dialog_share_budget_dialog_share_budget_model__["a" /* Booker */](coBookerCookie.userId, coBookerCookie.companyId, coBookerCookie.email, coBookerCookie.amount);
            this.shareBudget.totalBudget = this.shareBudget.booker.amount + this.shareBudget.coBooker.amount;
        }
        else {
            this.shareBudget = undefined;
            this.authorizeService.removeCoBookerCookie();
        }
    };
    BudgetLimitComponent.prototype.onMobileClickDetail = function () {
        this.dialog.open(__WEBPACK_IMPORTED_MODULE_17__dialog_budget_limit_dialog_budget_limit_mobile_dialog_budget_limit_mobile_component__["a" /* DialogBudgetLimitMobileComponent */], {
            data: {
                budgetBooker: this.normalBudgetBooker,
                budgetCoBooker: this.normalBudgetCoBooker,
                destinationTravelPolicyBooker: this.destinationTravelPolicyBooker,
                destinationTravelPolicyCoBooker: this.destinationTravelPolicyCoBooker,
                itemList: this.itemList,
                itemListCoBooker: this.itemListCoBooker,
                template: this.template,
                textAverageBudget: this.textAverageBudget,
                shareBudget: this.shareBudget,
            }
        });
    };
    BudgetLimitComponent.prototype.onClickMoreDetail = function () {
        this.dialog.open(__WEBPACK_IMPORTED_MODULE_16__dialog_budget_limit_dialog_budget_limit_detail_dialog_budget_limit_detail_component__["a" /* DialogBudgetLimitDetailComponent */], {
            data: {
                budgetBooker: this.normalBudgetBooker,
                budgetCoBooker: this.normalBudgetCoBooker,
                coBudget: this.normalCoBudget,
                coBudgetUnlimited: this.normalCoBudgetUnlimited,
                appliedCoBudget: this.appliedCoBudget,
                destinationTravelPolicyBooker: this.destinationTravelPolicyBooker,
                destinationTravelPolicyCoBooker: this.destinationTravelPolicyCoBooker,
                isShareBudget: !!this.shareBudget
            }
        });
    };
    BudgetLimitComponent.prototype.transformBudget = function (budget) {
        return "THB " + this.decimal.transform(budget, '1.0');
    };
    BudgetLimitComponent.prototype.convertDays = function (day, lang) {
        return "" + (this.lang === __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["a" /* Language */].th ? 'วัน' : '') + __WEBPACK_IMPORTED_MODULE_10_vendors_moment_locale_th__(day, 'E').locale(lang).format('dddd');
    };
    BudgetLimitComponent.prototype.openDialogShareBudget = function () {
        var _this = this;
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_13__modal_dialog_share_budget_dialog_share_budget_component__["a" /* DialogShareBudgetComponent */]);
        dialogRef.afterClosed().subscribe(function (val) {
            if (val.event === 'success') {
                _this.shareBudget = val.shareBudget;
                _this.shareBudget.booker = new __WEBPACK_IMPORTED_MODULE_14__modal_dialog_share_budget_dialog_share_budget_model__["a" /* Booker */](_this.userService.getUser().userId, _this.userService.getUser().companyId, _this.userService.getUser().email, _this.normalBudgetBooker);
                _this.shareBudget.totalBudget = _this.shareBudget.booker.amount + _this.shareBudget.coBooker.amount;
                _this.onShareBudget.emit(new __WEBPACK_IMPORTED_MODULE_14__modal_dialog_share_budget_dialog_share_budget_model__["a" /* Booker */](val.shareBudget.coBooker.userId, val.shareBudget.coBooker.companyId, val.shareBudget.coBooker.email, val.shareBudget.coBooker.amount));
                _this.authorizeService.setShareBudgetObs(true);
                _this.selectTemplate();
            }
            if (val.event === 'closeDialog') {
                dialogRef.close();
            }
            if (val.event === 'close') {
                dialogRef.close();
                var dialog = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_11__modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */], { data: { confirmType: __WEBPACK_IMPORTED_MODULE_12__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CLOSE } });
                dialog.afterClosed().subscribe(function (res) {
                    if (!res) {
                        _this.openDialogShareBudget();
                    }
                });
            }
            if (val.event === 'bookerNotAllowFeature') {
                // Reload current router
                _this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
                _this.router.navigated = false;
                _this.router.navigateByUrl(_this.router.url);
            }
        });
    };
    BudgetLimitComponent.prototype.onCancelShareBudget = function () {
        var _this = this;
        var message = { text: this.translate.transform('dialog-cancel-share-budget-text'), subText: this.translate.transform('dialog-cancel-share-budget-sub-text') };
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_11__modal_dialog_confirm_dialog_confirm_component__["a" /* DialogConfirmComponent */], {
            data: {
                confirmType: __WEBPACK_IMPORTED_MODULE_12__modal_dialog_confirm_dialog_confirm_model__["a" /* DialogConfirmType */].CONFIRM_CANCEL_SHARE_BUDGET_FROM_USER,
                data: {
                    message: message
                }
            },
        });
        dialogRef.afterClosed().subscribe(function (res) {
            if (res) {
                _this.textNormalBudget = _this.normalBudgetBooker ? _this.transformBudget(_this.normalBudgetBooker) : "" + _this.translate.transform('budget-limit-unlimited');
                _this.shareBudget = undefined;
                _this.selectTemplate();
                _this.authorizeService.removeCoBookerCookie();
                _this.authorizeService.setShareBudgetObs(false);
                _this.onShareBudget.emit(undefined);
            }
        });
    };
    return BudgetLimitComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", String)
], BudgetLimitComponent.prototype, "name", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Array)
], BudgetLimitComponent.prototype, "destinationTravelPolicyBooker", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Array)
], BudgetLimitComponent.prototype, "destinationTravelPolicyCoBooker", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Number)
], BudgetLimitComponent.prototype, "normalBudgetBooker", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], BudgetLimitComponent.prototype, "normalBudgetBookerUnlimited", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Number)
], BudgetLimitComponent.prototype, "normalBudgetCoBooker", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], BudgetLimitComponent.prototype, "normalBudgetCoBookerUnlimited", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Number)
], BudgetLimitComponent.prototype, "normalCoBudget", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], BudgetLimitComponent.prototype, "normalCoBudgetUnlimited", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], BudgetLimitComponent.prototype, "allowLimitBudget", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], BudgetLimitComponent.prototype, "isPOI", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], BudgetLimitComponent.prototype, "isWorkPurpose", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], BudgetLimitComponent.prototype, "allowBookForTraveller", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], BudgetLimitComponent.prototype, "isLoading", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]) === "function" && _a || Object)
], BudgetLimitComponent.prototype, "onShareBudget", void 0);
BudgetLimitComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
        selector: 'act-budget-limit',
        template: __webpack_require__(1016),
        styles: [__webpack_require__(881)]
    }),
    __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_9_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_9_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_5_app_pipes_translate_pipe__["a" /* TranslatePipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_pipes_translate_pipe__["a" /* TranslatePipe */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_common__["k" /* DecimalPipe */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_common__["k" /* DecimalPipe */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MdDialog */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_8_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8_app_services_user_user_service__["a" /* UserService */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_3__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__angular_router__["c" /* Router */]) === "function" && _h || Object, typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_authorize_authorize_service__["a" /* AuthorizeService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_authorize_authorize_service__["a" /* AuthorizeService */]) === "function" && _j || Object])
], BudgetLimitComponent);

var _a, _b, _c, _d, _e, _f, _g, _h, _j;
//# sourceMappingURL=budget-limit.component.js.map

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_carousel_model__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CarouselComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var CarouselComponent = (function () {
    function CarouselComponent(renderer, appConfigService, utilitiesService) {
        this.renderer = renderer;
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.index = 0;
        this.posX1 = 0;
        this.posX2 = 0;
        this.posInitial = 0;
        this.posFinal = 0;
        this.threshold = 0;
        this.itemSize = 0;
        this.isClick = false;
        this.isMobile = false;
        this.interVal = null;
        this.eventIndex = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    CarouselComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.utilitiesService.isScreenLessThan416() && (this.isMobile = true);
        this.MAX_IMAGE_LENGTH = this.data.imagesTh.length;
        this.setImageLang(this.appConfigService.getLanguage());
        this.langSubscription = this.appConfigService.getLanguageObs().subscribe(function (lang) {
            _this.setImageLang(lang);
        });
    };
    CarouselComponent.prototype.ngAfterViewInit = function () {
        //Binding and Add listener first
        this.containerItems = this.wrapper.nativeElement;
        this.carouselItem = this.containerItems.children;
        this.setDefaultValue();
        this.setAutoSlide();
        this.renderer.listen(this.containerItems, 'mouseenter', this.removeAutoSlide.bind(this));
        this.renderer.listen(this.containerItems, 'mouseleave', this.setAutoSlide.bind(this));
        this.renderer.listen(this.containerItems, 'touchstart', this.utilitiesService.debounce(this.ontouchstart.bind(this), 350));
        this.renderer.listen(this.containerItems, 'touchmove', this.utilitiesService.debounce(this.ontouchmove.bind(this), 350));
        this.renderer.listen(this.containerItems, 'touchend', this.utilitiesService.debounce(this.ontouchend.bind(this), 350));
        this.renderer.listen(this.containerItems, 'transitionend', this.checkIndex.bind(this));
    };
    CarouselComponent.prototype.ngOnDestroy = function () {
        this.langSubscription && this.langSubscription.unsubscribe();
    };
    CarouselComponent.prototype.setImageLang = function (lang) {
        if (lang === 'th') {
            this.images = this.data.imagesTh;
            this.mobileImages = this.data.mobileImagesTh;
        }
        else {
            this.images = this.data.imagesEn;
            this.mobileImages = this.data.mobileImagesEn;
        }
    };
    CarouselComponent.prototype.setAutoSlide = function () {
        if (this.interVal) {
            clearInterval(this.interVal);
        }
        this.interVal = setInterval(this.moveSlide.bind(this, 1), 7000);
    };
    CarouselComponent.prototype.removeAutoSlide = function () {
        clearInterval(this.interVal);
    };
    CarouselComponent.prototype.handleEvent = function (index) {
        if (!this.isModalOpen) {
            this.eventIndex.emit(index);
        }
    };
    CarouselComponent.prototype.setDefaultValue = function () {
        this.posX1 = 0;
        this.posX2 = 0;
        this.posInitial = 0;
        this.posFinal = 0;
        this.threshold = 100;
        this.carouselItemLength = this.MAX_IMAGE_LENGTH;
        this.carouselItemSize = this.carouselItem[0].clientWidth;
        this.allowShift = true;
        this.renderer.setStyle(this.containerItems, 'left', (this.posInitial - this.carouselItemSize * (this.index + 1)) + 'px');
    };
    CarouselComponent.prototype.setImageDisplay = function (targetIndex) {
        var hop = targetIndex - this.index;
        if (hop > 0) {
            this.shiftSlide('right', null, hop);
        }
        else if (hop < 0) {
            this.shiftSlide('left', null, Math.abs(hop));
        }
    };
    CarouselComponent.prototype.moveSlide = function (value) {
        this.removeAutoSlide();
        if (value > 0) {
            this.shiftSlide('right', null);
        }
        else {
            this.shiftSlide('left', null);
        }
        this.setAutoSlide();
    };
    ;
    CarouselComponent.prototype.shiftSlide = function (direction, action, hop) {
        if (hop === void 0) { hop = 1; }
        var carouselItemSize = this.carouselItem[0].clientWidth;
        this.renderer.addClass(this.containerItems, 'shifting');
        if (this.allowShift) {
            if (!action) {
                this.posInitial = this.containerItems.offsetLeft;
            }
            if (direction === 'right') {
                this.renderer.setStyle(this.containerItems, 'left', (this.posInitial - (carouselItemSize * hop)) + 'px');
                this.index = this.index + (1 * hop);
            }
            else if (direction === 'left') {
                this.renderer.setStyle(this.containerItems, 'left', (this.posInitial + (carouselItemSize * hop)) + 'px');
                this.index = this.index - (1 * hop);
            }
        }
        this.allowShift = false;
    };
    CarouselComponent.prototype.checkIndex = function () {
        this.renderer.removeClass(this.containerItems, 'shifting');
        if (this.index < 0) {
            this.renderer.setStyle(this.containerItems, 'left', -(this.carouselItemLength * this.carouselItemSize) + 'px');
            this.index = this.carouselItemLength - 1;
        }
        if (this.index >= this.data.imagesTh.length) {
            this.renderer.setStyle(this.containerItems, 'left', -(1 * this.carouselItemSize) + 'px');
            this.index = 0;
        }
        this.allowShift = true;
    };
    CarouselComponent.prototype.ontouchstart = function (event) {
        this.removeAutoSlide();
        this.isClick = true;
        this.posInitial = this.containerItems.offsetLeft;
        this.posX1 = event.touches[0].clientX;
    };
    CarouselComponent.prototype.ontouchmove = function (event) {
        event.preventDefault();
        this.isClick = false;
        this.posX2 = this.posX1 - event.touches[0].clientX;
        this.posX1 = event.touches[0].clientX;
        this.renderer.setStyle(this.containerItems, 'left', (this.containerItems.offsetLeft - this.posX2) + 'px');
    };
    CarouselComponent.prototype.ontouchend = function () {
        this.setAutoSlide();
        this.posFinal = this.containerItems.offsetLeft;
        if (this.posFinal - this.posInitial < -this.threshold) {
            this.shiftSlide('right', 'drag');
        }
        else if (this.posFinal - this.posInitial > this.threshold) {
            this.shiftSlide('left', 'drag');
        }
        else {
            this.renderer.setStyle(this.containerItems, 'left', (this.posInitial) + 'px');
        }
        if (this.isClick) {
            this.handleEvent(this.index);
        }
    };
    CarouselComponent.prototype.onResize = function (event) {
        this.removeAutoSlide();
        this.isMobile = this.utilitiesService.isScreenLessThan416();
        this.setDefaultValue();
        this.setAutoSlide();
    };
    return CarouselComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2_app_model_carousel_model__["a" /* CarouselInfo */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_model_carousel_model__["a" /* CarouselInfo */]) === "function" && _a || Object)
], CarouselComponent.prototype, "data", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], CarouselComponent.prototype, "isModalOpen", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", Object)
], CarouselComponent.prototype, "eventIndex", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('wrapper'),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _b || Object)
], CarouselComponent.prototype, "wrapper", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('container'),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _c || Object)
], CarouselComponent.prototype, "container", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CarouselComponent.prototype, "onResize", null);
CarouselComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-carousel',
        template: __webpack_require__(1019),
        styles: [__webpack_require__(884)]
    }),
    __metadata("design:paramtypes", [typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _f || Object])
], CarouselComponent);

var _a, _b, _c, _d, _e, _f;
//# sourceMappingURL=carousel.component.js.map

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_fleet_fleet_model__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FleetCardSelectBoxComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var FleetCardSelectBoxComponent = FleetCardSelectBoxComponent_1 = (function () {
    function FleetCardSelectBoxComponent(utilitiesService, appConfigService, cdr) {
        this.utilitiesService = utilitiesService;
        this.appConfigService = appConfigService;
        this.cdr = cdr;
        this.setElementIdPage = 'fleet-card-select-box';
        this.optionList = [];
        this.isError = false;
        this.defaultValue = 'Please select';
        this.FleetCardType = __WEBPACK_IMPORTED_MODULE_3_app_model_fleet_fleet_model__["b" /* FleetCardType */];
        this.Language = __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["a" /* Language */];
        this.selectBoxWidth = '0';
        this.isMobile = false;
        this.isOpenMenu = false;
        this.value = '';
    }
    FleetCardSelectBoxComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.optionList) {
            if (changes.optionList.currentValue) {
                if (this.value) {
                    var newOption = changes.optionList.currentValue.find(function (item) { return item.fleetCardId === _this.value; });
                    this.currentOption = newOption;
                    if (newOption) {
                        this.value = newOption.fleetCardId;
                    }
                }
            }
        }
    };
    FleetCardSelectBoxComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isMobile = this.utilitiesService.isMobile();
        this.lang = this.appConfigService.getLanguage();
        this.langSubscription && this.langSubscription.unsubscribe();
        this.langSubscription = this.appConfigService.getLanguageObs()
            .subscribe(function (lang) { return _this.lang = lang; });
    };
    FleetCardSelectBoxComponent.prototype.ngAfterViewInit = function () {
        if (document.getElementById(this.setElementIdPage + "-select-box").clientWidth === 0) {
            this.selectBoxWidth = window.innerWidth - 18 + 'px';
        }
        else {
            this.selectBoxWidth = (document.getElementById(this.setElementIdPage + "-select-box").clientWidth + 2) + 'px';
        }
        this.cdr.detectChanges();
    };
    FleetCardSelectBoxComponent.prototype.ngOnDestroy = function () {
        this.langSubscription && this.langSubscription.unsubscribe();
    };
    FleetCardSelectBoxComponent.prototype.writeValue = function (value) {
        this.value = value;
        this.optionList && this.optionList.length > 0 && this.onSelect(value);
    };
    FleetCardSelectBoxComponent.prototype.registerOnChange = function (onChange) {
        this.onChange = onChange;
    };
    FleetCardSelectBoxComponent.prototype.registerOnTouched = function (onTouch) {
        this.onTouch = onTouch;
    };
    FleetCardSelectBoxComponent.prototype.onSelect = function (value) {
        var newOption = this.optionList.find(function (item) { return item.fleetCardId === value; });
        if (this.currentOption !== newOption) {
            this.currentOption = newOption;
            if (newOption) {
                this.value = newOption.fleetCardId;
            }
            this.onChange && this.onChange(this.value);
        }
    };
    FleetCardSelectBoxComponent.prototype.onOpenMenu = function () {
        this.isOpenMenu = true;
    };
    FleetCardSelectBoxComponent.prototype.onCloseMenu = function () {
        this.isOpenMenu = false;
    };
    return FleetCardSelectBoxComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], FleetCardSelectBoxComponent.prototype, "setElementIdPage", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Array)
], FleetCardSelectBoxComponent.prototype, "optionList", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], FleetCardSelectBoxComponent.prototype, "isError", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], FleetCardSelectBoxComponent.prototype, "defaultValue", void 0);
FleetCardSelectBoxComponent = FleetCardSelectBoxComponent_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-fleet-card-select-box',
        template: __webpack_require__(1027),
        styles: [__webpack_require__(892)],
        providers: [
            {
                provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
                useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FleetCardSelectBoxComponent_1; }),
                multi: true
            }
        ]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _c || Object])
], FleetCardSelectBoxComponent);

var FleetCardSelectBoxComponent_1, _a, _b, _c;
//# sourceMappingURL=fleet-card-select-box.component.js.map

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FooterCopyrightComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var FooterCopyrightComponent = (function () {
    function FooterCopyrightComponent() {
        this.options = { page: 'default' };
        this.currentDate = new Date();
    }
    FooterCopyrightComponent.prototype.ngOnInit = function () {
    };
    return FooterCopyrightComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], FooterCopyrightComponent.prototype, "options", void 0);
FooterCopyrightComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'footer-copyright',
        template: __webpack_require__(1028),
        styles: [__webpack_require__(893)]
    }),
    __metadata("design:paramtypes", [])
], FooterCopyrightComponent);

//# sourceMappingURL=footer-copyright.component.js.map

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_environments_properties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fullpage_js_dist_jquery_fullpage_js__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fullpage_js_dist_jquery_fullpage_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fullpage_js_dist_jquery_fullpage_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FooterComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var FooterComponent = (function () {
    function FooterComponent(dialog, appConfigService) {
        this.dialog = dialog;
        this.appConfigService = appConfigService;
    }
    FooterComponent.prototype.ngOnInit = function () {
        var _this = this;
        var format = 'DD-MM-YYYY HH:mm';
        var now = __WEBPACK_IMPORTED_MODULE_5_moment__(__WEBPACK_IMPORTED_MODULE_5_moment__["utc"]().format(format), format).add(7, 'hours');
        this.effectiveNewAddress = now.isAfter(__WEBPACK_IMPORTED_MODULE_5_moment__(__WEBPACK_IMPORTED_MODULE_3_environments_properties__["z" /* effectiveDateNewTaxAddress */], format));
        this.lang = this.appConfigService.getLanguage();
        this.langSubscription && this.langSubscription.unsubscribe();
        this.langSubscription = this.appConfigService.getLanguageObs()
            .subscribe(function (lang) { return _this.lang = lang; });
    };
    return FooterComponent;
}());
FooterComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'app-footer',
        template: __webpack_require__(1029),
        styles: [__webpack_require__(894)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _b || Object])
], FooterComponent);

var _a, _b;
//# sourceMappingURL=footer.component.js.map

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_checkout_guest_info_model__ = __webpack_require__(218);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormAutocompleteComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var FormAutocompleteComponent = FormAutocompleteComponent_1 = (function () {
    function FormAutocompleteComponent(elementRef) {
        this.elementRef = elementRef;
        this.filterOn = ['fullName'];
        this.invalid = false;
        this.removable = true;
        this.displayOwner = false;
        this.disabled = false;
        this.isLoading = false;
        this.displayNoResult = false;
        this.onSelect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onDeselect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.newValueInserted = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onRemove = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onBlurInput = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.displayDropdown = false;
        this.optionIndex = {
            selecting: -1,
            submit: -1
        };
        this.optionSelected = __WEBPACK_IMPORTED_MODULE_2__model_checkout_guest_info_model__["h" /* Traveller */];
        this.filteredList = [];
        this.isDropUp = false;
        this.ownerStr = '';
    }
    FormAutocompleteComponent.prototype.writeValue = function (value) {
        this.value = value;
    };
    FormAutocompleteComponent.prototype.registerOnChange = function (onChange) {
        this.onChange = onChange;
    };
    FormAutocompleteComponent.prototype.registerOnTouched = function (onTouch) {
        this.onTouch = onTouch;
    };
    FormAutocompleteComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.options && changes.options.currentValue) {
            this.getFilteredList();
        }
        if (changes.owned && changes.owned.currentValue) {
            this.ownerStr = this.owned.roomIndex + "," + this.owned.guestIndex;
            if (this.isIndexValid(this.optionIndex.submit)) {
                this.findSubmit('owned', this.ownerStr);
            }
            else {
                if (this.options) {
                    var owner = this.options.find(function (option) { return (option.owned === _this.ownerStr); });
                    if (owner) {
                        this.optionIndex.submit = owner.userGuestID;
                    }
                }
            }
        }
        if (changes.pageId && changes.pageId.currentValue) {
            this.pageId = changes.pageId.currentValue;
        }
    };
    FormAutocompleteComponent.prototype.ngOnInit = function () {
        this.filteredList = this.options || [];
    };
    FormAutocompleteComponent.prototype.onClickOutside = function (event) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.displayDropdown && this.onTouch(true);
            this.displayDropdown = false;
        }
    };
    FormAutocompleteComponent.prototype.onSelectOption = function (byClick) {
        var _this = this;
        if (byClick === void 0) { byClick = undefined; }
        this.displayDropdown = this.isLoading;
        var optionSelected;
        if (this.isIndexValid(this.optionIndex.submit)) {
            this.findSubmit('selected', false);
        }
        if (byClick) {
            optionSelected = this.options.find(function (option) { return (byClick.userGuestID === option.userGuestID); });
        }
        else {
            optionSelected = this.options.find(function (option) { return (option.userGuestID === _this.filteredList[_this.optionIndex.selecting].userGuestID); });
        }
        this.optionIndex.submit = optionSelected.userGuestID;
        optionSelected.selected = true;
        optionSelected.owned = this.ownerStr;
        this.data = optionSelected;
        this.value = this.data.fullName;
        this.onSelect.emit(this.data);
    };
    FormAutocompleteComponent.prototype.onFocus = function ($event) {
        var dropdownContainer = $event.currentTarget;
        this.filteredList = this.options ? this.filter(this.options, this.value, this.filterOn) : [];
        var position = dropdownContainer.getBoundingClientRect().top;
        var buttonHeight = dropdownContainer.getBoundingClientRect().height;
        var dropdownMenu = dropdownContainer.parentElement.getElementsByClassName('dropdown');
        if (dropdownMenu[0]) {
            var menuHeight = dropdownMenu[0].offsetHeight;
            var windowHeight = window.innerHeight;
            if (position > menuHeight && windowHeight - position < buttonHeight + menuHeight) {
                this.isDropUp = true;
            }
            else {
                this.isDropUp = false;
            }
            this.displayDropdown = true;
            this.checkDisplayDropDown();
        }
        this.getFilteredList();
    };
    FormAutocompleteComponent.prototype.reselecting = function (index, submit) {
        if (index === void 0) { index = undefined; }
        if (submit === void 0) { submit = false; }
        this.filteredList.map(function (option) { return (option.selecting = false); });
        if (index !== undefined) {
            this.optionIndex.selecting = index;
            submit && (this.optionIndex.submit = index);
            if (this.isIndexValid(this.optionIndex.selecting)) {
                this.filteredList[this.optionIndex.selecting].selecting = true;
            }
        }
    };
    FormAutocompleteComponent.prototype.deselect = function () {
        this.options.map(function (option) { return (option.selected = false); });
        this.onDeselect.emit(false);
    };
    FormAutocompleteComponent.prototype.onKeyDown = function (event) {
        if (event.keyCode === 38 || event.keyCode === 40) {
            // this.handleArrowKey(event.key);
        }
        else if (event.key === 'Enter') {
            this.isIndexValid(this.optionIndex.selecting) && (this.onSelectOption());
        }
        else if (event.keyCode === 9) {
            this.onBlur();
        }
    };
    FormAutocompleteComponent.prototype.handleArrowKey = function (dir) {
        var isDown = dir === 'ArrowDown';
        do {
            if (isDown ? this.optionIndex.selecting + 1 < this.filteredList.length : this.optionIndex.selecting - 1 >= 0) {
                isDown ? this.optionIndex.selecting++ : this.optionIndex.selecting--;
            }
        } while (this.filteredList[this.optionIndex.selecting].selected);
        this.reselecting(this.optionIndex.selecting);
    };
    FormAutocompleteComponent.prototype.onBlur = function (checkIndex) {
        if (checkIndex === void 0) { checkIndex = false; }
        this.displayDropdown = false;
        checkIndex && this.reselecting(-1);
        this.handleNewValueInserted();
    };
    FormAutocompleteComponent.prototype.onValueChange = function () {
        this.onChange(this.value);
        this.onTouch(true);
        this.getFilteredList();
        this.displayDropdown = true;
        this.isIndexValid(this.optionIndex.selecting) && (this.reselecting(-1));
        if (this.isIndexValid(this.optionIndex.submit)) {
            this.findSubmit('selected', false);
            this.findSubmit('owned', undefined);
            this.reselecting(-1, true);
            this.deselect();
        }
        this.handleNewValueInserted();
    };
    FormAutocompleteComponent.prototype.onRemoved = function (option) {
        if (this.isIndexValid(this.optionIndex.submit) &&
            this.optionIndex.submit === option.userGuestID) {
            this.reselecting(-1, true);
            this.onRemove.emit({ id: option.userGuestID, clearAll: true });
        }
        else {
            this.onRemove.emit({ id: option.userGuestID, clearAll: false });
        }
    };
    FormAutocompleteComponent.prototype.findIndex = function (val) {
        return this.filteredList.findIndex(function (option) { return (option.userGuestID === val.userGuestID); });
    };
    FormAutocompleteComponent.prototype.isIndexValid = function (index) {
        return index >= 0;
    };
    FormAutocompleteComponent.prototype.handleNewValueInserted = function () {
        this.newValueInserted.emit(this.isIndexValid(this.optionIndex.submit));
    };
    FormAutocompleteComponent.prototype.getFilteredList = function () {
        this.filteredList = this.options ? this.filter(this.options, this.value, this.filterOn) : [];
        this.checkDisplayDropDown();
    };
    FormAutocompleteComponent.prototype.checkDisplayDropDown = function () {
        if ((this.filteredList.length === 0 && !this.displayNoResult) || (this.filteredList.length === 1 && this.filteredList[0].selected)) {
            this.displayDropdown = false;
        }
    };
    FormAutocompleteComponent.prototype.findSubmit = function (node, changeValue) {
        var _this = this;
        this.options.find(function (option) { return (option.userGuestID === _this.optionIndex.submit); })["" + node] = changeValue;
    };
    FormAutocompleteComponent.prototype.focus = function () {
        this.inputElement.nativeElement.focus();
    };
    FormAutocompleteComponent.prototype.filter = function (items, search, nodes) {
        if (!!!search) {
            return items;
        }
        var result = [];
        items && items.forEach(function (item) {
            for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
                var node = nodes_1[_i];
                if (item[node] && item[node].toLowerCase().includes(search.toLowerCase())) {
                    result.push(item);
                    break;
                }
            }
        });
        return result;
    };
    FormAutocompleteComponent.prototype.onBlurInputHandle = function (event) {
        if (event.target !== document.activeElement) {
            this.onBlurInput.emit(event);
        }
    };
    return FormAutocompleteComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], FormAutocompleteComponent.prototype, "pageId", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], FormAutocompleteComponent.prototype, "options", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], FormAutocompleteComponent.prototype, "className", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], FormAutocompleteComponent.prototype, "placeholder", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__model_checkout_guest_info_model__["f" /* RoomGuestIndex */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__model_checkout_guest_info_model__["f" /* RoomGuestIndex */]) === "function" && _a || Object)
], FormAutocompleteComponent.prototype, "owned", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Array)
], FormAutocompleteComponent.prototype, "filterOn", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], FormAutocompleteComponent.prototype, "invalid", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], FormAutocompleteComponent.prototype, "removable", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], FormAutocompleteComponent.prototype, "displayOwner", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], FormAutocompleteComponent.prototype, "disabled", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], FormAutocompleteComponent.prototype, "isLoading", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], FormAutocompleteComponent.prototype, "displayNoResult", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
], FormAutocompleteComponent.prototype, "onSelect", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
], FormAutocompleteComponent.prototype, "onDeselect", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _d || Object)
], FormAutocompleteComponent.prototype, "newValueInserted", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _e || Object)
], FormAutocompleteComponent.prototype, "onRemove", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _f || Object)
], FormAutocompleteComponent.prototype, "onBlurInput", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('inputEl'),
    __metadata("design:type", typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _g || Object)
], FormAutocompleteComponent.prototype, "inputElement", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('document:click', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FormAutocompleteComponent.prototype, "onClickOutside", null);
FormAutocompleteComponent = FormAutocompleteComponent_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-form-autocomplete',
        template: __webpack_require__(1030),
        styles: [__webpack_require__(895)],
        providers: [
            {
                provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
                useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormAutocompleteComponent_1; }),
                multi: true
            }
        ]
    }),
    __metadata("design:paramtypes", [typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _h || Object])
], FormAutocompleteComponent);

var FormAutocompleteComponent_1, _a, _b, _c, _d, _e, _f, _g, _h;
//# sourceMappingURL=form-autocomplete.component.js.map

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormAutocomplete; });
var FormAutocomplete = (function () {
    function FormAutocomplete() {
        this.selected = false;
        this.selecting = false;
    }
    return FormAutocomplete;
}());

//# sourceMappingURL=form-autocomplete.js.map

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__(48);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleMapComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};


var GoogleMapComponent = (function () {
    function GoogleMapComponent(document) {
        this.document = document;
        this.class = 'map';
        this._zoom = 18;
    }
    Object.defineProperty(GoogleMapComponent.prototype, "zoom", {
        set: function (zoom) {
            this._zoom = zoom || this._zoom;
        },
        enumerable: true,
        configurable: true
    });
    ;
    GoogleMapComponent.prototype.ngOnInit = function () {
    };
    GoogleMapComponent.prototype.ngOnChanges = function (changes) {
        if (changes['latitude'] || changes['longitude']) {
            this.lat = this.latitude;
            this.lng = this.longitude;
        }
    };
    GoogleMapComponent.prototype.ngAfterViewInit = function () {
        if (this.lat && this.lng) {
            this.buildMap(this.lat, this.lng, this._zoom);
        }
    };
    GoogleMapComponent.prototype.buildMap = function (latitude, longitude, zoom) {
        if (latitude && longitude && latitude >= -90 && latitude <= 90 && longitude >= -180 && longitude <= 180) {
            var map = new google.maps.Map(this.document.getElementById('map'), {
                center: { lat: latitude, lng: longitude },
                scrollwheel: true,
                gestureHandling: 'greedy',
                zoom: zoom
            });
            var marker = new google.maps.Marker({
                map: map,
                position: { lat: latitude, lng: longitude },
            });
        }
    };
    return GoogleMapComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('latitude'),
    __metadata("design:type", Object)
], GoogleMapComponent.prototype, "latitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('longitude'),
    __metadata("design:type", Object)
], GoogleMapComponent.prototype, "longitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('class'),
    __metadata("design:type", String)
], GoogleMapComponent.prototype, "class", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], GoogleMapComponent.prototype, "zoom", null);
GoogleMapComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-google-map',
        template: __webpack_require__(1032),
        styles: [__webpack_require__(897)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["b" /* DOCUMENT */])),
    __metadata("design:paramtypes", [Object])
], GoogleMapComponent);

//# sourceMappingURL=google-map.component.js.map

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_model_dropdown_dropdown_option_model__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_forms__ = __webpack_require__(11);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconDropdownComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var IconDropdownComponent = IconDropdownComponent_1 = (function () {
    function IconDropdownComponent(cdr) {
        this.cdr = cdr;
        this.hideRowWhenImgError = true;
        this.displayIcon = true;
        this.defaultValue = 'Please select';
        this.isError = false;
        this.disabled = false;
        this.buttonWidth = 0;
        this.menuClassName = 'dropdown-sub-menu';
        this.isOpenMenu = false;
    }
    IconDropdownComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.optionList) {
            if (changes.optionList.currentValue) {
                if (this.value) {
                    var newOption = changes.optionList.currentValue.find(function (x) { return x.value === _this.value; });
                    this.currentOption = newOption;
                    this.value = newOption.value;
                }
            }
            else {
                this.currentOption = this.default;
            }
        }
    };
    IconDropdownComponent.prototype.onOpenMenu = function () {
        this.isOpenMenu = true;
    };
    IconDropdownComponent.prototype.onCloseMenu = function () {
        this.isOpenMenu = false;
    };
    IconDropdownComponent.prototype.ngOnInit = function () {
        if (this.displayIcon) {
            this.menuClassName += ' -divide-first -max-content-width';
        }
        else {
            this.menuClassName += ' -fluid-width';
        }
    };
    IconDropdownComponent.prototype.ngAfterViewInit = function () {
        if (!this.displayIcon) {
            this.buttonWidth = document.getElementById(this.page + "-btn-" + this.name).clientWidth + 2;
            this.cdr.detectChanges();
        }
    };
    IconDropdownComponent.prototype.writeValue = function (value) {
        this.value = value;
        this.optionList && this.optionList.length > 0 && this.select(value);
    };
    IconDropdownComponent.prototype.registerOnChange = function (onChange) {
        this.onChange = onChange;
    };
    IconDropdownComponent.prototype.registerOnTouched = function (onTouch) {
        this.onTouch = onTouch;
    };
    IconDropdownComponent.prototype.select = function (value) {
        var newOption = this.optionList.find(function (x) { return x.value === value; });
        if (this.currentOption != newOption) {
            this.currentOption = newOption;
            if (newOption) {
                this.value = newOption.value;
            }
            this.isOpenMenu = false;
            this.onChange && this.onChange(this.value);
        }
    };
    IconDropdownComponent.prototype.hideOption = function (index) {
        this.optionList[index].error = true;
    };
    return IconDropdownComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], IconDropdownComponent.prototype, "page", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], IconDropdownComponent.prototype, "name", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Array)
], IconDropdownComponent.prototype, "optionList", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_model_dropdown_dropdown_option_model__["a" /* Option */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_model_dropdown_dropdown_option_model__["a" /* Option */]) === "function" && _a || Object)
], IconDropdownComponent.prototype, "default", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], IconDropdownComponent.prototype, "hideRowWhenImgError", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], IconDropdownComponent.prototype, "displayIcon", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], IconDropdownComponent.prototype, "defaultValue", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], IconDropdownComponent.prototype, "isError", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], IconDropdownComponent.prototype, "disabled", void 0);
IconDropdownComponent = IconDropdownComponent_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-icon-dropdown',
        template: __webpack_require__(1034),
        styles: [__webpack_require__(899)],
        providers: [
            {
                provide: __WEBPACK_IMPORTED_MODULE_2__angular_forms__["NG_VALUE_ACCESSOR"],
                useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return IconDropdownComponent_1; }),
                multi: true
            }
        ]
    }),
    __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _b || Object])
], IconDropdownComponent);

var IconDropdownComponent_1, _a, _b;
//# sourceMappingURL=icon-dropdown.component.js.map

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendors_typeahead_jquery_js__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendors_typeahead_jquery_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vendors_typeahead_jquery_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputSuggestionComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var InputSuggestionComponent = (function () {
    function InputSuggestionComponent() {
        // tslint:disable:no-input-rename
        // tslint:disable:no-output-rename
        this.inputId = 'input-suggestion';
        this.inputValue = '';
        this.inputPlaceholder = 'Search...';
        this.textInputMinimumSize = 3;
        this.suggestionData = [];
        this.onGetSuggestionOutput = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.onInputSelectedOutput = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.onClearedOutput = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.textValue = '';
    }
    InputSuggestionComponent.prototype.ngOnChanges = function (changes) {
        changes.suggestionData && changes.suggestionData.currentValue &&
            this.onSuggestionChanged(changes.suggestionData.currentValue);
        changes.inputValue && changes.inputValue.currentValue &&
            (this.textValue = changes.inputValue.currentValue);
    };
    InputSuggestionComponent.prototype.ngOnInit = function () {
    };
    InputSuggestionComponent.prototype.ngOnDestroy = function () {
        this.$typeaheadElement && this.$typeaheadElement.typeahead('destroy');
    };
    InputSuggestionComponent.prototype.ngAfterViewInit = function () {
        this.$typeaheadElement = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + this.inputId + '-control');
        this.setupTypeahead();
        this.setupInputKeyupEvent();
        this.setupTypeaheadSelectAllText();
    };
    InputSuggestionComponent.prototype.setupTypeahead = function () {
        this.$typeaheadElement.typeahead({
            highlight: true,
            hint: false,
            minLength: this.textInputMinimumSize,
            classNames: { menu: 'input-suggestion-menu' }
        }, {
            name: 'suggestion-' + this.inputId,
            source: this.setupTypeaheadSource(),
        })
            .bind('typeahead:selected', this.setupTypeaheadSelected());
    };
    InputSuggestionComponent.prototype.setupTypeaheadSource = function () {
        var _this = this;
        return function (query, syncResult, asyncResult) {
            _this.onGetSuggestionOutput.emit(query);
            _this.syncResult = asyncResult;
        };
    };
    InputSuggestionComponent.prototype.setupTypeaheadSelected = function () {
        var _this = this;
        return function (event, datum, dataset) {
            _this.onItemSelected(datum);
        };
    };
    InputSuggestionComponent.prototype.setupTypeaheadSelectAllText = function () {
        var $element = this.$typeaheadElement;
        $element.on('click', function () {
            $element && $element.select();
        });
    };
    InputSuggestionComponent.prototype.setupInputKeyupEvent = function () {
        var _this = this;
        var $element = this.$typeaheadElement;
        $element.on('keyup', function (event) {
            var isPressEnter = event.keyCode === 13;
            var isPressEsc = event.keyCode === 27;
            // press enter button => submit to search
            if (isPressEnter) {
                _this.onInputSelectedOutput.emit(_this.textValue);
                $element.blur();
            }
            // press esc button => clear text input
            if (isPressEsc) {
                _this.onClearButtonClicked(undefined);
                $element.blur();
            }
        });
    };
    InputSuggestionComponent.prototype.onSuggestionChanged = function (data) {
        this.syncResult && this.syncResult(data);
    };
    InputSuggestionComponent.prototype.onItemSelected = function (data) {
        this.onInputSelectedOutput.emit(data);
        this.$typeaheadElement && this.$typeaheadElement.blur();
    };
    InputSuggestionComponent.prototype.onClearButtonClicked = function (data) {
        this.onClearedOutput.emit();
        this.$typeaheadElement.typeahead('val', '');
        this.textValue = '';
        this.suggestionData = [];
        this.onSuggestionChanged(this.suggestionData);
    };
    return InputSuggestionComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('id'),
    __metadata("design:type", Object)
], InputSuggestionComponent.prototype, "inputId", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('value'),
    __metadata("design:type", Object)
], InputSuggestionComponent.prototype, "inputValue", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('placeholder'),
    __metadata("design:type", Object)
], InputSuggestionComponent.prototype, "inputPlaceholder", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('minSize'),
    __metadata("design:type", Object)
], InputSuggestionComponent.prototype, "textInputMinimumSize", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('data'),
    __metadata("design:type", Object)
], InputSuggestionComponent.prototype, "suggestionData", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])('onFetchSuggestion'),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]) === "function" && _a || Object)
], InputSuggestionComponent.prototype, "onGetSuggestionOutput", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])('onInputSelected'),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]) === "function" && _b || Object)
], InputSuggestionComponent.prototype, "onInputSelectedOutput", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])('onInputCleared'),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]) === "function" && _c || Object)
], InputSuggestionComponent.prototype, "onClearedOutput", void 0);
InputSuggestionComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
        selector: 'input-suggestion',
        template: __webpack_require__(1035),
        styles: [__webpack_require__(900)]
    }),
    __metadata("design:paramtypes", [])
], InputSuggestionComponent);

var _a, _b, _c;
//# sourceMappingURL=input-suggestion.component.js.map

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LangDropdownComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var LangDropdownComponent = (function () {
    function LangDropdownComponent(appConfigService) {
        this.appConfigService = appConfigService;
    }
    LangDropdownComponent.prototype.ngOnInit = function () {
        this.language = this.appConfigService.getLanguage();
    };
    LangDropdownComponent.prototype.handleChangeLanguage = function (languageCode) {
        this.appConfigService.setLanguage(languageCode);
        this.language = languageCode;
    };
    return LangDropdownComponent;
}());
LangDropdownComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'app-lang-dropdown',
        template: __webpack_require__(1036),
        styles: [__webpack_require__(901)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object])
], LangDropdownComponent);

var _a;
//# sourceMappingURL=lang-dropdown.component.js.map

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dialog_alert_dialog_alert_component__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_checkout_checkout_service__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogBudgetSuggestionComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};





var DialogBudgetSuggestionComponent = (function () {
    function DialogBudgetSuggestionComponent(dialogRef, checkoutService, dialog, appConfigService, existBudget) {
        this.dialogRef = dialogRef;
        this.checkoutService = checkoutService;
        this.dialog = dialog;
        this.appConfigService = appConfigService;
        this.existBudget = existBudget;
        this.pageElementName = 'dialog-budget-suggestion';
        this.isSubmitted = false;
        this.isLoading = false;
        this.oneMillion = 1000000;
        this.budgetMask = [/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
    }
    DialogBudgetSuggestionComponent.prototype.ngOnInit = function () {
        this.budgetValue = this.existBudget;
    };
    DialogBudgetSuggestionComponent.prototype.handleCancel = function () {
        this.dialogRef.close();
    };
    DialogBudgetSuggestionComponent.prototype.onApplyBudget = function () {
        var _this = this;
        this.isSubmitted = true;
        if (!this.isValid()) {
            return;
        }
        this.isLoading = true;
        this.checkoutService.saveBudgetSuggestion(this.budgetValue)
            .subscribe(function () { return _this.dialogRef.close(_this.budgetValue); }, function (error) {
            var errorCode;
            try {
                var errorList = error.json().errors;
                errorCode = errorList.length > 0 ? errorList[0].code : '';
            }
            catch (e) {
                console.log(e);
            }
            _this.dialogRef.close();
            var dialogAlertRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_1__dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */]);
            dialogAlertRef.componentInstance.alertText = _this.appConfigService.getTranslate('system-error');
            dialogAlertRef.componentInstance.imageSrc = '/assets/images/icons/icon-failed.png';
            dialogAlertRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-failed.png';
            if (errorCode)
                switch (errorCode) {
                    case '4500':
                    case '4501':
                    case '4502':
                    case '4503':
                    case '4504':
                        dialogAlertRef.componentInstance.imageSrc = 'assets/images/icons/icon-failed.png';
                        dialogAlertRef.componentInstance.imageSrcSet = 'assets/images/icons/icon-failed.png';
                        dialogAlertRef.componentInstance.alertText = _this.appConfigService.getTranslate('checkout-3-error-multi-payment-not-allow');
                        break;
                }
        });
    };
    DialogBudgetSuggestionComponent.prototype.isValid = function () {
        return this.budgetValue && this.budgetValue <= this.oneMillion;
    };
    return DialogBudgetSuggestionComponent;
}());
DialogBudgetSuggestionComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__angular_core__["Component"])({
        selector: 'act-dialog-budget-suggestion',
        template: __webpack_require__(1043),
        styles: [__webpack_require__(908)]
    }),
    __param(4, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_3__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__services_checkout_checkout_service__["a" /* CheckoutService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_checkout_checkout_service__["a" /* CheckoutService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialog */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object, Number])
], DialogBudgetSuggestionComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=dialog-budget-suggestion.component.js.map

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_form_form__ = __webpack_require__(126);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChangePasswordForm; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ChangePasswordForm = (function (_super) {
    __extends(ChangePasswordForm, _super);
    function ChangePasswordForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formErrors = {
            'newPassword': {
                valid: true
            },
            'confirmNewPassword': {
                valid: true
            },
        };
        _this.getInitForm = function (password, confirmPassword) {
            return {
                'newPassword': [password, [
                        __WEBPACK_IMPORTED_MODULE_0__angular_forms__["Validators"].required,
                        __WEBPACK_IMPORTED_MODULE_0__angular_forms__["Validators"].minLength(8),
                        __WEBPACK_IMPORTED_MODULE_0__angular_forms__["Validators"].maxLength(16),
                        _this.validateInvalidCharacter(_this.validatePattern.password)
                    ]],
                'confirmNewPassword': [confirmPassword, [
                        __WEBPACK_IMPORTED_MODULE_0__angular_forms__["Validators"].required
                    ]]
            };
        };
        return _this;
    }
    return ChangePasswordForm;
}(__WEBPACK_IMPORTED_MODULE_1_app_components_form_form__["a" /* Form */]));

//# sourceMappingURL=change-password.form.js.map

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_notice_notice_service__ = __webpack_require__(157);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogNotifyBudgetComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};



var DialogNotifyBudgetComponent = (function () {
    function DialogNotifyBudgetComponent(data, dialogRef, noticeService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.noticeService = noticeService;
    }
    DialogNotifyBudgetComponent.prototype.ngOnInit = function () {
    };
    DialogNotifyBudgetComponent.prototype.handleBtnOk = function () {
        if (this.agree) {
            this.noticeService.setNotifyDisabled('BOOK_NOTIFY_BUDGET', true);
        }
        this.dialogRef.close();
    };
    return DialogNotifyBudgetComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('text'),
    __metadata("design:type", String)
], DialogNotifyBudgetComponent.prototype, "text", void 0);
DialogNotifyBudgetComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'ota-dialog-notify-budget',
        template: __webpack_require__(1060),
        styles: [__webpack_require__(925)]
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MD_DIALOG_DATA */])),
    __metadata("design:paramtypes", [Object, typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_notice_notice_service__["b" /* NoticeService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_notice_notice_service__["b" /* NoticeService */]) === "function" && _b || Object])
], DialogNotifyBudgetComponent);

var _a, _b;
//# sourceMappingURL=dialog-notify-budget.component.js.map

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_components_verify_otp_otp_state__ = __webpack_require__(131);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PHONE_STATE; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PHONE_STATE = (function (_super) {
    __extends(PHONE_STATE, _super);
    function PHONE_STATE() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PHONE_STATE;
}(__WEBPACK_IMPORTED_MODULE_0_app_components_verify_otp_otp_state__["a" /* OTP_STATE */]));

PHONE_STATE.SET_PHONE = 'set_phone';
//# sourceMappingURL=phone-state.js.map

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_products_product_service__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var DialogComponent = (function () {
    function DialogComponent(utilitiesService, productService, dialogRef) {
        this.utilitiesService = utilitiesService;
        this.productService = productService;
        this.dialogRef = dialogRef;
        this.isDisbledClose = false;
        this.closeBottom = false;
        this.heightRowButton = 0;
        this.class = '';
        this.isDisbledBackground = false;
        this.isMice = false;
        this.closeType = '';
        this.eventEmitter = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    DialogComponent.prototype.ngOnChanges = function (changes) {
        if (changes.isMobileFullscreen) {
            this.updateHeightMobileScreen();
        }
    };
    DialogComponent.prototype.onResize = function (event) {
        this.updateHeightMobileScreen();
    };
    DialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.updateHeightMobileScreen();
        setTimeout(function () {
            if (_this.isMice) {
                _this.utilitiesService.lockBody(false);
            }
            else {
                _this.utilitiesService.lockBody();
            }
            _this.utilitiesService.lockBodyBackdrop();
        });
    };
    DialogComponent.prototype.updateHeightMobileScreen = function () {
        if (this.isMobileFullscreen) {
            document.documentElement.style.setProperty("--dialog-vh", window.innerHeight * 0.01 + "px");
            document.documentElement.style.setProperty("--heightRowButton", this.heightRowButton + "px");
        }
    };
    DialogComponent.prototype.ngOnDestroy = function () {
        this.utilitiesService.unlockBody();
        this.utilitiesService.unlockBodyBackdrop();
    };
    DialogComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    DialogComponent.prototype.onChoose = function () {
        this.eventEmitter.emit();
    };
    return DialogComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('disbledClose'),
    __metadata("design:type", Boolean)
], DialogComponent.prototype, "isDisbledClose", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('closeBottom'),
    __metadata("design:type", Boolean)
], DialogComponent.prototype, "closeBottom", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('fullscreen'),
    __metadata("design:type", Boolean)
], DialogComponent.prototype, "isFullscreen", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('mobileFullscreen'),
    __metadata("design:type", Boolean)
], DialogComponent.prototype, "isMobileFullscreen", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], DialogComponent.prototype, "heightRowButton", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('class'),
    __metadata("design:type", String)
], DialogComponent.prototype, "class", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('title'),
    __metadata("design:type", Object)
], DialogComponent.prototype, "title", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('subTitle'),
    __metadata("design:type", Object)
], DialogComponent.prototype, "subTitle", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('rating'),
    __metadata("design:type", Object)
], DialogComponent.prototype, "rating", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('address'),
    __metadata("design:type", Object)
], DialogComponent.prototype, "address", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('disbledClickBackground'),
    __metadata("design:type", Boolean)
], DialogComponent.prototype, "isDisbledBackground", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('mice'),
    __metadata("design:type", Boolean)
], DialogComponent.prototype, "isMice", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('closeAction'),
    __metadata("design:type", Function)
], DialogComponent.prototype, "closeAction", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('closeType'),
    __metadata("design:type", String)
], DialogComponent.prototype, "closeType", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])('eventEmitter'),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], DialogComponent.prototype, "eventEmitter", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DialogComponent.prototype, "onResize", null);
DialogComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'ota-dialog',
        template: __webpack_require__(1075),
        styles: [__webpack_require__(940)]
    }),
    __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_products_product_service__["a" /* ProductService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_products_product_service__["a" /* ProductService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialogRef */]) === "function" && _d || Object])
], DialogComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=dialog.component.js.map

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaginationComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var PaginationComponent = (function () {
    function PaginationComponent(utilitiesService) {
        this.utilitiesService = utilitiesService;
        this.isIpadMobile = false;
        this.detailless = false;
        this.onGoToPage = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    PaginationComponent.prototype.ngOnInit = function () {
        this.initialPagination();
    };
    PaginationComponent.prototype.ngOnChanges = function () {
        this.initialPagination();
    };
    PaginationComponent.prototype.initialPagination = function () {
        this.totalPage = Math.ceil(this.totalItem / this.itemPerPage);
        this.getCenterPaginations();
    };
    PaginationComponent.prototype.isDiabledPrevBtn = function () {
        return this.currentPage == 1;
    };
    PaginationComponent.prototype.isDiabledNextBtn = function () {
        return this.currentPage == this.totalPage;
    };
    PaginationComponent.prototype.isShowFirstDot = function () {
        return this.currentPage > 4;
    };
    PaginationComponent.prototype.isShowFirstNumberDot = function () {
        return this.currentPage < 5;
    };
    PaginationComponent.prototype.isShowLastNumberDot = function () {
        return this.currentPage > this.totalPage - 4;
    };
    PaginationComponent.prototype.isShowLastDot = function () {
        return this.currentPage < this.totalPage - 3;
    };
    PaginationComponent.prototype.nextPage = function () {
        var nextIndex = this.currentPage < this.totalPage ? this.currentPage + 1 : this.totalPage;
        this.setCurrentPage(nextIndex);
    };
    PaginationComponent.prototype.prevPage = function () {
        var prevIndex = this.currentPage > this.totalPage ? this.totalPage : this.currentPage - 1;
        this.setCurrentPage(prevIndex);
    };
    PaginationComponent.prototype.setCurrentPage = function (index) {
        this.currentPage = index;
        this.getCenterPaginations();
        this.onGoToPage.emit({ data: index });
    };
    PaginationComponent.prototype.getLastPage = function () {
        return Math.round(this.totalPage);
    };
    PaginationComponent.prototype.getCenterPaginations = function () {
        var _centerPaginations = [];
        var _currentPage = this.currentPage;
        var _totalPage = this.getLastPage();
        // detect min and max range number
        if (_currentPage < 5) {
            _currentPage = 5;
        }
        else if (_currentPage > _totalPage - 5) {
            _currentPage = _totalPage - 4;
        }
        for (var i = 0; i < 5; i++) {
            var index = _currentPage + (i - 2);
            if (index > 0 && index < _totalPage) {
                _centerPaginations.push(index);
            }
        }
        this.centerPaginations = _centerPaginations;
    };
    return PaginationComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('totalItem'),
    __metadata("design:type", Number)
], PaginationComponent.prototype, "totalItem", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('itemPerPage'),
    __metadata("design:type", Number)
], PaginationComponent.prototype, "itemPerPage", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('currentPage'),
    __metadata("design:type", Number)
], PaginationComponent.prototype, "currentPage", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('isIpadMobile'),
    __metadata("design:type", Boolean)
], PaginationComponent.prototype, "isIpadMobile", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], PaginationComponent.prototype, "detailless", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])('onGoToPage'),
    __metadata("design:type", Object)
], PaginationComponent.prototype, "onGoToPage", void 0);
PaginationComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'app-pagination',
        template: __webpack_require__(1076),
        styles: [__webpack_require__(941)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _a || Object])
], PaginationComponent);

var _a;
//# sourceMappingURL=pagination.component.js.map

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_model_booking_my_booking_model_v2__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_constant__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentMethodDetailsComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PaymentMethodDetailsComponent = (function () {
    function PaymentMethodDetailsComponent() {
        this.isCancelBeforePayCreditCard = false;
        this.onCancel = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.cancellationPolicy = null;
        this.cancellationPolicyTitle = null;
        this.anotherCancellationPolicy = null;
        this.anotherCancellationPolicyTitle = null;
        this.PaymentChannelType = __WEBPACK_IMPORTED_MODULE_2__model_constant__["l" /* PaymentChannelType */];
        this.PaymentMethodDetailType = __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */];
        this.RefundType = __WEBPACK_IMPORTED_MODULE_2__model_constant__["n" /* RefundType */];
        this.PaymentStatus = __WEBPACK_IMPORTED_MODULE_2__model_constant__["M" /* PaymentStatus */];
        this.BookingStatusType = __WEBPACK_IMPORTED_MODULE_2__model_constant__["f" /* BookingStatusType */];
    }
    PaymentMethodDetailsComponent.prototype.ngOnInit = function () {
        this.setHideDateSection();
        this.setCancellationPolicy();
    };
    PaymentMethodDetailsComponent.prototype.onClickCancel = function () {
        this.onCancel.emit();
    };
    PaymentMethodDetailsComponent.prototype.setHideDateSection = function () {
        this.hidePaymentDateSection = false;
        if (this.isCancelled) {
            switch (this.paymentChannel) {
                case __WEBPACK_IMPORTED_MODULE_2__model_constant__["l" /* PaymentChannelType */].TRUE_MONEY:
                case __WEBPACK_IMPORTED_MODULE_2__model_constant__["l" /* PaymentChannelType */].CORPORATE_FLEET:
                case __WEBPACK_IMPORTED_MODULE_2__model_constant__["l" /* PaymentChannelType */].PERSONAL_FLEET:
                case __WEBPACK_IMPORTED_MODULE_2__model_constant__["l" /* PaymentChannelType */].QR_CODE:
                case __WEBPACK_IMPORTED_MODULE_2__model_constant__["l" /* PaymentChannelType */].E_WALLET:
                case __WEBPACK_IMPORTED_MODULE_2__model_constant__["l" /* PaymentChannelType */].IM_BANKING:
                case __WEBPACK_IMPORTED_MODULE_2__model_constant__["l" /* PaymentChannelType */].PAY_AT_COUNTER:
                    this.hidePaymentDateSection = this.refundType === __WEBPACK_IMPORTED_MODULE_2__model_constant__["n" /* RefundType */].PARTIAL_REFUND || this.refundType === __WEBPACK_IMPORTED_MODULE_2__model_constant__["n" /* RefundType */].FULL_REFUND;
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__model_constant__["l" /* PaymentChannelType */].CREDIT_CARD:
                    this.hidePaymentDateSection = this.refundType === __WEBPACK_IMPORTED_MODULE_2__model_constant__["n" /* RefundType */].PARTIAL_REFUND || (this.refundType === __WEBPACK_IMPORTED_MODULE_2__model_constant__["n" /* RefundType */].FULL_REFUND && !this.isCancelBeforePayCreditCard);
                default:
                    break;
            }
        }
    };
    PaymentMethodDetailsComponent.prototype.setCancellationPolicy = function () {
        if (this.isCancelled) {
            if (this.refundType === __WEBPACK_IMPORTED_MODULE_2__model_constant__["n" /* RefundType */].PARTIAL_REFUND || this.refundType === __WEBPACK_IMPORTED_MODULE_2__model_constant__["n" /* RefundType */].FULL_REFUND) {
                // refund policy - main payment
                if (this.paymentMethodDetail.mainPaymentMethod === __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */].CREDIT_CARD) {
                    this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-credit-card';
                    if (this.paymentMethodDetail.anotherPaymentMethod) {
                        this.cancellationPolicyTitle = 'payment-method-detail-payment-credit-terms';
                    }
                }
                else if (this.paymentMethodDetail.mainPaymentMethod === __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */].CORPORATE_FLEET) {
                    this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-fleet';
                    if (this.paymentMethodDetail.anotherPaymentMethod) {
                        this.cancellationPolicyTitle = 'payment-method-detail-payment-corporate-fleet';
                    }
                }
                else if (this.paymentMethodDetail.mainPaymentMethod === __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */].PERSONAL_FLEET) {
                    this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-fleet';
                    if (this.paymentMethodDetail.anotherPaymentMethod) {
                        this.cancellationPolicyTitle = 'payment-method-detail-payment-personal-fleet';
                    }
                }
                else if (this.paymentMethodDetail.mainPaymentMethod === __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */].TRUE_MONEY) {
                    this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-true-money';
                    if (this.paymentMethodDetail.anotherPaymentMethod) {
                        this.cancellationPolicyTitle = 'payment-method-detail-payment-true-money';
                    }
                }
                else if (this.paymentMethodDetail.mainPaymentMethod === __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */].QR_CODE ||
                    this.paymentMethodDetail.mainPaymentMethod === __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */].IM_BANKING ||
                    this.paymentMethodDetail.mainPaymentMethod === __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */].PAY_AT_COUNTER) {
                    this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-payment';
                    if (this.paymentMethodDetail.anotherPaymentMethod) {
                        this.cancellationPolicyTitle = this.paymentMethodDetail.anotherPaymentMethodDisplay;
                    }
                }
                else if (this.paymentMethodDetail.mainPaymentMethod === __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */].E_WALLET) {
                    this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-e-wallet';
                    if (this.paymentMethodDetail.anotherPaymentMethod) {
                        this.cancellationPolicyTitle = this.paymentMethodDetail.anotherPaymentMethodDisplay;
                    }
                }
                // refund policy - another payment
                if (this.paymentMethodDetail.anotherPaymentMethod === __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */].CREDIT_CARD) {
                    if (this.paymentMethodDetail.mainPaymentMethod === __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */].CREDIT_TERMS) {
                        this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-credit-card';
                    }
                    else {
                        this.anotherCancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-credit-card';
                        this.anotherCancellationPolicyTitle = 'payment-method-detail-payment-credit-card';
                    }
                }
                else if (this.paymentMethodDetail.anotherPaymentMethod === __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */].TRUE_MONEY) {
                    if (this.paymentMethodDetail.mainPaymentMethod === __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */].CREDIT_TERMS) {
                        this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-true-money';
                    }
                    else {
                        this.anotherCancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-true-money';
                        this.anotherCancellationPolicyTitle = 'payment-method-detail-payment-true-money';
                    }
                }
                else if (this.paymentMethodDetail.anotherPaymentMethod === __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */].PERSONAL_FLEET) {
                    if (this.paymentMethodDetail.mainPaymentMethod === __WEBPACK_IMPORTED_MODULE_2__model_constant__["m" /* PaymentMethodDetailType */].CREDIT_TERMS) {
                        this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-fleet';
                    }
                    else {
                        this.anotherCancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-fleet';
                        this.anotherCancellationPolicyTitle = 'payment-method-detail-payment-personal-fleet';
                    }
                }
            }
        }
    };
    return PaymentMethodDetailsComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__model_constant__["l" /* PaymentChannelType */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__model_constant__["l" /* PaymentChannelType */]) === "function" && _a || Object)
], PaymentMethodDetailsComponent.prototype, "paymentChannel", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], PaymentMethodDetailsComponent.prototype, "displayCancelButton", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], PaymentMethodDetailsComponent.prototype, "payOnDate", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], PaymentMethodDetailsComponent.prototype, "isCancelled", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__model_constant__["n" /* RefundType */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__model_constant__["n" /* RefundType */]) === "function" && _b || Object)
], PaymentMethodDetailsComponent.prototype, "refundType", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], PaymentMethodDetailsComponent.prototype, "prefixElementId", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_1_app_model_booking_my_booking_model_v2__["c" /* PaymentMethodDetail */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_model_booking_my_booking_model_v2__["c" /* PaymentMethodDetail */]) === "function" && _c || Object)
], PaymentMethodDetailsComponent.prototype, "paymentMethodDetail", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], PaymentMethodDetailsComponent.prototype, "isCancelBeforePayCreditCard", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], PaymentMethodDetailsComponent.prototype, "paymentMethodDisplay", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], PaymentMethodDetailsComponent.prototype, "bookingStatus", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _d || Object)
], PaymentMethodDetailsComponent.prototype, "onCancel", void 0);
PaymentMethodDetailsComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-payment-method-details',
        template: __webpack_require__(1078),
        styles: [__webpack_require__(943)]
    }),
    __metadata("design:paramtypes", [])
], PaymentMethodDetailsComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=payment-method-details.component.js.map

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_approval_approval_detail_model__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_booking_my_booking_model_v2__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cart_dialog_taxes_fees_dialog_taxes_fees_component__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentSummaryComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var Condition = (function () {
    function Condition() {
    }
    return Condition;
}());
Condition.BOOKING_SINGLE_PAYMENT = 'BOOKING_SINGLE_PAYMENT';
Condition.CANCEL_SINGLE_PAYMENT = 'CANCEL_SINGLE_PAYMENT';
Condition.CANCEL_SINGLE_PAYMENT_NON_CREDIT_TERM = 'CANCEL_SINGLE_PAYMENT_NON_CREDIT_TERM';
Condition.BOOKING_MULTI_PAYMENT = 'BOOKING_MULTI_PAYMENT';
Condition.CANCEL_MULTI_PAYMENT = 'CANCEL_MULTI_PAYMENT';
var PaymentSummaryComponent = (function () {
    function PaymentSummaryComponent(appConfigService, dialog, utilitiesService) {
        this.appConfigService = appConfigService;
        this.dialog = dialog;
        this.utilitiesService = utilitiesService;
        this.isCancelBooking = false;
        this.surchargeList = [];
        this.mini = false;
        this.Condition = Condition;
        this.PaymentMethodDetailType = __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["m" /* PaymentMethodDetailType */];
        this.condition = Condition.BOOKING_MULTI_PAYMENT;
        this.isShareBudget = false;
        this.isMultiPayment = false;
        this.isShareBudgetByAdmin = false;
        this.hasDiscount = false;
        this.totalPriceBeforeDiscount = 0;
        this.discountAmount = 0;
    }
    PaymentSummaryComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.lang = this.appConfigService.getLanguage();
        this.langSubscription && this.langSubscription.unsubscribe();
        this.langSubscription = this.appConfigService.getLanguageObs()
            .subscribe(function (lang) { return _this.lang = lang; });
        this.prepareMainPaymentMethodDisplay(this.mainPaymentMethod);
        this.prepareAnotherPaymentMethodDisplay(this.anotherPaymentMethod);
        this.prepareDiscountSummary();
    };
    PaymentSummaryComponent.prototype.ngOnChanges = function (changes) {
        for (var propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                switch (propName) {
                    case 'mainPayment':
                    case 'anotherPayment':
                    case 'coBookerMainPayment':
                    case 'bookingPayment':
                        this.calculateCondition();
                        this.prepareDiscountSummary();
                        break;
                }
            }
        }
    };
    PaymentSummaryComponent.prototype.ngOnDestroy = function () {
        this.langSubscription && this.langSubscription.unsubscribe();
    };
    PaymentSummaryComponent.prototype.calculateCondition = function () {
        if (this.mainPayment && this.coBookerMainPayment) {
            this.bookerPayments = [this.mainPayment, this.coBookerMainPayment];
            this.isShareBudget = true;
        }
        if (this.anotherPayment) {
            this.isMultiPayment = true;
        }
        if (!this.isCancelBooking && !this.isMultiPayment) {
            this.condition = Condition.BOOKING_SINGLE_PAYMENT;
        }
        else if (this.isCancelBooking && !this.isMultiPayment) {
            this.condition = this.mainPaymentMethod !== __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_TERMS ?
                Condition.CANCEL_SINGLE_PAYMENT_NON_CREDIT_TERM : Condition.CANCEL_SINGLE_PAYMENT;
        }
        else if (!this.isCancelBooking && this.isMultiPayment) {
            this.condition = Condition.BOOKING_MULTI_PAYMENT;
        }
        else if (this.isCancelBooking && this.isMultiPayment) {
            this.condition = Condition.CANCEL_MULTI_PAYMENT;
        }
        this.isShareBudgetByAdmin = this.shareBudgetByAdmin();
    };
    PaymentSummaryComponent.prototype.shareBudgetByAdmin = function () {
        return this.paymentType === __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["N" /* PaymentType */].SHARE_BUDGET_BY_ADMIN || this.paymentType === __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["N" /* PaymentType */].SHARE_BUDGET_BY_ADMIN_MULTI_PAYMENT;
    };
    PaymentSummaryComponent.prototype.prepareMainPaymentMethodDisplay = function (paymentMethod) {
        var paymentMethodDisplay;
        switch (paymentMethod) {
            case __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_TERMS:
                paymentMethodDisplay = 'payment-summary-pay-credit-term';
                break;
            case __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["m" /* PaymentMethodDetailType */].CORPORATE_FLEET:
                paymentMethodDisplay = 'payment-summary-pay-corporate-fleet';
                break;
            case __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["m" /* PaymentMethodDetailType */].PERSONAL_FLEET:
                paymentMethodDisplay = 'payment-summary-pay-personal-fleet';
                break;
        }
        this.mainPaymentMethodDisplay = paymentMethodDisplay;
    };
    PaymentSummaryComponent.prototype.prepareAnotherPaymentMethodDisplay = function (paymentMethod) {
        var paymentMethodDisplay;
        switch (paymentMethod) {
            case __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["m" /* PaymentMethodDetailType */].CREDIT_CARD:
                paymentMethodDisplay = 'payment-summary-pay-credit-card-add';
                break;
            case __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["m" /* PaymentMethodDetailType */].TRUE_MONEY:
                paymentMethodDisplay = 'payment-summary-pay-true-money-add';
                break;
            case __WEBPACK_IMPORTED_MODULE_4_app_model_constant__["m" /* PaymentMethodDetailType */].PERSONAL_FLEET:
                paymentMethodDisplay = 'payment-summary-pay-personal-fleet-add';
                break;
        }
        this.anotherPaymentMethodDisplay = paymentMethodDisplay;
    };
    PaymentSummaryComponent.prototype.openDialogTaxesAndFees = function () {
        if (this.utilitiesService.isMobile()) {
            var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__cart_dialog_taxes_fees_dialog_taxes_fees_component__["a" /* DialogTaxesFeesComponent */]);
        }
    };
    PaymentSummaryComponent.prototype.prepareDiscountSummary = function () {
        this.hasDiscount = !!(this.bookingPayment && this.bookingPayment.discount > 0);
        this.discountAmount = this.hasDiscount ? this.bookingPayment.discount : 0;
        this.totalPriceBeforeDiscount = this.hasDiscount ? (this.bookingPayment.totalPrice + this.discountAmount) : 0;
    };
    return PaymentSummaryComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2_app_model_approval_approval_detail_model__["a" /* PaymentInformation */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_model_approval_approval_detail_model__["a" /* PaymentInformation */]) === "function" && _a || Object)
], PaymentSummaryComponent.prototype, "bookingPayment", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2_app_model_approval_approval_detail_model__["b" /* BookingCancellationCharge */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_model_approval_approval_detail_model__["b" /* BookingCancellationCharge */]) === "function" && _b || Object)
], PaymentSummaryComponent.prototype, "bookingCancellationCharge", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3_app_model_booking_my_booking_model_v2__["d" /* BookerPaymentInformation */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_model_booking_my_booking_model_v2__["d" /* BookerPaymentInformation */]) === "function" && _c || Object)
], PaymentSummaryComponent.prototype, "mainPayment", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_3_app_model_booking_my_booking_model_v2__["d" /* BookerPaymentInformation */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_model_booking_my_booking_model_v2__["d" /* BookerPaymentInformation */]) === "function" && _d || Object)
], PaymentSummaryComponent.prototype, "anotherPayment", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], PaymentSummaryComponent.prototype, "mainPaymentMethod", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], PaymentSummaryComponent.prototype, "anotherPaymentMethod", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_3_app_model_booking_my_booking_model_v2__["d" /* BookerPaymentInformation */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_model_booking_my_booking_model_v2__["d" /* BookerPaymentInformation */]) === "function" && _e || Object)
], PaymentSummaryComponent.prototype, "coBookerMainPayment", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], PaymentSummaryComponent.prototype, "isCancelBooking", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Array)
], PaymentSummaryComponent.prototype, "surchargeList", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], PaymentSummaryComponent.prototype, "mini", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], PaymentSummaryComponent.prototype, "prefixElementId", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], PaymentSummaryComponent.prototype, "isRejectBooking", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], PaymentSummaryComponent.prototype, "paymentType", void 0);
PaymentSummaryComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-payment-summary',
        template: __webpack_require__(1080),
        styles: [__webpack_require__(945)]
    }),
    __metadata("design:paramtypes", [typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _h || Object])
], PaymentSummaryComponent);

var _a, _b, _c, _d, _e, _f, _g, _h;
//# sourceMappingURL=payment-summary.component.js.map

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromotionMenuBarComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var PromotionMenuBarComponent = (function () {
    function PromotionMenuBarComponent(appConfigService, utilitiesService, dialog, router) {
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.dialog = dialog;
        this.router = router;
        this.isMobileDisplayMenu = false;
        this.isfirstSection = false;
        this.isLogin = false;
        this.isShowListLanguage = false;
        this.canChangePassword = true;
        this.showApprovalList = false;
        this.isMobile = false;
        this.theme = '';
        this.notFoundPage = false;
        this.mobileToggleMenuBar = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](); // tslint:disable-line
    }
    Object.defineProperty(PromotionMenuBarComponent.prototype, "firstLandingState", {
        set: function (firstLandingState) {
            this._firstLandingState = firstLandingState ? firstLandingState : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PromotionMenuBarComponent.prototype, "landingPageState", {
        set: function (landingPageState) {
            this._landingPageState = landingPageState ? landingPageState : '';
            this.isfirstSection = this._landingPageState === this._firstLandingState;
        },
        enumerable: true,
        configurable: true
    });
    PromotionMenuBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.language = this.appConfigService.getLanguage();
        this.isMobile = this.utilitiesService.isMobile();
        this.appConfigSubscription = this.appConfigService.getLanguageObs().subscribe(function (lang) {
            if (window.matchMedia('(max-width: 767px)').matches) {
                _this.handleBlurMenuBar();
            }
        });
        this.setLogoPath();
    };
    PromotionMenuBarComponent.prototype.ngOnDestroy = function () {
        this.utilitiesService.unlockBody();
        this.appConfigSubscription && this.appConfigSubscription.unsubscribe();
    };
    PromotionMenuBarComponent.prototype.getLang = function () {
        return this.appConfigService.getLanguage();
    };
    PromotionMenuBarComponent.prototype.handleToggleMenuBar = function (e) {
        this.isMobileDisplayMenu = !this.isMobileDisplayMenu;
        this.mobileToggleMenuBar.emit({ 'isMobileDisplayMenu': this.isMobileDisplayMenu });
        if (this.isMobileDisplayMenu) {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('html').addClass('-open-sidemenu');
            this.utilitiesService.lockBody();
        }
        else {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('html').removeClass('-open-sidemenu');
        }
    };
    PromotionMenuBarComponent.prototype.handleBlurMenuBar = function () {
        this.isMobileDisplayMenu = false;
        this.mobileToggleMenuBar.emit({ 'isMobileDisplayMenu': this.isMobileDisplayMenu });
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('html').removeClass('-open-sidemenu');
        this.utilitiesService.unlockBody();
    };
    PromotionMenuBarComponent.prototype.handleShowListLanguage = function (e) {
        this.isShowListLanguage = !this.isShowListLanguage;
    };
    PromotionMenuBarComponent.prototype.handleChangeLanguage = function (languageCode) {
        this.appConfigService.setLanguage(languageCode);
        this.isShowListLanguage = false;
        this.language = languageCode;
    };
    PromotionMenuBarComponent.prototype.setLogoPath = function () {
        var ActLogoPath = this.appConfigService.getActLogoPath().ActLogoPath;
        var ActDefaultLogoPath = this.appConfigService.getActDefaultLogoPath().ActDefaultLogoPath;
        this.logoPath = ActLogoPath;
        this.logoDefaultPath = ActDefaultLogoPath;
    };
    return PromotionMenuBarComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], PromotionMenuBarComponent.prototype, "theme", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], PromotionMenuBarComponent.prototype, "notFoundPage", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('firstLandingState'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], PromotionMenuBarComponent.prototype, "firstLandingState", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('landingPageState'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], PromotionMenuBarComponent.prototype, "landingPageState", null);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])('onMobileToggleMenuBar'),
    __metadata("design:type", Object)
], PromotionMenuBarComponent.prototype, "mobileToggleMenuBar", void 0);
PromotionMenuBarComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'app-promotion-menu-bar',
        template: __webpack_require__(1081),
        styles: [__webpack_require__(946)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialog */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_4__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__angular_router__["c" /* Router */]) === "function" && _d || Object])
], PromotionMenuBarComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=promotion-menu-bar.component.js.map

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_model_search_form_model__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_services_search_search_service__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromotionSearchBoxComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var PromotionSearchBoxComponent = (function () {
    function PromotionSearchBoxComponent(formBuilder, searchService, appConfigService, router, dialog, utilitiesService) {
        this.formBuilder = formBuilder;
        this.searchService = searchService;
        this.appConfigService = appConfigService;
        this.router = router;
        this.dialog = dialog;
        this.utilitiesService = utilitiesService;
        this.type = 'H'; // H = home, C = Level-C, D = Level-D
        this.layout = 'home'; // home, topwrap
        this.submitSearch = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"](); // tslint:disable-line:no-output-rename
        this.sendData = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"](); // tslint:disable-line:no-output-rename
        this.sendState = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"](); // tslint:disable-line:no-output-rename
        this.searchFormModel = new __WEBPACK_IMPORTED_MODULE_7_app_model_search_form_model__["d" /* SearchFormModel */]();
        this.searchSubmitted = false;
        this.isShowRoomBox = false;
        this.isRoomBoxShowArrow = false;
        this.isWorkOnly = false;
        this.isEditable = false;
        this.roomCount = 1;
        this.adultCount = 2;
        this.childCount = 0;
        this.currentTabRoom = 1;
    }
    PromotionSearchBoxComponent.prototype.ngOnChanges = function (changes) {
        if (!changes.data.firstChange && changes && changes.data && changes.data.currentValue && changes.data.currentValue.guests.length !== this.searchFormModel.guests.length) {
            this.searchFormModel.guests = this.data.guests;
            this.searchForm.get('guests').setValue(this.searchFormModel.guests);
            this.currentRoom = this.searchForm.value.guests[0];
            this.lastestSearchForm = JSON.parse(JSON.stringify(this.searchForm.value));
            this.updateCountOfRoom();
            this.onSubmit({ value: this.searchFormModel, valid: true });
        }
    };
    PromotionSearchBoxComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.data) {
            this.data = {
                checkInDate: __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__().format('DD-MM-YYYY'),
                checkOutDate: __WEBPACK_IMPORTED_MODULE_0_vendors_moment_locale_th__().add(1, 'days').format('DD-MM-YYYY'),
                destination: { title: '', id: '', suggestCat: '', slug: '' },
                guests: [{ adult: 2, children: [] }],
                purpose: 'leisure'
            };
        }
        // Setup Data
        this.searchFormModel.destination = this.data.destination;
        this.searchFormModel.guests = this.data.guests;
        this.searchFormModel.checkInDate = this.utilitiesService.reverseFormatDate(this.data.checkInDate);
        this.searchFormModel.checkOutDate = this.utilitiesService.reverseFormatDate(this.data.checkOutDate);
        this.searchFormModel.purpose = this.data.purpose;
        this.searchForm = this.formBuilder.group({
            'destination': this.formBuilder.group({
                id: [this.searchFormModel.destination.id],
                title: [this.searchFormModel.destination.title, __WEBPACK_IMPORTED_MODULE_2__angular_forms__["Validators"].required],
                suggestCat: [this.searchFormModel.destination.suggestCat],
                slug: [this.searchFormModel.destination.slug],
                poi: [this.searchFormModel.destination.poi],
            }),
            'checkInDate': [this.searchFormModel.checkInDate, __WEBPACK_IMPORTED_MODULE_2__angular_forms__["Validators"].required],
            'checkOutDate': [this.searchFormModel.checkOutDate, __WEBPACK_IMPORTED_MODULE_2__angular_forms__["Validators"].required],
            'guests': [this.searchFormModel.guests, __WEBPACK_IMPORTED_MODULE_2__angular_forms__["Validators"].required],
        });
        this.currentRoom = this.searchForm.value.guests[0];
        this.lastestSearchForm = JSON.parse(JSON.stringify(this.searchForm.value));
        this.updateCountOfRoom();
        // call emit data when outside component need data
        this.sendData.emit({ data: this.lastestSearchForm });
        // init date on text read
        this.dateCheckInOutput = this.utilitiesService.getOtaFormatYear(this.lang(), this.searchForm.value.checkInDate);
        this.dateCheckOutOutput = this.utilitiesService.getOtaFormatYear(this.lang(), this.searchForm.value.checkOutDate);
        this.searchForm.controls.checkInDate.valueChanges.subscribe(function (val) {
            _this.dateCheckInOutput = _this.utilitiesService.getOtaFormatYear(_this.lang(), val);
        });
        this.searchForm.controls.checkOutDate.valueChanges.subscribe(function (val) {
            _this.dateCheckOutOutput = _this.utilitiesService.getOtaFormatYear(_this.lang(), val);
        });
        this.appConfigService.getLanguageObs().subscribe(function (lang) {
            _this.dateCheckInOutput = _this.utilitiesService.getOtaFormatYear(lang, _this.searchForm.value.checkInDate);
            _this.dateCheckOutOutput = _this.utilitiesService.getOtaFormatYear(lang, _this.searchForm.value.checkOutDate);
        });
        // init class header for can know type search-box from css context
        var $html = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('html');
        $html.removeClass('topwrap-layout home-layout');
        $html.addClass(this.layout + '-layout');
    };
    PromotionSearchBoxComponent.prototype.onSubmit = function (_a) {
        var value = _a.value, valid = _a.valid;
        this.searchSubmitted = true;
        var suggestCat = this.searchForm.value.destination.suggestCat;
        var slug = suggestCat === 'pointofinterest' ? '' : this.searchForm.value.destination.slug;
        slug = this.utilitiesService.resolveSlugSpace(slug);
        if (suggestCat == 'product' || suggestCat == 'hotel') {
            this.data = {
                destination: this.utilitiesService.base64Encoder(JSON.stringify(this.searchFormModel.destination)),
                purpose: this.searchFormModel.purpose,
                checkIn: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkInDate),
                checkOut: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkOutDate),
                guests: this.utilitiesService.base64Encoder(JSON.stringify(this.searchForm.value.guests)),
                lang: this.lang()
            };
            this.submitSearch.emit({ data: this.data });
            this.hideEditable();
        }
    };
    PromotionSearchBoxComponent.prototype.lang = function () {
        return this.appConfigService.getLanguage();
    };
    PromotionSearchBoxComponent.prototype.isShowLimitedRoomSelect = function () {
        return this.searchForm.value.purpose == 'work' && this.isLimitRoom;
    };
    PromotionSearchBoxComponent.prototype.isShowFreeStyleRoomSelect = function () {
        return (this.searchForm.value.purpose == 'leisure' || !this.isLimitRoom) && this.searchForm.value.purpose != '';
    };
    PromotionSearchBoxComponent.prototype.toggleRoomBox = function (event) {
        if (this.isShowRoomBox) {
            this.hideRoomBox(event);
        }
        else {
            this.showRoomBox(event);
        }
    };
    PromotionSearchBoxComponent.prototype.showRoomBox = function (event) {
        var _this = this;
        this.isShowRoomBox = true;
        // Oganize JS Queue Stack Process.
        setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default()('html').on('click.hideRoomBox', function (e) {
                _this.hideRoomBox(e);
            });
            _this.detectToShowArrow();
        });
    };
    PromotionSearchBoxComponent.prototype.hideRoomBox = function (event) {
        this.isShowRoomBox = false;
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('html').off('click.hideRoomBox');
    };
    PromotionSearchBoxComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    PromotionSearchBoxComponent.prototype.resetToRoomDefault = function () {
        this.setActiveTabRoom(1);
        this.searchForm.controls.guests.setValue([{ adult: 2, children: [] }]);
        this.currentRoom = this.searchForm.value.guests[0];
        this.roomCount = 1;
        this.adultCount = 2;
    };
    // RoomBox
    PromotionSearchBoxComponent.prototype.handlerOnChangeRoom = function (event) {
        var oldRoomCount = this.roomCount;
        var roomChoose = parseInt(event.target.value);
        var _rooms = this.searchForm.value.guests;
        if (oldRoomCount > roomChoose) {
            // delete room
            _rooms.splice(roomChoose);
            this.setActiveTabRoom(roomChoose);
        }
        else {
            // add room
            var newRoomsCount = roomChoose - oldRoomCount;
            var newRooms = [];
            for (var i = 0; i < newRoomsCount; i++) {
                newRooms.push({
                    adult: 2,
                    children: []
                });
            }
            this.searchForm.controls.guests.setValue(_rooms.concat(newRooms));
        }
        this.roomCount = roomChoose;
        this.updateCountOfRoom();
        this.detectToShowArrow();
    };
    PromotionSearchBoxComponent.prototype.handlerOnChangeAdultCount = function (event) {
        var _adultCount = parseInt(event.target.value);
        this.currentRoom.adult = _adultCount;
        this.updateCountOfRoom();
    };
    PromotionSearchBoxComponent.prototype.handlerOnChangeChildren = function (event) {
        var oldChildrenCount = this.currentRoom.children.length;
        var _childrenCount = parseInt(event.target.value);
        if (oldChildrenCount > _childrenCount) {
            // delete children
            this.currentRoom.children.splice(_childrenCount);
        }
        else {
            // add children
            var newChildrenCount = _childrenCount - oldChildrenCount;
            var newChildren = [];
            for (var i = 0; i < newChildrenCount; i++) {
                newChildren.push(1);
            }
            this.currentRoom.children = this.currentRoom.children.concat(newChildren);
        }
        this.updateCountOfRoom();
    };
    PromotionSearchBoxComponent.prototype.handlerOnChangeChildrenOld = function (event, i) {
        this.currentRoom.children[i] = parseInt(event.target.value);
    };
    PromotionSearchBoxComponent.prototype.resetChildren = function () {
        var _rooms = this.searchForm.value.guests;
        _rooms.forEach(function (room) {
            room.children = [];
        });
        this.childCount = 0;
        this.searchForm.controls.guests.setValue(_rooms);
    };
    PromotionSearchBoxComponent.prototype.setActiveTabRoom = function (index) {
        if (this.currentTabRoom != index) {
            this.currentTabRoom = index;
            this.currentRoom = this.searchForm.value.guests[index - 1];
            this.moveScrollToItem();
        }
    };
    PromotionSearchBoxComponent.prototype.nextActiveTabRoom = function () {
        var nextRoom = this.currentTabRoom < this.searchForm.value.guests.length ? this.currentTabRoom + 1 : this.currentTabRoom;
        this.setActiveTabRoom(nextRoom);
        this.moveScrollToItem();
    };
    PromotionSearchBoxComponent.prototype.prevActiveTabRoom = function () {
        var prevRoom = this.currentTabRoom > 1 ? this.currentTabRoom - 1 : 1;
        this.setActiveTabRoom(prevRoom);
        this.moveScrollToItem();
    };
    PromotionSearchBoxComponent.prototype.detectToShowArrow = function () {
        var $tabContainer = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.select-room-popup-container');
        var $scrollContainer = $tabContainer.find('.tab-detail-room-list ul');
        var $tabs = $tabContainer.find('li');
        var $currentTab = $tabs[this.currentTabRoom - 1];
        var tabWidth = $currentTab.clientWidth;
        var scrollContainerWidth = $scrollContainer[0].clientWidth;
        var scrollLeft = $scrollContainer[0].scrollLeft;
        var currentPosLeft = __WEBPACK_IMPORTED_MODULE_4_jquery___default()($currentTab).position().left;
        var currentPosRight = currentPosLeft + tabWidth;
        // detect item is width over range
        if ((tabWidth + 2) * this.roomCount > scrollContainerWidth) {
            this.isRoomBoxShowArrow = true;
        }
        else {
            this.isRoomBoxShowArrow = false;
        }
    };
    PromotionSearchBoxComponent.prototype.moveScrollToItem = function () {
        var $tabContainer = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.select-room-popup-container');
        var $scrollContainer = $tabContainer.find('.tab-detail-room-list ul');
        var $tabs = $tabContainer.find('li');
        var $currentTab = $tabs[this.currentTabRoom - 1];
        var tabWidth = $currentTab.clientWidth;
        var scrollContainerWidth = $scrollContainer[0].clientWidth;
        var scrollLeft = $scrollContainer[0].scrollLeft;
        var currentPosLeft = __WEBPACK_IMPORTED_MODULE_4_jquery___default()($currentTab).position().left;
        var currentPosRight = currentPosLeft + tabWidth;
        // detect visible tab on scroll
        var targetLeftPos = (tabWidth + 2) * (this.currentTabRoom - 1);
        if (currentPosRight > scrollContainerWidth) {
            $scrollContainer[0].scrollLeft = targetLeftPos - scrollContainerWidth + tabWidth + 30;
        }
        else if (currentPosLeft < 0) {
            $scrollContainer[0].scrollLeft = targetLeftPos - 30;
        }
    };
    PromotionSearchBoxComponent.prototype.updateCountOfRoom = function () {
        var _adultCount = 0;
        var _childCount = 0;
        this.searchForm.value.guests.forEach(function (room, i) {
            _adultCount += room.adult;
            _childCount += room.children.length;
        });
        this.roomCount = this.searchForm.value.guests.length;
        this.adultCount = _adultCount;
        this.childCount = _childCount;
    };
    PromotionSearchBoxComponent.prototype.trackByChild = function (index, child) {
        return index;
    };
    // top wrap layout
    PromotionSearchBoxComponent.prototype.showEditable = function () {
        this.isEditable = true;
        this.sendState.emit({ mode: 'EDIT' });
    };
    PromotionSearchBoxComponent.prototype.hideEditable = function () {
        this.isEditable = false;
        this.sendState.emit({ mode: 'NORMAL' });
    };
    PromotionSearchBoxComponent.prototype.cancleChangeSearch = function () {
        this.hideEditable();
        this.searchForm.reset(JSON.parse(JSON.stringify(this.lastestSearchForm)));
        //this.isSelectedDestination = true;
        this.currentRoom = this.searchForm.value.guests[0];
        this.updateCountOfRoom();
    };
    PromotionSearchBoxComponent.prototype.handleClickDestinationTextArea = function () {
        var _this = this;
        this.showEditable();
        if (!window.matchMedia('(max-width: 767px)').matches) {
            setTimeout(function () {
                _this.inputCheckIn.nativeElement.focus();
            }, 600);
        }
        else {
            setTimeout(function () {
                _this.inputCheckIn.nativeElement.focus();
            }, 800);
        }
    };
    PromotionSearchBoxComponent.prototype.handleClickDateTextArea = function () {
        var _this = this;
        this.showEditable();
        setTimeout(function () {
            if (_this.utilitiesService.isIOS()) {
                __WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this.inputCheckIn.nativeElement).trigger('touchend');
            }
            else {
                __WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this.inputCheckIn.nativeElement).trigger('click');
            }
        }, 400);
    };
    PromotionSearchBoxComponent.prototype.handleClickRoomTextArea = function () {
        var _this = this;
        this.showEditable();
        setTimeout(function () {
            if (_this.inputRoomBox) {
                __WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this.inputRoomBox.nativeElement).trigger('click');
            }
        }, 200);
    };
    return PromotionSearchBoxComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", Object)
], PromotionSearchBoxComponent.prototype, "data", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", String)
], PromotionSearchBoxComponent.prototype, "type", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", String)
], PromotionSearchBoxComponent.prototype, "layout", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])('onSubmitSearch'),
    __metadata("design:type", Object)
], PromotionSearchBoxComponent.prototype, "submitSearch", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])('onGetData'),
    __metadata("design:type", Object)
], PromotionSearchBoxComponent.prototype, "sendData", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])('onGetState'),
    __metadata("design:type", Object)
], PromotionSearchBoxComponent.prototype, "sendState", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])('inputDestination'),
    __metadata("design:type", Object)
], PromotionSearchBoxComponent.prototype, "inputDestination", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])('inputCheckIn'),
    __metadata("design:type", Object)
], PromotionSearchBoxComponent.prototype, "inputCheckIn", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])('inputRoomBox'),
    __metadata("design:type", Object)
], PromotionSearchBoxComponent.prototype, "inputRoomBox", void 0);
PromotionSearchBoxComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
        selector: 'app-promotion-search-box',
        template: __webpack_require__(1082),
        styles: [__webpack_require__(947)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_forms__["FormBuilder"]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_8_app_services_search_search_service__["b" /* SearchService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8_app_services_search_search_service__["b" /* SearchService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_6__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6__angular_router__["c" /* Router */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialog */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_9_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_9_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _f || Object])
], PromotionSearchBoxComponent);

var _a, _b, _c, _d, _e, _f;
//# sourceMappingURL=promotion-search-box.component.js.map

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RoomtypeItemComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var RoomtypeItemComponent = (function () {
    function RoomtypeItemComponent() {
        this.isOpen = true;
    }
    RoomtypeItemComponent.prototype.ngOnInit = function () { };
    RoomtypeItemComponent.prototype.toggleContent = function () {
        this.isOpen = !this.isOpen;
    };
    return RoomtypeItemComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('isOpen'),
    __metadata("design:type", Boolean)
], RoomtypeItemComponent.prototype, "isOpen", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('data-index'),
    __metadata("design:type", Number)
], RoomtypeItemComponent.prototype, "itemIndex", void 0);
RoomtypeItemComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'ota-booking-details-roomtype-item',
        template: __webpack_require__(1083),
        styles: [__webpack_require__(948)]
    }),
    __metadata("design:paramtypes", [])
], RoomtypeItemComponent);

//# sourceMappingURL=roomtype-item.component.js.map

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_model_user_consent_model__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_environments_properties__ = __webpack_require__(21);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServiceAndPrivacyComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var ServiceAndPrivacyComponent = (function () {
    function ServiceAndPrivacyComponent(appConfigService, userService) {
        this.appConfigService = appConfigService;
        this.userService = userService;
        this.isGetContentFromAPI = false;
        this.consentName = __WEBPACK_IMPORTED_MODULE_4_environments_properties__["n" /* consentName */];
        this.lang = appConfigService.getLanguage();
    }
    ServiceAndPrivacyComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.langSubscription && this.langSubscription.unsubscribe();
        this.langSubscription = this.appConfigService.getLanguageObs().subscribe(function (lang) {
            _this.lang = lang;
            _this.getConsentDetail(_this.consentName, lang);
        });
        if (this.isGetContentFromAPI) {
            this.getConsentDetail(this.consentName, this.lang);
        }
    };
    ServiceAndPrivacyComponent.prototype.ngOnDestroy = function () {
        this.langSubscription && this.langSubscription.unsubscribe();
        this.getConsentDetailSubscription && this.getConsentDetailSubscription.unsubscribe();
    };
    ServiceAndPrivacyComponent.prototype.getConsentDetail = function (consentName, lang) {
        var _this = this;
        this.getConsentDetailSubscription && this.getConsentDetailSubscription.unsubscribe();
        this.getConsentDetailSubscription = this.userService.getConsentDetail(consentName, __WEBPACK_IMPORTED_MODULE_1_app_model_user_consent_model__["b" /* ConsentType */].PRIVACY, lang)
            .subscribe(function (res) {
            if (res) {
                _this.contentFromAPI = res.privacy;
            }
        }, function (err) { return console.error(err); });
    };
    return ServiceAndPrivacyComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ServiceAndPrivacyComponent.prototype, "lang", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ServiceAndPrivacyComponent.prototype, "content", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ServiceAndPrivacyComponent.prototype, "isGetContentFromAPI", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ServiceAndPrivacyComponent.prototype, "consentName", void 0);
ServiceAndPrivacyComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-service-and-privacy',
        template: __webpack_require__(1085),
        styles: [__webpack_require__(950)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_user_user_service__["a" /* UserService */]) === "function" && _b || Object])
], ServiceAndPrivacyComponent);

var _a, _b;
//# sourceMappingURL=service-and-privacy.component.js.map

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__show_more_prefix_model__ = __webpack_require__(511);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShowMoreContentBoxComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var ShowMoreContentBoxComponent = (function () {
    function ShowMoreContentBoxComponent() {
        this.isDisplayAll = true;
        this.showBtn = false;
        this.filter = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.contentClass = '-default';
        this._prefix = new __WEBPACK_IMPORTED_MODULE_1__show_more_prefix_model__["a" /* ShowMorePrefixModel */]();
    }
    Object.defineProperty(ShowMoreContentBoxComponent.prototype, "prefix", {
        set: function (prefix) {
            this._prefix = prefix || this._prefix;
        },
        enumerable: true,
        configurable: true
    });
    ShowMoreContentBoxComponent.prototype.ngOnChanges = function (changes) {
        if (changes['showBtn']) {
            if (this.showBtn) {
                this.isDisplayAll = this.showBtn ? false : true;
            }
            else {
                this.isDisplayAll = false;
                this.filter.emit(!this.isDisplayAll);
            }
        }
    };
    ShowMoreContentBoxComponent.prototype.switchBtn = function () {
        this.isDisplayAll = this.isDisplayAll ? false : true;
        this.filter.emit(!this.isDisplayAll);
    };
    return ShowMoreContentBoxComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('showBtn'),
    __metadata("design:type", Boolean)
], ShowMoreContentBoxComponent.prototype, "showBtn", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])('filter'),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], ShowMoreContentBoxComponent.prototype, "filter", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ShowMoreContentBoxComponent.prototype, "contentClass", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], ShowMoreContentBoxComponent.prototype, "prefix", null);
ShowMoreContentBoxComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-show-more-content-box',
        template: __webpack_require__(1086),
        styles: [__webpack_require__(951)]
    }),
    __metadata("design:paramtypes", [])
], ShowMoreContentBoxComponent);

var _a;
//# sourceMappingURL=show-more-content-box.component.js.map

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_model_carousel_model__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SlideShowComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var SlideShowComponent = (function () {
    function SlideShowComponent(renderer, appConfigService, utilitiesService) {
        this.renderer = renderer;
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.isMobile = false;
        this.posX1 = 0;
        this.posX2 = 0;
        this.posInitial = 0;
        this.posFinal = 0;
        this.threshold = 0;
        this.eventIndex = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    SlideShowComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.utilitiesService.isScreenLessThan416() && (this.isMobile = true);
        this.setLangImage(this.appConfigService.getLanguage());
        this.setDefaultValue();
        this.langSubscription = this.appConfigService.getLanguageObs().subscribe(function (lang) {
            _this.setLangImage(lang);
        });
    };
    SlideShowComponent.prototype.ngAfterViewInit = function () {
        this.showSlide(0);
        this.renderer.listen(this.wrapper.nativeElement, 'touchstart', this.ontouchstart.bind(this));
        this.renderer.listen(this.wrapper.nativeElement, 'touchmove', this.ontouchmove.bind(this));
        this.renderer.listen(this.wrapper.nativeElement, 'touchend', this.ontouchend.bind(this));
    };
    SlideShowComponent.prototype.ontouchstart = function (event) {
        this.posInitial = this.wrapper.nativeElement.offsetLeft;
        this.posX1 = event.touches[0].clientX;
    };
    SlideShowComponent.prototype.ontouchmove = function (event) {
        this.posX2 = this.posX1 - event.touches[0].clientX;
        this.posX1 = event.touches[0].clientX;
        var opacityValue = Math.abs(this.wrapper.nativeElement.offsetLeft - this.posX2);
        this.renderer.setStyle(this.wrapper.nativeElement.children[this.slideIndex], 'opacity', 1 - Math.floor(opacityValue) / 100 + '');
    };
    SlideShowComponent.prototype.normalizeValue = function (input) {
        return (input - 0) / 1;
    };
    SlideShowComponent.prototype.ontouchend = function () {
        this.posFinal = this.wrapper.nativeElement.offsetLeft;
        if (this.posFinal - this.posInitial < -this.threshold) {
            // shift right
        }
        else if (this.posFinal - this.posInitial > this.threshold) {
            // shift left
        }
    };
    SlideShowComponent.prototype.setLangImage = function (lang) {
        if (lang === 'th') {
            this.images = this.data.imagesTh;
            this.mobileImages = this.data.mobileImagesTh;
        }
        else {
            this.images = this.data.imagesEn;
            this.mobileImages = this.data.mobileImagesEn;
        }
    };
    SlideShowComponent.prototype.handleEvent = function (index) {
        if (!this.isModalOpen) {
            this.eventIndex.emit(index);
        }
    };
    SlideShowComponent.prototype.setDefaultValue = function () {
        this.slideIndex = 0;
        this.MAX_IMAGE_LENGTH = this.data.imagesTh.length;
        this.posX1 = 0;
        this.posX2 = 0;
        this.posInitial = 0;
        this.posFinal = 0;
        this.threshold = 100;
    };
    SlideShowComponent.prototype.nextSlide = function () {
        this.slideIndex = this.slideIndex + 1;
        this.showSlide(this.slideIndex);
    };
    SlideShowComponent.prototype.prevSlide = function () {
        this.slideIndex = this.slideIndex - 1;
        this.showSlide(this.slideIndex);
    };
    SlideShowComponent.prototype.setImageDisplay = function (index) {
        this.showSlide(index);
    };
    SlideShowComponent.prototype.showSlide = function (index) {
        if (index < 0) {
            this.slideIndex = this.MAX_IMAGE_LENGTH - 1;
            index = this.slideIndex;
        }
        if (index >= this.MAX_IMAGE_LENGTH) {
            this.slideIndex = 0;
            index = this.slideIndex;
        }
        var activeSlideElement = this.wrapper.nativeElement.querySelector('.activeSlide');
        var activeNavDotElement = this.navDot.nativeElement.querySelector('.active');
        if (activeSlideElement) {
            this.renderer.removeClass(activeSlideElement, 'activeSlide');
        }
        if (activeNavDotElement) {
            this.renderer.removeClass(activeNavDotElement, 'active');
        }
        this.renderer.addClass(this.wrapper.nativeElement.children[index], 'activeSlide');
        this.renderer.addClass(this.navDot.nativeElement.children[index], 'active');
    };
    SlideShowComponent.prototype.onResize = function (event) {
        this.isMobile = this.utilitiesService.isScreenLessThan416();
        if (this.isMobile) {
            this.showSlide(this.slideIndex);
        }
    };
    return SlideShowComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('data'),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_model_carousel_model__["a" /* CarouselInfo */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_model_carousel_model__["a" /* CarouselInfo */]) === "function" && _a || Object)
], SlideShowComponent.prototype, "data", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('isModalOpen'),
    __metadata("design:type", Boolean)
], SlideShowComponent.prototype, "isModalOpen", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('wrapper'),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _b || Object)
], SlideShowComponent.prototype, "wrapper", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('navDot'),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _c || Object)
], SlideShowComponent.prototype, "navDot", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", Object)
], SlideShowComponent.prototype, "eventIndex", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SlideShowComponent.prototype, "onResize", null);
SlideShowComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-slide-show',
        template: __webpack_require__(1087),
        styles: [__webpack_require__(952)]
    }),
    __metadata("design:paramtypes", [typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _f || Object])
], SlideShowComponent);

var _a, _b, _c, _d, _e, _f;
//# sourceMappingURL=slide-show.component.js.map

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_currency_currency_service__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery_ui_ui_widgets_slider__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery_ui_ui_widgets_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery_ui_ui_widgets_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vendors_jquery_ui_touch_punch_min_js__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vendors_jquery_ui_touch_punch_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__vendors_jquery_ui_touch_punch_min_js__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SliderRangeComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var SliderRangeComponent = (function () {
    function SliderRangeComponent(formBuilder, utilitiesService, currencyService) {
        var _this = this;
        this.formBuilder = formBuilder;
        this.utilitiesService = utilitiesService;
        this.currencyService = currencyService;
        this.min = 0;
        this.max = 0;
        this.minRange = 0;
        this.maxRange = 0;
        this.maxDirty = false;
        this.minDirty = false;
        this.autoSelectAll = true;
        this.wrapMaxPrice = true;
        this.rangeChange = new __WEBPACK_IMPORTED_MODULE_3__angular_core__["EventEmitter"]();
        this.$rangeChange = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["Subject"]();
        this.displayPostfix = 'Display';
        this.rangeForm = this.formBuilder.group({
            'min': this.min,
            'max': this.max,
            'minDisplay': this.transformPriceRangeDisplay(this.min),
            'maxDisplay': this.transformPriceRangeDisplay(this.max)
        });
        this.$rangeChange
            .asObservable()
            .filter(function (changeItem) { return !!changeItem; })
            .debounceTime(500)
            .subscribe(function (changeItem) {
            _this.rangeChange.emit(changeItem);
        });
        this.onCurrencyChanges();
    }
    SliderRangeComponent.prototype.ngOnChanges = function (changes) {
        if (this.sliderRangeEl) {
            if (changes['minRange'] || changes['maxRange'] || changes['min'] || changes['max']) {
                if (!__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.sliderRangeEl.nativeElement).slider("instance")) {
                    this.initSlider();
                }
                this.transformToDisplay('min', this.min);
                this.transformToDisplay('max', this.max);
                this.updateSlider();
            }
        }
    };
    SliderRangeComponent.prototype.ngOnInit = function () { };
    SliderRangeComponent.prototype.onCurrencyChanges = function () {
        var _this = this;
        this.currencyCode = this.currencyService.getCurrency().currencyCode;
        this.currencySubscription && this.currencySubscription.unsubscribe();
        this.currencySubscription = this.currencyService.getCurrencyObs().subscribe(function (val) {
            _this.currencyCode = val.currencyCode;
            _this.transformToDisplay('min', _this.min);
            _this.transformToDisplay('max', _this.max);
            _this.updateSlider();
        });
    };
    SliderRangeComponent.prototype.ngAfterViewInit = function () {
        this.initSlider();
    };
    SliderRangeComponent.prototype.rangeChanged = function () {
        this.$rangeChange.next({
            min: this.rangeForm.value.min,
            max: this.rangeForm.value.max,
            minDirty: this.minDirty,
            maxDirty: this.maxDirty
        });
    };
    SliderRangeComponent.prototype.isZeroMinMax = function () {
        return this.rangeForm.get('min').value === 0 && this.rangeForm.get('max').value === 0;
    };
    SliderRangeComponent.prototype.onInputFocused = function (fromControlName, ev) {
        this.rangeForm
            .get(fromControlName + this.displayPostfix)
            .setValue(this.rangeForm.get(fromControlName).value);
        this.autoSelectAll && ev && ev.target.select();
    };
    SliderRangeComponent.prototype.onInputBlured = function (fromControlName) {
        var newValue = +this.rangeForm.get(fromControlName + this.displayPostfix).value;
        var oldValue = +this.rangeForm.get(fromControlName).value;
        if (isNaN(+newValue)) {
            newValue = oldValue;
        }
        switch (fromControlName) {
            case 'min':
                newValue = Math.max(newValue, this.minRange);
                newValue = Math.min(newValue, this.maxRange);
                if (+this.rangeForm.value.max < newValue) {
                    this.transformToDisplay('max', newValue);
                }
                break;
            case 'max':
                if (this.wrapMaxPrice) {
                    newValue = Math.min(newValue, this.maxRange);
                    newValue = Math.max(newValue, this.minRange);
                }
                if (+this.rangeForm.value.min > newValue) {
                    this.transformToDisplay('min', newValue);
                }
                break;
        }
        this.transformToDisplay(fromControlName, newValue);
        this.updateSlider();
        if (oldValue !== newValue) {
            this[fromControlName + 'Dirty'] = true;
            this.rangeChanged();
        }
    };
    SliderRangeComponent.prototype.onInputEnter = function (ev) {
        ev.target.blur();
    };
    SliderRangeComponent.prototype.defualtTransform = function (inputVal) {
        return inputVal + '';
    };
    SliderRangeComponent.prototype.validateNumber = function (event) {
        return (/\d/.test(String.fromCharCode(event.which)));
    };
    SliderRangeComponent.prototype.initSlider = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.sliderRangeEl.nativeElement).slider({
            range: true,
            min: this.minRange,
            max: this.maxRange,
            values: [
                this.rangeForm.value.min,
                this.rangeForm.value.max
            ],
            slide: function (event, ui) {
                switch (ui.handleIndex) {
                    case 0:
                        _this.transformToDisplay('min', ui.values[ui.handleIndex]);
                        _this.minDirty = true;
                        break;
                    case 1:
                        _this.transformToDisplay('max', ui.values[ui.handleIndex]);
                        _this.maxDirty = true;
                        break;
                }
                _this.rangeChanged();
            }
        });
    };
    SliderRangeComponent.prototype.updateSlider = function () {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.sliderRangeEl.nativeElement).slider('option', 'max', this.maxRange);
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.sliderRangeEl.nativeElement).slider('option', 'min', this.minRange);
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.sliderRangeEl.nativeElement).slider('values', [this.rangeForm.value.min, this.rangeForm.value.max]);
    };
    SliderRangeComponent.prototype.transformToDisplay = function (fromControlName, newValue) {
        this.rangeForm.get(fromControlName + this.displayPostfix)
            .setValue(this.transformPriceRangeDisplay(newValue));
        this.rangeForm.get(fromControlName)
            .setValue(newValue);
    };
    SliderRangeComponent.prototype.transformPriceRangeDisplay = function (inputVal) {
        if (this.currencyCode) {
            return this.currencyCode + ' ' + inputVal.toLocaleString();
        }
        return this.utilitiesService.getPriceRangeFormatText(inputVal);
    };
    return SliderRangeComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_core__["ViewChild"])('sliderRange'),
    __metadata("design:type", Object)
], SliderRangeComponent.prototype, "sliderRangeEl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_core__["Input"])(),
    __metadata("design:type", Number)
], SliderRangeComponent.prototype, "min", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_core__["Input"])(),
    __metadata("design:type", Number)
], SliderRangeComponent.prototype, "max", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_core__["Input"])(),
    __metadata("design:type", Number)
], SliderRangeComponent.prototype, "minRange", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_core__["Input"])(),
    __metadata("design:type", Number)
], SliderRangeComponent.prototype, "maxRange", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_core__["Input"])(),
    __metadata("design:type", Object)
], SliderRangeComponent.prototype, "maxDirty", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_core__["Input"])(),
    __metadata("design:type", Object)
], SliderRangeComponent.prototype, "minDirty", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_core__["Input"])(),
    __metadata("design:type", Object)
], SliderRangeComponent.prototype, "autoSelectAll", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], SliderRangeComponent.prototype, "wrapMaxPrice", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_core__["Output"])(),
    __metadata("design:type", Object)
], SliderRangeComponent.prototype, "rangeChange", void 0);
SliderRangeComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_core__["Component"])({
        selector: 'act-slider-range',
        template: __webpack_require__(1088),
        styles: [__webpack_require__(953)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__angular_forms__["FormBuilder"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_forms__["FormBuilder"]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_currency_currency_service__["a" /* CurrencyService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_currency_currency_service__["a" /* CurrencyService */]) === "function" && _c || Object])
], SliderRangeComponent);

var _a, _b, _c;
//# sourceMappingURL=slider-range.component.js.map

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_model_rating_rating_title_model__ = __webpack_require__(640);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StarRatingComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var StarRatingComponent = (function () {
    function StarRatingComponent(changeDetectorRef, appConfigService) {
        this.changeDetectorRef = changeDetectorRef;
        this.appConfigService = appConfigService;
        this.readOnly = false;
        this.hover = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.leave = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.rateChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](true);
        this.contexts = [];
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this.rate = 0;
        this.nextRate = 0;
    }
    StarRatingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscriptionLanguage = this.appConfigService.getLanguageObs().subscribe(function (val) {
            _this.prepareData();
            _this.updateRatingDesc(_this.rate);
        });
        this.contexts = Array.from({ length: this.max }, function (context, i) { return ({
            selected: false,
            fraction: false,
            click: function (e) { return _this.handleClick(e, i); },
            enter: function () { return _this.handleEnter(i); }
        }); });
        this.prepareData();
    };
    StarRatingComponent.prototype.ngOnChanges = function (changes) {
        if (changes['rate']) {
            this.update(this.rate);
        }
    };
    StarRatingComponent.prototype.prepareData = function () {
        this.ratingTitle = this.appConfigService.getLanguage() === __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["a" /* Language */].th ? this.data.titleTH : this.data.titleEN;
    };
    StarRatingComponent.prototype.updateRatingDesc = function (val) {
        this.ratingDesc = this.appConfigService.getTranslate('rating-star-' + val);
    };
    StarRatingComponent.prototype.update = function (newRate, internalChange) {
        if (internalChange === void 0) { internalChange = true; }
        if (!this.readOnly && this.rate !== newRate) {
            this.rate = newRate;
            this.rateChange.emit({
                id: this.data.ratingTitleId,
                rate: this.rate
            });
        }
        if (internalChange) {
            this.onChange(this.rate);
            this.onTouched();
        }
        this.updateState(this.rate);
    };
    /** Reset rate value */
    StarRatingComponent.prototype.reset = function () {
        this.leave.emit(this.nextRate);
        this.updateState(this.rate);
    };
    StarRatingComponent.prototype.updateState = function (nextValue) {
        var _this = this;
        /** Set rate value as text */
        this.nextRate = nextValue - 1;
        /** Set the rating */
        this.contexts = Array.from({ length: this.max }, function (context, index) { return ({
            selected: index + 1 <= nextValue,
            fraction: (index + 1 === Math.round(nextValue) && nextValue % 1) >= 0.5,
            click: function (e) { return _this.handleClick(e, index); },
            enter: function () { return _this.handleEnter(index); }
        }); });
        this.updateRatingDesc(nextValue);
    };
    StarRatingComponent.prototype.handleClick = function (e, value) {
        e.preventDefault();
        e.stopPropagation();
        this.update(value + 1);
    };
    StarRatingComponent.prototype.handleEnter = function (index) {
        if (!this.readOnly) {
            /** Add selected class for rating hover */
            this.contexts.map(function (context, i) {
                context.active = i <= index;
                context.fraction = false;
                context.selected = false;
            });
            this.updateRatingDesc(index + 1);
            this.nextRate = index;
            this.hover.emit(index);
        }
    };
    /** This is the initial value set to the component */
    StarRatingComponent.prototype.writeValue = function (value) {
        this.update(value, false);
        this.changeDetectorRef.markForCheck();
    };
    StarRatingComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    StarRatingComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    StarRatingComponent.prototype.ngOnDestroy = function () {
        this.subscriptionLanguage && this.subscriptionLanguage.unsubscribe();
    };
    return StarRatingComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3_app_model_rating_rating_title_model__["a" /* RatingTitleModel */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_model_rating_rating_title_model__["a" /* RatingTitleModel */]) === "function" && _a || Object)
], StarRatingComponent.prototype, "data", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], StarRatingComponent.prototype, "max", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], StarRatingComponent.prototype, "readOnly", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", Object)
], StarRatingComponent.prototype, "hover", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", Object)
], StarRatingComponent.prototype, "leave", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", Object)
], StarRatingComponent.prototype, "rateChange", void 0);
StarRatingComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-star-rating',
        template: __webpack_require__(1089),
        styles: [__webpack_require__(954)]
    }),
    __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _c || Object])
], StarRatingComponent);

var _a, _b, _c;
//# sourceMappingURL=star-rating.component.js.map

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_user_consent_model__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_services_user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_dialog_alert_dialog_alert_component__ = __webpack_require__(45);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubscriptionComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var SubscriptionComponent = (function () {
    function SubscriptionComponent(appConfigService, userService, dialog) {
        this.appConfigService = appConfigService;
        this.userService = userService;
        this.dialog = dialog;
        this.onToggle = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.lang = this.appConfigService.getLanguage();
    }
    SubscriptionComponent.prototype.onTogglePurpose = function (action, purposeId) {
        var _this = this;
        var request = new __WEBPACK_IMPORTED_MODULE_2_app_model_user_consent_model__["e" /* PurposeByUserIdRequest */]();
        request.consentId = this.subscriptionData.consentId;
        request.purposeId = purposeId;
        this.userService.updatePurposeByUserId(this.userService.getUser().userId, action ? 'accept' : 'withdraw', request)
            .subscribe(function () { return true; }, function () {
            try {
                _this.toggleButtonComponent.find(function (f) { return f.name === "purpose-" + purposeId; }).on = !action;
            }
            catch (e) { }
            var dialogAlertRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_5__modal_dialog_alert_dialog_alert_component__["a" /* DialogAlertComponent */]);
            dialogAlertRef.componentInstance.alertText = _this.appConfigService.getTranslate('system-error');
            dialogAlertRef.componentInstance.imageSrc = '/assets/images/icons/icon-failed.png';
            dialogAlertRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-failed.png';
        });
    };
    return SubscriptionComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2_app_model_user_consent_model__["f" /* PurposeByUserIdResponse */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2_app_model_user_consent_model__["f" /* PurposeByUserIdResponse */]) === "function" && _a || Object)
], SubscriptionComponent.prototype, "subscriptionData", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
], SubscriptionComponent.prototype, "onToggle", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChildren"])('toggle'),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["QueryList"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["QueryList"]) === "function" && _c || Object)
], SubscriptionComponent.prototype, "toggleButtonComponent", void 0);
SubscriptionComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-subscription',
        template: __webpack_require__(1090),
        styles: [__webpack_require__(955)]
    }),
    __metadata("design:paramtypes", [typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_4_app_services_user_user_service__["a" /* UserService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4_app_services_user_user_service__["a" /* UserService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MdDialog */]) === "function" && _f || Object])
], SubscriptionComponent);

var _a, _b, _c, _d, _e, _f;
//# sourceMappingURL=subscription.component.js.map

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleButtonComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var ToggleButtonComponent = ToggleButtonComponent_1 = (function () {
    function ToggleButtonComponent() {
        this.toggled = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    ToggleButtonComponent.prototype.writeValue = function (on) {
        this.on = on;
    };
    ToggleButtonComponent.prototype.registerOnChange = function (onChange) {
        this.onChange = onChange;
    };
    ToggleButtonComponent.prototype.registerOnTouched = function (onTouch) {
        this.onTouch = onTouch;
    };
    ToggleButtonComponent.prototype.onClick = function () {
        this.on = !this.on;
        this.toggled.emit(this.on);
        this.onChange && this.onChange(this.on);
    };
    ToggleButtonComponent.prototype.ngOnInit = function () {
    };
    return ToggleButtonComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ToggleButtonComponent.prototype, "on", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ToggleButtonComponent.prototype, "disabledSwitch", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ToggleButtonComponent.prototype, "className", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ToggleButtonComponent.prototype, "name", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], ToggleButtonComponent.prototype, "toggled", void 0);
ToggleButtonComponent = ToggleButtonComponent_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-toggle-button',
        template: __webpack_require__(1092),
        styles: [__webpack_require__(957)],
        providers: [
            {
                provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
                useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return ToggleButtonComponent_1; }),
                multi: true
            }
        ]
    }),
    __metadata("design:paramtypes", [])
], ToggleButtonComponent);

var ToggleButtonComponent_1, _a;
//# sourceMappingURL=toggle-button.component.js.map

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VerifyMethodComponent; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var VerifyMethodComponent = (function () {
    function VerifyMethodComponent() {
        this.isLoading = false;
        this.selectMethod = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.elementId = 'verify-otp-methods';
    }
    VerifyMethodComponent.prototype.ngOnInit = function () {
    };
    VerifyMethodComponent.prototype.onSelectMethod = function (method) {
        this.selectedMethod = this.methods.find(function (o) { return o.method === method; });
        this.selectMethod.emit(this.selectedMethod);
    };
    return VerifyMethodComponent;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], VerifyMethodComponent.prototype, "isLoading", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Array)
], VerifyMethodComponent.prototype, "methods", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], VerifyMethodComponent.prototype, "selectMethod", void 0);
VerifyMethodComponent = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-verify-method',
        template: __webpack_require__(1095),
        styles: [__webpack_require__(960)]
    }),
    __metadata("design:paramtypes", [])
], VerifyMethodComponent);

var _a;
//# sourceMappingURL=verify-method.component.js.map

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImagePreloadDirective; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var ImagePreloadDirective = (function () {
    function ImagePreloadDirective() {
    }
    ImagePreloadDirective.prototype.updateUrl = function () {
        this.src = this.default;
    };
    ImagePreloadDirective.prototype.load = function () {
        this.className = 'image-loaded';
    };
    return ImagePreloadDirective;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ImagePreloadDirective.prototype, "src", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ImagePreloadDirective.prototype, "default", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class'),
    __metadata("design:type", Object)
], ImagePreloadDirective.prototype, "className", void 0);
ImagePreloadDirective = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
        selector: 'img[default]',
        host: {
            '(error)': 'updateUrl()',
            '(load)': 'load()',
            '[src]': 'src'
        }
    })
], ImagePreloadDirective);

//# sourceMappingURL=image-preload.directive.js.map

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__image_preload_directive__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(29);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImagePreloadModule; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var ImagePreloadModule = (function () {
    function ImagePreloadModule() {
    }
    return ImagePreloadModule;
}());
ImagePreloadModule = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
        imports: [__WEBPACK_IMPORTED_MODULE_2__angular_common__["a" /* CommonModule */]],
        declarations: [__WEBPACK_IMPORTED_MODULE_1__image_preload_directive__["a" /* ImagePreloadDirective */]],
        exports: [__WEBPACK_IMPORTED_MODULE_1__image_preload_directive__["a" /* ImagePreloadDirective */]]
    })
], ImagePreloadModule);

//# sourceMappingURL=image-preload.module.js.map

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnMaskDirective; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var UnMaskDirective = (function () {
    function UnMaskDirective(elementRef, model) {
        this.elementRef = elementRef;
        this.model = model;
    }
    UnMaskDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.subscriber = this.model.control.valueChanges.subscribe(function () {
            var newValue = _this.elementRef.nativeElement.value.replace(new RegExp(_this.unmask), '');
            _this.model.control.setValue(newValue, {
                emitEvent: false,
                emitModelToViewChange: false,
                emitViewToModelChange: false
            });
        });
    };
    UnMaskDirective.prototype.ngOnDestroy = function () {
        this.subscriber && this.subscriber.unsubscribe();
    };
    return UnMaskDirective;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('UnMask'),
    __metadata("design:type", String)
], UnMaskDirective.prototype, "unmask", void 0);
UnMaskDirective = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
        // tslint:disable-next-line:directive-selector
        selector: '[UnMask]'
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NgControl"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NgControl"]) === "function" && _b || Object])
], UnMaskDirective);

var _a, _b;
//# sourceMappingURL=un-mask.directive.js.map

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vendors_datepicker_custom_js__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vendors_datepicker_custom_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__vendors_datepicker_custom_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__translation_lang_en__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__translation_lang_th__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_model_constant__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DaterangepickerDirective; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var DaterangepickerDirective = (function () {
    function DaterangepickerDirective(elementRef, appConfigService, utilitiesService) {
        this.elementRef = elementRef;
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
        this.isFirst = true;
        this.ignoreLimit = true;
        this.allowSameDate = false;
        this.canSelectPastDate = false;
        this.haveDefaultDate = true;
        this.opens = 'right';
        this.subscription = null;
        this.suggestionData = '';
        this.actionSelectItem = false;
        this.hasSelectedAll = false;
        this.searchData = { 'hotel': {} };
        this.hotelDestinationTitle = new __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__["Subject"]();
    }
    DaterangepickerDirective.prototype.ngOnInit = function () {
    };
    DaterangepickerDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Get Translate
        var translate = function (value) {
            switch (_this.appConfigService.getLanguage()) {
                case __WEBPACK_IMPORTED_MODULE_10_app_model_constant__["a" /* Language */].th:
                    return __WEBPACK_IMPORTED_MODULE_9__translation_lang_th__["a" /* LANG_TH_TRANS */][value];
                case __WEBPACK_IMPORTED_MODULE_10_app_model_constant__["a" /* Language */].en:
                    return __WEBPACK_IMPORTED_MODULE_8__translation_lang_en__["a" /* LANG_EN_TRANS */][value];
            }
        };
        var locale = {
            daysOfWeek: {
                th: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
                en: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
            },
            monthNames: {
                th: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
                en: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
            }
        };
        var _self = this;
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()(function () {
            var $element = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(_self.elementRef.nativeElement);
            var $iconElem = undefined;
            var $picker = undefined;
            var $syncElem = undefined;
            var $pickerMask = undefined;
            var $syncMask = undefined;
            var vm = {
                displayFormatDate: 'dd DD MMM YYYY',
                valueFormatDate: 'YYYY-MM-DD',
                defaultStartDate: _self.haveDefaultDate ? (_self.defaultStartDate ? __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__(_self.defaultStartDate, 'YYYY-MM-DD') : __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__()) : undefined,
                defaultEndDate: _self.haveDefaultDate ? (_self.defaultEndDate ? __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__(_self.defaultEndDate, 'YYYY-MM-DD') : __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__().add(1, 'days')) : undefined,
                pickerId: _self.id,
                syncId: _self.syncToId,
                label: translate(_self.label),
                isStartElement: _self.isFirst,
                ignoreLimit: _self.ignoreLimit,
                allowSameDate: _self.allowSameDate,
                name: _self.name,
                section: _self.section,
                hiddenField: _self.id + '_submit',
                hiddenSyncField: _self.syncToId + '_submit',
                selectState: { CHECKIN: 'SELECT_CHECKIN', CHECKOUT: 'SELECT_CHECKOUT' },
                opens: _self.opens
            };
            function pickerInstance() {
                return $pickerMask.data('daterangepicker');
            }
            function syncInstance() {
                if ($syncMask) {
                    return $syncMask.data('daterangepicker');
                }
                else {
                    return false;
                }
            }
            function getRangeDate() {
                return {
                    startDate: pickerInstance().startDate,
                    endDate: pickerInstance().endDate
                };
            }
            function logDateRange() {
                var data = getRangeDate();
                var logDate = { startDate: data.startDate.format(vm.displayFormatDate), endDate: data.endDate.format(vm.displayFormatDate) };
            }
            /*********************************
             * update date
             ******************************** */
            function updateDisplayDate(isDefault) {
                if (isDefault === void 0) { isDefault = false; }
                var rangeDate = getRangeDate();
                var selfDate = vm.isStartElement ? rangeDate.startDate.clone() : rangeDate.endDate.clone();
                var syncDate = vm.isStartElement ? rangeDate.endDate.clone() : rangeDate.startDate.clone();
                // update self input
                var lang = _self.appConfigService.getLanguage();
                var selfDateOutput = _self.utilitiesService.getOtaFormatYear(lang, selfDate);
                $picker.val(selfDateOutput);
                __WEBPACK_IMPORTED_MODULE_2_jquery___default()('input[name=' + vm.hiddenField + ']').val(selfDateOutput);
                // update sync input
                if (!isDefault) {
                    var syncDateOutput = _self.utilitiesService.getOtaFormatYear(lang, syncDate);
                    $syncElem.val(syncDateOutput);
                    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('input[name=' + vm.hiddenSyncField + ']').val(syncDateOutput);
                }
                logDateRange();
            }
            function getCustomPosition() {
                var selfOffset = $element.offset();
                var syncOffset = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#" + vm.syncId).offset();
                return {
                    top: 0,
                    left: vm.isStartElement ? 0 : Math.abs(syncOffset.left - (selfOffset.left)),
                };
            }
            function createDateRangePicker() {
                var template = '<input type="text" class="ota-picker-mask" id="' + vm.pickerId + '-mask" />';
                var hiddenField = '<input type="hidden" name="' + vm.hiddenField + '" />';
                // let icon = '<i class="fa fa-calendar calendar-'+ vm.pickerId +'"></i>';
                var icon = '<i class="calendar-icon calendar-' + vm.pickerId + '"></i>';
                var _lang = _self.appConfigService.getLanguage();
                var $parentElem = $element.parent();
                var minDate = _self.canSelectPastDate ? __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__('2016-01-01') : __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__();
                var options = {
                    "id": vm.pickerId,
                    "showDropdowns": false,
                    "autoApply": true,
                    "showCustomRangeLabel": false,
                    "startDate": vm.defaultStartDate,
                    "endDate": vm.defaultEndDate,
                    "minDate": minDate,
                    "maxDate": vm.name === 'checkInDate' ? __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__().add(1, 'year').subtract(1, 'day') : __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__().add(1, 'year'),
                    "pickerLabel": vm.label,
                    "isFirstComponent": vm.isStartElement,
                    "locale": {
                        "daysOfWeek": locale.daysOfWeek[_lang],
                        "monthNames": locale.monthNames[_lang],
                    },
                    "allowSameDate": vm.allowSameDate,
                    "customHandler": onDatePickerEventHandler,
                    "customPosition": getCustomPosition(),
                    "lang": _lang,
                    "opens": vm.opens
                };
                /*
                if (!vm.ignoreLimit) {
                    options = angular.extend(options, { "dateLimit": { "days": 30 }});
                }
                */
                $picker = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#" + vm.pickerId);
                $pickerMask = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(template);
                $parentElem.append(icon);
                $parentElem.append(hiddenField);
                $parentElem.append($pickerMask);
                $iconElem = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.calendar-' + vm.pickerId);
                checkStartDateEndDate();
                $pickerMask.daterangepicker(options);
                if (vm.defaultStartDate || vm.defaultEndDate) {
                    updateDisplayDate(true);
                }
            }
            function setSelectionToPickerWithState(state, isSetAllComponent) {
                pickerInstance().setSelectionState(state);
                if (isSetAllComponent) {
                    syncInstance().setSelectionState(state);
                }
            }
            function focusEndDatePicker(data) {
                if (vm.isStartElement) {
                    pickerInstance().hide();
                    if (!(pickerInstance().getStartDate().format('DD MM YYYY') === __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__().add(1, 'year').subtract(1, 'day').format('DD MM YYYY'))) {
                        syncInstance().show();
                    }
                    setSelectionToPickerWithState(vm.selectState.CHECKOUT, true);
                    // set disable date
                    syncInstance().setMinDate(data.startDate.clone());
                    syncInstance().setMaxDate(false);
                    syncInstance().updateView();
                }
            }
            function checkStartDateEndDate() {
                if (vm.defaultStartDate && !vm.defaultStartDate.isValid()) {
                    vm.defaultStartDate = __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__();
                }
                if ((vm.defaultEndDate && !vm.defaultEndDate.isValid()) ||
                    (vm.defaultStartDate && vm.defaultEndDate && vm.defaultStartDate.isSame(vm.defaultEndDate))) {
                    vm.defaultEndDate = vm.allowSameDate ? vm.defaultStartDate : vm.defaultEndDate.add(1, 'days');
                }
            }
            function onSetStartDateComplete(data) {
                focusEndDatePicker(data);
            }
            function onSetEndDateComplete(data) {
                setSelectionToPickerWithState(vm.selectState.CHECKIN, true);
            }
            function onSetBothDateComplete(data) {
                focusEndDatePicker(data);
            }
            function updateSyncPicker() {
                var rangeDate = getRangeDate();
                syncInstance().setStartDate(rangeDate.startDate);
                syncInstance().setEndDate(rangeDate.endDate);
                syncInstance().updateView();
            }
            function syncToScope() {
                var rangeDate = getRangeDate();
                switch (vm.section) {
                    case 'searchProduct':
                        _self.searchData.hotel.dateFrom = rangeDate.startDate.format(vm.valueFormatDate);
                        _self.searchData.hotel.dateTo = rangeDate.endDate.format(vm.valueFormatDate);
                        break;
                    case 'searchMyBooking':
                    case 'exportBookingReport':
                        _self.formControlFrom.setValue(rangeDate.startDate.format(vm.valueFormatDate));
                        _self.formControlTo.setValue(rangeDate.endDate.format(vm.valueFormatDate));
                }
            }
            function onPickerChange() {
                updateDisplayDate();
                updateSyncPicker();
                syncToScope();
            }
            function onDatePickerEventHandler(type, data) {
                switch (type) {
                    case 'SET_START_DATE_COMPLETE':
                        onSetStartDateComplete(data);
                        break;
                    case 'SET_END_DATE_COMPLETE':
                        onSetEndDateComplete(data);
                        break;
                    case 'SET_BOTH_DATE_COMPLETE':
                        onSetBothDateComplete(data);
                        break;
                    default: break;
                }
                onPickerChange();
                var logDate = { startDate: data.startDate.format(vm.displayFormatDate), endDate: data.endDate.format(vm.displayFormatDate) };
            }
            function onElementClick() {
                if (syncInstance() && syncInstance().isPickerShowing()) {
                    syncInstance().toggle();
                }
                pickerInstance().toggle();
            }
            function registerEvent() {
                var _eventFire = 'click';
                if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
                    _eventFire = 'touchend';
                }
                $element.on(_eventFire, onElementClick);
                $iconElem.on(_eventFire, onElementClick);
                // $pickerMask.on('change.daterangepicker', onPickerChange);
            }
            function initSyncPicker() {
                $syncElem = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#" + vm.syncId);
                $syncMask = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#" + vm.syncId + "-mask");
                if (vm.isStartElement) {
                    syncInstance().setMinDate(syncInstance().startDate);
                }
            }
            function initialize() {
                createDateRangePicker();
                registerEvent();
                setTimeout(initSyncPicker, 100);
            }
            setTimeout(initialize);
            // change lang
            _self.appConfigService.getLanguageObs().subscribe(function (lang) {
                $pickerMask.data('daterangepicker').setLocale(translate(_self.label), locale.daysOfWeek[lang], locale.monthNames[lang], lang);
                updateDisplayDate();
            });
        }); // end jquery function call
    };
    DaterangepickerDirective.prototype.ngOnDestroy = function () {
    };
    return DaterangepickerDirective;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('daterangepicker'),
    __metadata("design:type", Object)
], DaterangepickerDirective.prototype, "state", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('formControlFrom'),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_5__angular_forms__["FormControl"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__angular_forms__["FormControl"]) === "function" && _a || Object)
], DaterangepickerDirective.prototype, "formControlFrom", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('formControlTo'),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_5__angular_forms__["FormControl"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__angular_forms__["FormControl"]) === "function" && _b || Object)
], DaterangepickerDirective.prototype, "formControlTo", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], DaterangepickerDirective.prototype, "defaultStartDate", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], DaterangepickerDirective.prototype, "defaultEndDate", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], DaterangepickerDirective.prototype, "id", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], DaterangepickerDirective.prototype, "syncToId", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], DaterangepickerDirective.prototype, "label", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], DaterangepickerDirective.prototype, "isFirst", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], DaterangepickerDirective.prototype, "ignoreLimit", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], DaterangepickerDirective.prototype, "allowSameDate", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], DaterangepickerDirective.prototype, "name", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], DaterangepickerDirective.prototype, "section", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], DaterangepickerDirective.prototype, "canSelectPastDate", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], DaterangepickerDirective.prototype, "haveDefaultDate", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], DaterangepickerDirective.prototype, "opens", void 0);
DaterangepickerDirective = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
        selector: '[daterangepicker]'
    }),
    __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _e || Object])
], DaterangepickerDirective);

var _a, _b, _c, _d, _e;
//# sourceMappingURL=daterangepicker.directive.js.map

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vendors_typeahead_jquery_js__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vendors_typeahead_jquery_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__vendors_typeahead_jquery_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_forms__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_services_search_search_service__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__translation_lang_en__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__translation_lang_th__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_constant__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_environments_properties__ = __webpack_require__(21);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TypeaheadDirective; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};













var TypeaheadDirective = (function () {
    function TypeaheadDirective(elementRef, appConfigService, searchService, googleTagManagerService) {
        this.elementRef = elementRef;
        this.appConfigService = appConfigService;
        this.searchService = searchService;
        this.googleTagManagerService = googleTagManagerService;
        this.onSelectedItem = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this._objective = 'work';
        this.suggestionData = '';
        this.actionSelectItem = false;
        this.hasSelectedAll = false;
        this.searchData = { 'hotel': {} };
        this.suggestionResData = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
    }
    Object.defineProperty(TypeaheadDirective.prototype, "objective", {
        set: function (objective) {
            if (objective) {
                this._objective = objective;
            }
        },
        enumerable: true,
        configurable: true
    });
    TypeaheadDirective.prototype.ngOnInit = function () {
    };
    TypeaheadDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Get Translate
        var translate = function (value) {
            switch (_this.appConfigService.getLanguage()) {
                case __WEBPACK_IMPORTED_MODULE_11__model_constant__["a" /* Language */].th:
                    return __WEBPACK_IMPORTED_MODULE_10__translation_lang_th__["a" /* LANG_TH_TRANS */][value];
                case __WEBPACK_IMPORTED_MODULE_11__model_constant__["a" /* Language */].en:
                    return __WEBPACK_IMPORTED_MODULE_9__translation_lang_en__["a" /* LANG_EN_TRANS */][value];
            }
        };
        // Call typeahead library to Generate Component.
        // typeahead ------------------------------------------------------------------------------------
        var _self = this;
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()(function () {
            var $element = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(_self.elementRef.nativeElement);
            var selected = [];
            var typeaheadConfig = { timeInitial: 500, instantiated: false };
            var historyConfig = { key: __WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__["a" /* AppConfigService */].localStorageSearchHistoryName, limit: 7 };
            var searchHistory;
            var countSuggestion = 0;
            $element.on('click', function ($event) {
                if (!_self.hasSelectedAll) {
                    _self.hasSelectedAll = true;
                    try {
                        // IOs, Safari, throws exception on Chrome etc
                        this.selectionStart = 0;
                        this.selectionEnd = this.value.length + 1;
                    }
                    catch (err) {
                        // Non IOs option if not supported, e.g. Chrome
                        this.select();
                    }
                }
            });
            // On blur reset hasSelectedAll to allow full select
            $element.on('blur', function ($event) {
                _self.hasSelectedAll = false;
            });
            $element.blur(function (e) {
                // if (!_self.dataSelected) {
                //   $(this).closest('.twitter-typeahead').find('.tt-suggestion:first-child').trigger('click');
                // }
            });
            // Watch
            _self.formSubRef = _self.formControl.valueChanges.subscribe(function (newValue) {
                if (newValue && _self.actionSelectItem === false) {
                    $element.typeahead('val', newValue);
                    $element.value = newValue;
                    $element.closest('.twitter-typeahead').find('.tt-suggestion:first-child').trigger('click');
                    _self.dataSelected = true;
                }
                else if (newValue == '') {
                    $element.typeahead('val', newValue);
                    $element.value = newValue;
                }
            });
            searchHistory = {
                load: function () {
                    var currentLang = _self.appConfigService.getLanguage();
                    var history;
                    try {
                        history = localStorage.getItem(historyConfig.key);
                        if (history == null) {
                            localStorage.setItem(historyConfig.key, JSON.stringify([]));
                        }
                        else {
                            history = JSON.parse(history);
                        }
                    }
                    catch (err) {
                        history = __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"](historyConfig.key);
                        if (history == null) {
                            __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](historyConfig.key, JSON.stringify([]), { domain: __WEBPACK_IMPORTED_MODULE_12_environments_properties__["e" /* domain */] });
                        }
                        else {
                            history = JSON.parse(history);
                        }
                    }
                    return history || [];
                },
                sorting: function (data, histories) {
                    // remove history existing and increase sorting number
                    histories = histories.filter(function (item) {
                        if (data.id != item.id) {
                            return Object.assign(item, { sortNumber: ++item.sortNumber });
                        }
                    });
                    data.type = 'history';
                    histories.push(Object.assign(data, { sortNumber: 0 })); // add latest history
                    // sorted by sortNumber
                    histories.sort(function (a, b) {
                        return a.sortNumber - b.sortNumber;
                    });
                    return histories;
                },
                update: function (data) {
                    var currentLang = _self.appConfigService.getLanguage();
                    var histories = this.sorting(data, this.load()); // load => add => sort
                    // remove overflow history
                    histories = histories.filter(function (item, index) {
                        if (index < historyConfig.limit) {
                            return item;
                        }
                    });
                    // save data
                    try {
                        localStorage.setItem(historyConfig.key, JSON.stringify(histories));
                    }
                    catch (err) {
                        __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"](historyConfig.key, JSON.stringify(histories), { domain: __WEBPACK_IMPORTED_MODULE_12_environments_properties__["e" /* domain */] });
                    }
                }
            };
            var selectItem = function (e, datum, dataset) {
                _self.dataSelected = true;
                _self.actionSelectItem = true;
                var type = datum.type;
                if (datum.suggestCat != __WEBPACK_IMPORTED_MODULE_11__model_constant__["y" /* SuggestionCategory */].NEAR_BY) {
                    searchHistory.update(datum);
                }
                else {
                    _self.actionSelectItem = false;
                }
                _self.valueControls.patchValue({
                    id: datum.id,
                    title: datum.suggestCat != __WEBPACK_IMPORTED_MODULE_11__model_constant__["y" /* SuggestionCategory */].NEAR_BY ? datum.title : _self.appConfigService.getTranslate('search-box-near-by-you'),
                    suggestCat: datum.suggestCat,
                    slug: datum.slug,
                    poi: datum.suggestCat === __WEBPACK_IMPORTED_MODULE_11__model_constant__["y" /* SuggestionCategory */].POINT_OF_INTEREST ? datum.poi : null,
                    destinationId: datum.destinationId,
                    destinationTitle: datum.destinationTitle,
                    type: type,
                });
                _self.actionSelectItem = true;
                _self.onSelectedItem.emit({ data: datum });
                $element.blur();
            };
            var fetchDataTimer;
            var dataCountry = function (q, sync, async) {
                // Call API
                clearTimeout(fetchDataTimer);
                fetchDataTimer = setTimeout(function () {
                    if (_self.valueControls.value.suggestCat != __WEBPACK_IMPORTED_MODULE_11__model_constant__["y" /* SuggestionCategory */].NEAR_BY) {
                        if (q.length > 0) {
                            countSuggestion = 0;
                            if (_self.getSearchSuggestionRef) {
                                _self.getSearchSuggestionRef.unsubscribe();
                            }
                            var req = {
                                str: q,
                                lang: _self.appConfigService.getLanguageId(),
                                lat: __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__["a" /* AppConfigService */].lat) !== undefined ? __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__["a" /* AppConfigService */].lat) : null,
                                lon: __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__["a" /* AppConfigService */].lon) !== undefined ? __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__["a" /* AppConfigService */].lon) : null,
                                companyId: JSON.parse(decodeURIComponent(window.atob(__WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"](__WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__["a" /* AppConfigService */].userInfoCookieName)))).companyId,
                                objective: _self._objective
                            };
                            _self.getSearchSuggestionRef = _self.searchService.getSearchSuggestion(req).subscribe(function (data) {
                                _self.googleTagManagerService.emitEvent('Search Suggestion', 'Search', q, data.length || 0);
                                _self.suggestionResData.next(data);
                            });
                        }
                    }
                }, 500);
                if (_self.suggestionResDataCountryRef) {
                    _self.suggestionResDataCountryRef.unsubscribe();
                }
                _self.suggestionResDataCountryRef = _self.suggestionResData.asObservable().subscribe(function (data) {
                    var filterData = [];
                    data.forEach(function (obj) {
                        obj.type = 'suggestion';
                        filterData.push(obj);
                    });
                    async(filterData);
                });
            };
            var historyWithDefaults = function (q, sync, async) {
                if (q === '') {
                    countSuggestion = 0;
                    _self.suggestionResDataCountryRef ? _self.suggestionResDataCountryRef.unsubscribe() : '';
                    var currentHistory = searchHistory.load();
                    sync(currentHistory);
                }
            };
            var nearBy = function (q, sync, async) {
                if (q === '') {
                    countSuggestion = 0;
                    _self.suggestionResDataCountryRef ? _self.suggestionResDataCountryRef.unsubscribe() : '';
                    var nearby = [];
                    nearby.push({
                        "id": null,
                        "lang": _self.appConfigService.getLanguageId(),
                        "slug": "",
                        "suggestCat": "nearby",
                        "title": _self.appConfigService.getLanguageId() == '2' ? "ค้นหาจากตำแหน่งของคุณ" : "Nearby location",
                        "destinationTitle": "",
                        "countryTitle": "",
                        "sortNumber": 0,
                        "type": 'nearby',
                    });
                    sync(nearby);
                }
            };
            var suggestionTemplate = function (data) {
                if (_self.suggestionData === '' || _self.suggestionData._query != data._query) {
                    _self.suggestionData = data;
                }
                var idSuggestion = 'item-suggestion-' + countSuggestion++;
                var dataCount = data.count > 0 ? true : false;
                var dataTitle = data.title ? data.title : '-';
                var destination = data.destinationTitle ? data.destinationTitle : '';
                var country = data.countryTitle ? data.countryTitle : '';
                var ic = '';
                var sub = '';
                switch (data.suggestCat) {
                    case 'product':
                        ic = 'hotel';
                        sub = destination + ', ' + country;
                        break;
                    case 'pointofinterest':
                        ic = 'poi';
                        destination ? sub = destination + ', ' + country : sub = country;
                        break;
                    case 'nearby':
                        ic = 'nearby';
                        break;
                    default:
                        ic = 'pin';
                        sub = country;
                        break;
                }
                // set icon
                var icon = '<div class="suggestion-icon"><i class="recent-suggest-icon icon-' + ic + '"></i></div>';
                // set content
                var title = '<div class="suggestion-title">' + dataTitle + '</div>';
                var subtitle = '<div class="suggestion-subtitle">' + sub + '</div>';
                var content = '<div class="suggestion-content' + (!dataCount ? ' full' : '') + '">' + title + subtitle + '</div>';
                // set count destination
                var countDest = dataCount ? '<div class="suggestion-count">' + data.count + ' ' + translate('search-box-props') + '</div>' : '';
                return '<div id="' + idSuggestion + '">' + icon + content + countDest + '</div>';
            };
            setTimeout(function () {
                $element.typeahead({
                    highlight: true,
                    hint: false,
                    minLength: 0,
                    order: 'asc',
                    limit: 'Infinity',
                }, {
                    name: 'product',
                    displayKey: 'title',
                    source: dataCountry,
                    limit: 8,
                    templates: {
                        // header: '<p class="tt-dataset tt-header">' + translate('search-box-result-search') + '</p>',
                        suggestion: suggestionTemplate
                    }
                }, {
                    name: 'nearby',
                    displayKey: 'title',
                    source: nearBy,
                    templates: {
                        suggestion: suggestionTemplate
                    }
                }, {
                    name: 'history',
                    displayKey: 'title',
                    source: historyWithDefaults,
                    limit: 8,
                    templates: {
                        header: '<p class="tt-dataset tt-header">' + translate('search-box-recent-searches') + '</p>',
                        suggestion: suggestionTemplate
                    }
                }).bind('typeahead:selected', selectItem);
                typeaheadConfig.instantiated = true;
            }, typeaheadConfig.timeInitial);
            // Detection Change Language.
            _self.langSubRef = _self.appConfigService.getLanguageObs().subscribe(function (lang) {
                $element.typeahead('destroy');
                $element.typeahead({
                    highlight: true,
                    hint: false,
                    minLength: 0,
                    order: 'asc',
                    limit: 'Infinity',
                }, {
                    name: 'product',
                    displayKey: 'title',
                    source: dataCountry,
                    limit: 8,
                    templates: {
                        header: '<p class="tt-dataset tt-header">' + translate('search-box-result-search') + '</p>',
                        suggestion: suggestionTemplate
                    }
                }, {
                    name: 'nearby',
                    displayKey: 'title',
                    source: nearBy,
                    templates: {
                        suggestion: suggestionTemplate
                    }
                }, {
                    name: 'history',
                    displayKey: 'title',
                    source: historyWithDefaults,
                    limit: 8,
                    templates: {
                        header: '<p class="tt-dataset tt-header">' + translate('search-box-recent-searches') + '</p>',
                        suggestion: suggestionTemplate
                    }
                }).bind('typeahead:selected', selectItem);
            });
            // end typeahead ------------------------------------------------------------------------------------
        });
    };
    TypeaheadDirective.prototype.ngOnDestroy = function () {
        // UnSubscribe ALL.
        this.getSearchSuggestionRef ? this.getSearchSuggestionRef.unsubscribe() : '';
        this.suggestionResDataCountryRef ? this.suggestionResDataCountryRef.unsubscribe() : '';
        this.formSubRef ? this.formSubRef.unsubscribe() : '';
        this.langSubRef ? this.langSubRef.unsubscribe() : '';
    };
    return TypeaheadDirective;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('typeahead'),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_6__angular_forms__["FormControl"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6__angular_forms__["FormControl"]) === "function" && _a || Object)
], TypeaheadDirective.prototype, "formControl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('valueControls'),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_6__angular_forms__["FormControl"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6__angular_forms__["FormControl"]) === "function" && _b || Object)
], TypeaheadDirective.prototype, "valueControls", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])('onSelectedItem'),
    __metadata("design:type", Object)
], TypeaheadDirective.prototype, "onSelectedItem", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], TypeaheadDirective.prototype, "objective", null);
TypeaheadDirective = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({
        selector: '[typeahead]'
    }),
    __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_8_app_services_search_search_service__["b" /* SearchService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8_app_services_search_search_service__["b" /* SearchService */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__["a" /* GoogleTagManagerService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__services_analytics_google_tag_manager_service__["a" /* GoogleTagManagerService */]) === "function" && _f || Object])
], TypeaheadDirective);

var _a, _b, _c, _d, _e, _f;
//# sourceMappingURL=typeahead.directive.js.map

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typeahead_directive__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(29);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TypeaheadModule; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var TypeaheadModule = (function () {
    function TypeaheadModule() {
    }
    return TypeaheadModule;
}());
TypeaheadModule = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
        imports: [__WEBPACK_IMPORTED_MODULE_2__angular_common__["a" /* CommonModule */]],
        declarations: [__WEBPACK_IMPORTED_MODULE_1__typeahead_directive__["a" /* TypeaheadDirective */]],
        exports: [__WEBPACK_IMPORTED_MODULE_1__typeahead_directive__["a" /* TypeaheadDirective */]]
    })
], TypeaheadModule);

//# sourceMappingURL=typeahead.module.js.map

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BookingApprovalDetailModel */
/* unused harmony export BookerInformation */
/* unused harmony export CreditCardInformation */
/* unused harmony export TrueMoneyInformation */
/* unused harmony export CreditTermsInformation */
/* unused harmony export FleetInformation */
/* unused harmony export CancellationCharge */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentInformation; });
/* unused harmony export PaymentInformationBooker */
/* unused harmony export BookingApproval */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BookingCancellationCharge; });
/* unused harmony export TravellerInformation */
/* unused harmony export Traveller */
/* unused harmony export CheckoutField */
/* unused harmony export Approval */
var BookingApprovalDetailModel = (function () {
    function BookingApprovalDetailModel() {
    }
    return BookingApprovalDetailModel;
}());

var BookerInformation = (function () {
    function BookerInformation() {
    }
    return BookerInformation;
}());

var CreditCardInformation = (function () {
    function CreditCardInformation() {
    }
    return CreditCardInformation;
}());

var TrueMoneyInformation = (function () {
    function TrueMoneyInformation() {
    }
    return TrueMoneyInformation;
}());

var CreditTermsInformation = (function () {
    function CreditTermsInformation() {
    }
    return CreditTermsInformation;
}());

var FleetInformation = (function () {
    function FleetInformation() {
    }
    return FleetInformation;
}());

var CancellationCharge = (function () {
    function CancellationCharge() {
    }
    return CancellationCharge;
}());

var PaymentInformation = (function () {
    function PaymentInformation() {
    }
    return PaymentInformation;
}());

var PaymentInformationBooker = (function () {
    function PaymentInformationBooker() {
    }
    return PaymentInformationBooker;
}());

var BookingApproval = (function () {
    function BookingApproval() {
    }
    return BookingApproval;
}());

var BookingCancellationCharge = (function () {
    function BookingCancellationCharge() {
    }
    return BookingCancellationCharge;
}());

var TravellerInformation = (function () {
    function TravellerInformation() {
    }
    return TravellerInformation;
}());

var Traveller = (function () {
    function Traveller() {
    }
    return Traveller;
}());

var CheckoutField = (function () {
    function CheckoutField() {
    }
    return CheckoutField;
}());

var Approval = (function () {
    function Approval() {
    }
    return Approval;
}());

//# sourceMappingURL=approval-detail-model.js.map

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApprovalStatusModel; });
var ApprovalStatusModel = (function () {
    function ApprovalStatusModel() {
    }
    return ApprovalStatusModel;
}());

//# sourceMappingURL=approval-status.js.map

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Billing; });
var Billing = (function () {
    function Billing() {
        this.isDefault = false;
        this.billingName = '';
        this.billingPhone = '';
        this.billingAddress = '';
    }
    return Billing;
}());

//# sourceMappingURL=billing.model.js.map

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BookingDetailModel */
/* unused harmony export CompanyModel */
/* unused harmony export BookingProductItemsModel */
/* unused harmony export CancellationConditionDetail */
/* unused harmony export GuestDetailModel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DisplayBookingDetailDTO; });
var BookingDetailModel = (function () {
    function BookingDetailModel() {
    }
    return BookingDetailModel;
}());

var CompanyModel = (function () {
    function CompanyModel() {
    }
    return CompanyModel;
}());

var BookingProductItemsModel = (function () {
    function BookingProductItemsModel() {
    }
    return BookingProductItemsModel;
}());

var CancellationConditionDetail = (function () {
    function CancellationConditionDetail() {
    }
    return CancellationConditionDetail;
}());

var GuestDetailModel = (function () {
    function GuestDetailModel() {
    }
    return GuestDetailModel;
}());

var DisplayBookingDetailDTO = (function () {
    function DisplayBookingDetailDTO() {
    }
    return DisplayBookingDetailDTO;
}());

//# sourceMappingURL=booking-detail-model.js.map

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookingStatusModel; });
/* unused harmony export BookingStatusV2Model */
var BookingStatusModel = (function () {
    function BookingStatusModel(orderStatus, paymentStatus, bookingStatus, cancelStatus) {
        this.orderStatus = orderStatus;
        this.paymentStatus = paymentStatus;
        this.bookingStatus = bookingStatus;
        this.cancelStatus = cancelStatus;
    }
    return BookingStatusModel;
}());

var BookingStatusV2Model = (function () {
    function BookingStatusV2Model(status) {
        this.status = status;
    }
    return BookingStatusV2Model;
}());

//# sourceMappingURL=booking-status-model.js.map

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_model_feature_allow_feature_model__ = __webpack_require__(132);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttachFileFeature; });
/* unused harmony export AttachFileLabel */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AttachFileFeature = (function (_super) {
    __extends(AttachFileFeature, _super);
    function AttachFileFeature(featureData) {
        if (featureData === void 0) { featureData = undefined; }
        var _this = this;
        var isRequired = featureData && featureData.required === 'true';
        var isDiaplayed = featureData && featureData.display === 'true';
        _this = _super.call(this, !!isRequired, !!isDiaplayed) || this;
        return _this;
    }
    return AttachFileFeature;
}(__WEBPACK_IMPORTED_MODULE_0_app_model_feature_allow_feature_model__["a" /* AllowFeature */]));

var AttachFileLabel = (function () {
    function AttachFileLabel(label) {
        if (label === void 0) { label = undefined; }
        this.en = label && label.en;
        this.th = label && label.th;
    }
    return AttachFileLabel;
}());

//# sourceMappingURL=attach-file-feature.model.js.map

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_model_feature_allow_feature_model__ = __webpack_require__(132);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BillingAddressFeature; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var BillingAddressFeature = (function (_super) {
    __extends(BillingAddressFeature, _super);
    function BillingAddressFeature(featureData) {
        if (featureData === void 0) { featureData = undefined; }
        var _this = this;
        var isRequired = featureData && featureData.required === 'true';
        var isDiaplayed = featureData && featureData.display === 'true';
        _this = _super.call(this, !!isRequired, !!isDiaplayed) || this;
        return _this;
    }
    return BillingAddressFeature;
}(__WEBPACK_IMPORTED_MODULE_0_app_model_feature_allow_feature_model__["a" /* AllowFeature */]));

//# sourceMappingURL=billing-address-feature.model.js.map

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_model_feature_allow_feature_model__ = __webpack_require__(132);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CostCenterFeature; });
/* unused harmony export labelLanguage */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var CostCenterFeature = (function (_super) {
    __extends(CostCenterFeature, _super);
    function CostCenterFeature(featureData) {
        if (featureData === void 0) { featureData = undefined; }
        var _this = this;
        var isRequired = featureData && featureData.required === 'true';
        var isDisplayed = featureData && featureData.display === 'true';
        _this = _super.call(this, isRequired, isDisplayed) || this;
        _this.getTaxAddressByAPI = featureData && featureData.getTaxAddressByAPI === 'true';
        _this.displayTaxAddressByDropdown = featureData && featureData.displayTaxAddressByDropdown === 'true';
        _this.label = featureData && featureData.label ? featureData.label : null;
        if (isDisplayed) {
            _this.costCenter = featureData.defaultCode && featureData.defaultCode.trim();
            _this.costCenterName = featureData.defaultName && featureData.defaultName.trim();
            _this.defaultAddress = featureData.defaultAddress;
        }
        return _this;
    }
    return CostCenterFeature;
}(__WEBPACK_IMPORTED_MODULE_0_app_model_feature_allow_feature_model__["a" /* AllowFeature */]));

var labelLanguage = (function () {
    function labelLanguage() {
    }
    return labelLanguage;
}());

//# sourceMappingURL=cost-center-feature.model.js.map

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_model_feature_allow_feature_model__ = __webpack_require__(132);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InternalOrderFeature; });
/* unused harmony export InternalOrderLabel */
/* unused harmony export InternalOrderPlaceholder */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var InternalOrderFeature = (function (_super) {
    __extends(InternalOrderFeature, _super);
    function InternalOrderFeature(featureData) {
        if (featureData === void 0) { featureData = undefined; }
        var _this = this;
        var required = (featureData || { required: undefined }).required;
        var display = (featureData || { display: undefined }).display;
        var label = (featureData || { label: undefined }).label;
        var placeholder = (featureData || { placeholder: undefined }).placeholder;
        var isDisplayed = display === 'false' ? false : true;
        var isRequired = required === 'true' ? true : false;
        _this = _super.call(this, isRequired, isDisplayed) || this;
        if (isDisplayed) {
            _this.label = new InternalOrderLabel(label);
            _this.placeholder = new InternalOrderPlaceholder(placeholder);
        }
        return _this;
    }
    return InternalOrderFeature;
}(__WEBPACK_IMPORTED_MODULE_0_app_model_feature_allow_feature_model__["a" /* AllowFeature */]));

var InternalOrderLabel = (function () {
    function InternalOrderLabel(label) {
        if (label === void 0) { label = undefined; }
        this.en = label && label.en;
        this.th = label && label.th;
    }
    return InternalOrderLabel;
}());

var InternalOrderPlaceholder = (function () {
    function InternalOrderPlaceholder(placeholder) {
        if (placeholder === void 0) { placeholder = undefined; }
        this.en = placeholder && placeholder.en;
        this.th = placeholder && placeholder.th;
    }
    return InternalOrderPlaceholder;
}());

//# sourceMappingURL=internal-order-feature.model.js.map

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Quotation */
/* unused harmony export QuotationResponse */
/* unused harmony export GalleryItem */
/* unused harmony export GalleryContent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GalleryList; });
var Quotation = (function () {
    function Quotation() {
    }
    return Quotation;
}());

var QuotationResponse = (function () {
    function QuotationResponse() {
    }
    return QuotationResponse;
}());

var GalleryItem = (function () {
    function GalleryItem() {
    }
    return GalleryItem;
}());

var GalleryContent = (function () {
    function GalleryContent() {
    }
    return GalleryContent;
}());

var GalleryList = (function () {
    function GalleryList() {
        this.data = [];
    }
    return GalleryList;
}());

//# sourceMappingURL=mice.model.js.map

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SetupPINRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SetupPINResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VerifyPINRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PINRequest; });
var SetupPINRequest = (function () {
    function SetupPINRequest(pin, verifiedToken) {
        this.pin = pin;
        this.verifiedToken = verifiedToken;
    }
    return SetupPINRequest;
}());

var SetupPINResponse = (function () {
    function SetupPINResponse(res) {
        if (res.text()) {
            var data = res.json().data;
            this.status = data.status;
            this.verification = data.verification;
        }
    }
    return SetupPINResponse;
}());

var VerifyPINRequest = (function () {
    function VerifyPINRequest(pin, verifiedToken) {
        this.pin = pin;
    }
    return VerifyPINRequest;
}());

var PINRequest = (function () {
    function PINRequest(pin, token) {
        this.pin = pin;
        this.token = token;
    }
    return PINRequest;
}());

//# sourceMappingURL=pin.model.js.map

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductListModel; });
var ProductListModel = (function () {
    function ProductListModel(productItem) {
        if (productItem === void 0) { productItem = undefined; }
        if (productItem) {
            this.address = productItem.address;
            this.allotment = productItem.allotment;
            this.countrySlug = productItem.countrySlug;
            this.countryTitle = productItem.countryTitle;
            this.currencyCode = productItem.currencyCode;
            this.currencyId = productItem.currencyId;
            this.destinationSlug = productItem.destinationSlug;
            this.destinationTitle = productItem.destinationTitle;
            this.image = productItem.image;
            this.latitude = productItem.latitude;
            this.longitude = productItem.longitude;
            this.netPrice = productItem.netPrice;
            this.notices = productItem.notices;
            this.payOn = productItem.payOn;
            this.lastDayCancel = productItem.lastDayCancel;
            this.pointPriority = productItem.pointPriority;
            this.productCategorySlug = productItem.productCategorySlug;
            this.productId = productItem.productId;
            this.productTitle = productItem.productTitle;
            this.rating = productItem.rating;
            this.ratingUser = productItem.ratingUser;
            this.recommend = productItem.recommend;
            this.reviewCount = productItem.reviewCount;
            this.reviewRating = productItem.reviewRating;
            this.slug = productItem.slug;
            this.totalPrice = productItem.totalPrice;
            this.distance = productItem.distance;
            this.overPrice = productItem.overPrice;
        }
    }
    return ProductListModel;
}());

//# sourceMappingURL=product-list.model.js.map

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductNearByDTO; });
var ProductNearByDTO = (function () {
    function ProductNearByDTO() {
    }
    return ProductNearByDTO;
}());

//# sourceMappingURL=product-nearby-dto.model.js.map

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RatingTitleModel; });
var RatingTitleModel = (function () {
    function RatingTitleModel() {
    }
    return RatingTitleModel;
}());

//# sourceMappingURL=rating-title-model.js.map

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VerifyUserExistModel; });
/* unused harmony export CompanyList */
var VerifyUserExistModel = (function () {
    function VerifyUserExistModel() {
    }
    return VerifyUserExistModel;
}());

var CompanyList = (function () {
    function CompanyList() {
    }
    return CompanyList;
}());

//# sourceMappingURL=verify-user-exist-model.js.map

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_not_found_page_not_found_component__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_guard_extra_guard__ = __webpack_require__(267);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageNotFoundModuleRoutingModule; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var routes = [{
        path: '**',
        component: __WEBPACK_IMPORTED_MODULE_2__page_not_found_page_not_found_component__["a" /* PageNotFoundComponent */],
        canActivate: [__WEBPACK_IMPORTED_MODULE_3__services_guard_extra_guard__["a" /* ExtraGuard */]]
    }];
var PageNotFoundModuleRoutingModule = (function () {
    function PageNotFoundModuleRoutingModule() {
    }
    return PageNotFoundModuleRoutingModule;
}());
PageNotFoundModuleRoutingModule = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
        imports: [__WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* RouterModule */].forChild(routes)],
        exports: [__WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* RouterModule */]]
    })
], PageNotFoundModuleRoutingModule);

//# sourceMappingURL=page-not-found-module-routing.module.js.map

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_not_found_module_routing_module__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_not_found_page_not_found_component__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_components_module__ = __webpack_require__(217);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageNotFoundModule; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var PageNotFoundModule = (function () {
    function PageNotFoundModule() {
    }
    return PageNotFoundModule;
}());
PageNotFoundModule = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
        imports: [
            __WEBPACK_IMPORTED_MODULE_1__angular_common__["a" /* CommonModule */],
            __WEBPACK_IMPORTED_MODULE_4_app_components_components_module__["a" /* ComponentsModule */],
            __WEBPACK_IMPORTED_MODULE_2__page_not_found_module_routing_module__["a" /* PageNotFoundModuleRoutingModule */]
        ],
        declarations: [__WEBPACK_IMPORTED_MODULE_3__page_not_found_page_not_found_component__["a" /* PageNotFoundComponent */]]
    })
], PageNotFoundModule);

//# sourceMappingURL=page-not-found-module.module.js.map

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActDatePipe; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var ActDatePipe = (function () {
    function ActDatePipe(appConfigService, utilitiesService) {
        this.appConfigService = appConfigService;
        this.utilitiesService = utilitiesService;
    }
    ActDatePipe.prototype.transform = function (value, inputFormat) {
        var lang = this.appConfigService.getLanguage();
        var invalidValue = [undefined, null].indexOf(value) > -1;
        if (inputFormat && !invalidValue) {
            value = __WEBPACK_IMPORTED_MODULE_3_vendors_moment_locale_th__(value, inputFormat).format('YYYY-MM-DD');
        }
        var dateResult = !invalidValue ? this.utilitiesService.getOtaFormatYear(lang, value) : 'DD MM YYYY';
        // console.log(`value:${value} result:${dateResult}`);
        return dateResult;
    };
    return ActDatePipe;
}());
ActDatePipe = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
        name: 'actDate',
        pure: false
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _b || Object])
], ActDatePipe);

var _a, _b;
//# sourceMappingURL=act-date.pipe.js.map

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommaCurrencyPipe; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var CommaCurrencyPipe = (function () {
    function CommaCurrencyPipe(utilitiesService) {
        this.utilitiesService = utilitiesService;
    }
    CommaCurrencyPipe.prototype.transform = function (value, args) {
        return this.utilitiesService.commaSeparateNumber(value);
    };
    return CommaCurrencyPipe;
}());
CommaCurrencyPipe = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
        name: 'commaCurrency'
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _a || Object])
], CommaCurrencyPipe);

var _a;
//# sourceMappingURL=comma-currency.pipe.js.map

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_model_constant__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FullyearPipe; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var FullyearPipe = (function () {
    function FullyearPipe(appConfigService) {
        this.appConfigService = appConfigService;
    }
    FullyearPipe.prototype.transform = function (value, args) {
        var lang = this.appConfigService.getLanguage();
        switch (lang) {
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["a" /* Language */].th:
                return parseInt(value) + 543;
            case __WEBPACK_IMPORTED_MODULE_2_app_model_constant__["a" /* Language */].en:
                return value;
        }
    };
    return FullyearPipe;
}());
FullyearPipe = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
        name: 'fullyear',
        pure: false
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1_app_services_app_config_app_config_service__["a" /* AppConfigService */]) === "function" && _a || Object])
], FullyearPipe);

var _a;
//# sourceMappingURL=fullyear.pipe.js.map

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReplaceLineBreaksPipe; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var ReplaceLineBreaksPipe = (function () {
    function ReplaceLineBreaksPipe() {
    }
    ReplaceLineBreaksPipe.prototype.transform = function (value) {
        return value && value.replace(/\n/g, '<br/>');
    };
    return ReplaceLineBreaksPipe;
}());
ReplaceLineBreaksPipe = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({ name: 'replaceLineBreaks' })
], ReplaceLineBreaksPipe);

//# sourceMappingURL=replaceLineBreaks.pipe.js.map

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SplitJoinPipe; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var SplitJoinPipe = (function () {
    function SplitJoinPipe() {
    }
    SplitJoinPipe.prototype.transform = function (value, join) {
        return value.toString().replace(/\d{4}(?=.)/g, "$&" + join);
    };
    return SplitJoinPipe;
}());
SplitJoinPipe = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
        name: 'splitJoin'
    })
], SplitJoinPipe);

//# sourceMappingURL=split-join.pipe.js.map

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductDetailPayload; });
var ProductDetailPayload = (function () {
    function ProductDetailPayload(productId, lang) {
        this.productId = productId;
        this.lang = lang;
    }
    return ProductDetailPayload;
}());

//# sourceMappingURL=product-detail.payload.js.map

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchSuggestionPayload; });
var SearchSuggestionPayload = (function () {
    function SearchSuggestionPayload() {
    }
    return SearchSuggestionPayload;
}());

//# sourceMappingURL=search-suggestion-payload.js.map

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__act_http_act_http_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__affiliate_affiliate_service__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_config_app_config_service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_services_approval_approval_service__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__guard_authentication_guard__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_authentication_service__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__guard_authorization_guard__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__banner_banner_service__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__booking_booking_service__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cart_cart_service__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__checkout_checkout_service__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__angular_common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__guard_extra_guard__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__products_product_service__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rating_rating_service__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__search_search_service__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__user_feature_user_feature_service__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__user_user_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utilities_utilities_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__warning_warning_service__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__confirmationSupplier_supplier_confirmation_service__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__promotion_promotion_service__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mice_mice_service__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__checkout_guest_info_service__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__thankyou_thankyou_service__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__budget_budget_service__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__authorize_authorize_service__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__fleet_fleet_service__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_app_services_notice_notice_service__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__analytics_google_tag_manager_service__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__currency_currency_service__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pin_pin_service__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__encrypt_encrypt_service__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__guard_language_currency_guard__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__guard_page_guard__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__guard_app_deep_link_guard__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__promotion_code_promotion_code_service__ = __webpack_require__(240);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServicesModule; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






































var ServicesModule = (function () {
    function ServicesModule() {
    }
    return ServicesModule;
}());
ServicesModule = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__angular_core__["NgModule"])({
        imports: [
            __WEBPACK_IMPORTED_MODULE_11__angular_common__["a" /* CommonModule */]
        ],
        declarations: [],
        providers: [
            __WEBPACK_IMPORTED_MODULE_18__user_user_service__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_19__utilities_utilities_service__["a" /* UtilitiesService */],
            __WEBPACK_IMPORTED_MODULE_2__app_config_app_config_service__["a" /* AppConfigService */],
            __WEBPACK_IMPORTED_MODULE_4__guard_authentication_guard__["a" /* AuthenticationGuard */],
            __WEBPACK_IMPORTED_MODULE_6__guard_authorization_guard__["a" /* AuthorizationGuard */],
            __WEBPACK_IMPORTED_MODULE_12__guard_extra_guard__["a" /* ExtraGuard */],
            __WEBPACK_IMPORTED_MODULE_34__guard_language_currency_guard__["a" /* LanguageCurrencyGuard */],
            __WEBPACK_IMPORTED_MODULE_0__act_http_act_http_service__["c" /* ActHttpService */],
            __WEBPACK_IMPORTED_MODULE_16__search_search_service__["b" /* SearchService */],
            __WEBPACK_IMPORTED_MODULE_8__booking_booking_service__["a" /* BookingService */],
            __WEBPACK_IMPORTED_MODULE_5__authentication_authentication_service__["a" /* AuthenticationService */],
            __WEBPACK_IMPORTED_MODULE_14__products_product_service__["a" /* ProductService */],
            __WEBPACK_IMPORTED_MODULE_9__cart_cart_service__["a" /* CartService */],
            __WEBPACK_IMPORTED_MODULE_10__checkout_checkout_service__["a" /* CheckoutService */],
            __WEBPACK_IMPORTED_MODULE_1__affiliate_affiliate_service__["a" /* AffiliateService */],
            __WEBPACK_IMPORTED_MODULE_20__warning_warning_service__["a" /* WarningService */],
            __WEBPACK_IMPORTED_MODULE_17__user_feature_user_feature_service__["a" /* UserFeatureService */],
            __WEBPACK_IMPORTED_MODULE_3_app_services_approval_approval_service__["a" /* ApprovalService */],
            __WEBPACK_IMPORTED_MODULE_15__rating_rating_service__["a" /* RatingService */],
            __WEBPACK_IMPORTED_MODULE_7__banner_banner_service__["a" /* BannerService */],
            __WEBPACK_IMPORTED_MODULE_21__confirmationSupplier_supplier_confirmation_service__["a" /* SupplierConfirmationService */],
            __WEBPACK_IMPORTED_MODULE_22__promotion_promotion_service__["a" /* PromotionService */],
            __WEBPACK_IMPORTED_MODULE_23__mice_mice_service__["a" /* MiceService */],
            __WEBPACK_IMPORTED_MODULE_24__checkout_guest_info_service__["a" /* GuestInfoService */],
            __WEBPACK_IMPORTED_MODULE_25__thankyou_thankyou_service__["a" /* ThankyouService */],
            __WEBPACK_IMPORTED_MODULE_26__budget_budget_service__["a" /* BudgetService */],
            __WEBPACK_IMPORTED_MODULE_27__authorize_authorize_service__["a" /* AuthorizeService */],
            __WEBPACK_IMPORTED_MODULE_28__fleet_fleet_service__["a" /* FleetService */],
            __WEBPACK_IMPORTED_MODULE_29_app_services_notice_notice_service__["b" /* NoticeService */],
            __WEBPACK_IMPORTED_MODULE_30__analytics_google_tag_manager_service__["a" /* GoogleTagManagerService */],
            __WEBPACK_IMPORTED_MODULE_31__currency_currency_service__["a" /* CurrencyService */],
            __WEBPACK_IMPORTED_MODULE_32__pin_pin_service__["a" /* PinService */],
            __WEBPACK_IMPORTED_MODULE_33__encrypt_encrypt_service__["a" /* EncryptService */],
            __WEBPACK_IMPORTED_MODULE_35__guard_page_guard__["a" /* PageGuard */],
            __WEBPACK_IMPORTED_MODULE_36__guard_app_deep_link_guard__["a" /* AppDeepLinkGuard */],
            __WEBPACK_IMPORTED_MODULE_37__promotion_code_promotion_code_service__["a" /* PromotionCodeService */],
        ]
    })
], ServicesModule);

//# sourceMappingURL=services.module.js.map

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginPayload; });
var LoginPayload = (function () {
    function LoginPayload() {
    }
    return LoginPayload;
}());

//# sourceMappingURL=login.payload.js.map

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegisterPayload; });
var RegisterPayload = (function () {
    function RegisterPayload(username, timestamp, appId, companyId) {
        if (companyId === void 0) { companyId = undefined; }
        this.username = username;
        this.timestamp = timestamp;
        companyId && (this.companyId = companyId);
        this.clientId = appId;
    }
    return RegisterPayload;
}());

//# sourceMappingURL=register-payload.js.map

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VerifyCompanyDomainPayload; });
/* unused harmony export VerifyCompanyDomainResponse */
var VerifyCompanyDomainPayload = (function () {
    function VerifyCompanyDomainPayload() {
    }
    return VerifyCompanyDomainPayload;
}());

var VerifyCompanyDomainResponse = (function () {
    function VerifyCompanyDomainResponse() {
    }
    return VerifyCompanyDomainResponse;
}());

//# sourceMappingURL=verify-company-domain.payload.js.map

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_maps_api_loader_lazy_maps_api_loader__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_circle__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_info_marker__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_info_window__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_map__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_marker__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_pop_over__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_browser_globals__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_maps_api_loader_maps_api_loader__ = __webpack_require__(106);
/* unused harmony export coreDirectives */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActMapModule; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











function coreDirectives() {
    return [
        __WEBPACK_IMPORTED_MODULE_5__directives_map__["a" /* ActMap */], __WEBPACK_IMPORTED_MODULE_6__directives_marker__["a" /* ActMarker */],
        __WEBPACK_IMPORTED_MODULE_4__directives_info_window__["a" /* ActInfoWindow */], __WEBPACK_IMPORTED_MODULE_3__directives_info_marker__["a" /* ActInfoMarker */],
        __WEBPACK_IMPORTED_MODULE_2__directives_circle__["a" /* ActCircle */],
        __WEBPACK_IMPORTED_MODULE_7__directives_pop_over__["a" /* ActPopOver */]
    ];
}
var ActMapModule = ActMapModule_1 = (function () {
    function ActMapModule() {
    }
    ActMapModule.forRoot = function (lazyMapsAPILoaderConfig) {
        return {
            ngModule: ActMapModule_1,
            providers: __WEBPACK_IMPORTED_MODULE_8__utils_browser_globals__["a" /* BROWSER_GLOBALS_PROVIDERS */].concat([
                { provide: __WEBPACK_IMPORTED_MODULE_9__services_maps_api_loader_maps_api_loader__["a" /* MapsAPILoader */], useClass: __WEBPACK_IMPORTED_MODULE_0__services_maps_api_loader_lazy_maps_api_loader__["a" /* LazyMapsAPILoader */] },
                { provide: __WEBPACK_IMPORTED_MODULE_0__services_maps_api_loader_lazy_maps_api_loader__["b" /* LAZY_MAPS_API_CONFIG */], useValue: lazyMapsAPILoaderConfig }
            ]),
        };
    };
    return ActMapModule;
}());
ActMapModule = ActMapModule_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({ declarations: coreDirectives(), exports: coreDirectives() })
], ActMapModule);

var ActMapModule_1;
//# sourceMappingURL=act-map.module.js.map

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_managers_circle_manager__ = __webpack_require__(272);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActCircle; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


// tslint:disable
var ActCircle = ActCircle_1 = (function () {
    function ActCircle(_manager) {
        this._manager = _manager;
        /**
         * Indicates whether this Circle handles mouse events. Defaults to true.
         */
        this.clickable = true;
        /**
         * If set to true, the user can drag this circle over the map. Defaults to false.
         */
        // tslint:disable-next-line:no-input-rename
        this.draggable = false;
        /**
         * If set to true, the user can edit this circle by dragging the control points shown at
         * the center and around the circumference of the circle. Defaults to false.
         */
        this.editable = false;
        /**
         * The radius in meters on the Earth's surface.
         */
        this.radius = 0;
        /**
         * The stroke width in pixels.
         */
        this.strokeWeight = 0;
        /**
         * Whether this circle is visible on the map. Defaults to true.
         */
        this.visible = true;
        /**
         * This event is fired when the circle's center is changed.
         */
        this.centerChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * This event emitter gets emitted when the user clicks on the circle.
         */
        this.circleClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * This event emitter gets emitted when the user clicks on the circle.
         */
        this.circleDblClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * This event is repeatedly fired while the user drags the circle.
         */
        this.drag = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * This event is fired when the user stops dragging the circle.
         */
        this.dragEnd = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * This event is fired when the user starts dragging the circle.
         */
        this.dragStart = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * This event is fired when the DOM mousedown event is fired on the circle.
         */
        this.mouseDown = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * This event is fired when the DOM mousemove event is fired on the circle.
         */
        this.mouseMove = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * This event is fired on circle mouseout.
         */
        this.mouseOut = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * This event is fired on circle mouseover.
         */
        this.mouseOver = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * This event is fired when the DOM mouseup event is fired on the circle.
         */
        this.mouseUp = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * This event is fired when the circle's radius is changed.
         */
        this.radiusChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * This event is fired when the circle is right-clicked on.
         */
        this.rightClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.strokePosition = 0; // 'CENTER'|'INSIDE'|'OUTSIDE'
        this._circleAddedToManager = false;
        this._eventSubscriptions = [];
    }
    /** @internal */
    ActCircle.prototype.ngOnInit = function () {
        this._manager.addCircle(this);
        this._circleAddedToManager = true;
        this._registerEventListeners();
    };
    /** @internal */
    ActCircle.prototype.ngOnChanges = function (changes) {
        if (!this._circleAddedToManager) {
            return;
        }
        if (changes['latitude'] || changes['longitude']) {
            this._manager.setCenter(this);
        }
        if (changes['editable']) {
            this._manager.setEditable(this);
        }
        if (changes['draggable']) {
            this._manager.setDraggable(this);
        }
        if (changes['visible']) {
            this._manager.setVisible(this);
        }
        if (changes['radius']) {
            this._manager.setRadius(this);
        }
        this._updateCircleOptionsChanges(changes);
    };
    ActCircle.prototype._updateCircleOptionsChanges = function (changes) {
        var options = {};
        var optionKeys = Object.keys(changes).filter(function (k) { return ActCircle_1._mapOptions.indexOf(k) !== -1; });
        optionKeys.forEach(function (k) { options[k] = changes[k].currentValue; });
        if (optionKeys.length > 0) {
            this._manager.setOptions(this, options);
        }
    };
    ActCircle.prototype._registerEventListeners = function () {
        var _this = this;
        var events = new Map();
        events.set('center_changed', this.centerChange);
        events.set('click', this.circleClick);
        events.set('dblclick', this.circleDblClick);
        events.set('drag', this.drag);
        events.set('dragend', this.dragEnd);
        events.set('dragStart', this.dragStart);
        events.set('mousedown', this.mouseDown);
        events.set('mousemove', this.mouseMove);
        events.set('mouseout', this.mouseOut);
        events.set('mouseover', this.mouseOver);
        events.set('mouseup', this.mouseUp);
        events.set('radius_changed', this.radiusChange);
        events.set('rightclick', this.rightClick);
        events.forEach(function (eventEmitter, eventName) {
            _this._eventSubscriptions.push(_this._manager.createEventObservable(eventName, _this).subscribe(function (value) {
                switch (eventName) {
                    case 'radius_changed':
                        _this._manager.getRadius(_this).then(function (radius) { return eventEmitter.emit(radius); });
                        break;
                    case 'center_changed':
                        _this._manager.getCenter(_this).then(function (center) {
                            return eventEmitter.emit({ lat: center.lat(), lng: center.lng() });
                        });
                        break;
                    default:
                        eventEmitter.emit({ coords: { lat: value.latLng.lat(), lng: value.latLng.lng() } });
                }
            }));
        });
    };
    /** @internal */
    ActCircle.prototype.ngOnDestroy = function () {
        this._eventSubscriptions.forEach(function (s) { s.unsubscribe(); });
        this._eventSubscriptions = null;
        this._manager.removeCircle(this);
    };
    /**
     * Gets the LatLngBounds of this Circle.
     */
    ActCircle.prototype.getBounds = function () { return this._manager.getBounds(this); };
    ActCircle.prototype.getCenter = function () { return this._manager.getCenter(this); };
    return ActCircle;
}());
ActCircle._mapOptions = [
    'fillColor', 'fillOpacity', 'strokeColor', 'strokeOpacity', 'strokePosition', 'strokeWeight',
    'visible', 'zIndex', 'clickable'
];
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActCircle.prototype, "latitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActCircle.prototype, "longitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActCircle.prototype, "clickable", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('circleDraggable'),
    __metadata("design:type", Boolean)
], ActCircle.prototype, "draggable", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActCircle.prototype, "editable", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActCircle.prototype, "fillColor", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActCircle.prototype, "fillOpacity", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActCircle.prototype, "radius", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActCircle.prototype, "strokeColor", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActCircle.prototype, "strokeOpacity", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActCircle.prototype, "strokeWeight", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActCircle.prototype, "visible", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActCircle.prototype, "zIndex", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], ActCircle.prototype, "centerChange", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
], ActCircle.prototype, "circleClick", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
], ActCircle.prototype, "circleDblClick", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _d || Object)
], ActCircle.prototype, "drag", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _e || Object)
], ActCircle.prototype, "dragEnd", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _f || Object)
], ActCircle.prototype, "dragStart", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _g || Object)
], ActCircle.prototype, "mouseDown", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _h || Object)
], ActCircle.prototype, "mouseMove", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _j || Object)
], ActCircle.prototype, "mouseOut", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_k = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _k || Object)
], ActCircle.prototype, "mouseOver", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_l = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _l || Object)
], ActCircle.prototype, "mouseUp", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_m = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _m || Object)
], ActCircle.prototype, "radiusChange", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_o = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _o || Object)
], ActCircle.prototype, "rightClick", void 0);
ActCircle = ActCircle_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
        selector: 'act-circle'
    }),
    __metadata("design:paramtypes", [typeof (_p = typeof __WEBPACK_IMPORTED_MODULE_1__services_managers_circle_manager__["a" /* CircleManager */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__services_managers_circle_manager__["a" /* CircleManager */]) === "function" && _p || Object])
], ActCircle);

var ActCircle_1, _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
//# sourceMappingURL=circle.js.map

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_managers_circle_manager__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_google_maps_api_wrapper__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_managers_info_marker_manager__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_managers_info_window_manager__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_managers_marker_manager__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__ = __webpack_require__(8);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActMap; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







// tslint:disable
var ActMap = ActMap_1 = (function () {
    function ActMap(_elem, _mapsWrapper, utilitiesService) {
        this._elem = _elem;
        this._mapsWrapper = _mapsWrapper;
        this.utilitiesService = utilitiesService;
        this.longitude = 0;
        this.latitude = 0;
        this.zoom = 8;
        this.draggable = true;
        this.disableDoubleClickZoom = false;
        this.disableDefaultUI = false;
        this.scrollwheel = true;
        this.keyboardShortcuts = true;
        this.zoomControl = true;
        // @Input() zoomControlOptions: ZoomControlOptions;
        this.styles = [];
        this.usePanning = false;
        this.streetViewControl = false;
        // @Input() streetViewControlOptions: StreetViewControlOptions;
        this.fitBounds = null;
        this.scaleControl = false;
        // @Input() scaleControlOptions: ScaleControlOptions;
        this.mapTypeControl = false;
        // @Input() mapTypeControlOptions: MapTypeControlOptions;
        this.panControl = false;
        // @Input() panControlOptions: PanControlOptions;
        this.rotateControl = false;
        // @Input() rotateControlOptions: RotateControlOptions;
        this.fullscreenControl = false;
        // @Input() fullscreenControlOptions: FullscreenControlOptions;
        this.mapTypeId = 'roadmap';
        this.clickableIcons = true;
        this.resetCenter = false;
        /**
         * This setting controls how gestures on the map are handled.
         * Allowed values:
         * - 'cooperative' (Two-finger touch gestures pan and zoom the map. One-finger touch gestures are not handled by the map.)
         * - 'greedy'      (All touch gestures pan or zoom the map.)
         * - 'none'        (The map cannot be panned or zoomed by user gestures.)
         * - 'auto'        [default] (Gesture handling is either cooperative or greedy, depending on whether the page is scrollable or not.
         */
        this.gestureHandling = 'auto';
        this._observableSubscriptions = [];
        this.mapClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.mapRightClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.mapDblClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.centerChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.boundsChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.mapTypeIdChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.idle = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.zoomChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.mapReady = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    /** @internal */
    ActMap.prototype.ngOnInit = function () {
        // todo: this should be solved with a new component and a viewChild decorator
        var container = this._elem.nativeElement.querySelector('.act-map-container-inner');
        this._initMapInstance(container);
    };
    ActMap.prototype._initMapInstance = function (el) {
        var _this = this;
        this._mapsWrapper.createMap(el, {
            center: { lat: this.latitude || 0, lng: this.longitude || 0 },
            zoom: this.zoom,
            minZoom: this.minZoom,
            maxZoom: this.maxZoom,
            disableDefaultUI: this.disableDefaultUI,
            disableDoubleClickZoom: this.disableDoubleClickZoom,
            scrollwheel: this.scrollwheel,
            backgroundColor: this.backgroundColor,
            draggable: this.draggable,
            draggableCursor: this.draggableCursor,
            draggingCursor: this.draggingCursor,
            keyboardShortcuts: this.keyboardShortcuts,
            styles: this.styles,
            zoomControl: this.zoomControl,
            // zoomControlOptions: this.zoomControlOptions,
            streetViewControl: this.streetViewControl,
            // streetViewControlOptions: this.streetViewControlOptions,
            scaleControl: this.scaleControl,
            // scaleControlOptions: this.scaleControlOptions,
            mapTypeControl: this.mapTypeControl,
            // mapTypeControlOptions: this.mapTypeControlOptions,
            panControl: this.panControl,
            // panControlOptions: this.panControlOptions,
            rotateControl: this.rotateControl,
            // rotateControlOptions: this.rotateControlOptions,
            fullscreenControl: this.fullscreenControl,
            // fullscreenControlOptions: this.fullscreenControlOptions,
            mapTypeId: this.mapTypeId,
            clickableIcons: this.clickableIcons,
            gestureHandling: this.gestureHandling
        })
            .then(function () { return _this._mapsWrapper.getNativeMap(); })
            .then(function (map) { return _this.mapReady.emit(map); });
        // register event listeners
        // this._handleMapCenterChange();
        this._handleMapZoomChange();
        this._handleMapMouseEvents();
        this._handleBoundsChange();
        this._handleMapTypeIdChange();
        this._handleIdleEvent();
    };
    /** @internal */
    ActMap.prototype.ngOnDestroy = function () {
        // unsubscribe all registered observable subscriptions
        this._observableSubscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /* @internal */
    ActMap.prototype.ngOnChanges = function (changes) {
        if (this.utilitiesService.isMobile()) {
            this.zoomControl = false;
        }
        this._updateMapOptionsChanges(changes);
        this._updatePosition(changes);
    };
    ActMap.prototype._updateMapOptionsChanges = function (changes) {
        var options = {};
        var optionKeys = Object.keys(changes).filter(function (k) { return ActMap_1._mapOptionsAttributes.indexOf(k) !== -1; });
        optionKeys.forEach(function (k) { options[k] = changes[k].currentValue; });
        this._mapsWrapper.setMapOptions(options);
    };
    /**
     * Triggers a resize event on the google map instance.
     * When recenter is true, the of the google map gets called with the current lat/lng values or fitBounds value to recenter the map.
     * Returns a promise that gets resolved after the event was triggered.
     */
    ActMap.prototype.triggerResize = function (recenter) {
        var _this = this;
        if (recenter === void 0) { recenter = true; }
        // Note: When we would trigger the resize event and show the map in the same turn (which is a
        // common case for triggering a resize event), then the resize event would not
        // work (to show the map), so we trigger the event in a timeout.
        return new Promise(function (resolve) {
            setTimeout(function () {
                return _this._mapsWrapper.triggerMapEvent('resize').then(function () {
                    if (recenter) {
                        _this.fitBounds != null ? _this._fitBounds() : _this._setCenter();
                    }
                    resolve();
                });
            });
        });
    };
    ActMap.prototype._updatePosition = function (changes) {
        if (changes['resetCenter']) {
            this._setCenter();
            return;
        }
        if (changes['latitude'] == null && changes['longitude'] == null &&
            changes['fitBounds'] == null) {
            // no position update needed
            return;
        }
        // we prefer fitBounds in changes
        if (changes['fitBounds'] && this.fitBounds != null) {
            this._fitBounds();
            return;
        }
        if (typeof this.latitude !== 'number' || typeof this.longitude !== 'number') {
            return;
        }
        this._setCenter();
    };
    ActMap.prototype._setCenter = function () {
        var newCenter = {
            lat: this.latitude,
            lng: this.longitude,
        };
        if (this.usePanning) {
            this._mapsWrapper.panTo(newCenter);
        }
        else {
            this._mapsWrapper.setCenter(newCenter);
        }
    };
    ActMap.prototype._fitBounds = function () {
        if (this.usePanning) {
            this._mapsWrapper.panToBounds(this.fitBounds);
            return;
        }
        this._mapsWrapper.fitBounds(this.fitBounds);
    };
    ActMap.prototype._handleMapCenterChange = function () {
        var _this = this;
        var s = this._mapsWrapper.subscribeToMapEvent('center_changed').subscribe(function () {
            _this._mapsWrapper.getCenter().then(function (center) {
                _this.latitude = center.lat();
                _this.longitude = center.lng();
                _this.centerChange.emit({ lat: _this.latitude, lng: _this.longitude });
            });
        });
        this._observableSubscriptions.push(s);
    };
    ActMap.prototype._handleBoundsChange = function () {
        var _this = this;
        var s = this._mapsWrapper.subscribeToMapEvent('bounds_changed').subscribe(function () {
            _this._mapsWrapper.getBounds().then(function (bounds) { _this.boundsChange.emit(bounds); });
        });
        this._observableSubscriptions.push(s);
    };
    ActMap.prototype._handleMapTypeIdChange = function () {
        var _this = this;
        var s = this._mapsWrapper.subscribeToMapEvent('maptypeid_changed').subscribe(function () {
            _this._mapsWrapper.getMapTypeId().then(function (mapTypeId) { _this.mapTypeIdChange.emit(mapTypeId); });
        });
        this._observableSubscriptions.push(s);
    };
    ActMap.prototype._handleMapZoomChange = function () {
        var _this = this;
        var s = this._mapsWrapper.subscribeToMapEvent('zoom_changed').subscribe(function () {
            _this._mapsWrapper.getZoom().then(function (z) {
                _this.zoom = z;
                _this.zoomChange.emit(z);
            });
        });
        this._observableSubscriptions.push(s);
    };
    ActMap.prototype._handleIdleEvent = function () {
        var _this = this;
        var s = this._mapsWrapper.subscribeToMapEvent('idle').subscribe(function () { _this.idle.emit(void 0); });
        this._observableSubscriptions.push(s);
    };
    ActMap.prototype._handleMapMouseEvents = function () {
        var _this = this;
        var events = [
            { name: 'click', emitter: this.mapClick },
            { name: 'rightclick', emitter: this.mapRightClick },
            { name: 'dblclick', emitter: this.mapDblClick },
        ];
        events.forEach(function (e) {
            var s = _this._mapsWrapper.subscribeToMapEvent(e.name).subscribe(function (event) {
                var value = { coords: { lat: event.latLng.lat(), lng: event.latLng.lng() } };
                e.emitter.emit(value);
            });
            _this._observableSubscriptions.push(s);
        });
    };
    return ActMap;
}());
/**
 * Map option attributes that can change over time
 */
ActMap._mapOptionsAttributes = [
    'disableDoubleClickZoom', 'scrollwheel', 'draggable', 'draggableCursor', 'draggingCursor',
    'keyboardShortcuts', 'zoomControl', 'zoomControlOptions', 'styles', 'streetViewControl',
    'streetViewControlOptions', 'zoom', 'mapTypeControl', 'mapTypeControlOptions', 'minZoom',
    'maxZoom', 'panControl', 'panControlOptions', 'rotateControl', 'rotateControlOptions',
    'fullscreenControl', 'fullscreenControlOptions', 'scaleControl', 'scaleControlOptions',
    'mapTypeId', 'clickableIcons', 'gestureHandling'
];
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActMap.prototype, "longitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActMap.prototype, "latitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActMap.prototype, "zoom", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActMap.prototype, "minZoom", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActMap.prototype, "maxZoom", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('mapDraggable'),
    __metadata("design:type", Boolean)
], ActMap.prototype, "draggable", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMap.prototype, "disableDoubleClickZoom", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMap.prototype, "disableDefaultUI", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMap.prototype, "scrollwheel", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActMap.prototype, "backgroundColor", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActMap.prototype, "draggableCursor", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActMap.prototype, "draggingCursor", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMap.prototype, "keyboardShortcuts", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMap.prototype, "zoomControl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Array)
], ActMap.prototype, "styles", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMap.prototype, "usePanning", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMap.prototype, "streetViewControl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ActMap.prototype, "fitBounds", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMap.prototype, "scaleControl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMap.prototype, "mapTypeControl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMap.prototype, "panControl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMap.prototype, "rotateControl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMap.prototype, "fullscreenControl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActMap.prototype, "mapTypeId", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMap.prototype, "clickableIcons", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMap.prototype, "resetCenter", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActMap.prototype, "gestureHandling", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], ActMap.prototype, "mapClick", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
], ActMap.prototype, "mapRightClick", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
], ActMap.prototype, "mapDblClick", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _d || Object)
], ActMap.prototype, "centerChange", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _e || Object)
], ActMap.prototype, "boundsChange", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _f || Object)
], ActMap.prototype, "mapTypeIdChange", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _g || Object)
], ActMap.prototype, "idle", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _h || Object)
], ActMap.prototype, "zoomChange", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _j || Object)
], ActMap.prototype, "mapReady", void 0);
ActMap = ActMap_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-map',
        providers: [
            __WEBPACK_IMPORTED_MODULE_2__services_google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */], __WEBPACK_IMPORTED_MODULE_5__services_managers_marker_manager__["a" /* MarkerManager */], __WEBPACK_IMPORTED_MODULE_4__services_managers_info_window_manager__["a" /* InfoWindowManager */], __WEBPACK_IMPORTED_MODULE_3__services_managers_info_marker_manager__["a" /* InfoMarkerManager */], __WEBPACK_IMPORTED_MODULE_1__services_managers_circle_manager__["a" /* CircleManager */],
        ],
        host: {
            '[class.google-map-container]': 'true'
        },
        styles: ["\n    .act-map-container-inner {\n      width: inherit;\n      height: inherit;\n    }\n    .act-map-content {\n      display:none;\n    }\n  "],
        template: "\n    <div class='act-map-container-inner google-map-container-inner'></div>\n    <div class='act-map-content'>\n      <ng-content></ng-content>\n    </div>\n  "
    }),
    __metadata("design:paramtypes", [typeof (_k = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _k || Object, typeof (_l = typeof __WEBPACK_IMPORTED_MODULE_2__services_google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */]) === "function" && _l || Object, typeof (_m = typeof __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__["a" /* UtilitiesService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6_app_services_utilities_utilities_service__["a" /* UtilitiesService */]) === "function" && _m || Object])
], ActMap);

var ActMap_1, _o, _p, _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
//# sourceMappingURL=map.js.map

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_managers_marker_manager__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__info_window__ = __webpack_require__(271);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActMarker; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var markerId = 0;
// tslint:disable
var ActMarker = (function () {
    function ActMarker(_markerManager) {
        this._markerManager = _markerManager;
        this.draggable = false;
        this.visible = true;
        this.openInfoWindow = true;
        this.opacity = 1;
        this.zIndex = 1;
        this.clickable = true;
        this.markerClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.dragEnd = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.mouseOver = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.mouseOut = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.infoWindow = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["QueryList"]();
        this._markerAddedToManger = false;
        this._observableSubscriptions = [];
        this._id = (markerId++).toString();
    }
    ActMarker.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.handleInfoWindowUpdate();
        this.infoWindow.changes.subscribe(function () { return _this.handleInfoWindowUpdate(); });
    };
    ActMarker.prototype.handleInfoWindowUpdate = function () {
        var _this = this;
        if (this.infoWindow.length > 1) {
            throw new Error('Expected no more than one info window.');
        }
        this.infoWindow.forEach(function (marker) {
            marker.hostMarker = _this;
        });
    };
    ActMarker.prototype.ngOnChanges = function (changes) {
        if (typeof this.latitude !== 'number' || typeof this.longitude !== 'number') {
            return;
        }
        if (!this._markerAddedToManger) {
            this._markerManager.addMarker(this);
            this._markerAddedToManger = true;
            this._addEventListeners();
            return;
        }
        if (changes['latitude'] || changes['longitude']) {
            this._markerManager.updateMarkerPosition(this);
        }
        if (changes['title']) {
            this._markerManager.updateTitle(this);
        }
        if (changes['label']) {
            this._markerManager.updateLabel(this);
        }
        if (changes['draggable']) {
            this._markerManager.updateDraggable(this);
        }
        if (changes['iconUrl']) {
            this._markerManager.updateIcon(this);
        }
        if (changes['opacity']) {
            this._markerManager.updateOpacity(this);
        }
        if (changes['visible']) {
            this._markerManager.updateVisible(this);
        }
        if (changes['zIndex']) {
            this._markerManager.updateZIndex(this);
        }
        if (changes['clickable']) {
            this._markerManager.updateClickable(this);
        }
        if (changes['animation']) {
            this._markerManager.updateAnimation(this);
        }
    };
    ActMarker.prototype._addEventListeners = function () {
        var _this = this;
        var cs = this._markerManager.createEventObservable('click', this).subscribe(function () {
            if (_this.openInfoWindow) {
                _this.infoWindow.forEach(function (infoWindow) { return infoWindow.open(); });
            }
            _this.markerClick.emit(null);
        });
        this._observableSubscriptions.push(cs);
        var ds = this._markerManager.createEventObservable('dragend', this)
            .subscribe(function (e) {
            _this.dragEnd.emit({ coords: { lat: e.latLng.lat(), lng: e.latLng.lng() } });
        });
        this._observableSubscriptions.push(ds);
        var mover = this._markerManager.createEventObservable('mouseover', this)
            .subscribe(function (e) {
            _this.mouseOver.emit({ coords: { lat: e.latLng.lat(), lng: e.latLng.lng() } });
        });
        this._observableSubscriptions.push(mover);
        var mout = this._markerManager.createEventObservable('mouseout', this)
            .subscribe(function (e) {
            _this.mouseOut.emit({ coords: { lat: e.latLng.lat(), lng: e.latLng.lng() } });
        });
        this._observableSubscriptions.push(mout);
    };
    ActMarker.prototype.id = function () { return this._id; };
    ActMarker.prototype.toString = function () { return 'ActMarker-' + this._id.toString(); };
    ActMarker.prototype.ngOnDestroy = function () {
        this._markerManager.deleteMarker(this);
        // unsubscribe all registered observable subscriptions
        this._observableSubscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    return ActMarker;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActMarker.prototype, "latitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActMarker.prototype, "longitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActMarker.prototype, "title", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ActMarker.prototype, "label", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('markerDraggable'),
    __metadata("design:type", Boolean)
], ActMarker.prototype, "draggable", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActMarker.prototype, "iconUrl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMarker.prototype, "visible", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActMarker.prototype, "openInfoWindow", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActMarker.prototype, "opacity", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActMarker.prototype, "zIndex", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('markerClickable'),
    __metadata("design:type", Boolean)
], ActMarker.prototype, "clickable", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], ActMarker.prototype, "markerClick", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
], ActMarker.prototype, "dragEnd", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
], ActMarker.prototype, "mouseOver", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _d || Object)
], ActMarker.prototype, "mouseOut", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"])(__WEBPACK_IMPORTED_MODULE_2__info_window__["a" /* ActInfoWindow */]),
    __metadata("design:type", typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["QueryList"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["QueryList"]) === "function" && _e || Object)
], ActMarker.prototype, "infoWindow", void 0);
ActMarker = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
        selector: 'act-marker',
        inputs: [
            'latitude', 'longitude', 'title', 'label', 'draggable: markerDraggable', 'iconUrl',
            'openInfoWindow', 'opacity', 'visible', 'zIndex', 'animation'
        ],
        outputs: ['markerClick', 'dragEnd', 'mouseOver', 'mouseOut']
    }),
    __metadata("design:paramtypes", [typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_1__services_managers_marker_manager__["a" /* MarkerManager */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__services_managers_marker_manager__["a" /* MarkerManager */]) === "function" && _f || Object])
], ActMarker);

var _g, _a, _b, _c, _d, _e, _f;
//# sourceMappingURL=marker.js.map

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__info_marker__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_google_maps_api_wrapper__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_managers_info_marker_manager__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_maps_api_loader_maps_api_loader__ = __webpack_require__(106);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActPopOver; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};





// tslint:disable
var ActPopOver = (function () {
    function ActPopOver(_infoMarker, _wrapper, _manager, _loader) {
        this._infoMarker = _infoMarker;
        this._wrapper = _wrapper;
        this._manager = _manager;
        this._loader = _loader;
        this.isOpen = false;
        this.placement = 'top';
        this.maxWidth = 200;
        this.maxHeight = 200;
        this.border = false;
        this.pointer = false;
        this.openOnMarkerClick = false;
        this.closeOnMapClick = true;
        this.closeWhenOthersOpen = true;
        this.panOnOpen = true;
        this.isOpenChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.beforeOpen = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.afterClose = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onRenderPopOverComplete = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._popOverInitialized = null;
    }
    ActPopOver.prototype.ngOnChanges = function (changes) {
        if (this._nativePopOver == null) {
            return;
        }
        if ('isOpen' in changes && this.isOpen) {
            this.openPopOver();
        }
        else if ('isOpen' in changes && !this.isOpen) {
            this.closePopOver();
        }
        if (('latitude' in changes || 'longitude' in changes) && this._infoMarker == null) {
            this._updatePosition();
        }
    };
    ActPopOver.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.createPopOver();
            _this.onRenderPopOverComplete.emit(_this.key);
        }, 1e3);
    };
    ActPopOver.prototype.createPopOver = function () {
        var _this = this;
        var m = this._manager !== null && this._infoMarker !== null ? this._manager.getMarker(this._infoMarker.key) : null;
        this._popOverInitialized = this._loader.load()
            .then(function () { return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 241)); })
            .then(function (module) { return Promise.all([module, m, _this._wrapper.getNativeMap()]); })
            .then(function (elems) {
            var options = {
                classPrefix: 'pop-',
                eventPrefix: 'pop-over-window-',
                map: elems[2],
                content: '',
                placement: _this.placement,
                maxWidth: _this.maxWidth,
                maxHeight: _this.maxHeight,
                backgroundColor: _this.backgroundColor,
                padding: _this.padding,
                border: _this.border,
                borderRadius: _this.borderRadius,
                fontColor: _this.fontColor,
                pointer: _this.pointer,
                shadow: _this.shadow,
                closeOnMapClick: _this.closeOnMapClick,
                openOnMarkerClick: _this.openOnMarkerClick,
                closeWhenOthersOpen: _this.closeWhenOthersOpen,
                showCloseButton: false,
                isHandleBackground: true,
                panOnOpen: _this.panOnOpen,
                wrapperClass: _this.wrapperClass,
                offset: { top: '-50px' },
                callbacks: {
                    beforeOpen: function () {
                        _this._createViewContent();
                        _this.beforeOpen.emit();
                    },
                    afterOpen: function () {
                        _this.isOpenChange.emit(_this.openStatus());
                    },
                    afterClose: function () {
                        var marker = _this._manager.getMarker(_this.key);
                        marker.removeActive();
                        _this.afterClose.emit();
                        _this.isOpenChange.emit(_this.openStatus());
                    },
                    bgClicked: function () {
                        _this.onClick.emit({ key: _this.key });
                    }
                }
            };
            if (elems[1] != null) {
                options.marker = elems[1];
                options.position = {
                    lat: options.marker.latitude,
                    lng: options.marker.longitude
                };
            }
            else {
                options.position = {
                    lat: _this.latitude,
                    lng: _this.longitude
                };
            }
            _this._nativePopOver = new elems[0](options);
        });
        this._popOverInitialized.then(function () {
            if (_this.isOpen) {
                _this.openPopOver();
            }
            _this._manager.addPopOver(_this.key, _this);
        });
    };
    ActPopOver.prototype.openPopOver = function () {
        var _this = this;
        this._popOverInitialized.then(function () {
            _this._createViewContent();
            _this._nativePopOver.open();
        });
    };
    ActPopOver.prototype.closePopOver = function () {
        var _this = this;
        this._popOverInitialized.then(function () {
            _this._nativePopOver.close();
        });
    };
    ActPopOver.prototype.togglePopOver = function () {
        var _this = this;
        this._popOverInitialized.then(function () {
            _this._nativePopOver.isOpen() ? _this._nativePopOver.close() : _this._nativePopOver.open();
        });
    };
    ActPopOver.prototype._createViewContent = function () {
        if (this._viewContainerRef.length === 1) {
            return;
        }
        var evr = this._viewContainerRef.createEmbeddedView(this._templateRef);
        this._nativePopOver.setContent(this._outerWrapper.nativeElement);
        // we have to run this in a separate cycle.
        setTimeout(function () {
            evr.detectChanges();
        });
    };
    ActPopOver.prototype._updatePosition = function () {
        this._nativePopOver.setPosition({
            lat: this.latitude,
            lng: this.longitude
        });
    };
    ActPopOver.prototype.openStatus = function () {
        return this._nativePopOver && this._nativePopOver.isOpen();
    };
    ActPopOver.prototype.ngOnDestroy = function () {
        if (this._nativePopOver) {
            this._nativePopOver.destroy();
        }
    };
    return ActPopOver;
}());
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ActPopOver.prototype, "key", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActPopOver.prototype, "latitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Number)
], ActPopOver.prototype, "longitude", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActPopOver.prototype, "isOpen", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActPopOver.prototype, "placement", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ActPopOver.prototype, "maxWidth", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ActPopOver.prototype, "maxHeight", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActPopOver.prototype, "backgroundColor", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActPopOver.prototype, "padding", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ActPopOver.prototype, "border", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActPopOver.prototype, "borderRadius", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActPopOver.prototype, "fontColor", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActPopOver.prototype, "fontSize", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ActPopOver.prototype, "pointer", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Object)
], ActPopOver.prototype, "shadow", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActPopOver.prototype, "openOnMarkerClick", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActPopOver.prototype, "closeOnMapClick", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", String)
], ActPopOver.prototype, "wrapperClass", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActPopOver.prototype, "closeWhenOthersOpen", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata("design:type", Boolean)
], ActPopOver.prototype, "panOnOpen", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
], ActPopOver.prototype, "isOpenChange", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
], ActPopOver.prototype, "beforeOpen", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
], ActPopOver.prototype, "afterClose", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _d || Object)
], ActPopOver.prototype, "onClick", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
    __metadata("design:type", typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _e || Object)
], ActPopOver.prototype, "onRenderPopOverComplete", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('outerWrapper', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] }),
    __metadata("design:type", typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _f || Object)
], ActPopOver.prototype, "_outerWrapper", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('viewContainer', { read: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] }),
    __metadata("design:type", typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]) === "function" && _g || Object)
], ActPopOver.prototype, "_viewContainerRef", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"])(__WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]),
    __metadata("design:type", typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]) === "function" && _h || Object)
], ActPopOver.prototype, "_templateRef", void 0);
ActPopOver = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
        selector: 'act-pop-over',
        template: "\n    <div #outerWrapper>\n      <div #viewContainer></div>\n    </div>\n    <ng-content></ng-content>"
    }),
    __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"])()), __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"])()), __param(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"])()),
    __metadata("design:paramtypes", [typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_1__info_marker__["a" /* ActInfoMarker */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__info_marker__["a" /* ActInfoMarker */]) === "function" && _j || Object, typeof (_k = typeof __WEBPACK_IMPORTED_MODULE_2__services_google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */]) === "function" && _k || Object, typeof (_l = typeof __WEBPACK_IMPORTED_MODULE_3__services_managers_info_marker_manager__["a" /* InfoMarkerManager */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__services_managers_info_marker_manager__["a" /* InfoMarkerManager */]) === "function" && _l || Object, typeof (_m = typeof __WEBPACK_IMPORTED_MODULE_4__services_maps_api_loader_maps_api_loader__["a" /* MapsAPILoader */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__services_maps_api_loader_maps_api_loader__["a" /* MapsAPILoader */]) === "function" && _m || Object])
], ActPopOver);

var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
//# sourceMappingURL=pop-over.js.map

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Helper; });
var Helper = (function () {
    function Helper() {
    }
    Helper.prototype.convertToCapital = function (text) {
        return text.charAt(0).toUpperCase() + text.slice(1);
    };
    return Helper;
}());

//# sourceMappingURL=helper.js.map

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nationalityList; });
var nationalityList = {
    list: [
        {
            ISO2: "AF",
            nationality: "Afghan"
        },
        {
            ISO2: "AX",
            nationality: "Ål5land Island"
        },
        {
            ISO2: "AL",
            nationality: "Albanian"
        },
        {
            ISO2: "DZ",
            nationality: "Algerian"
        },
        {
            ISO2: "AS",
            nationality: "American Samoan"
        },
        {
            ISO2: "AD",
            nationality: "Andorran"
        },
        {
            ISO2: "AO",
            nationality: "Angolan"
        },
        {
            ISO2: "AI",
            nationality: "Anguillan"
        },
        {
            ISO2: "AQ",
            nationality: "Antarctic"
        },
        {
            ISO2: "AG",
            nationality: "Antiguan or Barbudan"
        },
        {
            ISO2: "AR",
            nationality: "Argentine"
        },
        {
            ISO2: "AM",
            nationality: "Armenian"
        },
        {
            ISO2: "AW",
            nationality: "Aruban"
        },
        {
            ISO2: "AU",
            nationality: "Australian"
        },
        {
            ISO2: "AT",
            nationality: "Austrian"
        },
        {
            ISO2: "AZ",
            nationality: "Azerbaijani, Azeri"
        },
        {
            ISO2: "BS",
            nationality: "Bahamian"
        },
        {
            ISO2: "BH",
            nationality: "Bahraini"
        },
        {
            ISO2: "BD",
            nationality: "Bangladeshi"
        },
        {
            ISO2: "BB",
            nationality: "Barbadian"
        },
        {
            ISO2: "BY",
            nationality: "Belarusian"
        },
        {
            ISO2: "BE",
            nationality: "Belgian"
        },
        {
            ISO2: "BZ",
            nationality: "Belizean"
        },
        {
            ISO2: "BJ",
            nationality: "Beninese, Beninois"
        },
        {
            ISO2: "BM",
            nationality: "Bermudian, Bermudan"
        },
        {
            ISO2: "BT",
            nationality: "Bhutanese"
        },
        {
            ISO2: "BO",
            nationality: "Bolivian"
        },
        {
            ISO2: "BQ",
            nationality: "Bonaire"
        },
        {
            ISO2: "BA",
            nationality: "Bosnian or Herzegovinian"
        },
        {
            ISO2: "BW",
            nationality: "Motswana, Botswanan"
        },
        {
            ISO2: "BV",
            nationality: "Bouvet Island"
        },
        {
            ISO2: "BR",
            nationality: "Brazilian"
        },
        {
            ISO2: "IO",
            nationality: "BIOT"
        },
        {
            ISO2: "BN",
            nationality: "Bruneian"
        },
        {
            ISO2: "BG",
            nationality: "Bulgarian"
        },
        {
            ISO2: "BF",
            nationality: "Burkinabé"
        },
        {
            ISO2: "BI",
            nationality: "Burundian"
        },
        {
            ISO2: "CV",
            nationality: "Cabo Verdean"
        },
        {
            ISO2: "KH",
            nationality: "Cambodian"
        },
        {
            ISO2: "CM",
            nationality: "Cameroonian"
        },
        {
            ISO2: "CA",
            nationality: "Canadian"
        },
        {
            ISO2: "KY",
            nationality: "Caymanian"
        },
        {
            ISO2: "CF",
            nationality: "Central African"
        },
        {
            ISO2: "TD",
            nationality: "Chadian"
        },
        {
            ISO2: "CL",
            nationality: "Chilean"
        },
        {
            ISO2: "CN",
            nationality: "Chinese"
        },
        {
            ISO2: "CX",
            nationality: "Christmas Island"
        },
        {
            ISO2: "CC",
            nationality: "Cocos Island"
        },
        {
            ISO2: "CO",
            nationality: "Colombian"
        },
        {
            ISO2: "KM",
            nationality: "Comoran, Comorian"
        },
        {
            ISO2: "CG",
            nationality: "Congolese"
        },
        {
            ISO2: "CD",
            nationality: "Congolese"
        },
        {
            ISO2: "CK",
            nationality: "Cook Island"
        },
        {
            ISO2: "CR",
            nationality: "Costa Rican"
        },
        {
            ISO2: "CI",
            nationality: "Ivorian"
        },
        {
            ISO2: "HR",
            nationality: "Croatian"
        },
        {
            ISO2: "CU",
            nationality: "Cuban"
        },
        {
            ISO2: "CW",
            nationality: "Curaçaoan"
        },
        {
            ISO2: "CY",
            nationality: "Cypriot"
        },
        {
            ISO2: "CZ",
            nationality: "Czech"
        },
        {
            ISO2: "DK",
            nationality: "Danish"
        },
        {
            ISO2: "DJ",
            nationality: "Djiboutian"
        },
        {
            ISO2: "DM",
            nationality: "Dominican"
        },
        {
            ISO2: "DO",
            nationality: "Dominican"
        },
        {
            ISO2: "EC",
            nationality: "Ecuadorian"
        },
        {
            ISO2: "EG",
            nationality: "Egyptian"
        },
        {
            ISO2: "SV",
            nationality: "Salvadoran"
        },
        {
            ISO2: "GQ",
            nationality: "Equatorial Guinean, Equatoguinean"
        },
        {
            ISO2: "ER",
            nationality: "Eritrean"
        },
        {
            ISO2: "EE",
            nationality: "Estonian"
        },
        {
            ISO2: "ET",
            nationality: "Ethiopian"
        },
        {
            ISO2: "FK",
            nationality: "Falkland Island"
        },
        {
            ISO2: "FO",
            nationality: "Faroese"
        },
        {
            ISO2: "FJ",
            nationality: "Fijian"
        },
        {
            ISO2: "FI",
            nationality: "Finnish"
        },
        {
            ISO2: "FR",
            nationality: "French"
        },
        {
            ISO2: "GF",
            nationality: "French Guianese"
        },
        {
            ISO2: "PF",
            nationality: "French Polynesian"
        },
        {
            ISO2: "TF",
            nationality: "French Southern Territories"
        },
        {
            ISO2: "GA",
            nationality: "Gabonese"
        },
        {
            ISO2: "GM",
            nationality: "Gambian"
        },
        {
            ISO2: "GE",
            nationality: "Georgian"
        },
        {
            ISO2: "DE",
            nationality: "German"
        },
        {
            ISO2: "GH",
            nationality: "Ghanaian"
        },
        {
            ISO2: "GI",
            nationality: "Gibraltar"
        },
        {
            ISO2: "GR",
            nationality: "Greek, Hellenic"
        },
        {
            ISO2: "GL",
            nationality: "Greenlandic"
        },
        {
            ISO2: "GD",
            nationality: "Grenadian"
        },
        {
            ISO2: "GP",
            nationality: "Guadeloupe"
        },
        {
            ISO2: "GU",
            nationality: "Guamanian, Guambat"
        },
        {
            ISO2: "GT",
            nationality: "Guatemalan"
        },
        {
            ISO2: "GG",
            nationality: "Channel Island"
        },
        {
            ISO2: "GN",
            nationality: "Guinean"
        },
        {
            ISO2: "GW",
            nationality: "Bissau-Guinean"
        },
        {
            ISO2: "GY",
            nationality: "Guyanese"
        },
        {
            ISO2: "HT",
            nationality: "Haitian"
        },
        {
            ISO2: "HM",
            nationality: "Heard Island or McDonald Islands"
        },
        {
            ISO2: "VA",
            nationality: "Vatican"
        },
        {
            ISO2: "HN",
            nationality: "Honduran"
        },
        {
            ISO2: "HK",
            nationality: "Hong Kong, Hong Kongese"
        },
        {
            ISO2: "HU",
            nationality: "Hungarian, Magyar"
        },
        {
            ISO2: "IS",
            nationality: "Icelandic"
        },
        {
            ISO2: "IN",
            nationality: "Indian"
        },
        {
            ISO2: "ID",
            nationality: "Indonesian"
        },
        {
            ISO2: "IR",
            nationality: "Iranian, Persian"
        },
        {
            ISO2: "IQ",
            nationality: "Iraqi"
        },
        {
            ISO2: "IE",
            nationality: "Irish"
        },
        {
            ISO2: "IM",
            nationality: "Manx"
        },
        {
            ISO2: "IL",
            nationality: "Israeli"
        },
        {
            ISO2: "IT",
            nationality: "Italian"
        },
        {
            ISO2: "JM",
            nationality: "Jamaican"
        },
        {
            ISO2: "JP",
            nationality: "Japanese"
        },
        {
            ISO2: "JE",
            nationality: "Channel Island"
        },
        {
            ISO2: "JO",
            nationality: "Jordanian"
        },
        {
            ISO2: "KZ",
            nationality: "Kazakhstani, Kazakh"
        },
        {
            ISO2: "KE",
            nationality: "Kenyan"
        },
        {
            ISO2: "KI",
            nationality: "I-Kiribati"
        },
        {
            ISO2: "KP",
            nationality: "North Korean"
        },
        {
            ISO2: "KR",
            nationality: "South Korean"
        },
        {
            ISO2: "KW",
            nationality: "Kuwaiti"
        },
        {
            ISO2: "KG",
            nationality: "Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz"
        },
        {
            ISO2: "LA",
            nationality: "Lao, Laotian"
        },
        {
            ISO2: "LV",
            nationality: "Latvian"
        },
        {
            ISO2: "LB",
            nationality: "Lebanese"
        },
        {
            ISO2: "LS",
            nationality: "Basotho"
        },
        {
            ISO2: "LR",
            nationality: "Liberian"
        },
        {
            ISO2: "LY",
            nationality: "Libyan"
        },
        {
            ISO2: "LI",
            nationality: "Liechtenstein"
        },
        {
            ISO2: "LT",
            nationality: "Lithuanian"
        },
        {
            ISO2: "LU",
            nationality: "Luxembourg, Luxembourgish"
        },
        {
            ISO2: "MO",
            nationality: "Macanese, Chinese"
        },
        {
            ISO2: "MK",
            nationality: "Macedonian"
        },
        {
            ISO2: "MG",
            nationality: "Malagasy"
        },
        {
            ISO2: "MW",
            nationality: "Malawian"
        },
        {
            ISO2: "MY",
            nationality: "Malaysian"
        },
        {
            ISO2: "MV",
            nationality: "Maldivian"
        },
        {
            ISO2: "ML",
            nationality: "Malian, Malinese"
        },
        {
            ISO2: "MT",
            nationality: "Maltese"
        },
        {
            ISO2: "MH",
            nationality: "Marshallese"
        },
        {
            ISO2: "MQ",
            nationality: "Martiniquais, Martinican"
        },
        {
            ISO2: "MR",
            nationality: "Mauritanian"
        },
        {
            ISO2: "MU",
            nationality: "Mauritian"
        },
        {
            ISO2: "YT",
            nationality: "Mahoran"
        },
        {
            ISO2: "MX",
            nationality: "Mexican"
        },
        {
            ISO2: "FM",
            nationality: "Micronesian"
        },
        {
            ISO2: "MD",
            nationality: "Moldovan"
        },
        {
            ISO2: "MC",
            nationality: "Monégasque, Monacan"
        },
        {
            ISO2: "MN",
            nationality: "Mongolian"
        },
        {
            ISO2: "ME",
            nationality: "Montenegrin"
        },
        {
            ISO2: "MS",
            nationality: "Montserratian"
        },
        {
            ISO2: "MA",
            nationality: "Moroccan"
        },
        {
            ISO2: "MZ",
            nationality: "Mozambican"
        },
        {
            ISO2: "MM",
            nationality: "Burmese"
        },
        {
            ISO2: "NA",
            nationality: "Namibian"
        },
        {
            ISO2: "NR",
            nationality: "Nauruan"
        },
        {
            ISO2: "NP",
            nationality: "Nepali, Nepalese"
        },
        {
            ISO2: "NL",
            nationality: "Dutch, Netherlandic"
        },
        {
            ISO2: "NC",
            nationality: "New Caledonian"
        },
        {
            ISO2: "NZ",
            nationality: "New Zealand, NZ"
        },
        {
            ISO2: "NI",
            nationality: "Nicaraguan"
        },
        {
            ISO2: "NE",
            nationality: "Nigerien"
        },
        {
            ISO2: "NG",
            nationality: "Nigerian"
        },
        {
            ISO2: "NU",
            nationality: "Niuean"
        },
        {
            ISO2: "NF",
            nationality: "Norfolk Island"
        },
        {
            ISO2: "MP",
            nationality: "Northern Marianan"
        },
        {
            ISO2: "NO",
            nationality: "Norwegian"
        },
        {
            ISO2: "OM",
            nationality: "Omani"
        },
        {
            ISO2: "PK",
            nationality: "Pakistani"
        },
        {
            ISO2: "PW",
            nationality: "Palauan"
        },
        {
            ISO2: "PS",
            nationality: "Palestinian"
        },
        {
            ISO2: "PA",
            nationality: "Panamanian"
        },
        {
            ISO2: "PG",
            nationality: "Papua New Guinean, Papuan"
        },
        {
            ISO2: "PY",
            nationality: "Paraguayan"
        },
        {
            ISO2: "PE",
            nationality: "Peruvian"
        },
        {
            ISO2: "PH",
            nationality: "Philippine, Filipino"
        },
        {
            ISO2: "PN",
            nationality: "Pitcairn Island"
        },
        {
            ISO2: "PL",
            nationality: "Polish"
        },
        {
            ISO2: "PT",
            nationality: "Portuguese"
        },
        {
            ISO2: "PR",
            nationality: "Puerto Rican"
        },
        {
            ISO2: "QA",
            nationality: "Qatari"
        },
        {
            ISO2: "RE",
            nationality: "Réunionese, Réunionnais"
        },
        {
            ISO2: "RO",
            nationality: "Romanian"
        },
        {
            ISO2: "RU",
            nationality: "Russian"
        },
        {
            ISO2: "RW",
            nationality: "Rwandan"
        },
        {
            ISO2: "BL",
            nationality: "Barthélemois"
        },
        {
            ISO2: "SH",
            nationality: "Saint Helenian"
        },
        {
            ISO2: "KN",
            nationality: "Kittitian or Nevisian"
        },
        {
            ISO2: "LC",
            nationality: "Saint Lucian"
        },
        {
            ISO2: "MF",
            nationality: "Saint-Martinoise"
        },
        {
            ISO2: "PM",
            nationality: "Saint-Pierrais or Miquelonnais"
        },
        {
            ISO2: "VC",
            nationality: "Saint Vincentian, Vincentian"
        },
        {
            ISO2: "WS",
            nationality: "Samoan"
        },
        {
            ISO2: "SM",
            nationality: "Sammarinese"
        },
        {
            ISO2: "ST",
            nationality: "São Toméan"
        },
        {
            ISO2: "SA",
            nationality: "Saudi, Saudi Arabian"
        },
        {
            ISO2: "SN",
            nationality: "Senegalese"
        },
        {
            ISO2: "RS",
            nationality: "Serbian"
        },
        {
            ISO2: "SC",
            nationality: "Seychellois"
        },
        {
            ISO2: "SL",
            nationality: "Sierra Leonean"
        },
        {
            ISO2: "SG",
            nationality: "Singaporean"
        },
        {
            ISO2: "SX",
            nationality: "Sint Maarten"
        },
        {
            ISO2: "SK",
            nationality: "Slovak"
        },
        {
            ISO2: "SI",
            nationality: "Slovenian, Slovene"
        },
        {
            ISO2: "SB",
            nationality: "Solomon Island"
        },
        {
            ISO2: "SO",
            nationality: "Somali, Somalian"
        },
        {
            ISO2: "ZA",
            nationality: "South African"
        },
        {
            ISO2: "GS",
            nationality: "South Georgia or South Sandwich Islands"
        },
        {
            ISO2: "SS",
            nationality: "South Sudanese"
        },
        {
            ISO2: "ES",
            nationality: "Spanish"
        },
        {
            ISO2: "LK",
            nationality: "Sri Lankan"
        },
        {
            ISO2: "SD",
            nationality: "Sudanese"
        },
        {
            ISO2: "SR",
            nationality: "Surinamese"
        },
        {
            ISO2: "SJ",
            nationality: "Svalbard"
        },
        {
            ISO2: "SZ",
            nationality: "Swazi"
        },
        {
            ISO2: "SE",
            nationality: "Swedish"
        },
        {
            ISO2: "CH",
            nationality: "Swiss"
        },
        {
            ISO2: "SY",
            nationality: "Syrian"
        },
        {
            ISO2: "TW",
            nationality: "Chinese, Taiwanese"
        },
        {
            ISO2: "TJ",
            nationality: "Tajikistani"
        },
        {
            ISO2: "TZ",
            nationality: "Tanzanian"
        },
        {
            ISO2: "TH",
            nationality: "Thai"
        },
        {
            ISO2: "TL",
            nationality: "Timorese"
        },
        {
            ISO2: "TG",
            nationality: "Togolese"
        },
        {
            ISO2: "TK",
            nationality: "Tokelauan"
        },
        {
            ISO2: "TO",
            nationality: "Tongan"
        },
        {
            ISO2: "TT",
            nationality: "Trinidadian or Tobagonian"
        },
        {
            ISO2: "TN",
            nationality: "Tunisian"
        },
        {
            ISO2: "TR",
            nationality: "Turkish"
        },
        {
            ISO2: "TM",
            nationality: "Turkmen"
        },
        {
            ISO2: "TC",
            nationality: "Turks and Caicos Island"
        },
        {
            ISO2: "TV",
            nationality: "Tuvaluan"
        },
        {
            ISO2: "UG",
            nationality: "Ugandan"
        },
        {
            ISO2: "UA",
            nationality: "Ukrainian"
        },
        {
            ISO2: "AE",
            nationality: "Emirati, Emirian, Emiri"
        },
        {
            ISO2: "GB",
            nationality: "British, UK"
        },
        {
            ISO2: "US",
            nationality: "American"
        },
        {
            ISO2: "UY",
            nationality: "Uruguayan"
        },
        {
            ISO2: "UZ",
            nationality: "Uzbekistani, Uzbek"
        },
        {
            ISO2: "VU",
            nationality: "Ni-Vanuatu, Vanuatuan"
        },
        {
            ISO2: "VE",
            nationality: "Venezuelan"
        },
        {
            ISO2: "VN",
            nationality: "Vietnamese"
        },
        {
            ISO2: "VG",
            nationality: "British Virgin Island"
        },
        {
            ISO2: "VI",
            nationality: "U.S. Virgin Island"
        },
        {
            ISO2: "WF",
            nationality: "Wallis and Futuna, Wallisian or Futunan"
        },
        {
            ISO2: "EH",
            nationality: "Sahrawi, Sahrawian, Sahraouian"
        },
        {
            ISO2: "YE",
            nationality: "Yemeni"
        },
        {
            ISO2: "ZM",
            nationality: "Zambian"
        },
        {
            ISO2: "ZW",
            nationality: "Zimbabwean"
        }
    ]
};
//# sourceMappingURL=nationalityList.js.map

/***/ }),
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n/*base-link-mixin*/\n.daterangepicker {\n  position: absolute;\n  color: inherit;\n  background-color: #fff;\n  border-radius: 0;\n  width: 278px;\n  padding: 0;\n  margin-top: 1px;\n  top: 100px;\n  left: 20px;\n  /*\n  &:before, &:after {\n    position: absolute;\n    display: inline-block;\n\n    border-bottom-color: rgba(0, 0, 0, 0.2);\n    content: '';\n  }\n\n  &:before {\n    top: -$arrow-prefix-size;\n\n    border-right: $arrow-prefix-size solid transparent;\n    border-left: $arrow-prefix-size solid transparent;\n    border-bottom: $arrow-prefix-size solid $daterangepicker-border-color;\n  }\n\n  &:after {\n    top: -$arrow-suffix-size;\n\n    border-right: $arrow-suffix-size solid transparent;\n    border-bottom: $arrow-suffix-size solid $daterangepicker-bg-color;\n    border-left: $arrow-suffix-size solid transparent;\n  }\n  */\n  /* Header */\n  /* Calendars */ }\n  .daterangepicker.opensleft:before {\n    right: 9px; }\n  .daterangepicker.opensleft:after {\n    right: 10px; }\n  .daterangepicker.openscenter:before {\n    left: 0;\n    right: 0;\n    width: 0;\n    margin-left: auto;\n    margin-right: auto; }\n  .daterangepicker.openscenter:after {\n    left: 0;\n    right: 0;\n    width: 0;\n    margin-left: auto;\n    margin-right: auto; }\n  .daterangepicker.opensright:before {\n    left: 9px; }\n  .daterangepicker.opensright:after {\n    left: 10px; }\n  .daterangepicker.dropup {\n    margin-top: -5px; }\n    .daterangepicker.dropup:before {\n      top: initial;\n      bottom: -7px;\n      border-bottom: initial;\n      border-top: 7px solid #ccc; }\n    .daterangepicker.dropup:after {\n      top: initial;\n      bottom: -6px;\n      border-bottom: initial;\n      border-top: 6px solid #fff; }\n  .daterangepicker.dropdown-menu {\n    max-width: none;\n    z-index: 2147483649;\n    border: none;\n    border-radius: 4px;\n    margin-top: 5px;\n    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.4); }\n  .daterangepicker.single .ranges, .daterangepicker.single .calendar {\n    float: none; }\n  .daterangepicker .header {\n    width: 100%; }\n    .daterangepicker .header .bar-title.bar-control::before, .daterangepicker .header .bar-control.bar-control::before {\n      display: none;\n      position: absolute;\n      content: '';\n      width: 100%;\n      height: 1px;\n      background-color: #D1D1D1; }\n      @media (max-width: 767px) {\n        .daterangepicker .header .bar-title.bar-control::before, .daterangepicker .header .bar-control.bar-control::before {\n          display: none; } }\n    .daterangepicker .header .bar-title {\n      height: 45px; }\n    .daterangepicker .header .bar-control {\n      height: 40px; }\n  .daterangepicker .header .bar-title {\n    position: relative; }\n    @media (max-width: 767px) {\n      .daterangepicker .header .bar-title {\n        display: none; } }\n    .daterangepicker .header .bar-title .picker-label {\n      width: 100%;\n      height: 100%;\n      text-align: center;\n      padding-top: 11px;\n      font-size: 16px;\n      font-weight: normal; }\n    .daterangepicker .header .bar-title .close-icon {\n      position: absolute;\n      top: 12px;\n      right: 15px;\n      width: 20px;\n      height: 20px;\n      font-size: 20px;\n      text-align: center;\n      color: #DDDDDD;\n      display: none; }\n      .daterangepicker .header .bar-title .close-icon:hover {\n        color: #6b778c; }\n  .daterangepicker .header .bar-control .left, .daterangepicker .header .bar-control .right {\n    display: inline-block;\n    position: relative;\n    width: 50%;\n    height: 100%; }\n  .daterangepicker .header .bar-control .left span, .daterangepicker .header .bar-control .right span {\n    display: block;\n    position: absolute;\n    width: 42px;\n    height: 100%;\n    top: 0px;\n    font-size: 16px; }\n    .daterangepicker .header .bar-control .left span i, .daterangepicker .header .bar-control .right span i {\n      display: block;\n      width: 100%;\n      padding-top: 14px;\n      color: #6b778c; }\n    .daterangepicker .header .bar-control .left span:hover, .daterangepicker .header .bar-control .right span:hover {\n      background-color: #ddd; }\n  .daterangepicker .header .bar-control .left span {\n    left: 0; }\n    .daterangepicker .header .bar-control .left span i {\n      padding-top: 10px;\n      text-align: center;\n      font-size: 20px; }\n  .daterangepicker .header .bar-control .right span {\n    right: 0; }\n    .daterangepicker .header .bar-control .right span i {\n      padding-top: 10px;\n      text-align: center;\n      font-size: 20px; }\n  .daterangepicker .header .bar-control .left .month, .daterangepicker .header .bar-control .right .month {\n    display: block;\n    width: 100%;\n    height: 100%;\n    font-weight: normal;\n    text-align: center;\n    padding-top: 12px;\n    font-size: 14px; }\n  .daterangepicker .header .bar-control .left .month {\n    padding-left: 36px; }\n  .daterangepicker .header .bar-control .right .month {\n    padding-right: 36px; }\n  .daterangepicker.show-calendar .calendar {\n    display: block; }\n  .daterangepicker .calendar {\n    display: none;\n    max-height: 207px;\n    max-width: 270px;\n    margin: 4px; }\n    .daterangepicker .calendar.single .calendar-table {\n      border: none; }\n    .daterangepicker .calendar th, .daterangepicker .calendar td {\n      white-space: nowrap;\n      text-align: center;\n      min-width: 32px; }\n  .daterangepicker .calendar-table {\n    border: 1px solid #fff;\n    padding: 4px;\n    border-radius: 0px;\n    background-color: #fff; }\n  .daterangepicker table {\n    width: 100%;\n    margin: 0;\n    font-size: 12px; }\n  .daterangepicker table thead tr:first-child {\n    display: none; }\n  .daterangepicker td, .daterangepicker th {\n    text-align: center;\n    width: 20px;\n    height: 20px;\n    border-radius: 0;\n    border: 1px solid transparent;\n    white-space: nowrap;\n    cursor: pointer;\n    font-weight: normal; }\n    .daterangepicker td.available:hover, .daterangepicker th.available:hover {\n      border-color: transparent;\n      color: #fff; }\n    .daterangepicker td.week, .daterangepicker th.week {\n      font-size: 80%;\n      color: #ccc; }\n  .daterangepicker td.off, .daterangepicker td.off.in-range, .daterangepicker td.off.start-date, .daterangepicker td.off.end-date {\n    background-color: #fff;\n    border-color: transparent;\n    color: #999; }\n  .daterangepicker td.in-range {\n    background-color: #e4edff;\n    border-color: transparent;\n    color: #000;\n    border-radius: 0; }\n  .daterangepicker td.start-date {\n    border-radius: 0px 0 0 0px; }\n  .daterangepicker td.end-date {\n    border-radius: 0 0px 0px 0; }\n  .daterangepicker td.start-date.end-date {\n    border-radius: 0px; }\n  .daterangepicker td.active, .daterangepicker td.active:hover {\n    border-color: transparent;\n    color: #fff;\n    border-radius: 0; }\n  .daterangepicker th.month {\n    width: auto; }\n  .daterangepicker td.disabled, .daterangepicker option.disabled {\n    cursor: pointer;\n    color: #DDD;\n    background-color: transparent; }\n  .daterangepicker select.monthselect, .daterangepicker select.yearselect {\n    font-size: 12px;\n    padding: 1px;\n    height: auto;\n    margin: 0;\n    cursor: default; }\n  .daterangepicker select.monthselect {\n    margin-right: 2%;\n    width: 56%; }\n  .daterangepicker select.yearselect {\n    width: 40%; }\n  .daterangepicker select.hourselect, .daterangepicker select.minuteselect, .daterangepicker select.secondselect, .daterangepicker select.ampmselect {\n    width: 50px;\n    margin-bottom: 0; }\n  .daterangepicker .input-mini {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    color: #555;\n    height: 30px;\n    line-height: 30px;\n    display: block;\n    vertical-align: middle;\n    margin: 0 0 5px 0;\n    padding: 0 6px 0 28px;\n    width: 100%; }\n    .daterangepicker .input-mini.active {\n      border: 1px solid #08c;\n      border-radius: 4px; }\n  .daterangepicker .daterangepicker_input {\n    position: relative;\n    display: none; }\n    .daterangepicker .daterangepicker_input i {\n      position: absolute;\n      left: 8px;\n      top: 8px; }\n  .daterangepicker.rtl .input-mini {\n    padding-right: 28px;\n    padding-left: 6px; }\n  .daterangepicker.rtl .daterangepicker_input i {\n    left: auto;\n    right: 8px; }\n  .daterangepicker .calendar-time {\n    text-align: center;\n    margin: 5px auto;\n    line-height: 30px;\n    position: relative;\n    padding-left: 28px; }\n    .daterangepicker .calendar-time select.disabled {\n      color: #ccc;\n      cursor: not-allowed; }\n\n.ranges {\n  font-size: 11px;\n  float: none;\n  margin: 4px;\n  text-align: left; }\n  .ranges ul {\n    list-style: none;\n    margin: 0 auto;\n    padding: 0;\n    width: 100%; }\n  .ranges li {\n    font-size: 13px;\n    background-color: #f6f8f9;\n    border: 1px solid #f6f8f9;\n    border-radius: 0px;\n    color: #08c;\n    padding: 3px 12px;\n    margin-bottom: 8px;\n    cursor: pointer; }\n    .ranges li:hover {\n      background-color: #08c;\n      border: 1px solid #08c;\n      color: #fff; }\n    .ranges li.active {\n      background-color: #08c;\n      border: 1px solid #08c;\n      color: #fff; }\n\n/* calendar separate line */\n@media (min-width: 767px) {\n  .daterangepicker {\n    width: 550px; }\n    .daterangepicker .calendar.left::after {\n      position: relative;\n      display: none;\n      content: '';\n      width: 1px;\n      height: 245px;\n      top: -40px;\n      border-right: 1px dotted #D1D1D1; } }\n\n/*  Larger Screen Styling */\n@media (min-width: 564px) {\n  .daterangepicker {\n    width: 550px; }\n    .daterangepicker .calendar {\n      margin: 0px; }\n    .daterangepicker .ranges ul {\n      width: 160px; }\n    .daterangepicker.single .ranges ul {\n      width: 100%; }\n    .daterangepicker.single .calendar.left {\n      clear: none; }\n    .daterangepicker.single.ltr .ranges, .daterangepicker.single.ltr .calendar {\n      float: left; }\n    .daterangepicker.single.rtl .ranges, .daterangepicker.single.rtl .calendar {\n      float: right; }\n    .daterangepicker.ltr {\n      direction: ltr;\n      text-align: left; }\n      .daterangepicker.ltr .calendar {\n        display: -ms-flexbox;\n        display: flex; }\n        .daterangepicker.ltr .calendar.left {\n          clear: left;\n          margin-right: 0;\n          width: 100%; }\n          .daterangepicker.ltr .calendar.left .calendar-table {\n            border-right: none;\n            border-top-right-radius: 0;\n            border-bottom-right-radius: 0; }\n        .daterangepicker.ltr .calendar.right {\n          margin-left: 0;\n          float: right; }\n          .daterangepicker.ltr .calendar.right .calendar-table {\n            border-left: none;\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n            width: 100%; }\n      .daterangepicker.ltr .left .daterangepicker_input {\n        padding-right: 12px;\n        width: 100%; }\n      .daterangepicker.ltr .calendar.left .calendar-table {\n        width: 100%; }\n      .daterangepicker.ltr .ranges, .daterangepicker.ltr .calendar {\n        float: left;\n        width: inherit; }\n    .daterangepicker.rtl {\n      direction: rtl;\n      text-align: right; }\n      .daterangepicker.rtl .calendar.left {\n        clear: right;\n        margin-left: 0; }\n        .daterangepicker.rtl .calendar.left .calendar-table {\n          border-left: none;\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0; }\n      .daterangepicker.rtl .calendar.right {\n        margin-right: 0; }\n        .daterangepicker.rtl .calendar.right .calendar-table {\n          border-right: none;\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0; }\n      .daterangepicker.rtl .left .daterangepicker_input {\n        padding-left: 12px; }\n      .daterangepicker.rtl .calendar.left .calendar-table {\n        padding-left: 12px; }\n      .daterangepicker.rtl .ranges, .daterangepicker.rtl .calendar {\n        text-align: right;\n        float: right; } }\n\n@media (min-width: 730px) {\n  .daterangepicker .ranges {\n    width: auto; }\n  .daterangepicker.ltr .ranges {\n    float: left; }\n  .daterangepicker.rtl .ranges {\n    float: right; }\n  .daterangepicker .calendar.left {\n    clear: none !important; } }\n\n.datepicker-wrap input {\n  background-image: none; }\n\n.datepicker-wrap .ota-picker {\n  background-color: #fff;\n  border: 1px solid #ddd; }\n\n.datepicker-wrap .ota-picker-mask {\n  visibility: hidden;\n  position: absolute;\n  bottom: 0;\n  height: 0; }\n\n.no-touch .nextIcon:hover, .no-touch .prevIcon:hover {\n  cursor: pointer; }\n\n.prevIcon.radius {\n  border-radius: 4px 0 0 0; }\n\n.nextIcon.radius {\n  border-radius: 0 4px 0 0; }\n\n.datepicker-container {\n  position: relative; }\n  .datepicker-container .form-control.form-calendar {\n    padding-left: 29px;\n    background-image: none; }\n  .datepicker-container .fa-calendar {\n    float: right;\n    position: absolute;\n    right: 0;\n    top: 0;\n    margin: 10px;\n    font-size: 16px; }\n  .datepicker-container .calendar-icon {\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    top: 2px;\n    margin: 10px;\n    background-image: url(assets/images/icons/Date.png);\n    background-size: contain;\n    background-repeat: no-repeat;\n    cursor: pointer;\n    pointer-events: none; }\n\n.daterangepicker {\n  border-color: #042764;\n  margin-top: -1px; }\n  .daterangepicker.picker-state-start-pending td.available:hover {\n    background-color: #F3F6FC;\n    background-size: contain; }\n  .daterangepicker.picker-state-end-pending td.available:hover {\n    background: #F3F6FC; }\n  .daterangepicker.picker-state-start-pending td.active, .daterangepicker.picker-state-end-pending td.active {\n    background-color: #042764; }\n  .daterangepicker.picker-state-start-pending td.active:hover, .daterangepicker.picker-state-start-pending td.available:hover, .daterangepicker.picker-state-start-pending td.in-range:hover, .daterangepicker.picker-state-end-pending td.active:hover, .daterangepicker.picker-state-end-pending td.available:hover, .daterangepicker.picker-state-end-pending td.in-range:hover {\n    background-color: #3D6590; }\n  .daterangepicker.picker-state-start-pending td.active.start-date.off, .daterangepicker.picker-state-end-pending td.active.start-date.off {\n    background: #fff; }\n  .daterangepicker.picker-state-start-pending td.active.end-date.off, .daterangepicker.picker-state-end-pending td.active.end-date.off {\n    color: #fff; }\n  .daterangepicker.picker-state-start-pending td.otherMonth,\n  .daterangepicker.picker-state-start-pending td.otherMonth.active, .daterangepicker.picker-state-end-pending td.otherMonth,\n  .daterangepicker.picker-state-end-pending td.otherMonth.active {\n    color: #fff;\n    background: transparent; }\n  .no-touch .daterangepicker .close-icon:hover {\n    cursor: pointer; }\n  @media (max-width: 767px) {\n    .daterangepicker {\n      left: 25px !important;\n      width: calc(100% - 50px); }\n      .topwrap-layout .daterangepicker {\n        left: 20px !important;\n        width: calc(100% - 40px); }\n      .daterangepicker + .daterangepicker {\n        margin-top: 39px; }\n      .daterangepicker .bar-control .left {\n        width: calc(100% - 36px) !important;\n        vertical-align: middle !important; }\n      .daterangepicker .bar-control .right {\n        width: 36px !important;\n        vertical-align: middle !important; }\n        .daterangepicker .bar-control .right .month {\n          display: none !important; }\n      .daterangepicker .calendar {\n        max-width: 100%; }\n        .daterangepicker .calendar.right {\n          display: none; } }\n\n/* RESET-GENERAL STYLES\n–––––––––––––––––––––––––––––––––––––––––––––––––– */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box; }\n\nhtml {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%; }\n\nbody {\n  color: #061021;\n  font-family: Arial, Thonburi, tahoma, sans-serif;\n  font-size: 14px;\n  overflow-scrolling: touch;\n  -webkit-overflow-scrolling: touch; }\n  @media screen and (max-width: 767px) {\n    body {\n      cursor: pointer; } }\n  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n    body {\n      cursor: pointer; } }\n\n@media screen and (max-width: 768px) {\n  body.-lock-backdrop {\n    position: fixed; } }\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n  body.-lock-backdrop {\n    position: fixed; } }\n\nul,\nli {\n  list-style-type: none; }\n\na,\nbutton {\n  text-decoration: none; }\n  a:hover, a:focus,\n  button:hover,\n  button:focus {\n    text-decoration: none;\n    outline: none; }\n\nimg {\n  width: auto \\9;\n  height: auto;\n  max-width: 100%;\n  vertical-align: middle;\n  border: 0;\n  -ms-interpolation-mode: bicubic;\n  page-break-inside: avoid; }\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n  font-weight: normal;\n  font-style: normal; }\n\n/* Touch Class Setup STYLES\nSetting for Touch Class System.\n–––––––––––––––––––––––––––––––––––––––––––––––––– */\n.touch a,\n.touch button,\n.touch .btn,\n.touch .button,\n.touch select {\n  cursor: default;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.touch label {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  .touch label span {\n    cursor: default; }\n\n.no-touch a,\n.no-touch button,\n.no-touch .btn,\n.no-touch .button,\n.no-touch select {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.no-touch label {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  .no-touch label span {\n    cursor: pointer; }\n\nlabel:active {\n  background-color: inherit; }\n\n/* CLASS-GENERAL STYLES\n–––––––––––––––––––––––––––––––––––––––––––––––––– */\n.clearfix:before, .clearfix:after {\n  content: \"\";\n  display: table; }\n\n.clearfix:after {\n  clear: both; }\n\n.box-overflow,\n.wrap-inner {\n  overflow: hidden; }\n\n.wrap-inner,\n.wrap-inner-auto {\n  width: 100%;\n  max-width: 1140px;\n  margin: 0 auto;\n  padding: 0 15px; }\n  .wrap-inner.-extra-width,\n  .wrap-inner-auto.-extra-width {\n    max-width: 1200px; }\n\n.thumb-circle {\n  border-radius: 50% ; }\n\n.font-24px {\n  font-size: 24px; }\n\n.font-22px {\n  font-size: 22px; }\n\n.font-20px {\n  font-size: 20px; }\n\n.font-18px {\n  font-size: 18px; }\n\n.font-16px {\n  font-size: 16px; }\n\n.font-14px {\n  font-size: 14px; }\n\n.font-12px {\n  font-size: 12px; }\n\n.color-white {\n  color: #FFFFFF; }\n\n.color-main {\n  color: #061021; }\n\n.color-sub {\n  color: #6b778c; }\n\n.color-red {\n  color: #ed1c24; }\n\n.color-green {\n  color: #45ae59; }\n\n.link-default {\n  color: #003a90; }\n\n.pull-left,\n.pull-left-lg {\n  float: left; }\n\n.pull-right {\n  float: right; }\n\n.text-center {\n  text-align: center; }\n  .text-center .color-main {\n    margin-bottom: 0px; }\n\n.show-sm {\n  display: none; }\n\n.hide {\n  display: none; }\n\n.text-inline {\n  display: inline; }\n\n.inline-block {\n  display: inline-block; }\n\n/* icon star */\n.icon-star-level {\n  background-color: transparent;\n  background-image: url(\"assets/images/main/icon_star.svg\");\n  background-repeat: no-repeat;\n  background-position: 0 0;\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  overflow: hidden;\n  margin: -7px 2px 0 0;\n  vertical-align: middle;\n  background-size: 20px 20px; }\n  .icon-star-level.-half {\n    width: 10px; }\n\n.icon-star-level-s {\n  font-size: 16px;\n  display: inline-block;\n  color: #ffcc33;\n  margin: 0 1px; }\n  .icon-star-level-s.-half {\n    width: 8px;\n    overflow: hidden;\n    vertical-align: top; }\n\n.hotel-star-container {\n  display: inline-block; }\n  .hotel-star-container .hotel-star {\n    display: inline-block;\n    margin: 0 2px 0 0;\n    font-size: 16px;\n    color: #facc48;\n    width: 16px; }\n    .hotel-star-container .hotel-star.-half {\n      width: 8px;\n      overflow: hidden;\n      display: -ms-inline-flexbox;\n      display: inline-flex; }\n\n.filter-block {\n  background-color: #f6f8f9;\n  display: inline-block;\n  height: 40px;\n  min-width: 22%;\n  margin-bottom: 15px;\n  padding: 12px 10px;\n  color: #103058;\n  text-align: center;\n  cursor: pointer; }\n  .filter-block.less-than {\n    width: 25%; }\n  .filter-block:hover, .filter-block.active {\n    background-color: #e4edff;\n    color: #003a90; }\n  .filter-block.mobile {\n    min-width: 65px;\n    height: 44px;\n    width: 22%; }\n    .filter-block.mobile:hover {\n      background-color: #f6f8f9; }\n    .filter-block.mobile.active {\n      background-color: #e4edff; }\n\n.filter-clear-btn {\n  float: right;\n  font-size: 14px;\n  color: #003a90; }\n  .filter-clear-btn:hover, .filter-clear-btn :active {\n    color: #042764;\n    text-decoration: underline; }\n\n/* button */\n.ota-btn-main {\n  background-color: #ed1c24;\n  color: #FFFFFF;\n  width: 100%;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 40px;\n  height: 40px;\n  margin: 0 0 20px 0;\n  cursor: pointer; }\n  .ota-btn-main.disable {\n    background-color: #DFE1E6; }\n  .ota-btn-main.transparent {\n    background-color: transparent;\n    color: #ed1c24;\n    border: 1px solid #ed1c24; }\n  .no-touch .ota-btn-main:hover,\n  .touch .ota-btn-main.touch {\n    background-color: #E40000; }\n  .ota-btn-main.-line {\n    color: #ed1c24;\n    border: 1px solid #ed1c24;\n    background-color: #FFFFFF; }\n    .no-touch .ota-btn-main.-line:hover,\n    .touch .ota-btn-main.-line.touch {\n      color: #FFFFFF;\n      background-color: #E40000; }\n\n.dialog-ota-btn-main {\n  background-color: #ed1c24;\n  color: #FFFFFF;\n  width: 160px;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 40px;\n  height: 40px;\n  cursor: pointer;\n  border: none; }\n  .dialog-ota-btn-main:hover {\n    background-color: #E40000; }\n  .dialog-ota-btn-main:active {\n    background-color: #ed1c24; }\n  @media screen and (max-width: 767px) {\n    .dialog-ota-btn-main {\n      width: 100%;\n      background-color: white;\n      border-radius: 0;\n      color: #042764;\n      border-top: 1px solid #dfe1e6;\n      margin-bottom: 0;\n      height: 50px;\n      line-height: 50px; }\n      .dialog-ota-btn-main:hover {\n        background-color: white;\n        color: #042764;\n        text-decoration: underline; }\n      .dialog-ota-btn-main:active {\n        background-color: white;\n        color: #042764; } }\n\n.ota-btn-sub {\n  border: 1px solid #dfe1e6;\n  background-color: #FFFFFF;\n  width: 100%;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 38px; }\n  .no-touch .ota-btn-sub:hover,\n  .touch .ota-btn-sub.touch {\n    background-color: #f6f8f9; }\n\n.ota-btn-default {\n  background-color: #FFFFFF;\n  color: #061021;\n  width: 100%;\n  border: 1px solid #DFE1E6;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 40px; }\n  .ota-btn-default:hover {\n    background-color: #f6f8f9; }\n  .ota-btn-default:active {\n    background-color: #dfe1e6; }\n\n.line-dot-top {\n  border-top: 1px dotted #DFE1E6; }\n\n.box-grey {\n  background-color: #f5f5f5;\n  padding: 15px 0 0; }\n\n/* pagination */\n.ota-pagination-lg {\n  margin: 10px auto;\n  margin-bottom: 0px;\n  overflow: hidden; }\n  .ota-pagination-lg.-desktop {\n    display: block; }\n    @media screen and (max-width: 767px) {\n      .ota-pagination-lg.-desktop {\n        display: none; } }\n  .ota-pagination-lg.-mobile {\n    display: none; }\n    @media screen and (max-width: 767px) {\n      .ota-pagination-lg.-mobile {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n        width: 100%; } }\n    .ota-pagination-lg.-mobile .pagination-text-page-number {\n      line-height: 2.5;\n      margin: 0 10px; }\n    .ota-pagination-lg.-mobile .next-page,\n    .ota-pagination-lg.-mobile .prev-page {\n      margin: 0; }\n  .ota-pagination-lg .pagination-text-page-number {\n    background-color: transparent !important;\n    width: auto;\n    border: 0;\n    vertical-align: middle; }\n  .ota-pagination-lg.center {\n    width: 445px;\n    margin: 10px auto; }\n  .ota-pagination-lg .dott-style {\n    background-color: transparent !important;\n    width: 15px;\n    height: 40px;\n    -ms-flex-align: center;\n        align-items: center;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    border: none; }\n    .ota-pagination-lg .dott-style a, .ota-pagination-lg .dott-style:active {\n      background-color: transparent !important; }\n  .ota-pagination-lg.-active a {\n    color: white !important; }\n  .ota-pagination-lg.-active span:hover,\n  .ota-pagination-lg.-active li:hover {\n    background-color: inherit; }\n  .ota-pagination-lg .-disabled-button {\n    cursor: default !important;\n    pointer-events: none;\n    background-color: #DFE1E6 !important; }\n    .ota-pagination-lg .-disabled-button a,\n    .ota-pagination-lg .-disabled-button i {\n      color: #A5ADBA !important;\n      cursor: default !important; }\n  .ota-pagination-lg li,\n  .ota-pagination-lg span,\n  .ota-pagination-lg button {\n    width: 37px;\n    border: 1px solid #DFE1E6;\n    float: left;\n    margin: 0 5px;\n    border-radius: 4px;\n    background-color: #FFFFFF; }\n    .ota-pagination-lg li.ctrl-page,\n    .ota-pagination-lg span.ctrl-page,\n    .ota-pagination-lg button.ctrl-page {\n      width: 90px;\n      height: 40px; }\n    .ota-pagination-lg li.prev-page,\n    .ota-pagination-lg span.prev-page,\n    .ota-pagination-lg button.prev-page {\n      margin: 0 15px 0 0; }\n    .ota-pagination-lg li.next-page,\n    .ota-pagination-lg span.next-page,\n    .ota-pagination-lg button.next-page {\n      margin: 0 0 0 5px; }\n    .ota-pagination-lg li a,\n    .ota-pagination-lg span a,\n    .ota-pagination-lg button a {\n      color: #061021;\n      display: block;\n      text-align: center;\n      line-height: 2.5; }\n      .ota-pagination-lg li a.active, .ota-pagination-lg li a:active,\n      .ota-pagination-lg span a.active,\n      .ota-pagination-lg span a:active,\n      .ota-pagination-lg button a.active,\n      .ota-pagination-lg button a:active {\n        color: #FFFFFF !important; }\n        .ota-pagination-lg li a.active i, .ota-pagination-lg li a:active i,\n        .ota-pagination-lg span a.active i,\n        .ota-pagination-lg span a:active i,\n        .ota-pagination-lg button a.active i,\n        .ota-pagination-lg button a:active i {\n          color: #FFFFFF !important; }\n      .ota-pagination-lg li a i,\n      .ota-pagination-lg span a i,\n      .ota-pagination-lg button a i {\n        color: #959595;\n        font-size: 16px;\n        position: relative;\n        top: 2px; }\n    .no-touch .ota-pagination-lg li:hover,\n    .touch .ota-pagination-lg li.touch, .no-touch\n    .ota-pagination-lg span:hover,\n    .touch\n    .ota-pagination-lg span.touch, .no-touch\n    .ota-pagination-lg button:hover,\n    .touch\n    .ota-pagination-lg button.touch {\n      background-color: #f6f8f9; }\n    .touch .ota-pagination-lg li.touch, .ota-pagination-lg li.-active, .ota-pagination-lg li:active, .touch\n    .ota-pagination-lg span.touch,\n    .ota-pagination-lg span.-active,\n    .ota-pagination-lg span:active, .touch\n    .ota-pagination-lg button.touch,\n    .ota-pagination-lg button.-active,\n    .ota-pagination-lg button:active {\n      border-color: #042764 !important;\n      background-color: #042764 !important; }\n    .ota-pagination-lg li.-active:hover,\n    .ota-pagination-lg span.-active:hover,\n    .ota-pagination-lg button.-active:hover {\n      background-color: #042764; }\n  .ota-pagination-lg.detailless {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    width: 100%; }\n    .ota-pagination-lg.detailless .pagination-text-page-number {\n      line-height: 2.5;\n      -ms-flex-item-align: center;\n          -ms-grid-row-align: center;\n          align-self: center; }\n    .ota-pagination-lg.detailless .ctrl-page .prev-page {\n      margin-left: auto; }\n\n.pagination-wrapper.-ipad-mobile .ota-pagination-lg.-desktop {\n  display: block; }\n  @media screen and (max-width: 1154px) {\n    .pagination-wrapper.-ipad-mobile .ota-pagination-lg.-desktop {\n      display: none; } }\n\n.pagination-wrapper.-ipad-mobile .ota-pagination-lg.-mobile {\n  display: none; }\n  @media screen and (max-width: 1154px) {\n    .pagination-wrapper.-ipad-mobile .ota-pagination-lg.-mobile {\n      display: block; } }\n  @media screen and (max-width: 767px) {\n    .pagination-wrapper.-ipad-mobile .ota-pagination-lg.-mobile {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n      width: 100%; } }\n  .pagination-wrapper.-ipad-mobile .ota-pagination-lg.-mobile .pagination-text-page-number {\n    line-height: 2.5;\n    margin: 0 10px; }\n  .pagination-wrapper.-ipad-mobile .ota-pagination-lg.-mobile .next-page,\n  .pagination-wrapper.-ipad-mobile .ota-pagination-lg.-mobile .prev-page {\n    margin: 0; }\n\n@media screen and (max-width: 767px) {\n  .productlists-page .pagination-wrapper {\n    padding: 0 10px; } }\n\n.icon-prev,\n.icon-next {\n  background-size: 100%;\n  width: 8px;\n  height: 16px;\n  display: inline-block;\n  overflow: hidden;\n  margin: -4px 2px 0 2px;\n  vertical-align: middle; }\n\n.icon-prev {\n  background-color: transparent;\n  background-image: url(\"assets/images/main/arrow_page_left.png\");\n  background-repeat: no-repeat;\n  background-position: 0 0; }\n\n.icon-next {\n  background-color: transparent;\n  background-image: url(\"assets/images/main/arrow_page_right.png\");\n  background-repeat: no-repeat;\n  background-position: 0 0; }\n\n.ota-pagination-sm {\n  display: none; }\n\n@media screen and (max-width: 767px) {\n  .show-sm {\n    display: block; }\n  .hide-sm {\n    display: none !important; }\n  .pull-left-lg {\n    float: none; }\n  .box-grey {\n    padding: 0; }\n  /* pagination */\n  .ota-pagination-lg {\n    display: -ms-flexbox;\n    display: flex; }\n  .ota-pagination-sm {\n    display: block;\n    margin: 15px 10px 30px 10px;\n    overflow: hidden; }\n    .ota-pagination-sm li {\n      float: left;\n      text-align: center; }\n      .ota-pagination-sm li.text-page {\n        width: 40%;\n        line-height: 2.9; }\n      .ota-pagination-sm li.ctrl-page {\n        width: 30%; }\n        .ota-pagination-sm li.ctrl-page a {\n          border: 1px solid #DFE1E6;\n          color: #061021;\n          background-color: #FFFFFF;\n          display: block;\n          text-align: center;\n          line-height: 2.75; } }\n\ninput[type=\"radio\"] {\n  margin: 3px 0 0; }\n\ninput {\n  outline: 0; }\n\n.form-group,\n.form-group-inline {\n  position: relative; }\n  .form-group label,\n  .form-group-inline label {\n    color: #061021;\n    font-weight: normal;\n    font-size: 14px; }\n\n.form-group-inline label {\n  min-width: 100px; }\n\n.form-group-inline .form-control,\n.form-group-inline .select-ota-style {\n  display: inline-block;\n  vertical-align: middle; }\n\n.form-control {\n  border-radius: 0 ;\n  border-color: #DFE1E6;\n  box-shadow: none;\n  color: #061021;\n  -moz-appearance: none;\n       appearance: none;\n  border-radius: 4px;\n  height: 40px;\n  -ms-flex-align: center;\n      align-items: center; }\n  .form-control.form-calendar {\n    background-color: #FFFFFF;\n    background-image: url(\"assets/images/form/icon_calendar.png\");\n    background-repeat: no-repeat;\n    background-position: calc(100% - 10px) center; }\n    .form-control.form-calendar.active {\n      border-color: #003a90; }\n  .form-control.form-select {\n    background-color: #FFFFFF;\n    background-image: url(\"assets/images/form/Down.svg\");\n    background-repeat: no-repeat;\n    background-position: calc(100% - 10px) center; }\n  .form-control.box-sm {\n    width: 120px;\n    margin-right: 10px; }\n  .form-control.active, .form-control:focus {\n    border-color: #003a90;\n    box-shadow: none; }\n  .form-control[disabled] {\n    opacity: 1;\n    -webkit-opacity: 1;\n    background-color: #f5f5f5;\n    color: #061021;\n    -webkit-text-fill-color: #061021;\n    border-color: #DFE1E6; }\n  .form-control::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    color: #dfe1e6; }\n  .form-control::-moz-placeholder {\n    /* Firefox 19+ */\n    color: #dfe1e6; }\n  .form-control:-ms-input-placeholder {\n    /* IE 10+ */\n    color: #dfe1e6; }\n  .form-control:-moz-placeholder {\n    /* Firefox 18- */\n    color: #dfe1e6; }\n\n.radio {\n  margin: 0 0 15px 0; }\n  .radio .radio-wrapper {\n    width: 300px;\n    height: auto;\n    display: -ms-flexbox;\n    display: flex; }\n    @media screen and (max-width: 767px) {\n      .radio .radio-wrapper {\n        -ms-flex-pack: end;\n            justify-content: flex-end; } }\n  .radio .radio-inline {\n    color: #061021;\n    font-weight: normal;\n    font-size: 14px;\n    padding-left: 20px; }\n    @media screen and (max-width: 767px) {\n      .CHROME.ANDRIOD .radio .radio-inline input {\n        top: -2px; } }\n    @media screen and (max-width: 767px) {\n      .CHROME.ANDRIOD .radio .radio-inline .tooltips {\n        top: 2px; } }\n    @media screen and (max-width: 767px) {\n      .CHROME.ANDRIOD .radio .radio-inline {\n        top: 1px; }\n      .CHROME.ANDRIOD .radio .radio-inline.no-paddingleft {\n        top: 0px; } }\n\n.select-ota-style {\n  padding: 0;\n  margin: 0;\n  overflow: hidden; }\n  .select-ota-style select {\n    background-color: #FFFFFF;\n    background-image: url(\"assets/images/form/Down.svg\");\n    background-repeat: no-repeat;\n    background-position: calc(100% - 10px) center;\n    font-size: 14px;\n    color: #061021;\n    padding: 0 12px;\n    height: 40px;\n    width: 100%;\n    border: none;\n    box-shadow: none;\n    -moz-appearance: none;\n    appearance: none;\n    border: 1px solid #DFE1E6;\n    border-radius: 4px; }\n    .select-ota-style select:focus {\n      outline: none; }\n    .select-ota-style select:hover {\n      border: 1px solid #003a90; }\n    .select-ota-style select:disabled, .select-ota-style select:disabled:hover {\n      cursor: not-allowed;\n      background-color: #f5f5f5;\n      background-image: url(\"assets/images/form/Down.svg\");\n      background-repeat: no-repeat;\n      background-position: calc(100% - 10px) center;\n      border: 1px solid #DFE1E6;\n      opacity: 1; }\n  .select-ota-style option :hover {\n    background-color: #e4edff; }\n  .select-ota-style.box-sm {\n    width: 120px;\n    margin-right: 10px; }\n\nselect:focus {\n  border-color: #003a90; }\n\n/* search popup */\n.form-group-pop {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  top: 59px;\n  z-index: 2; }\n  .form-group-pop .close-pop {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    z-index: 3;\n    font-size: 20px;\n    color: #DFE1E6; }\n    .form-group-pop .close-pop span {\n      display: block; }\n    .no-touch .form-group-pop .close-pop:hover,\n    .touch .form-group-pop .close-pop.touch {\n      color: #6b778c; }\n\n.select-room-popup-container {\n  display: none; }\n  .select-room-popup-container.-right {\n    left: auto;\n    right: 0; }\n  .select-room-popup-container.-show {\n    display: block; }\n\n.select-room-popup {\n  position: absolute;\n  right: 0;\n  margin-top: 10px;\n  width: 590px;\n  background-color: #FFFFFF;\n  border-radius: 4px;\n  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.4); }\n\n.select-room-box {\n  padding: 15px;\n  border-bottom: 1px solid #DFE1E6; }\n\n.selcet-detail-room-box {\n  padding: 15px; }\n  .selcet-detail-room-box .tab-detail-room-list {\n    overflow-y: hidden;\n    position: relative;\n    z-index: 2;\n    padding-right: 98px;\n    height: 38px; }\n    .selcet-detail-room-box .tab-detail-room-list ul {\n      border-left: 1px solid #DFE1E6;\n      overflow-y: auto;\n      margin-bottom: 0px;\n      white-space: nowrap;\n      height: 80px; }\n      .selcet-detail-room-box .tab-detail-room-list ul li {\n        display: inline-block;\n        border-top: 1px solid #DFE1E6;\n        border-right: 1px solid #DFE1E6;\n        border-bottom: 1px solid #DFE1E6;\n        width: 99px;\n        height: 38px; }\n        .selcet-detail-room-box .tab-detail-room-list ul li a {\n          display: block;\n          text-align: center;\n          height: 100%;\n          text-decoration: none;\n          line-height: 38px;\n          color: #061021;\n          background-color: #FFFFFF; }\n        .selcet-detail-room-box .tab-detail-room-list ul li.active {\n          border-bottom: none; }\n          .selcet-detail-room-box .tab-detail-room-list ul li.active a {\n            background-color: #f6f8f9; }\n  .selcet-detail-room-box .wrapper-arrow-btn {\n    position: absolute;\n    top: 0;\n    right: 0; }\n  .selcet-detail-room-box .next,\n  .selcet-detail-room-box .prev {\n    float: left;\n    width: 49px;\n    border-top: 1px solid #DFE1E6;\n    border-bottom: 1px solid #DFE1E6;\n    border-right: 1px solid #DFE1E6;\n    background-color: white; }\n    .selcet-detail-room-box .next a,\n    .selcet-detail-room-box .prev a {\n      display: block;\n      text-align: center;\n      height: 36px;\n      text-decoration: none;\n      line-height: 38px; }\n      .no-touch .selcet-detail-room-box .next a:hover,\n      .touch .selcet-detail-room-box .next a.touch, .no-touch\n      .selcet-detail-room-box .prev a:hover,\n      .touch\n      .selcet-detail-room-box .prev a.touch {\n        background-color: #f6f8f9; }\n    .selcet-detail-room-box .next.disable a,\n    .selcet-detail-room-box .prev.disable a {\n      opacity: 0.4;\n      background-color: white !important; }\n    .selcet-detail-room-box .next .icon-arrow-left,\n    .selcet-detail-room-box .next .icon-arrow-right,\n    .selcet-detail-room-box .prev .icon-arrow-left,\n    .selcet-detail-room-box .prev .icon-arrow-right {\n      color: #6b778c;\n      font-size: 16px; }\n  .selcet-detail-room-box .next {\n    border-left: 1px solid #DFE1E6; }\n  .selcet-detail-room-box .content-detail-room-list {\n    margin-top: -1px;\n    background-color: #f6f8f9;\n    border: 1px solid #DFE1E6; }\n    .selcet-detail-room-box .content-detail-room-list .box-overflow {\n      padding: 15px 15px 0 15px; }\n\n.ota-checkbox {\n  padding: 3px 10px 0 10px;\n  /* Base for label styling */\n  /* checkbox aspect */\n  /* checkbox aspect */\n  /* checked mark aspect */\n  /* disabled checkbox */ }\n  .ota-checkbox:hover, .ota-checkbox.active {\n    background-color: #e4edff; }\n  .ota-checkbox [type=\"checkbox\"]:not(:checked),\n  .ota-checkbox [type=\"checkbox\"]:checked {\n    position: absolute;\n    left: -9999px; }\n  .ota-checkbox [type=\"checkbox\"]:not(:checked) + label,\n  .ota-checkbox [type=\"checkbox\"]:checked + label {\n    position: relative;\n    padding-left: 25px;\n    cursor: pointer;\n    width: 100%;\n    color: #061021;\n    font-weight: normal;\n    line-height: 33px;\n    margin-bottom: 0;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale; }\n  .ota-checkbox [type=\"checkbox\"]:not(:checked) + label:before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 7px;\n    width: 16px;\n    height: 16px;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    background: #FFFFFF;\n    border-radius: 3px; }\n  .ota-checkbox [type=\"checkbox\"]:checked + label:before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 7px;\n    width: 16px;\n    height: 16px;\n    border: 1px solid #2f91fc;\n    background: #3a9afc;\n    border-radius: 3px; }\n  .ota-checkbox [type=\"checkbox\"]:checked + label:after {\n    content: url(\"assets/images/icons/icon-checked-active.svg\");\n    position: absolute;\n    top: 7px;\n    left: 4px;\n    font-size: 16px;\n    line-height: 1;\n    color: #FFFFFF;\n    transition: all 0.2s; }\n  .ota-checkbox [type=\"checkbox\"]:disabled:not(:checked) + label:before,\n  .ota-checkbox [type=\"checkbox\"]:disabled:checked + label:before {\n    box-shadow: none;\n    border-color: #cccccc;\n    background: #dfe1e6; }\n  .ota-checkbox [type=\"checkbox\"]:disabled:checked + label:after {\n    content: url(\"assets/images/icons/icon-checked.svg\");\n    color: #061021; }\n  .ota-checkbox [type=\"checkbox\"]:disabled + label {\n    color: #aaa; }\n\n.ota-radio {\n  padding: 10px;\n  /* checked */\n  /* disabled */ }\n  .ota-radio:hover, .ota-radio.active {\n    background-color: #e4edff; }\n  .ota-radio [type=\"radio\"]:not(:checked),\n  .ota-radio [type=\"radio\"]:checked {\n    position: absolute;\n    left: -9999px !important; }\n  .ota-radio [type=\"radio\"]:not(:checked) + label,\n  .ota-radio [type=\"radio\"]:checked + label {\n    position: relative;\n    padding-left: 25px;\n    cursor: pointer;\n    width: 100%;\n    color: #061021;\n    font-weight: normal;\n    line-height: 33px;\n    margin-bottom: 0;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale; }\n  .ota-radio [type=\"radio\"]:not(:checked) + label:before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 7px;\n    width: 16px;\n    height: 16px;\n    background: #FFFFFF;\n    border-radius: 50%;\n    border: 0.5px solid rgba(0, 0, 0, 0.2);\n    box-shadow: inset 0 0.5px 1px 0 rgba(0, 0, 0, 0.25); }\n  .ota-radio [type=\"radio\"]:checked + label:before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 7px;\n    width: 16px;\n    height: 16px;\n    border: 1px solid #2f91fc;\n    background: #3a9afc;\n    border-radius: 50%; }\n  .ota-radio [type=\"radio\"]:checked + label:after {\n    content: \"\";\n    position: absolute;\n    background: #FFFFFF;\n    top: 12px;\n    left: 5px;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%; }\n  .ota-radio [type=\"radio\"]:disabled:not(:checked) + label:before,\n  .ota-radio [type=\"radio\"]:disabled:checked + label:before {\n    box-shadow: none;\n    border-color: #A5ADBA;\n    background: #DFE1E6; }\n  .ota-radio [type=\"radio\"]:disabled:checked + label:after {\n    content: url(\"assets/images/icons/icon-checked.svg\");\n    color: #061021; }\n  .ota-radio [type=\"radio\"]:disabled + label {\n    color: #aaa; }\n\n.button-group {\n  display: -ms-flexbox;\n  display: flex; }\n  .button-group .btn-horizontal {\n    margin-bottom: 0; }\n    .button-group .btn-horizontal:last-child {\n      margin-left: 10px; }\n\n@media screen and (max-width: 767px) {\n  .form-group .pull-left,\n  .form-group .pull-right {\n    width: 50%; }\n  .form-group .pull-right .form-calendar {\n    float: right; }\n  .form-group .col-left,\n  .form-group .col-right {\n    width: 49%; }\n  .form-control {\n    padding: 6px 7px; }\n    .form-control.form-calendar {\n      /*width:calc(100% - 5px);*/ }\n    .form-control.form-calendar, .form-control.form-select {\n      background-position: calc(100% - 7px) center; }\n  .form-group-pop {\n    width: 100%; }\n  .select-room-popup {\n    width: 100%;\n    border: none;\n    border-radius: 4px; }\n    .select-room-popup .close-pop {\n      display: none; }\n  .select-room-box {\n    border-bottom: none;\n    overflow: hidden; }\n    .select-room-box label {\n      float: left;\n      min-width: 75px;\n      line-height: 34px; }\n    .select-room-box .select-ota-style {\n      float: left; }\n  .selcet-detail-room-box {\n    padding: 0; }\n    .selcet-detail-room-box .tab-detail-room-list {\n      padding-right: 0; }\n      .selcet-detail-room-box .tab-detail-room-list ul {\n        width: calc(100% - 71px); }\n        .selcet-detail-room-box .tab-detail-room-list ul li {\n          width: 33.33%; }\n    .selcet-detail-room-box .next,\n    .selcet-detail-room-box .prev {\n      width: 36px; }\n    .selcet-detail-room-box .content-detail-room-list .box-overflow {\n      padding: 15px 5px 0 5px; }\n    .selcet-detail-room-box .content-detail-room-list label {\n      margin-left: 5px; }\n    .selcet-detail-room-box .content-detail-room-list .select-ota-style.box-sm {\n      width: calc(100% - 10px);\n      margin-left: 5px;\n      margin-right: 5px; } }\n\nhtml {\n  /* ------------ Material Menu ------------*/\n  /* ------------ Material Dialog ------------*/\n  /* SLIDENAV STYLES - fullPage.js\n  –––––––––––––––––––––––––––––––––––––––––––––––––– */ }\n  @media screen and (max-width: 767px) {\n    html.fp-enabled {\n      overflow: auto;\n      overflow: initial;\n      height: auto;\n      height: initial; } }\n  html .mat-menu-content {\n    padding-top: 0;\n    padding-bottom: 0; }\n  html .mat-dialog-container {\n    padding: 0;\n    background-color: transparent;\n    box-shadow: none;\n    max-width: 100vw;\n    z-index: 9999; }\n    html .mat-dialog-container .dialog-container {\n      z-index: 2; }\n  html .cdk-global-overlay-wrapper > .cdk-overlay-pane {\n    height: 100vh; }\n  html .cdk-global-overlay-wrapper .mat-dialog-container {\n    box-shadow: none;\n    background-color: transparent; }\n    html .cdk-global-overlay-wrapper .mat-dialog-container .mat-dialog-content {\n      position: relative;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-pack: center;\n          justify-content: center;\n      -ms-flex-align: center;\n          align-items: center;\n      width: 100vw;\n      min-height: 100vh;\n      max-height: 100vh;\n      padding: 40px 10px;\n      margin: 0;\n      overflow-x: hidden; }\n      @media screen and (max-width: 767px) {\n        html .cdk-global-overlay-wrapper .mat-dialog-container .mat-dialog-content {\n          padding-top: 60px;\n          padding-bottom: 80px;\n          display: block;\n          overflow-scrolling: touch;\n          -webkit-overflow-scrolling: touch; } }\n      html .cdk-global-overlay-wrapper .mat-dialog-container .mat-dialog-content .dialog-btn-film {\n        display: block;\n        -moz-appearance: none;\n             appearance: none;\n        border: 0;\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100vh;\n        width: 100vw;\n        background-color: transparent;\n        cursor: default;\n        z-index: 1; }\n  @media screen and (max-width: 1024px) {\n    html.IOS .cdk-global-overlay-wrapper > .cdk-overlay-pane {\n      position: relative !important; } }\n  html.lt-ie10 .cdk-global-overlay-wrapper > .cdk-overlay-pane {\n    height: 100vh;\n    position: relative !important; }\n  html.lt-ie10 .cdk-global-overlay-wrapper .mat-dialog-container .mat-dialog-content {\n    padding-top: 100px; }\n  html #fp-nav {\n    z-index: 1000; }\n  html #fp-nav ul li,\n  html .fp-slidesNav ul li {\n    margin: 15px; }\n  html #fp-nav ul li a span,\n  html .fp-slidesNav ul li a span {\n    background: rgba(221, 221, 221, 0.8);\n    width: 6px;\n    height: 6px;\n    margin: -3px 0 0 -3px; }\n  html #fp-nav ul li a.active span,\n  html .fp-slidesNav ul li a.active span,\n  html #fp-nav ul li:hover a.active span,\n  html .fp-slidesNav ul li:hover a.active span {\n    background: #ed1c24;\n    width: 6px;\n    height: 6px;\n    margin: -3px 0 0 -3px; }\n  html #fp-nav ul li:last-child {\n    display: none; }\n  @media screen and (max-width: 767px) {\n    html #fp-nav.right {\n      right: 0; } }\n\n.list-sub-menu {\n  padding-top: 48px;\n  position: relative;\n  z-index: 99;\n  width: 230px; }\n  .list-sub-menu .mat-menu-content {\n    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.4); }\n  .list-sub-menu.-fluid-width {\n    width: auto;\n    min-width: auto;\n    max-width: auto; }\n  .list-sub-menu li {\n    background: #FFFFFF; }\n    .list-sub-menu li a {\n      display: block;\n      width: 100%;\n      padding: 0 16px;\n      line-height: 40px;\n      height: 40px;\n      border-bottom: 1px solid #DFE1E6;\n      color: #061021; }\n      .list-sub-menu li a:last-child {\n        border-bottom: 0; }\n      .no-touch .list-sub-menu li a:hover,\n      .touch .list-sub-menu li a.touch {\n        background: #e4edff; }\n  .list-sub-menu.r-16 {\n    right: 16px !important; }\n\nhtml body {\n  transition: 0.4s;\n  position: relative;\n  left: 0%;\n  height: 100%; }\n\nhtml.-open-sidemenu {\n  overflow: hidden; }\n  html.-open-sidemenu body {\n    position: relative;\n    left: calc(-100% + 49px); }\n  html.-open-sidemenu .landing-page .header-wrap {\n    left: calc(-100% + 49px) !important; }\n  html.-open-sidemenu .m-list-menu-space {\n    visibility: visible;\n    opacity: 1; }\n  html.-open-sidemenu .m-list-menu-wrap {\n    transform: translate3d(0, 0, 0); }\n  html.-open-sidemenu .icon-navbar-toggle {\n    color: white !important; }\n  html.-open-sidemenu .header-white .icon-navbar-toggle {\n    color: #042764 !important; }\n\n/* slider\n----------------------------------------------------------*/\n.slider > * {\n  max-width: 100%; }\n\n.slider .slide-prev,\n.slider .slide-next {\n  cursor: pointer;\n  height: 48px;\n  width: 48px;\n  position: absolute;\n  top: 50%;\n  margin-top: -24px;\n  background-color: rgba(255, 255, 255, 0.8);\n  padding: 0px;\n  opacity: 0.8; }\n  .slider .slide-prev:before,\n  .slider .slide-next:before {\n    display: block;\n    width: 48px;\n    height: 48px;\n    font-size: 40px;\n    line-height: 50px;\n    text-align: center;\n    font-family: \"BenchNine\", sans-serif;\n    position: absolute; }\n  .no-touch .slider .slide-prev:hover,\n  .touch .slider .slide-prev.touch, .no-touch\n  .slider .slide-next:hover,\n  .touch\n  .slider .slide-next.touch {\n    background-color: rgba(255, 255, 255, 0.9); }\n\n.slider .slide-prev {\n  left: 0; }\n  .slider .slide-prev:before {\n    content: \"<\"; }\n\n.slider .slide-next {\n  right: 0; }\n  .slider .slide-next:before {\n    left: 3px;\n    /* for better central alignment */\n    content: \">\"; }\n\n.es-caption {\n  position: absolute;\n  bottom: 0;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: #FFFFFF;\n  font-size: 14px;\n  padding: 16px;\n  margin: 10px;\n  width: auto;\n  left: 0;\n  right: 0;\n  border-radius: 6px;\n  -moz-border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -khtml-border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.3); }\n\nul.es-pager {\n  display: block;\n  width: 100%;\n  text-align: center;\n  margin: 20px 0 0 0;\n  padding: 0;\n  line-height: 0px; }\n\nul.es-pager li {\n  display: inline-block;\n  margin: 2px 6px;\n  padding: 0;\n  height: 6px;\n  width: 6px;\n  cursor: pointer;\n  background-color: #c6ccd2;\n  border-radius: 6px;\n  -moz-border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -khtml-border-radius: 6px; }\n\nul.es-pager li:hover,\nul.es-pager li.act {\n  background-color: #cc1b1f; }\n\nul.es-pager li.act {\n  cursor: default; }\n\n@media screen and (max-height: 760px) {\n  #section4 .wrap-inner,\n  #section5 .wrap-inner,\n  #section6 .wrap-inner {\n    padding-top: 100px; } }\n\n@media screen and (max-width: 767px) {\n  #fp-nav {\n    display: none !important; }\n  #section4 .wrap-inner,\n  #section5 .wrap-inner,\n  #section6 .wrap-inner {\n    padding-top: 0; }\n  .wrap-inner,\n  .wrap-inner-auto {\n    box-sizing: border-box;\n    padding: 10px; }\n  #fullpage h2 {\n    font-size: 30px; }\n  .fp-tableCell {\n    padding-top: 48px; }\n  /* page 1 */\n  #section1 .fp-tableCell {\n    padding-top: 0; }\n  #section1 h2 {\n    width: 220px;\n    margin: 0 auto 10px auto; }\n  #section1 h3 {\n    font-size: 16px;\n    width: 300px;\n    margin: 0 auto; }\n  #section2 h3 {\n    font-size: 18px; }\n  #section3 .fp-tableCell,\n  #section7 .fp-tableCell {\n    padding-top: 0; }\n  #section4 .color-otaland-red,\n  #section5 .color-otaland-red {\n    display: block;\n    text-align: center; }\n  #section5 h3 {\n    font-size: 14px;\n    width: 270px;\n    margin: 0 auto; }\n    #section5 h3 br {\n      display: none; }\n  #section5 .slide-container {\n    height: 240px !important; }\n  #listslide2 {\n    width: 100%; }\n    #listslide2 .slide-container {\n      width: 100% !important;\n      height: 45vh !important; }\n  #listslide3 {\n    width: 100%; }\n    #listslide3 .slide-container {\n      width: 100% !important;\n      height: 280px !important; }\n  .bg-red-50 {\n    width: 100%;\n    padding: 10px;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-align: center;\n        align-items: center; }\n    .bg-red-50 .box-inner {\n      padding: 0;\n      width: 100%;\n      overflow: hidden;\n      display: block !important; }\n      .bg-red-50 .box-inner br {\n        display: none; }\n  .list-slide-wrap {\n    width: 100%;\n    overflow: scroll; }\n  .box-otaland-list {\n    margin: 0; }\n    .box-otaland-list > li {\n      width: 100%;\n      float: none;\n      margin: 0; }\n  .otaland-footer-list {\n    display: none; }\n  .otaland-copyright {\n    height: auto;\n    line-height: 1.4;\n    padding: 10px; }\n  .wdy-img {\n    width: 115px;\n    margin: 15px auto; }\n  .logo-img-row {\n    padding: 0 30px;\n    margin: 20px auto 0 auto;\n    max-width: 300px; }\n    .logo-img-row img {\n      display: inline-block !important;\n      width: 50%;\n      margin: 10px 0; }\n  .testimonial-list {\n    margin-top: 20px; }\n    .testimonial-list li .testimonial-inner {\n      padding: 30px 15px;\n      background-color: #FFFFFF;\n      position: relative;\n      max-width: 250px;\n      margin: 0 auto; }\n    .testimonial-list li .testimonial-img {\n      max-width: 123px;\n      margin-bottom: 10px; }\n    .testimonial-list li .color-otaland-grey br {\n      display: none; }\n    .testimonial-list li h3 {\n      margin: 10px 0 0 0 !important; }\n  .font-30px {\n    font-size: 20px; }\n  #otaland-footer {\n    height: auto;\n    padding-top: 15px; }\n  .btn-register,\n  .btn-joinus {\n    width: 90%;\n    margin: 10px auto; } }\n\n@media screen and (max-width: 400px) {\n  html {\n    font-size: 50%; }\n  .open-menu ~ nav {\n    padding: 20px 0; }\n  nav li a {\n    padding: 3px; } }\n\n.homepage .header-desktop {\n  background-color: rgba(255, 255, 255, 0.15);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3); }\n  .homepage .header-desktop .line-space {\n    color: #FFFFFF; }\n  .homepage .header-desktop .header-menu > li > a {\n    color: #FFFFFF; }\n  .homepage .header-desktop .logo {\n    display: block;\n    margin: 14px 0;\n    float: left; }\n\n.IOS .homepage {\n  min-height: 100% !important; }\n\n.IOS app-search {\n  display: initial; }\n\n@media screen and (max-width: 767px) {\n  .homepage .header-mobile {\n    background-color: rgba(255, 255, 255, 0.15);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.3); }\n    .homepage .header-mobile .logo {\n      display: block;\n      margin: 5px 16px;\n      float: left; } }\n\n/*#region typeahead  (input suggestion componet) */\n/*------------------------------------------------------------------------*/\n.input-suggestion-menu {\n  width: 100%;\n  border: 1px solid #003a90;\n  margin-top: -1px; }\n\n.input-suggestion-menu .tt-dataset {\n  background-color: #FFFFFF;\n  width: 100%; }\n\n/*#endregion */\n/*#region typeahead */\n/*------------------------------------------------------------------------*/\n.tt-menu {\n  width: 525px;\n  margin-top: 5px;\n  border-radius: 4px;\n  overflow: hidden;\n  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.4); }\n  @media screen and (max-width: 767px) {\n    .tt-menu {\n      width: 100%; } }\n\n.tt-menu > .tt-dataset {\n  width: 100%;\n  background-color: #FFFFFF; }\n\n.tt-dataset .tt-header {\n  background-color: #f6f8f9;\n  padding: 6px 10px;\n  margin: 0px;\n  width: 100%;\n  min-width: 268px;\n  border-bottom: 1px solid #dfe1e6;\n  font-size: 12px;\n  cursor: pointer; }\n  .tt-dataset .tt-header .icon-map,\n  .tt-dataset .tt-header .icon-city,\n  .tt-dataset .tt-header .icon-time,\n  .tt-dataset .tt-header .icon-icon-business-destination {\n    color: #576D77; }\n  .tt-dataset .tt-header .icon-map {\n    font-size: 10px; }\n  .tt-dataset .tt-header .icon-time,\n  .tt-dataset .tt-header .icon-icon-business-destination {\n    font-size: 12px; }\n\n.tt-dataset .tt-suggestion,\n.tt-dataset .empty-message {\n  margin: 0px;\n  width: 100%;\n  font-size: 14px;\n  cursor: pointer;\n  overflow: hidden;\n  padding: 10px;\n  position: relative;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  background-color: #FFFFFF;\n  border-bottom: 1px solid #dfe1e6; }\n\n.tt-dataset .recent-suggest-icon {\n  width: 16px;\n  color: #061021; }\n\n.tt-dataset .tt-suggestion:hover,\n.tt-dataset .empty-message:hover {\n  background-color: #e4edff; }\n\n.tt-dataset .tt-suggestion:first-child {\n  border-top: none; }\n\n.tt-dataset .tt-suggestion:last-child {\n  border-bottom: none; }\n\n.tt-dataset .tt-suggestion.tt-cursor {\n  background-color: #e4edff; }\n\n.tt-suggestion > i,\n.empty-message > i {\n  margin-right: 7px; }\n\n.twitter-typeahead {\n  width: 100%; }\n\n.destination_search {\n  position: relative; }\n  .destination_search input.input-destination {\n    background-color: #FFFFFF;\n    background-image: url(\"assets/images/icons/Destination.png\");\n    background-repeat: no-repeat;\n    background-position: 10px 10px;\n    background-size: 16px;\n    padding-left: 29px; }\n\n.destination_search i.delete {\n  position: absolute;\n  right: 11px;\n  font-size: 16px;\n  top: 12px;\n  cursor: pointer;\n  color: #6b778c; }\n  .destination_search i.delete:hover {\n    color: #061021; }\n\n.tt-suggestion i {\n  font-size: 16px; }\n\n.tt-suggestion .tt-highlight {\n  color: #003a90;\n  font-weight: bold; }\n\n.tt-suggestion .suggestion-icon {\n  float: left;\n  width: 22px; }\n\n.tt-suggestion .suggestion-content {\n  float: left;\n  width: calc(100% - 97px); }\n  .tt-suggestion .suggestion-content.full {\n    width: calc(100% - 22px); }\n  .tt-suggestion .suggestion-content .suggestion-title {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden; }\n  .tt-suggestion .suggestion-content .suggestion-subtitle {\n    font-size: 12px;\n    margin-top: 2px;\n    color: #6b778c; }\n  @media screen and (max-width: 768px) {\n    .tt-suggestion .suggestion-content {\n      width: calc(100% - 22px); } }\n\n.tt-suggestion .suggestion-count {\n  float: left;\n  width: 75px;\n  color: #6b778c;\n  text-align: right; }\n  @media screen and (max-width: 768px) {\n    .tt-suggestion .suggestion-count {\n      display: none; } }\n\n/*------------------------------------------------------------------------*/\n.mat-menu-panel.search-box-choose-room {\n  max-width: initial;\n  max-width: auto;\n  top: 34px; }\n\n/*------------------------------------------------------------------------*/\n.link-hover-style {\n  text-decoration: none;\n  color: #003a90; }\n  .link-hover-style:hover {\n    cursor: pointer;\n    color: #042764;\n    text-decoration: underline; }\n\n/*------------------------------------------------------------------------*/\n.cdk-overlay-dark-backdrop {\n  background: black; }\n\n.cdk-overlay-backdrop.cdk-overlay-backdrop-showing {\n  opacity: 0.6; }\n\n.cdk-overlay-pane {\n  margin: 0 auto; }\n\n.mat-menu-panel {\n  box-shadow: none !important;\n  overflow: initial !important;\n  transform: none !important; }\n\n.mat-dialog-container {\n  border-radius: 0 !important; }\n  .mat-dialog-container .mat-dialog-content.dialog-msg .ota-btn-main,\n  .mat-dialog-container .mat-dialog-content.dialog-msg .ota-btn-sub, .mat-dialog-container .mat-dialog-content.dialog-delete .ota-btn-main,\n  .mat-dialog-container .mat-dialog-content.dialog-delete .ota-btn-sub {\n    max-width: 175px; }\n    @media screen and (max-width: 767px) {\n      .mat-dialog-container .mat-dialog-content.dialog-msg .ota-btn-main,\n      .mat-dialog-container .mat-dialog-content.dialog-msg .ota-btn-sub, .mat-dialog-container .mat-dialog-content.dialog-delete .ota-btn-main,\n      .mat-dialog-container .mat-dialog-content.dialog-delete .ota-btn-sub {\n        max-width: auto;\n        max-width: initial; } }\n  .mat-dialog-container .dialog-container {\n    position: relative;\n    border-radius: 0; }\n    @media screen and (max-width: 767px) {\n      .mat-dialog-container .dialog-container {\n        width: 100%; } }\n    .mat-dialog-container .dialog-container a.link-hover-style {\n      text-decoration: none; }\n      .mat-dialog-container .dialog-container a.link-hover-style:hover {\n        color: #042764;\n        text-decoration: underline; }\n    .mat-dialog-container .dialog-container .forget-password-title {\n      margin-bottom: 25px; }\n    .mat-dialog-container .dialog-container .dialog-wrapper-content {\n      position: relative;\n      background-color: #FFFFFF;\n      width: 480px;\n      padding: 15px 30px 30px 30px;\n      font-size: 14px;\n      min-height: 380px; }\n      @media screen and (max-width: 767px) {\n        .mat-dialog-container .dialog-container .dialog-wrapper-content {\n          min-height: 365px;\n          padding: 10px;\n          padding-top: 15px;\n          padding-bottom: 20px;\n          width: 100%; } }\n      .lt-ie10 .mat-dialog-container .dialog-container .dialog-wrapper-content {\n        margin: 0 auto; }\n    .mat-dialog-container .dialog-container .close-box:after {\n      content: \"\";\n      display: table;\n      clear: both; }\n    .mat-dialog-container .dialog-container .close-box .icon-close,\n    .mat-dialog-container .dialog-container .close-box .icon-close2 {\n      font-size: 20px;\n      padding: 6px;\n      margin-right: -21px;\n      color: #DFE1E6; }\n      .no-touch .mat-dialog-container .dialog-container .close-box .icon-close:hover,\n      .touch .mat-dialog-container .dialog-container .close-box .icon-close.touch, .no-touch\n      .mat-dialog-container .dialog-container .close-box .icon-close2:hover,\n      .touch\n      .mat-dialog-container .dialog-container .close-box .icon-close2.touch {\n        color: #959595; }\n      @media screen and (max-width: 767px) {\n        .mat-dialog-container .dialog-container .close-box .icon-close,\n        .mat-dialog-container .dialog-container .close-box .icon-close2 {\n          font-size: 16px;\n          margin-right: -1px; } }\n    .mat-dialog-container .dialog-container a {\n      color: #003a90; }\n    .mat-dialog-container .dialog-container .form-pop-title {\n      font-size: 20px;\n      color: #061021;\n      margin: 15px 0 30px 0; }\n      @media screen and (max-width: 767px) {\n        .mat-dialog-container .dialog-container .form-pop-title {\n          font-size: 16px; } }\n    .mat-dialog-container .dialog-container .form-pop-sub-title {\n      color: #6b778c;\n      margin: 3px 0 25px 0;\n      line-height: 1.5em; }\n    .mat-dialog-container .dialog-container .form-pop-footer-float {\n      margin: 0;\n      position: absolute;\n      left: 30px;\n      right: 30px;\n      bottom: 30px; }\n      @media screen and (max-width: 767px) {\n        .mat-dialog-container .dialog-container .form-pop-footer-float {\n          left: 20px;\n          right: 20px; } }\n    .mat-dialog-container .dialog-container .ota-input-select {\n      background: #FFFFFF url(\"assets/images/form/icon_arrow_down.png\") no-repeat calc(100% - 7px) center; }\n    .mat-dialog-container .dialog-container .no-margin {\n      margin: 0; }\n    .mat-dialog-container .dialog-container .forgot-link {\n      margin: 5px 0 15px 0;\n      margin-bottom: 20px; }\n    .mat-dialog-container .dialog-container .box-success {\n      margin: 15px 0;\n      text-align: center; }\n    .mat-dialog-container .dialog-container .input-error {\n      border-color: #ed1c24 !important;\n      margin: 0; }\n    .mat-dialog-container .dialog-container .ota-btn-main.loading {\n      color: transparent;\n      position: relative;\n      pointer-events: none; }\n      .mat-dialog-container .dialog-container .ota-btn-main.loading:before {\n        position: absolute;\n        content: \"\";\n        top: 50%;\n        left: 50%;\n        margin: -0.64285714em 0em 0em -0.64285714em;\n        width: 1.28571429em;\n        height: 1.28571429em;\n        border-radius: 500rem;\n        border: 0.2em solid rgba(0, 0, 0, 0.15); }\n      .mat-dialog-container .dialog-container .ota-btn-main.loading:after {\n        position: absolute;\n        content: \"\";\n        top: 50%;\n        left: 50%;\n        margin: -0.64285714em 0em 0em -0.64285714em;\n        width: 1.28571429em;\n        height: 1.28571429em;\n        animation: loading 0.6s linear;\n        animation-iteration-count: infinite;\n        border-radius: 500rem;\n        border-color: #FFFFFF transparent transparent;\n        border-style: solid;\n        border-width: 0.2em;\n        box-shadow: 0px 0px 0px 1px transparent; }\n\n@keyframes loading {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(360deg); } }\n  .mat-dialog-container .icon-failed,\n  .mat-dialog-container .icon-success {\n    font-size: 60px;\n    color: #ed1c24; }\n  .mat-dialog-container .icon-success {\n    color: #4aad5d; }\n  .mat-dialog-container .link-hover-style {\n    text-decoration: underline; }\n  .mat-dialog-container .icon-service-failed,\n  .mat-dialog-container .icon-approve,\n  .mat-dialog-container .icon-reject,\n  .mat-dialog-container .icon-successful {\n    width: 100px;\n    height: 60px;\n    margin: 0 auto;\n    display: block;\n    background-size: 100%;\n    background-repeat: no-repeat; }\n  .mat-dialog-container .icon-service-failed {\n    background-image: url(\"../assets/images/icons/icon-failed.png\"); }\n  .mat-dialog-container .icon-approve {\n    background-image: url(\"../assets/images/icons/icon-approve.png\"); }\n  .mat-dialog-container .icon-reject {\n    background-image: url(\"../assets/images/icons/icon-reject.png\"); }\n  .mat-dialog-container .icon-successful {\n    background-image: url(\"../assets/images/icons/icon-successful.png\"); }\n\n.icon-rating-thankyou {\n  background-color: transparent;\n  background-image: url(\"/assets/images/icons/icon-nobooking.png\");\n  background-repeat: no-repeat;\n  background-position: 0 0;\n  background-size: cover;\n  width: 95px;\n  height: 60px;\n  display: inline-block; }\n\n.text-hint {\n  font-size: 12px;\n  color: #6b778c;\n  margin-bottom: 15px;\n  display: block; }\n\n.text-error {\n  color: #ed1c24;\n  font-size: 12px;\n  margin: 5px 0 15px 0;\n  padding: 0 0 0 17px;\n  display: block;\n  position: relative; }\n\n.text-error:before {\n  font-family: \"ota-icons\" !important;\n  font-style: 12px;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  content: \"\\E93D\";\n  position: absolute;\n  left: 1px;\n  top: 1px; }\n\n.input-error {\n  border-color: #ed1c24 !important;\n  margin-bottom: 0 !important;\n  height: 35px; }\n\n.ota-input-text, .mat-dialog-container .dialog-container .ota-input-select, .ota-input-select {\n  padding: 6px 12px;\n  margin: 0 0 20px 0;\n  border: 1px solid #DFE1E6;\n  font-size: 14px;\n  line-height: 1.5em;\n  width: 100%;\n  border-radius: 0;\n  -moz-appearance: none;\n       appearance: none;\n  color: #061021; }\n  .ota-input-text::-webkit-input-placeholder, .mat-dialog-container .dialog-container .ota-input-select::-webkit-input-placeholder, .ota-input-select::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    color: #dfe1e6; }\n  .ota-input-text::-moz-placeholder, .mat-dialog-container .dialog-container .ota-input-select::-moz-placeholder, .ota-input-select::-moz-placeholder {\n    /* Firefox 19+ */\n    color: #dfe1e6; }\n  .ota-input-text:-ms-input-placeholder, .mat-dialog-container .dialog-container .ota-input-select:-ms-input-placeholder, .ota-input-select:-ms-input-placeholder {\n    /* IE 10+ */\n    color: #dfe1e6; }\n  .ota-input-text:-moz-placeholder, .mat-dialog-container .dialog-container .ota-input-select:-moz-placeholder, .ota-input-select:-moz-placeholder {\n    /* Firefox 18- */\n    color: #dfe1e6; }\n  .ota-input-text:focus, .mat-dialog-container .dialog-container .ota-input-select:focus, .ota-input-select:focus {\n    border-color: #003a90;\n    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.3);\n    outline: 0; }\n  .ota-input-text[disabled], .mat-dialog-container .dialog-container .ota-input-select[disabled], .ota-input-select[disabled] {\n    opacity: 1;\n    -webkit-opacity: 1;\n    background-color: #DFE1E6;\n    color: #061021;\n    -webkit-text-fill-color: #061021; }\n\n.ota-input-select-group {\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 20px; }\n  .ota-input-select-group.select-group-error {\n    margin-bottom: 0; }\n  .ota-input-select-group .ota-input-select {\n    margin-bottom: 0; }\n    .ota-input-select-group .ota-input-select:not(:first-child) {\n      margin-left: 10px; }\n\n.ota-input-select {\n  background: #FFFFFF url(\"assets/images/form/icon_arrow_down.png\") no-repeat calc(100% - 7px) center; }\n\nselect:-moz-focusring {\n  color: transparent !important;\n  text-shadow: 0 0 0 #000 !important; }\n\n.ota-btn-main.loading {\n  color: transparent;\n  position: relative; }\n  .ota-btn-main.loading:before {\n    position: absolute;\n    content: \"\";\n    top: 50%;\n    left: 50%;\n    margin: -0.64285714em 0em 0em -0.64285714em;\n    width: 1em;\n    height: 1em;\n    border-radius: 500rem;\n    border: 0.2em solid rgba(0, 0, 0, 0.15); }\n  .ota-btn-main.loading:after {\n    position: absolute;\n    content: \"\";\n    top: 50%;\n    left: 50%;\n    margin: -0.64285714em 0em 0em -0.64285714em;\n    width: 1em;\n    height: 1em;\n    animation: loading 0.6s linear;\n    animation-iteration-count: infinite;\n    border-radius: 500rem;\n    border-color: #FFFFFF transparent transparent;\n    border-style: solid;\n    border-width: 0.2em;\n    box-shadow: 0px 0px 0px 1px transparent; }\n\n/*------------------------------------------------------------------------*/\n.mb-0 {\n  margin-bottom: 0 !important; }\n\n.mb-5 {\n  margin-bottom: 5px !important; }\n\n.mb-10 {\n  margin-bottom: 10px !important; }\n\n.mb-20 {\n  margin-bottom: 20px !important; }\n\n.bold {\n  font-weight: 700; }\n\n.ota-text-error {\n  display: block;\n  position: relative;\n  color: #ed1c24;\n  font-size: 12px;\n  margin-top: 5px;\n  padding-left: 20px; }\n  .ota-text-error i {\n    position: absolute;\n    left: 5px;\n    top: 3px;\n    font-size: 10px; }\n\n.ota-input-error {\n  border-color: #ed1c24 !important;\n  margin: 0; }\n\n.no-outline {\n  outline: none; }\n\n@media screen and (min-width: 768px) {\n  .owl-carousel {\n    display: block; } }\n\n.banner-owl .owl-dots .owl-dot,\n.landing-owl .owl-dots .owl-dot,\n.gallery-owl .owl-dots .owl-dot,\n.billboard-owl .owl-dots .owl-dot,\n.banner-overlay-owl .owl-dots .owl-dot {\n  display: inline-block;\n  margin: 2px 6px;\n  padding: 0;\n  height: 6px;\n  width: 6px;\n  cursor: pointer;\n  background-color: #c6ccd2;\n  border-radius: 6px;\n  -moz-border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -khtml-border-radius: 6px; }\n  .banner-owl .owl-dots .owl-dot.active,\n  .landing-owl .owl-dots .owl-dot.active,\n  .gallery-owl .owl-dots .owl-dot.active,\n  .billboard-owl .owl-dots .owl-dot.active,\n  .banner-overlay-owl .owl-dots .owl-dot.active {\n    background-color: #cc1b1f; }\n\n.banner-owl .owl-dots,\n.billboard-owl .owl-dots,\n.banner-overlay-owl .owl-dots {\n  margin-top: 10px; }\n  .banner-owl .owl-dots .owl-dot,\n  .billboard-owl .owl-dots .owl-dot,\n  .banner-overlay-owl .owl-dots .owl-dot {\n    background-color: #A5ADBA;\n    height: 12px;\n    width: 12px;\n    margin: 2px 4px; }\n    .banner-owl .owl-dots .owl-dot.active,\n    .billboard-owl .owl-dots .owl-dot.active,\n    .banner-overlay-owl .owl-dots .owl-dot.active {\n      background-color: #003A90; }\n\nselect:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #000; }\n\nselect::-ms-expand {\n  display: none; }\n\n.ota-slider-range {\n  border-radius: 6px;\n  background-color: #DFE1E6 !important;\n  height: 4px !important;\n  border: none !important;\n  margin: 27px 0 5px 0;\n  margin-left: 8px;\n  margin-right: 8px;\n  position: relative; }\n  .ota-slider-range::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: -8px;\n    border-radius: 6px;\n    height: 4px;\n    width: 20px;\n    background-color: #DFE1E6; }\n  .ota-slider-range::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: -8px;\n    border-radius: 6px;\n    height: 4px;\n    width: 20px;\n    background-color: #DFE1E6; }\n  .ota-slider-range .ui-slider-range {\n    background-color: #003a90 !important; }\n  .ota-slider-range .ui-slider-handle {\n    border-radius: 50% !important;\n    width: 20px !important;\n    height: 20px !important;\n    margin-left: -10px;\n    background-color: #FFFFFF !important;\n    border: 4px solid #003a90 !important;\n    top: -200%; }\n    .no-touch .ota-slider-range .ui-slider-handle:hover {\n      cursor: pointer; }\n    .ota-slider-range .ui-slider-handle:focus {\n      outline: none; }\n  .ota-slider-range.-zero-min-max .ui-slider-range {\n    width: 0% !important; }\n  .ota-slider-range.-zero-min-max .ui-slider-handle {\n    left: 0% !important; }\n\n.ota-loading {\n  animation: round 0.8s infinite linear; }\n\n@keyframes round {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n.nav-sm-menu {\n  display: none; }\n  @media screen and (max-width: 767px) {\n    .nav-sm-menu {\n      display: block;\n      margin: 10px;\n      margin-top: 0 !important;\n      margin-bottom: 7px !important;\n      position: relative;\n      top: -3px; }\n      .nav-sm-menu .nav-sm-inner {\n        background-color: #FFFFFF;\n        background-image: url(\"assets/images/account/arrow_menu.png\");\n        background-repeat: no-repeat;\n        background-position: calc(100% - 10px) center;\n        background-size: 11px 8px;\n        border: 1px solid #DFE1E6;\n        height: 35px;\n        padding: 7px 10px;\n        margin-top: -5px; }\n      .nav-sm-menu .account-menu-list {\n        display: none; } }\n\n[class^=\"icon-nav-\"],\n[class*=\" icon-nav-\"],\n.icon-nav {\n  display: inline-block;\n  width: 20px;\n  font-size: 16px;\n  text-align: center;\n  vertical-align: middle;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-position: 0 center;\n  background-size: contain;\n  margin: -5px 5px 0 0; }\n  [class^=\"icon-nav-\"].icon-setting,\n  [class*=\" icon-nav-\"].icon-setting,\n  .icon-nav.icon-setting {\n    font-size: 18px; }\n\n@media screen and (max-width: 767px) {\n  .account-menu-pop-up-sm {\n    margin-top: -8px !important;\n    width: calc(100vw - 22px) !important;\n    max-width: auto !important;\n    max-width: initial !important;\n    left: -1px !important; } }\n\n.account-container {\n  padding: 30px 0;\n  display: -ms-flexbox;\n  display: flex;\n  border-collapse: separate;\n  border-spacing: 30px 0; }\n  .account-container > .col-left,\n  .account-container > .col-right {\n    vertical-align: top; }\n  .account-container > .col-left {\n    width: 262px;\n    margin-right: 15px;\n    margin-bottom: 0; }\n  .account-container > .col-right {\n    background-color: #FFFFFF;\n    width: 818px;\n    margin-left: 15px; }\n  @media screen and (max-width: 767px) {\n    .account-container {\n      display: block;\n      width: 100%;\n      margin: 0 0 30px 0;\n      padding: 0; }\n      .account-container > .col-left {\n        display: none; }\n      .account-container > .col-right {\n        display: block;\n        width: 100%;\n        margin: 0; } }\n\n.box-popup-full-white {\n  padding-bottom: 71px; }\n  @media screen and (max-width: 767px) {\n    .box-popup-full-white {\n      min-height: 100vh !important;\n      padding-bottom: 139px; } }\n\n.footer-btn-container {\n  position: relative; }\n  @media screen and (max-width: 767px) {\n    .footer-btn-container {\n      position: absolute;\n      left: 0;\n      right: 0;\n      bottom: 48px; }\n      .IOS .footer-btn-container {\n        bottom: 68px; }\n      .CriOS .footer-btn-container {\n        bottom: 0; } }\n\n.text-middle-color {\n  color: #666666; }\n\n@media print {\n  .header-box,\n  .btn-pdf,\n  .btn-print,\n  .thkyou-btn-back,\n  .copyright-inner {\n    display: none !important; }\n  .body-thankyou {\n    background-color: white; }\n  .icon-success::before {\n    color: #4aad5d !important; }\n  .status-success .text-payment {\n    color: #4aad5d !important; }\n  .icon-failed::before {\n    color: #ed1c24 !important; }\n  .status-failed .text-payment {\n    color: #ed1c24 !important; }\n  .booking-detail-wrap .col-left,\n  .booking-detail-wrap .col-right {\n    width: 100% !important;\n    max-width: auto !important;\n    max-width: initial !important; }\n  .booking-detail-wrap .col-right {\n    border-top: 1px solid #DFE1E6; } }\n\n.input-destination + pre {\n  width: 100%; }\n\n.div-chat {\n  z-index: 999; }\n\n.circle-line {\n  display: none; }\n\n@media screen and (max-width: 1120px) {\n  .box-grey .circle-line {\n    bottom: 80px; }\n  .circle-line {\n    z-index: 9;\n    right: 10px;\n    width: 48px;\n    height: 48px;\n    bottom: 30px;\n    display: block;\n    position: fixed;\n    text-align: center;\n    border-radius: 50%;\n    background: #4a4a4a;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4); }\n    .circle-line img {\n      top: 12px;\n      width: 24px;\n      max-width: 24px;\n      position: relative; } }\n\n.d-flex {\n  display: -ms-flexbox !important;\n  display: flex !important; }\n\n.dropdown-ota-style {\n  background-color: #959595;\n  background-image: url(\"assets/images/form/Down.svg\");\n  background-repeat: no-repeat;\n  background-position: calc(100% - 10px) center;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #DFE1E6;\n  color: #061021;\n  border-radius: 4px;\n  overflow: hidden;\n  background-color: #FFFFFF; }\n  .dropdown-ota-style:active {\n    background-color: #FFFFFF;\n    border: 1px solid #DFE1E6; }\n  .dropdown-ota-style.selected {\n    background-color: #FFFFFF;\n    background-image: url(\"assets/images/form/Down_selected.svg\");\n    background-repeat: no-repeat;\n    background-position: calc(100% - 10px) center;\n    background-color: #042764;\n    border: 1px solid #042764 !important; }\n  .dropdown-ota-style.open {\n    border: 1px solid #003a90; }\n  .dropdown-ota-style.type-button:hover {\n    background-color: #e4edff; }\n\n.dropdown-sub-menu {\n  padding-top: 35px;\n  position: relative;\n  z-index: 99;\n  width: 230px;\n  margin-top: 10px; }\n  .dropdown-sub-menu > .mat-menu-content {\n    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.4);\n    border-radius: 4px; }\n  .dropdown-sub-menu.-fluid-width {\n    width: auto;\n    min-width: auto;\n    max-width: none; }\n  .dropdown-sub-menu.-max-content-width {\n    width: auto;\n    max-width: unset; }\n  .dropdown-sub-menu li {\n    background: #FFFFFF; }\n    .dropdown-sub-menu li:first-child,\n    .dropdown-sub-menu li:first-child:hover > a {\n      border-top-left-radius: 4px !important;\n      border-top-right-radius: 4px !important; }\n    .dropdown-sub-menu li:last-child,\n    .dropdown-sub-menu li:last-child:hover > a {\n      border-bottom-left-radius: 4px !important;\n      border-bottom-right-radius: 4px !important; }\n    .dropdown-sub-menu li a {\n      display: block;\n      width: 100%;\n      padding: 0 16px;\n      line-height: 39px;\n      height: 40px;\n      border-bottom: 1px solid #DFE1E6;\n      color: #061021; }\n      .dropdown-sub-menu li a:last-child {\n        border-bottom: 0; }\n      .no-touch .dropdown-sub-menu li a:hover,\n      .touch .dropdown-sub-menu li a.touch {\n        background: #e4edff; }\n  .dropdown-sub-menu.-divide-first li:first-child {\n    height: 40px;\n    border-bottom: 1px solid #DFE1E6; }\n    .dropdown-sub-menu.-divide-first li:first-child a {\n      height: 39px; }\n  .dropdown-sub-menu.-divide-first li:last-child {\n    border-bottom: unset; }\n    .dropdown-sub-menu.-divide-first li:last-child a {\n      height: 40px; }\n  .dropdown-sub-menu .scorllable-box {\n    max-height: 360px;\n    overflow-y: auto;\n    width: -moz-max-content;\n    width: max-content;\n    background-color: #FFFFFF;\n    border-radius: 4px; }\n    .dropdown-sub-menu .scorllable-box li {\n      background: unset; }\n      .dropdown-sub-menu .scorllable-box li:first-child:hover > a,\n      .dropdown-sub-menu .scorllable-box li:last-child:hover > a {\n        border-radius: unset !important; }\n\n/* icon */\n.icon-pinmap {\n  font-size: 12px;\n  color: #ed3833; }\n\n.act-content-warp {\n  margin-bottom: 15px;\n  background: white; }\n  .act-content-warp h3.header {\n    font-size: 20px;\n    font-weight: bold;\n    padding: 15px; }\n  .act-content-warp h5.title {\n    font-size: 14px;\n    font-weight: bold; }\n  .act-content-warp .act-content-box-title {\n    position: relative;\n    padding: 10px 15px 10px 15px;\n    max-height: 35px;\n    font-weight: bold;\n    border-bottom: 1px solid #dfe1e6;\n    overflow: hidden; }\n  .act-content-warp .act-content-box {\n    padding: 15px 15px 30px 15px; }\n\n.w-100 {\n  width: 100%; }\n\n.mb-15 {\n  margin-bottom: 15px !important; }\n\n.room-benefit-desc ul {\n  padding-left: 20px; }\n\n.room-benefit-desc li {\n  list-style-type: disc; }\n\n.privacy ul, .privacy li {\n  list-style-type: disc; }\n\n.privacy ul {\n  margin-left: 0px;\n  padding-left: 20px; }\n\n.terms-and-conditions ul, .terms-and-conditions li {\n  list-style-type: disc; }\n\n.terms-and-conditions ul {\n  margin-left: 0px;\n  padding-left: 20px; }\n\n.md-menu-button {\n  cursor: pointer;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.md-menu-list {\n  position: absolute;\n  top: 30px;\n  left: -150px;\n  background-color: white;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4);\n  border-radius: 4px; }\n\n.md-menu-item {\n  padding: 10px 15px;\n  min-height: 40px;\n  width: 250px;\n  font-size: 14px;\n  line-height: 19px;\n  color: #061021;\n  word-wrap: break-word;\n  cursor: pointer; }\n  .md-menu-item:hover {\n    background-color: #e4edff; }\n\n.link-btn {\n  color: #003a90;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  cursor: pointer; }\n  .link-btn i {\n    font-size: 16px; }\n  .link-btn .text {\n    margin-left: 5px;\n    font-size: 14px;\n    line-height: 16px; }\n  .link-btn:hover, .link-btn :active {\n    color: #042764; }\n    .link-btn:hover .text, .link-btn :active .text {\n      text-decoration: underline; }\n  .link-btn.disabled {\n    color: #A5ADBA;\n    cursor: not-allowed;\n    pointer-events: none; }\n    .link-btn.disabled:hover .text {\n      color: #A5ADBA; }\n\n.link-text {\n  color: #042764; }\n  .link-text:hover {\n    color: #042764;\n    text-decoration: underline; }\n\n.link-normal-text {\n  color: #061021; }\n  .link-normal-text:hover, .link-normal-text:active {\n    color: #061021;\n    text-decoration: underline; }\n  .link-normal-text:visited, .link-normal-text:focus {\n    color: #061021; }\n\n.dialog-ota-cancel-btn {\n  background-color: white;\n  border: none;\n  color: #003a90;\n  font-size: 14px;\n  line-height: 16px; }\n  .dialog-ota-cancel-btn:hover, .dialog-ota-cancel-btn:active {\n    color: #042764;\n    text-decoration: underline; }\n  @media screen and (max-width: 767px) {\n    .dialog-ota-cancel-btn {\n      border: 1px solid #dfe1e6;\n      border-radius: 4px;\n      background-color: #FFFFFF;\n      width: 100%;\n      height: 35px;\n      padding: 8px;\n      color: #061021; }\n      .dialog-ota-cancel-btn:hover, .dialog-ota-cancel-btn:active {\n        color: #061021;\n        text-decoration: none; } }\n\n.data-row {\n  display: -ms-flexbox;\n  display: flex;\n  padding: 10px;\n  background-color: white;\n  border-bottom: 1px dotted #dfe1e6; }\n  .data-row .data-label {\n    width: 110px;\n    text-align: left;\n    font-weight: bold; }\n  .data-row .data-value {\n    width: calc(100% - 110px);\n    text-align: right; }\n  .data-row.grey {\n    background-color: #f6f8f9;\n    border-bottom: 1px solid #dfe1e6; }\n\n.grecaptcha-badge {\n  visibility: hidden; }\n\n.font-bold {\n  font-weight: bold; }\n\n.horizontal-line-md {\n  width: 100%;\n  border-bottom: 1px solid #DFE1E6; }\n  @media screen and (max-width: 767px) {\n    .horizontal-line-md {\n      border-bottom: none; } }\n\n.refund-themselves {\n  color: #FF6600; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.homepage {\n  background-color: transparent;\n  background-image: url(\"/assets/images/home/bg_home.jpg\");\n  background-repeat: no-repeat;\n  background-position: center 0; }\n\nbody {\n  background-color: #f6f8f9; }\n\n.settingpage {\n  width: 100%;\n  height: auto;\n  background-color: #f5f5f5; }\n\n.account-container {\n  padding: 30px 0;\n  margin: 0 -30px;\n  display: table;\n  border-collapse: separate;\n  border-spacing: 30px 0; }\n\n.col-left,\n.col-right {\n  display: table-cell;\n  background-color: #FFFFFF;\n  vertical-align: top; }\n\n.col-left {\n  width: 262px;\n  margin-right: 15px; }\n\n.col-right {\n  width: 847px;\n  margin-left: 15px; }\n\n.nav-sm-menu {\n  display: none; }\n\n.account-content {\n  padding: 15px; }\n\n.box-user-display {\n  text-align: center; }\n\n.box-thumb {\n  border-radius: 50% ;\n  margin: 15px auto;\n  width: 120px;\n  height: 120px;\n  overflow: hidden; }\n  .box-thumb img {\n    width: 100%; }\n\n.icon-link {\n  font-weight: bold; }\n\n.nav-account-menu {\n  margin-bottom: 0;\n  border-top: 1px dotted #DFE1E6; }\n  .nav-account-menu li {\n    height: 40px; }\n    .nav-account-menu li a {\n      color: #061021;\n      display: block;\n      padding: 10px 15px;\n      line-height: 20px; }\n    .nav-account-menu li:hover {\n      background-color: #e4edff; }\n      .nav-account-menu li:hover a {\n        color: #061021; }\n    .nav-account-menu li.active {\n      background-color: #042764; }\n      .nav-account-menu li.active a {\n        color: #FFFFFF; }\n    .nav-account-menu li:focus {\n      outline: none; }\n\n@media screen and (max-width: 767px) {\n  .account-container {\n    display: block;\n    width: 100%;\n    margin: 0 0 60px 0;\n    padding: 0; }\n  .col-left {\n    display: none; }\n  .col-right {\n    display: block;\n    width: 100%;\n    margin: 0; }\n  .nav-sm-menu {\n    display: block; }\n    .nav-sm-menu .nav-sm-inner {\n      background-color: #FFFFFF;\n      background-image: url(\"/assets/images/account/arrow_menu.png\");\n      background-repeat: no-repeat;\n      background-position: calc(100% - 10px) center;\n      background-size: 11px 8px;\n      border: 1px solid #DFE1E6;\n      height: 35px;\n      padding: 7px 10px; }\n    .nav-sm-menu .account-menu-list {\n      display: none; }\n  .account-content {\n    padding: 0; } }\n\n.icon-nav-dashboard {\n  background-image: image-url(\"account/navleft/icon_dashboard.png\"); }\n\n.icon-nav-profile {\n  background-image: image-url(\"account/navleft/icon_profile.png\"); }\n\n.icon-nav-booking {\n  background-image: image-url(\"account/navleft/icon_booking.png\"); }\n\n.icon-nav-trip {\n  background-image: image-url(\"account/navleft/icon_trip.png\"); }\n\n.icon-nav-payment {\n  background-image: image-url(\"account/navleft/icon_payment.png\"); }\n\n.icon-nav-group {\n  background-image: image-url(\"account/navleft/icon_group.png\"); }\n\n.icon-nav-review {\n  background-image: image-url(\"account/navleft/icon_review.png\"); }\n\n.icon-nav-setting {\n  background-image: image-url(\"account/navleft/icon_setting.png\"); }\n\n.icon-nav-logout {\n  background-image: image-url(\"account/navleft/icon_logout.png\"); }\n\n.nav-account-menu li.active .icon-nav-dashboard,\n.nav-account-menu li:hover .icon-nav-dashboard {\n  background-image: image-url(\"account/navleft/active/icon_dashboard.png\"); }\n\n.nav-account-menu li.active .icon-nav-profile,\n.nav-account-menu li:hover .icon-nav-profile {\n  background-image: image-url(\"account/navleft/active/icon_profile.png\"); }\n\n.nav-account-menu li.active .icon-nav-booking,\n.nav-account-menu li:hover .icon-nav-booking {\n  background-image: image-url(\"account/navleft/active/icon_booking.png\"); }\n\n.nav-account-menu li.active .icon-nav-trip,\n.nav-account-menu li:hover .icon-nav-trip {\n  background-image: image-url(\"account/navleft/active/icon_trip.png\"); }\n\n.nav-account-menu li.active .icon-nav-payment,\n.nav-account-menu li:hover .icon-nav-payment {\n  background-image: image-url(\"account/navleft/active/icon_payment.png\"); }\n\n.nav-account-menu li.active .icon-nav-group,\n.nav-account-menu li:hover .icon-nav-group {\n  background-image: image-url(\"account/navleft/active/icon_group.png\"); }\n\n.nav-account-menu li.active .icon-nav-review,\n.nav-account-menu li:hover .icon-nav-review {\n  background-image: image-url(\"account/navleft/active/icon_review.png\"); }\n\n.nav-account-menu li.active .icon-nav-setting,\n.nav-account-menu li:hover .icon-nav-setting {\n  background-image: image-url(\"account/navleft/active/icon_setting.png\"); }\n\n.nav-account-menu li.active .icon-nav-logout,\n.nav-account-menu li:hover .icon-nav-logout {\n  background-image: image-url(\"account/navleft/active/icon_logout.png\"); }\n\n.nav-sm-menu {\n  margin: 10px; }\n\n.content-box {\n  margin: 15px 0 0 0; }\n\n.content-title {\n  background-color: #f6f8f9;\n  padding: 10px 15px;\n  overflow: hidden; }\n  .content-title a {\n    color: #6b778c; }\n    .content-title a:hover {\n      color: #061021; }\n\n.icon-link-edit {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/icon_edit.png\");\n  background-repeat: no-repeat;\n  background-position: 0 0;\n  background-size: 100%;\n  width: 16px;\n  height: 16px;\n  margin: -2px 10px 0 0;\n  display: inline-block;\n  vertical-align: middle; }\n\n.content-table {\n  display: table;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 15px 10px; }\n  .content-table .content-row {\n    display: table-row; }\n  .content-table .content-column {\n    display: table-cell; }\n    .content-table .content-column:first-child {\n      width: 180px; }\n\n.content-address {\n  padding: 0 15px; }\n\n.box-select-address {\n  border: 1px solid #DFE1E6;\n  margin: 15px 0;\n  width: 445px;\n  overflow: hidden; }\n  .box-select-address.selected {\n    background-color: transparent;\n    background-image: url(\"/assets/images/account/bg_address.gif\");\n    background-repeat: repeat-x;\n    background-position: 0 0; }\n  .box-select-address .address-inner {\n    padding: 20px 15px; }\n\n.radio-address {\n  margin: 0;\n  position: relative;\n  padding: 15px 35px 15px 40px;\n  font-weight: normal; }\n  .radio-address input[type=radio] {\n    position: absolute;\n    left: 15px;\n    top: 50%;\n    margin-top: -4px; }\n  .radio-address p {\n    margin: 5px 0 15px 0; }\n\n.delete-address {\n  display: inline-block;\n  min-height: 30px; }\n  .delete-address a {\n    color: #6b778c; }\n    .delete-address a .icon-delete-addrs {\n      background-color: transparent;\n      background-image: url(\"/assets/images/account/icon_bin.png\");\n      background-repeat: no-repeat;\n      background-position: 0 center;\n      background-size: 14px 15px;\n      width: 14px;\n      height: 15px;\n      display: block;\n      float: left; }\n    .delete-address a span {\n      color: #6b778c;\n      padding: 0;\n      display: block;\n      float: left;\n      margin: -3px 0 0 5px; }\n    .delete-address a:hover {\n      color: #061021; }\n      .delete-address a:hover span {\n        color: #061021; }\n\n.edit-address {\n  display: inline-block;\n  min-height: 30px;\n  margin-left: 70px; }\n  .edit-address a {\n    color: #6b778c; }\n    .edit-address a .icon-edit-addrs {\n      background-color: transparent;\n      background-image: url(\"/assets/images/account/icon_edit.png\");\n      background-repeat: no-repeat;\n      background-position: 0 center;\n      background-size: 14px 15px;\n      width: 14px;\n      height: 15px;\n      display: block;\n      float: left; }\n    .edit-address a span {\n      color: #6b778c;\n      padding: 0;\n      display: block;\n      float: left;\n      margin: -3px 0 0 5px; }\n    .edit-address a:hover {\n      color: #061021; }\n      .edit-address a:hover span {\n        color: #061021; }\n\n.add-address {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/icon_add.png\");\n  background-repeat: no-repeat;\n  background-position: 0 center;\n  background-size: 20px 20px;\n  color: #586d76;\n  padding: 0 0 0 26px;\n  line-height: 20px;\n  margin-bottom: 15px;\n  display: inline-block;\n  color: #576D77;\n  text-decoration: none; }\n  .add-address:visited {\n    color: #576D77; }\n  .add-address:hover {\n    color: #53798A;\n    text-decoration: none; }\n\n.address-button {\n  margin: 0 -15px;\n  overflow: hidden; }\n  .address-button .btn-horizontal {\n    float: left;\n    margin: 0 15px;\n    width: calc(50% - 30px); }\n\n.content-detail {\n  padding: 15px; }\n  .content-detail p {\n    margin-bottom: 15px; }\n  .content-detail .ota-checkbox {\n    padding: 0; }\n    .content-detail .ota-checkbox [type=\"checkbox\"]:not(:checked) + label,\n    .content-detail .ota-checkbox [type=\"checkbox\"]:checked + label {\n      color: #061021;\n      padding: 6px 0 6px 25px;\n      line-height: 1.4;\n      background-color: #FFFFFF; }\n\n.content-form {\n  width: 445px;\n  margin: 15px; }\n\n@media screen and (max-width: 767px) {\n  .content-title {\n    padding: 10px; }\n  .content-table {\n    border-spacing: 10px 10px; }\n    .content-table .content-column:first-child {\n      width: 110px; }\n  .content-address {\n    padding: 0 10px; }\n  .content-detail {\n    padding: 15px 10px; }\n  .box-select-address {\n    width: 100%; }\n    .box-select-address.selected {\n      border-color: #003a90;\n      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.3); }\n    .box-select-address .address-inner {\n      padding: 15px 10px; }\n  .radio-address {\n    padding: 15px 30px; }\n    .radio-address input[type=radio] {\n      left: 10px; }\n  .address-button {\n    margin: 0; }\n    .address-button .ota-btn-main {\n      float: right; }\n    .address-button .btn-horizontal {\n      margin: 0;\n      width: calc(50% - 5px); }\n  .content-form {\n    width: 100%;\n    padding: 15px 10px;\n    margin: 0; }\n  .btn-horizontal {\n    font-size: 16px; } }\n\n.box-detail {\n  text-align: left;\n  padding: 30px 15px 15px 15px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap; }\n\n.font-bold {\n  font-weight: bold; }\n\n.icon-company,\n.icon-mail {\n  margin-right: 10px; }\n\n.box-detail .icon-user {\n  margin-right: 10px; }\n\n.account-menu-container {\n  background-color: #FFFFFF; }\n\n.box-menu-display {\n  padding-bottom: 30px; }\n\n.border-top-solid {\n  border-top: 1px solid #DFE1E6; }\n\n.align-text-bottom {\n  vertical-align: text-bottom; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\nimg.act-image {\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  object-fit: cover; }\n\n.parent {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 65% 35%;\n      grid-template-columns: 65% 35%; }\n  .parent.full {\n    -ms-grid-columns: 100%;\n        grid-template-columns: 100%; }\n\n.img1 {\n  margin-right: 5px;\n  grid-area: 1 / 1 / 3 / 2; }\n\n.img2 {\n  margin-bottom: 5px;\n  grid-area: 1 / 2 / 2 / 3; }\n\n.img3 {\n  grid-area: 2 / 2 / 3 / 3;\n  position: relative; }\n\n.pointer {\n  cursor: pointer; }\n\n.all-images {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  color: white;\n  background-color: rgba(0, 0, 0, 0.6);\n  cursor: pointer; }\n  .all-images span {\n    margin-left: 5px; }\n    .all-images span:hover {\n      text-decoration: underline; }\n  .all-images i {\n    font-size: 24px;\n    vertical-align: middle; }\n  .all-images:hover {\n    background-color: rgba(0, 0, 0, 0.7); }\n\n@media screen and (max-width: 768px) {\n  .parent {\n    -ms-grid-columns: 50% 50%;\n        grid-template-columns: 50% 50%; }\n  .img1 {\n    grid-area: 1 / 1 / 2 / 3;\n    margin-right: 0; }\n  .img2 {\n    grid-area: 2 / 1 / 3 / 2;\n    margin: 5px 5px 0 0; }\n  .img3 {\n    grid-area: 2 / 2 / 3 / 3;\n    margin-top: 5px; }\n  .sm-mt-3 {\n    margin-top: 3px; } }\n\n.product-image-box {\n  position: relative;\n  background-color: #f5f5f5;\n  overflow: hidden;\n  margin-bottom: 15px; }\n\n.product-image-box-center {\n  top: 50%;\n  position: relative;\n  transform: translatey(-50%); }\n  .product-image-box-center.no-photo {\n    transform: translatey(0);\n    margin: auto; }\n\n.box-no-photo {\n  background-color: #dfe1e6;\n  display: -ms-flexbox;\n  display: flex; }\n  .box-no-photo i {\n    color: #a5adba;\n    font-size: 48px;\n    margin: auto; }\n\n.responsive-height.big {\n  height: 378px; }\n\n.responsive-height.small {\n  height: 186px; }\n\n.box-no-photo {\n  height: 378px; }\n  .box-no-photo.half {\n    height: 186px;\n    line-height: 186px; }\n\n@media screen and (max-width: 414px) {\n  .responsive-height.big {\n    height: 276px; }\n  .responsive-height.small {\n    height: 136px; }\n  .box-no-photo {\n    height: 276px; }\n    .box-no-photo.half {\n      height: 136px;\n      line-height: 136px; } }\n\n@media screen and (max-width: 375px) {\n  .responsive-height.big {\n    height: 250px; }\n  .responsive-height.small {\n    height: 124px; }\n  .box-no-photo {\n    height: 250px; }\n    .box-no-photo.half {\n      height: 124px;\n      line-height: 124px; } }\n\n@media screen and (max-width: 320px) {\n  .responsive-height.big {\n    height: 200px; }\n  .responsive-height.small {\n    height: 100px; }\n  .box-no-photo {\n    height: 200px; }\n    .box-no-photo.half {\n      height: 100px;\n      line-height: 100px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".tex-area-label {\n  padding-bottom: 7px; }\n\ntextarea {\n  width: 100%;\n  height: 88px;\n  padding: 10px;\n  border: 1px solid #DFE1E6;\n  border-radius: 4px;\n  resize: none;\n  outline: none; }\n\ntextarea:-ms-input-placeholder {\n  color: #DFE1E6;\n  size: 14px; }\n\ntextarea::placeholder {\n  color: #DFE1E6;\n  size: 14px; }\n\n.mt-0 {\n  margin-top: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.content-box {\n  margin: 15px 0 0 0; }\n\n.content-title {\n  background-color: #f6f8f9;\n  padding: 10px 15px;\n  overflow: hidden;\n  min-height: 20px; }\n  .content-title a {\n    color: #6b778c; }\n    .content-title a:hover, .content-title a.-active {\n      color: #061021; }\n\n.icon-link-edit {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/icon_edit.png\");\n  background-repeat: no-repeat;\n  background-position: 0 0;\n  background-size: 100%;\n  width: 16px;\n  height: 16px;\n  margin: -2px 5px 0 0;\n  display: inline-block;\n  vertical-align: middle; }\n\n.content-table {\n  display: table;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 15px 10px; }\n  .content-table .content-row {\n    display: table-row; }\n  .content-table .content-column {\n    display: table-cell; }\n    .content-table .content-column:first-child {\n      width: 180px; }\n  .content-table.-edit .content-row {\n    display: block; }\n  .content-table.-edit .content-column {\n    display: block;\n    max-width: 450px; }\n    .content-table.-edit .content-column:first-child {\n      margin-bottom: 5px; }\n    .content-table.-edit .content-column .ota-input-text,\n    .content-table.-edit .content-column .ota-input-select {\n      margin-bottom: 15px; }\n\n.content-address {\n  padding: 0 15px; }\n\n.box-select-address {\n  border: 1px solid #DFE1E6;\n  margin-top: 15px;\n  width: 445px;\n  overflow: hidden; }\n  .box-select-address.-full-width {\n    width: 100%; }\n  .box-select-address.selected {\n    background-color: transparent;\n    background-image: url(\"/assets/images/account/bg_address.gif\");\n    background-repeat: repeat-x;\n    background-position: 0 0; }\n  .box-select-address .address-inner {\n    padding: 20px 15px; }\n\n.radio-address {\n  margin: 0;\n  position: relative;\n  padding: 15px 35px 15px 40px;\n  font-weight: normal; }\n  .radio-address input[type=radio] {\n    position: absolute;\n    left: 15px;\n    top: 50%;\n    margin-top: -4px; }\n  .radio-address p {\n    margin: 5px 0 15px 0; }\n\n.delete-address {\n  display: inline-block;\n  min-height: 30px; }\n  .delete-address a {\n    color: #6b778c; }\n    .delete-address a .icon-delete-addrs {\n      background-color: transparent;\n      background-image: url(\"/assets/images/account/icon_bin.png\");\n      background-repeat: no-repeat;\n      background-position: 0 center;\n      background-size: 14px 15px;\n      width: 14px;\n      height: 15px;\n      display: block;\n      float: left; }\n    .delete-address a span {\n      color: #6b778c;\n      padding: 0;\n      display: block;\n      float: left;\n      margin: -3px 0 0 5px; }\n    .delete-address a:hover {\n      color: #061021; }\n      .delete-address a:hover span {\n        color: #061021; }\n\n.edit-address {\n  display: inline-block;\n  min-height: 30px;\n  margin-left: 70px; }\n  .edit-address a {\n    color: #6b778c; }\n    .edit-address a .icon-edit-addrs {\n      background-color: transparent;\n      background-image: url(\"/assets/images/account/icon_edit.png\");\n      background-repeat: no-repeat;\n      background-position: 0 center;\n      background-size: 14px 15px;\n      width: 14px;\n      height: 15px;\n      display: block;\n      float: left; }\n    .edit-address a span {\n      color: #6b778c;\n      padding: 0;\n      display: block;\n      float: left;\n      margin: -3px 0 0 5px; }\n    .edit-address a:hover {\n      color: #061021; }\n      .edit-address a:hover span {\n        color: #061021; }\n\n.add-address {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/icon_add.png\");\n  background-repeat: no-repeat;\n  background-position: 0 center;\n  background-size: 20px 20px;\n  color: #586d76;\n  padding: 0 0 0 26px;\n  line-height: 20px;\n  margin-bottom: 15px;\n  display: inline-block;\n  color: #576D77;\n  text-decoration: none;\n  margin-top: 15px; }\n  .add-address:visited {\n    color: #576D77; }\n  .add-address:hover {\n    color: #53798A;\n    text-decoration: none; }\n\n.address-button {\n  margin: 0 -15px;\n  overflow: hidden; }\n  .address-button .btn-horizontal {\n    float: left;\n    margin: 0 15px;\n    width: calc(50% - 30px); }\n\n.content-detail {\n  padding: 15px; }\n  .content-detail p {\n    margin-bottom: 15px; }\n  .content-detail .ota-checkbox {\n    padding: 0; }\n    .content-detail .ota-checkbox [type=\"checkbox\"]:not(:checked) + label,\n    .content-detail .ota-checkbox [type=\"checkbox\"]:checked + label {\n      color: #061021;\n      padding: 6px 0 6px 25px;\n      line-height: 1.4;\n      background-color: #FFFFFF; }\n\n.content-form {\n  width: 445px;\n  margin: 15px; }\n\n.ota-input-select-group {\n  margin-bottom: 0; }\n\n@media screen and (max-width: 767px) {\n  .content-title {\n    padding: 10px; }\n  .content-table {\n    border-spacing: 10px 10px; }\n  .content-address {\n    padding: 0 10px; }\n  .content-detail {\n    padding: 15px 10px; }\n  .box-select-address {\n    width: 100%; }\n    .box-select-address .address-inner {\n      padding: 15px 10px; }\n  .radio-address {\n    padding: 15px 30px; }\n    .radio-address input[type=radio] {\n      left: 10px; }\n  .address-button {\n    margin: 0; }\n    .address-button .ota-btn-main {\n      float: right; }\n    .address-button .btn-horizontal {\n      margin: 0;\n      width: calc(50% - 5px); }\n  .content-form {\n    width: 100%;\n    padding: 15px 10px;\n    margin: 0; }\n  .btn-horizontal {\n    font-size: 16px; } }\n\n.profile-content-loading-box {\n  min-height: 190px;\n  text-align: center;\n  padding-top: 60px; }\n\ntextarea {\n  resize: vertical; }\n\n.box-select-address {\n  margin-top: 15px;\n  border-radius: 6px; }\n  @media screen and (max-width: 767px) {\n    .box-select-address {\n      margin-top: 15px; } }\n  .box-select-address.-first-child {\n    margin-top: 15px; }\n  .box-select-address .address-inner {\n    padding: 15px;\n    padding-bottom: 0px; }\n    @media screen and (max-width: 767px) {\n      .box-select-address .address-inner {\n        margin-top: 10px;\n        padding: 15px 10px; }\n        .box-select-address .address-inner .-mb-20 {\n          margin-bottom: 15px; } }\n\n.-mb-20 {\n  margin-bottom: 20px; }\n\n.content-table {\n  border-spacing: 0 8px; }\n  @media screen and (max-width: 767px) {\n    .content-table {\n      border-spacing: 0; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.content-box {\n  margin: 15px 0 0 0; }\n\n.content-title {\n  background-color: #f6f8f9;\n  padding: 10px 15px;\n  overflow: hidden;\n  min-height: 20px; }\n  .content-title a {\n    color: #6b778c; }\n    .content-title a:hover, .content-title a.-active {\n      color: #061021; }\n\n.icon-link-edit {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/icon_edit.png\");\n  background-repeat: no-repeat;\n  background-position: 0 0;\n  background-size: 100%;\n  width: 16px;\n  height: 16px;\n  margin: -2px 5px 0 0;\n  display: inline-block;\n  vertical-align: middle; }\n\n.content-table {\n  display: table;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 15px 10px; }\n  .content-table .content-row {\n    display: table-row; }\n  .content-table .content-column {\n    display: table-cell; }\n    .content-table .content-column:first-child {\n      width: 180px; }\n  .content-table.-edit .content-row {\n    display: block; }\n  .content-table.-edit .content-column {\n    display: block;\n    max-width: 450px; }\n    .content-table.-edit .content-column:first-child {\n      margin-bottom: 5px; }\n    .content-table.-edit .content-column .ota-input-text,\n    .content-table.-edit .content-column .ota-input-select {\n      margin-bottom: 15px; }\n\n.content-address {\n  padding: 0 15px; }\n  .content-address div:first-child .box-select-address {\n    margin-top: 15px; }\n  .content-address div:last-child .box-select-address {\n    margin-bottom: 15px; }\n    @media screen and (max-width: 767px) {\n      .content-address div:last-child .box-select-address {\n        margin-bottom: 5px; } }\n\n.box-select-address {\n  border: 1px solid #DFE1E6;\n  margin-top: 15px;\n  width: 445px;\n  overflow: hidden;\n  border-radius: 6px; }\n  @media screen and (max-width: 767px) {\n    .box-select-address {\n      margin-top: 15px; } }\n  .box-select-address.-full-width {\n    width: 100%; }\n  .box-select-address.selected {\n    background-color: transparent;\n    background-image: url(\"/assets/images/account/bg_address.gif\");\n    background-repeat: repeat-x;\n    background-position: 0 0; }\n  .box-select-address .address-inner {\n    padding: 20px 15px; }\n\n.radio-address {\n  margin: 0;\n  position: relative;\n  width: 100%;\n  padding: 15px;\n  font-weight: normal; }\n  .radio-address.-can-select {\n    padding-left: 46px; }\n    @media screen and (max-width: 767px) {\n      .radio-address.-can-select {\n        padding-left: 37px; } }\n  .radio-address input[type=\"radio\"] {\n    position: absolute;\n    left: 15px;\n    top: 50%;\n    margin-top: -4px; }\n  .radio-address p {\n    margin: 5px 0 15px 0; }\n\n.delete-address {\n  display: inline-block;\n  margin-top: 10px; }\n  .delete-address a {\n    color: #6b778c; }\n    .delete-address a .icon-delete-addrs {\n      background-color: transparent;\n      background-image: url(\"/assets/images/account/icon_bin.png\");\n      background-repeat: no-repeat;\n      background-position: 0 center;\n      background-size: 14px 15px;\n      width: 14px;\n      height: 15px;\n      display: block;\n      float: left;\n      margin-right: 5px; }\n    .delete-address a span {\n      color: #6b778c;\n      padding: 0;\n      display: block;\n      float: left;\n      margin: -3px 0 0 5px; }\n    .delete-address a:hover span {\n      text-decoration: underline; }\n\n.edit-address {\n  display: inline-block;\n  margin-left: 70px;\n  margin-top: 10px; }\n  .edit-address a {\n    color: #6b778c; }\n    .edit-address a .icon-edit-addrs {\n      background-color: transparent;\n      background-image: url(\"/assets/images/account/icon_edit.png\");\n      background-repeat: no-repeat;\n      background-position: 0 center;\n      background-size: 14px 15px;\n      width: 14px;\n      height: 15px;\n      display: block;\n      float: left;\n      margin-right: 5px; }\n    .edit-address a span {\n      color: #6b778c;\n      padding: 0;\n      display: block;\n      float: left;\n      margin: -3px 0 0 5px; }\n    .edit-address a:hover span {\n      text-decoration: underline; }\n\n.add-address {\n  display: inline-block;\n  color: #003a90;\n  margin-top: 15px;\n  margin-bottom: 15px; }\n  @media screen and (max-width: 767px) {\n    .add-address {\n      margin-bottom: 5px; } }\n  .add-address i,\n  .add-address span {\n    vertical-align: middle; }\n  .add-address i {\n    font-size: 16px;\n    margin-right: 5px; }\n  .add-address:hover {\n    color: #042764; }\n  .add-address:hover span {\n    text-decoration: underline; }\n\n.address-button {\n  margin: 0 -15px;\n  overflow: hidden; }\n  .address-button .btn-horizontal {\n    float: left;\n    margin: 0 15px;\n    width: calc(50% - 30px); }\n\n.content-detail {\n  padding: 15px; }\n  .content-detail p {\n    margin-bottom: 15px; }\n  .content-detail .ota-checkbox {\n    padding: 0; }\n    .content-detail .ota-checkbox [type=\"checkbox\"]:not(:checked) + label,\n    .content-detail .ota-checkbox [type=\"checkbox\"]:checked + label {\n      color: #061021;\n      padding: 6px 0 6px 25px;\n      line-height: 1.4;\n      background-color: #FFFFFF; }\n\n.content-form {\n  width: 445px;\n  margin: 15px; }\n\n.ota-input-select-group {\n  margin-bottom: 0; }\n\n@media screen and (max-width: 768px) {\n  .content-title {\n    padding: 10px; }\n  .content-table {\n    border-spacing: 0px 10px; }\n  .content-address {\n    padding: 0 10px;\n    padding-bottom: 10px; }\n  .content-address.checkout {\n    padding: 0; }\n  .content-detail {\n    padding: 15px 10px; }\n  .box-select-address {\n    width: 100%; }\n    .box-select-address .address-inner {\n      padding: 15px 10px; }\n  .radio-address {\n    padding: 25px 10px; }\n    .radio-address input[type=\"radio\"] {\n      left: 10px; }\n  .address-button {\n    margin: 0; }\n    .address-button .ota-btn-main {\n      float: right; }\n    .address-button .btn-horizontal {\n      margin: 0;\n      width: calc(50% - 5px); }\n  .content-form {\n    width: 100%;\n    padding: 15px 10px;\n    margin: 0; }\n  .btn-horizontal {\n    font-size: 16px; } }\n\n.address-detail p {\n  margin-bottom: 0; }\n\n.mr-3 {\n  margin-right: 3px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.approval-button {\n  display: table;\n  width: 100%;\n  min-width: 260px;\n  height: 100%; }\n  .approval-button .ml-30 {\n    margin-left: 30px; }\n  .approval-button .disable-btn {\n    color: #A5ADBA !important;\n    pointer-events: none;\n    cursor: default; }\n  .approval-button .button-block {\n    display: table-cell;\n    position: relative;\n    width: 48%;\n    height: 100%;\n    padding: 5px;\n    text-align: center; }\n    .approval-button .button-block .loading-wrapper {\n      position: absolute;\n      top: 0;\n      left: 0px;\n      font-size: 12px;\n      width: 30px;\n      height: 100%; }\n      .approval-button .button-block .loading-wrapper.loading:before {\n        position: absolute;\n        content: \"\";\n        top: 50%;\n        left: 50%;\n        margin: -0.64285714em 0em 0em -0.64285714em;\n        width: 1.28571429em;\n        height: 1.28571429em;\n        border-radius: 500rem;\n        border: 0.2em solid rgba(0, 0, 0, 0.15); }\n      .approval-button .button-block .loading-wrapper.loading:after {\n        position: absolute;\n        content: \"\";\n        top: 50%;\n        left: 50%;\n        margin: -0.64285714em 0em 0em -0.64285714em;\n        width: 1.28571429em;\n        height: 1.28571429em;\n        animation: loading 0.6s linear;\n        animation-iteration-count: infinite;\n        border-radius: 500rem;\n        border-color: #4aad5d transparent transparent;\n        border-style: solid;\n        border-width: 0.2em;\n        box-shadow: 0px 0px 0px 1px transparent; }\n      @media screen and (max-width: 767px) {\n        .approval-button .button-block .loading-wrapper {\n          right: 0; } }\n  .approval-button .separator-block {\n    display: table-cell;\n    vertical-align: middle;\n    width: 2%; }\n    .approval-button .separator-block .separator {\n      display: block;\n      margin: auto;\n      width: 1px;\n      color: transparent;\n      background-color: #DFE1E6; }\n  .approval-button .button-wrapper {\n    display: table;\n    height: 100%;\n    width: 100%; }\n  .approval-button .btn-approval-reject,\n  .approval-button .btn-approval-approve {\n    display: -ms-flexbox;\n    display: flex;\n    height: 100%;\n    -ms-flex-pack: center;\n        justify-content: center;\n    font-weight: bold;\n    cursor: pointer; }\n    .approval-button .btn-approval-reject .btn-container,\n    .approval-button .btn-approval-approve .btn-container {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center;\n      -ms-flex-item-align: center;\n          align-self: center;\n      position: relative; }\n      .approval-button .btn-approval-reject .btn-container span:hover,\n      .approval-button .btn-approval-approve .btn-container span:hover {\n        text-decoration: underline; }\n  .approval-button .btn-approval-reject {\n    color: #ed1c24; }\n    .approval-button .btn-approval-reject i {\n      font-size: 14px;\n      padding-right: 10px; }\n    .approval-button .btn-approval-reject:hover {\n      color: #ff3333; }\n  .approval-button .btn-approval-approve {\n    color: #4aad5d; }\n    .approval-button .btn-approval-approve i {\n      font-size: 16px;\n      padding-right: 10px; }\n    .approval-button .btn-approval-approve:hover {\n      color: #58c06c; }\n  @media screen and (max-width: 768px) {\n    .approval-button {\n      display: table;\n      width: 100%;\n      height: 100%;\n      margin: 0; }\n      .approval-button.detail .button-block {\n        border-color: transparent; }\n        .approval-button.detail .button-block.-left {\n          border-right-color: #DFE1E6; }\n      .approval-button .separator-block {\n        display: none; }\n      .approval-button .button-block {\n        width: 50%;\n        border: 1px solid #DFE1E6;\n        display: table-cell;\n        height: 40px; }\n        .approval-button .button-block.-right {\n          border-left: none; }\n      .approval-button .btn-approval-reject,\n      .approval-button .btn-approval-approve {\n        vertical-align: middle; } }\n\n.approval-button.list {\n  display: -ms-flexbox;\n  display: flex; }\n  .approval-button.list .button-block {\n    display: block;\n    width: 100%;\n    padding: 10px; }\n    .approval-button.list .button-block .button-wrapper {\n      display: block; }\n  .approval-button.list .separator-block {\n    display: block;\n    -ms-flex-item-align: center;\n        -ms-grid-row-align: center;\n        align-self: center; }\n  @media screen and (max-width: 768px) {\n    .approval-button.list .button-block {\n      border-color: transparent; }\n      .approval-button.list .button-block.-left {\n        border-right-color: #DFE1E6; }\n    .approval-button.list .separator-block {\n      display: none; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".approval-content {\n  padding: 60px 0;\n  margin: 0 auto;\n  text-align: center; }\n  @media screen and (max-width: 767px) {\n    .approval-content {\n      padding: 15px 10px 30px; } }\n  .approval-content.approval-cancellation-fee {\n    padding: 0; }\n  .approval-content .icon-header {\n    height: 58px; }\n  .approval-content .header {\n    margin: 15px 0 5px 0; }\n\n.loading-box {\n  text-align: center;\n  padding: 80px 0; }\n  @media screen and (max-width: 767px) {\n    .loading-box .ota-loading {\n      width: 40px; } }\n\n.text-success {\n  color: #4aad5d; }\n\n.text-warning {\n  color: #ff6600; }\n\n.text-section {\n  margin-top: 5px;\n  margin-bottom: 20px; }\n\n.btn-parent {\n  width: 100%;\n  display: block;\n  padding: 0; }\n  .btn-parent .ota-btn-default, .btn-parent .ota-btn-main {\n    min-width: 175px;\n    width: -moz-fit-content;\n    width: fit-content;\n    font-size: 14px;\n    padding: 0 20px;\n    margin: 0; }\n  .btn-parent .ota-btn-main {\n    margin-left: 15px; }\n  @media screen and (max-width: 767px) {\n    .btn-parent {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly; }\n      .btn-parent .ota-btn-default, .btn-parent .ota-btn-main {\n        min-width: calc(50% - 5px); }\n      .btn-parent .ota-btn-main {\n        margin-left: 10px; }\n      .btn-parent.success .ota-btn-default {\n        display: none; }\n      .btn-parent.success .ota-btn-main {\n        margin-left: 0px; } }\n\n.approval-cancellation-fee {\n  min-width: 600px; }\n  .approval-cancellation-fee .acf-overflow {\n    text-align: left;\n    padding-top: 30px; }\n  .approval-cancellation-fee .header {\n    font-size: 20px;\n    font-weight: bold;\n    padding: 0;\n    margin: 0 0 20px;\n    font-family: Arial, Thonburi, tahoma, sans-serif; }\n    .approval-cancellation-fee .header .title-detail {\n      font-weight: normal; }\n  .approval-cancellation-fee .topic-box {\n    font-size: 14px;\n    color: #061021;\n    margin-bottom: 15px; }\n  .approval-cancellation-fee .space-0 {\n    margin: 0px !important;\n    border-bottom: 1px solid #DFE1E6;\n    padding-bottom: 15px; }\n  .approval-cancellation-fee .table-list-room {\n    width: 100%;\n    display: table;\n    box-sizing: border-box; }\n    .approval-cancellation-fee .table-list-room .col-left,\n    .approval-cancellation-fee .table-list-room .col-right {\n      padding: 15px 10px;\n      margin: 0;\n      box-sizing: border-box;\n      display: block;\n      float: left;\n      position: relative; }\n    .approval-cancellation-fee .table-list-room .col-left {\n      width: 60%; }\n      .approval-cancellation-fee .table-list-room .col-left::after {\n        width: 1px;\n        background-color: #DFE1E6;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        right: -1px; }\n    .approval-cancellation-fee .table-list-room .col-right {\n      width: 40%; }\n    .approval-cancellation-fee .table-list-room .table-head {\n      border-bottom: 2px solid #DFE1E6;\n      background-color: #f6f8f9;\n      display: table;\n      width: 100%;\n      box-sizing: border-box; }\n      .approval-cancellation-fee .table-list-room .table-head .col-left,\n      .approval-cancellation-fee .table-list-room .table-head .col-right {\n        padding: 9px 10px 8px;\n        background-color: #f6f8f9; }\n      .approval-cancellation-fee .table-list-room .table-head .col-right {\n        text-align: right; }\n    .approval-cancellation-fee .table-list-room .table-body {\n      width: 100%;\n      display: table;\n      background-color: #FFFFFF; }\n      .approval-cancellation-fee .table-list-room .table-body .table-item {\n        background-color: #FFFFFF;\n        border-bottom: 1px solid #DFE1E6; }\n      .approval-cancellation-fee .table-list-room .table-body .col-left {\n        text-align: left;\n        border-right: 1px solid #DFE1E6; }\n        .approval-cancellation-fee .table-list-room .table-body .col-left .cl-condition {\n          font-size: 12px;\n          margin-top: 5px;\n          color: #6b778c; }\n          .approval-cancellation-fee .table-list-room .table-body .col-left .cl-condition .cc-title {\n            text-decoration: underline; }\n        .approval-cancellation-fee .table-list-room .table-body .col-left .room-type {\n          font-weight: bold; }\n      .approval-cancellation-fee .table-list-room .table-body .col-right {\n        text-align: right; }\n        .approval-cancellation-fee .table-list-room .table-body .col-right .cr-title {\n          display: none; }\n    .approval-cancellation-fee .table-list-room .table-body-summary {\n      width: 100%;\n      display: table;\n      background-color: #f6f8f9; }\n      .approval-cancellation-fee .table-list-room .table-body-summary .col-left,\n      .approval-cancellation-fee .table-list-room .table-body-summary .col-right {\n        padding: 10px 15px;\n        font-size: 20px;\n        font-weight: 600; }\n      .approval-cancellation-fee .table-list-room .table-body-summary .col-left {\n        top: 2px;\n        position: relative; }\n        .approval-cancellation-fee .table-list-room .table-body-summary .col-left .cl-total {\n          font-size: 20px; }\n        .approval-cancellation-fee .table-list-room .table-body-summary .col-left .cl-multipayment {\n          font-size: 12px;\n          font-weight: normal;\n          color: #6b778c; }\n      .approval-cancellation-fee .table-list-room .table-body-summary .col-right {\n        text-align: right;\n        font-size: 24px; }\n        .approval-cancellation-fee .table-list-room .table-body-summary .col-right .cr-currency {\n          font-weight: normal; }\n    .approval-cancellation-fee .table-list-room .table-body-payment-type {\n      width: 100%;\n      display: table;\n      background-color: #FFFFFF; }\n      .approval-cancellation-fee .table-list-room .table-body-payment-type .col-left {\n        width: 70%; }\n      .approval-cancellation-fee .table-list-room .table-body-payment-type .col-right {\n        width: 30%;\n        text-align: right;\n        font-weight: 600; }\n        .approval-cancellation-fee .table-list-room .table-body-payment-type .col-right .cr-currency {\n          font-weight: normal; }\n      .approval-cancellation-fee .table-list-room .table-body-payment-type .tbpt-credit-terms,\n      .approval-cancellation-fee .table-list-room .table-body-payment-type .tbpt-credit-card {\n        border-bottom: 1px dotted #DFE1E6; }\n  .approval-cancellation-fee .remark-box {\n    font-size: 12px;\n    margin: 10px 0 18px;\n    color: #6b778c; }\n    .approval-cancellation-fee .remark-box .remark-title {\n      text-decoration: underline; }\n  .approval-cancellation-fee .btn-parent {\n    padding-bottom: 30px;\n    padding-top: 20px; }\n\n.title .header {\n  font-size: 20px;\n  font-weight: 700; }\n  @media screen and (max-width: 767px) {\n    .title .header {\n      font-size: 16px; } }\n\n.title .desc {\n  margin-bottom: 20px; }\n\n.title .icon {\n  font-size: 60px; }\n\n.text-black {\n  color: #061021; }\n\n.img-failed {\n  height: 74px;\n  margin-bottom: 20px; }\n\n.unable-approval {\n  margin-top: 30px; }\n\na.link-hover-style {\n  color: #003a90; }\n\n@media screen and (max-width: 767px) {\n  .approval-cancellation-fee {\n    min-width: auto; }\n    .approval-cancellation-fee .acf-overflow {\n      padding: 15px 10px; }\n    .approval-cancellation-fee .header {\n      font-size: 16px;\n      padding: 0 10px;\n      margin: 0 -10px 10px; }\n      .approval-cancellation-fee .header .title-detail {\n        display: block;\n        margin-top: 5px; }\n    .approval-cancellation-fee .topic-box {\n      font-size: 12px; }\n    .approval-cancellation-fee .table-list-room .col-left,\n    .approval-cancellation-fee .table-list-room .col-right {\n      width: 50%; }\n    .approval-cancellation-fee .table-list-room .table-head .col-left {\n      padding: 9px 10px; }\n    .approval-cancellation-fee .table-list-room .table-head .col-right {\n      display: none; }\n    .approval-cancellation-fee .table-list-room .table-body .col-left,\n    .approval-cancellation-fee .table-list-room .table-body .col-right {\n      width: 100%;\n      display: block;\n      padding: 10px; }\n    .approval-cancellation-fee .table-list-room .table-body .col-left {\n      border-right: none;\n      border-bottom: 1px dotted #DFE1E6 !important; }\n    .approval-cancellation-fee .table-list-room .table-body .col-right .cr-title {\n      float: left;\n      display: block;\n      font-weight: 600; }\n    .approval-cancellation-fee .table-list-room .table-body-summary .col-left, .approval-cancellation-fee .table-list-room .table-body-summary .col-right {\n      padding: 10px; }\n    .approval-cancellation-fee .table-list-room .table-body-summary .col-left {\n      top: 0; }\n      .approval-cancellation-fee .table-list-room .table-body-summary .col-left .cl-total {\n        font-size: 16px; }\n    .approval-cancellation-fee .table-list-room .table-body-payment-type .tbpt-share-budget .col-left {\n      width: 100%; }\n    .approval-cancellation-fee .table-list-room .table-body-payment-type .col-left, .approval-cancellation-fee .table-list-room .table-body-payment-type .col-right {\n      padding: 10px; }\n    .approval-cancellation-fee .remark-box {\n      margin-bottom: 0; }\n    .approval-cancellation-fee .btn-parent {\n      padding: 15px 10px;\n      border-top: 1px solid #DFE1E6; }\n    .approval-cancellation-fee .space-0 {\n      padding-bottom: 30px; } }\n\n.show-list-style {\n  list-style: disc;\n  list-style-position: inside; }\n\n.tbpt-credit-terms-share-budget {\n  width: 100% !important;\n  padding: 0 10px !important; }\n  .tbpt-credit-terms-share-budget span {\n    font-weight: 600; }\n    .tbpt-credit-terms-share-budget span .cr-currency {\n      font-weight: normal; }\n\n.reason-box {\n  margin-top: 18px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.billboard {\n  width: 100%;\n  max-width: 1140px;\n  margin: 40px auto 0;\n  padding: 0 15px; }\n  @media screen and (max-width: 768px) {\n    .billboard {\n      margin: 40px auto 0;\n      padding: 0 10px; } }\n\n.billboard-list {\n  text-align: center;\n  margin-bottom: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.leaderboard {\n  width: 100%;\n  max-width: 1140px;\n  margin-bottom: 15px; }\n  .leaderboard img {\n    width: 100%;\n    max-height: 80px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.banner-promotion {\n  width: 100%;\n  max-width: 1140px;\n  margin: 40px auto 20px; }\n  @media screen and (max-width: 768px) {\n    .banner-promotion {\n      margin: 20px auto; } }\n\n.banner-header {\n  padding-left: 15px; }\n  .banner-header .topic {\n    font-size: 20px;\n    font-weight: bold;\n    color: #061021; }\n  .banner-header .sub-topic {\n    color: #6b778c; }\n\n.banner-detail {\n  margin-top: 10px;\n  padding: 15px; }\n  @media screen and (max-width: 768px) {\n    .banner-detail {\n      padding: 10px; } }\n  .banner-detail .banner-image {\n    height: 250px; }\n    .banner-detail .banner-image img {\n      max-height: 255px;\n      cursor: pointer; }\n  .banner-detail .banner-info {\n    padding: 20px 15px 15px 15px; }\n    @media screen and (max-width: 768px) {\n      .banner-detail .banner-info {\n        text-align: left; } }\n    .banner-detail .banner-info .banner-title {\n      font-size: 16px;\n      font-weight: bold;\n      word-break: break-word;\n      overflow: hidden;\n      display: -webkit-box;\n      line-height: 1.4em;\n      /* fallback */\n      height: 2.8em;\n      /* fallback */\n      -webkit-line-clamp: 2;\n      /* number of lines to show */\n      -webkit-box-orient: vertical;\n      /* autoprefixer: off */ }\n    .banner-detail .banner-info .banner-time {\n      padding: 10px 0; }\n      .banner-detail .banner-info .banner-time div {\n        padding: 5px 10px;\n        background-color: #f6f8f9;\n        border: 1px dotted #DFE1E6; }\n        .banner-detail .banner-info .banner-time div:last-child {\n          border-top: none; }\n        @media screen and (max-width: 768px) {\n          .banner-detail .banner-info .banner-time div {\n            padding: 5px; } }\n    .banner-detail .banner-info .banner-description {\n      font-size: 12px;\n      word-break: break-word;\n      overflow: hidden;\n      display: -webkit-box;\n      line-height: 1.4em;\n      /* fallback */\n      height: 2.8em;\n      /* fallback */\n      -webkit-line-clamp: 2;\n      /* number of lines to show */\n      -webkit-box-orient: vertical;\n      /* autoprefixer: off */ }\n  .banner-detail .banner-button {\n    text-align: center; }\n    @media screen and (max-width: 768px) {\n      .banner-detail .banner-button {\n        display: none; } }\n    .banner-detail .banner-button .ota-btn-main {\n      width: 150px;\n      font-size: 16px; }\n    .banner-detail .banner-button .icon {\n      font-size: 12px; }\n\n.banner-list {\n  width: 100%;\n  display: table; }\n  @media screen and (max-width: 768px) {\n    .banner-list {\n      display: block;\n      text-align: center; } }\n  .banner-list .banner-item {\n    width: 31.5%;\n    margin: 0 30px 30px 0;\n    float: left;\n    background-color: #FFFFFF; }\n    .banner-list .banner-item:nth-child(3n+0) {\n      margin-right: 0; }\n    @media screen and (max-width: 1030px) {\n      .banner-list .banner-item {\n        margin: 0 15px 15px 0; } }\n    @media screen and (max-width: 768px) {\n      .banner-list .banner-item {\n        width: 100%;\n        margin: 0;\n        display: inline-block; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.content-box {\n  margin: 15px 0 0 0; }\n\n.content-title {\n  background-color: #f6f8f9;\n  padding: 10px 15px;\n  overflow: hidden;\n  min-height: 20px; }\n  .content-title a {\n    color: #6b778c; }\n    .content-title a:hover, .content-title a.-active {\n      color: #061021; }\n\n.icon-link-edit {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/icon_edit.png\");\n  background-repeat: no-repeat;\n  background-position: 0 0;\n  background-size: 100%;\n  width: 16px;\n  height: 16px;\n  margin: -2px 5px 0 0;\n  display: inline-block;\n  vertical-align: middle; }\n\n.content-table {\n  display: table;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 15px 10px; }\n  .content-table .content-row {\n    display: table-row; }\n  .content-table .content-column {\n    display: table-cell; }\n    .content-table .content-column:first-child {\n      width: 180px; }\n  .content-table.-edit .content-row {\n    display: block; }\n  .content-table.-edit .content-column {\n    display: block;\n    max-width: 450px; }\n    .content-table.-edit .content-column:first-child {\n      margin-bottom: 5px; }\n    .content-table.-edit .content-column .ota-input-text,\n    .content-table.-edit .content-column .ota-input-select {\n      margin-bottom: 15px; }\n\n.content-address {\n  padding: 0 15px; }\n  .content-address div:first-child .box-select-address {\n    margin-top: 15px; }\n\n.box-select-address {\n  border: 1px solid #DFE1E6;\n  margin-top: 30px;\n  width: 445px;\n  overflow: hidden; }\n  @media screen and (max-width: 767px) {\n    .box-select-address {\n      margin-top: 15px; } }\n  .box-select-address.-full-width {\n    width: 100%; }\n  .box-select-address.selected {\n    background-color: transparent;\n    background-image: url(\"/assets/images/account/bg_address.gif\");\n    background-repeat: repeat-x;\n    background-position: 0 0; }\n  .box-select-address .address-inner {\n    padding: 20px 15px; }\n\n.radio-address {\n  margin: 0;\n  position: relative;\n  width: 100%;\n  padding: 15px;\n  padding-top: 23px;\n  font-weight: normal; }\n  .radio-address.-can-select {\n    padding-left: 40px; }\n    @media screen and (max-width: 767px) {\n      .radio-address.-can-select {\n        padding-left: 30px; } }\n  .radio-address input[type=radio] {\n    position: absolute;\n    left: 15px;\n    top: 50%;\n    margin-top: -4px; }\n  .radio-address p {\n    margin: 5px 0 15px 0; }\n\n.delete-address {\n  display: inline-block;\n  margin-top: 15px; }\n  .delete-address a {\n    color: #6b778c; }\n    .delete-address a .icon-delete-addrs {\n      background-color: transparent;\n      background-image: url(\"/assets/images/account/icon_bin.png\");\n      background-repeat: no-repeat;\n      background-position: 0 center;\n      background-size: 14px 15px;\n      width: 14px;\n      height: 15px;\n      display: block;\n      float: left;\n      margin-right: 5px; }\n    .delete-address a span {\n      color: #6b778c;\n      padding: 0;\n      display: block;\n      float: left;\n      margin: -3px 0 0 5px; }\n    .delete-address a:hover span {\n      text-decoration: underline; }\n\n.edit-address {\n  display: inline-block;\n  margin-left: 70px;\n  margin-top: 15px; }\n  .edit-address a {\n    color: #6b778c; }\n    .edit-address a .icon-edit-addrs {\n      background-color: transparent;\n      background-image: url(\"/assets/images/account/icon_edit.png\");\n      background-repeat: no-repeat;\n      background-position: 0 center;\n      background-size: 14px 15px;\n      width: 14px;\n      height: 15px;\n      display: block;\n      float: left;\n      margin-right: 5px; }\n    .edit-address a span {\n      color: #6b778c;\n      padding: 0;\n      display: block;\n      float: left;\n      margin: -3px 0 0 5px; }\n    .edit-address a:hover span {\n      text-decoration: underline; }\n\n.add-address {\n  display: inline-block;\n  color: #576D77;\n  margin-top: 15px;\n  margin-bottom: 15px; }\n  .add-address i, .add-address span {\n    vertical-align: middle; }\n  .add-address i {\n    font-size: 20px;\n    margin-right: 5px; }\n  .add-address:hover {\n    color: #53798a; }\n  .add-address:hover span {\n    text-decoration: underline; }\n\n.address-button {\n  margin: 0 -15px;\n  overflow: hidden; }\n  .address-button .btn-horizontal {\n    float: left;\n    margin: 0 15px;\n    width: calc(50% - 30px); }\n\n.content-detail {\n  padding: 15px; }\n  .content-detail p {\n    margin-bottom: 15px; }\n  .content-detail .ota-checkbox {\n    padding: 0; }\n    .content-detail .ota-checkbox [type=\"checkbox\"]:not(:checked) + label,\n    .content-detail .ota-checkbox [type=\"checkbox\"]:checked + label {\n      color: #061021;\n      padding: 6px 0 6px 25px;\n      line-height: 1.4;\n      background-color: #FFFFFF; }\n\n.content-form {\n  width: 445px;\n  margin: 15px; }\n\n.ota-input-select-group {\n  margin-bottom: 0; }\n\n@media screen and (max-width: 768px) {\n  .content-title {\n    padding: 10px; }\n  .content-table {\n    border-spacing: 0px 10px; }\n  .content-address {\n    padding: 0;\n    padding-bottom: 10px; }\n  .content-address.checkout {\n    padding: 0; }\n  .content-detail {\n    padding: 15px 10px; }\n  .box-select-address {\n    width: 100%; }\n    .box-select-address.selected {\n      border-color: #003a90;\n      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.3); }\n    .box-select-address .address-inner {\n      padding: 15px 10px; }\n  .radio-address {\n    padding: 15px 10px;\n    padding-top: 23px; }\n    .radio-address input[type=radio] {\n      left: 10px; }\n  .address-button {\n    margin: 0; }\n    .address-button .ota-btn-main {\n      float: right; }\n    .address-button .btn-horizontal {\n      margin: 0;\n      width: calc(50% - 5px); }\n  .content-form {\n    width: 100%;\n    padding: 15px 10px;\n    margin: 0; }\n  .btn-horizontal {\n    font-size: 16px; } }\n\n.address-detail p {\n  margin-bottom: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.content-box {\n  margin: 15px 0 0 0; }\n\n.content-title {\n  background-color: #f6f8f9;\n  padding: 10px 15px;\n  overflow: hidden;\n  min-height: 20px; }\n  .content-title a {\n    color: #6b778c; }\n    .content-title a:hover, .content-title a.-active {\n      color: #061021; }\n\n.icon-link-edit {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/icon_edit.png\");\n  background-repeat: no-repeat;\n  background-position: 0 0;\n  background-size: 100%;\n  width: 16px;\n  height: 16px;\n  margin: -2px 5px 0 0;\n  display: inline-block;\n  vertical-align: middle; }\n\n.content-table {\n  display: table;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 15px 10px; }\n  .content-table .content-row {\n    display: table-row; }\n  .content-table .content-column {\n    display: table-cell; }\n    .content-table .content-column:first-child {\n      width: 180px; }\n  .content-table.-edit .content-row {\n    display: block; }\n  .content-table.-edit .content-column {\n    display: block;\n    max-width: 450px; }\n    .content-table.-edit .content-column:first-child {\n      margin-bottom: 5px; }\n    .content-table.-edit .content-column .ota-input-text,\n    .content-table.-edit .content-column .ota-input-select {\n      margin-bottom: 15px; }\n\n.content-address {\n  padding: 0 15px; }\n\n.box-select-address {\n  border: 1px solid #DFE1E6;\n  margin-top: 15px;\n  width: 445px;\n  overflow: hidden; }\n  .box-select-address.-full-width {\n    width: 100%; }\n  .box-select-address.selected {\n    background-color: transparent;\n    background-image: url(\"/assets/images/account/bg_address.gif\");\n    background-repeat: repeat-x;\n    background-position: 0 0; }\n  .box-select-address .address-inner {\n    padding: 20px 15px; }\n\n.radio-address {\n  margin: 0;\n  position: relative;\n  padding: 15px 35px 15px 40px;\n  font-weight: normal; }\n  .radio-address input[type=radio] {\n    position: absolute;\n    left: 15px;\n    top: 50%;\n    margin-top: -4px; }\n  .radio-address p {\n    margin: 5px 0 15px 0; }\n\n.delete-address {\n  display: inline-block;\n  min-height: 30px; }\n  .delete-address a {\n    color: #6b778c; }\n    .delete-address a .icon-delete-addrs {\n      background-color: transparent;\n      background-image: url(\"/assets/images/account/icon_bin.png\");\n      background-repeat: no-repeat;\n      background-position: 0 center;\n      background-size: 14px 15px;\n      width: 14px;\n      height: 15px;\n      display: block;\n      float: left; }\n    .delete-address a span {\n      color: #6b778c;\n      padding: 0;\n      display: block;\n      float: left;\n      margin: -3px 0 0 5px; }\n    .delete-address a:hover {\n      color: #061021; }\n      .delete-address a:hover span {\n        color: #061021; }\n\n.edit-address {\n  display: inline-block;\n  min-height: 30px;\n  margin-left: 70px; }\n  .edit-address a {\n    color: #6b778c; }\n    .edit-address a .icon-edit-addrs {\n      background-color: transparent;\n      background-image: url(\"/assets/images/account/icon_edit.png\");\n      background-repeat: no-repeat;\n      background-position: 0 center;\n      background-size: 14px 15px;\n      width: 14px;\n      height: 15px;\n      display: block;\n      float: left; }\n    .edit-address a span {\n      color: #6b778c;\n      padding: 0;\n      display: block;\n      float: left;\n      margin: -3px 0 0 5px; }\n    .edit-address a:hover {\n      color: #061021; }\n      .edit-address a:hover span {\n        color: #061021; }\n\n.add-address {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/icon_add.png\");\n  background-repeat: no-repeat;\n  background-position: 0 center;\n  background-size: 20px 20px;\n  color: #586d76;\n  padding: 0 0 0 26px;\n  line-height: 20px;\n  margin-bottom: 15px;\n  display: inline-block;\n  color: #576D77;\n  text-decoration: none;\n  margin-top: 15px; }\n  .add-address:visited {\n    color: #576D77; }\n  .add-address:hover {\n    color: #53798A;\n    text-decoration: none; }\n\n.address-button {\n  margin: 0 -15px;\n  overflow: hidden; }\n  .address-button .btn-horizontal {\n    float: left;\n    margin: 0 15px;\n    width: calc(50% - 30px); }\n\n.content-detail {\n  padding: 15px; }\n  .content-detail p {\n    margin-bottom: 15px; }\n  .content-detail .ota-checkbox {\n    padding: 0; }\n    .content-detail .ota-checkbox [type=\"checkbox\"]:not(:checked) + label,\n    .content-detail .ota-checkbox [type=\"checkbox\"]:checked + label {\n      color: #061021;\n      padding: 6px 0 6px 25px;\n      line-height: 1.4;\n      background-color: #FFFFFF; }\n\n.content-form {\n  width: 445px;\n  margin: 15px; }\n\n.ota-input-select-group {\n  margin-bottom: 0; }\n\n@media screen and (max-width: 767px) {\n  .content-title {\n    padding: 10px; }\n  .content-table {\n    border-spacing: 10px 10px; }\n  .content-address {\n    padding: 0 10px; }\n  .content-detail {\n    padding: 15px 10px; }\n  .box-select-address {\n    width: 100%; }\n    .box-select-address .address-inner {\n      padding: 15px 10px; }\n  .radio-address {\n    padding: 15px 30px; }\n    .radio-address input[type=radio] {\n      left: 10px; }\n  .address-button {\n    margin: 0; }\n    .address-button .ota-btn-main {\n      float: right; }\n    .address-button .btn-horizontal {\n      margin: 0;\n      width: calc(50% - 5px); }\n  .content-form {\n    width: 100%;\n    padding: 15px 10px;\n    margin: 0; }\n  .btn-horizontal {\n    font-size: 16px; } }\n\n.profile-content-loading-box {\n  min-height: 190px;\n  text-align: center;\n  padding-top: 60px; }\n\ntextarea {\n  resize: vertical; }\n\n.box-select-address {\n  width: 100%; }\n  @media screen and (max-width: 767px) {\n    .box-select-address {\n      margin-top: 15px; } }\n  .box-select-address.-first-child {\n    margin-top: 15px; }\n  .box-select-address .address-inner {\n    padding: 15px; }\n    @media screen and (max-width: 767px) {\n      .box-select-address .address-inner {\n        margin-top: 10px;\n        padding: 15px 10px; }\n        .box-select-address .address-inner .-mb-20 {\n          margin-bottom: 15px; } }\n\n.-mb-20 {\n  margin-bottom: 20px; }\n\n.content-table {\n  border-spacing: 0 8px; }\n  @media screen and (max-width: 767px) {\n    .content-table {\n      border-spacing: 0; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.my-booking-section {\n  font-size: 14px;\n  color: #061021; }\n\n.header {\n  padding: 8px 30px 8px 15px;\n  max-height: 35px;\n  font-weight: bold;\n  border-bottom: 1px solid #DFE1E6;\n  background-color: #FFFFFF; }\n\n.footer {\n  padding-left: 15px;\n  margin-left: -15px;\n  margin-right: -15px;\n  max-height: 35px;\n  color: #003a90;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  .footer i {\n    margin-right: 5px; }\n  .footer.margin-top {\n    margin-top: 8px; }\n  .booker-info .footer {\n    padding-top: 8px;\n    padding-bottom: 8px;\n    border-top: 1px solid #DFE1E6; }\n\n.body {\n  padding: 30px 15px 30px 30px; }\n\n.data {\n  padding: 15px 15px 30px 15px;\n  background-color: #FFFFFF; }\n  .data .data-header {\n    font-weight: bold;\n    margin-bottom: 10px; }\n  .data div .sub-section {\n    padding-top: 15px;\n    padding-bottom: 15px;\n    border-top: 1px dotted #DFE1E6; }\n\n.sub-section {\n  padding-top: 15px;\n  padding-bottom: 15px; }\n\n.row {\n  margin: 0;\n  width: 100%; }\n  .row:not(:last-child) {\n    margin-bottom: 5px; }\n  .row.seperator-bottom:not(:last-child) {\n    margin-bottom: 15px;\n    border-bottom: 1px dotted #DFE1E6; }\n  .row.room-type:not(:last-child) {\n    padding-bottom: 15px; }\n  .row.d-flex {\n    display: -ms-flexbox;\n    display: flex; }\n  .row .col {\n    display: inline-block; }\n    .row .col:first-child {\n      width: 170px;\n      color: #6b778c; }\n    .row .col:last-child {\n      margin-left: 10px; }\n    .row .col.value {\n      vertical-align: top;\n      word-break: break-all; }\n    .row .col.booking-id {\n      color: #042764; }\n    .row .col.booking-id-value {\n      color: #042764;\n      font-size: 16px; }\n    .row .col.left {\n      width: 80%;\n      color: #061021; }\n      .row .col.left ul {\n        margin-bottom: 0; }\n        .row .col.left ul li {\n          list-style-type: none;\n          display: -ms-flexbox;\n          display: flex; }\n          .row .col.left ul li .li-icon {\n            font-size: 5px;\n            margin-right: 5px;\n            margin-top: 8px; }\n      .row .col.left .cancellation-policy li {\n        font-size: 12px; }\n      .row .col.left .cancellation-policy li:first-child {\n        margin-top: 5px; }\n    .row .col.fix-width {\n      max-width: 68%; }\n\n.tax-width {\n  border-spacing: 0; }\n\n.long-title .row {\n  display: -ms-flexbox;\n  display: flex;\n  border-spacing: 0; }\n  .long-title .row .col:first-child {\n    min-width: 260px; }\n  .long-title .row .col.value {\n    max-width: 500px;\n    word-wrap: break-word; }\n\nhr.seperator-line {\n  display: block;\n  height: 1px;\n  margin: 15px 0;\n  padding: 0;\n  border: 0;\n  border-top: 1px dotted #DFE1E6; }\n\n.room-detail .data .row {\n  display: table;\n  border-spacing: 0; }\n  .room-detail .data .row .col {\n    display: table-cell; }\n    .room-detail .data .row .col.left {\n      width: unset;\n      padding-right: 15px; }\n    .room-detail .data .row .col.right {\n      text-align: end;\n      white-space: nowrap; }\n\n.booking-status {\n  margin-top: 10px;\n  margin-bottom: 0 !important; }\n\n@media screen and (max-width: 768px) {\n  .header {\n    padding: 8px 10px; }\n  .my-booking-section .data {\n    padding: 15px 10px; }\n    .my-booking-section .data.booking-info {\n      padding: 0; }\n    .my-booking-section .data .row {\n      margin-bottom: 0px; }\n      .my-booking-section .data .row .col.value {\n        display: block;\n        margin-left: 0px;\n        word-break: break-word; }\n      .my-booking-section .data .row.seperator-pd-bottom {\n        margin-bottom: 15px !important; }\n      .my-booking-section .data .row .col:first-child {\n        width: unset; }\n        .my-booking-section .data .row .col:first-child.left {\n          display: block;\n          margin-left: 0;\n          padding-left: 0;\n          padding-right: 0; }\n      .my-booking-section .data .row .col-left,\n      .my-booking-section .data .row .col-right {\n        display: inline-block;\n        padding: 10px;\n        width: 49vw; }\n        .my-booking-section .data .row .col-left .title,\n        .my-booking-section .data .row .col-right .title {\n          font-size: 12px;\n          color: #6b778c;\n          margin-bottom: 2px; }\n      .my-booking-section .data .row .col-left {\n        border-right: 1px dotted #DFE1E6; }\n      .my-booking-section .data .row.border-bottom {\n        border-bottom: 1px solid #DFE1E6; }\n    .my-booking-section .data .ref-group {\n      padding: 15px 10px;\n      border-bottom: 1px solid #DFE1E6; }\n      .my-booking-section .data .ref-group .row:not(:last-child) {\n        margin-bottom: 5px !important; }\n    .my-booking-section .data .night-room-guest {\n      padding: 15px 10px; }\n      .my-booking-section .data .night-room-guest i {\n        font-size: 16px;\n        margin-right: 5px; }\n  .my-booking-section .room-detail .data {\n    padding: 15px 10px; }\n    .my-booking-section .room-detail .data .row .col.left {\n      padding-bottom: 10px;\n      border-bottom: 1px dotted #DFE1E6;\n      margin-bottom: 9px; }\n    .my-booking-section .room-detail .data .row .room-total-price .room-total-price-title {\n      font-weight: bold; }\n    .my-booking-section .room-detail .data .row .room-total-price .room-total-price-value {\n      float: right; }\n    .my-booking-section .room-detail .data .row.room-type:not(:last-child) {\n      padding-bottom: 10px; }\n    .my-booking-section .room-detail .data .row.seperator-bottom:not(:last-child) {\n      margin-bottom: 10px;\n      border-bottom: 1px solid #dfe1e6; }\n    .my-booking-section .room-detail .data.room-type {\n      padding-bottom: 10px;\n      margin-bottom: 10px !important; }\n  .my-booking-section .booker-info .data .row {\n    margin-bottom: 5px; }\n  .row.d-flex {\n    -ms-flex-direction: column;\n        flex-direction: column; }\n  .row .col.fix-width {\n    max-width: unset; }\n  .mb-booking-info {\n    margin-bottom: 0; }\n  .booking-status {\n    margin-top: 0;\n    padding: 10px;\n    border-bottom: 1px solid #dfe1e6; }\n    .booking-status .col {\n      margin-left: 0 !important; }\n  .long-title .row {\n    display: block; }\n    .long-title .row .col.value {\n      max-width: unset; } }\n\n.mt-15 {\n  margin-top: 15px; }\n\n.mb-5 {\n  margin-bottom: 5px; }\n\n.color-success {\n  color: #4aad5d; }\n\n.color-fail {\n  color: #ed1c24; }\n\n.color-warning {\n  color: #ff6600; }\n\n.mb-booking-info {\n  margin-bottom: 15px; }\n\n.pl-15 {\n  padding-left: 15px; }\n\n.pb-15 {\n  padding-bottom: 15px; }\n\n.pt-0 {\n  padding-top: 0 !important; }\n\n.pb-0 {\n  padding-bottom: 0 !important; }\n\n.status-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding-left: 185px; }\n  .status-container .status {\n    display: -ms-flexbox;\n    display: flex; }\n    .status-container .status img {\n      width: 16px;\n      height: 16px;\n      margin-top: 2px; }\n    .status-container .status div {\n      padding-left: 10px; }\n      .status-container .status div .status-text {\n        font-weight: bold; }\n      .status-container .status div .status-remark {\n        display: inline-block; }\n  .status-container .reject-reason {\n    padding-top: 5px;\n    font-size: 12px; }\n  @media screen and (max-width: 768px) {\n    .status-container {\n      padding-left: 0; }\n      .status-container .reject-reason {\n        padding-top: 10px; } }\n\n.room-benefit-title {\n  color: #061021;\n  font-family: Thonburi;\n  font-size: 12px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 17px;\n  height: 20px;\n  width: 174px;\n  background-color: #f6f8f9;\n  padding: 2px 10px 2px 10px;\n  margin-bottom: 8px; }\n\n.traveller-table-header {\n  display: table;\n  border-collapse: collapse;\n  width: 100%; }\n  .traveller-table-header .traveller-table-row-header {\n    display: table-row;\n    background-color: #f6f8f9;\n    border-bottom: 2px solid #DFE1E6; }\n    .traveller-table-header .traveller-table-row-header .mb-traveller-table-title-header,\n    .traveller-table-header .traveller-table-row-header .traveller-table-title-header {\n      padding: 10px 15px;\n      display: table-cell;\n      vertical-align: middle;\n      border: none;\n      text-align: left; }\n    .traveller-table-header .traveller-table-row-header .mb-traveller-table-title-header {\n      padding: 10px; }\n  .traveller-table-header .col-l {\n    width: 40%; }\n  .traveller-table-header .col-m {\n    width: 30%; }\n\n.traveller-table-detail {\n  display: table;\n  border-collapse: collapse;\n  width: 100%;\n  border-bottom: 1px solid #DFE1E6; }\n  .traveller-table-detail .mb-traveller-table-detail-room,\n  .traveller-table-detail .traveller-table-detail-room {\n    padding: 15px;\n    display: table-cell;\n    vertical-align: top;\n    border-right: 1px solid #DFE1E6; }\n  .traveller-table-detail .mb-traveller-table-detail-room {\n    padding: 15px 10px;\n    width: 50%; }\n  .traveller-table-detail .traveller-table-detail-guest-sup {\n    display: table;\n    border-collapse: collapse;\n    width: 100%;\n    border-bottom: 1px solid #DFE1E6; }\n    .traveller-table-detail .traveller-table-detail-guest-sup .traveller-table-detail-guest-detail {\n      display: table-cell;\n      width: 50%;\n      border-right: 1px solid #DFE1E6;\n      padding: 15px;\n      vertical-align: top; }\n      .traveller-table-detail .traveller-table-detail-guest-sup .traveller-table-detail-guest-detail .traveller-table-detail-guest-detail-content-check-out {\n        margin-top: 5px; }\n        .traveller-table-detail .traveller-table-detail-guest-sup .traveller-table-detail-guest-detail .traveller-table-detail-guest-detail-content-check-out p {\n          margin-bottom: 2px;\n          font-size: 12px;\n          color: #6b778c; }\n          .traveller-table-detail .traveller-table-detail-guest-sup .traveller-table-detail-guest-detail .traveller-table-detail-guest-detail-content-check-out p:last-child {\n            margin-bottom: 0px; }\n    .traveller-table-detail .traveller-table-detail-guest-sup .traveller-table-detail-sup-detail {\n      display: table-cell;\n      width: 50%;\n      padding: 15px;\n      vertical-align: top; }\n      .traveller-table-detail .traveller-table-detail-guest-sup .traveller-table-detail-sup-detail .status-pending {\n        color: #ff6600;\n        font-size: 12px; }\n      .traveller-table-detail .traveller-table-detail-guest-sup .traveller-table-detail-sup-detail .status-approved {\n        color: #4aad5d;\n        font-size: 12px; }\n      .traveller-table-detail .traveller-table-detail-guest-sup .traveller-table-detail-sup-detail .status-rejected {\n        color: #ed1c24;\n        font-size: 12px; }\n      .traveller-table-detail .traveller-table-detail-guest-sup .traveller-table-detail-sup-detail .status-unable {\n        color: #ff6600;\n        font-size: 12px; }\n    .traveller-table-detail .traveller-table-detail-guest-sup .mb-traveller-table-detail-guest-header {\n      display: table-row;\n      background-color: #f6f8f9; }\n      .traveller-table-detail .traveller-table-detail-guest-sup .mb-traveller-table-detail-guest-header .mb-traveller-table-detail-guest-header-title {\n        padding: 5px 10px;\n        vertical-align: middle;\n        text-align: left;\n        font-size: 12px; }\n    .traveller-table-detail .traveller-table-detail-guest-sup .mb-traveller-table-detail-guest-detail {\n      display: table-row; }\n      .traveller-table-detail .traveller-table-detail-guest-sup .mb-traveller-table-detail-guest-detail .mb-traveller-table-detail-guest-detail-content {\n        padding: 10px 10px 15px 10px; }\n        .traveller-table-detail .traveller-table-detail-guest-sup .mb-traveller-table-detail-guest-detail .mb-traveller-table-detail-guest-detail-content .mb-traveller-table-detail-guest-detail-content-check-out {\n          margin-top: 5px; }\n          .traveller-table-detail .traveller-table-detail-guest-sup .mb-traveller-table-detail-guest-detail .mb-traveller-table-detail-guest-detail-content .mb-traveller-table-detail-guest-detail-content-check-out p {\n            margin-bottom: 2px;\n            font-size: 12px;\n            color: #6b778c; }\n            .traveller-table-detail .traveller-table-detail-guest-sup .mb-traveller-table-detail-guest-detail .mb-traveller-table-detail-guest-detail-content .mb-traveller-table-detail-guest-detail-content-check-out p:last-child {\n              margin-bottom: 0px; }\n        .traveller-table-detail .traveller-table-detail-guest-sup .mb-traveller-table-detail-guest-detail .mb-traveller-table-detail-guest-detail-content .mb-traveller-table-detail-sup-detail {\n          padding-top: 15px;\n          vertical-align: top; }\n          .traveller-table-detail .traveller-table-detail-guest-sup .mb-traveller-table-detail-guest-detail .mb-traveller-table-detail-guest-detail-content .mb-traveller-table-detail-sup-detail .status-pending {\n            color: #ff6600;\n            font-size: 12px; }\n          .traveller-table-detail .traveller-table-detail-guest-sup .mb-traveller-table-detail-guest-detail .mb-traveller-table-detail-guest-detail-content .mb-traveller-table-detail-sup-detail .status-approved {\n            color: #4aad5d;\n            font-size: 12px; }\n          .traveller-table-detail .traveller-table-detail-guest-sup .mb-traveller-table-detail-guest-detail .mb-traveller-table-detail-guest-detail-content .mb-traveller-table-detail-sup-detail .status-rejected {\n            color: #ed1c24;\n            font-size: 12px; }\n          .traveller-table-detail .traveller-table-detail-guest-sup .mb-traveller-table-detail-guest-detail .mb-traveller-table-detail-guest-detail-content .mb-traveller-table-detail-sup-detail .status-unable {\n            color: #ff6600;\n            font-size: 12px; }\n    .traveller-table-detail .traveller-table-detail-guest-sup:last-child {\n      border-bottom: none; }\n  .traveller-table-detail .traveller-guest div:last-child {\n    border-bottom: none !important; }\n  .traveller-table-detail .col-l {\n    width: 40%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".alert {\n  padding: 6px 15px 7px 15px; }\n\n.close {\n  float: right;\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 1;\n  color: #6b778c;\n  text-shadow: 0 1px 0 #FFFFFF;\n  filter: alpha(opacity=100);\n  opacity: 1; }\n\n.alert-top-wrap {\n  margin: 0 auto;\n  margin-bottom: 15px;\n  width: 100%;\n  max-width: 1140px;\n  background-color: #e4edff;\n  color: #042764;\n  text-align: center; }\n\n.alert-dismissible {\n  padding-right: 15px;\n  border-radius: initial; }\n  .alert-dismissible .close {\n    position: relative;\n    right: -10px;\n    color: #6b778c;\n    font-size: 20px;\n    font-weight: bold; }\n\na.tooltips {\n  position: relative;\n  color: #003a90;\n  -webkit-text-decoration-line: underline;\n          text-decoration-line: underline;\n  -webkit-text-decoration-style: dotted;\n          text-decoration-style: dotted; }\n\na.tooltips .tooltips-content {\n  position: absolute;\n  width: 298px;\n  padding: 7px 7px 5px 8px;\n  color: #042764;\n  background: #FFFFFF;\n  border: 1px solid #042764;\n  font-size: 12px;\n  line-height: 1.3;\n  text-align: left;\n  visibility: hidden;\n  border-radius: 4px; }\n\na.tooltips .tooltips-content:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: 100%;\n  margin-top: -10px;\n  width: 0;\n  height: 0;\n  border-right: 5px solid #042764;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent; }\n\na.tooltips .tooltips-content:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: 100%;\n  margin-top: -9px;\n  width: 0;\n  height: 0;\n  border-right: 4px solid #FFFFFF;\n  border-top: 3px solid transparent;\n  border-bottom: 3px solid transparent; }\n\na:hover,\n.for-hover:hover {\n  color: #042764; }\n  a:hover .for-hover,\n  .for-hover:hover .for-hover {\n    position: absolute;\n    width: 300px;\n    top: -20%;\n    height: 50px;\n    right: 0%; }\n  a:hover .tooltips-content,\n  a:hover .tooltips-content:hover,\n  .for-hover:hover .tooltips-content,\n  .for-hover:hover .tooltips-content:hover {\n    visibility: visible;\n    opacity: 1;\n    top: -27px;\n    left: 30px;\n    z-index: 999; }\n    a:hover .tooltips-content.under,\n    a:hover .tooltips-content:hover.under,\n    .for-hover:hover .tooltips-content.under,\n    .for-hover:hover .tooltips-content:hover.under {\n      color: #042764;\n      min-width: 300px;\n      top: unset !important;\n      left: unset !important;\n      margin-top: 10px !important;\n      margin-left: unset !important;\n      right: 0px !important;\n      padding: 0px !important;\n      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5); }\n      a:hover .tooltips-content.under::before,\n      a:hover .tooltips-content:hover.under::before,\n      .for-hover:hover .tooltips-content.under::before,\n      .for-hover:hover .tooltips-content:hover.under::before {\n        content: \"\";\n        position: absolute;\n        top: 1px;\n        right: 15px;\n        margin-top: -10px;\n        width: 0;\n        height: 0;\n        border-bottom: 5px solid #042764;\n        border-left: 4px solid transparent;\n        border-right: 4px solid transparent; }\n      a:hover .tooltips-content.under::after,\n      a:hover .tooltips-content:hover.under::after,\n      .for-hover:hover .tooltips-content.under::after,\n      .for-hover:hover .tooltips-content:hover.under::after {\n        content: \"\";\n        position: absolute;\n        top: 4px;\n        right: 16px;\n        margin-top: -10px;\n        width: 0;\n        height: 0;\n        border-bottom: 4px solid #FFFFFF;\n        border-left: 3px solid transparent;\n        border-right: 3px solid transparent; }\n\n.tc-container-special-budget .title {\n  padding: 12px 8px 0;\n  font-weight: bold; }\n\n.tc-container-special-budget .detail {\n  color: #061021;\n  padding: 4px 8px 0; }\n\n.tc-container-special-budget .tc-item {\n  display: -ms-flexbox;\n  display: flex;\n  padding: 12px 8px 0; }\n  .tc-container-special-budget .tc-item:first-child {\n    padding: 8px;\n    margin-top: 12px;\n    border-radius: 4px;\n    background-color: #F6F8F9; }\n  .tc-container-special-budget .tc-item:not(:first-child) {\n    padding: 12px 8px;\n    color: #061021; }\n  .tc-container-special-budget .tc-item div {\n    display: inline-block; }\n    .tc-container-special-budget .tc-item div:nth-child(1) {\n      width: 50%; }\n    .tc-container-special-budget .tc-item div:nth-child(2) {\n      margin-left: auto; }\n  .tc-container-special-budget .tc-item .font-bold {\n    font-weight: bold; }\n  .tc-container-special-budget .tc-item span {\n    color: #6b778c !important; }\n  .tc-container-special-budget .tc-item.last {\n    padding: 8px;\n    background-color: #F6F8F9;\n    color: #042764; }\n\n.tc-container-some-days .title {\n  padding: 12px 8px 0;\n  font-weight: bold; }\n\n.tc-container-some-days .detail {\n  color: #061021;\n  padding: 4px 8px 0; }\n\n.tc-container-some-days .tc-item {\n  display: -ms-flexbox;\n  display: flex;\n  padding: 12px 8px 0; }\n  .tc-container-some-days .tc-item:first-child {\n    color: #061021; }\n  .tc-container-some-days .tc-item.last {\n    padding: 8px;\n    margin-top: 12px;\n    background-color: #F6F8F9; }\n  .tc-container-some-days .tc-item div {\n    display: inline-block; }\n    .tc-container-some-days .tc-item div:nth-child(1) {\n      width: 55%; }\n    .tc-container-some-days .tc-item div:nth-child(2) {\n      margin-left: auto; }\n  .tc-container-some-days .tc-item .font-bold {\n    font-weight: bold; }\n\n.tc-container-poi .title {\n  padding: 12px 8px 0;\n  font-weight: bold; }\n\n.tc-container-poi .detail {\n  color: #061021;\n  padding: 4px 8px 0; }\n\n.tc-container-poi .tc-item {\n  display: -ms-flexbox;\n  display: flex;\n  padding: 12px 8px 0; }\n  .tc-container-poi .tc-item:first-child {\n    color: #061021; }\n  .tc-container-poi .tc-item.last {\n    padding: 8px;\n    margin-top: 12px;\n    background-color: #F6F8F9; }\n  .tc-container-poi .tc-item div {\n    display: inline-block; }\n    .tc-container-poi .tc-item div:nth-child(1) {\n      width: 55%; }\n    .tc-container-poi .tc-item div:nth-child(2) {\n      margin-left: auto; }\n    .tc-container-poi .tc-item div.w-100 {\n      width: 100%; }\n  .tc-container-poi .tc-item .font-bold {\n    font-weight: bold; }\n  .tc-container-poi .tc-item span {\n    color: #6b778c !important; }\n\n.more-detail {\n  color: #003a90;\n  text-align: right;\n  padding: 12px 8px; }\n  .more-detail:hover {\n    color: #042764;\n    -webkit-text-decoration-line: underline;\n            text-decoration-line: underline; }\n\n.color-main {\n  color: #061021; }\n\n.share-budget {\n  position: relative;\n  top: -20px;\n  float: right;\n  color: #042764; }\n  .share-budget.tooltips {\n    -webkit-text-decoration-line: unset;\n            text-decoration-line: unset;\n    -webkit-text-decoration-style: unset;\n            text-decoration-style: unset; }\n    .share-budget.tooltips .tooltips-content {\n      top: 30px;\n      left: -71px;\n      width: 240px;\n      height: auto;\n      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5); }\n      .share-budget.tooltips .tooltips-content.en {\n        left: -122px; }\n      .share-budget.tooltips .tooltips-content::before {\n        top: 0%;\n        right: 15px;\n        border: 5px solid #042764;\n        border-top: 4px solid transparent;\n        border-right: 4px solid transparent;\n        border-left: 4px solid transparent; }\n      .share-budget.tooltips .tooltips-content::after {\n        top: 0%;\n        right: 15px;\n        border: 5px solid white;\n        border-top: 5px solid transparent;\n        border-right: 4px solid transparent;\n        border-left: 4px solid transparent; }\n    .share-budget.tooltips .tooltips-content-en {\n      top: 30px;\n      left: -138px;\n      width: 240px;\n      height: auto;\n      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5); }\n      .share-budget.tooltips .tooltips-content-en::before {\n        top: 0%;\n        right: 15px;\n        border: 5px solid #042764;\n        border-top: 4px solid transparent;\n        border-right: 4px solid transparent;\n        border-left: 4px solid transparent; }\n      .share-budget.tooltips .tooltips-content-en::after {\n        top: 0%;\n        right: 15px;\n        border: 5px solid white;\n        border-top: 5px solid transparent;\n        border-right: 4px solid transparent;\n        border-left: 4px solid transparent; }\n    .share-budget.tooltips span:hover {\n      -webkit-text-decoration-line: underline;\n              text-decoration-line: underline;\n      -webkit-text-decoration-style: solid;\n              text-decoration-style: solid; }\n    .share-budget.tooltips:hover {\n      color: #042764; }\n\n.share-budget-mobile {\n  padding: 10px;\n  vertical-align: middle;\n  border: 1px solid #e4edff;\n  background-color: #F3F6FC;\n  font-size: 12px; }\n  .share-budget-mobile a {\n    color: #003a90; }\n\n.d-inline {\n  display: inline; }\n\n.tc-item {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px; }\n  .tc-item.has-more-detail {\n    border-radius: 0; }\n\n.co-budget-note {\n  color: #ed1c24; }\n\n@media screen and (max-width: 768px) {\n  .wrap-inner-auto {\n    padding: 0 10px 10px; }\n  .alert {\n    padding: 10px;\n    text-align: left;\n    font-size: 12px;\n    text-align: left; }\n  .alert-top-wrap {\n    margin-bottom: 0px; }\n  .tooltips {\n    -webkit-text-decoration-line: underline;\n            text-decoration-line: underline;\n    -webkit-text-decoration-style: dotted;\n            text-decoration-style: dotted; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n:host /deep/ .dialog-wrapper-content {\n  padding: 0px !important;\n  min-height: unset !important;\n  width: auto !important; }\n\n.icon-close2 {\n  display: inline;\n  position: absolute;\n  font-size: 16px;\n  right: 15px;\n  color: #DFE1E6; }\n  .icon-close2:hover {\n    color: #6b778c; }\n\n.box {\n  padding: 15px;\n  width: 760px; }\n  .box .title {\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 20px; }\n  .box .sub-title {\n    margin-top: 2px;\n    padding-bottom: 12px; }\n  .box .table-overflow {\n    max-height: 400px;\n    overflow-y: auto; }\n  .box .destination-list ul {\n    color: #003a90;\n    margin: 0px; }\n  .box .destination-list li {\n    display: inline-block;\n    width: 50%;\n    padding: 0 0 12px 4px; }\n  .box .destination-list li:before {\n    content: \"\\2022   \"; }\n  .box table {\n    width: 100%; }\n    .box table tr {\n      border-bottom: 1px solid #DFE1E6; }\n      .box table tr:first-child {\n        border-bottom: 2px solid #DFE1E6;\n        background-color: #f6f8f9; }\n      .box table tr .summary-title {\n        font-weight: bold;\n        font-size: 16px;\n        line-height: 20px; }\n      .box table tr .total {\n        font-size: 16px;\n        line-height: 20px; }\n      .box table tr .summary-sub-title {\n        font-size: 12px; }\n        .box table tr .summary-sub-title.color-sub {\n          color: #6b778c; }\n      .box table tr:last-child {\n        background-color: #f6f8f9;\n        border-bottom: none; }\n    .box table td {\n      padding: 10px;\n      vertical-align: top;\n      text-align: right;\n      border-right: 1px solid #DFE1E6; }\n      .box table td:nth-child(1) {\n        text-align: left; }\n      .box table td:last-child {\n        border-right: none; }\n      .box table td.border-right-none {\n        border-right: none; }\n    .box table.pois tr {\n      border-bottom: 1px solid #DFE1E6; }\n      .box table.pois tr:first-child {\n        background-color: #f6f8f9; }\n      .box table.pois tr:nth-child(2) {\n        background-color: #f6f8f9; }\n    .box table.pois td.destination {\n      text-align: center !important;\n      border-bottom: 1px solid #DFE1E6; }\n    .box table.share-budget {\n      margin-bottom: 20px; }\n      .box table.share-budget:last-child {\n        margin-bottom: 12px; }\n      .box table.share-budget tr {\n        border-bottom: 1px solid #DFE1E6; }\n      .box table.share-budget td {\n        padding: 10px;\n        vertical-align: top;\n        text-align: right;\n        border-right: 1px solid #DFE1E6;\n        min-width: 162px; }\n        .box table.share-budget td:last-child {\n          border-right: none; }\n        .box table.share-budget td.border-co-booker {\n          border-top: 1px solid #DFE1E6;\n          border-right: 1px solid #DFE1E6; }\n        .box table.share-budget td.destination {\n          min-width: 488;\n          text-align: center; }\n        .box table.share-budget td.first-column {\n          min-width: 240px;\n          text-align: left; }\n        .box table.share-budget td.border-right-none {\n          border-right: none; }\n      .box table.share-budget thead td {\n        border-top: 0; }\n      .box table.share-budget tbody tr:first-child td {\n        border-top: 2px solid #DFE1E6; }\n      .box table.share-budget tfoot tr {\n        border-bottom: 0; }\n      .box table.share-budget .day-check-in {\n        padding: 10px;\n        background-color: #f6f8f9;\n        border-bottom: 2px solid #DFE1E6;\n        margin: 0px; }\n        .box table.share-budget .day-check-in .destiantion {\n          text-align: right; }\n      .box table.share-budget .border-bottom-1 {\n        border-bottom: 1px solid #DFE1E6; }\n      .box table.share-budget .box-summary {\n        margin: 0;\n        background-color: #f6f8f9; }\n        .box table.share-budget .box-summary .summary-title {\n          font-weight: bold;\n          font-size: 16px;\n          line-height: 20px; }\n        .box table.share-budget .box-summary .summary-sub-title {\n          font-size: 12px; }\n      .box table.share-budget .total {\n        text-align: right;\n        font-size: 16px;\n        line-height: 20px; }\n      .box table.share-budget .total-budget-remark {\n        text-align: right;\n        font-size: 12px;\n        line-height: 14px;\n        margin-top: 2px;\n        color: #ed1c24;\n        white-space: normal; }\n      .box table.share-budget.mobile td {\n        min-width: 50%; }\n      .box table.share-budget.mobile:last-child {\n        margin-bottom: 24px; }\n\n.border-bottom-0 {\n  border-bottom: none !important; }\n\n.border-bottom-1 {\n  border-bottom: 1px solid #DFE1E6 !important; }\n\n.bg-unset {\n  background-color: unset !important; }\n\n@media screen and (max-width: 768px) {\n  :host /deep/ .dialog-wrapper-content {\n    width: 100vw !important;\n    padding: 15px 10px !important;\n    height: calc(var(--height-vh, 1vh) * 100) !important;\n    overflow-y: auto; }\n  :host /deep/ .mat-dialog-content {\n    padding: 0px !important; }\n  .table-responsive {\n    border: 0;\n    margin-bottom: 0; }\n  .box {\n    padding: 0px;\n    width: unset; }\n    .box .table-overflow {\n      max-height: unset; }\n    .box table {\n      margin-bottom: 15px; }\n      .box table:last-child {\n        margin-bottom: 24px; }\n      .box table tr .summary-title {\n        font-weight: bold;\n        font-size: 16px;\n        line-height: 20px; }\n      .box table tr .total {\n        font-size: 16px;\n        line-height: 20px; }\n      .box table td:nth-child(1) {\n        min-width: unset;\n        width: 50%; }\n    .box .row {\n      padding: 10px 0 !important; }\n  .icon-close2 {\n    top: 20px; }\n  .footer {\n    border-top: 1px solid #DFE1E6;\n    padding: 12px 12px 0;\n    margin: 0 -12px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    gap: 16px; }\n    .footer .action-left, .footer .action-right {\n      width: 50%; }\n      .footer .action-left button, .footer .action-right button {\n        margin: 0;\n        height: 44px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ":host /deep/ .dialog-wrapper-content {\n  padding: 0px !important;\n  min-height: unset !important;\n  width: auto !important; }\n\n.tc-container-special-budget .tc-item {\n  display: -ms-flexbox;\n  display: flex; }\n  .tc-container-special-budget .tc-item:first-child {\n    padding: 5px 10px !important;\n    margin-top: 10px;\n    border-radius: 4px;\n    color: #042764;\n    background-color: #F6F8F9; }\n  .tc-container-special-budget .tc-item:not(:first-child) {\n    padding: 10px;\n    color: #061021; }\n  .tc-container-special-budget .tc-item div {\n    display: inline-block; }\n    .tc-container-special-budget .tc-item div:nth-child(1) {\n      width: 50%; }\n    .tc-container-special-budget .tc-item div:nth-child(2) {\n      margin-left: auto; }\n  .tc-container-special-budget .tc-item .font-bold {\n    font-weight: bold; }\n\n.tc-container-special-budget .box-bottom {\n  padding: 20px 10px;\n  border-bottom: 1px solid #DFE1E6; }\n\n.tc-container-special-budget .row {\n  margin: 0px; }\n  .tc-container-special-budget .row .btn-close {\n    padding: 10px;\n    text-align: center; }\n\n.tc-container-special-budget.share-budget {\n  padding: 20px 10px 0 10px; }\n  .tc-container-special-budget.share-budget .tc-item {\n    padding: 10px 10px 0 10px; }\n    .tc-container-special-budget.share-budget .tc-item span {\n      color: #6b778c !important; }\n  .tc-container-special-budget.share-budget .box-bottom {\n    padding: 10px 0 20px; }\n    .tc-container-special-budget.share-budget .box-bottom .tc-item {\n      margin-top: 0; }\n\n.tc-container-some-days .title {\n  padding: 20px 10px 5px;\n  font-weight: bold;\n  color: #042764; }\n\n.tc-container-some-days .detail {\n  color: #061021;\n  padding: 0 10px 5px; }\n\n.tc-container-some-days .tc-item {\n  color: #042764;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 5px 20px; }\n  .tc-container-some-days .tc-item:first-child {\n    color: #061021; }\n  .tc-container-some-days .tc-item div {\n    display: inline-block; }\n    .tc-container-some-days .tc-item div:nth-child(1) {\n      width: 55%; }\n    .tc-container-some-days .tc-item div:nth-child(2) {\n      margin-left: auto; }\n  .tc-container-some-days .tc-item .font-bold {\n    font-weight: bold; }\n\n.tc-container-some-days .box-bottom {\n  padding: 0 10px 20px 10px;\n  border-bottom: 1px solid #DFE1E6; }\n  .tc-container-some-days .box-bottom .tc-item {\n    padding: 10px;\n    background-color: #F6F8F9;\n    color: #042764; }\n\n.tc-container-some-days .row {\n  margin: 0px; }\n  .tc-container-some-days .row .btn-close {\n    padding: 10px;\n    float: left; }\n  .tc-container-some-days .row .btn-more-detail {\n    padding: 10px;\n    float: right; }\n\n.tc-container-poi .title {\n  padding: 20px 10px 5px;\n  font-weight: bold;\n  color: #042764; }\n\n.tc-container-poi .detail {\n  color: #061021;\n  padding: 0 10px 5px; }\n\n.tc-container-poi .tc-item {\n  color: #042764;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 5px 20px; }\n  .tc-container-poi .tc-item:first-child {\n    color: #061021; }\n  .tc-container-poi .tc-item div {\n    display: inline-block; }\n    .tc-container-poi .tc-item div:nth-child(1) {\n      width: 55%; }\n    .tc-container-poi .tc-item div:nth-child(2) {\n      margin-left: auto; }\n    .tc-container-poi .tc-item div.w-100 {\n      width: 100%; }\n  .tc-container-poi .tc-item .font-bold {\n    font-weight: bold; }\n  .tc-container-poi .tc-item span {\n    color: #6b778c !important; }\n  .tc-container-poi .tc-item.last {\n    background-color: #F6F8F9;\n    color: #042764;\n    margin: 5px 10px 20px;\n    padding: 10px; }\n  .tc-container-poi .tc-item.co-budget-note {\n    color: #ed1c24; }\n\n.tc-container-poi .box-bottom {\n  padding: 0 10px 20px 10px;\n  border-bottom: 1px solid #DFE1E6;\n  color: #042764; }\n  .tc-container-poi .box-bottom .box {\n    padding: 5px 10px;\n    background-color: #F6F8F9; }\n\n.tc-container-poi .row {\n  margin: 0px; }\n  .tc-container-poi .row .btn-close {\n    padding: 10px;\n    float: left; }\n    .tc-container-poi .row .btn-close.center {\n      float: unset;\n      text-align: center; }\n  .tc-container-poi .row .btn-more-detail {\n    padding: 10px;\n    float: right; }\n  .tc-container-poi .row.bt-1 {\n    border-top: 1px solid #DFE1E6; }\n\n.color-main {\n  color: #061021 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".bottom-10 {\n  bottom: 10px !important; }\n\n.carousel-container {\n  position: relative; }\n\n.carousel-item {\n  width: 100%;\n  -ms-flex: 1 0 auto;\n      flex: 1 0 auto;\n  float: left;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  position: relative;\n  transition: all 1s; }\n\n.cursor {\n  cursor: pointer;\n  width: 100%; }\n\n.prev, .next {\n  cursor: pointer;\n  position: absolute;\n  top: 50%;\n  width: auto;\n  padding: 16px;\n  margin-top: -22px;\n  color: white;\n  font-size: 32px;\n  transition: 0.6s ease;\n  border-radius: 0 3px 3px 0;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  text-decoration: none;\n  z-index: 1; }\n\n.next {\n  right: 0; }\n\n.nav-dot {\n  position: absolute;\n  bottom: 30px;\n  width: 100%;\n  text-align: center; }\n  .nav-dot .dot {\n    cursor: pointer;\n    height: 8px;\n    width: 8px;\n    margin: 0 7.5px;\n    background-color: #D1D1D1;\n    border-radius: 50%;\n    display: inline-block;\n    transition: background-color 0.6s ease; }\n    .nav-dot .dot.active {\n      background-color: #ed1c24; }\n\n.img-slide {\n  width: 100%;\n  object-fit: cover;\n  min-height: 480px; }\n  @media (max-width: 1024px) {\n    .img-slide {\n      min-height: 380px; } }\n  @media (max-width: 768px) {\n    .img-slide {\n      min-height: 300px; } }\n\n.img-slide-mobile {\n  width: 100%;\n  object-fit: cover;\n  max-height: 480px; }\n\n#carousel-item-list {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  width: 100%; }\n\n.shifting {\n  transition: left .4s ease-out;\n  -webkit-transition: left .4s ease-out; }\n\n.wrapper {\n  position: relative;\n  overflow: hidden;\n  width: 100%; }\n\n.ota-btn-main {\n  background-color: #ed1c24;\n  padding: 10px 20px;\n  border-radius: 2px;\n  color: white;\n  text-decoration: none;\n  margin-right: 10px;\n  font-size: 16px; }\n  .ota-btn-main:hover {\n    background-color: #E40000; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.cart {\n  position: relative;\n  display: block;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 10;\n  width: 260px;\n  transition: opacity 0.3s; }\n  .cart.-show {\n    opacity: 1;\n    visibility: visible; }\n  .cart.-sticky {\n    position: fixed;\n    top: 1px; }\n  .cart .total-price-top {\n    background-color: #FFFFFF;\n    border-left: 0;\n    border-right: 0;\n    padding-top: 15px;\n    padding-bottom: 10px;\n    height: 60px;\n    font-size: 20px;\n    line-height: 1;\n    text-align: center; }\n  .cart .summary-detail .box-summary-all-room,\n  .cart .summary-detail .header-detail-list {\n    display: none; }\n  .cart .summary-detail .hotel-booking-box,\n  .cart .summary-detail .box-check-date,\n  .cart .summary-detail .box-summary-all-room,\n  .cart .summary-detail .header-detail-list,\n  .cart .summary-detail .promo-code,\n  .cart .summary-detail .detail-list,\n  .cart .summary-detail .total-price {\n    background-color: #FFFFFF; }\n  .cart .hotel-booking-box {\n    padding: 0 15px 15px;\n    overflow: hidden; }\n  .cart .img-hotel-booking {\n    width: 70px;\n    height: 70px;\n    margin-right: 10px;\n    float: left; }\n  .cart .text-hotel-booking {\n    padding: 3px 0;\n    width: 200px;\n    float: left;\n    font-size: 14px; }\n  .cart .box-check-date {\n    padding: 10px 0;\n    border-top: 1px solid #DFE1E6;\n    border-bottom: 2px solid #DFE1E6;\n    overflow: hidden; }\n  .cart .box-check-date .col-check-date {\n    width: 50%;\n    padding-left: 15px;\n    float: left; }\n    .cart .box-check-date .col-check-date:first-child {\n      border-right: 1px dotted #DFE1E6; }\n  .cart .promo-code {\n    padding: 15px; }\n    .cart .promo-code .promo-code-container {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n      .cart .promo-code .promo-code-container .promo-code-left {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n            align-items: center;\n        gap: 10px; }\n        .cart .promo-code .promo-code-container .promo-code-left img {\n          width: 40px;\n          height: 40px; }\n        .cart .promo-code .promo-code-container .promo-code-left .promo-code-title {\n          font-weight: bold;\n          line-height: 18px; }\n        .cart .promo-code .promo-code-container .promo-code-left .promo-code-label {\n          display: -ms-flexbox;\n          display: flex;\n          gap: 5px;\n          margin-top: 2px;\n          font-size: 12px;\n          line-height: 14px;\n          color: #A5ADBA; }\n          .cart .promo-code .promo-code-container .promo-code-left .promo-code-label.valid {\n            color: #4aad5d; }\n      .cart .promo-code .promo-code-container .promo-code-right {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n            align-items: center;\n        gap: 8px;\n        cursor: pointer;\n        line-height: 18px; }\n        .cart .promo-code .promo-code-container .promo-code-right i {\n          font-size: 16px; }\n        @media (hover: hover) {\n          .cart .promo-code .promo-code-container .promo-code-right a:hover {\n            color: #042764;\n            text-decoration: underline; } }\n        .cart .promo-code .promo-code-container .promo-code-right .discount-amount {\n          padding: 4px 8px;\n          color: #A5ADBA;\n          background-color: #DFE1E6;\n          border: 1px dotted #A5ADBA; }\n          .cart .promo-code .promo-code-container .promo-code-right .discount-amount.valid {\n            color: #4aad5d;\n            background-color: #F2FCE5;\n            border: 1px dotted #93CDB2; }\n        .cart .promo-code .promo-code-container .promo-code-right.disabled {\n          cursor: unset; }\n          .cart .promo-code .promo-code-container .promo-code-right.disabled a {\n            cursor: unset;\n            color: #A5ADBA; }\n            .cart .promo-code .promo-code-container .promo-code-right.disabled a:hover {\n              text-decoration: none; }\n    .cart .promo-code .promo-code-error-message {\n      color: #ed1c24;\n      line-height: 18px;\n      margin-top: 5px; }\n  .cart .detail-list {\n    padding: 15px;\n    margin: 0; }\n    .cart .detail-list.-scroll {\n      height: 225px;\n      overflow-y: scroll; }\n    .cart .detail-list li {\n      padding: 10px 0; }\n      .cart .detail-list li:not(:last-child) {\n        border-bottom: 1px dotted #DFE1E6; }\n    .cart .detail-list.has-taxes-and-fees li:nth-last-child(2) {\n      border-bottom: none; }\n    .cart .detail-list .discount {\n      color: #4aad5d; }\n  .cart .col-detail-title {\n    display: block;\n    width: 100%;\n    line-height: 1.35; }\n  .cart .col-detail-text {\n    display: block;\n    float: left;\n    width: 58%; }\n  .cart .col-nonrefund-text {\n    width: 100%;\n    font-size: 12px;\n    float: right;\n    color: #6b778c; }\n  .cart .col-detail-price {\n    width: 42%;\n    display: block;\n    float: right;\n    text-align: right; }\n  .cart .total-price {\n    padding: 15px 10px 0; }\n  .cart .total-price .pull-left {\n    font-weight: 600;\n    padding-top: 10px; }\n  .cart .total-price .text-include-vat,\n  .cart .total-price .text-remark {\n    display: block;\n    font-size: 12px;\n    width: 100%;\n    line-height: 1.5; }\n  .cart .total-price .text-include-vat {\n    line-height: 1.5;\n    margin-bottom: 15px; }\n  .cart .total-price .text-remark {\n    margin-bottom: 15px;\n    color: #E40000; }\n  .cart .total-price .text-remark span {\n    display: inline-block; }\n  .cart .total-price .box-available-budget {\n    background-color: #fff8ef;\n    border: 1px dotted #ffccaa;\n    padding: 8px 10px;\n    margin: 10px 0;\n    font-size: 12px; }\n    .cart .total-price .box-available-budget strong {\n      color: #ff6600;\n      display: inline; }\n    .cart .total-price .box-available-budget div {\n      display: inline; }\n    .cart .total-price .box-available-budget.danger {\n      background-color: #fff6f7;\n      border: 1px dotted #ff9095; }\n      .cart .total-price .box-available-budget.danger strong {\n        color: #ed1c24; }\n      .cart .total-price .box-available-budget.danger .btn-cancel-share-budget {\n        color: #003a90;\n        cursor: pointer; }\n        .cart .total-price .box-available-budget.danger .btn-cancel-share-budget:hover {\n          color: #042764;\n          text-decoration: underline; }\n\n.cart.checkout {\n  width: 360px; }\n  .cart.checkout .total-price-top {\n    border-right: 0px solid #DFE1E6;\n    border-left: 0px solid #DFE1E6;\n    text-align: left;\n    padding: 15px 15px 10px 15px;\n    font-size: 20px;\n    line-height: 20px;\n    height: 100%; }\n    .cart.checkout .total-price-top strong {\n      font-weight: 600; }\n    .cart.checkout .total-price-top span {\n      color: #6b778c; }\n  .cart.checkout .summary-detail .total-price {\n    margin-top: 15px;\n    padding: 15px 15px 0; }\n    .cart.checkout .summary-detail .total-price .pull-left {\n      font-size: 20px;\n      font-weight: 600;\n      padding: 2px 0 0; }\n    .cart.checkout .summary-detail .total-price .text-include-vat {\n      margin-bottom: 10px; }\n  .cart.checkout .summary-detail .box-summary-all-room {\n    display: block;\n    padding: 15px; }\n    .cart.checkout .summary-detail .box-summary-all-room .sum-item {\n      font-size: 14px; }\n      .cart.checkout .summary-detail .box-summary-all-room .sum-item i {\n        margin-right: 11px; }\n  .cart.checkout .summary-detail .header-detail-list {\n    display: block;\n    padding: 7px 15px 7px 15px;\n    margin-top: 15px;\n    border-bottom: 1px solid #DFE1E6; }\n  .cart.checkout .summary-detail .detail-list {\n    border-bottom: unset; }\n  .cart.checkout .summary-detail .box-check-date {\n    padding: 15px 0;\n    border-bottom: 1px solid #DFE1E6; }\n  .cart.checkout .hotel-star.-half {\n    width: 8px;\n    overflow: hidden; }\n  .cart.checkout .icon-star {\n    font-size: 16px;\n    color: #facc48; }\n\n.mini-cart {\n  display: none;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  padding: 0;\n  width: 100%;\n  height: 70px;\n  overflow: hidden;\n  background-color: #FFFFFF;\n  border-top: 1px solid #DFE1E6;\n  z-index: 2147483645;\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);\n  overflow: visible; }\n  .mini-cart.more-detail-multi-payment {\n    height: 85px; }\n    @media screen and (max-width: 320px) {\n      .mini-cart.more-detail-multi-payment {\n        height: 95px; } }\n  .mini-cart.summary-dialog-opened {\n    z-index: 2147483647; }\n  .mini-cart .more-detail-container {\n    width: 60px;\n    height: 23px;\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    top: -17px;\n    border-radius: 4px;\n    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);\n    background-color: #ffffff; }\n    .mini-cart .more-detail-container:after {\n      content: \" \";\n      display: block;\n      width: 70px;\n      height: 11px;\n      background-color: white;\n      position: relative;\n      top: 16px;\n      left: -4px; }\n    .mini-cart .more-detail-container .more-detail {\n      width: 16px;\n      height: 16px;\n      background-color: #6b778c;\n      background-repeat: no-repeat;\n      background-position: center;\n      position: relative;\n      margin-left: auto;\n      margin-right: auto; }\n      .mini-cart .more-detail-container .more-detail.-up {\n        -webkit-mask: url(\"../../../assets/images/form/Top.svg\");\n                mask: url(\"../../../assets/images/form/Top.svg\"); }\n      .mini-cart .more-detail-container .more-detail.-down {\n        background: url(\"../../../assets/images/form/Down.svg\") 2px center no-repeat;\n        border: 0; }\n  .mini-cart .sticky-inner {\n    width: 100%;\n    height: 100%;\n    display: table;\n    border-spacing: 10px 15px;\n    border-collapse: separate; }\n  .mini-cart .total-price,\n  .mini-cart .total-button {\n    width: 50%; }\n  .mini-cart .total-price {\n    text-align: left;\n    display: table-cell;\n    position: relative;\n    height: 40px;\n    vertical-align: middle; }\n  .mini-cart .total-price-wrapper {\n    display: block;\n    position: relative;\n    height: 40px;\n    width: 100%; }\n    .mini-cart .total-price-wrapper .grand-total {\n      display: block;\n      font-size: 12px; }\n    .mini-cart .total-price-wrapper .grand-total-currency,\n    .mini-cart .total-price-wrapper .grand-total-price {\n      display: inline-block;\n      height: 22px;\n      font-size: 22px;\n      line-height: 1; }\n  .mini-cart .total-button {\n    display: table-cell; }\n  .mini-cart .total-button .ota-btn-main {\n    height: 40px;\n    margin: 0;\n    min-width: 110px; }\n  .mini-cart .multi-payment-section {\n    font-size: 10px;\n    width: 50%; }\n\n@media screen and (max-width: 1120px) {\n  .cart {\n    display: none; }\n  .cart.checkout {\n    display: block;\n    margin: auto;\n    width: 100%;\n    z-index: 0; }\n  .cart.checkout.-sticky {\n    position: inherit;\n    top: inherit; }\n  .mini-cart {\n    display: block; }\n  .mini-cart.checkout {\n    display: none; }\n  .text-hotel-booking {\n    width: calc(100% - 85px) !important;\n    float: right !important; }\n    .text-hotel-booking .hotel-booking-name {\n      display: unset; } }\n\n@media screen and (max-width: 1120px) and (orientation: landscape) {\n  .cart {\n    display: none; }\n  .cart.checkout {\n    display: block;\n    margin: auto;\n    width: 100%;\n    z-index: 0; }\n  .cart.checkout.-sticky {\n    position: fixed;\n    top: 1px; }\n  .mini-cart {\n    display: block; }\n  .mini-cart.checkout {\n    display: none; }\n  .text-hotel-booking {\n    width: calc(100% - 85px) !important;\n    float: right !important; }\n    .text-hotel-booking .hotel-booking-name {\n      display: unset; } }\n\n@media screen and (max-width: 768px) {\n  .hide-sm {\n    display: none !important; }\n  .header-detail-list {\n    margin-top: 0px !important;\n    padding: 10px !important;\n    font-size: 16px; }\n  .row-ration {\n    background-color: #DFE1E6;\n    height: 15px;\n    margin-left: -15px;\n    margin-right: -15px; } }\n\n@media screen and (max-width: 1120px) and (orientation: portrait) {\n  .cart.checkout.-sticky {\n    position: inherit;\n    top: inherit; } }\n\n@media screen and (max-width: 768px) {\n  .cart.checkout {\n    display: block;\n    margin: auto;\n    width: 100%;\n    z-index: 0; }\n    .cart.checkout.-sticky {\n      position: inherit;\n      top: inherit; }\n    .cart.checkout .total-price-top {\n      padding: 15px 10px 10px 10px; }\n    .cart.checkout .summary-detail .hotel-booking-box {\n      padding: 0 10px 15px 10px; }\n    .cart.checkout .summary-detail .box-check-date .col-check-date {\n      padding-left: 10px; }\n    .cart.checkout .summary-detail .box-check-date .col-check-date {\n      padding-left: 10px; }\n    .cart.checkout .summary-detail .box-summary-all-room {\n      margin-bottom: 15px; }\n    .cart.checkout .summary-detail .promo-code {\n      padding: 10px;\n      margin-bottom: 15px; }\n    .cart.checkout .summary-detail .detail-list {\n      padding: 0 10px; }\n    .cart.checkout .summary-detail .total-price {\n      padding: 10px 10px 0; } }\n\n.line-sep-multi-pay {\n  width: 100%;\n  height: 2px;\n  border-bottom: dotted 1px #dfe1e6;\n  margin-top: 9px;\n  margin-bottom: 9px; }\n\n.multi-pay-section .multi-pay-header {\n  font-weight: 600;\n  margin-bottom: 10px; }\n\n.multi-pay-section .d-flex {\n  margin-bottom: 9px; }\n  .multi-pay-section .d-flex .amount {\n    margin-bottom: auto;\n    margin-left: auto; }\n    .multi-pay-section .d-flex .amount.mr-10 {\n      margin-right: 10px; }\n  .multi-pay-section .d-flex.ml-10 {\n    margin-left: 10px; }\n  .multi-pay-section .d-flex.debit-card-section {\n    color: #042764;\n    padding: 8px 10px;\n    background-color: #F6F8F9 !important;\n    border-top: dotted 1px #dfe1e6;\n    border-bottom: dotted 1px #dfe1e6; }\n    .multi-pay-section .d-flex.debit-card-section .debit-card {\n      background-color: #F6F8F9 !important; }\n\n.border-bottom {\n  border-bottom: 2px solid #dfe1e6; }\n\n.mt-5 {\n  margin-top: 5px; }\n\n.ota-btn-main {\n  margin: 0 0 15px 0;\n  height: 40px; }\n\n.font-24px {\n  font-size: 24px;\n  line-height: 28px; }\n\n.ota-btn-main.loading:before {\n  margin-top: -7px; }\n\n.ota-btn-main.loading:after {\n  margin-top: -7px; }\n\n.ws-nowrap {\n  padding-left: 20px;\n  white-space: nowrap; }\n\n.cart-share-budget {\n  margin-left: 10px; }\n  .cart-share-budget ul {\n    margin-left: 20px; }\n    .cart-share-budget ul li {\n      list-style-type: disc; }\n      .cart-share-budget ul li .budget {\n        padding: 10px 10px 0 0; }\n        .cart-share-budget ul li .budget span {\n          float: right; }\n\n.grand-total-price-container {\n  margin-bottom: 10px;\n  text-align: right; }\n\n.grand-total-price-default {\n  line-height: 18px;\n  margin-top: 2px;\n  text-align: right; }\n\n.credit-card-amount {\n  line-height: 18px;\n  text-align: right; }\n\n.credit-card-amount-default {\n  margin-top: 5px; }\n\n.price-info-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  gap: 10px;\n  padding: 10px;\n  background-color: #E4EDFF;\n  border: 1px solid #BFD6FF;\n  margin-bottom: 10px; }\n  .price-info-container .price-info-label {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    gap: 5px;\n    font-size: 14px;\n    line-height: 18px; }\n  .price-info-container i {\n    font-size: 14px;\n    font-weight: bold;\n    color: #003A90; }\n  .price-info-container .price-info-content {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    gap: 10px;\n    padding-left: 20px;\n    margin-bottom: 0;\n    font-size: 12px;\n    line-height: 14px; }\n    .price-info-container .price-info-content .surcharges-container {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-direction: column;\n          flex-direction: column;\n      gap: 5px; }\n    .price-info-container .price-info-content li {\n      list-style: disc; }\n\n.taxes-fees {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 4px;\n  float: left;\n  width: 58%; }\n\n.taxes-fees-icon {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer; }\n\n.tooltip-content {\n  display: none;\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #061021;\n  color: #FFFFFF;\n  padding: 8px 12px;\n  width: 280px;\n  z-index: 1;\n  border-radius: 4px;\n  text-align: left;\n  font-size: 12px;\n  line-height: 14px; }\n\n.tooltip-arrow {\n  position: absolute;\n  top: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 6px solid black;\n  line-height: 0; }\n\n@media (hover: hover) {\n  .tooltip-trigger:hover + .tooltip-content,\n  .tooltip-content:hover {\n    display: block; } }\n\n.terms-conditions {\n  font-size: 12px;\n  line-height: 14px;\n  margin-bottom: 15px; }\n  .terms-conditions .normal-text {\n    color: #061021; }\n\na {\n  color: #003A90; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n/* ------------ popup -------------*/\n.box-popup-full-white {\n  background: #FFFFFF;\n  width: 100%;\n  min-height: 100%;\n  margin-bottom: 71px;\n  position: relative;\n  padding-bottom: 0; }\n  .box-popup-full-white .close-box {\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    top: -7px;\n    right: 20px;\n    padding: 15px; }\n    .box-popup-full-white .close-box button {\n      color: #DFE1E6; }\n      .box-popup-full-white .close-box button:hover {\n        color: #6b778c; }\n    @media screen and (max-width: 767px) {\n      .box-popup-full-white .close-box {\n        width: 18px;\n        height: 18px; }\n        .box-popup-full-white .close-box img {\n          width: 100%; } }\n  .box-popup-full-white .header-section {\n    text-align: center;\n    padding: 15px 0;\n    border-bottom: 1px solid #DFE1E6; }\n    .box-popup-full-white .header-section .popup-title {\n      font-size: 20px;\n      font-weight: 700; }\n    .box-popup-full-white .header-section .popup-sub-title {\n      font-size: 12px; }\n  .box-popup-full-white .detail-list {\n    border-bottom: 2px solid #DFE1E6;\n    margin-bottom: 0; }\n    @media screen and (max-width: 768px) {\n      .box-popup-full-white .detail-list li {\n        border-bottom: none; } }\n  .box-popup-full-white .total-price {\n    padding: 10px 10px; }\n    .box-popup-full-white .total-price .total-price-desc .pull-left {\n      margin-top: 10px; }\n    .box-popup-full-white .total-price .total-price-desc.line-seperate-bottom {\n      padding-bottom: 10px;\n      margin-bottom: 10px;\n      border-bottom: 1px dotted #DFE1E6; }\n    .box-popup-full-white .total-price .multi-pay-section .multi-pay-header {\n      padding: 0 0 10px; }\n    .box-popup-full-white .total-price .multi-pay-section .d-flex {\n      padding: 10px; }\n      .box-popup-full-white .total-price .multi-pay-section .d-flex .fix-width {\n        width: 50%; }\n      .box-popup-full-white .total-price .multi-pay-section .d-flex .amount {\n        margin-left: auto; }\n      .box-popup-full-white .total-price .multi-pay-section .d-flex.debit-card-section {\n        color: #042764;\n        background-color: #F6F8F9;\n        border-top: 1px dotted #DFE1E6;\n        border-bottom: 1px dotted #DFE1E6; }\n    .box-popup-full-white .total-price .text-include-vat {\n      margin-top: 10px;\n      margin-bottom: 5px;\n      font-size: 12px; }\n    .box-popup-full-white .total-price .text-remark {\n      font-size: 12px;\n      color: #ed1c24; }\n  .box-popup-full-white .total-price .box-available-budget {\n    background-color: #fff8ef;\n    border: 1px solid #ffccaa;\n    padding: 10px;\n    margin: 10px 0 0;\n    font-size: 12px; }\n    .box-popup-full-white .total-price .box-available-budget strong {\n      color: #ff6600;\n      display: inline; }\n    .box-popup-full-white .total-price .box-available-budget div {\n      display: inline; }\n    .box-popup-full-white .total-price .box-available-budget.danger {\n      background-color: #fff6f7;\n      border: 1px dotted #ff9095; }\n      .box-popup-full-white .total-price .box-available-budget.danger strong {\n        color: #ed1c24; }\n      .box-popup-full-white .total-price .box-available-budget.danger .btn-cancel-share-budget {\n        color: #003a90;\n        cursor: pointer; }\n        .box-popup-full-white .total-price .box-available-budget.danger .btn-cancel-share-budget:hover {\n          color: #042764;\n          text-decoration: underline; }\n  .box-popup-full-white .text-include-vat.cannot {\n    margin-bottom: 10px; }\n\n.option-price-range .form-control {\n  width: 108px;\n  padding: 6px 10px;\n  display: inline-block; }\n  .option-price-range .form-control[readonly] {\n    background-color: white; }\n    .option-price-range .form-control[readonly]:focus {\n      border-color: #DFE1E6;\n      box-shadow: none; }\n\n.icon-close2 {\n  -moz-appearance: none;\n       appearance: none;\n  border: 0;\n  outline: 0;\n  background: none; }\n\n@media screen and (min-width: 766px) {\n  .line-bottom {\n    border-bottom: 1px solid #dfe1e6; } }\n\n.review-description {\n  font-weight: normal; }\n\n.ota-checkbox,\n.ota-radio {\n  padding: 0;\n  position: relative; }\n  .ota-checkbox input[type=\"radio\"],\n  .ota-radio input[type=\"radio\"] {\n    position: absolute;\n    top: 10px;\n    left: 10px; }\n  .ota-checkbox label,\n  .ota-radio label {\n    padding: 3px 0 3px 35px;\n    font-weight: normal;\n    line-height: 34px; }\n    .ota-checkbox label::before,\n    .ota-radio label::before {\n      top: 12px;\n      left: 12px; }\n    .ota-checkbox label::after,\n    .ota-radio label::after {\n      top: 11px;\n      left: 16px; }\n  .ota-checkbox .label-text,\n  .ota-radio .label-text {\n    color: #4a4a4a !important; }\n  .ota-checkbox .label-number,\n  .ota-radio .label-number {\n    position: absolute;\n    right: 10px;\n    color: #6b778c !important; }\n\n.m-0 {\n  margin: 0 !important; }\n\n.dialog-cart-summary /deep/ .mat-dialog-content {\n  -ms-flex-align: unset !important;\n      align-items: unset !important;\n  padding: 0 !important;\n  min-height: calc(var(--dialog-filter-vh, 1vh) * 100) !important;\n  max-height: calc(var(--dialog-filter-vh, 1vh) * 100) !important; }\n\n:host /deep/ .dialog-wrapper-content {\n  padding: 0 !important; }\n\n.box-check-date {\n  padding: 0px; }\n  .box-check-date .col-check-date {\n    padding: 10px; }\n\n.cart-share-budget {\n  margin-left: 10px; }\n  .cart-share-budget ul {\n    margin-left: 15px; }\n    .cart-share-budget ul li {\n      list-style-type: disc; }\n      .cart-share-budget ul li .budget {\n        padding: 10px 10px 0 0; }\n        .cart-share-budget ul li .budget span {\n          float: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n:host /deep/ ota-dialog .dialog-wrapper-content {\n  min-height: 202px !important; }\n\n.dialog-title {\n  font-weight: bold;\n  color: #003A90; }\n\n.dialog-body {\n  margin-top: 10px;\n  font-size: 14px;\n  line-height: 18px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ":host /deep/ .dialog-use-promotion-code .dialog-wrapper-content {\n  padding: 0;\n  width: 750px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  @media screen and (max-width: 767px) {\n    :host /deep/ .dialog-use-promotion-code .dialog-wrapper-content {\n      width: 100%;\n      max-height: 100dvh; } }\n\n.dialog-title {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  font-size: 20px;\n  line-height: 24px;\n  font-weight: bold;\n  padding: 24px 15px 12px; }\n  @media screen and (max-width: 767px) {\n    .dialog-title {\n      padding: 20px 12px;\n      border-bottom: 1px solid #dfe1e6; } }\n  .dialog-title i {\n    font-size: 16px;\n    color: #6b778c;\n    cursor: pointer; }\n\n.dialog-content {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex: 1;\n      flex: 1;\n  overflow: hidden; }\n  .dialog-content .input-search-containter {\n    display: -ms-flexbox;\n    display: flex;\n    gap: 16px;\n    padding: 15px;\n    margin: 16px 16px 0;\n    background-color: #f6f8f9; }\n    @media screen and (max-width: 767px) {\n      .dialog-content .input-search-containter {\n        margin: 0; } }\n    .dialog-content .input-search-containter .input-search {\n      position: relative;\n      width: 100%; }\n      .dialog-content .input-search-containter .input-search .form-control:focus {\n        outline: none;\n        box-shadow: 0px 0px 4px 1px #85B6FF; }\n      .dialog-content .input-search-containter .input-search .icon-close2 {\n        position: absolute;\n        top: 12px;\n        right: 15px;\n        font-size: 16px;\n        color: #6b778c;\n        cursor: pointer; }\n      .dialog-content .input-search-containter .input-search .ota-text-error {\n        width: 160%;\n        margin-top: 4px; }\n    .dialog-content .input-search-containter .ota-btn-main {\n      width: 120px; }\n  .dialog-content .promotion-code-container {\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: (1fr)[2];\n        grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n    max-height: 300px;\n    min-height: 300px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    -ms-flex: 1;\n        flex: 1;\n    padding: 16px 16px 0;\n    margin-bottom: 28px;\n    position: relative; }\n    @media screen and (max-width: 767px) {\n      .dialog-content .promotion-code-container {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        max-height: unset;\n        padding: 16px 12px 28px;\n        margin-bottom: 0; } }\n    .dialog-content .promotion-code-container .best-deal {\n      position: absolute;\n      top: -10px;\n      left: -4px;\n      padding: 3px 8px;\n      color: #FFFFFF;\n      background-color: #ED6F6F;\n      border-top-right-radius: 2px;\n      border-bottom-right-radius: 2px;\n      z-index: 1; }\n    .dialog-content .promotion-code-container .promotion-code-card-wrapper {\n      position: relative;\n      cursor: pointer; }\n      .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card {\n        position: relative;\n        border: 2px solid #DFE1E6;\n        border-radius: 8px;\n        min-height: 130px;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n        -webkit-mask-image: radial-gradient(circle at 0 38%, transparent 8px, black 8px), radial-gradient(circle at 100% 38%, transparent 8px, black 8px);\n                mask-image: radial-gradient(circle at 0 38%, transparent 8px, black 8px), radial-gradient(circle at 100% 38%, transparent 8px, black 8px);\n        mask-composite: intersect;\n        -webkit-mask-composite: source-in; }\n        .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card.selected {\n          border-color: #003a90 !important;\n          background-color: #e4edff; }\n          .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card.selected::before, .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card.selected::after {\n            border-color: #003a90 !important; }\n          .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card.selected .promotion-code-card-payment-method {\n            background-color: #bfd6ff; }\n      .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card-discount-container {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n            align-items: center;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n        padding: 12px 20px; }\n        .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card-discount-container.no-max-discount {\n          padding: 21px 20px; }\n        .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card-discount-container .promotion-code-card-discount {\n          display: -ms-flexbox;\n          display: flex;\n          -ms-flex-align: center;\n              align-items: center;\n          gap: 12px; }\n          .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card-discount-container .promotion-code-card-discount .promotion-code-discount {\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-direction: column;\n                flex-direction: column;\n            gap: 4px; }\n            .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card-discount-container .promotion-code-card-discount .promotion-code-discount .promotion-code-discount-amount {\n              font-size: 14px;\n              line-height: 18px;\n              font-weight: bold; }\n          .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card-discount-container .promotion-code-card-discount .promotion-code-discount-condition {\n            display: -ms-flexbox;\n            display: flex;\n            gap: 8px; }\n            .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card-discount-container .promotion-code-card-discount .promotion-code-discount-condition .condition-description {\n              color: #6b778c; }\n          .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card-discount-container .promotion-code-card-discount img {\n            width: 40px; }\n        .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card-discount-container .icon-circle-check {\n          font-size: 24px;\n          color: #003a90; }\n        .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card-discount-container .non-selected-circle {\n          width: 24px;\n          height: 24px;\n          border: 2px solid #dfe1e6;\n          border-radius: 50%;\n          background-color: #FFFFFF; }\n      .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-divider {\n        position: absolute;\n        right: 56px;\n        top: 0;\n        bottom: 0;\n        border-right: 1px dashed #003a90; }\n      .dialog-content .promotion-code-container .promotion-code-card-wrapper .promotion-code-card-payment-method {\n        position: relative;\n        padding: 8px 16px;\n        background-color: #e4edff;\n        border-bottom-left-radius: 6px;\n        border-bottom-right-radius: 6px; }\n    .dialog-content .promotion-code-container .promotion-code-card::before,\n    .dialog-content .promotion-code-container .promotion-code-card::after {\n      content: \"\";\n      position: absolute;\n      width: 20px;\n      height: 20px;\n      background: #FFFFFF;\n      border: 2px solid #dfe1e6;\n      border-radius: 50%;\n      top: 38%;\n      transform: translateY(-50%);\n      z-index: 3; }\n    .dialog-content .promotion-code-container .promotion-code-card::before {\n      right: 0px;\n      transform: translate(50%, -50%); }\n    .dialog-content .promotion-code-container .promotion-code-card::after {\n      left: -20px;\n      transform: translate(50%, -50%); }\n  .dialog-content .no-promotion-code {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    gap: 12px;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center;\n    padding: 96px 0;\n    font-size: 14px;\n    line-height: 18px;\n    min-height: 300px; }\n    .dialog-content .no-promotion-code img {\n      width: 100px;\n      height: 60px; }\n\n.dialog-footer {\n  padding: 12px 16px;\n  border-top: 1px solid #DFE1E6;\n  padding-top: 15px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center; }\n  @media screen and (max-width: 767px) {\n    .dialog-footer {\n      padding: 12px; } }\n  .dialog-footer .ota-btn-main {\n    width: 160px;\n    height: 40px;\n    margin: 0; }\n    @media screen and (max-width: 767px) {\n      .dialog-footer .ota-btn-main {\n        height: 44px; } }\n  .dialog-footer .summary-discount-amount-container .summary-discount-amount {\n    font-size: 20px;\n    line-height: 24px; }\n    .dialog-footer .summary-discount-amount-container .summary-discount-amount.selected {\n      color: #4aad5d; }\n\n.font-description {\n  font-size: 12px;\n  line-height: 14px; }\n\n.disabled {\n  color: #A5ADBA;\n  background-color: #DFE1E6; }\n\n.unclickable {\n  pointer-events: none; }\n\n@media (hover: hover) {\n  .dialog-title i:hover {\n    color: #061021; }\n  .dialog-content .input-search-containter .input-search .icon-close2:hover {\n    color: #061021; }\n  .dialog-content .promotion-code-container .promotion-code-card:hover {\n    background-color: #e4edff;\n    border: 2px solid #bfd6ff !important; }\n    .dialog-content .promotion-code-container .promotion-code-card:hover::before, .dialog-content .promotion-code-container .promotion-code-card:hover::after {\n      border: 2px solid #bfd6ff; }\n    .dialog-content .promotion-code-container .promotion-code-card:hover .promotion-code-card-payment-method {\n      background-color: #bfd6ff; }\n  .dialog-content .promotion-code-container .link-btn:hover {\n    color: #042764;\n    text-decoration: underline; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n/*base-link-mixin*/\n.homepage {\n  background-color: transparent;\n  background-image: url(\"/assets/images/home/bg_home.jpg\");\n  background-repeat: no-repeat;\n  background-position: center 0; }\n\n@media screen and (max-width: 767px) {\n  .nav-sm-menu {\n    width: calc(100vw - 20px) !important;\n    margin-left: 0px !important; } }\n\nbody {\n  background-color: #f5f5f5; }\n\n.bookingpage {\n  width: 100%;\n  height: auto;\n  background-color: #f5f5f5; }\n\n.booking-content-box {\n  background-color: white;\n  min-height: 600px;\n  text-align: center;\n  padding: 50px 30px; }\n  @media screen and (max-width: 767px) {\n    .booking-content-box {\n      margin-left: -10px;\n      margin-right: -10px; } }\n\n.account-container > .col-right {\n  background-color: transparent; }\n\n@media screen and (max-width: 767px) {\n  .account-container {\n    margin: 0 0 5px 0; } }\n\n.booking-content {\n  background-color: #FFFFFF;\n  padding: 15px;\n  margin-bottom: 30px; }\n  .booking-content.top {\n    margin-bottom: 15px; }\n  .booking-content.bottom {\n    margin-bottom: 15px; }\n  .booking-content.no-margin-bottom {\n    margin-bottom: 0; }\n\n.booking-filter-container {\n  padding: 15px 0; }\n  .booking-filter-container .search-box-container,\n  .booking-filter-container .filter-by-container,\n  .booking-filter-container .sort-by-container {\n    display: inline-block; }\n\n.search-box-container {\n  width: 40%; }\n  @media screen and (max-width: 1100px) {\n    .search-box-container {\n      width: 35%; } }\n\n.filter-by-container,\n.sort-by-container {\n  width: 30%;\n  float: right;\n  text-align: right; }\n  @media screen and (max-width: 1100px) {\n    .filter-by-container,\n    .sort-by-container {\n      width: 32%; } }\n  .filter-by-container .form-control.form-select,\n  .sort-by-container .form-control.form-select {\n    width: 150px;\n    line-height: 40px;\n    padding-top: 0px; }\n\n.my-booking-header {\n  margin: 0;\n  padding: 10px;\n  background-color: #FFFFFF; }\n\n.search-box-mobile-container {\n  width: 100%;\n  margin-bottom: 10px; }\n\n.booking-content2 {\n  background-color: #FFFFFF;\n  padding: 15px;\n  height: 500px;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  .booking-content2 img {\n    height: 60px;\n    width: 100px;\n    margin-bottom: 15px;\n    margin-top: 60px; }\n  .booking-content2 .text-blank {\n    text-align: center; }\n\n.booking-tab {\n  border-bottom: 1px solid #DFE1E6;\n  margin: 15px 0;\n  overflow: hidden; }\n  .booking-tab li {\n    width: 150px;\n    height: 40px;\n    float: left;\n    text-align: center;\n    border-left: 1px solid #DFE1E6;\n    border-top: 1px solid #DFE1E6; }\n    .booking-tab li:last-child {\n      border-right: 1px solid #DFE1E6; }\n    .booking-tab li a {\n      color: #061021;\n      line-height: 39px; }\n    .booking-tab li:hover, .booking-tab li.active {\n      background-color: #576D77;\n      border-color: #576D77; }\n      .booking-tab li:hover a, .booking-tab li.active a {\n        color: #FFFFFF; }\n\n.booking-manage {\n  float: right;\n  width: 260px; }\n\n.manage-print,\n.manage-send {\n  width: 50px;\n  height: 35px;\n  line-height: 33px;\n  float: left;\n  text-align: center;\n  border-left: 1px solid #DFE1E6;\n  border-top: 1px solid #DFE1E6;\n  border-bottom: 1px solid #DFE1E6; }\n\n.manage-send {\n  border-left: none; }\n\n.icon-print {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/icon_print.png\");\n  background-repeat: no-repeat;\n  background-position: 0 0;\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  margin: -3px 0 0 0; }\n\n.icon-send {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/icon_send.png\");\n  background-repeat: no-repeat;\n  background-position: 0 0;\n  width: 20px;\n  height: 16px;\n  display: inline-block;\n  vertical-align: middle;\n  margin: -3px 0 0 0; }\n\n.manage-menu {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/arrow_menu.png\");\n  background-repeat: no-repeat;\n  background-position: calc(100% - 10px) center;\n  background-size: 11px 8px;\n  width: 160px;\n  height: 40px;\n  float: right;\n  position: relative;\n  border: 1px solid #DFE1E6;\n  line-height: 33px;\n  padding-left: 10px;\n  cursor: pointer; }\n\n.manage-menu-list {\n  border-left: 1px solid #DFE1E6;\n  border-right: 1px solid #DFE1E6;\n  position: absolute;\n  width: 160px;\n  top: 34px;\n  left: -1px;\n  background-color: #FFFFFF; }\n  .manage-menu-list li {\n    border-bottom: 1px solid #DFE1E6;\n    line-height: 34px; }\n    .manage-menu-list li a {\n      display: block;\n      padding-left: 10px;\n      color: #061021; }\n      .manage-menu-list li a:hover {\n        color: #FFFFFF;\n        background-color: #576D77; }\n\n.box-title {\n  margin: 0 15px 5px 15px; }\n\n.booking-line-dotted {\n  height: 1px;\n  border-bottom: 1px dotted #DFE1E6;\n  margin: 0 15px 15px 15px; }\n\n.box-rebooking {\n  border-bottom: 1px solid #DFE1E6;\n  padding: 0 0 15px 0;\n  text-align: right; }\n  .box-rebooking a {\n    color: #6b778c; }\n  .box-rebooking .icon-rebooking {\n    background-color: transparent;\n    background-image: url(\"/assets/images/account/icon_rebooking.png\");\n    background-repeat: no-repeat;\n    background-position: 0 0;\n    background-size: 15px 16px;\n    display: inline-block;\n    width: 15px;\n    height: 16px;\n    vertical-align: middle;\n    margin-right: 5px;\n    margin-top: -3px; }\n\n.ota-pagination-lg {\n  margin-bottom: 0; }\n\n.date-booking-box {\n  border-top: 1px solid #DFE1E6;\n  margin-top: 15px;\n  padding-top: 15px;\n  overflow: hidden; }\n  .date-booking-box .booking-table {\n    width: 350px;\n    float: left;\n    line-height: 1.5; }\n\n.room-type-title {\n  background-color: #f6f8f9;\n  padding: 0 15px;\n  margin: 0px 15px;\n  line-height: 35px;\n  overflow: hidden; }\n\n.room-type-list {\n  margin: 0 15px; }\n  .room-type-list li {\n    padding: 15px;\n    border-bottom: 1px dotted #DFE1E6;\n    overflow: hidden; }\n    .room-type-list li .room-detail {\n      width: 80%;\n      float: left;\n      color: #333; }\n    .room-type-list li .room-price {\n      width: 20%;\n      float: right;\n      text-align: right;\n      overflow: hidden;\n      color: #333; }\n\n.more-room-detail {\n  padding: 10px 0 5px 25px;\n  color: #666666; }\n  .more-room-detail p {\n    margin-bottom: 8px; }\n    .more-room-detail p:last-child {\n      margin-bottom: 0px; }\n    .more-room-detail p span {\n      color: #333; }\n\n.show-detail,\n.hide-detail {\n  padding: 5px 0 5px 25px;\n  color: #586c77;\n  display: block;\n  background-size: 20px 20px;\n  color: #576D77;\n  text-decoration: none; }\n  .show-detail:visited,\n  .hide-detail:visited {\n    color: #576D77; }\n  .show-detail:hover,\n  .hide-detail:hover {\n    color: #53798A;\n    text-decoration: none; }\n\n.show-detail {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/icon_arrow_down.png\");\n  background-repeat: no-repeat;\n  background-position: 0 center; }\n\n.hide-detail {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/icon_arrow_up.png\");\n  background-repeat: no-repeat;\n  background-position: 0 center; }\n\n.price-summary {\n  width: 375px;\n  margin: 0 15px 25px 15px;\n  float: right;\n  color: #333; }\n  .price-summary > .row {\n    padding: 8px 10px;\n    overflow: hidden;\n    border-top: 1px dotted #DFE1E6; }\n    .price-summary > .row:first-child {\n      border-top: none; }\n  .price-summary .total {\n    font-size: 22px;\n    overflow: hidden;\n    background-color: #f6f8f9;\n    padding: 10px; }\n  .price-summary .summary-col-left {\n    float: left;\n    width: 50%; }\n  .price-summary .summary-col-right {\n    float: right;\n    width: 50%;\n    text-align: right; }\n\n/*---popup---*/\n.booking-popup {\n  width: 800px;\n  position: relative;\n  background-color: #FFFFFF; }\n  .booking-popup .popup-overflow {\n    padding: 15px;\n    min-height: 310px; }\n    @media screen and (max-width: 767px) {\n      .booking-popup .popup-overflow {\n        padding: 10px; } }\n  .booking-popup .close-popup-box {\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    top: 15px;\n    right: 10px;\n    opacity: 0.3;\n    filter: alpha(opacity=30);\n    border: none;\n    background-color: transparent; }\n    .booking-popup .close-popup-box:hover {\n      opacity: 1;\n      filter: alpha(opacity=100); }\n  .booking-popup .popup-title {\n    font-size: 20px;\n    font-weight: bold;\n    padding: 0 15px;\n    margin: 0 -15px 15px;\n    font-family: Arial, Thonburi, tahoma, sans-serif; }\n    @media screen and (max-width: 767px) {\n      .booking-popup .popup-title {\n        padding: 0 10px;\n        margin: 0 -10px 10px; } }\n    .booking-popup .popup-title .title-detail {\n      font-weight: normal; }\n  .booking-popup .topic-box {\n    font-size: 14px;\n    color: #061021;\n    margin-bottom: 15px; }\n  .booking-popup .space-b5 {\n    margin: 0 0 5px !important; }\n  .booking-popup .table-list-room {\n    width: 100%;\n    display: table;\n    box-sizing: border-box; }\n    .booking-popup .table-list-room .col-left,\n    .booking-popup .table-list-room .col-right {\n      padding: 10px;\n      margin: 0;\n      box-sizing: border-box;\n      display: block;\n      float: left;\n      position: relative; }\n    .booking-popup .table-list-room .col-left {\n      width: 60%; }\n      .booking-popup .table-list-room .col-left::after {\n        width: 1px;\n        background-color: #DFE1E6;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        right: -1px; }\n    .booking-popup .table-list-room .col-right {\n      width: 40%; }\n    .booking-popup .table-list-room .table-head {\n      border-bottom: 2px solid #DFE1E6;\n      font-weight: normal !important;\n      background-color: #f6f8f9;\n      display: table;\n      width: 100%;\n      box-sizing: border-box; }\n      .booking-popup .table-list-room .table-head .col-left,\n      .booking-popup .table-list-room .table-head .col-right {\n        padding: 6px 10px 5px;\n        background-color: #f6f8f9; }\n      .booking-popup .table-list-room .table-head .col-right {\n        text-align: right; }\n    .booking-popup .table-list-room .table-body {\n      width: 100%;\n      display: table;\n      background-color: #FFFFFF; }\n      .booking-popup .table-list-room .table-body .table-item {\n        background-color: #FFFFFF;\n        border-bottom: 1px solid #DFE1E6; }\n      .booking-popup .table-list-room .table-body .col-left {\n        text-align: left;\n        border-right: 1px solid #DFE1E6; }\n        .booking-popup .table-list-room .table-body .col-left .cl-condition {\n          font-size: 12px;\n          margin-top: 5px;\n          color: #6b778c; }\n          .booking-popup .table-list-room .table-body .col-left .cl-condition .cc-title {\n            text-decoration: underline; }\n      .booking-popup .table-list-room .table-body .col-right {\n        text-align: right; }\n        .booking-popup .table-list-room .table-body .col-right .cr-title {\n          display: none; }\n    .booking-popup .table-list-room .table-body-summary {\n      width: 100%;\n      display: table;\n      background-color: #f6f8f9; }\n      .booking-popup .table-list-room .table-body-summary .col-left,\n      .booking-popup .table-list-room .table-body-summary .col-right {\n        padding: 7px 10px;\n        font-size: 20px;\n        font-weight: 600; }\n      .booking-popup .table-list-room .table-body-summary .col-left {\n        top: 2px;\n        position: relative; }\n        .booking-popup .table-list-room .table-body-summary .col-left .cl-multipayment {\n          font-size: 12px;\n          font-weight: normal;\n          color: #6b778c; }\n      .booking-popup .table-list-room .table-body-summary .col-right {\n        text-align: right;\n        font-size: 24px; }\n        .booking-popup .table-list-room .table-body-summary .col-right .cr-currency {\n          font-weight: normal; }\n      @media screen and (max-width: 767px) {\n        .booking-popup .table-list-room .table-body-summary .col-left {\n          text-align: left; }\n        .booking-popup .table-list-room .table-body-summary .col-right {\n          background-color: transparent;\n          border-left: 0; } }\n    .booking-popup .table-list-room .table-body-payment-type {\n      width: 100%;\n      display: table;\n      background-color: #FFFFFF; }\n      .booking-popup .table-list-room .table-body-payment-type .col-left {\n        width: 70%; }\n      .booking-popup .table-list-room .table-body-payment-type .col-right {\n        width: 30%;\n        text-align: right;\n        font-weight: 600; }\n        .booking-popup .table-list-room .table-body-payment-type .col-right .cr-currency {\n          font-weight: normal; }\n      .booking-popup .table-list-room .table-body-payment-type .tbpt-credit-terms,\n      .booking-popup .table-list-room .table-body-payment-type .tbpt-credit-card {\n        border-bottom: 1px dotted #DFE1E6; }\n  .booking-popup .remark-box {\n    font-size: 12px;\n    margin: 10px 0 15px;\n    color: #6b778c; }\n    @media screen and (max-width: 767px) {\n      .booking-popup .remark-box {\n        margin-bottom: 15px; } }\n    .booking-popup .remark-box .remark-title {\n      text-decoration: underline; }\n  .booking-popup .popup-button {\n    width: 100%;\n    padding: 15px;\n    border-top: 1px solid #DFE1E6; }\n    .booking-popup .popup-button .btn-horizontal {\n      max-width: 180px;\n      margin: 0 !important; }\n      .booking-popup .popup-button .btn-horizontal:nth-child(1) {\n        display: inline-block;\n        background: transparent;\n        color: #042764;\n        text-align: left;\n        font-size: 14px;\n        visibility: hidden;\n        pointer-events: none; }\n        .booking-popup .popup-button .btn-horizontal:nth-child(1):hover {\n          text-decoration: underline; }\n      .booking-popup .popup-button .btn-horizontal:nth-child(2) {\n        float: right; }\n\n@media screen and (max-width: 767px) {\n  .account-content {\n    padding: 0; }\n  :host /deep/ .dialog-cancellation-booking {\n    padding: 0 !important; }\n    :host /deep/ .dialog-cancellation-booking .dialog-wrapper-content {\n      height: 100vh; }\n    :host /deep/ .dialog-cancellation-booking .booking-popup .popup-overflow {\n      overflow-y: auto;\n      min-height: calc(var(--dialog-filter-vh, 1vh) * 100 - 60px) !important;\n      max-height: calc(var(--dialog-filter-vh, 1vh) * 100 - 60px) !important;\n      width: 100%; } }\n\n@media screen and (max-width: 767px) {\n  .booking-content {\n    padding: 10px;\n    border-bottom: 2px solid #DFE1E6; }\n    .booking-content .box-overflow {\n      position: relative;\n      height: 100px; }\n    .booking-content .hotel-top-detail .box-overflow {\n      height: auto; }\n  .booking-sort-box {\n    background-color: #FFFFFF;\n    border: 1px solid #DFE1E6;\n    margin-bottom: 10px;\n    overflow: hidden;\n    margin-left: -10px;\n    margin-right: -10px;\n    border-left: 0;\n    border-right: 0; }\n    .booking-sort-box a {\n      padding: 0 10px;\n      line-height: 35px;\n      width: 50%;\n      display: block;\n      float: left;\n      color: #061021;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis; }\n    .booking-sort-box .sort-booking {\n      border-right: 1px solid #DFE1E6; }\n    .booking-sort-box .filter-by img,\n    .booking-sort-box .sort-by img {\n      width: 16px;\n      height: 16px;\n      position: relative;\n      top: -2px;\n      margin-right: 10px; }\n    .booking-sort-box .filter-by {\n      border-right: 1px solid #DFE1E6; }\n    .booking-sort-box .icon-date {\n      background-color: transparent;\n      background-image: url(\"/assets/images/account/icon_date.png\");\n      background-repeat: no-repeat;\n      background-position: 0 0;\n      background-size: 15px 16px;\n      display: inline-block;\n      width: 15px;\n      height: 16px;\n      vertical-align: middle;\n      margin: -3px 5px 0 0; }\n  .icon-star-level {\n    background-color: transparent;\n    background-image: url(\"/assets/images/main/icon_star_m.png\");\n    background-repeat: no-repeat;\n    background-position: 0 0;\n    background-size: 100%;\n    width: 15px;\n    height: 15px;\n    margin: -5px 2px 0 0; }\n  .booking-manage {\n    padding-top: 15px; }\n  .booking-manage,\n  .manage-menu {\n    clear: both;\n    width: 100%;\n    float: none; }\n  .manage-menu-list {\n    width: calc(100% + 2px); }\n  .booking-line-dotted {\n    margin: 0 0 15px 0; }\n  .box-title {\n    margin: 0 0 5px 0; }\n  .box-rebooking {\n    border: 1px solid #DFE1E6;\n    height: 40px;\n    line-height: 38px;\n    text-align: center;\n    display: none; }\n    .box-rebooking a {\n      font-size: 16px;\n      color: #061021; }\n  .user-booking-detail {\n    margin-top: -15px;\n    border-left: 1px solid #DFE1E6;\n    border-right: 1px solid #DFE1E6;\n    padding: 15px 10px 0 10px; }\n  .date-booking-box {\n    padding: 0 10; }\n    .date-booking-box .booking-table {\n      width: 100%; }\n      .date-booking-box .booking-table .booking-column:first-child {\n        width: 84px; }\n  .room-type-list {\n    border-top: 1px solid #DFE1E6;\n    margin: 0; }\n    .room-type-list li {\n      padding: 15px 0; }\n      .room-type-list li .room-detail,\n      .room-type-list li .room-price {\n        width: 100%;\n        float: none; }\n      .room-type-list li .room-price {\n        padding: 10px 0; }\n      .room-type-list li .price-left {\n        float: left; }\n      .room-type-list li .price-right {\n        float: right; }\n  .price-summary {\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    float: none; }\n    .price-summary > .row {\n      padding: 8px 0; }\n    .price-summary .total {\n      font-size: 16px;\n      margin: 0 -10px;\n      border-bottom: 1px solid #DFE1E6; }\n  /* ------------ popup -------------*/\n  .box-popup-full-white {\n    background: #FFFFFF;\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    overflow-y: scroll; }\n    .box-popup-full-white .btn-close-popup {\n      position: absolute;\n      width: 18px;\n      height: 18px;\n      top: 15px;\n      right: 10px; }\n      .box-popup-full-white .btn-close-popup img {\n        width: 100%; }\n    .box-popup-full-white .popup-title {\n      font-size: 16px;\n      font-weight: 700;\n      border-bottom: 1px solid #DFE1E6;\n      padding: 15px 10px;\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale; }\n    .box-popup-full-white .group-filter-menu {\n      margin: 0;\n      padding: 15px 10px;\n      border-bottom: 1px solid #DFE1E6; }\n      .box-popup-full-white .group-filter-menu .filter-title {\n        background: none; }\n      .box-popup-full-white .group-filter-menu .filter-detail {\n        display: block; }\n      .box-popup-full-white .group-filter-menu.no-bottom-line {\n        border-bottom: none; }\n    .box-popup-full-white .option-price-range .form-control {\n      width: calc(50% - 8px); }\n    .box-popup-full-white .box-filter-button {\n      position: fixed;\n      width: calc(100% - 20px);\n      margin: 0 10px;\n      bottom: 10px;\n      overflow: hidden; }\n    .box-popup-full-white .btn-cancle-horizontal,\n    .box-popup-full-white .btn-submit-horizontal {\n      width: calc(50% - 5px);\n      margin-bottom: 0; }\n    .box-popup-full-white .btn-cancle-horizontal {\n      float: left; }\n    .box-popup-full-white .btn-submit-horizontal {\n      float: right; }\n    .box-popup-full-white .form-inline .form-group {\n      width: calc(50% - 15px);\n      float: left; }\n      .box-popup-full-white .form-inline .form-group .form-control {\n        width: 100%; }\n    .box-popup-full-white .form-inline label {\n      font-weight: 100;\n      width: 30px;\n      line-height: 34px;\n      float: left;\n      text-align: center; }\n  /*---popup---*/\n  .booking-popup {\n    width: 100%; }\n    .booking-popup .popup-title .title-detail {\n      display: block; }\n    .booking-popup .table-list-room .col-left,\n    .booking-popup .table-list-room .col-right {\n      width: 50%; }\n    .booking-popup .table-list-room .table-head .col-right {\n      display: none; }\n    .booking-popup .table-list-room .table-body .col-left,\n    .booking-popup .table-list-room .table-body .col-right {\n      width: 100%;\n      display: block; }\n    .booking-popup .table-list-room .table-body .col-left {\n      border-right: none;\n      border-bottom: 1px dotted #DFE1E6 !important; }\n    .booking-popup .table-list-room .table-body .col-right .cr-title {\n      float: left;\n      display: block;\n      font-weight: 600; }\n    .booking-popup .table-list-room .table-body-summary .col-left {\n      top: 0; }\n    .booking-popup .remark-box {\n      margin-bottom: 15px; }\n    .booking-popup .popup-button {\n      padding: 10px; }\n      .booking-popup .popup-button .btn-horizontal {\n        max-width: unset;\n        width: calc(50% - 7px);\n        float: none !important; }\n        .booking-popup .popup-button .btn-horizontal:nth-child(1) {\n          font-size: 14px;\n          text-align: center;\n          color: #061021;\n          margin-right: 5px !important;\n          border: 1px solid #DFE1E6;\n          visibility: visible;\n          pointer-events: unset; }\n        .booking-popup .popup-button .btn-horizontal:nth-child(2) {\n          margin-left: 5px !important; } }\n\n.booking-content .form-control.form-select {\n  width: 150px; }\n\n.datepicker-container {\n  display: inline-block; }\n\n.first-col-topic {\n  vertical-align: text-top; }\n  @media screen and (max-width: 1100px) {\n    .first-col-topic {\n      margin-right: 0;\n      min-width: 60px;\n      text-align: right; } }\n\n.from-text {\n  margin: 0 5px; }\n\n@media screen and (max-width: 1100px) {\n  .form-calendar-booking-header {\n    padding-top: 5px; }\n    .form-calendar-booking-header .from-text {\n      margin: 0; }\n    .form-calendar-booking-header .until-text {\n      margin: 0 5px; } }\n\n.booking-report-button {\n  color: #003a90;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 15px 10px 15px;\n  float: right;\n  margin: -5px;\n  margin-right: 0px;\n  cursor: pointer; }\n  .booking-report-button:hover {\n    background: #e4edff; }\n  @media screen and (max-width: 767px) {\n    .booking-report-button {\n      padding: 6px 8px 6px 8px;\n      margin: -3px; } }\n\n.booking-report-text {\n  font-size: 14px;\n  font-family: Arial;\n  line-height: 16px; }\n\n.icon-export {\n  font-size: 16px;\n  position: relative;\n  top: 1px;\n  margin-right: 5px; }\n\n.booking-popup {\n  min-height: 380px; }\n\n.show-list-style {\n  list-style: disc;\n  list-style-position: inside; }\n\n.tbpt-credit-terms-share-budget {\n  width: 100% !important;\n  padding: 0 10px !important; }\n\n.ota-loading {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto; }\n\n.text-inline-block {\n  display: inline-block; }\n\n.fee-topics {\n  white-space: nowrap; }\n\n.table-head {\n  font-weight: bold; }\n\n@media screen and (max-width: 767px) {\n  .table-body-summary .col-left:after {\n    display: none; }\n  .booking-popup {\n    max-width: 100%; } }\n\n.font-bold {\n  font-weight: bold; }\n\n.reason-box {\n  margin-top: 18px; }\n\n.refund-details {\n  background-color: #FFF8EF;\n  border: #FFCCAA 1px solid;\n  padding: 8px 16px;\n  margin-bottom: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n/* ------------ popup -------------*/\n.box-popup-full-white {\n  background: #FFFFFF;\n  width: 100%;\n  min-height: 100%;\n  position: relative; }\n  .box-popup-full-white .btn-close-popup {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    top: 10px;\n    right: 15px; }\n    @media screen and (max-width: 767px) {\n      .box-popup-full-white .btn-close-popup {\n        width: 18px;\n        height: 18px;\n        top: 15px;\n        right: 10px; }\n        .box-popup-full-white .btn-close-popup img {\n          width: 100%; } }\n  .box-popup-full-white .popup-title {\n    font-size: 18px;\n    font-weight: 700;\n    border-bottom: 1px solid #DFE1E6;\n    padding: 15px 10px;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale; }\n  .box-popup-full-white .group-filter-menu {\n    margin: 0;\n    padding: 0 0 15px; }\n    .box-popup-full-white .group-filter-menu .filter-title {\n      background: none; }\n    .box-popup-full-white .group-filter-menu .filter-detail {\n      display: block; }\n    .box-popup-full-white .group-filter-menu .filter-item {\n      font-size: 16px;\n      padding: 10px; }\n      .box-popup-full-white .group-filter-menu .filter-item label {\n        width: 100%;\n        margin-bottom: 0;\n        font-weight: initial; }\n      .box-popup-full-white .group-filter-menu .filter-item.active {\n        background-color: #e4edff; }\n  .box-popup-full-white .option-price-range .form-control {\n    width: calc(50% - 8px); }\n  .box-popup-full-white .box-filter-button {\n    overflow: hidden; }\n  .box-popup-full-white .btn-cancle-horizontal,\n  .box-popup-full-white .btn-submit-horizontal {\n    width: calc(50% - 5px);\n    margin-bottom: 0; }\n  .box-popup-full-white .btn-cancle-horizontal {\n    float: left; }\n  .box-popup-full-white .btn-submit-horizontal {\n    float: right; }\n\n.group-filter-menu {\n  background-color: #FFFFFF;\n  margin: 0 0 15px 0;\n  padding: 15px; }\n  .group-filter-menu .showbox-header-wrapper {\n    width: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between; }\n  .group-filter-menu .show-icon-style {\n    left: 0;\n    -ms-flex-item-align: center;\n        -ms-grid-row-align: center;\n        align-self: center;\n    color: #D1D1D1;\n    cursor: pointer; }\n    .group-filter-menu .show-icon-style:hover {\n      color: #6b778c; }\n  .group-filter-menu .filter-title {\n    font-size: 16px;\n    color: #061021;\n    display: block; }\n  .group-filter-menu .filter-detail {\n    display: none;\n    margin-top: 10px; }\n    .group-filter-menu .filter-detail .chk-star:last-child {\n      margin-bottom: 0; }\n    .group-filter-menu .filter-detail .sort-by-sidebar {\n      background-color: #FFFFFF;\n      padding: 10px 0 0 0; }\n      .group-filter-menu .filter-detail .sort-by-sidebar .sort-box {\n        line-height: 33px;\n        border: 1px solid #DFE1E6;\n        color: #6b778c;\n        display: inline-block;\n        padding: 0;\n        margin: 0 0 10px 15px;\n        min-width: 100px;\n        box-sizing: border-box;\n        text-align: center; }\n        .group-filter-menu .filter-detail .sort-by-sidebar .sort-box:hover {\n          background-color: #f6f8f9; }\n        .group-filter-menu .filter-detail .sort-by-sidebar .sort-box.active {\n          background-color: #576D77;\n          border: 1px solid #576D77;\n          color: #FFFFFF; }\n        .group-filter-menu .filter-detail .sort-by-sidebar .sort-box:first-child {\n          margin: 0 0 10px 0; }\n        .group-filter-menu .filter-detail .sort-by-sidebar .sort-box:nth-child(3n+3) {\n          margin: 0 0 10px 0; }\n      .group-filter-menu .filter-detail .sort-by-sidebar .sort-box-popup {\n        line-height: 33px;\n        border: 1px solid #DFE1E6;\n        color: #6b778c;\n        display: inline-block;\n        padding: 0;\n        margin: 0 0 10px 15px;\n        min-width: 100px;\n        box-sizing: border-box;\n        text-align: center; }\n        .group-filter-menu .filter-detail .sort-by-sidebar .sort-box-popup.active {\n          background-color: #576D77;\n          color: #FFFFFF; }\n        .group-filter-menu .filter-detail .sort-by-sidebar .sort-box-popup:first-child {\n          margin: 0 0 10px 0; }\n  .group-filter-menu.open .filter-detail {\n    display: block; }\n  .group-filter-menu .filter-more {\n    background-color: transparent;\n    background-image: url(\"/assets/images/lvc/arrow_down_circle.png\");\n    background-repeat: no-repeat;\n    background-position: 9px center;\n    padding: 5px 0 5px 38px;\n    display: block;\n    color: #576D77;\n    color: #576D77;\n    text-decoration: none; }\n    .group-filter-menu .filter-more:visited {\n      color: #576D77; }\n    .group-filter-menu .filter-more:hover {\n      color: #53798A;\n      text-decoration: none; }\n  .group-filter-menu .filter-hide {\n    background-color: transparent;\n    background-image: url(\"/assets/images/lvc/arrow_up_circle.png\");\n    background-repeat: no-repeat;\n    background-position: 9px center;\n    background-size: 20px 20px;\n    padding: 5px 0 5px 38px;\n    display: block;\n    color: #576D77;\n    color: #576D77;\n    text-decoration: none; }\n    .group-filter-menu .filter-hide:visited {\n      color: #576D77; }\n    .group-filter-menu .filter-hide:hover {\n      color: #53798A;\n      text-decoration: none; }\n  @media screen and (max-width: 767px) {\n    .group-filter-menu {\n      margin: 0;\n      padding: 15px 0px; }\n      .group-filter-menu .filter-title {\n        background: none; }\n      .group-filter-menu .filter-detail {\n        display: block; } }\n\n.option-price-range .form-control {\n  width: 108px;\n  padding: 6px 10px;\n  display: inline-block; }\n  .option-price-range .form-control[readonly] {\n    background-color: white; }\n    .option-price-range .form-control[readonly]:focus {\n      border-color: #DFE1E6;\n      box-shadow: none; }\n\n.icon-close {\n  -moz-appearance: none;\n       appearance: none;\n  border: 0;\n  outline: 0;\n  background: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ":host {\n  display: block; }\n\n.dropdown {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  background-image: url(\"../../../assets/images/form/Down.svg\");\n  background-repeat: no-repeat;\n  background-position: calc(100% - 7px) center; }\n  .dropdown button {\n    background-color: transparent;\n    height: 40px; }\n    .dropdown button:focus {\n      border-color: #dfe1e6; }\n    .dropdown button label {\n      max-height: 100%;\n      max-width: calc(100% - 20px);\n      text-align: left;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis; }\n    .dropdown button:disabled {\n      background-color: #f5f5f5; }\n      .dropdown button:disabled label {\n        -webkit-user-select: text;\n           -moz-user-select: text;\n            -ms-user-select: text;\n                user-select: text;\n        cursor: not-allowed; }\n  .dropdown .dropdown-content {\n    width: 100%;\n    display: none;\n    background-color: #FFFFFF;\n    border: none;\n    position: absolute;\n    top: 40px;\n    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4);\n    border-radius: 4px; }\n    .dropdown .dropdown-content.show {\n      display: block; }\n    .dropdown .dropdown-content .dc-box {\n      margin: 10px;\n      position: relative; }\n      .dropdown .dropdown-content .dc-box .fcp {\n        top: 12px;\n        left: 12px;\n        z-index: 9;\n        position: absolute; }\n      .dropdown .dropdown-content .dc-box .input {\n        min-height: 40px;\n        border: 1px solid #dfe1e6;\n        border-radius: 4px;\n        padding: 6px 12px 6px 36px;\n        width: 100%;\n        height: 21px;\n        color: #404e67 !important; }\n        .dropdown .dropdown-content .dc-box .input:focus {\n          outline: none;\n          border-color: #003a90; }\n    .dropdown .dropdown-content .dc-items {\n      white-space: nowrap;\n      overflow-y: auto;\n      max-height: calc(40px * 10); }\n      @media screen and (max-width: 425px) {\n        .dropdown .dropdown-content .dc-items {\n          max-height: calc(40px * 5); } }\n      .dropdown .dropdown-content .dc-items .dc-item-table {\n        display: block;\n        border-collapse: collapse;\n        width: 100%; }\n        .dropdown .dropdown-content .dc-items .dc-item-table .dc-item {\n          display: block; }\n        .dropdown .dropdown-content .dc-items .dc-item-table .di-link {\n          text-overflow: ellipsis;\n          display: block;\n          overflow: hidden;\n          padding: 10px 15px;\n          text-decoration: none;\n          color: #061021 !important;\n          border: none; }\n          .dropdown .dropdown-content .dc-items .dc-item-table .di-link:hover {\n            background-color: #e4edff; }\n        .dropdown .dropdown-content .dc-items .dc-item-table .no-results-match {\n          color: #6b778c !important; }\n          .dropdown .dropdown-content .dc-items .dc-item-table .no-results-match:hover {\n            background-color: unset;\n            cursor: unset; }\n    .dropdown .dropdown-content.show.open-up {\n      top: unset;\n      bottom: 40px; }\n      .dropdown .dropdown-content.show.open-up .fcp {\n        top: unset;\n        bottom: 10px; }\n\n.has-error {\n  border: 1px solid #ff7588 !important; }\n\n.float-left {\n  float: left; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.dropdown-ota-style {\n  line-height: 19px;\n  padding: 10px 25px 10px 10px;\n  height: 40px;\n  cursor: pointer; }\n  .dropdown-ota-style.error {\n    border: 1px solid #ed1c24; }\n\n.fleet-card-item {\n  position: relative;\n  padding: 10px 10px 10px 35px;\n  width: 530px;\n  height: 50px;\n  background-color: white;\n  cursor: pointer; }\n  @media screen and (max-width: 767px) {\n    .fleet-card-item {\n      width: auto; } }\n  .fleet-card-item:hover {\n    background-color: #e4edff; }\n  .fleet-card-item .icon-fleet {\n    position: absolute;\n    left: 10px;\n    top: 10px;\n    font-size: 16px; }\n  .fleet-card-item .fleet-card-info {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between; }\n  .fleet-card-item .fleet-card-no,\n  .fleet-card-item .balance {\n    color: #061021;\n    font-size: 14px;\n    line-height: 16px; }\n  .fleet-card-item .fleet-card-type {\n    color: #6b778c;\n    font-size: 12px;\n    line-height: 14px; }\n\n.scorllable-box {\n  margin-top: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.footer-copyright {\n  height: 50px;\n  line-height: 50px;\n  font-size: 12px;\n  color: #6b778c;\n  text-align: center; }\n  .footer-copyright.-default {\n    background-color: #f6f8f9; }\n  .footer-copyright.-affiliate-login {\n    background-color: #FFFFFF; }\n\n@media screen and (max-width: 768px) {\n  .footer-copyright {\n    height: auto;\n    padding: 5px 0;\n    line-height: 1.4em;\n    font-size: 12px; }\n    .footer-copyright.-affiliate-login {\n      background-color: #f6f8f9; }\n    .footer-copyright .copyright-inner {\n      width: 255px;\n      margin: 0 auto; } }\n\n@media screen and (max-width: 1120px) {\n  .footer-copyright.-affiliate-login {\n    background-color: #f6f8f9; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.footer {\n  text-align: left;\n  background-color: #FFFFFF;\n  clear: both;\n  margin: 0;\n  padding: 0;\n  overflow: hidden; }\n  .footer .wrap-inner {\n    padding: 0px 15px 60px; }\n\n.footer-company {\n  text-align: left;\n  font-size: 16px;\n  margin: 30px 0 10px 0; }\n\n.icon {\n  position: relative;\n  top: 3px;\n  padding-right: 5px; }\n\n.box-left {\n  width: 50%; }\n\n.box-right {\n  width: 50%;\n  display: -ms-flexbox;\n  display: flex; }\n  .box-right .box-contract {\n    width: 50%; }\n    .box-right .box-contract .title {\n      padding-bottom: 20px; }\n    .box-right .box-contract ul {\n      margin-bottom: 0px; }\n    .box-right .box-contract li {\n      padding-bottom: 15px;\n      display: -ms-flexbox;\n      display: flex; }\n      .box-right .box-contract li a:hover {\n        color: #6b778c;\n        text-decoration: underline; }\n      .box-right .box-contract li:last-child {\n        padding-bottom: 0px; }\n  .box-right .box-help {\n    width: 50%; }\n    .box-right .box-help .title {\n      padding-bottom: 20px; }\n    .box-right .box-help div {\n      padding-bottom: 5px; }\n      .box-right .box-help div a:hover {\n        color: #6b778c;\n        text-decoration: underline; }\n\n.row {\n  margin: 0px;\n  display: -ms-flexbox;\n  display: flex; }\n\n.w-50 {\n  width: 50%; }\n\n@media screen and (max-width: 768px) {\n  .footer .wrap-inner {\n    padding: 30px 10px; }\n  .footer-company {\n    margin: 0 0 5px 0; }\n  .box-left {\n    width: 100%; }\n  .row {\n    display: unset; }\n  .box-right {\n    display: unset; }\n    .box-right .box-contract {\n      width: 100%; }\n      .box-right .box-contract .title {\n        display: none; }\n      .box-right .box-contract ul {\n        padding-top: 5px; }\n      .box-right .box-contract li {\n        padding-bottom: 10px; }\n    .box-right .box-help {\n      padding-top: 20px;\n      width: 100%; }\n      .box-right .box-help .title {\n        padding-bottom: 10px; }\n      .box-right .box-help div:last-child {\n        padding-bottom: 0px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.holder {\n  position: relative; }\n\n.dropdown {\n  z-index: 1;\n  width: 75%;\n  display: none;\n  margin-top: 5px;\n  overflow-y: auto;\n  max-height: 400px;\n  position: absolute;\n  background-color: #FFFFFF;\n  border-radius: 4px;\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4); }\n  .dropdown .option {\n    height: auto;\n    display: -ms-flexbox;\n    display: flex;\n    border-bottom: 1px solid #DFE1E6; }\n    .dropdown .option:hover {\n      cursor: pointer;\n      background-color: #e4edff !important; }\n      .dropdown .option:hover .option-rear {\n        display: -ms-flexbox !important;\n        display: flex !important;\n        -ms-flex-pack: center;\n            justify-content: center;\n        -ms-flex-align: center;\n            align-items: center; }\n    .dropdown .option .option-content {\n      word-wrap: break-word;\n      width: calc(100% - 80px);\n      padding: 9px 10px 9px 15px;\n      font-size: 14px; }\n      .dropdown .option .option-content .sub {\n        font-size: 12px;\n        color: #6b778c; }\n      .dropdown .option .option-content.no-result {\n        color: #6b778c; }\n    .dropdown .option .option-rear {\n      display: none;\n      width: 80px;\n      float: right;\n      padding: 9px 15px 9px 10px;\n      font-size: 12px;\n      color: #003a90; }\n      .dropdown .option .option-rear:hover {\n        color: #042764;\n        text-decoration: underline; }\n\n.v-visible {\n  display: block;\n  visibility: visible; }\n\n.v-hidden {\n  visibility: hidden !important; }\n\n.option-selecting {\n  background-color: #e4edff !important; }\n\ninput:focus + .dropdown {\n  display: block; }\n\n.open-up {\n  bottom: 40px; }\n\n@media screen and (max-width: 767px) {\n  .dropdown {\n    max-height: 200px;\n    width: 100%; }\n    .dropdown .option-rear {\n      display: -ms-flexbox !important;\n      display: flex !important;\n      -ms-flex-pack: center;\n          justify-content: center;\n      -ms-flex-align: center;\n          align-items: center; } }\n\n.h-40 {\n  height: 40px; }\n\n.loading-wrapper {\n  position: absolute;\n  top: 20px;\n  right: 0;\n  width: 34px;\n  height: 0; }\n  .loading-wrapper.loading:before {\n    position: absolute;\n    content: \"\";\n    top: 50%;\n    left: 50%;\n    margin: -0.64285714em 0em 0em -0.64285714em;\n    width: 1.28571429em;\n    height: 1.28571429em;\n    border-radius: 500rem;\n    border: 0.2em solid rgba(0, 0, 0, 0.15); }\n  .loading-wrapper.loading:after {\n    position: absolute;\n    content: \"\";\n    top: 50%;\n    left: 50%;\n    margin: -0.64285714em 0em 0em -0.64285714em;\n    width: 1.28571429em;\n    height: 1.28571429em;\n    animation: loading 0.6s linear;\n    animation-iteration-count: infinite;\n    border-radius: 500rem;\n    border-color: #FFFFFF transparent transparent;\n    border-style: solid;\n    border-width: 0.2em;\n    box-shadow: 0px 0px 0px 1px transparent; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ":host /deep/ .header-desktop,\n:host /deep/ .header-mobile {\n  border-width: 0 !important; }\n\n:host /deep/ :-ms-input-placeholder {\n  color: #6b778c !important; }\n\n:host /deep/ ::placeholder {\n  color: #6b778c !important; }\n\n:host /deep/ ::-webkit-input-placeholder {\n  color: #6b778c !important; }\n\n:host /deep/ :-moz-placeholder {\n  color: #6b778c !important; }\n\n:host /deep/ ::-moz-placeholder {\n  color: #6b778c !important; }\n\n:host /deep/ :-ms-input-placeholder {\n  color: #6b778c !important; }\n\n:host /deep/ .arial-font {\n  font-family: arial; }\n\n:host /deep/ .header-desktop {\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);\n  position: relative;\n  z-index: 1; }\n\n:host /deep/ .header-mobile .navbar-toggle {\n  margin-bottom: 0; }\n\n:host /deep/ .nav-menu {\n  float: left;\n  height: 91px;\n  position: relative;\n  margin-left: 75px; }\n\n:host /deep/ .nav-menu ul {\n  margin: 31px 0 0; }\n\n:host /deep/ .nav-menu ul li {\n  float: left;\n  position: relative; }\n\n:host /deep/ .nav-menu ul li a {\n  display: block;\n  color: #061021;\n  padding: 0 10px;\n  margin: 20px 0;\n  min-width: 70px;\n  text-align: center; }\n\n:host /deep/ .nav-menu ul li a:hover {\n  color: #1a1a1a; }\n\n:host /deep/ .nav-menu ul li.active:before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 4px;\n  background: #ed1c24; }\n\n:host /deep/ .slideshow-container {\n  position: relative;\n  margin: auto; }\n\n:host /deep/ .slideshow-container .slide {\n  display: none; }\n\n:host /deep/ .slideshow-container .slide .img-slide {\n  background-position: center;\n  background-size: cover;\n  height: 480px;\n  display: block; }\n\n:host /deep/ .slideshow-container .slide img {\n  display: none; }\n\n:host /deep/ .slideshow-container .next,\n:host /deep/ .slideshow-container .prev {\n  cursor: pointer;\n  position: absolute;\n  top: 50%;\n  width: auto;\n  padding: 16px;\n  margin-top: -22px;\n  color: #FFFFFF;\n  font-size: 32px;\n  transition: 0.6s ease;\n  border-radius: 0 3px 3px 0;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  text-decoration: none; }\n\n:host /deep/ .slideshow-container .next {\n  right: 0; }\n\n:host /deep/ .slideshow-container .caption-text {\n  color: #f5f5f5;\n  position: absolute;\n  top: 50%;\n  width: 100%;\n  margin-top: -90px; }\n\n:host /deep/ .slideshow-container .caption-text p {\n  font-size: 24px;\n  line-height: 1em;\n  font-family: TrueMedium; }\n\n:host /deep/ .slideshow-container .caption-text h1 {\n  font-size: 60px;\n  line-height: 0.8em;\n  margin-top: 0;\n  margin-bottom: 20px;\n  font-family: TrueMedium; }\n\n:host /deep/ .slideshow-container .nav-dot {\n  position: absolute;\n  bottom: 30px;\n  width: 100%;\n  text-align: center; }\n\n:host /deep/ .slideshow-container .nav-dot .dot {\n  cursor: pointer;\n  height: 8px;\n  width: 8px;\n  margin: 0 7.5px;\n  background-color: #d1d1d1;\n  border-radius: 50%;\n  display: inline-block;\n  transition: background-color 0.6s ease; }\n\n:host /deep/ .slideshow-container .nav-dot .dot.active {\n  background-color: #ed1c24; }\n\n:host /deep/ .slideshow-container .fadein {\n  -webkit-animation-name: fade;\n  -webkit-animation-duration: 1.5s;\n  animation-name: fade;\n  animation-duration: 1.5s; }\n\n:host /deep/ .slideshow-container .ota-btn-main {\n  background-color: #ed1c24;\n  padding: 10px 20px;\n  border-radius: 2px;\n  color: #FFFFFF;\n  text-decoration: none;\n  margin-right: 10px;\n  font-size: 16px; }\n\n:host /deep/ .slideshow-container .ota-btn-main:hover {\n  background-color: red; }\n\n@keyframes fade {\n  from {\n    opacity: 0.4; }\n  to {\n    opacity: 1; } }\n\n:host /deep/ .owl-nav {\n  position: relative;\n  margin: 0 auto;\n  top: -200px; }\n\n:host /deep/ .carousel-slide {\n  width: 390px;\n  min-height: 390px;\n  padding: 0 15px; }\n\n:host /deep/ .carousel-slide img {\n  width: 100%; }\n\n:host /deep/ .purejscarousel-slides-container:after,\n:host /deep/ .purejscarousel-slides-container:before {\n  content: \"\";\n  display: table; }\n\n:host /deep/ .purejscarousel-slides-container:after {\n  clear: both; }\n\n:host /deep/ .purejscarousel-slide {\n  float: left; }\n\n:host /deep/ .purejscarousel-btn {\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  height: 40px;\n  margin-top: -25px;\n  position: absolute;\n  top: 50%;\n  width: 40px;\n  background: #FFFFFF;\n  border-radius: 100%;\n  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);\n  z-index: 2; }\n  :host /deep/ .purejscarousel-btn.purejscarousel-btn-next {\n    right: 0; }\n    :host /deep/ .purejscarousel-btn.purejscarousel-btn-next:before {\n      font-family: ota-icons;\n      content: \"\\E93A\";\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 25%; }\n  :host /deep/ .purejscarousel-btn.purejscarousel-btn-prev {\n    left: 0; }\n    :host /deep/ .purejscarousel-btn.purejscarousel-btn-prev:before {\n      font-family: ota-icons;\n      content: \"\\E939\";\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 25%; }\n\n:host /deep/ .owl-next {\n  text-align: center;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  height: 40px;\n  margin-top: -25px;\n  margin-right: -10px;\n  position: absolute;\n  top: 50%;\n  width: 40px;\n  background: #FFFFFF !important;\n  border-radius: 100%;\n  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);\n  z-index: 2;\n  right: 0; }\n  :host /deep/ .owl-next:before {\n    top: 12px;\n    right: 14px;\n    content: \"\";\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    background: #4a4a4a;\n    transform: rotate(180deg);\n    clip-path: polygon(75% 0, 35% 50%, 75% 100%, 40% 100%, 0% 50%, 40% 0); }\n\n:host /deep/ .owl-prev {\n  text-align: center;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  height: 40px;\n  margin-top: -25px;\n  margin-left: -10px;\n  position: absolute;\n  top: 50%;\n  width: 40px;\n  background: #FFFFFF !important;\n  border-radius: 100%;\n  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);\n  z-index: 2;\n  left: 0; }\n  :host /deep/ .owl-prev:before {\n    left: 14px;\n    top: 12px;\n    content: \"\";\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    background: #4a4a4a;\n    clip-path: polygon(75% 0, 35% 50%, 75% 100%, 40% 100%, 0% 50%, 40% 0); }\n\n:host /deep/ .owl-next[disabled],\n:host /deep/ .owl-prev[disabled] {\n  opacity: 0.3; }\n\n:host /deep/ .purejscarousel-dots-container {\n  float: left;\n  margin: 10px 0 30px;\n  text-align: center;\n  width: 100%; }\n  :host /deep/ .purejscarousel-dots-container .purejscarousel-dot {\n    background: #d1d1d1;\n    border: 0;\n    border-radius: 50%;\n    box-shadow: none;\n    cursor: pointer;\n    height: 8px;\n    outline: 0;\n    margin: 0 7.5px;\n    width: 8px; }\n    :host /deep/ .purejscarousel-dots-container .purejscarousel-dot.active {\n      cursor: default;\n      background-color: #ed1c24; }\n\n:host /deep/ .full-section {\n  padding: 30px 0;\n  position: relative; }\n\n:host /deep/ .full-section .row + .row {\n  margin-top: 60px; }\n\n:host /deep/ .full-section h2.title {\n  text-align: center;\n  margin-top: 0;\n  margin-bottom: 30px;\n  font-size: 36px;\n  font-weight: 700; }\n\n:host /deep/ .full-section.our-services {\n  text-align: center;\n  padding: 60px 0; }\n\n:host /deep/ .full-section.our-services h2.title {\n  text-align: center;\n  margin-bottom: 60px;\n  font-size: 36px;\n  font-weight: 700; }\n\n:host /deep/ .full-section.our-services h3 {\n  font-size: 20px;\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 5px; }\n\n:host /deep/ .full-section.our-services p {\n  font-size: 12px; }\n\n:host /deep/ .full-section.our-services .img-radius {\n  border-radius: 100%;\n  width: 230px;\n  margin: 0 auto;\n  overflow: hidden; }\n\n:host /deep/ .full-section.our-portfolio:after,\n:host /deep/ .full-section.our-portfolio:before {\n  content: \"\";\n  top: 0;\n  bottom: 0;\n  width: 300px;\n  z-index: 1;\n  position: absolute; }\n\n:host /deep/ .full-section.our-portfolio {\n  padding: 60px 0;\n  overflow: hidden; }\n\n:host /deep/ .full-section.our-portfolio:before {\n  left: 0;\n  background: url(../../../assets/mice/images/transparent.png) right center repeat-y;\n  background-size: 100%; }\n\n:host /deep/ .full-section.our-portfolio:after {\n  right: 0;\n  background: url(../../../assets/mice/images/transparent.png) right center repeat-y;\n  background-size: 100%;\n  transform: rotate(180deg); }\n\n:host /deep/ .full-section.service-chioce {\n  text-align: center;\n  color: #FFFFFF;\n  background: url(\"/assets/mice/images/mice-sloganbg.jpg\") center no-repeat;\n  background-size: cover;\n  min-height: 420px; }\n\n:host /deep/ .full-section.service-chioce .wrap-inner {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  margin-top: -75px; }\n\n:host /deep/ .full-section.service-chioce .wrap-inner h2 {\n  font-size: 36px;\n  font-weight: 700; }\n\n:host /deep/ .full-section.service-chioce p {\n  margin-bottom: 20px; }\n\n:host /deep/ .full-section.gray {\n  background-color: #f6f8f9; }\n\n:host /deep/ .full-section.gray.dot {\n  border-bottom: 1px solid #dfe1e6; }\n\n:host /deep/ .full-section.gray .row [class*=\"col-\"] img {\n  margin-right: 10px;\n  height: 48px; }\n\n:host /deep/ .full-section.gray .row [class*=\"col-\"] .media-body h4 {\n  font-weight: 700;\n  font-family: Arial;\n  margin-bottom: 5px;\n  font-size: 16px; }\n\n:host /deep/ .full-section.gray .row [class*=\"col-\"] .media-body p {\n  font-size: 12px;\n  margin: 0;\n  line-height: 1.5rem; }\n\n:host /deep/ .full-section .thumbnail {\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  margin-bottom: 0;\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);\n  text-decoration: none; }\n\n:host /deep/ .full-section .thumbnail:hover {\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3); }\n\n:host /deep/ .full-section .thumbnail .caption {\n  padding: 10px 15px;\n  min-height: 140px;\n  position: relative;\n  color: #061021; }\n\n:host /deep/ .full-section .thumbnail h4 {\n  font-size: 14px;\n  font-weight: 700;\n  margin: 7px 0; }\n\n:host /deep/ .full-section .thumbnail small {\n  position: absolute;\n  left: 15px;\n  bottom: 5px;\n  color: #6b778c; }\n\n:host /deep/ .full-section .thumbnail small i {\n  margin-right: 3px; }\n\n:host /deep/ .full-section .ota-btn-main {\n  background-color: #ed1c24;\n  padding: 10px 20px;\n  border-radius: 2px;\n  color: #FFFFFF;\n  text-decoration: none;\n  font-size: 16px; }\n\n:host /deep/ .full-section .ota-btn-main:hover {\n  background-color: red; }\n\n:host /deep/ .dialog-service-chioce .dialog-wrapper-content {\n  min-width: 750px; }\n\n:host /deep/ .dialog-service-chioce .form-pop-title {\n  font-weight: 700;\n  font-size: 20px;\n  margin: 35px 0 5px !important; }\n\n:host /deep/ .dialog-service-chioce .ota-btn-main {\n  border-radius: 2px;\n  min-width: 220px;\n  width: auto;\n  margin: 0 auto;\n  display: block;\n  font-size: 16px; }\n\n:host /deep/ .dialog-service-chioce .mat-dialog-content {\n  display: -webkit-box !important; }\n\n:host /deep/ .modal {\n  display: none;\n  position: fixed;\n  z-index: 2000;\n  padding: 60px 0;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.8); }\n\n:host /deep/ .modal .row {\n  margin: 15px 0 0;\n  position: relative;\n  overflow: hidden; }\n\n:host /deep/ .modal .row .column {\n  float: left;\n  width: 12.5%;\n  background-color: #000; }\n\n:host /deep/ .modal .row:after {\n  content: \"\";\n  display: table;\n  clear: both; }\n\n:host /deep/ .modal .modal-content {\n  position: relative;\n  margin: auto;\n  padding: 0;\n  width: 90%;\n  max-width: 1200px;\n  border-radius: 0;\n  background: 0 0;\n  box-shadow: none; }\n\n:host /deep/ .modal .modal-content .modal-content-inner {\n  position: relative;\n  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5); }\n\n:host /deep/ .modal .close,\n:host /deep/ .modal .next,\n:host /deep/ .modal .prev {\n  position: absolute;\n  text-decoration: none;\n  color: #FFFFFF; }\n\n:host /deep/ .modal .close {\n  top: 15px;\n  right: 15px;\n  font-size: 24px;\n  opacity: 1;\n  background: rgba(0, 0, 0, 0.6);\n  padding: 4px 8px 8px;\n  text-align: center;\n  width: 32px;\n  height: 32px;\n  text-shadow: none; }\n\n:host /deep/ .modal .modalSlides {\n  display: none; }\n\n:host /deep/ .modal .modalSlides img {\n  width: 100%; }\n\n:host /deep/ .modal .cursor {\n  cursor: pointer; }\n\n:host /deep/ .modal .next,\n:host /deep/ .modal .prev {\n  cursor: pointer;\n  top: 50%;\n  width: auto;\n  padding: 15px;\n  margin-top: -50px;\n  font-weight: 700;\n  font-size: 40px;\n  transition: 0.6s ease;\n  -moz-user-select: none;\n   -ms-user-select: none;\n       user-select: none;\n  -webkit-user-select: none;\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.2); }\n\n:host /deep/ .modal .next {\n  right: 0; }\n\n:host /deep/ .modal .caption-container {\n  text-align: center;\n  background-color: #000;\n  padding: 2px 16px;\n  color: #FFFFFF; }\n\n:host /deep/ .modal .demo {\n  opacity: 0.5; }\n\n:host /deep/ .modal .active,\n:host /deep/ .modal .demo:hover {\n  opacity: 1; }\n\n:host /deep/ .form-wrapper {\n  margin-bottom: 30px; }\n\n:host /deep/ .form-wrapper h3 {\n  font-size: 16px;\n  margin-top: 0;\n  margin-bottom: 15px; }\n\n:host /deep/ .form-wrapper .row {\n  margin: 0 -7.5px; }\n\n:host /deep/ .form-wrapper .row [class*=\"col-\"] {\n  padding: 0 7.5px; }\n\n:host /deep/ .-form-calendar input[type=\"text\"],\n:host /deep/ .-form-map input[type=\"text\"] {\n  padding-left: 35px; }\n\n:host /deep/ .form-wrapper small {\n  display: block;\n  margin-top: 5px;\n  color: #6b778c;\n  font-size: 12px; }\n\n:host /deep/ .-form-calendar:before,\n:host /deep/ .-form-map:before {\n  font-family: ota-icons;\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  left: 12px;\n  top: 8px;\n  color: #061021; }\n\n:host /deep/ .form-wrapper + .ota-btn-main {\n  margin-top: -15px; }\n\n:host /deep/ .form-group .form-control {\n  border-color: #dfe1e6;\n  border-radius: 0; }\n\n:host /deep/ .form-group .ota-input-text {\n  margin: 0; }\n\n:host /deep/ .-form-map {\n  position: relative; }\n\n:host /deep/ .-form-map:before {\n  background: url(\"/assets/mice/images/icon-pin.svg\") center no-repeat;\n  position: absolute; }\n\n:host /deep/ .-form-calendar {\n  position: relative; }\n\n:host /deep/ .-form-calendar:before {\n  background: url(\"/assets/mice/images/Date.png\") center no-repeat;\n  position: absolute; }\n\n:host /deep/ .image-sent-data {\n  height: 60px;\n  display: block;\n  margin: 20px auto 0; }\n\n:host /deep/ h3.form-pop-title {\n  font-size: 16px !important;\n  line-height: normal; }\n\n:host /deep/ .dialog-sent-success .dialog-wrapper-content {\n  min-height: inherit !important; }\n\n:host /deep/ .dialog-sent-success .dialog-wrapper-content .form-pop-title {\n  text-align: center; }\n\n:host /deep/ .dialog-sent-success .dialog-wrapper-content .ota-btn-main {\n  min-width: 180px;\n  width: inherit;\n  display: block;\n  margin: 0 auto; }\n\n@media (min-width: 479px) {\n  :host /deep/ .purejscarousel-dots-container {\n    display: none; } }\n\n@media (min-width: 1200px) {\n  :host /deep/ .owl-nav {\n    width: 1170px; } }\n\n@media (max-width: 1600px) {\n  :host /deep/ .full-section.our-portfolio:after,\n  :host /deep/ .full-section.our-portfolio:before {\n    width: 200px; } }\n\n@media (max-width: 1200px) {\n  :host /deep/ .owl-nav {\n    width: 390px; }\n  :host /deep/ .full-section.our-portfolio:after,\n  :host /deep/ .full-section.our-portfolio:before {\n    width: 120px; }\n  :host /deep/ .slideshow-container .next,\n  :host /deep/ .slideshow-container .prev {\n    display: none; } }\n\n@media (max-width: 1140px) {\n  :host /deep/ .wrap-inner {\n    padding: 0 30px; } }\n\n@media (max-width: 768px) {\n  :host /deep/ .slideshow-container .caption-text h1 {\n    font-size: 48px; }\n  :host /deep/ .full-section.gray .row [class*=\"col-\"] {\n    text-align: center; }\n  :host /deep/ .full-section.gray .row [class*=\"col-\"] img {\n    margin-right: 0;\n    margin-bottom: 10px;\n    width: 48px;\n    float: none !important; }\n  :host /deep/ .full-section.gray .row [class*=\"col-\"] .media-body {\n    display: block;\n    width: auto; }\n  :host /deep/ .full-section h2.title {\n    font-size: 24px !important;\n    margin-bottom: 30px !important; }\n  :host /deep/ .full-section.service-chioce .wrap-inner h2 {\n    font-size: 24px; }\n  :host /deep/ .full-section.our-services .row [class*=\"col-\"] p {\n    margin-bottom: 30px; }\n  :host /deep/ .full-section.our-services .row [class*=\"col-\"]:last-child p {\n    margin-bottom: 0; }\n  :host /deep/ .full-section.our-portfolio:after,\n  :host /deep/ .full-section.our-portfolio:before {\n    width: 80px; }\n  :host /deep/ .modal .row .column {\n    width: 20%; }\n  :host /deep/ .dialog-service-chioce .dialog-wrapper-content {\n    min-width: inherit;\n    width: 100% !important; }\n  :host /deep/ .col-ipad {\n    width: 50%; } }\n\n@media (max-width: 767px) {\n  :host /deep/ .full-section.gray {\n    padding-bottom: 0; }\n  :host /deep/ .full-section.gray .row [class*=\"col-\"] p {\n    margin-bottom: 30px !important; } }\n\n@media (max-width: 480px) {\n  :host /deep/ .full-section {\n    padding: 30px 0 !important; }\n  :host /deep/ .full-section.our-portfolio:after,\n  :host /deep/ .full-section.our-portfolio:before {\n    width: 90px; }\n  :host /deep/ .full-section.gray {\n    padding-bottom: 0 !important; }\n  :host /deep/ .slideshow-container .slide .img-slide {\n    background: 0 0 !important;\n    height: inherit; }\n  :host /deep/ .slideshow-container .slide img {\n    display: block; }\n  :host /deep/ .slideshow-container .caption-text {\n    display: none; }\n  :host /deep/ .slideshow-container .nav-dot {\n    bottom: 15px; }\n  :host /deep/ .mat-dialog-container .dialog-container .dialog-wrapper-content {\n    padding: 10px; }\n  :host /deep/ .mat-dialog-container .dialog-container .close-box .icon-close {\n    margin: 0; }\n  :host /deep/ .dialog-service-chioce .ota-btn-main {\n    width: 100%; }\n  :host /deep/ .dialog-sent-success .dialog-wrapper-content .ota-btn-main {\n    min-width: 180px;\n    width: 100%; }\n  :host /deep/ .form-wrapper + .ota-btn-main {\n    margin-top: -30px; } }\n\n@media (max-width: 492px) {\n  :host /deep/ .carousel {\n    width: 320px;\n    margin: 0 auto; }\n  :host /deep/ .carousel-slide {\n    width: 320px;\n    min-height: 320px;\n    margin: 0 auto; }\n  :host /deep/ .owl-dots {\n    text-align: center;\n    margin: 10px 0 30px; }\n    :host /deep/ .owl-dots .owl-dot {\n      height: 8px;\n      width: 8px; }\n  :host /deep/ .full-section.our-portfolio:after,\n  :host /deep/ .full-section.our-portfolio:before,\n  :host /deep/ .purejscarousel-btn {\n    display: none; } }\n\n:host /deep/ .modal-carousel-dot {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n\n:host /deep/ .owl-carousel {\n  z-index: unset !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".dialog-map {\n  width: 100%;\n  position: absolute;\n  height: 100%;\n  background-color: #e5e3df; }\n\n@media screen and (max-width: 767px) {\n  .dialog-map {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background-color: #e5e3df; } }\n\n@media screen and (max-width: 767px) and (orientation: portrait) {\n  #map.iphone {\n    height: calc(100% - 75px); } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".ad-header {\n  font-size: 16px;\n  color: #061021; }\n\n.big-title {\n  font-size: 20px;\n  font-weight: 600;\n  padding: 0 0 15px 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.ds-title {\n  color: #061021;\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 15px; }\n\n.bold {\n  font-weight: bold; }\n\n.box-ctrl {\n  margin-bottom: 30px; }\n  .box-ctrl .title {\n    font-size: 14px;\n    color: #042764;\n    font-weight: 600;\n    margin-bottom: 10px; }\n  .box-ctrl .sub-title {\n    font-size: 14px;\n    margin-bottom: 15px; }\n  .box-ctrl:last-child {\n    margin-bottom: 0; }\n  .box-ctrl ul {\n    padding-left: 20px; }\n    .box-ctrl ul li {\n      list-style: disc;\n      font-size: 14px;\n      color: #061021; }\n      .box-ctrl ul li > div {\n        word-break: break-word; }\n  .box-ctrl .child-table {\n    width: 100%; }\n    .box-ctrl .child-table .ct-box-ctrl {\n      color: #061021;\n      border-bottom: 1px solid #dfe1e6; }\n      .box-ctrl .child-table .ct-box-ctrl:first-child {\n        background: #F6F8F9;\n        border-bottom: 2px solid #dfe1e6;\n        max-height: 35px; }\n        .box-ctrl .child-table .ct-box-ctrl:first-child .left,\n        .box-ctrl .child-table .ct-box-ctrl:first-child .right {\n          padding: 9px 10px 8px;\n          border-left: none; }\n      .box-ctrl .child-table .ct-box-ctrl .left,\n      .box-ctrl .child-table .ct-box-ctrl .right {\n        vertical-align: top;\n        display: table-cell;\n        padding: 15px 10px; }\n      .box-ctrl .child-table .ct-box-ctrl .left {\n        width: 300px; }\n      .box-ctrl .child-table .ct-box-ctrl .right {\n        width: calc(100% - 305px);\n        border-left: 1px solid #dfe1e6; }\n\n@media screen and (max-width: 768px) {\n  .box-ctrl .child-table .ct-box-ctrl .left {\n    width: 158px; }\n  .box-ctrl .child-table .ct-box-ctrl .right {\n    width: calc(100% - 158px); } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".dropdown-ota-style {\n  line-height: 40px;\n  padding: 0 15px 0 10px;\n  height: 40px;\n  cursor: pointer; }\n  .dropdown-ota-style.off {\n    pointer-events: none; }\n  .dropdown-ota-style.text-left {\n    text-align: left; }\n  .dropdown-ota-style.error {\n    border-color: #ed1c24; }\n  .dropdown-ota-style:focus {\n    border-color: #003a90; }\n  .dropdown-ota-style.disabled {\n    background-color: #f5f5f5;\n    cursor: not-allowed;\n    pointer-events: none; }\n  .dropdown-ota-style img {\n    width: 16px;\n    height: 16px;\n    margin-right: 5px;\n    position: relative;\n    top: -1px; }\n  .dropdown-ota-style a, .dropdown-ota-style a:hover {\n    line-height: 32px;\n    color: #061021; }\n\n.item-list {\n  overflow: hidden; }\n\n.d-none {\n  display: none; }\n\n.dropdown-sub-menu {\n  width: unset;\n  max-width: unset; }\n  .dropdown-sub-menu li :hover {\n    cursor: pointer;\n    background-color: red; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".input-wrapper {\n  position: relative;\n  width: 100%; }\n\n.input-suggestion {\n  width: 100%;\n  padding: 0 30px; }\n\n.left-icon,\n.right-icon {\n  position: absolute;\n  top: 13px;\n  font-size: 14px;\n  color: #061021; }\n\n.left-icon {\n  left: 11px; }\n\n.right-icon {\n  right: 9px;\n  cursor: pointer;\n  color: #6b778c; }\n  .right-icon:hover {\n    color: #061021; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n.title {\n  color: #061021;\n  font-size: 20px;\n  font-weight: 700;\n  padding: 0 15px; }\n\n.sub-title {\n  font-size: 12px;\n  padding: 0 15px; }\n\n.row {\n  padding: 0 15px;\n  margin: 0px; }\n  .row:last-child .header,\n  .row:last-child .data {\n    border-bottom: 1px solid #DFE1E6; }\n\n.d-inline {\n  display: inline; }\n\n.w-50 {\n  width: 50%; }\n\n.row-ota-button {\n  margin-top: 15px;\n  text-align: center;\n  border-top: 1px solid #DFE1E6;\n  display: flow-root; }\n\n.btn-horizontal {\n  margin-top: 15px;\n  width: 160px;\n  font-size: 14px; }\n  .btn-horizontal.ota-btn-sub {\n    border: none;\n    width: 0px;\n    float: left;\n    background-color: #FFFFFF;\n    margin-left: 15px;\n    text-align: left;\n    color: #003a90;\n    cursor: pointer; }\n    .btn-horizontal.ota-btn-sub:hover {\n      background-color: none;\n      text-decoration: underline; }\n  .btn-horizontal.ota-btn-main {\n    float: right;\n    margin-right: 15px;\n    margin-bottom: 0px; }\n\n.col-height {\n  display: -ms-flexbox;\n  display: flex; }\n  @media screen and (min-width: 768px) {\n    .col-height .data {\n      margin-left: 1px; } }\n\n:host /deep/ .dialog-wrapper-content {\n  width: 750px !important;\n  padding: 30px 0px 15px 0px !important;\n  min-height: unset !important;\n  max-height: 100vh;\n  overflow-y: auto; }\n\n:host /deep/ .mat-dialog-content {\n  padding: 0px !important; }\n\n.header {\n  color: #061021;\n  background-color: #f6f8f9;\n  width: 32%;\n  float: left;\n  padding: 12px;\n  border-left: 1px solid #DFE1E6;\n  border-right: 1px solid #DFE1E6;\n  border-top: 1px solid #DFE1E6; }\n  .header.merge-header {\n    border-top: none;\n    height: 45px; }\n    @media screen and (max-width: 767px) {\n      .header.merge-header {\n        display: none; } }\n\n.data {\n  color: #061021;\n  width: 68%;\n  float: right;\n  padding: 12px;\n  border-left: 0px;\n  border-right: 1px solid #DFE1E6;\n  border-top: 1px solid #DFE1E6; }\n  @media screen and (min-width: 768px) {\n    .data.fix-height {\n      height: 45px; } }\n\n.mb-15 {\n  margin-bottom: 15px; }\n\n.fa-check {\n  font-size: 12px;\n  color: #4aad5d; }\n\n.font-bold {\n  font-weight: bold; }\n\n.icon-check {\n  color: #45ae59; }\n\n.word-break-all {\n  word-break: break-all; }\n\n.warning {\n  padding: 5px 10px;\n  background-color: #e4edff;\n  display: inline-block;\n  font-size: 12px; }\n  .warning span {\n    word-break: break-word; }\n\n.travel-policy {\n  margin-top: 7px;\n  list-style-position: inside; }\n  .travel-policy li span {\n    color: #061021;\n    font-size: 12px;\n    letter-spacing: 0;\n    line-height: 14px; }\n  .travel-policy li:before {\n    content: \"\\2022\";\n    font-size: 12px;\n    padding-right: 5px; }\n\n@media screen and (max-width: 767px) {\n  .title {\n    color: #061021;\n    font-size: 16px;\n    font-weight: 700; }\n  .sub-title {\n    font-size: 12px; }\n  .col-height {\n    display: block; }\n  .header {\n    width: 100%; }\n  .data {\n    width: 100%;\n    border-left: 1px solid #DFE1E6; }\n  .btn-horizontal {\n    width: calc(50% - 22.5px) !important; }\n    .btn-horizontal.ota-btn-sub {\n      margin-left: 15px;\n      text-align: center;\n      color: #061021;\n      border: 1px solid #DFE1E6; }\n  :host /deep/ .dialog-wrapper-content {\n    width: 100% !important;\n    padding: 15px 0px !important;\n    height: 100vh !important;\n    overflow-y: scroll; }\n  .last .header {\n    border-bottom: 0px !important; }\n  .cal-height {\n    overflow-y: scroll;\n    height: calc(var(--height-vh, 1vh) * 100 - 190px) !important; }\n  .row-ota-button {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: calc(var(--height-vh, 1vh) * 100 - 85px);\n    bottom: 0;\n    background-color: #FFFFFF; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ":host /deep/ .dialog-wrapper-content {\n  width: 760px !important;\n  padding: 0 !important;\n  min-height: unset !important;\n  max-height: 100vh;\n  overflow-y: hidden; }\n\n.dialog-header {\n  padding: 24px 16px 12px; }\n  .dialog-header .title {\n    font-size: 20px;\n    line-height: 24px;\n    font-weight: bold;\n    margin-bottom: 2px; }\n\n.dialog-body {\n  padding: 12px 16px 24px;\n  max-height: calc(100vh - 246px);\n  overflow: auto; }\n  .dialog-body .section-title {\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: bold;\n    margin-bottom: 20px; }\n  .dialog-body .language-container i,\n  .dialog-body .currency-container i {\n    font-size: 16px;\n    display: none; }\n  .dialog-body .language-container .language-item.active, .dialog-body .language-container .currency-item.active,\n  .dialog-body .currency-container .language-item.active,\n  .dialog-body .currency-container .currency-item.active {\n    background-color: #E4EDFF; }\n    .dialog-body .language-container .language-item.active i, .dialog-body .language-container .currency-item.active i,\n    .dialog-body .currency-container .language-item.active i,\n    .dialog-body .currency-container .currency-item.active i {\n      display: block; }\n  .dialog-body .language-container .language-item:hover, .dialog-body .language-container .currency-item:hover,\n  .dialog-body .currency-container .language-item:hover,\n  .dialog-body .currency-container .currency-item:hover {\n    background-color: #E4EDFF; }\n  .dialog-body .language-container {\n    border-bottom: 1px solid #DFE1E6;\n    padding-bottom: 20px;\n    margin-bottom: 20px;\n    height: 102px; }\n    .dialog-body .language-container .language-item {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n      gap: 8px;\n      padding: 12px 16px; }\n      .dialog-body .language-container .language-item img {\n        width: 22px;\n        height: 16px; }\n      .dialog-body .language-container .language-item .language-label {\n        width: 100%;\n        color: #061021; }\n      .dialog-body .language-container .language-item .right-icon {\n        width: 16px;\n        height: 16px; }\n  .dialog-body .currency-container .currency-item {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    gap: 8px;\n    padding: 12px 16px; }\n    .dialog-body .currency-container .currency-item .currency-code {\n      margin-bottom: 4px;\n      color: #061021;\n      font-weight: bold; }\n    .dialog-body .currency-container .currency-item .currency-name {\n      font-size: 12px;\n      line-height: 14px;\n      color: #6b778c; }\n\n.dialog-footer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  height: 64px;\n  padding: 12px 16px;\n  border-top: 1px solid #DFE1E6; }\n  .dialog-footer .ota-btn-main {\n    margin: 0;\n    width: 160px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n:host /deep/ app-lang-dropdown > div {\n  width: 22px; }\n\n.wrap-inner {\n  overflow: visible;\n  display: -ms-flexbox;\n  display: flex; }\n\n.header-mobile {\n  display: none; }\n\n.logo {\n  display: none; }\n\n.header-desktop {\n  height: 91px; }\n\n.header-white {\n  background: white;\n  border-bottom: 1px solid #dfe1e6;\n  top: 0;\n  width: 100%;\n  z-index: 12;\n  box-sizing: border-box; }\n  .header-white .logo {\n    display: block;\n    margin: 14px 0;\n    float: left; }\n  .header-white .header-menu a, .header-white .header-menu .text {\n    color: #061021; }\n  .header-white .nav-menu ul {\n    display: -webkit-inline-box; }\n    .header-white .nav-menu ul li a, .header-white .nav-menu ul li .text {\n      color: #061021; }\n    .header-white .nav-menu ul li a:hover {\n      color: #1a1a1a; }\n  .header-white .line-space {\n    color: #DFE1E6; }\n  .header-white .box-short .icon-more {\n    display: block;\n    padding: 24px 15px 20px;\n    min-width: 70px;\n    text-align: left;\n    cursor: pointer; }\n  .header-white .box-short ul {\n    display: block;\n    position: absolute;\n    margin: 0;\n    margin-right: 0px;\n    top: 40px;\n    left: 10px;\n    z-index: 1;\n    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);\n    background-color: white; }\n  .header-white .box-short li {\n    display: none;\n    height: 40px;\n    padding: 0 16px;\n    margin-right: 0px;\n    line-height: 40px;\n    min-width: 200px; }\n    .header-white .box-short li a {\n      margin: 0;\n      padding: 0;\n      text-align: left; }\n    .header-white .box-short li:hover {\n      background: #e4edff; }\n  .header-white .box-short:hover li {\n    display: block; }\n\n.header-right {\n  -ms-flex-positive: 2;\n      flex-grow: 2; }\n\n.header-menu {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row-reverse;\n      flex-direction: row-reverse;\n  gap: 15px;\n  margin: 37px 0 0 0; }\n  .header-menu > li {\n    line-height: 40px;\n    font-size: 14px; }\n  .header-menu a, .header-menu .text {\n    color: #FFFFFF; }\n  .header-menu img {\n    vertical-align: middle; }\n  .header-menu .btn-language-currency {\n    display: -ms-flexbox;\n    display: flex;\n    font-size: 14px;\n    line-height: 20px;\n    -ms-flex-align: center;\n        align-items: center;\n    padding: 12px 16px;\n    gap: 8px;\n    height: 44px; }\n    .header-menu .btn-language-currency:hover {\n      background: #E4EDFF;\n      border-radius: 100px; }\n    .header-menu .btn-language-currency i {\n      font-size: 16px; }\n    .header-menu .btn-language-currency div {\n      white-space: nowrap; }\n\n.line-space {\n  margin: 0 20px;\n  width: 1px;\n  height: 20px;\n  font-size: 17px;\n  font-family: \"Times New Roman\", Tahoma, serif;\n  color: #A5ADBA !important; }\n\n.menu-login {\n  margin-top: 5px;\n  line-height: 15px;\n  position: relative;\n  display: block;\n  text-align: right;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n  .menu-login.login {\n    line-height: 29px !important; }\n  .menu-login .text-overflow {\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .menu-login .img-drowdown {\n    position: absolute;\n    top: 50%;\n    right: 15px;\n    transform: translateY(-50%);\n    font-size: 16px;\n    color: red; }\n  .menu-login .email {\n    font-size: 12px;\n    color: #6b778c; }\n  .menu-login .company {\n    font-size: 14px;\n    color: #061021; }\n\n.account-dropdown {\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  width: 191px; }\n\n.my-account {\n  margin-top: 7px;\n  line-height: 30px; }\n  .my-account .icon-arrow-down-round {\n    margin-top: 8px; }\n\n.menu-help {\n  padding: 0 35px 0 0; }\n\n.scroll-companies {\n  overflow: auto;\n  max-height: 320px; }\n\n.menu-bar-account {\n  padding-right: 10px; }\n\n.user-display {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 5px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  overflow: hidden; }\n\n.list-menu-wrap {\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  gap: 15px; }\n  .list-menu-wrap.show .list-sub-menu {\n    display: block; }\n\n.list-sub-menu {\n  display: none;\n  position: absolute;\n  z-index: 99;\n  top: 54px;\n  right: 35px;\n  width: 230px;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.4); }\n  .list-sub-menu > li {\n    background: #FFFFFF; }\n    .list-sub-menu > li > a {\n      display: block;\n      width: 100%;\n      padding: 0 16px;\n      line-height: 39px;\n      height: 40px;\n      border-bottom: 1px solid #DFE1E6;\n      color: #061021; }\n      .list-sub-menu > li > a:hover {\n        background: #e4edff; }\n\n.title {\n  background: #F6F8F9 !important;\n  color: #061021 !important;\n  border-top: 1px solid #DFE1E6 !important;\n  border-bottom: 1px solid #DFE1E6 !important;\n  height: 30px !important;\n  -ms-flex-align: center;\n      align-items: center;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 12px !important;\n  pointer-events: none; }\n\n.menu {\n  border-top: 1px solid #DFE1E6 !important; }\n\n@media screen and (max-width: 767px) {\n  .header-wrap {\n    width: 100%;\n    z-index: 1; }\n  .header-desktop {\n    display: none; }\n  .header-mobile {\n    position: relative;\n    height: 48px;\n    display: block;\n    left: 0%;\n    margin-left: 0;\n    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1); }\n    .header-mobile .navbar-toggle {\n      margin-right: 0;\n      padding-top: 1px;\n      float: right;\n      z-index: 1; }\n      .header-mobile .navbar-toggle .icon-navbar-toggle {\n        font-size: 26px;\n        color: white; }\n    .header-mobile.header-white {\n      border-width: 0 !important;\n      width: 100%;\n      background: white;\n      border-bottom: 3px solid #ed1c24; }\n      .header-mobile.header-white .logo {\n        display: block;\n        margin: 5px 16px;\n        float: left; }\n      .header-mobile.header-white .line-space {\n        color: #DFE1E6 !important; }\n      .header-mobile.header-white .navbar-toggle .icon-navbar-toggle {\n        color: #042764; }\n  .m-list-menu-space {\n    position: fixed;\n    height: 100vh;\n    top: 0;\n    right: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    visibility: hidden;\n    opacity: 0;\n    transition: opacity 0.4;\n    z-index: 99; }\n  .m-list-menu-wrap {\n    position: fixed;\n    width: calc(100% - 49px);\n    background: #f6f8f9;\n    right: 0;\n    height: 100%;\n    top: 0;\n    overflow-y: scroll;\n    z-index: 99;\n    transition: 0.4s;\n    transform: translate3d(100%, 0, 0);\n    overflow-scrolling: touch;\n    -webkit-overflow-scrolling: touch; }\n  .user-detail {\n    margin: 0;\n    padding: 25px 0 25px 16px;\n    overflow: hidden;\n    position: relative;\n    background-color: #FFFFFF; }\n    .user-detail .user-display {\n      width: 44px;\n      height: 44px;\n      margin: 0 10px;\n      float: left; }\n    .user-detail .user-name {\n      width: 100%;\n      float: left;\n      padding: 0 30px 0 0; }\n      .user-detail .user-name span {\n        display: block;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis; }\n    .user-detail .icon-arrow-right {\n      display: inline-block;\n      position: absolute;\n      top: 50%;\n      right: 10px;\n      margin-top: -7px;\n      transition: transform 0.2s;\n      color: #6b778c;\n      font-size: 16px; }\n    .user-detail .icon-close2 {\n      font-size: 16px;\n      display: inline-block;\n      position: absolute;\n      top: 50%;\n      right: 10px;\n      margin-top: -7px;\n      color: #6b778c; }\n  .m-list-menu-sub {\n    margin: 0 0 15px 0; }\n    .m-list-menu-sub > li {\n      background: #FFFFFF; }\n      .m-list-menu-sub > li > a {\n        position: relative;\n        font-size: 14px;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n            align-items: center;\n        width: 100%;\n        padding: 0 35px 0 16px;\n        line-height: 40px;\n        color: #061021; }\n        .m-list-menu-sub > li > a .icon-sidemenu {\n          margin-right: 10px;\n          font-size: 16px; }\n        .m-list-menu-sub > li > a.bt-1 {\n          border-top: 1px solid #DFE1E6; }\n        .m-list-menu-sub > li > a.no-border-top {\n          border-top: none; }\n        .m-list-menu-sub > li > a:hover, .m-list-menu-sub > li > a .active {\n          color: #FFFFFF !important;\n          background: #586d76; }\n        .m-list-menu-sub > li > a .link-arrow {\n          margin-left: auto;\n          display: -ms-flexbox;\n          display: flex;\n          -ms-flex-align: center;\n              align-items: center;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n          gap: 8px; }\n        .m-list-menu-sub > li > a .icon-arrow-right {\n          display: inline-block;\n          position: absolute;\n          top: 50%;\n          right: 10px;\n          margin-top: -7px;\n          transition: transform 0.2s;\n          color: #6b778c;\n          font-size: 16px; }\n        .m-list-menu-sub > li > a .icon-close2 {\n          display: inline-block;\n          position: absolute;\n          top: 50%;\n          right: 10px;\n          margin-top: -7px;\n          color: #6b778c;\n          font-size: 16px; }\n      .m-list-menu-sub > li:last-child {\n        border-bottom: none; }\n  .icon-flag {\n    width: 23px;\n    height: 17px;\n    vertical-align: middle; }\n  .company {\n    position: relative;\n    font-size: 14px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    width: 100%;\n    padding: 0 35px 0 16px;\n    line-height: 40px;\n    color: #061021;\n    background-color: #FFFFFF; }\n    .company > span {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap; } }\n\n.menu-bar-lang-mobile li {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  height: 46px;\n  padding: 0 35px 0 16px; }\n\n.nav-menu {\n  float: left;\n  height: 91px;\n  position: relative;\n  margin-left: 30px; }\n\n.nav-menu ul {\n  margin: 31px 0 0; }\n\n.nav-menu ul li {\n  float: left;\n  position: relative;\n  margin-right: 5px; }\n  .nav-menu ul li:focus {\n    outline: 0; }\n\n.nav-menu ul li a {\n  display: block;\n  color: #FFFFFF;\n  padding: 0 10px;\n  margin: 20px 0;\n  min-width: 70px;\n  text-align: center; }\n\n.nav-menu ul li a:hover {\n  color: none; }\n\n.nav-menu ul li.active:before {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 4px;\n  background: #ed1c24; }\n\n.logo-white {\n  display: block;\n  margin: 14px 0;\n  float: left; }\n\n.overflow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.icon-business-events {\n  background-image: url(\"../../../assets/images/icons/icon-bussinessevent.svg\");\n  width: 19px;\n  height: 16px;\n  filter: invert(26%) sepia(0%) saturate(1810%) hue-rotate(331deg) brightness(100%) contrast(87%); }\n\n.icon-arrow-down-round {\n  font-size: 16px;\n  color: #ed1c24;\n  margin-left: 12px;\n  margin-top: 10px; }\n\n.position-relative {\n  position: relative; }\n\n.icon-check {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  color: #042764; }\n  @media screen and (max-width: 767px) {\n    .icon-check {\n      top: 13px; } }\n\n.switch-company-mobile {\n  width: 100%; }\n  .switch-company-mobile .title {\n    line-height: 30px; }\n\n.company-padding {\n  padding-right: 31px; }\n\n.current-currency {\n  border-left: 1px solid #DFE1E6;\n  padding-left: 8px;\n  line-height: 18px; }\n\n.side-menu-language-currency-overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100; }\n  .side-menu-language-currency-overlay.-open {\n    display: -ms-flexbox;\n    display: flex; }\n  .side-menu-language-currency-overlay .side-menu-language-currency-backdrop {\n    z-index: 1;\n    width: 100%;\n    height: 100%; }\n  .side-menu-language-currency-overlay .side-menu-language-currency-container {\n    z-index: 2;\n    position: fixed;\n    right: 0;\n    height: 100%;\n    width: calc(100% - 49px);\n    background-color: white;\n    transition: 0.4s;\n    transform: translate3d(100%, 0, 0);\n    overflow: hidden; }\n    .side-menu-language-currency-overlay .side-menu-language-currency-container.-open-language-currency {\n      transform: translate3d(0, 0, 0); }\n    .side-menu-language-currency-overlay .side-menu-language-currency-container .language-currency-title {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n      padding: 16px 12px;\n      height: 60px;\n      border-bottom: 1px solid #DFE1E6; }\n      .side-menu-language-currency-overlay .side-menu-language-currency-container .language-currency-title .left-icon {\n        width: 16px;\n        height: 16px;\n        color: #6b778c;\n        z-index: 1; }\n        .side-menu-language-currency-overlay .side-menu-language-currency-container .language-currency-title .left-icon i {\n          font-size: 16px; }\n      .side-menu-language-currency-overlay .side-menu-language-currency-container .language-currency-title label {\n        font-weight: bold;\n        width: 100%;\n        text-align: center;\n        font-size: 16px;\n        line-height: 20px;\n        margin-left: -16px; }\n  .side-menu-language-currency-overlay .side-menu-section {\n    height: 30px;\n    font-size: 12px;\n    line-height: 14px;\n    padding: 8px 12px;\n    background-color: #F8FAFB;\n    border-top: 1px solid #DFE1E6;\n    border-bottom: 1px solid #DFE1E6; }\n  .side-menu-language-currency-overlay .language-body .dropdown-item, .side-menu-language-currency-overlay .currency-body .dropdown-item {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    padding: 12px;\n    height: 42px;\n    gap: 8px; }\n    .side-menu-language-currency-overlay .language-body .dropdown-item .left-icon:has(img), .side-menu-language-currency-overlay .currency-body .dropdown-item .left-icon:has(img) {\n      width: 22px; }\n    .side-menu-language-currency-overlay .language-body .dropdown-item .left-icon img, .side-menu-language-currency-overlay .currency-body .dropdown-item .left-icon img {\n      width: 22px;\n      height: 16px; }\n    .side-menu-language-currency-overlay .language-body .dropdown-item .left-icon .currency-code, .side-menu-language-currency-overlay .currency-body .dropdown-item .left-icon .currency-code {\n      width: 36px;\n      font-size: 14px;\n      line-height: 18px;\n      font-weight: bold;\n      color: #061021; }\n    .side-menu-language-currency-overlay .language-body .dropdown-item .item-label, .side-menu-language-currency-overlay .currency-body .dropdown-item .item-label {\n      text-align: left;\n      width: calc(100% - 54px); }\n    .side-menu-language-currency-overlay .language-body .dropdown-item .right-icon, .side-menu-language-currency-overlay .currency-body .dropdown-item .right-icon {\n      width: 16px;\n      height: 16px;\n      color: #6b778c; }\n      .side-menu-language-currency-overlay .language-body .dropdown-item .right-icon i, .side-menu-language-currency-overlay .currency-body .dropdown-item .right-icon i {\n        position: unset;\n        font-size: 16px;\n        color: #003a90; }\n  .side-menu-language-currency-overlay .language-body .item-label {\n    color: #061021; }\n  .side-menu-language-currency-overlay .currency-body {\n    height: calc(100% - 242px);\n    overflow-y: scroll;\n    overflow-scrolling: touch;\n    -webkit-overflow-scrolling: touch; }\n    .side-menu-language-currency-overlay .currency-body .item-label {\n      margin-left: -4px;\n      color: #6b778c; }\n  .side-menu-language-currency-overlay .language-currency-actions {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    gap: 16px;\n    height: 68px;\n    padding: 12px;\n    border-top: 1px solid #DFE1E6; }\n    .side-menu-language-currency-overlay .language-currency-actions .left-action, .side-menu-language-currency-overlay .language-currency-actions .right-action {\n      width: 100%; }\n      .side-menu-language-currency-overlay .language-currency-actions .left-action button, .side-menu-language-currency-overlay .language-currency-actions .right-action button {\n        height: 44px;\n        margin: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.dialog-alert-content {\n  text-align: center;\n  padding: 30px 30px 0; }\n  @media screen and (max-width: 768px) {\n    .dialog-alert-content {\n      padding: 30px 15px 0; } }\n\n.icon-close {\n  -moz-appearance: none;\n       appearance: none;\n  border: 0;\n  outline: 0;\n  background: none; }\n\n.alert-img {\n  display: block;\n  height: 60px;\n  width: 100px;\n  margin: 0 auto;\n  margin-bottom: 15px; }\n\n.alert-header {\n  color: #061021;\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: bold;\n  margin-bottom: 5px; }\n  @media screen and (max-width: 768px) {\n    .alert-header {\n      font-size: 18px; } }\n\n.alert-text {\n  color: #061021;\n  font-size: 14px;\n  margin-bottom: 30px; }\n  @media screen and (max-width: 768px) {\n    .alert-text {\n      font-size: 16px;\n      line-height: 20px; } }\n\n.ota-btn-main {\n  margin: 0;\n  width: 160px; }\n  @media screen and (max-width: 768px) {\n    .ota-btn-main {\n      font-size: 16px;\n      background-color: unset;\n      color: #003a90;\n      line-height: unset;\n      height: unset; }\n      .ota-btn-main:hover, .ota-btn-main.touch {\n        background-color: unset; } }\n\n.action-button {\n  padding: 15px;\n  border-top: 1px solid #DFE1E6;\n  padding-top: 15px;\n  text-align: right;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n:host /deep/ .dialog-banner-overlay .dialog-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n  :host /deep/ .dialog-banner-overlay .dialog-container .dialog-wrapper-content {\n    height: 100%;\n    width: 92vw;\n    max-width: 50vh;\n    max-height: 85vh;\n    padding: 0 !important;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-pack: justify;\n        justify-content: space-between; }\n    :host /deep/ .dialog-banner-overlay .dialog-container .dialog-wrapper-content:hover {\n      cursor: pointer; }\n      :host /deep/ .dialog-banner-overlay .dialog-container .dialog-wrapper-content:hover button.control {\n        opacity: 80%; }\n    @media screen and (min-width: 768px) {\n      :host /deep/ .dialog-banner-overlay .dialog-container .dialog-wrapper-content {\n        width: 85vh;\n        max-width: 85vw;\n        max-height: 85vh; } }\n    :host /deep/ .dialog-banner-overlay .dialog-container .dialog-wrapper-content .dialog-banner-content {\n      position: relative;\n      height: calc(100% - 64px); }\n\n:host /deep/ .dialog-banner-overlay .dialog-btn-film {\n  display: none !important; }\n\n:host /deep/ .dialog-banner-overlay .owl-dots {\n  position: absolute;\n  background: rgba(0, 0, 0, 0.24);\n  border-radius: 12px;\n  padding: 4px 12px;\n  display: -ms-flexbox;\n  display: flex;\n  bottom: 16px; }\n  :host /deep/ .dialog-banner-overlay .owl-dots.disabled {\n    display: none; }\n\n:host /deep/ .dialog-banner-overlay .owl-next,\n:host /deep/ .dialog-banner-overlay .owl-prev {\n  position: absolute;\n  top: 50%;\n  opacity: 0; }\n  :host /deep/ .dialog-banner-overlay .owl-next i,\n  :host /deep/ .dialog-banner-overlay .owl-prev i {\n    font-size: 3.2rem;\n    color: white; }\n\n:host /deep/ .dialog-banner-overlay .owl-next {\n  right: 16px; }\n\n:host /deep/ .dialog-banner-overlay .owl-prev {\n  left: 16px; }\n\n:host /deep/ .dialog-banner-overlay .banner-overlay-owl:has(.owl-dot.active:first-child) .owl-prev,\n:host /deep/ .dialog-banner-overlay .banner-overlay-owl:has(.owl-dot.active:last-child) .owl-next {\n  display: none; }\n\n:host /deep/ .dialog-banner-overlay .banner-overlay-owl:hover .owl-nav .owl-prev, :host /deep/ .dialog-banner-overlay .banner-overlay-owl:hover .owl-nav .owl-next {\n  opacity: 1; }\n\n:host /deep/ .dialog-banner-overlay .banner {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  height: 100%;\n  margin-bottom: 0px; }\n\n:host /deep/ .dialog-banner-overlay button.control {\n  position: absolute;\n  top: 50%;\n  color: white;\n  opacity: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  border-radius: 120px;\n  border: none; }\n  :host /deep/ .dialog-banner-overlay button.control i {\n    font-size: 32px; }\n  :host /deep/ .dialog-banner-overlay button.control.next {\n    right: 16px; }\n  :host /deep/ .dialog-banner-overlay button.control.prev {\n    left: 16px; }\n  :host /deep/ .dialog-banner-overlay button.control.disabled {\n    display: none; }\n\n:host /deep/ .dialog-banner-overlay .dialog-banner-button {\n  text-align: center;\n  padding: 12px; }\n  :host /deep/ .dialog-banner-overlay .dialog-banner-button .ota-btn-main {\n    margin: 0;\n    width: 173px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".title {\n  font-size: 18px;\n  font-weight: 600;\n  padding: 15px;\n  border-bottom: 1px solid #dfe1e6; }\n\n.col-left {\n  width: 50%;\n  padding-right: 7.5px; }\n\n.col-right {\n  width: 50%;\n  padding-left: 7.5px; }\n\n.booking-report-form {\n  padding: 15px; }\n\n.information {\n  font-size: 12px;\n  color: #6b778c;\n  margin: 10px 0px 30px; }\n\n.text-error {\n  font-size: 12px;\n  margin: 10px 0px 30px; }\n\n.form-group, .form-group-inline {\n  margin: 0; }\n\n@media screen and (max-width: 767px) {\n  .button-left {\n    padding-right: 10px; }\n  .button-right {\n    padding-left: 10px; }\n  .col-left {\n    padding-right: 5.5px; }\n  .col-right {\n    padding-left: 5.5px; } }\n\n.ota-loading {\n  height: 40px;\n  margin-bottom: 10px; }\n\n.ota-btn-main {\n  margin: 0px 0 15px 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "a {\n  color: #042764; }\n  a:hover {\n    text-decoration: underline; }\n\n.dialog-container {\n  padding: 15px !important; }\n\n.action-button {\n  padding: 15px;\n  border-top: 1px solid #DFE1E6;\n  padding-top: 15px;\n  text-align: right;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center; }\n  .action-button button {\n    max-width: 180px;\n    margin-bottom: 0; }\n\n.thb-input-group .input-group-addon {\n  background-color: transparent;\n  position: absolute;\n  border: 0;\n  padding: 10px; }\n\n.thb-input-group input {\n  padding-left: 48px; }\n\n:host /deep/ .dialog-header .pull-left {\n  width: 100%;\n  padding: 15px 15px 0 15px; }\n  :host /deep/ .dialog-header .pull-left .dialog-title {\n    color: #061021;\n    font-size: 20px;\n    font-weight: 700; }\n\n:host /deep/ .dialog-wrapper-content {\n  width: 750px !important;\n  padding: 0 !important;\n  min-height: unset !important; }\n\n:host /deep/ .close-box {\n  position: absolute;\n  right: 33px;\n  margin-top: 10px;\n  z-index: 3; }\n\n:host /deep/ .mat-dialog-content {\n  padding: 0px !important; }\n\n:host /deep/ .box-select-address {\n  width: 100% !important;\n  margin-top: 15px !important; }\n\n:host /deep/ .address-inner {\n  padding-bottom: 0 !important; }\n\n@media screen and (max-width: 767px) {\n  :host /deep/ .dialog-container {\n    margin-bottom: 71px; }\n  :host /deep/ .action-button {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 15px calc(15px / 2); }\n    :host /deep/ .action-button > * {\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n      max-width: unset !important;\n      margin: 0 calc(15px / 2); } }\n\n.mt-20 {\n  margin-top: 20px; }\n\n.error-text-warp {\n  min-height: 17px; }\n  .error-text-warp .text-error {\n    margin: 5px 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".cancellation-box {\n  padding: 30px 0 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n:host /deep/ .dialog-wrapper-content {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: 100vh; }\n  :host /deep/ .dialog-wrapper-content .dialog-header .close-box {\n    display: none;\n    position: absolute;\n    z-index: 4; }\n    :host /deep/ .dialog-wrapper-content .dialog-header .close-box .icon-close.button {\n      color: #6b778c; }\n  :host /deep/ .dialog-wrapper-content .dialog-header .pull-left {\n    border-bottom: 0 !important;\n    padding: 24px 12px 12px !important;\n    margin: 0 !important; }\n\n.dialog-content {\n  padding: 12px !important;\n  overflow: auto;\n  -ms-flex-positive: 1;\n      flex-grow: 1; }\n\n.action-button {\n  padding: 12px;\n  border-top: 1px solid #DFE1E6;\n  text-align: center;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  gap: 12px; }\n  .action-button button {\n    max-width: 180px;\n    margin-bottom: 0; }\n\n.password-validation {\n  font-size: 12px;\n  line-height: 14px;\n  color: #6B778C;\n  margin-bottom: 20px; }\n  .password-validation .validation-title {\n    margin-bottom: 3px; }\n  .password-validation .validation-bullet {\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 3px; }\n    .password-validation .validation-bullet i {\n      margin-top: 2px;\n      margin-right: 4px; }\n    .password-validation .validation-bullet.validation-valid {\n      color: #4aad5d; }\n    .password-validation .validation-bullet.validation-invalid {\n      color: #ed1c24; }\n\n@media screen and (min-width: 768px) {\n  :host /deep/ .dialog-wrapper-content {\n    height: unset;\n    width: 480px !important;\n    padding: 0 !important; }\n    :host /deep/ .dialog-wrapper-content .dialog-header .close-box {\n      display: block;\n      right: 33px;\n      margin-top: 28px; }\n    :host /deep/ .dialog-wrapper-content .dialog-header .pull-left {\n      padding: 24px 16px 12px; }\n      :host /deep/ .dialog-wrapper-content .dialog-header .pull-left .title {\n        color: #061021;\n        font-size: 20px;\n        font-weight: 700; }\n  .dialog-content {\n    height: unset;\n    max-height: 60vh;\n    padding: 12px 16px 24px !important; }\n  .action-button {\n    padding: 12px 16px;\n    gap: 16px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.notify-checkbox {\n  padding: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  .notify-checkbox input {\n    margin: 0;\n    cursor: pointer; }\n  .notify-checkbox label {\n    margin: 0;\n    font-weight: normal;\n    padding-left: 10px;\n    text-align: left;\n    cursor: pointer; }\n\n.ota-checkbox {\n  padding: 0;\n  display: -ms-flexbox;\n  display: flex; }\n  .ota-checkbox:hover {\n    background-color: transparent; }\n  .ota-checkbox.validate {\n    display: block;\n    padding-left: 22px; }\n    @media screen and (max-width: 560px) {\n      .ota-checkbox.validate {\n        text-align: left; } }\n\n.text-error {\n  display: inline; }\n\n.notify-content {\n  height: 600px;\n  width: 750px;\n  border: none;\n  position: relative;\n  background-position: center center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  max-height: calc(var(--height-vh, 1vh) * 100 - 190px); }\n  @media screen and (max-width: 768px) {\n    .notify-content {\n      max-height: calc(var(--height-vh, 1vh) * 100 - 190px);\n      width: auto;\n      height: auto; }\n      .notify-content.has-checkbox {\n        max-height: calc(var(--height-vh, 1vh) * 100 - 220px); } }\n\n.dialog-notify-button {\n  text-align: center;\n  padding: 0;\n  border-top: 1px solid #dfe1e6; }\n  .dialog-notify-button .ota-btn-main {\n    margin: 0;\n    width: 173px; }\n    .dialog-notify-button .ota-btn-main.-disabled {\n      background-color: #DFE1E6;\n      cursor: default; }\n  .dialog-notify-button .no-checkbox-content {\n    padding: 15px; }\n  .dialog-notify-button .checkbox-content {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    -ms-flex-align: center;\n        align-items: center;\n    padding: 15px; }\n  @media screen and (max-width: 560px) {\n    .dialog-notify-button .checkbox-content {\n      -ms-flex-direction: column;\n          flex-direction: column;\n      -ms-flex-align: normal;\n          align-items: normal;\n      padding: 0; }\n      .dialog-notify-button .checkbox-content .checkbox-container {\n        padding: 15px; }\n      .dialog-notify-button .checkbox-content .button-container {\n        padding: 15px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.dialog-notify-content {\n  text-align: center;\n  padding: 30px; }\n  .dialog-notify-content .notify-img {\n    height: 60px; }\n  .dialog-notify-content .notify-content {\n    text-align: left;\n    max-height: 55vh;\n    margin-top: 15px;\n    overflow-y: auto; }\n    @media screen and (max-width: 768px) {\n      .dialog-notify-content .notify-content {\n        height: calc(var(--height-vh, 1vh) * 100 - 400px); } }\n    .dialog-notify-content .notify-content .notify-title {\n      text-align: center;\n      font-weight: bold; }\n    .dialog-notify-content .notify-content .notify-message {\n      margin-top: 15px; }\n    .dialog-notify-content .notify-content .notify-remark {\n      margin: 0 0 15px 0;\n      white-space: pre-line; }\n  .dialog-notify-content .notify-checkbox {\n    margin-top: 15px;\n    padding: 0;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center; }\n    .dialog-notify-content .notify-checkbox input {\n      margin: 0;\n      cursor: pointer; }\n    .dialog-notify-content .notify-checkbox label {\n      margin: 0;\n      font-weight: normal;\n      padding-left: 10px;\n      cursor: pointer; }\n    .dialog-notify-content .notify-checkbox .notify-checkbox-label {\n      margin: 0; }\n  .dialog-notify-content .ota-checkbox {\n    padding: 0;\n    display: -ms-flexbox;\n    display: flex; }\n    .dialog-notify-content .ota-checkbox:hover {\n      background-color: transparent; }\n    .dialog-notify-content .ota-checkbox.validate {\n      display: block; }\n  .dialog-notify-content .text-error {\n    display: inline; }\n\n.dialog-notify-button {\n  text-align: center;\n  padding: 15px 0px;\n  border-top: 1px solid #DFE1E6; }\n  .dialog-notify-button .ota-btn-main {\n    margin: 0;\n    width: 173px; }\n    .dialog-notify-button .ota-btn-main.-disabled {\n      background-color: #DFE1E6;\n      cursor: default; }\n  @media screen and (max-width: 768px) {\n    .dialog-notify-button {\n      padding: 15px; } }\n\n:host /deep/ .notify-message p {\n  margin-top: 0;\n  margin-bottom: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.bg {\n  background-color: #FFFFFF;\n  padding: 30px 15px;\n  position: relative; }\n  @media screen and (max-width: 768px) {\n    .bg {\n      max-height: 85vh !important;\n      overflow-x: hidden;\n      overflow-y: scroll; } }\n\n.max-width {\n  width: 780px; }\n\n.medium-width {\n  width: 555px; }\n\n.min-width {\n  width: 480px; }\n\n.min-width-divider {\n  width: 480px;\n  padding: 30px 30px 15px 30px; }\n\n.pd-left-right-30 {\n  padding: 0px 30px; }\n\n.heading {\n  margin-bottom: 30px;\n  text-align: center; }\n\n.heading-img {\n  display: block;\n  height: 60px;\n  margin: 0 auto;\n  margin-bottom: 15px; }\n\n.heading-text {\n  color: #061021;\n  font-size: 16px; }\n\n.heading-title {\n  color: #061021;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 21px;\n  margin-bottom: 5px; }\n\n.heading-description {\n  color: #061021;\n  font-size: 14px;\n  line-height: 19px; }\n\n.popup-button-horizontal {\n  margin-top: 30px;\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  -ms-flex-pack: center;\n      justify-content: center; }\n  .popup-button-horizontal .btn-horizontal-0 {\n    font-size: 14px;\n    max-width: 160px;\n    margin: 0px; }\n  .popup-button-horizontal .btn-horizontal-1 {\n    font-size: 14px;\n    max-width: 200px;\n    margin: 0 0 0 15px; }\n  .popup-button-horizontal.divider {\n    margin-top: 0;\n    margin-left: -30px;\n    margin-right: -30px;\n    width: calc(100% + 60px);\n    padding-top: 15px;\n    border-top: 1px solid #dfe1e6; }\n    .popup-button-horizontal.divider .btn-horizontal-0 {\n      max-width: 160px;\n      margin-right: 15px;\n      margin-left: 15px; }\n\n.m-0 {\n  margin: 0px; }\n\n.th {\n  background-color: #f6f8f9;\n  border: 1px solid #dfe1e6;\n  font-weight: bold;\n  padding: 9px 0px 8px 15px; }\n\n.td {\n  border: 1px solid #dfe1e6;\n  padding: 15px; }\n\n.no-bd-bottom {\n  border-bottom: none; }\n\n.no-bd-right {\n  border-right: none; }\n\n.no-bd-left {\n  border-left: none; }\n\n.row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n\n.row > [class*='col-'] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n\n@media screen and (max-width: 767px) {\n  .min-width-divider {\n    padding: 30px 10px 15px 10px; }\n  .bg {\n    width: 100%;\n    overflow: scroll; }\n  .th {\n    padding: 15px;\n    border-bottom: 1px solid #dfe1e6; }\n  .m-0 {\n    margin: 0px; }\n  .no-bd-bottom {\n    border-bottom: none; }\n  .no-bd-right {\n    border-right: none; }\n  .no-bd-left {\n    border-left: none; }\n  .popup-button-horizontal {\n    margin-top: 30px;\n    width: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    -ms-flex-pack: center;\n        justify-content: center; }\n    .popup-button-horizontal .btn-horizontal-0 {\n      font-size: 14px;\n      max-width: 200px; }\n    .popup-button-horizontal .btn-horizontal-1 {\n      font-size: 16px;\n      max-width: 200px;\n      margin: 0 0 0 15px; }\n    .popup-button-horizontal.divider {\n      margin-left: -10px;\n      margin-right: -10px;\n      width: calc(100% + 20px); }\n      .popup-button-horizontal.divider .btn-horizontal-0 {\n        margin-right: 10px;\n        margin-left: 10px; }\n  .popup-button-vertical {\n    margin-top: 30px;\n    width: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -ms-flex-pack: center;\n        justify-content: center; }\n    .popup-button-vertical .btn-vertical-0 {\n      -ms-flex-order: 1;\n          order: 1;\n      font-size: 16px;\n      max-width: 200px; }\n    .popup-button-vertical .btn-vertical-1 {\n      font-size: 16px;\n      max-width: 200px;\n      margin: 0 0 15px 0; }\n  .ota-btn-main {\n    background-color: unset;\n    color: #003a90;\n    line-height: unset;\n    height: unset; }\n    .ota-btn-main:hover, .ota-btn-main.touch {\n      background-color: unset; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".text-msg {\n  margin-top: 15px;\n  margin-bottom: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ":host /deep/ .width-auto .dialog-wrapper-content {\n  width: auto !important; }\n\na {\n  color: #042764; }\n  a:hover {\n    text-decoration: underline; }\n\n.text-msg {\n  margin-top: 15px;\n  margin-bottom: 30px; }\n\n.dialog-container {\n  padding: 57px 15px 60px 15px !important; }\n\n.dialog-container-budget {\n  width: 480px;\n  text-align: center;\n  padding: 30px; }\n  .dialog-container-budget strong {\n    font-size: 16px; }\n    @media screen and (max-width: 767px) {\n      .dialog-container-budget strong {\n        font-size: 14px; } }\n  .dialog-container-budget img {\n    width: 100px;\n    height: 60px;\n    margin-bottom: 15px; }\n\n.action-button {\n  padding: 12px 16px;\n  border-top: 1px solid #DFE1E6;\n  text-align: right;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 16px; }\n  .action-button button {\n    max-width: 50% !important;\n    width: auto;\n    font-size: 14px;\n    margin: 0;\n    padding: 0 16px; }\n    @media screen and (max-width: 320px) {\n      .action-button button {\n        min-width: unset; } }\n  @media screen and (max-width: 767px) {\n    .action-button {\n      padding: 12px; }\n      .action-button button {\n        width: 50%; } }\n\n:host /deep/ .dialog-header .pull-left {\n  width: 100%;\n  padding: 15px 15px 0 15px; }\n  :host /deep/ .dialog-header .pull-left .dialog-title {\n    color: #061021;\n    font-size: 20px;\n    font-weight: 700; }\n\n:host /deep/ .dialog-wrapper-content {\n  padding: 0 !important;\n  min-height: unset !important; }\n\n:host /deep/ .close-box {\n  position: absolute;\n  right: 33px;\n  margin-top: 10px;\n  z-index: 3; }\n\n:host /deep/ .mat-dialog-content {\n  padding: 0px; }\n\n:host /deep/ .box-select-address {\n  width: 100%;\n  margin-top: 15px; }\n\n:host /deep/ .address-inner {\n  padding-bottom: 0; }\n\n@media screen and (max-width: 767px) {\n  :host /deep/ .dialog-container-budget {\n    width: auto;\n    padding: 30px 10px; }\n  :host /deep/ .action-button > * {\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    max-width: unset !important;\n    margin: 0 calc(15px / 2); } }\n\n:host /deep/ .dialog-confirm.center {\n  text-align: center; }\n  :host /deep/ .dialog-confirm.center img {\n    width: 100px;\n    margin-top: 24px; }\n  :host /deep/ .dialog-confirm.center .title {\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: bold;\n    margin-top: 8px; }\n  :host /deep/ .dialog-confirm.center .dialog-container {\n    padding: 8px 16px 24px !important;\n    line-height: 18px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.dialog-success-content {\n  text-align: center; }\n  .dialog-success-content .body-text {\n    margin: 15px 30px 30px; }\n  .dialog-success-content p:last-of-type {\n    margin-bottom: 30px; }\n  .dialog-success-content .box-success {\n    padding: 30px 0 0 !important;\n    margin: 0; }\n  .dialog-success-content .action-button {\n    padding: 15px;\n    border-top: 1px solid #DFE1E6;\n    padding-top: 15px;\n    text-align: right;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center; }\n  .dialog-success-content .ota-btn-main {\n    margin: 0;\n    width: 160px; }\n    @media screen and (max-width: 768px) {\n      .dialog-success-content .ota-btn-main {\n        background-color: unset;\n        color: #003a90;\n        line-height: unset;\n        height: unset; }\n        .dialog-success-content .ota-btn-main:hover, .dialog-success-content .ota-btn-main.touch {\n          background-color: unset; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.ota-btn-main {\n  margin: 0;\n  width: 160px; }\n  @media screen and (max-width: 768px) {\n    .ota-btn-main {\n      font-size: 16px;\n      background-color: unset;\n      color: #003a90;\n      line-height: unset;\n      height: unset; }\n      .ota-btn-main:hover, .ota-btn-main.touch {\n        background-color: unset; } }\n\np {\n  margin-bottom: 30px; }\n\n.title-text {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 20px;\n  margin-bottom: 10px; }\n  @media screen and (max-width: 768px) {\n    .title-text {\n      font-size: 16px; } }\n\nimg {\n  height: 60px; }\n\n.box-success {\n  margin: 30px 0 10px 0 !important; }\n\n.action-button {\n  padding: 15px;\n  border-top: 1px solid #DFE1E6;\n  padding-top: 15px;\n  text-align: right;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.box-content {\n  padding-left: 30px;\n  padding-right: 30px; }\n  @media screen and (max-width: 768px) {\n    .box-content {\n      padding-left: 15px;\n      padding-right: 15px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".section-content {\n  padding-bottom: 10px; }\n\n.title {\n  font-size: 20px;\n  font-weight: bold; }\n\n.sub-title {\n  font-size: 12px;\n  margin-bottom: 15px; }\n\n.remark {\n  height: 300px;\n  overflow-y: auto;\n  padding: 10px 0; }\n  .remark ul {\n    padding-left: 20px; }\n    .remark ul li {\n      list-style: disc;\n      font-size: 14px; }\n      .remark ul li > div {\n        word-break: break-word; }\n  @media (max-width: 575px) {\n    .remark {\n      height: 180px; } }\n\n.text-error {\n  margin-bottom: 5px; }\n\n.accept-condition {\n  padding: 10px 0; }\n  .accept-condition input {\n    margin-right: 5px; }\n\n.section-action {\n  position: absolute;\n  bottom: 15px;\n  left: 0;\n  right: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 15px 15px 0;\n  border-top: 1px solid #DFE1E6; }\n  @media screen and (max-width: 767px) {\n    .section-action {\n      padding: 15px 10px 0; } }\n  .section-action .ota-btn-main {\n    margin: 0;\n    font-size: 14px;\n    width: 160px; }\n    @media screen and (max-width: 767px) {\n      .section-action .ota-btn-main {\n        width: 100%; } }\n  .section-action .btn-cancel {\n    color: #003a90;\n    cursor: pointer; }\n    .section-action .btn-cancel:hover {\n      background-color: none;\n      text-decoration: underline; }\n  @media screen and (max-width: 767px) {\n    .section-action .btn-horizontal {\n      margin: 0 7.5px; } }\n\n:host /deep/ .dialog-information-cart .dialog-container .dialog-wrapper-content {\n  width: 700px;\n  padding: 20px 15px 65px; }\n  @media screen and (max-width: 767px) {\n    :host /deep/ .dialog-information-cart .dialog-container .dialog-wrapper-content {\n      width: 100%; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".btn-close-popup {\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  top: 15px;\n  right: 10px; }\n  .btn-close-popup img {\n    width: 100%; }\n\n.title {\n  font-size: 18px;\n  font-weight: 700;\n  padding: 15px 10px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border-bottom: 1px solid #dfe1e6;\n  margin-bottom: 15px; }\n\n.icon-close {\n  -moz-appearance: none;\n       appearance: none;\n  border: 0;\n  outline: 0;\n  background: none; }\n\n.active {\n  background-color: #e4edff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "act-map {\n  height: 100%;\n  position: absolute;\n  width: 100%; }\n\n.loading {\n  text-align: center; }\n\n.dialog-map-padding {\n  display: table-cell;\n  height: 100%;\n  position: relative; }\n\n.-hide {\n  display: none !important; }\n\n.marker-price {\n  white-space: nowrap; }\n\n@media screen and (max-width: 767px) {\n  .dialog-map-padding {\n    display: table-cell;\n    height: 100%;\n    position: relative; } }\n\n.info-window-mobile {\n  position: absolute !important;\n  z-index: 99;\n  bottom: 24px;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3); }\n\n:host /deep/ ota-dialog .title:has(.dialog-title) {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  max-width: 80vw;\n  padding-right: 31px;\n  margin: 0; }\n  @media screen and (max-width: 767px) {\n    :host /deep/ ota-dialog .title:has(.dialog-title) {\n      max-width: calc(100vw - 61px);\n      padding-right: 0; } }\n\n:host /deep/ ota-dialog .dialog-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  margin-right: 4px !important; }\n\n:host /deep/ act-map .pop-float-wrapper {\n  z-index: 1; }\n  :host /deep/ act-map .pop-float-wrapper:has(.-active) {\n    z-index: 2; }\n  :host /deep/ act-map .pop-float-wrapper:hover {\n    z-index: 3; }\n  :host /deep/ act-map .pop-float-wrapper:has(.pin) {\n    z-index: 0 !important; }\n  :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .pop-frame {\n    padding: 8px;\n    border: 0;\n    border-radius: 4px;\n    background-color: #E4EDFF;\n    color: #003A90; }\n    :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .pop-frame:not(:has(img)) {\n      box-shadow: 0px 0px 8px 0px rgba(0, 29, 72, 0.16); }\n    :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .pop-frame:hover {\n      cursor: pointer; }\n  :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .pop-pointer-border-top {\n    border: 0; }\n  :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .pop-pointer-bg-top {\n    border-width: 8px !important;\n    top: 0;\n    border-top-color: #E4EDFF; }\n  :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)):has(.-active) .pop-frame, :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)):hover .pop-frame {\n    background-color: #003A90;\n    color: #fff; }\n  :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)):has(.-active) .pop-pointer-bg-top, :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)):hover .pop-pointer-bg-top {\n    border-top-color: #003A90; }\n\n:host /deep/ act-map .info-marker-float-wrapper {\n  z-index: 1; }\n  :host /deep/ act-map .info-marker-float-wrapper:has(.-active) {\n    z-index: 2; }\n  :host /deep/ act-map .info-marker-float-wrapper:has(.pin) {\n    z-index: 0 !important; }\n  :host /deep/ act-map .info-marker-float-wrapper .info-marker-frame {\n    padding: 8px;\n    border: 0;\n    border-radius: 4px;\n    background-color: #E4EDFF;\n    color: #003A90; }\n    :host /deep/ act-map .info-marker-float-wrapper .info-marker-frame:not(:has(img)) {\n      box-shadow: 0px 0px 8px 0px rgba(0, 29, 72, 0.16); }\n  :host /deep/ act-map .info-marker-float-wrapper .info-marker-pointer-border-top {\n    border: 0; }\n  :host /deep/ act-map .info-marker-float-wrapper .info-marker-pointer-bg-top {\n    border-width: 8px !important;\n    top: 0;\n    border-top-color: #E4EDFF; }\n  :host /deep/ act-map .info-marker-float-wrapper:has(.-active) .info-marker-frame, :host /deep/ act-map .info-marker-float-wrapper:hover .info-marker-frame {\n    background-color: #003A90;\n    color: #fff; }\n    :host /deep/ act-map .info-marker-float-wrapper:has(.-active) .info-marker-frame:hover, :host /deep/ act-map .info-marker-float-wrapper:hover .info-marker-frame:hover {\n      cursor: pointer; }\n  :host /deep/ act-map .info-marker-float-wrapper:has(.-active) .info-marker-pointer-bg-top, :host /deep/ act-map .info-marker-float-wrapper:hover .info-marker-pointer-bg-top {\n    border-top-color: #003A90; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.info-window {\n  background: white;\n  width: 360px;\n  padding: 12px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  gap: 16px; }\n  .info-window .info-window-image {\n    display: table-cell;\n    width: 80px; }\n    .info-window .info-window-image img {\n      width: 80px;\n      height: 80px;\n      border-radius: 4px;\n      object-fit: cover; }\n  .info-window .info-window-content {\n    position: relative;\n    font-size: 12px;\n    width: 240px; }\n    .info-window .info-window-content .info-window-title {\n      font-weight: bold;\n      font-size: 16px;\n      line-height: 20px;\n      margin-bottom: 5px;\n      max-height: 40px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: normal;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      /* autoprefixer: off */\n      -webkit-box-orient: vertical;\n      /* autoprefixer: on */ }\n  @media screen and (max-width: 767px) {\n    .info-window {\n      width: 85vw; } }\n\n.hotel-review-score {\n  position: static;\n  text-align: left;\n  width: 100%;\n  padding-top: 2px;\n  display: block;\n  border-left: 1px solid #dfe1e6;\n  margin: 0 5px 0 0;\n  display: inline; }\n  .hotel-review-score div {\n    display: inline; }\n  .hotel-review-score .review-score-title-s {\n    line-height: 1.4;\n    font-size: 12px;\n    line-height: 1.4;\n    font-weight: 400;\n    color: #042764;\n    display: inline-block;\n    margin-left: 5px; }\n    .hotel-review-score .review-score-title-s .font-20px {\n      font-size: 12px; }\n  .hotel-review-score .review-score {\n    display: inline-block;\n    text-align: center;\n    background-color: #e4edff;\n    border-radius: 10%;\n    padding: 2px 6px;\n    line-height: 1.4;\n    font-size: 12px;\n    font-weight: 600;\n    color: #042764;\n    line-height: 1.5;\n    margin-left: 5px; }\n    .hotel-review-score .review-score .font-20px {\n      font-size: 12px; }\n\n.info-window:hover {\n  cursor: pointer; }\n\n.icon-star-level-s {\n  width: 16px;\n  height: 16px;\n  margin-right: 2px; }\n\n.icon-star-level-s.-half {\n  width: 8px;\n  height: unset; }\n\n.btn-navigate {\n  padding: 10px;\n  background-color: white;\n  text-align: center;\n  color: #003a90;\n  border-top: 1px solid #dfe1e6; }\n  .btn-navigate .icon-navigation {\n    font-size: 16px;\n    color: #003a90;\n    margin-right: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "act-map {\n  height: 100%;\n  position: absolute;\n  width: 100%; }\n\n.loading {\n  text-align: center; }\n\n.dialog-map-padding {\n  display: table-cell;\n  height: 100%;\n  position: relative; }\n\n.-hide {\n  display: none !important; }\n\n.marker-price {\n  white-space: nowrap; }\n\n@media screen and (max-width: 767px) {\n  .dialog-map-padding {\n    display: table-cell;\n    height: 100%;\n    position: relative; } }\n\n.info-window-mobile {\n  position: absolute !important;\n  z-index: 99;\n  bottom: 24px;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3); }\n\n:host /deep/ ota-dialog .title:has(.dialog-title) {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  max-width: 80vw;\n  padding-right: 31px;\n  margin: 0; }\n  @media screen and (max-width: 767px) {\n    :host /deep/ ota-dialog .title:has(.dialog-title) {\n      max-width: calc(100vw - 61px);\n      padding-right: 0; } }\n\n:host /deep/ ota-dialog .dialog-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  margin-right: 4px !important; }\n\n:host /deep/ act-map .pop-float-wrapper, :host /deep/ act-map .info-marker-float-wrapper {\n  z-index: 1; }\n  :host /deep/ act-map .pop-float-wrapper:has(.-active), :host /deep/ act-map .info-marker-float-wrapper:has(.-active) {\n    z-index: 2; }\n  :host /deep/ act-map .pop-float-wrapper:hover, :host /deep/ act-map .info-marker-float-wrapper:hover {\n    z-index: 3; }\n  :host /deep/ act-map .pop-float-wrapper:has(.pin), :host /deep/ act-map .info-marker-float-wrapper:has(.pin) {\n    z-index: 0 !important; }\n  :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .pop-frame, :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .info-marker-frame, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)) .pop-frame, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)) .info-marker-frame {\n    padding: 8px;\n    border: 0;\n    border-radius: 4px;\n    background-color: #E4EDFF;\n    color: #003A90; }\n    :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .pop-frame:not(:has(img)), :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .info-marker-frame:not(:has(img)), :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)) .pop-frame:not(:has(img)), :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)) .info-marker-frame:not(:has(img)) {\n      box-shadow: 0px 0px 8px 0px rgba(0, 29, 72, 0.16); }\n    :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .pop-frame:hover, :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .info-marker-frame:hover, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)) .pop-frame:hover, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)) .info-marker-frame:hover {\n      cursor: pointer; }\n  :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .pop-pointer-border-top, :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .info-marker-pointer-border-top, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)) .pop-pointer-border-top, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)) .info-marker-pointer-border-top {\n    border: 0; }\n  :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .pop-pointer-bg-top, :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)) .info-marker-pointer-bg-top, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)) .pop-pointer-bg-top, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)) .info-marker-pointer-bg-top {\n    border-width: 8px !important;\n    top: 0;\n    border-top-color: #E4EDFF; }\n  :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)):has(.-active) .pop-frame, :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)):has(.-active) .info-marker-frame, :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)):hover .pop-frame, :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)):hover .info-marker-frame, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)):has(.-active) .pop-frame, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)):has(.-active) .info-marker-frame, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)):hover .pop-frame, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)):hover .info-marker-frame {\n    background-color: #003A90;\n    color: #fff; }\n  :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)):has(.-active) .pop-pointer-bg-top, :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)):has(.-active) .info-marker-pointer-bg-top, :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)):hover .pop-pointer-bg-top, :host /deep/ act-map .pop-float-wrapper:not(:has(act-info-window-content)):hover .info-marker-pointer-bg-top, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)):has(.-active) .pop-pointer-bg-top, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)):has(.-active) .info-marker-pointer-bg-top, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)):hover .pop-pointer-bg-top, :host /deep/ act-map .info-marker-float-wrapper:not(:has(act-info-window-content)):hover .info-marker-pointer-bg-top {\n    border-top-color: #003A90; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".dialog-map-padding {\n  display: table-cell;\n  height: 100%;\n  position: relative; }\n\n@media screen and (max-width: 767px) {\n  .dialog-map-padding {\n    display: table-cell;\n    height: 100%;\n    position: relative; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".tc-container .tc-item {\n  display: -ms-flexbox;\n  display: flex; }\n  .tc-container .tc-item:first-child {\n    padding: 10px 10px 0 !important; }\n  .tc-container .tc-item:not(:first-child) {\n    padding: 10px 10px 10px; }\n  .tc-container .tc-item:last-child {\n    color: #042764;\n    border-top: dotted 1px #042764;\n    background-color: #F6F8F9;\n    border-radius: 0 0 5px 5px; }\n  .tc-container .tc-item div,\n  .tc-container .tc-item div strong {\n    display: inline-block; }\n    .tc-container .tc-item div:nth-child(2),\n    .tc-container .tc-item div strong,\n    .tc-container .tc-item div strong:nth-child(2),\n    .tc-container .tc-item div strong strong {\n      margin-left: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.dialog-alert-content {\n  text-align: center; }\n\n.alert-img {\n  display: block;\n  height: 60px;\n  width: 100px;\n  margin: 0 auto;\n  margin-bottom: 15px; }\n\n.alert-text {\n  color: #061021;\n  font-size: 16px;\n  margin-bottom: 30px; }\n\n.ota-btn-main {\n  width: 173px;\n  margin-bottom: 0; }\n  @media screen and (max-width: 767px) {\n    .ota-btn-main {\n      width: 100%; } }\n\n@media screen and (max-width: 767px) {\n  .dialog-alert .dialog-container .dialog-wrapper-content {\n    padding: 40px 30px 20px 30px !important;\n    min-height: 226px; } }\n\n@media screen and (max-width: 767px) {\n  .ota-checkbox {\n    padding: 3px 0px 0px 0px;\n    text-align: left; } }\n\n.ota-checkbox [type=\"checkbox\"]:not(:checked) + label, .ota-checkbox [type=\"checkbox\"]:checked + label {\n  position: relative;\n  padding-left: 25px;\n  cursor: pointer;\n  width: auto;\n  color: #061021;\n  font-weight: normal;\n  line-height: 33px;\n  margin-bottom: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.ota-checkbox:hover, .ota-checkbox.active {\n  background-color: transparent; }\n\n.content-mobile {\n  padding: 30px 0 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ":host /deep/ .dialog-wrapper-content {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: 100vh; }\n  :host /deep/ .dialog-wrapper-content .dialog-header {\n    display: none; }\n\n:host /deep/ .phone-input-group {\n  display: -ms-flexbox;\n  display: flex; }\n  :host /deep/ .phone-input-group act-icon-dropdown .dropdown-ota-style {\n    min-width: 104px;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    background-position: calc(100% - 12px) center;\n    padding: 0 12px; }\n  :host /deep/ .phone-input-group act-icon-dropdown:has(.open) {\n    z-index: 2; }\n  :host /deep/ .phone-input-group input {\n    z-index: 1;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    margin-left: -1px; }\n    :host /deep/ .phone-input-group input.input-error {\n      z-index: 1;\n      margin-left: -1px;\n      height: 40px; }\n\n.title {\n  font-size: 20px;\n  line-height: 24px;\n  font-weight: bold; }\n\n.sub-title {\n  margin-top: 2px;\n  line-height: 18px; }\n\n.content {\n  margin-top: 24px; }\n\n.dialog-content {\n  padding: 24px 12px !important;\n  overflow: auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-positive: 1;\n      flex-grow: 1; }\n\n.content-container {\n  height: 100%; }\n\n.action-button {\n  padding: 12px;\n  border-top: 1px solid #DFE1E6;\n  text-align: center;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  gap: 12px; }\n  .action-button.space {\n    -ms-flex-positive: 1;\n        flex-grow: 1; }\n  .action-button button {\n    max-width: 180px;\n    margin-bottom: 0; }\n  .action-button .ota-btn-main:disabled {\n    background-color: #DFE1E6;\n    color: #A5ADBA; }\n\n@media screen and (min-width: 768px) {\n  :host /deep/ .dialog-wrapper-content {\n    height: unset;\n    width: 480px !important;\n    min-height: 400px !important;\n    padding: 0 !important; }\n    :host /deep/ .dialog-wrapper-content .dialog-header {\n      display: block;\n      position: absolute;\n      right: 33px; }\n      :host /deep/ .dialog-wrapper-content .dialog-header .close-box {\n        margin-top: 28px; }\n  .dialog-content {\n    height: unset;\n    padding: 24px 16px !important; }\n  .action-button {\n    padding: 12px 16px;\n    gap: 16px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ":host /deep/ .dialog-wrapper-content {\n  padding: 0 !important;\n  min-height: unset !important;\n  max-height: 100vh;\n  overflow-y: hidden; }\n\n.dialog-content {\n  padding: 24px 16px;\n  text-align: center;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  gap: 8px; }\n  .dialog-content .alert-img {\n    display: block;\n    height: 60px;\n    width: 100px;\n    margin: 0 auto; }\n  .dialog-content .title {\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: bold; }\n\n.dialog-footer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 12px 16px;\n  -ms-flex-align: center;\n      align-items: center;\n  border-top: 1px solid #DFE1E6; }\n  .dialog-footer .ota-btn-main {\n    margin: 0;\n    width: 99px; }\n  .dialog-footer .text-link {\n    float: right;\n    color: #003A90; }\n    .dialog-footer .text-link:hover {\n      text-decoration: underline;\n      cursor: pointer; }\n\n@media screen and (max-width: 767px) {\n  .dialog-footer {\n    gap: 16px; }\n    .dialog-footer .ota-btn-sub {\n      height: 44px; }\n    .dialog-footer .ota-btn-main {\n      width: 100%;\n      height: 44px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ":host /deep/ .dialog-pin .dialog-wrapper-content {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: 100vh; }\n  :host /deep/ .dialog-pin .dialog-wrapper-content .dialog-header {\n    display: none; }\n\n:host /deep/ .dialog-pin .dialog-btn-film {\n  display: none !important; }\n\n.dialog-content {\n  padding: 24px 12px !important;\n  overflow: auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-positive: 1;\n      flex-grow: 1; }\n\n.content-container {\n  height: 100%; }\n\n.action-button {\n  padding: 12px;\n  border-top: 1px solid #DFE1E6;\n  text-align: center;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  gap: 12px; }\n  .action-button.space {\n    -ms-flex-positive: 1;\n        flex-grow: 1; }\n  .action-button button {\n    max-width: 180px;\n    margin-bottom: 0; }\n  .action-button .ota-btn-main:disabled {\n    background-color: #DFE1E6;\n    color: #A5ADBA; }\n  .action-button a:hover {\n    text-decoration: underline;\n    cursor: pointer; }\n\n@media screen and (min-width: 768px) {\n  :host /deep/ .dialog-pin .dialog-wrapper-content {\n    height: unset;\n    width: 480px !important;\n    min-height: 400px !important;\n    padding: 0 !important; }\n    :host /deep/ .dialog-pin .dialog-wrapper-content .dialog-header {\n      display: block;\n      position: absolute;\n      right: 33px; }\n      :host /deep/ .dialog-pin .dialog-wrapper-content .dialog-header .close-box {\n        margin-top: 28px; }\n  .dialog-content {\n    height: unset;\n    padding: 24px 16px !important; }\n  .action-button {\n    padding: 12px 16px;\n    gap: 16px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ":host {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-positive: 1;\n      flex-grow: 1; }\n\n.title {\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: bold; }\n\n.container-content {\n  margin-top: 24px;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 0;\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  .container-content .form-group {\n    color: #061021;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n        flex-direction: row;\n    -ms-flex-align: center;\n        align-items: center;\n    column-gap: 8px;\n    font-size: 20px;\n    line-height: 24px;\n    margin: 0; }\n    .container-content .form-group label {\n      font-size: 14px;\n      line-height: 18px;\n      margin-bottom: 4px; }\n    .container-content .form-group input {\n      height: 40px;\n      width: 100%;\n      border: 1px solid #DFE1E6;\n      border-radius: 4px;\n      text-align: center;\n      font-weight: bold;\n      font-size: 26px;\n      -webkit-text-stroke-width: 2px; }\n      .container-content .form-group input:focus {\n        border: 1px solid #003A90;\n        box-shadow: 0px 0px 4px 0px #85B6FF;\n        outline: none; }\n  .container-content .message {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    margin-top: 8px; }\n  .container-content .text-link {\n    color: #003A90; }\n    .container-content .text-link:hover {\n      text-decoration: underline;\n      cursor: pointer; }\n  .container-content .error {\n    margin-top: 8px;\n    color: #ED1C24;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: start;\n        align-items: flex-start; }\n    .container-content .error .icon-warning {\n      margin-top: 2px;\n      font-size: 12px;\n      margin-right: 5px; }\n    .container-content .error .error-text {\n      font-size: 12px;\n      line-height: 17px;\n      word-break: break-word; }\n  .container-content .text-link {\n    color: #003A90; }\n    .container-content .text-link:hover {\n      text-decoration: underline;\n      cursor: pointer; }\n  .container-content .text-link-disable {\n    color: #A5ADBA; }\n    .container-content .text-link-disable:hover {\n      text-decoration: unset;\n      cursor: auto; }\n  .container-content .forgot-pin {\n    margin-top: auto; }\n\n@media screen and (min-width: 768px) {\n  .title {\n    font-size: 20px;\n    line-height: 24px; } }\n\n/* Make input type number not show Arrow in Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0; }\n\n/* Make input type number not show Arrow in Firefox */\ninput[type=number] {\n  -moz-appearance: textfield; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".mice-form {\n  display: block !important; }\n  .mice-form .dialog-service-chioce {\n    max-width: 60vw;\n    margin: 0 auto;\n    height: auto;\n    background: #FFFFFF;\n    padding: 15px 30px 30px;\n    max-width: 750px; }\n    .mice-form .dialog-service-chioce .dialog-wrapper-content {\n      color: #061021 important; }\n      .mice-form .dialog-service-chioce .dialog-wrapper-content .close-box {\n        float: right;\n        width: 100%;\n        position: relative;\n        margin-bottom: 10px; }\n    .mice-form .dialog-service-chioce .form-pop-title {\n      font-weight: bold;\n      font-size: 20px;\n      margin: 0 0 5px 0 !important; }\n    .mice-form .dialog-service-chioce .form-pop-subtitle {\n      font-size: 14px; }\n    .mice-form .dialog-service-chioce .ota-btn-main {\n      border-radius: 2px;\n      min-width: 220px;\n      width: auto;\n      margin: 0 auto;\n      display: block;\n      font-size: 16px; }\n\n.mb-0 {\n  margin: 0px; }\n\n.mb-30 {\n  margin-bottom: 30px; }\n\n.form-wrapper {\n  margin-bottom: 30px; }\n  .form-wrapper:nth-child(4) {\n    margin-bottom: 15px; }\n  .form-wrapper h3 {\n    font-size: 16px;\n    margin-top: 0;\n    margin-bottom: 15px; }\n  .form-wrapper .row {\n    margin: 0 -7.5px; }\n    .form-wrapper .row [class*=\"col-\"] {\n      padding: 0 7.5px; }\n  .form-wrapper small {\n    display: block;\n    margin-top: 5px;\n    font-size: 12px; }\n    .form-wrapper small.text-sub-title {\n      color: #6b778c; }\n  .form-wrapper .form-group .ota-input-text {\n    margin: 0; }\n\n.-form-map {\n  position: relative; }\n  .-form-map input[type=\"text\"] {\n    padding-left: 35px; }\n  .-form-map:before {\n    font-family: \"ota-icons\";\n    content: \"\";\n    background: url(\"/assets/images/icons/icon-pin.svg\") no-repeat center;\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    left: 12px;\n    top: 8px;\n    color: #061021; }\n\n.-form-calendar {\n  position: relative; }\n  .-form-calendar input[type=\"text\"] {\n    padding-left: 35px; }\n  .-form-calendar:before {\n    font-family: \"ota-icons\";\n    content: \"\";\n    background: url(\"/assets/images/icons/Date.png\") no-repeat center;\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    left: 12px;\n    top: 8px;\n    color: #061021; }\n\n.description {\n  color: #6b778c; }\n\n:host /deep/ .mat-dialog-content .calendar-icon {\n  display: none; }\n\n@media (max-width: 736px) {\n  :host /deep/ .mat-dialog-content {\n    padding: 15px !important;\n    pointer-events: unset !important; }\n    :host /deep/ .mat-dialog-content .dialog-container {\n      top: 3px; } }\n\n:host /deep/ .calendar-icon {\n  display: none; }\n\n@media (max-width: 768px) {\n  .dialog-service-chioce .dialog-wrapper-content {\n    min-width: inherit;\n    width: 100% !important; } }\n\n@media (max-width: 480px) {\n  .mat-dialog-container .dialog-container .dialog-wrapper-content {\n    padding: 10px; }\n  .mat-dialog-container .dialog-container .close-box .icon-close {\n    margin: 0; }\n  .mice-form .dialog-service-chioce {\n    margin-bottom: 70px;\n    max-width: 100vw;\n    padding: 15px 18px 10px;\n    min-width: 0px; }\n    .mice-form .dialog-service-chioce .dialog-wrapper-content .pull-right {\n      right: 0px;\n      position: relative; }\n    .mice-form .dialog-service-chioce .dialog-wrapper-content .ota-btn-main {\n      width: 100%; }\n  .form-wrapper:nth-child(4) {\n    margin-bottom: 0px; }\n  .dialog-sent-success .dialog-wrapper-content .ota-btn-main {\n    min-width: 180px;\n    width: 100%; } }\n\n.pull-right {\n  right: -15px;\n  position: relative; }\n  .pull-right .icon-close {\n    margin: 0;\n    font-size: 20px;\n    color: #D1D1D1; }\n\n.clearfix::after {\n  content: \"\";\n  clear: both;\n  display: table; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".description {\n  word-break: break-word; }\n\n:host /deep/ .dialog-room-note-description .description {\n  word-break: break-word;\n  font-size: 14px;\n  line-height: 16px;\n  color: #061021; }\n  :host /deep/ .dialog-room-note-description .description ul {\n    padding-inline-start: 15px; }\n  :host /deep/ .dialog-room-note-description .description li {\n    list-style-type: disc; }\n  :host /deep/ .dialog-room-note-description .description p {\n    margin: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".title {\n  margin-top: -20px;\n  color: #061021;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 28px;\n  margin-bottom: 15px; }\n  @media screen and (max-width: 767px) {\n    .title {\n      margin-top: 0;\n      font-size: 16px;\n      line-height: 20px; } }\n\n.item {\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 8px; }\n  .item .fa {\n    font-size: 5px;\n    color: #061021;\n    padding-top: 6px;\n    margin-right: 8px; }\n  .item:last-child {\n    margin-bottom: 0; }\n\n.content {\n  width: 100%; }\n\n.name {\n  word-break: break-word;\n  font-size: 14px;\n  color: #061021;\n  line-height: 16px;\n  margin-bottom: 5px; }\n\n:host /deep/ .dialog-room-note .item-wrapper {\n  max-height: 70vh;\n  overflow-y: auto; }\n  @media screen and (max-width: 767px) {\n    :host /deep/ .dialog-room-note .item-wrapper {\n      max-height: 80vh; } }\n\n:host /deep/ .dialog-room-note .description {\n  word-break: break-word;\n  font-size: 12px;\n  line-height: 14px;\n  color: #061021; }\n  :host /deep/ .dialog-room-note .description p {\n    margin: 0; }\n  :host /deep/ .dialog-room-note .description ul {\n    padding-inline-start: 15px; }\n  :host /deep/ .dialog-room-note .description li {\n    list-style-type: disc; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".dialog-see-all-properties-wrapper-tooltips .dialog-see-all-properties-wrapper {\n  position: relative;\n  background-color: #FFFFFF;\n  width: 100%;\n  height: 200px;\n  padding: 20px 10px; }\n  .dialog-see-all-properties-wrapper-tooltips .dialog-see-all-properties-wrapper .footer-close-btn {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 10px 0;\n    border-top: 1px solid #dfe1e6;\n    color: #042764; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ":host /deep/ .dialog-wrapper-content {\n  padding: 0px !important;\n  min-height: unset !important;\n  width: auto !important; }\n\n.box-detail .title {\n  padding: 20px 10px 5px;\n  font-weight: bold;\n  color: #042764; }\n\n.box-detail .row {\n  margin: 0;\n  padding: 10px 20px; }\n  .box-detail .row:first-child {\n    padding: 0; }\n  .box-detail .row:nth-last-child(2) {\n    padding: 10px;\n    color: #042764 !important; }\n  .box-detail .row:last-child {\n    border-top: 1px solid #DFE1E6; }\n  .box-detail .row span {\n    color: #6b778c !important; }\n  .box-detail .row .row-summary {\n    padding: 10px;\n    background-color: #F6F8F9; }\n  .box-detail .row .btn-close {\n    text-align: center; }\n  .box-detail .row .co-budget-note {\n    font-size: 14px;\n    line-height: 18px;\n    color: #ed1c24; }\n\n.box-detail .col-xs-12,\n.box-detail .col-xs-8,\n.box-detail .col-xs-4 {\n  padding: 0; }\n\n.box-detail .col-xs-4 {\n  text-align: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".form-group {\n  margin-bottom: 0; }\n\n.form-control {\n  margin-top: 5px; }\n\n.sub-text {\n  margin: 5px 15px; }\n  .sub-text span {\n    font-size: 12px;\n    color: #6b778c; }\n  .sub-text .copy-link {\n    margin-left: 5px;\n    display: inline;\n    cursor: pointer; }\n    .sub-text .copy-link i {\n      font-size: 12px;\n      color: #003a90; }\n    .sub-text .copy-link span {\n      color: #003a90; }\n      .sub-text .copy-link span:hover {\n        color: #042764;\n        text-decoration: underline; }\n  .sub-text.copied i {\n    margin-left: 5px;\n    color: #4aad5d; }\n  .sub-text.copied .copy-link-to-clipboard {\n    color: #4aad5d; }\n\n.box-title .title {\n  font-size: 20px;\n  font-weight: bold; }\n\n.box-detail {\n  margin-top: 5px; }\n\n.box-code-ref {\n  margin-top: 20px; }\n  .box-code-ref .form-control.ota-input-error {\n    margin-bottom: 0; }\n  .box-code-ref .code-ref-title {\n    display: inline; }\n  .box-code-ref .change-code-ref {\n    color: #003a90;\n    cursor: pointer;\n    display: inline;\n    font-size: 12px; }\n    .box-code-ref .change-code-ref:hover {\n      background-color: none;\n      text-decoration: underline; }\n  .box-code-ref .icon-lock {\n    position: absolute;\n    top: 36px;\n    left: 206px; }\n  .box-code-ref .input-code-ref {\n    width: 30%; }\n    @media screen and (max-width: 767px) {\n      .box-code-ref .input-code-ref {\n        width: 100%; } }\n\n.box-co-booker-company {\n  margin-top: 10px; }\n\n.box-co-booker-company-address {\n  margin-top: 15px; }\n  .box-co-booker-company-address .address {\n    border-radius: 4px;\n    border: 1px solid #DFE1E6;\n    background: #f5f5f5;\n    height: 74px;\n    margin-top: 5px;\n    padding: 6px 12px;\n    overflow-y: auto; }\n    @media screen and (max-width: 767px) {\n      .box-co-booker-company-address .address {\n        height: 113px; } }\n\n.row-action {\n  position: absolute;\n  bottom: 15px;\n  width: 100%; }\n  .row-action .action {\n    text-align: center;\n    border-top: 1px solid #DFE1E6; }\n    .row-action .action .btn-horizontal {\n      margin-top: 15px;\n      width: 160px;\n      font-size: 14px; }\n      .row-action .action .btn-horizontal.ota-btn-sub {\n        width: 0px;\n        border: none;\n        float: left;\n        background-color: #FFFFFF;\n        margin-left: 15px;\n        text-align: left;\n        color: #003a90;\n        cursor: pointer; }\n        .row-action .action .btn-horizontal.ota-btn-sub:hover {\n          background-color: none;\n          text-decoration: underline; }\n      .row-action .action .btn-horizontal.ota-btn-main {\n        float: right;\n        margin-right: 15px;\n        margin-bottom: 0px; }\n\n.cal-height {\n  overflow-x: hidden;\n  height: calc(var(--height-vh, 1vh) * 100 - 100px) !important; }\n\n@media screen and (max-width: 767px) {\n  :host /deep/ .mat-dialog-content {\n    padding: 0px !important; }\n  .cal-height {\n    overflow-y: scroll; }\n  .row-action {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: calc(var(--height-vh, 1vh) * 100 - 80px) !important;\n    bottom: 0;\n    margin: 0;\n    margin-top: 10px; }\n    .row-action .action .btn-horizontal {\n      width: calc(50% - 22.5px) !important; }\n      .row-action .action .btn-horizontal.ota-btn-sub {\n        margin-left: 15px !important;\n        text-align: center !important;\n        color: #061021 !important;\n        border: 1px solid #DFE1E6; }\n  .box-code-ref .icon-lock {\n    left: unset;\n    right: 22px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".cdk-overlay-container {\n  z-index: 2147483634; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.dialog-success-content {\n  text-align: center; }\n  .dialog-success-content .body-text {\n    margin: 15px 30px 30px; }\n  .dialog-success-content .box-success {\n    padding: 30px 0 0 !important;\n    margin: 0; }\n  .dialog-success-content .action-button {\n    padding: 15px;\n    border-top: 1px solid #DFE1E6;\n    padding-top: 15px;\n    text-align: right;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center; }\n  .dialog-success-content .ota-btn-main {\n    margin: 0;\n    width: 160px; }\n    @media screen and (max-width: 768px) {\n      .dialog-success-content .ota-btn-main {\n        background-color: unset;\n        color: #003a90;\n        line-height: unset;\n        height: unset; }\n        .dialog-success-content .ota-btn-main:hover, .dialog-success-content .ota-btn-main.touch {\n          background-color: unset; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "a {\n  color: #042764; }\n  a:hover {\n    text-decoration: underline; }\n\n.title {\n  color: #061021;\n  font-size: 20px;\n  font-weight: 700; }\n\n.dialog-container {\n  padding: 42px 15px 15px 15px !important; }\n\n.action-button {\n  padding: 15px;\n  border-top: 1px solid #DFE1E6;\n  padding-top: 15px;\n  text-align: right;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center; }\n  .action-button button {\n    max-width: 180px;\n    margin-bottom: 0; }\n\n:host /deep/ .dialog-header .pull-left {\n  width: 100%;\n  padding: 15px 15px 0 15px; }\n  :host /deep/ .dialog-header .pull-left .dialog-title {\n    color: #061021;\n    font-size: 20px;\n    font-weight: 700; }\n\n:host /deep/ .dialog-wrapper-content {\n  width: 750px !important;\n  padding: 0 !important;\n  min-height: unset !important; }\n\n:host /deep/ .close-box {\n  position: absolute;\n  right: 33px;\n  margin-top: 10px;\n  z-index: 4; }\n  :host /deep/ .close-box .icon-close.button {\n    color: #6b778c; }\n\n:host /deep/ .mat-dialog-content {\n  padding: 0px !important; }\n\n:host /deep/ .box-select-address {\n  width: 100% !important;\n  margin-top: 15px !important; }\n\n:host /deep/ .address-inner {\n  padding-bottom: 0 !important; }\n\n@media screen and (max-width: 767px) {\n  :host /deep/ .box-select-address {\n    border: none !important;\n    background: none !important; }\n    :host /deep/ .box-select-address .address-inner {\n      padding: 0 !important;\n      margin: 0 !important; }\n  :host /deep/ .dialog-header .close-box {\n    right: 15px;\n    margin-top: 12px; }\n  :host /deep/ .dialog-header .pull-left {\n    border-bottom: 1px solid #DFE1E6;\n    padding: 15px;\n    margin-bottom: 15px; }\n    :host /deep/ .dialog-header .pull-left .dialog-title {\n      color: #061021;\n      font-size: 16px;\n      font-weight: 700; }\n  :host /deep/ .dialog-wrapper-content {\n    width: 100% !important;\n    padding: 0px !important;\n    height: 100vh !important;\n    overflow-y: scroll; }\n    :host /deep/ .dialog-wrapper-content .dialog-container {\n      padding: 53px 10px 10px 10px !important; }\n  :host /deep/ .action-button {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 15px calc(15px / 2); }\n    :host /deep/ .action-button > * {\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n      max-width: unset !important;\n      margin: 0 calc(15px / 2); } }\n\n@media screen and (max-width: 767px) {\n  .title {\n    color: #061021;\n    font-size: 16px;\n    font-weight: 700; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".box {\n  padding: 0 15px 10px; }\n  .box .icon-close2 {\n    border: 0;\n    outline: 0;\n    color: #DFE1E6;\n    font-size: 16px !important;\n    padding: 0 !important;\n    top: 5px;\n    float: right;\n    -moz-appearance: none;\n         appearance: none;\n    background: none;\n    position: relative; }\n    .box .icon-close2:hover {\n      color: #959595; }\n  @media screen and (max-width: 768px) {\n    .box {\n      padding: 10px; } }\n\n.title-terms {\n  font-size: 20px;\n  font-weight: 600;\n  display: inline; }\n  .title-terms.topup-head {\n    margin: 15px 0; }\n  @media screen and (max-width: 768px) {\n    .title-terms {\n      font-size: 16px;\n      text-align: left; } }\n\n.terms-and-conditions-privacy {\n  max-height: 320px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  text-align: left;\n  padding: 0 15px; }\n  @media screen and (max-width: 768px) {\n    .terms-and-conditions-privacy {\n      padding: 0 10px; }\n      .terms-and-conditions-privacy.full {\n        min-height: calc(var(--dialog-filter-vh, 1vh) * 100 - 60px) !important;\n        max-height: calc(var(--dialog-filter-vh, 1vh) * 100 - 60px) !important; }\n      .terms-and-conditions-privacy.un-full {\n        min-height: calc(var(--dialog-filter-vh, 1vh) * 100 - var(--footer-height) - var(--title-height) - 20px) !important;\n        max-height: calc(var(--dialog-filter-vh, 1vh) * 100 - var(--footer-height) - var(--title-height) - 20px) !important; } }\n\n.tac-footer {\n  padding: 15px 15px 0;\n  border-top: 1px solid #DFE1E6; }\n\n.button-wrapper {\n  text-align: right; }\n\n.tac-btn {\n  margin: 0;\n  cursor: pointer;\n  max-width: 180px; }\n  @media screen and (max-width: 768px) {\n    .tac-btn {\n      max-width: 100%; } }\n\n:host /deep/ .dialog-terms-and-conditions {\n  cursor: default; }\n  :host /deep/ .dialog-terms-and-conditions .close-box {\n    height: 15px; }\n    :host /deep/ .dialog-terms-and-conditions .close-box .pull-right {\n      right: 30px;\n      position: absolute; }\n  @media screen and (min-width: 767px) {\n    :host /deep/ .dialog-terms-and-conditions .loading-wrapper {\n      width: 680px; } }\n\n:host /deep/ .dialog-wrapper-content {\n  padding: 0 0 15px 0 !important; }\n  :host /deep/ .dialog-wrapper-content .dialog-header {\n    padding: 15px 30px 0; }\n    @media screen and (max-width: 768px) {\n      :host /deep/ .dialog-wrapper-content .dialog-header {\n        padding: 5px 5px 0; } }\n\n@media screen and (max-width: 768px) {\n  :host /deep/ .dialog-terms-and-conditions {\n    padding: 0 !important; }\n    :host /deep/ .dialog-terms-and-conditions .dialog-wrapper-content {\n      height: 100vh;\n      min-width: 100vw; }\n      :host /deep/ .dialog-terms-and-conditions .dialog-wrapper-content .dwc-overflow {\n        min-height: calc(var(--dialog-filter-vh, 1vh) * 100 - 35px) !important;\n        max-height: calc(var(--dialog-filter-vh, 1vh) * 100 - 35px) !important; }\n    :host /deep/ .dialog-terms-and-conditions .close-box {\n      height: 25px; }\n      :host /deep/ .dialog-terms-and-conditions .close-box .pull-right {\n        top: 15px;\n        right: 15px; }\n  :host /deep/ .dialog-container,\n  :host /deep/ .dialog-wrapper-content {\n    height: 100%; } }\n\n.purposes {\n  margin-bottom: 15px; }\n\n.purpose {\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 5px; }\n  .purpose .checkbox-wrapper {\n    width: 15px;\n    margin-right: 10px; }\n    .purpose .checkbox-wrapper input {\n      margin-top: 0px; }\n  .purpose .text {\n    color: #061021;\n    font-size: 12px;\n    line-height: 17px;\n    font-weight: normal; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n:host {\n  display: -ms-flexbox;\n  display: flex; }\n\n.lock-background {\n  pointer-events: none; }\n\n.unlock-background {\n  pointer-events: auto; }\n\n.dialog-container .close-bottom {\n  background-color: #FFFFFF;\n  border: none;\n  width: 100%;\n  padding: 10px;\n  text-align: center; }\n\n.dialog-confirm .dialog-container .dialog-wrapper-content {\n  min-height: auto;\n  min-height: initial; }\n\n.dialog-delete .dialog-container .dialog-wrapper-content {\n  min-height: auto;\n  min-height: initial; }\n\n.dialog-msg .dialog-container .dialog-wrapper-content {\n  padding: 0;\n  min-height: unset; }\n\n@media screen and (max-width: 767px) {\n  .dialog-alert {\n    padding-top: 120px !important; } }\n\n.dialog-alert .dialog-container .dialog-wrapper-content {\n  padding: 0;\n  min-height: unset; }\n\n@media screen and (max-width: 767px) {\n  .dialog-notify-budget {\n    padding-top: 120px !important; } }\n\n.dialog-notify-budget .dialog-container .dialog-wrapper-content {\n  padding: 40px 30px 20px 30px;\n  min-height: 226px; }\n  @media screen and (max-width: 767px) {\n    .dialog-notify-budget .dialog-container .dialog-wrapper-content {\n      padding: 40px 5px 20px 5px; } }\n\n.dialog-communication-preference-text .dialog-container .dialog-wrapper-content {\n  padding: 0px;\n  min-height: 226px;\n  width: 480px; }\n  @media screen and (max-width: 768px) {\n    .dialog-communication-preference-text .dialog-container .dialog-wrapper-content {\n      width: auto; } }\n\n.dialog-communication-preference-banner .dialog-container .dialog-wrapper-content {\n  padding: 0px;\n  width: 750px;\n  min-height: unset; }\n  @media screen and (max-width: 768px) {\n    .dialog-communication-preference-banner .dialog-container .dialog-wrapper-content {\n      width: auto; } }\n\n.dialog-filter .dialog-wrapper-content {\n  padding: 0; }\n\n.dialog-cancellation-booking .dialog-wrapper-content {\n  padding: 0;\n  width: auto; }\n\n.dialog-price-change-booking .dialog-wrapper-content {\n  padding: 0;\n  width: auto; }\n\n.dialog-condition-change .dialog-wrapper-content {\n  padding: 0;\n  width: auto;\n  min-height: 0px; }\n\n.dialog-form .dialog-wrapper-content {\n  padding: 0;\n  width: auto;\n  height: auto; }\n\n.dialog-map .dialog-container .dialog-wrapper-content {\n  width: 80vw;\n  height: 80vh;\n  padding: 15px;\n  display: table; }\n  .dialog-map .dialog-container .dialog-wrapper-content .dialog-header {\n    display: table-row; }\n    .dialog-map .dialog-container .dialog-wrapper-content .dialog-header .close-box {\n      position: absolute;\n      right: 30px; }\n    .dialog-map .dialog-container .dialog-wrapper-content .dialog-header .dialog-title {\n      font-size: 20px;\n      font-weight: 600;\n      line-height: 1.35; }\n    .dialog-map .dialog-container .dialog-wrapper-content .dialog-header .dialog-address {\n      display: table;\n      margin: 5px 0 0; }\n      .dialog-map .dialog-container .dialog-wrapper-content .dialog-header .dialog-address p {\n        font-size: 12px;\n        color: #6b778c; }\n\n.dialog-room-note .dialog-container .dialog-wrapper-content {\n  width: 750px;\n  padding: 15px 15px 30px; }\n  .dialog-room-note .dialog-container .dialog-wrapper-content .icon-close2 {\n    margin-right: 0; }\n\n.dialog-room .dialog-container .dialog-wrapper-content {\n  width: 80vw;\n  padding: 15px;\n  min-height: 600px; }\n  .dialog-room .dialog-container .dialog-wrapper-content .close-box {\n    position: absolute;\n    right: 30px; }\n  .dialog-room .dialog-container .dialog-wrapper-content .dialog-title {\n    font-size: 20px;\n    font-weight: 600; }\n  .dialog-room .dialog-container .dialog-wrapper-content .dialog-address {\n    display: block; }\n    .dialog-room .dialog-container .dialog-wrapper-content .dialog-address p {\n      font-size: 12px;\n      color: #6b778c;\n      margin: 5px 0 10px 0; }\n  .dialog-room .dialog-container .dialog-wrapper-content .dialog-header {\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 15px; }\n\n.dialog-terms-and-conditions .dialog-container .dialog-wrapper-content {\n  width: auto;\n  width: initial;\n  max-width: 710px;\n  min-height: auto;\n  min-height: initial; }\n  @media screen and (max-width: 767px) {\n    .dialog-terms-and-conditions .dialog-container .dialog-wrapper-content {\n      padding-bottom: 30px; } }\n\n.dialog-special-day .dialog-container .dialog-wrapper-content {\n  padding: 20px;\n  min-height: 500px;\n  width: 800px; }\n  @media screen and (max-width: 768px) {\n    .dialog-special-day .dialog-container .dialog-wrapper-content {\n      padding: 15px;\n      width: auto;\n      min-height: auto; }\n      .dialog-special-day .dialog-container .dialog-wrapper-content .close-box .icon-close2 {\n        margin-right: -24px;\n        margin-top: -16px;\n        font-size: 14px; } }\n\n.dialog-special-day .dialog-container .close-box .icon-close2 {\n  position: absolute;\n  right: 39px;\n  font-size: 16px;\n  margin-top: -16px; }\n\n.dialog-special-day .close-box {\n  padding: 15px; }\n\n.dialog-booking-report .dialog-wrapper-content {\n  padding: 0;\n  min-height: 0;\n  width: 555px;\n  height: 256px; }\n  @media screen and (max-width: 767px) {\n    .dialog-booking-report .dialog-wrapper-content {\n      width: unset; } }\n\n@media screen and (max-width: 767px) {\n  .fullscreen {\n    padding: 0 !important; }\n    .fullscreen .dialog-wrapper-content {\n      min-height: 100vh !important; } }\n\n@media screen and (max-width: 767px) {\n  .mobileFullscreen {\n    padding: 0 !important; }\n    .mobileFullscreen .dialog-header .close-box {\n      right: 15px;\n      margin-top: 12px; }\n    .mobileFullscreen .dialog-header .pull-left {\n      border-bottom: 1px solid #DFE1E6;\n      padding: 15px;\n      margin-bottom: 15px; }\n      .mobileFullscreen .dialog-header .pull-left .dialog-title {\n        color: #061021;\n        font-size: 16px;\n        font-weight: 700; }\n    .mobileFullscreen .dialog-wrapper-content {\n      height: calc(var(--dialog-vh, 1vh) * 100 - var(--heightRowButton)) !important;\n      width: 100% !important;\n      padding: 0px !important;\n      overflow-y: scroll; } }\n\n.icon-close2 {\n  -moz-appearance: none;\n       appearance: none;\n  border: 0;\n  outline: 0;\n  background: none;\n  font-size: 16px !important;\n  padding: 0 !important; }\n\n@media screen and (max-width: 767px) {\n  .dialog-map .dialog-container {\n    position: fixed;\n    left: 0;\n    top: 0; }\n    .dialog-map .dialog-container .dialog-wrapper-content {\n      width: 100vw;\n      height: 100vh;\n      min-height: 100% !important;\n      padding: 15px;\n      display: table; }\n      .dialog-map .dialog-container .dialog-wrapper-content .dialog-header {\n        display: table-row; }\n        .dialog-map .dialog-container .dialog-wrapper-content .dialog-header .close-box {\n          position: absolute;\n          right: 20px; }\n          .dialog-map .dialog-container .dialog-wrapper-content .dialog-header .close-box .icon-close2 {\n            padding: 0; }\n        .dialog-map .dialog-container .dialog-wrapper-content .dialog-header .pull-left {\n          width: 100%; }\n          .dialog-map .dialog-container .dialog-wrapper-content .dialog-header .pull-left .dialog-title {\n            font-size: 16px;\n            display: block;\n            margin: 0 20px 0 0; }\n          .dialog-map .dialog-container .dialog-wrapper-content .dialog-header .pull-left .dialog-rating {\n            display: inline-block; }\n          .dialog-map .dialog-container .dialog-wrapper-content .dialog-header .pull-left .dialog-address {\n            display: block;\n            margin: 5px 0 10px 0; }\n            .dialog-map .dialog-container .dialog-wrapper-content .dialog-header .pull-left .dialog-address p {\n              display: none; }\n            .dialog-map .dialog-container .dialog-wrapper-content .dialog-header .pull-left .dialog-address i {\n              display: none; }\n  .dialog-cancellation-policy .dialog-container .dialog-wrapper-content {\n    padding: 15px 15px 30px 15px;\n    min-height: 0; }\n    .dialog-cancellation-policy .dialog-container .dialog-wrapper-content .close-box {\n      position: absolute;\n      right: 15px; }\n  .dialog-checkout-tooltips .dialog-container .dialog-wrapper-content {\n    padding: 20px 30px 30px 30px;\n    min-height: 300px; }\n    .dialog-checkout-tooltips .dialog-container .dialog-wrapper-content .close-box {\n      position: absolute;\n      right: 15px; }\n  .dialog-room .dialog-container {\n    position: fixed;\n    left: 0;\n    top: 0; }\n    .dialog-room .dialog-container .dialog-wrapper-content {\n      width: 100vw;\n      height: 100vh;\n      min-height: 100% !important;\n      padding: 15px; }\n      .dialog-room .dialog-container .dialog-wrapper-content .dialog-header {\n        display: table-row; }\n        .dialog-room .dialog-container .dialog-wrapper-content .dialog-header .close-box {\n          position: absolute;\n          right: 15px; }\n        .dialog-room .dialog-container .dialog-wrapper-content .dialog-header .pull-left {\n          width: 100%; }\n          .dialog-room .dialog-container .dialog-wrapper-content .dialog-header .pull-left .dialog-title {\n            font-size: 18px;\n            display: block;\n            margin: 0 20px 0 0; }\n  .dialog-room-note .dialog-container {\n    position: fixed;\n    left: 0;\n    top: 0; }\n    .dialog-room-note .dialog-container .dialog-wrapper-content {\n      width: 100vw;\n      height: 100vh;\n      min-height: 100% !important;\n      padding: 15px; }\n      .dialog-room-note .dialog-container .dialog-wrapper-content .dialog-header {\n        display: table-row; }\n        .dialog-room-note .dialog-container .dialog-wrapper-content .dialog-header .close-box {\n          position: absolute;\n          right: 15px; }\n        .dialog-room-note .dialog-container .dialog-wrapper-content .dialog-header .pull-left {\n          width: 100%; }\n          .dialog-room-note .dialog-container .dialog-wrapper-content .dialog-header .pull-left .dialog-title {\n            font-size: 18px;\n            display: block;\n            margin: 0 20px 0 0; } }\n\n@media screen and (max-width: 767px) {\n  .dialog-multi-payment {\n    padding-top: 120px !important; } }\n\n.dialog-multi-payment .dialog-container .dialog-wrapper-content {\n  padding: 20px 20px 25px 20px;\n  min-height: 0px; }\n\n.dialog-share-budget {\n  overflow-y: hidden; }\n  .dialog-share-budget .dialog-container {\n    padding: 0; }\n    .dialog-share-budget .dialog-container .dialog-wrapper-content {\n      width: 750px;\n      height: 468px;\n      padding: 15px; }\n      @media screen and (max-width: 767px) {\n        .dialog-share-budget .dialog-container .dialog-wrapper-content {\n          width: 100% !important;\n          padding: 15px 10px !important;\n          height: 100vh !important; } }\n\n.dialog-room-note-description .dialog-container .dialog-wrapper-content {\n  padding: 20px 10px;\n  min-height: 0px;\n  min-height: 160px; }\n\n.close-pt {\n  border-top: 1px solid #DFE1E6 !important; }\n\n.close-bt {\n  border-bottom: 1px solid #DFE1E6; }\n\n.icon-star-level-s.-half {\n  vertical-align: unset; }\n\n.dialog-payment .dialog-wrapper-content {\n  padding: 15px;\n  min-height: 350px; }\n  @media screen and (min-width: 767px) {\n    .dialog-payment .dialog-wrapper-content {\n      width: 750px; } }\n\n.dialog-payment .close-bottom {\n  padding: 15px 10px; }\n\n.close-bottom-action {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  -ms-flex-align: center;\n      align-items: center; }\n  .close-bottom-action div {\n    -ms-flex-positive: 1;\n        flex-grow: 1; }\n  .close-bottom-action button {\n    width: 160px; }\n\n.mr-8 {\n  margin-right: 8px; }\n\n.ml-8 {\n  margin-left: 8px; }\n\n.mt-7 {\n  margin-top: 7px; }\n\n.hide-sm {\n  display: -ms-flexbox;\n  display: flex; }\n  @media screen and (max-width: 767px) {\n    .hide-sm {\n      display: none !important; } }\n\n@media screen and (max-width: 767px) {\n  .show-sm {\n    display: -ms-flexbox;\n    display: flex; } }\n\n.ota-btn-sub {\n  float: left;\n  text-align: center;\n  color: #061021;\n  border: 1px solid #dfe1e6;\n  background: white;\n  margin: 0 15px 20px 0;\n  font-size: 14px; }\n  @media screen and (max-width: 767px) {\n    .ota-btn-sub {\n      width: calc(50vw - 18px) !important; } }\n\n.ota-btn-main {\n  float: right; }\n  @media screen and (max-width: 767px) {\n    .ota-btn-main {\n      width: calc(50vw - 18px) !important; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.pagination-wrapper {\n  width: auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n  .pagination-wrapper .pagination-number-wrapper {\n    width: auto;\n    display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".dropdown-ota-style {\n  line-height: 15px;\n  padding: 10px 25px 10px 10px;\n  height: 40px;\n  cursor: pointer; }\n  .dropdown-ota-style.error {\n    border: 1px solid #ed1c24; }\n  .dropdown-ota-style.placeHolder {\n    padding: 10px; }\n\n.select-box,\n.item {\n  position: relative;\n  background-color: white;\n  cursor: pointer; }\n  .select-box .icon,\n  .item .icon {\n    position: absolute;\n    left: 10px;\n    margin-right: 10px;\n    color: #042764; }\n\n.item {\n  width: 456px;\n  height: 46px;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 10px 10px 10px 36px; }\n  .item:hover {\n    background-color: #e4edff; }\n  .item .icon {\n    top: 14px;\n    font-size: 16px; }\n\n.select-box {\n  padding: 10px 10px 10px 45px;\n  height: 40px;\n  -ms-flex-align: center;\n      align-items: center;\n  display: -ms-flexbox;\n  display: flex; }\n  .select-box .icon {\n    top: 7px;\n    font-size: 24px; }\n  .select-box.error {\n    border-color: #ed1c24; }\n\n.img-true-money {\n  width: 21px;\n  height: 16px; }\n  .img-true-money.top-10 {\n    top: 10px !important; }\n\n.disabled {\n  pointer-events: none;\n  background-color: #f6f8f9; }\n\n.scorllable-box {\n  margin-top: 5px; }\n  .scorllable-box li {\n    border-bottom: 1px solid #DFE1E6; }\n    .scorllable-box li:last-child {\n      border-bottom: none; }\n  .scorllable-box .display {\n    place-self: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.payment-method-container {\n  background-color: #FFFFFF;\n  width: 100%;\n  padding: 15px;\n  color: #061021; }\n  @media screen and (max-width: 767px) {\n    .payment-method-container {\n      padding: 15px 10px; } }\n  .payment-method-container .payment-method-section {\n    display: block; }\n    .payment-method-container .payment-method-section .inline {\n      display: -ms-flexbox;\n      display: flex; }\n      @media screen and (max-width: 767px) {\n        .payment-method-container .payment-method-section .inline {\n          display: block; } }\n    .payment-method-container .payment-method-section .payment-method-title {\n      font-size: 14px;\n      font-weight: bold;\n      width: 30%; }\n      .payment-method-container .payment-method-section .payment-method-title.w-25 {\n        width: 25%; }\n      @media screen and (max-width: 767px) {\n        .payment-method-container .payment-method-section .payment-method-title {\n          width: 100% !important; } }\n  .payment-method-container .payment-date-section,\n  .payment-method-container .refund-policy-section {\n    display: -ms-flexbox;\n    display: flex; }\n    @media screen and (max-width: 767px) {\n      .payment-method-container .payment-date-section,\n      .payment-method-container .refund-policy-section {\n        display: block;\n        padding-bottom: 15px; } }\n    .payment-method-container .payment-date-section .payment-date-title,\n    .payment-method-container .payment-date-section .refund-policy-title,\n    .payment-method-container .refund-policy-section .payment-date-title,\n    .payment-method-container .refund-policy-section .refund-policy-title {\n      font-size: 14px;\n      font-weight: bold;\n      width: 25%; }\n      @media screen and (max-width: 767px) {\n        .payment-method-container .payment-date-section .payment-date-title,\n        .payment-method-container .payment-date-section .refund-policy-title,\n        .payment-method-container .refund-policy-section .payment-date-title,\n        .payment-method-container .refund-policy-section .refund-policy-title {\n          width: 100%; } }\n  .payment-method-container .payment-method-section {\n    border-bottom: 1px dotted #DFE1E6;\n    margin-bottom: 15px; }\n  .payment-method-container .refund-policy-section {\n    border-top: 1px dotted #dfe1e6;\n    padding-top: 15px; }\n  .payment-method-container .border-none {\n    padding-top: 0;\n    border-top: none; }\n  .payment-method-container .payment-method-detail,\n  .payment-method-container .payment-date-detail,\n  .payment-method-container .refund-policy-detail {\n    width: 80%; }\n    @media screen and (max-width: 767px) {\n      .payment-method-container .payment-method-detail,\n      .payment-method-container .payment-date-detail,\n      .payment-method-container .refund-policy-detail {\n        width: 100%; } }\n    .payment-method-container .payment-method-detail .multi-payment-title,\n    .payment-method-container .payment-date-detail .multi-payment-title,\n    .payment-method-container .refund-policy-detail .multi-payment-title {\n      font-size: 12px;\n      line-height: 17px;\n      color: #6b778c; }\n  .payment-method-container .payment-method-detail {\n    margin-bottom: 15px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between; }\n  .payment-method-container .payment-detail-block {\n    margin-bottom: 15px;\n    font-size: 14px; }\n    @media screen and (max-width: 767px) {\n      .payment-method-container .payment-detail-block {\n        margin-bottom: 0; } }\n  .payment-method-container .refund-policy-detail {\n    font-size: 14px; }\n  .payment-method-container .payment-title {\n    font-weight: bold;\n    color: #061021; }\n    @media screen and (max-width: 767px) {\n      .payment-method-container .payment-title {\n        padding-top: 10px; } }\n  .payment-method-container .payment-success .icon-success {\n    vertical-align: middle;\n    color: #4aad5d;\n    font-size: 16px;\n    padding-right: 5px; }\n  .payment-method-container .payment-success .status {\n    font-weight: bold;\n    color: #4aad5d; }\n  .payment-method-container .payment-fail .icon-failed {\n    vertical-align: middle;\n    color: #ed1c24;\n    font-size: 16px;\n    padding-right: 5px; }\n  .payment-method-container .payment-fail .status {\n    font-weight: bold;\n    color: #ed1c24; }\n\n.cancel-btn {\n  float: right; }\n  .cancel-btn a {\n    color: #003a90; }\n    .cancel-btn a:visited {\n      color: #003a90; }\n    .cancel-btn a:hover {\n      color: #042764;\n      text-decoration: underline; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "ul.payment-type-select-warp {\n  padding: 0px 7.5px;\n  margin-bottom: 15px; }\n  @media (max-width: 768px) {\n    ul.payment-type-select-warp {\n      margin-bottom: 10px; } }\n  ul.payment-type-select-warp li.payment-type-select-item {\n    display: block;\n    padding: 0px 7.5px !important;\n    margin-top: 15px; }\n    ul.payment-type-select-warp li.payment-type-select-item .radio-button {\n      border: 2px solid #dfe1e6;\n      border-radius: 6px;\n      background-color: #FFFFFF;\n      cursor: pointer;\n      display: -ms-flexbox;\n      display: flex;\n      text-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n      position: relative;\n      width: 100%;\n      -ms-flex-direction: column;\n          flex-direction: column;\n      -ms-flex-pack: center;\n          justify-content: center;\n      padding: 24px 2px;\n      min-height: 95px;\n      margin-bottom: 0px;\n      max-height: 95px; }\n      @media (max-width: 768px) {\n        ul.payment-type-select-warp li.payment-type-select-item .radio-button {\n          max-height: 56px; } }\n      ul.payment-type-select-warp li.payment-type-select-item .radio-button input[type=\"radio\"] {\n        position: absolute;\n        left: 15px;\n        top: 15px; }\n      ul.payment-type-select-warp li.payment-type-select-item .radio-button .payment-title {\n        color: #061021; }\n        ul.payment-type-select-warp li.payment-type-select-item .radio-button .payment-title span {\n          display: block; }\n        ul.payment-type-select-warp li.payment-type-select-item .radio-button .payment-title .title {\n          font-size: 14px;\n          font-weight: bold;\n          line-height: 19px; }\n        ul.payment-type-select-warp li.payment-type-select-item .radio-button .payment-title .sub-title {\n          font-size: 12px;\n          line-height: 14px;\n          font-weight: normal; }\n      ul.payment-type-select-warp li.payment-type-select-item .radio-button.active {\n        border-color: #003a90;\n        background-color: #e4edff; }\n        ul.payment-type-select-warp li.payment-type-select-item .radio-button.active .payment-title {\n          color: #061021; }\n      ul.payment-type-select-warp li.payment-type-select-item .radio-button.disabled {\n        border-color: #DFE1E6 !important;\n        background-color: #FFFFFF !important;\n        pointer-events: none; }\n        ul.payment-type-select-warp li.payment-type-select-item .radio-button.disabled * {\n          color: #A5ADBA !important; }\n        ul.payment-type-select-warp li.payment-type-select-item .radio-button.disabled .payment-icon {\n          color: #A5ADBA !important; }\n      ul.payment-type-select-warp li.payment-type-select-item .radio-button .img-true-money {\n        height: 24px;\n        width: 32px; }\n        @media (max-width: 768px) {\n          ul.payment-type-select-warp li.payment-type-select-item .radio-button .img-true-money {\n            left: -8px;\n            position: relative; } }\n      ul.payment-type-select-warp li.payment-type-select-item .radio-button .img-e-wallet {\n        height: 24px;\n        width: auto; }\n        @media (max-width: 768px) {\n          ul.payment-type-select-warp li.payment-type-select-item .radio-button .img-e-wallet {\n            left: -8px;\n            position: relative; } }\n    ul.payment-type-select-warp li.payment-type-select-item .payment-icon {\n      margin-bottom: 6px;\n      color: #061021;\n      font-size: 24px; }\n  @media (max-width: 768px) {\n    ul.payment-type-select-warp .payment-icon {\n      min-width: 40px;\n      margin-left: 15px; }\n    ul.payment-type-select-warp li.payment-type-select-item {\n      margin-top: 10px; }\n      ul.payment-type-select-warp li.payment-type-select-item:first-child {\n        margin-top: 0; }\n      ul.payment-type-select-warp li.payment-type-select-item .payment-icon {\n        margin-bottom: 0; }\n      ul.payment-type-select-warp li.payment-type-select-item .radio-button {\n        -ms-flex-direction: row;\n            flex-direction: row;\n        text-align: left;\n        -ms-flex-pack: left;\n            justify-content: left;\n        min-height: 56px; }\n        ul.payment-type-select-warp li.payment-type-select-item .radio-button input[type=\"radio\"] {\n          position: relative !important;\n          left: unset !important;\n          top: unset !important; } }\n\n.icon-selected {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  font-size: 24px;\n  z-index: 99;\n  background-color: white;\n  border-radius: 50%;\n  color: #003a90; }\n  @media (max-width: 768px) {\n    .icon-selected {\n      top: 14px;\n      right: 15px;\n      font-size: 24px; } }\n\n.btn-collapse {\n  margin-top: 5px;\n  margin-left: -15px;\n  margin-right: -15px;\n  padding: 10px;\n  text-align: center;\n  border-top: 1px solid #DFE1E6;\n  color: #003a90;\n  cursor: pointer; }\n  @media (max-width: 768px) {\n    .btn-collapse {\n      margin-top: 15px;\n      padding-bottom: 0; } }\n  .btn-collapse .icon-arrow-right-round {\n    margin-left: 5px; }\n  .btn-collapse .icon-arrow-show-less-round {\n    margin-right: 5px; }\n  .btn-collapse:hover {\n    color: #042764; }\n  .btn-collapse:hover span {\n    text-decoration: underline; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".payment-summary-container {\n  background-color: #FFFFFF;\n  width: 100%;\n  padding: 15px;\n  color: #061021; }\n  .payment-summary-container .grand-total,\n  .payment-summary-container .exclude-vat,\n  .payment-summary-container .vat,\n  .payment-summary-container .total,\n  .payment-summary-container .sub-total {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    -ms-flex-align: end;\n        align-items: flex-end; }\n    .payment-summary-container .grand-total .value-text,\n    .payment-summary-container .exclude-vat .value-text,\n    .payment-summary-container .vat .value-text,\n    .payment-summary-container .total .value-text,\n    .payment-summary-container .sub-total .value-text {\n      white-space: normal;\n      margin-bottom: auto; }\n  .payment-summary-container .grand-total {\n    padding: 10px 0; }\n  .payment-summary-container .font-title {\n    font-size: 14px;\n    line-height: 18px; }\n  .payment-summary-container .font-subtitle {\n    font-size: 12px;\n    line-height: 14px; }\n  .payment-summary-container .font-grand-total {\n    -ms-flex-align: baseline !important;\n        align-items: baseline !important;\n    font-size: 24px;\n    line-height: 28px; }\n    .payment-summary-container .font-grand-total .label-text,\n    .payment-summary-container .font-grand-total strong {\n      font-weight: bold; }\n    @media screen and (max-width: 767px) {\n      .payment-summary-container .font-grand-total {\n        font-size: 20px;\n        line-height: 24px; } }\n  .payment-summary-container .mb-15 {\n    margin-bottom: 15px; }\n  .payment-summary-container .mb-0 {\n    margin-bottom: 0px; }\n  .payment-summary-container .border-top {\n    border-top: 1px dotted #DFE1E6; }\n  .payment-summary-container .border-bottom {\n    border-bottom: 1px dotted #DFE1E6; }\n  .payment-summary-container .price-breakdown {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    gap: 10px;\n    padding-bottom: 15px;\n    border-bottom: 1px dotted #DFE1E6; }\n  .payment-summary-container .discount-summary {\n    padding: 10px 0;\n    border-bottom: 1px dotted #DFE1E6; }\n    .payment-summary-container .discount-summary .discount-row {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n      -ms-flex-align: baseline;\n          align-items: baseline; }\n  .payment-summary-container .break-section {\n    margin-bottom: 10px; }\n  .payment-summary-container .row-text {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    padding-top: 15px;\n    padding-bottom: 15px; }\n    .payment-summary-container .row-text .label-text {\n      width: 100%; }\n    .payment-summary-container .row-text .value-text {\n      min-width: 120px;\n      text-align: right; }\n  .payment-summary-container ul {\n    padding-left: 35px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    gap: 10px;\n    margin-bottom: 0; }\n    .payment-summary-container ul li {\n      list-style-type: disc; }\n  .payment-summary-container .share-budget-single-payment {\n    margin-top: 10px; }\n  .payment-summary-container .share-budget-single-payment-thankyou {\n    display: none; }\n    .payment-summary-container .share-budget-single-payment-thankyou .main-payment {\n      padding-top: 12px;\n      padding-bottom: 12px;\n      font-size: 14px;\n      font-weight: bold;\n      line-height: 18px; }\n  .payment-summary-container .booking-multi-payment .multi-payment-thankyou {\n    display: none; }\n  .payment-summary-container .booker-payment-container {\n    padding-bottom: 15px;\n    border-bottom: 1px dotted #DFE1E6; }\n  .payment-summary-container .booker-payment-container-thankyou .booker-payment {\n    padding: 12px 0;\n    border-bottom: 1px dotted #DFE1E6; }\n  .payment-summary-container .fr {\n    float: right; }\n  .payment-summary-container .color-success {\n    color: #4aad5d; }\n  .payment-summary-container .booking-cancel-payment .total-title, .payment-summary-container .booking-cancel-payment .cancel-title {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    font-size: 14px;\n    line-height: 18px; }\n  .payment-summary-container .booking-cancel-payment .total-title {\n    padding-bottom: 15px;\n    border-bottom: 1px dotted #DFE1E6; }\n  .payment-summary-container .booking-cancel-payment .cancel-title {\n    padding-top: 15px;\n    padding-bottom: 10px; }\n  .payment-summary-container .booking-cancel-payment .cancel-detail-section {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    gap: 10px;\n    padding-left: 10px; }\n    .payment-summary-container .booking-cancel-payment .cancel-detail-section .cancel-detail-item {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n      .payment-summary-container .booking-cancel-payment .cancel-detail-section .cancel-detail-item .value-text {\n        min-width: 120px;\n        text-align: right; }\n\n.credit-card-icon {\n  font-size: 12px;\n  color: #042764; }\n\n.ft-c-blue {\n  color: #042764 !important; }\n\ni:hover {\n  cursor: pointer; }\n\n.price-info-container {\n  padding: 10px;\n  background-color: #E4EDFF;\n  border: 1px solid #bfd6ff; }\n  .price-info-container .price-info-label {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    gap: 5px;\n    font-size: 14px;\n    line-height: 18px;\n    margin-bottom: 10px; }\n  .price-info-container i {\n    font-size: 16px;\n    font-size: 14px;\n    font-weight: bold;\n    color: #003A90; }\n  .price-info-container .surcharges-container {\n    margin-bottom: 0;\n    padding-left: 20px; }\n    .price-info-container .surcharges-container .surcharge {\n      font-size: 12px;\n      line-height: 14px;\n      color: #061021; }\n    .price-info-container .surcharges-container li {\n      list-style-type: disc; }\n\n.taxes-fees {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 5px; }\n\n.taxes-fees-icon {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer; }\n\n.tooltip-content {\n  display: none;\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #061021;\n  color: #FFFFFF;\n  padding: 8px 12px;\n  width: 280px;\n  z-index: 1;\n  border-radius: 4px;\n  text-align: left;\n  font-size: 12px;\n  line-height: 14px; }\n\n.tooltip-arrow {\n  position: absolute;\n  top: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 6px solid #061021;\n  line-height: 0; }\n\n@media (hover: hover) {\n  .tooltip-trigger:hover + .tooltip-content,\n  .tooltip-content:hover {\n    display: block; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.header-wrap a {\n  text-decoration: none;\n  color: white; }\n\n.header-wrap ul, .header-wrap li {\n  list-style-type: none; }\n\n.header-wrap .wrap-inner {\n  overflow: visible; }\n\n.header-mobile {\n  display: none; }\n\n.logo {\n  display: none; }\n\n.header-desktop {\n  height: 91px; }\n\n.header-white {\n  background: white;\n  border-bottom: 1px solid #dfe1e6;\n  top: 0;\n  width: 100%;\n  z-index: 12;\n  box-sizing: border-box; }\n  .header-white .logo {\n    display: block;\n    margin: 14px 0;\n    float: left; }\n  .header-white .header-menu a, .header-white .header-menu .text {\n    color: #061021; }\n  .header-white .line-space {\n    color: #DFE1E6; }\n\n.header-right {\n  float: right; }\n\n.header-menu {\n  margin: 37px 0 0 0; }\n  .header-menu > li {\n    float: right;\n    line-height: 40px;\n    font-size: 14px; }\n  .header-menu a, .header-menu .text {\n    color: #FFFFFF;\n    line-height: 40px; }\n  .header-menu img {\n    vertical-align: middle; }\n\n.line-space {\n  margin: 0 20px;\n  width: 1px;\n  height: 20px;\n  font-size: 17px;\n  font-family: \"Times New Roman\", Tahoma, serif;\n  color: #A5ADBA !important; }\n\n.icon-flag {\n  margin-top: -5px; }\n\n.menu-login {\n  padding: 0 35px 0 0; }\n\n.menu-help {\n  padding: 0 35px 0 0; }\n\n.menu-bar-account {\n  padding-right: 10px; }\n\n.user-display {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 5px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  overflow: hidden; }\n\n.list-menu-wrap {\n  position: relative; }\n  .list-menu-wrap.show .list-sub-menu {\n    display: block; }\n\n.list-sub-menu {\n  display: none;\n  position: absolute;\n  z-index: 99;\n  top: 54px;\n  right: 35px;\n  width: 230px;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.4); }\n  .list-sub-menu > li {\n    background: #FFFFFF; }\n    .list-sub-menu > li > a {\n      display: block;\n      width: 100%;\n      padding: 0 16px;\n      line-height: 39px;\n      height: 40px;\n      border-bottom: 1px solid #DFE1E6;\n      color: #061021; }\n      .list-sub-menu > li > a:hover {\n        color: #FFFFFF !important;\n        background: #586d76; }\n\n@media screen and (max-width: 767px) {\n  .header-wrap {\n    width: 100%;\n    z-index: 1; }\n  .header-desktop {\n    display: none; }\n  .header-mobile {\n    position: relative;\n    height: 48px;\n    display: block;\n    left: 0%;\n    margin-left: 0; }\n    .header-mobile .navbar-toggle {\n      margin-right: 0;\n      padding-top: 1px;\n      float: right;\n      z-index: 1; }\n      .header-mobile .navbar-toggle .icon-navbar-toggle {\n        font-size: 26px;\n        color: white; }\n    .header-mobile.header-white {\n      width: 100%;\n      background: white;\n      border-bottom: 3px solid #ed1c24; }\n      .header-mobile.header-white .logo {\n        display: block;\n        margin: 5px 16px;\n        float: left; }\n      .header-mobile.header-white .line-space {\n        color: #DFE1E6 !important; }\n      .header-mobile.header-white .navbar-toggle .icon-navbar-toggle {\n        color: #042764; }\n  .m-list-menu-space {\n    position: fixed;\n    height: 100vh;\n    top: 0;\n    right: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    visibility: hidden;\n    opacity: 0;\n    transition: opacity 0.4;\n    z-index: 99; }\n  .m-list-menu-wrap {\n    position: fixed;\n    width: calc(100% - 49px);\n    background: #f6f8f9;\n    right: 0;\n    height: 100%;\n    top: 0;\n    overflow-y: scroll;\n    z-index: 99;\n    transition: 0.4s;\n    transform: translate3d(100%, 0, 0);\n    overflow-scrolling: touch;\n    -webkit-overflow-scrolling: touch; }\n  .user-detail {\n    margin: 0;\n    padding: 25px 0 25px 16px;\n    overflow: hidden;\n    position: relative; }\n    .user-detail .user-display {\n      width: 44px;\n      height: 44px;\n      margin: 0 10px;\n      float: left; }\n    .user-detail .user-name {\n      width: 100%;\n      float: left;\n      padding: 0 30px 0 0; }\n      .user-detail .user-name span {\n        display: block;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis; }\n    .user-detail .icon-arrow-right {\n      display: inline-block;\n      position: absolute;\n      top: 50%;\n      right: 10px;\n      margin-top: -7px;\n      transition: transform 0.2s;\n      font-size: 14px;\n      color: #DFE1E6; }\n  .m-list-menu-sub {\n    margin: 0 0 15px 0; }\n    .m-list-menu-sub > li {\n      background: #FFFFFF;\n      border-bottom: 1px solid #DFE1E6; }\n      .m-list-menu-sub > li > a {\n        position: relative;\n        font-size: 14px;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n            align-items: center;\n        width: 100%;\n        padding: 0 35px 0 16px;\n        line-height: 46px;\n        color: #061021; }\n        .m-list-menu-sub > li > a .icon-sidemenu {\n          margin-right: 10px;\n          font-size: 16px; }\n        .m-list-menu-sub > li > a:hover, .m-list-menu-sub > li > a .active {\n          color: #FFFFFF !important;\n          background: #586d76; }\n        .m-list-menu-sub > li > a .link-arrow {\n          margin-left: auto; }\n        .m-list-menu-sub > li > a .icon-arrow-right {\n          display: inline-block;\n          position: absolute;\n          top: 50%;\n          right: 10px;\n          margin-top: -7px;\n          transition: transform 0.2s;\n          font-size: 14px;\n          color: #DFE1E6; }\n      .m-list-menu-sub > li:last-child {\n        border-bottom: none; }\n      .m-list-menu-sub > li.-open-collapse .icon-arrow-right {\n        transform: rotate(90deg); }\n  .icon-flag {\n    width: 23px;\n    height: 17px;\n    vertical-align: middle;\n    margin: -5px 0 0 0; } }\n\n.menu-bar-lang-mobile li {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  height: 46px;\n  padding: 0 35px 0 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\na.tooltips {\n  position: relative;\n  display: inline;\n  color: #042764;\n  vertical-align: middle; }\n  a.tooltips > img {\n    margin-top: -2px; }\n  a.tooltips .icon-question {\n    font-size: 16px; }\n\na.tooltips .tooltips-content {\n  position: absolute;\n  width: 350px;\n  width: 370px\\0;\n  padding: 7px 7px 5px 8px;\n  color: #042764;\n  background: #FFFFFF;\n  border: 1px solid #042764;\n  height: 80px;\n  font-size: 12px;\n  line-height: 1.3;\n  text-align: left;\n  visibility: hidden;\n  border-radius: 0px; }\n  a.tooltips .tooltips-content p {\n    margin-bottom: 3px; }\n\n.tooltips-content {\n  white-space: normal; }\n\na.tooltips .tooltips-content:before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: 100%;\n  margin-top: -10px;\n  width: 0;\n  height: 0;\n  border-right: 10px solid #042764;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent; }\n\na.tooltips .tooltips-content:after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: 100%;\n  margin-top: -9px;\n  width: 0;\n  height: 0;\n  border-right: 9px solid #FFFFFF;\n  border-top: 9px solid transparent;\n  border-bottom: 9px solid transparent; }\n\na:hover.tooltips .tooltips-content {\n  visibility: visible;\n  opacity: 1;\n  left: 100%;\n  top: 50%;\n  margin-top: -40px;\n  margin-left: 15px;\n  z-index: 999; }\n  @media screen and (max-width: 340px) {\n    a:hover.tooltips .tooltips-content {\n      margin-left: -6px; } }\n\na.tooltips .tooltips-content-short {\n  position: absolute;\n  width: auto;\n  min-width: 100px;\n  padding: 7px 7px 5px 8px;\n  color: #042764;\n  background: #FFFFFF;\n  border: 1px solid #042764;\n  height: auto;\n  font-size: 12px;\n  line-height: 1.3;\n  text-align: left;\n  visibility: hidden;\n  border-radius: 0px; }\n  a.tooltips .tooltips-content-short p {\n    margin-bottom: 3px; }\n\na.tooltips .tooltips-content-short:before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: 100%;\n  margin-top: -9px;\n  width: 0;\n  height: 0;\n  border-right: 9px solid #042764;\n  border-top: 8px solid transparent;\n  border-bottom: 8px solid transparent; }\n\na.tooltips .tooltips-content-short:after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: 100%;\n  margin-top: -8px;\n  width: 0;\n  height: 0;\n  border-right: 8px solid #FFFFFF;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent; }\n\na:hover.tooltips .tooltips-content-short {\n  visibility: visible;\n  opacity: 1;\n  left: 100%;\n  top: 50%;\n  margin-top: -15px;\n  margin-left: 15px;\n  z-index: 999; }\n\n.home-search-wrap {\n  width: 460px;\n  margin: 30px 0; }\n  .home-search-wrap .search-title {\n    position: relative;\n    padding: 20px 30px 15px 30px;\n    border-bottom: 1px dotted #DFE1E6;\n    line-height: 1.3em;\n    background-color: #FFFFFF; }\n    .home-search-wrap .search-title .icon-city {\n      position: absolute;\n      top: 50%;\n      margin-top: -25px;\n      right: 30px;\n      font-size: 50px; }\n      @media screen and (max-width: 767px) {\n        .home-search-wrap .search-title .icon-city {\n          right: 15px; } }\n\n.home-form-search {\n  background-color: rgba(255, 255, 255, 0.8);\n  padding: 15px 30px; }\n  .home-form-search .col-left, .home-form-search .col-right {\n    width: 49%; }\n  .home-form-search .icon-question-circle {\n    line-height: 1em; }\n    .home-form-search .icon-question-circle img {\n      width: 16px;\n      height: 16px; }\n\n.no-padding-left {\n  padding-left: 0 !important; }\n  @media screen and (max-width: 767px) {\n    .no-padding-left {\n      margin-left: 0; } }\n\n.purpose-wrapper {\n  border-bottom: 1px dotted #6b778c; }\n  .purpose-wrapper .ota-text-error {\n    padding-bottom: 10px; }\n\n.radio .radio-inline {\n  padding: 0;\n  margin-right: 50px;\n  margin-left: -10px;\n  padding-left: 20px;\n  line-height: auto; }\n  .radio .radio-inline input {\n    width: 16px;\n    height: 16px;\n    padding: 0;\n    vertical-align: bottom;\n    *overflow: hidden; }\n  .radio .radio-inline.no-paddingleft {\n    padding-left: 0;\n    margin-left: 0; }\n\n@media screen and (max-width: 767px) {\n  .radio {\n    display: -ms-flexbox;\n    display: flex; } }\n\n@media screen and (max-width: 767px) {\n  .home-search-wrap {\n    margin: 30px 0 20px 0;\n    width: 100%; }\n    .home-search-wrap .search-title {\n      padding: 15px; }\n    .home-search-wrap .color-main {\n      font-size: 17px; }\n    .home-search-wrap .color-sub {\n      font-size: 10px; }\n  .home-form-search {\n    padding: 15px; }\n  .radio .radio-inline {\n    margin-right: 10px; } }\n  @media screen and (max-width: 767px) and (max-width: 767px) {\n    .radio .radio-inline {\n      padding-left: 25px;\n      margin-left: 3%;\n      white-space: nowrap; }\n      .radio .radio-inline:first-child {\n        padding-left: 0;\n        min-width: 105px; } }\n  @media screen and (max-width: 767px) and (max-width: 320px) {\n    .radio .radio-inline {\n      padding-left: 25px;\n      margin-left: -10px; }\n      .radio .radio-inline:first-child {\n        min-width: 105px; } }\n\n@media screen and (max-width: 767px) {\n    .radio .radio-inline.no-margin-left {\n      padding-left: 0; }\n  a.tooltips .tooltips-content {\n    width: 180px;\n    height: auto; }\n    a.tooltips .tooltips-content:before {\n      top: 30%; }\n    a.tooltips .tooltips-content:after {\n      top: 30%; } }\n\n.icon-calendar {\n  background-color: #FFFFFF;\n  background-image: url(\"/assets/images/icons/Date.png\");\n  background-repeat: no-repeat;\n  background-position: center 0;\n  width: 16px;\n  height: 17px;\n  display: inline-block;\n  margin: 0 5px 0 0; }\n\n.icon-town {\n  background-color: #FFFFFF;\n  background-image: url(\"/assets/images/icons/hotel.svg\");\n  background-repeat: no-repeat;\n  background-position: center 0;\n  width: 22px;\n  height: 17px;\n  display: inline-block;\n  margin: 0 5px 0 0; }\n\n.icon-people {\n  background-color: #FFFFFF;\n  background-image: url(\"/assets/images/icons/people.svg\");\n  background-repeat: no-repeat;\n  background-position: center 0;\n  width: 13px;\n  height: 16px;\n  display: inline-block;\n  margin: 0 5px 0 0; }\n\n.icon-search {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  margin: 0 5px 0 0; }\n\n.search-top-wrap {\n  background: #FFFFFF;\n  padding: 15px 0;\n  height: auto;\n  border-bottom: 1px solid #DFE1E6;\n  display: block; }\n  .search-top-wrap a, .search-top-wrap a:visited {\n    color: #003a90;\n    text-decoration: underline; }\n  .search-top-wrap a:hover {\n    color: #003a90;\n    text-decoration: underline; }\n\n.search-top-wrap-before {\n  background-color: white;\n  border-bottom: 1px solid #DFE1E6; }\n  .search-top-wrap-before .topic-search {\n    display: none; }\n  .search-top-wrap-before .form-padding {\n    padding-right: 15px; }\n    @media screen and (max-width: 767px) {\n      .search-top-wrap-before .form-padding {\n        padding-right: 0; } }\n  @media screen and (min-width: 768px) and (max-width: 1139px) {\n    .search-top-wrap-before .btn-submit-horizontal {\n      margin: 0;\n      margin-left: 15px;\n      position: relative;\n      left: -15px; } }\n\n.destination_search .form-control {\n  padding-right: 30px; }\n\n@media screen and (min-width: 768px) {\n  .destination_search.-error-fuild {\n    margin-bottom: 35px; }\n    .destination_search.-error-fuild .ota-text-error {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      margin-top: 5px; } }\n\n.search-summary {\n  display: block; }\n  .search-summary .search-summary-icon {\n    margin-top: -4px;\n    margin-right: 7px; }\n    .search-summary .search-summary-icon img {\n      height: 16px; }\n    .search-summary .search-summary-icon.-search {\n      position: relative;\n      top: 0;\n      margin-left: 5px;\n      margin-right: 0; }\n  .search-summary .cover-search-sum {\n    display: table;\n    width: 100%; }\n    .search-summary .cover-search-sum .headline {\n      color: #6b778c; }\n    .search-summary .cover-search-sum .desc-box {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center;\n      height: 17px;\n      margin-top: 5px; }\n      .search-summary .cover-search-sum .desc-box i,\n      .search-summary .cover-search-sum .desc-box span {\n        float: left;\n        display: -ms-flexbox;\n        display: flex; }\n    .search-summary .cover-search-sum .search-destination,\n    .search-summary .cover-search-sum .search-date,\n    .search-summary .cover-search-sum .search-num-of-guest,\n    .search-summary .cover-search-sum .search-change {\n      float: left;\n      border-right: 1px dotted #DFE1E6;\n      padding: 0 15px;\n      box-sizing: border-box;\n      cursor: pointer; }\n      @media screen and (max-width: 767px) {\n        .search-summary .cover-search-sum .search-destination,\n        .search-summary .cover-search-sum .search-date,\n        .search-summary .cover-search-sum .search-num-of-guest,\n        .search-summary .cover-search-sum .search-change {\n          border-right: 0; } }\n      .search-summary .cover-search-sum .search-destination .desc-box > span, .search-summary .cover-search-sum .search-destination .desc-box .text-inline,\n      .search-summary .cover-search-sum .search-date .desc-box > span,\n      .search-summary .cover-search-sum .search-date .desc-box .text-inline,\n      .search-summary .cover-search-sum .search-num-of-guest .desc-box > span,\n      .search-summary .cover-search-sum .search-num-of-guest .desc-box .text-inline,\n      .search-summary .cover-search-sum .search-change .desc-box > span,\n      .search-summary .cover-search-sum .search-change .desc-box .text-inline {\n        white-space: nowrap; }\n      .search-summary .cover-search-sum .search-destination:hover .desc-box > span, .search-summary .cover-search-sum .search-destination:hover .desc-box .text-inline,\n      .search-summary .cover-search-sum .search-date:hover .desc-box > span,\n      .search-summary .cover-search-sum .search-date:hover .desc-box .text-inline,\n      .search-summary .cover-search-sum .search-num-of-guest:hover .desc-box > span,\n      .search-summary .cover-search-sum .search-num-of-guest:hover .desc-box .text-inline,\n      .search-summary .cover-search-sum .search-change:hover .desc-box > span,\n      .search-summary .cover-search-sum .search-change:hover .desc-box .text-inline {\n        text-decoration: underline; }\n    .search-summary .cover-search-sum .search-destination {\n      width: 20%;\n      padding: 0 15px 0 0; }\n      .search-summary .cover-search-sum .search-destination .destination-text {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        width: 80%; }\n        @media screen and (max-width: 767px) {\n          .search-summary .cover-search-sum .search-destination .destination-text {\n            width: calc(100vw - 200px); } }\n    .search-summary .cover-search-sum .search-date {\n      width: 30%; }\n    .search-summary .cover-search-sum .search-num-of-guest {\n      width: 30%;\n      border-right: 0; }\n    .search-summary .cover-search-sum .search-change {\n      width: 20%;\n      text-align: right;\n      border-right: 0;\n      margin-top: 24px;\n      padding: 0 0 0 15px; }\n      .search-summary .cover-search-sum .search-change a, .search-summary .cover-search-sum .search-change a:visited {\n        color: #003a90;\n        text-decoration: underline; }\n      .search-summary .cover-search-sum .search-change .icon-search {\n        display: inline-block;\n        font-size: 16px; }\n      .search-summary .cover-search-sum .search-change:hover a {\n        color: #042764;\n        text-decoration: underline; }\n      .search-summary .cover-search-sum .search-change:hover .search-summary-icon {\n        color: #042764; }\n\n.horizontal-search-wrap {\n  padding: 15px 0; }\n\n.input-destination.-layout-topwrap {\n  width: 250px; }\n\n.input-checkin, .input-checkout {\n  width: 175px; }\n\n.input-num-of-guest {\n  width: 290px; }\n\n.btn-submit-horizontal {\n  float: left;\n  width: 160px;\n  margin: 24px 0 0 15px;\n  line-height: 34px; }\n\n.work-personal-box {\n  float: left;\n  max-width: 290px; }\n  .work-personal-box .col-left, .work-personal-box .col-right {\n    width: 50%; }\n  .work-personal-box .col-left {\n    padding-right: 15px; }\n    @media screen and (max-width: 767px) {\n      .work-personal-box .col-left {\n        padding-right: 5px; } }\n  @media screen and (max-width: 767px) {\n    .work-personal-box .col-right {\n      padding-left: 5px; } }\n\n.alert {\n  padding: 8px 15px; }\n\n.close {\n  float: right;\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 1;\n  color: #6b778c;\n  text-shadow: 0 1px 0 #FFFFFF;\n  filter: alpha(opacity=100);\n  opacity: 1; }\n\n.alert-top-wrap {\n  margin: 0 auto;\n  margin-bottom: 15px;\n  width: 100%;\n  max-width: 1140px;\n  background-color: #DFE1E6;\n  color: #576D77;\n  text-align: center; }\n\n.alert-dismissible {\n  padding-right: 15px; }\n  .alert-dismissible .close {\n    position: relative;\n    top: -4px; }\n\nbutton.close {\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: 0 0;\n  border: 0; }\n\n.lvc-radio {\n  white-space: nowrap;\n  padding-bottom: 15px;\n  border-bottom: 1px dotted #DFE1E6; }\n  .lvc-radio .radio-lvc-topic {\n    padding-left: 0;\n    margin-left: 0; }\n  .lvc-radio a,\n  .lvc-radio a:visited,\n  .lvc-radio a:hover {\n    text-decoration: none;\n    color: #FFFFFF; }\n  .lvc-radio .icon-question {\n    color: #576D77; }\n\n.lvc-cancel {\n  width: 100%;\n  text-align: right; }\n  .lvc-cancel a {\n    color: #003a90; }\n    .lvc-cancel a:visited {\n      color: #003a90; }\n    .lvc-cancel a:hover {\n      color: #042764;\n      text-decoration: underline; }\n  @media screen and (max-width: 767px) {\n    .lvc-cancel {\n      display: none; } }\n\n@media screen and (max-width: 767px) {\n  .search-top-wrap {\n    padding: 0;\n    height: auto;\n    border-bottom: 0;\n    background-color: transparent; }\n  .search-top-wrap-before {\n    margin-bottom: 10px;\n    background-color: #FFFFFF;\n    background-size: 100%;\n    padding: 10px;\n    height: auto;\n    width: 100%; }\n  .search-summary {\n    display: block;\n    background-color: #FFFFFF;\n    border: 1px solid #DFE1E6;\n    border-bottom: 3px solid #DFE1E6; }\n    .search-summary .cover-search-sum {\n      position: relative; }\n      .search-summary .cover-search-sum .headline {\n        display: none; }\n      .search-summary .cover-search-sum .search-destination {\n        background-color: #FFFFFF;\n        background-image: url(\"/assets/images/icons/search-color.png\");\n        background-repeat: no-repeat;\n        background-position: 15px 10px;\n        background-size: 16px 16px;\n        color: #061021;\n        font-size: 13px;\n        padding: 0 0 0 37px;\n        width: 100%;\n        height: 41px;\n        line-height: 1.5em;\n        border-bottom: 1px solid #DFE1E6;\n        overflow: hidden; }\n        .search-summary .cover-search-sum .search-destination .desc-box {\n          margin-top: 10px; }\n          .search-summary .cover-search-sum .search-destination .desc-box i {\n            display: none; }\n      .search-summary .cover-search-sum .search-date {\n        color: #061021;\n        font-size: 12px;\n        line-height: 1.5;\n        padding: 0 0 0 15px;\n        margin: 7px 0 3px 0;\n        overflow: hidden;\n        width: 100%;\n        border-right: 0; }\n      .search-summary .cover-search-sum .search-num-of-guest {\n        color: #061021;\n        font-size: 12px;\n        line-height: 1.6;\n        padding: 0 0 0 15px;\n        margin: 3px 0 7px 0;\n        width: 100%; }\n      .search-summary .cover-search-sum .search-change {\n        width: 100%;\n        position: absolute;\n        top: -14px;\n        font-size: 13px;\n        padding-right: 15px; }\n        .search-summary .cover-search-sum .search-change i {\n          display: none !important; }\n  .horizontal-search-wrap {\n    padding: 0; }\n  .input-destination {\n    display: block;\n    width: 100% !important;\n    margin-right: 0; }\n  .input-checkin, .input-checkout {\n    width: calc(100% - 5px);\n    margin-right: 0; }\n  .input-checkin {\n    margin-right: 5px; }\n  .input-checkout {\n    margin-left: 5px; }\n  .input-num-of-guest {\n    width: 100%;\n    display: block; }\n  .btn-submit-horizontal {\n    margin: 0 0 0 5px;\n    width: calc(50% - 5px);\n    line-height: 40px; }\n  .btn-cancle-horizontal {\n    float: left;\n    margin: 0 5px 0 0;\n    width: calc(50% - 5px);\n    text-align: center; }\n  .change-search {\n    color: #003a90;\n    font-size: 12px;\n    text-decoration: underline; }\n  .work-personal-box {\n    max-width: 100%;\n    float: none; }\n    .work-personal-box .form-group .col-left {\n      display: block;\n      width: 50%; }\n    .work-personal-box .form-group .col-right {\n      display: block; }\n    .work-personal-box .form-group .form-select {\n      width: 98%; }\n  .alert {\n    padding: 8px 10px; }\n  .alert-dismissible {\n    padding-right: 10px; }\n  .alert-top-wrap {\n    text-align: left;\n    width: 95% !important;\n    font-size: 12px; } }\n\n.select-room-box .form-group-inline label {\n  min-width: auto;\n  min-width: initial;\n  margin-right: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.show-detail,\n.hide-detail {\n  padding: 5px 0 5px 25px;\n  color: #586c77;\n  display: block;\n  background-size: 20px 20px;\n  color: #576D77;\n  text-decoration: none; }\n  .show-detail:visited,\n  .hide-detail:visited {\n    color: #576D77; }\n  .show-detail:hover,\n  .hide-detail:hover {\n    color: #53798A;\n    text-decoration: none; }\n  .show-detail:hover,\n  .hide-detail:hover {\n    text-decoration: underline; }\n\n.show-detail {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/icon_arrow_down.png\");\n  background-repeat: no-repeat;\n  background-position: 0 center;\n  float: none;\n  margin: 0;\n  border: 0;\n  line-height: initial;\n  text-align: left; }\n  @media screen and (max-width: 767px) {\n    .show-detail {\n      margin-bottom: -10px; } }\n\n.hide-detail {\n  background-color: transparent;\n  background-image: url(\"/assets/images/account/icon_arrow_up.png\");\n  background-repeat: no-repeat;\n  background-position: 0 center;\n  float: none;\n  margin: 0;\n  border: 0;\n  line-height: initial;\n  text-align: left; }\n  @media screen and (max-width: 767px) {\n    .hide-detail {\n      margin-bottom: -10px; } }\n\n.content-box {\n  padding-bottom: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\na.tooltips {\n  position: relative;\n  display: inline;\n  color: #042764; }\n  a.tooltips > img {\n    margin-top: -2px; }\n  a.tooltips .icon-question {\n    font-size: 16px; }\n\na.tooltips .tooltips-content {\n  position: absolute;\n  width: 350px;\n  padding: 7px 7px 5px 8px;\n  color: #042764;\n  background: #FFFFFF;\n  border: 1px solid #042764;\n  height: 80px;\n  font-size: 12px;\n  line-height: 1.3;\n  text-align: left;\n  visibility: hidden;\n  border-radius: 4px; }\n  a.tooltips .tooltips-content p {\n    margin-bottom: 3px; }\n\n.tooltips-content {\n  white-space: normal; }\n\na.tooltips .tooltips-content:before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: 100%;\n  margin-top: -10px;\n  width: 0;\n  height: 0;\n  border-right: 5px solid #042764;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent; }\n\na.tooltips .tooltips-content:after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: 100%;\n  margin-top: -9px;\n  width: 0;\n  height: 0;\n  border-right: 4px solid #FFFFFF;\n  border-top: 3px solid transparent;\n  border-bottom: 3px solid transparent; }\n\na:hover.tooltips .tooltips-content {\n  visibility: visible;\n  opacity: 1;\n  top: -27px;\n  left: 30px;\n  z-index: 999; }\n  @media screen and (max-width: 340px) {\n    a:hover.tooltips .tooltips-content {\n      margin-left: -6px; } }\n\na.tooltips .tooltips-content-short {\n  position: absolute;\n  width: auto;\n  min-width: 100px;\n  padding: 7px 7px 5px 8px;\n  color: #042764;\n  background: #FFFFFF;\n  border: 1px solid #042764;\n  height: auto;\n  font-size: 12px;\n  line-height: 1.3;\n  text-align: left;\n  visibility: hidden;\n  border-radius: 4px; }\n  a.tooltips .tooltips-content-short p {\n    margin-bottom: 3px; }\n\na.tooltips .tooltips-content-short:before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: 100%;\n  margin-top: -9px;\n  width: 0;\n  height: 0;\n  border-right: 9px solid #042764;\n  border-top: 8px solid transparent;\n  border-bottom: 8px solid transparent; }\n\na.tooltips .tooltips-content-short:after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: 100%;\n  margin-top: -8px;\n  width: 0;\n  height: 0;\n  border-right: 8px solid #FFFFFF;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent; }\n\na:hover.tooltips .tooltips-content-short {\n  visibility: visible;\n  opacity: 1;\n  left: 100%;\n  top: 50%;\n  margin-top: -15px;\n  margin-left: 15px;\n  z-index: 999; }\n\n.home-search-wrap {\n  margin: 30px 0; }\n  .home-search-wrap .search-header {\n    position: relative;\n    line-height: 1.3em;\n    color: #FFFFFF;\n    margin-bottom: 15px; }\n    .home-search-wrap .search-header .search-title {\n      font-size: 24px; }\n  .home-search-wrap .home-form-search {\n    background-color: #FFFFFF;\n    padding: 30px 0;\n    border-radius: 8px;\n    color: #061021; }\n    @media screen and (max-width: 767px) {\n      .home-search-wrap .home-form-search {\n        border-radius: 0;\n        padding: 10px 0; } }\n    .home-search-wrap .home-form-search .col-left, .home-search-wrap .home-form-search .col-right {\n      width: 49%; }\n    .home-search-wrap .home-form-search .icon-question {\n      color: #003a90; }\n    .home-search-wrap .home-form-search .purpose-wrapper .ota-text-error {\n      padding-bottom: 10px; }\n    .home-search-wrap .home-form-search .alert-budget {\n      background-color: #e4edff;\n      padding: 10px 30px;\n      margin-bottom: 20px; }\n      @media screen and (max-width: 767px) {\n        .home-search-wrap .home-form-search .alert-budget {\n          padding: 8px 10px;\n          margin-bottom: 0; } }\n      .home-search-wrap .home-form-search .alert-budget .first-line-budget {\n        color: #042764;\n        font-size: 14px;\n        line-height: 19px;\n        display: inline; }\n        @media screen and (max-width: 767px) {\n          .home-search-wrap .home-form-search .alert-budget .first-line-budget {\n            font-size: 12px;\n            line-height: 17px; } }\n        .home-search-wrap .home-form-search .alert-budget .first-line-budget .share-budget {\n          color: #003a90;\n          display: inline;\n          float: right; }\n          .home-search-wrap .home-form-search .alert-budget .first-line-budget .share-budget.tooltips .tooltips-content {\n            top: 30px;\n            left: -71px;\n            width: 240px;\n            height: auto;\n            box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5); }\n            .home-search-wrap .home-form-search .alert-budget .first-line-budget .share-budget.tooltips .tooltips-content.en {\n              left: -122px; }\n            .home-search-wrap .home-form-search .alert-budget .first-line-budget .share-budget.tooltips .tooltips-content::before {\n              top: 0%;\n              right: 15px;\n              border: 5px solid #042764;\n              border-top: 4px solid transparent;\n              border-right: 4px solid transparent;\n              border-left: 4px solid transparent; }\n            .home-search-wrap .home-form-search .alert-budget .first-line-budget .share-budget.tooltips .tooltips-content::after {\n              top: 0%;\n              right: 15px;\n              border: 5px solid white;\n              border-top: 5px solid transparent;\n              border-right: 4px solid transparent;\n              border-left: 4px solid transparent; }\n          .home-search-wrap .home-form-search .alert-budget .first-line-budget .share-budget.tooltips .tooltips-content-en {\n            top: 30px;\n            left: -138px;\n            width: 240px;\n            height: auto;\n            box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5); }\n            .home-search-wrap .home-form-search .alert-budget .first-line-budget .share-budget.tooltips .tooltips-content-en::before {\n              top: 0%;\n              right: 15px;\n              border: 5px solid #042764;\n              border-top: 4px solid transparent;\n              border-right: 4px solid transparent;\n              border-left: 4px solid transparent; }\n            .home-search-wrap .home-form-search .alert-budget .first-line-budget .share-budget.tooltips .tooltips-content-en::after {\n              top: 0%;\n              right: 15px;\n              border: 5px solid white;\n              border-top: 5px solid transparent;\n              border-right: 4px solid transparent;\n              border-left: 4px solid transparent; }\n          .home-search-wrap .home-form-search .alert-budget .first-line-budget .share-budget.middle {\n            position: relative;\n            top: 12px; }\n          .home-search-wrap .home-form-search .alert-budget .first-line-budget .share-budget span:hover {\n            -webkit-text-decoration-line: underline;\n                    text-decoration-line: underline;\n            -webkit-text-decoration-style: solid;\n                    text-decoration-style: solid; }\n          .home-search-wrap .home-form-search .alert-budget .first-line-budget .share-budget:hover {\n            color: #042764; }\n      .home-search-wrap .home-form-search .alert-budget .second-line-budget {\n        color: #061021;\n        font-size: 12px;\n        line-height: 17px;\n        margin-top: 2px; }\n      .home-search-wrap .home-form-search .alert-budget .permission {\n        color: #003a90;\n        -webkit-text-decoration-line: underline;\n                text-decoration-line: underline;\n        -webkit-text-decoration-style: dotted;\n                text-decoration-style: dotted; }\n        .home-search-wrap .home-form-search .alert-budget .permission:hover {\n          color: #042764; }\n      .home-search-wrap .home-form-search .alert-budget.mb-20 {\n        margin-bottom: 20px; }\n    .home-search-wrap .home-form-search .share-budget-mobile {\n      padding: 10px;\n      vertical-align: middle;\n      border: 1px solid #e4edff;\n      background-color: #F3F6FC;\n      margin-bottom: 20px;\n      font-size: 12px; }\n      .home-search-wrap .home-form-search .share-budget-mobile a {\n        color: #003a90; }\n    .home-search-wrap .home-form-search .share-budget-detail {\n      color: #003a90;\n      -webkit-text-decoration-line: underline;\n              text-decoration-line: underline;\n      -webkit-text-decoration-style: dotted;\n              text-decoration-style: dotted; }\n      .home-search-wrap .home-form-search .share-budget-detail:hover {\n        color: #042764; }\n      .home-search-wrap .home-form-search .share-budget-detail .row {\n        margin: 0;\n        padding: 10px 10px 0 10px; }\n        .home-search-wrap .home-form-search .share-budget-detail .row:nth-last-child(2) {\n          padding: 10px; }\n        .home-search-wrap .home-form-search .share-budget-detail .row:last-child {\n          padding: 5px 10px; }\n        .home-search-wrap .home-form-search .share-budget-detail .row .col-md-12,\n        .home-search-wrap .home-form-search .share-budget-detail .row .col-md-8,\n        .home-search-wrap .home-form-search .share-budget-detail .row .col-md-4 {\n          padding: 0; }\n          .home-search-wrap .home-form-search .share-budget-detail .row .col-md-12:not(:first-child):not(:last-child),\n          .home-search-wrap .home-form-search .share-budget-detail .row .col-md-8:not(:first-child):not(:last-child),\n          .home-search-wrap .home-form-search .share-budget-detail .row .col-md-4:not(:first-child):not(:last-child) {\n            color: #061021; }\n          .home-search-wrap .home-form-search .share-budget-detail .row .col-md-12 span,\n          .home-search-wrap .home-form-search .share-budget-detail .row .col-md-8 span,\n          .home-search-wrap .home-form-search .share-budget-detail .row .col-md-4 span {\n            color: #6b778c !important; }\n        .home-search-wrap .home-form-search .share-budget-detail .row .col-md-4 {\n          text-align: right; }\n        .home-search-wrap .home-form-search .share-budget-detail .row.total {\n          background-color: #F6F8F9;\n          border-radius: 4px; }\n        .home-search-wrap .home-form-search .share-budget-detail .row.warning {\n          color: #ed1c24; }\n      .home-search-wrap .home-form-search .share-budget-detail.tooltips .tooltips-content {\n        top: -15px;\n        left: 85px;\n        width: 304px;\n        height: auto;\n        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);\n        padding: 0; }\n        .home-search-wrap .home-form-search .share-budget-detail.tooltips .tooltips-content::before {\n          top: 20%;\n          right: 100%;\n          border: 5px solid #042764;\n          border-top: 4px solid transparent;\n          border-bottom: 4px solid transparent;\n          border-left: 4px solid transparent; }\n        .home-search-wrap .home-form-search .share-budget-detail.tooltips .tooltips-content::after {\n          top: 20%;\n          right: 99%;\n          border: 6px solid white;\n          border-top: 3px solid transparent;\n          border-bottom: 4px solid transparent;\n          border-left: 5px solid transparent; }\n      .home-search-wrap .home-form-search .share-budget-detail.tooltips .form-group {\n        margin-bottom: 0; }\n      @media screen and (max-width: 767px) {\n        .home-search-wrap .home-form-search .share-budget-detail.mobile {\n          color: #003a90;\n          -webkit-text-decoration-line: underline;\n                  text-decoration-line: underline;\n          -webkit-text-decoration-style: dotted;\n                  text-decoration-style: dotted;\n          display: inline; } }\n    .home-search-wrap .home-form-search form > .form-group {\n      padding: 0 30px;\n      display: inline-block;\n      width: 100%; }\n      .home-search-wrap .home-form-search form > .form-group.col-left, .home-search-wrap .home-form-search form > .form-group.col-right {\n        width: 49%; }\n      .home-search-wrap .home-form-search form > .form-group.col-left {\n        padding-right: 0; }\n      .home-search-wrap .home-form-search form > .form-group.col-right {\n        padding-left: 0; }\n      .home-search-wrap .home-form-search form > .form-group.over-budget {\n        margin: -5px 0 10px; }\n        .home-search-wrap .home-form-search form > .form-group.over-budget .ota-checkbox {\n          padding: 0; }\n          .home-search-wrap .home-form-search form > .form-group.over-budget .ota-checkbox:hover {\n            background-color: unset; }\n          .home-search-wrap .home-form-search form > .form-group.over-budget .ota-checkbox [type=\"checkbox\"]:not(:checked) + label,\n          .home-search-wrap .home-form-search form > .form-group.over-budget .ota-checkbox [type=\"checkbox\"]:checked + label {\n            margin: 0;\n            padding-top: 5px;\n            line-height: unset; }\n          .home-search-wrap .home-form-search form > .form-group.over-budget .ota-checkbox [type=\"checkbox\"]:checked + label:after {\n            top: 6px; }\n        .home-search-wrap .home-form-search form > .form-group.over-budget a.tooltips {\n          color: #061021; }\n          .home-search-wrap .home-form-search form > .form-group.over-budget a.tooltips .tooltips-content {\n            top: -9px;\n            left: 23px;\n            height: unset;\n            width: 245px; }\n            .home-search-wrap .home-form-search form > .form-group.over-budget a.tooltips .tooltips-content.th::before, .home-search-wrap .home-form-search form > .form-group.over-budget a.tooltips .tooltips-content.th::after {\n              top: 50%; }\n            .home-search-wrap .home-form-search form > .form-group.over-budget a.tooltips .tooltips-content.en::before, .home-search-wrap .home-form-search form > .form-group.over-budget a.tooltips .tooltips-content.en::after {\n              top: 37%; }\n      @media screen and (max-width: 767px) {\n        .home-search-wrap .home-form-search form > .form-group {\n          padding: 0 10px; }\n          .home-search-wrap .home-form-search form > .form-group.col-left, .home-search-wrap .home-form-search form > .form-group.col-right {\n            width: 100%;\n            padding: 0 10px; }\n          .home-search-wrap .home-form-search form > .form-group.search-box-room-guest {\n            margin-bottom: 10px; }\n          .home-search-wrap .home-form-search form > .form-group.over-budget {\n            margin-top: -5px; } }\n    .home-search-wrap .home-form-search .action-botton-group {\n      margin-top: 5px; }\n      @media screen and (max-width: 767px) {\n        .home-search-wrap .home-form-search .action-botton-group {\n          margin-top: 0; } }\n      .home-search-wrap .home-form-search .action-botton-group .ota-btn-main {\n        width: 180px; }\n        @media screen and (max-width: 416px) {\n          .home-search-wrap .home-form-search .action-botton-group .ota-btn-main {\n            width: 100%; } }\n\n.form-control.form-select {\n  position: relative; }\n  .form-control.form-select .form-group-pop {\n    width: 100%;\n    top: 33px; }\n    .form-control.form-select .form-group-pop .select-room-popup {\n      width: 100%; }\n  .form-control.form-select.select-room-guest {\n    background: url(\"../../../assets/images/icons/Guest.png\") 7px center no-repeat, url(\"../../../assets/images/form/Down.svg\") calc(100% - 10px) center no-repeat;\n    background-size: 16px, auto;\n    padding: 6px 12px 6px 30px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center; }\n\n.no-padding-left {\n  padding-left: 0 !important; }\n  @media screen and (max-width: 767px) {\n    .no-padding-left {\n      margin-left: 0; } }\n\n.purpose-box {\n  line-height: 18px; }\n  .purpose-box .ota-radio {\n    display: inline-block;\n    padding: 0;\n    margin-left: 60px; }\n    .purpose-box .ota-radio:hover {\n      background-color: unset; }\n    .purpose-box .ota-radio [type=\"radio\"]:checked + label:after {\n      top: 12px;\n      left: 5px; }\n    @media screen and (max-width: 767px) {\n      .purpose-box .ota-radio {\n        margin-left: 10px; }\n        .purpose-box .ota-radio:first-child {\n          margin-right: 20px; } }\n    @media screen and (max-width: 320px) {\n      .purpose-box .ota-radio:first-child {\n        margin-right: 5px; } }\n\n.select-ota-style.form-control select {\n  height: 32px; }\n\n.select-ota-style select {\n  padding: 0 12px 0 30px; }\n  .select-ota-style select.select-room {\n    background: url(\"../../../assets/images/icons/Room.png\") 7px center no-repeat, url(\"../../../assets/images/form/Down.svg\") calc(100% - 10px) center no-repeat;\n    background-size: 16px, auto; }\n  .select-ota-style select.select-guest {\n    background: url(\"../../../assets/images/icons/Guest.png\") 7px center no-repeat, url(\"../../../assets/images/form/Down.svg\") calc(100% - 10px) center no-repeat;\n    background-size: 16px, auto; }\n\n@media screen and (max-width: 767px) {\n  .home-search-wrap {\n    margin: 0;\n    width: 100%; }\n    .home-search-wrap .search-header {\n      padding: 0;\n      margin: 0 0 15px; }\n      .home-search-wrap .search-header .search-title {\n        font-size: 20px; }\n    .home-search-wrap .color-main {\n      font-size: calc(5px + 2vw);\n      font-size: 17px; }\n    .home-search-wrap .color-sub {\n      font-size: 10px; }\n    .home-search-wrap .home-form-search {\n      padding: 15px 0;\n      margin-bottom: 5px; }\n  a.tooltips .tooltips-content {\n    width: 180px;\n    height: auto; }\n    a.tooltips .tooltips-content:before, a.tooltips .tooltips-content:after {\n      top: 28%; }\n  .purpose-box a.tooltips .tooltips-content:before, .purpose-box a.tooltips .tooltips-content:after {\n    top: 35%; }\n  .select-ota-style.form-control select {\n    height: unset; } }\n\n.icon-calendar {\n  background-color: #FFFFFF;\n  background-image: url(\"/assets/images/icons/Date.png\");\n  background-repeat: no-repeat;\n  background-position: center 0;\n  width: 16px;\n  height: 17px;\n  display: inline-block;\n  margin: 0 5px 0 0; }\n\n.icon-town {\n  background-color: #FFFFFF;\n  background-image: url(\"/assets/images/icons/hotel.svg\");\n  background-repeat: no-repeat;\n  background-position: center 0;\n  width: 22px;\n  height: 17px;\n  display: inline-block;\n  margin: 0 5px 0 0; }\n\n.icon-people {\n  background-color: #FFFFFF;\n  background-image: url(\"/assets/images/icons/people.svg\");\n  background-repeat: no-repeat;\n  background-position: center 0;\n  width: 13px;\n  height: 16px;\n  display: inline-block;\n  margin: 0 5px 0 0; }\n\n.icon-search2 {\n  font-size: 16px;\n  display: inline-block;\n  margin: 0 5px 0 0; }\n\n.search-top-wrap {\n  background: #FFFFFF;\n  padding: 15px 0;\n  height: auto;\n  border-bottom: 1px solid #DFE1E6;\n  display: block; }\n  .search-top-wrap a, .search-top-wrap a:visited {\n    color: #003a90; }\n  .search-top-wrap a:hover {\n    color: #042764;\n    text-decoration: underline; }\n\n.search-top-wrap-before {\n  background-color: white;\n  border-bottom: 1px solid #DFE1E6; }\n  .search-top-wrap-before .topic-search {\n    display: none; }\n  .search-top-wrap-before .form-padding {\n    padding-right: 15px; }\n    @media screen and (max-width: 767px) {\n      .search-top-wrap-before .form-padding {\n        padding-right: 0; } }\n  @media screen and (min-width: 768px) and (max-width: 1139px) {\n    .search-top-wrap-before .btn-submit-horizontal {\n      margin: 0;\n      margin-left: 15px;\n      position: relative;\n      left: -15px; } }\n\n.destination_search .form-control {\n  padding-right: 30px; }\n\n@media screen and (min-width: 768px) {\n  .destination_search.-error-fuild {\n    margin-bottom: 35px; }\n    .destination_search.-error-fuild .ota-text-error {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      margin-top: 5px; } }\n\n.search-summary {\n  display: block; }\n  .search-summary .search-summary-icon {\n    margin-top: 0px;\n    margin-right: 5px; }\n    .search-summary .search-summary-icon img {\n      height: 16px; }\n    .search-summary .search-summary-icon.-search {\n      position: relative;\n      top: 0;\n      margin-left: 5px;\n      margin-right: 0; }\n  .search-summary .cover-search-sum {\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%; }\n    .search-summary .cover-search-sum .headline {\n      color: #6b778c; }\n    .search-summary .cover-search-sum .desc-box {\n      display: -ms-flexbox;\n      display: flex;\n      height: 17px;\n      margin-top: 5px; }\n      .search-summary .cover-search-sum .desc-box i,\n      .search-summary .cover-search-sum .desc-box span {\n        float: left;\n        display: -ms-flexbox;\n        display: flex; }\n    .search-summary .cover-search-sum .search-destination,\n    .search-summary .cover-search-sum .search-date,\n    .search-summary .cover-search-sum .search-num-of-guest,\n    .search-summary .cover-search-sum .search-change {\n      float: left;\n      border-right: 1px dotted #DFE1E6;\n      padding: 0 15px;\n      box-sizing: border-box;\n      cursor: pointer; }\n      @media screen and (max-width: 767px) {\n        .search-summary .cover-search-sum .search-destination,\n        .search-summary .cover-search-sum .search-date,\n        .search-summary .cover-search-sum .search-num-of-guest,\n        .search-summary .cover-search-sum .search-change {\n          border-right: 0; } }\n      .search-summary .cover-search-sum .search-destination .desc-box > span, .search-summary .cover-search-sum .search-destination .desc-box .text-inline,\n      .search-summary .cover-search-sum .search-date .desc-box > span,\n      .search-summary .cover-search-sum .search-date .desc-box .text-inline,\n      .search-summary .cover-search-sum .search-num-of-guest .desc-box > span,\n      .search-summary .cover-search-sum .search-num-of-guest .desc-box .text-inline,\n      .search-summary .cover-search-sum .search-change .desc-box > span,\n      .search-summary .cover-search-sum .search-change .desc-box .text-inline {\n        white-space: nowrap; }\n      .search-summary .cover-search-sum .search-destination:hover .desc-box > span, .search-summary .cover-search-sum .search-destination:hover .desc-box .text-inline,\n      .search-summary .cover-search-sum .search-date:hover .desc-box > span,\n      .search-summary .cover-search-sum .search-date:hover .desc-box .text-inline,\n      .search-summary .cover-search-sum .search-num-of-guest:hover .desc-box > span,\n      .search-summary .cover-search-sum .search-num-of-guest:hover .desc-box .text-inline,\n      .search-summary .cover-search-sum .search-change:hover .desc-box > span,\n      .search-summary .cover-search-sum .search-change:hover .desc-box .text-inline {\n        text-decoration: underline; }\n    .search-summary .cover-search-sum .search-destination {\n      width: 20%;\n      padding: 0 15px 0 0; }\n      .search-summary .cover-search-sum .search-destination .destination-text {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        width: 100%; }\n        @media screen and (max-width: 767px) {\n          .search-summary .cover-search-sum .search-destination .destination-text {\n            width: calc(100vw - 200px); } }\n    .search-summary .cover-search-sum .search-date {\n      width: 30%; }\n    .search-summary .cover-search-sum .search-num-of-guest {\n      width: 30%;\n      border-right: 0; }\n    .search-summary .cover-search-sum .search-change {\n      width: 20%;\n      text-align: right;\n      border-right: 0;\n      margin-top: 24px;\n      padding: 0 0 0 15px; }\n      .search-summary .cover-search-sum .search-change a, .search-summary .cover-search-sum .search-change a:visited {\n        color: #003a90; }\n      .search-summary .cover-search-sum .search-change .icon-search {\n        display: inline-block;\n        font-size: 16px; }\n      .search-summary .cover-search-sum .search-change:hover a {\n        color: #042764;\n        text-decoration: underline; }\n      .search-summary .cover-search-sum .search-change:hover .search-summary-icon {\n        color: #042764; }\n\n.horizontal-search-wrap {\n  padding: 15px 0; }\n\n.input-destination.-layout-topwrap {\n  width: 250px; }\n\n.input-checkin, .input-checkout {\n  width: 175px; }\n\n.input-num-of-guest {\n  width: 290px; }\n\n.btn-submit-horizontal {\n  float: left;\n  width: 160px;\n  margin: 25px 0 0 15px;\n  line-height: 35px; }\n\n.work-personal-box {\n  float: left;\n  max-width: 290px; }\n  .work-personal-box .col-left, .work-personal-box .col-right {\n    width: 50%; }\n  .work-personal-box .col-left {\n    padding-right: 15px; }\n    @media screen and (max-width: 767px) {\n      .work-personal-box .col-left {\n        padding-right: 5px; } }\n  @media screen and (max-width: 767px) {\n    .work-personal-box .col-right {\n      padding-left: 5px; } }\n\n.alert {\n  padding: 8px 15px; }\n\n.close {\n  float: right;\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 1;\n  color: #6b778c;\n  text-shadow: 0 1px 0 #FFFFFF;\n  filter: alpha(opacity=100);\n  opacity: 1; }\n\n.alert-top-wrap {\n  margin: 0 auto;\n  margin-bottom: 15px;\n  width: 100%;\n  max-width: 1140px;\n  background-color: #DFE1E6;\n  color: #576D77;\n  text-align: center; }\n\n.alert-dismissible {\n  padding-right: 15px; }\n  .alert-dismissible .close {\n    position: relative;\n    top: -4px; }\n\nbutton.close {\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: 0 0;\n  border: 0; }\n\n.lvc-radio {\n  white-space: nowrap;\n  padding-bottom: 10px;\n  border-bottom: 1px dotted #DFE1E6; }\n  .lvc-radio .radio-lvc-topic {\n    padding-left: 0;\n    margin-left: 0; }\n  .lvc-radio a,\n  .lvc-radio a:visited,\n  .lvc-radio a:hover {\n    text-decoration: none;\n    color: #FFFFFF; }\n  .lvc-radio .icon-question {\n    color: #003a90; }\n\n.lvc-cancel {\n  width: 100%;\n  text-align: right; }\n  .lvc-cancel a {\n    color: #003a90; }\n    .lvc-cancel a:visited {\n      color: #003a90; }\n    .lvc-cancel a:hover {\n      color: #042764;\n      text-decoration: underline; }\n  @media screen and (max-width: 767px) {\n    .lvc-cancel {\n      display: none; } }\n\n@media screen and (max-width: 767px) {\n  .search-top-wrap {\n    padding: 0;\n    height: auto;\n    border-bottom: 0;\n    background-color: transparent; }\n  .search-top-wrap-before {\n    margin-bottom: 10px;\n    background-color: #FFFFFF;\n    background-size: 100%;\n    padding: 10px;\n    height: auto;\n    width: 100%; }\n  .search-summary {\n    display: block;\n    background-color: #FFFFFF;\n    border: 1px solid #DFE1E6;\n    border-bottom: 3px solid #DFE1E6; }\n    .search-summary .cover-search-sum {\n      position: relative;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n      .search-summary .cover-search-sum .headline {\n        display: none; }\n      .search-summary .cover-search-sum .search-destination {\n        background-color: #FFFFFF;\n        background-image: url(\"/assets/images/icons/search-color.png\");\n        background-repeat: no-repeat;\n        background-position: 15px 10px;\n        background-size: 16px 16px;\n        color: #061021;\n        font-size: 13px;\n        padding: 0 0 0 37px;\n        width: 100%;\n        height: 41px;\n        line-height: 1.5em;\n        border-bottom: 1px solid #DFE1E6;\n        overflow: hidden; }\n        .search-summary .cover-search-sum .search-destination .desc-box {\n          margin-top: 10px; }\n          .search-summary .cover-search-sum .search-destination .desc-box i {\n            display: none; }\n      .search-summary .cover-search-sum .search-date {\n        color: #061021;\n        font-size: 12px;\n        line-height: 1.5;\n        padding: 0 0 0 15px;\n        margin: 7px 0 3px 0;\n        overflow: hidden;\n        width: 100%;\n        border-right: 0; }\n      .search-summary .cover-search-sum .search-num-of-guest {\n        color: #061021;\n        font-size: 12px;\n        line-height: 1.6;\n        padding: 0 0 0 15px;\n        margin: 3px 0 7px 0;\n        width: 100%; }\n      .search-summary .cover-search-sum .search-change {\n        width: 100%;\n        position: absolute;\n        top: -14px;\n        font-size: 13px;\n        padding-right: 15px; }\n        .search-summary .cover-search-sum .search-change i {\n          display: none !important; }\n  .horizontal-search-wrap {\n    padding: 0; }\n  .input-destination {\n    display: block;\n    width: 100% !important;\n    margin-right: 0; }\n  .input-checkin, .input-checkout {\n    width: calc(100% - 5px);\n    margin-right: 0; }\n  .input-checkin {\n    margin-right: 5px; }\n  .input-checkout {\n    margin-left: 5px; }\n  .input-num-of-guest {\n    width: 100%;\n    display: block; }\n  .btn-submit-horizontal {\n    margin: 0 0 0 5px;\n    width: calc(50% - 5px);\n    line-height: 35px; }\n  .btn-cancle-horizontal {\n    float: left;\n    margin: 0 5px 0 0;\n    width: calc(50% - 5px);\n    text-align: center; }\n  .change-search {\n    color: #003a90;\n    font-size: 12px;\n    text-decoration: underline; }\n  .work-personal-box {\n    max-width: 100%;\n    float: none; }\n    .work-personal-box .form-group .col-left {\n      display: block;\n      width: 50%; }\n    .work-personal-box .form-group .col-right {\n      display: block; }\n    .work-personal-box .form-group .form-select {\n      width: 98%; }\n  .alert {\n    padding: 8px 10px; }\n  .alert-dismissible {\n    padding-right: 10px; }\n  .alert-top-wrap {\n    text-align: left;\n    width: 95% !important;\n    font-size: 12px; } }\n\n.select-room-box .form-group-inline label {\n  min-width: auto;\n  min-width: initial;\n  margin-right: 20px; }\n\n.divide-line {\n  width: 100%;\n  border-bottom: 1px dotted #DFE1E6;\n  margin-bottom: 20px; }\n\n.unclickable {\n  pointer-events: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".loading-wrapper {\n  text-align: center;\n  padding-top: 100px;\n  min-height: 320px;\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.wrapper {\n  margin-bottom: 15px; }\n\n.wrapper .action-btn {\n  display: block;\n  line-height: 40px;\n  margin: 0 -15px -10px;\n  text-align: center;\n  color: #003a90;\n  border-top: 2px solid #f5f5f5; }\n  .wrapper .action-btn i {\n    font-size: 16px;\n    display: inline-block;\n    vertical-align: middle; }\n  .wrapper .action-btn span {\n    display: inline-block;\n    vertical-align: middle; }\n  .wrapper .action-btn:hover, .wrapper .action-btn:active {\n    color: #042764; }\n    .wrapper .action-btn:hover span, .wrapper .action-btn:active span {\n      text-decoration: underline; }\n\n.-default {\n  background-color: #FFFFFF;\n  padding: 15px; }\n\n.-gallery {\n  padding: 0; }\n\n@media screen and (max-width: 767px) {\n  .-gallery {\n    display: none; }\n  .-default {\n    padding: 15px 10px; }\n  .wrapper .action-btn {\n    margin: 0 -10px -10px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".container {\n  width: 100%;\n  position: relative;\n  padding: 0; }\n\n.wrapper {\n  min-height: 480px; }\n  @media (max-width: 1024px) {\n    .wrapper {\n      min-height: 380px; } }\n  @media (max-width: 768px) {\n    .wrapper {\n      min-height: 300px; } }\n\n.slide-item {\n  display: none; }\n\n.img-slide {\n  width: 100%;\n  object-fit: cover; }\n\n.activeSlide {\n  display: block; }\n\n.prev, .next {\n  cursor: pointer;\n  position: absolute;\n  top: 50%;\n  width: auto;\n  padding: 16px;\n  margin-top: -22px;\n  color: white;\n  font-size: 32px;\n  transition: 0.6s ease;\n  border-radius: 0 3px 3px 0;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  text-decoration: none;\n  z-index: 1; }\n\n.next {\n  right: 0; }\n\n.nav-dot {\n  position: absolute;\n  bottom: 30px;\n  width: 100%;\n  text-align: center; }\n  .nav-dot .dot {\n    cursor: pointer;\n    height: 8px;\n    width: 8px;\n    margin: 0 7.5px;\n    background-color: #D1D1D1;\n    border-radius: 50%;\n    display: inline-block;\n    transition: background-color 0.6s ease; }\n    .nav-dot .dot.active {\n      background-color: #ed1c24; }\n\n.fadein {\n  -webkit-animation-name: fade;\n  -webkit-animation-duration: 1.5s;\n  animation-name: fade;\n  animation-duration: 1.5s; }\n\n@keyframes fade {\n  from {\n    opacity: .4; }\n  to {\n    opacity: 1; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ":host {\n  display: block;\n  text-align: center;\n  position: relative;\n  height: 70px; }\n  :host .ui-widget.ui-widget-content {\n    top: 10px; }\n  :host .form-control {\n    position: absolute;\n    width: calc(50% - 6px);\n    padding: 6px 10px;\n    display: inline-block; }\n    :host .form-control[readonly] {\n      background-color: white; }\n      :host .form-control[readonly]:focus {\n        border-color: #DFE1E6;\n        box-shadow: none; }\n    :host .form-control.left {\n      left: 0; }\n    :host .form-control.right {\n      right: 0; }\n  :host .dash {\n    position: relative;\n    top: 10px;\n    left: 0.5px; }\n\ninput {\n  font-size: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.rating-row {\n  margin-bottom: 15px;\n  display: table; }\n  @media screen and (max-width: 768px) {\n    .rating-row {\n      display: block; } }\n  .rating-row .rating-title,\n  .rating-row .rating-stars,\n  .rating-row .rating-desc {\n    display: table-cell; }\n    @media screen and (max-width: 768px) {\n      .rating-row .rating-title,\n      .rating-row .rating-stars,\n      .rating-row .rating-desc {\n        display: block; } }\n  .rating-row .rating-title {\n    padding: 0;\n    width: 180px;\n    font-size: 14px;\n    vertical-align: top;\n    color: #061021; }\n    @media screen and (max-width: 768px) {\n      .rating-row .rating-title {\n        width: 100%;\n        margin-bottom: 10px; } }\n  .rating-row .rating-stars {\n    width: 160px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    -ms-flex-align: center;\n        align-items: center; }\n    @media screen and (max-width: 768px) {\n      .rating-row .rating-stars {\n        width: 100%; } }\n    .rating-row .rating-stars .rating-star {\n      width: 20px;\n      height: 20px;\n      cursor: pointer;\n      margin-right: 15px;\n      background-size: cover;\n      text-rendering: auto;\n      -webkit-font-smoothing: antialiased;\n      background-color: transparent;\n      background-image: url(\"/assets/images/icons/icon-rating.png\");\n      background-repeat: no-repeat;\n      background-position: 0 0; }\n      .rating-row .rating-stars .rating-star:last-child {\n        margin-right: 0; }\n      @media screen and (max-width: 768px) {\n        .rating-row .rating-stars .rating-star {\n          height: 32px;\n          width: 32px;\n          margin-right: 15px; } }\n    .rating-row .rating-stars .rating-selected {\n      background-color: transparent;\n      background-image: url(\"/assets/images/icons/icon-rating-active.png\");\n      background-repeat: no-repeat;\n      background-position: 0 0;\n      background-size: cover; }\n    .rating-row .rating-stars .rating-active {\n      background-color: transparent;\n      background-image: url(\"/assets/images/icons/icon-rating-active.png\");\n      background-repeat: no-repeat;\n      background-position: 0 0;\n      background-size: cover; }\n  .rating-row .rating-desc {\n    padding: 0 0 0 20px;\n    width: 100px;\n    font-size: 14px;\n    color: #003a90;\n    vertical-align: top; }\n    @media screen and (max-width: 768px) {\n      .rating-row .rating-desc {\n        display: none; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".wrapper {\n  padding: 15px; }\n  @media screen and (max-width: 767px) {\n    .wrapper {\n      padding: 15px 10px; } }\n  .wrapper .row {\n    padding: 0 15px; }\n    .wrapper .row .col-xs-10,\n    .wrapper .row .col-xs-2 {\n      padding: 0; }\n    @media screen and (max-width: 767px) {\n      .wrapper .row:last-child {\n        padding: 0 15px; } }\n\n.box {\n  display: -ms-flexbox;\n  display: flex; }\n  .box i {\n    padding-right: 10px; }\n  .box .box-text {\n    display: -ms-grid;\n    display: grid; }\n    .box .box-text .title {\n      display: inline; }\n    .box .box-text .sub-title {\n      color: #6b778c; }\n\n.toggle-button {\n  float: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".loading-wrapper {\n  text-align: center;\n  padding-top: 100px;\n  min-height: 320px;\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".toggle-btn {\n  display: inline-block;\n  outline: 0;\n  width: 36px;\n  height: 20px;\n  position: relative;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  background: #DFE1E6;\n  border-radius: 2em;\n  padding: 2px;\n  transition: all 0.4s ease;\n  border: none; }\n\n.toggle-btn::after {\n  left: 0;\n  position: relative;\n  display: block;\n  content: '';\n  width: 50%;\n  height: 100%;\n  border-radius: 2em;\n  background: #fbfbfb;\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), padding 0.3s ease, margin 0.3s ease;\n  box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.1); }\n\n.toggle-btn.toggle-btn-on::after {\n  left: 50%; }\n\n.toggle-btn.toggle-btn-on {\n  background: #3B94F0; }\n\n.toggle-btn.toggle-btn-on:active {\n  box-shadow: none; }\n\n.toggle-btn.toggle-btn-on:active::after {\n  margin-left: -0.8em; }\n\n.toggle-btn:active::after {\n  padding-right: 0.8em; }\n\n.toggle-input {\n  display: none; }\n\n.toggle-btn-on-disabled {\n  background: #80e1cd; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*base-link-mixin*/\n.file-container {\n  width: 100%; }\n  .file-container .inputfile {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1; }\n  .file-container .attach-choose-btn-warp {\n    display: inline-block; }\n    .file-container .attach-choose-btn-warp.disabled {\n      pointer-events: none; }\n  .file-container .attach-button {\n    display: -ms-flexbox;\n    display: flex;\n    color: #061021;\n    background-color: white;\n    height: 40px;\n    margin: auto;\n    text-align: center;\n    line-height: 1;\n    border: 1px solid #DFE1E6;\n    cursor: pointer;\n    border-radius: 4px;\n    width: 157px;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center; }\n    .file-container .attach-button i {\n      font-size: 18px;\n      color: #042764; }\n    .file-container .attach-button:hover {\n      border-color: #d2e3fc;\n      background-color: #e4edff; }\n    .file-container .attach-button:active {\n      border-color: #DFE1E6;\n      background-color: #DFE1E6; }\n    .file-container .attach-button * {\n      pointer-events: none; }\n  .file-container .attach-guide {\n    margin-top: 10px;\n    color: #6b778c;\n    font-size: 12px; }\n  .file-container .attach-button .attach-title {\n    padding-left: 5px; }\n  .file-container .attach-files {\n    height: 60px;\n    width: 345px;\n    font-size: 0;\n    background-color: #F6F8F9;\n    display: -ms-flexbox;\n    display: flex; }\n    .file-container .attach-files:not(:first-child) {\n      margin-top: 10px; }\n    .file-container .attach-files .file-icon,\n    .file-container .attach-files .file-content,\n    .file-container .attach-files .file-clear {\n      position: relative;\n      display: inline-block;\n      vertical-align: top;\n      font-size: 14px;\n      height: 100%;\n      margin: 0; }\n    .file-container .attach-files .file-icon {\n      min-width: 50px; }\n    .file-container .attach-files .file-content {\n      -ms-flex: 1;\n          flex: 1;\n      padding: 14px 0;\n      line-height: 16px;\n      overflow: hidden; }\n    .file-container .attach-files .file-clear {\n      min-width: 30px; }\n    @media screen and (max-width: 767px) {\n      .file-container .attach-files {\n        width: 100%; } }\n  .file-container .button-container.attaching {\n    margin-top: 15px; }\n  .file-container .file-icon i {\n    font-size: 24px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n  .file-container .file-content .name,\n  .file-container .file-content .size {\n    display: block;\n    width: 100%; }\n  .file-container .file-content .name {\n    color: #061021;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden; }\n  .file-container .file-content .size {\n    color: #6b778c; }\n  .file-container .file-clear .close-btn {\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    font-size: 16px;\n    color: #DFE1E6;\n    -ms-flex-pack: end;\n        justify-content: flex-end;\n    -ms-flex-align: center;\n        align-items: center;\n    padding-right: 10px; }\n    .file-container .file-clear .close-btn:hover {\n      cursor: pointer;\n      color: #6b778c; }\n\n.loading {\n  color: transparent;\n  position: relative;\n  margin-left: 5px;\n  margin-right: 15px; }\n  .loading:before {\n    position: absolute;\n    content: \"\";\n    top: 50%;\n    left: 50%;\n    margin: -0.64285714em 0em 0em -0.64285714em;\n    width: 1.28571429em;\n    height: 1.28571429em;\n    border-radius: 500rem;\n    border: 0.2em solid #dddddd; }\n  .loading:after {\n    position: absolute;\n    content: \"\";\n    top: 50%;\n    left: 50%;\n    margin: -0.64285714em 0em 0em -0.64285714em;\n    width: 1.28571429em;\n    height: 1.28571429em;\n    animation: loading 0.6s linear;\n    animation-iteration-count: infinite;\n    border-radius: 500rem;\n    border-color: #FFFFFF transparent transparent;\n    border-style: solid;\n    border-width: 0.2em;\n    box-shadow: 0px 0px 0px 1px transparent; }\n\n@keyframes loading {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(360deg); } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".title {\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: bold; }\n\n.bold {\n  font-weight: 700; }\n\n.container-content {\n  margin-top: 24px;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 0;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  .container-content .form-group {\n    color: #061021;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n        flex-direction: row;\n    -ms-flex-align: center;\n        align-items: center;\n    column-gap: 8px;\n    font-size: 20px;\n    line-height: 24px;\n    margin: 0; }\n    .container-content .form-group label {\n      font-size: 14px;\n      line-height: 18px;\n      margin-bottom: 4px; }\n    .container-content .form-group .prefix-input {\n      height: 40px;\n      width: 100%;\n      border: 1px solid #DFE1E6;\n      border-radius: 4px;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-pack: center;\n          justify-content: center;\n      -ms-flex-align: center;\n          align-items: center;\n      font-weight: 700; }\n    .container-content .form-group input {\n      height: 40px;\n      width: 100%;\n      border: 1px solid #DFE1E6;\n      border-radius: 4px;\n      text-align: center;\n      font-weight: bold; }\n      .container-content .form-group input:focus {\n        border: 1px solid #003A90;\n        box-shadow: 0px 0px 4px 0px #85B6FF;\n        outline: none; }\n  .container-content .message {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    margin-top: 8px; }\n  .container-content .text-link {\n    color: #003A90; }\n    .container-content .text-link:hover {\n      text-decoration: underline;\n      cursor: pointer; }\n  .container-content .error {\n    margin-top: 8px;\n    color: #ED1C24;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: start;\n        align-items: flex-start; }\n    .container-content .error .icon-warning {\n      margin-top: 2px;\n      font-size: 12px;\n      margin-right: 5px; }\n    .container-content .error .error-text {\n      font-size: 12px;\n      line-height: 17px; }\n  .container-content .text-link-disable {\n    color: #A5ADBA !important; }\n    .container-content .text-link-disable:hover {\n      text-decoration: unset;\n      cursor: auto; }\n\n@media screen and (min-width: 768px) {\n  .title {\n    font-size: 20px;\n    line-height: 24px; } }\n\n/* Make input type number not show Arrow in Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0; }\n\n/* Make input type number not show Arrow in Firefox */\ninput[type=number] {\n  -moz-appearance: textfield; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".title {\n  font-size: 20px;\n  line-height: 24px;\n  font-weight: bold;\n  margin-bottom: 2px; }\n\n.container-content {\n  margin-top: 24px;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 12px;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n\n.verify-method-option {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 16px;\n  height: 84px;\n  padding: 12px 16px;\n  border: 2px solid #DFE1E6;\n  border-radius: 8px; }\n  .verify-method-option:hover {\n    background-color: #F6F8F9;\n    cursor: pointer; }\n  .verify-method-option.loading {\n    pointer-events: none; }\n\n.verify-method-icon img {\n  height: 40px;\n  width: 66px; }\n\n.verify-method-box {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  width: 100%; }\n  .verify-method-box .verify-method-info .verify-method-title {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 20px;\n    margin-bottom: 4px; }\n  .verify-method-box .verify-next-btn .loader {\n    margin-right: 16px; }\n\n.loader {\n  animation-play-state: running;\n  opacity: 1;\n  position: relative; }\n\n@keyframes spinner {\n  0% {\n    transform: translate3d(-50%, -50%, 0) rotate(0deg); }\n  100% {\n    transform: translate3d(-50%, -50%, 0) rotate(360deg); } }\n  .loader.-paused {\n    animation-play-state: paused;\n    opacity: 0.2;\n    transition: opacity linear 0.1s; }\n  .loader::before {\n    animation: 1s linear infinite spinner;\n    animation-play-state: inherit;\n    border: solid 3px #dedede;\n    border-bottom-color: rgba(0, 0, 0, 0.4);\n    border-radius: 50%;\n    content: \"\";\n    height: 16px;\n    left: 50%;\n    opacity: inherit;\n    position: absolute;\n    top: 50%;\n    transform: translate3d(-50%, -50%, 0);\n    width: 16px;\n    will-change: transform;\n    left: 8px; }\n\n@media screen and (min-width: 768px) {\n  .title {\n    font-size: 20px;\n    line-height: 24px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ":host /deep/ .dialog-wrapper-content {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: 100vh; }\n\n.dialog-content {\n  padding: 24px 12px 12px !important;\n  overflow: auto;\n  -ms-flex-positive: 1;\n      flex-grow: 1; }\n\n.action-button {\n  padding: 12px;\n  border-top: 1px solid #DFE1E6;\n  text-align: center;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  gap: 12px; }\n  .action-button button {\n    max-width: 180px;\n    margin-bottom: 0; }\n  .action-button .ota-btn-main:disabled {\n    background-color: #DFE1E6;\n    color: #A5ADBA; }\n\n@media screen and (min-width: 768px) {\n  :host /deep/ .dialog-wrapper-content {\n    height: unset;\n    width: 480px !important;\n    min-height: 400px !important;\n    padding: 0 !important; }\n  .dialog-content {\n    height: unset;\n    max-height: 60vh;\n    padding: 24px 16px 12px !important; }\n  .action-button {\n    padding: 12px 16px;\n    gap: 16px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "a {\n  color: #042764; }\n  a:hover {\n    text-decoration: underline; }\n\n.title {\n  color: #061021;\n  font-size: 20px;\n  font-weight: 700; }\n\n.dialog-container {\n  padding: 0px 16px 24px !important; }\n  .dialog-container .full-name-group {\n    margin-bottom: 20px; }\n  .dialog-container .time-of-birth {\n    width: 50%;\n    float: none;\n    padding-left: 0; }\n\n.action-button {\n  padding: 12px 16px;\n  border-top: 1px solid #DFE1E6;\n  text-align: right;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center; }\n  .action-button button {\n    max-width: 180px;\n    margin-bottom: 0; }\n\n:host /deep/ .dialog-header .pull-left {\n  width: 100%;\n  padding: 12px 16px;\n  margin-bottom: 12px; }\n  :host /deep/ .dialog-header .pull-left .dialog-title {\n    color: #061021;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 24px; }\n\n:host /deep/ .dialog-wrapper-content {\n  width: 750px !important;\n  padding: 0 !important;\n  min-height: unset !important; }\n\n:host /deep/ .close-box {\n  position: absolute;\n  right: 33px;\n  margin-top: 10px;\n  z-index: 4; }\n  :host /deep/ .close-box .icon-close.button {\n    color: #6b778c; }\n\n:host /deep/ .mat-dialog-content {\n  padding: 0px !important; }\n\n:host /deep/ .box-select-address {\n  width: 100% !important;\n  margin-top: 15px !important; }\n\n:host /deep/ .address-inner {\n  padding-bottom: 0 !important; }\n\n@media screen and (max-width: 767px) {\n  :host /deep/ .dialog-header .close-box {\n    right: 15px;\n    margin-top: 12px; }\n  :host /deep/ .dialog-header .pull-left {\n    border-bottom: none !important;\n    padding: 12px !important;\n    margin-bottom: 12px !important;\n    background: #FFFFFF;\n    z-index: 3;\n    width: 100%; }\n    :host /deep/ .dialog-header .pull-left .dialog-title {\n      color: #061021;\n      font-size: 16px;\n      font-weight: 700; }\n  :host /deep/ .dialog-wrapper-content {\n    width: 100% !important;\n    padding: 0px !important;\n    height: 100vh !important;\n    overflow-y: scroll; }\n    :host /deep/ .dialog-wrapper-content .dialog-container {\n      height: calc(var(--height-vh, 1vh) * 100 - 65px) !important;\n      padding: 0px 16px 24px !important; }\n  :host /deep/ .action-button {\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 2;\n    background: #FFFFFF;\n    gap: 16px; }\n    :host /deep/ .action-button > * {\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n      max-width: unset !important; }\n  :host /deep/ .title {\n    color: #061021;\n    font-size: 16px;\n    font-weight: 700; }\n  :host /deep/ .col-md-4 {\n    width: 33.33%; }\n  :host /deep/ .time-of-birth {\n    width: 100% !important; } }\n\n.mt-4 {\n  margin-top: 4px; }\n\n.mb-0 {\n  margin-bottom: 0; }\n\n.pr-0 {\n  padding-right: 0; }\n\n.pl-16 {\n  padding-left: 16px; }\n\n.pr-16 {\n  padding-right: 16px; }\n\n.form-group {\n  margin-bottom: 16px; }\n\nlabel {\n  font-weight: normal;\n  margin-bottom: 4px; }\n\n.sub-text {\n  font-size: 12px;\n  line-height: 14px;\n  color: #6B778C; }\n\n.text-description {\n  font-size: 12px;\n  line-height: 14px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".page-not-found {\n  text-align: center;\n  width: 100%;\n  height: 100%;\n  margin-top: -90px; }\n  .page-not-found .page-not-found-description {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 100%;\n    transform: translate(-50%, -50%);\n    padding: 10px; }\n    .page-not-found .page-not-found-description .img-responsive {\n      margin: auto; }\n    .page-not-found .page-not-found-description .text-not-found-strong {\n      margin-top: 30px;\n      font-size: 24px; }\n    .page-not-found .page-not-found-description .text-not-found {\n      color: #6b778c;\n      margin-top: 10px;\n      font-size: 18px; }\n\n@media screen and (max-width: 767px) {\n  .text-not-found-strong {\n    font-size: 20px !important; }\n  .text-not-found {\n    font-size: 14px !important; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 320,
	"./af.js": 320,
	"./ar": 327,
	"./ar-dz": 321,
	"./ar-dz.js": 321,
	"./ar-kw": 322,
	"./ar-kw.js": 322,
	"./ar-ly": 323,
	"./ar-ly.js": 323,
	"./ar-ma": 324,
	"./ar-ma.js": 324,
	"./ar-sa": 325,
	"./ar-sa.js": 325,
	"./ar-tn": 326,
	"./ar-tn.js": 326,
	"./ar.js": 327,
	"./az": 328,
	"./az.js": 328,
	"./be": 329,
	"./be.js": 329,
	"./bg": 330,
	"./bg.js": 330,
	"./bn": 331,
	"./bn.js": 331,
	"./bo": 332,
	"./bo.js": 332,
	"./br": 333,
	"./br.js": 333,
	"./bs": 334,
	"./bs.js": 334,
	"./ca": 335,
	"./ca.js": 335,
	"./cs": 336,
	"./cs.js": 336,
	"./cv": 337,
	"./cv.js": 337,
	"./cy": 338,
	"./cy.js": 338,
	"./da": 339,
	"./da.js": 339,
	"./de": 342,
	"./de-at": 340,
	"./de-at.js": 340,
	"./de-ch": 341,
	"./de-ch.js": 341,
	"./de.js": 342,
	"./dv": 343,
	"./dv.js": 343,
	"./el": 344,
	"./el.js": 344,
	"./en-au": 345,
	"./en-au.js": 345,
	"./en-ca": 346,
	"./en-ca.js": 346,
	"./en-gb": 347,
	"./en-gb.js": 347,
	"./en-ie": 348,
	"./en-ie.js": 348,
	"./en-nz": 349,
	"./en-nz.js": 349,
	"./eo": 350,
	"./eo.js": 350,
	"./es": 352,
	"./es-do": 351,
	"./es-do.js": 351,
	"./es.js": 352,
	"./et": 353,
	"./et.js": 353,
	"./eu": 354,
	"./eu.js": 354,
	"./fa": 355,
	"./fa.js": 355,
	"./fi": 356,
	"./fi.js": 356,
	"./fo": 357,
	"./fo.js": 357,
	"./fr": 360,
	"./fr-ca": 358,
	"./fr-ca.js": 358,
	"./fr-ch": 359,
	"./fr-ch.js": 359,
	"./fr.js": 360,
	"./fy": 361,
	"./fy.js": 361,
	"./gd": 362,
	"./gd.js": 362,
	"./gl": 363,
	"./gl.js": 363,
	"./gom-latn": 364,
	"./gom-latn.js": 364,
	"./he": 365,
	"./he.js": 365,
	"./hi": 366,
	"./hi.js": 366,
	"./hr": 367,
	"./hr.js": 367,
	"./hu": 368,
	"./hu.js": 368,
	"./hy-am": 369,
	"./hy-am.js": 369,
	"./id": 370,
	"./id.js": 370,
	"./is": 371,
	"./is.js": 371,
	"./it": 372,
	"./it.js": 372,
	"./ja": 373,
	"./ja.js": 373,
	"./jv": 374,
	"./jv.js": 374,
	"./ka": 375,
	"./ka.js": 375,
	"./kk": 376,
	"./kk.js": 376,
	"./km": 377,
	"./km.js": 377,
	"./kn": 378,
	"./kn.js": 378,
	"./ko": 379,
	"./ko.js": 379,
	"./ky": 380,
	"./ky.js": 380,
	"./lb": 381,
	"./lb.js": 381,
	"./lo": 382,
	"./lo.js": 382,
	"./lt": 383,
	"./lt.js": 383,
	"./lv": 384,
	"./lv.js": 384,
	"./me": 385,
	"./me.js": 385,
	"./mi": 386,
	"./mi.js": 386,
	"./mk": 387,
	"./mk.js": 387,
	"./ml": 388,
	"./ml.js": 388,
	"./mr": 389,
	"./mr.js": 389,
	"./ms": 391,
	"./ms-my": 390,
	"./ms-my.js": 390,
	"./ms.js": 391,
	"./my": 392,
	"./my.js": 392,
	"./nb": 393,
	"./nb.js": 393,
	"./ne": 394,
	"./ne.js": 394,
	"./nl": 396,
	"./nl-be": 395,
	"./nl-be.js": 395,
	"./nl.js": 396,
	"./nn": 397,
	"./nn.js": 397,
	"./pa-in": 398,
	"./pa-in.js": 398,
	"./pl": 399,
	"./pl.js": 399,
	"./pt": 401,
	"./pt-br": 400,
	"./pt-br.js": 400,
	"./pt.js": 401,
	"./ro": 402,
	"./ro.js": 402,
	"./ru": 403,
	"./ru.js": 403,
	"./sd": 404,
	"./sd.js": 404,
	"./se": 405,
	"./se.js": 405,
	"./si": 406,
	"./si.js": 406,
	"./sk": 407,
	"./sk.js": 407,
	"./sl": 408,
	"./sl.js": 408,
	"./sq": 409,
	"./sq.js": 409,
	"./sr": 411,
	"./sr-cyrl": 410,
	"./sr-cyrl.js": 410,
	"./sr.js": 411,
	"./ss": 412,
	"./ss.js": 412,
	"./sv": 413,
	"./sv.js": 413,
	"./sw": 414,
	"./sw.js": 414,
	"./ta": 415,
	"./ta.js": 415,
	"./te": 416,
	"./te.js": 416,
	"./tet": 417,
	"./tet.js": 417,
	"./th": 418,
	"./th.js": 418,
	"./tl-ph": 419,
	"./tl-ph.js": 419,
	"./tlh": 420,
	"./tlh.js": 420,
	"./tr": 421,
	"./tr.js": 421,
	"./tzl": 422,
	"./tzl.js": 422,
	"./tzm": 424,
	"./tzm-latn": 423,
	"./tzm-latn.js": 423,
	"./tzm.js": 424,
	"./uk": 425,
	"./uk.js": 425,
	"./ur": 426,
	"./ur.js": 426,
	"./uz": 428,
	"./uz-latn": 427,
	"./uz-latn.js": 427,
	"./uz.js": 428,
	"./vi": 429,
	"./vi.js": 429,
	"./x-pseudo": 430,
	"./x-pseudo.js": 430,
	"./yo": 431,
	"./yo.js": 431,
	"./zh-cn": 432,
	"./zh-cn.js": 432,
	"./zh-hk": 433,
	"./zh-hk.js": 433,
	"./zh-tw": 434,
	"./zh-tw.js": 434
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 977;


/***/ }),
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */
/***/ (function(module, exports) {

module.exports = "<router-outlet></router-outlet>\n"

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports = "<div class=\"account-menu-container\">\n    <div class=\"box-user-display\">\n      <!-- <div class=\"box-thumb\"><img src=\"{{getUserPicture()}}\"></div> -->\n      <div class=\"box-detail\">\n        <span class=\"font-16px font-bold\">{{'menu-bar-account' | translate}}</span><br>\n        <span *ngIf=\"user?.fullName\">\n          <i class=\"icon-user font-12px\"></i>\n          <span class=\"font-12px align-text-bottom\" title=\"{{user?.fullName}}\">{{user?.fullName}}</span><br>\n        </span>\n        <span *ngIf=\"user?.username && !isB2C\">\n          <i class=\"icon-mail font-12px\"></i>\n          <span class=\"font-12px align-text-bottom\" title=\"{{user?.username}}\">{{user?.username}}</span>\n        </span>\n      </div>\n    </div>\n    <div class=\"box-menu-display\">\n      <ul class=\"nav-account-menu\">\n        <li id=\"account-menu-bar-lnk-booking\" routerLink=\"/booking\" [queryParams]=\"{lang: getLang()}\" [ngClass]=\"{'active': currentPage == 'booking'}\">\n          <a>\n            <i class=\"icon-my-booking-2 icon-nav\"></i>\n            <span>{{ 'menu-bar-booking' | translate }}</span>\n          </a>\n        </li>\n        <li id=\"account-menu-bar-lnk-approval\" routerLink=\"/approval\" [queryParams]=\"{lang: getLang()}\" [ngClass]=\"{'active': currentPage == 'approval'}\"\n          *ngIf=\"showApprovalList\">\n          <a>\n            <i class=\"icon-approve-2 icon-nav\"></i>\n            <span>{{'menu-bar-approval' | translate}}</span>\n          </a>\n        </li>\n        <li id=\"account-menu-bar-lnk-my-budget\" routerLink=\"/permission\" [queryParams]=\"{lang: getLang()}\" [ngClass]=\"{'active': currentPage == 'budget'}\"\n          *ngIf=\"showPermission\">\n          <a>\n            <i class=\"icon-budget icon-nav\" ></i>\n            <span>{{ 'account-menu-bar-my-budget' | translate  }}</span>\n          </a>\n        </li>\n        <li id=\"account-menu-bar-lnk-fleet-card\" routerLink=\"/fleet-card\" [queryParams]=\"{lang: getLang()}\" [ngClass]=\"{'active': currentPage == 'fleet-card'}\"\n          *ngIf=\"showFleetMenu\">\n          <a>\n            <i class=\"icon-fleet icon-nav\" ></i>\n            <span>{{ 'account-menu-bar-fleet-card' | translate  }}</span>\n          </a>\n        </li>\n        <li id=\"account-menu-bar-lnk-pre-approval-requests\" *ngIf=\"showPreApprovalRequester\">\n          <a [href]=\"redirectURIV2 + '/account/pre-approval/requests'\">\n            <i class=\"icon-pre-approval icon-nav\"></i>\n            <span>{{'menu-bar-pre-approval-requests' | translate}}</span>\n          </a>\n        </li>\n        <li id=\"account-menu-bar-lnk-pre-approval-approvals\" *ngIf=\"showPreApprovalApprover\">\n          <a [href]=\"redirectURIV2 + '/account/pre-approval/approvals'\">\n            <i class=\"icon-approve-2 icon-nav\"></i>\n            <span>{{'menu-bar-pre-approval-approvals' | translate}}</span>\n          </a>\n        </li>\n        <li id=\"account-menu-bar-lnk-profile\" routerLink=\"/profile\" [queryParams]=\"{lang: getLang()}\" [ngClass]=\"{'active': currentPage == 'profile'}\" class=\"border-top-solid\">\n          <a>\n            <i class=\"icon-user icon-nav\" ></i>\n            <span>{{ 'account-menu-bar-profile' | translate  }}</span>\n          </a>\n        </li>\n        <li id=\"account-menu-bar-lnk-setting\" routerLink=\"/setting\" [queryParams]=\"{lang: getLang()}\" [ngClass]=\"{'active': currentPage == 'setting'}\">\n          <a>\n            <i class=\"icon-setting-2 icon-nav\"></i>\n            <span>{{ 'account-menu-bar-account-security' | translate }}</span>\n          </a>\n        </li>\n        <li id=\"account-menu-bar-lnk-share-budget-code\" routerLink=\"/share-budget-code\" [queryParams]=\"{lang: getLang()}\"\n          [ngClass]=\"{'active': currentPage == 'share-budget-code'}\" *ngIf=\"showPermission\">\n          <a>\n            <i class=\"icon-link icon-nav\" ></i>\n            <span>{{ 'account-menu-bar-share-budget-code' | translate  }}</span>\n          </a>\n        </li>\n        <li>\n          <a id=\"account-menu-bar-lnk-logout\" (click)=\"userService.logout()\">\n            <i class=\"icon-logout-2 icon-nav\"></i>\n            <span>{{'account-menu-bar-logout' | translate}}</span>\n          </a>\n        </li>\n      </ul>\n    </div>\n</div>\n"

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports = "<img class=\"act-image {{contentClass}}\" src=\"{{defaultImage}}\" (error)=\"onImgError($event)\" srcset=\"{{scaleFactorImage}}\" alt=\"\">\n"

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports = "<div\n  *ngIf=\"label\"\n  class=\"tex-area-label\">\n  {{label}}\n</div>\n<textarea\n  [id]=\"id\"\n  [placeholder]=\"placeholder\"\n  [maxLength]=\"maxLength\"\n  [ngClass]=\"isError ? 'input-error' : ''\"\n  (keyup)=\"onKeyup($event)\"\n  (keydown.space)=\"onKeySpace($event)\"\n  (focusout)=\"onFocusOut($event)\">\n</textarea>\n<span\n  *ngIf=\"isError && errorText\"\n  class=\"text-error mt-0\">\n  {{errorText}}\n</span>"

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box-select-address\" [ngClass]=\"{\n    'selected': isSelected(),\n    '-full-width': options?.page !== 'profile',\n    '-first-child': index === 0\n  }\">\n  <form class=\"content-table\" [formGroup]=\"form\">\n    <div class=\"address-inner\">\n      <div class=\"form-group\">\n        <label for=\"address-form-txt-name-{{index}}\">{{ 'my-profile-address-form-company-name' | translate }}</label>\n        <input #title type=\"text\" class=\"form-control\" id=\"address-form-txt-name-{{index}}\"\n          placeholder=\"{{ 'my-profile-address-form-company-name-placeholder' | translate }}\" formControlName=\"title\"\n          (blur)=\"removeSpaceBetween($event, 'title')\"\n          [ngClass]=\"{\n            'input-error': isInvalid('title'),\n            'input-success': form.get('title').valid\n          }\">\n        <span *ngIf=\"isInvalid('title') && !form.get('title').value || formErrors?.title?.required\" class=\"text-error\">\n          {{ 'validation-required-title' | translate }}\n        </span>\n      </div>\n      <div class=\"form-group\">\n        <label\n          for=\"address-form-txt-taxnumber-{{index}}\">{{ 'my-profile-address-form-tax-number-id' | translate }}</label>\n        <input #taxNumber type=\"text\" class=\"form-control\" id=\"address-form-txt-taxnumber-{{index}}\"\n            placeholder=\"{{ 'my-profile-address-form-tax-number-id-placeholder' | translate }}\"\n            formControlName=\"taxNumber\" maxlength=\"20\"\n            [ngClass]=\"{\n              'input-error': isInvalid('taxNumber'),\n              'input-success': form.get('taxNumber').valid\n          }\">\n        <span *ngIf=\"isInvalid('taxNumber') && !form.get('taxNumber').value || formErrors?.taxNumber?.required\"\n          class=\"text-error\">\n          {{ 'validation-required-tax-number' | translate }}\n        </span>\n        <span *ngIf=\"isInvalid('taxNumber') && form.get('taxNumber').value || formErrors?.taxNumber?.pattern\"\n          class=\"text-error\">\n          {{ 'validation-invalid-tax-number' | translate }}\n        </span>\n      </div>\n      <div class=\"form-group\">\n        <label\n          for=\"address-form-txt-address-{{index}}\">{{ 'my-profile-address-form-billing-address' | translate }}</label>\n        <textarea #address class=\"form-control\" rows=\"3\" id=\"address-form-txt-address-{{index}}\"\n          placeholder=\"{{ 'my-profile-address-form-billing-address-placeholder' | translate }}\"\n          formControlName=\"address\"\n          (blur)=\"removeSpace($event, 'address')\"\n          [ngClass]=\"{\n            'input-error': isInvalid('address'),\n            'input-success': form.get('address').valid\n          }\"></textarea>\n        <span *ngIf=\"isInvalid('address') && !form.get('address').value || formErrors?.address?.required\"\n          class=\"text-error\">\n          {{ 'validation-required-invoice-address' | translate }}\n        </span>\n      </div>\n      <div class=\"address-button\" *ngIf=\"isDisplayButton\">\n        <button id=\"address-form-btn-cancel-{{index}}\" type=\"button\" class=\"ota-btn-sub btn-horizontal\"\n          (click)=\"handleCancel()\">\n          {{ 'my-profile-address-form-btn-cancel' | translate }}\n        </button>\n        <button id=\"address-form-btn-save-{{index}}\" class=\"ota-btn-main btn-horizontal\" tabindex=\"1\"\n          [ngClass]=\"{'loading': isLoading}\">\n          {{ 'my-profile-address-form-btn-submit' | translate }}\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports = "<div class=\"content-address {{ options?.page }}\">\n  <div id=\"address-list-{{options.credit}}-div-item-{{i}}\" *ngFor=\"let address of addressData; let i = index\">\n    <div *ngIf=\"!isEdit(address)\" class=\"box-select-address\" [ngClass]=\"{\n        'selected': isSelectedAddress(address, i),\n        '-full-width': options?.page !== 'profile'\n      }\">\n      <label class=\"radio-address\" [ngClass]=\"{'-can-select': options.selectable}\" id=\"selectedAddress-label-{{options.page}}-{{i}}\">\n        <input type=\"radio\" name=\"selectedAddress-{{options.page}}\" *ngIf=\"options.selectable\"\n          [checked]=\"isChecked(address, i)\" (change)=\"onAddressSelected(address)\">\n\n        <div class=\"address-detail\">\n          <strong id=\"address-list-{{options.credit}}-txt-company-{{i}}\">{{ address.title }}</strong>\n          <p>\n            {{ 'my-profile-address-form-tax-number' | translate }} <span\n              id=\"address-list-{{options.credit}}-txt-tax-no-{{i}}\">{{ address.taxNumber }}</span><br>\n            <span id=\"address-list-{{options.credit}}-txt-address-{{i}}\">{{ address.address }}</span>\n          </p>\n          <div class=\"delete-address\" *ngIf=\"options?.editable\">\n            <a id=\"address-list-{{options.credit}}-btn-delete-{{i}}\" (click)=\"handleDeleteAddress(address)\">\n              <i class=\"icon-delete2 mr-3\"></i>\n              {{'my-profile-delete' | translate}}\n            </a>\n          </div>\n          <div class=\"edit-address\" *ngIf=\"options?.editable\">\n            <a id=\"address-list-{{options.credit}}-btn-edit-{{i}}\" (click)=\"handleEditAddress(address)\">\n              <i class=\"icon-edit mr-3\"></i>\n              {{'my-profile-edit'| translate}}\n            </a>\n          </div>\n        </div>\n      </label>\n    </div>\n    <div *ngIf=\"isEdit(address)\">\n      <act-address-form #addressFormList [options]=\"options\" [index]=\"i\" [isActiveSelected]=\"true\"\n        [isDisplayButton]=\"true\" [selectedAddressInfo]=\"selectedAddress\" [addressInfo]=\"address\"\n        (onCancelAddressInfo)=\"handleUpdateAddressInfo($event)\" (onUpdateAddressInfo)=\"handleUpdateAddressInfo($event)\"\n        (onEditAddressInfo)=\"handleEditAddressInfo($event)\">\n      </act-address-form>\n    </div>\n  </div>\n  <div *ngIf=\"currentState === STATE.ADD\">\n    <act-address-form #addressFormAdd [options]=\"options\" [index]=\"new-address\" [isActiveSelected]=\"true\"\n      [isDisplayButton]=\"!oneTimeAddress\" [selectedAddressInfo]=\"selectedAddress\"\n      (onCancelAddressInfo)=\"handleCancelAddAddressInfo($event)\" (onUpdateAddressInfo)=\"handleAddAddressInfo($event)\"\n      (onEditAddressInfo)=\"handleEditAddressInfo($event)\">\n    </act-address-form>\n  </div>\n  <!-- <div *ngIf=\"oneTimeAddress\">\n      <act-address-form #addressFormOneTime\n        [options]=\"options\"\n        [index]=\"one-time-address\"\n        [isActiveSelected]=\"true\"\n        [isDisplayButton]=\"false\"\n        [selectedAddressInfo]=\"selectedAddress\"\n        (onCancelAddressInfo)=\"handleCancelAddAddressInfo($event)\"\n        (onUpdateAddressInfo)=\"handleAddAddressInfo($event)\"\n        (onEditAddressInfo)=\"handleEditAddressInfo($event)\">\n      </act-address-form>\n    </div> -->\n  <a *ngIf=\"addressData && addressData.length < limitAddress && options?.editable && currentState !== STATE.ADD && selectedEditAddress.state !== 'edit'\"\n    id=\"address-list-{{options.credit}}-btn-add-new-address\" class=\"add-address\" (click)=\"handleAddAddress()\">\n    <i class=\"fa fa-plus-circle\"></i>\n    <span>{{'my-profile-add-tax' | translate}}</span>\n  </a>\n</div>"

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports = "<div class=\"approval-button {{ options?.page }}\">\n  <div class=\"button-block -left\">\n    <div class=\"button-wrapper\">\n      <div class=\"btn-approval-reject\" [ngClass]=\"{'disable-btn': disabledRejectBtn}\" id=\"approval-btn-reject-{{display}}-{{index}}\" (click)=\"onRejectButtonClicked()\">\n        <div class=\"btn-container\">\n          <i class=\"icon-close\"></i>\n          <span>{{ 'approval-button-reject' | translate }}</span>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"separator-block\">\n    <div class=\"separator\">|</div>\n  </div>\n  <div class=\"button-block -right\">\n    <div class=\"button-wrapper\">\n      <div class=\"btn-approval-approve\" id=\"approval-btn-approve-{{display}}-{{index}}\" (click)=\"onApproveButtonClicked()\">\n          <div class=\"btn-container\">\n            <i *ngIf=\"!isApproveLoading\" class=\"icon-list-approve\"></i>\n            <span *ngIf=\"isApproveLoading\" class=\"loading-wrapper loading\" ></span>\n            <span [ngClass]=\"{'ml-30': isApproveLoading}\">{{ 'approval-button-approve' | translate }}</span>\n          </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"loading.PAGE\" id=\"approval-action-loading\" class=\"loading-box\">\n  <img class=\"ota-loading\" src=\"assets/images/loading/loading.png\">\n</div>\n\n<div\n  *ngIf=\"state[STATE.APPROVED] || state[STATE.REJECTED] || state[STATE.SERVICE_FAILED] || state[STATE.UNABLE_APPROVAL]\"\n  id=\"approval-action-status\" class=\"approval-content\">\n  <div *ngIf=\"state[STATE.APPROVED]\" id=\"approved\" class=\"title\">\n    <img class=\"icon-header\" src=\"assets/images/icons/icon-approve.png\">\n    <p class=\"header\">{{ 'approval-action-success-approve' | translate }}</p>\n  </div>\n  <div *ngIf=\"state[STATE.REJECTED]\" id=\"rejected\" class=\"title\">\n    <img class=\"icon-header\" src=\"assets/images/icons/icon-reject.png\">\n    <p class=\"header\">{{ 'approval-action-success-reject' | translate }}</p>\n  </div>\n  <div *ngIf=\"state[STATE.UNABLE_APPROVAL]\" id=\"unable-approval\" class=\"title\">\n    <img class=\"icon-header\" id=\"unable-approval-img\" src=\"assets/images/icons/Error.png\">\n    <br>\n    <p id=\"unable-approval-head\" class=\"header\">{{ 'approval-action-unable-approval' | translate }}</p>\n    <p id=\"unable-approval-desc\" class=\"desc\">{{ 'approval-action-unable-approval-detail' | translate }}</p>\n  </div>\n  <div *ngIf=\"state[STATE.SERVICE_FAILED]\" id=\"service-failed\" class=\"title text-warning\">\n    <i class=\"icon icon-error-approve\"></i>\n    <p class=\"header text-black\">{{ 'approval-action-fail-service' | translate }}</p>\n    <p class=\"desc\">{{ 'approval-action-fail-service-desc' | translate }}</p>\n  </div>\n  <p *ngIf=\"!state[STATE.UNABLE_APPROVAL]\" id=\"thankyou\" class=\"text-section\">\n    <span>{{ 'approval-action-thankyou-1' | translate }}</span><br />\n    <span>{{ 'approval-action-thankyou-2' | translate }}</span>\n  </p>\n  <div *ngIf=\"!state[STATE.UNABLE_APPROVAL]\" id=\"link-button\" class=\"btn-parent success\">\n    <button (click)=\"goToHome()\" class=\"ota-btn-default\">{{ 'approval-action-btn-home' | translate }}</button>\n    <button (click)=\"goToApprovalList()\" class=\"ota-btn-main\">{{ 'approval-action-btn-approval-list' | translate\n      }}</button>\n  </div>\n  <div *ngIf=\"state[STATE.UNABLE_APPROVAL]\" id=\"link-button\" class=\"btn-parent\">\n    <button (click)=\"goToApprovalList()\" class=\"ota-btn-main\">{{ 'approval-action-btn-approval-list' | translate\n      }}</button>\n  </div>\n</div>\n\n<div *ngIf=\"state[STATE.REJECT_WITH_FEE] || state[STATE.REJECT_FREE]\" id=\"approval-reject-fee\"\n  class=\"approval-content approval-cancellation-fee\">\n  <div class=\"acf-overflow\">\n    <h4 class=\"header\">{{'booking-cancellation-fee-3' | translate}} : <span\n        class=\"title-detail\">{{'booking-cancellation-booking-id' | translate}} {{bookingId}}</span></h4>\n    <div *ngIf=\"state[STATE.REJECT_FREE]\" id=\"reject\" class=\"box-overflow\">\n      <div class=\"topic-box space-0\">{{'booking-cancellation-free-2' | translate}}</div>\n    </div>\n\n    <div *ngIf=\"state[STATE.REJECT_WITH_FEE]\" id=\"reject-fee\" class=\"box-overflow\">\n      <div class=\"topic-box\">{{'booking-cancellation-if-cancel-text-2' | translate}}</div>\n      <div class=\"table-list-room\">\n        <div class=\"table-head\">\n          <div class=\"col-left\">{{'booking-cancellation-room-type' | translate}}</div>\n          <div class=\"col-right fee-topics\">{{'booking-cancellation-fee' | translate}}</div>\n        </div>\n        <div class=\"table-body\" *ngFor=\"let cancellationChargeItem of cancellationChargeList; let i = index\">\n          <div class=\"table-item\">\n            <div class=\"col-left\">\n              <div>\n                <div [ngSwitch]=\"currentLang\">\n                  <ng-template ngSwitchCase=\"en\">\n                    <span class=\"room-type\">{{ cancellationChargeItem?.roomTypeTitleEN }}</span>\n                    <span class=\"room-condition\">({{ cancellationChargeItem?.roomConditionTitleEN }})</span>\n                    <div class=\"cl-condition\">\n                      <span class=\"cc-title\" id=\"cancellation-popup-condition-policy-title-{{i}}\">Cancellation\n                        policy</span>\n                      <span *ngIf=\"cancellationChargeItem?.cancellationDate; else nonRefundEn\"\n                        id=\"cancellation-popup-condition-charge-policy-{{i}}\"> If cancel after\n                        {{cancellationChargeItem?.cancellationDate}}, will incur cancellation\n                        charge for THB\n                        {{cancellationChargeItem.chargeRoomAmount | number:'.2'}}\n                        per room</span>\n                      <ng-template #nonRefundEn>\n                        <span id=\"cancellation-popup-condition-charge-policy-{{i}}\"> Non-Refundable</span>\n                      </ng-template>\n                    </div>\n                  </ng-template>\n                  <ng-template ngSwitchCase=\"th\">\n                    <span class=\"room-type\">{{ cancellationChargeItem?.roomTypeTitleTH }}</span>\n                    <span class=\"room-condition\">({{ cancellationChargeItem?.roomConditionTitleTH }})</span>\n                    <div class=\"cl-condition\">\n                      <span class=\"cc-title\"\n                        id=\"cancellation-popup-condition-policy-title-{{i}}\">เงื่อนไขการยกเลิกห้องพัก</span>\n                      <span *ngIf=\"cancellationChargeItem?.cancellationDate; else nonRefundTh\"\n                        id=\"cancellation-popup-condition-charge-policy-{{i}}\"> หากยกเลิกหลังวันที่\n                        {{cancellationChargeItem?.cancellationDate}}\n                        จะเสียค่าธรรมเนียมการยกเลิกห้องพัก THB\n                        {{cancellationChargeItem.chargeRoomAmount | number:'.2'}}\n                        ต่อห้อง</span>\n                      <ng-template #nonRefundTh>\n                        <span id=\"cancellation-popup-condition-charge-policy-{{i}}\"> ขอรับเงินคืนไม่ได้</span>\n                      </ng-template>\n                    </div>\n                  </ng-template>\n                </div>\n              </div>\n            </div>\n            <div class=\"col-right\">\n              <div class=\"cr-title\">{{'booking-cancellation-fee' | translate}}</div>\n              <div class=\"cr-currency\">\n                {{ bookingCancellationStatus?.bookerCurrency }}\n                {{ cancellationChargeItem?.totalChargeAmount | number:'.2'}}\n              </div>\n            </div>\n            <div class=\"clearfix\"></div>\n          </div>\n        </div>\n        <div class=\"table-body-summary\">\n          <div class=\"col-left\">\n            <div class=\"cl-total\">{{'booking-cancellation-total' | translate}}</div>\n            <div class=\"cl-multipayment\" *ngIf=\"isMultiPayment\">{{'booking-cancellation-multipayment' | translate}}\n            </div>\n            <div class=\"cl-multipayment\" *ngIf=\"isShareBudget && !isMultiPayment\">{{'cart-seperate-payment-credit-terms'\n              | translate}}</div>\n          </div>\n          <div class=\"col-right\">\n            <span class=\"cr-currency\">{{bookingCancellationStatus?.bookerCurrency}}</span>\n            <span id=\"cancellation-popup-total-cancellation-fee\">\n              {{cancellationFee | number:'.2'}}\n            </span>\n          </div>\n        </div>\n\n        <div class=\"table-body-payment-type\" *ngIf=\"isMultiPayment\">\n          <div class=\"tbpt-share-budget\" *ngIf=\"isShareBudget\">\n            <div class=\"col-left\">\n              {{'booking-cancellation-credit-terms' | translate}}\n            </div>\n            <div class=\"col-left tbpt-credit-terms-share-budget\">\n              <ul>\n                <li class=\"show-list-style\">{{'booking-cancellation-credit-terms-main-booker' | translate}}\n                  <span class=\"pull-right\">\n                    <span class=\"cr-currency\">THB</span>\n                    <span id=\"cancellation-popup-total-credit-card\">{{ paymentCreditTerms | number:'.2'}}</span>\n                  </span>\n                </li>\n                <li style=\"padding-top: 10px;\" class=\"show-list-style\">\n                  {{'booking-cancellation-credit-terms-co-booker' | translate}}\n                  <span class=\"pull-right\">\n                    <span class=\"cr-currency\">THB</span>\n                    <span id=\"cancellation-popup-total-credit-card\">{{ paymentCoBooker | number:'.2'}} </span>\n                  </span>\n                </li>\n              </ul>\n            </div>\n            <div class=\"clearfix\"></div>\n          </div>\n\n          <div class=\"tbpt-credit-terms\" *ngIf=\"paymentCreditTerms && !isShareBudget\">\n            <div class=\"col-left\">\n              {{'booking-cancellation-credit-terms' | translate}}\n            </div>\n            <div class=\"col-right\">\n              <span class=\"cr-currency\">THB</span>\n              <span id=\"cancellation-popup-total-credit-terms\">\n                {{paymentCreditTerms | number:'.2'}}\n              </span>\n            </div>\n            <div class=\"clearfix\"></div>\n          </div>\n\n          <div class=\"tbpt\" *ngFor=\"let displayPaymentNonCreditTerm of displayPaymentNonCreditTermList\">\n            <div class=\"col-left\">\n              {{ displayPaymentNonCreditTerm?.label | translate }}\n            </div>\n            <div class=\"col-right\">\n              <span class=\"cr-currency\">THB</span>\n              <span id=\"cancellation-popup-total-credit-card\">\n                {{displayPaymentNonCreditTerm?.amount | number:'.2'}}\n              </span>\n            </div>\n            <div class=\"clearfix\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div id=\"reject-msg\" class=\"remark-box\">\n      <span class=\"remark-title\">{{'booking-cancellation-note' | translate}}:</span>\n      <span class=\"remark-desc\">{{'booking-cancellation-note-text' | translate}}</span>\n    </div>\n\n    <div class=\"reason-box\">\n      <act-text-area\n          id=\"booking-cancellation-reject-reaso\"\n          label=\"{{'booking-cancellation-reject-reason-label' | translate}}\" \n          placeholder=\"{{'booking-cancellation-reject-reason-placeholder' | translate}}\" \n          maxLength=\"200\"\n          [isError]=\"isReasonError\"\n          errorText=\"{{'booking-cancellation-reject-reason-error-required' | translate}}\"\n          (text)=\"onKeyupReason($event)\">\n      </act-text-area>\n    </div>\n  </div>\n\n  <div id=\"reject-button\" class=\"btn-parent\">\n    <button (click)=\"goToHome()\" class=\"ota-btn-default\">{{ 'approval-action-btn-home' | translate }}</button>\n    <button (click)=\"updateBookingApprovalStatus('reject')\" class=\"ota-btn-main btn-horizontal\"\n      [ngClass]=\"{'loading': loading.BUTTON }\"\n      id=\"approval-action-btn-confirm-rejection\">{{'booking-cancellation-btn-confirm-2' | translate}}</button>\n    <div class=\"clearfix\"></div>\n  </div>\n\n</div>"

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports = "<div class=\"billboard\" *ngIf=\"billboards.length > 0\">\n  <ul class=\"billboard-list owl-carousel billboard-owl\">\n    <li\n      class=\"billboard-item\"\n      *ngFor=\"let billboard of billboards; let i = index\"\n    >\n      <div class=\"billboard-image\" [attr.data-bannerId]=\"billboard.bannerId\" [attr.data-bannerType]=\"bannerType\">\n        <ng-container *ngIf=\"billboard.link; else noLink\">\n          <a\n            id=\"billboard-link-{{i}}\"\n            [href]=\"billboard.link\"\n            target=\"_blank\"\n          >\n            <img\n              id=\"billboard-img-{{ i }}\"\n              src=\"{{ billboard.fileUrl }}\"\n              alt=\"{{ billboard.altText ? billboard.altText : '' }}\"\n              title=\"{{ billboard.altText ? billboard.altText : '' }}\"\n            />\n          </a>\n        </ng-container>\n        <ng-template #noLink>\n          <img\n            id=\"billboard-img-{{ i }}\"\n            src=\"{{ billboard.fileUrl }}\"\n            alt=\"{{ billboard.altText ? billboard.altText : '' }}\"\n            title=\"{{ billboard.altText ? billboard.altText : '' }}\"\n          />\n        </ng-template>\n      </div>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports = "<div class=\"leaderboard\" *ngIf=\"leaderboard\">\n  <div class=\"leaderboard-image\" [attr.data-bannerId]=\"leaderboard.bannerId\" [attr.data-bannerType]=\"bannerType\">\n    <ng-container *ngIf=\"leaderboard.link; else noLink\">\n      <a\n        id=\"leaderboard-link\"\n        [href]=\"leaderboard.link\"\n        target=\"_blank\">\n        <img\n          id=\"leaderboard-img\"\n          src=\"{{ leaderboard.fileUrl }}\"\n          alt=\"{{ leaderboard.altText ? leaderboard.altText : '' }}\"\n          title=\"{{ leaderboard.altText ? leaderboard.altText : '' }}\"\n        />\n      </a>\n    </ng-container>\n    <ng-template #noLink>\n      <img\n        id=\"leaderboard-img\"\n        src=\"{{ leaderboard.fileUrl }}\"\n        alt=\"{{ leaderboard.altText ? leaderboard.altText : '' }}\"\n        title=\"{{ leaderboard.altText ? leaderboard.altText : '' }}\"\n      />\n    </ng-template>\n  </div>\n</div>\n"

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports = "<div class=\"banner-promotion\" *ngIf=\"banners?.length > 0\">\n  <div class=\"banner-header\">\n    <div class=\"topic\" id=\"banner-promotion-topic\">{{ 'banner-topic' | translate }}</div>\n    <div class=\"sub-topic\" id=\"banner-promotion-sub-topic\">{{ 'banner-sub-topic' | translate }}</div>\n  </div>\n  <div class=\"banner-detail\">\n    <ul class=\"banner-list owl-carousel banner-owl\">\n      <li id=\"banner-hotel-deals-li-{{i}}\" class=\"banner-item\" *ngFor=\"let banner of banners; let i = index\" (click)=\"openNewTab(banner, true);\" [ngClass]=\"{'is-mobile': isMobile}\" [attr.data-bannerId]=\"banner?.bannerId\" [attr.data-bannerType]=\"bannerType\">\n        <div class=\"banner-image\">\n          <ng-container *ngIf=\"banner?.altText; else noAltText\">\n            <img id=\"banner-img-hotel-image-{{i}}\" [src]=\"banner?.fileUrl\" [title]=\"banner?.altText\" [alt]=\"banner?.altText\" (click)=\"openNewTab(banner, false);\" [attr.data-bannerId]=\"banner?.bannerId\" [attr.data-bannerType]=\"bannerType\" />\n          </ng-container>\n          <ng-template #noAltText>\n            <img id=\"banner-img-hotel-image-{{i}}\" [src]=\"banner?.fileUrl\" (click)=\"openNewTab(banner, false);\" [attr.data-bannerId]=\"banner?.bannerId\" [attr.data-bannerType]=\"bannerType\" />\n          </ng-template>\n        </div>\n        <div class=\"banner-info\" [attr.data-bannerId]=\"banner?.bannerId\" [attr.data-bannerType]=\"bannerType\">\n          <div class=\"banner-title\" id=\"banner-lbl-hotel-name-{{i}}\">{{ banner?.title }}</div>\n          <div class=\"banner-time\">\n            <div>{{ 'banner-book-period' | translate }} :\n              <span id=\"banner-lbl-book-start-{{i}}\" attr.data-selenium-book-start-date=\"{{ banner?.bookPeriodFrom }}\">{{ banner?.displayBookStart }}</span> -\n              <span id=\"banner-lbl-book-end-{{i}}\" attr.data-selenium-book-end-date=\"{{ banner?.bookPeriodTo }}\">{{ banner?.displayBookEnd }}</span>\n            </div>\n            <div>{{ 'banner-stay-period' | translate }} :\n              <span id=\"banner-lbl-stay-start-{{i}}\" attr.data-selenium-stay-start-date=\"{{ banner?.stayPeriodFrom }}\">{{ banner?.displayStayStart }}</span> -\n              <span id=\"banner-lbl-stay-end-{{i}}\" attr.data-selenium-stay-end-date=\"{{ banner?.stayPeriodTo }}\">{{ banner?.displayStayEnd }}</span>\n            </div>\n          </div>\n          <div id=\"banner-lbl-description-{{i}}\" class=\"banner-description\">{{ banner?.description }}</div>\n        </div>\n        <div class=\"banner-button\">\n          <button class=\"ota-btn-main\" id=\"banner-btn-book-{{i}}\" (click)=\"openNewTab(banner, false);\" [attr.data-bannerId]=\"banner?.bannerId\" [attr.data-bannerType]=\"bannerType\">\n            {{ 'banner-btn-book' | translate }}\n            <span class=\"icon icon-arrow-right\"></span>\n          </button>\n        </div>\n      </li>\n    </ul>\n  </div>\n</div>\n"

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports = "<div class=\"content-address {{ options?.page }}\">\n  <div id=\"billing-list-div-item-{{i}}\"\n    *ngFor=\"let item of dataItems; let i = index\">\n    <div *ngIf=\"item?.state === STATE.VIEW\"\n      class=\"box-select-address -full-width\"\n      [ngClass]=\"{ 'selected': item?.isSelected }\">\n      <label class=\"radio-address\" [ngClass]=\"{ '-can-select': options?.selectable } \">\n        <input type=\"radio\" name=\"{{ options?.name }}\"\n          *ngIf=\"options.selectable\"\n          [checked]=\"item?.isChecked\"\n          (change)=\"onItemSelected(item)\" />\n\n        <div class=\"address-detail\">\n          <strong id=\"billing-list-txt-name-{{i}}\">{{ item.billingName }}</strong>\n          <p>\n            <span class=\"color-sub\">\n              {{ 'checkout-3-billing-address-phone' | translate }}\n              <span id=\"billing-list-txt-phone-{{i}}\">{{ item.billingPhone }}</span><br>\n              <span id=\"billing-list-txt-address-{{i}}\">{{ item.billingAddress }}</span>\n            </span>\n          </p>\n          <div class=\"delete-address\" *ngIf=\"options?.editable\">\n            <a id=\"billing-list-btn-delete-{{i}}\" (click)=\"onDeleteButtonClicked(item)\">\n              <i class=\"icon-delete-addrs\"></i>\n              <span>{{'my-profile-delete' | translate}}</span>\n            </a>\n          </div>\n          <div class=\"edit-address\" *ngIf=\"options?.editable\">\n            <a id=\"billing-list-btn-edit-{{i}}\" (click)=\"onEditButtonClicked(item)\">\n              <i class=\"icon-edit-addrs\"></i>\n              <span>{{'my-profile-edit'| translate}}</span>\n            </a>\n          </div>\n        </div>\n      </label>\n    </div>\n    <div *ngIf=\"item?.state === STATE.EDIT\">\n      <billing-form #editForm [options]=\"options\"\n        [refName]=\"i\" [data]=\"item\"\n        (onSaveCompleted)=\"onFormSaveCompleted($event)\"\n        (onCancelCompleted)=\"onFormCancelCompleted($event)\">\n      </billing-form>\n    </div>\n  </div>\n  <div *ngIf=\"currentState === STATE.ADD\">\n    <billing-form #addForm [options]=\"options\"\n      [data]=\"emptyBilling\"\n      (onSaveCompleted)=\"onFormSaveCompleted($event)\"\n      (onCancelCompleted)=\"onFormCancelCompleted($event)\">\n    </billing-form>\n  </div>\n  <a id=\"address-list-btn-add-new-address\" class=\"add-address\"\n    *ngIf=\"dataItems?.length < LIMIT_ADDING && currentState !== STATE.ADD\"\n    (click)=\"onAddButtonClicked($event)\">\n    <i class=\"fa fa-plus-circle\"></i>\n    <span>{{'my-profile-add-tax' | translate}}</span>\n  </a>\n</div>\n"

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box-select-address\"\n[ngClass]=\"{ 'selected': true }\">\n  <form class=\"content-table\" [formGroup]=\"form\">\n    <div class=\"address-inner\">\n      <div class=\"form-group\">\n        <label for=\"billing-form-txt-name-{{refName}}\">{{ 'checkout-3-billing-address-name' | translate }}</label>\n        <input #name id=\"billing-form-txt-name-{{refName}}\" class=\"form-control\"\n          type=\"text\"\n          formControlName=\"name\"\n          placeholder=\"{{ 'checkout-3-billing-address-name-placeholder' | translate }}\"\n          [ngClass]=\"{\n            'input-error': isInvalid('name'),\n            'input-success': form.get('name').valid\n          }\" />\n        <span *ngIf=\"isInvalid('name') && !form.get('name').value || formErrors?.name?.required\" class=\"text-error\">\n            {{ 'checkout-3-billing-validation-required-name' | translate }}\n        </span>\n        <span *ngIf=\"isInvalid('name') && form.get('name').value || formErrors?.name?.pattern\" class=\"text-error\">\n            {{ 'checkout-3-billing-validation-invalid-name' | translate }}\n        </span>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"billing-form-txt-phone-{{refName}}\">{{ 'checkout-3-billing-address-phone' | translate }}</label>\n        <input #phone id=\"billing-form-txt-phone-{{refName}}\" class=\"form-control\"\n          type=\"text\" pattern=\"\\d*\" inputmode=\"numeric\"\n          maxlength=\"10\"\n          placeholder=\"{{ 'checkout-3-billing-address-phone-placeholder' | translate }}\"\n          formControlName=\"phone\"\n          [ngClass]=\"{\n            'input-error': isInvalid('phone'),\n            'input-success': form.get('phone').valid\n          }\" />\n        <span *ngIf=\"isInvalid('phone') && !form.get('phone').value || formErrors?.phone?.required\" class=\"text-error\">\n            {{ 'checkout-3-billing-validation-required-phone' | translate }}\n        </span>\n        <span *ngIf=\"isInvalid('phone') && form.get('phone').value || formErrors?.phone?.pattern\" class=\"text-error\">\n          {{ 'checkout-3-billing-validation-invalid-phone' | translate }}\n        </span>\n      </div>\n      <div class=\"form-group -mb-20\">\n        <label for=\"billing-form-txt-address-{{refName}}\">\n          {{ 'checkout-3-billing-address-address' | translate }}\n        </label>\n        <textarea #address id=\"billing-form-txt-address-{{refName}}\" class=\"form-control\"\n          formControlName=\"address\" rows=\"3\"\n          placeholder=\"{{ 'checkout-3-billing-address-address-address-placeholder' | translate }}\"\n          [ngClass]=\"{\n            'input-error': isInvalid('address'),\n            'input-success': form.get('address').valid\n          }\">\n        </textarea>\n        <span *ngIf=\"isInvalid('address') && !form.get('address').value || formErrors?.address?.required\" class=\"text-error\">\n            {{ 'checkout-3-billing-validation-required-address' | translate }}\n        </span>\n        <span *ngIf=\"isInvalid('address') && form.get('address').value || formErrors?.address?.pattern\" class=\"text-error\">\n            {{ 'checkout-3-billing-validation-invalid-address' | translate }}\n        </span>\n      </div>\n      <div class=\"address-button\" *ngIf=\"isDisplayButton\">\n        <button id=\"billing-form-btn-cancel-{{refName}}\" class=\"ota-btn-sub btn-horizontal\"\n          (click)=\"onCancelButtonClicked()\">\n          {{ 'my-profile-address-form-btn-cancel' | translate }}\n        </button>\n        <button id=\"billing-form-btn-save-{{refName}}\" class=\"ota-btn-main btn-horizontal\"\n          (click)=\"onSubmitButtonClicked()\"\n          [ngClass]=\"{'loading': isLoading}\">\n          {{ 'my-profile-address-form-btn-submit' | translate }}\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n\n"

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports = "<div class=\"my-booking-section\">\n  <div [ngSwitch]=\"type\">\n    <ng-template [ngSwitchCase]=\"dataType.BOOKING\">\n      <ng-container *ngTemplateOutlet=\"bookingInfoTemplate; context: {data: myBooking}\"></ng-container>\n    </ng-template>\n\n    <ng-template [ngSwitchCase]=\"dataType.ROOM\">\n      <ng-container *ngTemplateOutlet=\"roomDetailTemplate; context: {data: myBooking}\"></ng-container>\n    </ng-template>\n\n    <ng-template [ngSwitchCase]=\"dataType.BOOKER\">\n      <ng-container *ngTemplateOutlet=\"bookerInfoTemplate; context: {data: myBooking}\"></ng-container>\n    </ng-template>\n\n    <ng-template [ngSwitchCase]=\"dataType.BOOKING_DETAIL\">\n      <ng-container *ngTemplateOutlet=\"bookingInfoWithBookingStatusTemplate; context: {data: myBooking}\"></ng-container>\n    </ng-template>\n\n    <ng-template [ngSwitchCase]=\"dataType.TRAVELLER_INFO\">\n      <ng-container *ngTemplateOutlet=\"travellerInfoTemplate; context: {data: myBooking}\"></ng-container>\n    </ng-template>\n  </div>\n</div>\n\n<ng-template #bookingInfoTemplate let-data=\"data\">\n  <div class=\"data booking-info\">\n    <div class=\"ref-group\">\n      <div class=\"row\" [class.mb-0]=\"!!!data?.wsReference\">\n        <div class=\"col booking-id\">{{ 'booking-detail-bookingId-ref-number' | translate }} :</div>\n        <div class=\"col booking-id-value\" id=\"{{prefixElementId}}-text-booking-id\"><strong>{{ data?.bookingId }}</strong></div>\n      </div>\n      <div class=\"row\" *ngIf=\"data?.wsReference\">\n        <div class=\"col\">{{ 'booking-detail-bookingId-hotel-ref' | translate }} :</div>\n        <div class=\"col\" id=\"{{prefixElementId}}-text-ws-reference\">{{ data?.wsReference }}</div>\n      </div>\n    </div>\n\n    <hr class=\"seperator-line hide-sm\" />\n\n    <div class=\"hide-sm\">\n      <ng-container *ngTemplateOutlet=\"bookingDetailDeskTopTemplate; context: {data: data}\"></ng-container>\n    </div>\n\n    <div class=\"show-sm\">\n      <ng-container *ngTemplateOutlet=\"bookingDetailMobileTemplate; context: {data: data}\"></ng-container>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #bookingInfoWithBookingStatusTemplate let-data=\"data\">\n  <div class=\"data booking-info mb-booking-info \">\n    <div class=\"ref-group\">\n      <div class=\"row\">\n        <div class=\"col booking-id\">{{ 'booking-detail-bookingId-ref-number' | translate }} :</div>\n        <div class=\"col booking-id-value\" id=\"{{prefixElementId}}-text-booking-id\"><strong>{{ data?.bookingId }}</strong></div>\n      </div>\n      <div class=\"row\" *ngIf=\"data?.wsReference\">\n        <div class=\"col\">{{ 'booking-detail-bookingId-hotel-ref' | translate }} :</div>\n        <div class=\"col\" id=\"{{prefixElementId}}-text-ws-reference\">{{ data?.wsReference }}</div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col\">{{ 'booking-detail-booking-date-and-time' | translate }} :</div>\n        <div class=\"col\" id=\"{{prefixElementId}}-text-booking-date\">{{ data?.bookingDate }} / {{ data?.bookingTime }}</div>\n      </div>\n    </div>\n    <div class=\"row booking-status\" *ngIf=\"data?.bookingStatus\">\n      <ng-container *ngTemplateOutlet=\"bookingStatusTemplate; context: {data: data?.bookingStatus}\"></ng-container>\n    </div>\n    <div class=\"show-sm\">\n      <ng-container *ngTemplateOutlet=\"bookingDetailMobileTemplate; context: {data: data}\"></ng-container>\n    </div>\n  </div>\n\n  <div class=\"header hide-sm\">{{ 'booking-detail-details-booking-detail-title' | translate }}</div>\n  <div class=\"data hide-sm\">\n    <ng-container *ngTemplateOutlet=\"bookingDetailDeskTopTemplate; context: {data: data}\"></ng-container>\n  </div>\n</ng-template>\n\n<ng-template #bookingDetailDeskTopTemplate let-data=\"data\">\n  <div class=\"row\">\n    <div class=\"col\">{{ 'booking-detail-details-checkin' | translate }} :</div>\n    <div class=\"col\" id=\"{{prefixElementId}}-text-check-in-date-time\"><span attr.data-selenium-checkin-date=\"{{ dataSelenium?.checkInDate }}\">{{ data?.checkIn?.date }}</span> {{'booking-detail-details-from' | translate }}\n      {{ data?.checkIn?.timeFrom + (data?.checkIn?.timeUntil ? ' - ' + data?.checkIn?.timeUntil : '') }}\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col\">{{ 'booking-detail-details-checkout' | translate }} :</div>\n    <div class=\"col\" id=\"{{prefixElementId}}-text-check-out-date-time\"><span attr.data-selenium-checkout-date=\"{{ dataSelenium?.checkOutDate }}\">{{ data?.checkOut?.date }}</span> {{ data?.checkOut?.timeFrom ? ('booking-detail-details-from' | translate) : ('booking-detail-details-before' | translate) }}\n        {{ (data?.checkOut?.timeFrom ? data?.checkOut?.timeFrom + ' - ': '') + data?.checkOut?.timeUntil }}\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col\">{{ 'booking-detail-details-period' | translate }} :</div>\n    <div class=\"col\" id=\"{{prefixElementId}}-text-period-of-stay\">{{ data?.periodOfStay }}\n      {{ 'booking-detail-details-night' | translateSingularPlural: data?.periodOfStay }}</div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col\">{{ 'booking-detail-details-room-guest-amount' | translate }} :</div>\n    <div class=\"col\" id=\"{{prefixElementId}}-text-room-amount\">{{ data?.roomAmount }}\n      {{ 'booking-detail-details-room' | translateSingularPlural: data?.roomAmount }}{{','}}\n      {{ dataSelenium.roomGuestAmount }}\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col\">{{ 'booking-detail-details-total-max-guest' | translate }} :</div>\n    <div class=\"col\" id=\"{{prefixElementId}}-text-total-max-guest\">\n      <span>{{'booking-detail-details-max-guest' | translate}}: </span>\n      {{'booking-detail-details-adult-text' | translate }}\n      {{ data?.maxGuest?.adult }}\n      {{ 'booking-detail-details-adult' | translateSingularPlural: data?.maxGuest?.adult }}<span\n        *ngIf=\"data?.maxGuest?.child && data?.maxGuest?.child > 0\">,\n        {{'booking-detail-details-child-text' | translate }}\n        {{ data?.maxGuest?.child }}\n        {{ 'booking-detail-details-child' | translateSingularPlural: data?.maxGuest?.child }}\n      </span>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #bookingDetailMobileTemplate let-data=\"data\">\n  <div class=\"row border-bottom\">\n    <div class=\"col-left\">\n      <div class=\"title\">{{'booking-detail-details-checkin' | translate}}</div>\n      <div>{{ data?.checkIn?.date }}</div>\n      <div>{{'booking-detail-details-from' | translate }}\n        {{ data?.checkIn?.timeFrom + (data?.checkIn?.timeUntil ? ' - ' + data?.checkIn?.timeUntil : '') }}\n      </div>\n    </div>\n    <div class=\"col-right\">\n      <div class=\"title\">{{'booking-detail-details-checkout' | translate}}</div>\n      <div>{{ data?.checkOut?.date }}</div>\n      <div>{{ data?.checkOut?.timeFrom ? ('booking-detail-details-from' | translate) : ('booking-detail-details-before' | translate) }}\n        {{ (data?.checkOut?.timeFrom ? data?.checkOut?.timeFrom + ' - ': '') + data?.checkOut?.timeUntil }}\n      </div>\n    </div>\n  </div>\n  <div class=\"night-room-guest\">\n    <div class=\"mb-5\">\n      <i class=\"icon-calendar-bold\"></i>\n      <span>{{ data?.periodOfStay }} {{ 'booking-detail-details-night' | translateSingularPlural: data?.periodOfStay }}</span>\n    </div>\n    <div class=\"mb-5\">\n      <i class=\"icon-bed-2\"></i>\n      <span>{{ data?.roomAmount }} {{ 'booking-detail-details-room' | translateSingularPlural: data?.roomAmount }}{{','}}\n        {{ dataSelenium.roomGuestAmount }}\n      </span>\n    </div>\n    <div>\n      <i class=\"icon-user\"></i>\n      <span>\n        <span *ngIf=\"appConfigService.getLanguage() === 'th'\">{{'booking-detail-details-max-guest' | translate}} : </span>\n        {{'booking-detail-details-adult-text' | translate }} {{ data?.maxGuest?.adult }} {{ 'booking-detail-details-adult' | translateSingularPlural: data?.maxGuest?.adult }}<span\n            *ngIf=\"data?.maxGuest?.child && data?.maxGuest?.child > 0\">,\n            {{'booking-detail-details-child-text' | translate }}\n            {{ data?.maxGuest?.child }}\n            {{ 'booking-detail-details-child' | translateSingularPlural: data?.maxGuest?.child }}\n          </span>\n      </span>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #roomDetailTemplate let-data=\"data\">\n  <div class=\"room-detail\">\n    <div class=\"header\">{{ 'booking-detail-details-room-detail-title' | translate }}</div>\n    <div class=\"data\">\n      <div class=\"row seperator-bottom room-type\" *ngFor=\"let room of data; let i = index\">\n        <div class=\"col left pl-15\">\n          <div class=\"mb-15\">\n            <div id=\"{{prefixElementId}}-text-room-type-name-{{i}}\"><strong>{{ room?.roomTypeName }}</strong></div>\n            <ul class=\"mb-0\">\n              <li id=\"{{prefixElementId}}-text-period-night-max-guest-{{i}}\">\n                <i class=\"fa fa-circle li-icon\" aria-hidden=\"true\"></i>\n                {{ 'booking-detail-details-room-title' | translate}} {{ room?.night }}\n                {{ 'booking-detail-details-night' | translateSingularPlural: room?.night }},&nbsp;\n                <span>\n                  <span *ngIf=\"appConfigService.getLanguage() === 'th'\">{{'booking-detail-details-max-guest' | translate}} :</span>\n                  {{'booking-detail-details-adult-text' | translate }}\n                  {{room?.maxGuest?.adult}}\n                  {{ 'booking-detail-details-adult' | translateSingularPlural: room?.maxGuest?.adult }}\n                </span>\n                <span *ngIf=\"room?.maxGuest?.child && room?.maxGuest?.child > 0\">,\n                  <span>\n                    {{'booking-detail-details-child-text' | translate }}\n                    {{ room?.maxGuest?.child }}\n                    {{ 'booking-detail-details-child' | translateSingularPlural: room?.maxGuest?.child }}\n                  </span>\n                </span>\n              </li>\n              <li id=\"{{prefixElementId}}-text-guests-name-{{i}}\">\n                <i class=\"fa fa-circle li-icon\" aria-hidden=\"true\"></i>\n                {{'booking-detail-details-room-guest' | translate}} : {{room?.guest}}\n              </li>\n              <li id=\"{{prefixElementId}}-text-special-request-{{i}}\">\n                <i class=\"fa fa-circle li-icon\" aria-hidden=\"true\"></i>\n                <span>{{'booking-detail-details-room-special-request' | translate}} : <span>{{room?.specialRequest || '-'}}</span></span>\n              </li>\n              <li id=\"{{prefixElementId}}-text-offer-type-{{i}}\">\n                <i class=\"fa fa-circle li-icon\" aria-hidden=\"true\"></i>\n                <span attr.data-selenium-breakfast=\"{{room?.offerType?.toLowerCase() !== offerType.ROOM_ONLY.toLowerCase()}}\">{{ room?.offerTypeDisplay }}</span>\n              </li>\n              <li *ngIf=\"!room?.cancellationPolicies || room?.cancellationPolicies.length == 0\" id=\"{{prefixElementId}}-text-non-refund-{{i}}\">\n                <i class=\"fa fa-circle li-icon\" aria-hidden=\"true\"></i>\n                {{ 'booking-detail-details-room-non-refund' | translate}}\n              </li>\n              <li *ngIf=\"room?.freeCancellationDate\" id=\"{{prefixElementId}}-text-free-cancellation-date-{{i}}\">\n                <i class=\"fa fa-circle li-icon\" aria-hidden=\"true\"></i>\n                {{ 'booking-detail-cancellation-policy-free-of-charge' | translate}}\n                {{ room?.freeCancellationDate }}\n              </li>\n              <li id=\"{{page}}-li-room-condition-cancellation-fee-{{i}}\" *ngIf=\"room?.policyMessage && !room?.freeCancellationDate\">\n                <i class=\"fa fa-circle li-icon\" aria-hidden=\"true\"></i>\n                <span>{{ 'product-detail-room-condition-cancellation-fee' | translate }}</span>\n              </li>\n              <li *ngIf=\"room?.policyMessage\">\n                <i class=\"fa fa-circle li-icon\" aria-hidden=\"true\"></i>\n                <span>\n                  <span>{{ 'booking-detail-room-cancellation-policy' | translate }}</span>\n                  <ul id=\"{{prefixElementId}}-ul-cancellation-policy-{{i}}\" class=\"cancellation-policy mb-0\">\n                    <li *ngFor=\"let cancelPolicy of room.policyMessage\" style=\"list-style-type: none;\" id=\"{{prefixElementId}}-li-cancellation-message-{{i}}\">\n                      {{ cancelPolicy }}\n                    </li>\n                  </ul>\n                </span>\n              </li>\n            </ul>\n          </div>\n          <div *ngIf=\"room?.benefits && room?.benefits.length > 0\" [class.collapse]=\"isMobile\" [class.show]=\"showMoreRoomInfo.includes(i)\">\n            <div id=\"{{prefixElementId}}-text-room-benefits-{{i}}\">\n              <span class=\"room-benefit-title\">\n                {{ 'booking-detail-details-room-benefits' | translate }}\n              </span>\n            </div>\n            <ul class=\"mb-0\">\n              <li *ngFor=\"let benefit of room?.benefits;\" id=\"{{prefixElementId}}-text-benefits-{{i}}\">\n                <i class=\"fa fa-circle li-icon\" aria-hidden=\"true\"></i>\n                <div>\n                  <span>{{ (appConfigService.getLanguage() === 'th') ? ( (benefit?.nameTh != null) ? benefit.nameTh : benefit.name ) : benefit.name }}</span>\n                  <div class=\"room-benefit-desc\" [innerHTML]=\"(appConfigService.getLanguage() === 'th') ? ( (benefit?.descriptionTh != null) ? benefit.descriptionTh : benefit.description ) : benefit.description\"></div>\n                </div>\n              </li>\n            </ul>\n          </div>\n          <div class=\"footer\" *ngIf=\"isMobile && room?.benefits && room?.benefits.length > 0\" (click)=\"toggleCollapseInfo('showMoreRoomInfo', i)\" [class.margin-top]=\"showMoreRoomInfo.includes(i)\">\n            <ng-container *ngIf=\"!showMoreRoomInfo.includes(i); else show\">\n              <i class=\"icon-Showmore\"></i>\n              <span>{{'view-more' | translate}}</span>\n            </ng-container>\n            <ng-template #show>\n              <i class=\"icon-arrow-show-less-round\"></i>\n              <span>{{'view-less' | translate}}</span>\n            </ng-template>\n          </div>\n        </div>\n        <div class=\"col right hide-sm\" id=\"{{prefixElementId}}-text-room-price-{{i}}\">\n          {{room?.currencyCode}} {{ room?.price | number:'.2' }}\n        </div>\n        <div class=\"room-total-price show-sm\" id=\"{{prefixElementId}}-text-room-price-mobile-{{i}}\">\n          <span class=\"room-total-price-title\">{{'booking-detail-room-price-total' | translate }}</span>\n          <span class=\"room-total-price-value\">{{room?.currencyCode}} {{ room?.price | number:'.2' }}</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #bookerInfoTemplate let-data=\"data\">\n  <div class=\"booker-info\">\n    <div class=\"header\">{{ isShareBudget ? ('booking-detail-details-main-booker-information-title' | translate) : ('booking-detail-details-booker-information-title' | translate) }}</div>\n    <div class=\"data pt-0 pb-15\" *ngFor=\"let booker of filterMainBooker(data); let i = index\" [class.pb-0]=\"isMobile\">\n      <div class=\"sub-section\">\n        <div class=\"row\">\n          <div class=\"col\">{{ isShareBudget ? ('booking-detail-details-main-booker-name' | translate) : ('booking-detail-details-booker-name' | translate) }} :</div>\n          <div class=\"col\" id=\"{{prefixElementId}}-text-main-booker-full-name\">{{ booker?.fullName }}</div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col\">{{ 'booking-detail-details-booker-phonenum' | translate }} :</div>\n          <div class=\"col\" id=\"{{prefixElementId}}-text-main-booker-phone\">{{ booker?.phone }}</div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col\">{{ 'booking-detail-details-booker-email' | translate }} :</div>\n          <div class=\"col\" id=\"{{prefixElementId}}-text-main-booker-email\">{{ booker?.email }}</div>\n        </div>\n      </div>\n      <ng-container *ngIf=\"(booker?.approval && (booker?.paymentChannel === paymentChannelType.CREDIT_TERMS || booker?.paymentChannel === paymentChannelType.MULTI_PAYMENT))\n        || booker?.creditTermsInfo\n        || booker?.creditCardInfo\n        || booker?.trueMoneyInfo\n        || booker?.qrCodeInfo\n        || booker?.eWalletInfo\n        || booker?.imBankingInfo\n        || booker?.payAtCounterInfo\">\n        <div [class.collapse]=\"isMobile\" [class.show]=\"showMoreBookerInfo.includes(i)\">\n          <!-- START CREDIT TERMS TAX INFO -->\n          <div *ngIf=\"booker?.approval && (booker?.paymentChannel === paymentChannelType.CREDIT_TERMS || booker?.paymentChannel === paymentChannelType.MULTI_PAYMENT)\" class=\"sub-section\">\n            <div class=\"row\">\n              <div class=\"col\">{{ 'booking-detail-details-supervisor-fullname' | translate }} :</div>\n              <div class=\"col\" id=\"{{prefixElementId}}-text-main-booker-approval-full-name\">{{ booker?.approval?.fullName }}</div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col\">{{ 'booking-detail-details-supervisor-email' | translate }} :</div>\n              <div class=\"col\" id=\"{{prefixElementId}}-text-main-approval-email\">{{ booker?.approval?.email }}</div>\n            </div>\n          </div>\n          <div *ngIf=\"booker?.creditTermsInfo && (booker?.paymentChannel === paymentChannelType.CREDIT_TERMS || booker?.paymentChannel === paymentChannelType.MULTI_PAYMENT)\" class=\"sub-section tax-width\">\n            <div class=\"data-header\" *ngIf=\"booker?.paymentChannel === paymentChannelType.MULTI_PAYMENT || isShareBudget \">{{'booking-detail-details-credit-terms-title' | translate }}</div>\n            <div class=\"row\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-name' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-credit-terms-tax-name\">{{ booker?.creditTermsInfo?.taxName }}</div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-tax' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-credit-terms-tax-id\">{{ booker?.creditTermsInfo?.taxId }}</div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-address' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-credit-terms-tax-address\">{{ booker?.creditTermsInfo?.taxAddress }}</div>\n            </div>\n          </div>\n          <div *ngIf=\"booker?.creditTermsInfo && booker?.checkoutFields\" class=\"sub-section tax-width\">\n            <div class=\"row\" *ngFor=\"let checkoutField of booker.checkoutFields; let j = index\">\n              <div class=\"col\" id=\"{{prefixElementId}}-text-main-booker-checkout-field-display-name-{{j}}\">{{ checkoutField.displayName }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-checkout-field-value-{{j}}\">{{ checkoutField.value ? checkoutField.value : '-' }}</div>\n            </div>\n          </div>\n          <!-- END CREDIT TERMS TAX INFO -->\n          <!-- START CREDIT CARD TAX INFO -->\n          <div *ngIf=\"booker?.creditCardInfo && (booker?.paymentChannel === paymentChannelType.CREDIT_CARD || booker?.paymentChannel === paymentChannelType.MULTI_PAYMENT)\" class=\"sub-section tax-width\">\n            <div class=\"data-header\" *ngIf=\"booker?.paymentChannel === paymentChannelType.MULTI_PAYMENT\">{{'booking-detail-details-credit-card-title' | translate }}</div>\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-name' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-credit-card-tax-name\">{{ booker?.creditCardInfo?.taxName }}</div>\n            </div>\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-tax' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-credit-card-tax-id\">{{ booker?.creditCardInfo?.taxId }}</div>\n            </div>\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-address' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-credit-card-tax-address\">{{ booker?.creditCardInfo?.taxAddress }}</div>\n            </div>\n          </div>\n          <!-- END CREDIT CARD TAX INFO -->\n          <!-- START TRUE MONEY TAX INFO -->\n          <div *ngIf=\"booker?.trueMoneyInfo && (booker?.paymentChannel === paymentChannelType.TRUE_MONEY || booker?.paymentChannel === paymentChannelType.MULTI_PAYMENT)\" class=\"sub-section tax-width\">\n            <div class=\"data-header\" *ngIf=\"booker?.paymentChannel === paymentChannelType.MULTI_PAYMENT\">{{'booking-detail-details-true-money-title' | translate }}</div>\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-name' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-credit-card-tax-name\">{{ booker?.trueMoneyInfo?.taxName }}</div>\n            </div>\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-tax' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-credit-card-tax-id\">{{ booker?.trueMoneyInfo?.taxId }}</div>\n            </div>\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-address' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-credit-card-tax-address\">{{ booker?.trueMoneyInfo?.taxAddress }}</div>\n            </div>\n          </div>\n          <!-- END TRUE MONEY TAX INFO -->\n          <!-- START QR CODD TAX INFO -->\n          <div *ngIf=\"booker?.qrCodeInfo && booker?.paymentChannel === paymentChannelType.QR_CODE\" class=\"sub-section tax-width\">\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-name' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-qr-code-tax-name\">{{ booker?.qrCodeInfo?.taxName }}</div>\n            </div>\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-tax' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-qr-code-tax-id\">{{ booker?.qrCodeInfo?.taxId }}</div>\n            </div>\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-address' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-qr-code-tax-address\">{{ booker?.qrCodeInfo?.taxAddress }}</div>\n            </div>\n          </div>\n          <!-- END QR CODD TAX INFO -->\n          <!-- START E WALLET TAX INFO -->\n          <div *ngIf=\"booker?.eWalletInfo && booker?.paymentChannel === paymentChannelType.E_WALLET\" class=\"sub-section tax-width\">\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-name' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-e-wallet-tax-name\">{{ booker?.eWalletInfo?.taxName }}</div>\n            </div>\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-tax' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-e-wallet-tax-id\">{{ booker?.eWalletInfo?.taxId }}</div>\n            </div>\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-address' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-e-wallet-tax-address\">{{ booker?.eWalletInfo?.taxAddress }}</div>\n            </div>\n          </div>\n          <!-- END E WALLET TAX INFO -->\n          <!-- START INTERNET MOBILE BANKING TAX INFO -->\n          <div *ngIf=\"booker?.imBankingInfo && booker?.paymentChannel === paymentChannelType.IM_BANKING\" class=\"sub-section tax-width\">\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-name' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-im-banking-tax-name\">{{ booker?.imBankingInfo?.taxName }}</div>\n            </div>\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-tax' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-im-banking-tax-id\">{{ booker?.imBankingInfo?.taxId }}</div>\n            </div>\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-address' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-im-banking-tax-address\">{{ booker?.imBankingInfo?.taxAddress }}</div>\n            </div>\n          </div>\n          <!-- END INTERNET MOBILE BANKING TAX INFO -->\n          <!-- START PAY AT COUNTER TAX INFO -->\n          <div *ngIf=\"booker?.payAtCounterInfo && booker?.paymentChannel === paymentChannelType.PAY_AT_COUNTER\" class=\"sub-section tax-width\">\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-name' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-counter-tax-name\">{{ booker?.payAtCounterInfo?.taxName }}</div>\n            </div>\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-tax' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-counter-tax-id\">{{ booker?.payAtCounterInfo?.taxId }}</div>\n            </div>\n            <div class=\"row d-flex\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-address' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-main-booker-counter-tax-address\">{{ booker?.payAtCounterInfo?.taxAddress }}</div>\n            </div>\n          </div>\n          <!-- END PAY AT COUNTER TAX INFO -->\n        </div>\n        <div class=\"footer\" *ngIf=\"isMobile\" (click)=\"toggleCollapseInfo('showMoreBookerInfo', i)\">\n          <ng-container *ngIf=\"!showMoreBookerInfo.includes(i); else show\">\n            <i class=\"icon-Showmore\"></i>\n            <span>{{'view-more' | translate}}</span>\n          </ng-container>\n          <ng-template #show>\n            <i class=\"icon-arrow-show-less-round\"></i>\n            <span>{{'view-less' | translate}}</span>\n          </ng-template>\n        </div>\n      </ng-container>\n    </div>\n    <!-- co booker -->\n    <div *ngFor=\"let booker of filterMainBooker(data, false); let i = index\">\n      <div class=\"header mt-15\">{{ 'booking-detail-details-co-booker-information-title' | translate }}</div>\n      <div class=\"data pt-0 pb-15\" [class.pb-0]=\"isMobile\">\n        <div class=\"sub-section\">\n          <div class=\"row\">\n            <div class=\"col\">{{ 'booking-detail-details-co-booker-name' | translate }} :</div>\n            <div class=\"col\" id=\"{{prefixElementId}}-text-co-booker-full-name\">{{ booker?.fullName }}</div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col\">{{ 'booking-detail-details-booker-phonenum' | translate }} :</div>\n            <div class=\"col\" id=\"{{prefixElementId}}-text-co-booker-phone\">{{ booker?.phone }}</div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col\">{{ 'booking-detail-details-booker-email' | translate }} :</div>\n            <div class=\"col\" id=\"{{prefixElementId}}-text-co-booker-email\">{{ booker?.email }}</div>\n          </div>\n        </div>\n        <div [class.collapse]=\"isMobile\" [class.show]=\"showMoreCoBookerInfo.includes(i)\">\n          <div *ngIf=\"booker?.approval && (booker?.paymentChannel === paymentChannelType.CREDIT_TERMS || booker?.paymentChannel === paymentChannelType.MULTI_PAYMENT)\" class=\"sub-section\">\n            <div class=\"row\">\n              <div class=\"col\">{{ 'booking-detail-details-supervisor-fullname' | translate }} :</div>\n              <div class=\"col\" id=\"{{prefixElementId}}-text-main-co-booker-approval-full-name\">{{ booker?.approval?.fullName }}</div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col\">{{ 'booking-detail-details-supervisor-email' | translate }} :</div>\n              <div class=\"col\" id=\"{{prefixElementId}}-text-co-booker-approval-email\">{{ booker?.approval?.email }}</div>\n            </div>\n          </div>\n          <div class=\"sub-section tax-width\">\n            <div class=\"data-header\">{{'booking-detail-details-credit-terms-title' | translate }}</div>\n            <div class=\"row\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-name' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-co-booker-credit-terms-tax-name\">{{ booker?.creditTermsInfo?.taxName }}</div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-tax' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-co-booker-credit-terms-tax-id\">{{ booker?.creditTermsInfo?.taxId }}</div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col\">{{ 'booking-detail-details-booker-company-address' | translate }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-co-booker-credit-terms-tax-address\">{{ booker?.creditTermsInfo?.taxAddress }}</div>\n            </div>\n          </div>\n          <div *ngIf=\"booker?.checkoutFields\" class=\"sub-section tax-width\">\n            <div class=\"row\" *ngFor=\"let checkoutField of booker.checkoutFields; let j = index\">\n              <div class=\"col\" id=\"{{prefixElementId}}-text-co-booker-checkout-field-display-name-{{j}}\">{{ checkoutField.displayName }} :</div>\n              <div class=\"col value fix-width\" id=\"{{prefixElementId}}-text-co-booker-checkout-field-value-{{j}}\">{{ checkoutField.value ? checkoutField.value : '-' }}</div>\n            </div>\n          </div>\n        </div>\n        <div class=\"footer\" *ngIf=\"isMobile\" (click)=\"toggleCollapseInfo('showMoreCoBookerInfo', i)\">\n          <ng-container *ngIf=\"!showMoreCoBookerInfo.includes(i); else show\">\n            <i class=\"icon-Showmore\"></i>\n            <span>{{'view-more' | translate}}</span>\n          </ng-container>\n          <ng-template #show>\n            <i class=\"icon-arrow-show-less-round\"></i>\n            <span>{{'view-less' | translate}}</span>\n          </ng-template>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #bookingStatusTemplate let-data=\"data\">\n  <div [ngSwitch]=\"data.bookingStatus\" class=\"status-container\">\n    <ng-template ngSwitchCase=\"BOOKING_SUCCESS\">\n      <div class=\"status\">\n        <img src=\"/assets/images/general/Success.png\" alt=\"\">\n        <div id=\"{{prefixElementId}}-lbl-booking-success\">\n          <span id=\"{{prefixElementId}}-text-booking-status\" class=\"color-success status-text\">{{'booking-my-status-success-booking' | translate}}</span>\n          <ng-template [ngIf]=\"data?.payOnDate\">\n            <span class=\"status-remark\" id=\"{{prefixElementId}}-lbl-booking-payment-date\"\n              attr.data-selenium-payment-date=\"{{ data?.payOnDate }}\">\n              {{'booking-my-booking-payment-date' | translate}} {{ data?.payOnDate }}\n            </span>\n          </ng-template>\n        </div>\n      </div>\n    </ng-template>\n    <ng-template ngSwitchCase=\"PAYMENT_SUCCESS\">\n      <div class=\"status\">\n        <img src=\"/assets/images/general/Success.png\" alt=\"\">\n        <div id=\"{{prefixElementId}}-lbl-booking-payment-success\">\n          <span id=\"{{prefixElementId}}-text-booking-status\" class=\"color-success status-text\">{{'booking-my-status-success-payment' | translate}}</span>\n        </div>\n      </div>\n    </ng-template>\n    <ng-template ngSwitchCase=\"BOOKING_FAIL\">\n      <div class=\"status\">\n        <img src=\"/assets/images/general/Failed.png\" alt=\"\">\n        <div id=\"{{prefixElementId}}-lbl-booking-failed\">\n          <span id=\"{{prefixElementId}}-text-booking-status\" class=\"color-fail status-text\">{{'booking-my-status-failure-booking' | translate}}</span>\n        </div>\n      </div>\n    </ng-template>\n    <ng-template ngSwitchCase=\"PAYMENT_FAIL\">\n      <div class=\"status\">\n        <img src=\"/assets/images/general/Failed.png\" alt=\"\">\n        <div id=\"{{prefixElementId}}-lbl-booking-payment-failed\">\n          <span id=\"{{prefixElementId}}-text-booking-status\" class=\"color-fail status-text\">{{'booking-my-status-failure-payment' | translate}}</span>\n        </div>\n      </div>\n    </ng-template>\n    <ng-template ngSwitchCase=\"CANCEL\">\n      <div class=\"status\">\n        <img src=\"/assets/images/general/Failed.png\" alt=\"\">\n        <div id=\"{{prefixElementId}}-lbl-booking-cancelled\">\n          <span id=\"{{prefixElementId}}-text-booking-status\" class=\"color-fail status-text\">{{'booking-my-status-cancelled-booking' | translate}}</span>\n          <ng-template [ngIf]=\"data?.cancellationDate\">\n            <span class=\"status-remark\" id=\"{{prefixElementId}}-lbl-booking-payment-date\"\n              attr.data-selenium-cancellation-date=\"{{ data?.cancellationDate }}\">\n              {{ 'booking-my-booking-booker-cancel-date' | translate }} {{ data?.cancellationDate }}\n            </span>\n          </ng-template>\n        </div>\n      </div>\n    </ng-template>\n    <ng-template ngSwitchCase=\"CANCEL_BY_MAIN_BOOKER\">\n      <div class=\"status\">\n        <img src=\"/assets/images/general/Failed.png\" alt=\"\">\n        <div id=\"{{prefixElementId}}-lbl-booking-cancelled\">\n          <span id=\"{{prefixElementId}}-text-booking-status\" class=\"color-fail status-text\">{{'booking-my-status-cancelled-booking' | translate}}</span>\n          <ng-template [ngIf]=\"data?.cancellationDate\">\n            <span class=\"status-remark\" id=\"{{prefixElementId}}-lbl-booking-payment-date\"\n              attr.data-selenium-cancellation-date=\"{{ data?.cancellationDate }}\">\n              {{ isShareBudgetByAdmin\n                  ? translate.transform('booking-my-booking-booker-cancel-date')\n                  : translate.transform('booking-my-booking-booker-cancel-booker-date')}} {{ data?.cancellationDate }}\n            </span>\n          </ng-template>\n        </div>\n      </div>\n    </ng-template>\n    <ng-template ngSwitchCase=\"CANCEL_BY_CO_BOOKER\">\n      <div class=\"status\">\n        <img src=\"/assets/images/general/Failed.png\" alt=\"\">\n        <div id=\"{{prefixElementId}}-lbl-booking-cancelled\">\n          <span id=\"{{prefixElementId}}-text-booking-status\" class=\"color-fail status-text\">{{'booking-my-status-cancelled-booking' | translate}}</span>\n          <ng-template [ngIf]=\"data?.cancellationDate\">\n            <span class=\"status-remark\" id=\"{{prefixElementId}}-lbl-booking-payment-date\"\n              attr.data-selenium-cancellation-date=\"{{ data?.cancellationDate }}\">\n              {{ isShareBudgetByAdmin\n                    ? translate.transform('booking-my-booking-booker-cancel-name-date', '{name}', data.cancelBy)\n                    : translate.transform('booking-my-booking-booker-cancel-co-booker-date')}} {{ data?.cancellationDate }}\n            </span>\n          </ng-template>\n        </div>\n      </div>\n    </ng-template>\n    <ng-template ngSwitchCase=\"REJECT_BY_SUPERVISOR\">\n      <div class=\"status\">\n        <img src=\"/assets/images/general/Failed.png\" alt=\"\">\n        <div id=\"{{prefixElementId}}-lbl-booking-cancelled\">\n          <span id=\"{{prefixElementId}}-text-booking-status\" class=\"color-fail status-text\">{{'booking-my-status-cancelled-booking' | translate}}</span>\n          <ng-template [ngIf]=\"data?.cancellationDate\">\n            <span class=\"status-remark\" id=\"{{prefixElementId}}-lbl-booking-payment-date\"\n              attr.data-selenium-cancellation-date=\"{{ data?.cancellationDate }}\">\n              {{ isShareBudgetByAdmin\n                ? translate.transform('booking-my-booking-rejected-date')\n                : translate.transform('booking-my-booking-booker-reject-supervisor-date')}} {{ data?.cancellationDate }}\n            </span>\n          </ng-template>\n        </div>\n      </div>\n      <div *ngIf=\"data?.reason\" class=\"reject-reason\">\n        <span>{{data?.reason}}</span>\n      </div>\n    </ng-template>\n    <ng-template ngSwitchCase=\"REJECT_BY_CO_SUPERVISOR\">\n      <div class=\"status\">\n        <img src=\"/assets/images/general/Failed.png\" alt=\"\">\n        <div id=\"{{prefixElementId}}-lbl-booking-cancelled\">\n          <span id=\"{{prefixElementId}}-text-booking-status\" class=\"color-fail status-text\">{{'booking-my-status-cancelled-booking' | translate}}</span>\n          <ng-template [ngIf]=\"data?.cancellationDate\">\n            <span class=\"status-remark\" id=\"{{prefixElementId}}-lbl-booking-payment-date\"\n              attr.data-selenium-cancellation-date=\"{{ data?.cancellationDate }}\">\n              {{ isShareBudgetByAdmin\n                ? translate.transform('booking-my-booking-rejected-date')\n                : translate.transform('booking-my-booking-booker-reject-co-supervisor-date')}} {{ data?.cancellationDate }}\n            </span>\n          </ng-template>\n        </div>\n      </div>\n      <div *ngIf=\"data?.reason\" class=\"reject-reason\">\n        <span>{{data?.reason}}</span>\n      </div>\n    </ng-template>\n    <ng-template ngSwitchCase=\"DEPART\">\n      <div class=\"status\">\n        <img src=\"/assets/images/general/Checkout.png\" alt=\"\">\n        <div id=\"{{prefixElementId}}-lbl-booking-checkout\">\n          <span id=\"{{prefixElementId}}-text-booking-status\" class=\"status-text\">{{'booking-my-status-already-checkout' | translate}}</span>\n          <ng-template [ngIf]=\"data?.payOnDate\">\n            <span class=\"status-remark\" id=\"{{prefixElementId}}-lbl-booking-payment-date\"\n              attr.data-selenium-payment-date=\"{{ data?.payOnDate }}\">\n              {{'booking-my-booking-payment-date' | translate}} {{ data?.payOnDate }}\n            </span>\n          </ng-template>\n        </div>\n      </div>\n    </ng-template>\n    <ng-template ngSwitchCase=\"ON_PROCESS\">\n      <div class=\"status\">\n        <img src=\"/assets/images/general/Waiting.png\" alt=\"\">\n        <div id=\"{{prefixElementId}}-lbl-booking-inprogress\">\n          <span id=\"{{prefixElementId}}-text-booking-status\" class=\"color-warning status-text\">{{'booking-my-status-inprogress' | translate}}</span>\n        </div>\n      </div>\n    </ng-template>\n    <ng-template ngSwitchCase=\"WAITING_FOR_APPROVE\">\n      <div class=\"status\">\n        <img src=\"/assets/images/general/Success.png\" alt=\"\">\n        <div id=\"{{prefixElementId}}-lbl-booking-awaiting-approval\">\n          <span id=\"{{prefixElementId}}-text-booking-status\" class=\"color-success status-text\">{{'booking-my-status-awaiting-approval' | translate}}</span>\n        </div>\n      </div>\n    </ng-template>\n    <ng-template ngSwitchCase=\"APPROVE\">\n      <div class=\"status\">\n        <img src=\"/assets/images/general/Success.png\" alt=\"\">\n        <div id=\"{{prefixElementId}}-lbl-booking-approved\">\n          <span id=\"{{prefixElementId}}-text-booking-status\" class=\"color-success status-text\">{{'booking-my-status-booking-approved' | translate}}</span>\n          <ng-template [ngIf]=\"data?.approvalDate && !isShareBudgetByAdmin\">\n            <span id=\"{{prefixElementId}}-lbl-booking-approved-date\" class=\"status-remark\"\n              attr.data-selenium-approved-date=\"{{ data?.approvalDate }}\">\n              {{'booking-my-booking-approved-date' | translate}} {{ data?.approvalDate }}\n            </span>\n          </ng-template>\n        </div>\n      </div>\n    </ng-template>\n    <ng-template ngSwitchCase=\"REJECT\">\n      <div class=\"status\">\n        <img src=\"/assets/images/general/Failed.png\" alt=\"\">\n        <div id=\"{{prefixElementId}}-lbl-booking-rejected\">\n          <span id=\"{{prefixElementId}}-text-booking-status\" class=\"color-fail status-text\">{{'booking-my-status-cancelled-booking' | translate}}</span>\n          <ng-template [ngIf]=\"data?.approvalDate\">\n            <span id=\"{{prefixElementId}}-lbl-booking-rejected-date\" class=\"status-remark\"\n              attr.data-selenium-rejected-date=\"{{ data?.approvalDate }}\">\n              {{'booking-my-booking-rejected-date' | translate}} {{ data?.approvalDate }}\n            </span>\n          </ng-template>\n        </div>\n      </div>\n      <div *ngIf=\"data?.reason\" class=\"reject-reason\">\n        <span>{{data?.reason}}</span>\n      </div>\n    </ng-template>\n  </div>\n</ng-template>\n\n<ng-template #travellerInfoTemplate let-data=\"data\">\n  <div class=\"header\">{{ 'booking-detail-details-traveller-info-title' | translate }}</div>\n  <div class=\"data\">\n    <ng-template [ngIf]=\"!isMobile\">\n      <div class=\"traveller-table-header\">\n        <div class=\"traveller-table-row-header\">\n          <div class=\"traveller-table-title-header col-l\">\n            {{ 'booking-detail-details-traveller-info-table-room-header' | translate }}\n          </div>\n          <div class=\"traveller-table-title-header col-m\">\n            {{ 'booking-detail-details-traveller-info-table-guest-header' | translate }}\n          </div>\n          <div class=\"traveller-table-title-header col-m\">\n            {{ 'booking-detail-details-traveller-info-table-supervisor-header' | translate }}\n          </div>\n        </div>\n      </div>\n      <div *ngFor=\"let traveller of data; let i = index\" class=\"traveller-table-detail\">\n        <div class=\"traveller-table-detail-room col-l\" id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-room-name\">{{traveller.roomTypeName}}</div>\n        <div *ngFor=\"let guest of traveller.travellers; let j = index\" class=\"traveller-table-detail-guest-sup\">\n          <div class=\"traveller-table-detail-guest-detail\">\n            <span id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-guest-name\">{{guest.name}}</span>\n            <br>\n            <div *ngIf=\"guest.checkoutFields && guest.checkoutFields.length > 0\" class=\"traveller-table-detail-guest-detail-content-check-out\">\n              <ng-container *ngFor=\"let field of guest.checkoutFields; let k = index\">\n                <p id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-field-{{k}}-checkout-value\">{{field.displayName}} : {{field.value ? field.value : '-'}}</p>\n              </ng-container>\n            </div>\n          </div>\n          <div class=\"traveller-table-detail-sup-detail\">\n            <ng-template [ngIf]=\"guest.approval\">\n              <span id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-approval-name\">{{guest.approval.approvalName}}</span>\n              <br>\n              <span *ngIf=\"guest.approval.approvalStatus === approvalStatusType.PENDING\" class=\"status-pending\" id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-approval-status\">\n                {{ 'booking-detail-details-traveller-info-table-pending-status' | translate }}\n              </span>\n              <span *ngIf=\"guest.approval.approvalStatus === approvalStatusType.APPROVE\" class=\"status-approved\" id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-approval-status\">\n                {{ 'booking-detail-details-traveller-info-table-approved-status' | translate }}\n              </span>\n              <span *ngIf=\"guest.approval.approvalStatus === approvalStatusType.REJECT\" class=\"status-rejected\" id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-approval-status\">\n                {{ 'booking-detail-details-traveller-info-table-rejected-status' | translate }}\n              </span>\n              <span *ngIf=\"guest.approval.approvalStatus === approvalStatusType.UNABLE_TO_ACTION || guest.approval.approvalStatus === approvalStatusType.UNKNOW\" class=\"status-unable\" id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-approval-status\">\n                {{ 'booking-detail-details-traveller-info-table-unable-status' | translate }}\n              </span>\n            </ng-template>\n            <ng-template [ngIf]=\"!guest.approval\">\n              <span id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-approval-name\">-</span>\n            </ng-template>\n          </div>\n        </div>\n      </div>\n    </ng-template>\n\n    <ng-template [ngIf]=\"isMobile\">\n      <div class=\"traveller-table-header\">\n        <div class=\"traveller-table-row-header\">\n          <div class=\"mb-traveller-table-title-header\">\n            {{ 'booking-detail-details-traveller-info-table-room-header' | translate }}\n          </div>\n        </div>\n      </div>\n      <div *ngFor=\"let traveller of data; let i = index\" class=\"traveller-table-detail\">\n        <div class=\"mb-traveller-table-detail-room\" id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-room-name\">{{traveller.roomTypeName}}</div>\n        <div *ngFor=\"let guest of traveller.travellers; let j = index\" class=\"traveller-table-detail-guest-sup\">\n          <div class=\"mb-traveller-table-detail-guest-header\">\n            <div class=\"mb-traveller-table-detail-guest-header-title\">{{ 'booking-detail-details-traveller-info-table-guest-number-header' | translate }} {{j + 1}} :</div>\n          </div>\n          <div class=\"mb-traveller-table-detail-guest-detail\">\n            <div class=\"mb-traveller-table-detail-guest-detail-content\">\n              <span id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-guest-name\">{{guest.name}}</span>\n              <div *ngIf=\"guest.checkoutFields && guest.checkoutFields.length > 0\" class=\"mb-traveller-table-detail-guest-detail-content-check-out\">\n                <ng-container *ngFor=\"let field of guest.checkoutFields; let k = index\">\n                  <p id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-field-{{k}}-checkout-value\">{{field.displayName}} : {{field.value ? field.value : '-'}}</p>\n                </ng-container>\n              </div>\n              <div class=\"mb-traveller-table-detail-sup-detail\">\n                <ng-template [ngIf]=\"guest.approval\">\n                  <span id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-approval-name\">{{guest.approval.approvalName}}</span>\n                  <br>\n                  <span *ngIf=\"guest.approval.approvalStatus === approvalStatusType.PENDING\" class=\"status-pending\" id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-approval-status\">\n                    {{ 'booking-detail-details-traveller-info-table-pending-status' | translate }}\n                  </span>\n                  <span *ngIf=\"guest.approval.approvalStatus === approvalStatusType.APPROVE\" class=\"status-approved\" id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-approval-status\">\n                    {{ 'booking-detail-details-traveller-info-table-approved-status' | translate }}\n                  </span>\n                  <span *ngIf=\"guest.approval.approvalStatus === approvalStatusType.REJECT\" class=\"status-rejected\" id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-approval-status\">\n                    {{ 'booking-detail-details-traveller-info-table-rejected-status' | translate }}\n                  </span>\n                  <span *ngIf=\"guest.approval.approvalStatus === approvalStatusType.UNABLE_TO_ACTION || guest.approval.approvalStatus === approvalStatusType.UNKNOW\" class=\"status-unable\" id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-approval-status\">\n                    {{ 'booking-detail-details-traveller-info-table-unable-status' | translate }}\n                  </span>\n                </ng-template>\n                <ng-template [ngIf]=\"!guest.approval\">\n                  <span id=\"{{prefixElementId}}-lbl-booking-guest-detail-room-{{i}}-guest-{{j}}-approval-name\">-</span>\n                </ng-template>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-template>\n  </div>\n</ng-template>\n"

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wrap-inner-auto\" *ngIf=\"showBudgetBar && (isLimitBudget || isShareBudget) && isWorkPurpose && !allowBookForTraveller\">\n  <div class=\"alert alert-dismissible alert-top-wrap\">\n    <p id=\"{{name}}-text-budget-limit\" [ngClass]=\"{'d-inline': isNewBudget}\" [innerHTML]=\"description\"></p>\n    <a *ngIf=\"isNewBudget\" class=\"tooltips hide-sm\" id=\"{{name}}-a-tooltips\">\n      {{'budget-limit-view-detail' | translate}}\n      <div class=\"for-hover\">\n      </div>\n      <div [ngSwitch]=\"true\">\n\n        <ng-template [ngSwitchCase]=\"template === 'special_budget' || template === 'unlimited_share_budget_feature'\">\n          <div class=\"tooltips-content under\">\n            <div class=\"tc-container-special-budget\">\n              <div class=\"tc-item\">\n                <div id=\"{{name}}-tooltip-content-average-budget-title\">\n                  {{'budget-limit-special-budget-for-destination' | translate}}</div>\n                <div class=\"font-bold\" id=\"{{name}}-tooltip-content-average-budget\">{{textAverageBudget ?\n                  textAverageBudget : ('budget-unlimited' | translate)}}</div>\n              </div>\n              <div class=\"tc-item\">\n                <div id=\"{{name}}-tooltip-content-normal-title\">{{'budget-limit-normal-budget' | translate}}</div>\n                <div id=\"{{name}}-tooltip-content-normal-budget\">{{textNormalBudget}}</div>\n              </div>\n            </div>\n          </div>\n        </ng-template>\n\n        <ng-template [ngSwitchCase]=\"template === 'special_budget_some_days'\">\n          <div class=\"tooltips-content under\">\n            <div class=\"tc-container-some-days\">\n              <div class=\"title\">{{ 'budget-limit-tittle' | translate }}</div>\n              <div class=\"detail\">{{ 'budget-limit-detail' | translate }}</div>\n              <div class=\"tc-group\">\n                <div class=\"tc-item color-main\">\n                  <div id=\"{{name}}-tooltip-content-normal-title\">{{'budget-limit-normal-budget' | translate}}</div>\n                  <div id=\"{{name}}-tooltip-content-normal-budget\">{{textNormalBudget}}</div>\n                </div>\n\n                <div class=\"tc-item\" *ngFor=\"let item of itemList; let i = index\">\n                  <div id=\"{{name}}-tooltip-content-special-title-{{i}}\">{{item.title}}</div>\n                  <div id=\"{{name}}-tooltip-content-special-budget-{{i}}\">{{item.subTitle}}</div>\n                </div>\n              </div>\n\n              <div class=\"tc-item last has-more-detail\">\n                <div id=\"{{name}}-tooltip-content-average-budget-title\">{{'budget-limit-net-budget' | translate}}</div>\n                <div id=\"{{name}}-tooltip-content-average-budget\" class=\"font-bold\">{{textAverageBudget}}</div>\n              </div>\n            </div>\n            <div id=\"{{name}}-tooltip-more-detail\" class=\"more-detail\" (click)=\"onClickMoreDetail()\">\n              {{ 'budget-limit-more-detail' | translate}}\n            </div>\n          </div>\n        </ng-template>\n\n        <ng-template [ngSwitchCase]=\"template === 'special_budget_poi'\">\n          <div class=\"tooltips-content under\">\n            <div class=\"tc-container-poi\">\n              <div class=\"title\">{{ 'budget-limit-tittle' | translate }}</div>\n              <div class=\"detail\">{{ 'budget-limit-detail-poi' | translate }}</div>\n\n              <div class=\"tc-group\">\n                <div class=\"tc-item color-main\">\n                  <div id=\"{{name}}-tooltip-content-normal-title\">{{'budget-limit-normal-budget' | translate}}</div>\n                  <div id=\"{{name}}-tooltip-content-normal-budget\">{{textNormalBudget}}</div>\n                </div>\n\n                <div class=\"tc-item\" *ngFor=\"let item of itemList; let i = index\">\n                  <div id=\"{{name}}-tooltip-content-special-title-{{i}}\">{{item.title}}</div>\n                  <div id=\"{{name}}-tooltip-content-special-budget-{{i}}\">{{item.subTitle}}</div>\n                </div>\n              </div>\n\n              <div class=\"tc-item last has-more-detail\">\n                <div id=\"{{name}}-tooltip-content-bottom-title\" class=\"w-100\">\n                  {{'budget-limit-detail-bottom-poi' | translate}}</div>\n              </div>\n\n            </div>\n            <div id=\"{{name}}-tooltip-more-detail\" class=\"more-detail\" (click)=\"onClickMoreDetail()\">\n              {{ 'budget-limit-more-detail' | translate}}\n            </div>\n          </div>\n        </ng-template>\n\n        <ng-template\n          [ngSwitchCase]=\"template === 'share_budget' || template === 'share_budget_special_budget' || template === 'share_budget_special_budget_poi'\">\n          <div class=\"tooltips-content under\">\n            <div class=\"tc-container-poi\">\n              <ng-template [ngIf]=\"template === 'share_budget_special_budget'\">\n                <div class=\"title\">{{ 'budget-limit-share-budget-title' | translate }}</div>\n                <div class=\"detail\">{{ 'budget-limit-share-budget-detail' | translate }}</div>\n              </ng-template>\n\n              <ng-template [ngIf]=\"template === 'share_budget_special_budget_poi'\">\n                <div class=\"title\">{{ 'budget-limit-share-budget-title' | translate }}</div>\n                <div class=\"detail\">{{ 'budget-limit-detail-poi' | translate }}</div>\n              </ng-template>\n\n              <ng-template [ngIf]=\"template === 'share_budget'\">\n                <div class=\"title\">{{ 'search-box-tooltips-share-budget-detail-title' | translate }}</div>\n              </ng-template>\n\n              <div class=\"tc-group\">\n                <div class=\"tc-item color-main\">\n                  <ng-template [ngIf]=\"template !== 'share_budget_special_budget_poi'\">\n                    <div id=\"{{name}}-tooltip-content-normal-title\">\n                      {{'budget-limit-booker-budget' | translate}}</div>\n                  </ng-template>\n                  <ng-template [ngIf]=\"template === 'share_budget_special_budget_poi'\">\n                    <div id=\"{{name}}-tooltip-content-normal-title\">\n                      {{'budget-limit-normal-budget-booker' | translate}}</div>\n                  </ng-template>\n                  <div id=\"{{name}}-tooltip-content-normal-budget\">{{ shareBudget?.booker?.amount ? 'THB ' +\n                    (shareBudget?.booker?.amount | number) :\n                    ('budget-unlimited' | translate) }}</div>\n                </div>\n\n                <div class=\"tc-item\" *ngFor=\"let item of itemList; let i = index\">\n                  <div id=\"{{name}}-tooltip-content-booker-special-title-{{i}}\">{{item.title}}</div>\n                  <div id=\"{{name}}-tooltip-content-booker-special-budget-{{i}}\">{{item.subTitle}}</div>\n                </div>\n              </div>\n\n              <div class=\"tc-group\">\n                <div class=\"tc-item\">\n                  <div id=\"{{name}}-tooltip-content-co-booker-normal-budget-title\">{{\n                    template === 'share_budget_special_budget_poi' ? ('budget-limit-normal-budget-co-booker' | translate) :\n                    ('budget-limit-co-booker-budget' | translate) }}\n                    <br>\n                    <span id=\"{{name}}-tooltip-content-co-booker-email\">\n                      {{ shareBudget?.coBooker?.email }}\n                    </span>\n                  </div>\n                  <div id=\"{{name}}-tooltip-content-co-booker-normal-budget\">{{ shareBudget?.coBooker?.amount ? 'THB ' +\n                    (shareBudget?.coBooker?.amount | number) :\n                    ('budget-unlimited' | translate) }}</div>\n                </div>\n                <div class=\"tc-item\" *ngFor=\"let item of itemListCoBooker; let i = index\">\n                  <div id=\"{{name}}-tooltip-content-co-booker-special-title-{{i}}\">{{item.title}}</div>\n                  <div id=\"{{name}}-tooltip-content-co-booker-special-budget-{{i}}\">{{item.subTitle}}</div>\n                </div>\n              </div>\n\n              <div class=\"tc-item co-budget-note\" *ngIf=\"appliedCoBudget\">\n                {{ 'budget-limit-applied-co-budget' | translate }}\n              </div>\n\n              <ng-template [ngIf]=\"template === 'share_budget_special_budget_poi'\">\n                <div class=\"tc-item last has-more-detail\">\n                  <div id=\"{{name}}-tooltip-content-bottom-title\" class=\"w-100\">\n                    {{ 'budget-limit-detail-bottom-poi' | translate}}</div>\n                </div>\n              </ng-template>\n\n              <ng-template [ngIf]=\"template === 'share_budget' || template === 'share_budget_special_budget'\">\n                <div class=\"tc-item last\" [ngClass]=\"{'has-more-detail': template !== 'share_budget'}\">\n                  <div id=\"{{name}}-tooltip-content-bottom-title\">\n                    {{ 'search-box-tooltips-share-budget-detail-total-budget' | translate}}</div>\n                  <div class=\"font-bold\" id=\"{{name}}-tooltip-content-bottom-total-budget\">\n                    {{ shareBudget?.totalBudget ? 'THB ' +\n                    (shareBudget?.totalBudget | number) :\n                    ('budget-unlimited' | translate) }}</div>\n                </div>\n              </ng-template>\n\n            </div>\n            <div *ngIf=\"template !== 'share_budget'\" id=\"{{name}}-tooltip-more-detail\" class=\"more-detail\"\n              (click)=\"onClickMoreDetail()\">\n              {{ 'budget-limit-more-detail' | translate}}\n            </div>\n          </div>\n        </ng-template>\n      </div>\n    </a>\n\n    <a *ngIf=\"isNewBudget\" class=\"tooltips show-sm\" id=\"{{name}}-a-tooltips\" (click)=\"onMobileClickDetail()\">\n      {{'budget-limit-view-detail' | translate}}\n    </a>\n\n    <!--- desktop share budget--->\n    <ng-template [ngIf]=\"isShareBudget && !shareBudget\">\n      <a class=\"share-budget tooltips hide-sm\" (click)=\"openDialogShareBudget()\" id=\"searchbox-share-budget\">\n        <i class=\"icon-add\"></i>\n        <span>\n          {{'search-box-share-budget' | translate}}\n        </span>\n        <div class=\"tooltips-content hide-sm\" [ngClass]=\"{'tooltips-content-en': lang === 'en'}\">\n          {{'search-box-share-budget-tooltips' | translate }}\n        </div>\n      </a>\n    </ng-template>\n    <ng-template [ngIf]=\"isShareBudget && shareBudget\">\n      <a class=\"share-budget tooltips hide-sm\" (click)=\"onCancelShareBudget()\" id=\"{{name}}-cancel-share-budget\">\n        <i class=\"icon-delete2\"></i>\n        <span>\n          {{'search-box-cancel-share-budget' | translate}}\n        </span>\n      </a>\n    </ng-template>\n    <!--- end desktop share budget--->\n  </div>\n  <!--- mobile share budget--->\n  <ng-template [ngIf]=\"isShareBudget && !shareBudget\">\n    <div class=\"share-budget-mobile show-sm\">\n      <a (click)=\"openDialogShareBudget()\">\n        <i class=\"icon-add\"></i>\n        <span>\n          {{'search-box-share-budget' | translate}}\n        </span>\n      </a>\n    </div>\n  </ng-template>\n  <ng-template [ngIf]=\"isShareBudget && shareBudget\">\n    <div class=\"share-budget-mobile show-sm\">\n      <a (click)=\"onCancelShareBudget()\" id=\"searchbox-cancel-share-budget\">\n        <i class=\"icon-delete2\"></i>\n        <span>\n          {{'search-box-cancel-share-budget' | translate}}\n        </span>\n      </a>\n    </div>\n  </ng-template>\n  <!--- end mobile share budget --->\n</div>\n"

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [disbledClose]=\"true\" [disbledClickBackground]=\"false\">\n  <div class=\"box\">\n    <div id=\"{{name}}-title\" class=\"title\">\n      {{'budget-limit-tittle' | translate}}\n      <div *ngIf=\"!isMobile\" id=\"{{name}}-btn-close\" class=\"icon-close2 button\" (click)=\"onClose()\">\n      </div>\n    </div>\n    <div id=\"{{name}}-description\" class=\"sub-title\">\n      {{ isPOIs ? ('budget-limit-dialog-detail-poi' | translate) : ('budget-limit-detail' | translate) }}\n    </div>\n    <div class=\"table-overflow\">\n      <span *ngIf=\"data?.isShareBudget;then shareBudget else normalBudget;\"></span>\n      <ng-template #shareBudget>\n        <div *ngIf=\"shareBudgetDestination?.length > 1\" class=\"destination-list\">\n          <ul class=\"row\">\n            <li *ngFor=\"let destination of shareBudgetDestination;let i = index\" id=\"{{name}}-table-destination-{{i}}\">\n              <a (click)=\"onGoTable(i)\">{{destination.name}}</a>\n            </li>\n          </ul>\n        </div>\n\n        <div class=\"table-responsive\">\n          <ng-container *ngIf=\"isMobile; else desktopShareBudget\">\n            <table *ngFor=\"let table of tableList; let i = index\" id=\"{{name}}-table-{{i}}\" class=\"table share-budget mobile\">\n              <thead>\n                <tr>\n                  <td class=\"first-column border-right-none\">\n                    {{ 'budget-limit-day-check-in' | translate}}\n                  </td>\n                  <td id=\"{{name}}-table-{{i}}-destination-name\">\n                    <div id=\"{{name}}-table-{{i}}-destination-name\" *ngIf=\"shareBudgetDestination?.length > 1\">\n                      {{'budget-limit-for' | translate}}<span *ngIf=\"lang === 'en'\"> </span>{{shareBudgetDestination[i].name}}\n                    </div>\n                    <div>\n                      {{'budget-limit-sum-budget-per-night' | translate}}\n                    </div>\n                  </td>\n                </tr>\n              </thead>\n              <tbody>\n                <ng-container *ngFor=\"let item of table; let x = index\">\n                  <tr class=\"bg-unset\">\n                    <td [colSpan]=\"2\" class=\"first-column\" id=\"{{name}}-table-{{i}}-date-{{x}}\">\n                      {{ item[0].title }}\n                    </td>\n                  </tr>\n                  <tr class=\"bg-unset\">\n                    <td class=\"first-column\" id=\"{{name}}-booker-budget-title-{{i}}-{{x}}\">\n                      <div class=\"summary-sub-title color-sub\">\n                        {{ 'budget-limit-booker-budget' | translate}}\n                      </div>\n                      <div id=\"{{name}}-budget-{{i}}-{{x}}\">\n                        {{item[1].title}}\n                      </div>\n                    </td>\n                    <td [rowSpan]=\"2\">\n                      <div id=\"{{name}}-total-budget-{{i}}-{{x}}\">\n                        {{item[3].totalBudget}}\n                      </div>\n                      <div class=\"total-budget-remark\" *ngIf=\"item[3].appliedCoBudget\" id=\"{{name}}-total-budget-remark-{{i}}-{{x}}\">\n                        **\n                      </div>\n                    </td>\n                  </tr>\n                  <tr class=\"bg-unset\">\n                    <td class=\"first-column border-co-booker\" id=\"{{name}}-co-booker-budget-title-{{i}}-{{x}}\">\n                      <div class=\"summary-sub-title color-sub\">\n                        {{ 'budget-limit-co-booker-budget' | translate}}\n                      </div>\n                      <div id=\"{{name}}-co-booker-budget-{{i}}-{{x}}\">\n                        {{item[2].title}}\n                      </div>\n                    </td>\n                  </tr>\n                </ng-container>\n              </tbody>\n              <tfoot>\n                <tr>\n                  <td class=\"box-summary first-column\">\n                    <div id=\"{{name}}-summary-budget-title-{{i}}\" class=\"summary-title\">\n                      {{ 'budget-limit-budget-per-night-per-room' | translate }}\n                    </div>\n                    <div id=\"{{name}}-summary-budget-sub-title-{{i}}\" class=\"summary-sub-title\">\n                      {{ 'budget-limit-for-search' | translate }}\n                    </div>\n                  </td>\n                  <td class=\"total\">\n                    <div id=\"{{name}}-summary-budget-{{i}}\" [innerHTML]=\"totalList[i].totalBudget\"></div>\n                    <div class=\"total-budget-remark\" *ngIf=\"totalList[i].appliedCoBudget\">\n                      {{ 'budget-limit-applied-co-budget' | translate }}\n                    </div>\n                  </td>\n                </tr>\n              </tfoot>\n            </table>\n          </ng-container>\n          <ng-template #desktopShareBudget>\n            <table *ngFor=\"let table of tableList; let i = index\" id=\"{{name}}-table-{{i}}\" class=\"table share-budget\">\n              <thead>\n                <ng-container *ngIf=\"shareBudgetDestination?.length > 1; else shareBudgetSingleDestination\">\n                  <tr>\n                    <td [rowSpan]=\"2\" class=\"first-column\">\n                      {{ 'budget-limit-day-check-in' | translate}}\n                    </td>\n                    <td [colSpan]=\"3\" class=\"destination\" id=\"{{name}}-table-{{i}}-destination-name\">\n                      {{'budget-limit-for' | translate}}<span *ngIf=\"lang === 'en'\"> </span>{{shareBudgetDestination[i].name}}\n                    </td>\n                  </tr>\n                  <tr>\n                    <td>\n                      {{ 'budget-limit-booker-budget' | translate}}\n                    </td>\n                    <td>\n                      {{ 'budget-limit-co-booker-budget' | translate}}\n                    </td>\n                    <td>\n                      {{'budget-limit-sum-budget-per-night' | translate}}\n                    </td>\n                  </tr>\n                </ng-container>\n                <ng-template #shareBudgetSingleDestination>\n                  <tr>\n                    <td class=\"first-column\">\n                      {{ 'budget-limit-day-check-in' | translate}}\n                    </td>\n                    <td>\n                      {{ 'budget-limit-booker-budget' | translate}}\n                    </td>\n                    <td>\n                      {{ 'budget-limit-co-booker-budget' | translate}}\n                    </td>\n                    <td>\n                      {{'budget-limit-sum-budget-per-night' | translate}}\n                    </td>\n                  </tr>\n                </ng-template>\n              </thead>\n              <tbody>\n                <tr class=\"bg-unset\" *ngFor=\"let item of table; let x = index\">\n                  <td class=\"first-column\" id=\"{{name}}-table-{{i}}-date-{{x}}\">\n                    {{ item[0].title }}\n                  </td>\n                  <td id=\"{{name}}-booker-budget-title-{{i}}-{{x}}\">\n                    <div id=\"{{name}}-budget-{{i}}-{{x}}\">\n                      {{item[1].title}}\n                    </div>\n                    <div id=\"{{name}}-sub-budget-{{i}}-{{x}}\" class=\"summary-sub-title color-sub\"\n                      *ngIf=\"item[1].subTitle\">\n                      {{item[1].subTitle}}\n                    </div>\n                  </td>\n                  <td class=\"border-co-booker\" id=\"{{name}}-co-booker-budget-title-{{i}}-{{x}}\">\n                    <div id=\"{{name}}-co-booker-budget-{{i}}-{{x}}\">\n                      {{item[2].title}}\n                    </div>\n                    <div id=\"{{name}}-co-booker-sub-budget-{{i}}-{{x}}\" class=\"summary-sub-title color-sub\"\n                      *ngIf=\"item[2].subTitle\">\n                      {{item[2].subTitle}}\n                    </div>\n                  </td>\n                  <td>\n                    <div id=\"{{name}}-total-budget-{{i}}-{{x}}\">\n                      {{item[3].totalBudget}}\n                    </div>\n                    <div class=\"total-budget-remark\" *ngIf=\"item[3].appliedCoBudget\" id=\"{{name}}-total-budget-remark-{{i}}-{{x}}\">\n                      **\n                    </div>\n                  </td>\n                </tr>\n              </tbody>\n              <tfoot>\n                <tr>\n                  <td class=\"box-summary first-column\">\n                    <div id=\"{{name}}-summary-budget-title-{{i}}\" class=\"summary-title\">\n                      {{ 'budget-limit-budget-per-night-per-room' | translate }}\n                    </div>\n                    <div id=\"{{name}}-summary-budget-sub-title-{{i}}\" class=\"summary-sub-title\">\n                      {{ 'budget-limit-for-search' | translate }}\n                    </div>\n                  </td>\n                  <td class=\"total\" [colSpan]=\"3\">\n                    <div id=\"{{name}}-summary-budget-{{i}}\" [innerHTML]=\"totalList[i].totalBudget\"></div>\n                    <div class=\"total-budget-remark\" *ngIf=\"totalList[i].appliedCoBudget\">\n                      {{ 'budget-limit-applied-co-budget' | translate }}\n                    </div>\n                  </td>\n                </tr>\n              </tfoot>\n            </table>\n          </ng-template>\n        </div>\n      </ng-template>\n      <ng-template #normalBudget>\n        <span *ngIf=\"isMobile && data?.destinationTravelPolicyBooker?.length > 1;then mobilePOI else default;\"></span>\n        <ng-template #mobilePOI>\n          <div class=\"destination-list\">\n            <ul class=\"row\">\n              <li *ngFor=\"let title of titleList;let i = index\" id=\"{{name}}-table-destination-{{i}}\"\n                (click)=\"onGoTable(i)\">\n                {{title}}\n              </li>\n            </ul>\n\n            <table *ngFor=\"let table of tableList; let i = index\" id=\"{{name}}-table-{{i}}\">\n              <tr>\n                <td class=\"border-right-none\">{{ 'budget-limit-day-check-in' | translate }}</td>\n                <td id=\"{{name}}-title-per-night\">{{ 'budget-limit-budget-per-night' | translate}}<span *ngIf=\"lang === 'en'\"> </span>{{titleList[i]}}</td>\n              </tr>\n\n              <tr *ngFor=\"let item of table; let itemI = index\">\n                <td *ngFor=\"let day of item; let dayI= index\">\n                  <div id=\"{{name}}-value-{{itemI}}-{{dayI}}\">\n                    {{day.title}}\n                  </div>\n                  <div class=\"summary-sub-title color-sub\" *ngIf=\"day.subTitle\"\n                    id=\"{{name}}-sub-value-{{itemI}}-{{dayI}}\">\n                    {{day.subTitle}}\n                  </div>\n                </td>\n              </tr>\n\n              <tr>\n                <td class=\"border-right-none\">\n                  <div class=\"summary-title\">\n                    {{ 'budget-limit-budget-per-night-per-room' | translate }}\n                  </div>\n                  <div class=\"summary-sub-title\">\n                    {{ 'budget-limit-for-search' | translate }}\n                  </div>\n                </td>\n                <td class=\"total\" id=\"{{name}}-total-{{i}}\" [innerHTML]=\"totalList[i]\">\n                </td>\n              </tr>\n            </table>\n          </div>\n        </ng-template>\n        <ng-template #default>\n          <table>\n            <tr>\n              <td class=\"border-right-none\">{{ 'budget-limit-day-check-in' | translate }}</td>\n              <span *ngIf=\"titleList?.length === 1;then perNight else perDestination;\"></span>\n              <ng-template #perNight>\n                <td class=\"border-right-none\" id=\"{{name}}-title-per-night\">\n                  {{ 'budget-limit-budget-per-night' | translate}}</td>\n              </ng-template>\n              <ng-template #perDestination>\n                <td *ngFor=\"let title of titleList; let i = index\" class=\"border-right-none\"\n                  id=\"{{name}}-title-destination-{{i}}\">{{ 'budget-limit-budget-per-night' | translate}}<span *ngIf=\"lang === 'en'\"> </span>{{title}}</td>\n              </ng-template>\n            </tr>\n\n            <tr *ngFor=\"let item of itemList; let itemI = index\">\n              <td *ngFor=\"let day of item; let dayI= index\">\n                <div id=\"{{name}}-value-{{itemI}}-{{dayI}}\">\n                  {{day.title}}\n                </div>\n                <div class=\"summary-sub-title color-sub\" *ngIf=\"day.subTitle\"\n                  id=\"{{name}}-sub-value-{{itemI}}-{{dayI}}\">\n                  {{day.subTitle}}\n                </div>\n              </td>\n            </tr>\n\n            <tr>\n              <td [ngClass]=\"{'border-right-none': data?.destinationTravelPolicyBooker?.length === 1} \">\n                <div class=\"summary-title\">\n                  {{ 'budget-limit-budget-per-night-per-room' | translate }}\n                </div>\n                <div class=\"summary-sub-title\">\n                  {{ 'budget-limit-for-search' | translate }}\n                </div>\n              </td>\n              <td\n                *ngFor=\"let total of totalList; let i = index\"\n                class=\"total\" id=\"{{name}}-total-{{i}}\"\n                [innerHTML]=\"total\"\n              ></td>\n            </tr>\n          </table>\n        </ng-template>\n      </ng-template>\n    </div>\n    <div *ngIf=\"isMobile\" class=\"footer\">\n      <div class=\"action-left\"></div>\n      <div class=\"action-right\">\n        <button\n          id=\"{{name}}-btn-close\"\n          class=\"ota-btn-main\"\n          (click)=\"onClose()\">\n          {{ 'btn-close' | translate }}\n        </button>\n      </div>\n    </div>\n  </div>\n</ota-dialog>\n"

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [disbledClose]=\"true\" [disbledClickBackground]=\"false\">\n  <div class=\"box\">\n    <div [ngSwitch]=\"true\">\n\n      <ng-template [ngSwitchCase]=\"data?.template === 'special_budget' || data?.template === 'unlimited_share_budget_feature'\">\n        <div class=\"tc-container-special-budget\">\n          <div class=\"box-bottom\">\n            <div class=\"tc-item\">\n              <div id=\"{{name}}-average-budget-title\">\n                {{'budget-limit-special-budget-for-destination' | translate}}</div>\n              <div class=\"font-bold\" id=\"{{name}}-average-budget\">{{data?.textAverageBudget ?\n                data?.textAverageBudget : ('budget-unlimited' | translate)}}</div>\n            </div>\n            <div class=\"tc-item\">\n              <div id=\"{{c-container-special-budget}}-normal-title\">\n                {{'budget-limit-normal-budget' | translate}}</div>\n              <div id=\"{{name}}-normal-budget\">{{ data?.budgetBooker ? 'THB ' +\n                (data?.budgetBooker | number) :\n                ('budget-unlimited' | translate) }}</div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"btn-close\">\n              <a (click)=\"onClose()\" id=\"{{name}}-btn-close\">\n                {{ 'my-profile-address-dialog-button-close' | translate }}\n              </a>\n            </div>\n          </div>\n        </div>\n      </ng-template>\n\n      <ng-template [ngSwitchCase]=\"data?.template === 'special_budget_some_days'\">\n        <div class=\"tc-container-some-days\">\n          <div class=\"title\">{{ 'budget-limit-tittle' | translate }}</div>\n          <div class=\"detail\">{{ 'budget-limit-detail' | translate }}</div>\n          <div class=\"tc-group\">\n            <div class=\"tc-item color-main\">\n              <div id=\"{{name}}-normal-title\">{{'budget-limit-normal-budget' | translate}}</div>\n              <div id=\"{{name}}-normal-budget\">{{ data?.budgetBooker ? 'THB ' +\n                (data?.budgetBooker | number) :\n                ('budget-unlimited' | translate) }}</div>\n            </div>\n\n            <div class=\"tc-item\" *ngFor=\"let item of data.itemList; let i = index\">\n              <div id=\"{{name}}-special-title-{{i}}\">{{item.title}}</div>\n              <div id=\"{{name}}-special-budget-{{i}}\">{{item.subTitle}}</div>\n            </div>\n          </div>\n\n          <div class=\"box-bottom\">\n            <div class=\"tc-item\">\n              <div id=\"{{name}}-average-budget-title\">{{'budget-limit-net-budget' | translate}}</div>\n              <div id=\"{{name}}-average-budget\" class=\"font-bold\">{{data.textAverageBudget}}</div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div id=\"{{name}}-btn-close\" class=\"btn-close\">\n              <a (click)=\"onClose()\">\n                {{ 'my-profile-address-dialog-button-close' | translate }}\n              </a>\n            </div>\n            <div class=\"btn-more-detail\">\n              <a (click)=\"onMoreDetail()\" id=\"{{name}}-btn-more-detail\">\n                {{ 'budget-limit-more-detail' | translate}}\n              </a>\n            </div>\n          </div>\n        </div>\n      </ng-template>\n\n      <ng-template [ngSwitchCase]=\"data?.template === 'special_budget_poi'\">\n        <div class=\"tc-container-poi\">\n          <div class=\"title\">{{ 'budget-limit-tittle' | translate }}</div>\n          <div class=\"detail\">{{ 'budget-limit-detail-poi' | translate }}</div>\n          <div class=\"tc-group\">\n            <div class=\"tc-item color-main\">\n              <div id=\"{{name}}-normal-title\">{{'budget-limit-normal-budget' | translate}}</div>\n              <div id=\"{{name}}-normal-budget\">{{ data?.budgetBooker ? 'THB ' +\n                (data?.budgetBooker | number) :\n                ('budget-unlimited' | translate) }}</div>\n            </div>\n\n            <div class=\"tc-item\" *ngFor=\"let item of data.itemList; let i = index\">\n              <div id=\"{{name}}-special-title-{{i}}\">{{item.title}}</div>\n              <div id=\"{{name}}-special-budget-{{i}}\">{{item.subTitle}}</div>\n            </div>\n          </div>\n\n          <div class=\"box-bottom\">\n            <div class=\"box\">\n              <div id=\"{{name}}-bottom-title\" class=\"w-100\">\n                {{'budget-limit-detail-bottom-poi' | translate}}</div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div id=\"{{name}}-btn-close\" class=\"btn-close\">\n              <a (click)=\"onClose()\">\n                {{ 'my-profile-address-dialog-button-close' | translate }}\n              </a>\n            </div>\n            <div class=\"btn-more-detail\">\n              <a (click)=\"onMoreDetail()\" id=\"{{name}}-btn-more-detail\">\n                {{ 'budget-limit-more-detail' | translate}}\n              </a>\n            </div>\n          </div>\n        </div>\n      </ng-template>\n\n      <ng-template\n        [ngSwitchCase]=\"data?.template === 'share_budget' || data?.template === 'share_budget_special_budget' || data?.template === 'share_budget_special_budget_poi'\">\n        <div class=\"tooltips-content under\">\n          <div class=\"tc-container-poi\">\n            <ng-template [ngIf]=\"data?.template !== 'share_budget'\">\n              <div class=\"title\">{{ 'budget-limit-share-budget-title' | translate }}</div>\n              <div class=\"detail\">{{ 'budget-limit-share-budget-detail' | translate }}</div>\n            </ng-template>\n\n            <ng-template [ngIf]=\"data?.template === 'share_budget'\">\n              <div class=\"title\">{{ 'search-box-tooltips-share-budget-detail-title' | translate }}</div>\n            </ng-template>\n\n            <div class=\"tc-group\">\n              <div class=\"tc-item color-main\">\n                <ng-template [ngIf]=\"data?.template !== 'share_budget_special_budget_poi'\">\n                  <div id=\"{{name}}-tooltip-content-booker-normal-budget-title\">\n                    {{'search-box-tooltips-share-budget-detail-booker-budget' | translate}}</div>\n                </ng-template>\n                <ng-template [ngIf]=\"data?.template === 'share_budget_special_budget_poi'\">\n                  <div id=\"{{name}}-tooltip-content-booker-normal-budget-title\">\n                    {{'budget-limit-normal-budget-booker' | translate}}</div>\n                </ng-template>\n                <div id=\"{{name}}-tooltip-content-booker-normal-budget\">{{ data?.shareBudget?.booker?.amount ? 'THB ' +\n                  (data?.shareBudget?.booker?.amount | number) :\n                  ('budget-unlimited' | translate) }}</div>\n              </div>\n\n              <div class=\"tc-item\" *ngFor=\"let item of data?.itemList; let i = index\">\n                <div id=\"{{name}}-tooltip-content-booker-special-title-{{i}}\">{{item.title}}</div>\n                <div id=\"{{name}}-tooltip-content-booker-special-budget-{{i}}\">{{item.subTitle}}</div>\n              </div>\n            </div>\n\n            <div class=\"tc-group\">\n              <div class=\"tc-item\">\n                <div id=\"{{name}}-tooltip-content-co-booker-normal-budget-title\">{{\n                  data?.template === 'share_budget_special_budget_poi' ? ('budget-limit-normal-budget-co-booker' | translate) :\n                  ('budget-limit-co-booker-budget' | translate) }}\n                  <br>\n                  <span id=\"{{name}}-tooltip-content-co-booker-email\">\n                    {{ data?.shareBudget?.coBooker?.email }}\n                  </span>\n                </div>\n                <div id=\"{{name}}-tooltip-content-co-booker-normal-budget\">{{ data?.shareBudget?.coBooker?.amount ? 'THB ' +\n                  (data?.shareBudget?.coBooker?.amount | number) :\n                  ('budget-unlimited' | translate) }}</div>\n              </div>\n              <div class=\"tc-item\" *ngFor=\"let item of data?.itemListCoBooker; let i = index\">\n                <div id=\"{{name}}-tooltip-content-co-booker-special-title-{{i}}\">{{item.title}}</div>\n                <div id=\"{{name}}-tooltip-content-co-booker-special-budget-{{i}}\">{{item.subTitle}}</div>\n              </div>\n            </div>\n\n            <div class=\"tc-item co-budget-note\" *ngIf=\"appliedCoBudget\">\n              {{ 'budget-limit-applied-co-budget' | translate }}\n            </div>\n\n            <ng-template [ngIf]=\"data?.template === 'share_budget_special_budget_poi'\">\n              <div class=\"tc-item last\">\n                <div id=\"{{name}}-tooltip-content-bottom-title\" class=\"w-100\">\n                  {{ 'budget-limit-detail-bottom-poi' | translate }}</div>\n              </div>\n            </ng-template>\n\n            <ng-template [ngIf]=\"data?.template === 'share_budget' || data?.template === 'share_budget_special_budget'\">\n              <div class=\"tc-item last\">\n                <div id=\"{{name}}-tooltip-content-bottom-title\">\n                  {{ 'search-box-tooltips-share-budget-detail-total-budget' | translate}}</div>\n                <div class=\"font-bold\" id=\"{{name}}-tooltip-content-bottom-total-budget\">\n                  {{ data?.shareBudget?.totalBudget ? 'THB ' +\n                  (data?.shareBudget?.totalBudget | number) :\n                  ('budget-unlimited' | translate) }}</div>\n              </div>\n            </ng-template>\n\n            <div class=\"row bt-1\">\n              <div id=\"{{name}}-btn-close\" class=\"btn-close\" [ngClass]=\"{'center': data?.template === 'share_budget'}\">\n                <a (click)=\"onClose()\">\n                  {{ 'my-profile-address-dialog-button-close' | translate }}\n                </a>\n              </div>\n              <div *ngIf=\"data?.template !== 'share_budget'\" class=\"btn-more-detail\">\n                <a (click)=\"onMoreDetail()\" id=\"{{name}}-btn-more-detail\">\n                  {{ 'budget-limit-more-detail' | translate}}\n                </a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </ng-template>\n    </div>\n  </div>\n</ota-dialog>\n"

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports = "<div #container id=\"carousel-container\" class=\"carousel-container\">\n  <div class=\"wrapper\" id=\"carousel-wrapper\">\n    <div #wrapper id=\"carousel-item-list\" class=\"items\">\n      <div *ngIf=\"isMobile; then mobile; else desktop\"></div>\n      <ng-template #desktop>\n        <div class=\"carousel-item\">\n          <a class=\"cursor\">\n            <img class=\"img-slide\" [src]=\"images[MAX_IMAGE_LENGTH-1]\" />\n          </a>\n        </div> \n        <div *ngFor=\"let img of images; let i = index;\" class=\"carousel-item\" id=\"carousel-item-{{i}}\" (click)=\"handleEvent(i)\">\n          <a class=\"cursor\">\n            <img class=\"img-slide\" [src]=\"img\" id=\"carousel-item-image{{i}}\"/>\n          </a>\n        </div> \n        <div class=\"carousel-item\">\n          <a class=\"cursor\">\n            <img class=\"img-slide\" [src]=\"images[0]\"/>\n          </a>\n        </div> \n      </ng-template>\n      <ng-template #mobile>\n        <div class=\"carousel-item\">\n          <a class=\"cursor\">\n            <img class=\"img-slide-mobile\" [src]=\"mobileImages[MAX_IMAGE_LENGTH-1]\" />\n          </a>\n        </div>\n        <div *ngFor=\"let img of mobileImages; let i = index;\" class=\"carousel-item\" id=\"carousel-item-{{i}}\" (click)=\"handleEvent(i)\">\n          <a class=\"cursor\">\n            <img class=\"img-slide-mobile\" [src]=\"img\" id=\"carousel-item-image{{i}}\"/>\n          </a>\n        </div>\n        <div class=\"carousel-item\">\n          <a class=\"cursor\">\n            <img class=\"img-slide-mobile\" [src]=\"mobileImages[0]\" />\n          </a>\n        </div>\n      </ng-template>\n    </div>\n  </div>\n  <a *ngIf=\"!isMobile\" class=\"prev\" (click)=\"moveSlide(-1)\" >❮</a>\n  <a *ngIf=\"!isMobile\" class=\"next\" (click)=\"moveSlide(1)\">❯</a>\n  <div class=\"nav-dot\" [ngClass]=\"{'bottom-10': isMobile}\">\n    <span *ngFor=\"let item of images; let i = index;\" (click)=\"setImageDisplay(i)\" [ngClass]=\"{'active': i === this.index}\" class=\"dot\"></span>\n  </div>\n</div>"

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cart {{ options?.page }}\" id=\"{{ option?.page }}-full-cart-container\" [ngClass]=\"{'-show': (!options?.enableSticky) && cart?.search }\">\n  <div class=\"total-price-top\" [ngClass]=\"{'hide-sm' : !isMobileShowFullCart}\">\n    <strong>{{'cart-booking-detail' | translate}}</strong>\n    <br>\n    <div *ngIf=\"!options?.displayHotel\" class=\"font-12px mt-5\">{{'cart-price-for' | translate}}\n      <span id=\"{{ options?.page }}-text-cart-night\">{{ bookNight }}</span> {{'cart-night' | translateSingularPlural: bookNight}}\n    </div>\n    <span *ngIf=\"options?.displayHotel\" id=\"{{ option?.page }}-text-include-vat\" class=\"font-12px\">{{'cart-include-vat-label' | translate }}</span>\n  </div>\n  <div class=\"summary-detail\">\n    <div *ngIf=\"options?.displayHotel\" class=\"hotel-booking-box\" [ngClass]=\"{'hide-sm' : !isMobileShowFullCart}\">\n      <div>\n        <img id=\"{{ option?.page }}-img-hotel-booking\" class=\"img-hotel-booking\" src=\"{{ hotelImage }}\">\n      </div>\n      <div class=\"text-hotel-booking\">\n        <span class=\"hotel-booking-name\" id=\"{{ options?.page }}-text-cart-hotel-name\">{{ cart?.productDetail?.title }}</span><br>\n        <div class=\"d-flex\">\n          <span class=\"hotel-star\" *ngFor=\"let rating of utilitiesService.indexToArray(cart?.characterDetail?.ratingStar)\"\n          id=\"{{ options?.page }}-text-cart-hotel-star\" attr.data-selenium-rating=\"{{ cart?.characterDetail?.ratingStar }}\" [ngClass]=\"{'-half': rating===0.5}\">\n            <i id=\"cart-i-rating-point\" class=\"icon-star\"></i>\n          </span>\n        </div>\n      </div>\n    </div>\n    <div class=\"box-check-date\" [ngClass]=\"{'hide-sm' : !isMobileShowFullCart}\">\n      <div class=\"col-check-date\">\n        <span class=\"color-sub\">{{ 'search-box-check-in' | translate }}</span>\n        <br>\n        <span id=\"{{ options?.page }}-text-checkin-date\" attr.data-selenium-checkin-date=\"{{ dataSelenium?.checkInDate }}\">\n          {{ cart?.search?.checkInDate | actDate:formatSearchDate }}\n        </span>\n        <br>\n        <span class=\"font-12px\">\n          {{ 'cart-time-from' | translate }}\n          <span id=\"{{ options?.page }}-text-checkin-time\">{{ cart?.productDetail?.checkInTimeFrom + (cart?.productDetail?.checkInTimeUntil ? ' - ' + cart?.productDetail?.checkInTimeUntil: '') }}</span>\n        </span>\n      </div>\n      <div class=\"col-check-date\">\n        <span class=\"color-sub\">{{ 'search-box-check-out' | translate }}</span>\n        <br>\n        <span id=\"{{ options?.page }}-text-checkout-date\" attr.data-selenium-checkout-date=\"{{ dataSelenium?.checkOutDate }}\">\n          {{ cart?.search?.checkOutDate | actDate:formatSearchDate }}\n        </span>\n        <br>\n        <span class=\"font-12px\">\n          {{ cart?.productDetail?.checkOutTimeFrom ? ('cart-time-from' | translate) : ('cart-time-until' | translate) }}\n          <span id=\"{{ options?.page }}-text-checkout-time\">{{ (cart?.productDetail?.checkOutTimeFrom ? cart?.productDetail?.checkOutTimeFrom + ' - ': '') + cart?.productDetail?.checkOutTimeUntil }}</span>\n        </span>\n      </div>\n    </div>\n    <div class=\"box-summary-all-room\" [ngClass]=\"{'hide-sm' : !isMobileShowFullCart}\">\n      <div class=\"sum-item\">\n        <i class=\"icon-night\"></i>\n        <span id=\"{{ option?.page }}-text-book-night\" >{{bookNight}} {{'cart-night' | translateSingularPlural: bookNight}}</span>\n      </div>\n      <div class=\"sum-item\">\n        <i class=\"icon-bed-2\"></i>\n        <span id=\"{{ option?.page }}-text-total-room-selected\">\n          {{totalRoomSelected}} {{'cart-room' | translateSingularPlural: totalRoomSelected}},\n          {{ occupancyInfo?.adult }}<span *ngIf=\"occupancyInfo?.child\">, {{ occupancyInfo?.child }}</span>\n          <span *ngIf=\"occupancyInfo?.childAges\">({{ occupancyInfo?.childAges }})</span>\n        </span>\n      </div>\n      <div class=\"sum-item\">\n        <i class=\"icon-user\"></i>\n        <span>\n          <span *ngIf=\"appConfigService.getLanguage() === 'th'\" id=\"{{ option?.page }}-text-max-guest\">{{'cart-max-guest' | translate}} : </span>\n          <span id=\"{{ option?.page }}-text-max-guest-detail\">{{'cart-adult-text' | translate}} {{totalAdult}} {{'cart-adult' | translateSingularPlural: totalAdult}}<span *ngIf=\"totalChild > 0\">, {{'cart-child-text' | translate}} {{totalChild}} {{'cart-child' | translateSingularPlural: totalChild}}</span>\n          </span>\n        </span>\n      </div>\n    </div>\n    <div class=\"header-detail-list\">\n      <strong>{{'cart-discount' | translate}}</strong>\n    </div>\n    <div class=\"promo-code\">\n      <div class=\"promo-code-container\">\n        <div class=\"promo-code-left\">\n          <img src=\"/assets/images/checkout/promotion_code/promo_code.png\" alt=\"\">\n          <div class=\"promo-code-box\">\n            <div id=\"{{ options?.page }}-text-cart-promo-code-title\" class=\"promo-code-title\">\n              {{ 'cart-promotion-code' | translate }}\n            </div>\n            <div *ngIf=\"promoCode\" class=\"promo-code-label\" [ngClass]=\"{'valid': validatedPromoCode?.valid }\">\n              <i *ngIf=\"validatedPromoCode?.valid\" class=\"fa icon-check\"></i>\n              <span id=\"{{ options?.page }}-text-cart-promo-code\">{{ promoCode.promotionCode }}</span>\n            </div>\n          </div>\n        </div>\n        <div\n          id=\"{{ options?.page }}-btn-cart-select-promo-code\"\n          class=\"promo-code-right\"\n          [ngClass]=\"{'disabled': isLockedPromoCode}\"\n          (click)=\"openDialogUsePromotionCode()\"\n        >\n          <ng-container *ngIf=\"validatedPromoCode?.discountAmount; else selectPromoCodeTemplate\">\n            <div id=\"{{ options?.page }}-text-cart-promo-code-discount-amount\" class=\"discount-amount\" [ngClass]=\"{'valid': validatedPromoCode?.valid }\">\n              {{ '- THB ' + (validatedPromoCode?.discountAmount | number: '.2') }}\n            </div>\n          </ng-container>\n          <ng-template #selectPromoCodeTemplate>\n            <a id=\"{{ options?.page }}-text-cart-select-promo-code\">\n              {{ 'cart-select-code' | translate }}\n            </a>\n          </ng-template>\n          <a>\n            <i class=\"fa icon-arrow-right-round\"></i>\n          </a>\n        </div>\n      </div>\n      <div *ngIf=\"promoCode && validatedPromoCode && !validatedPromoCode.valid && validatedPromoCode.reason\" id=\"{{ options?.page }}-text-promo-code-error-message\" class=\"promo-code-error-message\">\n        {{ ('cart-promotion-code-error-' + validatedPromoCode.reason) | translate }}\n      </div>\n    </div>\n    <div class=\"header-detail-list\">\n      <strong>{{'cart-room-type-detail' | translate}}</strong>\n    </div>\n    <ul class=\"detail-list\" id=\"{{ options?.page }}-ul-cart-room-list\" attr.data-selenium-total-room=\"{{totalRoomSelected}}\"\n      [ngClass]=\"{'-scroll' : cart?.conditions?.length > 3, 'border-bottom':  cart?.conditions?.length !== 0, 'has-taxes-and-fees': totalTaxesAndFees}\" >\n      <li *ngFor=\"let room of cart?.conditions; let i=index;\" id=\"{{ options?.page }}-li-cart-room-{{i}}\">\n        <div class=\"clearfix\"></div>\n        <span class=\"col-detail-text\">\n          <span id=\"{{options?.page}}-text-cart-room-amount-{{i}}\">\n            {{ room.quantity }}\n          </span> x\n          <span id=\"{{ options?.page }}-text-cart-room-title-{{i}}\">\n            {{ room.displayTitle }}\n          </span>\n        </span>\n        <span class=\"col-detail-price\">{{ defaultCurrency.currencyCode }}\n          <span id=\"{{options?.page}}-text-cart-room-total-{{i}}\">\n            {{ room.totalPriceExclude | number: '.2' }}\n          </span>\n        </span>\n        <span *ngIf=\"options?.displayHotel && room?.cancellationPolicies?.length <= 0\" id=\"{{ option?.page }}-label-non-refund\" class=\"col-nonrefund-text\">* {{ 'cart-non-refund-label' | translate }}</span>\n        <div class=\"clearfix\"></div>\n      </li>\n      <li *ngIf=\"totalTaxesAndFees\" id=\"{{ options?.page }}-li-cart-taxes-and-fees\">\n        <div class=\"clearfix\"></div>\n        <span class=\"taxes-fees\">\n          {{ 'cart-taxes-fees' | translate }}\n          <span class=\"taxes-fees-icon\">\n            <i class=\"icon-info tooltip-trigger\" (click)=\"openDialogTaxesAndFees()\"></i>\n            <div class=\"tooltip-content\">\n              <div class=\"tooltip-arrow\"></div>\n              {{ 'cart-taxes-fees-description' | translate }}\n            </div>\n          </span>\n        </span>\n        <span class=\"col-detail-price\">{{ defaultCurrency.currencyCode }}\n          <span id=\"{{options?.page}}-text-cart-room-total\">\n            {{ totalTaxesAndFees | number: '.2' }}\n          </span>\n        </span>\n        <div class=\"clearfix\"></div>\n      </li>\n      <li *ngIf=\"promoCode && validatedPromoCode?.valid\" id=\"{{ options?.page }}-li-cart-discount\" class=\"discount\">\n        <div class=\"clearfix\"></div>\n        <span id=\"{{options?.page}}-text-cart-discount-label\" class=\"discount-label\">\n          {{ 'cart-promotion-code-discount' | translate }}\n        </span>\n        <span class=\"col-detail-price\">- {{ defaultCurrency.currencyCode }}\n          <span id=\"{{options?.page}}-text-cart-discount-amount\">\n            {{ validatedPromoCode.discountAmount | number: '.2' }}\n          </span>\n        </span>\n        <div class=\"clearfix\"></div>\n      </li>\n    </ul>\n    <div class=\"total-price\">\n      <ng-template [ngIf]=\"!options?.isLoading || isCartButtonClicked\">\n        <span *ngIf=\"cart?.conditions?.length === 0;then selectRoomTmpl else grandTotalTmpl;\"></span>\n        <ng-template #grandTotalTmpl>\n          <div class=\"grand-total-price-container\">\n            <div class=\"pull-left\">\n              {{ 'cart-grand-total' | translate }}\n            </div>\n            <div class=\"pull-right\">\n              <span class=\"font-24px\">{{ defaultCurrency.currencyCode }}</span>\n              <strong class=\"font-24px\" id=\"{{options?.page}}-text-cart-grand-total\">\n                {{ grandTotalPrice | number }}\n              </strong>\n              <div class=\"grand-total-price-default\" *ngIf=\"defaultCurrency.currencyCode !== currency.currencyCode\">\n                <div>{{ 'cart-approximate-price-in' | translate }} {{ currency.currencyCode }}</div>\n                <div>\n                  ≈ {{ currency.currencyCode }} {{ grandTotalPrice | convertExchange }}\n                </div>\n              </div>\n            </div>\n            <div class=\"clearfix\"></div>\n          </div>\n          <span *ngIf=\"message && message.event === 'cannot';then cannot else default;\"></span>\n          <ng-template #cannot>\n            <div id=\"{{options?.page}}-box-available-budget\" class=\"box-available-budget danger\">\n              <strong id=\"{{options?.page}}-box-available-budget-text\">{{message?.text}}</strong>\n              <div id=\"{{options?.page}}-box-available-budget-sub-text\">{{ 'cart-cannot-share-budget' | translate }}</div>\n              <div class=\"btn-cancel-share-budget\" id=\"{{options?.page}}-box-available-budget-cancel-share-budget\"\n                (click)=\"onCancelShareBudget()\">{{ 'cart-btn-cannot-share-budget' | translate }}</div>\n              <span>{{ 'cart-before-continuing' | translate }}</span>\n            </div>\n            <div class=\"text-include-vat cannot\">{{ 'cart-include-vat-label' | translate }}</div>\n          </ng-template>\n\n          <ng-template #default>\n            <div *ngIf=\"message\">\n              <div id=\"{{options?.page}}-box-available-budget\" class=\"box-available-budget\" [ngClass]=\"{'danger': message.event === 'danger'}\">\n                <strong id=\"{{options?.page}}-box-available-budget-text\">{{message?.text}}</strong>\n                <div id=\"{{options?.page}}-box-available-budget-sub-text\">{{message?.subText}}</div>\n              </div>\n            </div>\n            <div *ngIf=\"!!multiPaymentDetail\">\n              <span *ngIf=\"multiPaymentDetail?.creditTermsAmount.coBooker;then shareBudget else default;\"></span>\n              <ng-template #shareBudget>\n                <span class=\"multi-pay-section\">\n                  <div class=\"line-sep-multi-pay\" id=\"{{ option?.page }}-line-multi-payment\"></div>\n                  <div class=\"multi-pay-header\">{{ multiPaymentDetail?.creditCardAmount > 0 ? ('cart-seperate-payment' |\n                    translate) : ('cart-seperate-payment-credit-terms' | translate) }}</div>\n                  <div class=\"cart-share-budget\">\n                    <div >\n                        {{'cart-pay-credit-terms' | translate}}\n                    </div>\n                    <ul>\n                      <li>\n                        <div class=\"budget\" id=\"{{ option?.page }}-text-credit-terms-booker-amount\">{{'cart-booker' |\n                          translate}}\n                          <span>\n                            THB\n                            <strong>{{multiPaymentDetail?.creditTermsAmount?.booker | number}}</strong>\n                          </span>\n                        </div>\n                      </li>\n                      <li>\n                        <div class=\"budget\" id=\"{{ option?.page }}-text-credit-terms-co-booker-amount\">{{'cart-co-booker' |\n                          translate}}\n                          <span>\n                            THB\n                            <strong>{{multiPaymentDetail?.creditTermsAmount?.coBooker | number}}</strong>\n                          </span>\n                        </div>\n                      </li>\n                    </ul>\n                  </div>\n                  <div class=\"d-flex debit-card-section\" *ngIf=\"multiPaymentDetail?.creditCardAmount > 0 || (multiPaymentDetail?.isMultipayment && multiPaymentDetail?.creditCardAmount === 0)\">\n                    <div class=\"debit-card\">\n                      <i class=\"icon-card-add\"></i>\n                      <span>{{'cart-pay-debit-card' | translate}}</span>\n                    </div>\n                    <div class=\"amount ws-nowrap\" id=\"{{ option?.page }}-text-credit-card-amount\">THB\n                      <strong>{{multiPaymentDetail?.creditCardAmount | number}}</strong>\n                    </div>\n                  </div>\n                </span>\n              </ng-template>\n              <ng-template #default>\n                <span class=\"multi-pay-section\">\n                  <div class=\"line-sep-multi-pay\" id=\"{{ option?.page }}-line-multi-payment\"></div>\n                  <div class=\"multi-pay-header\">{{'cart-seperate-payment' | translate}}</div>\n                  <div class=\"d-flex ml-10\">\n                    <div\n                      *ngIf=\"isAllowMultiCorporateFleetOnly || multiPaymentMainChannel === 'personal-fleet' || multiPaymentMainChannel === 'corporate-fleet'; else creditTerms\"\n                      class=\"fix-width\">\n                      <div *ngIf=\"isAllowMultiCorporateFleetOnly && !multiPaymentMainChannel\"\n                        [innerHTML]=\"'cart-pay-corporate-fleet-new-line' | translate\">\n                      </div>\n                      <div *ngIf=\"multiPaymentMainChannel === 'corporate-fleet'\"\n                        [innerHTML]=\"'cart-pay-corporate-fleet-new-line' | translate\">\n                      </div>\n                      <div *ngIf=\"multiPaymentMainChannel === 'personal-fleet'\"\n                        [innerHTML]=\"'cart-pay-personal-fleet-new-line' | translate\">\n                      </div>\n                    </div>\n                    <ng-template #creditTerms>\n                      <div class=\"fix-width\">{{'cart-pay-credit-terms' | translate}}</div>\n                    </ng-template>\n                    <div class=\"amount mr-10 ws-nowrap\" id=\"{{ option?.page }}-text-credit-terms-amount\">{{ defaultCurrency.currencyCode }}\n                      <strong>{{ multiPaymentDetail?.creditTermsAmount?.booker | number }}</strong>\n                    </div>\n                  </div>\n                  <div class=\"d-flex debit-card-section\" *ngIf=\"multiPaymentDetail?.creditCardAmount > 0 || (multiPaymentDetail?.isMultipayment && multiPaymentDetail?.creditCardAmount === 0)\">\n                    <div class=\"debit-card\">\n                      <i class=\"icon-card-add\"></i>\n                      <span>{{'cart-pay-debit-card' | translate}}</span>\n                    </div>\n                    <div class=\"amount ws-nowrap credit-card-amount\" id=\"{{ option?.page }}-text-credit-card-amount\">{{ defaultCurrency.currencyCode }}\n                      <strong>{{ multiPaymentDetail?.creditCardAmount | number }}</strong>\n                      <div class=\"credit-card-amount-default\" *ngIf=\"currency.currencyCode !== defaultCurrency.currencyCode\">\n                        ≈ {{ currency.currencyCode }} {{ multiPaymentDetail?.creditCardAmount | convertExchange }}\n                      </div>\n                    </div>\n                  </div>\n                </span>\n              </ng-template>\n            </div>\n\n            <div class=\"price-info-container\" *ngIf=\"displaySurcharges || displayCurrencyNote\">\n              <div class=\"price-info-label font-bold\">\n                <i class=\"icon-info\"></i>\n                <div>{{ 'cart-price-info' | translate }}</div>\n              </div>\n              <ul class=\"price-info-content\">\n                <div class=\"surcharges-container\">\n                  <div *ngFor=\"let room of cart?.conditions; let i=index;\" id=\"{{ options?.page }}-cart-room-surcharge-{{i}}\">\n                    <div *ngIf=\"room.surcharges\">\n                      <li id=\"{{ option?.page }}-li-cart-room-surcharge-include-{{i}}\" *ngIf=\"room.displayIncludeSurcharge\">\n                        <span id=\"{{ option?.page }}-text-surcharge-include\">{{room.displayIncludeSurcharge}}</span>\n                      </li>\n                      <li id=\"{{ option?.page }}-li-cart-room-surcharge-exclude-{{i}}\" *ngIf=\"room.displayExcludeSurcharge\">\n                        <span id=\"{{ option?.page }}-text-surcharge-exclude\">{{room.displayExcludeSurcharge}}</span>\n                      </li>\n                    </div>\n                  </div>\n                </div>\n                <div *ngIf=\"displayCurrencyNote\">\n                  <li>{{'cart-currency-note' | translate: '{currency}' : currency.currencyCode }}</li>\n                </div>\n              </ul>\n            </div>\n\n            <div class=\"text-include-vat\">{{ 'cart-include-vat-label' | translate }}</div>\n          </ng-template>\n        </ng-template>\n        <ng-template #selectRoomTmpl>\n          <div class=\"text-remark\">\n            <span class=\"font-14px\" id=\"{{options?.page}}-text-cart-emptyRoomMsg\">{{ 'cart-select-room' | translate }}</span>\n          </div>\n        </ng-template>\n      </ng-template>\n      <div class=\"terms-conditions\" [ngSwitch]=\"termsConditions.template\">\n        {{ 'cart-terms-conditions' | translate }}\n        <a [routerLink]=\"['/terms-of-use']\" [queryParams]=\"{lang: lang}\" target=\"_blank\">{{'footer-customer-terms' | translate}}<span class=\"normal-text\">{{ termsConditions.template ? ',' : ' ' + ( 'cart-terms-conditions-and' | translate ) }}</span></a>\n        <span *ngSwitchCase=\"TermsConditionTemplate.SUPPLIER_AGENT\">\n          <a [routerLink]=\"['/privacy-policy']\" [queryParams]=\"{lang: lang}\" target=\"_blank\">{{'footer-customer-terms-02' | translate}}<span class=\"normal-text\">,</span></a>\n          <a href={{termsConditions.linkSupplier}} target=\"_blank\">{{ 'cart-terms-conditions-supplier' | translate }}</a>\n          {{ 'cart-terms-conditions-and' | translate }}\n          <a href={{termsConditions.linkAgent}} target=\"_blank\">{{ 'cart-terms-conditions-agent' | translate }}{{lang === langType.en ? '.' : ''}}</a>\n        </span>\n        <span *ngSwitchCase=\"TermsConditionTemplate.SUPPLIER\">\n          <a [routerLink]=\"['/privacy-policy']\" [queryParams]=\"{lang: lang}\" target=\"_blank\">{{'footer-customer-terms-02' | translate}}</a>\n          {{ 'cart-terms-conditions-and' | translate }}\n          <a href={{termsConditions.linkSupplier}} target=\"_blank\">{{ 'cart-terms-conditions-supplier' | translate }}{{lang === langType.en ? '.' : ''}}</a>\n        </span>\n        <span *ngSwitchDefault>\n          <a [routerLink]=\"['/privacy-policy']\" [queryParams]=\"{lang: lang}\" target=\"_blank\">{{'footer-customer-terms-02' | translate}}{{lang === langType.en ? '.' : ''}}</a>\n        </span>\n      </div>\n      <button class=\"ota-btn-main\" id=\"{{options?.page}}-btn-cart-continue\" [ngClass]=\"{'loading': options?.isLoading }\" [disabled]=\"options?.isLoading\" (click)=\"onCartButtonClicked()\">\n        {{ (options?.page==='checkout' ? (options?.displayConfirmBookingBtn ? 'cart-button-confirm-to-book' : 'cart-button-continue') : 'cart-book-now') | translate }}\n      </button>\n    </div>\n  </div>\n</div>\n\n<div class=\"mini-cart {{ options?.page }}\" #miniCart [class.summary-dialog-opened]=\"dialogSummaryOpening\" [class.more-detail-multi-payment]=\"!!multiPaymentDetail?.creditCardAmount || messageError?.payOwn ||messageError?.multiPayment\">\n  <div class=\"show-sm more-detail-container\" (click)=\"openDialog()\" id=\"{{ option?.page }}-mini-more-detail\">\n    <span class=\"more-detail\" [ngClass]=\" dialogSummaryOpening ? '-down' : '-up' \" id=\"{{ option?.page }}-i-arrow-{{ dialogSummaryOpening ? 'down' : 'up' }}\"></span>\n  </div>\n  <div class=\"sticky-inner\">\n    <div class=\"d-flex\">\n      <div class=\"total-price\">\n        <div class=\"total-price-wrapper\">\n          <span class=\"grand-total\">{{ 'cart-grand-total' | translate }}</span>\n          <span class=\"grand-total-currency\">THB</span>\n          <div *ngIf=\"cart?.conditions?.length === 0;then defaultPriceTmpl else grandTotalPriceTmpl;\"></div>\n          <ng-template #defaultPriceTmpl>\n            <strong class=\"grand-total-price\" id=\"{{options?.page}}-text-miniCart-grand-total-zero\">0</strong>\n          </ng-template>\n          <ng-template #grandTotalPriceTmpl>\n            <strong class=\"grand-total-price\" id=\"{{options?.page}}-text-miniCart-grand-total\">\n                {{ setCurrencyFormat(grandTotalPrice) }}\n              </strong>\n          </ng-template>\n        </div>\n      </div>\n      <div class=\"total-button\">\n        <button class=\"ota-btn-main\" id=\"{{options?.page}}-btn-miniCart-continue\" [ngClass]=\"{'loading': options?.isLoading }\" [disabled]=\"options?.isLoading\" (click)=\"onCartButtonClicked()\">\n          {{ (options?.page==='checkout' ? (options?.displayConfirmBookingBtn ? 'cart-button-confirm-to-book' : 'cart-button-continue') : 'cart-book-now') | translate }}\n        </button>\n      </div>\n    </div>\n    <div class=\"multi-payment-section\" *ngIf=\"!!multiPaymentDetail?.creditCardAmount || messageError?.payOwn ||messageError?.multiPayment\" id=\"{{ option?.page }}-text-seperate-payment-box\">\n      <span *ngIf=\"!!multiPaymentDetail?.creditCardAmount;then multipayment else message;\"></span>\n      <ng-template #multipayment>\n        <span *ngIf=\"multiPaymentDetail?.creditCardAmount\" id=\"{{options?.page}}-text-seperate-payment\">\n          {{ multiPaymentDetail?.creditTermsAmount?.coBooker ? ('cart-budget-over-budget-mobile' | translate) : ('cart-seperate-payment' | translate) }}\n        </span>\n      </ng-template>\n      <ng-template #message>\n        <span *ngIf=\"messageError?.payOwn\" id=\"{{options?.page}}-text-seperate-payment\">\n          {{'cart-budget-no-remaning-mobile' | translate}}\n        </span>\n        <span *ngIf=\"messageError?.multiPayment\" id=\"{{options?.page}}-text-seperate-payment\">\n          {{ allowMultiPayment ? ('cart-budget-detail-mobile'| translate) : ('cart-budget-no-remaning-mobile' | translate)\n          }}\n        </span>\n      </ng-template>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [fullscreen]=\"true\" [disbledClose]=\"true\" class=\"dialog-cart-summary\">\n  <div class=\"box-popup-full-white\">\n    <div class=\"close-box\">\n      <a class=\"btn-close-popup\">\n        <button id=\"\" md-dialog-close class=\"icon-close2 button\"></button>\n      </a>\n    </div>\n    <div class=\"header-section\">\n      <div class=\"popup-title\">{{'cart-booking-detail' | translate}}</div>\n      <div class=\"popup-sub-title\">{{'cart-price-for' | translate}} {{data?.bookNight}} {{'cart-night' |\n        translateSingularPlural: data?.bookNight}}</div>\n    </div>\n\n    <!-- check in / out date -->\n    <div class=\"box-check-date\">\n      <div class=\"col-check-date\">\n        <span class=\"color-sub\">{{ 'search-box-check-in' | translate }}</span>\n        <br>\n        <span id=\"\">\n          {{ data?.cart?.search?.checkInDate | actDate:data?.formatSearchDate }}\n        </span>\n        <br>\n        <span class=\"font-12px\">\n          {{ 'cart-time-from' | translate }}\n          <span id=\"\">\n            {{ data?.cart?.productDetail?.checkInTimeFrom + (data?.cart?.productDetail?.checkInTimeUntil ? ' - ' + data?.cart?.productDetail?.checkInTimeUntil : '') }}\n          </span>\n        </span>\n      </div>\n      <div class=\"col-check-date\">\n        <span class=\"color-sub\">{{ 'search-box-check-out' | translate }}</span>\n        <br>\n        <span id=\"\">\n          {{ data?.cart?.search?.checkOutDate | actDate:data?.formatSearchDate }}\n        </span>\n        <br>\n        <span class=\"font-12px\">\n          {{ data?.cart?.productDetail?.checkOutTimeFrom ? ('cart-time-from' | translate ) : ('cart-time-until' | translate) }}\n          <span id=\"\">{{ (data?.cart?.productDetail?.checkOutTimeFrom ? data?.cart?.productDetail?.checkOutTimeFrom + ' - ': '') + data?.cart?.productDetail?.checkOutTimeUntil }}</span>\n        </span>\n      </div>\n    </div>\n\n    <!-- room detail -->\n    <ul class=\"detail-list\" id=\"\">\n      <li *ngFor=\"let room of data?.cart?.conditions; let i=index;\" id=\"\">\n        <span class=\"col-detail-title\" id=\"\">{{ room.displayTitle }}</span>\n        <div class=\"clearfix\"></div>\n        <span class=\"col-detail-text\">\n          <span id=\"\">\n            {{ room.quantity }}\n          </span> {{'cart-room' | translateSingularPlural: room.quantity}} x\n          <span id=\"\">\n            {{ data?.bookNight }}\n          </span> {{'cart-night' | translateSingularPlural: data?.bookNight}}\n        </span>\n        <span class=\"col-detail-price\">THB\n          <span id=\"\">\n            {{ room.totalPrice * room.quantity | number }}\n          </span>\n        </span>\n        <span *ngIf=\"options?.displayHotel && room?.cancellationPolicies?.length <= 0\" class=\"col-nonrefund-text\">*\n          {{ 'cart-non-refund-label' | translate }}</span>\n        <div class=\"clearfix\"></div>\n        <div id=\"\">\n          <span id=\"\" *ngIf=\"room.displayIncludeSurcharge\">{{room.displayIncludeSurcharge}}</span>\n          <span id=\"\" *ngIf=\"room.displayExcludeSurcharge\">{{room.displayExcludeSurcharge}}</span>\n        </div>\n      </li>\n    </ul>\n\n    <!-- grand total -->\n    <div class=\"total-price\">\n      <div class=\"total-price-desc\" [class.line-seperate-bottom]=\"!!data?.multiPaymentDetail\">\n        <div class=\"pull-left\">\n          <strong>\n            {{ 'cart-grand-total' | translate }}\n          </strong>\n        </div>\n        <div class=\"pull-right\">\n          <span class=\"font-24px\">THB</span>\n          <strong class=\"font-24px\" id=\"\">\n            {{ data?.grandTotalPrice | number }}\n          </strong>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n      <span *ngIf=\"data?.message && data?.message.event === 'cannot';then cannot else default;\"></span>\n      <ng-template #cannot>\n        <div id=\"{{options?.page}}-box-available-budget\" class=\"box-available-budget danger\">\n          <strong id=\"{{options?.page}}-box-available-budget-text\">{{data?.message?.text}}</strong>\n          <div id=\"{{options?.page}}-box-available-budget-sub-text\">{{ 'cart-cannot-share-budget' | translate }}</div>\n          <div class=\"btn-cancel-share-budget\" id=\"{{options?.page}}-box-available-budget-cancel-share-budget\"\n            (click)=\"onCancelShareBudget()\">{{ 'cart-btn-cannot-share-budget' | translate }}</div>\n          <span>{{ 'cart-before-continuing' | translate }}</span>\n        </div>\n        <div class=\"text-include-vat cannot\">{{ 'cart-include-vat-label' | translate }}</div>\n      </ng-template>\n      <ng-template #default>\n        <div *ngIf=\"data?.message\" class=\"box-available-budget\">\n          <strong>{{data?.message?.text}}</strong>\n          <div>{{data?.message?.subText}}</div>\n        </div>\n        <span *ngIf=\"!!data?.multiPaymentDetail\" class=\"multi-pay-section\">\n          <span *ngIf=\"data?.multiPaymentDetail.creditTermsAmount.coBooker;then shareBudget else default;\"></span>\n          <ng-template #shareBudget>\n\n            <div class=\"multi-pay-header\">{{ data?.multiPaymentDetail?.creditCardAmount > 0 ? ('cart-seperate-payment' |\n              translate) : ('cart-seperate-payment-credit-terms' | translate) }}</div>\n            <div class=\"cart-share-budget\">\n              <div>\n                {{'cart-pay-credit-terms' | translate}}\n              </div>\n              <ul>\n                <li>\n                  <div class=\"budget\" id=\"{{ option?.page }}-text-credit-terms-booker-amount\">{{'cart-booker' |\n                    translate}}\n                    <span>\n                      THB\n                      <strong>{{data?.multiPaymentDetail.creditTermsAmount.booker | number}}</strong>\n                    </span>\n                  </div>\n                </li>\n                <li>\n                  <div class=\"budget\" id=\"{{ option?.page }}-text-credit-terms-co-booker-amount\">{{'cart-co-booker' |\n                    translate}}\n                    <span>\n                      THB\n                      <strong>{{data?.multiPaymentDetail.creditTermsAmount.coBooker | number}}</strong>\n                    </span>\n                  </div>\n                </li>\n              </ul>\n            </div>\n            <div class=\"d-flex debit-card-section\"\n              *ngIf=\"data?.multiPaymentDetail.creditCardAmount > 0 || (data?.multiPaymentDetail?.isMultipayment && data?.multiPaymentDetail?.creditCardAmount === 0)\">\n              <div class=\"debit-card\">\n                <i class=\"icon-card-add\"></i>\n                <span>{{'cart-pay-debit-card' | translate}}</span>\n              </div>\n              <div class=\"amount ws-nowrap\" id=\"{{ option?.page }}-text-credit-card-amount\">THB\n                <strong>{{data?.multiPaymentDetail.creditCardAmount | number}}</strong>\n              </div>\n            </div>\n\n          </ng-template>\n          <ng-template #default>\n            <strong class=\"multi-pay-header\">{{'cart-seperate-payment' | translate}}</strong>\n            <div class=\"d-flex ml-10\">\n              <div\n                *ngIf=\"data?.isAllowMultiCorporateFleetOnly || data?.multiPaymentMainChannel === 'personal-fleet' || data?.multiPaymentMainChannel === 'corporate-fleet'; else creditTerms\"\n                class=\"fix-width\">\n                <div *ngIf=\"data?.isAllowMultiCorporateFleetOnly && !data?.multiPaymentMainChannel\">\n                  {{'cart-pay-corporate-fleet' | translate}}\n                </div>\n                <div *ngIf=\"data?.multiPaymentMainChannel === 'corporate-fleet'\">\n                  {{'cart-pay-corporate-fleet' | translate}}\n                </div>\n                <div *ngIf=\"data?.multiPaymentMainChannel === 'personal-fleet'\">\n                  {{'cart-pay-personal-fleet' | translate}}\n                </div>\n              </div>\n              <ng-template #creditTerms>\n                <div class=\"fix-width\">{{'cart-pay-credit-terms' | translate}}</div>\n              </ng-template>\n              <div class=\"amount mr-10\">THB <strong>{{data?.multiPaymentDetail.creditTermsAmount.booker |\n                  number}}</strong></div>\n            </div>\n            <div class=\"d-flex debit-card-section\"\n              *ngIf=\"data?.multiPaymentDetail.creditCardAmount > 0 || (data?.multiPaymentDetail?.isMultipayment && data?.multiPaymentDetail?.creditCardAmount === 0)\">\n              <div class=\"debit-card\">\n                <i class=\"icon-card-add\"></i>\n                <span>{{'cart-pay-debit-card' | translate}}</span>\n              </div>\n              <div class=\"amount\">THB <strong>{{data?.multiPaymentDetail.creditCardAmount | number}}</strong></div>\n            </div>\n          </ng-template>\n        </span>\n\n        <div class=\"text-include-vat\">{{ 'cart-include-vat-label' | translate }}</div>\n      </ng-template>\n    </div>\n\n  </div>\n</ota-dialog>"

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog\n  [fullscreen]=\"false\"\n  [disbledClose]=\"true\"\n  [closeBottom]=\"true\"\n  class=\"dialog-taxes-fees\"\n>\n  <div class=\"dialog-title\">\n    {{ 'cart-taxes-fees' | translate }}\n  </div>\n  <div class=\"dialog-body\">\n    {{ 'cart-taxes-fees-description' | translate }}\n  </div>\n</ota-dialog>\n"

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog\n  [fullscreen]=\"false\"\n  [disbledClose]=\"true\"\n  [mobileFullscreen]=\"true\"\n  class=\"dialog-use-promotion-code\"\n>\n  <div class=\"dialog-title\">\n    <i *ngIf=\"isMobile\" id=\"{{ elementId }}-button-close\" class=\"icon-arrow-left\" (click)=\"handleCloseDialog('close')\"></i>\n    <span id=\"{{ elementId }}-text-title\">\n      {{ 'cart-dialog-use-promotion-code-title' | translate }}\n    </span>\n    <i id=\"{{ elementId }}-button-close\" class=\"{{ isMobile ? '' : 'icon-close2'}}\" (click)=\"handleCloseDialog('close')\"></i>\n  </div>\n  <div class=\"dialog-content\">\n    <form (ngSubmit)=\"onApplyCode()\">\n      <div class=\"input-search-containter\">\n        <div class=\"input-search\">\n          <input\n            id=\"{{ elementId }}-input-promotion-code\"\n            type=\"text\"\n            class=\"form-control\"\n            [ngClass]=\"{'ota-input-error': searchErrorMessage}\"\n            [formControl]=\"searchControl\"\n            placeholder=\"{{'cart-dialog-use-promotion-code-search-placeholder' | translate }}\"\n            maxlength=\"20\"\n          />\n\n          <i\n            *ngIf=\"searchControl.value != ''\"\n            id=\"{{ elementId }}-ico-clear\"\n            class=\"icon-close2\"\n            (click)=\"resetApplyCode($event)\">\n          </i>\n\n          <div class=\"ota-text-error\" *ngIf=\"searchErrorMessage\">\n            <i class=\"icon-warning\"></i>\n            <span id=\"{{ elementId }}-text-search-promotion-code-error-message\">\n              {{ searchErrorMessage }}\n            </span>\n          </div>\n        </div>\n\n        <button\n          id=\"{{ elementId }}-button-use-code\"\n          type=\"submit\"\n          [ngClass]=\"{\n            'unclickable': isLoading || searchControl.value == '',\n             'loading': isLoading,\n              'disabled': !isLoading && searchControl.value == ''\n          }\"\n          class=\"ota-btn-main mb-0\">\n          {{ 'cart-dialog-use-promotion-code-btn-search' | translate }}\n        </button>\n      </div>\n    </form>\n\n    <ng-container *ngIf=\"isLoading; else loadingSuccess\">\n      <div class=\"promotion-code-container\"></div>\n    </ng-container>\n    <ng-template #loadingSuccess>\n      <ng-container *ngIf=\"promotionCodeActiveDisplayList.length; else noPromotionCodes\">\n        <div class=\"promotion-code-container\">\n          <div *ngFor=\"let item of promotionCodeActiveDisplayList; let i = index\"\n            id=\"{{ elementId }}-button-promotion-code-card-{{ i }}\"\n            class=\"promotion-code-card-wrapper\"\n            (click)=\"onSelected(item)\"\n          >\n\n            <span *ngIf=\"item.bestDeal\" id=\"{{ elementId }}-text-best-deal\" class=\"best-deal font-description\">\n              {{ 'cart-dialog-use-promotion-code-best-deal' | translate }}\n            </span>\n\n            <div class=\"promotion-code-card\" [ngClass]=\"{'selected': item.selected}\">\n              <div class=\"promotion-code-card-discount-container\" [ngClass]=\"{'no-max-discount': !item.maxDiscountPerBookDisplay}\">\n                <div class=\"promotion-code-card-discount\">\n\n                    <img id=\"{{ elementId }}-img-promotion-code-{{ i }}\" src=\"/assets/images/checkout/promotion_code/promo_code.png\">\n\n                    <div class=\"promotion-code-discount\">\n                      <div class=\"promotion-code-discount-amount\">\n                        <div id=\"{{ elementId }}-text-discount-amount-{{ i }}\">\n                          {{ item.discountDisplay }}\n                        </div>\n                        <div *ngIf=\"item.maxDiscountPerBookDisplay\" id=\"{{ elementId }}-text-max-discount-per-book-{{ i }}\">\n                          {{ item.maxDiscountPerBookDisplay }}\n                        </div>\n                      </div>\n                      <div *ngIf=\"item.minSpendPerBookDisplay\" id=\"{{ elementId }}-text-min-spend-per-book-{{ i }}\" class=\"font-description\">\n                        {{ item.minSpendPerBookDisplay }}\n                      </div>\n                      <div class=\"promotion-code-discount-condition font-description\">\n                        <span id=\"{{ elementId }}-text-promotion-code-{{ i }}\" class=\"condition-description\">\n                          {{ 'Code: ' }}{{ item.promotionCode }}\n                        </span>\n                        <a *ngIf=\"item.link\" id=\"{{ elementId }}-link-promotion-code-{{ i }}\" class=\"link-btn\" href=\"{{item.link}}\" target=\"_blank\">\n                          {{ 'cart-dialog-use-promotion-code-term-condition' | translate }}\n                        </a>\n                      </div>\n                    </div>\n\n                </div>\n\n                <ng-container *ngIf=\"item.selected; else nonSelected\">\n                  <i class=\"icon-circle-check\" aria-hidden=\"true\"></i>\n                </ng-container>\n                <ng-template #nonSelected>\n                  <div class=\"non-selected-circle\"></div>\n                </ng-template>\n              </div>\n\n              <div class=\"promotion-code-divider\"></div>\n\n              <div *ngIf=\"item.paymentMethodDisplay\" id=\"{{ elementId }}-text-promotion-code-payment-method-{{ i }}\" class=\"promotion-code-card-payment-method font-description\">\n                {{ item.paymentMethodDisplay }}\n              </div>\n            </div>\n\n          </div>\n        </div>\n      </ng-container>\n\n      <ng-template #noPromotionCodes>\n        <div class=\"no-promotion-code\">\n          <img id=\"{{ elementId }}-img-no-promotion-code\" src=\"/assets/images/checkout/promotion_code/no_promo_code.png\">\n          <span id=\"{{ elementId }}-text-no-promotion-code\">\n            {{ 'cart-dialog-use-promotion-no-promotion-code' | translate }}\n          </span>\n        </div>\n      </ng-template>\n\n    </ng-template>\n  </div>\n\n  <div *ngIf=\"!isLoading && promotionCodeActiveDisplayList.length\" class=\"dialog-footer\">\n    <div class=\"summary-discount-amount-container\">\n      <div id=\"{{ elementId }}-text-summary-discount-amount-title\">\n        {{ 'cart-dialog-use-promotion-discount' | translate }}\n      </div>\n      <div class=\"summary-discount-amount bold\" [ngClass]=\"{ 'selected' : !!selectedItem }\">\n        {{ selectedItem ? '- THB' : 'THB' }}\n        <span id=\"{{ elementId }}-text-summary-discount-amount\">{{ selectedItem ? selectedItem.discountAmountDisplay : 0 }}</span>\n      </div>\n    </div>\n    <button id=\"{{ elementId }}-btn-confirm\" class=\"ota-btn-main\" (click)=\"handleSubmit()\">\n      {{ 'btn-confirm' | translate }}\n    </button>\n  </div>\n</ota-dialog>\n"

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [disbledClose]=\"true\" class=\"dialog-cancellation-booking\">\n    <div [ngSwitch]=\"cancelBookingListState\">\n        <ng-template ngSwitchCase=\"LOADING\">\n            <div class=\"booking-popup\" id=\"cancellation-popup\"\n                attr.data-selenium-cancel-state=\"{{ cancelBookingListState }}\">\n                <button md-dialog-close class=\"close-popup-box\"><span class=\"icon-close\"></span>\n                </button>\n                <img class=\"ota-loading\" src=\"assets/images/loading/loading.png\" />\n            </div>\n        </ng-template>\n\n        <ng-template ngSwitchCase=\"FREE\">\n            <div class=\"booking-popup\" id=\"cancellation-popup\"\n                attr.data-selenium-cancel-state=\"{{ cancelBookingListState }}\">\n                <div class=\"popup-overflow\">\n                    <button md-dialog-close class=\"close-popup-box\" id=\"cancellation-popup-close-btn\"><span class=\"icon-close\"></span>\n                    </button>\n                    <div class=\"popup-title\" id=\"cancellation-popup-title\">\n                        {{(data?.type === 'approval' ? 'booking-cancellation-fee-3' : 'booking-cancellation-fee') | translate}}\n                        : <span class=\"text-inline-block title-detail\" id=\"cancellation-popup-title-booking-id\">{{'booking-cancellation-booking-id' | translate}}\n                            {{cancelBookingId}}</span></div>\n                    <div *ngIf=\"isDisplayRefundPolicy\" class=\"refund-details\" [innerHTML]=\"( 'booking-cancellation-refund-details' | translate )\"></div>\n                    <div class=\"topic-box space-b5\" id=\"cancellation-popup-topic\">\n                        {{(data?.type === 'approval' ? 'booking-cancellation-free-2' : 'booking-cancellation-free') | translate}}\n                    </div>\n                    <div class=\"remark-box space-b5\">\n                        <span class=\"remark-title\" id=\"cancellation-popup-remark-title\">{{'booking-cancellation-note' | translate}}:</span>\n                        <span class=\"remark-desc\" id=\"cancellation-popup-remark-description\">{{'booking-cancellation-note-text' | translate}}</span>\n                        <div *ngIf=\"isDisplayPromotionPolicy\" class=\"remark-desc\" id=\"cancellation-popup-remark-promotion-description\">{{'booking-cancellation-promotion-text' | translate}}</div>\n                    </div>\n                    <div *ngIf=\"data?.type === 'approval'\" class=\"reason-box\">\n                        <act-text-area\n                            id=\"booking-cancellation-reject-reaso\"\n                            label=\"{{'booking-cancellation-reject-reason-label' | translate}}\"\n                            placeholder=\"{{'booking-cancellation-reject-reason-placeholder' | translate}}\"\n                            maxLength=\"200\"\n                            [isError]=\"isReasonError\"\n                            errorText=\"{{'booking-cancellation-reject-reason-error-required' | translate}}\"\n                            (text)=\"onKeyupReason($event)\">\n                        </act-text-area>\n                    </div>\n                </div>\n                <div class=\"popup-button\">\n                    <button id=\"cancellation-popup-btn-close-confirm-cancel\" md-dialog-close\n                        class=\"ota-btn-sub btn-horizontal\">{{'booking-cancellation-btn-close' | translate}}</button>\n                    <button id=\"cancellation-popup-btn-confirm-cancel\" (click)=\"cancelBooking()\"\n                        class=\"ota-btn-main btn-horizontal\" [ngClass]=\"{'loading': isCancelling}\">\n                        {{(data?.type === 'approval' ? 'booking-cancellation-btn-confirm-2' : 'booking-cancellation-btn-confirm') | translate}}\n                    </button>\n                </div>\n            </div>\n        </ng-template>\n\n        <ng-template ngSwitchCase=\"SUCCESS\">\n            <div class=\"booking-popup\" id=\"cancellation-popup\"\n                attr.data-selenium-cancel-state=\"{{ cancelBookingListState }}\">\n                <div class=\"popup-overflow\">\n                    <button md-dialog-close class=\"close-popup-box\" id=\"cancellation-popup-close-btn\"><span class=\"icon-close\"></span>\n                    </button>\n                    <div class=\"popup-title\" id=\"cancellation-popup-title\">\n                        {{(data?.type === 'approval' ? 'booking-cancellation-fee-3' : 'booking-cancellation-fee') | translate}}\n                        : <span class=\"text-inline-block title-detail\" id=\"cancellation-popup-title-booking-id\">{{'booking-cancellation-booking-id' | translate}}\n                            {{cancelBookingId}}</span></div>\n                    <div *ngIf=\"isDisplayRefundPolicy\" class=\"refund-details\" [innerHTML]=\"( 'booking-cancellation-refund-details' | translate )\"></div>\n                    <div class=\"box-overflow\">\n                        <div class=\"topic-box\" id=\"cancellation-popup-topic\">\n                            {{(data?.type === 'approval' ? 'booking-cancellation-if-cancel-text-2' : 'booking-cancellation-if-cancel-text') | translate}}\n                        </div>\n                        <div class=\"table-list-room\">\n                            <div class=\"table-head\">\n                                <div class=\"col-left\" id=\"cancellation-popup-header-roomtype\">{{'booking-cancellation-room-type' | translate}}</div>\n                                <div class=\"col-right fee-topics\" id=\"cancellation-popup-header-cancellation-fee\">{{'booking-cancellation-fee' | translate}}</div>\n                            </div>\n                            <div class=\"table-body\"\n                                *ngFor=\"let cancellationChargeItem of cancellationChargeList; let i = index\">\n                                <div class=\"table-item\">\n                                    <div [ngSwitch]=\"lang\">\n                                        <ng-template ngSwitchCase=\"en\">\n                                            <div class=\"col-left\">\n                                                <div id=\"cancellation-popup-condition-name-{{i}}\">{{cancellationChargeItem.roomTypeTitleEN}}\n                                                    ({{cancellationChargeItem.roomConditionTitleEN}})</div>\n                                                <div class=\"cl-condition\">\n                                                    <span class=\"cc-title\" id=\"cancellation-popup-condition-policy-title-{{i}}\">Cancellation policy</span>\n                                                    <span *ngIf=\"cancellationChargeItem?.cancellationDate; else nonRefundEn\" id=\"cancellation-popup-condition-charge-policy-{{i}}\"> If cancel after {{cancellationChargeItem?.cancellationDate}}, will incur cancellation\n                                                        charge for THB\n                                                        {{cancellationChargeItem.chargeRoomAmount | number:'.2'}}\n                                                        per room</span>\n                                                    <ng-template #nonRefundEn>\n                                                        <span id=\"cancellation-popup-condition-charge-policy-{{i}}\"> Non-Refundable</span>\n                                                    </ng-template>\n                                                </div>\n                                            </div>\n                                        </ng-template>\n                                        <ng-template ngSwitchCase=\"th\">\n                                            <div class=\"col-left\">\n                                                <div id=\"cancellation-popup-condition-name-{{i}}\">{{cancellationChargeItem.roomTypeTitleTH}}\n                                                    ({{cancellationChargeItem.roomConditionTitleTH}})</div>\n                                                <div class=\"cl-condition\">\n                                                    <span class=\"cc-title\" id=\"cancellation-popup-condition-policy-title-{{i}}\">เงื่อนไขการยกเลิกห้องพัก</span>\n                                                    <span *ngIf=\"cancellationChargeItem?.cancellationDate; else nonRefundTh\" id=\"cancellation-popup-condition-charge-policy-{{i}}\"> หากยกเลิกหลังวันที่ {{cancellationChargeItem?.cancellationDate}}\n                                                        จะเสียค่าธรรมเนียมการยกเลิกห้องพัก THB\n                                                        {{cancellationChargeItem.chargeRoomAmount | number:'.2'}}\n                                                        ต่อห้อง</span>\n                                                    <ng-template #nonRefundTh>\n                                                        <span id=\"cancellation-popup-condition-charge-policy-{{i}}\"> ขอรับเงินคืนไม่ได้</span>\n                                                    </ng-template>\n                                                </div>\n                                            </div>\n                                        </ng-template>\n                                    </div>\n                                    <div class=\"col-right\">\n                                        <div class=\"cr-title\" id=\"cancellation-popup-condition-cancellation-fee-title-{{i}}\">{{'booking-cancellation-fee' | translate}}</div>\n                                        <div class=\"cr-currency\" id=\"cancellation-popup-condition-cancellation-fee-amount-{{i}}\">\n                                            THB\n                                            {{cancellationChargeItem.totalChargeAmount | number:'.2'}}\n                                        </div>\n                                    </div>\n                                    <div class=\"clearfix\"></div>\n                                </div>\n                            </div>\n\n                            <div class=\"table-body-summary\">\n                                <div class=\"col-left\">\n                                    <strong id=\"cancellation-popup-total-cancellation-free-title\">{{'booking-cancellation-total' | translate}}</strong>\n                                    <div class=\"cl-multipayment\" id=\"cancellation-popup-total-cancellation-free-title-payment\" *ngIf=\"isCreditTerms || isCreditCard || isTrueMoneyWallet\">\n                                        {{'booking-cancellation-multipayment' | translate}}</div>\n                                </div>\n                                <div class=\"col-right\">\n                                    <span class=\"cr-currency\">THB</span>\n                                    <span id=\"cancellation-popup-total-cancellation-free\">\n                                        {{cancellationFee | number:'.2'}}\n                                    </span>\n                                </div>\n                            </div>\n\n                            <div class=\"table-body-payment-type\">\n\n                                <!-- total payment: credit term -->\n                                <div class=\"tbpt-credit-terms\" *ngIf=\"isShareBudget\">\n                                    <div class=\"col-left\" id=\"cancellation-popup-cancellation-summary-title-main-payment\">\n                                        {{'booking-cancellation-credit-terms' | translate}}\n                                    </div>\n                                    <div class=\"col-left tbpt-credit-terms-share-budget\">\n                                        <ul>\n                                            <li class=\"show-list-style\" id=\"cancellation-popup-cancellation-summary-main-booker\">\n                                                {{'booking-cancellation-credit-terms-main-booker' | translate}}\n                                                <span class=\"pull-right\" id=\"cancellation-popup-cancellation-summary-main-booker-amount\"> <span class=\"cr-currency\">THB</span>  {{paymentCreditTermsShareBudget.mainBooker | number:'.2'}} </span>\n                                            </li>\n                                            <li style=\"padding-top: 10px;\" class=\"show-list-style\" id=\"cancellation-popup-cancellation-summary-co-booker\">\n                                                {{'booking-cancellation-credit-terms-co-booker' | translate}}\n                                                <span class=\"pull-right\" id=\"cancellation-popup-cancellation-summary-co-booker-amount\"> <span class=\"cr-currency\">THB</span>  {{paymentCreditTermsShareBudget.coBooker | number:'.2'}} </span>\n                                            </li>\n                                        </ul>\n                                    </div>\n                                    <div class=\"clearfix\"></div>\n                                </div>\n                                <div class=\"tbpt-credit-terms\" *ngIf=\"isCreditTerms && !isShareBudget\">\n                                    <div class=\"col-left\" id=\"cancellation-popup-cancellation-summary-title-main-payment\">\n                                        {{'booking-cancellation-credit-terms' | translate}}\n                                    </div>\n                                    <div class=\"col-right\">\n                                        <span class=\"cr-currency\">THB</span>\n                                        <span id=\"cancellation-popup-total-main-payment\">\n                                            {{paymentCreditTerms | number:'.2'}}\n                                        </span>\n                                    </div>\n                                    <div class=\"clearfix\"></div>\n                                </div>\n\n                                <!-- total payment: non credit term -->\n                                <ng-container *ngFor=\"let displayPaymentNonCreditTerm of displayPaymentNonCreditTermList\">\n                                    <div>\n                                        <div class=\"col-left\" id=\"cancellation-popup-cancellation-summary-title-{{displayPaymentNonCreditTerm?.paymentId}}\">\n                                            {{ displayPaymentNonCreditTerm?.title | translate }}\n                                        </div>\n                                        <div class=\"col-right\">\n                                            <span class=\"cr-currency\">THB</span>\n                                            <span id=\"cancellation-popup-total-{{displayPaymentNonCreditTerm?.paymentId}}\">\n                                                {{ displayPaymentNonCreditTerm?.totalCancellationFee | number:'.2'}}\n                                            </span>\n                                        </div>\n                                        <div class=\"clearfix\"></div>\n                                    </div>\n                                </ng-container>\n\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"remark-box\">\n                        <span class=\"remark-title\" id=\"cancellation-popup-remark-title\">{{'booking-cancellation-note' | translate}}</span>\n                        <span class=\"remark-desc\" id=\"cancellation-popup-remark-description\">{{'booking-cancellation-note-text' | translate}}</span>\n                        <div *ngIf=\"isDisplayPromotionPolicy\" class=\"remark-desc\" id=\"cancellation-popup-remark-promotion-description\">{{'booking-cancellation-promotion-text' | translate}}</div>\n                    </div>\n                    <div *ngIf=\"data?.type === 'approval'\" class=\"reason-box\">\n                        <act-text-area\n                            id=\"booking-cancellation-reject-reaso\"\n                            label=\"{{'booking-cancellation-reject-reason-label' | translate}}\"\n                            placeholder=\"{{'booking-cancellation-reject-reason-placeholder' | translate}}\"\n                            maxLength=\"200\"\n                            [isError]=\"isReasonError\"\n                            errorText=\"{{'booking-cancellation-reject-reason-error-required' | translate}}\"\n                            (text)=\"onKeyupReason($event)\">\n                        </act-text-area>\n                    </div>\n                </div>\n\n                <div class=\"popup-button\">\n                    <button id=\"cancellation-popup-btn-close-confirm-cancel\" md-dialog-close\n                        class=\"ota-btn-sub btn-horizontal\">{{'booking-cancellation-btn-close' | translate}}</button>\n                    <button id=\"cancellation-popup-btn-confirm-cancel\" (click)=\"cancelBooking()\"\n                        class=\"ota-btn-main btn-horizontal\" [ngClass]=\"{'loading': isCancelling}\">\n                        {{(data?.type === 'approval' ? 'booking-cancellation-btn-confirm-2' : 'booking-cancellation-btn-confirm') | translate}}\n                    </button>\n                </div>\n            </div>\n        </ng-template>\n    </div>\n</ota-dialog>\n"

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [fullscreen]=\"true\" [disbledClose]=\"true\" class=\"dialog-filter\">\n  <div class=\"box-popup-full-white\">\n      <div class=\"close-box\">\n        <a class=\"btn-close-popup\">\n          <button id=\"my-booking-btn-close-arrange-filter-popup-mobile\" md-dialog-close class=\"icon-close button\"></button>\n        </a>\n      </div>\n      <div class=\"popup-title\">{{ filterTitle }}</div>\n\n      <div class=\"group-filter-menu\">\n        <div *ngFor=\"let item of listItems\" class=\"ota-radio\" [ngClass]=\"{ 'active': _bookingPayload.controls.filterSort.value === item?.value }\">\n          <input type=\"radio\" name=\"filterSort\" id=\"my-booking-rdo-filter-sort-{{ item?.value }}\"\n            [value]=\"item?.value\" [formControl]=\"_bookingPayload.controls.filterSort\"\n            [checked]=\"_bookingPayload.controls.filterSort.value === item?.value\" />\n          <label for=\"my-booking-rdo-filter-sort-{{ item?.value }}\">{{ item?.keyText | translate }}</label>\n        </div>\n      </div>\n      <!-- end -->\n  </div>\n</ota-dialog>\n"

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dropdown\">\n  <button id=\"ddl-{{name}}\" (click)=\"onClickDDL()\" [ngClass]=\"{ 'has-error' : error, 'focus': isShow}\" class=\"form-control\" [disabled]=\"disabled\">\n    <label class=\"float-left mb-0\" title=\"{{defaultSelect}}\">{{defaultSelect}}</label>\n  </button>\n  <div id=\"ddl-filter-{{name}}\" class=\"dropdown-content\" *ngIf=\"isShow\"\n    [ngClass]=\"{'show': isShow, 'open-up': isDropUp}\">\n    <div class=\"dc-box\" *ngIf=\"!isDropUp\">\n      <i class=\"fa fa-search fcp\"></i>\n      <input type=\"text\" class=\"input\" placeholder=\"Search\" id=\"filterInput-{{name}}\" (keyup)=\"filterFunction()\"\n        autocomplete=\"off\" [(ngModel)]=\"search\">\n    </div>\n    <div class=\"dc-items\">\n      <div class=\"dc-item-table\">\n        <div *ngFor=\"let item of listShow; let i = index\" class=\"dc-item\">\n          <a id=\"item-{{name}}-{{i}}\" (click)=\"onSelect(item)\" class=\"di-link\" title=\"{{item?.name}}\">{{item?.name}}</a>\n        </div>\n        <div *ngIf=\"listShow.length === 0\" class=\"dc-item\">\n          <a id=\"item-{{name}}-no-results-match\"\n            class=\"di-link no-results-match\">{{'filter-dropdown-no-results-match' | translate}}</a>\n        </div>\n      </div>\n    </div>\n    <div class=\"dc-box\" *ngIf=\"isDropUp\">\n      <i class=\"fa fa-search fcp\"></i>\n      <input type=\"text\" class=\"input\" placeholder=\"Search\" id=\"filterInput-{{name}}\" (keyup)=\"filterFunction()\"\n        autocomplete=\"off\" [(ngModel)]=\"search\">\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports = "<div\n    class=\"dropdown-ota-style\"\n    [mdMenuTriggerFor]=\"fleetCard\"\n    id=\"{{setElementIdPage}}-select-box\"\n    (onMenuOpen)=\"onOpenMenu()\"\n    (onMenuClose)=\"onCloseMenu()\"\n    [ngClass]=\"{'open': isOpenMenu, 'error': isError}\"\n>\n    <ng-container *ngIf=\"value\">\n        {{value | splitJoin: ' '}}\n    </ng-container>\n    <ng-container *ngIf=\"!value\">\n        {{defaultValue}}\n    </ng-container>\n    \n</div>\n<md-menu\n    class=\"dropdown-sub-menu -fluid-width\"\n    #fleetCard=\"mdMenu\"\n    xPosition=\"after\"\n>\n    <div\n        class=\"scorllable-box\"\n        [ngStyle]=\"isMobile && {'width': selectBoxWidth}\"\n    >\n        <li *ngFor=\"let fleetCard of optionList; let i = index\">\n            <div\n                class=\"fleet-card-item\"\n                (click)=\"onSelect(fleetCard?.fleetCardId)\"\n                id=\"{{setElementIdPage}}-item-{{i}}\"\n            >\n                <i class=\"icon-fleet\"></i>\n                <div class=\"fleet-card-info\">\n                    <div\n                        class=\"fleet-card-no\"\n                        id=\"{{setElementIdPage}}-item-{{i}}-fleet-card-no\"\n                    >\n                        {{fleetCard?.fleetCardId | splitJoin: ' '}}\n                    </div>\n                    <div class=\"balance\">\n                        <span>THB</span>\n                        <span\n                            class=\"font-bold\"\n                            id=\"{{setElementIdPage}}-item-{{i}}-balance\"\n                        >\n                            {{fleetCard?.balanceAmount | number: '1.0-0'}}\n                        </span>\n                    </div>\n                </div>\n                <div\n                    class=\"fleet-card-type\"\n                    id=\"{{setElementIdPage}}-item-{{i}}-fleet-card-type\"\n                >\n                    <ng-container *ngIf=\"fleetCard?.fleetCardType === FleetCardType.CORPORATE\">\n                        {{lang === Language.en ? fleetCard?.companyNameEn : fleetCard?.companyNameTh}}\n                    </ng-container>\n                    <ng-container *ngIf=\"fleetCard?.fleetCardType === FleetCardType.PERSONAL\">\n                        {{'fleet-card-information-card-personal' | translate}}\n                    </ng-container>\n                </div>\n            </div>\n        </li>\n    </div>\n</md-menu>\n"

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports = "<div class=\"footer-copyright -{{ options?.page }}\">\n  <div class=\"copyright-inner\">©Copyright 2016-{{currentDate | date: 'yyyy'}} www.ascendtravel.com <span class=\"hide-sm\">-</span> All rights reserved</div>\n</div>\n"

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports = "<div class=\"footer\">\n  <div class=\"wrap-inner\">\n    <a href=\"http://line.me/ti/p/~@AscendTravel\" class=\"circle-line\">\n      <img src=\"../../../assets/images/icons/icon-line.svg\" alt=\"ascendtravel-line\">\n    </a>\n    <div class=\"footer-company\"><strong class=\"color-main\">{{'footer-company-name' | translate }}</strong></div>\n    <div class=\"row\">\n      <div class=\"box-left\">\n        <p class=\"color-sub\" *ngIf=\"effectiveNewAddress\">{{'footer-new-address-01' | translate }}<br> {{'footer-new-address-02' | translate }}<br>\n          {{'footer-new-address-03' | translate }}\n        </p>\n        <p class=\"color-sub\" *ngIf=\"!effectiveNewAddress\">{{'footer-address-01' | translate }}<br> {{'footer-address-02' | translate }}<br>\n          {{'footer-address-03' | translate }}\n        </p>\n        <p class=\"color-sub\">{{'footer-license' | translate }}</p>\n      </div>\n      <div class=\"box-right\">\n        <div class=\"box-contract\">\n          <div class=\"title\">{{'footer-customer-support' | translate}}</div>\n          <ul>\n            <li>\n              <span class=\"icon icon-mail-thick\"></span>\n              <div>\n                <span>{{'my-profile-email' | translate}}</span><br>\n                <a href=\"mailto:support@ascendtravel.com\" class=\"color-sub\">Support@ascendtravel.com</a>\n              </div>\n            </li>\n            <li>\n              <span class=\"icon icon-hotel-contact\"></span>\n              <div>\n                <span>{{'my-profile-phone-number' | translate}}</span><br>\n                <a href=\"tel:+6620202351\" class=\"color-sub\">+66(0) 2-020-2351</a>\n              </div>\n            </li>\n            <li>\n              <span class=\"icon icon-Line\"></span>\n              <div>\n                <span>Line Official Account</span><br>\n                <a href=\"http://line.me/ti/p/~@AscendTravel\" class=\"color-sub\">@AscendTravel</a>\n              </div>\n            </li>\n          </ul>\n        </div>\n        <div class=\"box-help\">\n          <div class=\"title\">{{'footer-customer-help' | translate}}</div>\n          <div>\n            <a [routerLink]=\"['/terms-of-use']\" [queryParams]=\"{lang: lang}\" target=\"_blank\" class=\"color-sub\">{{'footer-customer-terms' | translate}}</a>\n          </div>\n          <div>\n            <a [routerLink]=\"['/privacy-policy']\" [queryParams]=\"{lang: lang}\" target=\"_blank\" class=\"color-sub\">{{'footer-customer-terms-02' | translate}}</a>\n          </div>\n          <div>\n            <a [routerLink]=\"['/cookies-policy']\" [queryParams]=\"{lang: lang}\" target=\"_blank\" class=\"color-sub\">{{'footer-customer-cookies' | translate}}</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <footer-copyright></footer-copyright>\n</div>"

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports = "<div class=\"holder\">\n  <input #inputEl id=\"{{pageId}}-from-auto-complete-inp-text\" type=\"text\" class=\"{{className}}\"\n    placeholder=\"{{placeholder}}\"\n    [ngClass]=\"{'input-success': value, 'input-error': invalid}\"\n    [(ngModel)]=\"value\"\n    (click)=\"onFocus($event)\"\n    (keydown)=\"onKeyDown($event)\"\n    (ngModelChange)=\"onValueChange()\"\n    (blur)=\"onBlurInputHandle($event)\"\n    [disabled]=\"disabled\"\n    />\n  <div id=\"{{pageId}}-from-auto-complete-div-dropdown\" class=\"dropdown\" *ngIf=\"filteredList.length > 0 || displayNoResult && filteredList.length === 0\" [ngClass]=\"{'v-visible': displayDropdown && !isLoading, 'v-hidden': !displayDropdown || isLoading, 'open-up': isDropUp}\">\n      <ng-template ngFor let-option let-i=\"index\" [ngForOf]=\"filteredList\">\n        <div class=\"option\"\n          *ngIf=\"!option.selected || (displayOwner && option.owned !== '' && option.owned == ownerStr)\"\n          [ngClass]=\"{'option-selecting': option.selecting }\">\n          <!-- (mouseenter)=\"reselecting(i)\" -->\n          <div class=\"option-content\" (click)=\"onSelectOption(option)\" id=\"{{pageId}}-from-auto-complete-div-dropdown-option-{{index}}\">\n            {{option.fullName}}\n            <div class=\"sub\" *ngIf=\"option.displayEmail\">\n              {{option.email}}\n            </div>\n          </div>\n          <div class=\"option-rear\" *ngIf=\"removable\" (click)=\"onRemoved(option);$event.stopPropagation()\" id=\"{{pageId}}-from-auto-complete-div-dropdown-option-{{index}}\">\n            {{ 'checkout-2-autocomplete-remove-guest' | translate }}\n          </div>\n        </div>\n      </ng-template>\n      <div *ngIf=\"displayNoResult && filteredList?.length === 0 && !isLoading && value?.length > 0\">\n        <div class=\"option\">\n          <div class=\"option-content no-result\">\n            {{'form-autocomplete-no-result' | translate}}\n          </div>\n        </div>\n      </div>\n  </div>\n  <span class=\"loading-wrapper\" [ngClass]=\"{ 'loading': isLoading }\"></span>\n</div>\n"

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports = "<div [hidden] = \"isHidden\">\n  <div class=\"full-section our-portfolio gray\">\n    <h2 class=\"title\">{{'mice-service-gallery-title' | translate}}</h2>\n    <div id=\"carousel-one-by-one\" class=\"carousel\" *ngIf=\"galleryItems\">\n      <div class=\"owl-carousel gallery-owl\">\n      <div class=\"carousel-slide\" *ngFor=\"let item of galleryItems?.data; let i = index;\" (click)=\"openModal(i)\">\n        <div id=\"carousel-slide-{{i}}\"  class=\"thumbnail\">\n          <img src=\"{{imangePath}}{{item.folderName}}{{item.gallery[0]}}\">\n          <div class=\"caption\">\n            <h4 id=\"carousel-slide-topic-{{i}}\">{{ item[lang].topic }}</h4>\n            <p id=\"carousel-slide-description-{{i}}\">{{ item[lang].description }}</p>\n            <small>\n              <i class=\"icon-map\"></i>\n              <span id=\"carousel-slide-map-{{i}}\">{{ item[lang].map }}</span>\n            </small>\n          </div>\n        </div>\n      </div>\n    </div>\n    </div>\n  </div>\n  \n  <div id=\"slideModal\" class=\"modal\" [ngStyle]=\"{'display': showModalSlide ? 'block': 'none'}\">\n    <div class=\"modal-content\">\n      <div class=\"modal-content-inner\">\n        <span id=\"modal-slide-btn-close\" (click)=\"closeModal()\" class=\"close cursor\">×</span>\n        <div class=\"modalSlides\" *ngFor=\"let image of modalGalery?.gallery; let i = index;\" [ngStyle]=\"{'display': modalSlideIndex == i ? 'block': 'none'}\">\n          <img src=\"{{imangePath}}{{modalGalery.folderName}}{{image}}\">\n        </div>\n        <a (click)=\"modalPlusSlides(-1)\" class=\"prev\">❮</a>\n        <a (click)=\"modalPlusSlides(1)\" class=\"next\">❯</a>\n      </div>\n      <div id=\"carousel-default\" class=\"row modal-carousel-dot\">\n        <div id=\"modal-slide-dots-{{i}}\" class=\"column\" *ngFor=\"let image of modalGalery?.gallery; let i = index;\">\n          <img [ngClass]=\"{'active': modalSlideIndex == i}\" src=\"{{imangePath}}{{modalGalery.folderName}}{{image}}\" (click)=\"modalCurrentSlide(i)\"\n            class=\"demo cursor\">\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports = "<div id=\"map\" class=\"{{class}}\"></div>"

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports = "<div class=\"big-title\" *ngIf=\"page === 'detail'\">{{'occupancy-policy-title' | translate}}</div>\n<div class=\"ad-header\" *ngIf=\"page === 'checkout'\">{{'description-title' | translate}}</div>\n<div class=\"ds-title\" *ngIf=\"page === 'checkout1'\">{{'checkout-1-description' | translate}}</div>\n<div class=\"box-ctrl child-box\" *ngIf=\"childPolicyDisplay.length > 0\">\n  <div class=\"title\">{{'child-policy-title' | translate}}</div>\n  <div class=\"sub-title\">{{minGuestDisplay}}</div>\n  <div class=\"child-table\">\n    <div class=\"ct-box-ctrl\">\n      <div class=\"left\">{{'child-policy-table-guest-age' | translate}}</div>\n      <div class=\"right\">{{'child-policy-table-extrabed' | translate}}</div>\n    </div>\n    <div class=\"ct-box-ctrl\" *ngFor=\"let policyDetail of childPolicyDisplay\">\n      <div class=\"left\">{{policyDetail.policy}}</div>\n      <div class=\"right\">\n        <div *ngIf=\"policyDetail.stayFree\">{{policyDetail.stayFree}}</div>\n        <div>{{policyDetail.description}}</div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"box-ctrl remark-box\" *ngIf=\"hotelRemarksDisplay.length > 0\">\n  <div class=\"title\">{{'occupancy-policy-remark-title' | translate}}</div>\n  <ul>\n    <li *ngFor=\"let item of hotelRemarksDisplay; let i = index;\">\n      <div id=\"remark-item-{{i}}\" [innerHtml]=\"item\"></div>\n    </li>\n  </ul>\n</div>"

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dropdown-ota-style btn-block\" id=\"{{page}}-btn-{{name}}\" [mdMenuTriggerFor]=\"iconDropdownMenu\"\n  [ngClass]=\"{'off': !optionList || optionList.length == 0, 'text-left': !displayIcon, 'error': isError, 'disabled': disabled, 'open': isOpenMenu}\"\n  (onMenuOpen)=\"onOpenMenu()\" (onMenuClose)=\"onCloseMenu()\">\n  <a>\n    <ng-container *ngIf=\"currentOption; else elseTemplate\">\n      <img *ngIf=\"displayIcon\" [src]=\"currentOption.icon ? '/assets/images/' + currentOption.icon : ''\">\n      {{currentOption.displayValue ? currentOption.displayValue : currentOption.value}}\n    </ng-container>\n    <ng-template #elseTemplate>\n      <span>{{defaultValue}}</span>\n    </ng-template>\n  </a>\n</div>\n<md-menu [class]=\"menuClassName\" #iconDropdownMenu=\"mdMenu\" xPosition=\"after\">\n  <div class=\"scorllable-box\" [style.width]=\"displayIcon ? 'max-content' : buttonWidth+'px'\">\n    <li *ngFor=\"let item of optionList; let i=index\" class=\"item-list\" [ngClass]=\"{'d-none': item.error && hideRowWhenImgError}\" >\n      <a id=\"{{page}}-btn-{{name}}-{{i}}\" (click)=\"select(item.value)\">\n        <img *ngIf=\"displayIcon\" [src]=\"item.icon ? '/assets/images/' + item.icon : ''\" style=\"margin-right: 5px; height: 16px; width: 16px;\" (error)=\"hideOption(i)\">\n        {{item.name}}\n      </a>\n    </li>\n  </div>\n</md-menu>\n"

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input-suggestion-container\">\n  <div class=\"input-wrapper\">\n    <input type=\"text\" name=\"input-text\"\n      id=\"{{ inputId }}-control\"\n      class=\"form-control input-suggestion\"\n      placeholder=\"{{ inputPlaceholder }}\"\n      [(ngModel)]=\"textValue\" />\n    <span><i class=\"icon-search left-icon\"></i></span>\n    <span *ngIf=\"textValue?.length > 0\" (click)=\"onClearButtonClicked($event)\">\n      <i class=\"icon-close right-icon\" id=\"btn-clear-input\"></i>\n    </span>\n  </div>\n</div>\n\n"

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <a id=\"header-btn-lang-dropdown\" [mdMenuTriggerFor]=\"langMenu\">\n    <img *ngIf=\"(language == 'th')\" src=\"assets/images/header/header_flag_th.png\" title=\"ภาษาไทย\" class=\"icon-flag\">\n    <img *ngIf=\"(language == 'en')\" src=\"assets/images/header/header_flag_en.png\" title=\"English\" class=\"icon-flag\">\n  </a>\n  <md-menu class=\"list-sub-menu -fluid-width\" #langMenu=\"mdMenu\" xPosition=\"before\">\n    <li *ngIf=\"(language == 'en')\">\n      <a id=\"header-btn-lang-th\" (click)=\"handleChangeLanguage('th')\" class=\"flag tha\" data-code=\"th\" data-id=\"th\">\n        <span class=\"lang-label\">\n          <img src=\"assets/images/header/header_flag_th.png\" class=\"icon-flag\">\n        </span>\n      </a>\n    </li>\n    <li *ngIf=\"(language == 'th')\">\n      <a id=\"header-btn-lang-en\" (click)=\"handleChangeLanguage('en')\" class=\"flag eng\" data-code=\"en\" data-id=\"en\">\n        <span class=\"lang-label\">\n          <img src=\"assets/images/header/header_flag_en.png\" class=\"icon-flag\">\n        </span>\n      </a>\n    </li>\n  </md-menu>\n</div>\n"

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [disbledClose]=\"true\" [disbledClickBackground]=\"true\">\n\n  <div id=\"title-switch-company\" class=\"title\">\n    {{'dialog-switch-company-title' | translate}} {{lang === 'th' ? data.companyTitleTh : data.companyTitleEn}}?\n  </div>\n  <div class=\"mb-15 sub-title\">\n    {{'dialog-switch-company-sub-title' | translate}}\n  </div>\n\n  <div class=\"cal-height\">\n    <!-- Payment method -->\n    <div class=\"row\">\n      <div class=\"header\" id=\"{{setElementIdPage}}-payment-method-header\">\n        {{'dialog-switch-company-payment-method' | translate}}\n      </div>\n      <div class=\"data\" id=\"{{setElementIdPage}}-payment-method-data-credit-term\">\n        <ng-container *ngIf=\"data?.allowCreditTerm; else notAllowCreditTerm\">\n          <i class=\"fa icon-check\" aria-hidden=\"true\"></i>\n          <span >{{'dialog-switch-company-allow' | translate}}</span>\n          <span>{{'dialog-switch-company-allow-credit-terms' | translate}}</span>\n        </ng-container>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"header merge-header\"></div>\n      <div class=\"data fix-height\" id=\"{{setElementIdPage}}-payment-method-data-corporate-fleet\">\n        <ng-container *ngIf=\"data?.allowCorporateFleet; else notAllowCorporateFleet\">\n          <i class=\"fa icon-check\" aria-hidden=\"true\"></i>\n          <span >{{'dialog-switch-company-allow' | translate}}</span>\n          <span>{{'dialog-switch-company-allow-corporate-fleet' | translate}}</span>\n        </ng-container>\n      </div>\n    </div>\n    <!-- Budget Per Night -->\n    <div class=\"row col-height\" *ngIf=\"data?.limitBudget\">\n      <div class=\"header\">\n        {{'dialog-switch-company-budget' | translate}}\n      </div>\n      <div class=\"data\">\n        <span class=\"normal-budget\">\n          {{ data.normalBudgetUnlimited ? ('unlimited-budget' | translate) : 'THB ' + (data?.normalBudget | number) }}\n        </span>\n        <!-- Special Budget  -->\n        <div *ngIf=\"data?.travelPolicyList !== null\">\n          <ul class=\"travel-policy\">\n            <li *ngFor=\"let travelPolicy of data?.travelPolicyList\">\n              <span *ngIf=\"travelPolicy?.budget;else unlimited_special_budget\">\n                THB {{travelPolicy?.budget | number}} {{'dialog-switch-company-for'| translate}} {{lang === 'en' ? travelPolicy?.policyNameEn : travelPolicy?.policyNameTh}}\n              </span>\n              <ng-template #unlimited_special_budget>\n                <span>\n                  {{ 'unlimited-budget' | translate }} {{'dialog-switch-company-for'| translate}} {{lang === 'en' ? travelPolicy?.policyNameEn : travelPolicy?.policyNameTh}}\n                </span>\n              </ng-template>\n            </li>\n          </ul>\n          <div class=\"warning\">\n            <span>{{'dialog-switch-company-limit-budget-warning' | translate}}</span>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- Co Budget  -->\n    <div class=\"row col-height\" *ngIf=\"data?.shareBudget && (data?.normalCoBudgetUnlimited != null || this.travelPolicyCoBudgetList.length != 0)\">\n      <div class=\"header\" [innerHTML]=\"'dialog-switch-company-co-budget' | translate\"></div>\n      <div class=\"data\">\n        <span class=\"normal-budget\">\n          {{ data?.normalCoBudget ? 'THB ' + (data?.normalCoBudget | number) : ('unlimited-budget' | translate)}}\n        </span>\n        <!-- Special Budget  -->\n        <div *ngIf=\"this.travelPolicyCoBudgetList.length != 0\">\n          <ul class=\"travel-policy\">\n            <li *ngFor=\"let travelPolicy of travelPolicyCoBudgetList\">\n              <span>\n                {{ travelPolicy?.coBudgetUnlimited ? ('unlimited-budget' | translate) : 'THB ' + (travelPolicy?.coBudget | number)}} {{'dialog-switch-company-for'| translate}} {{lang === 'en' ? travelPolicy?.policyNameEn : travelPolicy?.policyNameTh}}\n              </span>\n            </li>\n          </ul>\n          <div class=\"warning\">\n            <span>{{'dialog-switch-company-limit-budget-warning' | translate}}</span>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- Budget Per Month -->\n    <div class=\"row\" *ngIf=\"data?.limitBudget && data?.allowCreditTerm\">\n      <div class=\"header\">\n        {{'dialog-switch-company-budget-per-month' | translate}}\n      </div>\n      <div class=\"data\">\n        <span class=\"normal-budget-per-month\" *ngIf=\"data?.normalBudgetPerMonth; else unlimited_normal_budget_per_month\">\n          THB {{data?.normalBudgetPerMonth | number}}\n        </span>\n        <ng-template #unlimited_normal_budget_per_month>\n          <span class=\"normal-budget-per-month\">\n            {{ 'unlimited-budget' | translate }}\n          </span>\n        </ng-template>\n      </div>\n    </div>\n    <!-- Budget Per Year -->\n    <div class=\"row\"  *ngIf=\"data?.limitBudget && data?.allowCreditTerm\">\n      <div class=\"header\">\n        {{'dialog-switch-company-budget-per-year' | translate}}\n      </div>\n      <div class=\"data\">\n        <span class=\"normal-budget-per-year\" *ngIf=\"data?.normalBudgetPerYear; else unlimited_normal_budget_per_year\">\n          THB {{data?.normalBudgetPerYear | number}}\n        </span>\n        <ng-template #unlimited_normal_budget_per_year>\n          <span class=\"normal-budget-per-year\">\n            {{ 'unlimited-budget' | translate }}\n          </span>\n        </ng-template>\n      </div>\n    </div>\n    <div class=\"row\" *ngIf=\"data?.allowLimitRoom\">\n      <div class=\"header\">\n        {{'dialog-switch-company-limit-room' | translate}}\n      </div>\n      <div class=\"data\">\n        <span>{{data?.limitRoom | number}}\n          {{'dialog-switch-company-room' | translateSingularPlural: data?.limitRoom}}</span>\n      </div>\n    </div>\n    <div class=\"row\" *ngIf=\"data?.shareBudget !== null\">\n      <div class=\"header\">\n        {{'dialog-switch-company-share-budget' | translate}}\n      </div>\n      <div class=\"data\">\n        <i class=\"fa icon-check\" aria-hidden=\"true\"></i>\n        <span>{{'dialog-switch-company-allow' | translate}}</span>\n      </div>\n    </div>\n    <div class=\"row col-height\" *ngIf=\"(data?.multiPayment && data?.allowCreditTerm) || (data?.allowMultiPaymentCorporateFleet && data?.allowCorporateFleet)\">\n      <div class=\"header\">\n        {{'dialog-switch-company-multi-payment' | translate}}\n      </div>\n      <div class=\"data\">\n        <i class=\"fa icon-check\" aria-hidden=\"true\"></i>\n        <span>{{'dialog-switch-company-allow' | translate}}</span>\n      </div>\n    </div>\n    <div class=\"row col-height\" *ngIf=\"data?.allowCreditTerm\">\n      <div class=\"header\">\n        {{'dialog-switch-company-tax-address' | translate}}\n      </div>\n      <div class=\"data word-break-all\">\n        <span>{{lang === 'th' ? 'บริษัท ': ''}}{{data.taxName}}</span><br>\n        <span>{{'my-profile-address-form-tax-number' | translate}} {{data.taxId}}</span><br>\n        <span>{{data.taxAddress}}</span><br>\n      </div>\n    </div>\n  </div>\n\n  <ng-template #notAllowCorporateFleet>\n    <span >{{'dialog-switch-company-not-allow-corporate-fleet' | translate}}</span>\n  </ng-template>\n  <ng-template #notAllowCreditTerm>\n    <div *ngIf=\"lang === 'th'\">\n      <span>{{'dialog-switch-company-not-allow' | translate}}</span>\n      <span>{{'dialog-switch-company-not-allow-credit-terms' | translate}}</span>\n    </div>\n    <div *ngIf=\"lang !== 'th'\">\n      <span>{{'thankyou-payment-detail-2' | translate}}</span>\n      <span>{{'dialog-switch-company-not-allow' | translate}}</span>\n      <span>{{'dialog-switch-company-not-allow-credit-terms' | translate}}</span>\n    </div>\n  </ng-template>\n\n  <!-- action button -->\n  <div class=\"row-ota-button\">\n    <div class=\"ota-btn-sub btn-horizontal\" (click)=\"onClose()\">{{'btn-cancel' | translate}}</div>\n    <button class=\"ota-btn-main btn-horizontal\" [ngClass]=\"{'loading': isLoading}\" id=\"{{setElementIdPage}}-switch-button\"\n      (click)=\"onChangeCompany()\">{{'btn-confirm' | translate}}</button>\n  </div>\n\n</ota-dialog>\n"

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [disbledClose]=\"true\" [disbledClickBackground]=\"true\">\n  <div class=\"dialog-header\">\n    <div class=\"title\">\n      {{ \"switch-language-currency-title\" | translate }}\n    </div>\n    <div class=\"sub-title\">\n      {{ \"switch-language-currency-sub-title\" | translate }}\n    </div>\n  </div>\n  <div class=\"dialog-body\">\n    <div class=\"language-container\">\n      <div class=\"section-title\">\n        {{ \"switch-language-title\" | translate }}\n      </div>\n      <div class=\"language-list row\">\n        <div\n          class=\"col-md-4\"\n          *ngFor=\"let languageItem of languageList; let i = index\"\n        >\n          <a\n            class=\"language-item\"\n            [ngClass]=\"{ active: tempLanguage === languageItem.value }\"\n            (click)=\"handleChangeLanguage(languageItem.value)\"\n          >\n            <img [src]=\"languageItem.icon\" />\n            <div class=\"language-label\">{{ languageItem.displayValue }}</div>\n            <div class=\"right-icon\">\n              <i class=\"icon-check\"></i>\n            </div>\n          </a>\n        </div>\n      </div>\n    </div>\n    <div class=\"currency-container\">\n      <div class=\"section-title\">\n        {{ \"switch-currency-title\" | translate }}\n      </div>\n      <div class=\"currency-list row\">\n        <div\n          class=\"col-md-4\"\n          *ngFor=\"let currencyItem of currencyList | async; let i = index\"\n        >\n          <a\n            class=\"currency-item\"\n            [ngClass]=\"{ active: tempCurrency === currencyItem.currencyCode }\"\n            (click)=\"handleChangeCurrency(currencyItem.currencyCode)\"\n          >\n            <div>\n              <div class=\"currency-code\">{{ currencyItem.currencyCode }}</div>\n              <div class=\"currency-name\">\n                {{\n                  currentLanguage === LANGUAGE.th\n                    ? currencyItem.currencyNameTh\n                    : currencyItem.currencyNameEn\n                }}\n              </div>\n            </div>\n            <div class=\"right-icon\">\n              <i class=\"icon-check\"></i>\n            </div>\n          </a>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"dialog-footer\">\n    <a (click)=\"handleCancel()\">{{ \"btn-cancel\" | translate }}</a>\n    <button class=\"ota-btn-main\" (click)=\"handleSubmit()\">{{ \"btn-submit\" | translate }}</button>\n  </div>\n</ota-dialog>\n"

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports = "<header [ngClass]=\"{'fp-viewing-firstSection': isfirstSection}\">\n\t<!-- header desktop -->\n\t<div *ngIf=\"isLogin; then desktopUserTmpl else desktopOtherTmpl\">\n\t</div>\n\n\t<ng-template #desktopUserTmpl>\n\t\t<div class=\"header-box header-desktop\" [ngClass]=\"{  'header-white': theme == 'white' }\">\n\t\t\t<div class=\"header-top clearfix\">\n\n\t\t\t\t<div class=\"wrap-inner\">\n\t\t\t\t\t<div class=\"logo\">\n            <ng-container *ngIf=\"useHomeV2; else logoLinkV1\">\n              <a\n                href=\"{{redirectURIV2}}\"\n              >\n                <img [src]=\"logoPath\" [default]=\"ACT_LOGO_DEFAULT\" width=\"180\">\n              </a>\n            </ng-container>\n            <ng-template #logoLinkV1>\n              <a\n                routerLink=\"/\"\n                [queryParams]=\"{lang: appConfigService.getLanguage()}\"\n              >\n                <img [src]=\"logoPath\" [default]=\"ACT_LOGO_DEFAULT\" width=\"180\">\n              </a>\n            </ng-template>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"nav-menu\" *ngIf=\"showMenu\">\n\t\t\t\t\t\t<ul>\n              <ng-container *ngIf=\"useHomeV2; else accommodationLinkV1\">\n                <li id=\"nav-menu-accommodation\">\n                  <a href=\"{{redirectURIV2}}\">{{'menu-bar-baht-accommodation' | translate }}</a>\n                </li>\n              </ng-container>\n              <ng-template #accommodationLinkV1>\n                <li\n                  routerLink=\"/\"\n                  [queryParams]=\"{lang: appConfigService.getLanguage()}\"\n                  id=\"nav-menu-accommodation\" routerLinkActive=\"active\"\n                >\n                  <a>{{'menu-bar-baht-accommodation' | translate }}</a>\n                </li>\n              </ng-template>\n\t\t\t\t\t\t\t<li *ngIf=\"displayFlight\" id=\"nav-menu-flight\" (click)=\"onClickFlight()\">\n\t\t\t\t\t\t\t\t<a>{{ 'menu-bar-flight' | translate }}</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li *ngIf=\"displayCarRental\" id=\"nav-menu-car-rental\"\n\t\t\t\t\t\t\t\t(click)=\"onClickCarRental()\">\n\t\t\t\t\t\t\t\t<a>{{ 'menu-bar-car-rental' | translate }}</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li *ngIf=\"displayCoWorkingSpace\"\n\t\t\t\t\t\t\t\t(click)=\"openTabCoWorkingSpace()\" id=\"nav-menu-co-working-space\">\n\t\t\t\t\t\t\t\t<a>{{ 'menu-bar-co-working-space' | translate}}</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li *ngIf=\"displayMoreService; else displayFull\" id=\"nav-menu-more-service\" class=\"box-short\">\n\t\t\t\t\t\t\t\t<i class=\"icon-more\"></i>\n\t\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t\t<li *ngIf=\"!displayCoWorkingSpace\"\n\t\t\t\t\t\t\t\t\t\t(click)=\"openTabCoWorkingSpace()\" id=\"nav-menu-co-working-space\">\n\t\t\t\t\t\t\t\t\t\t<a>{{ 'menu-bar-co-working-space' | translate}}</a>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t<li routerLink=\"/mice\" id=\"nav-menu-business-events\" class=\"more-service\">\n\t\t\t\t\t\t\t\t\t\t<a>{{'menu-bar-baht-business-events' | translate }}</a>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<ng-template #displayFull>\n\t\t\t\t\t\t\t\t<li routerLink=\"/mice\" id=\"nav-menu-business-events\" routerLinkActive=\"active\" #miceLink=\"routerLinkActive\">\n\t\t\t\t\t\t\t\t\t<a>{{'menu-bar-baht-business-events' | translate }}</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ng-template>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"header-right\" *ngIf=\"!notFoundPage\">\n\t\t\t\t\t\t<ul class=\"header-menu\">\n              <ng-container *ngIf=\"isShowCurrency; else isHideCurrency\">\n                <li id=\"header-btn-my-account-desktop\" class=\"list-menu-wrap\">\n                  <a [mdMenuTriggerFor]=\"profileMenu\" class=\"menu-login d-flex account-dropdown {{currentLanguage}}\" (click)=\"onGetUserCompanies()\" *ngIf=\"allowBookWork\">\n                    <span class=\"text-overflow\">\n                      <span class=\"company\"\n                        title=\"{{getLang() == 'th' ? user?.companyTitleTh : user?.companyTitleEn}}\">{{getLang() ==\n                        'th' ? user?.companyTitleTh : user?.companyTitleEn}}</span><br>\n                      <span class=\"email\" title=\"{{user?.username}}\">{{user?.username ? user?.username : user?.fullName ?\n                        user?.fullName : user?.telephone}}</span>\n                    </span>\n\n                    <i class=\"icon-arrow-down-round\"></i>\n                  </a>\n                  <a [mdMenuTriggerFor]=\"profileMenu\" class=\"menu-login d-flex my-account\" (click)=\"onGetUserCompanies()\" *ngIf=\"!allowBookWork\">\n                    <span class=\"text-overflow\">{{'menu-bar-account' | translate }}</span>\n                    <i class=\"icon-arrow-down-round\"></i>\n                  </a>\n                  <md-menu class=\"list-sub-menu\" #profileMenu=\"mdMenu\" xPosition=\"before\">\n                <li>\n                  <a class=\"title\">{{'menu-bar-account' | translate }}</a>\n                </li>\n                <li>\n                  <a id=\"header-lnk-my-booking-desktop\" routerLink=\"/booking\"\n                    [queryParams]=\"{lang: getLang()}\">{{'menu-bar-booking' | translate }}</a>\n                </li>\n                <li *ngIf=\"showApprovalList\">\n                  <a id=\"header-lnk-approval-list-desktop\" routerLink=\"/approval\"\n                    [queryParams]=\"{lang: getLang()}\">{{'menu-bar-approval' | translate }}</a>\n                </li>\n                <li *ngIf=\"showPermission\">\n                  <a id=\"header-lnk-my-budget-desktop\" routerLink=\"/permission\"\n                    [queryParams]=\"{lang: getLang()}\">{{'menu-bar-my-budget' | translate }}</a>\n                </li>\n                <li *ngIf=\"showFleetMenu\">\n                  <a id=\"header-lnk-fleet-card-desktop\" routerLink=\"/fleet-card\"\n                    [queryParams]=\"{lang: getLang()}\">{{'menu-bar-fleet-card' | translate }}</a>\n                </li>\n                <li *ngIf=\"showPreApprovalRequester\">\n                  <a id=\"header-lnk-pre-approval-requests-desktop\" [href]=\"redirectURIV2 + '/account/pre-approval/requests'\">\n                    {{ 'menu-bar-pre-approval-requests' | translate }}\n                  </a>\n                </li>\n                <li *ngIf=\"showPreApprovalApprover\">\n                  <a id=\"header-lnk-pre-approval-approvals-desktop\" [href]=\"redirectURIV2 + '/account/pre-approval/approvals'\">\n                    {{ 'menu-bar-pre-approval-approvals' | translate }}\n                  </a>\n                </li>\n                <li *ngIf=\"isShowCompanies\">\n                  <a class=\"title\">{{'menu-bar-switch-company' | translate }}</a>\n                </li>\n                <div *ngIf=\"isShowCompanies\" class=\"scroll-companies\">\n                  <li *ngFor=\"let company of companies\">\n                    <a id=\"select-company-{{company.companyTitleEn}}\"\n                      title=\"{{getLang() == 'th' ? company.companyTitleTh : company.companyTitleEn}}\"\n                      class=\"overflow position-relative company-padding\"\n                      (click)=\"onClickCompany(company?.companyId)\">\n                      <span>{{getLang() == 'th' ? company.companyTitleTh : company.companyTitleEn}}</span>\n                      <i class=\"icon-check\" *ngIf=\"company?.companyId === selectedCompanyId\"></i>\n                    </a>\n                  </li>\n                </div>\n                <li>\n                  <a class=\"title\">{{'menu-bar-setting' | translate }}</a>\n                </li>\n                <li>\n                  <a id=\"header-lnk-my-profile-desktop\" routerLink=\"/profile\"\n                    [queryParams]=\"{lang: getLang()}\">{{'menu-bar-profile' | translate }}</a>\n                </li>\n                <li>\n                  <a id=\"header-lnk-setting-desktop\" routerLink=\"/setting\"\n                    [queryParams]=\"{lang: getLang()}\">{{'account-menu-bar-account-security' | translate }}</a>\n                </li>\n                <li *ngIf=\"showPermission\">\n                  <a id=\"header-lnk-share-budget-code-desktop\" routerLink=\"/share-budget-code\"\n                    [queryParams]=\"{lang: getLang()}\">{{'account-menu-bar-share-budget-code' | translate }}</a>\n                </li>\n                <li>\n                  <a id=\"header-lnk-logout-desktop\" class=\"menu\"\n                    (click)=\"handleLogoutButton($event)\">{{'menu-bar-logout' | translate }}</a>\n                </li>\n                </md-menu>\n                </li>\n                <li>\n                  <a class=\"btn-language-currency\" id=\"header-btn-language-currency\" (click)=\"openDialogLanguageCurrency()\">\n                    <i class=\"icon-language\"></i>\n                    <div>\n                      {{(currentLanguage === LANGUAGE.th ? 'menu-bar-language-choice-th' : 'menu-bar-language-choice-en') | translate}}\n                      {{'/'}}\n                      {{currentCurrency}}\n                    </div>\n                  </a>\n                </li>\n              </ng-container>\n              <ng-template #isHideCurrency>\n                <li>\n                  <app-lang-dropdown></app-lang-dropdown>\n                </li>\n              </ng-template>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</ng-template>\n\n\t<ng-template #desktopOtherTmpl>\n\t\t<div class=\"header-box header-desktop\" [ngClass]=\"{ 'header-white': !isfirstSection || theme == 'white' }\">\n\t\t\t<div class=\"header-top clearfix\">\n\t\t\t\t<div class=\"wrap-inner\">\n\t\t\t\t\t<div class=\"logo\">\n\t\t\t\t\t\t<a (click)=\"goToTop($event)\">\n\t\t\t\t\t\t\t<img [src]=\"logoPath\" [default]=\"ACT_LOGO_DEFAULT\" width=\"180\">\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"logo-white\" *ngIf=\"isfirstSection && theme != 'white'\">\n\t\t\t\t\t\t<a>\n\t\t\t\t\t\t\t<img [src]=\"logoWhitePath\" [default]=\"ACT_LOGO_DEFAULT_WHITE\" width=\"180\">\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"nav-menu\" *ngIf=\"showMenu\">\n\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t<li routerLink=\"/\" [queryParams]=\"{lang: appConfigService.getLanguage()}\"\n\t\t\t\t\t\t\t\tid=\"nav-menu-accommodation\" [ngClass]=\"{'active': !miceLink.isActive}\">\n\t\t\t\t\t\t\t\t<a>{{'menu-bar-baht-accommodation' | translate }}</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li routerLink=\"/mice\" id=\"nav-menu-business-events\" routerLinkActive=\"active\"\n\t\t\t\t\t\t\t\t#miceLink=\"routerLinkActive\">\n\t\t\t\t\t\t\t\t<a>{{'menu-bar-baht-business-events' | translate }}</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"header-right\" *ngIf=\"!notFoundPage\">\n\t\t\t\t\t\t<ul class=\"header-menu\">\n              <ng-container *ngIf=\"isShowCurrency; else isHideCurrency\">\n                <li>\n                  <a id=\"header-btn-show-login-desktop\" (click)=\"onClickLogin($event)\"\n                    class=\"menu-login login\">{{'menu-bar-login' | translate }}</a>\n                </li>\n                <li>\n                  <a class=\"btn-language-currency\" id=\"header-btn-language-currency\" (click)=\"openDialogLanguageCurrency()\">\n                    <i class=\"icon-language\"></i>\n                    <div>\n                      {{(currentLanguage === LANGUAGE.th ? 'menu-bar-language-choice-th' : 'menu-bar-language-choice-en') | translate}}\n                      {{'/'}}\n                      {{currentCurrency}}\n                    </div>\n                  </a>\n                </li>\n              </ng-container>\n              <ng-template #isHideCurrency>\n                <li>\n                  <app-lang-dropdown></app-lang-dropdown>\n                </li>\n              </ng-template>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</ng-template>\n\t<!-- header mobile -->\n\t<div *ngIf=\"isLogin; then mobileUserTmpl else mobileOtherTmpl\">\n\t</div>\n\n\t<ng-template #mobileUserTmpl>\n\t\t<div class=\"header-box header-mobile\" [ngClass]=\"{  'header-white': theme == 'white' }\">\n\t\t\t<div class=\"l-left logo\" (click)=\"goToHome($event)\">\n\t\t\t\t<img [src]=\"logoMobilePath\" [default]=\"ACT_LOGO_DEFAULT_MOBILE\" width=\"100\">\n\t\t\t</div>\n\t\t\t<button *ngIf=\"!notFoundPage\" id=\"header-btn-navbar-toggle-mobile\" class=\"navbar-toggle\" type=\"button\"\n\t\t\t\t(click)=\"handleToggleMenuBar()\">\n\t\t\t\t<span class=\"icon-navbar-toggle icon-fill\"></span>\n\t\t\t</button>\n\t\t\t<div class=\"m-list-menu-space\" (click)=\"handleBlurMenuBar($event)\">\n\t\t\t</div>\n\t\t\t<div id=\"m-list-menu-wrap\" class=\"m-list-menu-wrap\">\n\t\t\t\t<div id=\"header-btn-my-account-mobile\" class=\"user-detail\" (click)=\"handleToggleMenuBar()\">\n\t\t\t\t\t<!-- <div class=\"user-display thumb-circle\" [ngStyle]=\"{'background-image': user_img}\"></div> -->\n\t\t\t\t\t<!-- <a class=\"user-name\" *ngIf=\"allowBookWork\">\n\t\t\t\t\t\t<span\n\t\t\t\t\t\t\tclass=\"font-14px color-main\">{{getLang() == 'th' ? user?.companyTitleTh : user?.companyTitleEn}}</span>\n\t\t\t\t\t\t<span\n\t\t\t\t\t\t\tclass=\"font-12px color-sub\">{{user?.username ? user?.username : user?.fullName ? user?.fullName : user?.telephone}}</span>\n\t\t\t\t\t</a> -->\n\t\t\t\t\t<a class=\"user-name\" *ngIf=\"!allowBookWork\">\n\t\t\t\t\t\t<span class=\"font-14px color-main\">{{'menu-bar-account' | translate }}</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<i class=\"icon-close2\"></i>\n\t\t\t\t</div>\n\t\t\t\t<ul class=\"m-list-menu-sub\">\n          <ng-container *ngIf=\"isShowCurrency\">\n            <li>\n              <a id=\"header-lnk-home-mobile\" class=\"bt-1\" [ngClass]=\"{'no-border-top': allowBookWork}\" (click)=\"goToHome($event)\">\n                {{'menu-bar-baht-accommodation' | translate }}\n              </a>\n            </li>\n            <li *ngIf=\"displayFlight\">\n              <a id=\"header-lnk-home-mobile-flight\" class=\"bt-1\" (click)=\"onClickFlight()\">\n                {{'menu-bar-flight' | translate }}\n              </a>\n            </li>\n            <li *ngIf=\"displayCarRental\">\n              <a id=\"header-lnk-home-mobile-car-rental\" class=\"bt-1\" (click)=\"onClickCarRental()\">\n                {{'menu-bar-car-rental' | translate }}\n              </a>\n            </li>\n            <li id=\"nav-menu-co-working-space\">\n              <a (click)=\"openTabCoWorkingSpace()\" class=\"bt-1\">\n                {{ 'menu-bar-co-working-space' | translate}}\n              </a>\n            </li>\n            <li>\n              <a (click)=\"goToMice($event)\" class=\"bt-1\">\n                {{'menu-bar-baht-business-events' | translate }}\n              </a>\n            </li>\n            <li>\n              <a class=\"title\">{{'menu-bar-account' | translate }}</a>\n            </li>\n            <li>\n              <a id=\"header-lnk-booking-mobile\" (click)=\"goToBooking($event)\">\n                {{'menu-bar-booking' | translate }}\n              </a>\n            </li>\n            <li *ngIf=\"showApprovalList\">\n              <a id=\"header-lnk-approval-mobile\" (click)=\"goToApproval($event)\">\n                {{'menu-bar-approval' | translate }}\n              </a>\n            </li>\n            <li *ngIf=\"showPermission\">\n              <a id=\"header-lnk-my-budget-mobile\" (click)=\"goToMyBudget($event)\">\n                {{'menu-bar-my-budget' | translate }}\n              </a>\n            </li>\n            <li *ngIf=\"showFleetMenu\">\n              <a id=\"header-lnk-fleet-card-mobile\" (click)=\"goToFleetCard($event)\">\n                {{'menu-bar-fleet-card' | translate }}\n              </a>\n            </li>\n            <li *ngIf=\"showPreApprovalRequester\">\n              <a id=\"header-lnk-pre-approval-requests-mobile\" [href]=\"redirectURIV2 + '/account/pre-approval/requests'\">\n                {{ 'menu-bar-pre-approval-requests' | translate }}\n              </a>\n            </li>\n            <li *ngIf=\"showPreApprovalApprover\">\n              <a id=\"header-lnk-pre-approval-approvals-mobile\" [href]=\"redirectURIV2 + '/account/pre-approval/approvals'\">\n                {{ 'menu-bar-pre-approval-approvals' | translate }}\n              </a>\n            </li>\n            <div *ngIf=\"isShowCompanies\">\n              <li class=\"switch-company-mobile\">\n                <a class=\"title company\">{{'menu-bar-switch-company' | translate }}</a>\n              </li>\n              <li *ngFor=\"let company of companies\">\n                <a id=\"select-company-{{company.companyTitleEn}}\" class=\"company position-relative company-padding\"\n                  (click)=\"onClickCompany(company?.companyId)\">\n                  <span>\n                    {{getLang() == 'th' ? company.companyTitleTh : company.companyTitleEn}}\n                  </span>\n                  <i class=\"icon-check\" *ngIf=\"company?.companyId === selectedCompanyId\"></i>\n                </a>\n              </li>\n            </div>\n            <li>\n              <a class=\"title\">{{'menu-bar-setting' | translate }}</a>\n            </li>\n            <li>\n              <a id=\"header-lnk-my-profile-mobile\" (click)=\"goToProfile($event)\">\n                {{'menu-bar-profile' | translate }}\n              </a>\n            </li>\n            <li>\n              <a id=\"header-lnk-setting-mobile\" (click)=\"goToSetting($event)\">\n                {{'menu-bar-setting-account' | translate }}\n              </a>\n            </li>\n            <li *ngIf=\"showPermission\">\n              <a id=\"header-lnk-share-budget-code-mobile\" (click)=\"goToShareBudget($event)\">\n                {{'account-menu-bar-share-budget-code' | translate }}</a>\n            </li>\n          </ng-container>\n\t\t\t\t\t<li [ngClass]=\"{ '-open-collapse': isShowListLanguageCurrency }\">\n\t\t\t\t\t\t<a id=\"header-lnk-language\" (click)=\"handleShowLanguageCurrency(true)\">\n\t\t\t\t\t\t\t<span>{{(isShowCurrency ? 'switch-language-currency-title' : 'switch-language-title') | translate }}</span>\n\t\t\t\t\t\t\t<span class=\"link-arrow\">\n\t\t\t\t\t\t\t\t<img *ngIf=\"(currentLanguage == 'th')\" class=\"icon-flag\" src=\"assets/images/header/header_flag_th_2x.png\">\n\t\t\t\t\t\t\t\t<img *ngIf=\"(currentLanguage == 'en')\" class=\"icon-flag\" src=\"assets/images/header/header_flag_en_2x.png\">\n                <span *ngIf=\"isShowCurrency\" class=\"current-currency\">{{ currentCurrency }}</span>\n\t\t\t\t\t\t\t\t<span class=\"icon-arrow-right\"></span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n          <li>\n            <a id=\"header-lnk-logout-mobile\" class=\"bt-1\" (click)=\"handleLogoutButton($event)\">\n              {{'menu-bar-logout' | translate }}\n            </a>\n          </li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t</div>\n\t</ng-template>\n\t<ng-template #mobileOtherTmpl>\n\t\t<div class=\"header-box header-mobile\" [ngClass]=\"{ 'header-white': !isfirstSection }\">\n\t\t\t<div class=\"l-left logo\" (click)=\"goToTop($event)\">\n\t\t\t\t<img [src]=\"logoMobilePath\" [default]=\"ACT_LOGO_DEFAULT_MOBILE\" width=\"100\">\n\t\t\t</div>\n\t\t\t<button *ngIf=\"!notFoundPage\" class=\"navbar-toggle\" type=\"button\" (click)=\"handleToggleMenuBar()\">\n\t\t\t\t<span class=\"icon-navbar-toggle icon-fill\"></span>\n\t\t\t</button>\n\t\t\t<div class=\"m-list-menu-space\" (click)=\"handleBlurMenuBar($event)\">\n\t\t\t</div>\n\t\t\t<div class=\"m-list-menu-wrap\">\n        <ng-container *ngIf=\"isShowCurrency\">\n          <ul class=\"m-list-menu-sub\">\n            <li>\n              <a (click)=\"goToHome($event)\">\n                <span class=\"icon-sidemenu icon-home\"></span>\n                {{'menu-bar-baht-accommodation' | translate }}\n              </a>\n            </li>\n            <li (click)=\"openTabCoWorkingSpace()\" id=\"nav-menu-co-working-space\">\n              <a>{{ 'menu-bar-co-working-space' | translate}}</a>\n            </li>\n            <li>\n              <a (click)=\"goToMice($event)\">\n                <span class=\"icon-sidemenu icon-business-events\"></span>\n                {{'menu-bar-baht-business-events' | translate }}\n              </a>\n            </li>\n            <li>\n              <a id=\"header-btn-show-login-mobile\" (click)=\"onClickLogin($event)\">\n                <span class=\"icon-sidemenu icon-login\"></span>\n                {{'menu-bar-login' | translate }}\n              </a>\n            </li>\n          </ul>\n        </ng-container>\n\n\t\t\t\t<ul class=\"m-list-menu-sub\">\n\t\t\t\t\t<li [ngClass]=\"{ '-open-collapse': isShowListLanguageCurrency }\">\n\t\t\t\t\t\t<a id=\"header-lnk-language\" (click)=\"handleShowLanguageCurrency(true)\">\n\t\t\t\t\t\t\t<span>{{(isShowCurrency ? 'switch-language-currency-title' : 'switch-language-title') | translate }}</span>\n\t\t\t\t\t\t\t<span class=\"link-arrow\">\n\t\t\t\t\t\t\t\t<img *ngIf=\"(currentLanguage == 'th')\" class=\"icon-flag\" src=\"assets/images/header/header_flag_th_2x.png\">\n\t\t\t\t\t\t\t\t<img *ngIf=\"(currentLanguage == 'en')\" class=\"icon-flag\" src=\"assets/images/header/header_flag_en_2x.png\">\n                <span *ngIf=\"isShowCurrency\" class=\"current-currency\">{{ currentCurrency }}</span>\n\t\t\t\t\t\t\t\t<span class=\"icon-arrow-right\"></span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</a>\n          </li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t</div>\n\t</ng-template>\n</header>\n<div class=\"side-menu-language-currency-overlay\">\n  <div class=\"side-menu-language-currency-backdrop\" (click)=\"handleShowLanguageCurrency(false)\"></div>\n  <div class=\"side-menu-language-currency-container\">\n    <div class=\"language-currency-title\">\n      <div class=\"left-icon\">\n        <i class=\"icon-arrow-left\" (click)=\"handleShowLanguageCurrency(false)\"></i>\n      </div>\n      <label>{{ (isShowCurrency ? 'switch-language-currency-title' : 'switch-language-title') | translate }}</label>\n    </div>\n    <div class=\"language-body\">\n      <ng-container *ngFor=\"let langItem of languageList; let i = index\">\n        <a id=\"side-menu-language-item-{{i}}\" class=\"dropdown-item\" (click)=\"handleChangeLanguage(langItem.value)\">\n          <div class=\"left-icon\">\n            <img [src]=\"langItem.icon\">\n          </div>\n          <div class=\"item-label\">{{ langItem.displayValue }}</div>\n          <div class=\"right-icon\">\n            <i class=\"icon-check\" *ngIf=\"tempLanguage === langItem.value\"></i>\n          </div>\n        </a>\n      </ng-container>\n    </div>\n    <ng-container *ngIf=\"isShowCurrency\">\n      <div class=\"side-menu-section\">\n        {{'switch-currency-title' | translate}}\n      </div>\n      <div class=\"currency-body\">\n        <ng-container *ngFor=\"let currencyItem of currencyList | async; let i = index\">\n          <a id=\"side-menu-currency-item-{{i}}\" class=\"dropdown-item\" (click)=\"handleChangeCurrency(currencyItem.currencyCode)\">\n            <div class=\"left-icon\">\n              <div class=\"currency-code\">{{ currencyItem.currencyCode }}</div>\n            </div>\n            <div class=\"item-label\">{{ LANGUAGE.th === currentLanguage ? currencyItem.currencyNameTh : currencyItem.currencyNameEn }}</div>\n            <div class=\"right-icon\">\n              <i class=\"icon-check\" *ngIf=\"tempCurrency === currencyItem.currencyCode\"></i>\n            </div>\n          </a>\n        </ng-container>\n      </div>\n    </ng-container>\n    <div class=\"language-currency-actions\">\n      <div class=\"left-action\"></div>\n      <div class=\"right-action\">\n        <button class=\"ota-btn-main\" id=\"side-menu-language-currency-btn-submit\" (click)=\"handleSubmitLanguageCurrency()\">\n          {{'btn-submit' | translate}}\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog disbledClose=\"true\" class=\"dialog-alert\" mice=\"isMice\">\n\n  <!-- contnet -->\n  <div class=\"dialog-alert-content\">\n    <img class=\"alert-img\" src=\"{{imageSrc}}\" srcset=\"{{imageSrcSet}}\" />\n    <div class=\"alert-header\">{{ alertHeader }}</div>\n    <div class=\"alert-text\">\n      <div [innerHTML]=\"alertText\"></div>\n    </div>\n  </div>\n  <div class=\"action-button\">\n    <button class=\"ota-btn-main\" md-dialog-close>{{confirmText ? confirmText : ('btn-ok' | translate)}} {{countdown || countdown == 0 ? '(' + countdown + 's)'  : ''}}</button>\n  </div>\n\n</ota-dialog>"

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [disbledClose]=\"true\" [disbledClickBackground]=\"true\" class=\"dialog-banner-overlay\">\n  <div class=\"dialog-banner-content\">\n    <div class=\"banner-container\">\n      <ul class=\"banner owl-carousel banner-overlay-owl\">\n        <li *ngFor=\"let item of data; let i = index\">\n          <div *ngIf=\"owlCarouselInitialed\" [attr.data-bannerId]=\"item.bannerId\" [attr.data-bannerType]=\"'overlay'\">\n            <ng-container *ngIf=\"item.link; else noLink\">\n              <a [attr.href]=\"item.link\" target=\"_blank\" id=\"{{elementId}}-link-{{i}}\">\n                <img class=\"banner-item\" id=\"{{elementId}}-img-{{i}}\"\n                  src=\"{{ item.fileUrl }}\"\n                  alt=\"{{ item.altText ? item.altText : '' }}\"\n                  title=\"{{ item.altText ? item.altText : '' }}\"/>\n              </a>\n            </ng-container>\n            <ng-template #noLink>\n              <img class=\"banner-item\" id=\"{{elementId}}-img-{{i}}\"\n                src=\"{{ item.fileUrl }}\"\n                alt=\"{{ item.altText ? item.altText : '' }}\"\n                title=\"{{ item.altText ? item.altText : '' }}\"/>\n            </ng-template>\n          </div>\n        </li>\n      </ul>\n    </div>\n  </div>\n  <div class=\"dialog-banner-button\">\n    <button\n      id=\"{{elementId}}-btn-close\"\n      class=\"ota-btn-main\"\n      (click)=\"onClose()\">\n      {{ 'btn-close' | translate }}\n    </button>\n  </div>\n</ota-dialog>"

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog disbledClose=\"true\" disbledClickBackground=\"true\" class=\"dialog-booking-report\">\n  <div id=\"booking-report-title\" class=\"title\">{{'booking-report-dialog-title' | translate}}</div>\n  <div class=\"booking-report-form\">\n    <form novalidate [formGroup]=\"chechInDateForm\">\n        <div class=\"form-group\">\n          <div class=\"pull-left col-left\">\n            <label>{{'booking-report-check-in-from' | translate}}</label>\n            <div class=\"datepicker-wrap datepicker-container\">\n              <input\n                readonly\n                (input)=\"onDateChange()\"\n                [ngClass]=\"{'input-error': isError }\"\n                placeholder=\"{{'booking-report-placeholder-from' | translate}}\"\n                [daterangepicker]=\"stateDaterangepicker\"\n                [formControlFrom]=\"chechInDateForm.controls.from\"\n                [formControlTo]=\"chechInDateForm.controls.to\"\n                [canSelectPastDate]=\"true\"\n                [haveDefaultDate]=\"defaultDate\"\n                [defaultStartDate]=\"chechInDateForm.value.from\"\n                [defaultEndDate]=\"chechInDateForm.value.to\"\n                [allowSameDate]=\"true\"\n                id=\"booking-report-inp-checkin-from\"\n                syncToId=\"booking-report-inp-checkin-to\"\n                label=\"search-box-check-in-calendar\"\n                name=\"checkInDate\"\n                section=\"exportBookingReport\"\n                type=\"text\"\n                class=\"form-control form-calendar button\">\n            </div>\n          </div>\n          <div class=\"pull-right col-right\">\n            <label>{{'booking-report-check-in-to' | translate}}</label>\n            <div class=\"datepicker-wrap datepicker-container\">\n              <input\n                readonly\n                (input)=\"onDateChange()\"\n                [ngClass]=\"{'input-error': isError }\"\n                placeholder=\"{{'booking-report-placeholder-to' | translate}}\"\n                [daterangepicker]=\"stateDaterangepicker\"\n                [formControlFrom]=\"chechInDateForm.controls.from\"\n                [formControlTo]=\"chechInDateForm.controls.to\"\n                [canSelectPastDate]=\"true\"\n                [haveDefaultDate]=\"defaultDate\"\n                [defaultStartDate]=\"chechInDateForm.value.from\"\n                [defaultEndDate]=\"chechInDateForm.value.to\"\n                [allowSameDate]=\"true\"\n                opens=\"left\"\n                id=\"booking-report-inp-checkin-to\"\n                syncToId=\"booking-report-inp-checkin-from\"\n                [isFirst]=\"false\"\n                label=\"search-box-check-in-calendar\"\n                name=\"checkOutDate\"\n                section=\"exportBookingReport\"\n                type=\"text\"\n                class=\"form-control form-calendar button\">\n            </div>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n       <p class=\"text-error\" *ngIf=\"isError\">{{'dialog-booking-report-error' | translate}}</p>\n       <p class=\"information\" *ngIf=\"!isError\">{{'booking-report-information' | translate}}</p>\n      <div class=\"row\">\n        <div class=\"col-xs-6 col-md-5 col-md-offset-1 button-left\">\n          <button id=\"booking-report-btn-cancel\" class=\"ota-btn-sub\" (click)=\"onCancael()\">{{'btn-cancel' | translate}}</button>\n        </div>\n        <div class=\"col-xs-6 col-md-5 button-right\">\n          <button id=\"booking-report-btn-export\" \n          class=\"ota-btn-main\" \n          [ngClass]=\"{'loading': isLoading }\"\n          (click)=\"exportReport()\">{{'btn-export' | translate}}</button>\n        </div>\n      </div>\n    </form>\n  </div>\n</ota-dialog>"

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [mobileFullscreen]=\"true\" title=\"{{'dialog-budget-suggestion-title' | translate}}\" [disbledClickBackground]=\"true\">\n  <div class=\"dialog-container\">\n    <div class=\"mb-15 sub-title\" id=\"{{pageElementName}}-text-description\">\n      {{'dialog-budget-suggestion-desc' | translate}}\n    </div>\n\n    <div class=\"row mt-20\">\n      <div class=\"form-group col-xs-12 col-sm-6\">\n        <label>{{ 'dialog-budget-suggestion-label-budget' | translate }}</label>\n        <div class=\"thb-input-group\">\n          <span class=\"input-group-addon\">THB</span>\n          <input type=\"text\" class=\"form-control\" id=\"{{pageElementName}}-input-budget-amount\" name=\"budget\"\n            max=\"9999999\" [(ngModel)]=\"budgetValue\" [textMask]=\"{ mask: budgetMask, guide: false }\"\n            [ngClass]=\"[!budgetValue && isSubmitted ? 'input-error':'input-success']\" />\n        </div>\n        <div class=\"error-text-warp\">\n          <span id=\"{{pageElementName}}-text-error-budget-amount\" *ngIf=\"!budgetValue && isSubmitted\"\n            class=\"text-error\">\n            {{ 'dialog-budget-suggestion-form-require-budget' | translate }}\n          </span>\n          <span id=\"{{pageElementName}}-text-error-budget-amount\"\n            *ngIf=\"budgetValue && budgetValue > oneMillion && isSubmitted\" class=\"text-error\">\n            {{ 'dialog-budget-suggestion-form-exceed-limit-budget' | translate }}\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"action-button\">\n    <a class=\"hidden-xs\" id=\"{{pageElementName}}-a-cancel\" (click)=\"handleCancel()\">\n      {{ 'dialog-budget-suggestion-form-btn-cancel' | translate }}\n    </a>\n\n    <button id=\"{{pageElementName}}-btn-cancel\" class=\"ota-btn-default btn-horizontal visible-xs-block\"\n      (click)=\"handleCancel()\">\n      {{ 'dialog-budget-suggestion-form-btn-cancel' | translate }}\n    </button>\n    <button id=\"{{pageElementName}}-btn-submit\" class=\"ota-btn-main btn-horizontal\" tabindex=\"1\"\n      [ngClass]=\"{'loading': isLoading}\" (click)=\"onApplyBudget()\">\n      {{ 'dialog-budget-suggestion-form-btn-submit' | translate }}\n    </button>\n  </div>\n</ota-dialog>"

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog class=\"dialog-cancellation-policy\" [disbledClose]=\"true\" [closeBottom]=\"true\">\n  <div id=\"levelD-div-cancellation-box\" class=\"cancellation-box\">\n    <p id=\"levelD-text-cancellation-policy-description-{{i}}\" *ngFor=\"let cancellation of cancellations; let i=index;\">{{cancellation}}</p>\n  </div>\n</ota-dialog>"

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog class=\"dialog-change-password\" title=\"{{'account-change-password-title' | translate}}\"\n  [mobileFullscreen]=\"true\" [disbledClickBackground]=\"true\" [disbledClose]=\"true\">\n  <div class=\"dialog-content\">\n    <form novalidate [formGroup]=\"form\">\n      <div class=\"form-group\">\n        <label for=\"setting-txt-new-password\">{{'account-change-password-new' | translate}} </label>\n        <input #password type=\"password\" formControlName=\"newPassword\" class=\"form-control mb-10\"\n          id=\"setting-txt-new-password\" placeholder=\"{{'account-change-password-new-fill' | translate}}\"\n          [ngClass]=\"{'input-error': isInvalid('newPassword') || formErrors.newPassword.invalid, 'input-success': form.get('newPassword').valid}\">\n        <span class=\"text-error\" *ngIf=\"formErrors.newPassword.required\" id=\"setting-lbl-new-password-caution\">\n          {{ 'validation-required-new-password' | translate }}\n        </span>\n        <span class=\"text-error\" *ngIf=\"formErrors.newPassword.previouslyUsed\" id=\"setting-lbl-new-password-caution\">\n          {{ 'validation-previously-used-new-password' | translate }}\n        </span>\n        <div class=\"password-validation\">\n          <div class=\"validation-title\" id=\"setting-lbl-password-rule\">{{ 'account-change-password-validation-text' |\n            translate }}</div>\n          <div class=\"row-validation\">\n            <div class=\"validation-bullet\" [ngClass]=\"{\n              'validation-valid': !formErrors.newPassword.required && !formErrors.newPassword.previouslyUsed && passwordHasValidLength,\n              'validation-invalid': form.get('newPassword').touched && !passwordHasValidLength\n            }\">\n              <i\n                class=\"icon-{{!formErrors.newPassword.required && !formErrors.newPassword.previouslyUsed && passwordHasValidLength ? 'check' : 'bullet'}}\"></i>\n              <span class=\"password-validation-text\">\n                {{'account-change-password-validation-length-text' | translate}}\n              </span>\n            </div>\n            <div class=\"validation-bullet\" [ngClass]=\"{\n              'validation-valid': !formErrors.newPassword.required && !formErrors.newPassword.previouslyUsed && passwordHasUppercase,\n              'validation-invalid': form.get('newPassword').touched && !passwordHasUppercase\n            }\">\n              <i\n                class=\"icon-{{!formErrors.newPassword.required && !formErrors.newPassword.previouslyUsed && passwordHasUppercase ? 'check' : 'bullet'}}\"></i>\n              <span class=\"password-validation-text\">\n                {{'account-change-password-validation-uppercase-text' | translate}}\n              </span>\n            </div>\n            <div class=\"validation-bullet\" [ngClass]=\"{\n              'validation-valid': !formErrors.newPassword.required && !formErrors.newPassword.previouslyUsed && passwordHasLowercase,\n              'validation-invalid': form.get('newPassword').touched && !passwordHasLowercase\n            }\">\n              <i\n                class=\"icon-{{!formErrors.newPassword.required && !formErrors.newPassword.previouslyUsed && passwordHasLowercase ? 'check' : 'bullet'}}\"></i>\n              <span class=\"password-validation-text\">\n                {{'account-change-password-validation-lowercase-text' | translate}}\n              </span>\n            </div>\n            <div class=\"validation-bullet\" [ngClass]=\"{\n              'validation-valid': !formErrors.newPassword.required && !formErrors.newPassword.previouslyUsed && passwordHasNumeric,\n              'validation-invalid': form.get('newPassword').touched && !passwordHasNumeric\n            }\">\n              <i\n                class=\"icon-{{!formErrors.newPassword.required && !formErrors.newPassword.previouslyUsed && passwordHasNumeric ? 'check' : 'bullet'}}\"></i>\n              <span class=\"password-validation-text\">\n                {{'account-change-password-validation-numeric-text' | translate}}\n              </span>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"setting-txt-confirm-new-password\">{{'account-change-password-confirmation' |\n          translate}}</label>\n        <input #confirmPassword type=\"password\" formControlName=\"confirmNewPassword\" class=\"form-control\"\n          id=\"setting-txt-confirm-new-password\"\n          placeholder=\"{{'account-change-password-confirmation-fill' | translate }}\"\n          [ngClass]=\"{'input-error': isInvalid('confirmNewPassword') || formErrors.confirmNewPassword.invalid, 'input-success': form.get('confirmNewPassword').valid }\">\n        <span class=\"text-error\" *ngIf=\"formErrors.confirmNewPassword.required\"\n          id=\"setting-lbl-please-confirm-new-password\">\n          {{ 'validation-required-confirm-new-password' | translate }}\n        </span>\n        <span\n          *ngIf=\"!formErrors.confirmNewPassword.required && (isInvalid('confirmNewPassword') || formErrors.confirmNewPassword.invalid)\"\n          class=\"text-error\" id=\"setting-lbl-password-not-match\">\n          {{ 'validation-match-password' | translate }}\n        </span>\n      </div>\n    </form>\n  </div>\n  <div class=\"action-button\">\n    <a class=\"hidden-xs\" id=\"setting-a-cancel\" (click)=\"handleCancel()\">\n      {{ 'account-change-password-button-cancel' | translate }}\n    </a>\n    <button id=\"setting-btn-cancel\" class=\"ota-btn-default btn-horizontal visible-xs-block\" (click)=\"handleCancel()\">\n      {{ 'account-change-password-button-cancel' | translate }}\n    </button>\n    <button type=\"submit\" (click)=\"onSubmit()\" class=\"ota-btn-main btn-horizontal\" [ngClass]=\"{'loading': isLoading}\" [disabled]=\"isLoading\"\n      id=\"setting-btn-save\">\n      {{'account-change-password-button-submit' | translate}}\n    </button>\n  </div>\n</ota-dialog>"

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog disbledClose=\"true\" disbledClickBackground=\"true\" class=\"dialog-communication-preference-banner\">\n  <form [formGroup]=\"form\" (submit)=\"onFormSubmit()\" #formControl>\n    <div class=\"dialog-notify-content\">\n      <ng-container *ngIf=\"!utilitiesService.isMobile()\">\n        <div class=\"notify-content\" \n          [ngStyle]=\"{ 'background-image': 'url('+ image +')', 'width': dialogWidthDesktop + 'px' }\" \n          [ngClass]=\"{ 'has-checkbox' : data?.acceptingCondition }\"\n        >\n        </div>\n      </ng-container>\n      <ng-container *ngIf=\"utilitiesService.isMobile()\">\n        <div class=\"notify-content\" \n          [ngStyle]=\"{ 'background-image': 'url('+ image +')', 'height': dialogHeightMobile + 'px', 'max-width': dialogMaxWidthMobile + 'px' }\" \n          [ngClass]=\"{ 'has-checkbox' : data?.acceptingCondition }\"\n        >\n        </div>\n      </ng-container>\n\n    </div>\n    <div class=\"dialog-notify-button\">\n      <div *ngIf=\"data?.acceptingCondition; then btnWithCheckbox else btnWithoutCheckbox\"></div>\n      <ng-template #btnWithCheckbox>\n        <div class=\"checkbox-content\">\n          <div class=\"checkbox-container\">\n            <div class=\"notify-checkbox\">\n              <input type=\"checkbox\" id=\"chk-notify-terms-conditions\" formControlName=\"agree\">\n              <label for=\"chk-notify-terms-conditions\">{{ 'notify_accept_terms_conditions' | translate }}</label>\n            </div>\n            <div *ngIf=\"form.invalid && isValidFormSubmitted != null && !isValidFormSubmitted\" class=\"ota-checkbox validate\">\n              <span class=\"text-error\">{{ 'notify_accept_terms_conditions_validation_accept' | translate }}</span>\n            </div>\n          </div>\n          <div class=\"button-container\">\n            <button\n              id=\"btn-notify-terms-conditions-accept\"\n              class=\"ota-btn-main\">\n              {{ 'btn-ok' | translate }}\n            </button>\n          </div>\n        </div>\n      </ng-template>\n      \n      <ng-template #btnWithoutCheckbox>\n        <div *ngIf=\"!data?.acceptingCondition\" class=\"no-checkbox-content\">\n          <button\n            id=\"btn-notify-terms-conditions-accept\"\n            class=\"ota-btn-main\">\n            {{ 'btn-close' | translate }}\n          </button>\n        </div>\n      </ng-template>\n      \n    </div>\n  </form>\n\n</ota-dialog>"

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog disbledClose=\"true\" disbledClickBackground=\"true\" class=\"dialog-communication-preference-text\">\n  <form [formGroup]=\"form\" (submit)=\"onFormSubmit()\" #formControl>\n    <div class=\"dialog-notify-content\">\n      <img class=\"notify-img\" src=\"/assets/images/icons/icon-hotel.svg\"/>\n      <div class=\"notify-content\">\n        <div *ngIf=\"title\" class=\"notify-title\" [innerHTML]=\"title\"></div>\n        <div class=\"notify-message\" [innerHTML]=\"message\"></div>\n      </div>\n      \n        <div *ngIf=\"data?.acceptingCondition\">\n          <div class=\"notify-checkbox\">\n            <input type=\"checkbox\" id=\"chk-notify-terms-conditions\" formControlName=\"agree\">\n            <label for=\"chk-notify-terms-conditions\">{{ 'notify_accept_terms_conditions' | translate }}</label>\n          </div>\n          <div *ngIf=\"form.invalid && isValidFormSubmitted != null && !isValidFormSubmitted\" class=\"ota-checkbox validate\">\n            <span class=\"text-error\">{{ 'notify_accept_terms_conditions_validation_accept' | translate }}</span>\n          </div>\n        </div>\n    </div>\n    <div class=\"dialog-notify-button\">\n      <button\n          id=\"btn-notify-terms-conditions-accept\"\n          class=\"ota-btn-main\">\n          {{ (data?.acceptingCondition ? 'btn-ok' : 'btn-close')  | translate }}\n        </button>\n    </div>\n  </form>\n</ota-dialog>\n"

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [disbledClose]=\"true\" class=\"dialog-condition-change\" disbledClickBackground=\"true\" [ngClass]=\"{ 'content-mobile': isMobile }\">\n  <div class=\"bg\" [ngClass]=\"{'max-width': type === conditionDisplayType.TABLE, 'medium-width': type === conditionDisplayType.TWO_BUTTON, 'min-width': type === conditionDisplayType.ONE_BUTTON, 'min-width-divider': type === conditionDisplayType.ONE_BUTTON_DIVIDER}\">\n    <ng-template\n      *ngIf=\"type === conditionDisplayType.ONE_BUTTON_DIVIDER; then headingWithDescription; else headingWithoutDescription\">\n    </ng-template>\n    <ng-template #headingWithDescription>\n      <div class=\"heading\">\n        <img id=\"dialog-condition-change-heading-img\" class=\"heading-img\" src=\"{{imgPath}}\"/>\n        <div id=\"dialog-condition-change-heading-title\" class=\"heading-title\" [innerHTML]=\"title\"></div>\n        <div id=\"dialog-condition-change-heading-description\" class=\"heading-description\" [innerHTML]=\"description\"></div>\n      </div>\n    </ng-template>\n    <ng-template #headingWithoutDescription>\n      <div class=\"heading\">\n        <img id=\"dialog-condition-change-heading-img\" class=\"heading-img\" src=\"{{imgPath}}\"/>\n        <div id=\"dialog-condition-change-heading-text\" class=\"heading-text\" [ngClass]=\"{'pd-left-right-30': type === conditionDisplayType.ONE_BUTTON}\" [innerHTML]=\"title\"></div>\n      </div>\n    </ng-template>\n    <div *ngIf=\"!isMobile && type ==='table' ; then desktopTmpl else mobileTmpl;\"></div>\n    <!-- Desktop -->\n    <ng-template #desktopTmpl> \n      <div [ngSwitch]=\"noOfColumns\">\n        <!-- 2 Columns-->\n        <ng-container *ngSwitchCase=\"2\">\n          <div class=\"row m-0\">\n            <div id=\"dialog-condition-change-th-0\" class=\"col-md-6 col-xs-6 no-bd-right no-bd-bottom th\">\n              {{columns[0]}}\n            </div>\n            <div id=\"dialog-condition-change-th-1\" class=\"col-md-6 col-xs-6 no-bd-bottom th\">\n              {{columns[1]}}\n            </div>\n          </div>\n          <div *ngFor=\"let row of data; let last = last;\" class=\"row m-0\">\n            <div id=\"dialog-condition-change-td-0\" class=\"col-md-6 col-xs-6 no-bd-right td\" [ngClass]=\"{'no-bd-bottom': !last}\" [innerHTML]=\"row[0]\">\n            </div>\n            <div id=\"dialog-condition-change-td-1\" class=\"col-md-6 col-xs-6 td\" [ngClass]=\"{'no-bd-bottom': !last}\" [innerHTML]=\"row[1]\">\n            </div>    \n          </div>\n        </ng-container>\n        <!-- 3 Columns-->\n        <ng-container *ngSwitchCase=\"3\">\n          <div class=\"row m-0\">\n              <div id=\"dialog-condition-change-th-0\" class=\"col-md-6 col-xs-6 no-bd-right no-bd-bottom th\">\n                {{columns[0]}}\n              </div>\n              <div id=\"dialog-condition-change-th-1\" class=\"col-md-3 col-xs-3 no-bd-right no-bd-bottom th\">\n                {{columns[1]}}\n              </div>\n              <div id=\"dialog-condition-change-th-2\" class=\"col-md-3 col-xs-3 no-bd-bottom th\">\n                {{columns[2]}}\n              </div>\n          </div>\n          <div *ngFor=\"let row of data; let last = last;\" class=\"row m-0\">\n            <div id=\"dialog-condition-change-td-0\" class=\"col-md-6 col-xs-6 no-bd-right td\" [ngClass]=\"{'no-bd-bottom': !last}\">\n              {{row[0]}}\n            </div>\n            <div id=\"dialog-condition-change-td-1\" class=\"col-md-3 col-xs-3 no-bd-right td\" [ngClass]=\"{'no-bd-bottom': !last}\">\n              {{row[1]}}\n            </div>\n            <div id=\"dialog-condition-change-td-2\" class=\"col-md-3 col-xs-3 td\" [ngClass]=\"{'no-bd-bottom': !last}\">\n              {{row[2]}}\n            </div>    \n          </div>\n        </ng-container>\n      </div>\n    </ng-template>\n    <!-- Mobile -->\n    <ng-template #mobileTmpl>\n      <ng-container *ngFor=\"let row of data\">\n        <div style=\"margin-bottom: 10px\">\n          <div *ngFor=\"let item of row;let i = index;let last = last;\" class=\"row m-0\" >\n            <div id=\"dialog-condition-change-th-{{i}}\" class=\"col-xs-6 th no-bd-right\" [ngClass]=\"{'no-bd-bottom': !last}\" [innerHTML]=\"columns[i]\">\n            </div>\n            <div id=\"dialog-condition-change-td-{{i}}\" class=\"col-xs-6 td\" [ngClass]=\"{'no-bd-bottom': !last}\" [innerHTML]=\"item\">\n            </div>\n          </div>\n        </div>\n        </ng-container>\n    </ng-template>\n    <div *ngIf=\"type === conditionDisplayType.ONE_BUTTON || type === conditionDisplayType.ONE_BUTTON_DIVIDER; then oneButtonDisplay else twoButtonDisplay;\"></div>\n    <ng-template #oneButtonDisplay>\n        <div class=\"popup-button-horizontal\" [ngClass]=\"{divider: type === conditionDisplayType.ONE_BUTTON_DIVIDER}\">\n          <button (click)=\"acceptChange()\" id=\"dialog-condition-change-btn-0\" class=\"ota-btn-main btn-horizontal-0\">{{btn[0]}}</button>\n        </div>\n    </ng-template>\n    <ng-template #twoButtonDisplay>\n        <div *ngIf=\" isVerticalDisplayMobile && isMobile; then verticalDisplay else horizontalDisplay;\"></div>\n        <ng-template #horizontalDisplay>\n          <div class=\"popup-button-horizontal\">\n            <button (click)=\"goToHome()\" id=\"dialog-condition-change-btn-0\" md-dialog-close class=\"ota-btn-sub btn-horizontal-0\">{{btn[0]}}</button>\n            <button (click)=\"acceptChange()\" id=\"dialog-condition-change-btn-1\" class=\"ota-btn-main btn-horizontal-1\">{{btn[1]}}</button>\n          </div>\n        </ng-template>\n        <ng-template #verticalDisplay>\n          <div class=\"popup-button-vertical\">\n            <button (click)=\"goToHome()\" id=\"dialog-condition-change-btn-0\" md-dialog-close class=\"ota-btn-sub btn-vertical-0\">{{btn[0]}}</button>\n            <button (click)=\"acceptChange()\" id=\"dialog-condition-change-btn-1\" class=\"ota-btn-main btn-vertical-1\">{{btn[1]}}</button>\n          </div>\n        </ng-template>\n    </ng-template>\n  </div>\n</ota-dialog>\n\n"

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog disbledClose=\"true\" class=\"dialog-confirm\">\n  <div class=\"close-box\">\n    <a id=\"dialog-confirm-btn-close-x\" (click)=\"handleClose($event)\" class=\"pull-right\">\n      <span class=\"icon-close button\"></span>\n    </a>\n  </div>\n  <div class=\"box-overflow text-center\">\n    <p class=\"font-16px color-main text-msg\">{{message}}</p>\n    <div class=\"content-column\">\n      <div class=\"button-group\">\n        <button id=\"dialog-confirm-btn-cancel\" type=\"button\" class=\"ota-btn-sub btn-horizontal\" (click)=\"handleClose($event)\">\n          {{ 'my-profile-address-dialog-button-cancel' | translate }}\n        </button>\n        <button id=\"dialog-confirm-btn-save\" class=\"ota-btn-main btn-horizontal\"\n          [ngClass]=\"{'loading': isLoading}\"\n          (click)=\"handleConfirm($event)\">\n          {{ mainBtn }}\n        </button>\n      </div>\n    </div>\n  </div>\n</ota-dialog>\n"

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog disbledClose=\"true\" class=\"dialog-confirm\"\n  [ngClass]=\"{\n    'width-auto': template === DialogConfirmType.CONFIRM_AVAILABLE_BUDGET || template === DialogConfirmType.CONFIRM_CANCEL_SHARE_BUDGET || template === DialogConfirmType.CONFIRM_CONTINUE_BOOKER_BUDGET,\n    'center': template === DialogConfirmType.CONFIRM_CONTINUE_WITHOUT_PROMOTION_CODE\n  }\"\n  [title]=\"template === DialogConfirmType.CONFIRM_CONTINUE_WITHOUT_PROMOTION_CODE ? '' : (titleText | translate)\"\n  [disbledClickBackground]=\"true\">\n\n  <ng-container *ngIf=\"template === DialogConfirmType.CONFIRM_AVAILABLE_BUDGET || template === DialogConfirmType.CONFIRM_CANCEL_SHARE_BUDGET || template === DialogConfirmType.CONFIRM_CONTINUE_BOOKER_BUDGET; then budget else default\">\n  </ng-container>\n\n  <ng-template #budget>\n    <div class=\"dialog-container-budget\">\n      <img src=\"{{imgPath}}\">\n      <div>\n        <strong id=\"dialog-container-budget-text\">{{descriptionText.text}}</strong>\n        <div id=\"dialog-container-budget-sub-text\">{{descriptionText.subText}}</div>\n      </div>\n    </div>\n  </ng-template>\n\n  <ng-template #default>\n    <ng-container *ngIf=\"template === DialogConfirmType.CONFIRM_CONTINUE_WITHOUT_PROMOTION_CODE\">\n      <img src=\"{{imgPath}}\">\n      <div class=\"title\">{{titleText | translate}}</div>\n    </ng-container>\n    <div class=\"dialog-container\" [innerHTML]=\"(descriptionText | translate)\"></div>\n  </ng-template>\n\n  <div class=\"action-button\">\n    <a class=\"hidden-xs\" id=\"{{pageElementName}}-a-cancel\" (click)=\"handleClose()\">\n      {{ cancelText | translate }}\n    </a>\n\n    <button id=\"{{pageElementName}}-btn-cancel\" class=\"ota-btn-default btn-horizontal visible-xs-block\"\n      (click)=\"handleClose()\">\n      {{ cancelText | translate }}\n    </button>\n\n    <button id=\"{{pageElementName}}-btn-submit\" class=\"ota-btn-main btn-horizontal\" [ngClass]=\"{'loading': isLoading}\"\n      (click)=\"handleConfirm()\">\n      {{ confirmText | translate }}\n    </button>\n  </div>\n\n</ota-dialog>\n"

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog disbledClose=\"true\" class=\"dialog-alert\">\n\n  <!-- contnet -->\n  <div class=\"dialog-success-content\">\n    <div class=\"box-success\">\n      <span class=\"icon-service-failed\"></span>\n    </div>\n    <p class=\"font-16px color-main body-text\" [ngClass]=\"{'mb-0': subText}\">{{text}}</p>\n    <p *ngIf=\"subText\" class=\"color-sub\">{{subText}}</p>\n    <div class=\"action-button\">\n      <button class=\"ota-btn-main\" md-dialog-close>{{'btn-ok' | translate}}</button>\n    </div>\n  </div>\n\n</ota-dialog>"

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog disbledClose=\"true\" class=\"dialog-msg\">\n  <div class=\"box-overflow text-center\">\n    <div class=\"box-content\">\n      <div class=\"box-success\">\n        <span [ngClass]=\"icon\"></span>\n        <img *ngIf=\"img\" src=\"{{img}}\">\n      </div>\n      <p class=\"title-text color-main\" *ngIf=\"title\" [innerHTML]=\"title\"></p>\n      <p class=\"color-sub\" *ngIf=\"message\" [innerHTML]=\"message\"></p>\n      <p #errorMessage></p>\n    </div>\n    \n    <div class=\"action-button\">\n      <button id=\"landing-btn-close-message\" class=\"ota-btn-main\" (click)=\"handleCloseDialog()\">\n        {{ mainBtn }} {{countdown || countdown == 0 ? '(' + countdown + 's)'  : ''}}\n      </button>\n    </div>\n  </div>\n</ota-dialog>"

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog class=\"dialog-information-cart\" [disbledClose]=\"true\" [disbledClickBackground]=\"true\">\n  <div class=\"section-content\">\n    <div class=\"title\" id=\"{{pageElementName}}-title\">\n      {{'dialog-information-cart-title' | translate}}\n    </div>\n    <div class=\"sub-title\" id=\"{{pageElementName}}-sub-title\">\n      {{'dialog-information-cart-sub-title' | translate}}\n    </div>\n    <div class=\"remark\">\n      <ul>\n        <li \n          class=\"remark-item\" \n          *ngFor=\"let remarkItem of data?.remark; let i = index\" \n          [innerHTML]=\"lang == 'th' ? remarkItem?.th : remarkItem?.en\"\n          id=\"{{pageElementName}}-remark-item-{{i}}\"\n        ></li>\n      </ul> \n    </div>\n    <div class=\"accept-condition\">\n      <form [formGroup]=\"form\">\n        <input type=\"checkbox\" formControlName=\"acceptTerms\" id=\"{{pageElementName}}-accept-terms-checkbox\">\n        <span id=\"{{pageElementName}}-accept-terms-text\">{{'dialog-information-cart-accept-condition' | translate}}</span>       \n        <div class=\"text-error\" id=\"{{pageElementName}}-accept-terms-error-required\" *ngIf=\"isSubmitted && form?.get('acceptTerms')?.hasError('required')\">\n          {{'dialog-information-cart-accept-condition-required' | translate}}\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"section-action\">\n    <span class=\"btn-cancel hidden-xs\" id=\"{{pageElementName}}-cancel-button-desktop\" (click)=\"onCancel()\">\n      {{'btn-cancel' | translate}}\n    </span>\n    <button class=\"ota-btn-default btn-horizontal visible-xs-block\" id=\"{{pageElementName}}-cancel-button-mobile\" (click)=\"onCancel()\">\n      {{'btn-cancel' | translate}}\n    </button>\n    <button class=\"ota-btn-main btn-horizontal\" id=\"{{pageElementName}}-confirm-button\" (click)=\"onConfirm()\">\n      {{'btn-confirm' | translate}}\n    </button>\n  </div>\n</ota-dialog>\n"

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [fullscreen]=\"true\" [disbledClose]=\"true\" class=\"dialog-filter\">\n  <div class=\"box-popup-full-white\">\n    <div class=\"close-box\">\n      <a class=\"btn-close-popup\">\n        <button id=\"dialog-list-close-popup\" md-dialog-close class=\"icon-close button\" (click)=\"close()\"></button>\n      </a>\n    </div>\n    <div id=\"dialog-list-title\" class=\"title\">{{data?.title}}</div>\n\n    <div *ngFor=\"let item of data?.items; let i = index\" class=\"ota-radio\"\n      [ngClass]=\"{ 'active': data?.defaultIndex === i && !formCtrl.dirty }\">\n      <input type=\"radio\" id=\"dialog-list-item-{{i}}\" [value]=\"item?.value\" [formControl]=\"formCtrl\"\n        [checked]=\"data?.defaultIndex === i\" />\n      <label for=\"dialog-list-item-{{i}}\">{{ item?.name }}</label>\n    </div>\n  </div>\n</ota-dialog>"

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [title]=\"data?.product?.productTitle\" [rating]=\"data?.product?.hotelStar\" [address]=\"data?.product?.address\" class=\"dialog-map\">\n  <div class=\"loading\" *ngIf=\"!resetCenter\">\n    <img class=\"ota-loading\" src=\"assets/images/loading/loading.png\" />\n  </div>\n  <div id=\"dialog-map\" class=\"dialog-map-padding\" *ngIf=\"productNearByList\" [ngClass]=\"{'-hide': !resetCenter }\">\n\n    <div *ngIf=\"!isMobile; then desktopTmpl else mobileTmpl;\"></div>\n      <ng-template #desktopTmpl>\n        <act-map\n          [zoom]=\"zoom\"\n          [latitude]=\"data?.product?.latitude\"\n          [longitude]=\"data?.product?.longitude\"\n          [resetCenter]=\"resetCenter\">\n          <!-- <act-circle\n            [latitude]=\"data?.product?.latitude\"\n            [longitude]=\"data?.product?.longitude\"\n            [fillColor]=\"'#F5A623'\"\n            [fillOpacity]=\"0.1\"\n            [strokeWeight]=\"1\"\n            [strokeOpacity]=\"0.5\"\n            [strokeColor]=\"'red'\"\n            [radius]=\"radius\">\n          </act-circle> -->\n          <!-- Marker Center -->\n          <act-info-marker\n            key=\"center\"\n            keyCenter=\"center\"\n            [isAllPopOverComplete]=\"isAllPopOverComplete\"\n            [latitude]=\"data?.product?.latitude\"\n            [longitude]=\"data?.product?.longitude\"\n            [isFirstActive]=\"true\"\n            [wrapperClass]=\"data?.product?.netPrice > 0 ? '' : 'marker-no-price'\"\n            [enablePopOver]=\"true\"\n            (onClick)=\"onMarkerClicked($event)\"\n            (onRenderMarkerComplete)=\"onRenderMarkerComplete($event)\">\n            <ng-template>\n              <div *ngIf=\"data?.product?.netPrice > 0; then showPrice else noPrice;\"></div>\n              <ng-template #showPrice>\n                <div class=\"marker-price\">{{ currency.currencyCode }} <b>{{ data?.product?.netPrice | convertExchange }}</b></div>\n              </ng-template>\n              <ng-template #noPrice>\n                <div class=\"marker-price\">{{ 'map-marker-room-not-available' | translate }}</div>\n              </ng-template>\n            </ng-template>\n            <act-pop-over\n              key=\"center\"\n              [isOpen]=\"true\"\n              (onRenderPopOverComplete)=\"onRenderPopOverComplete($event)\"\n              (onClick)=\"onPopOverClicked($event)\">\n                <ng-template>\n                  <act-info-window-content\n                    [image]=\"data?.product?.imageUrl\"\n                    [title]=\"data?.product?.productTitle\"\n                    [rating]=\"data?.product?.hotelStar\"\n                    [review]=\"reviewRating\">\n                  </act-info-window-content>\n                </ng-template>\n            </act-pop-over>\n          </act-info-marker>\n\n          <!-- Other Center -->\n          <act-info-marker *ngFor=\"let item of productNearByList; let i=index\"\n            key=\"{{i}}\"\n            keyCenter=\"center\"\n            [isAllPopOverComplete]=\"isAllPopOverComplete\"\n            [latitude]=\"item?.latitude\"\n            [longitude]=\"item?.longitude\"\n            [wrapperClass]=\"item?.netPrice > 0 ? '' : 'marker-no-price'\"\n            [enablePopOver]=\"true\"\n            (onClick)=\"onMarkerClicked($event)\"\n            (onRenderMarkerComplete)=\"onRenderMarkerComplete($event)\">\n            <ng-template>\n              <div *ngIf=\"item?.netPrice > 0; then showPrice else noPrice;\"></div>\n              <ng-template #showPrice><div class=\"marker-price\">{{ currency.currencyCode }} <b>{{ item?.netPrice | convertExchange }}</b></div></ng-template>\n              <ng-template #noPrice><div class=\"marker-price\">{{ 'map-marker-room-not-available' | translate }}</div></ng-template>\n            </ng-template>\n            <act-pop-over\n              key=\"{{i}}\"\n              [isOpen]=\"false\"\n              (onRenderPopOverComplete)=\"onRenderPopOverComplete($event)\"\n              (onClick)=\"onPopOverClicked($event)\">\n                <ng-template>\n                  <act-info-window-content\n                    [image]=\"item?.imageUrl\"\n                    [title]=\"item?.productTitle\"\n                    [rating]=\"item?.hotelStar\"\n                    [review]=\"item?.reviewRating\">\n                  </act-info-window-content>\n                </ng-template>\n            </act-pop-over>\n          </act-info-marker>\n        </act-map>\n      </ng-template>\n\n      <ng-template #mobileTmpl>\n        <act-info-window-content class=\"info-window-mobile\" (click)=\"onPopOverClicked(infoWindowKey)\"\n          [latitude]=\"data?.product?.latitude\" [longitude]=\"data?.product?.longitude\">\n        </act-info-window-content>\n        <act-map\n          [zoom]=\"zoom\"\n          [latitude]=\"data?.product?.latitude\"\n          [longitude]=\"data?.product?.longitude\"\n          [resetCenter]=\"resetCenter\">\n          <!-- <act-circle\n            [latitude]=\"data?.product?.latitude\"\n            [longitude]=\"data?.product?.longitude\"\n            [fillColor]=\"'#F5A623'\"\n            [fillOpacity]=\"0.1\"\n            [strokeWeight]=\"1\"\n            [strokeOpacity]=\"0.5\"\n            [strokeColor]=\"'red'\"\n            [radius]=\"radius\">\n          </act-circle> -->\n          <!-- Marker Center -->\n          <act-info-marker\n            key=\"center\"\n            keyCenter=\"center\"\n            [latitude]=\"data?.product?.latitude\"\n            [longitude]=\"data?.product?.longitude\"\n            [isFirstActive]=\"true\"\n            [wrapperClass]=\"data?.product?.netPrice > 0 ? '' : 'marker-no-price'\"\n            [enablePopOver]=\"false\"\n            (onClick)=\"onMarkerClicked($event)\"\n            (onRenderMarkerComplete)=\"onRenderMarkerComplete($event)\">\n            <ng-template>\n              <div *ngIf=\"data?.product?.netPrice > 0; then showPrice else noPrice;\"></div>\n              <ng-template #showPrice>\n                <div class=\"marker-price\">{{ currency.currencyCode }} <b>{{ data?.product?.netPrice | convertExchange }}</b></div>\n              </ng-template>\n              <ng-template #noPrice>\n                <div class=\"marker-price\">{{ 'map-marker-room-not-available' | translate }}</div>\n              </ng-template>\n            </ng-template>\n          </act-info-marker>\n\n          <!-- Other Center -->\n          <act-info-marker *ngFor=\"let item of productNearByList; let i=index\"\n            key=\"{{i}}\"\n            keyCenter=\"center\"\n            [latitude]=\"item?.latitude\"\n            [longitude]=\"item?.longitude\"\n            [wrapperClass]=\"item?.netPrice > 0 ? '' : 'marker-no-price'\"\n            [enablePopOver]=\"false\"\n            (onClick)=\"onMarkerClicked($event)\"\n            (onRenderMarkerComplete)=\"onRenderMarkerComplete($event)\">\n            <ng-template>\n              <div *ngIf=\"item?.netPrice > 0; then showPrice else noPrice;\"></div>\n              <ng-template #showPrice><div class=\"marker-price\">{{ currency.currencyCode }} <b>{{ item?.netPrice | convertExchange }}</b></div></ng-template>\n              <ng-template #noPrice><div class=\"marker-price\">{{ 'map-marker-room-not-available' | translate }}</div></ng-template>\n            </ng-template>\n          </act-info-marker>\n        </act-map>\n      </ng-template>\n  </div>\n  <a id=\"link-to-product-detail\"></a>\n</ota-dialog>\n"

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports = "<div class=\"info-window\" [ngClass]=\"{'-hover': _isActive }\">\n  <div class=\"info-window-image\">\n    <img src=\"{{_image}}\">\n  </div>\n  <div class=\"info-window-content\">\n    <div class=\"info-window-title\">{{_title}}</div>\n    <span class=\"info-window-rating\" *ngFor=\"let rate of ratingArray\" class=\"icon-star icon-star-level-s\"\n      [ngClass]=\"{'-half': rate == 0.5}\"></span>\n    <div class=\"hotel-review-score\" *ngIf=\"reviewRating?.totalScore && reviewRating?.totalTitle\">\n      <!-- Review Score -->\n      <!-- Review Title -->\n      <span class=\"review-score-title-s\" id=\"rating-description-item\">{{reviewRating?.totalTitle | translate}}</span>\n      <span class=\"review-score\" id=\"rating-score-item\">{{reviewRating?.totalScore}}</span>\n    </div>\n  </div>\n</div>\n<div *ngIf=\"displayNavigate\" class=\"btn-navigate show-sm\" (click)=\"onNavigate()\">\n  <i class=\"icon-navigation\"></i><span>{{ 'info-window-content-navigate' | translate }}</span>\n</div>"

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [title]=\"data?.product?.productTitle\" [rating]=\"data?.product?.hotelStar\" [address]=\"data?.product?.address\" class=\"dialog-map\">\n    <div class=\"loading\" *ngIf=\"!resetCenter\">\n      <img class=\"ota-loading\" src=\"assets/images/loading/loading.png\" />\n    </div>\n    <div id=\"dialog-map\" class=\"dialog-map-padding\" *ngIf=\"productPoiList\" [ngClass]=\"{'-hide': !resetCenter }\">\n      <div *ngIf=\"!isMobile; then desktopTmpl else mobileTmpl;\"></div>\n        <ng-template #desktopTmpl>\n          <act-map\n            [zoom]=\"zoom\"\n            [latitude]=\"data?.searchData?.destination?.poi?.lat\"\n            [longitude]=\"data?.searchData?.destination?.poi?.lon\"\n            [resetCenter]=\"resetCenter\">\n            <!-- <act-circle\n              [latitude]=\"data?.searchData?.destination?.poi?.lat\"\n              [longitude]=\"data?.searchData?.destination?.poi?.lon\"\n              [fillColor]=\"'#F5A623'\"\n              [fillOpacity]=\"0.1\"\n              [strokeWeight]=\"1\"\n              [strokeOpacity]=\"0.5\"\n              [strokeColor]=\"'red'\"\n              [radius]=\"radius\">\n            </act-circle> -->\n            <!-- Marker Center -->\n            <act-info-marker\n              key=\"center\"\n              keyCenter=\"center\"\n              [isAllPopOverComplete]=\"isAllPopOverComplete\"\n              [latitude]=\"data?.product?.latitude\"\n              [longitude]=\"data?.product?.longitude\"\n              [isFirstActive]=\"true\"\n              [wrapperClass]=\"data?.product?.netPrice > 0 ? '' : 'marker-no-price'\"\n              [enablePopOver]=\"true\"\n              (onClick)=\"onMarkerClicked($event)\"\n              (onRenderMarkerComplete)=\"onRenderMarkerComplete($event)\">\n              <ng-template>\n                <div *ngIf=\"data?.product?.netPrice > 0; then showPrice else noPrice;\"></div>\n                <ng-template #showPrice>\n                  <div class=\"marker-price\">{{ currency.currencyCode }} <b>{{ data?.product?.netPrice | convertExchange }}</b></div>\n                </ng-template>\n                <ng-template #noPrice>\n                  <div class=\"marker-price\">{{ 'map-marker-room-not-available' | translate }}</div>\n                </ng-template>\n              </ng-template>\n              <act-pop-over\n                key=\"center\"\n                [isOpen]=\"true\"\n                (onRenderPopOverComplete)=\"onRenderPopOverComplete($event)\"\n                (onClick)=\"onPopOverClicked($event)\">\n                  <ng-template>\n                    <act-info-window-content\n                      [image]=\"data?.product?.imageUrl\"\n                      [title]=\"data?.product?.productTitle\"\n                      [rating]=\"data?.product?.hotelStar\"\n                      [review]=\"reviewRating\">\n                    </act-info-window-content>\n                  </ng-template>\n              </act-pop-over>\n            </act-info-marker>\n\n            <!-- POI Center -->\n            <act-info-marker\n            key=\"poi\"\n            keyCenter=\"center\"\n            [isAllPopOverComplete]=\"isAllPopOverComplete\"\n            [latitude]=\"data?.searchData?.destination?.poi?.lat\"\n            [longitude]=\"data?.searchData?.destination?.poi?.lon\"\n            [enablePopOver]=\"false\"\n            [isPoi]=\"true\"\n            (onClick)=\"onMarkerClicked($event)\"\n            (onRenderMarkerComplete)=\"onRenderMarkerComplete($event)\">\n            <ng-template>\n                <img class=\"pin\" src=\"assets/images/icons/icon-POI.png\" alt=\"POI-pin\" style=\"height:30px\">\n            </ng-template>\n            <act-pop-over\n              key=\"poi\"\n              [isOpen]=\"false\"\n              (onRenderPopOverComplete)=\"onRenderPopOverComplete($event)\"\n              (onClick)=\"onPopOverClicked($event)\">\n                <ng-template>\n                  <act-info-window-content\n                    [image]=\"data?.product?.imageUrl\"\n                    [title]=\"data?.product?.productTitle\"\n                    [rating]=\"data?.product?.hotelStar\"\n                    [review]=\"item?.reviewRating\">\n                  </act-info-window-content>\n                </ng-template>\n            </act-pop-over>\n          </act-info-marker>\n            <!-- Other Center -->\n            <act-info-marker *ngFor=\"let item of productPoiList; let i=index\"\n              key=\"{{i}}\"\n              keyCenter=\"center\"\n              [isAllPopOverComplete]=\"isAllPopOverComplete\"\n              [latitude]=\"item?.latitude\"\n              [longitude]=\"item?.longitude\"\n              [wrapperClass]=\"item?.netPrice > 0 ? '' : 'marker-no-price'\"\n              [enablePopOver]=\"true\"\n              (onClick)=\"onMarkerClicked($event)\"\n              (onRenderMarkerComplete)=\"onRenderMarkerComplete($event)\">\n              <ng-template>\n                <div *ngIf=\"item?.netPrice > 0; then showPrice else noPrice;\"></div>\n                <ng-template #showPrice><div class=\"marker-price\">{{ currency.currencyCode }} <b>{{ item?.netPrice | convertExchange }}</b></div></ng-template>\n                <ng-template #noPrice><div class=\"marker-price\">{{ 'map-marker-room-not-available' | translate }}</div></ng-template>\n              </ng-template>\n              <act-pop-over\n                key=\"{{i}}\"\n                [isOpen]=\"false\"\n                (onRenderPopOverComplete)=\"onRenderPopOverComplete($event)\"\n                (onClick)=\"onPopOverClicked($event)\">\n                  <ng-template>\n                    <act-info-window-content\n                      [image]=\"item?.imageUrl\"\n                      [title]=\"item?.productTitle\"\n                      [rating]=\"item?.hotelStar\"\n                      [review]=\"item?.reviewRating\">\n                    </act-info-window-content>\n                  </ng-template>\n              </act-pop-over>\n            </act-info-marker>\n          </act-map>\n        </ng-template>\n\n        <ng-template #mobileTmpl>\n          <act-info-window-content class=\"info-window-mobile\" (click)=\"onPopOverClicked(infoWindowKey)\"\n            [latitude]=\"data?.product?.latitude\" [longitude]=\"data?.product?.longitude\"></act-info-window-content>\n          <act-map\n            [zoom]=\"zoom\"\n            [latitude]=\"data?.searchData?.destination?.poi?.lat\"\n            [longitude]=\"data?.searchData?.destination?.poi?.lon\"\n            [resetCenter]=\"resetCenter\">\n            <!-- <act-circle\n              [latitude]=\"data?.searchData?.destination?.poi?.lat\"\n              [longitude]=\"data?.searchData?.destination?.poi?.lon\"\n              [fillColor]=\"'#F5A623'\"\n              [fillOpacity]=\"0.1\"\n              [strokeWeight]=\"1\"\n              [strokeOpacity]=\"0.5\"\n              [strokeColor]=\"'red'\"\n              [radius]=\"radius\">\n            </act-circle> -->\n            <!-- Marker Center -->\n            <act-info-marker\n              key=\"center\"\n              keyCenter=\"center\"\n              [latitude]=\"data?.product?.latitude\"\n              [longitude]=\"data?.product?.longitude\"\n              [isFirstActive]=\"true\"\n              [wrapperClass]=\"data?.product?.netPrice > 0 ? '' : 'marker-no-price'\"\n              [enablePopOver]=\"false\"\n              (onClick)=\"onMarkerClicked($event)\"\n              (onRenderMarkerComplete)=\"onRenderMarkerComplete($event)\">\n              <ng-template>\n                <div *ngIf=\"data?.product?.netPrice > 0; then showPrice else noPrice;\"></div>\n                <ng-template #showPrice>\n                  <div class=\"marker-price\">{{ currency.currencyCode }} <b>{{ data?.product?.netPrice | convertExchange }}</b></div>\n                </ng-template>\n                <ng-template #noPrice>\n                  <div class=\"marker-price\">{{ 'map-marker-room-not-available' | translate }}</div>\n                </ng-template>\n              </ng-template>\n            </act-info-marker>\n\n            <!-- POI Center -->\n            <act-info-marker\n              key=\"poi\"\n              keyCenter=\"center\"\n              [latitude]=\"data?.searchData?.destination?.poi?.lat\"\n              [longitude]=\"data?.searchData?.destination?.poi?.lon\"\n              [enablePopOver]=\"false\"\n              [isPoi]=\"true\"\n              (onRenderMarkerComplete)=\"onRenderMarkerComplete($event)\">\n              <ng-template>\n                  <img class=\"pin\" src=\"assets/images/icons/icon-POI.png\" alt=\"POI-pin\" style=\"height:30px\">\n              </ng-template>\n            </act-info-marker>\n\n            <!-- Other Center -->\n            <act-info-marker *ngFor=\"let item of productPoiList; let i=index\"\n              key=\"{{i}}\"\n              keyCenter=\"center\"\n              [latitude]=\"item?.latitude\"\n              [longitude]=\"item?.longitude\"\n              [wrapperClass]=\"item?.netPrice > 0 ? '' : 'marker-no-price'\"\n              [enablePopOver]=\"false\"\n              (onClick)=\"onMarkerClicked($event)\"\n              (onRenderMarkerComplete)=\"onRenderMarkerComplete($event)\">\n              <ng-template>\n                <div *ngIf=\"item?.netPrice > 0; then showPrice else noPrice;\"></div>\n                <ng-template #showPrice><div class=\"marker-price\">{{ currency.currencyCode }} <b>{{ item?.netPrice | convertExchange }}</b></div></ng-template>\n                <ng-template #noPrice><div class=\"marker-price\">{{ 'map-marker-room-not-available' | translate }}</div></ng-template>\n              </ng-template>\n            </act-info-marker>\n          </act-map>\n        </ng-template>\n    </div>\n    <a id=\"link-to-product-detail\"></a>\n  </ota-dialog>\n"

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

module.exports = " <ota-dialog [title]=\"title\" [rating]=\"rating\" [address]=\"address\" class=\"dialog-map\">\n     <div id=\"dialog-map\" class=\"dialog-map-padding\">\n        <act-google-map [latitude]=\"lat\" [longitude]=\"lng\" class=\"dialog-map\"></act-google-map>\n     </div>\n</ota-dialog> "

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog class=\"dialog-multi-payment\" [disbledClose]=\"true\" [closeBottom]=\"true\">\n  <div class=\"tc-container\">\n    <div class=\"tc-item\">\n      <div>{{'product-detail-tooltip-price-per-night' | translate}}</div>\n      <div>{{data?.currency}} {{data?.netPrice | number}}</div>\n    </div>\n    <div class=\"tc-item\">\n      <div>{{'product-detail-tooltip-user-budget' | translate}}</div>\n      <div>- {{data?.currency}} {{data?.userBudget | number}}</div>\n    </div>\n    <div class=\"tc-item\">\n      <div>{{'product-detail-tooltip-pay-over-budget' | translate}}</div>\n      <div><strong>{{data?.currency}} {{data?.overPrice | number}}</strong></div>\n    </div>\n  </div>\n</ota-dialog>"

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog disbledClose=\"true\" class=\"dialog-notify-budget center\" [ngClass]=\"{'content-mobile': isMobile}\">\n  <div class=\"dialog-alert-content\">\n    <img class=\"alert-img\" src=\"/assets/images/icons/icon-scg-budget.png\" srcset=\"/assets/images/icons/icon-scg-budget.png 1x, /assets/images/icons/icon-scg-budget@2x.png 2x\"/>\n    <div class=\"alert-text\">\n      <div [innerHTML]=\"data.text\"></div>\n    </div>\n    <button class=\"ota-btn-main\" (click)=\"handleBtnOk()\">{{'btn-ok' | translate}}</button>\n    <div class=\"ota-checkbox\">\n      <input\n        [(ngModel)]=\"agree\"\n        type=\"checkbox\"\n        id=\"search-popup-notify-budget-checkbox\">\n      <label for=\"search-popup-notify-budget-checkbox\">\n        {{'search-popup-checkbox-label' | translate}}\n      </label>\n    </div>\n  </div>\n</ota-dialog>"

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [mobileFullscreen]=\"true\" [disbledClose]=\"true\" [disbledClickBackground]=\"true\">\n  <div class=\"dialog-content\">\n    <div *ngIf=\"state != PHONE_STATE.METHODS && state != PHONE_STATE.OTP && state != PHONE_STATE.SESSION_EXPIRE\">\n      <div class=\"title\">{{ \"dialog-set-phone-header\" | translate }}</div>\n      <div class=\"sub-title\">{{ \"dialog-set-phone-sub-header\" | translate }}</div>\n      <div class=\"content\" [formGroup]=\"form\">\n        <div class=\"form-group\">\n          <label for=\"{{elementId}}-label-phone-number\">{{ \"dialog-set-phone-label-phone-number\" | translate }}</label>\n          <div class=\"phone-input-group\">\n            <act-icon-dropdown\n              name=\"calling-code\"\n              [page]=\"elementId\"\n              [optionList]=\"callingCodeList\"\n              [default]=\"defaultOption\"\n              formControlName=\"countryISO2\"\n              (ngModelChange)=\"onSelectCallingCode($event)\"\n              [defaultValue]=\"'default-dropdown' | translate\"\n            ></act-icon-dropdown>\n            <input\n              #mobileNumber\n              id=\"{{elementId}}-inp-phone-number\"\n              formControlName=\"mobileNumber\"\n              type=\"tel\"\n              class=\"form-control\"\n              name=\"mobileNo\"\n              placeholder=\"e.g. 0812345678\"\n              [textMask]=\"{ mask: phoneNumberMask, guide: false }\"\n              [ngClass]=\"{'input-error': isInvalid('mobileNumber'), 'input-success': form.get('mobileNumber').valid}\"\n            />\n          </div>\n          <span id=\"{{elementId}}-span-phone-number-error-require\" *ngIf=\"!form.get('mobileNumber').value && isInvalid('mobileNumber') || form.get('mobileNumber').formErrors?.required\" class=\"text-error mb-0\">\n            {{ 'dialog-set-phone-require-mobile-number' | translate }}\n          </span>\n          <span id=\"{{elementId}}-span-phone-number-error-pattern\" *ngIf=\"form.get('mobileNumber').value && isInvalid('mobileNumber') || form.get('mobileNumber').formErrors?.pattern\" class=\"text-error mb-0\">\n            {{ 'dialog-set-phone-invalid-mobile-number' | translate }}\n          </span>\n        </div>\n      </div>\n    </div>\n    <act-verify-otp\n      #otpVerifyChild\n      *ngIf=\"state == PHONE_STATE.METHODS || state == PHONE_STATE.OTP || state == PHONE_STATE.SESSION_EXPIRE\"\n      [methods]=\"otpMethods\" [token]=\"otpToken\" [state]=\"state\" [purpose]=\"OTP_PURPOSE.SET_PHONE\"\n      (verified)=\"onVerifiedOtp($event)\" (stateChange)=\"onOtpStateChange($event)\" (accountLock)=\"onAccountLocked()\"\n      [(isLoading)]=\"isLoading\"\n    ></act-verify-otp>\n  </div>\n  <div class=\"action-button\">\n    <a id=\"{{elementId}}-text-link-back\" *ngIf=\"backButtonMode == 'back' && state != PHONE_STATE.SESSION_EXPIRE\" class=\"text-link hidden-xs\"\n      (click)=\"onClickBack()\">{{ (state == PHONE_STATE.OTP ? 'otp-try-another-way' : 'btn-back') | translate }}</a>\n    <a id=\"{{elementId}}-text-link-cancel\" *ngIf=\"backButtonMode == 'cancel' && state != PHONE_STATE.SESSION_EXPIRE\" class=\"text-link hidden-xs\"\n      (click)=\"onClickCancel()\">{{ \"btn-cancel\" | translate }}</a>\n    <button id=\"{{elementId}}-btn-back\" *ngIf=\"backButtonMode == 'back'\"\n      class=\"ota-btn-default btn-horizontal visible-xs-block\" (click)=\"onClickBack()\">\n      {{ (state == PHONE_STATE.OTP ? 'otp-try-another-way' : 'btn-back') | translate }}\n    </button>\n    <button id=\"{{elementId}}-btn-cancel\" *ngIf=\"backButtonMode == 'cancel'\"\n      class=\"ota-btn-default btn-horizontal visible-xs-block\" (click)=\"onClickCancel()\">\n      {{ (state == PHONE_STATE.SESSION_EXPIRE ? 'btn-close' : 'btn-cancel') | translate }}\n    </button>\n    <div class=\"space\"></div>\n    <button id=\"{{elementId}}-btn-verify\" class=\"ota-btn-main\" [ngClass]=\"{'loading': isLoading}\"\n      [disabled]=\"(form && form.invalid) || (otpInputForm && otpInputForm.invalid)\" (click)=\"onSubmit()\">\n      <ng-container *ngIf=\"!isLoading\">\n        <span *ngIf=\"state != PHONE_STATE.OTP && state != PHONE_STATE.METHODS\">{{ \"btn-continue\" | translate }}</span>\n        <span *ngIf=\"state == PHONE_STATE.OTP\">{{ \"btn-confirm\" | translate }}</span>\n        <span *ngIf=\"state == PHONE_STATE.METHODS\">{{ \"btn-close\" | translate }}</span>\n      </ng-container>\n    </button>\n  </div>\n</ota-dialog>\n"

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [disbledClose]=\"true\">\n    <div class=\"dialog-content\">\n      <img class=\"alert-img\" src=\"{{imageSrc}}\" />\n      <div id=\"{{elementId}}-text-title\" class=\"title\" [innerHTML]=\"'dialog-alert-set-pin-title' | translate\"></div>\n      <div id=\"{{elementId}}-text-description\" class=\"description\" [innerHTML]=\"'dialog-alert-set-pin-description' | translate\"></div>\n    </div>\n    <div class=\"dialog-footer\">\n      <ng-container *ngIf=\"isMobile; else desktop\">\n        <button class=\"ota-btn-sub\" (click)=\"handleClose()\">{{ 'btn-close' | translate}}</button>\n      </ng-container>\n      <ng-template #desktop>\n        <a id=\"{{elementId}}-text-link-back\" class=\"text-link\" (click)=\"handleClose()\">{{ 'btn-close' | translate }}</a>\n      </ng-template>\n      <button class=\"ota-btn-main\" (click)=\"handleSubmit()\">{{ 'dialog-alert-btn-confirm-set-pin' | translate}}</button>\n    </div>\n</ota-dialog>\n"

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [mobileFullscreen]=\"true\" [disbledClose]=\"state != PIN_STATE.OTP && state != PIN_STATE.SESSION_EXPIRE\" [disbledClickBackground]=\"true\" class=\"dialog-pin\">\n  <div class=\"dialog-content\">\n    <act-pin *ngIf=\"state != PIN_STATE.METHODS && state != PIN_STATE.OTP && state != PIN_STATE.SESSION_EXPIRE\" #pinChild [state]=\"state\"\n      [errorMessage]=\"errorMessage\" (resetError)=\"resetError()\"></act-pin>\n    <act-verify-otp #otpVerifyChild *ngIf=\"state == PIN_STATE.METHODS || state == PIN_STATE.OTP || state == PIN_STATE.SESSION_EXPIRE\" [methods]=\"otpMethods\"\n      [token]=\"otpToken\" (verified)=\"onVerifiedOtp($event)\" [state]=\"state\" [purpose]=\"OTP_PURPOSE.SET_PIN\"\n      (stateChange)=\"onOtpStateChange($event)\" (accountLock)=\"onAccountLocked()\" [(isLoading)]=\"isLoading\"></act-verify-otp>\n  </div>\n  <div class=\"action-button\">\n    <a id=\"{{elementId}}-text-link-back\" *ngIf=\"backButtonMode == 'back' && state != PIN_STATE.SESSION_EXPIRE\" class=\"text-link hidden-xs\"\n      (click)=\"onClickBack()\">{{ (state == PIN_STATE.OTP ? 'otp-try-another-way' : 'btn-back') | translate }}</a>\n    <a id=\"{{elementId}}-text-link-cancel\" *ngIf=\"backButtonMode == 'cancel' && state != PIN_STATE.SESSION_EXPIRE\" class=\"text-link hidden-xs\"\n      (click)=\"onClickCancel()\">{{ \"btn-cancel\" | translate }}</a>\n    <button id=\"{{elementId}}-btn-back\" *ngIf=\"backButtonMode == 'back'\"\n      class=\"ota-btn-default btn-horizontal visible-xs-block\" (click)=\"onClickBack()\">\n      {{ (state == PIN_STATE.OTP ? 'otp-try-another-way' : 'btn-back') | translate }}\n    </button>\n    <button id=\"{{elementId}}-btn-cancel\" *ngIf=\"backButtonMode == 'cancel'\"\n      class=\"ota-btn-default btn-horizontal visible-xs-block\" (click)=\"onClickCancel()\">\n      {{ (state == PIN_STATE.SESSION_EXPIRE ? 'btn-close' : 'btn-cancel') | translate }}\n    </button>\n    <div class=\"space\"></div>\n    <button id=\"{{elementId}}-btn-verify\" class=\"ota-btn-main\" [ngClass]=\"{'loading': isLoading}\"\n      [disabled]=\"(pinInputForm && pinInputForm.invalid) || (otpInputForm && otpInputForm.invalid)\"\n      (click)=\"onSubmit()\">\n      <ng-container *ngIf=\"!isLoading\">\n        <span [ngSwitch]=\"state\">\n          <span *ngSwitchCase=\"PIN_STATE.OTP\">{{ \"btn-confirm\" | translate }}</span>\n          <span *ngSwitchCase=\"PIN_STATE.CHECKOUT\">{{ \"btn-confirm\" | translate }}</span>\n          <span *ngSwitchCase=\"PIN_STATE.METHODS\">{{ \"btn-close\" | translate }}</span>\n          <span *ngSwitchDefault>{{ \"btn-continue\" | translate }}</span>\n        </span>\n      </ng-container>\n    </button>\n  </div>\n</ota-dialog>\n"

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container-title\">\n  <ng-container [ngSwitch]=\"state\">\n    <div *ngSwitchCase=\"PIN_STATE.SET_PIN\">\n      <div class=\"title\">\n        {{ \"dialog-set-pin-header\" | translate }}\n      </div>\n      <div class=\"sub-title\">\n        {{ \"dialog-set-pin-sub-header\" | translate }}\n      </div>\n      <div class=\"sub-title\">\n        {{ \"dialog-set-pin-sub-header-2\" | translate }}\n      </div>\n    </div>\n    <div *ngSwitchCase=\"PIN_STATE.CONFIRM_SET_PIN\">\n      <div class=\"title\">\n        {{ \"dialog-confirm-set-pin-header\" | translate }}\n      </div>\n      <div class=\"sub-title\">\n        {{ \"dialog-set-pin-sub-header\" | translate }}\n      </div>\n      <div class=\"sub-title\">\n        {{ \"dialog-set-pin-sub-header-2\" | translate }}\n      </div>\n    </div>\n    <div *ngSwitchCase=\"PIN_STATE.CHECKOUT\">\n      <div class=\"title\">\n        {{ \"dialog-confirm-pin-booking-header\" | translate }}\n      </div>\n      <div class=\"sub-title\">\n        {{ \"dialog-confirm-pin-booking-sub-header\" | translate }}\n      </div>\n    </div>\n  </ng-container>\n</div>\n<div class=\"container-content\">\n  <div>\n    <form [formGroup]=\"pinInputForm\" class=\"form-group\" id=\"{{elementId}}-form\">\n      <input *ngFor=\"let ctrl of pinControls; let i = index\" id=\"{{elementId}}-input-{{i}}\" class=\"input-number\"\n        inputmode=\"numeric\" type=\"password\" [formControlName]=\"i\" (keydown)=\"onKeydown($event, i)\"\n        (paste)=\"onPaste($event)\" (input)=\"onPinInput($event, i)\" />\n    </form>\n    <div class=\"error\" *ngIf=\"!!errorMessage\">\n      <i class=\"icon-warning\"></i>\n      <div id=\"{{elementId}}-text-error\" class=\"error-text\" [innerHTML]=\"errorMessage\"></div>\n    </div>\n  </div>\n  <div *ngIf=\"state == PIN_STATE.CHECKOUT\" class=\"forgot-pin\">\n    <span>{{\"dialog-confirm-pin-booking-forgot-pin\" | translate}} <a class=\"text-link\" [href]=\"'/setting?lang=' + lang\"\n        target=\"_blank\">{{\"dialog-confirm-pin-booking-set-new-pin\" | translate}}</a></span>\n  </div>\n</div>"

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports = "<md-dialog-content class=\"mice-form\">\n  <div class=\"dialog-service-chioce\">\n    <div class=\"dialog-wrapper-content\">\n      <div class=\"close-box clearfix\">\n        <a id=\"mice-form-close-button\" (click)=\"closeDialog()\" class=\"pull-right\">\n          <span class=\"icon-close button\">\n          </span>\n        </a>\n      </div>\n      <h2 id=\"mice-form-title\" class=\"form-pop-title\">{{ 'mice-quotation-title' | translate }}</h2>\n      <p id=\"mice-form-subtitle\" class=\"form-pop-subtitle\">{{ 'mice-quotation-sub-title' | translate }}</p>\n      <div class=\"mf-control\">\n        <form [formGroup]=\"quotationForm\" (ngSubmit)=\"onSubmit()\" class=\"mc-form\">\n          <div class=\"form-wrapper\">\n            <div class=\"form-group\">\n              <div\n                [ngClass]=\"{ 'ota-input-error' : quotationForm?.get('serviceType')?.invalid && (quotationForm?.get('serviceType')?.touched || isSubmitted) }\"\n                class=\"select-ota-style\">\n                <select id=\"mice-form-serviceType\" formControlName=\"serviceType\">\n                  <option [disabled]=\"true\" value=\"\">{{ 'mice-quotation-placeholder-dropdown' | translate }}</option>\n                  <option *ngFor=\"let type of serviceTypes;let i = index;\" [value]=\"i\">{{type}}</option>\n                </select>\n              </div>\n              <div id=\"mice-form-serviceType-error\" *ngIf=\"quotationForm?.get('serviceType')?.invalid && (quotationForm?.get('serviceType')?.touched || isSubmitted); then error else subTitle\"></div>\n              <ng-template #error>\n                <small class=\"text-error mb-0\"> {{'mice-quotation-warning-placeholder-dropdown' | translate}}</small>\n              </ng-template>\n              <ng-template #subTitle>\n                <small class=\"text-sub-title\"> {{'mice-quotation-description-service' | translate}} </small>\n              </ng-template>\n            </div>\n          </div>\n          <div class=\"form-wrapper\">\n            <div class=\"form-group\">\n              <div class=\"-form-map\">\n                <input formControlName=\"destination\" type=\"text\" value=\"\" maxlength=\"200\"\n                  placeholder=\"{{ 'mice-quotation-destination' | translate }}\" class=\"ota-input-text\">\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-xs-6\">\n                  <div class=\"datepicker-wrap datepicker-container -form-calendar\">\n                    <input\n                        readonly\n                        [daterangepicker]=\"stateDaterangepicker\"\n                        [formControlFrom]=\"quotationForm.controls.startDate\"\n                        [formControlTo]=\"quotationForm.controls.endDate\"\n                        [haveDefaultDate]= \"false\"\n                        [allowSameDate]=\"true\"\n                        placeholder=\"{{ 'mice-quotation-start-date' | translate }}\"\n                        id=\"mice-form-startDate\"\n                        syncToId=\"mice-form-endDate\"\n                        label=\"mice-quotation-start-date\"\n                        name=\"startDate\"\n                        section=\"searchMyBooking\"\n                        type=\"text\"\n                        class=\"form-control form-calendar button\">\n                  </div>\n                </div>\n                <div class=\"col-xs-6\">\n                  <div class=\"datepicker-wrap datepicker-container -form-calendar\">\n                    <input\n                        readonly\n                        [daterangepicker]=\"stateDaterangepicker\"\n                        [formControlFrom]=\"quotationForm.controls.startDate\"\n                        [formControlTo]=\"quotationForm.controls.endDate\"\n                        [haveDefaultDate]= \"false\"\n                        [allowSameDate]=\"true\"\n                        id=\"mice-form-endDate\"\n                        syncToId=\"mice-form-startDate\"\n                        placeholder=\"{{ 'mice-quotation-end-date' | translate }}\"\n                        [isFirst]=\"false\"\n                        label=\"mice-quotation-end-date\"\n                        name=\"endDate\"\n                        section=\"searchMyBooking\"\n                        type=\"text\"\n                        opens=\"left\"\n                        class=\"form-control form-calendar button\">\n                  </div>\n                </div>\n              </div>\n              <small id=\"mice-form-date-description\" class=\"description\">{{ 'mice-quotation-description-date' | translate }}</small>\n            </div>\n          </div>\n          <div class=\"form-wrapper\">\n            <div class=\"row\">\n              <div class=\"col-sm-6 mb-0\">\n                <div class=\"form-group\">\n                  <input id=\"mice-form-budget\" [textMask]=\"{ mask: maskBudgetNumber, guide: false }\" formControlName=\"budget\" type=\"text\" placeholder=\"{{ 'mice-quotation-budget' | translate }}\" class=\"ota-input-text\">\n                  <div id=\"mice-form-budget-error\" *ngIf=\"quotationForm?.get('budget')?.errors?.zero && (quotationForm?.get('budget')?.touched || isSubmitted)\">\n                    <small class=\"text-error mb-0\"> {{'mice-quotation-warning-zero-budget' | translate}} </small>\n                  </div>\n                </div>\n              </div>\n              <div class=\"col-sm-6 mb-0\">\n                <div class=\"form-group\">\n                  <input id=\"mice-form-attendees\" [textMask]=\"{ mask: maskAttendeesNumber, guide: false }\" formControlName=\"attendees\" type=\"text\" placeholder=\"{{ 'mice-quotation-attendees' | translate }}\" class=\"ota-input-text\">\n                  <div id=\"mice-form-attendee-error\" *ngIf=\"quotationForm?.get('attendees')?.errors?.zero && (quotationForm?.get('attendees')?.touched || isSubmitted)\">\n                    <small class=\"text-error mb-0\"> {{'mice-quotation-warning-zero-attendees' | translate}} </small>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <textarea id=\"mice-form-remark\" style=\"resize: none;\" maxlength=\"4000\" formControlName=\"remark\" rows=\"5\" placeholder=\"{{ 'mice-quotation-special-request' | translate }}\" class=\"form-control\"></textarea>\n            </div>\n          </div>\n          <div class=\"form-wrapper\">\n            <h3 id=\"mice-form-contact-title\"> {{ 'mice-quotation-contact-title' | translate }}</h3>\n            <div class=\"form-group\">\n              <input \n                [ngClass]=\"{ 'ota-input-error' : quotationForm?.get('contactName')?.invalid && (quotationForm?.get('contactName')?.touched || isSubmitted) }\" id=\"mice-form-contactName\"\n              formControlName=\"contactName\" type=\"text\" value=\"\" placeholder=\"{{ 'mice-quotation-contact-name' | translate }}\" class=\"ota-input-text\" maxlength=\"100\">\n              <div id=\"mice-form-contactName-error\" *ngIf=\"quotationForm?.get('contactName')?.invalid && (quotationForm?.get('contactName')?.touched || isSubmitted)\">\n                <small class=\"text-error mb-0\"> {{ 'mice-quotation-warning-contact-name' | translate }} </small>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <input [ngClass]=\"{ 'ota-input-error' : quotationForm?.get('companyName')?.invalid && (quotationForm?.get('companyName')?.touched || isSubmitted) }\" id=\"mice-form-companyName\"\n              formControlName=\"companyName\" type=\"text\" value=\"\" placeholder=\"{{ 'mice-quotation-contact-company' | translate }}\" class=\"ota-input-text\">\n              <div id=\"mice-form-companyName-error\" *ngIf=\"quotationForm?.get('companyName')?.invalid && (quotationForm?.get('companyName')?.touched || isSubmitted)\">\n                <small class=\"text-error mb-0\"> {{ 'mice-quotation-warning-contact-company' | translate }} </small>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-sm-6\">\n                <div class=\"form-group\">\n                  <input id=\"mice-form-phone\" [ngClass]=\"{ 'ota-input-error' : quotationForm?.get('phone')?.invalid && (quotationForm?.get('phone')?.touched || isSubmitted) }\"\n                  formControlName=\"phone\" maxlength=\"10\" [textMask]=\"{ mask: maskPhoneNumber, guide: false }\" pattern=\"\\d*\" type=\"tel\" value=\"\" placeholder=\"{{ 'mice-quotation-contact-phone' | translate }}\" class=\"ota-input-text\">\n                  <div id=\"mice-form-phone-error\" *ngIf=\"quotationForm?.get('phone')?.errors?.required && (quotationForm?.get('phone')?.touched || isSubmitted)\">\n                    <small class=\"text-error mb-0\"> {{ 'mice-quotation-warning-contact-phone' | translate }} </small>\n                  </div>\n                  <div id=\"mice-form-phone-pattern-error\" *ngIf=\"quotationForm?.get('phone')?.errors?.minlength && (quotationForm?.get('phone')?.touched || isSubmitted)\">\n                    <small class=\"text-error mb-0\"> {{ 'mice-validation-pattern-contact-number' | translate }} </small>\n                  </div>\n                </div>\n              </div>\n              <div class=\"col-sm-6\">\n                <div class=\"form-group\">\n                  <input id=\"mice-form-contact-email\" [ngClass]=\"{ 'ota-input-error' : quotationForm?.get('email')?.invalid && (quotationForm?.get('email')?.touched || isSubmitted) }\"\n                  formControlName=\"email\" type=\"text\" value=\"\" placeholder=\"{{ 'mice-quotation-contact-email' | translate }}\" class=\"ota-input-text\">\n                  <div id=\"mice-form-contact-email-error\" *ngIf=\"quotationForm?.get('email')?.errors?.required && (quotationForm?.get('email')?.touched || isSubmitted)\">\n                    <small class=\"text-error mb-0\"> {{ 'mice-quotation-warning-contact-email' | translate }} </small>\n                  </div>\n                  <div id=\"mice-form-contact-email-pattern\" *ngIf=\"quotationForm?.get('email')?.errors?.pattern && (quotationForm?.get('email')?.touched || isSubmitted)\">\n                    <small class=\"text-error mb-0\"> {{ 'mice-validation-pattern-email' | translate }} </small>\n                  </div>\n                </div>\n              </div>\n            </div> \n          </div>\n          <button id=\"mice-form-submit\" class=\"ota-btn-main\" type=\"submit\">{{ 'mice-quotation-button-submit' | translate }}</button>\n        </form>\n      </div>\n    </div>\n  </div>\n</md-dialog-content>"

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog class=\"dialog-room-note-description\" [disbledClose]=\"true\" [closeBottom]=\"true\">\n  <div class=\"description\" [innerHtml]=\"data\"></div>\n</ota-dialog>"

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog class=\"dialog-room-note\">\n  <div class=\"title\">\n    {{ 'product-detail-room-note-title' | translate }}\n  </div>\n  <div class=\"item-wrapper\">\n    <div class=\"item\" *ngFor=\"let roomNote of data;\">\n      <i class=\"fa fa-circle\" aria-hidden=\"true\"></i>\n      <div class=\"content\">\n        <div class=\"name\">\n          {{ roomNote?.name }}\n        </div>\n        <div class=\"description\" [innerHtml]=\"roomNote?.description\">\n        </div>\n      </div>\n    </div>\n  </div>\n  \n</ota-dialog>\n"

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports = "<md-dialog-content class=\"dialog-see-all-properties-wrapper-tooltips\">\n  <div class=\"dialog-see-all-properties-wrapper\">\n    <div *ngIf=\"!isCustomText\" class=\"content\">\n      {{'search-box-over-budget-hover-info-label' | translate }}\n    </div>\n    <div *ngIf=\"isCustomText\" class=\"content\">\n       {{ text }}\n    </div>\n    <div class=\"footer-close-btn\" (click)=\"close()\">{{'dialog-close' | translate}}</div>\n  </div>\n</md-dialog-content>\n"

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [disbledClose]=\"true\" [disbledClickBackground]=\"false\">\n  <div class=\"box-detail\">\n    <div class=\"form-group\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <div class=\"title\">{{ 'search-box-tooltips-share-budget-detail-title' | translate }}</div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-xs-8\">\n          <div>{{ 'search-box-tooltips-share-budget-detail-booker-budget' | translate }}</div>\n        </div>\n        <div class=\"col-xs-4\">\n          <div>\n            {{ shareBudget?.booker?.amount ? 'THB ' + (shareBudget?.booker?.amount | number) : ('budget-unlimited' | translate) }}\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-xs-8\">\n          <div>{{ 'search-box-tooltips-share-budget-detail-co-booker-budget' | translate }}</div>\n          <span>\n            {{ shareBudget?.coBooker?.email }}\n          </span>\n        </div>\n        <div class=\"col-xs-4\">\n          {{ shareBudget?.coBooker?.amount ? 'THB ' + (shareBudget?.coBooker?.amount | number) : ('budget-unlimited' | translate) }}\n        </div>\n      </div>\n\n      <div class=\"row\" *ngIf=\"shareBudget?.applyCoBudget\">\n        <div class=\"col-xs-12 co-budget-note\">\n          **{{ 'search-box-tooltips-share-budget-detail-apply-co-budget' | translate }}\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"row-summary\">\n          <div class=\"col-xs-8\">\n            <div>{{ 'search-box-tooltips-share-budget-detail-total-budget' | translate }}</div>\n          </div>\n          <div class=\"col-xs-4\">\n            <b>{{ shareBudget?.totalBudget ? 'THB ' + (shareBudget?.totalBudget| number) : ('budget-unlimited' | translate) }}\n            </b>\n          </div>\n          <div class=\"clearfix\"></div>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div id=\"dialog-share-budget-detail-btn-close\" class=\"btn-close\">\n          <a (click)=\"onClose()\">\n            {{ 'my-profile-address-dialog-button-close' | translate }}\n          </a>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</ota-dialog>\n"

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog class=\"dialog-share-budget\" [disbledClose]=\"true\" [disbledClickBackground]=\"true\">\n  <div class=\"cal-height\">\n    <form [formGroup]=\"form\">\n      <div class=\"box-title\">\n        <div id=\"dialog-share-budget-title\" class=\"title\">\n          {{'dialog-share-budget-title' | translate}}\n        </div>\n      </div>\n      <div class=\"box-detail\">\n        <div id=\"dialog-share-budget-sub-title\" [innerHTML]=\"'dialog-share-budget-sub-title' | translate\">\n        </div>\n        <br *ngIf=\"getLang() === 'en'\">\n      </div>\n      <div class=\"form-group\">\n        <div class=\"row\">\n          <div class=\"box-code-ref col-xs-12\">\n            <div class=\"code-ref-title\" id=\"dialog-share-budget-code-ref-title\">\n              {{'dialog-share-budget-code-ref' | translate}}\n            </div>\n            <div id=\"dialog-share-budget-change-code-ref\" *ngIf=\"state !== STATE.VERIFY\" class=\"change-code-ref\"\n              (click)=\"onChangeCodeRef()\">\n              {{'dialog-share-budget-code-ref-change' | translate}}\n            </div>\n            <input id=\"dialog-share-budget-code-ref\" type=\"text\" formControlName=\"codeRef\"\n              class=\"form-control input-code-ref\" maxlength=\"6\"\n              [ngClass]=\"{'ota-input-error': ((form?.get('codeRef')?.invalid || form?.get('codeRef')?.hasError('pattern') ||form?.get('codeRef')?.hasError('incorrect') || form?.get('codeRef')?.hasError('expired') || form?.get('codeRef')?.hasError('yourself') || form?.get('codeRef')?.hasError('notAllowFeature') || form?.get('codeRef')?.hasError('minlength')) && isSubmitted) || form?.get('codeRef')?.hasError('pattern')}\">\n            <i class=\"icon-lock\"></i>\n            <div class=\"ota-text-error\"\n              *ngIf=\"((form?.get('codeRef')?.invalid || form?.get('codeRef')?.hasError('pattern') || form?.get('codeRef')?.hasError('incorrect') || form?.get('codeRef')?.hasError('expired') || form?.get('codeRef')?.hasError('yourself') || form?.get('codeRef')?.hasError('notAllowFeature') || form?.get('codeRef')?.hasError('minlength')) && isSubmitted ) || form?.get('codeRef')?.hasError('pattern')\">\n              <i class=\"icon-warning\"></i>\n              <ng-template [ngIf]=\"form?.get('codeRef')?.hasError('required')\">\n                <span id=\"dialog-share-budget-error-code-ref-required\">{{'dialog-share-budget-error-code-ref-require' |\n                  translate}}</span>\n              </ng-template>\n              <ng-template\n                [ngIf]=\"form?.get('codeRef')?.hasError('incorrect') || form?.get('codeRef')?.hasError('pattern') || form?.get('codeRef')?.hasError('minlength')\">\n                <span id=\"dialog-share-budget-error-code-ref-incorrect\">{{'dialog-share-budget-error-code-ref-incorrect'\n                  | translate}}</span>\n              </ng-template>\n              <ng-template [ngIf]=\"form?.get('codeRef')?.hasError('expired')\">\n                <span id=\"dialog-share-budget-error-code-ref-expired\">{{'dialog-share-budget-error-code-ref-expired'\n                  | translate}}</span>\n              </ng-template>\n              <ng-template [ngIf]=\"form?.get('codeRef')?.hasError('yourself')\">\n                <span id=\"dialog-share-budget-error-code-ref-yourself\">{{'dialog-share-budget-error-code-ref-yourself'\n                  | translate}}</span>\n              </ng-template>\n              <ng-template [ngIf]=\"form?.get('codeRef')?.hasError('notAllowFeature')\">\n                <span\n                  id=\"dialog-share-budget-error-code-ref-not-allow-feature\">{{'dialog-share-budget-error-code-ref-not-allow-feature'\n                  | translate}}</span>\n              </ng-template>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"sub-text\" [ngClass]=\"{'copied': copied}\">\n            <span>\n              {{ 'dialog-share-budget-gen-code-link' | translate }} {{link}}\n            </span>\n            <br class=\"show-sm\">\n            <ng-template [ngIf]=\"!copied\">\n              <div class=\"copy-link\" (click)=\"onCopyLink()\" ngxClipboard [cbContent]=\"link\">\n                <i class=\"icon-link\">\n                </i>\n                <span>\n                  {{ 'dialog-share-budget-copy-link' | translate }}\n                </span>\n              </div>\n            </ng-template>\n            <ng-template [ngIf]=\"copied\">\n              <i class=\"icon-check\">\n              </i>\n              <span class=\"copy-link-to-clipboard\">\n                {{ 'dialog-share-budget-copy-link-to-clipboard' | translate }}\n              </span>\n            </ng-template>\n          </div>\n        </div>\n      </div>\n\n      <div *ngIf=\"state === STATE.CO_BOOKER_COMPANY\">\n        <div class=\"form-group\">\n          <div class=\"row\">\n            <div class=\"box-co-booker-company col-xs-12 col-sm-6\">\n              <div id=\"dialog-share-budget-co-booker-name-title\">\n                {{'dialog-share-budget-co-booker-email' | translate}}\n              </div>\n              <input id=\"dialog-share-budget-co-booker-name\" type=\"text\" formControlName=\"coBookerEmail\"\n                class=\"form-control\" disabled>\n            </div>\n            <div class=\"box-co-booker-company col-xs-12 col-sm-6\">\n              <div id=\"dialog-share-budget-co-booker-company-name-title\">\n                {{'dialog-share-budget-co-booker-company' | translate}}\n              </div>\n              <input id=\"dialog-share-budget-co-booker-company-name\" type=\"text\" formControlName=\"companyName\"\n                class=\"form-control\" disabled>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div *ngIf=\"coBookerAddress\" class=\"form-group\">\n        <div class=\"row\">\n          <div class=\"box-co-booker-company-address col-xs-12\">\n            <div id=\"dialog-share-budget-summary-co-booker-company-address-title\">\n              {{'dialog-share-budget-co-booker-company-address' | translate}}\n            </div>\n            <div class=\"address\" id=\"dialog-share-budget-co-booker-company-tax-address\" [innerHTML]=\"coBookerAddress\">\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </div>\n  <div class=\"row row-action\">\n    <div class=\"action\">\n      <div id=\"dialog-share-budget-button-cancel\" class=\"ota-btn-sub btn-horizontal\" (click)=\"onClose()\">\n        <span id=\"dialog-share-budget-button-cance-text\">{{'btn-cancel' | translate}}</span>\n      </div>\n      <button id=\"dialog-share-budget-button-continue\" class=\"ota-btn-main btn-horizontal\"\n        [ngClass]=\"{'loading': isLoading}\" (click)=\"onContinue()\">{{ state === STATE.CO_BOOKER_COMPANY ?\n        ('dialog-share-budget-confirm-share-budget' | translate) : ('btn-continue' | translate)}}\n      </button>\n    </div>\n  </div>\n</ota-dialog>"

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog class=\"dialog-special-day\">\n  <div class=\"dialog-notify-content\">\n    <a href={{URI}} target=\"_blank\">\n      <img *ngIf=\"!isMobile\" class=\"alert-img\" src=\"{{ImageURI}}/act-special-day.jpg\" />\n      <img *ngIf=\"isMobile\" class=\"alert-img\" src=\"{{ImageURI}}/act-special-day-m.jpg\" />\n    </a>\n  </div>\n</ota-dialog>"

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog disbledClose=\"true\" class=\"dialog-alert\">\n\n  <!-- contnet -->\n  <div class=\"dialog-success-content\">\n    <div class=\"box-success\">\n      <span class=\"{{ icon }}\"></span>\n    </div>\n    <p class=\"font-16px color-main body-text\" [innerHtml]=\"text\"></p>\n    <div class=\"action-button\">\n      <button class=\"ota-btn-main\" md-dialog-close>{{'btn-ok' | translate}}</button>\n    </div>\n  </div>\n\n</ota-dialog>"

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [mobileFullscreen]=\"true\"\n  title=\"{{(address ? 'dialog-tax-address-title-edit-mode' : 'dialog-tax-address-title-add-mode') | translate}}\"\n  [disbledClickBackground]=\"true\">\n  <div class=\"dialog-container\">\n    <act-address-form [addressInfo]=\"addressInfo\" [isDisplayButton]=\"false\" #addressFormList [options]=\"options\"\n      [isActiveSelected]=\"true\" (onCancelAddressInfo)=\"handleUpdateAddressInfo($event)\"\n      (onUpdateAddressInfo)=\"handleUpdateAddressInfo($event)\">\n    </act-address-form>\n  </div>\n  <div class=\"action-button\">\n    <a class=\"hidden-xs\" id=\"{{pageElementName}}-a-cancel\" (click)=\"handleCancel()\">\n      {{ 'my-profile-address-form-btn-cancel' | translate }}\n    </a>\n\n    <button id=\"{{pageElementName}}-btn-cancel\" class=\"ota-btn-default btn-horizontal visible-xs-block\"\n      (click)=\"handleCancel()\">\n      {{ 'my-profile-address-form-btn-cancel' | translate }}\n    </button>\n    <button id=\"{{pageElementName}}-btn-submit\" class=\"ota-btn-main btn-horizontal\" tabindex=\"1\"\n      [ngClass]=\"{'loading': isLoading}\" (click)=\"onSubmit()\">\n      {{ 'my-profile-address-form-btn-submit' | translate }}\n    </button>\n  </div>\n\n</ota-dialog>"

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [disbledClose]=\"true\" [disbledClickBackground]=\"true\" class=\"dialog-terms-and-conditions\">\n  <div class=\"dwc-overflow\">\n    <div class=\"box\" id=\"dialog-terms-and-condition-title\">\n      <p class=\"color-main title-terms\">\n        <ng-container  *ngIf=\"consentType === consentTypeConst.TERMS\">\n          {{ 'pdpa-term-of-use' | translate }}\n        </ng-container>\n        <ng-container  *ngIf=\"consentType === consentTypeConst.PRIVACY\">\n          {{ 'pdpa-privacy-notice' | translate }}\n        </ng-container>\n        <ng-container *ngIf=\"consent\">\n          {{ 'pdpa-title' | translate }}\n        </ng-container>\n      </p>\n      <button *ngIf=\"consentType\" (click)=\"handleCloseDialog()\" class=\"icon-close2 button\"></button>\n    </div>\n    <div class=\"terms-and-conditions-privacy\" [ngClass]=\"{'un-full' : isShowSubmit, 'full': !isShowSubmit}\">\n      <ng-container *ngIf=\"consentType\">\n        <act-terms-and-conditions *ngIf=\"consentType === consentTypeConst.TERMS\" [isGetContentFromAPI]=\"true\"></act-terms-and-conditions>\n        <act-service-and-privacy *ngIf=\"consentType === consentTypeConst.PRIVACY\" [isGetContentFromAPI]=\"true\"></act-service-and-privacy>\n      </ng-container>\n      <ng-container *ngIf=\"consent\">\n        <act-terms-and-conditions *ngIf=\"consent?.terms\" [content]=\"consent?.terms\"></act-terms-and-conditions>\n        <act-service-and-privacy *ngIf=\"consent?.privacy\" [content]=\"consent?.privacy\"></act-service-and-privacy>\n      </ng-container>\n    </div>\n    <div *ngIf=\"isShowSubmit\" class=\"tac-footer\" id=\"dialog-terms-and-condition-footer\">\n        <div class=\"purposes\" *ngIf=\"consent?.purposes?.length > 0\">\n          <form [formGroup]=\"form\">\n            <label class=\"purpose\" formArrayName=\"purposes\" *ngFor=\"let purpose of purposesFormArray.controls; let i = index\">\n              <div class=\"checkbox-wrapper\">\n                <input type=\"checkbox\" [formControlName]=\"i\">\n              </div>\n              <div class=\"text\">{{ consent?.purposes[i]?.description }}</div>\n            </label>\n          </form>\n        </div>\n        <div class=\"button-wrapper\">\n          <button class=\"ota-btn-main tac-btn\" (click)=\"submit()\">{{'pdpa-btn-accept' | translate}}</button>\n        </div>\n    </div>\n  </div>\n</ota-dialog>"

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports = "<md-dialog-content class=\"{{class}}\"\n  [ngClass]=\"{ 'fullscreen': isFullscreen, 'lock-background': isDisbledBackground,'mobileFullscreen':isMobileFullscreen }\">\n  <button md-dialog-close class=\"dialog-btn-film\"></button>\n  <div class=\"dialog-container\" [ngClass]=\"{ 'unlock-background': isDisbledBackground }\">\n    <div class=\"dialog-wrapper-content\" [class.close-bt]=\"closeBottom\">\n\n      <div class=\"dialog-header\">\n        <div *ngIf=\"!isDisbledClose\" class=\"close-box\">\n          <a class=\"pull-right\">\n            <button *ngIf=\"!closeAction\" md-dialog-close class=\"icon-close2 button\"></button>\n            <button *ngIf=\"closeAction\" (click)=\"closeAction($event)\" class=\"icon-close2 button\"></button>\n          </a>\n        </div>\n\n        <!-- Dialog head -->\n        <div *ngIf=\"title\" class=\"pull-left\">\n          <div class=\"title\">\n            <span class=\"dialog-title\">{{title}}\n            </span>\n            <span *ngIf=\"rating && rating > 0\" class=\"dialog-rating\">\n              <i *ngFor=\"let rate of utilitiesService.indexToArray(rating)\" class=\"icon-star icon-star-level-s\"\n                [ngClass]=\"{'-half': rate===0.5}\"></i>\n            </span>\n          </div>\n          <div *ngIf=\"subTitle\" class=\"sub-title\">\n            <span>{{subTitle}}</span>\n          </div>\n          <div *ngIf=\"address\" class=\"dialog-address\">\n            <p>\n              <i aria-hidden=\"true\" class=\"icon-pinmap\"></i>\n              {{productService.formatDisplayTitle(address)}}\n            </p>\n          </div>\n        </div>\n      </div>\n\n\n      <!-- Content -->\n      <ng-content></ng-content>\n\n    </div>\n\n    <div *ngIf=\"closeBottom\" class=\"close-bottom\">\n      <div [ngSwitch]=\"closeType\">\n        <div *ngSwitchCase=\"'close-with-action'\" class=\"close-bottom-action\">\n          <div class=\"hide-sm\">\n            <div>\n              <a class=\"link-hover-style mt-7\" (click)=\"onClose()\" id=\"close-bottom-cancel\" style=\"float: left;\">\n                {{'dialog-cancel' | translate}}\n              </a>\n            </div>\n            <div>\n              <button (click)=\"onChoose()\" class=\"ota-btn-main mb-0\" id=\"close-bottom-choose\" style=\"float: right;\">\n                {{'dialog-confirm' | translate}}\n              </button>\n            </div>\n          </div>\n          <div class=\"show-sm\">\n            <button (click)=\"onClose()\" class=\"ota-btn-sub\" id=\"close-bottom-cancel\">\n              {{'dialog-cancel' | translate}}\n            </button>\n            <button (click)=\"onChoose()\" class=\"ota-btn-main\" id=\"close-bottom-choose\">\n              {{'dialog-confirm' | translate}}\n            </button>\n          </div>\n        </div>\n        <div *ngSwitchDefault>\n          <div (click)=\"onClose()\">\n            <a class=\"link-hover-style\">\n              {{'dialog-close' | translate}}\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</md-dialog-content>\n"

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

module.exports = "\n<div class=\"pagination-wrapper\" *ngIf=\"totalItem > itemPerPage\" [ngClass]=\"{'-ipad-mobile': isIpadMobile}\">\n  <div *ngIf=\"!detailless\">\n    <ul class=\"ota-pagination-lg -desktop\" *ngIf=\"totalPage < 10\">\n      <button\n        class=\"ctrl-page\"\n        [ngClass]=\"{'-disabled-button': isDiabledPrevBtn()}\"\n        [disabled] = \"isDiabledPrevBtn()\"\n        (click)=\"prevPage()\">\n        <a><i class=\"icon-arrow-left-round\">\n        </i> {{'booking-my-booking-previous' | translate}}</a>\n      </button>\n\n      <span\n        class=\"ota-pagination-lg\"\n        *ngFor=\"let item of utilitiesService.indexToArray(totalPage); let i = index\"\n        [ngClass]=\"{'-active': i+1 == currentPage}\"\n        (click)=\"setCurrentPage(i+1)\"\n      ><a>{{i+1}}</a>\n      </span>\n\n      <button\n        class=\"ctrl-page next-page\"\n        [ngClass]=\"{'-disabled-button': isDiabledNextBtn()}\"\n        [disabled]=\"isDiabledNextBtn()\"\n        (click)=\"nextPage()\">\n        <a>{{'booking-my-booking-next' | translate}} <i class=\"icon-arrow-right-round\"></i></a></button>\n    </ul>\n\n    <ul class=\"ota-pagination-lg -desktop\" *ngIf=\"!(totalPage < 10)\">\n      <button\n        class=\"ctrl-page\"\n        [ngClass]=\"{'-disabled-button': isDiabledPrevBtn()}\"\n        [disabled] = \"isDiabledPrevBtn()\"\n        (click)=\"prevPage()\">\n        <a><i class=\"icon-arrow-left-round\">\n        </i> {{'booking-my-booking-previous' | translate}}</a>\n      </button>\n\n        <li\n          class=\"ota-pagination-lg\"\n          [ngClass]=\"{'-active': 1 == currentPage}\"\n          (click)=\"setCurrentPage(1)\">\n          <a>1</a>\n        </li>\n        <li\n          *ngIf=\"isShowFirstNumberDot()\"\n          class=\"ota-pagination-lg\"\n          [ngClass]=\"{'-active': 2 == currentPage}\"\n          (click)=\"setCurrentPage(2)\">\n          <a>2</a>\n        </li>\n\n        <li\n        *ngIf=\"isShowFirstDot()\"\n        class=\"dott-style\">\n          <a>\n            <img src=\"assets/images/form/pagination-dot.svg\"/>\n          </a>\n        </li>\n\n\n        <span\n          class=\"ota-pagination-lg\"\n          *ngFor=\"let item of centerPaginations\"\n          [ngClass]=\"{'-active': item == currentPage}\"\n          (click)=\"setCurrentPage(item)\"\n        ><a>{{item}}</a>\n        </span>\n\n          <li\n          *ngIf=\"isShowLastDot()\"\n          class=\"dott-style\">\n            <a>\n              <img src=\"assets/images/form/pagination-dot.svg\"/>\n            </a>\n          </li>\n          <li\n            class=\"ota-pagination-lg\"\n            *ngIf=\"isShowLastNumberDot()\"\n            [ngClass]=\"{'-active': getLastPage()-1 == currentPage}\"\n            (click)=\"setCurrentPage(getLastPage()-1)\">\n            <a>{{getLastPage()-1}}</a>\n          </li>\n          <li\n            class=\"ota-pagination-lg\"\n            [ngClass]=\"{'-active': getLastPage() == currentPage}\"\n            (click)=\"setCurrentPage(getLastPage())\">\n            <a>{{getLastPage()}}</a>\n          </li>\n\n      <button\n        class=\"ctrl-page next-page\"\n        [ngClass]=\"{'-disabled-button': isDiabledNextBtn()}\"\n        [disabled]=\"isDiabledNextBtn()\"\n        (click)=\"nextPage()\">\n        <a>{{'booking-my-booking-next' | translate}} <i class=\"icon-arrow-right-round\"></i></a></button>\n    </ul>\n\n\n\n    <ul class=\"ota-pagination-lg -mobile\">\n      <button\n        class=\"ctrl-page prev-page\"\n        [ngClass]=\"{'-disabled-button': isDiabledPrevBtn()}\"\n        [disabled] = \"isDiabledPrevBtn()\"\n        (click)=\"prevPage()\">\n        <a><i class=\"icon-arrow-left-round\">\n        </i> {{'booking-my-booking-previous' | translate}}</a>\n      </button>\n\n        <li class=\"pagination-text-page-number\">{{currentPage}} of {{getLastPage()}}</li>\n\n      <button\n        class=\"ctrl-page next-page\"\n        [ngClass]=\"{'-disabled-button': isDiabledNextBtn()}\"\n        [disabled]=\"isDiabledNextBtn()\"\n        (click)=\"nextPage()\">\n        <a>{{'booking-my-booking-next' | translate}} <i class=\"icon-arrow-right-round\"></i></a></button>\n    </ul>\n  </div>\n\n  <div *ngIf=\"detailless\" class=\"w-100\">\n    <ul class=\"ota-pagination-lg detailless\">\n      <button\n        class=\"ctrl-page prev-page\"\n        [ngClass]=\"{'-disabled-button': isDiabledPrevBtn()}\"\n        [disabled] = \"isDiabledPrevBtn()\"\n        (click)=\"prevPage()\">\n        <a><i class=\"icon-arrow-left-round\">\n        </i> {{'booking-my-booking-previous' | translate}}</a>\n      </button>\n\n      <button\n        class=\"ctrl-page next-page\"\n        [ngClass]=\"{'-disabled-button': isDiabledNextBtn()}\"\n        [disabled]=\"isDiabledNextBtn()\"\n        (click)=\"nextPage()\">\n        <a>{{'booking-my-booking-next' | translate}} <i class=\"icon-arrow-right-round\"></i></a></button>\n    </ul>\n  </div>\n</div>\n"

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports = "<div #selectBox class=\"dropdown-ota-style\" [mdMenuTriggerFor]=\"payment\" id=\"{{setElementIdPage}}-select-box\"\n  (onMenuOpen)=\"onOpenMenu()\" (onMenuClose)=\"onCloseMenu()\" [ngClass]=\"{'open': isOpenMenu, 'placeHolder': !currentOption, 'disabled': optionList.length <= 1, 'error': error}\">\n  <span *ngIf=\"!currentOption\">\n    {{placeHolder}}\n  </span>\n  <div *ngIf=\"currentOption\">\n    <ng-container *ngIf=\"currentOption?.value === paymentChannelType.TRUE_MONEY else defaultPaymentChannel\">\n      <img class=\"icon img-true-money top-10\"\n        src=\"/assets/images/logo/TrueWallet.png\">\n    </ng-container>\n    <ng-template #defaultPaymentChannel>\n      <i class=\"icon {{currentOption?.icon}}\"></i>\n    </ng-template>  \n    <span>{{currentOption?.display | translate}}</span>\n  </div>\n</div>\n<md-menu class=\"dropdown-sub-menu -fluid-width\" #payment=\"mdMenu\" xPosition=\"after\">\n  <div class=\"scorllable-box\" [ngStyle]=\"isMobile && {'width': selectBoxWidth}\">\n    <li *ngFor=\"let item of optionList; let i = index\">\n      <div class=\"item\" (click)=\"onSelect(item)\" id=\"{{setElementIdPage}}-item-{{i}}\">\n        <ng-container *ngIf=\"item?.value === paymentChannelType.TRUE_MONEY else defaultPaymentChannel\">\n          <img class=\"icon img-true-money\"\n            src=\"/assets/images/logo/TrueWallet.png\">\n        </ng-container>\n        <ng-template #defaultPaymentChannel>\n          <i class=\"icon {{item?.icon}}\"></i>\n        </ng-template>\n        <div class=\"display\" id=\"{{setElementIdPage}}-{{item?.value}}\">\n          {{item?.display | translate}}\n        </div>\n      </div>\n    </li>\n  </div>\n</md-menu>"

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"paymentChannel\" class=\"payment-method-container\">\n  <section class=\"payment-method-section\">\n    <div *ngIf=\"displayCancelButton\" class=\"cancel-btn\" (click)=\"onClickCancel()\" id=\"{{prefixElementId}}-payment-method-detail-cancel-btn\">\n      <a>{{ 'booking-my-booking-cancel' | translate }}</a>\n    </div>\n    <div class=\"inline\">\n      <div id=\"{{prefixElementId}}-payment-method-title\" class=\"payment-method-title\" [ngClass]=\"{'w-25': !displayCancelButton}\">{{'payment-method-detail-payment-title' | translate}}</div>\n      <div id=\"{{prefixElementId}}-payment-method-detail\" class=\"payment-method-detail\">\n        <ng-container *ngIf=\"bookingStatus !== BookingStatusType.ON_PROCESS; else onProcessTitleTemplate\">\n          <div [ngSwitch]=\"paymentChannel\">\n            <ng-template [ngSwitchCase]=\"PaymentChannelType.MULTI_PAYMENT\">\n              <span id=\"{{prefixElementId}}-payment-method-type\" class=\"multi-payment\">Multi-payment</span>\n              <div id=\"{{prefixElementId}}-payment-method-type-sub\" class=\"multi-payment-title\">{{ paymentMethodDisplay }}</div>\n            </ng-template>\n            <ng-template ngSwitchDefault>\n              <span id=\"{{prefixElementId}}-payment-method-type\">{{ paymentMethodDisplay }}</span>\n            </ng-template>\n          </div>\n        </ng-container>\n        <ng-template #onProcessTitleTemplate>\n          {{ '-' }}\n        </ng-template>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"payment-date-section\" *ngIf=\"!hidePaymentDateSection\">\n    <div id=\"{{prefixElementId}}-payment-date-title\" class=\"payment-date-title\">{{ 'payment-method-detail-payment-date' | translate }}</div>\n    <div class=\"payment-date-detail\">\n\n      <ng-container *ngIf=\"bookingStatus !== BookingStatusType.ON_PROCESS; else onProcessDateTemplate\">\n        <!-- MAIN PAYMENT -->\n        <div *ngIf=\"paymentMethodDetail?.mainPaymentMethod\" class=\"payment-detail-block\">\n          <div class=\"payment-title\" *ngIf=\"paymentChannel === PaymentChannelType.MULTI_PAYMENT\" id=\"{{prefixElementId}}-payment-date-main-title\">\n            {{ paymentMethodDetail?.mainPaymentMethodDisplay }}\n          </div>\n\n          <!-- normal booking -->\n          <ng-container *ngIf=\"!isCancelled; else cancelMainPayment\">\n            <div [ngSwitch]=\"paymentMethodDetail?.mainPaymentMethod\">\n              <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.CREDIT_TERMS\">\n                <ng-container *ngTemplateOutlet=\"paymentMethodDetail?.mainPaymentMethodStatus === PaymentStatus.SUCCESS ? payCreditTerm : incompleteCreditTerm; context: {$implicit: 'main-payment'}\"></ng-container>\n              </ng-template>\n              <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.CREDIT_CARD\">\n                <ng-container *ngTemplateOutlet=\"paymentMethodDetail?.mainPaymentMethodStatus === PaymentStatus.SUCCESS ? successAndPayOnDate : null; context: {$implicit: 'main-payment'}\"></ng-container>\n                <ng-container *ngTemplateOutlet=\"paymentMethodDetail?.mainPaymentMethodStatus === PaymentStatus.AUTHORIZE ? paylaterCreditCard : null; context: {$implicit: 'main-payment'}\"></ng-container>\n                <ng-container *ngTemplateOutlet=\"\n                  paymentMethodDetail?.mainPaymentMethodStatus !== PaymentStatus.SUCCESS &&\n                  paymentMethodDetail?.mainPaymentMethodStatus !== PaymentStatus.AUTHORIZE ? incompleteCreditCard : null; context: {$implicit: 'main-payment'}\">\n                </ng-container>\n              </ng-template>\n              <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.TRUE_MONEY\">\n                <ng-container *ngTemplateOutlet=\"paymentMethodDetail?.mainPaymentMethodStatus === PaymentStatus.SUCCESS ? successAndPayOnDate : incompleteTruemoney; context: {$implicit: 'main-payment'}\"></ng-container>\n              </ng-template>\n              <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.CORPORATE_FLEET\">\n                <ng-container *ngTemplateOutlet=\"paymentMethodDetail?.mainPaymentMethodStatus === PaymentStatus.SUCCESS ? successAndPayOnDate : incompleteFleet; context: {$implicit: 'main-payment'}\"></ng-container>\n              </ng-template>\n              <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.PERSONAL_FLEET\">\n                <ng-container *ngTemplateOutlet=\"paymentMethodDetail?.mainPaymentMethodStatus === PaymentStatus.SUCCESS ? successAndPayOnDate : incompleteFleet; context: {$implicit: 'main-payment'}\"></ng-container>\n              </ng-template>\n              <ng-template ngSwitchDefault>\n                <ng-container *ngTemplateOutlet=\"paymentMethodDetail?.mainPaymentMethodStatus === PaymentStatus.SUCCESS ? successAndPayOnDate : incompletePayment; context: {$implicit: 'main-payment'}\"></ng-container>\n              </ng-template>\n            </div>\n          </ng-container>\n\n          <!-- cancel booking -->\n          <ng-template #cancelMainPayment>\n            <ng-container *ngIf=\"paymentMethodDetail?.mainPaymentMethod === PaymentMethodDetailType.CREDIT_TERMS\">\n              <ng-container *ngTemplateOutlet=\"refundType === RefundType.FULL_REFUND ? incompleteCreditTerm : payCreditTerm; context: {$implicit: 'main-payment'}\"></ng-container>\n            </ng-container>\n            <ng-container *ngIf=\"paymentMethodDetail?.mainPaymentMethod === PaymentMethodDetailType.CREDIT_CARD\">\n              <ng-container *ngTemplateOutlet=\"refundType === RefundType.FULL_REFUND && isCancelBeforePayCreditCard ? incompleteCreditCard : payOnDateText; context: {$implicit: 'main-payment'}\"></ng-container>\n            </ng-container>\n            <ng-container *ngIf=\"paymentMethodDetail?.mainPaymentMethod !== PaymentMethodDetailType.CREDIT_TERMS && paymentMethodDetail?.mainPaymentMethod !== PaymentMethodDetailType.CREDIT_CARD\">\n              <ng-container *ngTemplateOutlet=\"payOnDateText; context: {$implicit: 'main-payment'}\"></ng-container>\n            </ng-container>\n          </ng-template>\n        </div>\n\n        <!-- ANOTHER PAYMENT -->\n        <div *ngIf=\"paymentMethodDetail.anotherPaymentMethod && paymentChannel === PaymentChannelType.MULTI_PAYMENT\" class=\"payment-detail-block\">\n          <div class=\"payment-title\" id=\"{{prefixElementId}}-payment-date-another-title\">\n            {{ paymentMethodDetail.anotherPaymentMethodDisplay }}\n          </div>\n\n          <!-- normal booking -->\n          <ng-container *ngIf=\"!isCancelled; else cancelAnotherPayment\">\n            <ng-container *ngIf=\"paymentMethodDetail?.anotherPaymentMethod === PaymentMethodDetailType.CREDIT_TERMS\">\n              <ng-container *ngTemplateOutlet=\"paymentMethodDetail?.anotherPaymentMethodStatus === PaymentStatus.SUCCESS ? payCreditTerm : incompleteCreditTerm; context: {$implicit: 'another-payment'}\"></ng-container>\n            </ng-container>\n            <ng-container *ngIf=\"paymentMethodDetail?.anotherPaymentMethod === PaymentMethodDetailType.CREDIT_CARD\">\n              <ng-container *ngTemplateOutlet=\"paymentMethodDetail?.anotherPaymentMethodStatus === PaymentStatus.SUCCESS ? successAndPayOnDate : null; context: {$implicit: 'another-payment'}\"></ng-container>\n              <ng-container *ngTemplateOutlet=\"paymentMethodDetail?.anotherPaymentMethodStatus === PaymentStatus.AUTHORIZE ? paylaterCreditCard : null; context: {$implicit: 'another-payment'}\"></ng-container>\n              <ng-container *ngTemplateOutlet=\"\n                paymentMethodDetail?.anotherPaymentMethodStatus !== PaymentStatus.SUCCESS &&\n                paymentMethodDetail?.anotherPaymentMethodStatus !== PaymentStatus.AUTHORIZE ? incompleteCreditCard : null; context: {$implicit: 'another-payment'}\"></ng-container>\n            </ng-container>\n            <ng-container *ngIf=\"paymentMethodDetail?.anotherPaymentMethod === PaymentMethodDetailType.TRUE_MONEY\">\n              <ng-container *ngTemplateOutlet=\"paymentMethodDetail?.anotherPaymentMethodStatus === PaymentStatus.SUCCESS ? successAndPayOnDate : incompleteTruemoney; context: {$implicit: 'another-payment'}\"></ng-container>\n            </ng-container>\n            <ng-container *ngIf=\"paymentMethodDetail?.anotherPaymentMethod === PaymentMethodDetailType.CORPORATE_FLEET || paymentMethodDetail?.anotherPaymentMethod === PaymentMethodDetailType.PERSONAL_FLEET\">\n              <ng-container *ngTemplateOutlet=\"paymentMethodDetail?.anotherPaymentMethodStatus === PaymentStatus.SUCCESS ? successAndPayOnDate : incompleteFleet; context: {$implicit: 'another-payment'}\"></ng-container>\n            </ng-container>\n          </ng-container>\n\n          <!-- cancel booking -->\n          <ng-template #cancelAnotherPayment>\n            <ng-container *ngIf=\"paymentMethodDetail?.anotherPaymentMethod === PaymentMethodDetailType.CREDIT_TERMS\">\n              <ng-container *ngTemplateOutlet=\"refundType === RefundType.FULL_REFUND ? incompleteCreditTerm : payCreditTerm; context: {$implicit: 'another-payment'}\"></ng-container>\n            </ng-container>\n            <ng-container *ngIf=\"paymentMethodDetail?.anotherPaymentMethod === PaymentMethodDetailType.CREDIT_CARD\">\n              <ng-container *ngTemplateOutlet=\"refundType === RefundType.FULL_REFUND && isCancelBeforePayCreditCard ? incompleteCreditCard : payOnDateText; context: {$implicit: 'another-payment'}\"></ng-container>\n            </ng-container>\n            <ng-container *ngIf=\"paymentMethodDetail?.anotherPaymentMethod !== PaymentMethodDetailType.CREDIT_TERMS && paymentMethodDetail?.anotherPaymentMethod !== PaymentMethodDetailType.CREDIT_CARD\">\n              <ng-container *ngTemplateOutlet=\"payOnDateText; context: {$implicit: 'another-payment'}\"></ng-container>\n            </ng-container>\n          </ng-template>\n        </div>\n      </ng-container>\n      <ng-template #onProcessDateTemplate>\n        {{ '-' }}\n      </ng-template>\n\n      <!-- TEMPLATE START -->\n      <ng-template #payCreditTerm let-payment>\n        <span id=\"{{prefixElementId}}-payment-text-{{payment}}\">\n          {{ 'payment-method-detail-payment-date-credit-terms' | translate }}\n        </span>\n      </ng-template>\n      <ng-template #successAndPayOnDate let-payment>\n        <div class=\"payment-success\">\n          <i class=\"icon-success\"></i>\n          <span class=\"status\" id=\"{{prefixElementId}}-payment-text-{{payment}}\">{{ 'booking-my-status-successfully-payment' | translate }}</span>\n          <span id=\"{{prefixElementId}}-payment-text-pay-on-date-{{payment}}\">{{ payOnDate }}</span>\n        </div>\n      </ng-template>\n      <ng-template #paylaterCreditCard let-payment>\n        <div>\n          <span id=\"{{prefixElementId}}-payment-text-{{payment}}\">{{ 'payment-method-detail-payment-date-credit-card' | translate }}</span>\n          <span id=\"{{prefixElementId}}-payment-text-pay-on-date-{{payment}}\">{{ payOnDate }}</span>\n        </div>\n      </ng-template>\n      <ng-template #incompleteCreditTerm let-payment>\n        <span id=\"{{prefixElementId}}-payment-text-{{payment}}\">{{ 'payment-method-detail-payment-date-credit-terms-no-charge' | translate }}</span>\n      </ng-template>\n      <ng-template #incompleteCreditCard let-payment>\n        <span id=\"{{prefixElementId}}-payment-text-{{payment}}\">{{ 'payment-method-detail-payment-date-credit-card-no-charge' | translate }}</span>\n      </ng-template>\n      <ng-template #incompleteTruemoney let-payment>\n        <span id=\"{{prefixElementId}}-payment-text-{{payment}}\">{{ 'payment-method-detail-payment-date-true-money-no-charge' | translate }}</span>\n      </ng-template>\n      <ng-template #incompleteFleet let-payment>\n        <span id=\"{{prefixElementId}}-payment-text-{{payment}}\">{{ 'payment-method-detail-payment-date-fleet-no-charge' | translate }}</span>\n      </ng-template>\n      <ng-template #incompletePayment let-payment>\n        <span id=\"{{prefixElementId}}-payment-text-{{payment}}\">{{ 'payment-method-detail-payment-date-payment-no-charge' | translate }}</span>\n      </ng-template>\n      <ng-template #payOnDateText let-payment>\n        <div class=\"payment-success\">\n          <span id=\"{{prefixElementId}}-payment-text-pay-on-date-{{payment}}\">{{ payOnDate }}</span>\n        </div>\n      </ng-template>\n      <!-- TEMPLATE END -->\n    </div>\n  </section>\n\n  <section *ngIf=\"cancellationPolicy\" class=\"refund-policy-section\" [ngClass]=\"{'border-none': hidePaymentDateSection}\">\n    <div id=\"{{prefixElementId}}-refund-policy-title\" class=\"refund-policy-title\">\n      {{ 'payment-method-detail-payment-date-refund-policy' | translate }}\n    </div>\n    <div class=\"refund-policy-detail\">\n      <div class=\"payment-detail-block\">\n        <div class=\"payment-title\" *ngIf=\"cancellationPolicyTitle\" id=\"{{prefixElementId}}-refund-policy-main-title\">{{ cancellationPolicyTitle | translate }}</div>\n        <div *ngIf=\"cancellationPolicy\" id=\"{{prefixElementId}}-refund-policy-main-content\" [innerHTML]=\"( cancellationPolicy | translate )\"></div>\n      </div>\n      <div class=\"payment-detail-block\"  *ngIf=\"anotherCancellationPolicy\">\n        <div class=\"payment-title\" *ngIf=\"anotherCancellationPolicyTitle\" id=\"{{prefixElementId}}-refund-policy-another-title\">{{ anotherCancellationPolicyTitle | translate }}</div>\n        <div *ngIf=\"anotherCancellationPolicy\" id=\"{{prefixElementId}}-refund-policy-another-content\">{{ anotherCancellationPolicy | translate }}</div>\n      </div>\n    </div>\n  </section>\n</div>\n"

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"payment-type-select-warp row\">\n  <div *ngIf=\"!isMobile || (isMobile && !collapse); then default else mobile\"></div>\n  <ng-template #default>\n    <ng-container *ngFor=\"let payableMethodItem of paymentable?.paymentChannels; let i = index\">\n      <ng-container *ngIf=\"!collapse || i < 8\">\n        <li class=\"payment-type-select-item col-xs-12 col-sm-3\">\n          <label id=\"{{name}}-rdo-{{payableMethodItem?.paymentChannelName}}\"\n            (click)=\"onSelectPaymentChannel(payableMethodItem)\" class=\"radio-button\"\n            [ngClass]=\"{'active' : payableMethodItem === paymentChannelSelected}\">\n            <ng-container [ngSwitch]=\"payableMethodItem?.paymentChannelName\">\n              <img *ngSwitchCase=\"paymentChannelType.TRUE_MONEY\" class=\"payment-icon img-true-money\"src=\"/assets/images/logo/TrueWallet.png\">\n              <img *ngSwitchCase=\"paymentChannelType.E_WALLET\" class=\"payment-icon img-e-wallet\"src=\"/assets/images/logo/aliwechatpay.png\">\n              <i *ngSwitchDefault class=\"payment-icon\" [ngClass]=\"[payableMethodItem.icon]\"></i>\n            </ng-container>\n            <div class=\"payment-title\">\n              <span class=\"title\"\n                id=\"{{name}}-{{payableMethodItem?.paymentChannelName}}-title\">{{payableMethodItem.title |\n                translate}}</span>\n              <span class=\"sub-title\"\n                id=\"{{name}}-{{payableMethodItem?.paymentChannelName}}-sub-title\">{{payableMethodItem.subTitle\n                | translate}}</span>\n            </div>\n            <i id=\"{{name}}-icon-{{payableMethodItem?.paymentChannelName}}\"\n              *ngIf=\"payableMethodItem === paymentChannelSelected\"\n              class=\"img-step icon-circle-user icon-circle-check icon-selected\"></i>\n          </label>\n        </li>\n      </ng-container>\n    </ng-container>\n  </ng-template>\n  <ng-template #mobile>\n    <li class=\"payment-type-select-item col-xs-12 selected\">\n      <label id=\"{{name}}-rdo-{{paymentChannelSelected?.paymentChannelName}}\" class=\"radio-button active\">\n        <ng-container [ngSwitch]=\"paymentChannelSelected?.paymentChannelName\">\n          <img *ngSwitchCase=\"paymentChannelType.TRUE_MONEY\" class=\"payment-icon img-true-money\"src=\"/assets/images/logo/TrueWallet.png\">\n          <img *ngSwitchCase=\"paymentChannelType.E_WALLET\" class=\"payment-icon img-e-wallet\"src=\"/assets/images/logo/aliwechatpay.png\">\n          <i *ngSwitchDefault class=\"payment-icon\" [ngClass]=\"[paymentChannelSelected.icon]\"></i>\n        </ng-container>\n        <div class=\"payment-title\">\n          <span class=\"title\"\n            id=\"{{name}}-{{paymentChannelSelected?.paymentChannelName}}-title\">{{paymentChannelSelected.title |\n            translate}}</span>\n          <span class=\"sub-title\"\n            id=\"{{name}}-{{paymentChannelSelected?.paymentChannelName}}-sub-title\">{{paymentChannelSelected.subTitle\n            | translate}}</span>\n        </div>\n        <i id=\"{{name}}-icon-{{paymentChannelSelected?.paymentChannelName}}\"\n          class=\"img-step icon-circle-user icon-circle-check icon-selected\"></i>\n      </label>\n    </li>\n  </ng-template>\n</ul>\n<div *ngIf=\"paymentable?.paymentChannels.length > 8 || isMobile\" class=\"btn-collapse\" (click)=\"collapse = !collapse\">\n  <div *ngIf=\"collapse; else show\">\n    <span>{{'payment-method-expanse' | translate}}</span>\n    <i class=\"icon-arrow-right-round\"></i>\n  </div>\n  <ng-template #show>\n    <i class=\"icon-arrow-show-less-round\"></i>\n    <span>{{'payment-method-collapse' | translate}}</span>\n  </ng-template>\n</div>"

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

module.exports = "<div class=\"payment-summary-container\">\n  <div [ngSwitch]=\"condition\">\n\n    <ng-template [ngSwitchCase]=\"Condition.BOOKING_SINGLE_PAYMENT\">\n      <div class=\"booking-single-payment {{ surchargeList.length !== 0 ? 'break-section' : '' }}\">\n        <ng-container *ngIf=\"mainPaymentMethod === PaymentMethodDetailType.CREDIT_TERMS; else singlePaymentNonCreditTerm\">\n          <ng-container *ngIf=\"isShareBudget; else nonShareBudgetTemplate\">\n            <ng-container *ngTemplateOutlet=\"paymentVatSection\"></ng-container>\n            <ng-container *ngTemplateOutlet=\"paymentTotalSection\"></ng-container>\n            <ng-container *ngTemplateOutlet=\"shareBudgetSinglePaymentSection\"></ng-container>\n          </ng-container>\n          <ng-template #nonShareBudgetTemplate>\n            <ng-container *ngTemplateOutlet=\"paymentVatSection\"></ng-container>\n            <ng-container *ngTemplateOutlet=\"paymentTotalSection\"></ng-container>\n          </ng-template>\n        </ng-container>\n        <ng-template #singlePaymentNonCreditTerm>\n          <ng-container *ngTemplateOutlet=\"paymentVatSection\"></ng-container>\n          <ng-container *ngTemplateOutlet=\"paymentTotalSection\"></ng-container>\n        </ng-template>\n        <ng-template #shareBudgetSinglePaymentSection>\n          <div class=\"share-budget-single-payment-thankyou\">\n            <div class=\"main-payment\" id=\"{{prefixElementId}}-payment-summary-total-main-payment-label\">{{ 'payment-summary-pay-credit-term' | translate  }}</div>\n            <ng-container *ngTemplateOutlet=\"shareBudgetThankyou\"></ng-container>\n          </div>\n          <div class=\"share-budget-single-payment\">\n            <div class=\"bold\">{{'cart-seperate-payment-credit-terms' | translate }}</div>\n            <div class=\"row-text font-title\" id=\"{{prefixElementId}}-payment-summary-total-main-payment-label\">{{ 'payment-summary-pay-credit-term' | translate  }}</div>\n            <ng-container *ngTemplateOutlet=\"shareBudget\"></ng-container>\n          </div>\n        </ng-template>\n      </div>\n      <ng-container *ngTemplateOutlet=\"priceInformationSection\"></ng-container>\n    </ng-template>\n\n    <ng-template [ngSwitchCase]=\"Condition.CANCEL_SINGLE_PAYMENT\">\n      <div class=\"booking-cancel-payment\">\n        <div class=\"total-title\">\n          <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-book-total-label\"><strong>{{ 'payment-summary-cancel-total-price' | translate  }}</strong></div>\n          <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-book-total-value\">\n            {{ bookingPayment?.currencyCode }}\n            <strong>{{ bookingPayment?.totalPrice | number:'.2' }}</strong>\n          </div>\n        </div>\n        <div class=\"cancel-title\">\n          <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-total-cancellation-fee-label\"><strong>{{ 'payment-summary-cancel-total-cancellation-fee' | translate  }}</strong></div>\n          <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-total-cancellation-fee-value\">\n            {{ bookingPayment?.currencyCode }}\n            <strong>{{ bookingCancellationCharge?.cancellationFee | number:'.2' }}</strong>\n          </div>\n        </div>\n        <!-- credit term (share budget) non refund and partial -->\n        <ng-container *ngIf=\"isShareBudget && bookingCancellationCharge.cancellationFee >= 0\">\n          <div class=\"cancel-detail-section\">\n            <div class=\"font-title\" id=\"{{prefixElementId}}-payment-summary-cancel-total-cancellation-label\">{{ 'payment-summary-pay-credit-term' | translate }}</div>\n            <ul class=\"booker-payment\">\n              <li *ngFor=\"let bookerPayment of bookerPayments; let i = index\">\n                <span>{{ (i == 0 ? 'payment-summary-booker' : 'payment-summary-co-booker') | translate }}</span>\n                <span id=\"{{prefixElementId}}-payment-summary-total-main-payment-value-{{i}}\" class=\"fr\">{{ bookerPayment?.paymentInformation?.currencyCode }} {{ bookerPayment?.cancellationCharge?.cancellationFee | number:'.2' }}</span>\n              </li>\n            </ul>\n          </div>\n        </ng-container>\n      </div>\n    </ng-template>\n\n    <ng-template [ngSwitchCase]=\"Condition.CANCEL_SINGLE_PAYMENT_NON_CREDIT_TERM\">\n      <div class=\"booking-cancel-payment\">\n        <div class=\"total-title\">\n          <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-book-total-label\"><strong>{{ 'payment-summary-cancel-total-price' | translate  }}</strong></div>\n          <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-book-total-value\">\n            {{ bookingPayment?.currencyCode }}\n            <strong>{{ bookingPayment?.totalPrice | number:'.2' }}</strong>\n          </div>\n        </div>\n        <!-- cancel fee -->\n        <div class=\"row-text font-title border-bottom\">\n          <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-total-cancel-label\"><strong>{{ 'payment-summary-cancel-total-cancellation-fee' | translate  }}</strong></div>\n          <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-total-cancel-value\">\n            {{ bookingPayment?.currencyCode }}\n            <strong>{{ bookingCancellationCharge?.cancellationFee | number:'.2' }}</strong>\n          </div>\n        </div>\n        <div class=\"grand-total font-grand-total\">\n          <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-refund-label\">{{ 'payment-summary-refund' | translate  }}</div>\n          <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-refund-value\">\n            {{ bookingPayment?.currencyCode }}\n            <strong>{{ mainPayment?.cancellationCharge?.refundAmount | number:'.2' }}</strong>\n          </div>\n        </div>\n      </div>\n    </ng-template>\n\n    <ng-template [ngSwitchCase]=\"Condition.BOOKING_MULTI_PAYMENT\">\n      <div class=\"booking-multi-payment {{ surchargeList.length !== 0 ? 'break-section' : '' }}\">\n        <ng-container *ngTemplateOutlet=\"paymentVatSection\"></ng-container>\n        <ng-container *ngTemplateOutlet=\"paymentTotalSection\"></ng-container>\n        <ng-container *ngTemplateOutlet=\"multiPaymentSection\"></ng-container>\n        <ng-template #multiPaymentSection>\n          <div class=\"multi-payment-thankyou\">\n            <div class=\"row-text {{isShareBudget ? '' : 'border-bottom'}}\" id=\"{{prefixElementId}}-payment-summary-total-main-payment-label\">\n              <span class=\"label-text bold\">\n                {{ mainPaymentMethodDisplay | translate }}\n              </span>\n              <span *ngIf=\"!isShareBudget\" class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-total-main-payment-value\">\n                {{ mainPayment?.paymentInformation?.currencyCode }}\n                <strong>{{ mainPayment?.paymentInformation?.totalPrice | number:'.2' }}</strong>\n              </span>\n            </div>\n            <ng-container *ngIf=\"isShareBudget\">\n              <ng-container *ngTemplateOutlet=\"shareBudgetThankyou\"></ng-container>\n            </ng-container>\n            <div class=\"row-text border-bottom\" id=\"{{prefixElementId}}-payment-summary-total-another-payment-label\">\n              <span class=\"label-text\">\n                <i class=\"icon-add-card credit-card-icon\"></i>\n                <span class=\"ft-c-blue bold\">\n                  {{ anotherPaymentMethodDisplay | translate }}\n                </span>\n              </span>\n              <span class=\"value-text ft-c-blue\" id=\"{{prefixElementId}}-payment-summary-total-another-payment-value\">\n                {{ anotherPayment?.paymentInformation?.currencyCode }}\n                <strong>{{ anotherPayment?.paymentInformation?.totalPrice | number:'.2' }}</strong>\n              </span>\n            </div>\n          </div>\n          <div class=\"multi-payment\">\n            <div class=\"bold\">{{ (isShareBudget ? 'cart-seperate-payment-credit-terms' : 'cart-seperate-payment') | translate }}</div>\n            <div class=\"row-text {{ isShareBudget ? '' : 'border-bottom' }}\" id=\"{{prefixElementId}}-payment-summary-total-main-payment-label\">\n              <span class=\"label-text\">\n                {{ mainPaymentMethodDisplay | translate }}\n              </span>\n              <span *ngIf=\"!isShareBudget\" class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-total-main-payment-value\">\n                {{ mainPayment?.paymentInformation?.currencyCode }}\n                <strong>{{ mainPayment?.paymentInformation?.totalPrice | number:'.2' }}</strong>\n              </span>\n            </div>\n            <ng-container *ngIf=\"isShareBudget\">\n              <ng-container *ngTemplateOutlet=\"shareBudget\"></ng-container>\n            </ng-container>\n            <div class=\"row-text border-bottom\" id=\"{{prefixElementId}}-payment-summary-total-another-payment-label\">\n              <span class=\"label-text\">\n                <i class=\"icon-add-card credit-card-icon\"></i>\n                <span class=\"ft-c-blue\">\n                  {{ anotherPaymentMethodDisplay | translate }}\n                </span>\n              </span>\n              <span class=\"value-text ft-c-blue\" id=\"{{prefixElementId}}-payment-summary-total-another-payment-value\">\n                {{ anotherPayment?.paymentInformation?.currencyCode }}\n                <strong>{{ anotherPayment?.paymentInformation?.totalPrice | number:'.2' }}</strong>\n              </span>\n            </div>\n          </div>\n        </ng-template>\n      </div>\n      <ng-container *ngTemplateOutlet=\"priceInformationSection\"></ng-container>\n    </ng-template>\n\n    <ng-template [ngSwitchCase]=\"Condition.CANCEL_MULTI_PAYMENT\">\n      <div class=\"booking-cancel-payment\">\n        <!-- payment summary section -->\n        <div class=\"total-title\">\n          <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-book-total-label\"><strong>{{ 'payment-summary-cancel-total-price' | translate  }}</strong></div>\n          <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-book-total-value\">\n            {{ bookingPayment?.currencyCode }}\n            <strong>{{ bookingPayment?.totalPrice | number:'.2' }}</strong>\n          </div>\n        </div>\n\n         <!-- payment cancellation section -->\n        <div class=\"cancel-title\">\n          <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-cancel-total-label\"><strong>{{ 'payment-summary-cancel-total-cancellation-fee' | translate  }}</strong></div>\n          <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-cancel-total-value\">\n            {{ bookingPayment?.currencyCode }}\n            <strong>{{ bookingCancellationCharge?.cancellationFee | number:'.2' }}</strong>\n          </div>\n        </div>\n\n        <div class=\"cancel-detail-section mb-15\">\n          <ng-container *ngIf=\"isShareBudget; else cancelPaymentCancellationFeeMultiDefault\">\n            <div id=\"{{prefixElementId}}-payment-summary-cancel-total-main-payment-label\">{{ 'payment-summary-cancel-pay-credit-term' | translate  }}</div>\n            <ul>\n              <li *ngFor=\"let bookerPayment of bookerPayments; let i = index\">\n                <span>{{ (i == 0 ? 'payment-summary-booker' : 'payment-summary-co-booker') | translate }}</span>\n                <span id=\"{{prefixElementId}}-payment-summary-total-main-payment-value-{{i}}\" class=\"fr\">{{ bookerPayment?.paymentInformation?.currencyCode }} {{ bookerPayment?.cancellationCharge?.cancellationFee | number:'.2' }}</span>\n              </li>\n            </ul>\n          </ng-container>\n          <ng-template #cancelPaymentCancellationFeeMultiDefault>\n            <div class=\"cancel-detail-item\">\n              <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-cancel-main-payment-label\">\n                <ng-container [ngSwitch]=\"mainPaymentMethod\">\n                  <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.CREDIT_TERMS\">\n                    {{ 'payment-summary-cancel-pay-credit-term' | translate  }}\n                  </ng-template>\n                  <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.CORPORATE_FLEET\">\n                    {{ 'payment-summary-cancel-pay-corporate-fleet' | translate  }}\n                  </ng-template>\n                  <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.PERSONAL_FLEET\">\n                    {{ 'payment-summary-cancel-pay-personal-fleet' | translate  }}\n                  </ng-template>\n                </ng-container>\n              </div>\n              <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-cancel-main-payment-value\">\n                {{ mainPayment?.paymentInformation?.currencyCode }}\n                <strong>{{ mainPayment?.cancellationCharge?.cancellationFee | number:'.2' }}</strong>\n              </div>\n            </div>\n          </ng-template>\n\n          <ng-container *ngIf=\"anotherPayment?.cancellationCharge\">\n            <div class=\"cancel-detail-item\">\n              <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-cancel-another-pay-label\">\n                <ng-container [ngSwitch]=\"anotherPaymentMethod\">\n                  <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.CREDIT_CARD\">\n                    {{ 'payment-summary-cancel-pay-credit-card' | translate  }}\n                  </ng-template>\n                  <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.TRUE_MONEY\">\n                    {{ 'payment-summary-cancel-pay-true-money' | translate  }}\n                  </ng-template>\n                  <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.PERSONAL_FLEET\">\n                    {{ 'payment-summary-cancel-pay-personal-fleet' | translate  }}\n                  </ng-template>\n                </ng-container>\n              </div>\n              <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-cancel-another-pay-value\">\n                {{ anotherPayment?.paymentInformation?.currencyCode }}\n                <strong>{{ anotherPayment?.cancellationCharge?.cancellationFee | number:'.2' }}</strong>\n              </div>\n            </div>\n          </ng-container>\n        </div>\n      </div>\n\n      <!-- payment grand total section (non credit-term) -->\n      <div class=\"grand-total font-grand-total\" *ngIf=\"mainPayment?.cancellationCharge?.refundAmount != null && mainPaymentMethod != PaymentMethodDetailType.CREDIT_TERMS\">\n        <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-refund-main-payment-grand-total-label\">\n          <ng-container [ngSwitch]=\"mainPaymentMethod\">\n            <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.CORPORATE_FLEET\">\n              {{ 'payment-summary-cancel-corporate-fleet-refund' | translate  }}\n            </ng-template>\n            <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.PERSONAL_FLEET\">\n              {{ 'payment-summary-cancel-personal-fleet-refund' | translate  }}\n            </ng-template>\n          </ng-container>\n        </div>\n        <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-refund-main-payment-grand-total-value\">\n          {{ bookingPayment?.currencyCode }}\n        <strong>{{ mainPayment?.cancellationCharge?.refundAmount | number:'.2' }}</strong>\n        </div>\n      </div>\n\n      <div class=\"grand-total font-grand-total border-top\" *ngIf=\"anotherPayment?.cancellationCharge?.refundAmount != null\">\n        <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-refund-another-payment-grand-total-label\">\n          <ng-container [ngSwitch]=\"anotherPaymentMethod\">\n            <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.CREDIT_CARD\">\n              {{ 'payment-summary-cancel-credit-card-refund' | translate  }}\n            </ng-template>\n            <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.TRUE_MONEY\">\n              {{ 'payment-summary-cancel-true-money-refund' | translate  }}\n            </ng-template>\n            <ng-template [ngSwitchCase]=\"PaymentMethodDetailType.PERSONAL_FLEET\">\n              {{ 'payment-summary-cancel-personal-fleet-refund' | translate  }}\n            </ng-template>\n          </ng-container>\n        </div>\n        <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-refund-another-payment-grand-total-value\">\n          {{ bookingPayment?.currencyCode }}\n        <strong>{{ anotherPayment?.cancellationCharge?.refundAmount | number:'.2' }}</strong>\n        </div>\n      </div>\n    </ng-template>\n\n    <ng-template #paymentVatSection>\n      <ng-container *ngIf=\"bookingPayment?.taxesAndFees; else defaultVat\">\n        <div class=\"price-breakdown {{ !isShareBudget ? 'non-share-budget' : '' }}\">\n          <div class=\"exclude-vat font-subtitle\" *ngIf=\"bookingPayment?.totalPrice\">\n            <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-booking-price-label\">{{ 'payment-summary-price' | translate  }}</div>\n            <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-booking-price-value\">{{ bookingPayment?.currencyCode }} {{ bookingPayment?.totalPrice - bookingPayment?.taxesAndFees | number:'.2' }}</div>\n          </div>\n          <div class=\"vat font-subtitle\">\n            <span class=\"taxes-fees\" id=\"{{prefixElementId}}-payment-summary-booking-taxes-fees-label\">\n              {{ 'payment-summary-taxes-fees' | translate }}\n              <span class=\"taxes-fees-icon\">\n                <i class=\"icon-info tooltip-trigger\" (click)=\"openDialogTaxesAndFees()\"></i>\n                <div class=\"tooltip-content\">\n                  <div class=\"tooltip-arrow\"></div>\n                  {{ 'cart-taxes-fees-description' | translate }}\n                </div>\n              </span>\n            </span>\n            <div id=\"{{prefixElementId}}-payment-summary-booking-taxes-fees-value\">{{ bookingPayment?.currencyCode }} {{ bookingPayment?.taxesAndFees | number:'.2' }}</div>\n          </div>\n        </div>\n      </ng-container>\n      <ng-template #defaultVat>\n        <div *ngIf=\"bookingPayment?.totalPriceExcludeVat != null\" class=\"price-breakdown {{ !isShareBudget ? 'non-share-budget' : '' }}\">\n          <div class=\"exclude-vat font-subtitle\">\n            <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-booking-price-label\">{{ 'payment-summary-price' | translate  }}</div>\n            <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-booking-price-value\">{{ bookingPayment?.currencyCode }} {{ bookingPayment?.totalPriceExcludeVat | number:'.2' }}</div>\n          </div>\n          <div class=\"vat font-subtitle\" *ngIf=\"bookingPayment?.totalVat != null\">\n            <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-booking-vat-label\">{{ 'payment-summary-vat' | translate  }}</div>\n            <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-booking-vat-value\">{{ bookingPayment?.currencyCode }} {{ bookingPayment?.totalVat | number:'.2' }}</div>\n          </div>\n        </div>\n      </ng-template>\n    </ng-template>\n\n    <ng-template #paymentTotalSection>\n      <div class=\"discount-summary price-breakdown\" *ngIf=\"hasDiscount\">\n        <div class=\"discount-row font-subtitle\">\n          <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-before-discount-label\">{{ 'payment-summary-before-discount' | translate }}</div>\n          <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-before-discount-value\">\n            {{ bookingPayment?.currencyCode }} {{ totalPriceBeforeDiscount | number:'.2' }}\n          </div>\n        </div>\n        <div class=\"discount-row font-subtitle\">\n          <div class=\"label-text color-success\" id=\"{{prefixElementId}}-payment-summary-discount-label\">{{ 'payment-summary-promotion-code-discount' | translate }}</div>\n          <div class=\"value-text color-success\" id=\"{{prefixElementId}}-payment-summary-discount-value\">\n            - {{ bookingPayment?.currencyCode }} {{ discountAmount | number:'.2' }}\n          </div>\n        </div>\n      </div>\n      <div class=\"grand-total font-grand-total\">\n        <div class=\"label-text\" id=\"{{prefixElementId}}-payment-summary-booking-total-price-label\">{{ 'payment-summary-book-grand-total' | translate  }}</div>\n        <div class=\"value-text\" id=\"{{prefixElementId}}-payment-summary-booking-total-price-value\">\n          {{ bookingPayment?.currencyCode }}\n          <strong>{{ bookingPayment?.totalPrice | number:'.2' }}</strong>\n        </div>\n      </div>\n    </ng-template>\n\n    <ng-template #priceInformationSection>\n      <div class=\"price-info-container\" *ngIf=\"surchargeList.length > 0\">\n        <div class=\"price-info-label font-bold\">\n          <i class=\"icon-info\"></i>\n          <div>{{ 'cart-price-info' | translate }}</div>\n        </div>\n        <ul class=\"surcharges-container\">\n          <div class=\"surcharge\">\n            <li *ngFor=\"let surcharge of surchargeList; let i = index\">\n              {{ surcharge }}\n            </li>\n          </div>\n        </ul>\n      </div>\n    </ng-template>\n\n    <ng-template #shareBudget>\n      <ul class=\"booker-payment-container\">\n        <li *ngFor=\"let bookerPayment of bookerPayments; let i = index\">\n          <span>{{ (i == 0 ? 'cart-booker' : 'cart-co-booker') | translate }}</span>\n          <span class=\"fr\">{{ bookerPayment?.paymentInformation?.currencyCode }} <strong>{{ bookerPayment?.paymentInformation?.totalPrice | number:'.2' }}</strong></span>\n        </li>\n      </ul>\n    </ng-template>\n\n    <ng-template #shareBudgetThankyou>\n      <div class=\"booker-payment-container-thankyou {{ isMultiPayment ? 'mb-0' : '' }}\">\n        <div class=\"booker-payment\" *ngFor=\"let bookerPayment of bookerPayments; let i = index\">\n          <span id=\"{{prefixElementId}}-payment-summary-total-main-payment-text-{{index}}\">\n            {{ (i == 0 ? 'payment-summary-booker' : 'payment-summary-co-booker') | translate }}\n          </span>\n          <span class=\"fr\" id=\"{{prefixElementId}}-payment-summary-total-main-payment-value-{{index}}\">\n            {{ bookerPayment?.paymentInformation?.currencyCode }} <strong>{{ bookerPayment?.paymentInformation?.totalPrice | number:'.2' }}</strong>\n          </span>\n        </div>\n      </div>\n    </ng-template>\n\n  </div>\n</div>\n"

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

module.exports = "<header [ngClass]=\"{'fp-viewing-firstSection': isfirstSection}\">\n\t<div *ngIf=\"isMobile; then mobileTmpl else desktopTmpl;\"></div>\n\t<ng-template #desktopTmpl>\n\t\t<div class=\"header-box header-desktop\" [ngClass]=\"{ 'header-white': !isfirstSection || theme == 'white' }\">\n\t\t\t<div class=\"header-top clearfix\">\n\t\t\t\t<div class=\"wrap-inner\">\n\t\t\t\t\t<div class=\"logo\">\n\t\t\t\t\t\t<img [src]=\"logoPath\" [default]=\"logoDefaultPath\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"header-right\" *ngIf=\"!notFoundPage\">\n\t\t\t\t\t\t<ul class=\"header-menu\">\n\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t<app-lang-dropdown></app-lang-dropdown>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li class=\"line-space\">|</li>\n\t\t\t\t\t\t\t<li id=\"header-lnk-currency-desktop\">\n\t\t\t\t\t\t\t\t<span id=\"header-lnk-currency-th-desktop\" class=\"text\" title=\"{{'menu-bar-baht-opposite' | translate }}\">{{'menu-bar-baht' | translate }}</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</ng-template>\n\n\t<ng-template #mobileTmpl>\n\t\t<div class=\"header-box header-mobile\" [ngClass]=\"{ 'header-white': !isfirstSection }\">\n\t\t\t<div class=\"l-left logo\">\n\t\t\t\t<img src=\"assets/images/header/ota_logo_m.png\" width=\"100\">\n\t\t\t</div>\n\t\t\t<button *ngIf=\"!notFoundPage\" class=\"navbar-toggle\" type=\"button\" (click)=\"handleToggleMenuBar($event)\">\n\t\t\t\t<span class=\"icon-navbar-toggle icon-fill\"></span>\n\t\t\t</button>\n\t\t\t<div class=\"m-list-menu-space\" (click)=\"handleBlurMenuBar($event)\">\n\t\t\t</div>\n\t\t\t<div class=\"m-list-menu-wrap\">\n\t\t\t\t<ul class=\"m-list-menu-sub\">\n\t\t\t\t\t<li [ngClass]=\"{ '-open-collapse': isShowListLanguage }\">\n\t\t\t\t\t\t<a (click)=\"handleShowListLanguage($event)\" id=\"header-btn-lang-dropdown\">\n\t\t\t\t\t\t\t<span>{{'menu-bar-language' | translate }}</span>\n\t\t\t\t\t\t\t<span class=\"link-arrow\">\n\t\t\t\t\t\t\t\t<img *ngIf=\"(language == 'th')\" src=\"assets/images/header/header_flag_th_2x.png\" class=\"icon-flag\">\n\t\t\t\t\t\t\t\t<img *ngIf=\"(language == 'en')\" src=\"assets/images/header/header_flag_en_2x.png\" class=\"icon-flag\">\n\t\t\t\t\t\t\t\t<span class=\"icon-arrow-right\"></span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<ul *ngIf=\"isShowListLanguage\" class=\"menu-bar-lang-mobile\">\n\t\t\t\t\t\t\t<li *ngIf=\"(language == 'en')\" (click)=\"handleChangeLanguage('th')\">\n\t\t\t\t\t\t\t\t<a id=\"header-btn-lang-th\" class=\"flag tha\" data-code=\"th\" data-id=\"th\">\n\t\t\t\t\t\t\t\t\t<span class=\"lang-label\">\n\t\t\t\t\t\t\t\t\t\t<img src=\"assets/images/header/header_flag_th.png\" class=\"icon-flag\">\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li *ngIf=\"(language == 'th')\" (click)=\"handleChangeLanguage('en')\">\n\t\t\t\t\t\t\t\t<a id=\"header-btn-lang-en\" class=\"flag eng\" data-code=\"en\" data-id=\"en\">\n\t\t\t\t\t\t\t\t\t<span class=\"lang-label\">\n\t\t\t\t\t\t\t\t\t\t<img src=\"assets/images/header/header_flag_en.png\" class=\"icon-flag\">\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<a id=\"header-lnk-currency-mobile\">\n\t\t\t\t\t\t\t<span class=\"pull-left\">{{'menu-bar-currency' | translate }}</span>\n\t\t\t\t\t\t\t<span id=\"header-lnk-currency-th-mobile\" class=\"pull-right link-arrow color-sub\">{{'menu-bar-baht' | translate }}</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t</div>\n\t</ng-template>\n</header>\n"

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <div [ngSwitch]=\"layout\">\n    <!-- Search Template top wrap for product-list and product-details -->\n    <ng-template ngSwitchCase=\"topwrap\">\n      <div class=\"search-top-wrap\" *ngIf=\"!isEditable\">\n        <div class=\"wrap-inner-auto\">\n          <div class=\"search-summary\">\n            <div class=\"cover-search-sum\">\n              <div class=\"search-destination\" (click)=\"handleClickDestinationTextArea($event)\">\n                <div class=\"headline\">{{'search-box-want-read' | translate}}</div>\n                <div class=\"desc-box\">\n                  <i class=\"search-summary-icon\">\n                    <img src=\"assets/images/icons/hotel.svg\" />\n                  </i>\n                  <span class=\"destination-text\">{{searchForm.value.destination.title}}</span>\n                </div>\n              </div>\n              <div class=\"search-date\" (click)=\"handleClickDateTextArea($event)\">\n                <div class=\"headline\">{{'search-box-check-in-out-read' | translate}}</div>\n                <div class=\"desc-box\">\n                  <i class=\"search-summary-icon\">\n                    <img src=\"assets/images/icons/Date.png\" />\n                  </i>\n                  <span>{{dateCheckInOutput}} - {{dateCheckOutOutput}}</span>\n                </div>\n              </div>\n              <div class=\"search-num-of-guest\" (click)=\"handleClickRoomTextArea($event)\">\n                <div class=\"headline\">{{'search-box-guest-read' | translate}}</div>\n                <div class=\"desc-box\">\n                  <i class=\"search-summary-icon\">\n                    <img src=\"assets/images/icons/people.svg\" />\n                  </i>\n                  <div *ngIf=\"lang() == 'en'\">\n                    <div class=\"text-inline\">{{roomCount}} {{'search-box-room-in-choose' | translate}}</div>\n                    <div class=\"text-inline\">, {{adultCount}} {{'search-box-adult' | translate}}</div>\n                    <div class=\"text-inline\" *ngIf=\"searchForm.value.purpose != 'work'\">, {{childCount}} {{'search-box-child' | translate}}</div>\n                  </div>\n                  <div *ngIf=\"lang() == 'th'\">\n                    <div class=\"text-inline\">{{roomCount}} {{'search-box-room-in-choose' | translate}}</div>\n                    <div class=\"text-inline\">, {{'search-box-adult' | translate}} {{adultCount}} {{'search-box-person' | translate}}</div>\n                    <div class=\"text-inline\" *ngIf=\"searchForm.value.purpose != 'work'\">, {{'search-box-child' | translate}} {{childCount}} {{'search-box-person' | translate}}</div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"search-change\" (click)=\"handleClickDestinationTextArea($event)\">\n                <a id=\"search-change\">{{'search-box-btn-change' | translate}}\n                  <i class=\"search-summary-icon -search icon-search\"></i>\n                </a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <!-- edit form -->\n      <div class=\"search-top-wrap-before\" *ngIf=\"isEditable\">\n        <div class=\"wrap-inner-auto\">\n          <div class=\"horizontal-search-wrap\">\n            <div class=\"top-form-search\">\n              <div class=\"topic-search\">{{'search-box-btn-change' | translate}}</div>\n              <form novalidate [formGroup]=\"searchForm\" (ngSubmit)=\"onSubmit(searchForm)\">\n                <div class=\"form-group pull-left-lg\">\n                  <div class=\"pull-left form-padding\">\n                    <label>{{'search-box-check-in' | translate }}</label>\n                    <div class=\"datepicker-wrap datepicker-container\">\n                      <input #inputCheckIn readonly [daterangepicker]=\"stateDaterangepicker\" [formControlFrom]=\"searchForm.controls.checkInDate\"\n                        [formControlTo]=\"searchForm.controls.checkOutDate\" [defaultStartDate]=\"searchForm.value.checkInDate\"\n                        [defaultEndDate]=\"searchForm.value.checkOutDate\" id=\"searchbox-inp-checkin\" syncToId=\"searchbox-inp-checkout\"\n                        label=\"search-box-check-in-calendar\" name=\"checkInDate\" section=\"searchMyBooking\" type=\"text\" class=\"form-control form-calendar input-checkin button\">\n                    </div>\n                  </div>\n                  <div class=\"pull-right form-padding\">\n                    <label>{{'search-box-check-out' | translate }}</label>\n                    <div class=\"datepicker-wrap datepicker-container\">\n                      <input readonly [daterangepicker]=\"stateDaterangepicker\" [formControlFrom]=\"searchForm.controls.checkInDate\" [formControlTo]=\"searchForm.controls.checkOutDate\"\n                        [defaultStartDate]=\"searchForm.value.checkInDate\" [defaultEndDate]=\"searchForm.value.checkOutDate\"\n                        id=\"searchbox-inp-checkout\" syncToId=\"searchbox-inp-checkin\" [isFirst]=\"false\" label=\"search-box-check-out-calendar\"\n                        name=\"checkOutDate\" section=\"searchMyBooking\" type=\"text\" class=\"form-control form-calendar input-checkout button\">\n                    </div>\n                  </div>\n                  <div class=\"clearfix\"></div>\n                </div>\n                <!--for travel-->\n                <div class=\"travel-box\" *ngIf=\"isShowFreeStyleRoomSelect()\">\n                  <div class=\"form-group pull-left-lg\">\n                    <label for=\"select1\">{{'search-box-guest-count' | translate}}</label>\n                    <div readonly class=\"form-control form-select button input-num-of-guest\" id=\"search-btn-toggle-roombox\" (click)=\"toggleRoomBox($event)\"\n                      [ngClass]=\"{'active': isShowRoomBox}\" #inputRoomBox>\n                      <div *ngIf=\"lang() == 'en'\">\n                        <span>{{roomCount}} {{'search-box-room-in-choose' | translate}}</span>\n                        <span>, {{adultCount}} {{'search-box-adult' | translate}}</span>\n                        <span *ngIf=\"searchForm.value.purpose != 'work'\">, {{childCount}} {{'search-box-child' | translate}}</span>\n                      </div>\n                      <div *ngIf=\"lang() == 'th'\">\n                        <span>{{roomCount}} {{'search-box-room-in-choose' | translate}}</span>\n                        <span>, {{'search-box-adult' | translate}} {{adultCount}} {{'search-box-person' | translate}}</span>\n                        <span *ngIf=\"searchForm.value.purpose != 'work'\">, {{'search-box-child' | translate}} {{childCount}} {{'search-box-person' | translate}}</span>\n                      </div>\n                    </div>\n                    <!-- showRoomBox -->\n                    <div class=\"form-group-pop select-room-popup-container -right\" [ngClass]=\"{'-show': isShowRoomBox}\" (click)=\"stopPropagation($event)\">\n                      <div class=\"select-room-popup\">\n                        <a id=\"search-btn-hide-roombox\" (click)=\"hideRoomBox($event)\" class=\"close-pop\">\n                          <span class=\"close-icon icon-close\"></span>\n                        </a>\n                        <div class=\"select-room-box\">\n                          <div class=\"form-group-inline\">\n                            <label for=\"select2\">{{'search-box-room' | translate}}</label>\n                            <div class=\"select-ota-style box-sm\">\n                              <select id=\"search-select-room\" (change)=\"handlerOnChangeRoom($event)\">\n                                <option *ngFor=\"let item of [1,2,3,4,5,6,7,8,9]; let i = index\" [attr.data-index]=\"i+1\" [value]=\"i+1\" [selected]=\"i+1==roomCount\">{{i+1}}</option>\n                              </select>\n                            </div>\n                          </div>\n                        </div>\n                        <div class=\"selcet-detail-room-box\">\n                          <div class=\"tab-detail-room-list\">\n                            <ul>\n                              <li [ngClass]=\"{'active': currentTabRoom == i+1}\" *ngFor=\"let room of searchForm.value.guests; let i = index\" [attr.data-index]=\"i+1\"\n                                (click)=\"setActiveTabRoom(i+1)\" id=\"search-btn-active-room-tab{{i}}\">\n                                <a>{{'search-box-room-in-choose' | translate}} #{{i+1}}</a>\n                              </li>\n                            </ul>\n                            <div class=\"wrapper-arrow-btn\" *ngIf=\"this.isRoomBoxShowArrow\">\n                              <div class=\"next\" [ngClass]=\"{'disable': searchForm.value.guests.length == 1 || currentTabRoom == 1}\" (click)=\"prevActiveTabRoom()\"\n                                id=\"search-btn-next-room-tab\">\n                                <a class=\"disable\">\n                                  <i class=\"icon-arrow-left\"></i>\n                                </a>\n                              </div>\n                              <div class=\"prev\" [ngClass]=\"{'disable': currentTabRoom == searchForm.value.guests.length}\" (click)=\"nextActiveTabRoom()\"\n                                id=\"search-btn-prev-room-tab\">\n                                <a>\n                                  <i class=\"icon-arrow-right\"></i>\n                                </a>\n                              </div>\n                            </div>\n                          </div>\n                          <div class=\"content-detail-room-list\">\n                            <div class=\"box-overflow\">\n                              <div class=\"form-group pull-left\">\n                                <label for=\"select3\">{{'search-box-adult' | translate}}</label>\n                                <div class=\"select-ota-style box-sm\">\n                                  <select id=\"search-select-adult\" (change)=\"handlerOnChangeAdultCount($event)\">\n                                    <option *ngFor=\"let item of [1,2,3,4,5,6,7,8]; let i = index\" [attr.data-index]=\"i+1\" [value]=\"i+1\" [selected]=\"i+1==currentRoom.adult\">{{i+1}}</option>\n                                  </select>\n                                </div>\n                              </div>\n                              <div class=\"form-group pull-left\" *ngIf=\"searchForm.value.purpose != 'work'\">\n                                <label for=\"select3\">{{'search-box-child' | translate}}</label>\n                                <div class=\"select-ota-style select-child box-sm\">\n                                  <select id=\"search-select-child\" (change)=\"handlerOnChangeChildren($event)\">\n                                    <option *ngFor=\"let item of [0,1,2,3,4]; let i = index\" [attr.data-index]=\"i\" [value]=\"i\" [selected]=\"i==currentRoom.children.length\">{{i}}</option>\n                                  </select>\n                                </div>\n                              </div>\n\n                            </div>\n                            <!-- children how old? -->\n                            <div *ngIf=\"currentRoom.children.length > 0\" class=\"box-overflow line-dot-top\">\n                              <div class=\"form-group pull-left\" *ngFor=\"let child of currentRoom.children; let i = index; trackBy:trackByChild\">\n                                <label for=\"select3\">{{'search-box-child-age' | translate}} #{{i+1}}</label>\n                                <div class=\"select-ota-style box-sm\">\n                                  <select id=\"search-select-child-age\" (change)=\"handlerOnChangeChildrenOld($event, i)\">\n                                    <option *ngFor=\"let item of [0,1,2,3,4,5,6,7,8,9,10,11,12]; let i = index\" [value]=\"i\" [selected]=\"i==child\">{{i}}</option>\n                                  </select>\n                                </div>\n                              </div>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                    <!-- end showRoomBox -->\n                  </div>\n                </div>\n                <!--/end for travel-->\n                <div (click)=\"cancleChangeSearch($event)\" class=\"ota-btn-sub btn-cancle-horizontal show-sm\">{{'btn-cancel' | translate}}</div>\n                <button type=\"submit\" class=\"ota-btn-main btn-submit-horizontal\">{{'search-box-btn-search' | translate}}</button>\n                <div class=\"clearfix\"></div>\n                <div class=\"lvc-cancel\">\n                  <a (click)=\"cancleChangeSearch($event)\">{{'search-box-btn-cancel-change' | translate}}</a>\n                </div>\n              </form>\n            </div>\n          </div>\n          <!-- end search -->\n        </div>\n      </div>\n      <!--/search-top-wrap-->\n    </ng-template>\n  </div>\n  <!-- ng switch templates -->\n</div>"

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <div class=\"content-box\" *ngIf=\"isOpen\">\n    <ng-content></ng-content>\n  </div>\n  <a id=\"booking-details-btn-hide-details-{{itemIndex}}\" (click)=\"toggleContent()\" [ngClass]=\"{'hide-detail': isOpen, 'show-detail': !isOpen}\">\n    {{ (isOpen? 'booking-details-hide-details': 'booking-details-view-more-details') | translate}}\n  </a>\n</div>\n"

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

module.exports = "<div>\n\n  <div [ngSwitch]=\"layout\">\n    <ng-template ngSwitchCase=\"home\">\n      <div class=\"wrap-inner-auto\">\n        <div class=\"home-search-wrap\">\n          <div class=\"search-header\">\n            <strong class=\"search-title\">{{'search-box-title' | translate }}</strong>\n            <br>\n            <span class=\"font-14px hide-sm\">{{'search-box-title-sub' | translate }}</span>\n          </div>\n\n          <div class=\"home-form-search\">\n            <form novalidate [formGroup]=\"searchForm\" (ngSubmit)=\"onSubmit(searchForm.value)\">\n              <div *ngIf=\"bookWorkPurpose\" class=\"form-group\">\n                <div class=\"purpose-wrapper\">\n                  <div class=\"purpose-box\">\n                    <label class=\"purpose-title\">{{'search-box-topic-title' | translate }}\n                      <a class=\"tooltips\">\n                        <i class=\"icon-question\"></i>\n                        <div class=\"tooltips-content\">\n                          <strong>{{'search-box-tooltip-title' | translate }}</strong>\n                          <p><strong>{{'search-box-topic-work' | translate }}</strong> :\n                            {{'search-box-tooltip-work' | translate }}</p>\n                          <p><strong>{{'search-box-topic-travel' | translate }}</strong> :\n                            {{'search-box-tooltip-travel' | translate }}</p>\n                        </div>\n                      </a> :\n                    </label>\n                    <div class=\"ota-radio\">\n                      <input type=\"radio\" formControlName=\"purpose\" id=\"search-radio-purpose-work\" value=\"work\">\n                      <label class=\"radio-text\" for=\"search-radio-purpose-work\">\n                        {{'search-box-topic-work' | translate }}\n                      </label>\n                    </div>\n                    <div class=\"ota-radio\">\n                      <input type=\"radio\" formControlName=\"purpose\" id=\"search-radio-purpose-leisure\" value=\"leisure\">\n                      <label class=\"radio-text\" for=\"search-radio-purpose-leisure\">\n                        {{'search-box-topic-travel' | translate }}\n                      </label>\n                    </div>\n                  </div>\n                  <div class=\"ota-text-error\" *ngIf=\"searchForm.controls.purpose.invalid && searchSubmitted\">\n                    <i class=\"icon-warning\"></i><span>{{'search-box-error-purpose' | translate}}</span>\n                  </div>\n                </div>\n              </div>\n\n              <ng-container\n                *ngIf=\"searchForm.value.purpose == 'work' && (budget || budgetPerMonth || budgetPerYear || isShareBudget) && !allowBookForTraveller; else noBudget\">\n                <div *ngIf=\"displayFirstLineBudget\" class=\"alert-budget\" [ngClass]=\"{'mb-20' : !isShareBudget}\">\n                  <div class=\"first-line-budget\">\n                    <span [innerHtml]=\"displayFirstLineBudget\"></span>\n                    <a *ngIf=\"!displaySecondLineBudget && displayPermission\" class=\"permission\" routerLink=\"/permission\"\n                      [queryParams]=\"{lang: lang}\">{{'search-box-see-all-my-budget' | translate}}\n                    </a>\n\n                    <!--- share detail--->\n                    <a *ngIf=\"shareBudget\" class=\"share-budget-detail tooltips hide-sm\" id=\"searchbox-share-budget-tooltips\">\n                      {{'budget-limit-view-detail' | translate}}\n                      <div class=\"tooltips-content hide-sm\">\n                        <div class=\"form-group\">\n                          <div class=\"row\">\n                            <div class=\"col-md-12\">\n                              <b>{{ 'search-box-tooltips-share-budget-detail-title' | translate }}</b>\n                            </div>\n                          </div>\n                          <div class=\"row\">\n                            <div id=\"searchbox-share-budget-tooltips-booker-budget-title\" class=\"col-md-8\">\n                              {{ 'search-box-tooltips-share-budget-detail-booker-budget' | translate }}\n                            </div>\n                            <div id=\"searchbox-share-budget-tooltips-booker-budget\" class=\"col-md-4\">\n                              {{ shareBudget?.booker?.amount ? 'THB ' + (shareBudget?.booker?.amount | number) : ('budget-unlimited' | translate) }}\n                            </div>\n                          </div>\n                          <div class=\"row\">\n                            <div id=\"searchbox-share-budget-tooltips-co-booker-budget-title\" class=\"col-md-8\">\n                              {{ 'search-box-tooltips-share-budget-detail-co-booker-budget' | translate }}\n                              <br>\n                              <span>\n                                {{ shareBudget?.coBooker?.email }}\n                              </span>\n                            </div>\n                            <div id=\"searchbox-share-budget-tooltips-co-booker-budget\" class=\"col-md-4\">\n                              {{ shareBudget?.coBooker?.amount ? 'THB ' + (shareBudget?.coBooker?.amount | number) : ('budget-unlimited' | translate) }}\n                            </div>\n                          </div>\n                          <div *ngIf=\"shareBudget.applyCoBudget\" class=\"row warning\">\n                            <div class=\"col-md-12\">\n                              **{{'search-box-tooltips-share-budget-detail-apply-co-budget' | translate}}\n                            </div>\n                          </div>\n                          <div class=\"row total\">\n                            <div id=\"searchbox-share-budget-tooltips-total-budget-title\" class=\"col-md-8\">\n                              {{ 'search-box-tooltips-share-budget-detail-total-budget' | translate }}\n                            </div>\n                            <div id=\"searchbox-share-budget-tooltips-total-budget\" class=\"col-md-4\">\n                              <b>{{ shareBudget?.totalBudget ? 'THB ' + (shareBudget?.totalBudget| number) : ('budget-unlimited' | translate) }}\n                              </b>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                    </a>\n\n                    <div *ngIf=\"shareBudget\" class=\"share-budget-detail tooltips show-sm mobile\" id=\"searchbox-share-budget-tooltips\"\n                      (click)=\"openDialogShareBudgetDetail()\">\n                      {{'budget-limit-view-detail' | translate}}\n                    </div>\n                    <!--- end detail--->\n\n                    <!--- desktop share budget--->\n                    <ng-template [ngIf]=\"isShareBudget && !shareBudget\">\n                      <a class=\"share-budget tooltips hide-sm\" [ngClass]=\"{'middle': displaySecondLineBudget}\" (click)=\"openDialogShareBudget()\" id=\"searchbox-share-budget\">\n                        <i class=\"icon-add\"></i>\n                        <span>\n                          {{'search-box-share-budget' | translate}}\n                        </span>\n                        <div id=\"searchbox-share-budget-tooltips-content\" class=\"tooltips-content hide-sm\" [ngClass]=\"{'tooltips-content-en': lang === 'en'}\">\n                          {{'search-box-share-budget-tooltips' | translate }}\n                        </div>\n                      </a>\n                    </ng-template>\n                    <ng-template [ngIf]=\"isShareBudget && shareBudget\">\n                      <a class=\"share-budget hide-sm\" [ngClass]=\"{'middle': displaySecondLineBudget}\" (click)=\"onCancelShareBudget()\" id=\"searchbox-cancel-share-budget\">\n                        <i class=\"icon-delete2\"></i>\n                        <span>\n                          {{'search-box-cancel-share-budget' | translate}}\n                        </span>\n                      </a>\n                    </ng-template>\n                    <!--- end desktop share budget--->\n\n                  </div>\n                  <div class=\"second-line-budget\" *ngIf=\"displaySecondLineBudget\">\n                    <span [innerHtml]=\"displaySecondLineBudget\"></span>\n                    <a routerLink=\"/permission\" class=\"permission\" [queryParams]=\"{lang: lang}\">{{'search-box-see-all-my-budget' | translate}}</a>\n                  </div>\n                </div>\n\n                <!--- mobile share budget--->\n                <ng-template [ngIf]=\"isShareBudget && !shareBudget\">\n                  <div class=\"share-budget-mobile show-sm\">\n                    <a (click)=\"openDialogShareBudget()\">\n                      <i class=\"icon-add\"></i>\n                      <span>\n                        {{'search-box-share-budget' | translate}}\n                      </span>\n                    </a>\n                  </div>\n                </ng-template>\n                <ng-template [ngIf]=\"isShareBudget && shareBudget\">\n                  <div class=\"share-budget-mobile show-sm\">\n                    <a (click)=\"onCancelShareBudget()\" id=\"searchbox-cancel-share-budget\">\n                      <i class=\"icon-delete2\"></i>\n                      <span>\n                        {{'search-box-cancel-share-budget' | translate}}\n                      </span>\n                    </a>\n                  </div>\n                </ng-template>\n                <!--- end mobile share budget --->\n\n              </ng-container>\n              <ng-template #noBudget>\n                <div class=\"divide-line\" *ngIf=\"bookWorkPurpose\"></div>\n              </ng-template>\n\n              <div class=\"form-group\" formGroupName=\"destination\">\n                <label for=\"input1\">{{'search-box-want' | translate }}</label>\n                <div class=\"destination_search\">\n                  <input #inputDestination\n                    type=\"text\"\n                    [typeahead]=\"searchForm.controls.destination.controls.title\"\n                    [valueControls]=\"searchForm.controls.destination\"\n                    formControlName=\"title\"\n                    (onSelectedItem)=\"handleOnSelectedDestination($event)\"\n                    [objective]=\"searchForm.value.purpose\"\n                    class=\"form-control input-destination\"\n                    id=\"search-input-destination\" [ngClass]=\"{'ota-input-error': !isSelectedDestination && searchSubmitted}\"\n                    placeholder=\"{{'search-box-want-placeholder' | translate }}\" maxlength=\"110\">\n                  <i *ngIf=\"searchForm.value.destination.title != ''\" class=\"icon-close delete ng-hide\"\n                    (click)=\"resetDestinationValue($event)\" id=\"search-btn-delete-destination\"></i>\n                </div>\n                <div class=\"ota-text-error\" *ngIf=\"!isSelectedDestination && searchSubmitted\">\n                  <i class=\"icon-warning\"></i><span>{{'search-box-error-destination' | translate}}</span>\n                </div>\n              </div>\n              <div class=\"form-group pull-left col-left\">\n                <div>\n                  <div class=\"pull-left col-left\">\n                    <label>{{'search-box-check-in' | translate }}</label>\n                    <div class=\"datepicker-wrap datepicker-container\">\n                      <input readonly [daterangepicker]=\"stateDaterangepicker\"\n                        [formControlFrom]=\"searchForm.controls.checkInDate\"\n                        [formControlTo]=\"searchForm.controls.checkOutDate\"\n                        id=\"searchbox-inp-checkin\" syncToId=\"searchbox-inp-checkout\"\n                        name=\"checkInDate\" section=\"searchMyBooking\" type=\"text\"\n                        class=\"form-control form-calendar button\">\n                    </div>\n                  </div>\n                  <div class=\"pull-right col-right\">\n                    <label>{{'search-box-check-out' | translate }}</label>\n                    <div class=\"datepicker-wrap datepicker-container\">\n                      <input readonly [daterangepicker]=\"stateDaterangepicker\"\n                        [formControlFrom]=\"searchForm.controls.checkInDate\"\n                        [formControlTo]=\"searchForm.controls.checkOutDate\"\n                        id=\"searchbox-inp-checkout\" syncToId=\"searchbox-inp-checkin\" [isFirst]=\"false\"\n                        name=\"checkOutDate\" section=\"searchMyBooking\" type=\"text\"\n                        class=\"form-control form-calendar button\">\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <!-- for work owner-->\n              <div class=\"form-group pull-right col-right search-box-room-guest\" *ngIf=\"isShowLimitedRoomSelect()\">\n                <div *ngIf=\"isShowLimitedRoomSelect()\">\n                  <div class=\"pull-left col-left\">\n                    <label for=\"select1\">{{'search-box-room' | translate }}</label>\n                    <div class=\"select-ota-style\">\n                      <select id=\"search-select-room-personal\" class=\"select-room\" readonly>\n                        <option selected value=\"1\">1</option>\n                      </select>\n                    </div>\n                  </div>\n                  <div class=\"pull-right col-right\">\n                    <label for=\"select1\">{{'search-box-guest' | translate }}</label>\n                    <div class=\"select-ota-style\">\n                      <select id=\"search-select-guest-personal\" class=\"select-guest\" readonly (change)=\"handlerOnChangeAdultCount($event)\">\n                        <ng-template [ngIf]=\"shareBudget\">\n                          <option *ngFor=\"let item of [1]\" [value]=\"2\">2</option>\n                        </ng-template>\n                        <ng-template [ngIf]=\"!shareBudget\">\n                          <option *ngFor=\"let item of [1,2]; let i = index\" [attr.data-index]=\"i+1\" [value]=\"i+1\"\n                          [selected]=\"i+1==currentRoom.adult\">{{i+1}}</option>\n                        </ng-template>\n                      </select>\n                    </div>\n                  </div>\n                  <div class=\"clearfix\"></div>\n                </div>\n              </div>\n              <!--for work owner-->\n\n              <div class=\"form-group pull-right col-right\" *ngIf=\"isShowFreeStyleRoomSelect()\">\n                <div *ngIf=\"isShowFreeStyleRoomSelect()\">\n                  <label for=\"search-btn-toggle-roombox\">{{'search-box-guest-count' | translate}}</label>\n                  <div readonly class=\"form-control form-select button select-room-guest\" id=\"search-btn-toggle-roombox\"\n                    (click)=\"toggleRoomBox($event)\" [ngClass]=\"{'active': isShowRoomBox}\">\n                    <div *ngIf=\"lang == 'en'\">\n                      <span>{{roomCount}} {{'search-box-room-in-choose' | translateSingularPlural: roomCount}}</span><span>, {{adultCount}} {{'search-box-adult' | translateSingularPlural: adultCount}}</span><span *ngIf=\"searchForm.value.purpose != 'work'\">, {{childCount}} <ng-container *ngIf=\"childCount == 1; else homeSearchChildElse\">{{'search-box-child' | translate}}</ng-container><ng-template #homeSearchChildElse>{{'search-box-children' | translate}}</ng-template></span>\n                    </div>\n\n                    <div *ngIf=\"lang == 'th'\">\n                      <span>{{roomCount}} {{'search-box-room-in-choose' | translate}}</span><span>,\n                        {{'search-box-adult' | translate}} {{adultCount}}\n                        {{'search-box-person' | translate}}</span><span *ngIf=\"searchForm.value.purpose != 'work'\">,\n                        {{'search-box-child' | translate}}\n                        {{childCount}} {{'search-box-person' | translate}}</span>\n                    </div>\n\n                    <div class=\"form-group-pop select-room-popup-container\" [ngClass]=\"{'-show': isShowRoomBox}\"\n                      (click)=\"stopPropagation($event)\">\n                      <div class=\"select-room-popup\">\n                        <div class=\"select-room-box\">\n                          <div class=\"form-group-inline\">\n                            <label for=\"select2\">{{'search-box-room' | translate}}</label>\n                            <div class=\"select-ota-style box-sm\">\n                              <select id=\"search-select-room\" (change)=\"handlerOnChangeRoom($event)\">\n                                <option *ngFor=\"let item of [1,2,3,4,5,6,7,8,9]; let i = index\" [attr.data-index]=\"i+1\"\n                                  [value]=\"i+1\" [selected]=\"i+1==roomCount\">\n                                  {{i+1}}</option>\n                              </select>\n                            </div>\n                          </div>\n                        </div>\n                        <div class=\"selcet-detail-room-box\">\n                          <div class=\"tab-detail-room-list\">\n                            <ul>\n                              <li [ngClass]=\"{'active': currentTabRoom == i+1}\"\n                                *ngFor=\"let room of searchForm.value.guests; let i = index\" [attr.data-index]=\"i+1\"\n                                (click)=\"setActiveTabRoom(i+1)\" id=\"search-btn-active-room-tab{{i}}\">\n                                <a>{{'search-box-room-in-choose' | translate}} #{{i+1}}</a>\n                              </li>\n                            </ul>\n                            <div class=\"wrapper-arrow-btn\" *ngIf=\"this.isRoomBoxShowArrow\">\n                              <div class=\"next\"\n                                [ngClass]=\"{'disable': searchForm.value.guests.length == 1 || currentTabRoom == 1}\"\n                                (click)=\"prevActiveTabRoom()\" id=\"search-btn-next-room-tab\">\n                                <a class=\"disable\"><i class=\"icon-arrow-left\"></i></a>\n                              </div>\n                              <div class=\"prev\" [ngClass]=\"{'disable': currentTabRoom == searchForm.value.guests.length}\"\n                                (click)=\"nextActiveTabRoom()\" id=\"search-btn-prev-room-tab\">\n                                <a><i class=\"icon-arrow-right\"></i></a>\n                              </div>\n                            </div>\n                          </div>\n                          <div class=\"content-detail-room-list\">\n                            <div class=\"box-overflow\">\n                              <div class=\"form-group pull-left col-left\">\n                                <label for=\"select3\">{{'search-box-adult' | translate}}</label>\n                                <div class=\"select-ota-style\">\n                                  <select id=\"search-select-adult\" (change)=\"handlerOnChangeAdultCount($event)\">\n                                    <option *ngFor=\"let item of [1,2,3,4,5,6,7,8]; let i = index\" [attr.data-index]=\"i+1\"\n                                      [value]=\"i+1\" [selected]=\"i+1==currentRoom.adult\">{{i+1}}</option>\n                                  </select>\n                                </div>\n                              </div>\n                              <div class=\"form-group pull-right col-right\" *ngIf=\"searchForm.value.purpose != 'work'\">\n                                <label for=\"select3\">{{'search-box-child' | translate}}</label>\n                                <div class=\"select-ota-style select-child\">\n                                  <select id=\"search-select-child\" (change)=\"handlerOnChangeChildren($event)\">\n                                    <option *ngFor=\"let item of [0,1,2,3,4]; let i = index\" [attr.data-index]=\"i\" [value]=\"i\"\n                                      [selected]=\"i==currentRoom.children.length\">{{i}}</option>\n                                  </select>\n                                </div>\n                              </div>\n\n                            </div>\n\n                            <!-- children how old? -->\n                            <div *ngIf=\"currentRoom.children.length > 0\" class=\"box-overflow line-dot-top\">\n                              <label for=\"select3\">{{'search-box-child-age' | translate}}</label>\n                              <div class=\"row\">\n                                <div class=\"col-sm-3 form-group\" *ngFor=\"let child of currentRoom.children; let i = index; trackBy:trackByChild\">\n                                  <div class=\"select-ota-style\">\n                                    <select id=\"search-select-child-age-{{i}}\" (change)=\"handlerOnChangeChildrenOld($event, i)\">\n                                      <option *ngFor=\"let item of [0,1,2,3,4,5,6,7,8,9,10,11,12]; let i = index\" [value]=\"i\"\n                                        [selected]=\"i==child\">{{i}}</option>\n                                    </select>\n                                  </div>\n                                </div>\n                              </div>\n\n                            </div>\n\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"form-group over-budget\" *ngIf=\"searchForm.value.purpose == 'work' && allowOverBudget && budget && !allowBookForTraveller\">\n                <div class=\"ota-checkbox\">\n                  <input formControlName=\"overBudget\" type=\"checkbox\" id=\"search-checkbox-over-budget\">\n                  <label for=\"search-checkbox-over-budget\">\n                    {{'search-box-over-budget-checkbox-label' | translate}}\n                    <a class=\"tooltips\" (click)=\"openDialogTooltips()\">\n                      <i class=\"icon-info\"></i>\n                      <div class=\"tooltips-content hide-sm\" [ngClass]=\"lang\">\n                        {{'search-box-over-budget-hover-info-label' | translate }}\n                      </div>\n                    </a>\n                  </label>\n                </div>\n              </div>\n\n              <!--end for travel-->\n              <div class=\"form-group action-botton-group mb-0\">\n                <button id=\"search-btn-submit\" type=\"submit\" [ngClass]=\"{'unclickable': isLoading, 'loading': isLoading }\" class=\"ota-btn-main mb-0\">{{'search-box-btn-search' | translate }}</button>\n              </div>\n            </form>\n          </div>\n        </div>\n      </div>\n      <!-- end search -->\n    </ng-template>\n\n    <!-- Search Template top wrap for product-list and product-details -->\n    <ng-template ngSwitchCase=\"topwrap\">\n      <div class=\"search-top-wrap\" *ngIf=\"!isEditable\">\n          <div class=\"wrap-inner-auto\">\n              <div class=\"search-summary\" >\n                  <div class=\"cover-search-sum\">\n                      <div class=\"search-destination\" (click)=\"handleClickDestinationTextArea($event)\">\n                          <div id=\"searchbox-div-destination-title\" class=\"headline\">{{'search-box-want-read' | translate}}</div>\n                          <div class=\"desc-box\">\n                            <i class=\"search-summary-icon destination-icon\"><img src=\"assets/images/icons/Destination.png\"/></i><span class=\"destination-text\">{{searchForm.value.destination.title}}</span>\n                          </div>\n                      </div>\n                      <div class=\"search-date\" (click)=\"handleClickDateTextArea($event)\">\n                          <div id=\"searchbox-div-period-of-stay-title\" class=\"headline\">{{'search-box-check-in-out-read' | translate}}</div>\n                          <div class=\"desc-box\">\n                              <i class=\"search-summary-icon\">\n                                <img src=\"assets/images/icons/Date.png\"/>\n                              </i><span>{{dateCheckInOutput}} - {{dateCheckOutOutput}}</span>\n                          </div>\n                      </div>\n                      <div class=\"search-num-of-guest\" (click)=\"handleClickRoomTextArea($event)\">\n                          <div class=\"headline\">{{'search-box-guest-read' | translate}}</div>\n                          <div class=\"desc-box\">\n                              <i class=\"search-summary-icon\">\n                                <img src=\"assets/images/icons/Guest.png\"/>\n                              </i>\n                              <div *ngIf=\"lang == 'en'\">\n                                <div class=\"text-inline\">{{roomCount}} {{'search-box-room-in-choose' | translateSingularPlural: roomCount}}</div><div class=\"text-inline\">, {{adultCount}} {{'search-box-adult' | translateSingularPlural: adultCount}}</div><div class=\"text-inline\" *ngIf=\"searchForm.value.purpose != 'work'\">, {{childCount}} <ng-container *ngIf=\"childCount == 1; else searchBoxDetailChildElse\">{{'search-box-child' | translate}}</ng-container><ng-template #searchBoxDetailChildElse>{{'search-box-children' | translate}}</ng-template></div>\n                              </div>\n\n                              <div *ngIf=\"lang == 'th'\">\n                                <div class=\"text-inline\">{{roomCount}} {{'search-box-room-in-choose' | translate}}</div><div class=\"text-inline\">, {{'search-box-adult' | translate}} {{adultCount}} {{'search-box-person' | translate}}</div><div class=\"text-inline\" *ngIf=\"searchForm.value.purpose != 'work'\">, {{'search-box-child' | translate}} {{childCount}} {{'search-box-person' | translate}}</div>\n                              </div>\n                          </div>\n                      </div>\n                      <div class=\"search-change\" (click)=\"handleClickDestinationTextArea($event)\">\n                          <a id=\"search-change\">{{'search-box-btn-change' | translate}}<i class=\"search-summary-icon -search icon-search2\"></i></a>\n                      </div>\n                  </div>\n              </div>\n          </div>\n      </div>\n\n\n      <!-- edit form -->\n      <div class=\"search-top-wrap-before\" *ngIf=\"isEditable\">\n        <div class=\"wrap-inner-auto\">\n          <div class=\"horizontal-search-wrap\">\n            <div class=\"top-form-search\">\n              <div class=\"topic-search\">{{'search-box-btn-change' | translate}}</div>\n              <form novalidate [formGroup]=\"searchForm\" (ngSubmit)=\"onSubmit(searchForm.value)\">\n                <div *ngIf=\"bookWorkPurpose\" class=\"radio lvc-radio purpose-box\">\n                    <label class=\"radio-lvc-topic\">{{'search-box-topic-title' | translate}}\n                        <a class=\"tooltips\">\n                            <span class=\"icon-question\"></span>\n                            <div class=\"tooltips-content\">\n                                <strong>{{'search-box-tooltip-title' | translate }}</strong>\n                                <p><strong>{{'search-box-topic-work' | translate }}</strong> : {{'search-box-tooltip-work' | translate }}</p>\n                                <p><strong>{{'search-box-topic-travel' | translate }}</strong> : {{'search-box-tooltip-travel' | translate }}</p>\n                            </div>\n                        </a> :\n                    </label>\n\n                    <div class=\"ota-radio\">\n                      <input type=\"radio\" formControlName=\"purpose\" id=\"search-radio-purpose-work\" value=\"work\">\n                      <label class=\"radio-text\" for=\"search-radio-purpose-work\">\n                        {{'search-box-topic-work' | translate }}\n                      </label>\n                    </div>\n                    <div class=\"ota-radio\">\n                      <input type=\"radio\" formControlName=\"purpose\" id=\"search-radio-purpose-leisure\" value=\"leisure\">\n                      <label class=\"radio-text\" for=\"search-radio-purpose-leisure\">\n                        {{'search-box-topic-travel' | translate }}\n                      </label>\n                    </div>\n                </div>\n\n                <div class=\"form-group pull-left-lg form-padding\" formGroupName=\"destination\">\n                    <label id=\"searchbox-label-destination-title\" for=\"input1\">{{'search-box-want' | translate }}</label>\n                    <div\n                      class=\"destination_search\"\n                      [ngClass]=\"{'-error-fuild': !isSelectedDestination && searchSubmitted}\">\n                      <input\n                        #inputDestination\n                        type=\"text\"\n                        [typeahead]=\"searchForm.controls.destination.controls.title\"\n                        [valueControls]=\"searchForm.controls.destination\"\n                        formControlName=\"title\"\n                        (onSelectedItem)=\"handleOnSelectedDestination($event)\"\n                        [objective]=\"searchForm.value.purpose\"\n                        class=\"form-control input-destination -layout-topwrap\"\n                        id=\"search-input-destination\"\n                        [ngClass]=\"{'ota-input-error': !isSelectedDestination && searchSubmitted}\"\n                        placeholder=\"{{'search-box-want-placeholder' | translate }}\"\n                        maxlength=\"110\"\n                      >\n                      <i *ngIf=\"searchForm.value.destination.title != ''\" class=\"icon-close delete ng-hide\" (click)=\"resetDestinationValue($event)\"></i>\n                      <div class=\"ota-text-error\" *ngIf=\"!isSelectedDestination && searchSubmitted\">\n                        <i class=\"icon-warning\"></i><span>{{'search-box-error-destination' | translate}}</span>\n                      </div>\n                    </div>\n                </div>\n                <div class=\"form-group pull-left-lg\">\n                    <div class=\"pull-left form-padding\">\n                        <label id=\"searchbox-label-check-in-title\">{{'search-box-check-in' | translate }}</label>\n                        <div class=\"datepicker-wrap datepicker-container\">\n                          <input\n                            #inputCheckIn\n                            readonly\n                            [daterangepicker]=\"stateDaterangepicker\"\n                            [formControlFrom]=\"searchForm.controls.checkInDate\"\n                            [formControlTo]=\"searchForm.controls.checkOutDate\"\n                            [defaultStartDate]=\"searchForm.value.checkInDate\"\n                            [defaultEndDate]=\"searchForm.value.checkOutDate\"\n                            id=\"searchbox-inp-checkin\"\n                            syncToId=\"searchbox-inp-checkout\"\n                            name=\"checkInDate\"\n                            section=\"searchMyBooking\"\n                            type=\"text\"\n                            class=\"form-control form-calendar input-checkin button\">\n                          </div>\n                    </div>\n                    <div class=\"pull-right form-padding\">\n                        <label id=\"searchbox-label-check-out-title\">{{'search-box-check-out' | translate }}</label>\n                        <div class=\"datepicker-wrap datepicker-container\">\n                          <input\n                            readonly\n                            [daterangepicker]=\"stateDaterangepicker\"\n                            [formControlFrom]=\"searchForm.controls.checkInDate\"\n                            [formControlTo]=\"searchForm.controls.checkOutDate\"\n                            [defaultStartDate]=\"searchForm.value.checkInDate\"\n                            [defaultEndDate]=\"searchForm.value.checkOutDate\"\n                            id=\"searchbox-inp-checkout\"\n                            syncToId=\"searchbox-inp-checkin\"\n                            [isFirst]=\"false\"\n                            name=\"checkOutDate\"\n                            section=\"searchMyBooking\"\n                            type=\"text\"\n                            class=\"form-control form-calendar input-checkout button\">\n                          </div>\n                    </div>\n                    <div class=\"clearfix\"></div>\n                </div>\n                <!--for work personal-->\n                <div class=\"work-personal-box\" *ngIf=\"isShowLimitedRoomSelect()\">\n                    <div class=\"form-group input-num-of-guest\">\n                        <div class=\"pull-left col-left\">\n                            <label for=\"select1\">{{'search-box-room' | translate }}</label>\n                            <div class=\"select-ota-style\">\n                              <select id=\"search-select-room-personal\" class=\"select-room\" readonly>\n                                <option selected value=\"1\">1</option>\n                              </select>\n                            </div>\n                        </div>\n                        <div class=\"pull-right col-right\">\n                            <label for=\"select1\">{{'search-box-guest' | translate }}</label>\n                            <div class=\"select-ota-style\">\n                              <select id=\"search-select-guest-personal\" class=\"select-guest\" readonly (change)=\"handlerOnChangeAdultCount($event)\">\n                                <ng-template [ngIf]=\"shareBudget\">\n                                  <option *ngFor=\"let item of [1]\" [value]=\"2\">2</option>\n                                </ng-template>\n                                <ng-template [ngIf]=\"!shareBudget\">\n                                  <option *ngFor=\"let item of [1,2]; let i = index\" [attr.data-index]=\"i+1\" [value]=\"i+1\"\n                                    [selected]=\"i+1==currentRoom.adult\">{{i+1}}</option>\n                                </ng-template>\n                              </select>\n                            </div>\n                        </div>\n                        <div class=\"clearfix\"></div>\n                    </div>\n                </div>\n                <!--/end for work personal-->\n\n                <!--for travel-->\n                <div class=\"travel-box\"\n                  *ngIf=\"isShowFreeStyleRoomSelect()\"\n                >\n                <div class=\"form-group pull-left-lg\">\n                    <label for=\"select1\">{{'search-box-guest-count' | translate}}</label>\n                    <div readonly class=\"form-control form-select button input-num-of-guest select-room-guest\" id=\"search-btn-toggle-roombox\"  (click)=\"toggleRoomBox($event)\" [ngClass]=\"{'active': isShowRoomBox}\" #inputRoomBox>\n                      <div *ngIf=\"lang == 'en'\">\n                        <span>{{roomCount}} {{'search-box-room-in-choose' | translateSingularPlural: roomCount}}</span><span>, {{adultCount}} {{'search-box-adult' | translateSingularPlural: adultCount}}</span><span *ngIf=\"searchForm.value.purpose != 'work'\">, {{childCount}} <ng-container *ngIf=\"childCount == 1; else searchBoxEditChildElse\">{{'search-box-child' | translate}}</ng-container><ng-template #searchBoxEditChildElse>{{'search-box-children' | translate}}</ng-template></span>\n                      </div>\n\n                      <div *ngIf=\"lang == 'th'\">\n                        <span>{{roomCount}} {{'search-box-room-in-choose' | translate}}</span><span>, {{'search-box-adult' | translate}} {{adultCount}} {{'search-box-person' | translate}}</span><span *ngIf=\"searchForm.value.purpose != 'work'\">, {{'search-box-child' | translate}} {{childCount}} {{'search-box-person' | translate}}</span>\n                      </div>\n                    </div>\n\n                    <!-- showRoomBox -->\n                    <div class=\"form-group-pop select-room-popup-container -right\" [ngClass]=\"{'-show': isShowRoomBox}\" (click)=\"stopPropagation($event)\">\n                      <div class=\"select-room-popup\">\n                          <div class=\"select-room-box\">\n                              <div class=\"form-group-inline\">\n                                  <label for=\"select2\">{{'search-box-room' | translate}}</label>\n                                  <div class=\"select-ota-style box-sm\">\n                                      <select id=\"search-select-room\" (change)=\"handlerOnChangeRoom($event)\">\n                                          <option *ngFor=\"let item of [1,2,3,4,5,6,7,8,9]; let i = index\" [attr.data-index]=\"i+1\" [value]=\"i+1\" [selected]=\"i+1==roomCount\">{{i+1}}</option>\n                                      </select>\n                                  </div>\n                              </div>\n                          </div>\n                          <div class=\"selcet-detail-room-box\">\n                              <div class=\"tab-detail-room-list\">\n                                  <ul>\n                                      <li\n                                        [ngClass]=\"{'active': currentTabRoom == i+1}\"\n                                        *ngFor=\"let room of searchForm.value.guests; let i = index\" [attr.data-index]=\"i+1\"\n                                        (click)=\"setActiveTabRoom(i+1)\" id=\"search-btn-active-room-tab{{i}}\">\n                                          <a>{{'search-box-room-in-choose' | translate}} #{{i+1}}</a>\n                                      </li>\n                                  </ul>\n                                  <div class=\"wrapper-arrow-btn\" *ngIf=\"this.isRoomBoxShowArrow\">\n                                    <div\n                                      class=\"next\"\n                                      [ngClass]=\"{'disable': searchForm.value.guests.length == 1 || currentTabRoom == 1}\"\n                                      (click)=\"prevActiveTabRoom()\" id=\"search-btn-next-room-tab\">\n                                        <a class=\"disable\"><i class=\"icon-arrow-left\"></i></a>\n                                    </div>\n                                    <div\n                                        class=\"prev\"\n                                        [ngClass]=\"{'disable': currentTabRoom == searchForm.value.guests.length}\"\n                                        (click)=\"nextActiveTabRoom()\" id=\"search-btn-prev-room-tab\">\n                                        <a><i class=\"icon-arrow-right\"></i></a>\n                                    </div>\n                                  </div>\n                              </div>\n                              <div class=\"content-detail-room-list\">\n                                  <div class=\"box-overflow row\">\n                                      <div class=\"form-group col-sm-6\">\n                                        <label for=\"select3\">{{'search-box-adult' | translate}}</label>\n                                        <div class=\"select-ota-style\">\n                                          <select id=\"search-select-adult\" (change)=\"handlerOnChangeAdultCount($event)\">\n                                            <option\n                                              *ngFor=\"let item of [1,2,3,4,5,6,7,8]; let i = index\" [attr.data-index]=\"i+1\" [value]=\"i+1\" [selected]=\"i+1==currentRoom.adult\">{{i+1}}</option>\n                                          </select>\n                                        </div>\n                                      </div>\n                                      <div class=\"form-group col-sm-6\" *ngIf=\"searchForm.value.purpose != 'work'\">\n                                          <label for=\"select3\">{{'search-box-child' | translate}}</label>\n                                          <div class=\"select-ota-style select-child\">\n                                              <select id=\"search-select-child\" (change)=\"handlerOnChangeChildren($event)\">\n                                                <option\n                                                  *ngFor=\"let item of [0,1,2,3,4]; let i = index\" [attr.data-index]=\"i\" [value]=\"i\"\n                                                  [selected]=\"i==currentRoom.children.length\">{{i}}</option>\n                                              </select>\n                                          </div>\n                                      </div>\n\n                                  </div>\n\n                                  <!-- children how old? -->\n                                  <div *ngIf=\"currentRoom.children.length > 0\" class=\"box-overflow line-dot-top\">\n                                    <label for=\"select3\">{{'search-box-child-age' | translate}}</label>\n                                    <div class=\"row\">\n                                      <div class=\"col-sm-3 form-group\" *ngFor=\"let child of currentRoom.children; let i = index; trackBy:trackByChild\">\n                                        <div class=\"select-ota-style\">\n                                          <select id=\"search-select-child-age-{{i}}\" (change)=\"handlerOnChangeChildrenOld($event, i)\">\n                                            <option *ngFor=\"let item of [0,1,2,3,4,5,6,7,8,9,10,11,12]; let i = index\" [value]=\"i\" [selected]=\"i==child\">{{i}}</option>\n                                          </select>\n                                        </div>\n                                      </div>\n                                    </div>\n                                  </div>\n\n                              </div>\n                          </div>\n                      </div>\n                    </div>\n                    <!-- end showRoomBox -->\n                </div>\n                </div>\n                <!--/end for travel-->\n                <div (click)=\"cancleChangeSearch($event)\" class=\"ota-btn-sub btn-cancle-horizontal show-sm\">{{'btn-cancel' | translate}}</div>\n                <button type=\"submit\" class=\"ota-btn-main btn-submit-horizontal\" [ngClass]=\"{'unclickable': isLoading, 'loading': isLoading}\">{{'search-box-btn-search' | translate}}</button>\n                <div class=\"clearfix\"></div>\n\n                <div class=\"lvc-cancel\">\n                    <a (click)=\"cancleChangeSearch($event)\">{{'search-box-btn-cancel-change' | translate}}</a>\n                </div>\n              </form>\n            </div>\n          </div>\n          <!-- end search -->\n        </div>\n      </div>\n      <!--/search-top-wrap-->\n    </ng-template>\n\n\n  </div>\n  <!-- ng switch templates -->\n</div>\n"

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

module.exports = "<div class=\"privacy\">\n  <ng-container *ngIf=\"!isGetContentFromAPI\">\n    <div [innerHTML]=\"content | safeHTML\"></div>\n  </ng-container>\n  <ng-container *ngIf=\"isGetContentFromAPI\">\n    <div *ngIf=\"contentFromAPI\" [innerHTML]=\"contentFromAPI | safeHTML\"></div>\n    <div *ngIf=\"!contentFromAPI\" class=\"loading-wrapper\">\n      <img class=\"ota-loading\" src=\"assets/images/loading/loading.png\" />\n    </div>\n  </ng-container>\n</div>"

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wrapper {{ contentClass }}\">\n  <ng-content></ng-content>\n  <a *ngIf=\"showBtn\" tabindex=\"0\" id=\"{{_prefix?.page}}-btn-show-more-{{_prefix?.component}}\" class=\"action-btn\" (click)=\"switchBtn()\">\n    <i [ngClass]=\"{ 'icon-Showmore': !isDisplayAll, 'icon-arrow-show-less-round': isDisplayAll }\"></i>\n      <span>{{ (!isDisplayAll ? 'show-more-btn' : 'show-less-btn') | translate}}</span>\n  </a>\n</div>\n"

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <div *ngIf=\"isMobile; then mobile; else desktop\"></div>\n  <ng-template #desktop>\n    <div #wrapper class=\"wrapper\">\n      <div *ngFor=\"let img of images; let i = index;\" class=\"slide-item fadein\" [ngClass]=\"{'activeSlide': i === this.slideIndex}\" (click)=\"handleEvent(i)\">\n        <a class=\"cursor\">\n          <img class=\"img-slide\" [src]=\"img\" />\n        </a>\n      </div> \n    </div>\n  </ng-template>\n  <ng-template #mobile>\n    <div #wrapper class=\"wrapper\">\n      <div *ngFor=\"let img of mobileImages; let i = index;\" class=\"slide-item fadein\" [ngClass]=\"{'activeSlide': i === this.slideIndex}\" (click)=\"handleEvent(i)\">\n        <a class=\"cursor\">\n          <img class=\"img-slide-mobile\" [src]=\"img\" />\n        </a>\n      </div>\n    </div>\n  </ng-template> \n  <a class=\"prev\" (click)=\"prevSlide()\" >❮</a>\n  <a class=\"next\" (click)=\"nextSlide()\">❯</a>\n  <div #navDot class=\"nav-dot\">\n    <span *ngFor=\"let item of images; let i = index;\" (click)=\"setImageDisplay(i)\" class=\"dot\"></span>\n  </div>\n</div>"

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports = "<form [formGroup]=\"rangeForm\">\n  <input #minPrice type=\"text\" id=\"min-price\" name=\"min-price\" class=\"form-control left\"\n    formControlName=\"min{{displayPostfix}}\" (blur)=\"onInputBlured('min')\" (focus)=\"onInputFocused('min',$event)\"\n    (keyup.enter)=\"onInputEnter($event)\" (keypress)=\"validateNumber($event)\">\n\n  <span class=\"dash\">-</span>\n\n  <input #maxPrice type=\"text\" id=\"max-price\" name=\"max-price\" class=\"form-control right\"\n    formControlName=\"max{{displayPostfix}}\" (blur)=\"onInputBlured('max')\" (focus)=\"onInputFocused('max',$event)\"\n    (keyup.enter)=\"onInputEnter($event)\" (keypress)=\"validateNumber($event)\">\n\n  <div #sliderRange class=\"ota-slider-range\" [ngClass]=\"{'-zero-min-max': isZeroMinMax()}\"></div>\n\n  <button id=\"btn-filter-range\" type=\"submit\" style=\"display: none;\"></button>\n</form>\n"

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rating-row\">\n  <div class=\"rating-title\" id=\"star-rating-title-{{data.id}}\">{{ ratingTitle }}</div>\n  <div class=\"rating-stars\" (mouseleave)=\"reset()\">\n    <div class=\"rating-star\" *ngFor=\"let unit of contexts; let i = index\"\n      id=\"star-rating-{{data.id}}-{{i+1}}\"\n      [class.rating-fraction]=\"unit.fraction\"\n      [class.rating-selected]=\"unit.selected\"\n      [class.rating-active]=\"unit.active\"\n      (click)=\"unit.click($event)\"\n      (mouseenter)=\"unit.enter()\">\n    </div>\n  </div>\n  <div class=\"rating-desc\" id=\"star-rating-desc-{{data.id}}\">{{ ratingDesc }}</div>\n</div>\n"

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wrapper\">\n  <div *ngFor=\"let purpose of subscriptionData?.purposes;let i = index\" class=\"row m-0\">\n    <div class=\"box col-xs-10\">\n      <div>\n        <i class=\"icon icon-{{purpose?.icon}}\"></i>\n      </div>\n      <div class=\"box-text\">\n        <span class=\"title\">{{purpose?.title}}</span>\n        <span class=\"sub-title\">{{purpose?.subTitle}}</span>\n      </div>\n    </div>\n    <div class=\"col-xs-2\">\n      <act-toggle-button #toggle id=\"toggle-{{i}}\" class=\"toggle-button\" name=\"purpose-{{purpose?.purposeId}}\" [on]=\"purpose?.accepted\"\n        (toggled)=\"onTogglePurpose($event, purpose?.purposeId)\">\n      </act-toggle-button>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

module.exports = "<div class=\"terms-and-conditions\">\n  <ng-container *ngIf=\"!isGetContentFromAPI\">\n    <div [innerHTML]=\"content | safeHTML\"></div>\n  </ng-container>\n  <ng-container *ngIf=\"isGetContentFromAPI\">\n    <div *ngIf=\"contentFromAPI\" [innerHTML]=\"contentFromAPI | safeHTML\"></div>\n    <div *ngIf=\"!contentFromAPI\" class=\"loading-wrapper\">\n      <img class=\"ota-loading\" src=\"assets/images/loading/loading.png\" />\n    </div>\n  </ng-container>\n</div>"

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

module.exports = "<div class=\"toggle\">\n    <input class=\"toggle-input\" type=\"checkbox\" />\n    <button id=\"btn-toggle-{{name}}\" type=\"button\" class=\"toggle-btn {{className}}\" [ngClass]=\"{'toggle-btn-on': on , 'toggle-btn-off': !on }\" [attr.aria-expanded]=\"on\" [disabled]=\"disabledSwitch\" (click)=\"onClick()\"></button>\n</div>"

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

module.exports = "<div class=\"file-container\">\n  <div class=\"attach-result\" *ngIf=\"currentState !== STATE.NO_ATTACH\">\n    <div class=\"attach-files\" *ngFor=\"let file of currentFile; let i = index\">\n      <div class=\"file-icon\">\n        <i *ngIf=\"getFileTypeForDisplay(i) === FileTypes.PDF\" class=\"icon-pdf-bold\" alt=\"file-type-pdf\"></i>\n        <i *ngIf=\"getFileTypeForDisplay(i) === FileTypes.JPG\" class=\"icon-jpg-bold\" alt=\"file-type-jpg\"></i>\n        <i *ngIf=\"getFileTypeForDisplay(i) === FileTypes.PNG\" class=\"icon-png-bold\" alt=\"file-type-png\"></i>\n        <i *ngIf=\"getFileTypeForDisplay(i) === FileTypes.MSG\" class=\"icon-msg-bold\" alt=\"file-type-msg\"></i>\n        <i *ngIf=\"getFileTypeForDisplay(i) === FileTypes.EML\" class=\"icon-eml-bold\" alt=\"file-type-eml\"></i>\n      </div>\n      <div class=\"file-content\">\n        <span class=\"name\">{{ getCurrentFileName(i) }}</span>\n        <span class=\"size\">{{ getCurrentFileSize(i) }}</span>\n      </div>\n      <div class=\"file-clear\" *ngIf=\"canDeleteFile(i)\">\n        <span id=\"upload-file-btn-remove\" class=\"close-btn\" (click)=\"onCloseButtonClicked(i)\">\n          <i class=\"icon-delete2\" aria-hidden=\"true\"></i>\n        </span>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"button-container\" [class.attaching]=\"currentState === STATE.ATTACHING\" *ngIf=\"currentState !== STATE.FULL_ATTACH\">\n    <input type=\"file\" #inputFile name=\"file\" id=\"{{ options?.id }}\" class=\"inputfile\"\n      (change)=\"onFileUploadChanged($event)\" />\n\n    <div class=\"attach-choose\">\n      <div class=\"attach-choose-btn-warp\" [ngClass]=\"{disabled: isLoading}\">\n        <label id=\"upload-file-btn-file\" class=\"attach-button\" for=\"{{ options?.id }}\">\n          <i class=\"icon-attach\" aria-hidden=\"true\" *ngIf=\"!isLoading\"></i>\n          <span class=\"attach-title\" *ngIf=\"!isLoading\">{{ 'checkout-3-attach-file-choose-button' | translate }}</span>\n          <i class=\"loading\" *ngIf=\"isLoading\"></i>\n        </label>\n      </div>\n      <div class=\"attach-guide\">\n        {{ 'checkout-3-attach-file-guide' | translate }}\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container-title\">\n  <div class=\"title\">\n    {{ \"otp-title\" | translate }}\n  </div>\n  <div class=\"sub-title\">\n    {{ \"dialog-otp-verify-sub-header\" | translate }} <span class=\"bold\">{{selectedMethod.identity}}</span>\n    <ng-container *ngIf=\"selectedMethod.method == 'sms'\">\n      {{ \"dialog-otp-verify-sms-sub-header\" | translate }}\n    </ng-container>\n  </div>\n  <div *ngIf=\"selectedMethod.method == 'email'\" class=\"sub-title\">\n    {{ \"dialog-otp-verify-email-sub-header\" | translate }}\n  </div>\n</div>\n<div class=\"container-content\">\n  <form [formGroup]=\"otpInputForm\" id=\"{{elementId}}-form\" class=\"form-group\">\n    <div class=\"prefix-input\">A</div>\n    <span>-</span>\n    <input *ngFor=\"let ctrl of otpControls; let i = index\" id=\"{{elementId}}-input-{{i}}\" class=\"input-number\"\n      type=\"number\" inputmode=\"numeric\" min=\"1\" max=\"9\" [formControlName]=\"i\" (keydown)=\"onKeydown($event, i)\" (paste)=\"onPaste($event)\"\n      (input)=\"onOtpInput($event, i)\" />\n  </form>\n  <div class=\"message\">\n    <div id=\"{{elementId}}-text-reference\">{{ 'otp-reference' | translate }} <span>{{ referenceCode }}</span> </div>\n    <a id=\"{{elementId}}-text-link-resend\" class=\"text-link\" [ngClass]=\"{ 'text-link-disable' : coundown > 0 || sessionExpired }\"\n      (click)=\"onClickResendOTP()\">\n      {{ 'otp-resend' | translate }} <span *ngIf=\"coundown > 0\">({{ coundown }}s)</span>\n    </a>\n  </div>\n  <div class=\"error\" *ngIf=\"!!error\">\n    <i class=\"icon-warning\"></i>\n    <div id=\"{{elementId}}-text-error\" class=\"error-text\">{{ error }}</div>\n  </div>\n</div>"

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container-title\">\n  <div id=\"{{elementId}}-text-title\" class=\"title\">{{ 'otp-title' | translate }}</div>\n  <div id=\"{{elementId}}-text-sub-title\" class=\"sub-title\">\n    <span>{{ 'otp-select-channel'| translate }}</span>\n  </div>\n</div>\n<div class=\"container-content\">\n  <div *ngFor=\"let option of methods; let i = index;\">\n    <div [ngSwitch]=\"option.method\" class=\"verify-method-option\" [ngClass]=\"{ 'loading': isLoading }\"\n      (click)=\"onSelectMethod(option.method)\">\n      <ng-container *ngSwitchCase=\"'email'\">\n        <div class=\"verify-method-icon\">\n          <img class=\"sent-icon\" src=\"/assets/images/icons/icon-verify-by-email.svg\">\n        </div>\n        <div class=\"verify-method-box\">\n          <div class=\"verify-method-info\">\n            <span class=\"verify-method-title\">{{ 'email' | translate }}</span><br />\n            <span>{{ 'otp-send-to' | translate }}</span><br />\n            <strong>{{ option.identity }}</strong>\n          </div>\n          <div class=\"verify-next-btn\">\n            <i [ngClass]=\"isLoading && selectedMethod.method === 'email' ? 'loader':'icon-arrow-right'\"></i>\n          </div>\n        </div>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'sms'\">\n        <div class=\"verify-method-icon\">\n          <img class=\"sent-icon\" src=\"/assets/images/icons/icon-verify-by-sms.svg\">\n        </div>\n        <div class=\"verify-method-box\">\n          <div class=\"verify-method-info\">\n            <span class=\"verify-method-title\">{{ 'phone' | translate }}</span><br />\n            <span>{{ 'otp-send-to' | translate }}\n              <strong>{{ option.identity }}</strong>\n            </span>\n          </div>\n          <div class=\"verify-next-btn\">\n            <i [ngClass]=\"isLoading && selectedMethod.method === 'sms' ? 'loader':'icon-arrow-right'\"></i>\n          </div>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports = "<act-verify-method *ngIf=\"state == OTP_STATE.METHODS\" [methods]=\"methods\" [isLoading]=\"sendingRequestOtp\"\n  (selectMethod)=\"onSelectOtpMethod($event)\"></act-verify-method>\n<act-otp #otpChild *ngIf=\"state == OTP_STATE.OTP || state == OTP_STATE.SESSION_EXPIRE\" [isLoading]=\"isLoading\" [referenceCode]=\"otpReference\"\n  [selectedMethod]=\"selectedVerifyMethod\" [error]=\"errorMessage\" (clickResentOTP)=\"requestOTP($event)\" [sessionExpired]=\"sessionExpired\"></act-otp>"

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

module.exports = "<ota-dialog [closeAction]=\"handleCancel.bind(this)\" [mobileFullscreen]=\"true\" title=\"{{ title | translate}}\" subTitle=\"{{ subTitle | translate}}\"\n  [disbledClickBackground]=\"true\">\n  <div class=\"dialog-container\">\n    <form class=\"act-content-box\" [formGroup]=\"form\">\n      <div class=\"full-name-group\">\n        <label for=\"address-form-txt-address\">{{ 'my-profile-full-name-label' | translate }}</label>\n        <input id=\"{{pageElementName}}-input-full-name\" class=\"form-control\" name=\"fullName\"\n          placeholder=\"{{ 'my-profile-full-name-placeholder' | translate }}\"\n          formControlName=\"fullName\"\n          (blur)=\"removeSpaceBetween($event, 'fullName')\"\n          [ngClass]=\"{'input-error': isInvalid('fullName') && (touched('fullName') || isSubmit)}\"\n          maxlength=\"200\" />\n        <div *ngIf=\"!(isInvalid('fullName') && (touched('fullName') || isSubmit))\" class=\"sub-text mt-4\">\n          {{'full-name-description' | translate}}\n        </div>\n        <span *ngIf=\"hasError('fullName', 'required') && (touched('fullName') || isSubmit)\"\n          class=\"text-error\">\n          {{ 'validation-required-full-name' | translate }}\n        </span>\n        <span *ngIf=\"hasError('fullName', 'pattern') && (touched('fullName') || isSubmit)\"\n          class=\"text-error\">\n          {{ 'validation-pattern-full-name' | translate }}\n        </span>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"address-form-label-address\">{{ 'my-profile-birthday' | translate }}</label>\n        <div class=\"row ota-input-select-group mb-0\" >\n          <div class=\"col-md-4 pr-0 pl-16\">\n            <div class=\"select-ota-style\">\n              <select id=\"{{pageElementName}}-cbo-birthdate-date\" class=\"form-control\" formControlName=\"date\"\n                [ngClass]=\"{'input-error': isInvalidBirthDate() && isSubmit}\">\n                <option value=\"\" disabled [selected]=\"!profile.date\">{{ 'day-select' | translate }}\n                <option *ngFor=\"let date of dates\" [value]=\"date\">\n                  {{ date }}\n                </option>\n              </select></div>\n          </div>\n          <div class=\"col-md-4 pr-0 pl-16\">\n            <div class=\"select-ota-style\">\n              <select id=\"{{pageElementName}}-cbo-birthdate-month\" class=\"form-control\" formControlName=\"month\"\n                [ngClass]=\"{'input-error': isInvalidBirthDate() && isSubmit}\">\n                <option value=\"\" disabled [selected]=\"!profile.month\">{{ 'month-select' | translate }}</option>\n                <option *ngFor=\"let month of months\" [value]=\"month.value\">\n                  {{ month.label | translate }}\n                </option>\n              </select>\n            </div>\n          </div>\n          <div class=\"col-md-4 pl-16 pr-16\">\n            <div class=\"select-ota-style\">\n              <select id=\"{{pageElementName}}-cbo-birthdate-year\" class=\"form-control\" formControlName=\"year\"\n                [ngClass]=\"{'input-error': isInvalidBirthDate() && isSubmit}\">\n                <option value=\"\" disabled [selected]=\"!profile.year\">{{ 'year-select' | translate }}</option>\n                <option *ngFor=\"let year of years\" [value]=\"year\">\n                  {{ year | fullyear }}\n                </option>\n              </select>\n            </div>\n          </div>\n        </div>\n\n        <span *ngIf=\"isInvalidBirthDate() && isSubmit\" class=\"text-error mb-0\">\n          {{ 'validation-required-group-select-birth-date' | translate }}\n        </span>\n      </div>\n\n      <div class=\"form-group\">\n        <div class=\"time-of-birth\">\n          <label for=\"time-of-birth-form-label-time-of-birth\">{{ 'time-of-birth-label' | translate }}</label>\n\n          <div class=\"select-ota-style\">\n            <select id=\"{{pageElementName}}-cbo-time-of-birth\" class=\"form-control\" formControlName=\"timeOfBirth\"\n            [ngClass]=\"{'input-error': isInvalid('timeOfBirth') && isSubmit}\">\n              <option value=\"\" disabled [selected]=\"!profile.timeOfBirth\">{{ 'time-of-birth-placeholder' | translate }}</option>\n              <option *ngFor=\"let timeOfBirth of timeOfBirths\" [value]=\"timeOfBirth.value\">\n                {{ timeOfBirth.label | translate }}\n              </option>\n            </select>\n          </div>\n          <span *ngIf=\"hasError('timeOfBirth', 'required') && isSubmit\"\n            class=\"text-error\">\n            {{ 'validation-required-time-of-birth' | translate }}\n          </span>\n        </div>\n      </div>\n      <div [innerHtml]=\"'positive-energy-description' | translate\" class=\"text-description\">\n      </div>\n    </form>\n\n\n  </div>\n  <div class=\"action-button\">\n    <a class=\"hidden-xs\" id=\"{{pageElementName}}-a-cancel\" (click)=\"!isLoading && handleCancel()\">\n      {{ 'my-profile-address-form-btn-cancel' | translate }}\n    </a>\n\n    <button [disabled]=\"isLoading\" id=\"{{pageElementName}}-btn-cancel\"\n      class=\"ota-btn-default btn-horizontal visible-xs-block\" (click)=\"handleCancel()\">\n      {{ 'my-profile-address-form-btn-cancel' | translate }}\n    </button>\n    <button [disabled]=\"isLoading\" id=\"{{pageElementName}}-btn-submit\" class=\"ota-btn-main btn-horizontal\" tabindex=\"1\"\n      [ngClass]=\"{'loading': isLoading}\" (click)=\"onSubmit(form)\">\n      {{ submitText | translate }}\n    </button>\n  </div>\n\n</ota-dialog>\n"

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

module.exports = "<app-menu-bar theme=\"white\" notFoundPage=\"true\"></app-menu-bar>\n\n<div class=\"page-not-found\">\n  <div class=\"page-not-found-description\">\n    <img src=\"assets/images/ota404.png\" alt=\"\" class=\"img-responsive\">\n    <div class=\"text-not-found-strong\"><strong>Error 404 Page Not found</strong></div>\n    <div class=\"text-not-found\">The request URL was not found on this server. That's all we know.</div>\n  </div>\n</div>"

/***/ }),
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */
/***/ (function(module, exports) {

// Detect Andriod.
(function() {
  var ua = navigator.userAgent.toLowerCase();
  var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
  if(isAndroid) {
    var DHtml = document.getElementsByTagName('html')[0];
    var _className = DHtml.getAttribute('class');
    DHtml.setAttribute('class', _className + ' ANDRIOD');
  }
})();

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

// Detect Chrome.
(function() {
  if (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)) {
    var DHtml = document.getElementsByTagName('html')[0];
    var _className = DHtml.getAttribute('class');
    DHtml.setAttribute('class', _className + ' CHROME');
  }
  if (navigator.userAgent.match('CriOS')) {
    var DHtml = document.getElementsByTagName('html')[0];
    var _className = DHtml.getAttribute('class');
    DHtml.setAttribute('class', _className + ' CriOS');
  }
})();

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

// Detect IOS. to add Class 'IOS' on html.
(function() {
  if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
    var DHtml = document.getElementsByTagName('html')[0];
    var _className = DHtml.getAttribute('class');
    DHtml.setAttribute('class', _className + ' IOS');
  }
})();


/***/ }),
/* 1346 */
/***/ (function(module, exports) {

// TouchClass
// v1.2.0
// 2016 - 2017
// Author: Watcharakrit Phantu (WPH.)
// Description
// - Vanilla Js
// - Check browser has touch event.
// - Touch class for touch device state *use instead :active.
// - Add & remove when touchstart & touchend.
//   - Add & Remove on base user event. (user is using touch or mouse on the while).
// - Do not support lower than IE10.
// ====================================================
(function() {
  // Detect if have element that have class "lt-ie10"
  if ( document.getElementsByClassName('lt-ie10').length > 0 ) {
    // Is Browser is lower than IE10.
    var DHtml = document.getElementsByTagName('html')[0];
    var _className = DHtml.getAttribute('class');
    DHtml.setAttribute('class', _className + ' no-touch');
  } else {
    // Detect touch & no-touch base on Event.
    // ----------------------------------------------------
      var html = document.documentElement;
      var touchTimer;
      var isTouchEvent;
      var isNoTouchEvent;
      if ('ontouchstart' in window || 'ontouchstart' in document.documentElement) {
        html.classList.add('touch');
        isTouchEvent = true;
        isNoTouchEvent = false;
      } else {
        html.classList.add('no-touch');
        isTouchEvent = false;
        isNoTouchEvent = true;
      }

      document.addEventListener('touchstart', function() {
        html.classList.remove('no-touch');
        html.classList.add('touch');

        isTouchEvent = true;
        isNoTouchEvent = false;
        clearTimeout(touchTimer);
        touchTimer = setTimeout(function() {
          isTouchEvent = false;
        }, 400);
      }, true);

      document.addEventListener('mousemove', function() {
        if (!isTouchEvent && !isNoTouchEvent) {
          html.classList.remove('touch');
          html.classList.add('no-touch');
          isNoTouchEvent = true;
        }
      });
      // ----------------------------------------------------


      // Detect to addClass touch on Element that have basic class button.
      // ----------------------------------------------------
      // Pattern
      var patternContext = /(^body$|^html$)/i;
      var patternTag = /^a$|^button$/i;
      var patternClass = /button|^bt-|^btn-/;

      // Recusive Function to find Parent Element which match Context.
      var recFindUpElement = function(self, type) {
        var _self = self;
        while (_self) {
          if (patternContext.test(_self.tagName)) {
            break;
          } else if (patternTag.test(_self.tagName) || patternClass.test(_self.getAttribute('class'))) {
            // cancle with disabled.
            if (_self.hasAttribute('disabled')) { return false }

            if (type === 'ADD_TOUCH') {
              _self.classList.add('touch');
            } else {
              _self.classList.remove('touch');
            }
            break;
          } else {
            _self = _self.parentNode;
          }
        }
        return false;
      }

      // add touch class
      document.addEventListener('touchstart', function(event) {
        recFindUpElement(event.target, 'ADD_TOUCH');
      });

      // remove touch class
      document.addEventListener('touchend', function(event) {
        recFindUpElement(event.target, 'REMOVE_TOUCH');
      });
      // ----------------------------------------------------
  }
})();


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, jQuery) {/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
/**
 * Owl carousel
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 * @todo Lazy Load Icon
 * @todo prevent animationend bubling
 * @todo itemsScaleUp
 * @todo Test Zepto
 * @todo stagePadding calculate wrong active classes
 */
;(function($, window, document, undefined) {

	/**
	 * Creates a carousel.
	 * @class The Owl Carousel.
	 * @public
	 * @param {HTMLElement|jQuery} element - The element to create the carousel for.
	 * @param {Object} [options] - The options
	 */
	function Owl(element, options) {

		/**
		 * Current settings for the carousel.
		 * @public
		 */
		this.settings = null;

		/**
		 * Current options set by the caller including defaults.
		 * @public
		 */
		this.options = $.extend({}, Owl.Defaults, options);

		/**
		 * Plugin element.
		 * @public
		 */
		this.$element = $(element);

		/**
		 * Proxied event handlers.
		 * @protected
		 */
		this._handlers = {};

		/**
		 * References to the running plugins of this carousel.
		 * @protected
		 */
		this._plugins = {};

		/**
		 * Currently suppressed events to prevent them from being retriggered.
		 * @protected
		 */
		this._supress = {};

		/**
		 * Absolute current position.
		 * @protected
		 */
		this._current = null;

		/**
		 * Animation speed in milliseconds.
		 * @protected
		 */
		this._speed = null;

		/**
		 * Coordinates of all items in pixel.
		 * @todo The name of this member is missleading.
		 * @protected
		 */
		this._coordinates = [];

		/**
		 * Current breakpoint.
		 * @todo Real media queries would be nice.
		 * @protected
		 */
		this._breakpoint = null;

		/**
		 * Current width of the plugin element.
		 */
		this._width = null;

		/**
		 * All real items.
		 * @protected
		 */
		this._items = [];

		/**
		 * All cloned items.
		 * @protected
		 */
		this._clones = [];

		/**
		 * Merge values of all items.
		 * @todo Maybe this could be part of a plugin.
		 * @protected
		 */
		this._mergers = [];

		/**
		 * Widths of all items.
		 */
		this._widths = [];

		/**
		 * Invalidated parts within the update process.
		 * @protected
		 */
		this._invalidated = {};

		/**
		 * Ordered list of workers for the update process.
		 * @protected
		 */
		this._pipe = [];

		/**
		 * Current state information for the drag operation.
		 * @todo #261
		 * @protected
		 */
		this._drag = {
			time: null,
			target: null,
			pointer: null,
			stage: {
				start: null,
				current: null
			},
			direction: null
		};

		/**
		 * Current state information and their tags.
		 * @type {Object}
		 * @protected
		 */
		this._states = {
			current: {},
			tags: {
				'initializing': [ 'busy' ],
				'animating': [ 'busy' ],
				'dragging': [ 'interacting' ]
			}
		};

		$.each([ 'onResize', 'onThrottledResize' ], $.proxy(function(i, handler) {
			this._handlers[handler] = $.proxy(this[handler], this);
		}, this));

		$.each(Owl.Plugins, $.proxy(function(key, plugin) {
			this._plugins[key.charAt(0).toLowerCase() + key.slice(1)]
				= new plugin(this);
		}, this));

		$.each(Owl.Workers, $.proxy(function(priority, worker) {
			this._pipe.push({
				'filter': worker.filter,
				'run': $.proxy(worker.run, this)
			});
		}, this));

		this.setup();
		this.initialize();
	}

	/**
	 * Default options for the carousel.
	 * @public
	 */
	Owl.Defaults = {
		items: 3,
		loop: false,
		center: false,
		rewind: false,
		checkVisibility: true,

		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		freeDrag: false,

		margin: 0,
		stagePadding: 0,

		merge: false,
		mergeFit: true,
		autoWidth: false,

		startPosition: 0,
		rtl: false,

		smartSpeed: 250,
		fluidSpeed: false,
		dragEndSpeed: false,

		responsive: {},
		responsiveRefreshRate: 200,
		responsiveBaseElement: window,

		fallbackEasing: 'swing',
		slideTransition: '',

		info: false,

		nestedItemSelector: false,
		itemElement: 'div',
		stageElement: 'div',

		refreshClass: 'owl-refresh',
		loadedClass: 'owl-loaded',
		loadingClass: 'owl-loading',
		rtlClass: 'owl-rtl',
		responsiveClass: 'owl-responsive',
		dragClass: 'owl-drag',
		itemClass: 'owl-item',
		stageClass: 'owl-stage',
		stageOuterClass: 'owl-stage-outer',
		grabClass: 'owl-grab'
	};

	/**
	 * Enumeration for width.
	 * @public
	 * @readonly
	 * @enum {String}
	 */
	Owl.Width = {
		Default: 'default',
		Inner: 'inner',
		Outer: 'outer'
	};

	/**
	 * Enumeration for types.
	 * @public
	 * @readonly
	 * @enum {String}
	 */
	Owl.Type = {
		Event: 'event',
		State: 'state'
	};

	/**
	 * Contains all registered plugins.
	 * @public
	 */
	Owl.Plugins = {};

	/**
	 * List of workers involved in the update process.
	 */
	Owl.Workers = [ {
		filter: [ 'width', 'settings' ],
		run: function() {
			this._width = this.$element.width();
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			cache.current = this._items && this._items[this.relative(this._current)];
		}
	}, {
		filter: [ 'items', 'settings' ],
		run: function() {
			this.$stage.children('.cloned').remove();
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var margin = this.settings.margin || '',
				grid = !this.settings.autoWidth,
				rtl = this.settings.rtl,
				css = {
					'width': 'auto',
					'margin-left': rtl ? margin : '',
					'margin-right': rtl ? '' : margin
				};

			!grid && this.$stage.children().css(css);

			cache.css = css;
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var width = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
				merge = null,
				iterator = this._items.length,
				grid = !this.settings.autoWidth,
				widths = [];

			cache.items = {
				merge: false,
				width: width
			};

			while (iterator--) {
				merge = this._mergers[iterator];
				merge = this.settings.mergeFit && Math.min(merge, this.settings.items) || merge;

				cache.items.merge = merge > 1 || cache.items.merge;

				widths[iterator] = !grid ? this._items[iterator].width() : width * merge;
			}

			this._widths = widths;
		}
	}, {
		filter: [ 'items', 'settings' ],
		run: function() {
			var clones = [],
				items = this._items,
				settings = this.settings,
				// TODO: Should be computed from number of min width items in stage
				view = Math.max(settings.items * 2, 4),
				size = Math.ceil(items.length / 2) * 2,
				repeat = settings.loop && items.length ? settings.rewind ? view : Math.max(view, size) : 0,
				append = '',
				prepend = '';

			repeat /= 2;

			while (repeat > 0) {
				// Switch to only using appended clones
				clones.push(this.normalize(clones.length / 2, true));
				append = append + items[clones[clones.length - 1]][0].outerHTML;
				clones.push(this.normalize(items.length - 1 - (clones.length - 1) / 2, true));
				prepend = items[clones[clones.length - 1]][0].outerHTML + prepend;
				repeat -= 1;
			}

			this._clones = clones;

			$(append).addClass('cloned').appendTo(this.$stage);
			$(prepend).addClass('cloned').prependTo(this.$stage);
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function() {
			var rtl = this.settings.rtl ? 1 : -1,
				size = this._clones.length + this._items.length,
				iterator = -1,
				previous = 0,
				current = 0,
				coordinates = [];

			while (++iterator < size) {
				previous = coordinates[iterator - 1] || 0;
				current = this._widths[this.relative(iterator)] + this.settings.margin;
				coordinates.push(previous + current * rtl);
			}

			this._coordinates = coordinates;
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function() {
			var padding = this.settings.stagePadding,
				coordinates = this._coordinates,
				css = {
					'width': Math.ceil(Math.abs(coordinates[coordinates.length - 1])) + padding * 2,
					'padding-left': padding || '',
					'padding-right': padding || ''
				};

			this.$stage.css(css);
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var iterator = this._coordinates.length,
				grid = !this.settings.autoWidth,
				items = this.$stage.children();

			if (grid && cache.items.merge) {
				while (iterator--) {
					cache.css.width = this._widths[this.relative(iterator)];
					items.eq(iterator).css(cache.css);
				}
			} else if (grid) {
				cache.css.width = cache.items.width;
				items.css(cache.css);
			}
		}
	}, {
		filter: [ 'items' ],
		run: function() {
			this._coordinates.length < 1 && this.$stage.removeAttr('style');
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			cache.current = cache.current ? this.$stage.children().index(cache.current) : 0;
			cache.current = Math.max(this.minimum(), Math.min(this.maximum(), cache.current));
			this.reset(cache.current);
		}
	}, {
		filter: [ 'position' ],
		run: function() {
			this.animate(this.coordinates(this._current));
		}
	}, {
		filter: [ 'width', 'position', 'items', 'settings' ],
		run: function() {
			var rtl = this.settings.rtl ? 1 : -1,
				padding = this.settings.stagePadding * 2,
				begin = this.coordinates(this.current()) + padding,
				end = begin + this.width() * rtl,
				inner, outer, matches = [], i, n;

			for (i = 0, n = this._coordinates.length; i < n; i++) {
				inner = this._coordinates[i - 1] || 0;
				outer = Math.abs(this._coordinates[i]) + padding * rtl;

				if ((this.op(inner, '<=', begin) && (this.op(inner, '>', end)))
					|| (this.op(outer, '<', begin) && this.op(outer, '>', end))) {
					matches.push(i);
				}
			}

			this.$stage.children('.active').removeClass('active');
			this.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass('active');

			this.$stage.children('.center').removeClass('center');
			if (this.settings.center) {
				this.$stage.children().eq(this.current()).addClass('center');
			}
		}
	} ];

	/**
	 * Create the stage DOM element
	 */
	Owl.prototype.initializeStage = function() {
		this.$stage = this.$element.find('.' + this.settings.stageClass);

		// if the stage is already in the DOM, grab it and skip stage initialization
		if (this.$stage.length) {
			return;
		}

		this.$element.addClass(this.options.loadingClass);

		// create stage
		this.$stage = $('<' + this.settings.stageElement + '>', {
			"class": this.settings.stageClass
		}).wrap( $( '<div/>', {
			"class": this.settings.stageOuterClass
		}));

		// append stage
		this.$element.append(this.$stage.parent());
	};

	/**
	 * Create item DOM elements
	 */
	Owl.prototype.initializeItems = function() {
		var $items = this.$element.find('.owl-item');

		// if the items are already in the DOM, grab them and skip item initialization
		if ($items.length) {
			this._items = $items.get().map(function(item) {
				return $(item);
			});

			this._mergers = this._items.map(function() {
				return 1;
			});

			this.refresh();

			return;
		}

		// append content
		this.replace(this.$element.children().not(this.$stage.parent()));

		// check visibility
		if (this.isVisible()) {
			// update view
			this.refresh();
		} else {
			// invalidate width
			this.invalidate('width');
		}

		this.$element
			.removeClass(this.options.loadingClass)
			.addClass(this.options.loadedClass);
	};

	/**
	 * Initializes the carousel.
	 * @protected
	 */
	Owl.prototype.initialize = function() {
		this.enter('initializing');
		this.trigger('initialize');

		this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl);

		if (this.settings.autoWidth && !this.is('pre-loading')) {
			var imgs, nestedSelector, width;
			imgs = this.$element.find('img');
			nestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;
			width = this.$element.children(nestedSelector).width();

			if (imgs.length && width <= 0) {
				this.preloadAutoWidthImages(imgs);
			}
		}

		this.initializeStage();
		this.initializeItems();

		// register event handlers
		this.registerEventHandlers();

		this.leave('initializing');
		this.trigger('initialized');
	};

	/**
	 * @returns {Boolean} visibility of $element
	 *                    if you know the carousel will always be visible you can set `checkVisibility` to `false` to
	 *                    prevent the expensive browser layout forced reflow the $element.is(':visible') does
	 */
	Owl.prototype.isVisible = function() {
		return this.settings.checkVisibility
			? this.$element.is(':visible')
			: true;
	};

	/**
	 * Setups the current settings.
	 * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?
	 * @todo Support for media queries by using `matchMedia` would be nice.
	 * @public
	 */
	Owl.prototype.setup = function() {
		var viewport = this.viewport(),
			overwrites = this.options.responsive,
			match = -1,
			settings = null;

		if (!overwrites) {
			settings = $.extend({}, this.options);
		} else {
			$.each(overwrites, function(breakpoint) {
				if (breakpoint <= viewport && breakpoint > match) {
					match = Number(breakpoint);
				}
			});

			settings = $.extend({}, this.options, overwrites[match]);
			if (typeof settings.stagePadding === 'function') {
				settings.stagePadding = settings.stagePadding();
			}
			delete settings.responsive;

			// responsive class
			if (settings.responsiveClass) {
				this.$element.attr('class',
					this.$element.attr('class').replace(new RegExp('(' + this.options.responsiveClass + '-)\\S+\\s', 'g'), '$1' + match)
				);
			}
		}

		this.trigger('change', { property: { name: 'settings', value: settings } });
		this._breakpoint = match;
		this.settings = settings;
		this.invalidate('settings');
		this.trigger('changed', { property: { name: 'settings', value: this.settings } });
	};

	/**
	 * Updates option logic if necessery.
	 * @protected
	 */
	Owl.prototype.optionsLogic = function() {
		if (this.settings.autoWidth) {
			this.settings.stagePadding = false;
			this.settings.merge = false;
		}
	};

	/**
	 * Prepares an item before add.
	 * @todo Rename event parameter `content` to `item`.
	 * @protected
	 * @returns {jQuery|HTMLElement} - The item container.
	 */
	Owl.prototype.prepare = function(item) {
		var event = this.trigger('prepare', { content: item });

		if (!event.data) {
			event.data = $('<' + this.settings.itemElement + '/>')
				.addClass(this.options.itemClass).append(item)
		}

		this.trigger('prepared', { content: event.data });

		return event.data;
	};

	/**
	 * Updates the view.
	 * @public
	 */
	Owl.prototype.update = function() {
		var i = 0,
			n = this._pipe.length,
			filter = $.proxy(function(p) { return this[p] }, this._invalidated),
			cache = {};

		while (i < n) {
			if (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {
				this._pipe[i].run(cache);
			}
			i++;
		}

		this._invalidated = {};

		!this.is('valid') && this.enter('valid');
	};

	/**
	 * Gets the width of the view.
	 * @public
	 * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.
	 * @returns {Number} - The width of the view in pixel.
	 */
	Owl.prototype.width = function(dimension) {
		dimension = dimension || Owl.Width.Default;
		switch (dimension) {
			case Owl.Width.Inner:
			case Owl.Width.Outer:
				return this._width;
			default:
				return this._width - this.settings.stagePadding * 2 + this.settings.margin;
		}
	};

	/**
	 * Refreshes the carousel primarily for adaptive purposes.
	 * @public
	 */
	Owl.prototype.refresh = function() {
		this.enter('refreshing');
		this.trigger('refresh');

		this.setup();

		this.optionsLogic();

		this.$element.addClass(this.options.refreshClass);

		this.update();

		this.$element.removeClass(this.options.refreshClass);

		this.leave('refreshing');
		this.trigger('refreshed');
	};

	/**
	 * Checks window `resize` event.
	 * @protected
	 */
	Owl.prototype.onThrottledResize = function() {
		window.clearTimeout(this.resizeTimer);
		this.resizeTimer = window.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);
	};

	/**
	 * Checks window `resize` event.
	 * @protected
	 */
	Owl.prototype.onResize = function() {
		if (!this._items.length) {
			return false;
		}

		if (this._width === this.$element.width()) {
			return false;
		}

		if (!this.isVisible()) {
			return false;
		}

		this.enter('resizing');

		if (this.trigger('resize').isDefaultPrevented()) {
			this.leave('resizing');
			return false;
		}

		this.invalidate('width');

		this.refresh();

		this.leave('resizing');
		this.trigger('resized');
	};

	/**
	 * Registers event handlers.
	 * @todo Check `msPointerEnabled`
	 * @todo #261
	 * @protected
	 */
	Owl.prototype.registerEventHandlers = function() {
		if ($.support.transition) {
			this.$stage.on($.support.transition.end + '.owl.core', $.proxy(this.onTransitionEnd, this));
		}

		if (this.settings.responsive !== false) {
			this.on(window, 'resize', this._handlers.onThrottledResize);
		}

		if (this.settings.mouseDrag) {
			this.$element.addClass(this.options.dragClass);
			this.$stage.on('mousedown.owl.core', $.proxy(this.onDragStart, this));
			this.$stage.on('dragstart.owl.core selectstart.owl.core', function() { return false });
		}

		if (this.settings.touchDrag){
			this.$stage.on('touchstart.owl.core', $.proxy(this.onDragStart, this));
			this.$stage.on('touchcancel.owl.core', $.proxy(this.onDragEnd, this));
		}
	};

	/**
	 * Handles `touchstart` and `mousedown` events.
	 * @todo Horizontal swipe threshold as option
	 * @todo #261
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragStart = function(event) {
		var stage = null;

		if (event.which === 3) {
			return;
		}

		if ($.support.transform) {
			stage = this.$stage.css('transform').replace(/.*\(|\)| /g, '').split(',');
			stage = {
				x: stage[stage.length === 16 ? 12 : 4],
				y: stage[stage.length === 16 ? 13 : 5]
			};
		} else {
			stage = this.$stage.position();
			stage = {
				x: this.settings.rtl ?
					stage.left + this.$stage.width() - this.width() + this.settings.margin :
					stage.left,
				y: stage.top
			};
		}

		if (this.is('animating')) {
			$.support.transform ? this.animate(stage.x) : this.$stage.stop()
			this.invalidate('position');
		}

		this.$element.toggleClass(this.options.grabClass, event.type === 'mousedown');

		this.speed(0);

		this._drag.time = new Date().getTime();
		this._drag.target = $(event.target);
		this._drag.stage.start = stage;
		this._drag.stage.current = stage;
		this._drag.pointer = this.pointer(event);

		$(document).on('mouseup.owl.core touchend.owl.core', $.proxy(this.onDragEnd, this));

		$(document).one('mousemove.owl.core touchmove.owl.core', $.proxy(function(event) {
			var delta = this.difference(this._drag.pointer, this.pointer(event));

			$(document).on('mousemove.owl.core touchmove.owl.core', $.proxy(this.onDragMove, this));

			if (Math.abs(delta.x) < Math.abs(delta.y) && this.is('valid')) {
				return;
			}

			event.preventDefault();

			this.enter('dragging');
			this.trigger('drag');
		}, this));
	};

	/**
	 * Handles the `touchmove` and `mousemove` events.
	 * @todo #261
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragMove = function(event) {
		var minimum = null,
			maximum = null,
			pull = null,
			delta = this.difference(this._drag.pointer, this.pointer(event)),
			stage = this.difference(this._drag.stage.start, delta);

		if (!this.is('dragging')) {
			return;
		}

		event.preventDefault();

		if (this.settings.loop) {
			minimum = this.coordinates(this.minimum());
			maximum = this.coordinates(this.maximum() + 1) - minimum;
			stage.x = (((stage.x - minimum) % maximum + maximum) % maximum) + minimum;
		} else {
			minimum = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());
			maximum = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());
			pull = this.settings.pullDrag ? -1 * delta.x / 5 : 0;
			stage.x = Math.max(Math.min(stage.x, minimum + pull), maximum + pull);
		}

		this._drag.stage.current = stage;

		this.animate(stage.x);
	};

	/**
	 * Handles the `touchend` and `mouseup` events.
	 * @todo #261
	 * @todo Threshold for click event
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragEnd = function(event) {
		var delta = this.difference(this._drag.pointer, this.pointer(event)),
			stage = this._drag.stage.current,
			direction = delta.x > 0 ^ this.settings.rtl ? 'left' : 'right';

		$(document).off('.owl.core');

		this.$element.removeClass(this.options.grabClass);

		if (delta.x !== 0 && this.is('dragging') || !this.is('valid')) {
			this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);
			this.current(this.closest(stage.x, delta.x !== 0 ? direction : this._drag.direction));
			this.invalidate('position');
			this.update();

			this._drag.direction = direction;

			if ((Math.abs(delta.x) > 3 || new Date().getTime() - this._drag.time > 300) && event.type === 'mouseup') {
				this._drag.target.one('click.owl.core', function() { return false; });
			}
		}

		if (!this.is('dragging')) {
			return;
		}

		this.leave('dragging');
		this.trigger('dragged');
	};

	/**
	 * Gets absolute position of the closest item for a coordinate.
	 * @todo Setting `freeDrag` makes `closest` not reusable. See #165.
	 * @protected
	 * @param {Number} coordinate - The coordinate in pixel.
	 * @param {String} direction - The direction to check for the closest item. Ether `left` or `right`.
	 * @return {Number} - The absolute position of the closest item.
	 */
	Owl.prototype.closest = function(coordinate, direction) {
		var position = -1,
			pull = 30,
			width = this.width(),
			coordinates = this.coordinates();

		if (!this.settings.freeDrag) {
			// check closest item
			$.each(coordinates, $.proxy(function(index, value) {
				// on a left pull, check on current index
				if (direction === 'left' && coordinate > value - pull && coordinate < value + pull) {
					position = index;
				// on a right pull, check on previous index
				// to do so, subtract width from value and set position = index + 1
				} else if (direction === 'right' && coordinate > value - width - pull && coordinate < value - width + pull) {
					position = index + 1;
				} else if (this.op(coordinate, '<', value)
					&& this.op(coordinate, '>', coordinates[index + 1] !== undefined ? coordinates[index + 1] : value - width)) {
					position = direction === 'left' ? index + 1 : index;
				}
				return position === -1;
			}, this));
		}

		if (!this.settings.loop) {
			// non loop boundries
			if (this.op(coordinate, '>', coordinates[this.minimum()])) {
				position = coordinate = this.minimum();
			} else if (this.op(coordinate, '<', coordinates[this.maximum()])) {
				position = coordinate = this.maximum();
			}
		}

		return position;
	};

	/**
	 * Animates the stage.
	 * @todo #270
	 * @public
	 * @param {Number} coordinate - The coordinate in pixels.
	 */
	Owl.prototype.animate = function(coordinate) {
		var animate = this.speed() > 0;

		this.is('animating') && this.onTransitionEnd();

		if (animate) {
			this.enter('animating');
			this.trigger('translate');
		}

		if ($.support.transform3d && $.support.transition) {
			this.$stage.css({
				transform: 'translate3d(' + coordinate + 'px,0px,0px)',
				transition: (this.speed() / 1000) + 's' + (
					this.settings.slideTransition ? ' ' + this.settings.slideTransition : ''
				)
			});
		} else if (animate) {
			this.$stage.animate({
				left: coordinate + 'px'
			}, this.speed(), this.settings.fallbackEasing, $.proxy(this.onTransitionEnd, this));
		} else {
			this.$stage.css({
				left: coordinate + 'px'
			});
		}
	};

	/**
	 * Checks whether the carousel is in a specific state or not.
	 * @param {String} state - The state to check.
	 * @returns {Boolean} - The flag which indicates if the carousel is busy.
	 */
	Owl.prototype.is = function(state) {
		return this._states.current[state] && this._states.current[state] > 0;
	};

	/**
	 * Sets the absolute position of the current item.
	 * @public
	 * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.
	 * @returns {Number} - The absolute position of the current item.
	 */
	Owl.prototype.current = function(position) {
		if (position === undefined) {
			return this._current;
		}

		if (this._items.length === 0) {
			return undefined;
		}

		position = this.normalize(position);

		if (this._current !== position) {
			var event = this.trigger('change', { property: { name: 'position', value: position } });

			if (event.data !== undefined) {
				position = this.normalize(event.data);
			}

			this._current = position;

			this.invalidate('position');

			this.trigger('changed', { property: { name: 'position', value: this._current } });
		}

		return this._current;
	};

	/**
	 * Invalidates the given part of the update routine.
	 * @param {String} [part] - The part to invalidate.
	 * @returns {Array.<String>} - The invalidated parts.
	 */
	Owl.prototype.invalidate = function(part) {
		if ($.type(part) === 'string') {
			this._invalidated[part] = true;
			this.is('valid') && this.leave('valid');
		}
		return $.map(this._invalidated, function(v, i) { return i });
	};

	/**
	 * Resets the absolute position of the current item.
	 * @public
	 * @param {Number} position - The absolute position of the new item.
	 */
	Owl.prototype.reset = function(position) {
		position = this.normalize(position);

		if (position === undefined) {
			return;
		}

		this._speed = 0;
		this._current = position;

		this.suppress([ 'translate', 'translated' ]);

		this.animate(this.coordinates(position));

		this.release([ 'translate', 'translated' ]);
	};

	/**
	 * Normalizes an absolute or a relative position of an item.
	 * @public
	 * @param {Number} position - The absolute or relative position to normalize.
	 * @param {Boolean} [relative=false] - Whether the given position is relative or not.
	 * @returns {Number} - The normalized position.
	 */
	Owl.prototype.normalize = function(position, relative) {
		var n = this._items.length,
			m = relative ? 0 : this._clones.length;

		if (!this.isNumeric(position) || n < 1) {
			position = undefined;
		} else if (position < 0 || position >= n + m) {
			position = ((position - m / 2) % n + n) % n + m / 2;
		}

		return position;
	};

	/**
	 * Converts an absolute position of an item into a relative one.
	 * @public
	 * @param {Number} position - The absolute position to convert.
	 * @returns {Number} - The converted position.
	 */
	Owl.prototype.relative = function(position) {
		position -= this._clones.length / 2;
		return this.normalize(position, true);
	};

	/**
	 * Gets the maximum position for the current item.
	 * @public
	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
	 * @returns {Number}
	 */
	Owl.prototype.maximum = function(relative) {
		var settings = this.settings,
			maximum = this._coordinates.length,
			iterator,
			reciprocalItemsWidth,
			elementWidth;

		if (settings.loop) {
			maximum = this._clones.length / 2 + this._items.length - 1;
		} else if (settings.autoWidth || settings.merge) {
			iterator = this._items.length;
			if (iterator) {
				reciprocalItemsWidth = this._items[--iterator].width();
				elementWidth = this.$element.width();
				while (iterator--) {
					reciprocalItemsWidth += this._items[iterator].width() + this.settings.margin;
					if (reciprocalItemsWidth > elementWidth) {
						break;
					}
				}
			}
			maximum = iterator + 1;
		} else if (settings.center) {
			maximum = this._items.length - 1;
		} else {
			maximum = this._items.length - settings.items;
		}

		if (relative) {
			maximum -= this._clones.length / 2;
		}

		return Math.max(maximum, 0);
	};

	/**
	 * Gets the minimum position for the current item.
	 * @public
	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
	 * @returns {Number}
	 */
	Owl.prototype.minimum = function(relative) {
		return relative ? 0 : this._clones.length / 2;
	};

	/**
	 * Gets an item at the specified relative position.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
	 */
	Owl.prototype.items = function(position) {
		if (position === undefined) {
			return this._items.slice();
		}

		position = this.normalize(position, true);
		return this._items[position];
	};

	/**
	 * Gets an item at the specified relative position.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
	 */
	Owl.prototype.mergers = function(position) {
		if (position === undefined) {
			return this._mergers.slice();
		}

		position = this.normalize(position, true);
		return this._mergers[position];
	};

	/**
	 * Gets the absolute positions of clones for an item.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.
	 */
	Owl.prototype.clones = function(position) {
		var odd = this._clones.length / 2,
			even = odd + this._items.length,
			map = function(index) { return index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2 };

		if (position === undefined) {
			return $.map(this._clones, function(v, i) { return map(i) });
		}

		return $.map(this._clones, function(v, i) { return v === position ? map(i) : null });
	};

	/**
	 * Sets the current animation speed.
	 * @public
	 * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.
	 * @returns {Number} - The current animation speed in milliseconds.
	 */
	Owl.prototype.speed = function(speed) {
		if (speed !== undefined) {
			this._speed = speed;
		}

		return this._speed;
	};

	/**
	 * Gets the coordinate of an item.
	 * @todo The name of this method is missleanding.
	 * @public
	 * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.
	 * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.
	 */
	Owl.prototype.coordinates = function(position) {
		var multiplier = 1,
			newPosition = position - 1,
			coordinate;

		if (position === undefined) {
			return $.map(this._coordinates, $.proxy(function(coordinate, index) {
				return this.coordinates(index);
			}, this));
		}

		if (this.settings.center) {
			if (this.settings.rtl) {
				multiplier = -1;
				newPosition = position + 1;
			}

			coordinate = this._coordinates[position];
			coordinate += (this.width() - coordinate + (this._coordinates[newPosition] || 0)) / 2 * multiplier;
		} else {
			coordinate = this._coordinates[newPosition] || 0;
		}

		coordinate = Math.ceil(coordinate);

		return coordinate;
	};

	/**
	 * Calculates the speed for a translation.
	 * @protected
	 * @param {Number} from - The absolute position of the start item.
	 * @param {Number} to - The absolute position of the target item.
	 * @param {Number} [factor=undefined] - The time factor in milliseconds.
	 * @returns {Number} - The time in milliseconds for the translation.
	 */
	Owl.prototype.duration = function(from, to, factor) {
		if (factor === 0) {
			return 0;
		}

		return Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs((factor || this.settings.smartSpeed));
	};

	/**
	 * Slides to the specified item.
	 * @public
	 * @param {Number} position - The position of the item.
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.to = function(position, speed) {
		var current = this.current(),
			revert = null,
			distance = position - this.relative(current),
			direction = (distance > 0) - (distance < 0),
			items = this._items.length,
			minimum = this.minimum(),
			maximum = this.maximum();

		if (this.settings.loop) {
			if (!this.settings.rewind && Math.abs(distance) > items / 2) {
				distance += direction * -1 * items;
			}

			position = current + distance;
			revert = ((position - minimum) % items + items) % items + minimum;

			if (revert !== position && revert - distance <= maximum && revert - distance > 0) {
				current = revert - distance;
				position = revert;
				this.reset(current);
			}
		} else if (this.settings.rewind) {
			maximum += 1;
			position = (position % maximum + maximum) % maximum;
		} else {
			position = Math.max(minimum, Math.min(maximum, position));
		}

		this.speed(this.duration(current, position, speed));
		this.current(position);

		if (this.isVisible()) {
			this.update();
		}
	};

	/**
	 * Slides to the next item.
	 * @public
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.next = function(speed) {
		speed = speed || false;
		this.to(this.relative(this.current()) + 1, speed);
	};

	/**
	 * Slides to the previous item.
	 * @public
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.prev = function(speed) {
		speed = speed || false;
		this.to(this.relative(this.current()) - 1, speed);
	};

	/**
	 * Handles the end of an animation.
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onTransitionEnd = function(event) {

		// if css2 animation then event object is undefined
		if (event !== undefined) {
			event.stopPropagation();

			// Catch only owl-stage transitionEnd event
			if ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {
				return false;
			}
		}

		this.leave('animating');
		this.trigger('translated');
	};

	/**
	 * Gets viewport width.
	 * @protected
	 * @return {Number} - The width in pixel.
	 */
	Owl.prototype.viewport = function() {
		var width;
		if (this.options.responsiveBaseElement !== window) {
			width = $(this.options.responsiveBaseElement).width();
		} else if (window.innerWidth) {
			width = window.innerWidth;
		} else if (document.documentElement && document.documentElement.clientWidth) {
			width = document.documentElement.clientWidth;
		} else {
			console.warn('Can not detect viewport width.');
		}
		return width;
	};

	/**
	 * Replaces the current content.
	 * @public
	 * @param {HTMLElement|jQuery|String} content - The new content.
	 */
	Owl.prototype.replace = function(content) {
		this.$stage.empty();
		this._items = [];

		if (content) {
			content = (content instanceof jQuery) ? content : $(content);
		}

		if (this.settings.nestedItemSelector) {
			content = content.find('.' + this.settings.nestedItemSelector);
		}

		content.filter(function() {
			return this.nodeType === 1;
		}).each($.proxy(function(index, item) {
			item = this.prepare(item);
			this.$stage.append(item);
			this._items.push(item);
			this._mergers.push(item.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		}, this));

		this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);

		this.invalidate('items');
	};

	/**
	 * Adds an item.
	 * @todo Use `item` instead of `content` for the event arguments.
	 * @public
	 * @param {HTMLElement|jQuery|String} content - The item content to add.
	 * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.
	 */
	Owl.prototype.add = function(content, position) {
		var current = this.relative(this._current);

		position = position === undefined ? this._items.length : this.normalize(position, true);
		content = content instanceof jQuery ? content : $(content);

		this.trigger('add', { content: content, position: position });

		content = this.prepare(content);

		if (this._items.length === 0 || position === this._items.length) {
			this._items.length === 0 && this.$stage.append(content);
			this._items.length !== 0 && this._items[position - 1].after(content);
			this._items.push(content);
			this._mergers.push(content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		} else {
			this._items[position].before(content);
			this._items.splice(position, 0, content);
			this._mergers.splice(position, 0, content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		}

		this._items[current] && this.reset(this._items[current].index());

		this.invalidate('items');

		this.trigger('added', { content: content, position: position });
	};

	/**
	 * Removes an item by its position.
	 * @todo Use `item` instead of `content` for the event arguments.
	 * @public
	 * @param {Number} position - The relative position of the item to remove.
	 */
	Owl.prototype.remove = function(position) {
		position = this.normalize(position, true);

		if (position === undefined) {
			return;
		}

		this.trigger('remove', { content: this._items[position], position: position });

		this._items[position].remove();
		this._items.splice(position, 1);
		this._mergers.splice(position, 1);

		this.invalidate('items');

		this.trigger('removed', { content: null, position: position });
	};

	/**
	 * Preloads images with auto width.
	 * @todo Replace by a more generic approach
	 * @protected
	 */
	Owl.prototype.preloadAutoWidthImages = function(images) {
		images.each($.proxy(function(i, element) {
			this.enter('pre-loading');
			element = $(element);
			$(new Image()).one('load', $.proxy(function(e) {
				element.attr('src', e.target.src);
				element.css('opacity', 1);
				this.leave('pre-loading');
				!this.is('pre-loading') && !this.is('initializing') && this.refresh();
			}, this)).attr('src', element.attr('src') || element.attr('data-src') || element.attr('data-src-retina'));
		}, this));
	};

	/**
	 * Destroys the carousel.
	 * @public
	 */
	Owl.prototype.destroy = function() {

		this.$element.off('.owl.core');
		this.$stage.off('.owl.core');
		$(document).off('.owl.core');

		if (this.settings.responsive !== false) {
			window.clearTimeout(this.resizeTimer);
			this.off(window, 'resize', this._handlers.onThrottledResize);
		}

		for (var i in this._plugins) {
			this._plugins[i].destroy();
		}

		this.$stage.children('.cloned').remove();

		this.$stage.unwrap();
		this.$stage.children().contents().unwrap();
		this.$stage.children().unwrap();
		this.$stage.remove();
		this.$element
			.removeClass(this.options.refreshClass)
			.removeClass(this.options.loadingClass)
			.removeClass(this.options.loadedClass)
			.removeClass(this.options.rtlClass)
			.removeClass(this.options.dragClass)
			.removeClass(this.options.grabClass)
			.attr('class', this.$element.attr('class').replace(new RegExp(this.options.responsiveClass + '-\\S+\\s', 'g'), ''))
			.removeData('owl.carousel');
	};

	/**
	 * Operators to calculate right-to-left and left-to-right.
	 * @protected
	 * @param {Number} [a] - The left side operand.
	 * @param {String} [o] - The operator.
	 * @param {Number} [b] - The right side operand.
	 */
	Owl.prototype.op = function(a, o, b) {
		var rtl = this.settings.rtl;
		switch (o) {
			case '<':
				return rtl ? a > b : a < b;
			case '>':
				return rtl ? a < b : a > b;
			case '>=':
				return rtl ? a <= b : a >= b;
			case '<=':
				return rtl ? a >= b : a <= b;
			default:
				break;
		}
	};

	/**
	 * Attaches to an internal event.
	 * @protected
	 * @param {HTMLElement} element - The event source.
	 * @param {String} event - The event name.
	 * @param {Function} listener - The event handler to attach.
	 * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.
	 */
	Owl.prototype.on = function(element, event, listener, capture) {
		if (element.addEventListener) {
			element.addEventListener(event, listener, capture);
		} else if (element.attachEvent) {
			element.attachEvent('on' + event, listener);
		}
	};

	/**
	 * Detaches from an internal event.
	 * @protected
	 * @param {HTMLElement} element - The event source.
	 * @param {String} event - The event name.
	 * @param {Function} listener - The attached event handler to detach.
	 * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.
	 */
	Owl.prototype.off = function(element, event, listener, capture) {
		if (element.removeEventListener) {
			element.removeEventListener(event, listener, capture);
		} else if (element.detachEvent) {
			element.detachEvent('on' + event, listener);
		}
	};

	/**
	 * Triggers a public event.
	 * @todo Remove `status`, `relatedTarget` should be used instead.
	 * @protected
	 * @param {String} name - The event name.
	 * @param {*} [data=null] - The event data.
	 * @param {String} [namespace=carousel] - The event namespace.
	 * @param {String} [state] - The state which is associated with the event.
	 * @param {Boolean} [enter=false] - Indicates if the call enters the specified state or not.
	 * @returns {Event} - The event arguments.
	 */
	Owl.prototype.trigger = function(name, data, namespace, state, enter) {
		var status = {
			item: { count: this._items.length, index: this.current() }
		}, handler = $.camelCase(
			$.grep([ 'on', name, namespace ], function(v) { return v })
				.join('-').toLowerCase()
		), event = $.Event(
			[ name, 'owl', namespace || 'carousel' ].join('.').toLowerCase(),
			$.extend({ relatedTarget: this }, status, data)
		);

		if (!this._supress[name]) {
			$.each(this._plugins, function(name, plugin) {
				if (plugin.onTrigger) {
					plugin.onTrigger(event);
				}
			});

			this.register({ type: Owl.Type.Event, name: name });
			this.$element.trigger(event);

			if (this.settings && typeof this.settings[handler] === 'function') {
				this.settings[handler].call(this, event);
			}
		}

		return event;
	};

	/**
	 * Enters a state.
	 * @param name - The state name.
	 */
	Owl.prototype.enter = function(name) {
		$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
			if (this._states.current[name] === undefined) {
				this._states.current[name] = 0;
			}

			this._states.current[name]++;
		}, this));
	};

	/**
	 * Leaves a state.
	 * @param name - The state name.
	 */
	Owl.prototype.leave = function(name) {
		$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
			this._states.current[name]--;
		}, this));
	};

	/**
	 * Registers an event or state.
	 * @public
	 * @param {Object} object - The event or state to register.
	 */
	Owl.prototype.register = function(object) {
		if (object.type === Owl.Type.Event) {
			if (!$.event.special[object.name]) {
				$.event.special[object.name] = {};
			}

			if (!$.event.special[object.name].owl) {
				var _default = $.event.special[object.name]._default;
				$.event.special[object.name]._default = function(e) {
					if (_default && _default.apply && (!e.namespace || e.namespace.indexOf('owl') === -1)) {
						return _default.apply(this, arguments);
					}
					return e.namespace && e.namespace.indexOf('owl') > -1;
				};
				$.event.special[object.name].owl = true;
			}
		} else if (object.type === Owl.Type.State) {
			if (!this._states.tags[object.name]) {
				this._states.tags[object.name] = object.tags;
			} else {
				this._states.tags[object.name] = this._states.tags[object.name].concat(object.tags);
			}

			this._states.tags[object.name] = $.grep(this._states.tags[object.name], $.proxy(function(tag, i) {
				return $.inArray(tag, this._states.tags[object.name]) === i;
			}, this));
		}
	};

	/**
	 * Suppresses events.
	 * @protected
	 * @param {Array.<String>} events - The events to suppress.
	 */
	Owl.prototype.suppress = function(events) {
		$.each(events, $.proxy(function(index, event) {
			this._supress[event] = true;
		}, this));
	};

	/**
	 * Releases suppressed events.
	 * @protected
	 * @param {Array.<String>} events - The events to release.
	 */
	Owl.prototype.release = function(events) {
		$.each(events, $.proxy(function(index, event) {
			delete this._supress[event];
		}, this));
	};

	/**
	 * Gets unified pointer coordinates from event.
	 * @todo #261
	 * @protected
	 * @param {Event} - The `mousedown` or `touchstart` event.
	 * @returns {Object} - Contains `x` and `y` coordinates of current pointer position.
	 */
	Owl.prototype.pointer = function(event) {
		var result = { x: null, y: null };

		event = event.originalEvent || event || window.event;

		event = event.touches && event.touches.length ?
			event.touches[0] : event.changedTouches && event.changedTouches.length ?
				event.changedTouches[0] : event;

		if (event.pageX) {
			result.x = event.pageX;
			result.y = event.pageY;
		} else {
			result.x = event.clientX;
			result.y = event.clientY;
		}

		return result;
	};

	/**
	 * Determines if the input is a Number or something that can be coerced to a Number
	 * @protected
	 * @param {Number|String|Object|Array|Boolean|RegExp|Function|Symbol} - The input to be tested
	 * @returns {Boolean} - An indication if the input is a Number or can be coerced to a Number
	 */
	Owl.prototype.isNumeric = function(number) {
		return !isNaN(parseFloat(number));
	};

	/**
	 * Gets the difference of two vectors.
	 * @todo #261
	 * @protected
	 * @param {Object} - The first vector.
	 * @param {Object} - The second vector.
	 * @returns {Object} - The difference.
	 */
	Owl.prototype.difference = function(first, second) {
		return {
			x: first.x - second.x,
			y: first.y - second.y
		};
	};

	/**
	 * The jQuery Plugin for the Owl Carousel
	 * @todo Navigation plugin `next` and `prev`
	 * @public
	 */
	$.fn.owlCarousel = function(option) {
		var args = Array.prototype.slice.call(arguments, 1);

		return this.each(function() {
			var $this = $(this),
				data = $this.data('owl.carousel');

			if (!data) {
				data = new Owl(this, typeof option == 'object' && option);
				$this.data('owl.carousel', data);

				$.each([
					'next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'
				], function(i, event) {
					data.register({ type: Owl.Type.Event, name: event });
					data.$element.on(event + '.owl.carousel.core', $.proxy(function(e) {
						if (e.namespace && e.relatedTarget !== this) {
							this.suppress([ event ]);
							data[event].apply(this, [].slice.call(arguments, 1));
							this.release([ event ]);
						}
					}, data));
				});
			}

			if (typeof option == 'string' && option.charAt(0) !== '_') {
				data[option].apply(data, args);
			}
		});
	};

	/**
	 * The constructor for the jQuery Plugin
	 * @public
	 */
	$.fn.owlCarousel.Constructor = Owl;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * AutoRefresh Plugin
 * @version 2.3.4
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the auto refresh plugin.
	 * @class The Auto Refresh Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var AutoRefresh = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Refresh interval.
		 * @protected
		 * @type {number}
		 */
		this._interval = null;

		/**
		 * Whether the element is currently visible or not.
		 * @protected
		 * @type {Boolean}
		 */
		this._visible = null;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoRefresh) {
					this.watch();
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, AutoRefresh.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	AutoRefresh.Defaults = {
		autoRefresh: true,
		autoRefreshInterval: 500
	};

	/**
	 * Watches the element.
	 */
	AutoRefresh.prototype.watch = function() {
		if (this._interval) {
			return;
		}

		this._visible = this._core.isVisible();
		this._interval = window.setInterval($.proxy(this.refresh, this), this._core.settings.autoRefreshInterval);
	};

	/**
	 * Refreshes the element.
	 */
	AutoRefresh.prototype.refresh = function() {
		if (this._core.isVisible() === this._visible) {
			return;
		}

		this._visible = !this._visible;

		this._core.$element.toggleClass('owl-hidden', !this._visible);

		this._visible && (this._core.invalidate('width') && this._core.refresh());
	};

	/**
	 * Destroys the plugin.
	 */
	AutoRefresh.prototype.destroy = function() {
		var handler, property;

		window.clearInterval(this._interval);

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.AutoRefresh = AutoRefresh;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Lazy Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the lazy plugin.
	 * @class The Lazy Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Lazy = function(carousel) {

		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Already loaded items.
		 * @protected
		 * @type {Array.<jQuery>}
		 */
		this._loaded = [];

		/**
		 * Event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel change.owl.carousel resized.owl.carousel': $.proxy(function(e) {
				if (!e.namespace) {
					return;
				}

				if (!this._core.settings || !this._core.settings.lazyLoad) {
					return;
				}

				if ((e.property && e.property.name == 'position') || e.type == 'initialized') {
					var settings = this._core.settings,
						n = (settings.center && Math.ceil(settings.items / 2) || settings.items),
						i = ((settings.center && n * -1) || 0),
						position = (e.property && e.property.value !== undefined ? e.property.value : this._core.current()) + i,
						clones = this._core.clones().length,
						load = $.proxy(function(i, v) { this.load(v) }, this);
					//TODO: Need documentation for this new option
					if (settings.lazyLoadEager > 0) {
						n += settings.lazyLoadEager;
						// If the carousel is looping also preload images that are to the "left"
						if (settings.loop) {
              position -= settings.lazyLoadEager;
              n++;
            }
					}

					while (i++ < n) {
						this.load(clones / 2 + this._core.relative(position));
						clones && $.each(this._core.clones(this._core.relative(position)), load);
						position++;
					}
				}
			}, this)
		};

		// set the default options
		this._core.options = $.extend({}, Lazy.Defaults, this._core.options);

		// register event handler
		this._core.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	Lazy.Defaults = {
		lazyLoad: false,
		lazyLoadEager: 0
	};

	/**
	 * Loads all resources of an item at the specified position.
	 * @param {Number} position - The absolute position of the item.
	 * @protected
	 */
	Lazy.prototype.load = function(position) {
		var $item = this._core.$stage.children().eq(position),
			$elements = $item && $item.find('.owl-lazy');

		if (!$elements || $.inArray($item.get(0), this._loaded) > -1) {
			return;
		}

		$elements.each($.proxy(function(index, element) {
			var $element = $(element), image,
                url = (window.devicePixelRatio > 1 && $element.attr('data-src-retina')) || $element.attr('data-src') || $element.attr('data-srcset');

			this._core.trigger('load', { element: $element, url: url }, 'lazy');

			if ($element.is('img')) {
				$element.one('load.owl.lazy', $.proxy(function() {
					$element.css('opacity', 1);
					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
				}, this)).attr('src', url);
            } else if ($element.is('source')) {
                $element.one('load.owl.lazy', $.proxy(function() {
                    this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
                }, this)).attr('srcset', url);
			} else {
				image = new Image();
				image.onload = $.proxy(function() {
					$element.css({
						'background-image': 'url("' + url + '")',
						'opacity': '1'
					});
					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
				}, this);
				image.src = url;
			}
		}, this));

		this._loaded.push($item.get(0));
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Lazy.prototype.destroy = function() {
		var handler, property;

		for (handler in this.handlers) {
			this._core.$element.off(handler, this.handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * AutoHeight Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the auto height plugin.
	 * @class The Auto Height Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var AutoHeight = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		this._previousHeight = null;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight) {
					this.update();
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight && e.property.name === 'position'){
					this.update();
				}
			}, this),
			'loaded.owl.lazy': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight
					&& e.element.closest('.' + this._core.settings.itemClass).index() === this._core.current()) {
					this.update();
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);
		this._intervalId = null;
		var refThis = this;

		// These changes have been taken from a PR by gavrochelegnou proposed in #1575
		// and have been made compatible with the latest jQuery version
		$(window).on('load', function() {
			if (refThis._core.settings.autoHeight) {
				refThis.update();
			}
		});

		// Autoresize the height of the carousel when window is resized
		// When carousel has images, the height is dependent on the width
		// and should also change on resize
		$(window).resize(function() {
			if (refThis._core.settings.autoHeight) {
				if (refThis._intervalId != null) {
					clearTimeout(refThis._intervalId);
				}

				refThis._intervalId = setTimeout(function() {
					refThis.update();
				}, 250);
			}
		});

	};

	/**
	 * Default options.
	 * @public
	 */
	AutoHeight.Defaults = {
		autoHeight: false,
		autoHeightClass: 'owl-height'
	};

	/**
	 * Updates the view.
	 */
	AutoHeight.prototype.update = function() {
		var start = this._core._current,
			end = start + this._core.settings.items,
			lazyLoadEnabled = this._core.settings.lazyLoad,
			visible = this._core.$stage.children().toArray().slice(start, end),
			heights = [],
			maxheight = 0;

		$.each(visible, function(index, item) {
			heights.push($(item).height());
		});

		maxheight = Math.max.apply(null, heights);

		if (maxheight <= 1 && lazyLoadEnabled && this._previousHeight) {
			maxheight = this._previousHeight;
		}

		this._previousHeight = maxheight;

		this._core.$stage.parent()
			.height(maxheight)
			.addClass(this._core.settings.autoHeightClass);
	};

	AutoHeight.prototype.destroy = function() {
		var handler, property;

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] !== 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Video Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the video plugin.
	 * @class The Video Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Video = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Cache all video URLs.
		 * @protected
		 * @type {Object}
		 */
		this._videos = {};

		/**
		 * Current playing item.
		 * @protected
		 * @type {jQuery}
		 */
		this._playing = null;

		/**
		 * All event handlers.
		 * @todo The cloned content removale is too late
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					this._core.register({ type: 'state', name: 'playing', tags: [ 'interacting' ] });
				}
			}, this),
			'resize.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.video && this.isInFullScreen()) {
					e.preventDefault();
				}
			}, this),
			'refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.is('resizing')) {
					this._core.$stage.find('.cloned .owl-video-frame').remove();
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'position' && this._playing) {
					this.stop();
				}
			}, this),
			'prepared.owl.carousel': $.proxy(function(e) {
				if (!e.namespace) {
					return;
				}

				var $element = $(e.content).find('.owl-video');

				if ($element.length) {
					$element.css('display', 'none');
					this.fetch($element, $(e.content));
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Video.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);

		this._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function(e) {
			this.play(e);
		}, this));
	};

	/**
	 * Default options.
	 * @public
	 */
	Video.Defaults = {
		video: false,
		videoHeight: false,
		videoWidth: false
	};

	/**
	 * Gets the video ID and the type (YouTube/Vimeo/vzaar only).
	 * @protected
	 * @param {jQuery} target - The target containing the video data.
	 * @param {jQuery} item - The item containing the video.
	 */
	Video.prototype.fetch = function(target, item) {
			var type = (function() {
					if (target.attr('data-vimeo-id')) {
						return 'vimeo';
					} else if (target.attr('data-vzaar-id')) {
						return 'vzaar'
					} else {
						return 'youtube';
					}
				})(),
				id = target.attr('data-vimeo-id') || target.attr('data-youtube-id') || target.attr('data-vzaar-id'),
				width = target.attr('data-width') || this._core.settings.videoWidth,
				height = target.attr('data-height') || this._core.settings.videoHeight,
				url = target.attr('href');

		if (url) {

			/*
					Parses the id's out of the following urls (and probably more):
					https://www.youtube.com/watch?v=:id
					https://youtu.be/:id
					https://vimeo.com/:id
					https://vimeo.com/channels/:channel/:id
					https://vimeo.com/groups/:group/videos/:id
					https://app.vzaar.com/videos/:id

					Visual example: https://regexper.com/#(http%3A%7Chttps%3A%7C)%5C%2F%5C%2F(player.%7Cwww.%7Capp.)%3F(vimeo%5C.com%7Cyoutu(be%5C.com%7C%5C.be%7Cbe%5C.googleapis%5C.com)%7Cvzaar%5C.com)%5C%2F(video%5C%2F%7Cvideos%5C%2F%7Cembed%5C%2F%7Cchannels%5C%2F.%2B%5C%2F%7Cgroups%5C%2F.%2B%5C%2F%7Cwatch%5C%3Fv%3D%7Cv%5C%2F)%3F(%5BA-Za-z0-9._%25-%5D*)(%5C%26%5CS%2B)%3F
			*/

			id = url.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

			if (id[3].indexOf('youtu') > -1) {
				type = 'youtube';
			} else if (id[3].indexOf('vimeo') > -1) {
				type = 'vimeo';
			} else if (id[3].indexOf('vzaar') > -1) {
				type = 'vzaar';
			} else {
				throw new Error('Video URL not supported.');
			}
			id = id[6];
		} else {
			throw new Error('Missing video URL.');
		}

		this._videos[url] = {
			type: type,
			id: id,
			width: width,
			height: height
		};

		item.attr('data-video', url);

		this.thumbnail(target, this._videos[url]);
	};

	/**
	 * Creates video thumbnail.
	 * @protected
	 * @param {jQuery} target - The target containing the video data.
	 * @param {Object} info - The video info object.
	 * @see `fetch`
	 */
	Video.prototype.thumbnail = function(target, video) {
		var tnLink,
			icon,
			path,
			dimensions = video.width && video.height ? 'width:' + video.width + 'px;height:' + video.height + 'px;' : '',
			customTn = target.find('img'),
			srcType = 'src',
			lazyClass = '',
			settings = this._core.settings,
			create = function(path) {
				icon = '<div class="owl-video-play-icon"></div>';

				if (settings.lazyLoad) {
					tnLink = $('<div/>',{
						"class": 'owl-video-tn ' + lazyClass,
						"srcType": path
					});
				} else {
					tnLink = $( '<div/>', {
						"class": "owl-video-tn",
						"style": 'opacity:1;background-image:url(' + path + ')'
					});
				}
				target.after(tnLink);
				target.after(icon);
			};

		// wrap video content into owl-video-wrapper div
		target.wrap( $( '<div/>', {
			"class": "owl-video-wrapper",
			"style": dimensions
		}));

		if (this._core.settings.lazyLoad) {
			srcType = 'data-src';
			lazyClass = 'owl-lazy';
		}

		// custom thumbnail
		if (customTn.length) {
			create(customTn.attr(srcType));
			customTn.remove();
			return false;
		}

		if (video.type === 'youtube') {
			path = "//img.youtube.com/vi/" + video.id + "/hqdefault.jpg";
			create(path);
		} else if (video.type === 'vimeo') {
			$.ajax({
				type: 'GET',
				url: '//vimeo.com/api/v2/video/' + video.id + '.json',
				jsonp: 'callback',
				dataType: 'jsonp',
				success: function(data) {
					path = data[0].thumbnail_large;
					create(path);
				}
			});
		} else if (video.type === 'vzaar') {
			$.ajax({
				type: 'GET',
				url: '//vzaar.com/api/videos/' + video.id + '.json',
				jsonp: 'callback',
				dataType: 'jsonp',
				success: function(data) {
					path = data.framegrab_url;
					create(path);
				}
			});
		}
	};

	/**
	 * Stops the current video.
	 * @public
	 */
	Video.prototype.stop = function() {
		this._core.trigger('stop', null, 'video');
		this._playing.find('.owl-video-frame').remove();
		this._playing.removeClass('owl-video-playing');
		this._playing = null;
		this._core.leave('playing');
		this._core.trigger('stopped', null, 'video');
	};

	/**
	 * Starts the current video.
	 * @public
	 * @param {Event} event - The event arguments.
	 */
	Video.prototype.play = function(event) {
		var target = $(event.target),
			item = target.closest('.' + this._core.settings.itemClass),
			video = this._videos[item.attr('data-video')],
			width = video.width || '100%',
			height = video.height || this._core.$stage.height(),
			html,
			iframe;

		if (this._playing) {
			return;
		}

		this._core.enter('playing');
		this._core.trigger('play', null, 'video');

		item = this._core.items(this._core.relative(item.index()));

		this._core.reset(item.index());

		html = $( '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>' );
		html.attr( 'height', height );
		html.attr( 'width', width );
		if (video.type === 'youtube') {
			html.attr( 'src', '//www.youtube.com/embed/' + video.id + '?autoplay=1&rel=0&v=' + video.id );
		} else if (video.type === 'vimeo') {
			html.attr( 'src', '//player.vimeo.com/video/' + video.id + '?autoplay=1' );
		} else if (video.type === 'vzaar') {
			html.attr( 'src', '//view.vzaar.com/' + video.id + '/player?autoplay=true' );
		}

		iframe = $(html).wrap( '<div class="owl-video-frame" />' ).insertAfter(item.find('.owl-video'));

		this._playing = item.addClass('owl-video-playing');
	};

	/**
	 * Checks whether an video is currently in full screen mode or not.
	 * @todo Bad style because looks like a readonly method but changes members.
	 * @protected
	 * @returns {Boolean}
	 */
	Video.prototype.isInFullScreen = function() {
		var element = document.fullscreenElement || document.mozFullScreenElement ||
				document.webkitFullscreenElement;

		return element && $(element).parent().hasClass('owl-video-frame');
	};

	/**
	 * Destroys the plugin.
	 */
	Video.prototype.destroy = function() {
		var handler, property;

		this._core.$element.off('click.owl.video');

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Video = Video;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Animate Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the animate plugin.
	 * @class The Navigation Plugin
	 * @param {Owl} scope - The Owl Carousel
	 */
	var Animate = function(scope) {
		this.core = scope;
		this.core.options = $.extend({}, Animate.Defaults, this.core.options);
		this.swapping = true;
		this.previous = undefined;
		this.next = undefined;

		this.handlers = {
			'change.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name == 'position') {
					this.previous = this.core.current();
					this.next = e.property.value;
				}
			}, this),
			'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					this.swapping = e.type == 'translated';
				}
			}, this),
			'translate.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {
					this.swap();
				}
			}, this)
		};

		this.core.$element.on(this.handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	Animate.Defaults = {
		animateOut: false,
		animateIn: false
	};

	/**
	 * Toggles the animation classes whenever an translations starts.
	 * @protected
	 * @returns {Boolean|undefined}
	 */
	Animate.prototype.swap = function() {

		if (this.core.settings.items !== 1) {
			return;
		}

		if (!$.support.animation || !$.support.transition) {
			return;
		}

		this.core.speed(0);

		var left,
			clear = $.proxy(this.clear, this),
			previous = this.core.$stage.children().eq(this.previous),
			next = this.core.$stage.children().eq(this.next),
			incoming = this.core.settings.animateIn,
			outgoing = this.core.settings.animateOut;

		if (this.core.current() === this.previous) {
			return;
		}

		if (outgoing) {
			left = this.core.coordinates(this.previous) - this.core.coordinates(this.next);
			previous.one($.support.animation.end, clear)
				.css( { 'left': left + 'px' } )
				.addClass('animated owl-animated-out')
				.addClass(outgoing);
		}

		if (incoming) {
			next.one($.support.animation.end, clear)
				.addClass('animated owl-animated-in')
				.addClass(incoming);
		}
	};

	Animate.prototype.clear = function(e) {
		$(e.target).css( { 'left': '' } )
			.removeClass('animated owl-animated-out owl-animated-in')
			.removeClass(this.core.settings.animateIn)
			.removeClass(this.core.settings.animateOut);
		this.core.onTransitionEnd();
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Animate.prototype.destroy = function() {
		var handler, property;

		for (handler in this.handlers) {
			this.core.$element.off(handler, this.handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Animate = Animate;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Autoplay Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author Artus Kolanowski
 * @author David Deutsch
 * @author Tom De Caluwé
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the autoplay plugin.
	 * @class The Autoplay Plugin
	 * @param {Owl} scope - The Owl Carousel
	 */
	var Autoplay = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * The autoplay timeout id.
		 * @type {Number}
		 */
		this._call = null;

		/**
		 * Depending on the state of the plugin, this variable contains either
		 * the start time of the timer or the current timer value if it's
		 * paused. Since we start in a paused state we initialize the timer
		 * value.
		 * @type {Number}
		 */
		this._time = 0;

		/**
		 * Stores the timeout currently used.
		 * @type {Number}
		 */
		this._timeout = 0;

		/**
		 * Indicates whenever the autoplay is paused.
		 * @type {Boolean}
		 */
		this._paused = true;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'settings') {
					if (this._core.settings.autoplay) {
						this.play();
					} else {
						this.stop();
					}
				} else if (e.namespace && e.property.name === 'position' && this._paused) {
					// Reset the timer. This code is triggered when the position
					// of the carousel was changed through user interaction.
					this._time = 0;
				}
			}, this),
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoplay) {
					this.play();
				}
			}, this),
			'play.owl.autoplay': $.proxy(function(e, t, s) {
				if (e.namespace) {
					this.play(t, s);
				}
			}, this),
			'stop.owl.autoplay': $.proxy(function(e) {
				if (e.namespace) {
					this.stop();
				}
			}, this),
			'mouseover.owl.autoplay': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.pause();
				}
			}, this),
			'mouseleave.owl.autoplay': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.play();
				}
			}, this),
			'touchstart.owl.core': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.pause();
				}
			}, this),
			'touchend.owl.core': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause) {
					this.play();
				}
			}, this)
		};

		// register event handlers
		this._core.$element.on(this._handlers);

		// set default options
		this._core.options = $.extend({}, Autoplay.Defaults, this._core.options);
	};

	/**
	 * Default options.
	 * @public
	 */
	Autoplay.Defaults = {
		autoplay: false,
		autoplayTimeout: 5000,
		autoplayHoverPause: false,
		autoplaySpeed: false
	};

	/**
	 * Transition to the next slide and set a timeout for the next transition.
	 * @private
	 * @param {Number} [speed] - The animation speed for the animations.
	 */
	Autoplay.prototype._next = function(speed) {
		this._call = window.setTimeout(
			$.proxy(this._next, this, speed),
			this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()
		);

		if (this._core.is('interacting') || document.hidden) {
			return;
		}
		this._core.next(speed || this._core.settings.autoplaySpeed);
	}

	/**
	 * Reads the current timer value when the timer is playing.
	 * @public
	 */
	Autoplay.prototype.read = function() {
		return new Date().getTime() - this._time;
	};

	/**
	 * Starts the autoplay.
	 * @public
	 * @param {Number} [timeout] - The interval before the next animation starts.
	 * @param {Number} [speed] - The animation speed for the animations.
	 */
	Autoplay.prototype.play = function(timeout, speed) {
		var elapsed;

		if (!this._core.is('rotating')) {
			this._core.enter('rotating');
		}

		timeout = timeout || this._core.settings.autoplayTimeout;

		// Calculate the elapsed time since the last transition. If the carousel
		// wasn't playing this calculation will yield zero.
		elapsed = Math.min(this._time % (this._timeout || timeout), timeout);

		if (this._paused) {
			// Start the clock.
			this._time = this.read();
			this._paused = false;
		} else {
			// Clear the active timeout to allow replacement.
			window.clearTimeout(this._call);
		}

		// Adjust the origin of the timer to match the new timeout value.
		this._time += this.read() % timeout - elapsed;

		this._timeout = timeout;
		this._call = window.setTimeout($.proxy(this._next, this, speed), timeout - elapsed);
	};

	/**
	 * Stops the autoplay.
	 * @public
	 */
	Autoplay.prototype.stop = function() {
		if (this._core.is('rotating')) {
			// Reset the clock.
			this._time = 0;
			this._paused = true;

			window.clearTimeout(this._call);
			this._core.leave('rotating');
		}
	};

	/**
	 * Pauses the autoplay.
	 * @public
	 */
	Autoplay.prototype.pause = function() {
		if (this._core.is('rotating') && !this._paused) {
			// Pause the clock.
			this._time = this.read();
			this._paused = true;

			window.clearTimeout(this._call);
		}
	};

	/**
	 * Destroys the plugin.
	 */
	Autoplay.prototype.destroy = function() {
		var handler, property;

		this.stop();

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Navigation Plugin
 * @version 2.3.4
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {
	'use strict';

	/**
	 * Creates the navigation plugin.
	 * @class The Navigation Plugin
	 * @param {Owl} carousel - The Owl Carousel.
	 */
	var Navigation = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Indicates whether the plugin is initialized or not.
		 * @protected
		 * @type {Boolean}
		 */
		this._initialized = false;

		/**
		 * The current paging indexes.
		 * @protected
		 * @type {Array}
		 */
		this._pages = [];

		/**
		 * All DOM elements of the user interface.
		 * @protected
		 * @type {Object}
		 */
		this._controls = {};

		/**
		 * Markup for an indicator.
		 * @protected
		 * @type {Array.<String>}
		 */
		this._templates = [];

		/**
		 * The carousel element.
		 * @type {jQuery}
		 */
		this.$element = this._core.$element;

		/**
		 * Overridden methods of the carousel.
		 * @protected
		 * @type {Object}
		 */
		this._overrides = {
			next: this._core.next,
			prev: this._core.prev,
			to: this._core.to
		};

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'prepared.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.push('<div class="' + this._core.settings.dotClass + '">' +
						$(e.content).find('[data-dot]').addBack('[data-dot]').attr('data-dot') + '</div>');
				}
			}, this),
			'added.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.splice(e.position, 0, this._templates.pop());
				}
			}, this),
			'remove.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.splice(e.position, 1);
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name == 'position') {
					this.draw();
				}
			}, this),
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && !this._initialized) {
					this._core.trigger('initialize', null, 'navigation');
					this.initialize();
					this.update();
					this.draw();
					this._initialized = true;
					this._core.trigger('initialized', null, 'navigation');
				}
			}, this),
			'refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._initialized) {
					this._core.trigger('refresh', null, 'navigation');
					this.update();
					this.draw();
					this._core.trigger('refreshed', null, 'navigation');
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Navigation.Defaults, this._core.options);

		// register event handlers
		this.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 * @todo Rename `slideBy` to `navBy`
	 */
	Navigation.Defaults = {
		nav: false,
		navText: [
			'<span aria-label="' + 'Previous' + '">&#x2039;</span>',
			'<span aria-label="' + 'Next' + '">&#x203a;</span>'
		],
		navSpeed: false,
		navElement: 'button type="button" role="presentation"',
		navContainer: false,
		navContainerClass: 'owl-nav',
		navClass: [
			'owl-prev',
			'owl-next'
		],
		slideBy: 1,
		dotClass: 'owl-dot',
		dotsClass: 'owl-dots',
		dots: true,
		dotsEach: false,
		dotsData: false,
		dotsSpeed: false,
		dotsContainer: false
	};

	/**
	 * Initializes the layout of the plugin and extends the carousel.
	 * @protected
	 */
	Navigation.prototype.initialize = function() {
		var override,
			settings = this._core.settings;

		// create DOM structure for relative navigation
		this._controls.$relative = (settings.navContainer ? $(settings.navContainer)
			: $('<div>').addClass(settings.navContainerClass).appendTo(this.$element)).addClass('disabled');

		this._controls.$previous = $('<' + settings.navElement + '>')
			.addClass(settings.navClass[0])
			.html(settings.navText[0])
			.prependTo(this._controls.$relative)
			.on('click', $.proxy(function(e) {
				this.prev(settings.navSpeed);
			}, this));
		this._controls.$next = $('<' + settings.navElement + '>')
			.addClass(settings.navClass[1])
			.html(settings.navText[1])
			.appendTo(this._controls.$relative)
			.on('click', $.proxy(function(e) {
				this.next(settings.navSpeed);
			}, this));

		// create DOM structure for absolute navigation
		if (!settings.dotsData) {
			this._templates = [ $('<button role="button">')
				.addClass(settings.dotClass)
				.append($('<span>'))
				.prop('outerHTML') ];
		}

		this._controls.$absolute = (settings.dotsContainer ? $(settings.dotsContainer)
			: $('<div>').addClass(settings.dotsClass).appendTo(this.$element)).addClass('disabled');

		this._controls.$absolute.on('click', 'button', $.proxy(function(e) {
			var index = $(e.target).parent().is(this._controls.$absolute)
				? $(e.target).index() : $(e.target).parent().index();

			e.preventDefault();

			this.to(index, settings.dotsSpeed);
		}, this));

		/*$el.on('focusin', function() {
			$(document).off(".carousel");

			$(document).on('keydown.carousel', function(e) {
				if(e.keyCode == 37) {
					$el.trigger('prev.owl')
				}
				if(e.keyCode == 39) {
					$el.trigger('next.owl')
				}
			});
		});*/

		// override public methods of the carousel
		for (override in this._overrides) {
			this._core[override] = $.proxy(this[override], this);
		}
	};

	/**
	 * Destroys the plugin.
	 * @protected
	 */
	Navigation.prototype.destroy = function() {
		var handler, control, property, override, settings;
		settings = this._core.settings;

		for (handler in this._handlers) {
			this.$element.off(handler, this._handlers[handler]);
		}
		for (control in this._controls) {
			if (control === '$relative' && settings.navContainer) {
				this._controls[control].html('');
			} else {
				this._controls[control].remove();
			}
		}
		for (override in this.overides) {
			this._core[override] = this._overrides[override];
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	/**
	 * Updates the internal state.
	 * @protected
	 */
	Navigation.prototype.update = function() {
		var i, j, k,
			lower = this._core.clones().length / 2,
			upper = lower + this._core.items().length,
			maximum = this._core.maximum(true),
			settings = this._core.settings,
			size = settings.center || settings.autoWidth || settings.dotsData
				? 1 : settings.dotsEach || settings.items;

		if (settings.slideBy !== 'page') {
			settings.slideBy = Math.min(settings.slideBy, settings.items);
		}

		if (settings.dots || settings.slideBy == 'page') {
			this._pages = [];

			for (i = lower, j = 0, k = 0; i < upper; i++) {
				if (j >= size || j === 0) {
					this._pages.push({
						start: Math.min(maximum, i - lower),
						end: i - lower + size - 1
					});
					if (Math.min(maximum, i - lower) === maximum) {
						break;
					}
					j = 0, ++k;
				}
				j += this._core.mergers(this._core.relative(i));
			}
		}
	};

	/**
	 * Draws the user interface.
	 * @todo The option `dotsData` wont work.
	 * @protected
	 */
	Navigation.prototype.draw = function() {
		var difference,
			settings = this._core.settings,
			disabled = this._core.items().length <= settings.items,
			index = this._core.relative(this._core.current()),
			loop = settings.loop || settings.rewind;

		this._controls.$relative.toggleClass('disabled', !settings.nav || disabled);

		if (settings.nav) {
			this._controls.$previous.toggleClass('disabled', !loop && index <= this._core.minimum(true));
			this._controls.$next.toggleClass('disabled', !loop && index >= this._core.maximum(true));
		}

		this._controls.$absolute.toggleClass('disabled', !settings.dots || disabled);

		if (settings.dots) {
			difference = this._pages.length - this._controls.$absolute.children().length;

			if (settings.dotsData && difference !== 0) {
				this._controls.$absolute.html(this._templates.join(''));
			} else if (difference > 0) {
				this._controls.$absolute.append(new Array(difference + 1).join(this._templates[0]));
			} else if (difference < 0) {
				this._controls.$absolute.children().slice(difference).remove();
			}

			this._controls.$absolute.find('.active').removeClass('active');
			this._controls.$absolute.children().eq($.inArray(this.current(), this._pages)).addClass('active');
		}
	};

	/**
	 * Extends event data.
	 * @protected
	 * @param {Event} event - The event object which gets thrown.
	 */
	Navigation.prototype.onTrigger = function(event) {
		var settings = this._core.settings;

		event.page = {
			index: $.inArray(this.current(), this._pages),
			count: this._pages.length,
			size: settings && (settings.center || settings.autoWidth || settings.dotsData
				? 1 : settings.dotsEach || settings.items)
		};
	};

	/**
	 * Gets the current page position of the carousel.
	 * @protected
	 * @returns {Number}
	 */
	Navigation.prototype.current = function() {
		var current = this._core.relative(this._core.current());
		return $.grep(this._pages, $.proxy(function(page, index) {
			return page.start <= current && page.end >= current;
		}, this)).pop();
	};

	/**
	 * Gets the current succesor/predecessor position.
	 * @protected
	 * @returns {Number}
	 */
	Navigation.prototype.getPosition = function(successor) {
		var position, length,
			settings = this._core.settings;

		if (settings.slideBy == 'page') {
			position = $.inArray(this.current(), this._pages);
			length = this._pages.length;
			successor ? ++position : --position;
			position = this._pages[((position % length) + length) % length].start;
		} else {
			position = this._core.relative(this._core.current());
			length = this._core.items().length;
			successor ? position += settings.slideBy : position -= settings.slideBy;
		}

		return position;
	};

	/**
	 * Slides to the next item or page.
	 * @public
	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
	 */
	Navigation.prototype.next = function(speed) {
		$.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);
	};

	/**
	 * Slides to the previous item or page.
	 * @public
	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
	 */
	Navigation.prototype.prev = function(speed) {
		$.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);
	};

	/**
	 * Slides to the specified item or page.
	 * @public
	 * @param {Number} position - The position of the item or page.
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.
	 */
	Navigation.prototype.to = function(position, speed, standard) {
		var length;

		if (!standard && this._pages.length) {
			length = this._pages.length;
			$.proxy(this._overrides.to, this._core)(this._pages[((position % length) + length) % length].start, speed);
		} else {
			$.proxy(this._overrides.to, this._core)(position, speed);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Hash Plugin
 * @version 2.3.4
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {
	'use strict';

	/**
	 * Creates the hash plugin.
	 * @class The Hash Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Hash = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Hash index for the items.
		 * @protected
		 * @type {Object}
		 */
		this._hashes = {};

		/**
		 * The carousel element.
		 * @type {jQuery}
		 */
		this.$element = this._core.$element;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.startPosition === 'URLHash') {
					$(window).trigger('hashchange.owl.navigation');
				}
			}, this),
			'prepared.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					var hash = $(e.content).find('[data-hash]').addBack('[data-hash]').attr('data-hash');

					if (!hash) {
						return;
					}

					this._hashes[hash] = e.content;
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'position') {
					var current = this._core.items(this._core.relative(this._core.current())),
						hash = $.map(this._hashes, function(item, hash) {
							return item === current ? hash : null;
						}).join();

					if (!hash || window.location.hash.slice(1) === hash) {
						return;
					}

					window.location.hash = hash;
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Hash.Defaults, this._core.options);

		// register the event handlers
		this.$element.on(this._handlers);

		// register event listener for hash navigation
		$(window).on('hashchange.owl.navigation', $.proxy(function(e) {
			var hash = window.location.hash.substring(1),
				items = this._core.$stage.children(),
				position = this._hashes[hash] && items.index(this._hashes[hash]);

			if (position === undefined || position === this._core.current()) {
				return;
			}

			this._core.to(this._core.relative(position), false, true);
		}, this));
	};

	/**
	 * Default options.
	 * @public
	 */
	Hash.Defaults = {
		URLhashListener: false
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Hash.prototype.destroy = function() {
		var handler, property;

		$(window).off('hashchange.owl.navigation');

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Hash = Hash;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Support Plugin
 *
 * @version 2.3.4
 * @author Vivid Planet Software GmbH
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	var style = $('<support>').get(0).style,
		prefixes = 'Webkit Moz O ms'.split(' '),
		events = {
			transition: {
				end: {
					WebkitTransition: 'webkitTransitionEnd',
					MozTransition: 'transitionend',
					OTransition: 'oTransitionEnd',
					transition: 'transitionend'
				}
			},
			animation: {
				end: {
					WebkitAnimation: 'webkitAnimationEnd',
					MozAnimation: 'animationend',
					OAnimation: 'oAnimationEnd',
					animation: 'animationend'
				}
			}
		},
		tests = {
			csstransforms: function() {
				return !!test('transform');
			},
			csstransforms3d: function() {
				return !!test('perspective');
			},
			csstransitions: function() {
				return !!test('transition');
			},
			cssanimations: function() {
				return !!test('animation');
			}
		};

	function test(property, prefixed) {
		var result = false,
			upper = property.charAt(0).toUpperCase() + property.slice(1);

		$.each((property + ' ' + prefixes.join(upper + ' ') + upper).split(' '), function(i, property) {
			if (style[property] !== undefined) {
				result = prefixed ? property : true;
				return false;
			}
		});

		return result;
	}

	function prefixed(property) {
		return test(property, true);
	}

	if (tests.csstransitions()) {
		/* jshint -W053 */
		$.support.transition = new String(prefixed('transition'))
		$.support.transition.end = events.transition.end[ $.support.transition ];
	}

	if (tests.cssanimations()) {
		/* jshint -W053 */
		$.support.animation = new String(prefixed('animation'))
		$.support.animation.end = events.animation.end[ $.support.animation ];
	}

	if (tests.csstransforms()) {
		/* jshint -W053 */
		$.support.transform = new String(prefixed('transform'));
		$.support.transform3d = tests.csstransforms3d();
	}

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16), __webpack_require__(16)))

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
* @version: 2.1.24
* @author: Dan Grossman http://www.dangrossman.info/
* @copyright: Copyright (c) 2012-2016 Dan Grossman. All rights reserved.
* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
* @website: https://www.improvely.com/
*/
// Follow the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js


/**
 * Custom from : https://github.com/dangrossman/bootstrap-daterangepicker
 */

(function (root, factory) {
    if (true) {
        // AMD. Make globaly available as well
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function (moment, jquery) {
            return (root.daterangepicker = factory(moment, jquery));
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        // Node / Browserify
        //isomorphic issue
        var jQuery = (typeof window != 'undefined') ? window.jQuery : undefined;
        if (!jQuery) {
            jQuery = require('jquery');
            if (!jQuery.fn) jQuery.fn = {};
        }
        module.exports = factory(require('vendors/moment-locale-th'), jQuery);
    } else {
        // Browser globals
        root.daterangepicker = factory(root.moment, root.jQuery);
    }
}(this, function(moment, $) {
    var DateRangePicker = function(element, options, cb) {

        //default settings for options
        this.parentEl = 'body';
        this.element = $(element);
        this.$btnTriggerDatePicker = $('#'+element[0].id.replace('-mask', ''));
        this.startDate = moment().startOf('day');
        this.endDate = moment().endOf('day');
        this.minDate = false;
        this.maxDate = false;
        this.dateLimit = false;
        this.autoApply = false;
        this.singleDatePicker = false;
        this.showDropdowns = false;
        this.showWeekNumbers = false;
        this.showISOWeekNumbers = false;
        this.showCustomRangeLabel = true;
        this.timePicker = false;
        this.timePicker24Hour = false;
        this.timePickerIncrement = 1;
        this.timePickerSeconds = false;
        this.linkedCalendars = true;
        this.autoUpdateInput = true;
        this.alwaysShowCalendars = false;
        this.ranges = {};

        this.pickerLabel = 'DatePicker';
        this.isFirstComponent = false;
        this.allowSameDate = false;
        this.customPosition = undefined;
        this.selectionState = {
            START_DATE_PENDING: 'SET_START_DATE_PENDING',
            START_DATE_COMPLETE: 'SET_START_DATE_COMPLETE',
            END_DATE_PENDING: 'SET_END_DATE_PENDING',
            END_DATE_COMPLETE: 'SET_END_DATE_COMPLETE',
            BOTH_DATE_COMPLETE: 'SET_BOTH_DATE_COMPLETE',
        };
        this.currentSelectionState = this.selectionState.START_DATE_PENDING;

        this.opens = 'right';
        if (this.element.hasClass('pull-right'))
            this.opens = 'left';

        this.drops = 'down';
        if (this.element.hasClass('dropup'))
            this.drops = 'up';

        this.buttonClasses = 'btn btn-sm';
        this.applyClass = 'btn-success';
        this.cancelClass = 'btn-default';

        this.locale = {
            direction: 'ltr',
            format: moment.localeData().longDateFormat('L'),
            separator: ' - ',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: moment.weekdaysMin(),
            monthNames: moment.monthsShort(),
            firstDay: moment.localeData().firstDayOfWeek()
        };

        this.id = options.id
        this.lang = options.lang;

        this.callback = function() { };

        //some state information
        this.isShowing = false;
        this.leftCalendar = {};
        this.rightCalendar = {};

        //custom options from user
        if (typeof options !== 'object' || options === null)
            options = {};

        //allow setting options with data attributes
        //data-api options will be overwritten with custom javascript options
        options = $.extend(this.element.data(), options);

        var titleTemplate = '';
        if (options.pickerLabel) {
          this.pickerLabel = options.pickerLabel;
          titleTemplate = '<div class="bar-title">' +
              '<div class="picker-label">'+ this.pickerLabel +'</div>' +
              '<span class="close-icon icon-close"></span>' +
          '</div>';
        }
        if (options.isFirstComponent) this.isFirstComponent = options.isFirstComponent;
        if (options.allowSameDate) this.allowSameDate = options.allowSameDate;

        //html template for the picker UI
        var otaPickerAddonTemplate = '<div class="header">' +
            titleTemplate +
            '<div class="bar-control">' +
                '<div class="left">' +
                    '<div class="month">2017 Dec</div>' +
                    '<span class="prevIcon ' + (options.pickerLabel ? '' : 'radius') + '"><i class="icon-arrow-left-round"></i></span>' +
                '</div>' +
                '<div class="right">' +
                    '<div class="month">2017 dec</div>' +
                    '<span class="nextIcon ' + (options.pickerLabel ? '' : 'radius') + '"><i class="icon-arrow-right-round"></i></span>' +
                '</div>' +
            '</div>' +
        '</div>';

        if (typeof options.template !== 'string' && !(options.template instanceof $))
            options.template = '<div id="' + this.id +'" class="daterangepicker dropdown-menu '+this.id+'-calendar">' + otaPickerAddonTemplate +
                '<div class="calendar left">' +
                    '<div class="daterangepicker_input">' +
                      '<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
                      '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
                      '<div class="calendar-time">' +
                        '<div></div>' +
                        '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
                      '</div>' +
                    '</div>' +
                    '<div class="calendar-table"></div>' +
                '</div>' +
                '<div class="calendar right">' +
                    '<div class="daterangepicker_input">' +
                      '<input class="input-mini form-control" type="text" name="daterangepicker_end" value="" />' +
                      '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
                      '<div class="calendar-time">' +
                        '<div></div>' +
                        '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
                      '</div>' +
                    '</div>' +
                    '<div class="calendar-table"></div>' +
                '</div>' +
                '<div class="ranges">' +
                    '<div class="range_inputs">' +
                        '<button class="applyBtn" disabled="disabled" type="button"></button> ' +
                        '<button class="cancelBtn" type="button"></button>' +
                    '</div>' +
                '</div>' +
            '</div>';

        this.parentEl = (options.parentEl && $(options.parentEl).length) ? $(options.parentEl) : $(this.parentEl);
        // console.log('Datepicker Render');
        $('.'+this.id+'-calendar').remove();
        this.container = $(options.template).appendTo(this.parentEl);

        //
        // handle all the possible options overriding defaults
        //

        if (typeof options.locale === 'object') {

            if (typeof options.locale.direction === 'string')
                this.locale.direction = options.locale.direction;

            if (typeof options.locale.format === 'string')
                this.locale.format = options.locale.format;

            if (typeof options.locale.separator === 'string')
                this.locale.separator = options.locale.separator;

            if (typeof options.locale.daysOfWeek === 'object')
                this.locale.daysOfWeek = options.locale.daysOfWeek.slice();

            if (typeof options.locale.monthNames === 'object')
              this.locale.monthNames = options.locale.monthNames.slice();

            if (typeof options.locale.firstDay === 'number')
              this.locale.firstDay = options.locale.firstDay;

            if (typeof options.locale.applyLabel === 'string')
              this.locale.applyLabel = options.locale.applyLabel;

            if (typeof options.locale.cancelLabel === 'string')
              this.locale.cancelLabel = options.locale.cancelLabel;

            if (typeof options.locale.weekLabel === 'string')
              this.locale.weekLabel = options.locale.weekLabel;

            if (typeof options.locale.customRangeLabel === 'string')
              this.locale.customRangeLabel = options.locale.customRangeLabel;

        }
        this.container.addClass(this.locale.direction);

        if (typeof options.startDate === 'string')
            this.startDate = moment(options.startDate, this.locale.format);

        if (typeof options.endDate === 'string')
            this.endDate = moment(options.endDate, this.locale.format);

        if (typeof options.minDate === 'string')
            this.minDate = moment(options.minDate, this.locale.format);

        if (typeof options.maxDate === 'string')
            this.maxDate = moment(options.maxDate, this.locale.format);

        if (typeof options.startDate === 'object')
            this.startDate = moment(options.startDate);

        if (typeof options.endDate === 'object')
            this.endDate = moment(options.endDate);

        if (typeof options.minDate === 'object')
            this.minDate = moment(options.minDate);

        if (typeof options.maxDate === 'object')
            this.maxDate = moment(options.maxDate);

        // sanity check for bad options
        if (this.minDate && this.startDate.isBefore(this.minDate))
            this.startDate = this.minDate.clone();

        // sanity check for bad options
        // if (this.maxDate && this.endDate.isAfter(this.maxDate))
        //     this.endDate = this.maxDate.clone();

        if (typeof options.applyClass === 'string')
            this.applyClass = options.applyClass;

        if (typeof options.cancelClass === 'string')
            this.cancelClass = options.cancelClass;

        if (typeof options.dateLimit === 'object')
            this.dateLimit = options.dateLimit;

        if (typeof options.customPosition === 'object')
            this.customPosition = options.customPosition;

        if (typeof options.opens === 'string')
            this.opens = options.opens;

        if (typeof options.drops === 'string')
            this.drops = options.drops;

        if (typeof options.showWeekNumbers === 'boolean')
            this.showWeekNumbers = options.showWeekNumbers;

        if (typeof options.showISOWeekNumbers === 'boolean')
            this.showISOWeekNumbers = options.showISOWeekNumbers;

        if (typeof options.buttonClasses === 'string')
            this.buttonClasses = options.buttonClasses;

        if (typeof options.buttonClasses === 'object')
            this.buttonClasses = options.buttonClasses.join(' ');

        if (typeof options.showDropdowns === 'boolean')
            this.showDropdowns = options.showDropdowns;

        if (typeof options.showCustomRangeLabel === 'boolean')
            this.showCustomRangeLabel = options.showCustomRangeLabel;

        if (typeof options.singleDatePicker === 'boolean') {
            this.singleDatePicker = options.singleDatePicker;
            if (this.singleDatePicker)
                this.endDate = this.startDate.clone();
        }

        if (typeof options.timePicker === 'boolean')
            this.timePicker = options.timePicker;

        if (typeof options.timePickerSeconds === 'boolean')
            this.timePickerSeconds = options.timePickerSeconds;

        if (typeof options.timePickerIncrement === 'number')
            this.timePickerIncrement = options.timePickerIncrement;

        if (typeof options.timePicker24Hour === 'boolean')
            this.timePicker24Hour = options.timePicker24Hour;

        if (typeof options.autoApply === 'boolean')
            this.autoApply = options.autoApply;

        if (typeof options.autoUpdateInput === 'boolean')
            this.autoUpdateInput = options.autoUpdateInput;

        if (typeof options.linkedCalendars === 'boolean')
            this.linkedCalendars = options.linkedCalendars;

        if (typeof options.isInvalidDate === 'function')
            this.isInvalidDate = options.isInvalidDate;

        if (typeof options.isCustomDate === 'function')
            this.isCustomDate = options.isCustomDate;

        if (typeof options.alwaysShowCalendars === 'boolean')
            this.alwaysShowCalendars = options.alwaysShowCalendars;

        if (typeof options.customHandler === 'function')
            this.customHandler = options.customHandler;

        // update day names order to firstDay
        if (this.locale.firstDay != 0) {
            var iterator = this.locale.firstDay;
            while (iterator > 0) {
                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
                iterator--;
            }
        }

        var start, end, range;

        //if no start/end dates set, check if an input element contains initial values
        if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
            if ($(this.element).is('input[type=text]')) {
                var val = $(this.element).val(),
                    split = val.split(this.locale.separator);

                start = end = null;

                if (split.length == 2) {
                    start = moment(split[0], this.locale.format);
                    end = moment(split[1], this.locale.format);
                } else if (this.singleDatePicker && val !== "") {
                    start = moment(val, this.locale.format);
                    end = moment(val, this.locale.format);
                }
                if (start !== null && end !== null) {
                    this.setStartDate(start);
                    this.setEndDate(end);
                }
            }
        }

        if (typeof options.ranges === 'object') {
            for (range in options.ranges) {

                if (typeof options.ranges[range][0] === 'string')
                    start = moment(options.ranges[range][0], this.locale.format);
                else
                    start = moment(options.ranges[range][0]);

                if (typeof options.ranges[range][1] === 'string')
                    end = moment(options.ranges[range][1], this.locale.format);
                else
                    end = moment(options.ranges[range][1]);

                // If the start or end date exceed those allowed by the minDate or dateLimit
                // options, shorten the range to the allowable period.
                if (this.minDate && start.isBefore(this.minDate))
                    start = this.minDate.clone();

                var maxDate = this.maxDate;
                if (this.dateLimit && maxDate && start.clone().add(this.dateLimit).isAfter(maxDate))
                    maxDate = start.clone().add(this.dateLimit);
                if (maxDate && end.isAfter(maxDate))
                    end = maxDate.clone();

                // If the end of the range is before the minimum or the start of the range is
                // after the maximum, don't display this range option at all.
                if ((this.minDate && end.isBefore(this.minDate, this.timepicker ? 'minute' : 'day'))
                  || (maxDate && start.isAfter(maxDate, this.timepicker ? 'minute' : 'day')))
                    continue;

                //Support unicode chars in the range names.
                var elem = document.createElement('textarea');
                elem.innerHTML = range;
                var rangeHtml = elem.value;

                this.ranges[rangeHtml] = [start, end];
            }

            var list = '<ul>';
            for (range in this.ranges) {
                list += '<li data-range-key="' + range + '">' + range + '</li>';
            }
            if (this.showCustomRangeLabel) {
                list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
            }
            list += '</ul>';
            this.container.find('.ranges').prepend(list);
        }

        if (typeof cb === 'function') {
            this.callback = cb;
        }

        if (!this.timePicker) {
            this.startDate = this.startDate.startOf('day');
            this.endDate = this.endDate.endOf('day');
            this.container.find('.calendar-time').hide();
        }

        //can't be used together for now
        if (this.timePicker && this.autoApply)
            this.autoApply = false;

        if (this.autoApply && typeof options.ranges !== 'object') {
            this.container.find('.ranges').hide();
        } else if (this.autoApply) {
            this.container.find('.applyBtn, .cancelBtn').addClass('hide');
        }

        if (this.singleDatePicker) {
            this.container.addClass('single');
            this.container.find('.calendar.left').addClass('single');
            this.container.find('.calendar.left').show();
            this.container.find('.calendar.right').hide();
            this.container.find('.daterangepicker_input input, .daterangepicker_input > i').hide();
            if (this.timePicker) {
                this.container.find('.ranges ul').hide();
            } else {
                this.container.find('.ranges').hide();
            }
        }

        if ((typeof options.ranges === 'undefined' && !this.singleDatePicker) || this.alwaysShowCalendars) {
            this.container.addClass('show-calendar');
        }

        this.container.addClass('opens' + this.opens);

        //swap the position of the predefined ranges if opens right
        if (typeof options.ranges !== 'undefined' && this.opens == 'right') {
            this.container.find('.ranges').prependTo( this.container.find('.calendar.left').parent() );
        }

        //apply CSS classes and labels to buttons
        this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
        if (this.applyClass.length)
            this.container.find('.applyBtn').addClass(this.applyClass);
        if (this.cancelClass.length)
            this.container.find('.cancelBtn').addClass(this.cancelClass);
        this.container.find('.applyBtn').html(this.locale.applyLabel);
        this.container.find('.cancelBtn').html(this.locale.cancelLabel);

        //
        // event listeners
        //

        this.container.find('.header')
            .on('click.daterangepicker', '.close-icon', $.proxy(this.toggle, this))
            .on('click.daterangepicker', '.prevIcon', $.proxy(this.clickPrev, this))
            .on('click.daterangepicker', '.nextIcon', $.proxy(this.clickNext, this));

        this.container.find('.calendar')
            .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
            .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
            .on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
            .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
            .on('mouseleave.daterangepicker', 'td.available', $.proxy(this.updateFormInputs, this))
            .on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this))
            .on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this))
            .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this))
            .on('click.daterangepicker', '.daterangepicker_input input', $.proxy(this.showCalendars, this))
            .on('focus.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsFocused, this))
            .on('blur.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsBlurred, this))
            .on('change.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsChanged, this));

        this.container.find('.ranges')
            .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
            .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this))
            .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this))
            .on('mouseenter.daterangepicker', 'li', $.proxy(this.hoverRange, this))
            .on('mouseleave.daterangepicker', 'li', $.proxy(this.updateFormInputs, this));

        if (this.element.is('input') || this.element.is('button')) {
            this.element.on({
                'click.daterangepicker': $.proxy(this.show, this),
                'focus.daterangepicker': $.proxy(this.show, this),
                'keyup.daterangepicker': $.proxy(this.elementChanged, this),
                'keydown.daterangepicker': $.proxy(this.keydown, this)
            });
        } else {
            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
        }

        //
        // if attached to a text input, set the initial value
        //

        if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
            this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            this.element.trigger('change');
        } else if (this.element.is('input') && this.autoUpdateInput) {
            this.element.val(this.startDate.format(this.locale.format));
            this.element.trigger('change');
        }

        //this.updateStateClass();

    };

    DateRangePicker.prototype = {

        constructor: DateRangePicker,

        customHandler: function (type, data) { },

        setSelectionState: function (state) {
            switch (state) {
                case 'SELECT_CHECKIN':      this.currentSelectionState = this.selectionState.START_DATE_PENDING;    break;
                case 'SELECT_CHECKOUT':     this.currentSelectionState = this.selectionState.END_DATE_PENDING;      break;
                default: this.currentSelectionState = this.selectionState.START_DATE_PENDING; break;
            }
           //console.log('setSelectionState : ', this.currentSelectionState);
        },

        sendEventHandler: function (state) {
            switch (state) {
                case this.selectionState.START_DATE_COMPLETE:   this.currentSelectionState = this.selectionState.END_DATE_PENDING;      break;
                case this.selectionState.END_DATE_COMPLETE:     this.currentSelectionState = this.selectionState.START_DATE_PENDING;    break;
                case this.selectionState.BOTH_DATE_COMPLETE:    this.currentSelectionState = this.selectionState.START_DATE_PENDING;    break;
                default: this.currentSelectionState = this.selectionState.END_DATE_PENDING; break;
            }
            //console.log('sendEventHandler current state : ', this.currentSelectionState);
            this.customHandler(state, { startDate: this.startDate, endDate: this.endDate });
            this.updateStateClass();

        },

        getStartDate: function () {
            return this.startDate;
        },

        setMinDate: function (minDate) {
            if (typeof minDate === 'string')
                this.minDate = moment(minDate, this.locale.format);

            if (typeof minDate === 'object')
                this.minDate = moment(minDate);
        },

        setMaxDate: function (maxDate) {
            if (typeof maxDate === 'string')
                this.maxDate = moment(maxDate, this.locale.format);

            if (typeof maxDate === 'object')
                this.maxDate = moment(maxDate);
        },

        updateStateClass: function () {
            var stateClass = 'start-pending',
                prefixClass = 'picker-state-';

            switch (this.currentSelectionState) {
                case this.selectionState.START_DATE_PENDING:    stateClass = 'start-pending';   break;
                case this.selectionState.END_DATE_PENDING:      stateClass = 'end-pending';     break;
                default:  break;
            }


            this.container.removeClass(function (index, className) {
                return (className.match(/(^|\s)picker-state-\S+/g) || []).join(' ');
            });
            this.container.addClass(prefixClass + stateClass);
            //console.log("updateStateClass : ", stateClass);
        },

        setStartDate: function(startDate) {
            if (typeof startDate === 'string')
                this.startDate = moment(startDate, this.locale.format);

            if (typeof startDate === 'object')
                this.startDate = moment(startDate);

            if (!this.timePicker)
                this.startDate = this.startDate.startOf('day');

            if (this.timePicker && this.timePickerIncrement)
                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

            if (this.minDate && this.startDate.isBefore(this.minDate)) {
                this.startDate = this.minDate.clone();
                if (this.timePicker && this.timePickerIncrement)
                    this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }

            if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
                this.startDate = this.maxDate.clone();
                if (this.timePicker && this.timePickerIncrement)
                    this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }

            if (!this.isShowing)
                this.updateElement();

            this.updateMonthsInView();
        },

        setEndDate: function(endDate) {
            if (typeof endDate === 'string')
                this.endDate = moment(endDate, this.locale.format);

            if (typeof endDate === 'object')
                this.endDate = moment(endDate);

            if (!this.timePicker)
                this.endDate = this.endDate.endOf('day');

            if (this.timePicker && this.timePickerIncrement)
                this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

            if (this.endDate.isBefore(this.startDate))
                this.endDate = this.startDate.clone();

            // if (this.maxDate && this.endDate.isAfter(this.maxDate))
                // this.endDate = this.maxDate.clone();

            if (this.dateLimit && this.startDate.clone().add(this.dateLimit).isBefore(this.endDate))
                this.endDate = this.startDate.clone().add(this.dateLimit);

            this.previousRightTime = this.endDate.clone();

            if (!this.isShowing)
                this.updateElement();

            this.updateMonthsInView();
        },

        isInvalidDate: function() {
            return false;
        },

        isCustomDate: function() {
            return false;
        },

        updateView: function() {
            if (this.timePicker) {
                this.renderTimePicker('left');
                this.renderTimePicker('right');
                if (!this.endDate) {
                    this.container.find('.right .calendar-time select').attr('disabled', 'disabled').addClass('disabled');
                } else {
                    this.container.find('.right .calendar-time select').removeAttr('disabled').removeClass('disabled');
                }
            }
            if (this.endDate) {
                this.container.find('input[name="daterangepicker_end"]').removeClass('active');
                this.container.find('input[name="daterangepicker_start"]').addClass('active');
            } else {
                this.container.find('input[name="daterangepicker_end"]').addClass('active');
                this.container.find('input[name="daterangepicker_start"]').removeClass('active');
            }
            this.updateMonthsInView();
            this.updateCalendars();
            this.updateFormInputs();
            this.updateStateClass();
        },

        updateMonthsInView: function() {
            if (this.endDate) {

                //if both dates are visible already, do nothing
                if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
                    (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
                    &&
                    (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
                    ) {
                    return;
                }

                this.leftCalendar.month = this.startDate.clone().date(2);
                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) {
                    this.rightCalendar.month = this.endDate.clone().date(2);
                } else {
                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
                }

            } else {
                if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
                    this.leftCalendar.month = this.startDate.clone().date(2);
                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
                }
            }
            if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
                this.rightCalendar.month = this.maxDate.clone().date(2);
                this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
            }
        },

        updateCalendars: function() {
            this.arrowEnable();

            if (this.timePicker) {
                var hour, minute, second;
                if (this.endDate) {
                    hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                } else {
                    hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                }
                this.leftCalendar.month.hour(hour).minute(minute).second(second);
                this.rightCalendar.month.hour(hour).minute(minute).second(second);
            }

            this.renderCalendar('left');
            this.renderCalendar('right');

            //highlight any predefined range matching the current start and end dates
            this.container.find('.ranges li').removeClass('active');
            if (this.endDate == null) return;

            this.calculateChosenLabel();
        },

        setLocale: function (label ,daysOfWeek, monthNames, lang) {
            // set label
            var target = '#'+this.id+' .picker-label';
            $(target)[0] && ($(target)[0].innerHTML = label);

            // set lang to calendar
            this.locale.daysOfWeek = daysOfWeek;
            this.locale.monthNames = monthNames;
            this.lang = lang;
        },

        renderCalendar: function(side) {
            //
            // Build the matrix of dates that will populate the calendar
            //

            var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
            var month = this.isMobileSize() && side == 'right'?calendar.month.subtract(1, 'month').month(): calendar.month.month();
            var year = calendar.month.year();
            var hour = calendar.month.hour();
            var minute = calendar.month.minute();
            var second = calendar.month.second();
            var daysInMonth = moment([year, month]).daysInMonth();
            var firstDay = moment([year, month, 1]);
            var lastDay = moment([year, month, daysInMonth]);
            var lastMonth = moment(firstDay).subtract(1, 'month').month();
            var lastYear = moment(firstDay).subtract(1, 'month').year();
            var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
            var dayOfWeek = firstDay.day();

            var weekFirstDate = firstDay.isoWeek();
            var weekLastDate = lastDay.isoWeek();
            var amountWeekInMonth = 6; // row is always 6.

            //initialize a 6 rows x 7 columns array for the calendar
            var calendar = [];
            calendar.firstDay = firstDay;
            calendar.lastDay = lastDay;

            for (var i = 0; i < amountWeekInMonth; i++) {
                calendar[i] = [];
            }

            //populate the calendar with date objects
            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
            if (startDay > daysInLastMonth)
                startDay -= 7;

            if (dayOfWeek == this.locale.firstDay)
                startDay = daysInLastMonth - 6;

            var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);

            var col, row;
            for (var i = 0, col = 0, row = 0; i < amountWeekInMonth*7; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
                if (i > 0 && col % 7 === 0) {
                    col = 0;
                    row++;
                }
                //console.log('i: %s , row: %s , col: $s', i, row, col);
                calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
                curDate.hour(12);

                if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') {
                    calendar[row][col] = this.minDate.clone();
                }

                if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') {
                    calendar[row][col] = this.maxDate.clone();
                }

            }

            //make the calendar object available to hoverDate/clickDate
            if (side == 'left') {
                this.leftCalendar.calendar = calendar;
            } else {
                this.rightCalendar.calendar = calendar;
            }

            //
            // Display the calendar
            //

            var minDate = side == 'left' ? this.minDate : this.startDate;
            var maxDate = this.maxDate;
            var selected = side == 'left' ? this.startDate : this.endDate;
            var arrow = this.locale.direction == 'ltr' ? {left: 'chevron-left', right: 'chevron-right'} : {left: 'chevron-right', right: 'chevron-left'};

            var html = '<table class="table-condensed">';
            html += '<thead>';
            html += '<tr>';

            // add empty cell for week number
            if (this.showWeekNumbers || this.showISOWeekNumbers)
                html += '<th></th>';

            if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) {
                html += '<th class="prev available"><i class="fa fa-' + arrow.left + ' glyphicon glyphicon-' + arrow.left + '"></i></th>';
            } else {
                html += '<th></th>';
            }

            var _yearNumber = parseInt(calendar[1][1].format(" YYYY"));
            var _displayYear = this.lang === 'th'? _yearNumber + 543: _yearNumber;
            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + ' ' + _displayYear;

            if (this.showDropdowns) {
                var currentMonth = calendar[1][1].month();
                var currentYear = calendar[1][1].year();
                var maxYear = (maxDate && maxDate.year()) || (currentYear + 5);
                var minYear = (minDate && minDate.year()) || (currentYear - 50);
                var inMinYear = currentYear == minYear;
                var inMaxYear = currentYear == maxYear;

                var monthHtml = '<select class="monthselect">';
                for (var m = 0; m < 12; m++) {
                    if ((!inMinYear || m >= minDate.month()) && (!inMaxYear || m <= maxDate.month())) {
                        monthHtml += "<option value='" + m + "'" +
                            (m === currentMonth ? " selected='selected'" : "") +
                            ">" + this.locale.monthNames[m] + "</option>";
                    } else {
                        monthHtml += "<option value='" + m + "'" +
                            (m === currentMonth ? " selected='selected'" : "") +
                            " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
                    }
                }
                monthHtml += "</select>";

                var yearHtml = '<select class="yearselect">';
                for (var y = minYear; y <= maxYear; y++) {
                    yearHtml += '<option value="' + y + '"' +
                        (y === currentYear ? ' selected="selected"' : '') +
                        '>' + y + '</option>';
                }
                yearHtml += '</select>';

                dateHtml = monthHtml + yearHtml;
            }

            this.updateHeaderDate({ side: side, date: dateHtml });
            html += '<th colspan="5" class="month">' + dateHtml + '</th>';
            if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) {
                html += '<th class="next available"><i class="fa fa-' + arrow.right + ' glyphicon glyphicon-' + arrow.right + '"></i></th>';
            } else {
                html += '<th></th>';
            }

            html += '</tr>';
            html += '<tr>';

            // add week number label
            if (this.showWeekNumbers || this.showISOWeekNumbers)
                html += '<th class="week">' + this.locale.weekLabel + '</th>';

            $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
                html += '<th>' + dayOfWeek + '</th>';
            });

            html += '</tr>';
            html += '</thead>';
            html += '<tbody>';

            //adjust maxDate to reflect the dateLimit setting in order to
            //grey out end dates beyond the dateLimit
            if (this.endDate == null && this.dateLimit) {
                var maxLimit = this.startDate.clone().add(this.dateLimit).endOf('day');
                if (!maxDate || maxLimit.isBefore(maxDate)) {
                    maxDate = maxLimit;
                }
            }

            for (var row = 0; row < amountWeekInMonth; row++) {
                html += '<tr>';

                // add week number
                if (this.showWeekNumbers)
                    html += '<td class="week">' + calendar[row][0].week() + '</td>';
                else if (this.showISOWeekNumbers)
                    html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';

                for (var col = 0; col < 7; col++) {

                    var classes = [];

                    //highlight today's date
                    if (calendar[row][col].isSame(new Date(), "day"))
                        classes.push('today');

                    //highlight weekends
                    if (calendar[row][col].isoWeekday() > 5)
                        classes.push('weekend');

                    //grey out the dates in other months displayed at beginning and end of this calendar
                    if (calendar[row][col].month() != calendar[1][1].month()) {
                        classes.push('otherMonth', 'disabled');
                    }

                    //don't allow selection of dates before the minimum date
                    if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day'))
                        classes.push('off', 'disabled');

                    //don't allow selection of dates after the maximum date
                    if (maxDate && calendar[row][col].isAfter(maxDate, 'day'))
                        classes.push('off', 'disabled');

                    //don't allow selection of date if a custom function decides it's invalid
                    if (this.isInvalidDate(calendar[row][col]))
                        classes.push('off', 'disabled');

                    //highlight the currently selected start date
                    if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD'))
                        classes.push('active', 'start-date');

                    //highlight the currently selected end date
                    if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD'))
                        classes.push('active', 'end-date');

                    //highlight dates in-between the selected dates
                    if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate)
                        classes.push('in-range');

                    //apply custom classes for this date
                    var isCustom = this.isCustomDate(calendar[row][col]);
                    if (isCustom !== false) {
                        if (typeof isCustom === 'string')
                            classes.push(isCustom);
                        else
                            Array.prototype.push.apply(classes, isCustom);
                    }

                    var cname = '', disabled = false;
                    for (var i = 0; i < classes.length; i++) {
                        cname += classes[i] + ' ';
                        if (classes[i] == 'disabled')
                            disabled = true;
                    }
                    if (!disabled)
                        cname += 'available';

                    html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';

                }
                html += '</tr>';
            }

            html += '</tbody>';
            html += '</table>';

            this.container.find('.calendar.' + side + ' .calendar-table').html(html);

        },

        renderTimePicker: function(side) {

            // Don't bother updating the time picker if it's currently disabled
            // because an end date hasn't been clicked yet
            if (side == 'right' && !this.endDate) return;

            var html, selected, minDate, maxDate = this.maxDate;

            if (this.dateLimit && (!this.maxDate || this.startDate.clone().add(this.dateLimit).isAfter(this.maxDate)))
                maxDate = this.startDate.clone().add(this.dateLimit);

            if (side == 'left') {
                selected = this.startDate.clone();
                minDate = this.minDate;
            } else if (side == 'right') {
                selected = this.endDate.clone();
                minDate = this.startDate;

                //Preserve the time already selected
                var timeSelector = this.container.find('.calendar.right .calendar-time div');
                if (!this.endDate && timeSelector.html() != '') {

                    selected.hour(timeSelector.find('.hourselect option:selected').val() || selected.hour());
                    selected.minute(timeSelector.find('.minuteselect option:selected').val() || selected.minute());
                    selected.second(timeSelector.find('.secondselect option:selected').val() || selected.second());

                    if (!this.timePicker24Hour) {
                        var ampm = timeSelector.find('.ampmselect option:selected').val();
                        if (ampm === 'PM' && selected.hour() < 12)
                            selected.hour(selected.hour() + 12);
                        if (ampm === 'AM' && selected.hour() === 12)
                            selected.hour(0);
                    }

                }

                if (selected.isBefore(this.startDate))
                    selected = this.startDate.clone();

                if (maxDate && selected.isAfter(maxDate))
                    selected = maxDate.clone();

            }

            //
            // hours
            //

            html = '<select class="hourselect">';

            var start = this.timePicker24Hour ? 0 : 1;
            var end = this.timePicker24Hour ? 23 : 12;

            for (var i = start; i <= end; i++) {
                var i_in_24 = i;
                if (!this.timePicker24Hour)
                    i_in_24 = selected.hour() >= 12 ? (i == 12 ? 12 : i + 12) : (i == 12 ? 0 : i);

                var time = selected.clone().hour(i_in_24);
                var disabled = false;
                if (minDate && time.minute(59).isBefore(minDate))
                    disabled = true;
                if (maxDate && time.minute(0).isAfter(maxDate))
                    disabled = true;

                if (i_in_24 == selected.hour() && !disabled) {
                    html += '<option value="' + i + '" selected="selected">' + i + '</option>';
                } else if (disabled) {
                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
                } else {
                    html += '<option value="' + i + '">' + i + '</option>';
                }
            }

            html += '</select> ';

            //
            // minutes
            //

            html += ': <select class="minuteselect">';

            for (var i = 0; i < 60; i += this.timePickerIncrement) {
                var padded = i < 10 ? '0' + i : i;
                var time = selected.clone().minute(i);

                var disabled = false;
                if (minDate && time.second(59).isBefore(minDate))
                    disabled = true;
                if (maxDate && time.second(0).isAfter(maxDate))
                    disabled = true;

                if (selected.minute() == i && !disabled) {
                    html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                } else if (disabled) {
                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                } else {
                    html += '<option value="' + i + '">' + padded + '</option>';
                }
            }

            html += '</select> ';

            //
            // seconds
            //

            if (this.timePickerSeconds) {
                html += ': <select class="secondselect">';

                for (var i = 0; i < 60; i++) {
                    var padded = i < 10 ? '0' + i : i;
                    var time = selected.clone().second(i);

                    var disabled = false;
                    if (minDate && time.isBefore(minDate))
                        disabled = true;
                    if (maxDate && time.isAfter(maxDate))
                        disabled = true;

                    if (selected.second() == i && !disabled) {
                        html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                    } else if (disabled) {
                        html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                    } else {
                        html += '<option value="' + i + '">' + padded + '</option>';
                    }
                }

                html += '</select> ';
            }

            //
            // AM/PM
            //

            if (!this.timePicker24Hour) {
                html += '<select class="ampmselect">';

                var am_html = '';
                var pm_html = '';

                if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate))
                    am_html = ' disabled="disabled" class="disabled"';

                if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate))
                    pm_html = ' disabled="disabled" class="disabled"';

                if (selected.hour() >= 12) {
                    html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
                } else {
                    html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
                }

                html += '</select>';
            }

            this.container.find('.calendar.' + side + ' .calendar-time div').html(html);

        },

        updateFormInputs: function() {
            //ignore mouse movements while an above-calendar text input has focus
            if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
                return;

            this.container.find('input[name=daterangepicker_start]').val(this.startDate.format(this.locale.format));
            if (this.endDate)
                this.container.find('input[name=daterangepicker_end]').val(this.endDate.format(this.locale.format));

            if (this.singleDatePicker || (this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate)))) {
                this.container.find('button.applyBtn').removeAttr('disabled');
            } else {
                this.container.find('button.applyBtn').attr('disabled', 'disabled');
            }

        },

        updateHeaderDate: function(data) {
            var pickerLabel = this.container.find('.header .'+ data.side + ' .month');
            if(pickerLabel && data.date) pickerLabel.html(data.date);
        },

        move: function() {
            var parentOffset = { top: 0, left: 0 },
                containerTop;

            if (this.customPosition) {
                parentOffset = $.extend(parentOffset, this.customPosition);
            }

            var parentRightEdge = $(window).width();
            if (!this.parentEl.is('body')) {
                parentOffset = {
                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
                };
                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
            }

            var removeArrow = 0;
            if (this.drops == 'up')
                containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
            else
                containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top - removeArrow;
            this.container[this.drops == 'up' ? 'addClass' : 'removeClass']('dropup');

            if (this.opens == 'left') {
                this.container.css({
                    top: containerTop,
                    right: parentRightEdge - this.element.offset().left - $('#' + this.id).outerWidth(),
                    left: 'auto'
                });
                if (this.container.offset().left < 0) {
                    this.container.css({
                        right: 'auto',
                        left: 9
                    });
                }
            } else if (this.opens == 'center') {
                this.container.css({
                    top: containerTop,
                    left: this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2
                            - this.container.outerWidth() / 2,
                    right: 'auto'
                });
                if (this.container.offset().left < 0) {
                    this.container.css({
                        right: 'auto',
                        left: 9
                    });
                }
            } else {
                this.container.css({
                    top: containerTop,
                    left: this.element.offset().left - parentOffset.left,
                    right: 'auto'
                });
                if (this.container.offset().left + this.container.outerWidth() > $(window).width()) {
                    this.container.css({
                        left: 'auto',
                        right: 0
                    });
                }
            }
        },

        show: function(e) {
            if (this.isShowing) return;

            // Create a click proxy that is private to this instance of datepicker, for unbinding
            this._outsideClickProxy = $.proxy(function(e) { this.outsideClick(e); }, this);

            // Bind global datepicker mousedown for hiding and
            $(document)
              .on('mousedown.daterangepicker', this._outsideClickProxy)
              // also support mobile devices
              .on('touchend.daterangepicker', this._outsideClickProxy)
              // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
              .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
              // and also close when focus changes to outside the picker (eg. tabbing between controls)
              .on('focusin.daterangepicker', this._outsideClickProxy);

            // Reposition the picker if the window is resized while it's open
            $(window).on('resize.daterangepicker', $.proxy(function(e) { this.move(e); }, this));

            this.oldStartDate = this.startDate.clone();
            this.oldEndDate = this.endDate.clone();
            this.previousRightTime = this.endDate.clone();

            if (this.isFirstComponent) {
                this.currentSelectionState = this.selectionState.START_DATE_PENDING;
            } else {
                this.currentSelectionState = this.selectionState.END_DATE_PENDING;
            }

            this.updateView();
            this.container.show();
            this.move();
            this.element.trigger('show.daterangepicker', this);
            this.$btnTriggerDatePicker.addClass('active');
            this.isShowing = true;
        },

        hide: function(e) {
            if (!this.isShowing) return;

            //incomplete date selection, revert to last values
            if (!this.endDate) {
                this.startDate = this.oldStartDate.clone();
                this.endDate = this.oldEndDate.clone();
            }

            //if a new date range was selected, invoke the user callback function
            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
                this.callback(this.startDate, this.endDate, this.chosenLabel);

            //if picker is attached to a text input, update it
            this.updateElement();

            if (!this.isFirstComponent) {
                this.currentSelectionState = this.selectionState.START_DATE_PENDING;
            }

            $(document).off('.daterangepicker');
            $(window).off('.daterangepicker');
            this.container.hide();
            this.element.trigger('hide.daterangepicker', this);
            this.$btnTriggerDatePicker.removeClass('active');
            this.isShowing = false;
        },

        isPickerShowing: function() {
            return this.isShowing;
        },

        toggle: function(e) {
            if (this.isShowing) {
                this.hide();
            } else {
                this.show();
            }
        },

        outsideClick: function(e) {
            var target = $(e.target);
            // if the page is clicked anywhere except within the daterangerpicker/button
            // itself then call this.hide()

            if (
                // ie modal dialog fix
                e.type == "focusin" ||
                target.closest(this.element).length ||
                target.closest(this.container).length ||
                target.closest(this.$btnTriggerDatePicker).length ||
                target.closest('.calendar-table').length
                ) return;
            this.hide();
            this.element.trigger('outsideClick.daterangepicker', this);
        },

        showCalendars: function() {
            this.container.addClass('show-calendar');
            this.move();
            this.element.trigger('showCalendar.daterangepicker', this);
        },

        hideCalendars: function() {
            this.container.removeClass('show-calendar');
            this.element.trigger('hideCalendar.daterangepicker', this);
        },

        hoverRange: function(e) {

            //ignore mouse movements while an above-calendar text input has focus
            if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
                return;

            var label = e.target.getAttribute('data-range-key');

            if (label == this.locale.customRangeLabel) {
                this.updateView();
            } else {
                var dates = this.ranges[label];
                this.container.find('input[name=daterangepicker_start]').val(dates[0].format(this.locale.format));
                this.container.find('input[name=daterangepicker_end]').val(dates[1].format(this.locale.format));
            }

        },

        clickRange: function(e) {
            var label = e.target.getAttribute('data-range-key');
            this.chosenLabel = label;
            if (label == this.locale.customRangeLabel) {
                this.showCalendars();
            } else {
                var dates = this.ranges[label];
                this.startDate = dates[0];
                this.endDate = dates[1];

                if (!this.timePicker) {
                    this.startDate.startOf('day');
                    this.endDate.endOf('day');
                }

                if (!this.alwaysShowCalendars)
                    this.hideCalendars();
                this.clickApply();
            }
        },

        checkMinimumMonth: function() {
            return this.minDate.diff(this.leftCalendar.month, 'months', true);
        },

        checkMaximumMonth: function() {
            if ( this.isMobileSize() ) {
                return this.maxDate.diff(this.leftCalendar.month, 'months');
            } else {
                return this.maxDate.diff(this.leftCalendar.month, 'months') - 1;
            }
        },

        isMobileSize: function() {
            return window.matchMedia('(max-width: 767px)').matches;
        },

        arrowEnable: function() {
            var $prevBtn = this.container.find('.prevIcon');
            var $nextBtn = this.container.find('.nextIcon');
            $prevBtn.css('display', '');
            $nextBtn.css('display', '');
            if ( this.checkMinimumMonth() > 0 ) {
                $prevBtn.css('display', 'none');
            }
            if ( this.checkMaximumMonth() === 0 ) {
                $nextBtn.css('display', 'none');
            }
        },

        clickPrev: function (e) {
            var target = $(e.target);
            var cal = target.parents('.calendar');
            if (cal.length == 0) cal = target.hasClass('prevIcon') ? target.parent() : target.parents('.prevIcon').parent();
            if ( this.checkMinimumMonth() < 0 ) {
                if (cal.hasClass('left')) {
                    this.leftCalendar.month.subtract(1, 'month');
                    if (this.linkedCalendars)
                        this.rightCalendar.month.subtract(1, 'month');
                } else {
                    this.rightCalendar.month.subtract(1, 'month');
                }
                this.updateCalendars();
            }
        },

        clickNext: function(e) {
            var target = $(e.target);
            var cal = target.parents('.calendar');
            if (cal.length == 0) cal = target.hasClass('nextIcon') ? target.parent() : target.parents('.nextIcon').parent();
            if ( this.checkMaximumMonth() > 0 ) {
                if (cal.hasClass('left')) {
                    this.leftCalendar.month.add(1, 'month');
                } else {
                    this.rightCalendar.month.add(1, 'month');
                    if (this.linkedCalendars)
                        this.leftCalendar.month.add(1, 'month');
                }
                this.updateCalendars();
            }
        },

        hoverDate: function(e) {

            //ignore mouse movements while an above-calendar text input has focus
            //if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
            //    return;

            //ignore dates that can't be selected
            if (!$(e.target).hasClass('available')) return;

            //have the text inputs above calendars reflect the date being hovered over
            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.calendar');
            var date = cal.hasClass('lxreft') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];

            if (this.endDate && !this.container.find('input[name=daterangepicker_start]').is(":focus")) {
                this.container.find('input[name=daterangepicker_start]').val(date.format(this.locale.format));
            } else if (!this.endDate && !this.container.find('input[name=daterangepicker_end]').is(":focus")) {
                this.container.find('input[name=daterangepicker_end]').val(date.format(this.locale.format));
            }

            //highlight the dates between the start date and the date being hovered as a potential end date
            var leftCalendar = this.leftCalendar;
            var rightCalendar = this.rightCalendar;
            var startDate = this.startDate;
            if (!this.endDate) {
                this.container.find('.calendar td').each(function(index, el) {

                    //skip week numbers, only look at dates
                    if ($(el).hasClass('week')) return;

                    var title = $(el).attr('data-title');
                    var row = title.substr(1, 1);
                    var col = title.substr(3, 1);
                    var cal = $(el).parents('.calendar');
                    var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];

                    if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
                        $(el).addClass('in-range');
                    } else {
                        $(el).removeClass('in-range');
                    }

                });
            }

        },

        clickDate: function (e) {
            if (!$(e.target).hasClass('available')) return;

            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.calendar');
            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];


            var isSelectStartDate = this.currentSelectionState == this.selectionState.START_DATE_PENDING && this.isFirstComponent,
                allowSendingEvent = true,
                senderEvent = this.setSelectionState.START_DATE_COMPLETE;


            if (isSelectStartDate && this.endDate) { //picking start

                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                    var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }

                // set startDate
                if (date.isBefore(this.endDate.clone(), 'day')) {
                    this.setStartDate(date.clone());
                    senderEvent = this.selectionState.START_DATE_COMPLETE;
                } else {
                    this.setStartDate(date.clone());
                    this.setEndDate(this.allowSameDate ? date.clone() : date.clone().add(1, 'days'));
                    senderEvent = this.selectionState.BOTH_DATE_COMPLETE;
                }


            } else { // picking end

                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                    var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }

                if (!this.allowSameDate && date.isSame(this.startDate)) {
                    allowSendingEvent = false;
                } else {
                    this.setEndDate(date.clone());
                    senderEvent = this.selectionState.END_DATE_COMPLETE;
                }


                if (this.autoApply && allowSendingEvent) {
                    this.calculateChosenLabel();
                    this.clickApply();
                }
            }

            if (this.singleDatePicker) {
                this.setEndDate(this.startDate);
                if (!this.timePicker)
                    this.clickApply();
            }
            this.updateView();

            if (allowSendingEvent) {
                this.sendEventHandler(senderEvent);
            }


            //This is to cancel the blur event handler if the mouse was in one of the inputs
            e.stopPropagation();

        },

        calculateChosenLabel: function () {
            var customRange = true;
            var i = 0;
            for (var range in this.ranges) {
                if (this.timePicker) {
                    if (this.startDate.isSame(this.ranges[range][0]) && this.endDate.isSame(this.ranges[range][1])) {
                        customRange = false;
                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
                        break;
                    }
                } else {
                    //ignore times when comparing dates if time picker is not enabled
                    if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
                        customRange = false;
                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
                        break;
                    }
                }
                i++;
            }
            if (customRange) {
                if (this.showCustomRangeLabel) {
                    this.chosenLabel = this.container.find('.ranges li:last').addClass('active').html();
                } else {
                    this.chosenLabel = null;
                }
                this.showCalendars();
            }
        },

        clickApply: function(e) {
            this.hide();
            this.element.trigger('apply.daterangepicker', this);
        },

        clickCancel: function(e) {
            this.startDate = this.oldStartDate;
            this.endDate = this.oldEndDate;
            this.hide();
            this.element.trigger('cancel.daterangepicker', this);
        },

        monthOrYearChanged: function(e) {
            var isLeft = $(e.target).closest('.calendar').hasClass('left'),
                leftOrRight = isLeft ? 'left' : 'right',
                cal = this.container.find('.calendar.'+leftOrRight);

            // Month must be Number for new moment versions
            var month = parseInt(cal.find('.monthselect').val(), 10);
            var year = cal.find('.yearselect').val();

            if (!isLeft) {
                if (year < this.startDate.year() || (year == this.startDate.year() && month < this.startDate.month())) {
                    month = this.startDate.month();
                    year = this.startDate.year();
                }
            }

            if (this.minDate) {
                if (year < this.minDate.year() || (year == this.minDate.year() && month < this.minDate.month())) {
                    month = this.minDate.month();
                    year = this.minDate.year();
                }
            }

            if (this.maxDate) {
                if (year > this.maxDate.year() || (year == this.maxDate.year() && month > this.maxDate.month())) {
                    month = this.maxDate.month();
                    year = this.maxDate.year();
                }
            }

            if (isLeft) {
                this.leftCalendar.month.month(month).year(year);
                if (this.linkedCalendars)
                    this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
            } else {
                this.rightCalendar.month.month(month).year(year);
                if (this.linkedCalendars)
                    this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
            }
            this.updateCalendars();
        },

        timeChanged: function(e) {

            var cal = $(e.target).closest('.calendar'),
                isLeft = cal.hasClass('left');

            var hour = parseInt(cal.find('.hourselect').val(), 10);
            var minute = parseInt(cal.find('.minuteselect').val(), 10);
            var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;

            if (!this.timePicker24Hour) {
                var ampm = cal.find('.ampmselect').val();
                if (ampm === 'PM' && hour < 12)
                    hour += 12;
                if (ampm === 'AM' && hour === 12)
                    hour = 0;
            }

            if (isLeft) {
                var start = this.startDate.clone();
                start.hour(hour);
                start.minute(minute);
                start.second(second);
                this.setStartDate(start);
                if (this.singleDatePicker) {
                    this.endDate = this.startDate.clone();
                } else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
                    this.setEndDate(start.clone());
                }
            } else if (this.endDate) {
                var end = this.endDate.clone();
                end.hour(hour);
                end.minute(minute);
                end.second(second);
                this.setEndDate(end);
            }

            //update the calendars so all clickable dates reflect the new time component
            this.updateCalendars();

            //update the form inputs above the calendars with the new time
            this.updateFormInputs();

            //re-render the time pickers because changing one selection can affect what's enabled in another
            this.renderTimePicker('left');
            this.renderTimePicker('right');

        },

        formInputsChanged: function(e) {
            var isRight = $(e.target).closest('.calendar').hasClass('right');
            var start = moment(this.container.find('input[name="daterangepicker_start"]').val(), this.locale.format);
            var end = moment(this.container.find('input[name="daterangepicker_end"]').val(), this.locale.format);

            if (start.isValid() && end.isValid()) {

                if (isRight && end.isBefore(start))
                    start = end.clone();

                this.setStartDate(start);
                this.setEndDate(end);

                if (isRight) {
                    this.container.find('input[name="daterangepicker_start"]').val(this.startDate.format(this.locale.format));
                } else {
                    this.container.find('input[name="daterangepicker_end"]').val(this.endDate.format(this.locale.format));
                }

            }

            this.updateView();
        },

        formInputsFocused: function(e) {

            // Highlight the focused input
            this.container.find('input[name="daterangepicker_start"], input[name="daterangepicker_end"]').removeClass('active');
            $(e.target).addClass('active');

            // Set the state such that if the user goes back to using a mouse,
            // the calendars are aware we're selecting the end of the range, not
            // the start. This allows someone to edit the end of a date range without
            // re-selecting the beginning, by clicking on the end date input then
            // using the calendar.
            var isRight = $(e.target).closest('.calendar').hasClass('right');
            if (isRight) {
                this.endDate = null;
                this.setStartDate(this.startDate.clone());
                this.updateView();
            }

        },

        formInputsBlurred: function(e) {

            // this function has one purpose right now: if you tab from the first
            // text input to the second in the UI, the endDate is nulled so that
            // you can click another, but if you tab out without clicking anything
            // or changing the input value, the old endDate should be retained

            if (!this.endDate) {
                var val = this.container.find('input[name="daterangepicker_end"]').val();
                var end = moment(val, this.locale.format);
                if (end.isValid()) {
                    this.setEndDate(end);
                    this.updateView();
                }
            }

        },

        elementChanged: function() {
            if (!this.element.is('input')) return;
            if (!this.element.val().length) return;
            if (this.element.val().length < this.locale.format.length) return;

            var dateString = this.element.val().split(this.locale.separator),
                start = null,
                end = null;

            if (dateString.length === 2) {
                start = moment(dateString[0], this.locale.format);
                end = moment(dateString[1], this.locale.format);
            }

            if (this.singleDatePicker || start === null || end === null) {
                start = moment(this.element.val(), this.locale.format);
                end = start;
            }

            if (!start.isValid() || !end.isValid()) return;

            this.setStartDate(start);
            this.setEndDate(end);
            this.updateView();
        },

        keydown: function(e) {
            //hide on tab or enter
            if ((e.keyCode === 9) || (e.keyCode === 13)) {
                this.hide();
            }
        },

        updateElement: function() {
            if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
                this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
                this.element.trigger('change');
            } else if (this.element.is('input') && this.autoUpdateInput) {
                this.element.val(this.startDate.format(this.locale.format));
                this.element.trigger('change');
            }
        },

        remove: function() {
            this.container.remove();
            this.element.off('.daterangepicker');
            this.element.removeData();
        }

    };

    $.fn.daterangepicker = function(options, callback) {
        this.each(function() {
            var el = $(this);
            if (el.data('daterangepicker'))
                el.data('daterangepicker').remove();
            el.data('daterangepicker', new DateRangePicker(el, options, callback));
        });
        return this;
    };

    return DateRangePicker;

}));


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
 * jQuery UI Touch Punch 0.2.3
 *
 * Copyright 2011–2014, Dave Furfero
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * Depends:
 *  jquery.ui.widget.js
 *  jquery.ui.mouse.js
 */
!function(a){function f(a,b){if(!(a.originalEvent.touches.length>1)){a.preventDefault();var c=a.originalEvent.changedTouches[0],d=document.createEvent("MouseEvents");d.initMouseEvent(b,!0,!0,window,1,c.screenX,c.screenY,c.clientX,c.clientY,!1,!1,!1,!1,0,null),a.target.dispatchEvent(d)}}if(a.support.touch="ontouchend"in document,a.support.touch){var e,b=a.ui.mouse.prototype,c=b._mouseInit,d=b._mouseDestroy;b._touchStart=function(a){var b=this;!e&&b._mouseCapture(a.originalEvent.changedTouches[0])&&(e=!0,b._touchMoved=!1,f(a,"mouseover"),f(a,"mousemove"),f(a,"mousedown"))},b._touchMove=function(a){e&&(this._touchMoved=!0,f(a,"mousemove"))},b._touchEnd=function(a){e&&(f(a,"mouseup"),f(a,"mouseout"),this._touchMoved||f(a,"click"),e=!1)},b._mouseInit=function(){var b=this;b.element.bind({touchstart:a.proxy(b,"_touchStart"),touchmove:a.proxy(b,"_touchMove"),touchend:a.proxy(b,"_touchEnd")}),c.call(b)},b._mouseDestroy=function(){var b=this;b.element.unbind({touchstart:a.proxy(b,"_touchStart"),touchmove:a.proxy(b,"_touchMove"),touchend:a.proxy(b,"_touchEnd")}),d.call(b)}}}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(97);
module.exports = __webpack_require__(505);


/***/ })
],[1382]);


// WEBPACK FOOTER //
// main.594f8080445a0e30866a.bundle.js